(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[Object.keys(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all2) => {
    __markAsModule(target);
    for (var name in all2)
      __defProp(target, name, { get: all2[name], enumerable: true });
  };
  var __reExport = (target, module, desc) => {
    if (module && typeof module === "object" || typeof module === "function") {
      for (let key of __getOwnPropNames(module))
        if (!__hasOwnProp.call(target, key) && key !== "default")
          __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
    }
    return target;
  };
  var __toModule = (module) => {
    return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
  };

  // node_modules/plyr/dist/plyr.min.js
  var require_plyr_min = __commonJS({
    "node_modules/plyr/dist/plyr.min.js"(exports, module) {
      typeof navigator == "object" && function(e2, t3) {
        typeof exports == "object" && typeof module != "undefined" ? module.exports = t3() : typeof define == "function" && define.amd ? define("Plyr", t3) : (e2 = typeof globalThis != "undefined" ? globalThis : e2 || self).Plyr = t3();
      }(exports, function() {
        "use strict";
        function e2(e3, t4, i4) {
          return t4 in e3 ? Object.defineProperty(e3, t4, { value: i4, enumerable: true, configurable: true, writable: true }) : e3[t4] = i4, e3;
        }
        function t3(e3, t4) {
          for (var i4 = 0; i4 < t4.length; i4++) {
            var s4 = t4[i4];
            s4.enumerable = s4.enumerable || false, s4.configurable = true, "value" in s4 && (s4.writable = true), Object.defineProperty(e3, s4.key, s4);
          }
        }
        function i3(e3, t4, i4) {
          return t4 in e3 ? Object.defineProperty(e3, t4, { value: i4, enumerable: true, configurable: true, writable: true }) : e3[t4] = i4, e3;
        }
        function s3(e3, t4) {
          var i4 = Object.keys(e3);
          if (Object.getOwnPropertySymbols) {
            var s4 = Object.getOwnPropertySymbols(e3);
            t4 && (s4 = s4.filter(function(t5) {
              return Object.getOwnPropertyDescriptor(e3, t5).enumerable;
            })), i4.push.apply(i4, s4);
          }
          return i4;
        }
        function n3(e3) {
          for (var t4 = 1; t4 < arguments.length; t4++) {
            var n4 = arguments[t4] != null ? arguments[t4] : {};
            t4 % 2 ? s3(Object(n4), true).forEach(function(t5) {
              i3(e3, t5, n4[t5]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(n4)) : s3(Object(n4)).forEach(function(t5) {
              Object.defineProperty(e3, t5, Object.getOwnPropertyDescriptor(n4, t5));
            });
          }
          return e3;
        }
        var a3 = { addCSS: true, thumbWidth: 15, watch: true };
        function l3(e3, t4) {
          return function() {
            return Array.from(document.querySelectorAll(t4)).includes(this);
          }.call(e3, t4);
        }
        var o3 = function(e3) {
          return e3 != null ? e3.constructor : null;
        }, r2 = function(e3, t4) {
          return !!(e3 && t4 && e3 instanceof t4);
        }, c4 = function(e3) {
          return e3 == null;
        }, h4 = function(e3) {
          return o3(e3) === Object;
        }, u3 = function(e3) {
          return o3(e3) === String;
        }, d2 = function(e3) {
          return Array.isArray(e3);
        }, m4 = function(e3) {
          return r2(e3, NodeList);
        }, p4 = u3, g2 = d2, f3 = m4, b2 = function(e3) {
          return r2(e3, Element);
        }, y3 = function(e3) {
          return r2(e3, Event);
        }, v3 = function(e3) {
          return c4(e3) || (u3(e3) || d2(e3) || m4(e3)) && !e3.length || h4(e3) && !Object.keys(e3).length;
        };
        function w2(e3, t4) {
          if (1 > t4) {
            var i4 = function(e4) {
              var t5 = "".concat(e4).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
              return t5 ? Math.max(0, (t5[1] ? t5[1].length : 0) - (t5[2] ? +t5[2] : 0)) : 0;
            }(t4);
            return parseFloat(e3.toFixed(i4));
          }
          return Math.round(e3 / t4) * t4;
        }
        var T3 = function() {
          function e3(t4, i4) {
            (function(e4, t5) {
              if (!(e4 instanceof t5))
                throw new TypeError("Cannot call a class as a function");
            })(this, e3), b2(t4) ? this.element = t4 : p4(t4) && (this.element = document.querySelector(t4)), b2(this.element) && v3(this.element.rangeTouch) && (this.config = n3({}, a3, {}, i4), this.init());
          }
          return function(e4, i4, s4) {
            i4 && t3(e4.prototype, i4), s4 && t3(e4, s4);
          }(e3, [{ key: "init", value: function() {
            e3.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(true), this.element.rangeTouch = this);
          } }, { key: "destroy", value: function() {
            e3.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(false), this.element.rangeTouch = null);
          } }, { key: "listeners", value: function(e4) {
            var t4 = this, i4 = e4 ? "addEventListener" : "removeEventListener";
            ["touchstart", "touchmove", "touchend"].forEach(function(e5) {
              t4.element[i4](e5, function(e6) {
                return t4.set(e6);
              }, false);
            });
          } }, { key: "get", value: function(t4) {
            if (!e3.enabled || !y3(t4))
              return null;
            var i4, s4 = t4.target, n4 = t4.changedTouches[0], a4 = parseFloat(s4.getAttribute("min")) || 0, l4 = parseFloat(s4.getAttribute("max")) || 100, o4 = parseFloat(s4.getAttribute("step")) || 1, r3 = s4.getBoundingClientRect(), c5 = 100 / r3.width * (this.config.thumbWidth / 2) / 100;
            return 0 > (i4 = 100 / r3.width * (n4.clientX - r3.left)) ? i4 = 0 : 100 < i4 && (i4 = 100), 50 > i4 ? i4 -= (100 - 2 * i4) * c5 : 50 < i4 && (i4 += 2 * (i4 - 50) * c5), a4 + w2(i4 / 100 * (l4 - a4), o4);
          } }, { key: "set", value: function(t4) {
            e3.enabled && y3(t4) && !t4.target.disabled && (t4.preventDefault(), t4.target.value = this.get(t4), function(e4, t5) {
              if (e4 && t5) {
                var i4 = new Event(t5, { bubbles: true });
                e4.dispatchEvent(i4);
              }
            }(t4.target, t4.type === "touchend" ? "change" : "input"));
          } }], [{ key: "setup", value: function(t4) {
            var i4 = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, s4 = null;
            if (v3(t4) || p4(t4) ? s4 = Array.from(document.querySelectorAll(p4(t4) ? t4 : 'input[type="range"]')) : b2(t4) ? s4 = [t4] : f3(t4) ? s4 = Array.from(t4) : g2(t4) && (s4 = t4.filter(b2)), v3(s4))
              return null;
            var o4 = n3({}, a3, {}, i4);
            if (p4(t4) && o4.watch) {
              var r3 = new MutationObserver(function(i5) {
                Array.from(i5).forEach(function(i6) {
                  Array.from(i6.addedNodes).forEach(function(i7) {
                    b2(i7) && l3(i7, t4) && new e3(i7, o4);
                  });
                });
              });
              r3.observe(document.body, { childList: true, subtree: true });
            }
            return s4.map(function(t5) {
              return new e3(t5, i4);
            });
          } }, { key: "enabled", get: function() {
            return "ontouchstart" in document.documentElement;
          } }]), e3;
        }();
        const k2 = (e3) => e3 != null ? e3.constructor : null, C2 = (e3, t4) => Boolean(e3 && t4 && e3 instanceof t4), A2 = (e3) => e3 == null, S2 = (e3) => k2(e3) === Object, E2 = (e3) => k2(e3) === String, P2 = (e3) => k2(e3) === Function, N3 = (e3) => Array.isArray(e3), x2 = (e3) => C2(e3, NodeList), M2 = (e3) => A2(e3) || (E2(e3) || N3(e3) || x2(e3)) && !e3.length || S2(e3) && !Object.keys(e3).length;
        var I2 = A2, L2 = S2, $12 = (e3) => k2(e3) === Number && !Number.isNaN(e3), _3 = E2, O3 = (e3) => k2(e3) === Boolean, j2 = P2, q2 = N3, D2 = x2, H2 = (e3) => e3 !== null && typeof e3 == "object" && e3.nodeType === 1 && typeof e3.style == "object" && typeof e3.ownerDocument == "object", F2 = (e3) => C2(e3, Event), R2 = (e3) => C2(e3, KeyboardEvent), V2 = (e3) => C2(e3, TextTrack) || !A2(e3) && E2(e3.kind), B2 = (e3) => C2(e3, Promise) && P2(e3.then), U2 = (e3) => {
          if (C2(e3, window.URL))
            return true;
          if (!E2(e3))
            return false;
          let t4 = e3;
          e3.startsWith("http://") && e3.startsWith("https://") || (t4 = `http://${e3}`);
          try {
            return !M2(new URL(t4).hostname);
          } catch (e4) {
            return false;
          }
        }, W2 = M2;
        const z2 = (() => {
          const e3 = document.createElement("span"), t4 = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" }, i4 = Object.keys(t4).find((t5) => e3.style[t5] !== void 0);
          return !!_3(i4) && t4[i4];
        })();
        function K2(e3, t4) {
          setTimeout(() => {
            try {
              e3.hidden = true, e3.offsetHeight, e3.hidden = false;
            } catch (e4) {
            }
          }, t4);
        }
        const Y2 = { isIE: Boolean(window.document.documentMode), isEdge: window.navigator.userAgent.includes("Edge"), isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/.test(navigator.userAgent), isIPhone: /(iPhone|iPod)/gi.test(navigator.platform), isIos: navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 || /(iPad|iPhone|iPod)/gi.test(navigator.platform) };
        function Q2(e3, t4) {
          return t4.split(".").reduce((e4, t5) => e4 && e4[t5], e3);
        }
        function X2(e3 = {}, ...t4) {
          if (!t4.length)
            return e3;
          const i4 = t4.shift();
          return L2(i4) ? (Object.keys(i4).forEach((t5) => {
            L2(i4[t5]) ? (Object.keys(e3).includes(t5) || Object.assign(e3, { [t5]: {} }), X2(e3[t5], i4[t5])) : Object.assign(e3, { [t5]: i4[t5] });
          }), X2(e3, ...t4)) : e3;
        }
        function J2(e3, t4) {
          const i4 = e3.length ? e3 : [e3];
          Array.from(i4).reverse().forEach((e4, i5) => {
            const s4 = i5 > 0 ? t4.cloneNode(true) : t4, n4 = e4.parentNode, a4 = e4.nextSibling;
            s4.appendChild(e4), a4 ? n4.insertBefore(s4, a4) : n4.appendChild(s4);
          });
        }
        function G2(e3, t4) {
          H2(e3) && !W2(t4) && Object.entries(t4).filter(([, e4]) => !I2(e4)).forEach(([t5, i4]) => e3.setAttribute(t5, i4));
        }
        function Z2(e3, t4, i4) {
          const s4 = document.createElement(e3);
          return L2(t4) && G2(s4, t4), _3(i4) && (s4.innerText = i4), s4;
        }
        function ee2(e3, t4, i4, s4) {
          H2(t4) && t4.appendChild(Z2(e3, i4, s4));
        }
        function te2(e3) {
          D2(e3) || q2(e3) ? Array.from(e3).forEach(te2) : H2(e3) && H2(e3.parentNode) && e3.parentNode.removeChild(e3);
        }
        function ie2(e3) {
          if (!H2(e3))
            return;
          let { length: t4 } = e3.childNodes;
          for (; t4 > 0; )
            e3.removeChild(e3.lastChild), t4 -= 1;
        }
        function se2(e3, t4) {
          return H2(t4) && H2(t4.parentNode) && H2(e3) ? (t4.parentNode.replaceChild(e3, t4), e3) : null;
        }
        function ne2(e3, t4) {
          if (!_3(e3) || W2(e3))
            return {};
          const i4 = {}, s4 = X2({}, t4);
          return e3.split(",").forEach((e4) => {
            const t5 = e4.trim(), n4 = t5.replace(".", ""), a4 = t5.replace(/[[\]]/g, "").split("="), [l4] = a4, o4 = a4.length > 1 ? a4[1].replace(/["']/g, "") : "";
            switch (t5.charAt(0)) {
              case ".":
                _3(s4.class) ? i4.class = `${s4.class} ${n4}` : i4.class = n4;
                break;
              case "#":
                i4.id = t5.replace("#", "");
                break;
              case "[":
                i4[l4] = o4;
            }
          }), X2(s4, i4);
        }
        function ae2(e3, t4) {
          if (!H2(e3))
            return;
          let i4 = t4;
          O3(i4) || (i4 = !e3.hidden), e3.hidden = i4;
        }
        function le2(e3, t4, i4) {
          if (D2(e3))
            return Array.from(e3).map((e4) => le2(e4, t4, i4));
          if (H2(e3)) {
            let s4 = "toggle";
            return i4 !== void 0 && (s4 = i4 ? "add" : "remove"), e3.classList[s4](t4), e3.classList.contains(t4);
          }
          return false;
        }
        function oe2(e3, t4) {
          return H2(e3) && e3.classList.contains(t4);
        }
        function re2(e3, t4) {
          const { prototype: i4 } = Element;
          return (i4.matches || i4.webkitMatchesSelector || i4.mozMatchesSelector || i4.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t4)).includes(this);
          }).call(e3, t4);
        }
        function ce2(e3) {
          return this.elements.container.querySelectorAll(e3);
        }
        function he2(e3) {
          return this.elements.container.querySelector(e3);
        }
        function ue2(e3 = null, t4 = false) {
          H2(e3) && (e3.focus({ preventScroll: true }), t4 && le2(e3, this.config.classNames.tabFocus));
        }
        const de2 = { "audio/ogg": "vorbis", "audio/wav": "1", "video/webm": "vp8, vorbis", "video/mp4": "avc1.42E01E, mp4a.40.2", "video/ogg": "theora" }, me2 = { audio: "canPlayType" in document.createElement("audio"), video: "canPlayType" in document.createElement("video"), check(e3, t4, i4) {
          const s4 = Y2.isIPhone && i4 && me2.playsinline, n4 = me2[e3] || t4 !== "html5";
          return { api: n4, ui: n4 && me2.rangeInput && (e3 !== "video" || !Y2.isIPhone || s4) };
        }, pip: !(Y2.isIPhone || !j2(Z2("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || Z2("video").disablePictureInPicture)), airplay: j2(window.WebKitPlaybackTargetAvailabilityEvent), playsinline: "playsInline" in document.createElement("video"), mime(e3) {
          if (W2(e3))
            return false;
          const [t4] = e3.split("/");
          let i4 = e3;
          if (!this.isHTML5 || t4 !== this.type)
            return false;
          Object.keys(de2).includes(i4) && (i4 += `; codecs="${de2[e3]}"`);
          try {
            return Boolean(i4 && this.media.canPlayType(i4).replace(/no/, ""));
          } catch (e4) {
            return false;
          }
        }, textTracks: "textTracks" in document.createElement("video"), rangeInput: (() => {
          const e3 = document.createElement("input");
          return e3.type = "range", e3.type === "range";
        })(), touch: "ontouchstart" in document.documentElement, transitions: z2 !== false, reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches }, pe2 = (() => {
          let e3 = false;
          try {
            const t4 = Object.defineProperty({}, "passive", { get: () => (e3 = true, null) });
            window.addEventListener("test", null, t4), window.removeEventListener("test", null, t4);
          } catch (e4) {
          }
          return e3;
        })();
        function ge2(e3, t4, i4, s4 = false, n4 = true, a4 = false) {
          if (!e3 || !("addEventListener" in e3) || W2(t4) || !j2(i4))
            return;
          const l4 = t4.split(" ");
          let o4 = a4;
          pe2 && (o4 = { passive: n4, capture: a4 }), l4.forEach((t5) => {
            this && this.eventListeners && s4 && this.eventListeners.push({ element: e3, type: t5, callback: i4, options: o4 }), e3[s4 ? "addEventListener" : "removeEventListener"](t5, i4, o4);
          });
        }
        function fe2(e3, t4 = "", i4, s4 = true, n4 = false) {
          ge2.call(this, e3, t4, i4, true, s4, n4);
        }
        function be2(e3, t4 = "", i4, s4 = true, n4 = false) {
          ge2.call(this, e3, t4, i4, false, s4, n4);
        }
        function ye2(e3, t4 = "", i4, s4 = true, n4 = false) {
          const a4 = (...l4) => {
            be2(e3, t4, a4, s4, n4), i4.apply(this, l4);
          };
          ge2.call(this, e3, t4, a4, true, s4, n4);
        }
        function ve2(e3, t4 = "", i4 = false, s4 = {}) {
          if (!H2(e3) || W2(t4))
            return;
          const n4 = new CustomEvent(t4, { bubbles: i4, detail: { ...s4, plyr: this } });
          e3.dispatchEvent(n4);
        }
        function we2() {
          this && this.eventListeners && (this.eventListeners.forEach((e3) => {
            const { element: t4, type: i4, callback: s4, options: n4 } = e3;
            t4.removeEventListener(i4, s4, n4);
          }), this.eventListeners = []);
        }
        function Te() {
          return new Promise((e3) => this.ready ? setTimeout(e3, 0) : fe2.call(this, this.elements.container, "ready", e3)).then(() => {
          });
        }
        function ke(e3) {
          B2(e3) && e3.then(null, () => {
          });
        }
        function Ce(e3) {
          return q2(e3) ? e3.filter((t4, i4) => e3.indexOf(t4) === i4) : e3;
        }
        function Ae(e3, t4) {
          return q2(e3) && e3.length ? e3.reduce((e4, i4) => Math.abs(i4 - t4) < Math.abs(e4 - t4) ? i4 : e4) : null;
        }
        function Se(e3) {
          return !(!window || !window.CSS) && window.CSS.supports(e3);
        }
        const Ee = [[1, 1], [4, 3], [3, 4], [5, 4], [4, 5], [3, 2], [2, 3], [16, 10], [10, 16], [16, 9], [9, 16], [21, 9], [9, 21], [32, 9], [9, 32]].reduce((e3, [t4, i4]) => ({ ...e3, [t4 / i4]: [t4, i4] }), {});
        function Pe(e3) {
          if (!(q2(e3) || _3(e3) && e3.includes(":")))
            return false;
          return (q2(e3) ? e3 : e3.split(":")).map(Number).every($12);
        }
        function Ne2(e3) {
          if (!q2(e3) || !e3.every($12))
            return null;
          const [t4, i4] = e3, s4 = (e4, t5) => t5 === 0 ? e4 : s4(t5, e4 % t5), n4 = s4(t4, i4);
          return [t4 / n4, i4 / n4];
        }
        function xe(e3) {
          const t4 = (e4) => Pe(e4) ? e4.split(":").map(Number) : null;
          let i4 = t4(e3);
          if (i4 === null && (i4 = t4(this.config.ratio)), i4 === null && !W2(this.embed) && q2(this.embed.ratio) && ({ ratio: i4 } = this.embed), i4 === null && this.isHTML5) {
            const { videoWidth: e4, videoHeight: t5 } = this.media;
            i4 = [e4, t5];
          }
          return Ne2(i4);
        }
        function Me(e3) {
          if (!this.isVideo)
            return {};
          const { wrapper: t4 } = this.elements, i4 = xe.call(this, e3);
          if (!q2(i4))
            return {};
          const [s4, n4] = Ne2(i4), a4 = 100 / s4 * n4;
          if (Se(`aspect-ratio: ${s4}/${n4}`) ? t4.style.aspectRatio = `${s4}/${n4}` : t4.style.paddingBottom = `${a4}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e4 = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i5 = (e4 - a4) / (e4 / 50);
            this.fullscreen.active ? t4.style.paddingBottom = null : this.media.style.transform = `translateY(-${i5}%)`;
          } else
            this.isHTML5 && t4.classList.add(this.config.classNames.videoFixedRatio);
          return { padding: a4, ratio: i4 };
        }
        function Ie(e3, t4, i4 = 0.05) {
          const s4 = e3 / t4, n4 = Ae(Object.keys(Ee), s4);
          return Math.abs(n4 - s4) <= i4 ? Ee[n4] : [e3, t4];
        }
        const Le2 = { getSources() {
          if (!this.isHTML5)
            return [];
          return Array.from(this.media.querySelectorAll("source")).filter((e3) => {
            const t4 = e3.getAttribute("type");
            return !!W2(t4) || me2.mime.call(this, t4);
          });
        }, getQualityOptions() {
          return this.config.quality.forced ? this.config.quality.options : Le2.getSources.call(this).map((e3) => Number(e3.getAttribute("size"))).filter(Boolean);
        }, setup() {
          if (!this.isHTML5)
            return;
          const e3 = this;
          e3.options.speed = e3.config.speed.options, W2(this.config.ratio) || Me.call(e3), Object.defineProperty(e3.media, "quality", { get() {
            const t4 = Le2.getSources.call(e3).find((t5) => t5.getAttribute("src") === e3.source);
            return t4 && Number(t4.getAttribute("size"));
          }, set(t4) {
            if (e3.quality !== t4) {
              if (e3.config.quality.forced && j2(e3.config.quality.onChange))
                e3.config.quality.onChange(t4);
              else {
                const i4 = Le2.getSources.call(e3).find((e4) => Number(e4.getAttribute("size")) === t4);
                if (!i4)
                  return;
                const { currentTime: s4, paused: n4, preload: a4, readyState: l4, playbackRate: o4 } = e3.media;
                e3.media.src = i4.getAttribute("src"), (a4 !== "none" || l4) && (e3.once("loadedmetadata", () => {
                  e3.speed = o4, e3.currentTime = s4, n4 || ke(e3.play());
                }), e3.media.load());
              }
              ve2.call(e3, e3.media, "qualitychange", false, { quality: t4 });
            }
          } });
        }, cancelRequests() {
          this.isHTML5 && (te2(Le2.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        } };
        function $e(e3, ...t4) {
          return W2(e3) ? e3 : e3.toString().replace(/{(\d+)}/g, (e4, i4) => t4[i4].toString());
        }
        const _e = (e3 = "", t4 = "", i4 = "") => e3.replace(new RegExp(t4.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i4.toString()), Oe = (e3 = "") => e3.toString().replace(/\w\S*/g, (e4) => e4.charAt(0).toUpperCase() + e4.substr(1).toLowerCase());
        function je(e3 = "") {
          let t4 = e3.toString();
          return t4 = function(e4 = "") {
            let t5 = e4.toString();
            return t5 = _e(t5, "-", " "), t5 = _e(t5, "_", " "), t5 = Oe(t5), _e(t5, " ", "");
          }(t4), t4.charAt(0).toLowerCase() + t4.slice(1);
        }
        function qe(e3) {
          const t4 = document.createElement("div");
          return t4.appendChild(e3), t4.innerHTML;
        }
        const De = { pip: "PIP", airplay: "AirPlay", html5: "HTML5", vimeo: "Vimeo", youtube: "YouTube" }, He = { get(e3 = "", t4 = {}) {
          if (W2(e3) || W2(t4))
            return "";
          let i4 = Q2(t4.i18n, e3);
          if (W2(i4))
            return Object.keys(De).includes(e3) ? De[e3] : "";
          const s4 = { "{seektime}": t4.seekTime, "{title}": t4.title };
          return Object.entries(s4).forEach(([e4, t5]) => {
            i4 = _e(i4, e4, t5);
          }), i4;
        } };
        class Fe {
          constructor(t4) {
            e2(this, "get", (e3) => {
              if (!Fe.supported || !this.enabled)
                return null;
              const t5 = window.localStorage.getItem(this.key);
              if (W2(t5))
                return null;
              const i4 = JSON.parse(t5);
              return _3(e3) && e3.length ? i4[e3] : i4;
            }), e2(this, "set", (e3) => {
              if (!Fe.supported || !this.enabled)
                return;
              if (!L2(e3))
                return;
              let t5 = this.get();
              W2(t5) && (t5 = {}), X2(t5, e3);
              try {
                window.localStorage.setItem(this.key, JSON.stringify(t5));
              } catch (e4) {
              }
            }), this.enabled = t4.config.storage.enabled, this.key = t4.config.storage.key;
          }
          static get supported() {
            try {
              if (!("localStorage" in window))
                return false;
              const e3 = "___test";
              return window.localStorage.setItem(e3, e3), window.localStorage.removeItem(e3), true;
            } catch (e3) {
              return false;
            }
          }
        }
        function Re(e3, t4 = "text") {
          return new Promise((i4, s4) => {
            try {
              const s5 = new XMLHttpRequest();
              if (!("withCredentials" in s5))
                return;
              s5.addEventListener("load", () => {
                if (t4 === "text")
                  try {
                    i4(JSON.parse(s5.responseText));
                  } catch (e4) {
                    i4(s5.responseText);
                  }
                else
                  i4(s5.response);
              }), s5.addEventListener("error", () => {
                throw new Error(s5.status);
              }), s5.open("GET", e3, true), s5.responseType = t4, s5.send();
            } catch (e4) {
              s4(e4);
            }
          });
        }
        function Ve(e3, t4) {
          if (!_3(e3))
            return;
          const i4 = _3(t4);
          let s4 = false;
          const n4 = () => document.getElementById(t4) !== null, a4 = (e4, t5) => {
            e4.innerHTML = t5, i4 && n4() || document.body.insertAdjacentElement("afterbegin", e4);
          };
          if (!i4 || !n4()) {
            const n5 = Fe.supported, l4 = document.createElement("div");
            if (l4.setAttribute("hidden", ""), i4 && l4.setAttribute("id", t4), n5) {
              const e4 = window.localStorage.getItem(`cache-${t4}`);
              if (s4 = e4 !== null, s4) {
                const t5 = JSON.parse(e4);
                a4(l4, t5.content);
              }
            }
            Re(e3).then((e4) => {
              if (!W2(e4)) {
                if (n5)
                  try {
                    window.localStorage.setItem(`cache-${t4}`, JSON.stringify({ content: e4 }));
                  } catch (e5) {
                  }
                a4(l4, e4);
              }
            }).catch(() => {
            });
          }
        }
        const Be = (e3) => Math.trunc(e3 / 60 / 60 % 60, 10);
        function Ue(e3 = 0, t4 = false, i4 = false) {
          if (!$12(e3))
            return Ue(void 0, t4, i4);
          const s4 = (e4) => `0${e4}`.slice(-2);
          let n4 = Be(e3);
          const a4 = (l4 = e3, Math.trunc(l4 / 60 % 60, 10));
          var l4;
          const o4 = ((e4) => Math.trunc(e4 % 60, 10))(e3);
          return n4 = t4 || n4 > 0 ? `${n4}:` : "", `${i4 && e3 > 0 ? "-" : ""}${n4}${s4(a4)}:${s4(o4)}`;
        }
        const We = { getIconUrl() {
          const e3 = new URL(this.config.iconUrl, window.location), t4 = window.location.host ? window.location.host : window.top.location.host, i4 = e3.host !== t4 || Y2.isIE && !window.svg4everybody;
          return { url: this.config.iconUrl, cors: i4 };
        }, findElements() {
          try {
            return this.elements.controls = he2.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = { play: ce2.call(this, this.config.selectors.buttons.play), pause: he2.call(this, this.config.selectors.buttons.pause), restart: he2.call(this, this.config.selectors.buttons.restart), rewind: he2.call(this, this.config.selectors.buttons.rewind), fastForward: he2.call(this, this.config.selectors.buttons.fastForward), mute: he2.call(this, this.config.selectors.buttons.mute), pip: he2.call(this, this.config.selectors.buttons.pip), airplay: he2.call(this, this.config.selectors.buttons.airplay), settings: he2.call(this, this.config.selectors.buttons.settings), captions: he2.call(this, this.config.selectors.buttons.captions), fullscreen: he2.call(this, this.config.selectors.buttons.fullscreen) }, this.elements.progress = he2.call(this, this.config.selectors.progress), this.elements.inputs = { seek: he2.call(this, this.config.selectors.inputs.seek), volume: he2.call(this, this.config.selectors.inputs.volume) }, this.elements.display = { buffer: he2.call(this, this.config.selectors.display.buffer), currentTime: he2.call(this, this.config.selectors.display.currentTime), duration: he2.call(this, this.config.selectors.display.duration) }, H2(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), true;
          } catch (e3) {
            return this.debug.warn("It looks like there is a problem with your custom controls HTML", e3), this.toggleNativeControls(true), false;
          }
        }, createIcon(e3, t4) {
          const i4 = "http://www.w3.org/2000/svg", s4 = We.getIconUrl.call(this), n4 = `${s4.cors ? "" : s4.url}#${this.config.iconPrefix}`, a4 = document.createElementNS(i4, "svg");
          G2(a4, X2(t4, { "aria-hidden": "true", focusable: "false" }));
          const l4 = document.createElementNS(i4, "use"), o4 = `${n4}-${e3}`;
          return "href" in l4 && l4.setAttributeNS("http://www.w3.org/1999/xlink", "href", o4), l4.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", o4), a4.appendChild(l4), a4;
        }, createLabel(e3, t4 = {}) {
          const i4 = He.get(e3, this.config);
          return Z2("span", { ...t4, class: [t4.class, this.config.classNames.hidden].filter(Boolean).join(" ") }, i4);
        }, createBadge(e3) {
          if (W2(e3))
            return null;
          const t4 = Z2("span", { class: this.config.classNames.menu.value });
          return t4.appendChild(Z2("span", { class: this.config.classNames.menu.badge }, e3)), t4;
        }, createButton(e3, t4) {
          const i4 = X2({}, t4);
          let s4 = je(e3);
          const n4 = { element: "button", toggle: false, label: null, icon: null, labelPressed: null, iconPressed: null };
          switch (["element", "icon", "label"].forEach((e4) => {
            Object.keys(i4).includes(e4) && (n4[e4] = i4[e4], delete i4[e4]);
          }), n4.element !== "button" || Object.keys(i4).includes("type") || (i4.type = "button"), Object.keys(i4).includes("class") ? i4.class.split(" ").some((e4) => e4 === this.config.classNames.control) || X2(i4, { class: `${i4.class} ${this.config.classNames.control}` }) : i4.class = this.config.classNames.control, e3) {
            case "play":
              n4.toggle = true, n4.label = "play", n4.labelPressed = "pause", n4.icon = "play", n4.iconPressed = "pause";
              break;
            case "mute":
              n4.toggle = true, n4.label = "mute", n4.labelPressed = "unmute", n4.icon = "volume", n4.iconPressed = "muted";
              break;
            case "captions":
              n4.toggle = true, n4.label = "enableCaptions", n4.labelPressed = "disableCaptions", n4.icon = "captions-off", n4.iconPressed = "captions-on";
              break;
            case "fullscreen":
              n4.toggle = true, n4.label = "enterFullscreen", n4.labelPressed = "exitFullscreen", n4.icon = "enter-fullscreen", n4.iconPressed = "exit-fullscreen";
              break;
            case "play-large":
              i4.class += ` ${this.config.classNames.control}--overlaid`, s4 = "play", n4.label = "play", n4.icon = "play";
              break;
            default:
              W2(n4.label) && (n4.label = s4), W2(n4.icon) && (n4.icon = e3);
          }
          const a4 = Z2(n4.element);
          return n4.toggle ? (a4.appendChild(We.createIcon.call(this, n4.iconPressed, { class: "icon--pressed" })), a4.appendChild(We.createIcon.call(this, n4.icon, { class: "icon--not-pressed" })), a4.appendChild(We.createLabel.call(this, n4.labelPressed, { class: "label--pressed" })), a4.appendChild(We.createLabel.call(this, n4.label, { class: "label--not-pressed" }))) : (a4.appendChild(We.createIcon.call(this, n4.icon)), a4.appendChild(We.createLabel.call(this, n4.label))), X2(i4, ne2(this.config.selectors.buttons[s4], i4)), G2(a4, i4), s4 === "play" ? (q2(this.elements.buttons[s4]) || (this.elements.buttons[s4] = []), this.elements.buttons[s4].push(a4)) : this.elements.buttons[s4] = a4, a4;
        }, createRange(e3, t4) {
          const i4 = Z2("input", X2(ne2(this.config.selectors.inputs[e3]), { type: "range", min: 0, max: 100, step: 0.01, value: 0, autocomplete: "off", role: "slider", "aria-label": He.get(e3, this.config), "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": 0 }, t4));
          return this.elements.inputs[e3] = i4, We.updateRangeFill.call(this, i4), T3.setup(i4), i4;
        }, createProgress(e3, t4) {
          const i4 = Z2("progress", X2(ne2(this.config.selectors.display[e3]), { min: 0, max: 100, value: 0, role: "progressbar", "aria-hidden": true }, t4));
          if (e3 !== "volume") {
            i4.appendChild(Z2("span", null, "0"));
            const t5 = { played: "played", buffer: "buffered" }[e3], s4 = t5 ? He.get(t5, this.config) : "";
            i4.innerText = `% ${s4.toLowerCase()}`;
          }
          return this.elements.display[e3] = i4, i4;
        }, createTime(e3, t4) {
          const i4 = ne2(this.config.selectors.display[e3], t4), s4 = Z2("div", X2(i4, { class: `${i4.class ? i4.class : ""} ${this.config.classNames.display.time} `.trim(), "aria-label": He.get(e3, this.config) }), "00:00");
          return this.elements.display[e3] = s4, s4;
        }, bindMenuItemShortcuts(e3, t4) {
          fe2.call(this, e3, "keydown keyup", (i4) => {
            if (![32, 38, 39, 40].includes(i4.which))
              return;
            if (i4.preventDefault(), i4.stopPropagation(), i4.type === "keydown")
              return;
            const s4 = re2(e3, '[role="menuitemradio"]');
            if (!s4 && [32, 39].includes(i4.which))
              We.showMenuPanel.call(this, t4, true);
            else {
              let t5;
              i4.which !== 32 && (i4.which === 40 || s4 && i4.which === 39 ? (t5 = e3.nextElementSibling, H2(t5) || (t5 = e3.parentNode.firstElementChild)) : (t5 = e3.previousElementSibling, H2(t5) || (t5 = e3.parentNode.lastElementChild)), ue2.call(this, t5, true));
            }
          }, false), fe2.call(this, e3, "keyup", (e4) => {
            e4.which === 13 && We.focusFirstMenuItem.call(this, null, true);
          });
        }, createMenuItem({ value: e3, list: t4, type: i4, title: s4, badge: n4 = null, checked: a4 = false }) {
          const l4 = ne2(this.config.selectors.inputs[i4]), o4 = Z2("button", X2(l4, { type: "button", role: "menuitemradio", class: `${this.config.classNames.control} ${l4.class ? l4.class : ""}`.trim(), "aria-checked": a4, value: e3 })), r3 = Z2("span");
          r3.innerHTML = s4, H2(n4) && r3.appendChild(n4), o4.appendChild(r3), Object.defineProperty(o4, "checked", { enumerable: true, get: () => o4.getAttribute("aria-checked") === "true", set(e4) {
            e4 && Array.from(o4.parentNode.children).filter((e5) => re2(e5, '[role="menuitemradio"]')).forEach((e5) => e5.setAttribute("aria-checked", "false")), o4.setAttribute("aria-checked", e4 ? "true" : "false");
          } }), this.listeners.bind(o4, "click keyup", (t5) => {
            if (!R2(t5) || t5.which === 32) {
              switch (t5.preventDefault(), t5.stopPropagation(), o4.checked = true, i4) {
                case "language":
                  this.currentTrack = Number(e3);
                  break;
                case "quality":
                  this.quality = e3;
                  break;
                case "speed":
                  this.speed = parseFloat(e3);
              }
              We.showMenuPanel.call(this, "home", R2(t5));
            }
          }, i4, false), We.bindMenuItemShortcuts.call(this, o4, i4), t4.appendChild(o4);
        }, formatTime(e3 = 0, t4 = false) {
          if (!$12(e3))
            return e3;
          return Ue(e3, Be(this.duration) > 0, t4);
        }, updateTimeDisplay(e3 = null, t4 = 0, i4 = false) {
          H2(e3) && $12(t4) && (e3.innerText = We.formatTime(t4, i4));
        }, updateVolume() {
          this.supported.ui && (H2(this.elements.inputs.volume) && We.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), H2(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || this.volume === 0));
        }, setRange(e3, t4 = 0) {
          H2(e3) && (e3.value = t4, We.updateRangeFill.call(this, e3));
        }, updateProgress(e3) {
          if (!this.supported.ui || !F2(e3))
            return;
          let t4 = 0;
          const i4 = (e4, t5) => {
            const i5 = $12(t5) ? t5 : 0, s5 = H2(e4) ? e4 : this.elements.display.buffer;
            if (H2(s5)) {
              s5.value = i5;
              const e5 = s5.getElementsByTagName("span")[0];
              H2(e5) && (e5.childNodes[0].nodeValue = i5);
            }
          };
          if (e3)
            switch (e3.type) {
              case "timeupdate":
              case "seeking":
              case "seeked":
                s4 = this.currentTime, n4 = this.duration, t4 = s4 === 0 || n4 === 0 || Number.isNaN(s4) || Number.isNaN(n4) ? 0 : (s4 / n4 * 100).toFixed(2), e3.type === "timeupdate" && We.setRange.call(this, this.elements.inputs.seek, t4);
                break;
              case "playing":
              case "progress":
                i4(this.elements.display.buffer, 100 * this.buffered);
            }
          var s4, n4;
        }, updateRangeFill(e3) {
          const t4 = F2(e3) ? e3.target : e3;
          if (H2(t4) && t4.getAttribute("type") === "range") {
            if (re2(t4, this.config.selectors.inputs.seek)) {
              t4.setAttribute("aria-valuenow", this.currentTime);
              const e4 = We.formatTime(this.currentTime), i4 = We.formatTime(this.duration), s4 = He.get("seekLabel", this.config);
              t4.setAttribute("aria-valuetext", s4.replace("{currentTime}", e4).replace("{duration}", i4));
            } else if (re2(t4, this.config.selectors.inputs.volume)) {
              const e4 = 100 * t4.value;
              t4.setAttribute("aria-valuenow", e4), t4.setAttribute("aria-valuetext", `${e4.toFixed(1)}%`);
            } else
              t4.setAttribute("aria-valuenow", t4.value);
            Y2.isWebkit && t4.style.setProperty("--value", t4.value / t4.max * 100 + "%");
          }
        }, updateSeekTooltip(e3) {
          if (!this.config.tooltips.seek || !H2(this.elements.inputs.seek) || !H2(this.elements.display.seekTooltip) || this.duration === 0)
            return;
          const t4 = `${this.config.classNames.tooltip}--visible`, i4 = (e4) => le2(this.elements.display.seekTooltip, t4, e4);
          if (this.touch)
            return void i4(false);
          let s4 = 0;
          const n4 = this.elements.progress.getBoundingClientRect();
          if (F2(e3))
            s4 = 100 / n4.width * (e3.pageX - n4.left);
          else {
            if (!oe2(this.elements.display.seekTooltip, t4))
              return;
            s4 = parseFloat(this.elements.display.seekTooltip.style.left, 10);
          }
          s4 < 0 ? s4 = 0 : s4 > 100 && (s4 = 100), We.updateTimeDisplay.call(this, this.elements.display.seekTooltip, this.duration / 100 * s4), this.elements.display.seekTooltip.style.left = `${s4}%`, F2(e3) && ["mouseenter", "mouseleave"].includes(e3.type) && i4(e3.type === "mouseenter");
        }, timeUpdate(e3) {
          const t4 = !H2(this.elements.display.duration) && this.config.invertTime;
          We.updateTimeDisplay.call(this, this.elements.display.currentTime, t4 ? this.duration - this.currentTime : this.currentTime, t4), e3 && e3.type === "timeupdate" && this.media.seeking || We.updateProgress.call(this, e3);
        }, durationUpdate() {
          if (!this.supported.ui || !this.config.invertTime && this.currentTime)
            return;
          if (this.duration >= 2 ** 32)
            return ae2(this.elements.display.currentTime, true), void ae2(this.elements.progress, true);
          H2(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
          const e3 = H2(this.elements.display.duration);
          !e3 && this.config.displayDuration && this.paused && We.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e3 && We.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), We.updateSeekTooltip.call(this);
        }, toggleMenuButton(e3, t4) {
          ae2(this.elements.settings.buttons[e3], !t4);
        }, updateSetting(e3, t4, i4) {
          const s4 = this.elements.settings.panels[e3];
          let n4 = null, a4 = t4;
          if (e3 === "captions")
            n4 = this.currentTrack;
          else {
            if (n4 = W2(i4) ? this[e3] : i4, W2(n4) && (n4 = this.config[e3].default), !W2(this.options[e3]) && !this.options[e3].includes(n4))
              return void this.debug.warn(`Unsupported value of '${n4}' for ${e3}`);
            if (!this.config[e3].options.includes(n4))
              return void this.debug.warn(`Disabled value of '${n4}' for ${e3}`);
          }
          if (H2(a4) || (a4 = s4 && s4.querySelector('[role="menu"]')), !H2(a4))
            return;
          this.elements.settings.buttons[e3].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = We.getLabel.call(this, e3, n4);
          const l4 = a4 && a4.querySelector(`[value="${n4}"]`);
          H2(l4) && (l4.checked = true);
        }, getLabel(e3, t4) {
          switch (e3) {
            case "speed":
              return t4 === 1 ? He.get("normal", this.config) : `${t4}&times;`;
            case "quality":
              if ($12(t4)) {
                const e4 = He.get(`qualityLabel.${t4}`, this.config);
                return e4.length ? e4 : `${t4}p`;
              }
              return Oe(t4);
            case "captions":
              return Ye.getLabel.call(this);
            default:
              return null;
          }
        }, setQualityMenu(e3) {
          if (!H2(this.elements.settings.panels.quality))
            return;
          const t4 = "quality", i4 = this.elements.settings.panels.quality.querySelector('[role="menu"]');
          q2(e3) && (this.options.quality = Ce(e3).filter((e4) => this.config.quality.options.includes(e4)));
          const s4 = !W2(this.options.quality) && this.options.quality.length > 1;
          if (We.toggleMenuButton.call(this, t4, s4), ie2(i4), We.checkMenu.call(this), !s4)
            return;
          const n4 = (e4) => {
            const t5 = He.get(`qualityBadge.${e4}`, this.config);
            return t5.length ? We.createBadge.call(this, t5) : null;
          };
          this.options.quality.sort((e4, t5) => {
            const i5 = this.config.quality.options;
            return i5.indexOf(e4) > i5.indexOf(t5) ? 1 : -1;
          }).forEach((e4) => {
            We.createMenuItem.call(this, { value: e4, list: i4, type: t4, title: We.getLabel.call(this, "quality", e4), badge: n4(e4) });
          }), We.updateSetting.call(this, t4, i4);
        }, setCaptionsMenu() {
          if (!H2(this.elements.settings.panels.captions))
            return;
          const e3 = "captions", t4 = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i4 = Ye.getTracks.call(this), s4 = Boolean(i4.length);
          if (We.toggleMenuButton.call(this, e3, s4), ie2(t4), We.checkMenu.call(this), !s4)
            return;
          const n4 = i4.map((e4, i5) => ({ value: i5, checked: this.captions.toggled && this.currentTrack === i5, title: Ye.getLabel.call(this, e4), badge: e4.language && We.createBadge.call(this, e4.language.toUpperCase()), list: t4, type: "language" }));
          n4.unshift({ value: -1, checked: !this.captions.toggled, title: He.get("disabled", this.config), list: t4, type: "language" }), n4.forEach(We.createMenuItem.bind(this)), We.updateSetting.call(this, e3, t4);
        }, setSpeedMenu() {
          if (!H2(this.elements.settings.panels.speed))
            return;
          const e3 = "speed", t4 = this.elements.settings.panels.speed.querySelector('[role="menu"]');
          this.options.speed = this.options.speed.filter((e4) => e4 >= this.minimumSpeed && e4 <= this.maximumSpeed);
          const i4 = !W2(this.options.speed) && this.options.speed.length > 1;
          We.toggleMenuButton.call(this, e3, i4), ie2(t4), We.checkMenu.call(this), i4 && (this.options.speed.forEach((i5) => {
            We.createMenuItem.call(this, { value: i5, list: t4, type: e3, title: We.getLabel.call(this, "speed", i5) });
          }), We.updateSetting.call(this, e3, t4));
        }, checkMenu() {
          const { buttons: e3 } = this.elements.settings, t4 = !W2(e3) && Object.values(e3).some((e4) => !e4.hidden);
          ae2(this.elements.settings.menu, !t4);
        }, focusFirstMenuItem(e3, t4 = false) {
          if (this.elements.settings.popup.hidden)
            return;
          let i4 = e3;
          H2(i4) || (i4 = Object.values(this.elements.settings.panels).find((e4) => !e4.hidden));
          const s4 = i4.querySelector('[role^="menuitem"]');
          ue2.call(this, s4, t4);
        }, toggleMenu(e3) {
          const { popup: t4 } = this.elements.settings, i4 = this.elements.buttons.settings;
          if (!H2(t4) || !H2(i4))
            return;
          const { hidden: s4 } = t4;
          let n4 = s4;
          if (O3(e3))
            n4 = e3;
          else if (R2(e3) && e3.which === 27)
            n4 = false;
          else if (F2(e3)) {
            const s5 = j2(e3.composedPath) ? e3.composedPath()[0] : e3.target, a4 = t4.contains(s5);
            if (a4 || !a4 && e3.target !== i4 && n4)
              return;
          }
          i4.setAttribute("aria-expanded", n4), ae2(t4, !n4), le2(this.elements.container, this.config.classNames.menu.open, n4), n4 && R2(e3) ? We.focusFirstMenuItem.call(this, null, true) : n4 || s4 || ue2.call(this, i4, R2(e3));
        }, getMenuSize(e3) {
          const t4 = e3.cloneNode(true);
          t4.style.position = "absolute", t4.style.opacity = 0, t4.removeAttribute("hidden"), e3.parentNode.appendChild(t4);
          const i4 = t4.scrollWidth, s4 = t4.scrollHeight;
          return te2(t4), { width: i4, height: s4 };
        }, showMenuPanel(e3 = "", t4 = false) {
          const i4 = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e3}`);
          if (!H2(i4))
            return;
          const s4 = i4.parentNode, n4 = Array.from(s4.children).find((e4) => !e4.hidden);
          if (me2.transitions && !me2.reducedMotion) {
            s4.style.width = `${n4.scrollWidth}px`, s4.style.height = `${n4.scrollHeight}px`;
            const e4 = We.getMenuSize.call(this, i4), t5 = (e5) => {
              e5.target === s4 && ["width", "height"].includes(e5.propertyName) && (s4.style.width = "", s4.style.height = "", be2.call(this, s4, z2, t5));
            };
            fe2.call(this, s4, z2, t5), s4.style.width = `${e4.width}px`, s4.style.height = `${e4.height}px`;
          }
          ae2(n4, true), ae2(i4, false), We.focusFirstMenuItem.call(this, i4, t4);
        }, setDownloadUrl() {
          const e3 = this.elements.buttons.download;
          H2(e3) && e3.setAttribute("href", this.download);
        }, create(e3) {
          const { bindMenuItemShortcuts: t4, createButton: i4, createProgress: s4, createRange: n4, createTime: a4, setQualityMenu: l4, setSpeedMenu: o4, showMenuPanel: r3 } = We;
          this.elements.controls = null, q2(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i4.call(this, "play-large"));
          const c5 = Z2("div", ne2(this.config.selectors.controls.wrapper));
          this.elements.controls = c5;
          const h5 = { class: "plyr__controls__item" };
          return Ce(q2(this.config.controls) ? this.config.controls : []).forEach((l5) => {
            if (l5 === "restart" && c5.appendChild(i4.call(this, "restart", h5)), l5 === "rewind" && c5.appendChild(i4.call(this, "rewind", h5)), l5 === "play" && c5.appendChild(i4.call(this, "play", h5)), l5 === "fast-forward" && c5.appendChild(i4.call(this, "fast-forward", h5)), l5 === "progress") {
              const t5 = Z2("div", { class: `${h5.class} plyr__progress__container` }), i5 = Z2("div", ne2(this.config.selectors.progress));
              if (i5.appendChild(n4.call(this, "seek", { id: `plyr-seek-${e3.id}` })), i5.appendChild(s4.call(this, "buffer")), this.config.tooltips.seek) {
                const e4 = Z2("span", { class: this.config.classNames.tooltip }, "00:00");
                i5.appendChild(e4), this.elements.display.seekTooltip = e4;
              }
              this.elements.progress = i5, t5.appendChild(this.elements.progress), c5.appendChild(t5);
            }
            if (l5 === "current-time" && c5.appendChild(a4.call(this, "currentTime", h5)), l5 === "duration" && c5.appendChild(a4.call(this, "duration", h5)), l5 === "mute" || l5 === "volume") {
              let { volume: t5 } = this.elements;
              if (H2(t5) && c5.contains(t5) || (t5 = Z2("div", X2({}, h5, { class: `${h5.class} plyr__volume`.trim() })), this.elements.volume = t5, c5.appendChild(t5)), l5 === "mute" && t5.appendChild(i4.call(this, "mute")), l5 === "volume" && !Y2.isIos) {
                const i5 = { max: 1, step: 0.05, value: this.config.volume };
                t5.appendChild(n4.call(this, "volume", X2(i5, { id: `plyr-volume-${e3.id}` })));
              }
            }
            if (l5 === "captions" && c5.appendChild(i4.call(this, "captions", h5)), l5 === "settings" && !W2(this.config.settings)) {
              const s5 = Z2("div", X2({}, h5, { class: `${h5.class} plyr__menu`.trim(), hidden: "" }));
              s5.appendChild(i4.call(this, "settings", { "aria-haspopup": true, "aria-controls": `plyr-settings-${e3.id}`, "aria-expanded": false }));
              const n5 = Z2("div", { class: "plyr__menu__container", id: `plyr-settings-${e3.id}`, hidden: "" }), a5 = Z2("div"), l6 = Z2("div", { id: `plyr-settings-${e3.id}-home` }), o5 = Z2("div", { role: "menu" });
              l6.appendChild(o5), a5.appendChild(l6), this.elements.settings.panels.home = l6, this.config.settings.forEach((i5) => {
                const s6 = Z2("button", X2(ne2(this.config.selectors.buttons.settings), { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`, role: "menuitem", "aria-haspopup": true, hidden: "" }));
                t4.call(this, s6, i5), fe2.call(this, s6, "click", () => {
                  r3.call(this, i5, false);
                });
                const n6 = Z2("span", null, He.get(i5, this.config)), l7 = Z2("span", { class: this.config.classNames.menu.value });
                l7.innerHTML = e3[i5], n6.appendChild(l7), s6.appendChild(n6), o5.appendChild(s6);
                const c6 = Z2("div", { id: `plyr-settings-${e3.id}-${i5}`, hidden: "" }), h6 = Z2("button", { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--back` });
                h6.appendChild(Z2("span", { "aria-hidden": true }, He.get(i5, this.config))), h6.appendChild(Z2("span", { class: this.config.classNames.hidden }, He.get("menuBack", this.config))), fe2.call(this, c6, "keydown", (e4) => {
                  e4.which === 37 && (e4.preventDefault(), e4.stopPropagation(), r3.call(this, "home", true));
                }, false), fe2.call(this, h6, "click", () => {
                  r3.call(this, "home", false);
                }), c6.appendChild(h6), c6.appendChild(Z2("div", { role: "menu" })), a5.appendChild(c6), this.elements.settings.buttons[i5] = s6, this.elements.settings.panels[i5] = c6;
              }), n5.appendChild(a5), s5.appendChild(n5), c5.appendChild(s5), this.elements.settings.popup = n5, this.elements.settings.menu = s5;
            }
            if (l5 === "pip" && me2.pip && c5.appendChild(i4.call(this, "pip", h5)), l5 === "airplay" && me2.airplay && c5.appendChild(i4.call(this, "airplay", h5)), l5 === "download") {
              const e4 = X2({}, h5, { element: "a", href: this.download, target: "_blank" });
              this.isHTML5 && (e4.download = "");
              const { download: t5 } = this.config.urls;
              !U2(t5) && this.isEmbed && X2(e4, { icon: `logo-${this.provider}`, label: this.provider }), c5.appendChild(i4.call(this, "download", e4));
            }
            l5 === "fullscreen" && c5.appendChild(i4.call(this, "fullscreen", h5));
          }), this.isHTML5 && l4.call(this, Le2.getQualityOptions.call(this)), o4.call(this), c5;
        }, inject() {
          if (this.config.loadSprite) {
            const e4 = We.getIconUrl.call(this);
            e4.cors && Ve(e4.url, "sprite-plyr");
          }
          this.id = Math.floor(1e4 * Math.random());
          let e3 = null;
          this.elements.controls = null;
          const t4 = { id: this.id, seektime: this.config.seekTime, title: this.config.title };
          let i4 = true;
          j2(this.config.controls) && (this.config.controls = this.config.controls.call(this, t4)), this.config.controls || (this.config.controls = []), H2(this.config.controls) || _3(this.config.controls) ? e3 = this.config.controls : (e3 = We.create.call(this, { id: this.id, seektime: this.config.seekTime, speed: this.speed, quality: this.quality, captions: Ye.getLabel.call(this) }), i4 = false);
          let s4;
          i4 && _3(this.config.controls) && (e3 = ((e4) => {
            let i5 = e4;
            return Object.entries(t4).forEach(([e5, t5]) => {
              i5 = _e(i5, `{${e5}}`, t5);
            }), i5;
          })(e3)), _3(this.config.selectors.controls.container) && (s4 = document.querySelector(this.config.selectors.controls.container)), H2(s4) || (s4 = this.elements.container);
          if (s4[H2(e3) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e3), H2(this.elements.controls) || We.findElements.call(this), !W2(this.elements.buttons)) {
            const e4 = (e5) => {
              const t5 = this.config.classNames.controlPressed;
              Object.defineProperty(e5, "pressed", { enumerable: true, get: () => oe2(e5, t5), set(i5 = false) {
                le2(e5, t5, i5);
              } });
            };
            Object.values(this.elements.buttons).filter(Boolean).forEach((t5) => {
              q2(t5) || D2(t5) ? Array.from(t5).filter(Boolean).forEach(e4) : e4(t5);
            });
          }
          if (Y2.isEdge && K2(s4), this.config.tooltips.controls) {
            const { classNames: e4, selectors: t5 } = this.config, i5 = `${t5.controls.wrapper} ${t5.labels} .${e4.hidden}`, s5 = ce2.call(this, i5);
            Array.from(s5).forEach((e5) => {
              le2(e5, this.config.classNames.hidden, false), le2(e5, this.config.classNames.tooltip, true);
            });
          }
        } };
        function ze(e3, t4 = true) {
          let i4 = e3;
          if (t4) {
            const e4 = document.createElement("a");
            e4.href = i4, i4 = e4.href;
          }
          try {
            return new URL(i4);
          } catch (e4) {
            return null;
          }
        }
        function Ke(e3) {
          const t4 = new URLSearchParams();
          return L2(e3) && Object.entries(e3).forEach(([e4, i4]) => {
            t4.set(e4, i4);
          }), t4;
        }
        const Ye = { setup() {
          if (!this.supported.ui)
            return;
          if (!this.isVideo || this.isYouTube || this.isHTML5 && !me2.textTracks)
            return void (q2(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && We.setCaptionsMenu.call(this));
          var e3, t4;
          if (H2(this.elements.captions) || (this.elements.captions = Z2("div", ne2(this.config.selectors.captions)), e3 = this.elements.captions, t4 = this.elements.wrapper, H2(e3) && H2(t4) && t4.parentNode.insertBefore(e3, t4.nextSibling)), Y2.isIE && window.URL) {
            const e4 = this.media.querySelectorAll("track");
            Array.from(e4).forEach((e5) => {
              const t5 = e5.getAttribute("src"), i5 = ze(t5);
              i5 !== null && i5.hostname !== window.location.href.hostname && ["http:", "https:"].includes(i5.protocol) && Re(t5, "blob").then((t6) => {
                e5.setAttribute("src", window.URL.createObjectURL(t6));
              }).catch(() => {
                te2(e5);
              });
            });
          }
          const i4 = Ce((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map((e4) => e4.split("-")[0]));
          let s4 = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
          s4 === "auto" && ([s4] = i4);
          let n4 = this.storage.get("captions");
          if (O3(n4) || ({ active: n4 } = this.config.captions), Object.assign(this.captions, { toggled: false, active: n4, language: s4, languages: i4 }), this.isHTML5) {
            const e4 = this.config.captions.update ? "addtrack removetrack" : "removetrack";
            fe2.call(this, this.media.textTracks, e4, Ye.update.bind(this));
          }
          setTimeout(Ye.update.bind(this), 0);
        }, update() {
          const e3 = Ye.getTracks.call(this, true), { active: t4, language: i4, meta: s4, currentTrackNode: n4 } = this.captions, a4 = Boolean(e3.find((e4) => e4.language === i4));
          this.isHTML5 && this.isVideo && e3.filter((e4) => !s4.get(e4)).forEach((e4) => {
            this.debug.log("Track added", e4), s4.set(e4, { default: e4.mode === "showing" }), e4.mode === "showing" && (e4.mode = "hidden"), fe2.call(this, e4, "cuechange", () => Ye.updateCues.call(this));
          }), (a4 && this.language !== i4 || !e3.includes(n4)) && (Ye.setLanguage.call(this, i4), Ye.toggle.call(this, t4 && a4)), this.elements && le2(this.elements.container, this.config.classNames.captions.enabled, !W2(e3)), q2(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && We.setCaptionsMenu.call(this);
        }, toggle(e3, t4 = true) {
          if (!this.supported.ui)
            return;
          const { toggled: i4 } = this.captions, s4 = this.config.classNames.captions.active, n4 = I2(e3) ? !i4 : e3;
          if (n4 !== i4) {
            if (t4 || (this.captions.active = n4, this.storage.set({ captions: n4 })), !this.language && n4 && !t4) {
              const e4 = Ye.getTracks.call(this), t5 = Ye.findTrack.call(this, [this.captions.language, ...this.captions.languages], true);
              return this.captions.language = t5.language, void Ye.set.call(this, e4.indexOf(t5));
            }
            this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n4), le2(this.elements.container, s4, n4), this.captions.toggled = n4, We.updateSetting.call(this, "captions"), ve2.call(this, this.media, n4 ? "captionsenabled" : "captionsdisabled");
          }
          setTimeout(() => {
            n4 && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
          });
        }, set(e3, t4 = true) {
          const i4 = Ye.getTracks.call(this);
          if (e3 !== -1)
            if ($12(e3))
              if (e3 in i4) {
                if (this.captions.currentTrack !== e3) {
                  this.captions.currentTrack = e3;
                  const s4 = i4[e3], { language: n4 } = s4 || {};
                  this.captions.currentTrackNode = s4, We.updateSetting.call(this, "captions"), t4 || (this.captions.language = n4, this.storage.set({ language: n4 })), this.isVimeo && this.embed.enableTextTrack(n4), ve2.call(this, this.media, "languagechange");
                }
                Ye.toggle.call(this, true, t4), this.isHTML5 && this.isVideo && Ye.updateCues.call(this);
              } else
                this.debug.warn("Track not found", e3);
            else
              this.debug.warn("Invalid caption argument", e3);
          else
            Ye.toggle.call(this, false, t4);
        }, setLanguage(e3, t4 = true) {
          if (!_3(e3))
            return void this.debug.warn("Invalid language argument", e3);
          const i4 = e3.toLowerCase();
          this.captions.language = i4;
          const s4 = Ye.getTracks.call(this), n4 = Ye.findTrack.call(this, [i4]);
          Ye.set.call(this, s4.indexOf(n4), t4);
        }, getTracks(e3 = false) {
          return Array.from((this.media || {}).textTracks || []).filter((t4) => !this.isHTML5 || e3 || this.captions.meta.has(t4)).filter((e4) => ["captions", "subtitles"].includes(e4.kind));
        }, findTrack(e3, t4 = false) {
          const i4 = Ye.getTracks.call(this), s4 = (e4) => Number((this.captions.meta.get(e4) || {}).default), n4 = Array.from(i4).sort((e4, t5) => s4(t5) - s4(e4));
          let a4;
          return e3.every((e4) => (a4 = n4.find((t5) => t5.language === e4), !a4)), a4 || (t4 ? n4[0] : void 0);
        }, getCurrentTrack() {
          return Ye.getTracks.call(this)[this.currentTrack];
        }, getLabel(e3) {
          let t4 = e3;
          return !V2(t4) && me2.textTracks && this.captions.toggled && (t4 = Ye.getCurrentTrack.call(this)), V2(t4) ? W2(t4.label) ? W2(t4.language) ? He.get("enabled", this.config) : e3.language.toUpperCase() : t4.label : He.get("disabled", this.config);
        }, updateCues(e3) {
          if (!this.supported.ui)
            return;
          if (!H2(this.elements.captions))
            return void this.debug.warn("No captions element to render to");
          if (!I2(e3) && !Array.isArray(e3))
            return void this.debug.warn("updateCues: Invalid input", e3);
          let t4 = e3;
          if (!t4) {
            const e4 = Ye.getCurrentTrack.call(this);
            t4 = Array.from((e4 || {}).activeCues || []).map((e5) => e5.getCueAsHTML()).map(qe);
          }
          const i4 = t4.map((e4) => e4.trim()).join("\n");
          if (i4 !== this.elements.captions.innerHTML) {
            ie2(this.elements.captions);
            const e4 = Z2("span", ne2(this.config.selectors.caption));
            e4.innerHTML = i4, this.elements.captions.appendChild(e4), ve2.call(this, this.media, "cuechange");
          }
        } }, Qe = { enabled: true, title: "", debug: false, autoplay: false, autopause: true, playsinline: true, seekTime: 10, volume: 1, muted: false, duration: null, displayDuration: true, invertTime: true, toggleInvert: true, ratio: null, clickToPlay: true, hideControls: true, resetOnEnd: false, disableContextMenu: true, loadSprite: true, iconPrefix: "plyr", iconUrl: "https://cdn.plyr.io/3.6.9/plyr.svg", blankVideo: "https://cdn.plyr.io/static/blank.mp4", quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240], forced: false, onChange: null }, loop: { active: false }, speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4] }, keyboard: { focused: true, global: false }, tooltips: { controls: false, seek: true }, captions: { active: false, language: "auto", update: false }, fullscreen: { enabled: true, fallback: true, iosNative: false }, storage: { enabled: true, key: "plyr" }, controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"], settings: ["captions", "quality", "speed"], i18n: { restart: "Restart", rewind: "Rewind {seektime}s", play: "Play", pause: "Pause", fastForward: "Forward {seektime}s", seek: "Seek", seekLabel: "{currentTime} of {duration}", played: "Played", buffered: "Buffered", currentTime: "Current time", duration: "Duration", volume: "Volume", mute: "Mute", unmute: "Unmute", enableCaptions: "Enable captions", disableCaptions: "Disable captions", download: "Download", enterFullscreen: "Enter fullscreen", exitFullscreen: "Exit fullscreen", frameTitle: "Player for {title}", captions: "Captions", settings: "Settings", pip: "PIP", menuBack: "Go back to previous menu", speed: "Speed", normal: "Normal", quality: "Quality", loop: "Loop", start: "Start", end: "End", all: "All", reset: "Reset", disabled: "Disabled", enabled: "Enabled", advertisement: "Ad", qualityBadge: { 2160: "4K", 1440: "HD", 1080: "HD", 720: "HD", 576: "SD", 480: "SD" } }, urls: { download: null, vimeo: { sdk: "https://player.vimeo.com/api/player.js", iframe: "https://player.vimeo.com/video/{0}?{1}", api: "https://vimeo.com/api/oembed.json?url={0}" }, youtube: { sdk: "https://www.youtube.com/iframe_api", api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}" }, googleIMA: { sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js" } }, listeners: { seek: null, play: null, pause: null, restart: null, rewind: null, fastForward: null, mute: null, volume: null, captions: null, download: null, fullscreen: null, pip: null, airplay: null, speed: null, quality: null, loop: null, language: null }, events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"], selectors: { editable: "input, textarea, select, [contenteditable]", container: ".plyr", controls: { container: null, wrapper: ".plyr__controls" }, labels: "[data-plyr]", buttons: { play: '[data-plyr="play"]', pause: '[data-plyr="pause"]', restart: '[data-plyr="restart"]', rewind: '[data-plyr="rewind"]', fastForward: '[data-plyr="fast-forward"]', mute: '[data-plyr="mute"]', captions: '[data-plyr="captions"]', download: '[data-plyr="download"]', fullscreen: '[data-plyr="fullscreen"]', pip: '[data-plyr="pip"]', airplay: '[data-plyr="airplay"]', settings: '[data-plyr="settings"]', loop: '[data-plyr="loop"]' }, inputs: { seek: '[data-plyr="seek"]', volume: '[data-plyr="volume"]', speed: '[data-plyr="speed"]', language: '[data-plyr="language"]', quality: '[data-plyr="quality"]' }, display: { currentTime: ".plyr__time--current", duration: ".plyr__time--duration", buffer: ".plyr__progress__buffer", loop: ".plyr__progress__loop", volume: ".plyr__volume--display" }, progress: ".plyr__progress", captions: ".plyr__captions", caption: ".plyr__caption" }, classNames: { type: "plyr--{0}", provider: "plyr--{0}", video: "plyr__video-wrapper", embed: "plyr__video-embed", videoFixedRatio: "plyr__video-wrapper--fixed-ratio", embedContainer: "plyr__video-embed__container", poster: "plyr__poster", posterEnabled: "plyr__poster-enabled", ads: "plyr__ads", control: "plyr__control", controlPressed: "plyr__control--pressed", playing: "plyr--playing", paused: "plyr--paused", stopped: "plyr--stopped", loading: "plyr--loading", hover: "plyr--hover", tooltip: "plyr__tooltip", cues: "plyr__cues", hidden: "plyr__sr-only", hideControls: "plyr--hide-controls", isIos: "plyr--is-ios", isTouch: "plyr--is-touch", uiSupported: "plyr--full-ui", noTransition: "plyr--no-transition", display: { time: "plyr__time" }, menu: { value: "plyr__menu__value", badge: "plyr__badge", open: "plyr--menu-open" }, captions: { enabled: "plyr--captions-enabled", active: "plyr--captions-active" }, fullscreen: { enabled: "plyr--fullscreen-enabled", fallback: "plyr--fullscreen-fallback" }, pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" }, airplay: { supported: "plyr--airplay-supported", active: "plyr--airplay-active" }, tabFocus: "plyr__tab-focus", previewThumbnails: { thumbContainer: "plyr__preview-thumb", thumbContainerShown: "plyr__preview-thumb--is-shown", imageContainer: "plyr__preview-thumb__image-container", timeContainer: "plyr__preview-thumb__time-container", scrubbingContainer: "plyr__preview-scrubbing", scrubbingContainerShown: "plyr__preview-scrubbing--is-shown" } }, attributes: { embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id", hash: "data-plyr-embed-hash" } }, ads: { enabled: false, publisherId: "", tagUrl: "" }, previewThumbnails: { enabled: false, src: "" }, vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false, customControls: true, referrerPolicy: null, premium: false }, youtube: { rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, customControls: true, noCookie: false } }, Xe = "picture-in-picture", Je = "inline", Ge = { html5: "html5", youtube: "youtube", vimeo: "vimeo" }, Ze = "audio", et3 = "video";
        const tt2 = () => {
        };
        class it2 {
          constructor(e3 = false) {
            this.enabled = window.console && e3, this.enabled && this.log("Debugging enabled");
          }
          get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : tt2;
          }
          get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : tt2;
          }
          get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : tt2;
          }
        }
        class st2 {
          constructor(t4) {
            e2(this, "onChange", () => {
              if (!this.enabled)
                return;
              const e3 = this.player.elements.buttons.fullscreen;
              H2(e3) && (e3.pressed = this.active);
              const t5 = this.target === this.player.media ? this.target : this.player.elements.container;
              ve2.call(this.player, t5, this.active ? "enterfullscreen" : "exitfullscreen", true);
            }), e2(this, "toggleFallback", (e3 = false) => {
              if (e3 ? this.scrollPosition = { x: window.scrollX || 0, y: window.scrollY || 0 } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e3 ? "hidden" : "", le2(this.target, this.player.config.classNames.fullscreen.fallback, e3), Y2.isIos) {
                let t5 = document.head.querySelector('meta[name="viewport"]');
                const i4 = "viewport-fit=cover";
                t5 || (t5 = document.createElement("meta"), t5.setAttribute("name", "viewport"));
                const s4 = _3(t5.content) && t5.content.includes(i4);
                e3 ? (this.cleanupViewport = !s4, s4 || (t5.content += `,${i4}`)) : this.cleanupViewport && (t5.content = t5.content.split(",").filter((e4) => e4.trim() !== i4).join(","));
              }
              this.onChange();
            }), e2(this, "trapFocus", (e3) => {
              if (Y2.isIos || !this.active || e3.key !== "Tab" || e3.keyCode !== 9)
                return;
              const t5 = document.activeElement, i4 = ce2.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s4] = i4, n4 = i4[i4.length - 1];
              t5 !== n4 || e3.shiftKey ? t5 === s4 && e3.shiftKey && (n4.focus(), e3.preventDefault()) : (s4.focus(), e3.preventDefault());
            }), e2(this, "update", () => {
              if (this.enabled) {
                let e3;
                e3 = this.forceFallback ? "Fallback (forced)" : st2.native ? "Native" : "Fallback", this.player.debug.log(`${e3} fullscreen enabled`);
              } else
                this.player.debug.log("Fullscreen not supported and fallback disabled");
              le2(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
            }), e2(this, "enter", () => {
              this.enabled && (Y2.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !st2.native || this.forceFallback ? this.toggleFallback(true) : this.prefix ? W2(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({ navigationUI: "hide" }));
            }), e2(this, "exit", () => {
              if (this.enabled)
                if (Y2.isIos && this.player.config.fullscreen.iosNative)
                  this.target.webkitExitFullscreen(), ke(this.player.play());
                else if (!st2.native || this.forceFallback)
                  this.toggleFallback(false);
                else if (this.prefix) {
                  if (!W2(this.prefix)) {
                    const e3 = this.prefix === "moz" ? "Cancel" : "Exit";
                    document[`${this.prefix}${e3}${this.property}`]();
                  }
                } else
                  (document.cancelFullScreen || document.exitFullscreen).call(document);
            }), e2(this, "toggle", () => {
              this.active ? this.exit() : this.enter();
            }), this.player = t4, this.prefix = st2.prefix, this.property = st2.property, this.scrollPosition = { x: 0, y: 0 }, this.forceFallback = t4.config.fullscreen.fallback === "force", this.player.elements.fullscreen = t4.config.fullscreen.container && function(e3, t5) {
              const { prototype: i4 } = Element;
              return (i4.closest || function() {
                let e4 = this;
                do {
                  if (re2.matches(e4, t5))
                    return e4;
                  e4 = e4.parentElement || e4.parentNode;
                } while (e4 !== null && e4.nodeType === 1);
                return null;
              }).call(e3, t5);
            }(this.player.elements.container, t4.config.fullscreen.container), fe2.call(this.player, document, this.prefix === "ms" ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, () => {
              this.onChange();
            }), fe2.call(this.player, this.player.elements.container, "dblclick", (e3) => {
              H2(this.player.elements.controls) && this.player.elements.controls.contains(e3.target) || this.player.listeners.proxy(e3, this.toggle, "fullscreen");
            }), fe2.call(this, this.player.elements.container, "keydown", (e3) => this.trapFocus(e3)), this.update();
          }
          static get native() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
          }
          get usingNative() {
            return st2.native && !this.forceFallback;
          }
          static get prefix() {
            if (j2(document.exitFullscreen))
              return "";
            let e3 = "";
            return ["webkit", "moz", "ms"].some((t4) => !(!j2(document[`${t4}ExitFullscreen`]) && !j2(document[`${t4}CancelFullScreen`])) && (e3 = t4, true)), e3;
          }
          static get property() {
            return this.prefix === "moz" ? "FullScreen" : "Fullscreen";
          }
          get enabled() {
            return (st2.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
          }
          get active() {
            if (!this.enabled)
              return false;
            if (!st2.native || this.forceFallback)
              return oe2(this.target, this.player.config.classNames.fullscreen.fallback);
            const e3 = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e3 && e3.shadowRoot ? e3 === this.target.getRootNode().host : e3 === this.target;
          }
          get target() {
            return Y2.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
          }
        }
        function nt2(e3, t4 = 1) {
          return new Promise((i4, s4) => {
            const n4 = new Image(), a4 = () => {
              delete n4.onload, delete n4.onerror, (n4.naturalWidth >= t4 ? i4 : s4)(n4);
            };
            Object.assign(n4, { onload: a4, onerror: a4, src: e3 });
          });
        }
        const at2 = { addStyleHook() {
          le2(this.elements.container, this.config.selectors.container.replace(".", ""), true), le2(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        }, toggleNativeControls(e3 = false) {
          e3 && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        }, build() {
          if (this.listeners.media(), !this.supported.ui)
            return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void at2.toggleNativeControls.call(this, true);
          H2(this.elements.controls) || (We.inject.call(this), this.listeners.controls()), at2.toggleNativeControls.call(this), this.isHTML5 && Ye.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, We.updateVolume.call(this), We.timeUpdate.call(this), We.durationUpdate.call(this), at2.checkPlaying.call(this), le2(this.elements.container, this.config.classNames.pip.supported, me2.pip && this.isHTML5 && this.isVideo), le2(this.elements.container, this.config.classNames.airplay.supported, me2.airplay && this.isHTML5), le2(this.elements.container, this.config.classNames.isIos, Y2.isIos), le2(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = true, setTimeout(() => {
            ve2.call(this, this.media, "ready");
          }, 0), at2.setTitle.call(this), this.poster && at2.setPoster.call(this, this.poster, false).catch(() => {
          }), this.config.duration && We.durationUpdate.call(this);
        }, setTitle() {
          let e3 = He.get("play", this.config);
          if (_3(this.config.title) && !W2(this.config.title) && (e3 += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t4) => {
            t4.setAttribute("aria-label", e3);
          }), this.isEmbed) {
            const e4 = he2.call(this, "iframe");
            if (!H2(e4))
              return;
            const t4 = W2(this.config.title) ? "video" : this.config.title, i4 = He.get("frameTitle", this.config);
            e4.setAttribute("title", i4.replace("{title}", t4));
          }
        }, togglePoster(e3) {
          le2(this.elements.container, this.config.classNames.posterEnabled, e3);
        }, setPoster(e3, t4 = true) {
          return t4 && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e3), this.elements.poster.removeAttribute("hidden"), Te.call(this).then(() => nt2(e3)).catch((t5) => {
            throw e3 === this.poster && at2.togglePoster.call(this, false), t5;
          }).then(() => {
            if (e3 !== this.poster)
              throw new Error("setPoster cancelled by later call to setPoster");
          }).then(() => (Object.assign(this.elements.poster.style, { backgroundImage: `url('${e3}')`, backgroundSize: "" }), at2.togglePoster.call(this, true), e3)));
        }, checkPlaying(e3) {
          le2(this.elements.container, this.config.classNames.playing, this.playing), le2(this.elements.container, this.config.classNames.paused, this.paused), le2(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e4) => {
            Object.assign(e4, { pressed: this.playing }), e4.setAttribute("aria-label", He.get(this.playing ? "pause" : "play", this.config));
          }), F2(e3) && e3.type === "timeupdate" || at2.toggleControls.call(this);
        }, checkLoading(e3) {
          this.loading = ["stalled", "waiting"].includes(e3.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(() => {
            le2(this.elements.container, this.config.classNames.loading, this.loading), at2.toggleControls.call(this);
          }, this.loading ? 250 : 0);
        }, toggleControls(e3) {
          const { controls: t4 } = this.elements;
          if (t4 && this.config.hideControls) {
            const i4 = this.touch && this.lastSeekTime + 2e3 > Date.now();
            this.toggleControls(Boolean(e3 || this.loading || this.paused || t4.pressed || t4.hover || i4));
          }
        }, migrateStyles() {
          Object.values({ ...this.media.style }).filter((e3) => !W2(e3) && _3(e3) && e3.startsWith("--plyr")).forEach((e3) => {
            this.elements.container.style.setProperty(e3, this.media.style.getPropertyValue(e3)), this.media.style.removeProperty(e3);
          }), W2(this.media.style) && this.media.removeAttribute("style");
        } };
        class lt2 {
          constructor(t4) {
            e2(this, "firstTouch", () => {
              const { player: e3 } = this, { elements: t5 } = e3;
              e3.touch = true, le2(t5.container, e3.config.classNames.isTouch, true);
            }), e2(this, "setTabFocus", (e3) => {
              const { player: t5 } = this, { elements: i4 } = t5;
              if (clearTimeout(this.focusTimer), e3.type === "keydown" && e3.which !== 9)
                return;
              e3.type === "keydown" && (this.lastKeyDown = e3.timeStamp);
              const s4 = e3.timeStamp - this.lastKeyDown <= 20;
              (e3.type !== "focus" || s4) && ((() => {
                const e4 = t5.config.classNames.tabFocus;
                le2(ce2.call(t5, `.${e4}`), e4, false);
              })(), e3.type !== "focusout" && (this.focusTimer = setTimeout(() => {
                const e4 = document.activeElement;
                i4.container.contains(e4) && le2(document.activeElement, t5.config.classNames.tabFocus, true);
              }, 10)));
            }), e2(this, "global", (e3 = true) => {
              const { player: t5 } = this;
              t5.config.keyboard.global && ge2.call(t5, window, "keydown keyup", this.handleKey, e3, false), ge2.call(t5, document.body, "click", this.toggleMenu, e3), ye2.call(t5, document.body, "touchstart", this.firstTouch), ge2.call(t5, document.body, "keydown focus blur focusout", this.setTabFocus, e3, false, true);
            }), e2(this, "container", () => {
              const { player: e3 } = this, { config: t5, elements: i4, timers: s4 } = e3;
              !t5.keyboard.global && t5.keyboard.focused && fe2.call(e3, i4.container, "keydown keyup", this.handleKey, false), fe2.call(e3, i4.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t6) => {
                const { controls: n5 } = i4;
                n5 && t6.type === "enterfullscreen" && (n5.pressed = false, n5.hover = false);
                let a5 = 0;
                ["touchstart", "touchmove", "mousemove"].includes(t6.type) && (at2.toggleControls.call(e3, true), a5 = e3.touch ? 3e3 : 2e3), clearTimeout(s4.controls), s4.controls = setTimeout(() => at2.toggleControls.call(e3, false), a5);
              });
              const n4 = () => {
                if (!e3.isVimeo || e3.config.vimeo.premium)
                  return;
                const t6 = i4.wrapper, { active: s5 } = e3.fullscreen, [n5, a5] = xe.call(e3), l4 = Se(`aspect-ratio: ${n5} / ${a5}`);
                if (!s5)
                  return void (l4 ? (t6.style.width = null, t6.style.height = null) : (t6.style.maxWidth = null, t6.style.margin = null));
                const [o4, r3] = [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)], c5 = o4 / r3 > n5 / a5;
                l4 ? (t6.style.width = c5 ? "auto" : "100%", t6.style.height = c5 ? "100%" : "auto") : (t6.style.maxWidth = c5 ? r3 / a5 * n5 + "px" : null, t6.style.margin = c5 ? "0 auto" : null);
              }, a4 = () => {
                clearTimeout(s4.resized), s4.resized = setTimeout(n4, 50);
              };
              fe2.call(e3, i4.container, "enterfullscreen exitfullscreen", (t6) => {
                const { target: s5 } = e3.fullscreen;
                if (s5 !== i4.container)
                  return;
                if (!e3.isEmbed && W2(e3.config.ratio))
                  return;
                n4();
                (t6.type === "enterfullscreen" ? fe2 : be2).call(e3, window, "resize", a4);
              });
            }), e2(this, "media", () => {
              const { player: e3 } = this, { elements: t5 } = e3;
              if (fe2.call(e3, e3.media, "timeupdate seeking seeked", (t6) => We.timeUpdate.call(e3, t6)), fe2.call(e3, e3.media, "durationchange loadeddata loadedmetadata", (t6) => We.durationUpdate.call(e3, t6)), fe2.call(e3, e3.media, "ended", () => {
                e3.isHTML5 && e3.isVideo && e3.config.resetOnEnd && (e3.restart(), e3.pause());
              }), fe2.call(e3, e3.media, "progress playing seeking seeked", (t6) => We.updateProgress.call(e3, t6)), fe2.call(e3, e3.media, "volumechange", (t6) => We.updateVolume.call(e3, t6)), fe2.call(e3, e3.media, "playing play pause ended emptied timeupdate", (t6) => at2.checkPlaying.call(e3, t6)), fe2.call(e3, e3.media, "waiting canplay seeked playing", (t6) => at2.checkLoading.call(e3, t6)), e3.supported.ui && e3.config.clickToPlay && !e3.isAudio) {
                const i5 = he2.call(e3, `.${e3.config.classNames.video}`);
                if (!H2(i5))
                  return;
                fe2.call(e3, t5.container, "click", (s4) => {
                  ([t5.container, i5].includes(s4.target) || i5.contains(s4.target)) && (e3.touch && e3.config.hideControls || (e3.ended ? (this.proxy(s4, e3.restart, "restart"), this.proxy(s4, () => {
                    ke(e3.play());
                  }, "play")) : this.proxy(s4, () => {
                    ke(e3.togglePlay());
                  }, "play")));
                });
              }
              e3.supported.ui && e3.config.disableContextMenu && fe2.call(e3, t5.wrapper, "contextmenu", (e4) => {
                e4.preventDefault();
              }, false), fe2.call(e3, e3.media, "volumechange", () => {
                e3.storage.set({ volume: e3.volume, muted: e3.muted });
              }), fe2.call(e3, e3.media, "ratechange", () => {
                We.updateSetting.call(e3, "speed"), e3.storage.set({ speed: e3.speed });
              }), fe2.call(e3, e3.media, "qualitychange", (t6) => {
                We.updateSetting.call(e3, "quality", null, t6.detail.quality);
              }), fe2.call(e3, e3.media, "ready qualitychange", () => {
                We.setDownloadUrl.call(e3);
              });
              const i4 = e3.config.events.concat(["keyup", "keydown"]).join(" ");
              fe2.call(e3, e3.media, i4, (i5) => {
                let { detail: s4 = {} } = i5;
                i5.type === "error" && (s4 = e3.media.error), ve2.call(e3, t5.container, i5.type, true, s4);
              });
            }), e2(this, "proxy", (e3, t5, i4) => {
              const { player: s4 } = this, n4 = s4.config.listeners[i4];
              let a4 = true;
              j2(n4) && (a4 = n4.call(s4, e3)), a4 !== false && j2(t5) && t5.call(s4, e3);
            }), e2(this, "bind", (e3, t5, i4, s4, n4 = true) => {
              const { player: a4 } = this, l4 = a4.config.listeners[s4], o4 = j2(l4);
              fe2.call(a4, e3, t5, (e4) => this.proxy(e4, i4, s4), n4 && !o4);
            }), e2(this, "controls", () => {
              const { player: e3 } = this, { elements: t5 } = e3, i4 = Y2.isIE ? "change" : "input";
              if (t5.buttons.play && Array.from(t5.buttons.play).forEach((t6) => {
                this.bind(t6, "click", () => {
                  ke(e3.togglePlay());
                }, "play");
              }), this.bind(t5.buttons.restart, "click", e3.restart, "restart"), this.bind(t5.buttons.rewind, "click", () => {
                e3.lastSeekTime = Date.now(), e3.rewind();
              }, "rewind"), this.bind(t5.buttons.fastForward, "click", () => {
                e3.lastSeekTime = Date.now(), e3.forward();
              }, "fastForward"), this.bind(t5.buttons.mute, "click", () => {
                e3.muted = !e3.muted;
              }, "mute"), this.bind(t5.buttons.captions, "click", () => e3.toggleCaptions()), this.bind(t5.buttons.download, "click", () => {
                ve2.call(e3, e3.media, "download");
              }, "download"), this.bind(t5.buttons.fullscreen, "click", () => {
                e3.fullscreen.toggle();
              }, "fullscreen"), this.bind(t5.buttons.pip, "click", () => {
                e3.pip = "toggle";
              }, "pip"), this.bind(t5.buttons.airplay, "click", e3.airplay, "airplay"), this.bind(t5.buttons.settings, "click", (t6) => {
                t6.stopPropagation(), t6.preventDefault(), We.toggleMenu.call(e3, t6);
              }, null, false), this.bind(t5.buttons.settings, "keyup", (t6) => {
                const i5 = t6.which;
                [13, 32].includes(i5) && (i5 !== 13 ? (t6.preventDefault(), t6.stopPropagation(), We.toggleMenu.call(e3, t6)) : We.focusFirstMenuItem.call(e3, null, true));
              }, null, false), this.bind(t5.settings.menu, "keydown", (t6) => {
                t6.which === 27 && We.toggleMenu.call(e3, t6);
              }), this.bind(t5.inputs.seek, "mousedown mousemove", (e4) => {
                const i5 = t5.progress.getBoundingClientRect(), s4 = 100 / i5.width * (e4.pageX - i5.left);
                e4.currentTarget.setAttribute("seek-value", s4);
              }), this.bind(t5.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t6) => {
                const i5 = t6.currentTarget, s4 = t6.keyCode ? t6.keyCode : t6.which, n4 = "play-on-seeked";
                if (R2(t6) && s4 !== 39 && s4 !== 37)
                  return;
                e3.lastSeekTime = Date.now();
                const a4 = i5.hasAttribute(n4), l4 = ["mouseup", "touchend", "keyup"].includes(t6.type);
                a4 && l4 ? (i5.removeAttribute(n4), ke(e3.play())) : !l4 && e3.playing && (i5.setAttribute(n4, ""), e3.pause());
              }), Y2.isIos) {
                const t6 = ce2.call(e3, 'input[type="range"]');
                Array.from(t6).forEach((e4) => this.bind(e4, i4, (e5) => K2(e5.target)));
              }
              this.bind(t5.inputs.seek, i4, (t6) => {
                const i5 = t6.currentTarget;
                let s4 = i5.getAttribute("seek-value");
                W2(s4) && (s4 = i5.value), i5.removeAttribute("seek-value"), e3.currentTime = s4 / i5.max * e3.duration;
              }, "seek"), this.bind(t5.progress, "mouseenter mouseleave mousemove", (t6) => We.updateSeekTooltip.call(e3, t6)), this.bind(t5.progress, "mousemove touchmove", (t6) => {
                const { previewThumbnails: i5 } = e3;
                i5 && i5.loaded && i5.startMove(t6);
              }), this.bind(t5.progress, "mouseleave touchend click", () => {
                const { previewThumbnails: t6 } = e3;
                t6 && t6.loaded && t6.endMove(false, true);
              }), this.bind(t5.progress, "mousedown touchstart", (t6) => {
                const { previewThumbnails: i5 } = e3;
                i5 && i5.loaded && i5.startScrubbing(t6);
              }), this.bind(t5.progress, "mouseup touchend", (t6) => {
                const { previewThumbnails: i5 } = e3;
                i5 && i5.loaded && i5.endScrubbing(t6);
              }), Y2.isWebkit && Array.from(ce2.call(e3, 'input[type="range"]')).forEach((t6) => {
                this.bind(t6, "input", (t7) => We.updateRangeFill.call(e3, t7.target));
              }), e3.config.toggleInvert && !H2(t5.display.duration) && this.bind(t5.display.currentTime, "click", () => {
                e3.currentTime !== 0 && (e3.config.invertTime = !e3.config.invertTime, We.timeUpdate.call(e3));
              }), this.bind(t5.inputs.volume, i4, (t6) => {
                e3.volume = t6.target.value;
              }, "volume"), this.bind(t5.controls, "mouseenter mouseleave", (i5) => {
                t5.controls.hover = !e3.touch && i5.type === "mouseenter";
              }), t5.fullscreen && Array.from(t5.fullscreen.children).filter((e4) => !e4.contains(t5.container)).forEach((i5) => {
                this.bind(i5, "mouseenter mouseleave", (i6) => {
                  t5.controls && (t5.controls.hover = !e3.touch && i6.type === "mouseenter");
                });
              }), this.bind(t5.controls, "mousedown mouseup touchstart touchend touchcancel", (e4) => {
                t5.controls.pressed = ["mousedown", "touchstart"].includes(e4.type);
              }), this.bind(t5.controls, "focusin", () => {
                const { config: i5, timers: s4 } = e3;
                le2(t5.controls, i5.classNames.noTransition, true), at2.toggleControls.call(e3, true), setTimeout(() => {
                  le2(t5.controls, i5.classNames.noTransition, false);
                }, 0);
                const n4 = this.touch ? 3e3 : 4e3;
                clearTimeout(s4.controls), s4.controls = setTimeout(() => at2.toggleControls.call(e3, false), n4);
              }), this.bind(t5.inputs.volume, "wheel", (t6) => {
                const i5 = t6.webkitDirectionInvertedFromDevice, [s4, n4] = [t6.deltaX, -t6.deltaY].map((e4) => i5 ? -e4 : e4), a4 = Math.sign(Math.abs(s4) > Math.abs(n4) ? s4 : n4);
                e3.increaseVolume(a4 / 50);
                const { volume: l4 } = e3.media;
                (a4 === 1 && l4 < 1 || a4 === -1 && l4 > 0) && t6.preventDefault();
              }, "volume", false);
            }), this.player = t4, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.setTabFocus = this.setTabFocus.bind(this), this.firstTouch = this.firstTouch.bind(this);
          }
          handleKey(e3) {
            const { player: t4 } = this, { elements: i4 } = t4, s4 = e3.keyCode ? e3.keyCode : e3.which, n4 = e3.type === "keydown", a4 = n4 && s4 === this.lastKey;
            if (e3.altKey || e3.ctrlKey || e3.metaKey || e3.shiftKey)
              return;
            if (!$12(s4))
              return;
            if (n4) {
              const n5 = document.activeElement;
              if (H2(n5)) {
                const { editable: s5 } = t4.config.selectors, { seek: a5 } = i4.inputs;
                if (n5 !== a5 && re2(n5, s5))
                  return;
                if (e3.which === 32 && re2(n5, 'button, [role^="menuitem"]'))
                  return;
              }
              switch ([32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79].includes(s4) && (e3.preventDefault(), e3.stopPropagation()), s4) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  a4 || (t4.currentTime = t4.duration / 10 * (s4 - 48));
                  break;
                case 32:
                case 75:
                  a4 || ke(t4.togglePlay());
                  break;
                case 38:
                  t4.increaseVolume(0.1);
                  break;
                case 40:
                  t4.decreaseVolume(0.1);
                  break;
                case 77:
                  a4 || (t4.muted = !t4.muted);
                  break;
                case 39:
                  t4.forward();
                  break;
                case 37:
                  t4.rewind();
                  break;
                case 70:
                  t4.fullscreen.toggle();
                  break;
                case 67:
                  a4 || t4.toggleCaptions();
                  break;
                case 76:
                  t4.loop = !t4.loop;
              }
              s4 === 27 && !t4.fullscreen.usingNative && t4.fullscreen.active && t4.fullscreen.toggle(), this.lastKey = s4;
            } else
              this.lastKey = null;
          }
          toggleMenu(e3) {
            We.toggleMenu.call(this.player, e3);
          }
        }
        typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" && self;
        var ot2 = function(e3, t4) {
          return e3(t4 = { exports: {} }, t4.exports), t4.exports;
        }(function(e3, t4) {
          e3.exports = function() {
            var e4 = function() {
            }, t5 = {}, i4 = {}, s4 = {};
            function n4(e5, t6) {
              e5 = e5.push ? e5 : [e5];
              var n5, a5, l5, o5 = [], r4 = e5.length, c6 = r4;
              for (n5 = function(e6, i5) {
                i5.length && o5.push(e6), --c6 || t6(o5);
              }; r4--; )
                a5 = e5[r4], (l5 = i4[a5]) ? n5(a5, l5) : (s4[a5] = s4[a5] || []).push(n5);
            }
            function a4(e5, t6) {
              if (e5) {
                var n5 = s4[e5];
                if (i4[e5] = t6, n5)
                  for (; n5.length; )
                    n5[0](e5, t6), n5.splice(0, 1);
              }
            }
            function l4(t6, i5) {
              t6.call && (t6 = { success: t6 }), i5.length ? (t6.error || e4)(i5) : (t6.success || e4)(t6);
            }
            function o4(t6, i5, s5, n5) {
              var a5, l5, r4 = document, c6 = s5.async, h5 = (s5.numRetries || 0) + 1, u4 = s5.before || e4, d3 = t6.replace(/[\?|#].*$/, ""), m5 = t6.replace(/^(css|img)!/, "");
              n5 = n5 || 0, /(^css!|\.css$)/.test(d3) ? ((l5 = r4.createElement("link")).rel = "stylesheet", l5.href = m5, (a5 = "hideFocus" in l5) && l5.relList && (a5 = 0, l5.rel = "preload", l5.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d3) ? (l5 = r4.createElement("img")).src = m5 : ((l5 = r4.createElement("script")).src = t6, l5.async = c6 === void 0 || c6), l5.onload = l5.onerror = l5.onbeforeload = function(e5) {
                var r5 = e5.type[0];
                if (a5)
                  try {
                    l5.sheet.cssText.length || (r5 = "e");
                  } catch (e6) {
                    e6.code != 18 && (r5 = "e");
                  }
                if (r5 == "e") {
                  if ((n5 += 1) < h5)
                    return o4(t6, i5, s5, n5);
                } else if (l5.rel == "preload" && l5.as == "style")
                  return l5.rel = "stylesheet";
                i5(t6, r5, e5.defaultPrevented);
              }, u4(t6, l5) !== false && r4.head.appendChild(l5);
            }
            function r3(e5, t6, i5) {
              var s5, n5, a5 = (e5 = e5.push ? e5 : [e5]).length, l5 = a5, r4 = [];
              for (s5 = function(e6, i6, s6) {
                if (i6 == "e" && r4.push(e6), i6 == "b") {
                  if (!s6)
                    return;
                  r4.push(e6);
                }
                --a5 || t6(r4);
              }, n5 = 0; n5 < l5; n5++)
                o4(e5[n5], s5, i5);
            }
            function c5(e5, i5, s5) {
              var n5, o5;
              if (i5 && i5.trim && (n5 = i5), o5 = (n5 ? s5 : i5) || {}, n5) {
                if (n5 in t5)
                  throw "LoadJS";
                t5[n5] = true;
              }
              function c6(t6, i6) {
                r3(e5, function(e6) {
                  l4(o5, e6), t6 && l4({ success: t6, error: i6 }, e6), a4(n5, e6);
                }, o5);
              }
              if (o5.returnPromise)
                return new Promise(c6);
              c6();
            }
            return c5.ready = function(e5, t6) {
              return n4(e5, function(e6) {
                l4(t6, e6);
              }), c5;
            }, c5.done = function(e5) {
              a4(e5, []);
            }, c5.reset = function() {
              t5 = {}, i4 = {}, s4 = {};
            }, c5.isDefined = function(e5) {
              return e5 in t5;
            }, c5;
          }();
        });
        function rt2(e3) {
          return new Promise((t4, i4) => {
            ot2(e3, { success: t4, error: i4 });
          });
        }
        function ct2(e3) {
          e3 && !this.embed.hasPlayed && (this.embed.hasPlayed = true), this.media.paused === e3 && (this.media.paused = !e3, ve2.call(this, this.media, e3 ? "play" : "pause"));
        }
        const ht2 = { setup() {
          const e3 = this;
          le2(e3.elements.wrapper, e3.config.classNames.embed, true), e3.options.speed = e3.config.speed.options, Me.call(e3), L2(window.Vimeo) ? ht2.ready.call(e3) : rt2(e3.config.urls.vimeo.sdk).then(() => {
            ht2.ready.call(e3);
          }).catch((t4) => {
            e3.debug.warn("Vimeo SDK (player.js) failed to load", t4);
          });
        }, ready() {
          const e3 = this, t4 = e3.config.vimeo, { premium: i4, referrerPolicy: s4, ...n4 } = t4;
          let a4 = e3.media.getAttribute("src"), l4 = "";
          W2(a4) ? (a4 = e3.media.getAttribute(e3.config.attributes.embed.id), l4 = e3.media.getAttribute(e3.config.attributes.embed.hash)) : l4 = function(e4) {
            const t5 = e4.match(/^.*(?:vimeo.com\/|video\/)(?:\d+)(?:\?.*&*h=|\/)+(?<hash>[\d,a-f]+)/);
            return t5 ? t5.groups.hash : null;
          }(a4);
          const o4 = l4 ? { h: l4 } : {};
          i4 && Object.assign(n4, { controls: false, sidedock: false });
          const r3 = Ke({ loop: e3.config.loop.active, autoplay: e3.autoplay, muted: e3.muted, gesture: "media", playsinline: !this.config.fullscreen.iosNative, ...o4, ...n4 }), c5 = W2(h5 = a4) ? null : $12(Number(h5)) ? h5 : h5.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : h5;
          var h5;
          const u4 = Z2("iframe"), d3 = $e(e3.config.urls.vimeo.iframe, c5, r3);
          if (u4.setAttribute("src", d3), u4.setAttribute("allowfullscreen", ""), u4.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")), W2(s4) || u4.setAttribute("referrerPolicy", s4), i4 || !t4.customControls)
            u4.setAttribute("data-poster", e3.poster), e3.media = se2(u4, e3.media);
          else {
            const t5 = Z2("div", { class: e3.config.classNames.embedContainer, "data-poster": e3.poster });
            t5.appendChild(u4), e3.media = se2(t5, e3.media);
          }
          t4.customControls || Re($e(e3.config.urls.vimeo.api, d3)).then((t5) => {
            !W2(t5) && t5.thumbnail_url && at2.setPoster.call(e3, t5.thumbnail_url).catch(() => {
            });
          }), e3.embed = new window.Vimeo.Player(u4, { autopause: e3.config.autopause, muted: e3.muted }), e3.media.paused = true, e3.media.currentTime = 0, e3.supported.ui && e3.embed.disableTextTrack(), e3.media.play = () => (ct2.call(e3, true), e3.embed.play()), e3.media.pause = () => (ct2.call(e3, false), e3.embed.pause()), e3.media.stop = () => {
            e3.pause(), e3.currentTime = 0;
          };
          let { currentTime: m5 } = e3.media;
          Object.defineProperty(e3.media, "currentTime", { get: () => m5, set(t5) {
            const { embed: i5, media: s5, paused: n5, volume: a5 } = e3, l5 = n5 && !i5.hasPlayed;
            s5.seeking = true, ve2.call(e3, s5, "seeking"), Promise.resolve(l5 && i5.setVolume(0)).then(() => i5.setCurrentTime(t5)).then(() => l5 && i5.pause()).then(() => l5 && i5.setVolume(a5)).catch(() => {
            });
          } });
          let p5 = e3.config.speed.selected;
          Object.defineProperty(e3.media, "playbackRate", { get: () => p5, set(t5) {
            e3.embed.setPlaybackRate(t5).then(() => {
              p5 = t5, ve2.call(e3, e3.media, "ratechange");
            }).catch(() => {
              e3.options.speed = [1];
            });
          } });
          let { volume: g3 } = e3.config;
          Object.defineProperty(e3.media, "volume", { get: () => g3, set(t5) {
            e3.embed.setVolume(t5).then(() => {
              g3 = t5, ve2.call(e3, e3.media, "volumechange");
            });
          } });
          let { muted: f4 } = e3.config;
          Object.defineProperty(e3.media, "muted", { get: () => f4, set(t5) {
            const i5 = !!O3(t5) && t5;
            e3.embed.setVolume(i5 ? 0 : e3.config.volume).then(() => {
              f4 = i5, ve2.call(e3, e3.media, "volumechange");
            });
          } });
          let b3, { loop: y4 } = e3.config;
          Object.defineProperty(e3.media, "loop", { get: () => y4, set(t5) {
            const i5 = O3(t5) ? t5 : e3.config.loop.active;
            e3.embed.setLoop(i5).then(() => {
              y4 = i5;
            });
          } }), e3.embed.getVideoUrl().then((t5) => {
            b3 = t5, We.setDownloadUrl.call(e3);
          }).catch((e4) => {
            this.debug.warn(e4);
          }), Object.defineProperty(e3.media, "currentSrc", { get: () => b3 }), Object.defineProperty(e3.media, "ended", { get: () => e3.currentTime === e3.duration }), Promise.all([e3.embed.getVideoWidth(), e3.embed.getVideoHeight()]).then((t5) => {
            const [i5, s5] = t5;
            e3.embed.ratio = Ie(i5, s5), Me.call(this);
          }), e3.embed.setAutopause(e3.config.autopause).then((t5) => {
            e3.config.autopause = t5;
          }), e3.embed.getVideoTitle().then((t5) => {
            e3.config.title = t5, at2.setTitle.call(this);
          }), e3.embed.getCurrentTime().then((t5) => {
            m5 = t5, ve2.call(e3, e3.media, "timeupdate");
          }), e3.embed.getDuration().then((t5) => {
            e3.media.duration = t5, ve2.call(e3, e3.media, "durationchange");
          }), e3.embed.getTextTracks().then((t5) => {
            e3.media.textTracks = t5, Ye.setup.call(e3);
          }), e3.embed.on("cuechange", ({ cues: t5 = [] }) => {
            const i5 = t5.map((e4) => function(e5) {
              const t6 = document.createDocumentFragment(), i6 = document.createElement("div");
              return t6.appendChild(i6), i6.innerHTML = e5, t6.firstChild.innerText;
            }(e4.text));
            Ye.updateCues.call(e3, i5);
          }), e3.embed.on("loaded", () => {
            if (e3.embed.getPaused().then((t5) => {
              ct2.call(e3, !t5), t5 || ve2.call(e3, e3.media, "playing");
            }), H2(e3.embed.element) && e3.supported.ui) {
              e3.embed.element.setAttribute("tabindex", -1);
            }
          }), e3.embed.on("bufferstart", () => {
            ve2.call(e3, e3.media, "waiting");
          }), e3.embed.on("bufferend", () => {
            ve2.call(e3, e3.media, "playing");
          }), e3.embed.on("play", () => {
            ct2.call(e3, true), ve2.call(e3, e3.media, "playing");
          }), e3.embed.on("pause", () => {
            ct2.call(e3, false);
          }), e3.embed.on("timeupdate", (t5) => {
            e3.media.seeking = false, m5 = t5.seconds, ve2.call(e3, e3.media, "timeupdate");
          }), e3.embed.on("progress", (t5) => {
            e3.media.buffered = t5.percent, ve2.call(e3, e3.media, "progress"), parseInt(t5.percent, 10) === 1 && ve2.call(e3, e3.media, "canplaythrough"), e3.embed.getDuration().then((t6) => {
              t6 !== e3.media.duration && (e3.media.duration = t6, ve2.call(e3, e3.media, "durationchange"));
            });
          }), e3.embed.on("seeked", () => {
            e3.media.seeking = false, ve2.call(e3, e3.media, "seeked");
          }), e3.embed.on("ended", () => {
            e3.media.paused = true, ve2.call(e3, e3.media, "ended");
          }), e3.embed.on("error", (t5) => {
            e3.media.error = t5, ve2.call(e3, e3.media, "error");
          }), t4.customControls && setTimeout(() => at2.build.call(e3), 0);
        } };
        function ut2(e3) {
          e3 && !this.embed.hasPlayed && (this.embed.hasPlayed = true), this.media.paused === e3 && (this.media.paused = !e3, ve2.call(this, this.media, e3 ? "play" : "pause"));
        }
        function dt2(e3) {
          return e3.noCookie ? "https://www.youtube-nocookie.com" : window.location.protocol === "http:" ? "http://www.youtube.com" : void 0;
        }
        const mt2 = { setup() {
          if (le2(this.elements.wrapper, this.config.classNames.embed, true), L2(window.YT) && j2(window.YT.Player))
            mt2.ready.call(this);
          else {
            const e3 = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = () => {
              j2(e3) && e3(), mt2.ready.call(this);
            }, rt2(this.config.urls.youtube.sdk).catch((e4) => {
              this.debug.warn("YouTube API failed to load", e4);
            });
          }
        }, getTitle(e3) {
          Re($e(this.config.urls.youtube.api, e3)).then((e4) => {
            if (L2(e4)) {
              const { title: t4, height: i4, width: s4 } = e4;
              this.config.title = t4, at2.setTitle.call(this), this.embed.ratio = Ie(s4, i4);
            }
            Me.call(this);
          }).catch(() => {
            Me.call(this);
          });
        }, ready() {
          const e3 = this, t4 = e3.config.youtube, i4 = e3.media && e3.media.getAttribute("id");
          if (!W2(i4) && i4.startsWith("youtube-"))
            return;
          let s4 = e3.media.getAttribute("src");
          W2(s4) && (s4 = e3.media.getAttribute(this.config.attributes.embed.id));
          const n4 = W2(a4 = s4) ? null : a4.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a4;
          var a4;
          const l4 = Z2("div", { id: `${e3.provider}-${Math.floor(1e4 * Math.random())}`, "data-poster": t4.customControls ? e3.poster : void 0 });
          if (e3.media = se2(l4, e3.media), t4.customControls) {
            const t5 = (e4) => `https://i.ytimg.com/vi/${n4}/${e4}default.jpg`;
            nt2(t5("maxres"), 121).catch(() => nt2(t5("sd"), 121)).catch(() => nt2(t5("hq"))).then((t6) => at2.setPoster.call(e3, t6.src)).then((t6) => {
              t6.includes("maxres") || (e3.elements.poster.style.backgroundSize = "cover");
            }).catch(() => {
            });
          }
          e3.embed = new window.YT.Player(e3.media, { videoId: n4, host: dt2(t4), playerVars: X2({}, { autoplay: e3.config.autoplay ? 1 : 0, hl: e3.config.hl, controls: e3.supported.ui && t4.customControls ? 0 : 1, disablekb: 1, playsinline: e3.config.fullscreen.iosNative ? 0 : 1, cc_load_policy: e3.captions.active ? 1 : 0, cc_lang_pref: e3.config.captions.language, widget_referrer: window ? window.location.href : null }, t4), events: { onError(t5) {
            if (!e3.media.error) {
              const i5 = t5.data, s5 = { 2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.", 5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.", 100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.", 101: "The owner of the requested video does not allow it to be played in embedded players.", 150: "The owner of the requested video does not allow it to be played in embedded players." }[i5] || "An unknown error occured";
              e3.media.error = { code: i5, message: s5 }, ve2.call(e3, e3.media, "error");
            }
          }, onPlaybackRateChange(t5) {
            const i5 = t5.target;
            e3.media.playbackRate = i5.getPlaybackRate(), ve2.call(e3, e3.media, "ratechange");
          }, onReady(i5) {
            if (j2(e3.media.play))
              return;
            const s5 = i5.target;
            mt2.getTitle.call(e3, n4), e3.media.play = () => {
              ut2.call(e3, true), s5.playVideo();
            }, e3.media.pause = () => {
              ut2.call(e3, false), s5.pauseVideo();
            }, e3.media.stop = () => {
              s5.stopVideo();
            }, e3.media.duration = s5.getDuration(), e3.media.paused = true, e3.media.currentTime = 0, Object.defineProperty(e3.media, "currentTime", { get: () => Number(s5.getCurrentTime()), set(t5) {
              e3.paused && !e3.embed.hasPlayed && e3.embed.mute(), e3.media.seeking = true, ve2.call(e3, e3.media, "seeking"), s5.seekTo(t5);
            } }), Object.defineProperty(e3.media, "playbackRate", { get: () => s5.getPlaybackRate(), set(e4) {
              s5.setPlaybackRate(e4);
            } });
            let { volume: a5 } = e3.config;
            Object.defineProperty(e3.media, "volume", { get: () => a5, set(t5) {
              a5 = t5, s5.setVolume(100 * a5), ve2.call(e3, e3.media, "volumechange");
            } });
            let { muted: l5 } = e3.config;
            Object.defineProperty(e3.media, "muted", { get: () => l5, set(t5) {
              const i6 = O3(t5) ? t5 : l5;
              l5 = i6, s5[i6 ? "mute" : "unMute"](), s5.setVolume(100 * a5), ve2.call(e3, e3.media, "volumechange");
            } }), Object.defineProperty(e3.media, "currentSrc", { get: () => s5.getVideoUrl() }), Object.defineProperty(e3.media, "ended", { get: () => e3.currentTime === e3.duration });
            const o4 = s5.getAvailablePlaybackRates();
            e3.options.speed = o4.filter((t5) => e3.config.speed.options.includes(t5)), e3.supported.ui && t4.customControls && e3.media.setAttribute("tabindex", -1), ve2.call(e3, e3.media, "timeupdate"), ve2.call(e3, e3.media, "durationchange"), clearInterval(e3.timers.buffering), e3.timers.buffering = setInterval(() => {
              e3.media.buffered = s5.getVideoLoadedFraction(), (e3.media.lastBuffered === null || e3.media.lastBuffered < e3.media.buffered) && ve2.call(e3, e3.media, "progress"), e3.media.lastBuffered = e3.media.buffered, e3.media.buffered === 1 && (clearInterval(e3.timers.buffering), ve2.call(e3, e3.media, "canplaythrough"));
            }, 200), t4.customControls && setTimeout(() => at2.build.call(e3), 50);
          }, onStateChange(i5) {
            const s5 = i5.target;
            clearInterval(e3.timers.playing);
            switch (e3.media.seeking && [1, 2].includes(i5.data) && (e3.media.seeking = false, ve2.call(e3, e3.media, "seeked")), i5.data) {
              case -1:
                ve2.call(e3, e3.media, "timeupdate"), e3.media.buffered = s5.getVideoLoadedFraction(), ve2.call(e3, e3.media, "progress");
                break;
              case 0:
                ut2.call(e3, false), e3.media.loop ? (s5.stopVideo(), s5.playVideo()) : ve2.call(e3, e3.media, "ended");
                break;
              case 1:
                t4.customControls && !e3.config.autoplay && e3.media.paused && !e3.embed.hasPlayed ? e3.media.pause() : (ut2.call(e3, true), ve2.call(e3, e3.media, "playing"), e3.timers.playing = setInterval(() => {
                  ve2.call(e3, e3.media, "timeupdate");
                }, 50), e3.media.duration !== s5.getDuration() && (e3.media.duration = s5.getDuration(), ve2.call(e3, e3.media, "durationchange")));
                break;
              case 2:
                e3.muted || e3.embed.unMute(), ut2.call(e3, false);
                break;
              case 3:
                ve2.call(e3, e3.media, "waiting");
            }
            ve2.call(e3, e3.elements.container, "statechange", false, { code: i5.data });
          } } });
        } }, pt2 = { setup() {
          this.media ? (le2(this.elements.container, this.config.classNames.type.replace("{0}", this.type), true), le2(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), true), this.isEmbed && le2(this.elements.container, this.config.classNames.type.replace("{0}", "video"), true), this.isVideo && (this.elements.wrapper = Z2("div", { class: this.config.classNames.video }), J2(this.media, this.elements.wrapper), this.elements.poster = Z2("div", { class: this.config.classNames.poster }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? Le2.setup.call(this) : this.isYouTube ? mt2.setup.call(this) : this.isVimeo && ht2.setup.call(this)) : this.debug.warn("No media element found!");
        } };
        class gt2 {
          constructor(t4) {
            e2(this, "load", () => {
              this.enabled && (L2(window.google) && L2(window.google.ima) ? this.ready() : rt2(this.player.config.urls.googleIMA.sdk).then(() => {
                this.ready();
              }).catch(() => {
                this.trigger("error", new Error("Google IMA SDK failed to load"));
              }));
            }), e2(this, "ready", () => {
              var e3;
              this.enabled || ((e3 = this).manager && e3.manager.destroy(), e3.elements.displayContainer && e3.elements.displayContainer.destroy(), e3.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(() => {
                this.clearSafetyTimer("onAdsManagerLoaded()");
              }), this.listeners(), this.setupIMA();
            }), e2(this, "setupIMA", () => {
              this.elements.container = Z2("div", { class: this.player.config.classNames.ads }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e3) => this.onAdsManagerLoaded(e3), false), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e3) => this.onAdError(e3), false), this.requestAds();
            }), e2(this, "requestAds", () => {
              const { container: e3 } = this.player.elements;
              try {
                const t5 = new google.ima.AdsRequest();
                t5.adTagUrl = this.tagUrl, t5.linearAdSlotWidth = e3.offsetWidth, t5.linearAdSlotHeight = e3.offsetHeight, t5.nonLinearAdSlotWidth = e3.offsetWidth, t5.nonLinearAdSlotHeight = e3.offsetHeight, t5.forceNonLinearFullSlot = false, t5.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t5);
              } catch (e4) {
                this.onAdError(e4);
              }
            }), e2(this, "pollCountdown", (e3 = false) => {
              if (!e3)
                return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
              this.countdownTimer = setInterval(() => {
                const e4 = Ue(Math.max(this.manager.getRemainingTime(), 0)), t5 = `${He.get("advertisement", this.player.config)} - ${e4}`;
                this.elements.container.setAttribute("data-badge-text", t5);
              }, 100);
            }), e2(this, "onAdsManagerLoaded", (e3) => {
              if (!this.enabled)
                return;
              const t5 = new google.ima.AdsRenderingSettings();
              t5.restoreCustomPlaybackStateOnAdBreakComplete = true, t5.enablePreloading = true, this.manager = e3.getAdsManager(this.player, t5), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e4) => this.onAdError(e4)), Object.keys(google.ima.AdEvent.Type).forEach((e4) => {
                this.manager.addEventListener(google.ima.AdEvent.Type[e4], (e5) => this.onAdEvent(e5));
              }), this.trigger("loaded");
            }), e2(this, "addCuePoints", () => {
              W2(this.cuePoints) || this.cuePoints.forEach((e3) => {
                if (e3 !== 0 && e3 !== -1 && e3 < this.player.duration) {
                  const t5 = this.player.elements.progress;
                  if (H2(t5)) {
                    const i4 = 100 / this.player.duration * e3, s4 = Z2("span", { class: this.player.config.classNames.cues });
                    s4.style.left = `${i4.toString()}%`, t5.appendChild(s4);
                  }
                }
              });
            }), e2(this, "onAdEvent", (e3) => {
              const { container: t5 } = this.player.elements, i4 = e3.getAd(), s4 = e3.getAdData();
              switch (((e4) => {
                ve2.call(this.player, this.player.media, `ads${e4.replace(/_/g, "").toLowerCase()}`);
              })(e3.type), e3.type) {
                case google.ima.AdEvent.Type.LOADED:
                  this.trigger("loaded"), this.pollCountdown(true), i4.isLinear() || (i4.width = t5.offsetWidth, i4.height = t5.offsetHeight);
                  break;
                case google.ima.AdEvent.Type.STARTED:
                  this.manager.setVolume(this.player.volume);
                  break;
                case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                  this.player.ended ? this.loadAds() : this.loader.contentComplete();
                  break;
                case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                  this.pauseContent();
                  break;
                case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                  this.pollCountdown(), this.resumeContent();
                  break;
                case google.ima.AdEvent.Type.LOG:
                  s4.adError && this.player.debug.warn(`Non-fatal ad error: ${s4.adError.getMessage()}`);
              }
            }), e2(this, "onAdError", (e3) => {
              this.cancel(), this.player.debug.warn("Ads error", e3);
            }), e2(this, "listeners", () => {
              const { container: e3 } = this.player.elements;
              let t5;
              this.player.on("canplay", () => {
                this.addCuePoints();
              }), this.player.on("ended", () => {
                this.loader.contentComplete();
              }), this.player.on("timeupdate", () => {
                t5 = this.player.currentTime;
              }), this.player.on("seeked", () => {
                const e4 = this.player.currentTime;
                W2(this.cuePoints) || this.cuePoints.forEach((i4, s4) => {
                  t5 < i4 && i4 < e4 && (this.manager.discardAdBreak(), this.cuePoints.splice(s4, 1));
                });
              }), window.addEventListener("resize", () => {
                this.manager && this.manager.resize(e3.offsetWidth, e3.offsetHeight, google.ima.ViewMode.NORMAL);
              });
            }), e2(this, "play", () => {
              const { container: e3 } = this.player.elements;
              this.managerPromise || this.resumeContent(), this.managerPromise.then(() => {
                this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                try {
                  this.initialized || (this.manager.init(e3.offsetWidth, e3.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = true;
                } catch (e4) {
                  this.onAdError(e4);
                }
              }).catch(() => {
              });
            }), e2(this, "resumeContent", () => {
              this.elements.container.style.zIndex = "", this.playing = false, ke(this.player.media.play());
            }), e2(this, "pauseContent", () => {
              this.elements.container.style.zIndex = 3, this.playing = true, this.player.media.pause();
            }), e2(this, "cancel", () => {
              this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e2(this, "loadAds", () => {
              this.managerPromise.then(() => {
                this.manager && this.manager.destroy(), this.managerPromise = new Promise((e3) => {
                  this.on("loaded", e3), this.player.debug.log(this.manager);
                }), this.initialized = false, this.requestAds();
              }).catch(() => {
              });
            }), e2(this, "trigger", (e3, ...t5) => {
              const i4 = this.events[e3];
              q2(i4) && i4.forEach((e4) => {
                j2(e4) && e4.apply(this, t5);
              });
            }), e2(this, "on", (e3, t5) => (q2(this.events[e3]) || (this.events[e3] = []), this.events[e3].push(t5), this)), e2(this, "startSafetyTimer", (e3, t5) => {
              this.player.debug.log(`Safety timer invoked from: ${t5}`), this.safetyTimer = setTimeout(() => {
                this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
              }, e3);
            }), e2(this, "clearSafetyTimer", (e3) => {
              I2(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e3}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t4, this.config = t4.config.ads, this.playing = false, this.initialized = false, this.elements = { container: null, displayContainer: null }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e3, t5) => {
              this.on("loaded", e3), this.on("error", t5);
            }), this.load();
          }
          get enabled() {
            const { config: e3 } = this;
            return this.player.isHTML5 && this.player.isVideo && e3.enabled && (!W2(e3.publisherId) || U2(e3.tagUrl));
          }
          get tagUrl() {
            const { config: e3 } = this;
            if (U2(e3.tagUrl))
              return e3.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ke({ AV_PUBLISHERID: "58c25bb0073ef448b1087ad6", AV_CHANNELID: "5a0458dc28a06145e4519d21", AV_URL: window.location.hostname, cb: Date.now(), AV_WIDTH: 640, AV_HEIGHT: 480, AV_CDIM2: e3.publisherId })}`;
          }
        }
        const ft2 = (e3) => {
          const t4 = [];
          return e3.split(/\r\n\r\n|\n\n|\r\r/).forEach((e4) => {
            const i4 = {};
            e4.split(/\r\n|\n|\r/).forEach((e5) => {
              if ($12(i4.startTime)) {
                if (!W2(e5.trim()) && W2(i4.text)) {
                  const t5 = e5.trim().split("#xywh=");
                  [i4.text] = t5, t5[1] && ([i4.x, i4.y, i4.w, i4.h] = t5[1].split(","));
                }
              } else {
                const t5 = e5.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                t5 && (i4.startTime = 60 * Number(t5[1] || 0) * 60 + 60 * Number(t5[2]) + Number(t5[3]) + Number(`0.${t5[4]}`), i4.endTime = 60 * Number(t5[6] || 0) * 60 + 60 * Number(t5[7]) + Number(t5[8]) + Number(`0.${t5[9]}`));
              }
            }), i4.text && t4.push(i4);
          }), t4;
        }, bt2 = (e3, t4) => {
          const i4 = {};
          return e3 > t4.width / t4.height ? (i4.width = t4.width, i4.height = 1 / e3 * t4.width) : (i4.height = t4.height, i4.width = e3 * t4.height), i4;
        };
        class yt2 {
          constructor(t4) {
            e2(this, "load", () => {
              this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(() => {
                this.enabled && (this.render(), this.determineContainerAutoSizing(), this.loaded = true);
              });
            }), e2(this, "getThumbnails", () => new Promise((e3) => {
              const { src: t5 } = this.player.config.previewThumbnails;
              if (W2(t5))
                throw new Error("Missing previewThumbnails.src config attribute");
              const i4 = () => {
                this.thumbnails.sort((e4, t6) => e4.height - t6.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e3();
              };
              if (j2(t5))
                t5((e4) => {
                  this.thumbnails = e4, i4();
                });
              else {
                const e4 = (_3(t5) ? [t5] : t5).map((e5) => this.getThumbnail(e5));
                Promise.all(e4).then(i4);
              }
            })), e2(this, "getThumbnail", (e3) => new Promise((t5) => {
              Re(e3).then((i4) => {
                const s4 = { frames: ft2(i4), height: null, urlPrefix: "" };
                s4.frames[0].text.startsWith("/") || s4.frames[0].text.startsWith("http://") || s4.frames[0].text.startsWith("https://") || (s4.urlPrefix = e3.substring(0, e3.lastIndexOf("/") + 1));
                const n4 = new Image();
                n4.onload = () => {
                  s4.height = n4.naturalHeight, s4.width = n4.naturalWidth, this.thumbnails.push(s4), t5();
                }, n4.src = s4.urlPrefix + s4.frames[0].text;
              });
            })), e2(this, "startMove", (e3) => {
              if (this.loaded && F2(e3) && ["touchmove", "mousemove"].includes(e3.type) && this.player.media.duration) {
                if (e3.type === "touchmove")
                  this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                else {
                  const t5 = this.player.elements.progress.getBoundingClientRect(), i4 = 100 / t5.width * (e3.pageX - t5.left);
                  this.seekTime = this.player.media.duration * (i4 / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e3.pageX, this.elements.thumb.time.innerText = Ue(this.seekTime);
                }
                this.showImageAtCurrentTime();
              }
            }), e2(this, "endMove", () => {
              this.toggleThumbContainer(false, true);
            }), e2(this, "startScrubbing", (e3) => {
              (I2(e3.button) || e3.button === false || e3.button === 0) && (this.mouseDown = true, this.player.media.duration && (this.toggleScrubbingContainer(true), this.toggleThumbContainer(false, true), this.showImageAtCurrentTime()));
            }), e2(this, "endScrubbing", () => {
              this.mouseDown = false, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(false) : ye2.call(this.player, this.player.media, "timeupdate", () => {
                this.mouseDown || this.toggleScrubbingContainer(false);
              });
            }), e2(this, "listeners", () => {
              this.player.on("play", () => {
                this.toggleThumbContainer(false, true);
              }), this.player.on("seeked", () => {
                this.toggleThumbContainer(false);
              }), this.player.on("timeupdate", () => {
                this.lastTime = this.player.media.currentTime;
              });
            }), e2(this, "render", () => {
              this.elements.thumb.container = Z2("div", { class: this.player.config.classNames.previewThumbnails.thumbContainer }), this.elements.thumb.imageContainer = Z2("div", { class: this.player.config.classNames.previewThumbnails.imageContainer }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
              const e3 = Z2("div", { class: this.player.config.classNames.previewThumbnails.timeContainer });
              this.elements.thumb.time = Z2("span", {}, "00:00"), e3.appendChild(this.elements.thumb.time), this.elements.thumb.container.appendChild(e3), H2(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = Z2("div", { class: this.player.config.classNames.previewThumbnails.scrubbingContainer }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e2(this, "destroy", () => {
              this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e2(this, "showImageAtCurrentTime", () => {
              this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
              const e3 = this.thumbnails[0].frames.findIndex((e4) => this.seekTime >= e4.startTime && this.seekTime <= e4.endTime), t5 = e3 >= 0;
              let i4 = 0;
              this.mouseDown || this.toggleThumbContainer(t5), t5 && (this.thumbnails.forEach((t6, s4) => {
                this.loadedImages.includes(t6.frames[e3].text) && (i4 = s4);
              }), e3 !== this.showingThumb && (this.showingThumb = e3, this.loadImage(i4)));
            }), e2(this, "loadImage", (e3 = 0) => {
              const t5 = this.showingThumb, i4 = this.thumbnails[e3], { urlPrefix: s4 } = i4, n4 = i4.frames[t5], a4 = i4.frames[t5].text, l4 = s4 + a4;
              if (this.currentImageElement && this.currentImageElement.dataset.filename === a4)
                this.showImage(this.currentImageElement, n4, e3, t5, a4, false), this.currentImageElement.dataset.index = t5, this.removeOldImages(this.currentImageElement);
              else {
                this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                const i5 = new Image();
                i5.src = l4, i5.dataset.index = t5, i5.dataset.filename = a4, this.showingThumbFilename = a4, this.player.debug.log(`Loading image: ${l4}`), i5.onload = () => this.showImage(i5, n4, e3, t5, a4, true), this.loadingImage = i5, this.removeOldImages(i5);
              }
            }), e2(this, "showImage", (e3, t5, i4, s4, n4, a4 = true) => {
              this.player.debug.log(`Showing thumb: ${n4}. num: ${s4}. qual: ${i4}. newimg: ${a4}`), this.setImageSizeAndOffset(e3, t5), a4 && (this.currentImageContainer.appendChild(e3), this.currentImageElement = e3, this.loadedImages.includes(n4) || this.loadedImages.push(n4)), this.preloadNearby(s4, true).then(this.preloadNearby(s4, false)).then(this.getHigherQuality(i4, e3, t5, n4));
            }), e2(this, "removeOldImages", (e3) => {
              Array.from(this.currentImageContainer.children).forEach((t5) => {
                if (t5.tagName.toLowerCase() !== "img")
                  return;
                const i4 = this.usingSprites ? 500 : 1e3;
                if (t5.dataset.index !== e3.dataset.index && !t5.dataset.deleting) {
                  t5.dataset.deleting = true;
                  const { currentImageContainer: e4 } = this;
                  setTimeout(() => {
                    e4.removeChild(t5), this.player.debug.log(`Removing thumb: ${t5.dataset.filename}`);
                  }, i4);
                }
              });
            }), e2(this, "preloadNearby", (e3, t5 = true) => new Promise((i4) => {
              setTimeout(() => {
                const s4 = this.thumbnails[0].frames[e3].text;
                if (this.showingThumbFilename === s4) {
                  let n4;
                  n4 = t5 ? this.thumbnails[0].frames.slice(e3) : this.thumbnails[0].frames.slice(0, e3).reverse();
                  let a4 = false;
                  n4.forEach((e4) => {
                    const t6 = e4.text;
                    if (t6 !== s4 && !this.loadedImages.includes(t6)) {
                      a4 = true, this.player.debug.log(`Preloading thumb filename: ${t6}`);
                      const { urlPrefix: e5 } = this.thumbnails[0], s5 = e5 + t6, n5 = new Image();
                      n5.src = s5, n5.onload = () => {
                        this.player.debug.log(`Preloaded thumb filename: ${t6}`), this.loadedImages.includes(t6) || this.loadedImages.push(t6), i4();
                      };
                    }
                  }), a4 || i4();
                }
              }, 300);
            })), e2(this, "getHigherQuality", (e3, t5, i4, s4) => {
              if (e3 < this.thumbnails.length - 1) {
                let n4 = t5.naturalHeight;
                this.usingSprites && (n4 = i4.h), n4 < this.thumbContainerHeight && setTimeout(() => {
                  this.showingThumbFilename === s4 && (this.player.debug.log(`Showing higher quality thumb for: ${s4}`), this.loadImage(e3 + 1));
                }, 300);
              }
            }), e2(this, "toggleThumbContainer", (e3 = false, t5 = false) => {
              const i4 = this.player.config.classNames.previewThumbnails.thumbContainerShown;
              this.elements.thumb.container.classList.toggle(i4, e3), !e3 && t5 && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e2(this, "toggleScrubbingContainer", (e3 = false) => {
              const t5 = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
              this.elements.scrubbing.container.classList.toggle(t5, e3), e3 || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e2(this, "determineContainerAutoSizing", () => {
              (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = true);
            }), e2(this, "setThumbContainerSizeAndPos", () => {
              if (this.sizeSpecifiedInCSS) {
                if (this.elements.thumb.imageContainer.clientHeight > 20 && this.elements.thumb.imageContainer.clientWidth < 20) {
                  const e3 = Math.floor(this.elements.thumb.imageContainer.clientHeight * this.thumbAspectRatio);
                  this.elements.thumb.imageContainer.style.width = `${e3}px`;
                } else if (this.elements.thumb.imageContainer.clientHeight < 20 && this.elements.thumb.imageContainer.clientWidth > 20) {
                  const e3 = Math.floor(this.elements.thumb.imageContainer.clientWidth / this.thumbAspectRatio);
                  this.elements.thumb.imageContainer.style.height = `${e3}px`;
                }
              } else {
                const e3 = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                this.elements.thumb.imageContainer.style.height = `${this.thumbContainerHeight}px`, this.elements.thumb.imageContainer.style.width = `${e3}px`;
              }
              this.setThumbContainerPos();
            }), e2(this, "setThumbContainerPos", () => {
              const e3 = this.player.elements.progress.getBoundingClientRect(), t5 = this.player.elements.container.getBoundingClientRect(), { container: i4 } = this.elements.thumb, s4 = t5.left - e3.left + 10, n4 = t5.right - e3.left - i4.clientWidth - 10;
              let a4 = this.mousePosX - e3.left - i4.clientWidth / 2;
              a4 < s4 && (a4 = s4), a4 > n4 && (a4 = n4), i4.style.left = `${a4}px`;
            }), e2(this, "setScrubbingContainerSize", () => {
              const { width: e3, height: t5 } = bt2(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
              this.elements.scrubbing.container.style.width = `${e3}px`, this.elements.scrubbing.container.style.height = `${t5}px`;
            }), e2(this, "setImageSizeAndOffset", (e3, t5) => {
              if (!this.usingSprites)
                return;
              const i4 = this.thumbContainerHeight / t5.h;
              e3.style.height = e3.naturalHeight * i4 + "px", e3.style.width = e3.naturalWidth * i4 + "px", e3.style.left = `-${t5.x * i4}px`, e3.style.top = `-${t5.y * i4}px`;
            }), this.player = t4, this.thumbnails = [], this.loaded = false, this.lastMouseMoveTime = Date.now(), this.mouseDown = false, this.loadedImages = [], this.elements = { thumb: {}, scrubbing: {} }, this.load();
          }
          get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
          }
          get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
          }
          get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
          }
          get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
          }
          get thumbContainerHeight() {
            if (this.mouseDown) {
              const { height: e3 } = bt2(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
              return e3;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
          }
          get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
          }
          set currentImageElement(e3) {
            this.mouseDown ? this.currentScrubbingImageElement = e3 : this.currentThumbnailImageElement = e3;
          }
        }
        const vt2 = { insertElements(e3, t4) {
          _3(t4) ? ee2(e3, this.media, { src: t4 }) : q2(t4) && t4.forEach((t5) => {
            ee2(e3, this.media, t5);
          });
        }, change(e3) {
          Q2(e3, "sources.length") ? (Le2.cancelRequests.call(this), this.destroy.call(this, () => {
            this.options.quality = [], te2(this.media), this.media = null, H2(this.elements.container) && this.elements.container.removeAttribute("class");
            const { sources: t4, type: i4 } = e3, [{ provider: s4 = Ge.html5, src: n4 }] = t4, a4 = s4 === "html5" ? i4 : "div", l4 = s4 === "html5" ? {} : { src: n4 };
            Object.assign(this, { provider: s4, type: i4, supported: me2.check(i4, s4, this.config.playsinline), media: Z2(a4, l4) }), this.elements.container.appendChild(this.media), O3(e3.autoplay) && (this.config.autoplay = e3.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), W2(e3.poster) || (this.poster = e3.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), at2.addStyleHook.call(this), this.isHTML5 && vt2.insertElements.call(this, "source", t4), this.config.title = e3.title, pt2.setup.call(this), this.isHTML5 && Object.keys(e3).includes("tracks") && vt2.insertElements.call(this, "track", e3.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && at2.build.call(this), this.isHTML5 && this.media.load(), W2(e3.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e3.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new yt2(this))), this.fullscreen.update();
          }, true)) : this.debug.warn("Invalid source format");
        } };
        class wt2 {
          constructor(t4, i4) {
            if (e2(this, "play", () => j2(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(() => this.ads.play()).catch(() => ke(this.media.play())), this.media.play()) : null), e2(this, "pause", () => this.playing && j2(this.media.pause) ? this.media.pause() : null), e2(this, "togglePlay", (e3) => (O3(e3) ? e3 : !this.playing) ? this.play() : this.pause()), e2(this, "stop", () => {
              this.isHTML5 ? (this.pause(), this.restart()) : j2(this.media.stop) && this.media.stop();
            }), e2(this, "restart", () => {
              this.currentTime = 0;
            }), e2(this, "rewind", (e3) => {
              this.currentTime -= $12(e3) ? e3 : this.config.seekTime;
            }), e2(this, "forward", (e3) => {
              this.currentTime += $12(e3) ? e3 : this.config.seekTime;
            }), e2(this, "increaseVolume", (e3) => {
              const t5 = this.media.muted ? 0 : this.volume;
              this.volume = t5 + ($12(e3) ? e3 : 0);
            }), e2(this, "decreaseVolume", (e3) => {
              this.increaseVolume(-e3);
            }), e2(this, "airplay", () => {
              me2.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e2(this, "toggleControls", (e3) => {
              if (this.supported.ui && !this.isAudio) {
                const t5 = oe2(this.elements.container, this.config.classNames.hideControls), i5 = e3 === void 0 ? void 0 : !e3, s5 = le2(this.elements.container, this.config.classNames.hideControls, i5);
                if (s5 && q2(this.config.controls) && this.config.controls.includes("settings") && !W2(this.config.settings) && We.toggleMenu.call(this, false), s5 !== t5) {
                  const e4 = s5 ? "controlshidden" : "controlsshown";
                  ve2.call(this, this.media, e4);
                }
                return !s5;
              }
              return false;
            }), e2(this, "on", (e3, t5) => {
              fe2.call(this, this.elements.container, e3, t5);
            }), e2(this, "once", (e3, t5) => {
              ye2.call(this, this.elements.container, e3, t5);
            }), e2(this, "off", (e3, t5) => {
              be2(this.elements.container, e3, t5);
            }), e2(this, "destroy", (e3, t5 = false) => {
              if (!this.ready)
                return;
              const i5 = () => {
                document.body.style.overflow = "", this.embed = null, t5 ? (Object.keys(this.elements).length && (te2(this.elements.buttons.play), te2(this.elements.captions), te2(this.elements.controls), te2(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), j2(e3) && e3()) : (we2.call(this), Le2.cancelRequests.call(this), se2(this.elements.original, this.elements.container), ve2.call(this, this.elements.original, "destroyed", true), j2(e3) && e3.call(this.elements.original), this.ready = false, setTimeout(() => {
                  this.elements = null, this.media = null;
                }, 200));
              };
              this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (at2.toggleNativeControls.call(this, true), i5()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), this.embed !== null && j2(this.embed.destroy) && this.embed.destroy(), i5()) : this.isVimeo && (this.embed !== null && this.embed.unload().then(i5), setTimeout(i5, 200));
            }), e2(this, "supports", (e3) => me2.mime.call(this, e3)), this.timers = {}, this.ready = false, this.loading = false, this.failed = false, this.touch = me2.touch, this.media = t4, _3(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || D2(this.media) || q2(this.media)) && (this.media = this.media[0]), this.config = X2({}, Qe, wt2.defaults, i4 || {}, (() => {
              try {
                return JSON.parse(this.media.getAttribute("data-plyr-config"));
              } catch (e3) {
                return {};
              }
            })()), this.elements = { container: null, fullscreen: null, captions: null, buttons: {}, display: {}, progress: {}, inputs: {}, settings: { popup: null, menu: null, panels: {}, buttons: {} } }, this.captions = { active: null, currentTrack: -1, meta: new WeakMap() }, this.fullscreen = { active: false }, this.options = { speed: [], quality: [] }, this.debug = new it2(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", me2), I2(this.media) || !H2(this.media))
              return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr)
              return void this.debug.warn("Target already setup");
            if (!this.config.enabled)
              return void this.debug.error("Setup failed: disabled by config");
            if (!me2.check().api)
              return void this.debug.error("Setup failed: no support");
            const s4 = this.media.cloneNode(true);
            s4.autoplay = false, this.elements.original = s4;
            const n4 = this.media.tagName.toLowerCase();
            let a4 = null, l4 = null;
            switch (n4) {
              case "div":
                if (a4 = this.media.querySelector("iframe"), H2(a4)) {
                  if (l4 = ze(a4.getAttribute("src")), this.provider = function(e3) {
                    return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e3) ? Ge.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e3) ? Ge.vimeo : null;
                  }(l4.toString()), this.elements.container = this.media, this.media = a4, this.elements.container.className = "", l4.search.length) {
                    const e3 = ["1", "true"];
                    e3.includes(l4.searchParams.get("autoplay")) && (this.config.autoplay = true), e3.includes(l4.searchParams.get("loop")) && (this.config.loop.active = true), this.isYouTube ? (this.config.playsinline = e3.includes(l4.searchParams.get("playsinline")), this.config.youtube.hl = l4.searchParams.get("hl")) : this.config.playsinline = true;
                  }
                } else
                  this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                if (W2(this.provider) || !Object.values(Ge).includes(this.provider))
                  return void this.debug.error("Setup failed: Invalid provider");
                this.type = et3;
                break;
              case "video":
              case "audio":
                this.type = n4, this.provider = Ge.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = true), this.media.hasAttribute("autoplay") && (this.config.autoplay = true), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = true), this.media.hasAttribute("muted") && (this.config.muted = true), this.media.hasAttribute("loop") && (this.config.loop.active = true);
                break;
              default:
                return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = me2.check(this.type, this.provider, this.config.playsinline), this.supported.api ? (this.eventListeners = [], this.listeners = new lt2(this), this.storage = new Fe(this), this.media.plyr = this, H2(this.elements.container) || (this.elements.container = Z2("div", { tabindex: 0 }), J2(this.media, this.elements.container)), at2.migrateStyles.call(this), at2.addStyleHook.call(this), pt2.setup.call(this), this.config.debug && fe2.call(this, this.elements.container, this.config.events.join(" "), (e3) => {
              this.debug.log(`event: ${e3.type}`);
            }), this.fullscreen = new st2(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && at2.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new gt2(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", () => ke(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new yt2(this))) : this.debug.error("Setup failed: no support");
          }
          get isHTML5() {
            return this.provider === Ge.html5;
          }
          get isEmbed() {
            return this.isYouTube || this.isVimeo;
          }
          get isYouTube() {
            return this.provider === Ge.youtube;
          }
          get isVimeo() {
            return this.provider === Ge.vimeo;
          }
          get isVideo() {
            return this.type === et3;
          }
          get isAudio() {
            return this.type === Ze;
          }
          get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
          }
          get paused() {
            return Boolean(this.media.paused);
          }
          get stopped() {
            return Boolean(this.paused && this.currentTime === 0);
          }
          get ended() {
            return Boolean(this.media.ended);
          }
          set currentTime(e3) {
            if (!this.duration)
              return;
            const t4 = $12(e3) && e3 > 0;
            this.media.currentTime = t4 ? Math.min(e3, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
          }
          get currentTime() {
            return Number(this.media.currentTime);
          }
          get buffered() {
            const { buffered: e3 } = this.media;
            return $12(e3) ? e3 : e3 && e3.length && this.duration > 0 ? e3.end(0) / this.duration : 0;
          }
          get seeking() {
            return Boolean(this.media.seeking);
          }
          get duration() {
            const e3 = parseFloat(this.config.duration), t4 = (this.media || {}).duration, i4 = $12(t4) && t4 !== 1 / 0 ? t4 : 0;
            return e3 || i4;
          }
          set volume(e3) {
            let t4 = e3;
            _3(t4) && (t4 = Number(t4)), $12(t4) || (t4 = this.storage.get("volume")), $12(t4) || ({ volume: t4 } = this.config), t4 > 1 && (t4 = 1), t4 < 0 && (t4 = 0), this.config.volume = t4, this.media.volume = t4, !W2(e3) && this.muted && t4 > 0 && (this.muted = false);
          }
          get volume() {
            return Number(this.media.volume);
          }
          set muted(e3) {
            let t4 = e3;
            O3(t4) || (t4 = this.storage.get("muted")), O3(t4) || (t4 = this.config.muted), this.config.muted = t4, this.media.muted = t4;
          }
          get muted() {
            return Boolean(this.media.muted);
          }
          get hasAudio() {
            return !this.isHTML5 || (!!this.isAudio || (Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length)));
          }
          set speed(e3) {
            let t4 = null;
            $12(e3) && (t4 = e3), $12(t4) || (t4 = this.storage.get("speed")), $12(t4) || (t4 = this.config.speed.selected);
            const { minimumSpeed: i4, maximumSpeed: s4 } = this;
            t4 = function(e4 = 0, t5 = 0, i5 = 255) {
              return Math.min(Math.max(e4, t5), i5);
            }(t4, i4, s4), this.config.speed.selected = t4, setTimeout(() => {
              this.media && (this.media.playbackRate = t4);
            }, 0);
          }
          get speed() {
            return Number(this.media.playbackRate);
          }
          get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? 0.5 : 0.0625;
          }
          get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
          }
          set quality(e3) {
            const t4 = this.config.quality, i4 = this.options.quality;
            if (!i4.length)
              return;
            let s4 = [!W2(e3) && Number(e3), this.storage.get("quality"), t4.selected, t4.default].find($12), n4 = true;
            if (!i4.includes(s4)) {
              const e4 = Ae(i4, s4);
              this.debug.warn(`Unsupported quality option: ${s4}, using ${e4} instead`), s4 = e4, n4 = false;
            }
            t4.selected = s4, this.media.quality = s4, n4 && this.storage.set({ quality: s4 });
          }
          get quality() {
            return this.media.quality;
          }
          set loop(e3) {
            const t4 = O3(e3) ? e3 : this.config.loop.active;
            this.config.loop.active = t4, this.media.loop = t4;
          }
          get loop() {
            return Boolean(this.media.loop);
          }
          set source(e3) {
            vt2.change.call(this, e3);
          }
          get source() {
            return this.media.currentSrc;
          }
          get download() {
            const { download: e3 } = this.config.urls;
            return U2(e3) ? e3 : this.source;
          }
          set download(e3) {
            U2(e3) && (this.config.urls.download = e3, We.setDownloadUrl.call(this));
          }
          set poster(e3) {
            this.isVideo ? at2.setPoster.call(this, e3, false).catch(() => {
            }) : this.debug.warn("Poster can only be set for video");
          }
          get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
          }
          get ratio() {
            if (!this.isVideo)
              return null;
            const e3 = Ne2(xe.call(this));
            return q2(e3) ? e3.join(":") : e3;
          }
          set ratio(e3) {
            this.isVideo ? _3(e3) && Pe(e3) ? (this.config.ratio = Ne2(e3), Me.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e3})`) : this.debug.warn("Aspect ratio can only be set for video");
          }
          set autoplay(e3) {
            const t4 = O3(e3) ? e3 : this.config.autoplay;
            this.config.autoplay = t4;
          }
          get autoplay() {
            return Boolean(this.config.autoplay);
          }
          toggleCaptions(e3) {
            Ye.toggle.call(this, e3, false);
          }
          set currentTrack(e3) {
            Ye.set.call(this, e3, false), Ye.setup();
          }
          get currentTrack() {
            const { toggled: e3, currentTrack: t4 } = this.captions;
            return e3 ? t4 : -1;
          }
          set language(e3) {
            Ye.setLanguage.call(this, e3, false);
          }
          get language() {
            return (Ye.getCurrentTrack.call(this) || {}).language;
          }
          set pip(e3) {
            if (!me2.pip)
              return;
            const t4 = O3(e3) ? e3 : !this.pip;
            j2(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t4 ? Xe : Je), j2(this.media.requestPictureInPicture) && (!this.pip && t4 ? this.media.requestPictureInPicture() : this.pip && !t4 && document.exitPictureInPicture());
          }
          get pip() {
            return me2.pip ? W2(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Xe : null;
          }
          setPreviewThumbnails(e3) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e3), this.config.previewThumbnails.enabled && (this.previewThumbnails = new yt2(this));
          }
          static supported(e3, t4, i4) {
            return me2.check(e3, t4, i4);
          }
          static loadSprite(e3, t4) {
            return Ve(e3, t4);
          }
          static setup(e3, t4 = {}) {
            let i4 = null;
            return _3(e3) ? i4 = Array.from(document.querySelectorAll(e3)) : D2(e3) ? i4 = Array.from(e3) : q2(e3) && (i4 = e3.filter(H2)), W2(i4) ? null : i4.map((e4) => new wt2(e4, t4));
          }
        }
        var Tt2;
        return wt2.defaults = (Tt2 = Qe, JSON.parse(JSON.stringify(Tt2))), wt2;
      });
    }
  });

  // node_modules/html2canvas/dist/html2canvas.js
  var require_html2canvas = __commonJS({
    "node_modules/html2canvas/dist/html2canvas.js"(exports, module) {
      (function(global4, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global4 = typeof globalThis !== "undefined" ? globalThis : global4 || self, global4.html2canvas = factory());
      })(exports, function() {
        "use strict";
        var extendStatics = function(d2, b2) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
            d3.__proto__ = b3;
          } || function(d3, b3) {
            for (var p4 in b3)
              if (Object.prototype.hasOwnProperty.call(b3, p4))
                d3[p4] = b3[p4];
          };
          return extendStatics(d2, b2);
        };
        function __extends(d2, b2) {
          if (typeof b2 !== "function" && b2 !== null)
            throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
          extendStatics(d2, b2);
          function __() {
            this.constructor = d2;
          }
          d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
        }
        var __assign = function() {
          __assign = Object.assign || function __assign2(t3) {
            for (var s3, i4 = 1, n3 = arguments.length; i4 < n3; i4++) {
              s3 = arguments[i4];
              for (var p4 in s3)
                if (Object.prototype.hasOwnProperty.call(s3, p4))
                  t3[p4] = s3[p4];
            }
            return t3;
          };
          return __assign.apply(this, arguments);
        };
        function __awaiter(thisArg, _arguments, P2, generator) {
          function adopt(value) {
            return value instanceof P2 ? value : new P2(function(resolve3) {
              resolve3(value);
            });
          }
          return new (P2 || (P2 = Promise))(function(resolve3, reject2) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e3) {
                reject2(e3);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e3) {
                reject2(e3);
              }
            }
            function step(result) {
              result.done ? resolve3(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }
        function __generator(thisArg, body) {
          var _3 = { label: 0, sent: function() {
            if (t3[0] & 1)
              throw t3[1];
            return t3[1];
          }, trys: [], ops: [] }, f4, y3, t3, g2;
          return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
            return this;
          }), g2;
          function verb(n3) {
            return function(v3) {
              return step([n3, v3]);
            };
          }
          function step(op) {
            if (f4)
              throw new TypeError("Generator is already executing.");
            while (_3)
              try {
                if (f4 = 1, y3 && (t3 = op[0] & 2 ? y3["return"] : op[0] ? y3["throw"] || ((t3 = y3["return"]) && t3.call(y3), 0) : y3.next) && !(t3 = t3.call(y3, op[1])).done)
                  return t3;
                if (y3 = 0, t3)
                  op = [op[0] & 2, t3.value];
                switch (op[0]) {
                  case 0:
                  case 1:
                    t3 = op;
                    break;
                  case 4:
                    _3.label++;
                    return { value: op[1], done: false };
                  case 5:
                    _3.label++;
                    y3 = op[1];
                    op = [0];
                    continue;
                  case 7:
                    op = _3.ops.pop();
                    _3.trys.pop();
                    continue;
                  default:
                    if (!(t3 = _3.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                      _3 = 0;
                      continue;
                    }
                    if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
                      _3.label = op[1];
                      break;
                    }
                    if (op[0] === 6 && _3.label < t3[1]) {
                      _3.label = t3[1];
                      t3 = op;
                      break;
                    }
                    if (t3 && _3.label < t3[2]) {
                      _3.label = t3[2];
                      _3.ops.push(op);
                      break;
                    }
                    if (t3[2])
                      _3.ops.pop();
                    _3.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _3);
              } catch (e3) {
                op = [6, e3];
                y3 = 0;
              } finally {
                f4 = t3 = 0;
              }
            if (op[0] & 5)
              throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
          }
        }
        function __spreadArray(to, from, pack2) {
          if (pack2 || arguments.length === 2)
            for (var i4 = 0, l3 = from.length, ar; i4 < l3; i4++) {
              if (ar || !(i4 in from)) {
                if (!ar)
                  ar = Array.prototype.slice.call(from, 0, i4);
                ar[i4] = from[i4];
              }
            }
          return to.concat(ar || from);
        }
        var Bounds = function() {
          function Bounds2(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
          }
          Bounds2.prototype.add = function(x2, y3, w2, h4) {
            return new Bounds2(this.left + x2, this.top + y3, this.width + w2, this.height + h4);
          };
          Bounds2.fromClientRect = function(context, clientRect) {
            return new Bounds2(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
          };
          Bounds2.fromDOMRectList = function(context, domRectList) {
            var domRect = domRectList[0];
            return domRect ? new Bounds2(domRect.x + context.windowBounds.left, domRect.y + context.windowBounds.top, domRect.width, domRect.height) : Bounds2.EMPTY;
          };
          Bounds2.EMPTY = new Bounds2(0, 0, 0, 0);
          return Bounds2;
        }();
        var parseBounds = function(context, node2) {
          return Bounds.fromClientRect(context, node2.getBoundingClientRect());
        };
        var parseDocumentSize = function(document3) {
          var body = document3.body;
          var documentElement = document3.documentElement;
          if (!body || !documentElement) {
            throw new Error("Unable to get document size");
          }
          var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
          var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
          return new Bounds(0, 0, width, height);
        };
        var toCodePoints$1 = function(str) {
          var codePoints = [];
          var i4 = 0;
          var length = str.length;
          while (i4 < length) {
            var value = str.charCodeAt(i4++);
            if (value >= 55296 && value <= 56319 && i4 < length) {
              var extra = str.charCodeAt(i4++);
              if ((extra & 64512) === 56320) {
                codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
              } else {
                codePoints.push(value);
                i4--;
              }
            } else {
              codePoints.push(value);
            }
          }
          return codePoints;
        };
        var fromCodePoint$1 = function() {
          var codePoints = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
          }
          if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
          }
          var length = codePoints.length;
          if (!length) {
            return "";
          }
          var codeUnits = [];
          var index3 = -1;
          var result = "";
          while (++index3 < length) {
            var codePoint = codePoints[index3];
            if (codePoint <= 65535) {
              codeUnits.push(codePoint);
            } else {
              codePoint -= 65536;
              codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
            }
            if (index3 + 1 === length || codeUnits.length > 16384) {
              result += String.fromCharCode.apply(String, codeUnits);
              codeUnits.length = 0;
            }
          }
          return result;
        };
        var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
          lookup$2[chars$2.charCodeAt(i$2)] = i$2;
        }
        var decode$1 = function(base642) {
          var bufferLength = base642.length * 0.75, len = base642.length, i4, p4 = 0, encoded1, encoded2, encoded3, encoded4;
          if (base642[base642.length - 1] === "=") {
            bufferLength--;
            if (base642[base642.length - 2] === "=") {
              bufferLength--;
            }
          }
          var buffer2 = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
          var bytes = Array.isArray(buffer2) ? buffer2 : new Uint8Array(buffer2);
          for (i4 = 0; i4 < len; i4 += 4) {
            encoded1 = lookup$2[base642.charCodeAt(i4)];
            encoded2 = lookup$2[base642.charCodeAt(i4 + 1)];
            encoded3 = lookup$2[base642.charCodeAt(i4 + 2)];
            encoded4 = lookup$2[base642.charCodeAt(i4 + 3)];
            bytes[p4++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p4++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p4++] = (encoded3 & 3) << 6 | encoded4 & 63;
          }
          return buffer2;
        };
        var polyUint16Array$1 = function(buffer2) {
          var length = buffer2.length;
          var bytes = [];
          for (var i4 = 0; i4 < length; i4 += 2) {
            bytes.push(buffer2[i4 + 1] << 8 | buffer2[i4]);
          }
          return bytes;
        };
        var polyUint32Array$1 = function(buffer2) {
          var length = buffer2.length;
          var bytes = [];
          for (var i4 = 0; i4 < length; i4 += 4) {
            bytes.push(buffer2[i4 + 3] << 24 | buffer2[i4 + 2] << 16 | buffer2[i4 + 1] << 8 | buffer2[i4]);
          }
          return bytes;
        };
        var UTRIE2_SHIFT_2$1 = 5;
        var UTRIE2_SHIFT_1$1 = 6 + 5;
        var UTRIE2_INDEX_SHIFT$1 = 2;
        var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
        var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 65536 >> UTRIE2_SHIFT_2$1;
        var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
        var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 1024 >> UTRIE2_SHIFT_2$1;
        var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 2048 >> 6;
        var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 65536 >> UTRIE2_SHIFT_1$1;
        var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
        var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
        var slice16$1 = function(view, start2, end) {
          if (view.slice) {
            return view.slice(start2, end);
          }
          return new Uint16Array(Array.prototype.slice.call(view, start2, end));
        };
        var slice32$1 = function(view, start2, end) {
          if (view.slice) {
            return view.slice(start2, end);
          }
          return new Uint32Array(Array.prototype.slice.call(view, start2, end));
        };
        var createTrieFromBase64$1 = function(base642) {
          var buffer2 = decode$1(base642);
          var view32 = Array.isArray(buffer2) ? polyUint32Array$1(buffer2) : new Uint32Array(buffer2);
          var view16 = Array.isArray(buffer2) ? polyUint16Array$1(buffer2) : new Uint16Array(buffer2);
          var headerLength = 24;
          var index3 = slice16$1(view16, headerLength / 2, view32[4] / 2);
          var data2 = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
          return new Trie$1(view32[0], view32[1], view32[2], view32[3], index3, data2);
        };
        var Trie$1 = function() {
          function Trie2(initialValue, errorValue, highStart, highValueIndex, index3, data2) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index3;
            this.data = data2;
          }
          Trie2.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
              if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
              }
              if (codePoint <= 65535) {
                ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 55296 >> UTRIE2_SHIFT_2$1)];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
              }
              if (codePoint < this.highStart) {
                ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                ix = this.index[ix];
                ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                ix = this.index[ix];
                ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                return this.data[ix];
              }
              if (codePoint <= 1114111) {
                return this.data[this.highValueIndex];
              }
            }
            return this.errorValue;
          };
          return Trie2;
        }();
        var base64$1 = "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";
        var LETTER_NUMBER_MODIFIER = 50;
        var BK = 1;
        var CR$1 = 2;
        var LF$1 = 3;
        var CM = 4;
        var NL = 5;
        var WJ = 7;
        var ZW = 8;
        var GL = 9;
        var SP = 10;
        var ZWJ$1 = 11;
        var B2 = 12;
        var BA = 13;
        var BB = 14;
        var HY = 15;
        var CB = 16;
        var CL = 17;
        var CP = 18;
        var EX = 19;
        var IN = 20;
        var NS = 21;
        var OP = 22;
        var QU = 23;
        var IS = 24;
        var NU = 25;
        var PO = 26;
        var PR = 27;
        var SY = 28;
        var AI = 29;
        var AL = 30;
        var CJ = 31;
        var EB = 32;
        var EM = 33;
        var H2 = 34;
        var H3 = 35;
        var HL = 36;
        var ID = 37;
        var JL = 38;
        var JV = 39;
        var JT = 40;
        var RI$1 = 41;
        var SA = 42;
        var XX = 43;
        var ea_OP = [9001, 65288];
        var BREAK_MANDATORY = "!";
        var BREAK_NOT_ALLOWED$1 = "\xD7";
        var BREAK_ALLOWED$1 = "\xF7";
        var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
        var ALPHABETICS = [AL, HL];
        var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
        var SPACE$1 = [SP, ZW];
        var PREFIX_POSTFIX = [PR, PO];
        var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
        var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
        var HYPHEN = [HY, BA];
        var codePointsToCharacterClasses = function(codePoints, lineBreak2) {
          if (lineBreak2 === void 0) {
            lineBreak2 = "strict";
          }
          var types = [];
          var indices = [];
          var categories = [];
          codePoints.forEach(function(codePoint, index3) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
              categories.push(true);
              classType -= LETTER_NUMBER_MODIFIER;
            } else {
              categories.push(false);
            }
            if (["normal", "auto", "loose"].indexOf(lineBreak2) !== -1) {
              if ([8208, 8211, 12316, 12448].indexOf(codePoint) !== -1) {
                indices.push(index3);
                return types.push(CB);
              }
            }
            if (classType === CM || classType === ZWJ$1) {
              if (index3 === 0) {
                indices.push(index3);
                return types.push(AL);
              }
              var prev2 = types[index3 - 1];
              if (LINE_BREAKS.indexOf(prev2) === -1) {
                indices.push(indices[index3 - 1]);
                return types.push(prev2);
              }
              indices.push(index3);
              return types.push(AL);
            }
            indices.push(index3);
            if (classType === CJ) {
              return types.push(lineBreak2 === "strict" ? NS : ID);
            }
            if (classType === SA) {
              return types.push(AL);
            }
            if (classType === AI) {
              return types.push(AL);
            }
            if (classType === XX) {
              if (codePoint >= 131072 && codePoint <= 196605 || codePoint >= 196608 && codePoint <= 262141) {
                return types.push(ID);
              } else {
                return types.push(AL);
              }
            }
            types.push(classType);
          });
          return [indices, types, categories];
        };
        var isAdjacentWithSpaceIgnored = function(a4, b2, currentIndex, classTypes) {
          var current = classTypes[currentIndex];
          if (Array.isArray(a4) ? a4.indexOf(current) !== -1 : a4 === current) {
            var i4 = currentIndex;
            while (i4 <= classTypes.length) {
              i4++;
              var next2 = classTypes[i4];
              if (next2 === b2) {
                return true;
              }
              if (next2 !== SP) {
                break;
              }
            }
          }
          if (current === SP) {
            var i4 = currentIndex;
            while (i4 > 0) {
              i4--;
              var prev2 = classTypes[i4];
              if (Array.isArray(a4) ? a4.indexOf(prev2) !== -1 : a4 === prev2) {
                var n3 = currentIndex;
                while (n3 <= classTypes.length) {
                  n3++;
                  var next2 = classTypes[n3];
                  if (next2 === b2) {
                    return true;
                  }
                  if (next2 !== SP) {
                    break;
                  }
                }
              }
              if (prev2 !== SP) {
                break;
              }
            }
          }
          return false;
        };
        var previousNonSpaceClassType = function(currentIndex, classTypes) {
          var i4 = currentIndex;
          while (i4 >= 0) {
            var type = classTypes[i4];
            if (type === SP) {
              i4--;
            } else {
              return type;
            }
          }
          return 0;
        };
        var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index3, forbiddenBreaks) {
          if (indicies[index3] === 0) {
            return BREAK_NOT_ALLOWED$1;
          }
          var currentIndex = index3 - 1;
          if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
          }
          var beforeIndex = currentIndex - 1;
          var afterIndex = currentIndex + 1;
          var current = classTypes[currentIndex];
          var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
          var next2 = classTypes[afterIndex];
          if (current === CR$1 && next2 === LF$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
          }
          if (HARD_LINE_BREAKS.indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (SPACE$1.indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
          }
          if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === WJ || next2 === WJ) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([SP, BA, HY].indexOf(current) === -1 && next2 === GL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([CL, CP, EX, IS, SY].indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === SP) {
            return BREAK_ALLOWED$1;
          }
          if (current === QU || next2 === QU) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (next2 === CB || current === CB) {
            return BREAK_ALLOWED$1;
          }
          if ([BA, HY, NS].indexOf(next2) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === SY && next2 === HL) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (next2 === IN) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(next2) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next2 === NU) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === PR && [ID, EB, EM].indexOf(next2) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next2 === PO) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next2) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([PR, PO].indexOf(current) !== -1 && (next2 === NU || [OP, HY].indexOf(next2) !== -1 && classTypes[afterIndex + 1] === NU) || [OP, HY].indexOf(current) !== -1 && next2 === NU || current === NU && [NU, SY, IS].indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if ([NU, SY, IS, CL, CP].indexOf(next2) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
              var type = classTypes[prevIndex];
              if (type === NU) {
                return BREAK_NOT_ALLOWED$1;
              } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
              } else {
                break;
              }
            }
          }
          if ([PR, PO].indexOf(next2) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
              var type = classTypes[prevIndex];
              if (type === NU) {
                return BREAK_NOT_ALLOWED$1;
              } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
              } else {
                break;
              }
            }
          }
          if (JL === current && [JL, JV, H2, H3].indexOf(next2) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next2) !== -1 || [JT, H3].indexOf(current) !== -1 && next2 === JT) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next2) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next2) !== -1 && current === PR) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === IS && ALPHABETICS.indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next2 === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next2) !== -1 && current === CP) {
            return BREAK_NOT_ALLOWED$1;
          }
          if (current === RI$1 && next2 === RI$1) {
            var i4 = indicies[currentIndex];
            var count = 1;
            while (i4 > 0) {
              i4--;
              if (classTypes[i4] === RI$1) {
                count++;
              } else {
                break;
              }
            }
            if (count % 2 !== 0) {
              return BREAK_NOT_ALLOWED$1;
            }
          }
          if (current === EB && next2 === EM) {
            return BREAK_NOT_ALLOWED$1;
          }
          return BREAK_ALLOWED$1;
        };
        var cssFormattedClasses = function(codePoints, options) {
          if (!options) {
            options = { lineBreak: "normal", wordBreak: "normal" };
          }
          var _a3 = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a3[0], classTypes = _a3[1], isLetterNumber = _a3[2];
          if (options.wordBreak === "break-all" || options.wordBreak === "break-word") {
            classTypes = classTypes.map(function(type) {
              return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
            });
          }
          var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i4) {
            return letterNumber && codePoints[i4] >= 19968 && codePoints[i4] <= 40959;
          }) : void 0;
          return [indicies, classTypes, forbiddenBreakpoints];
        };
        var Break = function() {
          function Break2(codePoints, lineBreak2, start2, end) {
            this.codePoints = codePoints;
            this.required = lineBreak2 === BREAK_MANDATORY;
            this.start = start2;
            this.end = end;
          }
          Break2.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
          };
          return Break2;
        }();
        var LineBreaker = function(str, options) {
          var codePoints = toCodePoints$1(str);
          var _a3 = cssFormattedClasses(codePoints, options), indicies = _a3[0], classTypes = _a3[1], forbiddenBreakpoints = _a3[2];
          var length = codePoints.length;
          var lastEnd = 0;
          var nextIndex = 0;
          return {
            next: function() {
              if (nextIndex >= length) {
                return { done: true, value: null };
              }
              var lineBreak2 = BREAK_NOT_ALLOWED$1;
              while (nextIndex < length && (lineBreak2 = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1) {
              }
              if (lineBreak2 !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                var value = new Break(codePoints, lineBreak2, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return { value, done: false };
              }
              return { done: true, value: null };
            }
          };
        };
        var FLAG_UNRESTRICTED = 1 << 0;
        var FLAG_ID = 1 << 1;
        var FLAG_INTEGER = 1 << 2;
        var FLAG_NUMBER = 1 << 3;
        var LINE_FEED = 10;
        var SOLIDUS = 47;
        var REVERSE_SOLIDUS = 92;
        var CHARACTER_TABULATION = 9;
        var SPACE = 32;
        var QUOTATION_MARK = 34;
        var EQUALS_SIGN = 61;
        var NUMBER_SIGN = 35;
        var DOLLAR_SIGN = 36;
        var PERCENTAGE_SIGN = 37;
        var APOSTROPHE = 39;
        var LEFT_PARENTHESIS = 40;
        var RIGHT_PARENTHESIS = 41;
        var LOW_LINE = 95;
        var HYPHEN_MINUS = 45;
        var EXCLAMATION_MARK = 33;
        var LESS_THAN_SIGN = 60;
        var GREATER_THAN_SIGN = 62;
        var COMMERCIAL_AT = 64;
        var LEFT_SQUARE_BRACKET = 91;
        var RIGHT_SQUARE_BRACKET = 93;
        var CIRCUMFLEX_ACCENT = 61;
        var LEFT_CURLY_BRACKET = 123;
        var QUESTION_MARK = 63;
        var RIGHT_CURLY_BRACKET = 125;
        var VERTICAL_LINE = 124;
        var TILDE = 126;
        var CONTROL = 128;
        var REPLACEMENT_CHARACTER = 65533;
        var ASTERISK = 42;
        var PLUS_SIGN = 43;
        var COMMA = 44;
        var COLON = 58;
        var SEMICOLON = 59;
        var FULL_STOP = 46;
        var NULL = 0;
        var BACKSPACE = 8;
        var LINE_TABULATION = 11;
        var SHIFT_OUT = 14;
        var INFORMATION_SEPARATOR_ONE = 31;
        var DELETE = 127;
        var EOF = -1;
        var ZERO = 48;
        var a3 = 97;
        var e2 = 101;
        var f3 = 102;
        var u3 = 117;
        var z2 = 122;
        var A2 = 65;
        var E2 = 69;
        var F2 = 70;
        var U2 = 85;
        var Z2 = 90;
        var isDigit = function(codePoint) {
          return codePoint >= ZERO && codePoint <= 57;
        };
        var isSurrogateCodePoint = function(codePoint) {
          return codePoint >= 55296 && codePoint <= 57343;
        };
        var isHex = function(codePoint) {
          return isDigit(codePoint) || codePoint >= A2 && codePoint <= F2 || codePoint >= a3 && codePoint <= f3;
        };
        var isLowerCaseLetter = function(codePoint) {
          return codePoint >= a3 && codePoint <= z2;
        };
        var isUpperCaseLetter = function(codePoint) {
          return codePoint >= A2 && codePoint <= Z2;
        };
        var isLetter = function(codePoint) {
          return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
        };
        var isNonASCIICodePoint = function(codePoint) {
          return codePoint >= CONTROL;
        };
        var isWhiteSpace = function(codePoint) {
          return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
        };
        var isNameStartCodePoint = function(codePoint) {
          return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
        };
        var isNameCodePoint = function(codePoint) {
          return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
        };
        var isNonPrintableCodePoint = function(codePoint) {
          return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
        };
        var isValidEscape = function(c1, c22) {
          if (c1 !== REVERSE_SOLIDUS) {
            return false;
          }
          return c22 !== LINE_FEED;
        };
        var isIdentifierStart = function(c1, c22, c32) {
          if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c22) || isValidEscape(c22, c32);
          } else if (isNameStartCodePoint(c1)) {
            return true;
          } else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c22)) {
            return true;
          }
          return false;
        };
        var isNumberStart = function(c1, c22, c32) {
          if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c22)) {
              return true;
            }
            return c22 === FULL_STOP && isDigit(c32);
          }
          if (c1 === FULL_STOP) {
            return isDigit(c22);
          }
          return isDigit(c1);
        };
        var stringToNumber = function(codePoints) {
          var c4 = 0;
          var sign = 1;
          if (codePoints[c4] === PLUS_SIGN || codePoints[c4] === HYPHEN_MINUS) {
            if (codePoints[c4] === HYPHEN_MINUS) {
              sign = -1;
            }
            c4++;
          }
          var integers = [];
          while (isDigit(codePoints[c4])) {
            integers.push(codePoints[c4++]);
          }
          var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
          if (codePoints[c4] === FULL_STOP) {
            c4++;
          }
          var fraction = [];
          while (isDigit(codePoints[c4])) {
            fraction.push(codePoints[c4++]);
          }
          var fracd = fraction.length;
          var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
          if (codePoints[c4] === E2 || codePoints[c4] === e2) {
            c4++;
          }
          var expsign = 1;
          if (codePoints[c4] === PLUS_SIGN || codePoints[c4] === HYPHEN_MINUS) {
            if (codePoints[c4] === HYPHEN_MINUS) {
              expsign = -1;
            }
            c4++;
          }
          var exponent = [];
          while (isDigit(codePoints[c4])) {
            exponent.push(codePoints[c4++]);
          }
          var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
          return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
        };
        var LEFT_PARENTHESIS_TOKEN = {
          type: 2
        };
        var RIGHT_PARENTHESIS_TOKEN = {
          type: 3
        };
        var COMMA_TOKEN = { type: 4 };
        var SUFFIX_MATCH_TOKEN = { type: 13 };
        var PREFIX_MATCH_TOKEN = { type: 8 };
        var COLUMN_TOKEN = { type: 21 };
        var DASH_MATCH_TOKEN = { type: 9 };
        var INCLUDE_MATCH_TOKEN = { type: 10 };
        var LEFT_CURLY_BRACKET_TOKEN = {
          type: 11
        };
        var RIGHT_CURLY_BRACKET_TOKEN = {
          type: 12
        };
        var SUBSTRING_MATCH_TOKEN = { type: 14 };
        var BAD_URL_TOKEN = { type: 23 };
        var BAD_STRING_TOKEN = { type: 1 };
        var CDO_TOKEN = { type: 25 };
        var CDC_TOKEN = { type: 24 };
        var COLON_TOKEN = { type: 26 };
        var SEMICOLON_TOKEN = { type: 27 };
        var LEFT_SQUARE_BRACKET_TOKEN = {
          type: 28
        };
        var RIGHT_SQUARE_BRACKET_TOKEN = {
          type: 29
        };
        var WHITESPACE_TOKEN = { type: 31 };
        var EOF_TOKEN = { type: 32 };
        var Tokenizer = function() {
          function Tokenizer2() {
            this._value = [];
          }
          Tokenizer2.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
          };
          Tokenizer2.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
              tokens.push(token);
              token = this.consumeToken();
            }
            return tokens;
          };
          Tokenizer2.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
              case QUOTATION_MARK:
                return this.consumeStringToken(QUOTATION_MARK);
              case NUMBER_SIGN:
                var c1 = this.peekCodePoint(0);
                var c22 = this.peekCodePoint(1);
                var c32 = this.peekCodePoint(2);
                if (isNameCodePoint(c1) || isValidEscape(c22, c32)) {
                  var flags = isIdentifierStart(c1, c22, c32) ? FLAG_ID : FLAG_UNRESTRICTED;
                  var value = this.consumeName();
                  return { type: 5, value, flags };
                }
                break;
              case DOLLAR_SIGN:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                  this.consumeCodePoint();
                  return SUFFIX_MATCH_TOKEN;
                }
                break;
              case APOSTROPHE:
                return this.consumeStringToken(APOSTROPHE);
              case LEFT_PARENTHESIS:
                return LEFT_PARENTHESIS_TOKEN;
              case RIGHT_PARENTHESIS:
                return RIGHT_PARENTHESIS_TOKEN;
              case ASTERISK:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                  this.consumeCodePoint();
                  return SUBSTRING_MATCH_TOKEN;
                }
                break;
              case PLUS_SIGN:
                if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeNumericToken();
                }
                break;
              case COMMA:
                return COMMA_TOKEN;
              case HYPHEN_MINUS:
                var e1 = codePoint;
                var e22 = this.peekCodePoint(0);
                var e3 = this.peekCodePoint(1);
                if (isNumberStart(e1, e22, e3)) {
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeNumericToken();
                }
                if (isIdentifierStart(e1, e22, e3)) {
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeIdentLikeToken();
                }
                if (e22 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                  this.consumeCodePoint();
                  this.consumeCodePoint();
                  return CDC_TOKEN;
                }
                break;
              case FULL_STOP:
                if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeNumericToken();
                }
                break;
              case SOLIDUS:
                if (this.peekCodePoint(0) === ASTERISK) {
                  this.consumeCodePoint();
                  while (true) {
                    var c4 = this.consumeCodePoint();
                    if (c4 === ASTERISK) {
                      c4 = this.consumeCodePoint();
                      if (c4 === SOLIDUS) {
                        return this.consumeToken();
                      }
                    }
                    if (c4 === EOF) {
                      return this.consumeToken();
                    }
                  }
                }
                break;
              case COLON:
                return COLON_TOKEN;
              case SEMICOLON:
                return SEMICOLON_TOKEN;
              case LESS_THAN_SIGN:
                if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                  this.consumeCodePoint();
                  this.consumeCodePoint();
                  return CDO_TOKEN;
                }
                break;
              case COMMERCIAL_AT:
                var a1 = this.peekCodePoint(0);
                var a22 = this.peekCodePoint(1);
                var a32 = this.peekCodePoint(2);
                if (isIdentifierStart(a1, a22, a32)) {
                  var value = this.consumeName();
                  return { type: 7, value };
                }
                break;
              case LEFT_SQUARE_BRACKET:
                return LEFT_SQUARE_BRACKET_TOKEN;
              case REVERSE_SOLIDUS:
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                  this.reconsumeCodePoint(codePoint);
                  return this.consumeIdentLikeToken();
                }
                break;
              case RIGHT_SQUARE_BRACKET:
                return RIGHT_SQUARE_BRACKET_TOKEN;
              case CIRCUMFLEX_ACCENT:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                  this.consumeCodePoint();
                  return PREFIX_MATCH_TOKEN;
                }
                break;
              case LEFT_CURLY_BRACKET:
                return LEFT_CURLY_BRACKET_TOKEN;
              case RIGHT_CURLY_BRACKET:
                return RIGHT_CURLY_BRACKET_TOKEN;
              case u3:
              case U2:
                var u1 = this.peekCodePoint(0);
                var u22 = this.peekCodePoint(1);
                if (u1 === PLUS_SIGN && (isHex(u22) || u22 === QUESTION_MARK)) {
                  this.consumeCodePoint();
                  this.consumeUnicodeRangeToken();
                }
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
              case VERTICAL_LINE:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                  this.consumeCodePoint();
                  return DASH_MATCH_TOKEN;
                }
                if (this.peekCodePoint(0) === VERTICAL_LINE) {
                  this.consumeCodePoint();
                  return COLUMN_TOKEN;
                }
                break;
              case TILDE:
                if (this.peekCodePoint(0) === EQUALS_SIGN) {
                  this.consumeCodePoint();
                  return INCLUDE_MATCH_TOKEN;
                }
                break;
              case EOF:
                return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
              this.consumeWhiteSpace();
              return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
              this.reconsumeCodePoint(codePoint);
              return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
              this.reconsumeCodePoint(codePoint);
              return this.consumeIdentLikeToken();
            }
            return { type: 6, value: fromCodePoint$1(codePoint) };
          };
          Tokenizer2.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
          };
          Tokenizer2.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
          };
          Tokenizer2.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) {
              return -1;
            }
            return this._value[delta];
          };
          Tokenizer2.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
              digits.push(codePoint);
              codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
              digits.push(codePoint);
              codePoint = this.consumeCodePoint();
              questionMarks = true;
            }
            if (questionMarks) {
              var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                return digit === QUESTION_MARK ? ZERO : digit;
              })), 16);
              var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                return digit === QUESTION_MARK ? F2 : digit;
              })), 16);
              return { type: 30, start: start_1, end };
            }
            var start2 = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
              this.consumeCodePoint();
              codePoint = this.consumeCodePoint();
              var endDigits = [];
              while (isHex(codePoint) && endDigits.length < 6) {
                endDigits.push(codePoint);
                codePoint = this.consumeCodePoint();
              }
              var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
              return { type: 30, start: start2, end };
            } else {
              return { type: 30, start: start2, end: start2 };
            }
          };
          Tokenizer2.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
              this.consumeCodePoint();
              return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
              this.consumeCodePoint();
              return { type: 19, value };
            }
            return { type: 20, value };
          };
          Tokenizer2.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
              return { type: 22, value: "" };
            }
            var next2 = this.peekCodePoint(0);
            if (next2 === APOSTROPHE || next2 === QUOTATION_MARK) {
              var stringToken = this.consumeStringToken(this.consumeCodePoint());
              if (stringToken.type === 0) {
                this.consumeWhiteSpace();
                if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                  this.consumeCodePoint();
                  return { type: 22, value: stringToken.value };
                }
              }
              this.consumeBadUrlRemnants();
              return BAD_URL_TOKEN;
            }
            while (true) {
              var codePoint = this.consumeCodePoint();
              if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
              } else if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                  this.consumeCodePoint();
                  return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
              } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
              } else if (codePoint === REVERSE_SOLIDUS) {
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                  value.push(this.consumeEscapedCodePoint());
                } else {
                  this.consumeBadUrlRemnants();
                  return BAD_URL_TOKEN;
                }
              } else {
                value.push(codePoint);
              }
            }
          };
          Tokenizer2.prototype.consumeWhiteSpace = function() {
            while (isWhiteSpace(this.peekCodePoint(0))) {
              this.consumeCodePoint();
            }
          };
          Tokenizer2.prototype.consumeBadUrlRemnants = function() {
            while (true) {
              var codePoint = this.consumeCodePoint();
              if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                return;
              }
              if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                this.consumeEscapedCodePoint();
              }
            }
          };
          Tokenizer2.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 6e4;
            var value = "";
            while (count > 0) {
              var amount = Math.min(SLICE_STACK_SIZE, count);
              value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
              count -= amount;
            }
            this._value.shift();
            return value;
          };
          Tokenizer2.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i4 = 0;
            do {
              var codePoint = this._value[i4];
              if (codePoint === EOF || codePoint === void 0 || codePoint === endingCodePoint) {
                value += this.consumeStringSlice(i4);
                return { type: 0, value };
              }
              if (codePoint === LINE_FEED) {
                this._value.splice(0, i4);
                return BAD_STRING_TOKEN;
              }
              if (codePoint === REVERSE_SOLIDUS) {
                var next2 = this._value[i4 + 1];
                if (next2 !== EOF && next2 !== void 0) {
                  if (next2 === LINE_FEED) {
                    value += this.consumeStringSlice(i4);
                    i4 = -1;
                    this._value.shift();
                  } else if (isValidEscape(codePoint, next2)) {
                    value += this.consumeStringSlice(i4);
                    value += fromCodePoint$1(this.consumeEscapedCodePoint());
                    i4 = -1;
                  }
                }
              }
              i4++;
            } while (true);
          };
          Tokenizer2.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
              repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
              repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c22 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c22)) {
              repr.push(this.consumeCodePoint(), this.consumeCodePoint());
              type = FLAG_NUMBER;
              while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
              }
            }
            c1 = this.peekCodePoint(0);
            c22 = this.peekCodePoint(1);
            var c32 = this.peekCodePoint(2);
            if ((c1 === E2 || c1 === e2) && ((c22 === PLUS_SIGN || c22 === HYPHEN_MINUS) && isDigit(c32) || isDigit(c22))) {
              repr.push(this.consumeCodePoint(), this.consumeCodePoint());
              type = FLAG_NUMBER;
              while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
              }
            }
            return [stringToNumber(repr), type];
          };
          Tokenizer2.prototype.consumeNumericToken = function() {
            var _a3 = this.consumeNumber(), number = _a3[0], flags = _a3[1];
            var c1 = this.peekCodePoint(0);
            var c22 = this.peekCodePoint(1);
            var c32 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c22, c32)) {
              var unit = this.consumeName();
              return { type: 15, number, flags, unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
              this.consumeCodePoint();
              return { type: 16, number, flags };
            }
            return { type: 17, number, flags };
          };
          Tokenizer2.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
              var hex = fromCodePoint$1(codePoint);
              while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                hex += fromCodePoint$1(this.consumeCodePoint());
              }
              if (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
              }
              var hexCodePoint = parseInt(hex, 16);
              if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 1114111) {
                return REPLACEMENT_CHARACTER;
              }
              return hexCodePoint;
            }
            if (codePoint === EOF) {
              return REPLACEMENT_CHARACTER;
            }
            return codePoint;
          };
          Tokenizer2.prototype.consumeName = function() {
            var result = "";
            while (true) {
              var codePoint = this.consumeCodePoint();
              if (isNameCodePoint(codePoint)) {
                result += fromCodePoint$1(codePoint);
              } else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                result += fromCodePoint$1(this.consumeEscapedCodePoint());
              } else {
                this.reconsumeCodePoint(codePoint);
                return result;
              }
            }
          };
          return Tokenizer2;
        }();
        var Parser2 = function() {
          function Parser3(tokens) {
            this._tokens = tokens;
          }
          Parser3.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser3(tokenizer.read());
          };
          Parser3.parseValue = function(value) {
            return Parser3.create(value).parseComponentValue();
          };
          Parser3.parseValues = function(value) {
            return Parser3.create(value).parseComponentValues();
          };
          Parser3.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while (token.type === 31) {
              token = this.consumeToken();
            }
            if (token.type === 32) {
              throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
              token = this.consumeToken();
            } while (token.type === 31);
            if (token.type === 32) {
              return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
          };
          Parser3.prototype.parseComponentValues = function() {
            var values = [];
            while (true) {
              var value = this.consumeComponentValue();
              if (value.type === 32) {
                return values;
              }
              values.push(value);
              values.push();
            }
          };
          Parser3.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch (token.type) {
              case 11:
              case 28:
              case 2:
                return this.consumeSimpleBlock(token.type);
              case 19:
                return this.consumeFunction(token);
            }
            return token;
          };
          Parser3.prototype.consumeSimpleBlock = function(type) {
            var block = { type, values: [] };
            var token = this.consumeToken();
            while (true) {
              if (token.type === 32 || isEndingTokenFor(token, type)) {
                return block;
              }
              this.reconsumeToken(token);
              block.values.push(this.consumeComponentValue());
              token = this.consumeToken();
            }
          };
          Parser3.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
              name: functionToken.value,
              values: [],
              type: 18
            };
            while (true) {
              var token = this.consumeToken();
              if (token.type === 32 || token.type === 3) {
                return cssFunction;
              }
              this.reconsumeToken(token);
              cssFunction.values.push(this.consumeComponentValue());
            }
          };
          Parser3.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
          };
          Parser3.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
          };
          return Parser3;
        }();
        var isDimensionToken = function(token) {
          return token.type === 15;
        };
        var isNumberToken = function(token) {
          return token.type === 17;
        };
        var isIdentToken = function(token) {
          return token.type === 20;
        };
        var isStringToken = function(token) {
          return token.type === 0;
        };
        var isIdentWithValue = function(token, value) {
          return isIdentToken(token) && token.value === value;
        };
        var nonWhiteSpace = function(token) {
          return token.type !== 31;
        };
        var nonFunctionArgSeparator = function(token) {
          return token.type !== 31 && token.type !== 4;
        };
        var parseFunctionArgs = function(tokens) {
          var args = [];
          var arg = [];
          tokens.forEach(function(token) {
            if (token.type === 4) {
              if (arg.length === 0) {
                throw new Error("Error parsing function args, zero tokens for arg");
              }
              args.push(arg);
              arg = [];
              return;
            }
            if (token.type !== 31) {
              arg.push(token);
            }
          });
          if (arg.length) {
            args.push(arg);
          }
          return args;
        };
        var isEndingTokenFor = function(token, type) {
          if (type === 11 && token.type === 12) {
            return true;
          }
          if (type === 28 && token.type === 29) {
            return true;
          }
          return type === 2 && token.type === 3;
        };
        var isLength = function(token) {
          return token.type === 17 || token.type === 15;
        };
        var isLengthPercentage = function(token) {
          return token.type === 16 || isLength(token);
        };
        var parseLengthPercentageTuple = function(tokens) {
          return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
        };
        var ZERO_LENGTH = {
          type: 17,
          number: 0,
          flags: FLAG_INTEGER
        };
        var FIFTY_PERCENT = {
          type: 16,
          number: 50,
          flags: FLAG_INTEGER
        };
        var HUNDRED_PERCENT = {
          type: 16,
          number: 100,
          flags: FLAG_INTEGER
        };
        var getAbsoluteValueForTuple = function(tuple, width, height) {
          var x2 = tuple[0], y3 = tuple[1];
          return [getAbsoluteValue(x2, width), getAbsoluteValue(typeof y3 !== "undefined" ? y3 : x2, height)];
        };
        var getAbsoluteValue = function(token, parent2) {
          if (token.type === 16) {
            return token.number / 100 * parent2;
          }
          if (isDimensionToken(token)) {
            switch (token.unit) {
              case "rem":
              case "em":
                return 16 * token.number;
              case "px":
              default:
                return token.number;
            }
          }
          return token.number;
        };
        var DEG = "deg";
        var GRAD = "grad";
        var RAD = "rad";
        var TURN = "turn";
        var angle = {
          name: "angle",
          parse: function(_context, value) {
            if (value.type === 15) {
              switch (value.unit) {
                case DEG:
                  return Math.PI * value.number / 180;
                case GRAD:
                  return Math.PI / 200 * value.number;
                case RAD:
                  return value.number;
                case TURN:
                  return Math.PI * 2 * value.number;
              }
            }
            throw new Error("Unsupported angle type");
          }
        };
        var isAngle = function(value) {
          if (value.type === 15) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
              return true;
            }
          }
          return false;
        };
        var parseNamedSide = function(tokens) {
          var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
          }).join(" ");
          switch (sideOrCorner) {
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
              return [ZERO_LENGTH, ZERO_LENGTH];
            case "to top":
            case "bottom":
              return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
              return [ZERO_LENGTH, HUNDRED_PERCENT];
            case "to right":
            case "left":
              return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
              return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case "to bottom":
            case "top":
              return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
              return [HUNDRED_PERCENT, ZERO_LENGTH];
            case "to left":
            case "right":
              return deg(270);
          }
          return 0;
        };
        var deg = function(deg2) {
          return Math.PI * deg2 / 180;
        };
        var color$1 = {
          name: "color",
          parse: function(context, value) {
            if (value.type === 18) {
              var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
              if (typeof colorFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
              }
              return colorFunction(context, value.values);
            }
            if (value.type === 5) {
              if (value.value.length === 3) {
                var r2 = value.value.substring(0, 1);
                var g2 = value.value.substring(1, 2);
                var b2 = value.value.substring(2, 3);
                return pack(parseInt(r2 + r2, 16), parseInt(g2 + g2, 16), parseInt(b2 + b2, 16), 1);
              }
              if (value.value.length === 4) {
                var r2 = value.value.substring(0, 1);
                var g2 = value.value.substring(1, 2);
                var b2 = value.value.substring(2, 3);
                var a4 = value.value.substring(3, 4);
                return pack(parseInt(r2 + r2, 16), parseInt(g2 + g2, 16), parseInt(b2 + b2, 16), parseInt(a4 + a4, 16) / 255);
              }
              if (value.value.length === 6) {
                var r2 = value.value.substring(0, 2);
                var g2 = value.value.substring(2, 4);
                var b2 = value.value.substring(4, 6);
                return pack(parseInt(r2, 16), parseInt(g2, 16), parseInt(b2, 16), 1);
              }
              if (value.value.length === 8) {
                var r2 = value.value.substring(0, 2);
                var g2 = value.value.substring(2, 4);
                var b2 = value.value.substring(4, 6);
                var a4 = value.value.substring(6, 8);
                return pack(parseInt(r2, 16), parseInt(g2, 16), parseInt(b2, 16), parseInt(a4, 16) / 255);
              }
            }
            if (value.type === 20) {
              var namedColor = COLORS[value.value.toUpperCase()];
              if (typeof namedColor !== "undefined") {
                return namedColor;
              }
            }
            return COLORS.TRANSPARENT;
          }
        };
        var isTransparent = function(color2) {
          return (255 & color2) === 0;
        };
        var asString = function(color2) {
          var alpha = 255 & color2;
          var blue = 255 & color2 >> 8;
          var green = 255 & color2 >> 16;
          var red = 255 & color2 >> 24;
          return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
        };
        var pack = function(r2, g2, b2, a4) {
          return (r2 << 24 | g2 << 16 | b2 << 8 | Math.round(a4 * 255) << 0) >>> 0;
        };
        var getTokenColorValue = function(token, i4) {
          if (token.type === 17) {
            return token.number;
          }
          if (token.type === 16) {
            var max3 = i4 === 3 ? 1 : 255;
            return i4 === 3 ? token.number / 100 * max3 : Math.round(token.number / 100 * max3);
          }
          return 0;
        };
        var rgb = function(_context, args) {
          var tokens = args.filter(nonFunctionArgSeparator);
          if (tokens.length === 3) {
            var _a3 = tokens.map(getTokenColorValue), r2 = _a3[0], g2 = _a3[1], b2 = _a3[2];
            return pack(r2, g2, b2, 1);
          }
          if (tokens.length === 4) {
            var _b2 = tokens.map(getTokenColorValue), r2 = _b2[0], g2 = _b2[1], b2 = _b2[2], a4 = _b2[3];
            return pack(r2, g2, b2, a4);
          }
          return 0;
        };
        function hue2rgb(t1, t22, hue) {
          if (hue < 0) {
            hue += 1;
          }
          if (hue >= 1) {
            hue -= 1;
          }
          if (hue < 1 / 6) {
            return (t22 - t1) * hue * 6 + t1;
          } else if (hue < 1 / 2) {
            return t22;
          } else if (hue < 2 / 3) {
            return (t22 - t1) * 6 * (2 / 3 - hue) + t1;
          } else {
            return t1;
          }
        }
        var hsl = function(context, args) {
          var tokens = args.filter(nonFunctionArgSeparator);
          var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
          var h4 = (hue.type === 17 ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
          var s3 = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
          var l3 = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
          var a4 = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
          if (s3 === 0) {
            return pack(l3 * 255, l3 * 255, l3 * 255, 1);
          }
          var t22 = l3 <= 0.5 ? l3 * (s3 + 1) : l3 + s3 - l3 * s3;
          var t1 = l3 * 2 - t22;
          var r2 = hue2rgb(t1, t22, h4 + 1 / 3);
          var g2 = hue2rgb(t1, t22, h4);
          var b2 = hue2rgb(t1, t22, h4 - 1 / 3);
          return pack(r2 * 255, g2 * 255, b2 * 255, a4);
        };
        var SUPPORTED_COLOR_FUNCTIONS = {
          hsl,
          hsla: hsl,
          rgb,
          rgba: rgb
        };
        var parseColor = function(context, value) {
          return color$1.parse(context, Parser2.create(value).parseComponentValue());
        };
        var COLORS = {
          ALICEBLUE: 4042850303,
          ANTIQUEWHITE: 4209760255,
          AQUA: 16777215,
          AQUAMARINE: 2147472639,
          AZURE: 4043309055,
          BEIGE: 4126530815,
          BISQUE: 4293182719,
          BLACK: 255,
          BLANCHEDALMOND: 4293643775,
          BLUE: 65535,
          BLUEVIOLET: 2318131967,
          BROWN: 2771004159,
          BURLYWOOD: 3736635391,
          CADETBLUE: 1604231423,
          CHARTREUSE: 2147418367,
          CHOCOLATE: 3530104575,
          CORAL: 4286533887,
          CORNFLOWERBLUE: 1687547391,
          CORNSILK: 4294499583,
          CRIMSON: 3692313855,
          CYAN: 16777215,
          DARKBLUE: 35839,
          DARKCYAN: 9145343,
          DARKGOLDENROD: 3095837695,
          DARKGRAY: 2846468607,
          DARKGREEN: 6553855,
          DARKGREY: 2846468607,
          DARKKHAKI: 3182914559,
          DARKMAGENTA: 2332068863,
          DARKOLIVEGREEN: 1433087999,
          DARKORANGE: 4287365375,
          DARKORCHID: 2570243327,
          DARKRED: 2332033279,
          DARKSALMON: 3918953215,
          DARKSEAGREEN: 2411499519,
          DARKSLATEBLUE: 1211993087,
          DARKSLATEGRAY: 793726975,
          DARKSLATEGREY: 793726975,
          DARKTURQUOISE: 13554175,
          DARKVIOLET: 2483082239,
          DEEPPINK: 4279538687,
          DEEPSKYBLUE: 12582911,
          DIMGRAY: 1768516095,
          DIMGREY: 1768516095,
          DODGERBLUE: 512819199,
          FIREBRICK: 2988581631,
          FLORALWHITE: 4294635775,
          FORESTGREEN: 579543807,
          FUCHSIA: 4278255615,
          GAINSBORO: 3705462015,
          GHOSTWHITE: 4177068031,
          GOLD: 4292280575,
          GOLDENROD: 3668254975,
          GRAY: 2155905279,
          GREEN: 8388863,
          GREENYELLOW: 2919182335,
          GREY: 2155905279,
          HONEYDEW: 4043305215,
          HOTPINK: 4285117695,
          INDIANRED: 3445382399,
          INDIGO: 1258324735,
          IVORY: 4294963455,
          KHAKI: 4041641215,
          LAVENDER: 3873897215,
          LAVENDERBLUSH: 4293981695,
          LAWNGREEN: 2096890111,
          LEMONCHIFFON: 4294626815,
          LIGHTBLUE: 2916673279,
          LIGHTCORAL: 4034953471,
          LIGHTCYAN: 3774873599,
          LIGHTGOLDENRODYELLOW: 4210742015,
          LIGHTGRAY: 3553874943,
          LIGHTGREEN: 2431553791,
          LIGHTGREY: 3553874943,
          LIGHTPINK: 4290167295,
          LIGHTSALMON: 4288707327,
          LIGHTSEAGREEN: 548580095,
          LIGHTSKYBLUE: 2278488831,
          LIGHTSLATEGRAY: 2005441023,
          LIGHTSLATEGREY: 2005441023,
          LIGHTSTEELBLUE: 2965692159,
          LIGHTYELLOW: 4294959359,
          LIME: 16711935,
          LIMEGREEN: 852308735,
          LINEN: 4210091775,
          MAGENTA: 4278255615,
          MAROON: 2147483903,
          MEDIUMAQUAMARINE: 1724754687,
          MEDIUMBLUE: 52735,
          MEDIUMORCHID: 3126187007,
          MEDIUMPURPLE: 2473647103,
          MEDIUMSEAGREEN: 1018393087,
          MEDIUMSLATEBLUE: 2070474495,
          MEDIUMSPRINGGREEN: 16423679,
          MEDIUMTURQUOISE: 1221709055,
          MEDIUMVIOLETRED: 3340076543,
          MIDNIGHTBLUE: 421097727,
          MINTCREAM: 4127193855,
          MISTYROSE: 4293190143,
          MOCCASIN: 4293178879,
          NAVAJOWHITE: 4292783615,
          NAVY: 33023,
          OLDLACE: 4260751103,
          OLIVE: 2155872511,
          OLIVEDRAB: 1804477439,
          ORANGE: 4289003775,
          ORANGERED: 4282712319,
          ORCHID: 3664828159,
          PALEGOLDENROD: 4008225535,
          PALEGREEN: 2566625535,
          PALETURQUOISE: 2951671551,
          PALEVIOLETRED: 3681588223,
          PAPAYAWHIP: 4293907967,
          PEACHPUFF: 4292524543,
          PERU: 3448061951,
          PINK: 4290825215,
          PLUM: 3718307327,
          POWDERBLUE: 2967529215,
          PURPLE: 2147516671,
          REBECCAPURPLE: 1714657791,
          RED: 4278190335,
          ROSYBROWN: 3163525119,
          ROYALBLUE: 1097458175,
          SADDLEBROWN: 2336560127,
          SALMON: 4202722047,
          SANDYBROWN: 4104413439,
          SEAGREEN: 780883967,
          SEASHELL: 4294307583,
          SIENNA: 2689740287,
          SILVER: 3233857791,
          SKYBLUE: 2278484991,
          SLATEBLUE: 1784335871,
          SLATEGRAY: 1887473919,
          SLATEGREY: 1887473919,
          SNOW: 4294638335,
          SPRINGGREEN: 16744447,
          STEELBLUE: 1182971135,
          TAN: 3535047935,
          TEAL: 8421631,
          THISTLE: 3636451583,
          TOMATO: 4284696575,
          TRANSPARENT: 0,
          TURQUOISE: 1088475391,
          VIOLET: 4001558271,
          WHEAT: 4125012991,
          WHITE: 4294967295,
          WHITESMOKE: 4126537215,
          YELLOW: 4294902015,
          YELLOWGREEN: 2597139199
        };
        var BACKGROUND_CLIP;
        (function(BACKGROUND_CLIP2) {
          BACKGROUND_CLIP2[BACKGROUND_CLIP2["BORDER_BOX"] = 0] = "BORDER_BOX";
          BACKGROUND_CLIP2[BACKGROUND_CLIP2["PADDING_BOX"] = 1] = "PADDING_BOX";
          BACKGROUND_CLIP2[BACKGROUND_CLIP2["CONTENT_BOX"] = 2] = "CONTENT_BOX";
        })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
        var backgroundClip = {
          name: "background-clip",
          initialValue: "border-box",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.map(function(token) {
              if (isIdentToken(token)) {
                switch (token.value) {
                  case "padding-box":
                    return BACKGROUND_CLIP.PADDING_BOX;
                  case "content-box":
                    return BACKGROUND_CLIP.CONTENT_BOX;
                }
              }
              return BACKGROUND_CLIP.BORDER_BOX;
            });
          }
        };
        var backgroundColor = {
          name: "background-color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var parseColorStop = function(context, args) {
          var color2 = color$1.parse(context, args[0]);
          var stop3 = args[1];
          return stop3 && isLengthPercentage(stop3) ? { color: color2, stop: stop3 } : { color: color2, stop: null };
        };
        var processColorStops = function(stops, lineLength) {
          var first = stops[0];
          var last = stops[stops.length - 1];
          if (first.stop === null) {
            first.stop = ZERO_LENGTH;
          }
          if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
          }
          var processStops = [];
          var previous = 0;
          for (var i4 = 0; i4 < stops.length; i4++) {
            var stop_1 = stops[i4].stop;
            if (stop_1 !== null) {
              var absoluteValue = getAbsoluteValue(stop_1, lineLength);
              if (absoluteValue > previous) {
                processStops.push(absoluteValue);
              } else {
                processStops.push(previous);
              }
              previous = absoluteValue;
            } else {
              processStops.push(null);
            }
          }
          var gapBegin = null;
          for (var i4 = 0; i4 < processStops.length; i4++) {
            var stop_2 = processStops[i4];
            if (stop_2 === null) {
              if (gapBegin === null) {
                gapBegin = i4;
              }
            } else if (gapBegin !== null) {
              var gapLength = i4 - gapBegin;
              var beforeGap = processStops[gapBegin - 1];
              var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
              for (var g2 = 1; g2 <= gapLength; g2++) {
                processStops[gapBegin + g2 - 1] = gapValue * g2;
              }
              gapBegin = null;
            }
          }
          return stops.map(function(_a3, i5) {
            var color2 = _a3.color;
            return { color: color2, stop: Math.max(Math.min(1, processStops[i5] / lineLength), 0) };
          });
        };
        var getAngleFromCorner = function(corner, width, height) {
          var centerX = width / 2;
          var centerY = height / 2;
          var x2 = getAbsoluteValue(corner[0], width) - centerX;
          var y3 = centerY - getAbsoluteValue(corner[1], height);
          return (Math.atan2(y3, x2) + Math.PI * 2) % (Math.PI * 2);
        };
        var calculateGradientDirection = function(angle2, width, height) {
          var radian = typeof angle2 === "number" ? angle2 : getAngleFromCorner(angle2, width, height);
          var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
          var halfWidth = width / 2;
          var halfHeight = height / 2;
          var halfLineLength = lineLength / 2;
          var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
          var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
          return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
        };
        var distance = function(a4, b2) {
          return Math.sqrt(a4 * a4 + b2 * b2);
        };
        var findCorner = function(width, height, x2, y3, closest2) {
          var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
          ];
          return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d2 = distance(x2 - cx, y3 - cy);
            if (closest2 ? d2 < stat.optimumDistance : d2 > stat.optimumDistance) {
              return {
                optimumCorner: corner,
                optimumDistance: d2
              };
            }
            return stat;
          }, {
            optimumDistance: closest2 ? Infinity : -Infinity,
            optimumCorner: null
          }).optimumCorner;
        };
        var calculateRadius = function(gradient, x2, y3, width, height) {
          var rx = 0;
          var ry = 0;
          switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
              if (gradient.shape === CSSRadialShape.CIRCLE) {
                rx = ry = Math.min(Math.abs(x2), Math.abs(x2 - width), Math.abs(y3), Math.abs(y3 - height));
              } else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                rx = Math.min(Math.abs(x2), Math.abs(x2 - width));
                ry = Math.min(Math.abs(y3), Math.abs(y3 - height));
              }
              break;
            case CSSRadialExtent.CLOSEST_CORNER:
              if (gradient.shape === CSSRadialShape.CIRCLE) {
                rx = ry = Math.min(distance(x2, y3), distance(x2, y3 - height), distance(x2 - width, y3), distance(x2 - width, y3 - height));
              } else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                var c4 = Math.min(Math.abs(y3), Math.abs(y3 - height)) / Math.min(Math.abs(x2), Math.abs(x2 - width));
                var _a3 = findCorner(width, height, x2, y3, true), cx = _a3[0], cy = _a3[1];
                rx = distance(cx - x2, (cy - y3) / c4);
                ry = c4 * rx;
              }
              break;
            case CSSRadialExtent.FARTHEST_SIDE:
              if (gradient.shape === CSSRadialShape.CIRCLE) {
                rx = ry = Math.max(Math.abs(x2), Math.abs(x2 - width), Math.abs(y3), Math.abs(y3 - height));
              } else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                rx = Math.max(Math.abs(x2), Math.abs(x2 - width));
                ry = Math.max(Math.abs(y3), Math.abs(y3 - height));
              }
              break;
            case CSSRadialExtent.FARTHEST_CORNER:
              if (gradient.shape === CSSRadialShape.CIRCLE) {
                rx = ry = Math.max(distance(x2, y3), distance(x2, y3 - height), distance(x2 - width, y3), distance(x2 - width, y3 - height));
              } else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                var c4 = Math.max(Math.abs(y3), Math.abs(y3 - height)) / Math.max(Math.abs(x2), Math.abs(x2 - width));
                var _b2 = findCorner(width, height, x2, y3, false), cx = _b2[0], cy = _b2[1];
                rx = distance(cx - x2, (cy - y3) / c4);
                ry = c4 * rx;
              }
              break;
          }
          if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
          }
          return [rx, ry];
        };
        var linearGradient = function(context, tokens) {
          var angle$1 = deg(180);
          var stops = [];
          parseFunctionArgs(tokens).forEach(function(arg, i4) {
            if (i4 === 0) {
              var firstToken = arg[0];
              if (firstToken.type === 20 && firstToken.value === "to") {
                angle$1 = parseNamedSide(arg);
                return;
              } else if (isAngle(firstToken)) {
                angle$1 = angle.parse(context, firstToken);
                return;
              }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
          });
          return { angle: angle$1, stops, type: CSSImageType.LINEAR_GRADIENT };
        };
        var prefixLinearGradient = function(context, tokens) {
          var angle$1 = deg(180);
          var stops = [];
          parseFunctionArgs(tokens).forEach(function(arg, i4) {
            if (i4 === 0) {
              var firstToken = arg[0];
              if (firstToken.type === 20 && ["top", "left", "right", "bottom"].indexOf(firstToken.value) !== -1) {
                angle$1 = parseNamedSide(arg);
                return;
              } else if (isAngle(firstToken)) {
                angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                return;
              }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
          });
          return {
            angle: angle$1,
            stops,
            type: CSSImageType.LINEAR_GRADIENT
          };
        };
        var webkitGradient = function(context, tokens) {
          var angle2 = deg(180);
          var stops = [];
          var type = CSSImageType.LINEAR_GRADIENT;
          var shape = CSSRadialShape.CIRCLE;
          var size3 = CSSRadialExtent.FARTHEST_CORNER;
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i4) {
            var firstToken = arg[0];
            if (i4 === 0) {
              if (isIdentToken(firstToken) && firstToken.value === "linear") {
                type = CSSImageType.LINEAR_GRADIENT;
                return;
              } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                type = CSSImageType.RADIAL_GRADIENT;
                return;
              }
            }
            if (firstToken.type === 18) {
              if (firstToken.name === "from") {
                var color2 = color$1.parse(context, firstToken.values[0]);
                stops.push({ stop: ZERO_LENGTH, color: color2 });
              } else if (firstToken.name === "to") {
                var color2 = color$1.parse(context, firstToken.values[0]);
                stops.push({ stop: HUNDRED_PERCENT, color: color2 });
              } else if (firstToken.name === "color-stop") {
                var values = firstToken.values.filter(nonFunctionArgSeparator);
                if (values.length === 2) {
                  var color2 = color$1.parse(context, values[1]);
                  var stop_1 = values[0];
                  if (isNumberToken(stop_1)) {
                    stops.push({
                      stop: { type: 16, number: stop_1.number * 100, flags: stop_1.flags },
                      color: color2
                    });
                  }
                }
              }
            }
          });
          return type === CSSImageType.LINEAR_GRADIENT ? {
            angle: (angle2 + deg(180)) % deg(360),
            stops,
            type
          } : { size: size3, shape, stops, position: position2, type };
        };
        var CLOSEST_SIDE = "closest-side";
        var FARTHEST_SIDE = "farthest-side";
        var CLOSEST_CORNER = "closest-corner";
        var FARTHEST_CORNER = "farthest-corner";
        var CIRCLE = "circle";
        var ELLIPSE = "ellipse";
        var COVER = "cover";
        var CONTAIN = "contain";
        var radialGradient = function(context, tokens) {
          var shape = CSSRadialShape.CIRCLE;
          var size3 = CSSRadialExtent.FARTHEST_CORNER;
          var stops = [];
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i4) {
            var isColorStop = true;
            if (i4 === 0) {
              var isAtPosition_1 = false;
              isColorStop = arg.reduce(function(acc, token) {
                if (isAtPosition_1) {
                  if (isIdentToken(token)) {
                    switch (token.value) {
                      case "center":
                        position2.push(FIFTY_PERCENT);
                        return acc;
                      case "top":
                      case "left":
                        position2.push(ZERO_LENGTH);
                        return acc;
                      case "right":
                      case "bottom":
                        position2.push(HUNDRED_PERCENT);
                        return acc;
                    }
                  } else if (isLengthPercentage(token) || isLength(token)) {
                    position2.push(token);
                  }
                } else if (isIdentToken(token)) {
                  switch (token.value) {
                    case CIRCLE:
                      shape = CSSRadialShape.CIRCLE;
                      return false;
                    case ELLIPSE:
                      shape = CSSRadialShape.ELLIPSE;
                      return false;
                    case "at":
                      isAtPosition_1 = true;
                      return false;
                    case CLOSEST_SIDE:
                      size3 = CSSRadialExtent.CLOSEST_SIDE;
                      return false;
                    case COVER:
                    case FARTHEST_SIDE:
                      size3 = CSSRadialExtent.FARTHEST_SIDE;
                      return false;
                    case CONTAIN:
                    case CLOSEST_CORNER:
                      size3 = CSSRadialExtent.CLOSEST_CORNER;
                      return false;
                    case FARTHEST_CORNER:
                      size3 = CSSRadialExtent.FARTHEST_CORNER;
                      return false;
                  }
                } else if (isLength(token) || isLengthPercentage(token)) {
                  if (!Array.isArray(size3)) {
                    size3 = [];
                  }
                  size3.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            }
            if (isColorStop) {
              var colorStop = parseColorStop(context, arg);
              stops.push(colorStop);
            }
          });
          return { size: size3, shape, stops, position: position2, type: CSSImageType.RADIAL_GRADIENT };
        };
        var prefixRadialGradient = function(context, tokens) {
          var shape = CSSRadialShape.CIRCLE;
          var size3 = CSSRadialExtent.FARTHEST_CORNER;
          var stops = [];
          var position2 = [];
          parseFunctionArgs(tokens).forEach(function(arg, i4) {
            var isColorStop = true;
            if (i4 === 0) {
              isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) {
                  switch (token.value) {
                    case "center":
                      position2.push(FIFTY_PERCENT);
                      return false;
                    case "top":
                    case "left":
                      position2.push(ZERO_LENGTH);
                      return false;
                    case "right":
                    case "bottom":
                      position2.push(HUNDRED_PERCENT);
                      return false;
                  }
                } else if (isLengthPercentage(token) || isLength(token)) {
                  position2.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            } else if (i4 === 1) {
              isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) {
                  switch (token.value) {
                    case CIRCLE:
                      shape = CSSRadialShape.CIRCLE;
                      return false;
                    case ELLIPSE:
                      shape = CSSRadialShape.ELLIPSE;
                      return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                      size3 = CSSRadialExtent.CLOSEST_SIDE;
                      return false;
                    case FARTHEST_SIDE:
                      size3 = CSSRadialExtent.FARTHEST_SIDE;
                      return false;
                    case CLOSEST_CORNER:
                      size3 = CSSRadialExtent.CLOSEST_CORNER;
                      return false;
                    case COVER:
                    case FARTHEST_CORNER:
                      size3 = CSSRadialExtent.FARTHEST_CORNER;
                      return false;
                  }
                } else if (isLength(token) || isLengthPercentage(token)) {
                  if (!Array.isArray(size3)) {
                    size3 = [];
                  }
                  size3.push(token);
                  return false;
                }
                return acc;
              }, isColorStop);
            }
            if (isColorStop) {
              var colorStop = parseColorStop(context, arg);
              stops.push(colorStop);
            }
          });
          return { size: size3, shape, stops, position: position2, type: CSSImageType.RADIAL_GRADIENT };
        };
        var CSSImageType;
        (function(CSSImageType2) {
          CSSImageType2[CSSImageType2["URL"] = 0] = "URL";
          CSSImageType2[CSSImageType2["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
          CSSImageType2[CSSImageType2["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
        })(CSSImageType || (CSSImageType = {}));
        var isLinearGradient = function(background) {
          return background.type === CSSImageType.LINEAR_GRADIENT;
        };
        var isRadialGradient = function(background) {
          return background.type === CSSImageType.RADIAL_GRADIENT;
        };
        var CSSRadialShape;
        (function(CSSRadialShape2) {
          CSSRadialShape2[CSSRadialShape2["CIRCLE"] = 0] = "CIRCLE";
          CSSRadialShape2[CSSRadialShape2["ELLIPSE"] = 1] = "ELLIPSE";
        })(CSSRadialShape || (CSSRadialShape = {}));
        var CSSRadialExtent;
        (function(CSSRadialExtent2) {
          CSSRadialExtent2[CSSRadialExtent2["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
          CSSRadialExtent2[CSSRadialExtent2["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
          CSSRadialExtent2[CSSRadialExtent2["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
          CSSRadialExtent2[CSSRadialExtent2["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
        })(CSSRadialExtent || (CSSRadialExtent = {}));
        var image = {
          name: "image",
          parse: function(context, value) {
            if (value.type === 22) {
              var image_1 = { url: value.value, type: CSSImageType.URL };
              context.cache.addImage(value.value);
              return image_1;
            }
            if (value.type === 18) {
              var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
              if (typeof imageFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
              }
              return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
          }
        };
        function isSupportedImage(value) {
          return !(value.type === 20 && value.value === "none") && (value.type !== 18 || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
        }
        var SUPPORTED_IMAGE_FUNCTIONS = {
          "linear-gradient": linearGradient,
          "-moz-linear-gradient": prefixLinearGradient,
          "-ms-linear-gradient": prefixLinearGradient,
          "-o-linear-gradient": prefixLinearGradient,
          "-webkit-linear-gradient": prefixLinearGradient,
          "radial-gradient": radialGradient,
          "-moz-radial-gradient": prefixRadialGradient,
          "-ms-radial-gradient": prefixRadialGradient,
          "-o-radial-gradient": prefixRadialGradient,
          "-webkit-radial-gradient": prefixRadialGradient,
          "-webkit-gradient": webkitGradient
        };
        var backgroundImage = {
          name: "background-image",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return [];
            }
            return tokens.filter(function(value) {
              return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
              return image.parse(context, value);
            });
          }
        };
        var backgroundOrigin = {
          name: "background-origin",
          initialValue: "border-box",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.map(function(token) {
              if (isIdentToken(token)) {
                switch (token.value) {
                  case "padding-box":
                    return 1;
                  case "content-box":
                    return 2;
                }
              }
              return 0;
            });
          }
        };
        var backgroundPosition = {
          name: "background-position",
          initialValue: "0% 0%",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
          }
        };
        var BACKGROUND_REPEAT;
        (function(BACKGROUND_REPEAT2) {
          BACKGROUND_REPEAT2[BACKGROUND_REPEAT2["REPEAT"] = 0] = "REPEAT";
          BACKGROUND_REPEAT2[BACKGROUND_REPEAT2["NO_REPEAT"] = 1] = "NO_REPEAT";
          BACKGROUND_REPEAT2[BACKGROUND_REPEAT2["REPEAT_X"] = 2] = "REPEAT_X";
          BACKGROUND_REPEAT2[BACKGROUND_REPEAT2["REPEAT_Y"] = 3] = "REPEAT_Y";
        })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
        var backgroundRepeat = {
          name: "background-repeat",
          initialValue: "repeat",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isIdentToken).map(function(token) {
                return token.value;
              }).join(" ");
            }).map(parseBackgroundRepeat);
          }
        };
        var parseBackgroundRepeat = function(value) {
          switch (value) {
            case "no-repeat":
              return BACKGROUND_REPEAT.NO_REPEAT;
            case "repeat-x":
            case "repeat no-repeat":
              return BACKGROUND_REPEAT.REPEAT_X;
            case "repeat-y":
            case "no-repeat repeat":
              return BACKGROUND_REPEAT.REPEAT_Y;
            case "repeat":
            default:
              return BACKGROUND_REPEAT.REPEAT;
          }
        };
        var BACKGROUND_SIZE;
        (function(BACKGROUND_SIZE2) {
          BACKGROUND_SIZE2["AUTO"] = "auto";
          BACKGROUND_SIZE2["CONTAIN"] = "contain";
          BACKGROUND_SIZE2["COVER"] = "cover";
        })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
        var backgroundSize = {
          name: "background-size",
          initialValue: "0",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
              return values.filter(isBackgroundSizeInfoToken);
            });
          }
        };
        var isBackgroundSizeInfoToken = function(value) {
          return isIdentToken(value) || isLengthPercentage(value);
        };
        var borderColorForSide = function(side) {
          return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3,
            format: "color"
          };
        };
        var borderTopColor = borderColorForSide("top");
        var borderRightColor = borderColorForSide("right");
        var borderBottomColor = borderColorForSide("bottom");
        var borderLeftColor = borderColorForSide("left");
        var borderRadiusForSide = function(side) {
          return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1,
            parse: function(_context, tokens) {
              return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
          };
        };
        var borderTopLeftRadius = borderRadiusForSide("top-left");
        var borderTopRightRadius = borderRadiusForSide("top-right");
        var borderBottomRightRadius = borderRadiusForSide("bottom-right");
        var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
        var BORDER_STYLE;
        (function(BORDER_STYLE2) {
          BORDER_STYLE2[BORDER_STYLE2["NONE"] = 0] = "NONE";
          BORDER_STYLE2[BORDER_STYLE2["SOLID"] = 1] = "SOLID";
          BORDER_STYLE2[BORDER_STYLE2["DASHED"] = 2] = "DASHED";
          BORDER_STYLE2[BORDER_STYLE2["DOTTED"] = 3] = "DOTTED";
          BORDER_STYLE2[BORDER_STYLE2["DOUBLE"] = 4] = "DOUBLE";
        })(BORDER_STYLE || (BORDER_STYLE = {}));
        var borderStyleForSide = function(side) {
          return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2,
            parse: function(_context, style) {
              switch (style) {
                case "none":
                  return BORDER_STYLE.NONE;
                case "dashed":
                  return BORDER_STYLE.DASHED;
                case "dotted":
                  return BORDER_STYLE.DOTTED;
                case "double":
                  return BORDER_STYLE.DOUBLE;
              }
              return BORDER_STYLE.SOLID;
            }
          };
        };
        var borderTopStyle = borderStyleForSide("top");
        var borderRightStyle = borderStyleForSide("right");
        var borderBottomStyle = borderStyleForSide("bottom");
        var borderLeftStyle = borderStyleForSide("left");
        var borderWidthForSide = function(side) {
          return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0,
            prefix: false,
            parse: function(_context, token) {
              if (isDimensionToken(token)) {
                return token.number;
              }
              return 0;
            }
          };
        };
        var borderTopWidth = borderWidthForSide("top");
        var borderRightWidth = borderWidthForSide("right");
        var borderBottomWidth = borderWidthForSide("bottom");
        var borderLeftWidth = borderWidthForSide("left");
        var color = {
          name: "color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var direction = {
          name: "direction",
          initialValue: "ltr",
          prefix: false,
          type: 2,
          parse: function(_context, direction2) {
            switch (direction2) {
              case "rtl":
                return 1;
              case "ltr":
              default:
                return 0;
            }
          }
        };
        var display = {
          name: "display",
          initialValue: "inline-block",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
              return bit | parseDisplayValue(token.value);
            }, 0);
          }
        };
        var parseDisplayValue = function(display2) {
          switch (display2) {
            case "block":
            case "-webkit-box":
              return 2;
            case "inline":
              return 4;
            case "run-in":
              return 8;
            case "flow":
              return 16;
            case "flow-root":
              return 32;
            case "table":
              return 64;
            case "flex":
            case "-webkit-flex":
              return 128;
            case "grid":
            case "-ms-grid":
              return 256;
            case "ruby":
              return 512;
            case "subgrid":
              return 1024;
            case "list-item":
              return 2048;
            case "table-row-group":
              return 4096;
            case "table-header-group":
              return 8192;
            case "table-footer-group":
              return 16384;
            case "table-row":
              return 32768;
            case "table-cell":
              return 65536;
            case "table-column-group":
              return 131072;
            case "table-column":
              return 262144;
            case "table-caption":
              return 524288;
            case "ruby-base":
              return 1048576;
            case "ruby-text":
              return 2097152;
            case "ruby-base-container":
              return 4194304;
            case "ruby-text-container":
              return 8388608;
            case "contents":
              return 16777216;
            case "inline-block":
              return 33554432;
            case "inline-list-item":
              return 67108864;
            case "inline-table":
              return 134217728;
            case "inline-flex":
              return 268435456;
            case "inline-grid":
              return 536870912;
          }
          return 0;
        };
        var FLOAT;
        (function(FLOAT2) {
          FLOAT2[FLOAT2["NONE"] = 0] = "NONE";
          FLOAT2[FLOAT2["LEFT"] = 1] = "LEFT";
          FLOAT2[FLOAT2["RIGHT"] = 2] = "RIGHT";
          FLOAT2[FLOAT2["INLINE_START"] = 3] = "INLINE_START";
          FLOAT2[FLOAT2["INLINE_END"] = 4] = "INLINE_END";
        })(FLOAT || (FLOAT = {}));
        var float = {
          name: "float",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, float2) {
            switch (float2) {
              case "left":
                return FLOAT.LEFT;
              case "right":
                return FLOAT.RIGHT;
              case "inline-start":
                return FLOAT.INLINE_START;
              case "inline-end":
                return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
          }
        };
        var letterSpacing = {
          name: "letter-spacing",
          initialValue: "0",
          prefix: false,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20 && token.value === "normal") {
              return 0;
            }
            if (token.type === 17) {
              return token.number;
            }
            if (token.type === 15) {
              return token.number;
            }
            return 0;
          }
        };
        var LINE_BREAK;
        (function(LINE_BREAK2) {
          LINE_BREAK2["NORMAL"] = "normal";
          LINE_BREAK2["STRICT"] = "strict";
        })(LINE_BREAK || (LINE_BREAK = {}));
        var lineBreak = {
          name: "line-break",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, lineBreak2) {
            switch (lineBreak2) {
              case "strict":
                return LINE_BREAK.STRICT;
              case "normal":
              default:
                return LINE_BREAK.NORMAL;
            }
          }
        };
        var lineHeight = {
          name: "line-height",
          initialValue: "normal",
          prefix: false,
          type: 4
        };
        var computeLineHeight = function(token, fontSize2) {
          if (isIdentToken(token) && token.value === "normal") {
            return 1.2 * fontSize2;
          } else if (token.type === 17) {
            return fontSize2 * token.number;
          } else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize2);
          }
          return fontSize2;
        };
        var listStyleImage = {
          name: "list-style-image",
          initialValue: "none",
          type: 0,
          prefix: false,
          parse: function(context, token) {
            if (token.type === 20 && token.value === "none") {
              return null;
            }
            return image.parse(context, token);
          }
        };
        var LIST_STYLE_POSITION;
        (function(LIST_STYLE_POSITION2) {
          LIST_STYLE_POSITION2[LIST_STYLE_POSITION2["INSIDE"] = 0] = "INSIDE";
          LIST_STYLE_POSITION2[LIST_STYLE_POSITION2["OUTSIDE"] = 1] = "OUTSIDE";
        })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
        var listStylePosition = {
          name: "list-style-position",
          initialValue: "outside",
          prefix: false,
          type: 2,
          parse: function(_context, position2) {
            switch (position2) {
              case "inside":
                return LIST_STYLE_POSITION.INSIDE;
              case "outside":
              default:
                return LIST_STYLE_POSITION.OUTSIDE;
            }
          }
        };
        var LIST_STYLE_TYPE;
        (function(LIST_STYLE_TYPE2) {
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["NONE"] = -1] = "NONE";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DISC"] = 0] = "DISC";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CIRCLE"] = 1] = "CIRCLE";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["SQUARE"] = 2] = "SQUARE";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DECIMAL"] = 3] = "DECIMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["LOWER_GREEK"] = 8] = "LOWER_GREEK";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["ARMENIAN"] = 12] = "ARMENIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["BENGALI"] = 13] = "BENGALI";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CAMBODIAN"] = 14] = "CAMBODIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DEVANAGARI"] = 18] = "DEVANAGARI";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["GEORGIAN"] = 20] = "GEORGIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["GUJARATI"] = 21] = "GUJARATI";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["GURMUKHI"] = 22] = "GURMUKHI";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["HEBREW"] = 22] = "HEBREW";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["HIRAGANA"] = 23] = "HIRAGANA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KANNADA"] = 27] = "KANNADA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KATAKANA"] = 28] = "KATAKANA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KHMER"] = 30] = "KHMER";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["LAO"] = 34] = "LAO";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["MALAYALAM"] = 36] = "MALAYALAM";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["MONGOLIAN"] = 37] = "MONGOLIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["MYANMAR"] = 38] = "MYANMAR";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["ORIYA"] = 39] = "ORIYA";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["PERSIAN"] = 40] = "PERSIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["TAMIL"] = 43] = "TAMIL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["TELUGU"] = 44] = "TELUGU";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["THAI"] = 45] = "THAI";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["TIBETAN"] = 46] = "TIBETAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
          LIST_STYLE_TYPE2[LIST_STYLE_TYPE2["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
        })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
        var listStyleType = {
          name: "list-style-type",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, type) {
            switch (type) {
              case "disc":
                return LIST_STYLE_TYPE.DISC;
              case "circle":
                return LIST_STYLE_TYPE.CIRCLE;
              case "square":
                return LIST_STYLE_TYPE.SQUARE;
              case "decimal":
                return LIST_STYLE_TYPE.DECIMAL;
              case "cjk-decimal":
                return LIST_STYLE_TYPE.CJK_DECIMAL;
              case "decimal-leading-zero":
                return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
              case "lower-roman":
                return LIST_STYLE_TYPE.LOWER_ROMAN;
              case "upper-roman":
                return LIST_STYLE_TYPE.UPPER_ROMAN;
              case "lower-greek":
                return LIST_STYLE_TYPE.LOWER_GREEK;
              case "lower-alpha":
                return LIST_STYLE_TYPE.LOWER_ALPHA;
              case "upper-alpha":
                return LIST_STYLE_TYPE.UPPER_ALPHA;
              case "arabic-indic":
                return LIST_STYLE_TYPE.ARABIC_INDIC;
              case "armenian":
                return LIST_STYLE_TYPE.ARMENIAN;
              case "bengali":
                return LIST_STYLE_TYPE.BENGALI;
              case "cambodian":
                return LIST_STYLE_TYPE.CAMBODIAN;
              case "cjk-earthly-branch":
                return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
              case "cjk-heavenly-stem":
                return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
              case "cjk-ideographic":
                return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
              case "devanagari":
                return LIST_STYLE_TYPE.DEVANAGARI;
              case "ethiopic-numeric":
                return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
              case "georgian":
                return LIST_STYLE_TYPE.GEORGIAN;
              case "gujarati":
                return LIST_STYLE_TYPE.GUJARATI;
              case "gurmukhi":
                return LIST_STYLE_TYPE.GURMUKHI;
              case "hebrew":
                return LIST_STYLE_TYPE.HEBREW;
              case "hiragana":
                return LIST_STYLE_TYPE.HIRAGANA;
              case "hiragana-iroha":
                return LIST_STYLE_TYPE.HIRAGANA_IROHA;
              case "japanese-formal":
                return LIST_STYLE_TYPE.JAPANESE_FORMAL;
              case "japanese-informal":
                return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
              case "kannada":
                return LIST_STYLE_TYPE.KANNADA;
              case "katakana":
                return LIST_STYLE_TYPE.KATAKANA;
              case "katakana-iroha":
                return LIST_STYLE_TYPE.KATAKANA_IROHA;
              case "khmer":
                return LIST_STYLE_TYPE.KHMER;
              case "korean-hangul-formal":
                return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
              case "korean-hanja-formal":
                return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
              case "korean-hanja-informal":
                return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
              case "lao":
                return LIST_STYLE_TYPE.LAO;
              case "lower-armenian":
                return LIST_STYLE_TYPE.LOWER_ARMENIAN;
              case "malayalam":
                return LIST_STYLE_TYPE.MALAYALAM;
              case "mongolian":
                return LIST_STYLE_TYPE.MONGOLIAN;
              case "myanmar":
                return LIST_STYLE_TYPE.MYANMAR;
              case "oriya":
                return LIST_STYLE_TYPE.ORIYA;
              case "persian":
                return LIST_STYLE_TYPE.PERSIAN;
              case "simp-chinese-formal":
                return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
              case "simp-chinese-informal":
                return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
              case "tamil":
                return LIST_STYLE_TYPE.TAMIL;
              case "telugu":
                return LIST_STYLE_TYPE.TELUGU;
              case "thai":
                return LIST_STYLE_TYPE.THAI;
              case "tibetan":
                return LIST_STYLE_TYPE.TIBETAN;
              case "trad-chinese-formal":
                return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
              case "trad-chinese-informal":
                return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
              case "upper-armenian":
                return LIST_STYLE_TYPE.UPPER_ARMENIAN;
              case "disclosure-open":
                return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
              case "disclosure-closed":
                return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
              case "none":
              default:
                return LIST_STYLE_TYPE.NONE;
            }
          }
        };
        var marginForSide = function(side) {
          return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4
          };
        };
        var marginTop = marginForSide("top");
        var marginRight = marginForSide("right");
        var marginBottom = marginForSide("bottom");
        var marginLeft = marginForSide("left");
        var OVERFLOW;
        (function(OVERFLOW2) {
          OVERFLOW2[OVERFLOW2["VISIBLE"] = 0] = "VISIBLE";
          OVERFLOW2[OVERFLOW2["HIDDEN"] = 1] = "HIDDEN";
          OVERFLOW2[OVERFLOW2["SCROLL"] = 2] = "SCROLL";
          OVERFLOW2[OVERFLOW2["CLIP"] = 3] = "CLIP";
          OVERFLOW2[OVERFLOW2["AUTO"] = 4] = "AUTO";
        })(OVERFLOW || (OVERFLOW = {}));
        var overflow = {
          name: "overflow",
          initialValue: "visible",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow2) {
              switch (overflow2.value) {
                case "hidden":
                  return OVERFLOW.HIDDEN;
                case "scroll":
                  return OVERFLOW.SCROLL;
                case "clip":
                  return OVERFLOW.CLIP;
                case "auto":
                  return OVERFLOW.AUTO;
                case "visible":
                default:
                  return OVERFLOW.VISIBLE;
              }
            });
          }
        };
        var overflowWrap = {
          name: "overflow-wrap",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, overflow2) {
            switch (overflow2) {
              case "break-word":
                return "break-word";
              case "normal":
              default:
                return "normal";
            }
          }
        };
        var paddingForSide = function(side) {
          return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3,
            format: "length-percentage"
          };
        };
        var paddingTop = paddingForSide("top");
        var paddingRight = paddingForSide("right");
        var paddingBottom = paddingForSide("bottom");
        var paddingLeft = paddingForSide("left");
        var TEXT_ALIGN;
        (function(TEXT_ALIGN2) {
          TEXT_ALIGN2[TEXT_ALIGN2["LEFT"] = 0] = "LEFT";
          TEXT_ALIGN2[TEXT_ALIGN2["CENTER"] = 1] = "CENTER";
          TEXT_ALIGN2[TEXT_ALIGN2["RIGHT"] = 2] = "RIGHT";
        })(TEXT_ALIGN || (TEXT_ALIGN = {}));
        var textAlign = {
          name: "text-align",
          initialValue: "left",
          prefix: false,
          type: 2,
          parse: function(_context, textAlign2) {
            switch (textAlign2) {
              case "right":
                return TEXT_ALIGN.RIGHT;
              case "center":
              case "justify":
                return TEXT_ALIGN.CENTER;
              case "left":
              default:
                return TEXT_ALIGN.LEFT;
            }
          }
        };
        var POSITION;
        (function(POSITION2) {
          POSITION2[POSITION2["STATIC"] = 0] = "STATIC";
          POSITION2[POSITION2["RELATIVE"] = 1] = "RELATIVE";
          POSITION2[POSITION2["ABSOLUTE"] = 2] = "ABSOLUTE";
          POSITION2[POSITION2["FIXED"] = 3] = "FIXED";
          POSITION2[POSITION2["STICKY"] = 4] = "STICKY";
        })(POSITION || (POSITION = {}));
        var position = {
          name: "position",
          initialValue: "static",
          prefix: false,
          type: 2,
          parse: function(_context, position2) {
            switch (position2) {
              case "relative":
                return POSITION.RELATIVE;
              case "absolute":
                return POSITION.ABSOLUTE;
              case "fixed":
                return POSITION.FIXED;
              case "sticky":
                return POSITION.STICKY;
            }
            return POSITION.STATIC;
          }
        };
        var textShadow = {
          name: "text-shadow",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
              return [];
            }
            return parseFunctionArgs(tokens).map(function(values) {
              var shadow = {
                color: COLORS.TRANSPARENT,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH
              };
              var c4 = 0;
              for (var i4 = 0; i4 < values.length; i4++) {
                var token = values[i4];
                if (isLength(token)) {
                  if (c4 === 0) {
                    shadow.offsetX = token;
                  } else if (c4 === 1) {
                    shadow.offsetY = token;
                  } else {
                    shadow.blur = token;
                  }
                  c4++;
                } else {
                  shadow.color = color$1.parse(context, token);
                }
              }
              return shadow;
            });
          }
        };
        var TEXT_TRANSFORM;
        (function(TEXT_TRANSFORM2) {
          TEXT_TRANSFORM2[TEXT_TRANSFORM2["NONE"] = 0] = "NONE";
          TEXT_TRANSFORM2[TEXT_TRANSFORM2["LOWERCASE"] = 1] = "LOWERCASE";
          TEXT_TRANSFORM2[TEXT_TRANSFORM2["UPPERCASE"] = 2] = "UPPERCASE";
          TEXT_TRANSFORM2[TEXT_TRANSFORM2["CAPITALIZE"] = 3] = "CAPITALIZE";
        })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
        var textTransform = {
          name: "text-transform",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, textTransform2) {
            switch (textTransform2) {
              case "uppercase":
                return TEXT_TRANSFORM.UPPERCASE;
              case "lowercase":
                return TEXT_TRANSFORM.LOWERCASE;
              case "capitalize":
                return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
          }
        };
        var transform$1 = {
          name: "transform",
          initialValue: "none",
          prefix: true,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20 && token.value === "none") {
              return null;
            }
            if (token.type === 18) {
              var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
              if (typeof transformFunction === "undefined") {
                throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
              }
              return transformFunction(token.values);
            }
            return null;
          }
        };
        var matrix = function(args) {
          var values = args.filter(function(arg) {
            return arg.type === 17;
          }).map(function(arg) {
            return arg.number;
          });
          return values.length === 6 ? values : null;
        };
        var matrix3d = function(args) {
          var values = args.filter(function(arg) {
            return arg.type === 17;
          }).map(function(arg) {
            return arg.number;
          });
          var a1 = values[0], b1 = values[1];
          values[2];
          values[3];
          var a22 = values[4], b2 = values[5];
          values[6];
          values[7];
          values[8];
          values[9];
          values[10];
          values[11];
          var a4 = values[12], b4 = values[13];
          values[14];
          values[15];
          return values.length === 16 ? [a1, b1, a22, b2, a4, b4] : null;
        };
        var SUPPORTED_TRANSFORM_FUNCTIONS = {
          matrix,
          matrix3d
        };
        var DEFAULT_VALUE = {
          type: 16,
          number: 50,
          flags: FLAG_INTEGER
        };
        var DEFAULT2 = [DEFAULT_VALUE, DEFAULT_VALUE];
        var transformOrigin = {
          name: "transform-origin",
          initialValue: "50% 50%",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
              return DEFAULT2;
            }
            return [origins[0], origins[1]];
          }
        };
        var VISIBILITY;
        (function(VISIBILITY2) {
          VISIBILITY2[VISIBILITY2["VISIBLE"] = 0] = "VISIBLE";
          VISIBILITY2[VISIBILITY2["HIDDEN"] = 1] = "HIDDEN";
          VISIBILITY2[VISIBILITY2["COLLAPSE"] = 2] = "COLLAPSE";
        })(VISIBILITY || (VISIBILITY = {}));
        var visibility = {
          name: "visible",
          initialValue: "none",
          prefix: false,
          type: 2,
          parse: function(_context, visibility2) {
            switch (visibility2) {
              case "hidden":
                return VISIBILITY.HIDDEN;
              case "collapse":
                return VISIBILITY.COLLAPSE;
              case "visible":
              default:
                return VISIBILITY.VISIBLE;
            }
          }
        };
        var WORD_BREAK;
        (function(WORD_BREAK2) {
          WORD_BREAK2["NORMAL"] = "normal";
          WORD_BREAK2["BREAK_ALL"] = "break-all";
          WORD_BREAK2["KEEP_ALL"] = "keep-all";
        })(WORD_BREAK || (WORD_BREAK = {}));
        var wordBreak = {
          name: "word-break",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, wordBreak2) {
            switch (wordBreak2) {
              case "break-all":
                return WORD_BREAK.BREAK_ALL;
              case "keep-all":
                return WORD_BREAK.KEEP_ALL;
              case "normal":
              default:
                return WORD_BREAK.NORMAL;
            }
          }
        };
        var zIndex = {
          name: "z-index",
          initialValue: "auto",
          prefix: false,
          type: 0,
          parse: function(_context, token) {
            if (token.type === 20) {
              return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
              return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
          }
        };
        var time = {
          name: "time",
          parse: function(_context, value) {
            if (value.type === 15) {
              switch (value.unit.toLowerCase()) {
                case "s":
                  return 1e3 * value.number;
                case "ms":
                  return value.number;
              }
            }
            throw new Error("Unsupported time type");
          }
        };
        var opacity = {
          name: "opacity",
          initialValue: "1",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isNumberToken(token)) {
              return token.number;
            }
            return 1;
          }
        };
        var textDecorationColor = {
          name: "text-decoration-color",
          initialValue: "transparent",
          prefix: false,
          type: 3,
          format: "color"
        };
        var textDecorationLine = {
          name: "text-decoration-line",
          initialValue: "none",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
              switch (token.value) {
                case "underline":
                  return 1;
                case "overline":
                  return 2;
                case "line-through":
                  return 3;
                case "none":
                  return 4;
              }
              return 0;
            }).filter(function(line) {
              return line !== 0;
            });
          }
        };
        var fontFamily = {
          name: "font-family",
          initialValue: "",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
              switch (token.type) {
                case 20:
                case 0:
                  accumulator.push(token.value);
                  break;
                case 17:
                  accumulator.push(token.number.toString());
                  break;
                case 4:
                  results.push(accumulator.join(" "));
                  accumulator.length = 0;
                  break;
              }
            });
            if (accumulator.length) {
              results.push(accumulator.join(" "));
            }
            return results.map(function(result) {
              return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
          }
        };
        var fontSize = {
          name: "font-size",
          initialValue: "0",
          prefix: false,
          type: 3,
          format: "length"
        };
        var fontWeight = {
          name: "font-weight",
          initialValue: "normal",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isNumberToken(token)) {
              return token.number;
            }
            if (isIdentToken(token)) {
              switch (token.value) {
                case "bold":
                  return 700;
                case "normal":
                default:
                  return 400;
              }
            }
            return 400;
          }
        };
        var fontVariant = {
          name: "font-variant",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
              return token.value;
            });
          }
        };
        var FONT_STYLE;
        (function(FONT_STYLE2) {
          FONT_STYLE2["NORMAL"] = "normal";
          FONT_STYLE2["ITALIC"] = "italic";
          FONT_STYLE2["OBLIQUE"] = "oblique";
        })(FONT_STYLE || (FONT_STYLE = {}));
        var fontStyle = {
          name: "font-style",
          initialValue: "normal",
          prefix: false,
          type: 2,
          parse: function(_context, overflow2) {
            switch (overflow2) {
              case "oblique":
                return FONT_STYLE.OBLIQUE;
              case "italic":
                return FONT_STYLE.ITALIC;
              case "normal":
              default:
                return FONT_STYLE.NORMAL;
            }
          }
        };
        var contains = function(bit, value) {
          return (bit & value) !== 0;
        };
        var content = {
          name: "content",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return [];
            }
            return tokens;
          }
        };
        var counterIncrement = {
          name: "counter-increment",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return null;
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i4 = 0; i4 < filtered.length; i4++) {
              var counter = filtered[i4];
              var next2 = filtered[i4 + 1];
              if (counter.type === 20) {
                var increment = next2 && isNumberToken(next2) ? next2.number : 1;
                increments.push({ counter: counter.value, increment });
              }
            }
            return increments;
          }
        };
        var counterReset = {
          name: "counter-reset",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i4 = 0; i4 < filtered.length; i4++) {
              var counter = filtered[i4];
              var next2 = filtered[i4 + 1];
              if (isIdentToken(counter) && counter.value !== "none") {
                var reset2 = next2 && isNumberToken(next2) ? next2.number : 0;
                resets.push({ counter: counter.value, reset: reset2 });
              }
            }
            return resets;
          }
        };
        var duration = {
          name: "duration",
          initialValue: "0s",
          prefix: false,
          type: 1,
          parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
              return time.parse(context, token);
            });
          }
        };
        var quotes = {
          name: "quotes",
          initialValue: "none",
          prefix: true,
          type: 1,
          parse: function(_context, tokens) {
            if (tokens.length === 0) {
              return null;
            }
            var first = tokens[0];
            if (first.type === 20 && first.value === "none") {
              return null;
            }
            var quotes2 = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
              return null;
            }
            for (var i4 = 0; i4 < filtered.length; i4 += 2) {
              var open_1 = filtered[i4].value;
              var close_1 = filtered[i4 + 1].value;
              quotes2.push({ open: open_1, close: close_1 });
            }
            return quotes2;
          }
        };
        var getQuote = function(quotes2, depth, open2) {
          if (!quotes2) {
            return "";
          }
          var quote = quotes2[Math.min(depth, quotes2.length - 1)];
          if (!quote) {
            return "";
          }
          return open2 ? quote.open : quote.close;
        };
        var boxShadow = {
          name: "box-shadow",
          initialValue: "none",
          type: 1,
          prefix: false,
          parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
              return [];
            }
            return parseFunctionArgs(tokens).map(function(values) {
              var shadow = {
                color: 255,
                offsetX: ZERO_LENGTH,
                offsetY: ZERO_LENGTH,
                blur: ZERO_LENGTH,
                spread: ZERO_LENGTH,
                inset: false
              };
              var c4 = 0;
              for (var i4 = 0; i4 < values.length; i4++) {
                var token = values[i4];
                if (isIdentWithValue(token, "inset")) {
                  shadow.inset = true;
                } else if (isLength(token)) {
                  if (c4 === 0) {
                    shadow.offsetX = token;
                  } else if (c4 === 1) {
                    shadow.offsetY = token;
                  } else if (c4 === 2) {
                    shadow.blur = token;
                  } else {
                    shadow.spread = token;
                  }
                  c4++;
                } else {
                  shadow.color = color$1.parse(context, token);
                }
              }
              return shadow;
            });
          }
        };
        var PAINT_ORDER_LAYER;
        (function(PAINT_ORDER_LAYER2) {
          PAINT_ORDER_LAYER2[PAINT_ORDER_LAYER2["FILL"] = 0] = "FILL";
          PAINT_ORDER_LAYER2[PAINT_ORDER_LAYER2["STROKE"] = 1] = "STROKE";
          PAINT_ORDER_LAYER2[PAINT_ORDER_LAYER2["MARKERS"] = 2] = "MARKERS";
        })(PAINT_ORDER_LAYER || (PAINT_ORDER_LAYER = {}));
        var paintOrder = {
          name: "paint-order",
          initialValue: "normal",
          prefix: false,
          type: 1,
          parse: function(_context, tokens) {
            var DEFAULT_VALUE2 = [PAINT_ORDER_LAYER.FILL, PAINT_ORDER_LAYER.STROKE, PAINT_ORDER_LAYER.MARKERS];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
              switch (token.value) {
                case "stroke":
                  layers.push(PAINT_ORDER_LAYER.STROKE);
                  break;
                case "fill":
                  layers.push(PAINT_ORDER_LAYER.FILL);
                  break;
                case "markers":
                  layers.push(PAINT_ORDER_LAYER.MARKERS);
                  break;
              }
            });
            DEFAULT_VALUE2.forEach(function(value) {
              if (layers.indexOf(value) === -1) {
                layers.push(value);
              }
            });
            return layers;
          }
        };
        var webkitTextStrokeColor = {
          name: "-webkit-text-stroke-color",
          initialValue: "currentcolor",
          prefix: false,
          type: 3,
          format: "color"
        };
        var webkitTextStrokeWidth = {
          name: "-webkit-text-stroke-width",
          initialValue: "0",
          type: 0,
          prefix: false,
          parse: function(_context, token) {
            if (isDimensionToken(token)) {
              return token.number;
            }
            return 0;
          }
        };
        var CSSParsedDeclaration = function() {
          function CSSParsedDeclaration2(context, declaration) {
            var _a3, _b2;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a3 = declaration.textDecorationColor) !== null && _a3 !== void 0 ? _a3 : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b2 = declaration.textDecorationLine) !== null && _b2 !== void 0 ? _b2 : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
          }
          CSSParsedDeclaration2.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
          };
          CSSParsedDeclaration2.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
          };
          CSSParsedDeclaration2.prototype.isTransformed = function() {
            return this.transform !== null;
          };
          CSSParsedDeclaration2.prototype.isPositioned = function() {
            return this.position !== POSITION.STATIC;
          };
          CSSParsedDeclaration2.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
          };
          CSSParsedDeclaration2.prototype.isFloating = function() {
            return this.float !== FLOAT.NONE;
          };
          CSSParsedDeclaration2.prototype.isInlineLevel = function() {
            return contains(this.display, 4) || contains(this.display, 33554432) || contains(this.display, 268435456) || contains(this.display, 536870912) || contains(this.display, 67108864) || contains(this.display, 134217728);
          };
          return CSSParsedDeclaration2;
        }();
        var CSSParsedPseudoDeclaration = function() {
          function CSSParsedPseudoDeclaration2(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
          }
          return CSSParsedPseudoDeclaration2;
        }();
        var CSSParsedCounterDeclaration = function() {
          function CSSParsedCounterDeclaration2(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
          }
          return CSSParsedCounterDeclaration2;
        }();
        var parse = function(context, descriptor, style) {
          var tokenizer = new Tokenizer();
          var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
          tokenizer.write(value);
          var parser = new Parser2(tokenizer.read());
          switch (descriptor.type) {
            case 2:
              var token = parser.parseComponentValue();
              return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0:
              return descriptor.parse(context, parser.parseComponentValue());
            case 1:
              return descriptor.parse(context, parser.parseComponentValues());
            case 4:
              return parser.parseComponentValue();
            case 3:
              switch (descriptor.format) {
                case "angle":
                  return angle.parse(context, parser.parseComponentValue());
                case "color":
                  return color$1.parse(context, parser.parseComponentValue());
                case "image":
                  return image.parse(context, parser.parseComponentValue());
                case "length":
                  var length_1 = parser.parseComponentValue();
                  return isLength(length_1) ? length_1 : ZERO_LENGTH;
                case "length-percentage":
                  var value_1 = parser.parseComponentValue();
                  return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                case "time":
                  return time.parse(context, parser.parseComponentValue());
              }
              break;
          }
        };
        var elementDebuggerAttribute = "data-html2canvas-debug";
        var getElementDebugType = function(element) {
          var attribute = element.getAttribute(elementDebuggerAttribute);
          switch (attribute) {
            case "all":
              return 1;
            case "clone":
              return 2;
            case "parse":
              return 3;
            case "render":
              return 4;
            default:
              return 0;
          }
        };
        var isDebugging = function(element, type) {
          var elementType = getElementDebugType(element);
          return elementType === 1 || type === elementType;
        };
        var ElementContainer = function() {
          function ElementContainer2(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3)) {
              debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
              if (this.styles.animationDuration.some(function(duration2) {
                return duration2 > 0;
              })) {
                element.style.animationDuration = "0s";
              }
              if (this.styles.transform !== null) {
                element.style.transform = "none";
              }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4)) {
              this.flags |= 16;
            }
          }
          return ElementContainer2;
        }();
        var base64 = "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";
        var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
          lookup$1[chars$1.charCodeAt(i$1)] = i$1;
        }
        var decode = function(base642) {
          var bufferLength = base642.length * 0.75, len = base642.length, i4, p4 = 0, encoded1, encoded2, encoded3, encoded4;
          if (base642[base642.length - 1] === "=") {
            bufferLength--;
            if (base642[base642.length - 2] === "=") {
              bufferLength--;
            }
          }
          var buffer2 = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
          var bytes = Array.isArray(buffer2) ? buffer2 : new Uint8Array(buffer2);
          for (i4 = 0; i4 < len; i4 += 4) {
            encoded1 = lookup$1[base642.charCodeAt(i4)];
            encoded2 = lookup$1[base642.charCodeAt(i4 + 1)];
            encoded3 = lookup$1[base642.charCodeAt(i4 + 2)];
            encoded4 = lookup$1[base642.charCodeAt(i4 + 3)];
            bytes[p4++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p4++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p4++] = (encoded3 & 3) << 6 | encoded4 & 63;
          }
          return buffer2;
        };
        var polyUint16Array = function(buffer2) {
          var length = buffer2.length;
          var bytes = [];
          for (var i4 = 0; i4 < length; i4 += 2) {
            bytes.push(buffer2[i4 + 1] << 8 | buffer2[i4]);
          }
          return bytes;
        };
        var polyUint32Array = function(buffer2) {
          var length = buffer2.length;
          var bytes = [];
          for (var i4 = 0; i4 < length; i4 += 4) {
            bytes.push(buffer2[i4 + 3] << 24 | buffer2[i4 + 2] << 16 | buffer2[i4 + 1] << 8 | buffer2[i4]);
          }
          return bytes;
        };
        var UTRIE2_SHIFT_2 = 5;
        var UTRIE2_SHIFT_1 = 6 + 5;
        var UTRIE2_INDEX_SHIFT = 2;
        var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
        var UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> UTRIE2_SHIFT_2;
        var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
        var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> UTRIE2_SHIFT_2;
        var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 2048 >> 6;
        var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> UTRIE2_SHIFT_1;
        var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
        var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
        var slice16 = function(view, start2, end) {
          if (view.slice) {
            return view.slice(start2, end);
          }
          return new Uint16Array(Array.prototype.slice.call(view, start2, end));
        };
        var slice32 = function(view, start2, end) {
          if (view.slice) {
            return view.slice(start2, end);
          }
          return new Uint32Array(Array.prototype.slice.call(view, start2, end));
        };
        var createTrieFromBase64 = function(base642, _byteLength) {
          var buffer2 = decode(base642);
          var view32 = Array.isArray(buffer2) ? polyUint32Array(buffer2) : new Uint32Array(buffer2);
          var view16 = Array.isArray(buffer2) ? polyUint16Array(buffer2) : new Uint16Array(buffer2);
          var headerLength = 24;
          var index3 = slice16(view16, headerLength / 2, view32[4] / 2);
          var data2 = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
          return new Trie(view32[0], view32[1], view32[2], view32[3], index3, data2);
        };
        var Trie = function() {
          function Trie2(initialValue, errorValue, highStart, highValueIndex, index3, data2) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index3;
            this.data = data2;
          }
          Trie2.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
              if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
                ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
              }
              if (codePoint <= 65535) {
                ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> UTRIE2_SHIFT_2)];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
              }
              if (codePoint < this.highStart) {
                ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                ix = this.index[ix];
                ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                ix = this.index[ix];
                ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                return this.data[ix];
              }
              if (codePoint <= 1114111) {
                return this.data[this.highValueIndex];
              }
            }
            return this.errorValue;
          };
          return Trie2;
        }();
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i3 = 0; i3 < chars.length; i3++) {
          lookup[chars.charCodeAt(i3)] = i3;
        }
        var Prepend = 1;
        var CR = 2;
        var LF = 3;
        var Control = 4;
        var Extend = 5;
        var SpacingMark = 7;
        var L2 = 8;
        var V2 = 9;
        var T3 = 10;
        var LV = 11;
        var LVT = 12;
        var ZWJ = 13;
        var Extended_Pictographic = 14;
        var RI = 15;
        var toCodePoints = function(str) {
          var codePoints = [];
          var i4 = 0;
          var length = str.length;
          while (i4 < length) {
            var value = str.charCodeAt(i4++);
            if (value >= 55296 && value <= 56319 && i4 < length) {
              var extra = str.charCodeAt(i4++);
              if ((extra & 64512) === 56320) {
                codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
              } else {
                codePoints.push(value);
                i4--;
              }
            } else {
              codePoints.push(value);
            }
          }
          return codePoints;
        };
        var fromCodePoint = function() {
          var codePoints = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
          }
          if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
          }
          var length = codePoints.length;
          if (!length) {
            return "";
          }
          var codeUnits = [];
          var index3 = -1;
          var result = "";
          while (++index3 < length) {
            var codePoint = codePoints[index3];
            if (codePoint <= 65535) {
              codeUnits.push(codePoint);
            } else {
              codePoint -= 65536;
              codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
            }
            if (index3 + 1 === length || codeUnits.length > 16384) {
              result += String.fromCharCode.apply(String, codeUnits);
              codeUnits.length = 0;
            }
          }
          return result;
        };
        var UnicodeTrie = createTrieFromBase64(base64);
        var BREAK_NOT_ALLOWED = "\xD7";
        var BREAK_ALLOWED = "\xF7";
        var codePointToClass = function(codePoint) {
          return UnicodeTrie.get(codePoint);
        };
        var _graphemeBreakAtIndex = function(_codePoints, classTypes, index3) {
          var prevIndex = index3 - 2;
          var prev2 = classTypes[prevIndex];
          var current = classTypes[index3 - 1];
          var next2 = classTypes[index3];
          if (current === CR && next2 === LF) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
          }
          if (next2 === CR || next2 === LF || next2 === Control) {
            return BREAK_ALLOWED;
          }
          if (current === L2 && [L2, V2, LV, LVT].indexOf(next2) !== -1) {
            return BREAK_NOT_ALLOWED;
          }
          if ((current === LV || current === V2) && (next2 === V2 || next2 === T3)) {
            return BREAK_NOT_ALLOWED;
          }
          if ((current === LVT || current === T3) && next2 === T3) {
            return BREAK_NOT_ALLOWED;
          }
          if (next2 === ZWJ || next2 === Extend) {
            return BREAK_NOT_ALLOWED;
          }
          if (next2 === SpacingMark) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
          }
          if (current === ZWJ && next2 === Extended_Pictographic) {
            while (prev2 === Extend) {
              prev2 = classTypes[--prevIndex];
            }
            if (prev2 === Extended_Pictographic) {
              return BREAK_NOT_ALLOWED;
            }
          }
          if (current === RI && next2 === RI) {
            var countRI = 0;
            while (prev2 === RI) {
              countRI++;
              prev2 = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
              return BREAK_NOT_ALLOWED;
            }
          }
          return BREAK_ALLOWED;
        };
        var GraphemeBreaker = function(str) {
          var codePoints = toCodePoints(str);
          var length = codePoints.length;
          var index3 = 0;
          var lastEnd = 0;
          var classTypes = codePoints.map(codePointToClass);
          return {
            next: function() {
              if (index3 >= length) {
                return { done: true, value: null };
              }
              var graphemeBreak = BREAK_NOT_ALLOWED;
              while (index3 < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index3)) === BREAK_NOT_ALLOWED) {
              }
              if (graphemeBreak !== BREAK_NOT_ALLOWED || index3 === length) {
                var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index3));
                lastEnd = index3;
                return { value, done: false };
              }
              return { done: true, value: null };
            }
          };
        };
        var splitGraphemes = function(str) {
          var breaker = GraphemeBreaker(str);
          var graphemes = [];
          var bk;
          while (!(bk = breaker.next()).done) {
            if (bk.value) {
              graphemes.push(bk.value.slice());
            }
          }
          return graphemes;
        };
        var testRangeBounds = function(document3) {
          var TEST_HEIGHT = 123;
          if (document3.createRange) {
            var range = document3.createRange();
            if (range.getBoundingClientRect) {
              var testElement = document3.createElement("boundtest");
              testElement.style.height = TEST_HEIGHT + "px";
              testElement.style.display = "block";
              document3.body.appendChild(testElement);
              range.selectNode(testElement);
              var rangeBounds = range.getBoundingClientRect();
              var rangeHeight = Math.round(rangeBounds.height);
              document3.body.removeChild(testElement);
              if (rangeHeight === TEST_HEIGHT) {
                return true;
              }
            }
          }
          return false;
        };
        var testIOSLineBreak = function(document3) {
          var testElement = document3.createElement("boundtest");
          testElement.style.width = "50px";
          testElement.style.display = "block";
          testElement.style.fontSize = "12px";
          testElement.style.letterSpacing = "0px";
          testElement.style.wordSpacing = "0px";
          document3.body.appendChild(testElement);
          var range = document3.createRange();
          testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
          var node2 = testElement.firstChild;
          var textList = toCodePoints$1(node2.data).map(function(i4) {
            return fromCodePoint$1(i4);
          });
          var offset2 = 0;
          var prev2 = {};
          var supports = textList.every(function(text2, i4) {
            range.setStart(node2, offset2);
            range.setEnd(node2, offset2 + text2.length);
            var rect = range.getBoundingClientRect();
            offset2 += text2.length;
            var boundAhead = rect.x > prev2.x || rect.y > prev2.y;
            prev2 = rect;
            if (i4 === 0) {
              return true;
            }
            return boundAhead;
          });
          document3.body.removeChild(testElement);
          return supports;
        };
        var testCORS = function() {
          return typeof new Image().crossOrigin !== "undefined";
        };
        var testResponseType = function() {
          return typeof new XMLHttpRequest().responseType === "string";
        };
        var testSVG = function(document3) {
          var img = new Image();
          var canvas = document3.createElement("canvas");
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            return false;
          }
          img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
          try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
          } catch (e3) {
            return false;
          }
          return true;
        };
        var isGreenPixel = function(data2) {
          return data2[0] === 0 && data2[1] === 255 && data2[2] === 0 && data2[3] === 255;
        };
        var testForeignObject = function(document3) {
          var canvas = document3.createElement("canvas");
          var size3 = 100;
          canvas.width = size3;
          canvas.height = size3;
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            return Promise.reject(false);
          }
          ctx.fillStyle = "rgb(0, 255, 0)";
          ctx.fillRect(0, 0, size3, size3);
          var img = new Image();
          var greenImageSrc = canvas.toDataURL();
          img.src = greenImageSrc;
          var svg = createForeignObjectSVG(size3, size3, 0, 0, img);
          ctx.fillStyle = "red";
          ctx.fillRect(0, 0, size3, size3);
          return loadSerializedSVG$1(svg).then(function(img2) {
            ctx.drawImage(img2, 0, 0);
            var data2 = ctx.getImageData(0, 0, size3, size3).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size3, size3);
            var node2 = document3.createElement("div");
            node2.style.backgroundImage = "url(" + greenImageSrc + ")";
            node2.style.height = size3 + "px";
            return isGreenPixel(data2) ? loadSerializedSVG$1(createForeignObjectSVG(size3, size3, 0, 0, node2)) : Promise.reject(false);
          }).then(function(img2) {
            ctx.drawImage(img2, 0, 0);
            return isGreenPixel(ctx.getImageData(0, 0, size3, size3).data);
          }).catch(function() {
            return false;
          });
        };
        var createForeignObjectSVG = function(width, height, x2, y3, node2) {
          var xmlns = "http://www.w3.org/2000/svg";
          var svg = document.createElementNS(xmlns, "svg");
          var foreignObject = document.createElementNS(xmlns, "foreignObject");
          svg.setAttributeNS(null, "width", width.toString());
          svg.setAttributeNS(null, "height", height.toString());
          foreignObject.setAttributeNS(null, "width", "100%");
          foreignObject.setAttributeNS(null, "height", "100%");
          foreignObject.setAttributeNS(null, "x", x2.toString());
          foreignObject.setAttributeNS(null, "y", y3.toString());
          foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
          svg.appendChild(foreignObject);
          foreignObject.appendChild(node2);
          return svg;
        };
        var loadSerializedSVG$1 = function(svg) {
          return new Promise(function(resolve3, reject2) {
            var img = new Image();
            img.onload = function() {
              return resolve3(img);
            };
            img.onerror = reject2;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
          });
        };
        var FEATURES = {
          get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", { value });
            return value;
          },
          get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", { value });
            return value;
          },
          get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", { value });
            return value;
          },
          get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", { value });
            return value;
          },
          get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", { value });
            return value;
          },
          get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", { value });
            return value;
          },
          get SUPPORT_CORS_XHR() {
            var value = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", { value });
            return value;
          }
        };
        var TextBounds = function() {
          function TextBounds2(text2, bounds) {
            this.text = text2;
            this.bounds = bounds;
          }
          return TextBounds2;
        }();
        var parseTextBounds = function(context, value, styles2, node2) {
          var textList = breakText(value, styles2);
          var textBounds = [];
          var offset2 = 0;
          textList.forEach(function(text2) {
            if (styles2.textDecorationLine.length || text2.trim().length > 0) {
              if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                if (!FEATURES.SUPPORT_WORD_BREAKING) {
                  textBounds.push(new TextBounds(text2, Bounds.fromDOMRectList(context, createRange(node2, offset2, text2.length).getClientRects())));
                } else {
                  textBounds.push(new TextBounds(text2, getRangeBounds(context, node2, offset2, text2.length)));
                }
              } else {
                var replacementNode = node2.splitText(text2.length);
                textBounds.push(new TextBounds(text2, getWrapperBounds(context, node2)));
                node2 = replacementNode;
              }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
              node2 = node2.splitText(text2.length);
            }
            offset2 += text2.length;
          });
          return textBounds;
        };
        var getWrapperBounds = function(context, node2) {
          var ownerDocument = node2.ownerDocument;
          if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node2.cloneNode(true));
            var parentNode = node2.parentNode;
            if (parentNode) {
              parentNode.replaceChild(wrapper, node2);
              var bounds = parseBounds(context, wrapper);
              if (wrapper.firstChild) {
                parentNode.replaceChild(wrapper.firstChild, wrapper);
              }
              return bounds;
            }
          }
          return Bounds.EMPTY;
        };
        var createRange = function(node2, offset2, length) {
          var ownerDocument = node2.ownerDocument;
          if (!ownerDocument) {
            throw new Error("Node has no owner document");
          }
          var range = ownerDocument.createRange();
          range.setStart(node2, offset2);
          range.setEnd(node2, offset2 + length);
          return range;
        };
        var getRangeBounds = function(context, node2, offset2, length) {
          return Bounds.fromClientRect(context, createRange(node2, offset2, length).getBoundingClientRect());
        };
        var breakText = function(value, styles2) {
          return styles2.letterSpacing !== 0 ? splitGraphemes(value) : breakWords(value, styles2);
        };
        var wordSeparators = [32, 160, 4961, 65792, 65793, 4153, 4241];
        var breakWords = function(str, styles2) {
          var breaker = LineBreaker(str, {
            lineBreak: styles2.lineBreak,
            wordBreak: styles2.overflowWrap === "break-word" ? "break-word" : styles2.wordBreak
          });
          var words = [];
          var bk;
          var _loop_1 = function() {
            if (bk.value) {
              var value = bk.value.slice();
              var codePoints = toCodePoints$1(value);
              var word_1 = "";
              codePoints.forEach(function(codePoint) {
                if (wordSeparators.indexOf(codePoint) === -1) {
                  word_1 += fromCodePoint$1(codePoint);
                } else {
                  if (word_1.length) {
                    words.push(word_1);
                  }
                  words.push(fromCodePoint$1(codePoint));
                  word_1 = "";
                }
              });
              if (word_1.length) {
                words.push(word_1);
              }
            }
          };
          while (!(bk = breaker.next()).done) {
            _loop_1();
          }
          return words;
        };
        var TextContainer = function() {
          function TextContainer2(context, node2, styles2) {
            this.text = transform2(node2.data, styles2.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles2, node2);
          }
          return TextContainer2;
        }();
        var transform2 = function(text2, transform3) {
          switch (transform3) {
            case TEXT_TRANSFORM.LOWERCASE:
              return text2.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
              return text2.replace(CAPITALIZE, capitalize4);
            case TEXT_TRANSFORM.UPPERCASE:
              return text2.toUpperCase();
            default:
              return text2;
          }
        };
        var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
        var capitalize4 = function(m4, p1, p22) {
          if (m4.length > 0) {
            return p1 + p22.toUpperCase();
          }
          return m4;
        };
        var ImageElementContainer = function(_super) {
          __extends(ImageElementContainer2, _super);
          function ImageElementContainer2(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
          }
          return ImageElementContainer2;
        }(ElementContainer);
        var CanvasElementContainer = function(_super) {
          __extends(CanvasElementContainer2, _super);
          function CanvasElementContainer2(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
          }
          return CanvasElementContainer2;
        }(ElementContainer);
        var SVGElementContainer = function(_super) {
          __extends(SVGElementContainer2, _super);
          function SVGElementContainer2(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s3 = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s3.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
          }
          return SVGElementContainer2;
        }(ElementContainer);
        var LIElementContainer = function(_super) {
          __extends(LIElementContainer2, _super);
          function LIElementContainer2(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
          }
          return LIElementContainer2;
        }(ElementContainer);
        var OLElementContainer = function(_super) {
          __extends(OLElementContainer2, _super);
          function OLElementContainer2(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
          }
          return OLElementContainer2;
        }(ElementContainer);
        var CHECKBOX_BORDER_RADIUS = [
          {
            type: 15,
            flags: 0,
            unit: "px",
            number: 3
          }
        ];
        var RADIO_BORDER_RADIUS = [
          {
            type: 16,
            flags: 0,
            number: 50
          }
        ];
        var reformatInputBounds = function(bounds) {
          if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
          } else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
          }
          return bounds;
        };
        var getInputValue2 = function(node2) {
          var value = node2.type === PASSWORD ? new Array(node2.value.length + 1).join("\u2022") : node2.value;
          return value.length === 0 ? node2.placeholder || "" : value;
        };
        var CHECKBOX = "checkbox";
        var RADIO = "radio";
        var PASSWORD = "password";
        var INPUT_COLOR = 707406591;
        var InputElementContainer = function(_super) {
          __extends(InputElementContainer2, _super);
          function InputElementContainer2(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue2(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
              _this.styles.backgroundColor = 3739148031;
              _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 2779096575;
              _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
              _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = BORDER_STYLE.SOLID;
              _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
              _this.styles.backgroundOrigin = [0];
              _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
              case CHECKBOX:
                _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                break;
              case RADIO:
                _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                break;
            }
            return _this;
          }
          return InputElementContainer2;
        }(ElementContainer);
        var SelectElementContainer = function(_super) {
          __extends(SelectElementContainer2, _super);
          function SelectElementContainer2(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
          }
          return SelectElementContainer2;
        }(ElementContainer);
        var TextareaElementContainer = function(_super) {
          __extends(TextareaElementContainer2, _super);
          function TextareaElementContainer2(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
          }
          return TextareaElementContainer2;
        }(ElementContainer);
        var IFrameElementContainer = function(_super) {
          __extends(IFrameElementContainer2, _super);
          function IFrameElementContainer2(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
              if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
              }
            } catch (e3) {
            }
            return _this;
          }
          return IFrameElementContainer2;
        }(ElementContainer);
        var LIST_OWNERS = ["OL", "UL", "MENU"];
        var parseNodeTree = function(context, node2, parent2, root) {
          for (var childNode = node2.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
              parent2.textNodes.push(new TextContainer(context, childNode, parent2.styles));
            } else if (isElementNode(childNode)) {
              if (isSlotElement(childNode) && childNode.assignedNodes) {
                childNode.assignedNodes().forEach(function(childNode2) {
                  return parseNodeTree(context, childNode2, parent2, root);
                });
              } else {
                var container = createContainer(context, childNode);
                if (container.styles.isVisible()) {
                  if (createsRealStackingContext(childNode, container, root)) {
                    container.flags |= 4;
                  } else if (createsStackingContext(container.styles)) {
                    container.flags |= 2;
                  }
                  if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                    container.flags |= 8;
                  }
                  parent2.elements.push(container);
                  childNode.slot;
                  if (childNode.shadowRoot) {
                    parseNodeTree(context, childNode.shadowRoot, container, root);
                  } else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                    parseNodeTree(context, childNode, container, root);
                  }
                }
              }
            }
          }
        };
        var createContainer = function(context, element) {
          if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
          }
          if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
          }
          if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
          }
          if (isLIElement(element)) {
            return new LIElementContainer(context, element);
          }
          if (isOLElement(element)) {
            return new OLElementContainer(context, element);
          }
          if (isInputElement(element)) {
            return new InputElementContainer(context, element);
          }
          if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
          }
          if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
          }
          if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
          }
          return new ElementContainer(context, element);
        };
        var parseTree = function(context, element) {
          var container = createContainer(context, element);
          container.flags |= 4;
          parseNodeTree(context, element, container, container);
          return container;
        };
        var createsRealStackingContext = function(node2, container, root) {
          return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node2) && root.styles.isTransparent();
        };
        var createsStackingContext = function(styles2) {
          return styles2.isPositioned() || styles2.isFloating();
        };
        var isTextNode = function(node2) {
          return node2.nodeType === Node.TEXT_NODE;
        };
        var isElementNode = function(node2) {
          return node2.nodeType === Node.ELEMENT_NODE;
        };
        var isHTMLElementNode = function(node2) {
          return isElementNode(node2) && typeof node2.style !== "undefined" && !isSVGElementNode(node2);
        };
        var isSVGElementNode = function(element) {
          return typeof element.className === "object";
        };
        var isLIElement = function(node2) {
          return node2.tagName === "LI";
        };
        var isOLElement = function(node2) {
          return node2.tagName === "OL";
        };
        var isInputElement = function(node2) {
          return node2.tagName === "INPUT";
        };
        var isHTMLElement = function(node2) {
          return node2.tagName === "HTML";
        };
        var isSVGElement = function(node2) {
          return node2.tagName === "svg";
        };
        var isBodyElement = function(node2) {
          return node2.tagName === "BODY";
        };
        var isCanvasElement = function(node2) {
          return node2.tagName === "CANVAS";
        };
        var isImageElement = function(node2) {
          return node2.tagName === "IMG";
        };
        var isIFrameElement = function(node2) {
          return node2.tagName === "IFRAME";
        };
        var isStyleElement = function(node2) {
          return node2.tagName === "STYLE";
        };
        var isScriptElement = function(node2) {
          return node2.tagName === "SCRIPT";
        };
        var isTextareaElement = function(node2) {
          return node2.tagName === "TEXTAREA";
        };
        var isSelectElement = function(node2) {
          return node2.tagName === "SELECT";
        };
        var isSlotElement = function(node2) {
          return node2.tagName === "SLOT";
        };
        var CounterState = function() {
          function CounterState2() {
            this.counters = {};
          }
          CounterState2.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
              return counter[counter.length - 1];
            }
            return 1;
          };
          CounterState2.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
          };
          CounterState2.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
              return _this.counters[counter].pop();
            });
          };
          CounterState2.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement2 = style.counterIncrement;
            var counterReset2 = style.counterReset;
            var canReset = true;
            if (counterIncrement2 !== null) {
              counterIncrement2.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                  canReset = false;
                  if (!counter.length) {
                    counter.push(1);
                  }
                  counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
              });
            }
            var counterNames = [];
            if (canReset) {
              counterReset2.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) {
                  counter = _this.counters[entry.counter] = [];
                }
                counter.push(entry.reset);
              });
            }
            return counterNames;
          };
          return CounterState2;
        }();
        var ROMAN_UPPER = {
          integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
          values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
        };
        var ARMENIAN = {
          integers: [
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
          ]
        };
        var HEBREW = {
          integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
          ]
        };
        var GEORGIAN = {
          integers: [
            1e4,
            9e3,
            8e3,
            7e3,
            6e3,
            5e3,
            4e3,
            3e3,
            2e3,
            1e3,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
          ],
          values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
          ]
        };
        var createAdditiveCounter = function(value, min5, max3, symbols, fallback, suffix) {
          if (value < min5 || value > max3) {
            return createCounterText(value, fallback, suffix.length > 0);
          }
          return symbols.integers.reduce(function(string, integer, index3) {
            while (value >= integer) {
              value -= integer;
              string += symbols.values[index3];
            }
            return string;
          }, "") + suffix;
        };
        var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric4, resolver) {
          var string = "";
          do {
            if (!isNumeric4) {
              value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
          } while (value * codePointRangeLength >= codePointRangeLength);
          return string;
        };
        var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric4, suffix) {
          var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
          return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric4, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
          }) + suffix);
        };
        var createCounterStyleFromSymbols = function(value, symbols, suffix) {
          if (suffix === void 0) {
            suffix = ". ";
          }
          var codePointRangeLength = symbols.length;
          return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
          }) + suffix;
        };
        var CJK_ZEROS = 1 << 0;
        var CJK_TEN_COEFFICIENTS = 1 << 1;
        var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
        var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
        var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
          if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
          }
          var tmp = Math.abs(value);
          var string = suffix;
          if (tmp === 0) {
            return numbers[0] + string;
          }
          for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") {
              string = numbers[coefficient] + string;
            } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) {
              string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            } else if (coefficient === 1 && digit > 0) {
              string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
          }
          return (value < 0 ? negativeSign : "") + string;
        };
        var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
        var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
        var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
        var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
        var createCounterText = function(value, type, appendSuffix) {
          var defaultSuffix = appendSuffix ? ". " : "";
          var cjkSuffix = appendSuffix ? "\u3001" : "";
          var koreanSuffix = appendSuffix ? ", " : "";
          var spaceSuffix = appendSuffix ? " " : "";
          switch (type) {
            case LIST_STYLE_TYPE.DISC:
              return "\u2022" + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
              return "\u25E6" + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
              return "\u25FE" + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
              var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
              return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
              return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
              return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
              return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
              return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
              return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
              return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
              return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
              return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
              return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
              return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
              return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
              return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
              return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
              return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
              return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
              return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
              return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
              return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
              return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
              return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
              return createCounterStyleFromRange(value, 2406, 2415, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
              return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
              return createCounterStyleFromRange(value, 2790, 2799, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
              return createCounterStyleFromRange(value, 2662, 2671, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
              return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
              return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
              return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case LIST_STYLE_TYPE.KANNADA:
              return createCounterStyleFromRange(value, 3302, 3311, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
              return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
              return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
              return createCounterStyleFromRange(value, 3792, 3801, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
              return createCounterStyleFromRange(value, 6160, 6169, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
              return createCounterStyleFromRange(value, 4160, 4169, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
              return createCounterStyleFromRange(value, 2918, 2927, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
              return createCounterStyleFromRange(value, 1776, 1785, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
              return createCounterStyleFromRange(value, 3046, 3055, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
              return createCounterStyleFromRange(value, 3174, 3183, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
              return createCounterStyleFromRange(value, 3664, 3673, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
              return createCounterStyleFromRange(value, 3872, 3881, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
              return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
          }
        };
        var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
        var DocumentCloner = function() {
          function DocumentCloner2(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
              throw new Error("Cloned element does not have an owner document");
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
          }
          DocumentCloner2.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
              return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            var iframeLoad = iframeLoader(iframe).then(function() {
              return __awaiter(_this, void 0, void 0, function() {
                var onclone, referenceElement;
                return __generator(this, function(_a3) {
                  switch (_a3.label) {
                    case 0:
                      this.scrolledElements.forEach(restoreNodeScroll);
                      if (cloneWindow) {
                        cloneWindow.scrollTo(windowSize.left, windowSize.top);
                        if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                          this.context.logger.warn("Unable to restore scroll position for cloned document");
                          this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                        }
                      }
                      onclone = this.options.onclone;
                      referenceElement = this.clonedReferenceElement;
                      if (typeof referenceElement === "undefined") {
                        return [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                      }
                      if (!(documentClone.fonts && documentClone.fonts.ready))
                        return [3, 2];
                      return [4, documentClone.fonts.ready];
                    case 1:
                      _a3.sent();
                      _a3.label = 2;
                    case 2:
                      if (!/(AppleWebKit)/g.test(navigator.userAgent))
                        return [3, 4];
                      return [4, imagesReady(documentClone)];
                    case 3:
                      _a3.sent();
                      _a3.label = 4;
                    case 4:
                      if (typeof onclone === "function") {
                        return [2, Promise.resolve().then(function() {
                          return onclone(documentClone, referenceElement);
                        }).then(function() {
                          return iframe;
                        })];
                      }
                      return [2, iframe];
                  }
                });
              });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
          };
          DocumentCloner2.prototype.createElementClone = function(node2) {
            if (isDebugging(node2, 2)) {
              debugger;
            }
            if (isCanvasElement(node2)) {
              return this.createCanvasClone(node2);
            }
            if (isStyleElement(node2)) {
              return this.createStyleClone(node2);
            }
            var clone2 = node2.cloneNode(false);
            if (isImageElement(clone2)) {
              if (isImageElement(node2) && node2.currentSrc && node2.currentSrc !== node2.src) {
                clone2.src = node2.currentSrc;
                clone2.srcset = "";
              }
              if (clone2.loading === "lazy") {
                clone2.loading = "eager";
              }
            }
            return clone2;
          };
          DocumentCloner2.prototype.createStyleClone = function(node2) {
            try {
              var sheet = node2.sheet;
              if (sheet && sheet.cssRules) {
                var css2 = [].slice.call(sheet.cssRules, 0).reduce(function(css3, rule) {
                  if (rule && typeof rule.cssText === "string") {
                    return css3 + rule.cssText;
                  }
                  return css3;
                }, "");
                var style = node2.cloneNode(false);
                style.textContent = css2;
                return style;
              }
            } catch (e3) {
              this.context.logger.error("Unable to access cssRules property", e3);
              if (e3.name !== "SecurityError") {
                throw e3;
              }
            }
            return node2.cloneNode(false);
          };
          DocumentCloner2.prototype.createCanvasClone = function(canvas) {
            var _a3;
            if (this.options.inlineImages && canvas.ownerDocument) {
              var img = canvas.ownerDocument.createElement("img");
              try {
                img.src = canvas.toDataURL();
                return img;
              } catch (e3) {
                this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
              }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
              clonedCanvas.width = canvas.width;
              clonedCanvas.height = canvas.height;
              var ctx = canvas.getContext("2d");
              var clonedCtx = clonedCanvas.getContext("2d");
              if (clonedCtx) {
                if (!this.options.allowTaint && ctx) {
                  clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                } else {
                  var gl = (_a3 = canvas.getContext("webgl2")) !== null && _a3 !== void 0 ? _a3 : canvas.getContext("webgl");
                  if (gl) {
                    var attribs = gl.getContextAttributes();
                    if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                      this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                    }
                  }
                  clonedCtx.drawImage(canvas, 0, 0);
                }
              }
              return clonedCanvas;
            } catch (e3) {
              this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
          };
          DocumentCloner2.prototype.cloneNode = function(node2) {
            if (isTextNode(node2)) {
              return document.createTextNode(node2.data);
            }
            if (!node2.ownerDocument) {
              return node2.cloneNode(false);
            }
            var window2 = node2.ownerDocument.defaultView;
            if (window2 && isElementNode(node2) && (isHTMLElementNode(node2) || isSVGElementNode(node2))) {
              var clone2 = this.createElementClone(node2);
              clone2.style.transitionProperty = "none";
              var style = window2.getComputedStyle(node2);
              var styleBefore = window2.getComputedStyle(node2, ":before");
              var styleAfter = window2.getComputedStyle(node2, ":after");
              if (this.referenceElement === node2 && isHTMLElementNode(clone2)) {
                this.clonedReferenceElement = clone2;
              }
              if (isBodyElement(clone2)) {
                createPseudoHideStyles(clone2);
              }
              var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
              var before = this.resolvePseudoContent(node2, clone2, styleBefore, PseudoElementType.BEFORE);
              for (var child = node2.firstChild; child; child = child.nextSibling) {
                if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                  if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone2.appendChild(this.cloneNode(child));
                  }
                }
              }
              if (before) {
                clone2.insertBefore(before, clone2.firstChild);
              }
              var after = this.resolvePseudoContent(node2, clone2, styleAfter, PseudoElementType.AFTER);
              if (after) {
                clone2.appendChild(after);
              }
              this.counters.pop(counters);
              if (style && (this.options.copyStyles || isSVGElementNode(node2)) && !isIFrameElement(node2)) {
                copyCSSStyles(style, clone2);
              }
              if (node2.scrollTop !== 0 || node2.scrollLeft !== 0) {
                this.scrolledElements.push([clone2, node2.scrollLeft, node2.scrollTop]);
              }
              if ((isTextareaElement(node2) || isSelectElement(node2)) && (isTextareaElement(clone2) || isSelectElement(clone2))) {
                clone2.value = node2.value;
              }
              return clone2;
            }
            return node2.cloneNode(false);
          };
          DocumentCloner2.prototype.resolvePseudoContent = function(node2, clone2, style, pseudoElt) {
            var _this = this;
            if (!style) {
              return;
            }
            var value = style.content;
            var document3 = clone2.ownerDocument;
            if (!document3 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") {
              return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document3.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
              if (token.type === 0) {
                anonymousReplacedElement.appendChild(document3.createTextNode(token.value));
              } else if (token.type === 22) {
                var img = document3.createElement("img");
                img.src = token.value;
                img.style.opacity = "1";
                anonymousReplacedElement.appendChild(img);
              } else if (token.type === 18) {
                if (token.name === "attr") {
                  var attr2 = token.values.filter(isIdentToken);
                  if (attr2.length) {
                    anonymousReplacedElement.appendChild(document3.createTextNode(node2.getAttribute(attr2[0].value) || ""));
                  }
                } else if (token.name === "counter") {
                  var _a3 = token.values.filter(nonFunctionArgSeparator), counter = _a3[0], counterStyle = _a3[1];
                  if (counter && isIdentToken(counter)) {
                    var counterState = _this.counters.getCounterValue(counter.value);
                    var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : LIST_STYLE_TYPE.DECIMAL;
                    anonymousReplacedElement.appendChild(document3.createTextNode(createCounterText(counterState, counterType, false)));
                  }
                } else if (token.name === "counters") {
                  var _b2 = token.values.filter(nonFunctionArgSeparator), counter = _b2[0], delim = _b2[1], counterStyle = _b2[2];
                  if (counter && isIdentToken(counter)) {
                    var counterStates = _this.counters.getCounterValues(counter.value);
                    var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : LIST_STYLE_TYPE.DECIMAL;
                    var separator = delim && delim.type === 0 ? delim.value : "";
                    var text2 = counterStates.map(function(value2) {
                      return createCounterText(value2, counterType_1, false);
                    }).join(separator);
                    anonymousReplacedElement.appendChild(document3.createTextNode(text2));
                  }
                } else
                  ;
              } else if (token.type === 20) {
                switch (token.value) {
                  case "open-quote":
                    anonymousReplacedElement.appendChild(document3.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                    break;
                  case "close-quote":
                    anonymousReplacedElement.appendChild(document3.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                    break;
                  default:
                    anonymousReplacedElement.appendChild(document3.createTextNode(token.value));
                }
              }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone2)) {
              clone2.className.baseValue += newClassName;
            } else {
              clone2.className += newClassName;
            }
            return anonymousReplacedElement;
          };
          DocumentCloner2.destroy = function(container) {
            if (container.parentNode) {
              container.parentNode.removeChild(container);
              return true;
            }
            return false;
          };
          return DocumentCloner2;
        }();
        var PseudoElementType;
        (function(PseudoElementType2) {
          PseudoElementType2[PseudoElementType2["BEFORE"] = 0] = "BEFORE";
          PseudoElementType2[PseudoElementType2["AFTER"] = 1] = "AFTER";
        })(PseudoElementType || (PseudoElementType = {}));
        var createIFrameContainer = function(ownerDocument, bounds) {
          var cloneIframeContainer = ownerDocument.createElement("iframe");
          cloneIframeContainer.className = "html2canvas-container";
          cloneIframeContainer.style.visibility = "hidden";
          cloneIframeContainer.style.position = "fixed";
          cloneIframeContainer.style.left = "-10000px";
          cloneIframeContainer.style.top = "0px";
          cloneIframeContainer.style.border = "0";
          cloneIframeContainer.width = bounds.width.toString();
          cloneIframeContainer.height = bounds.height.toString();
          cloneIframeContainer.scrolling = "no";
          cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
          ownerDocument.body.appendChild(cloneIframeContainer);
          return cloneIframeContainer;
        };
        var imageReady = function(img) {
          return new Promise(function(resolve3) {
            if (img.complete) {
              resolve3();
              return;
            }
            if (!img.src) {
              resolve3();
              return;
            }
            img.onload = resolve3;
            img.onerror = resolve3;
          });
        };
        var imagesReady = function(document3) {
          return Promise.all([].slice.call(document3.images, 0).map(imageReady));
        };
        var iframeLoader = function(iframe) {
          return new Promise(function(resolve3, reject2) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
              return reject2("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
              cloneWindow.onload = iframe.onload = null;
              var interval = setInterval(function() {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                  clearInterval(interval);
                  resolve3(iframe);
                }
              }, 50);
            };
          });
        };
        var ignoredStyleProperties = [
          "all",
          "d",
          "content"
        ];
        var copyCSSStyles = function(style, target) {
          for (var i4 = style.length - 1; i4 >= 0; i4--) {
            var property = style.item(i4);
            if (ignoredStyleProperties.indexOf(property) === -1) {
              target.style.setProperty(property, style.getPropertyValue(property));
            }
          }
          return target;
        };
        var serializeDoctype = function(doctype) {
          var str = "";
          if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) {
              str += doctype.name;
            }
            if (doctype.internalSubset) {
              str += doctype.internalSubset;
            }
            if (doctype.publicId) {
              str += '"' + doctype.publicId + '"';
            }
            if (doctype.systemId) {
              str += '"' + doctype.systemId + '"';
            }
            str += ">";
          }
          return str;
        };
        var restoreOwnerScroll = function(ownerDocument, x2, y3) {
          if (ownerDocument && ownerDocument.defaultView && (x2 !== ownerDocument.defaultView.pageXOffset || y3 !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x2, y3);
          }
        };
        var restoreNodeScroll = function(_a3) {
          var element = _a3[0], x2 = _a3[1], y3 = _a3[2];
          element.scrollLeft = x2;
          element.scrollTop = y3;
        };
        var PSEUDO_BEFORE = ":before";
        var PSEUDO_AFTER = ":after";
        var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
        var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
        var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
        var createPseudoHideStyles = function(body) {
          createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
        };
        var createStyles = function(body, styles2) {
          var document3 = body.ownerDocument;
          if (document3) {
            var style = document3.createElement("style");
            style.textContent = styles2;
            body.appendChild(style);
          }
        };
        var CacheStorage = function() {
          function CacheStorage2() {
          }
          CacheStorage2.getOrigin = function(url) {
            var link = CacheStorage2._link;
            if (!link) {
              return "about:blank";
            }
            link.href = url;
            link.href = link.href;
            return link.protocol + link.hostname + link.port;
          };
          CacheStorage2.isSameOrigin = function(src) {
            return CacheStorage2.getOrigin(src) === CacheStorage2._origin;
          };
          CacheStorage2.setContext = function(window2) {
            CacheStorage2._link = window2.document.createElement("a");
            CacheStorage2._origin = CacheStorage2.getOrigin(window2.location.href);
          };
          CacheStorage2._origin = "about:blank";
          return CacheStorage2;
        }();
        var Cache = function() {
          function Cache2(context, _options) {
            this.context = context;
            this._options = _options;
            this._cache = {};
          }
          Cache2.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) {
              return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
              (this._cache[src] = this.loadImage(src)).catch(function() {
              });
              return result;
            }
            return result;
          };
          Cache2.prototype.match = function(src) {
            return this._cache[src];
          };
          Cache2.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
              var isSameOrigin, useCORS, useProxy, src;
              var _this = this;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    isSameOrigin = CacheStorage.isSameOrigin(key);
                    useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                    useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                    if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) {
                      return [2];
                    }
                    src = key;
                    if (!useProxy)
                      return [3, 2];
                    return [4, this.proxy(src)];
                  case 1:
                    src = _a3.sent();
                    _a3.label = 2;
                  case 2:
                    this.context.logger.debug("Added image " + key.substring(0, 256));
                    return [4, new Promise(function(resolve3, reject2) {
                      var img = new Image();
                      img.onload = function() {
                        return resolve3(img);
                      };
                      img.onerror = reject2;
                      if (isInlineBase64Image(src) || useCORS) {
                        img.crossOrigin = "anonymous";
                      }
                      img.src = src;
                      if (img.complete === true) {
                        setTimeout(function() {
                          return resolve3(img);
                        }, 500);
                      }
                      if (_this._options.imageTimeout > 0) {
                        setTimeout(function() {
                          return reject2("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                        }, _this._options.imageTimeout);
                      }
                    })];
                  case 3:
                    return [2, _a3.sent()];
                }
              });
            });
          };
          Cache2.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
          };
          Cache2.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
          };
          Cache2.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
              throw new Error("No proxy defined");
            }
            var key = src.substring(0, 256);
            return new Promise(function(resolve3, reject2) {
              var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
              var xhr = new XMLHttpRequest();
              xhr.onload = function() {
                if (xhr.status === 200) {
                  if (responseType === "text") {
                    resolve3(xhr.response);
                  } else {
                    var reader_1 = new FileReader();
                    reader_1.addEventListener("load", function() {
                      return resolve3(reader_1.result);
                    }, false);
                    reader_1.addEventListener("error", function(e3) {
                      return reject2(e3);
                    }, false);
                    reader_1.readAsDataURL(xhr.response);
                  }
                } else {
                  reject2("Failed to proxy resource " + key + " with status code " + xhr.status);
                }
              };
              xhr.onerror = reject2;
              var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
              xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
              if (responseType !== "text" && xhr instanceof XMLHttpRequest) {
                xhr.responseType = responseType;
              }
              if (_this._options.imageTimeout) {
                var timeout_1 = _this._options.imageTimeout;
                xhr.timeout = timeout_1;
                xhr.ontimeout = function() {
                  return reject2("Timed out (" + timeout_1 + "ms) proxying " + key);
                };
              }
              xhr.send();
            });
          };
          return Cache2;
        }();
        var INLINE_SVG = /^data:image\/svg\+xml/i;
        var INLINE_BASE64 = /^data:image\/.*;base64,/i;
        var INLINE_IMG = /^data:image\/.*/i;
        var isRenderable = function(src) {
          return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
        };
        var isInlineImage = function(src) {
          return INLINE_IMG.test(src);
        };
        var isInlineBase64Image = function(src) {
          return INLINE_BASE64.test(src);
        };
        var isBlobImage = function(src) {
          return src.substr(0, 4) === "blob";
        };
        var isSVG = function(src) {
          return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
        };
        var PathType;
        (function(PathType2) {
          PathType2[PathType2["VECTOR"] = 0] = "VECTOR";
          PathType2[PathType2["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
        })(PathType || (PathType = {}));
        var equalPath = function(a4, b2) {
          if (a4.length === b2.length) {
            return a4.some(function(v3, i4) {
              return v3 === b2[i4];
            });
          }
          return false;
        };
        var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
          return path.map(function(point, index3) {
            switch (index3) {
              case 0:
                return point.add(deltaX, deltaY);
              case 1:
                return point.add(deltaX + deltaW, deltaY);
              case 2:
                return point.add(deltaX + deltaW, deltaY + deltaH);
              case 3:
                return point.add(deltaX, deltaY + deltaH);
            }
            return point;
          });
        };
        var Vector = function() {
          function Vector2(x2, y3) {
            this.type = PathType.VECTOR;
            this.x = x2;
            this.y = y3;
          }
          Vector2.prototype.add = function(deltaX, deltaY) {
            return new Vector2(this.x + deltaX, this.y + deltaY);
          };
          return Vector2;
        }();
        var lerp = function(a4, b2, t3) {
          return new Vector(a4.x + (b2.x - a4.x) * t3, a4.y + (b2.y - a4.y) * t3);
        };
        var BezierCurve = function() {
          function BezierCurve2(start2, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start2;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
          }
          BezierCurve2.prototype.subdivide = function(t3, firstHalf) {
            var ab = lerp(this.start, this.startControl, t3);
            var bc = lerp(this.startControl, this.endControl, t3);
            var cd = lerp(this.endControl, this.end, t3);
            var abbc = lerp(ab, bc, t3);
            var bccd = lerp(bc, cd, t3);
            var dest = lerp(abbc, bccd, t3);
            return firstHalf ? new BezierCurve2(this.start, ab, abbc, dest) : new BezierCurve2(dest, bccd, cd, this.end);
          };
          BezierCurve2.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve2(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
          };
          BezierCurve2.prototype.reverse = function() {
            return new BezierCurve2(this.end, this.endControl, this.startControl, this.start);
          };
          return BezierCurve2;
        }();
        var isBezierCurve = function(path) {
          return path.type === PathType.BEZIER_CURVE;
        };
        var BoundCurves = function() {
          function BoundCurves2(element) {
            var styles2 = element.styles;
            var bounds = element.bounds;
            var _a3 = getAbsoluteValueForTuple(styles2.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a3[0], tlv = _a3[1];
            var _b2 = getAbsoluteValueForTuple(styles2.borderTopRightRadius, bounds.width, bounds.height), trh = _b2[0], trv = _b2[1];
            var _c = getAbsoluteValueForTuple(styles2.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles2.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
              tlh /= maxFactor;
              tlv /= maxFactor;
              trh /= maxFactor;
              trv /= maxFactor;
              brh /= maxFactor;
              brv /= maxFactor;
              blh /= maxFactor;
              blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth2 = styles2.borderTopWidth;
            var borderRightWidth2 = styles2.borderRightWidth;
            var borderBottomWidth2 = styles2.borderBottomWidth;
            var borderLeftWidth2 = styles2.borderLeftWidth;
            var paddingTop2 = getAbsoluteValue(styles2.paddingTop, element.bounds.width);
            var paddingRight2 = getAbsoluteValue(styles2.paddingRight, element.bounds.width);
            var paddingBottom2 = getAbsoluteValue(styles2.paddingBottom, element.bounds.width);
            var paddingLeft2 = getAbsoluteValue(styles2.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3, tlh - borderLeftWidth2 / 3, tlv - borderTopWidth2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 3, trh - borderRightWidth2 / 3, trv - borderTopWidth2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + borderTopWidth2 / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 3, brv - borderBottomWidth2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 / 3, blv - borderBottomWidth2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3, tlh - borderLeftWidth2 * 2 / 3, tlv - borderTopWidth2 * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 * 2 / 3, trh - borderRightWidth2 * 2 / 3, trv - borderTopWidth2 * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 * 2 / 3, brv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 * 2 / 3, blv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2, tlh - borderLeftWidth2 / 2, tlv - borderTopWidth2 / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 2, trh - borderRightWidth2 / 2, trv - borderTopWidth2 / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + borderTopWidth2 / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 2, brv - borderBottomWidth2 / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + leftHeight, blh - borderLeftWidth2 / 2, blv - borderBottomWidth2 / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2, Math.max(0, tlh - borderLeftWidth2), Math.max(0, tlv - borderTopWidth2), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth2), bounds.top + borderTopWidth2, topWidth > bounds.width + borderRightWidth2 ? 0 : Math.max(0, trh - borderRightWidth2), Math.max(0, trv - borderTopWidth2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + borderTopWidth2);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth2), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth2), Math.max(0, brh - borderRightWidth2), Math.max(0, brv - borderBottomWidth2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + bounds.height - borderBottomWidth2);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth2), Math.max(0, blh - borderLeftWidth2), Math.max(0, blv - borderBottomWidth2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + bounds.height - borderBottomWidth2);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2, Math.max(0, tlh - (borderLeftWidth2 + paddingLeft2)), Math.max(0, tlv - (borderTopWidth2 + paddingTop2)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth2 + paddingLeft2), bounds.top + borderTopWidth2 + paddingTop2, topWidth > bounds.width + borderLeftWidth2 + paddingLeft2 ? 0 : trh - borderLeftWidth2 + paddingLeft2, trv - (borderTopWidth2 + paddingTop2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + borderTopWidth2 + paddingTop2);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth2 + paddingLeft2)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth2 + paddingTop2), Math.max(0, brh - (borderRightWidth2 + paddingRight2)), brv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth2 + paddingLeft2)), blv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
          }
          return BoundCurves2;
        }();
        var CORNER;
        (function(CORNER2) {
          CORNER2[CORNER2["TOP_LEFT"] = 0] = "TOP_LEFT";
          CORNER2[CORNER2["TOP_RIGHT"] = 1] = "TOP_RIGHT";
          CORNER2[CORNER2["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
          CORNER2[CORNER2["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
        })(CORNER || (CORNER = {}));
        var getCurvePoints = function(x2, y3, r1, r2, position2) {
          var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
          var ox = r1 * kappa;
          var oy = r2 * kappa;
          var xm = x2 + r1;
          var ym = y3 + r2;
          switch (position2) {
            case CORNER.TOP_LEFT:
              return new BezierCurve(new Vector(x2, ym), new Vector(x2, ym - oy), new Vector(xm - ox, y3), new Vector(xm, y3));
            case CORNER.TOP_RIGHT:
              return new BezierCurve(new Vector(x2, y3), new Vector(x2 + ox, y3), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
              return new BezierCurve(new Vector(xm, y3), new Vector(xm, y3 + oy), new Vector(x2 + ox, ym), new Vector(x2, ym));
            case CORNER.BOTTOM_LEFT:
            default:
              return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x2, y3 + oy), new Vector(x2, y3));
          }
        };
        var calculateBorderBoxPath = function(curves) {
          return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
        };
        var calculateContentBoxPath = function(curves) {
          return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
          ];
        };
        var calculatePaddingBoxPath = function(curves) {
          return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
          ];
        };
        var TransformEffect = function() {
          function TransformEffect2(offsetX, offsetY, matrix2) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix2;
            this.type = 0;
            this.target = 2 | 4;
          }
          return TransformEffect2;
        }();
        var ClipEffect = function() {
          function ClipEffect2(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1;
          }
          return ClipEffect2;
        }();
        var OpacityEffect = function() {
          function OpacityEffect2(opacity2) {
            this.opacity = opacity2;
            this.type = 2;
            this.target = 2 | 4;
          }
          return OpacityEffect2;
        }();
        var isTransformEffect = function(effect4) {
          return effect4.type === 0;
        };
        var isClipEffect = function(effect4) {
          return effect4.type === 1;
        };
        var isOpacityEffect = function(effect4) {
          return effect4.type === 2;
        };
        var StackingContext = function() {
          function StackingContext2(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
          }
          return StackingContext2;
        }();
        var ElementPaint = function() {
          function ElementPaint2(container, parent2) {
            this.container = container;
            this.parent = parent2;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
              this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
              var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
              var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
              var matrix2 = this.container.styles.transform;
              this.effects.push(new TransformEffect(offsetX, offsetY, matrix2));
            }
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
              var borderBox = calculateBorderBoxPath(this.curves);
              var paddingBox2 = calculatePaddingBoxPath(this.curves);
              if (equalPath(borderBox, paddingBox2)) {
                this.effects.push(new ClipEffect(borderBox, 2 | 4));
              } else {
                this.effects.push(new ClipEffect(borderBox, 2));
                this.effects.push(new ClipEffect(paddingBox2, 4));
              }
            }
          }
          ElementPaint2.prototype.getEffects = function(target) {
            var inFlow = [POSITION.ABSOLUTE, POSITION.FIXED].indexOf(this.container.styles.position) === -1;
            var parent2 = this.parent;
            var effects = this.effects.slice(0);
            while (parent2) {
              var croplessEffects = parent2.effects.filter(function(effect4) {
                return !isClipEffect(effect4);
              });
              if (inFlow || parent2.container.styles.position !== POSITION.STATIC || !parent2.parent) {
                effects.unshift.apply(effects, croplessEffects);
                inFlow = [POSITION.ABSOLUTE, POSITION.FIXED].indexOf(parent2.container.styles.position) === -1;
                if (parent2.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                  var borderBox = calculateBorderBoxPath(parent2.curves);
                  var paddingBox2 = calculatePaddingBoxPath(parent2.curves);
                  if (!equalPath(borderBox, paddingBox2)) {
                    effects.unshift(new ClipEffect(paddingBox2, 2 | 4));
                  }
                }
              } else {
                effects.unshift.apply(effects, croplessEffects);
              }
              parent2 = parent2.parent;
            }
            return effects.filter(function(effect4) {
              return contains(effect4.target, target);
            });
          };
          return ElementPaint2;
        }();
        var parseStackTree = function(parent2, stackingContext, realStackingContext, listItems) {
          parent2.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4);
            var createsStackingContext2 = contains(child.flags, 2);
            var paintContainer = new ElementPaint(child, parent2);
            if (contains(child.styles.display, 2048)) {
              listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext2) {
              var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
              var stack2 = new StackingContext(paintContainer);
              if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                var order_1 = child.styles.zIndex.order;
                if (order_1 < 0) {
                  var index_1 = 0;
                  parentStack.negativeZIndex.some(function(current, i4) {
                    if (order_1 > current.element.container.styles.zIndex.order) {
                      index_1 = i4;
                      return false;
                    } else if (index_1 > 0) {
                      return true;
                    }
                    return false;
                  });
                  parentStack.negativeZIndex.splice(index_1, 0, stack2);
                } else if (order_1 > 0) {
                  var index_2 = 0;
                  parentStack.positiveZIndex.some(function(current, i4) {
                    if (order_1 >= current.element.container.styles.zIndex.order) {
                      index_2 = i4 + 1;
                      return false;
                    } else if (index_2 > 0) {
                      return true;
                    }
                    return false;
                  });
                  parentStack.positiveZIndex.splice(index_2, 0, stack2);
                } else {
                  parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack2);
                }
              } else {
                if (child.styles.isFloating()) {
                  parentStack.nonPositionedFloats.push(stack2);
                } else {
                  parentStack.nonPositionedInlineLevel.push(stack2);
                }
              }
              parseStackTree(paintContainer, stack2, treatAsRealStackingContext ? stack2 : realStackingContext, listOwnerItems);
            } else {
              if (child.styles.isInlineLevel()) {
                stackingContext.inlineLevel.push(paintContainer);
              } else {
                stackingContext.nonInlineLevel.push(paintContainer);
              }
              parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8)) {
              processListItems(child, listOwnerItems);
            }
          });
        };
        var processListItems = function(owner, elements2) {
          var numbering = owner instanceof OLElementContainer ? owner.start : 1;
          var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
          for (var i4 = 0; i4 < elements2.length; i4++) {
            var item = elements2[i4];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) {
              numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
          }
        };
        var parseStackingContexts = function(container) {
          var paintContainer = new ElementPaint(container, null);
          var root = new StackingContext(paintContainer);
          var listItems = [];
          parseStackTree(paintContainer, root, root, listItems);
          processListItems(paintContainer.container, listItems);
          return root;
        };
        var parsePathForBorder = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
          }
        };
        var parsePathForBorderDoubleOuter = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
          }
        };
        var parsePathForBorderDoubleInner = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
              return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
              return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
              return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
          }
        };
        var parsePathForBorderStroke = function(curves, borderSide) {
          switch (borderSide) {
            case 0:
              return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
              return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
              return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
              return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
          }
        };
        var createStrokePathFromCurves = function(outer1, outer2) {
          var path = [];
          if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
          } else {
            path.push(outer1);
          }
          if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
          } else {
            path.push(outer2);
          }
          return path;
        };
        var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
          var path = [];
          if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
          } else {
            path.push(outer1);
          }
          if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
          } else {
            path.push(outer2);
          }
          if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
          } else {
            path.push(inner2);
          }
          if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
          } else {
            path.push(inner1);
          }
          return path;
        };
        var paddingBox = function(element) {
          var bounds = element.bounds;
          var styles2 = element.styles;
          return bounds.add(styles2.borderLeftWidth, styles2.borderTopWidth, -(styles2.borderRightWidth + styles2.borderLeftWidth), -(styles2.borderTopWidth + styles2.borderBottomWidth));
        };
        var contentBox = function(element) {
          var styles2 = element.styles;
          var bounds = element.bounds;
          var paddingLeft2 = getAbsoluteValue(styles2.paddingLeft, bounds.width);
          var paddingRight2 = getAbsoluteValue(styles2.paddingRight, bounds.width);
          var paddingTop2 = getAbsoluteValue(styles2.paddingTop, bounds.width);
          var paddingBottom2 = getAbsoluteValue(styles2.paddingBottom, bounds.width);
          return bounds.add(paddingLeft2 + styles2.borderLeftWidth, paddingTop2 + styles2.borderTopWidth, -(styles2.borderRightWidth + styles2.borderLeftWidth + paddingLeft2 + paddingRight2), -(styles2.borderTopWidth + styles2.borderBottomWidth + paddingTop2 + paddingBottom2));
        };
        var calculateBackgroundPositioningArea = function(backgroundOrigin2, element) {
          if (backgroundOrigin2 === 0) {
            return element.bounds;
          }
          if (backgroundOrigin2 === 2) {
            return contentBox(element);
          }
          return paddingBox(element);
        };
        var calculateBackgroundPaintingArea = function(backgroundClip2, element) {
          if (backgroundClip2 === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
          }
          if (backgroundClip2 === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
          }
          return paddingBox(element);
        };
        var calculateBackgroundRendering = function(container, index3, intrinsicSize) {
          var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index3), container);
          var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index3), container);
          var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index3), intrinsicSize, backgroundPositioningArea);
          var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
          var position2 = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index3), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
          var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index3), position2, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
          var offsetX = Math.round(backgroundPositioningArea.left + position2[0]);
          var offsetY = Math.round(backgroundPositioningArea.top + position2[1]);
          return [path, offsetX, offsetY, sizeWidth, sizeHeight];
        };
        var isAuto = function(token) {
          return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
        };
        var hasIntrinsicValue = function(value) {
          return typeof value === "number";
        };
        var calculateBackgroundSize = function(size3, _a3, bounds) {
          var intrinsicWidth = _a3[0], intrinsicHeight = _a3[1], intrinsicProportion = _a3[2];
          var first = size3[0], second = size3[1];
          if (!first) {
            return [0, 0];
          }
          if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
          }
          var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
          if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
              var targetRatio = bounds.width / bounds.height;
              return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [bounds.width, bounds.width / intrinsicProportion] : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
          }
          var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
          var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
          var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
          if (isAuto(first) && (!second || isAuto(second))) {
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
              return [intrinsicWidth, intrinsicHeight];
            }
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
              return [bounds.width, bounds.height];
            }
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
              var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
              var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
              return [width_1, height_1];
            }
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
          }
          if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
              width_3 = getAbsoluteValue(first, bounds.width);
            } else if (isLengthPercentage(second)) {
              height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
              width_3 = height_3 * intrinsicProportion;
            } else if (!second || isAuto(second)) {
              height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
          }
          var width = null;
          var height = null;
          if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
          } else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
          }
          if (width !== null && (!second || isAuto(second))) {
            height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
          }
          if (height !== null && isAuto(first)) {
            width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
          }
          if (width !== null && height !== null) {
            return [width, height];
          }
          throw new Error("Unable to calculate background-size for element");
        };
        var getBackgroundValueForIndex = function(values, index3) {
          var value = values[index3];
          if (typeof value === "undefined") {
            return values[0];
          }
          return value;
        };
        var calculateBackgroundRepeatPath = function(repeat, _a3, _b2, backgroundPositioningArea, backgroundPaintingArea) {
          var x2 = _a3[0], y3 = _a3[1];
          var width = _b2[0], height = _b2[1];
          switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
              return [
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y3)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y3)),
                new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y3)),
                new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y3))
              ];
            case BACKGROUND_REPEAT.REPEAT_Y:
              return [
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
              ];
            case BACKGROUND_REPEAT.NO_REPEAT:
              return [
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top + y3)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top + y3)),
                new Vector(Math.round(backgroundPositioningArea.left + x2 + width), Math.round(backgroundPositioningArea.top + y3 + height)),
                new Vector(Math.round(backgroundPositioningArea.left + x2), Math.round(backgroundPositioningArea.top + y3 + height))
              ];
            default:
              return [
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
              ];
          }
        };
        var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        var SAMPLE_TEXT = "Hidden Text";
        var FontMetrics = function() {
          function FontMetrics2(document3) {
            this._data = {};
            this._document = document3;
          }
          FontMetrics2.prototype.parseMetrics = function(fontFamily2, fontSize2) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily2;
            container.style.fontSize = fontSize2;
            container.style.margin = "0";
            container.style.padding = "0";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily2;
            span.style.fontSize = fontSize2;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline, middle };
          };
          FontMetrics2.prototype.getMetrics = function(fontFamily2, fontSize2) {
            var key = fontFamily2 + " " + fontSize2;
            if (typeof this._data[key] === "undefined") {
              this._data[key] = this.parseMetrics(fontFamily2, fontSize2);
            }
            return this._data[key];
          };
          return FontMetrics2;
        }();
        var Renderer = function() {
          function Renderer2(context, options) {
            this.context = context;
            this.options = options;
          }
          return Renderer2;
        }();
        var MASK_OFFSET = 1e4;
        var CanvasRenderer = function(_super) {
          __extends(CanvasRenderer2, _super);
          function CanvasRenderer2(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
              _this.canvas.width = Math.floor(options.width * options.scale);
              _this.canvas.height = Math.floor(options.height * options.scale);
              _this.canvas.style.width = options.width + "px";
              _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
          }
          CanvasRenderer2.prototype.applyEffects = function(effects) {
            var _this = this;
            while (this._activeEffects.length) {
              this.popEffect();
            }
            effects.forEach(function(effect4) {
              return _this.applyEffect(effect4);
            });
          };
          CanvasRenderer2.prototype.applyEffect = function(effect4) {
            this.ctx.save();
            if (isOpacityEffect(effect4)) {
              this.ctx.globalAlpha = effect4.opacity;
            }
            if (isTransformEffect(effect4)) {
              this.ctx.translate(effect4.offsetX, effect4.offsetY);
              this.ctx.transform(effect4.matrix[0], effect4.matrix[1], effect4.matrix[2], effect4.matrix[3], effect4.matrix[4], effect4.matrix[5]);
              this.ctx.translate(-effect4.offsetX, -effect4.offsetY);
            }
            if (isClipEffect(effect4)) {
              this.path(effect4.path);
              this.ctx.clip();
            }
            this._activeEffects.push(effect4);
          };
          CanvasRenderer2.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
          };
          CanvasRenderer2.prototype.renderStack = function(stack2) {
            return __awaiter(this, void 0, void 0, function() {
              var styles2;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    styles2 = stack2.element.container.styles;
                    if (!styles2.isVisible())
                      return [3, 2];
                    return [4, this.renderStackContent(stack2)];
                  case 1:
                    _a3.sent();
                    _a3.label = 2;
                  case 2:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    if (contains(paint.container.flags, 16)) {
                      debugger;
                    }
                    if (!paint.container.styles.isVisible())
                      return [3, 3];
                    return [4, this.renderNodeBackgroundAndBorders(paint)];
                  case 1:
                    _a3.sent();
                    return [4, this.renderNodeContent(paint)];
                  case 2:
                    _a3.sent();
                    _a3.label = 3;
                  case 3:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderTextWithLetterSpacing = function(text2, letterSpacing2, baseline) {
            var _this = this;
            if (letterSpacing2 === 0) {
              this.ctx.fillText(text2.text, text2.bounds.left, text2.bounds.top + baseline);
            } else {
              var letters = splitGraphemes(text2.text);
              letters.reduce(function(left, letter) {
                _this.ctx.fillText(letter, left, text2.bounds.top + baseline);
                return left + _this.ctx.measureText(letter).width;
              }, text2.bounds.left);
            }
          };
          CanvasRenderer2.prototype.createFontStyle = function(styles2) {
            var fontVariant2 = styles2.fontVariant.filter(function(variant) {
              return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily2 = styles2.fontFamily.join(", ");
            var fontSize2 = isDimensionToken(styles2.fontSize) ? "" + styles2.fontSize.number + styles2.fontSize.unit : styles2.fontSize.number + "px";
            return [
              [styles2.fontStyle, fontVariant2, styles2.fontWeight, fontSize2, fontFamily2].join(" "),
              fontFamily2,
              fontSize2
            ];
          };
          CanvasRenderer2.prototype.renderTextNode = function(text2, styles2) {
            return __awaiter(this, void 0, void 0, function() {
              var _a3, font, fontFamily2, fontSize2, _b2, baseline, middle, paintOrder2;
              var _this = this;
              return __generator(this, function(_c) {
                _a3 = this.createFontStyle(styles2), font = _a3[0], fontFamily2 = _a3[1], fontSize2 = _a3[2];
                this.ctx.font = font;
                this.ctx.direction = styles2.direction === 1 ? "rtl" : "ltr";
                this.ctx.textAlign = "left";
                this.ctx.textBaseline = "alphabetic";
                _b2 = this.fontMetrics.getMetrics(fontFamily2, fontSize2), baseline = _b2.baseline, middle = _b2.middle;
                paintOrder2 = styles2.paintOrder;
                text2.textBounds.forEach(function(text3) {
                  paintOrder2.forEach(function(paintOrderLayer) {
                    switch (paintOrderLayer) {
                      case PAINT_ORDER_LAYER.FILL:
                        _this.ctx.fillStyle = asString(styles2.color);
                        _this.renderTextWithLetterSpacing(text3, styles2.letterSpacing, baseline);
                        var textShadows = styles2.textShadow;
                        if (textShadows.length && text3.text.trim().length) {
                          textShadows.slice(0).reverse().forEach(function(textShadow2) {
                            _this.ctx.shadowColor = asString(textShadow2.color);
                            _this.ctx.shadowOffsetX = textShadow2.offsetX.number * _this.options.scale;
                            _this.ctx.shadowOffsetY = textShadow2.offsetY.number * _this.options.scale;
                            _this.ctx.shadowBlur = textShadow2.blur.number;
                            _this.renderTextWithLetterSpacing(text3, styles2.letterSpacing, baseline);
                          });
                          _this.ctx.shadowColor = "";
                          _this.ctx.shadowOffsetX = 0;
                          _this.ctx.shadowOffsetY = 0;
                          _this.ctx.shadowBlur = 0;
                        }
                        if (styles2.textDecorationLine.length) {
                          _this.ctx.fillStyle = asString(styles2.textDecorationColor || styles2.color);
                          styles2.textDecorationLine.forEach(function(textDecorationLine2) {
                            switch (textDecorationLine2) {
                              case 1:
                                _this.ctx.fillRect(text3.bounds.left, Math.round(text3.bounds.top + baseline), text3.bounds.width, 1);
                                break;
                              case 2:
                                _this.ctx.fillRect(text3.bounds.left, Math.round(text3.bounds.top), text3.bounds.width, 1);
                                break;
                              case 3:
                                _this.ctx.fillRect(text3.bounds.left, Math.ceil(text3.bounds.top + middle), text3.bounds.width, 1);
                                break;
                            }
                          });
                        }
                        break;
                      case PAINT_ORDER_LAYER.STROKE:
                        if (styles2.webkitTextStrokeWidth && text3.text.trim().length) {
                          _this.ctx.strokeStyle = asString(styles2.webkitTextStrokeColor);
                          _this.ctx.lineWidth = styles2.webkitTextStrokeWidth;
                          _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                          _this.ctx.strokeText(text3.text, text3.bounds.left, text3.bounds.top + baseline);
                        }
                        _this.ctx.strokeStyle = "";
                        _this.ctx.lineWidth = 0;
                        _this.ctx.lineJoin = "miter";
                        break;
                    }
                  });
                });
                return [2];
              });
            });
          };
          CanvasRenderer2.prototype.renderReplacedElement = function(container, curves, image2) {
            if (image2 && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
              var box = contentBox(container);
              var path = calculatePaddingBoxPath(curves);
              this.path(path);
              this.ctx.save();
              this.ctx.clip();
              this.ctx.drawImage(image2, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
              this.ctx.restore();
            }
          };
          CanvasRenderer2.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
              var container, curves, styles2, _i, _a3, child, image2, image2, iframeRenderer, canvas, size3, _b2, fontFamily2, fontSize2, baseline, bounds, x2, textBounds, img, image2, url, fontFamily2, bounds;
              return __generator(this, function(_c) {
                switch (_c.label) {
                  case 0:
                    this.applyEffects(paint.getEffects(4));
                    container = paint.container;
                    curves = paint.curves;
                    styles2 = container.styles;
                    _i = 0, _a3 = container.textNodes;
                    _c.label = 1;
                  case 1:
                    if (!(_i < _a3.length))
                      return [3, 4];
                    child = _a3[_i];
                    return [4, this.renderTextNode(child, styles2)];
                  case 2:
                    _c.sent();
                    _c.label = 3;
                  case 3:
                    _i++;
                    return [3, 1];
                  case 4:
                    if (!(container instanceof ImageElementContainer))
                      return [3, 8];
                    _c.label = 5;
                  case 5:
                    _c.trys.push([5, 7, , 8]);
                    return [4, this.context.cache.match(container.src)];
                  case 6:
                    image2 = _c.sent();
                    this.renderReplacedElement(container, curves, image2);
                    return [3, 8];
                  case 7:
                    _c.sent();
                    this.context.logger.error("Error loading image " + container.src);
                    return [3, 8];
                  case 8:
                    if (container instanceof CanvasElementContainer) {
                      this.renderReplacedElement(container, curves, container.canvas);
                    }
                    if (!(container instanceof SVGElementContainer))
                      return [3, 12];
                    _c.label = 9;
                  case 9:
                    _c.trys.push([9, 11, , 12]);
                    return [4, this.context.cache.match(container.svg)];
                  case 10:
                    image2 = _c.sent();
                    this.renderReplacedElement(container, curves, image2);
                    return [3, 12];
                  case 11:
                    _c.sent();
                    this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                    return [3, 12];
                  case 12:
                    if (!(container instanceof IFrameElementContainer && container.tree))
                      return [3, 14];
                    iframeRenderer = new CanvasRenderer2(this.context, {
                      scale: this.options.scale,
                      backgroundColor: container.backgroundColor,
                      x: 0,
                      y: 0,
                      width: container.width,
                      height: container.height
                    });
                    return [4, iframeRenderer.render(container.tree)];
                  case 13:
                    canvas = _c.sent();
                    if (container.width && container.height) {
                      this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                    }
                    _c.label = 14;
                  case 14:
                    if (container instanceof InputElementContainer) {
                      size3 = Math.min(container.bounds.width, container.bounds.height);
                      if (container.type === CHECKBOX) {
                        if (container.checked) {
                          this.ctx.save();
                          this.path([
                            new Vector(container.bounds.left + size3 * 0.39363, container.bounds.top + size3 * 0.79),
                            new Vector(container.bounds.left + size3 * 0.16, container.bounds.top + size3 * 0.5549),
                            new Vector(container.bounds.left + size3 * 0.27347, container.bounds.top + size3 * 0.44071),
                            new Vector(container.bounds.left + size3 * 0.39694, container.bounds.top + size3 * 0.5649),
                            new Vector(container.bounds.left + size3 * 0.72983, container.bounds.top + size3 * 0.23),
                            new Vector(container.bounds.left + size3 * 0.84, container.bounds.top + size3 * 0.34085),
                            new Vector(container.bounds.left + size3 * 0.39363, container.bounds.top + size3 * 0.79)
                          ]);
                          this.ctx.fillStyle = asString(INPUT_COLOR);
                          this.ctx.fill();
                          this.ctx.restore();
                        }
                      } else if (container.type === RADIO) {
                        if (container.checked) {
                          this.ctx.save();
                          this.ctx.beginPath();
                          this.ctx.arc(container.bounds.left + size3 / 2, container.bounds.top + size3 / 2, size3 / 4, 0, Math.PI * 2, true);
                          this.ctx.fillStyle = asString(INPUT_COLOR);
                          this.ctx.fill();
                          this.ctx.restore();
                        }
                      }
                    }
                    if (isTextInputElement(container) && container.value.length) {
                      _b2 = this.createFontStyle(styles2), fontFamily2 = _b2[0], fontSize2 = _b2[1];
                      baseline = this.fontMetrics.getMetrics(fontFamily2, fontSize2).baseline;
                      this.ctx.font = fontFamily2;
                      this.ctx.fillStyle = asString(styles2.color);
                      this.ctx.textBaseline = "alphabetic";
                      this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                      bounds = contentBox(container);
                      x2 = 0;
                      switch (container.styles.textAlign) {
                        case TEXT_ALIGN.CENTER:
                          x2 += bounds.width / 2;
                          break;
                        case TEXT_ALIGN.RIGHT:
                          x2 += bounds.width;
                          break;
                      }
                      textBounds = bounds.add(x2, 0, 0, -bounds.height / 2 + 1);
                      this.ctx.save();
                      this.path([
                        new Vector(bounds.left, bounds.top),
                        new Vector(bounds.left + bounds.width, bounds.top),
                        new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                        new Vector(bounds.left, bounds.top + bounds.height)
                      ]);
                      this.ctx.clip();
                      this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles2.letterSpacing, baseline);
                      this.ctx.restore();
                      this.ctx.textBaseline = "alphabetic";
                      this.ctx.textAlign = "left";
                    }
                    if (!contains(container.styles.display, 2048))
                      return [3, 20];
                    if (!(container.styles.listStyleImage !== null))
                      return [3, 19];
                    img = container.styles.listStyleImage;
                    if (!(img.type === CSSImageType.URL))
                      return [3, 18];
                    image2 = void 0;
                    url = img.url;
                    _c.label = 15;
                  case 15:
                    _c.trys.push([15, 17, , 18]);
                    return [4, this.context.cache.match(url)];
                  case 16:
                    image2 = _c.sent();
                    this.ctx.drawImage(image2, container.bounds.left - (image2.width + 10), container.bounds.top);
                    return [3, 18];
                  case 17:
                    _c.sent();
                    this.context.logger.error("Error loading list-style-image " + url);
                    return [3, 18];
                  case 18:
                    return [3, 20];
                  case 19:
                    if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                      fontFamily2 = this.createFontStyle(styles2)[0];
                      this.ctx.font = fontFamily2;
                      this.ctx.fillStyle = asString(styles2.color);
                      this.ctx.textBaseline = "middle";
                      this.ctx.textAlign = "right";
                      bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles2.lineHeight, styles2.fontSize.number) / 2 + 1);
                      this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles2.letterSpacing, computeLineHeight(styles2.lineHeight, styles2.fontSize.number) / 2 + 2);
                      this.ctx.textBaseline = "bottom";
                      this.ctx.textAlign = "left";
                    }
                    _c.label = 20;
                  case 20:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderStackContent = function(stack2) {
            return __awaiter(this, void 0, void 0, function() {
              var _i, _a3, child, _b2, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
              return __generator(this, function(_p) {
                switch (_p.label) {
                  case 0:
                    if (contains(stack2.element.container.flags, 16)) {
                      debugger;
                    }
                    return [4, this.renderNodeBackgroundAndBorders(stack2.element)];
                  case 1:
                    _p.sent();
                    _i = 0, _a3 = stack2.negativeZIndex;
                    _p.label = 2;
                  case 2:
                    if (!(_i < _a3.length))
                      return [3, 5];
                    child = _a3[_i];
                    return [4, this.renderStack(child)];
                  case 3:
                    _p.sent();
                    _p.label = 4;
                  case 4:
                    _i++;
                    return [3, 2];
                  case 5:
                    return [4, this.renderNodeContent(stack2.element)];
                  case 6:
                    _p.sent();
                    _b2 = 0, _c = stack2.nonInlineLevel;
                    _p.label = 7;
                  case 7:
                    if (!(_b2 < _c.length))
                      return [3, 10];
                    child = _c[_b2];
                    return [4, this.renderNode(child)];
                  case 8:
                    _p.sent();
                    _p.label = 9;
                  case 9:
                    _b2++;
                    return [3, 7];
                  case 10:
                    _d = 0, _e = stack2.nonPositionedFloats;
                    _p.label = 11;
                  case 11:
                    if (!(_d < _e.length))
                      return [3, 14];
                    child = _e[_d];
                    return [4, this.renderStack(child)];
                  case 12:
                    _p.sent();
                    _p.label = 13;
                  case 13:
                    _d++;
                    return [3, 11];
                  case 14:
                    _f = 0, _g = stack2.nonPositionedInlineLevel;
                    _p.label = 15;
                  case 15:
                    if (!(_f < _g.length))
                      return [3, 18];
                    child = _g[_f];
                    return [4, this.renderStack(child)];
                  case 16:
                    _p.sent();
                    _p.label = 17;
                  case 17:
                    _f++;
                    return [3, 15];
                  case 18:
                    _h = 0, _j = stack2.inlineLevel;
                    _p.label = 19;
                  case 19:
                    if (!(_h < _j.length))
                      return [3, 22];
                    child = _j[_h];
                    return [4, this.renderNode(child)];
                  case 20:
                    _p.sent();
                    _p.label = 21;
                  case 21:
                    _h++;
                    return [3, 19];
                  case 22:
                    _k = 0, _l = stack2.zeroOrAutoZIndexOrTransformedOrOpacity;
                    _p.label = 23;
                  case 23:
                    if (!(_k < _l.length))
                      return [3, 26];
                    child = _l[_k];
                    return [4, this.renderStack(child)];
                  case 24:
                    _p.sent();
                    _p.label = 25;
                  case 25:
                    _k++;
                    return [3, 23];
                  case 26:
                    _m = 0, _o = stack2.positiveZIndex;
                    _p.label = 27;
                  case 27:
                    if (!(_m < _o.length))
                      return [3, 30];
                    child = _o[_m];
                    return [4, this.renderStack(child)];
                  case 28:
                    _p.sent();
                    _p.label = 29;
                  case 29:
                    _m++;
                    return [3, 27];
                  case 30:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
          };
          CanvasRenderer2.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
          };
          CanvasRenderer2.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index3) {
              var start2 = isBezierCurve(point) ? point.start : point;
              if (index3 === 0) {
                _this.ctx.moveTo(start2.x, start2.y);
              } else {
                _this.ctx.lineTo(start2.x, start2.y);
              }
              if (isBezierCurve(point)) {
                _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
              }
            });
          };
          CanvasRenderer2.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
          };
          CanvasRenderer2.prototype.resizeImage = function(image2, width, height) {
            var _a3;
            if (image2.width === width && image2.height === height) {
              return image2;
            }
            var ownerDocument = (_a3 = this.canvas.ownerDocument) !== null && _a3 !== void 0 ? _a3 : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image2, 0, 0, image2.width, image2.height, 0, 0, width, height);
            return canvas;
          };
          CanvasRenderer2.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
              var index3, _loop_1, this_1, _i, _a3, backgroundImage2;
              return __generator(this, function(_b2) {
                switch (_b2.label) {
                  case 0:
                    index3 = container.styles.backgroundImage.length - 1;
                    _loop_1 = function(backgroundImage3) {
                      var image2, url, _c, path, x2, y3, width, height, pattern, _d, path, x2, y3, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position2, x2, y3, _g, rx, ry, radialGradient_1, midX, midY, f4, invF;
                      return __generator(this, function(_h) {
                        switch (_h.label) {
                          case 0:
                            if (!(backgroundImage3.type === CSSImageType.URL))
                              return [3, 5];
                            image2 = void 0;
                            url = backgroundImage3.url;
                            _h.label = 1;
                          case 1:
                            _h.trys.push([1, 3, , 4]);
                            return [4, this_1.context.cache.match(url)];
                          case 2:
                            image2 = _h.sent();
                            return [3, 4];
                          case 3:
                            _h.sent();
                            this_1.context.logger.error("Error loading background-image " + url);
                            return [3, 4];
                          case 4:
                            if (image2) {
                              _c = calculateBackgroundRendering(container, index3, [
                                image2.width,
                                image2.height,
                                image2.width / image2.height
                              ]), path = _c[0], x2 = _c[1], y3 = _c[2], width = _c[3], height = _c[4];
                              pattern = this_1.ctx.createPattern(this_1.resizeImage(image2, width, height), "repeat");
                              this_1.renderRepeat(path, pattern, x2, y3);
                            }
                            return [3, 6];
                          case 5:
                            if (isLinearGradient(backgroundImage3)) {
                              _d = calculateBackgroundRendering(container, index3, [null, null, null]), path = _d[0], x2 = _d[1], y3 = _d[2], width = _d[3], height = _d[4];
                              _e = calculateGradientDirection(backgroundImage3.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                              canvas = document.createElement("canvas");
                              canvas.width = width;
                              canvas.height = height;
                              ctx = canvas.getContext("2d");
                              gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                              processColorStops(backgroundImage3.stops, lineLength).forEach(function(colorStop) {
                                return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                              });
                              ctx.fillStyle = gradient_1;
                              ctx.fillRect(0, 0, width, height);
                              if (width > 0 && height > 0) {
                                pattern = this_1.ctx.createPattern(canvas, "repeat");
                                this_1.renderRepeat(path, pattern, x2, y3);
                              }
                            } else if (isRadialGradient(backgroundImage3)) {
                              _f = calculateBackgroundRendering(container, index3, [
                                null,
                                null,
                                null
                              ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                              position2 = backgroundImage3.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage3.position;
                              x2 = getAbsoluteValue(position2[0], width);
                              y3 = getAbsoluteValue(position2[position2.length - 1], height);
                              _g = calculateRadius(backgroundImage3, x2, y3, width, height), rx = _g[0], ry = _g[1];
                              if (rx > 0 && ry > 0) {
                                radialGradient_1 = this_1.ctx.createRadialGradient(left + x2, top_1 + y3, 0, left + x2, top_1 + y3, rx);
                                processColorStops(backgroundImage3.stops, rx * 2).forEach(function(colorStop) {
                                  return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                });
                                this_1.path(path);
                                this_1.ctx.fillStyle = radialGradient_1;
                                if (rx !== ry) {
                                  midX = container.bounds.left + 0.5 * container.bounds.width;
                                  midY = container.bounds.top + 0.5 * container.bounds.height;
                                  f4 = ry / rx;
                                  invF = 1 / f4;
                                  this_1.ctx.save();
                                  this_1.ctx.translate(midX, midY);
                                  this_1.ctx.transform(1, 0, 0, f4, 0, 0);
                                  this_1.ctx.translate(-midX, -midY);
                                  this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                  this_1.ctx.restore();
                                } else {
                                  this_1.ctx.fill();
                                }
                              }
                            }
                            _h.label = 6;
                          case 6:
                            index3--;
                            return [2];
                        }
                      });
                    };
                    this_1 = this;
                    _i = 0, _a3 = container.styles.backgroundImage.slice(0).reverse();
                    _b2.label = 1;
                  case 1:
                    if (!(_i < _a3.length))
                      return [3, 4];
                    backgroundImage2 = _a3[_i];
                    return [5, _loop_1(backgroundImage2)];
                  case 2:
                    _b2.sent();
                    _b2.label = 3;
                  case 3:
                    _i++;
                    return [3, 1];
                  case 4:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderSolidBorder = function(color2, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
              return __generator(this, function(_a3) {
                this.path(parsePathForBorder(curvePoints, side));
                this.ctx.fillStyle = asString(color2);
                this.ctx.fill();
                return [2];
              });
            });
          };
          CanvasRenderer2.prototype.renderDoubleBorder = function(color2, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
              var outerPaths, innerPaths;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    if (!(width < 3))
                      return [3, 2];
                    return [4, this.renderSolidBorder(color2, side, curvePoints)];
                  case 1:
                    _a3.sent();
                    return [2];
                  case 2:
                    outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                    this.path(outerPaths);
                    this.ctx.fillStyle = asString(color2);
                    this.ctx.fill();
                    innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                    this.path(innerPaths);
                    this.ctx.fill();
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
              var styles2, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
              var _this = this;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    this.applyEffects(paint.getEffects(2));
                    styles2 = paint.container.styles;
                    hasBackground = !isTransparent(styles2.backgroundColor) || styles2.backgroundImage.length;
                    borders = [
                      { style: styles2.borderTopStyle, color: styles2.borderTopColor, width: styles2.borderTopWidth },
                      { style: styles2.borderRightStyle, color: styles2.borderRightColor, width: styles2.borderRightWidth },
                      { style: styles2.borderBottomStyle, color: styles2.borderBottomColor, width: styles2.borderBottomWidth },
                      { style: styles2.borderLeftStyle, color: styles2.borderLeftColor, width: styles2.borderLeftWidth }
                    ];
                    backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles2.backgroundClip, 0), paint.curves);
                    if (!(hasBackground || styles2.boxShadow.length))
                      return [3, 2];
                    this.ctx.save();
                    this.path(backgroundPaintingArea);
                    this.ctx.clip();
                    if (!isTransparent(styles2.backgroundColor)) {
                      this.ctx.fillStyle = asString(styles2.backgroundColor);
                      this.ctx.fill();
                    }
                    return [4, this.renderBackgroundImage(paint.container)];
                  case 1:
                    _a3.sent();
                    this.ctx.restore();
                    styles2.boxShadow.slice(0).reverse().forEach(function(shadow) {
                      _this.ctx.save();
                      var borderBoxArea = calculateBorderBoxPath(paint.curves);
                      var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                      var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                      if (shadow.inset) {
                        _this.path(borderBoxArea);
                        _this.ctx.clip();
                        _this.mask(shadowPaintingArea);
                      } else {
                        _this.mask(borderBoxArea);
                        _this.ctx.clip();
                        _this.path(shadowPaintingArea);
                      }
                      _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                      _this.ctx.shadowOffsetY = shadow.offsetY.number;
                      _this.ctx.shadowColor = asString(shadow.color);
                      _this.ctx.shadowBlur = shadow.blur.number;
                      _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                      _this.ctx.fill();
                      _this.ctx.restore();
                    });
                    _a3.label = 2;
                  case 2:
                    side = 0;
                    _i = 0, borders_1 = borders;
                    _a3.label = 3;
                  case 3:
                    if (!(_i < borders_1.length))
                      return [3, 13];
                    border = borders_1[_i];
                    if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color) && border.width > 0))
                      return [3, 11];
                    if (!(border.style === BORDER_STYLE.DASHED))
                      return [3, 5];
                    return [4, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DASHED)];
                  case 4:
                    _a3.sent();
                    return [3, 11];
                  case 5:
                    if (!(border.style === BORDER_STYLE.DOTTED))
                      return [3, 7];
                    return [4, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DOTTED)];
                  case 6:
                    _a3.sent();
                    return [3, 11];
                  case 7:
                    if (!(border.style === BORDER_STYLE.DOUBLE))
                      return [3, 9];
                    return [4, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                  case 8:
                    _a3.sent();
                    return [3, 11];
                  case 9:
                    return [4, this.renderSolidBorder(border.color, side, paint.curves)];
                  case 10:
                    _a3.sent();
                    _a3.label = 11;
                  case 11:
                    side++;
                    _a3.label = 12;
                  case 12:
                    _i++;
                    return [3, 3];
                  case 13:
                    return [2];
                }
              });
            });
          };
          CanvasRenderer2.prototype.renderDashedDottedBorder = function(color2, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
              var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
              return __generator(this, function(_a3) {
                this.ctx.save();
                strokePaths = parsePathForBorderStroke(curvePoints, side);
                boxPaths = parsePathForBorder(curvePoints, side);
                if (style === BORDER_STYLE.DASHED) {
                  this.path(boxPaths);
                  this.ctx.clip();
                }
                if (isBezierCurve(boxPaths[0])) {
                  startX = boxPaths[0].start.x;
                  startY = boxPaths[0].start.y;
                } else {
                  startX = boxPaths[0].x;
                  startY = boxPaths[0].y;
                }
                if (isBezierCurve(boxPaths[1])) {
                  endX = boxPaths[1].end.x;
                  endY = boxPaths[1].end.y;
                } else {
                  endX = boxPaths[1].x;
                  endY = boxPaths[1].y;
                }
                if (side === 0 || side === 2) {
                  length = Math.abs(startX - endX);
                } else {
                  length = Math.abs(startY - endY);
                }
                this.ctx.beginPath();
                if (style === BORDER_STYLE.DOTTED) {
                  this.formatPath(strokePaths);
                } else {
                  this.formatPath(boxPaths.slice(0, 2));
                }
                dashLength = width < 3 ? width * 3 : width * 2;
                spaceLength = width < 3 ? width * 2 : width;
                if (style === BORDER_STYLE.DOTTED) {
                  dashLength = width;
                  spaceLength = width;
                }
                useLineDash = true;
                if (length <= dashLength * 2) {
                  useLineDash = false;
                } else if (length <= dashLength * 2 + spaceLength) {
                  multiplier = length / (2 * dashLength + spaceLength);
                  dashLength *= multiplier;
                  spaceLength *= multiplier;
                } else {
                  numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                  minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                  maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                  spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                }
                if (useLineDash) {
                  if (style === BORDER_STYLE.DOTTED) {
                    this.ctx.setLineDash([0, dashLength + spaceLength]);
                  } else {
                    this.ctx.setLineDash([dashLength, spaceLength]);
                  }
                }
                if (style === BORDER_STYLE.DOTTED) {
                  this.ctx.lineCap = "round";
                  this.ctx.lineWidth = width;
                } else {
                  this.ctx.lineWidth = width * 2 + 1.1;
                }
                this.ctx.strokeStyle = asString(color2);
                this.ctx.stroke();
                this.ctx.setLineDash([]);
                if (style === BORDER_STYLE.DASHED) {
                  if (isBezierCurve(boxPaths[0])) {
                    path1 = boxPaths[3];
                    path2 = boxPaths[0];
                    this.ctx.beginPath();
                    this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                    this.ctx.stroke();
                  }
                  if (isBezierCurve(boxPaths[1])) {
                    path1 = boxPaths[1];
                    path2 = boxPaths[2];
                    this.ctx.beginPath();
                    this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                    this.ctx.stroke();
                  }
                }
                this.ctx.restore();
                return [2];
              });
            });
          };
          CanvasRenderer2.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
              var stack2;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    if (this.options.backgroundColor) {
                      this.ctx.fillStyle = asString(this.options.backgroundColor);
                      this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                    }
                    stack2 = parseStackingContexts(element);
                    return [4, this.renderStack(stack2)];
                  case 1:
                    _a3.sent();
                    this.applyEffects([]);
                    return [2, this.canvas];
                }
              });
            });
          };
          return CanvasRenderer2;
        }(Renderer);
        var isTextInputElement = function(container) {
          if (container instanceof TextareaElementContainer) {
            return true;
          } else if (container instanceof SelectElementContainer) {
            return true;
          } else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
          }
          return false;
        };
        var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
          switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
              return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
              return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
              return calculatePaddingBoxPath(curves);
          }
        };
        var canvasTextAlign = function(textAlign2) {
          switch (textAlign2) {
            case TEXT_ALIGN.CENTER:
              return "center";
            case TEXT_ALIGN.RIGHT:
              return "right";
            case TEXT_ALIGN.LEFT:
            default:
              return "left";
          }
        };
        var ForeignObjectRenderer = function(_super) {
          __extends(ForeignObjectRenderer2, _super);
          function ForeignObjectRenderer2(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
          }
          ForeignObjectRenderer2.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
              var svg, img;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                    return [4, loadSerializedSVG(svg)];
                  case 1:
                    img = _a3.sent();
                    if (this.options.backgroundColor) {
                      this.ctx.fillStyle = asString(this.options.backgroundColor);
                      this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                    }
                    this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                    return [2, this.canvas];
                }
              });
            });
          };
          return ForeignObjectRenderer2;
        }(Renderer);
        var loadSerializedSVG = function(svg) {
          return new Promise(function(resolve3, reject2) {
            var img = new Image();
            img.onload = function() {
              resolve3(img);
            };
            img.onerror = reject2;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
          });
        };
        var Logger = function() {
          function Logger2(_a3) {
            var id = _a3.id, enabled = _a3.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
          }
          Logger2.prototype.debug = function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (this.enabled) {
              if (typeof window !== "undefined" && window.console && typeof console.debug === "function") {
                console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
              } else {
                this.info.apply(this, args);
              }
            }
          };
          Logger2.prototype.getTime = function() {
            return Date.now() - this.start;
          };
          Logger2.prototype.info = function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (this.enabled) {
              if (typeof window !== "undefined" && window.console && typeof console.info === "function") {
                console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
              }
            }
          };
          Logger2.prototype.warn = function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (this.enabled) {
              if (typeof window !== "undefined" && window.console && typeof console.warn === "function") {
                console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
              } else {
                this.info.apply(this, args);
              }
            }
          };
          Logger2.prototype.error = function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (this.enabled) {
              if (typeof window !== "undefined" && window.console && typeof console.error === "function") {
                console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
              } else {
                this.info.apply(this, args);
              }
            }
          };
          Logger2.instances = {};
          return Logger2;
        }();
        var Context = function() {
          function Context2(options, windowBounds) {
            var _a3;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context2.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a3 = options.cache) !== null && _a3 !== void 0 ? _a3 : new Cache(this, options);
          }
          Context2.instanceCount = 1;
          return Context2;
        }();
        var html2canvas = function(element, options) {
          if (options === void 0) {
            options = {};
          }
          return renderElement(element, options);
        };
        if (typeof window !== "undefined") {
          CacheStorage.setContext(window);
        }
        var renderElement = function(element, opts) {
          return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a3, width, height, left, top, backgroundColor2, renderOptions, canvas, renderer2, root, renderer2;
            var _b2, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t2;
            return __generator(this, function(_u) {
              switch (_u.label) {
                case 0:
                  if (!element || typeof element !== "object") {
                    return [2, Promise.reject("Invalid element provided as first argument")];
                  }
                  ownerDocument = element.ownerDocument;
                  if (!ownerDocument) {
                    throw new Error("Element is not attached to a Document");
                  }
                  defaultView = ownerDocument.defaultView;
                  if (!defaultView) {
                    throw new Error("Document is not attached to a Window");
                  }
                  resourceOptions = {
                    allowTaint: (_b2 = opts.allowTaint) !== null && _b2 !== void 0 ? _b2 : false,
                    imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15e3,
                    proxy: opts.proxy,
                    useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                  };
                  contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                  windowOptions = {
                    windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                    windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                    scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                    scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                  };
                  windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                  context = new Context(contextOptions, windowBounds);
                  foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                  cloneOptions = {
                    allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                    onclone: opts.onclone,
                    ignoreElements: opts.ignoreElements,
                    inlineImages: foreignObjectRendering,
                    copyStyles: foreignObjectRendering
                  };
                  context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                  documentCloner = new DocumentCloner(context, element, cloneOptions);
                  clonedElement = documentCloner.clonedReferenceElement;
                  if (!clonedElement) {
                    return [2, Promise.reject("Unable to find element in cloned iframe")];
                  }
                  return [4, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                  container = _u.sent();
                  _a3 = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a3.width, height = _a3.height, left = _a3.left, top = _a3.top;
                  backgroundColor2 = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                  renderOptions = {
                    canvas: opts.canvas,
                    backgroundColor: backgroundColor2,
                    scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                    x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                    y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                    width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                    height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                  };
                  if (!foreignObjectRendering)
                    return [3, 3];
                  context.logger.debug("Document cloned, using foreign object rendering");
                  renderer2 = new ForeignObjectRenderer(context, renderOptions);
                  return [4, renderer2.render(clonedElement)];
                case 2:
                  canvas = _u.sent();
                  return [3, 5];
                case 3:
                  context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                  context.logger.debug("Starting DOM parsing");
                  root = parseTree(context, clonedElement);
                  if (backgroundColor2 === root.styles.backgroundColor) {
                    root.styles.backgroundColor = COLORS.TRANSPARENT;
                  }
                  context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                  renderer2 = new CanvasRenderer(context, renderOptions);
                  return [4, renderer2.render(root)];
                case 4:
                  canvas = _u.sent();
                  _u.label = 5;
                case 5:
                  if ((_t2 = opts.removeContainer) !== null && _t2 !== void 0 ? _t2 : true) {
                    if (!DocumentCloner.destroy(container)) {
                      context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                    }
                  }
                  context.logger.debug("Finished rendering");
                  return [2, canvas];
              }
            });
          });
        };
        var parseBackgroundColor = function(context, element, backgroundColorOverride) {
          var ownerDocument = element.ownerDocument;
          var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
          var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
          var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 4294967295;
          return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
        };
        return html2canvas;
      });
    }
  });

  // node_modules/dompurify/dist/purify.js
  var require_purify = __commonJS({
    "node_modules/dompurify/dist/purify.js"(exports, module) {
      (function(global4, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global4 = global4 || self, global4.DOMPurify = factory());
      })(exports, function() {
        "use strict";
        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i3 = 0, arr2 = Array(arr.length); i3 < arr.length; i3++) {
              arr2[i3] = arr[i3];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }
        var hasOwnProperty3 = Object.hasOwnProperty, setPrototypeOf2 = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor3 = Object.getOwnPropertyDescriptor;
        var freeze = Object.freeze, seal = Object.seal, create = Object.create;
        var _ref = typeof Reflect !== "undefined" && Reflect, apply3 = _ref.apply, construct = _ref.construct;
        if (!apply3) {
          apply3 = function apply4(fun, thisValue, args) {
            return fun.apply(thisValue, args);
          };
        }
        if (!freeze) {
          freeze = function freeze2(x2) {
            return x2;
          };
        }
        if (!seal) {
          seal = function seal2(x2) {
            return x2;
          };
        }
        if (!construct) {
          construct = function construct2(Func, args) {
            return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
          };
        }
        var arrayForEach = unapply(Array.prototype.forEach);
        var arrayPop = unapply(Array.prototype.pop);
        var arrayPush = unapply(Array.prototype.push);
        var stringToLowerCase = unapply(String.prototype.toLowerCase);
        var stringMatch = unapply(String.prototype.match);
        var stringReplace = unapply(String.prototype.replace);
        var stringIndexOf3 = unapply(String.prototype.indexOf);
        var stringTrim = unapply(String.prototype.trim);
        var regExpTest = unapply(RegExp.prototype.test);
        var typeErrorCreate = unconstruct(TypeError);
        function unapply(func) {
          return function(thisArg) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            return apply3(func, thisArg, args);
          };
        }
        function unconstruct(func) {
          return function() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return construct(func, args);
          };
        }
        function addToSet(set4, array) {
          if (setPrototypeOf2) {
            setPrototypeOf2(set4, null);
          }
          var l3 = array.length;
          while (l3--) {
            var element = array[l3];
            if (typeof element === "string") {
              var lcElement = stringToLowerCase(element);
              if (lcElement !== element) {
                if (!isFrozen(array)) {
                  array[l3] = lcElement;
                }
                element = lcElement;
              }
            }
            set4[element] = true;
          }
          return set4;
        }
        function clone2(object) {
          var newObject = create(null);
          var property = void 0;
          for (property in object) {
            if (apply3(hasOwnProperty3, object, [property])) {
              newObject[property] = object[property];
            }
          }
          return newObject;
        }
        function lookupGetter(object, prop) {
          while (object !== null) {
            var desc = getOwnPropertyDescriptor3(object, prop);
            if (desc) {
              if (desc.get) {
                return unapply(desc.get);
              }
              if (typeof desc.value === "function") {
                return unapply(desc.value);
              }
            }
            object = getPrototypeOf(object);
          }
          function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
          }
          return fallbackValue;
        }
        var html2 = freeze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]);
        var svg = freeze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]);
        var svgFilters = freeze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]);
        var svgDisallowed = freeze(["animate", "color-profile", "cursor", "discard", "fedropshadow", "feimage", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]);
        var mathMl = freeze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]);
        var mathMlDisallowed = freeze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]);
        var text2 = freeze(["#text"]);
        var html$1 = freeze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]);
        var svg$1 = freeze(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]);
        var mathMl$1 = freeze(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]);
        var xml = freeze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]);
        var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm);
        var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
        var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
        var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
        var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
        var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
        var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
        var _typeof3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
          return typeof obj;
        } : function(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function _toConsumableArray$1(arr) {
          if (Array.isArray(arr)) {
            for (var i3 = 0, arr2 = Array(arr.length); i3 < arr.length; i3++) {
              arr2[i3] = arr[i3];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }
        var getGlobal = function getGlobal2() {
          return typeof window === "undefined" ? null : window;
        };
        var _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, document3) {
          if ((typeof trustedTypes === "undefined" ? "undefined" : _typeof3(trustedTypes)) !== "object" || typeof trustedTypes.createPolicy !== "function") {
            return null;
          }
          var suffix = null;
          var ATTR_NAME = "data-tt-policy-suffix";
          if (document3.currentScript && document3.currentScript.hasAttribute(ATTR_NAME)) {
            suffix = document3.currentScript.getAttribute(ATTR_NAME);
          }
          var policyName = "dompurify" + (suffix ? "#" + suffix : "");
          try {
            return trustedTypes.createPolicy(policyName, {
              createHTML: function createHTML(html$$1) {
                return html$$1;
              }
            });
          } catch (_3) {
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
          }
        };
        function createDOMPurify() {
          var window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
          var DOMPurify = function DOMPurify2(root) {
            return createDOMPurify(root);
          };
          DOMPurify.version = "2.3.3";
          DOMPurify.removed = [];
          if (!window2 || !window2.document || window2.document.nodeType !== 9) {
            DOMPurify.isSupported = false;
            return DOMPurify;
          }
          var originalDocument = window2.document;
          var document3 = window2.document;
          var DocumentFragment = window2.DocumentFragment, HTMLTemplateElement = window2.HTMLTemplateElement, Node2 = window2.Node, Element3 = window2.Element, NodeFilter = window2.NodeFilter, _window$NamedNodeMap = window2.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window2.NamedNodeMap || window2.MozNamedAttrMap : _window$NamedNodeMap, Text2 = window2.Text, Comment2 = window2.Comment, DOMParser2 = window2.DOMParser, trustedTypes = window2.trustedTypes;
          var ElementPrototype = Element3.prototype;
          var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
          var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
          var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
          var getParentNode = lookupGetter(ElementPrototype, "parentNode");
          if (typeof HTMLTemplateElement === "function") {
            var template = document3.createElement("template");
            if (template.content && template.content.ownerDocument) {
              document3 = template.content.ownerDocument;
            }
          }
          var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
          var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML("") : "";
          var _document = document3, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
          var importNode = originalDocument.importNode;
          var documentMode = {};
          try {
            documentMode = clone2(document3).documentMode ? document3.documentMode : {};
          } catch (_3) {
          }
          var hooks = {};
          DOMPurify.isSupported = typeof getParentNode === "function" && implementation && typeof implementation.createHTMLDocument !== "undefined" && documentMode !== 9;
          var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR, ERB_EXPR$$1 = ERB_EXPR, DATA_ATTR$$1 = DATA_ATTR, ARIA_ATTR$$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
          var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;
          var ALLOWED_TAGS = null;
          var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html2), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text2)));
          var ALLOWED_ATTR = null;
          var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));
          var FORBID_TAGS = null;
          var FORBID_ATTR = null;
          var ALLOW_ARIA_ATTR = true;
          var ALLOW_DATA_ATTR = true;
          var ALLOW_UNKNOWN_PROTOCOLS = false;
          var SAFE_FOR_TEMPLATES = false;
          var WHOLE_DOCUMENT = false;
          var SET_CONFIG = false;
          var FORCE_BODY = false;
          var RETURN_DOM = false;
          var RETURN_DOM_FRAGMENT = false;
          var RETURN_DOM_IMPORT = true;
          var RETURN_TRUSTED_TYPE = false;
          var SANITIZE_DOM = true;
          var KEEP_CONTENT = true;
          var IN_PLACE = false;
          var USE_PROFILES = {};
          var FORBID_CONTENTS = null;
          var DEFAULT_FORBID_CONTENTS = addToSet({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
          var DATA_URI_TAGS = null;
          var DEFAULT_DATA_URI_TAGS = addToSet({}, ["audio", "video", "img", "source", "image", "track"]);
          var URI_SAFE_ATTRIBUTES = null;
          var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]);
          var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
          var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
          var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
          var NAMESPACE = HTML_NAMESPACE;
          var IS_EMPTY_INPUT = false;
          var PARSER_MEDIA_TYPE = void 0;
          var SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
          var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
          var transformCaseFunc = void 0;
          var CONFIG = null;
          var formElement = document3.createElement("form");
          var _parseConfig = function _parseConfig2(cfg) {
            if (CONFIG && CONFIG === cfg) {
              return;
            }
            if (!cfg || (typeof cfg === "undefined" ? "undefined" : _typeof3(cfg)) !== "object") {
              cfg = {};
            }
            cfg = clone2(cfg);
            ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone2(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone2(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
            RETURN_DOM = cfg.RETURN_DOM || false;
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
            RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false;
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
            FORCE_BODY = cfg.FORCE_BODY || false;
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
            IN_PLACE = cfg.IN_PLACE || false;
            IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? function(x2) {
              return x2;
            } : stringToLowerCase;
            if (SAFE_FOR_TEMPLATES) {
              ALLOW_DATA_ATTR = false;
            }
            if (RETURN_DOM_FRAGMENT) {
              RETURN_DOM = true;
            }
            if (USE_PROFILES) {
              ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text2)));
              ALLOWED_ATTR = [];
              if (USE_PROFILES.html === true) {
                addToSet(ALLOWED_TAGS, html2);
                addToSet(ALLOWED_ATTR, html$1);
              }
              if (USE_PROFILES.svg === true) {
                addToSet(ALLOWED_TAGS, svg);
                addToSet(ALLOWED_ATTR, svg$1);
                addToSet(ALLOWED_ATTR, xml);
              }
              if (USE_PROFILES.svgFilters === true) {
                addToSet(ALLOWED_TAGS, svgFilters);
                addToSet(ALLOWED_ATTR, svg$1);
                addToSet(ALLOWED_ATTR, xml);
              }
              if (USE_PROFILES.mathMl === true) {
                addToSet(ALLOWED_TAGS, mathMl);
                addToSet(ALLOWED_ATTR, mathMl$1);
                addToSet(ALLOWED_ATTR, xml);
              }
            }
            if (cfg.ADD_TAGS) {
              if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                ALLOWED_TAGS = clone2(ALLOWED_TAGS);
              }
              addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
            }
            if (cfg.ADD_ATTR) {
              if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                ALLOWED_ATTR = clone2(ALLOWED_ATTR);
              }
              addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
            }
            if (cfg.ADD_URI_SAFE_ATTR) {
              addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
            }
            if (cfg.FORBID_CONTENTS) {
              if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
                FORBID_CONTENTS = clone2(FORBID_CONTENTS);
              }
              addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
            }
            if (KEEP_CONTENT) {
              ALLOWED_TAGS["#text"] = true;
            }
            if (WHOLE_DOCUMENT) {
              addToSet(ALLOWED_TAGS, ["html", "head", "body"]);
            }
            if (ALLOWED_TAGS.table) {
              addToSet(ALLOWED_TAGS, ["tbody"]);
              delete FORBID_TAGS.tbody;
            }
            if (freeze) {
              freeze(cfg);
            }
            CONFIG = cfg;
          };
          var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ["mi", "mo", "mn", "ms", "mtext"]);
          var HTML_INTEGRATION_POINTS = addToSet({}, ["foreignobject", "desc", "title", "annotation-xml"]);
          var ALL_SVG_TAGS = addToSet({}, svg);
          addToSet(ALL_SVG_TAGS, svgFilters);
          addToSet(ALL_SVG_TAGS, svgDisallowed);
          var ALL_MATHML_TAGS = addToSet({}, mathMl);
          addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
          var _checkValidNamespace = function _checkValidNamespace2(element) {
            var parent2 = getParentNode(element);
            if (!parent2 || !parent2.tagName) {
              parent2 = {
                namespaceURI: HTML_NAMESPACE,
                tagName: "template"
              };
            }
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent2.tagName);
            if (element.namespaceURI === SVG_NAMESPACE) {
              if (parent2.namespaceURI === HTML_NAMESPACE) {
                return tagName === "svg";
              }
              if (parent2.namespaceURI === MATHML_NAMESPACE) {
                return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
              }
              return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
              if (parent2.namespaceURI === HTML_NAMESPACE) {
                return tagName === "math";
              }
              if (parent2.namespaceURI === SVG_NAMESPACE) {
                return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
              }
              return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
              if (parent2.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
                return false;
              }
              if (parent2.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
                return false;
              }
              var commonSvgAndHTMLElements = addToSet({}, ["title", "style", "font", "a", "script"]);
              return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            return false;
          };
          var _forceRemove = function _forceRemove2(node2) {
            arrayPush(DOMPurify.removed, { element: node2 });
            try {
              node2.parentNode.removeChild(node2);
            } catch (_3) {
              try {
                node2.outerHTML = emptyHTML;
              } catch (_4) {
                node2.remove();
              }
            }
          };
          var _removeAttribute = function _removeAttribute2(name, node2) {
            try {
              arrayPush(DOMPurify.removed, {
                attribute: node2.getAttributeNode(name),
                from: node2
              });
            } catch (_3) {
              arrayPush(DOMPurify.removed, {
                attribute: null,
                from: node2
              });
            }
            node2.removeAttribute(name);
            if (name === "is" && !ALLOWED_ATTR[name]) {
              if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
                try {
                  _forceRemove(node2);
                } catch (_3) {
                }
              } else {
                try {
                  node2.setAttribute(name, "");
                } catch (_3) {
                }
              }
            }
          };
          var _initDocument = function _initDocument2(dirty) {
            var doc2 = void 0;
            var leadingWhitespace = void 0;
            if (FORCE_BODY) {
              dirty = "<remove></remove>" + dirty;
            } else {
              var matches = stringMatch(dirty, /^[\r\n\t ]+/);
              leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml") {
              dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            }
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            if (NAMESPACE === HTML_NAMESPACE) {
              try {
                doc2 = new DOMParser2().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
              } catch (_3) {
              }
            }
            if (!doc2 || !doc2.documentElement) {
              doc2 = implementation.createDocument(NAMESPACE, "template", null);
              try {
                doc2.documentElement.innerHTML = IS_EMPTY_INPUT ? "" : dirtyPayload;
              } catch (_3) {
              }
            }
            var body = doc2.body || doc2.documentElement;
            if (dirty && leadingWhitespace) {
              body.insertBefore(document3.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            }
            if (NAMESPACE === HTML_NAMESPACE) {
              return getElementsByTagName.call(doc2, WHOLE_DOCUMENT ? "html" : "body")[0];
            }
            return WHOLE_DOCUMENT ? doc2.documentElement : body;
          };
          var _createIterator = function _createIterator2(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
          };
          var _isClobbered = function _isClobbered2(elm) {
            if (elm instanceof Text2 || elm instanceof Comment2) {
              return false;
            }
            if (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function") {
              return true;
            }
            return false;
          };
          var _isNode = function _isNode2(object) {
            return (typeof Node2 === "undefined" ? "undefined" : _typeof3(Node2)) === "object" ? object instanceof Node2 : object && (typeof object === "undefined" ? "undefined" : _typeof3(object)) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
          };
          var _executeHook = function _executeHook2(entryPoint, currentNode, data2) {
            if (!hooks[entryPoint]) {
              return;
            }
            arrayForEach(hooks[entryPoint], function(hook) {
              hook.call(DOMPurify, currentNode, data2, CONFIG);
            });
          };
          var _sanitizeElements = function _sanitizeElements2(currentNode) {
            var content = void 0;
            _executeHook("beforeSanitizeElements", currentNode, null);
            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);
              return true;
            }
            if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
              _forceRemove(currentNode);
              return true;
            }
            var tagName = transformCaseFunc(currentNode.nodeName);
            _executeHook("uponSanitizeElement", currentNode, {
              tagName,
              allowedTags: ALLOWED_TAGS
            });
            if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
              _forceRemove(currentNode);
              return true;
            }
            if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
              _forceRemove(currentNode);
              return true;
            }
            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                  var childCount = childNodes.length;
                  for (var i3 = childCount - 1; i3 >= 0; --i3) {
                    parentNode.insertBefore(cloneNode(childNodes[i3], true), getNextSibling(currentNode));
                  }
                }
              }
              _forceRemove(currentNode);
              return true;
            }
            if (currentNode instanceof Element3 && !_checkValidNamespace(currentNode)) {
              _forceRemove(currentNode);
              return true;
            }
            if ((tagName === "noscript" || tagName === "noembed") && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
              _forceRemove(currentNode);
              return true;
            }
            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
              content = currentNode.textContent;
              content = stringReplace(content, MUSTACHE_EXPR$$1, " ");
              content = stringReplace(content, ERB_EXPR$$1, " ");
              if (currentNode.textContent !== content) {
                arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
                currentNode.textContent = content;
              }
            }
            _executeHook("afterSanitizeElements", currentNode, null);
            return false;
          };
          var _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value) {
            if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document3 || value in formElement)) {
              return false;
            }
            if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName))
              ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName))
              ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
              return false;
            } else if (URI_SAFE_ATTRIBUTES[lcName])
              ;
            else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, "")))
              ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf3(value, "data:") === 0 && DATA_URI_TAGS[lcTag])
              ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, "")))
              ;
            else if (!value)
              ;
            else {
              return false;
            }
            return true;
          };
          var _sanitizeAttributes = function _sanitizeAttributes2(currentNode) {
            var attr2 = void 0;
            var value = void 0;
            var lcName = void 0;
            var l3 = void 0;
            _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            if (!attributes) {
              return;
            }
            var hookEvent = {
              attrName: "",
              attrValue: "",
              keepAttr: true,
              allowedAttributes: ALLOWED_ATTR
            };
            l3 = attributes.length;
            while (l3--) {
              attr2 = attributes[l3];
              var _attr = attr2, name = _attr.name, namespaceURI = _attr.namespaceURI;
              value = stringTrim(attr2.value);
              lcName = transformCaseFunc(name);
              hookEvent.attrName = lcName;
              hookEvent.attrValue = value;
              hookEvent.keepAttr = true;
              hookEvent.forceKeepAttr = void 0;
              _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
              value = hookEvent.attrValue;
              if (hookEvent.forceKeepAttr) {
                continue;
              }
              _removeAttribute(name, currentNode);
              if (!hookEvent.keepAttr) {
                continue;
              }
              if (regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
              }
              if (SAFE_FOR_TEMPLATES) {
                value = stringReplace(value, MUSTACHE_EXPR$$1, " ");
                value = stringReplace(value, ERB_EXPR$$1, " ");
              }
              var lcTag = transformCaseFunc(currentNode.nodeName);
              if (!_isValidAttribute(lcTag, lcName, value)) {
                continue;
              }
              try {
                if (namespaceURI) {
                  currentNode.setAttributeNS(namespaceURI, name, value);
                } else {
                  currentNode.setAttribute(name, value);
                }
                arrayPop(DOMPurify.removed);
              } catch (_3) {
              }
            }
            _executeHook("afterSanitizeAttributes", currentNode, null);
          };
          var _sanitizeShadowDOM = function _sanitizeShadowDOM2(fragment) {
            var shadowNode = void 0;
            var shadowIterator = _createIterator(fragment);
            _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while (shadowNode = shadowIterator.nextNode()) {
              _executeHook("uponSanitizeShadowNode", shadowNode, null);
              if (_sanitizeElements(shadowNode)) {
                continue;
              }
              if (shadowNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM2(shadowNode.content);
              }
              _sanitizeAttributes(shadowNode);
            }
            _executeHook("afterSanitizeShadowDOM", fragment, null);
          };
          DOMPurify.sanitize = function(dirty, cfg) {
            var body = void 0;
            var importedNode = void 0;
            var currentNode = void 0;
            var oldNode = void 0;
            var returnNode = void 0;
            IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) {
              dirty = "<!-->";
            }
            if (typeof dirty !== "string" && !_isNode(dirty)) {
              if (typeof dirty.toString !== "function") {
                throw typeErrorCreate("toString is not a function");
              } else {
                dirty = dirty.toString();
                if (typeof dirty !== "string") {
                  throw typeErrorCreate("dirty is not a string, aborting");
                }
              }
            }
            if (!DOMPurify.isSupported) {
              if (_typeof3(window2.toStaticHTML) === "object" || typeof window2.toStaticHTML === "function") {
                if (typeof dirty === "string") {
                  return window2.toStaticHTML(dirty);
                }
                if (_isNode(dirty)) {
                  return window2.toStaticHTML(dirty.outerHTML);
                }
              }
              return dirty;
            }
            if (!SET_CONFIG) {
              _parseConfig(cfg);
            }
            DOMPurify.removed = [];
            if (typeof dirty === "string") {
              IN_PLACE = false;
            }
            if (IN_PLACE)
              ;
            else if (dirty instanceof Node2) {
              body = _initDocument("<!---->");
              importedNode = body.ownerDocument.importNode(dirty, true);
              if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") {
                body = importedNode;
              } else if (importedNode.nodeName === "HTML") {
                body = importedNode;
              } else {
                body.appendChild(importedNode);
              }
            } else {
              if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) {
                return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
              }
              body = _initDocument(dirty);
              if (!body) {
                return RETURN_DOM ? null : emptyHTML;
              }
            }
            if (body && FORCE_BODY) {
              _forceRemove(body.firstChild);
            }
            var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            while (currentNode = nodeIterator.nextNode()) {
              if (currentNode.nodeType === 3 && currentNode === oldNode) {
                continue;
              }
              if (_sanitizeElements(currentNode)) {
                continue;
              }
              if (currentNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(currentNode.content);
              }
              _sanitizeAttributes(currentNode);
              oldNode = currentNode;
            }
            oldNode = null;
            if (IN_PLACE) {
              return dirty;
            }
            if (RETURN_DOM) {
              if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while (body.firstChild) {
                  returnNode.appendChild(body.firstChild);
                }
              } else {
                returnNode = body;
              }
              if (RETURN_DOM_IMPORT) {
                returnNode = importNode.call(originalDocument, returnNode, true);
              }
              return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            if (SAFE_FOR_TEMPLATES) {
              serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, " ");
              serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
          };
          DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
          };
          DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
          };
          DOMPurify.isValidAttribute = function(tag, attr2, value) {
            if (!CONFIG) {
              _parseConfig({});
            }
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr2);
            return _isValidAttribute(lcTag, lcName, value);
          };
          DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") {
              return;
            }
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
          };
          DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) {
              arrayPop(hooks[entryPoint]);
            }
          };
          DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) {
              hooks[entryPoint] = [];
            }
          };
          DOMPurify.removeAllHooks = function() {
            hooks = {};
          };
          return DOMPurify;
        }
        var purify = createDOMPurify();
        return purify;
      });
    }
  });

  // node_modules/core-js/internals/global.js
  var require_global = __commonJS({
    "node_modules/core-js/internals/global.js"(exports, module) {
      var check = function(it2) {
        return it2 && it2.Math == Math && it2;
      };
      module.exports = check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof global == "object" && global) || function() {
        return this;
      }() || Function("return this")();
    }
  });

  // node_modules/core-js/internals/fails.js
  var require_fails = __commonJS({
    "node_modules/core-js/internals/fails.js"(exports, module) {
      module.exports = function(exec2) {
        try {
          return !!exec2();
        } catch (error2) {
          return true;
        }
      };
    }
  });

  // node_modules/core-js/internals/descriptors.js
  var require_descriptors = __commonJS({
    "node_modules/core-js/internals/descriptors.js"(exports, module) {
      var fails4 = require_fails();
      module.exports = !fails4(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }
  });

  // node_modules/core-js/internals/function-call.js
  var require_function_call = __commonJS({
    "node_modules/core-js/internals/function-call.js"(exports, module) {
      var call5 = Function.prototype.call;
      module.exports = call5.bind ? call5.bind(call5) : function() {
        return call5.apply(call5, arguments);
      };
    }
  });

  // node_modules/core-js/internals/object-property-is-enumerable.js
  var require_object_property_is_enumerable = __commonJS({
    "node_modules/core-js/internals/object-property-is-enumerable.js"(exports) {
      "use strict";
      var $propertyIsEnumerable = {}.propertyIsEnumerable;
      var getOwnPropertyDescriptor3 = Object.getOwnPropertyDescriptor;
      var NASHORN_BUG = getOwnPropertyDescriptor3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);
      exports.f = NASHORN_BUG ? function propertyIsEnumerable(V2) {
        var descriptor = getOwnPropertyDescriptor3(this, V2);
        return !!descriptor && descriptor.enumerable;
      } : $propertyIsEnumerable;
    }
  });

  // node_modules/core-js/internals/create-property-descriptor.js
  var require_create_property_descriptor = __commonJS({
    "node_modules/core-js/internals/create-property-descriptor.js"(exports, module) {
      module.exports = function(bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value
        };
      };
    }
  });

  // node_modules/core-js/internals/function-uncurry-this.js
  var require_function_uncurry_this = __commonJS({
    "node_modules/core-js/internals/function-uncurry-this.js"(exports, module) {
      var FunctionPrototype = Function.prototype;
      var bind4 = FunctionPrototype.bind;
      var call5 = FunctionPrototype.call;
      var callBind = bind4 && bind4.bind(call5);
      module.exports = bind4 ? function(fn) {
        return fn && callBind(call5, fn);
      } : function(fn) {
        return fn && function() {
          return call5.apply(fn, arguments);
        };
      };
    }
  });

  // node_modules/core-js/internals/classof-raw.js
  var require_classof_raw = __commonJS({
    "node_modules/core-js/internals/classof-raw.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var toString7 = uncurryThis9({}.toString);
      var stringSlice4 = uncurryThis9("".slice);
      module.exports = function(it2) {
        return stringSlice4(toString7(it2), 8, -1);
      };
    }
  });

  // node_modules/core-js/internals/indexed-object.js
  var require_indexed_object = __commonJS({
    "node_modules/core-js/internals/indexed-object.js"(exports, module) {
      var global4 = require_global();
      var uncurryThis9 = require_function_uncurry_this();
      var fails4 = require_fails();
      var classof = require_classof_raw();
      var Object2 = global4.Object;
      var split = uncurryThis9("".split);
      module.exports = fails4(function() {
        return !Object2("z").propertyIsEnumerable(0);
      }) ? function(it2) {
        return classof(it2) == "String" ? split(it2, "") : Object2(it2);
      } : Object2;
    }
  });

  // node_modules/core-js/internals/require-object-coercible.js
  var require_require_object_coercible = __commonJS({
    "node_modules/core-js/internals/require-object-coercible.js"(exports, module) {
      var global4 = require_global();
      var TypeError3 = global4.TypeError;
      module.exports = function(it2) {
        if (it2 == void 0)
          throw TypeError3("Can't call method on " + it2);
        return it2;
      };
    }
  });

  // node_modules/core-js/internals/to-indexed-object.js
  var require_to_indexed_object = __commonJS({
    "node_modules/core-js/internals/to-indexed-object.js"(exports, module) {
      var IndexedObject = require_indexed_object();
      var requireObjectCoercible7 = require_require_object_coercible();
      module.exports = function(it2) {
        return IndexedObject(requireObjectCoercible7(it2));
      };
    }
  });

  // node_modules/core-js/internals/is-callable.js
  var require_is_callable = __commonJS({
    "node_modules/core-js/internals/is-callable.js"(exports, module) {
      module.exports = function(argument) {
        return typeof argument == "function";
      };
    }
  });

  // node_modules/core-js/internals/is-object.js
  var require_is_object = __commonJS({
    "node_modules/core-js/internals/is-object.js"(exports, module) {
      var isCallable3 = require_is_callable();
      module.exports = function(it2) {
        return typeof it2 == "object" ? it2 !== null : isCallable3(it2);
      };
    }
  });

  // node_modules/core-js/internals/get-built-in.js
  var require_get_built_in = __commonJS({
    "node_modules/core-js/internals/get-built-in.js"(exports, module) {
      var global4 = require_global();
      var isCallable3 = require_is_callable();
      var aFunction = function(argument) {
        return isCallable3(argument) ? argument : void 0;
      };
      module.exports = function(namespace, method) {
        return arguments.length < 2 ? aFunction(global4[namespace]) : global4[namespace] && global4[namespace][method];
      };
    }
  });

  // node_modules/core-js/internals/object-is-prototype-of.js
  var require_object_is_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-is-prototype-of.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      module.exports = uncurryThis9({}.isPrototypeOf);
    }
  });

  // node_modules/core-js/internals/engine-user-agent.js
  var require_engine_user_agent = __commonJS({
    "node_modules/core-js/internals/engine-user-agent.js"(exports, module) {
      var getBuiltIn2 = require_get_built_in();
      module.exports = getBuiltIn2("navigator", "userAgent") || "";
    }
  });

  // node_modules/core-js/internals/engine-v8-version.js
  var require_engine_v8_version = __commonJS({
    "node_modules/core-js/internals/engine-v8-version.js"(exports, module) {
      var global4 = require_global();
      var userAgent = require_engine_user_agent();
      var process3 = global4.process;
      var Deno = global4.Deno;
      var versions = process3 && process3.versions || Deno && Deno.version;
      var v8 = versions && versions.v8;
      var match;
      var version2;
      if (v8) {
        match = v8.split(".");
        version2 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
      }
      if (!version2 && userAgent) {
        match = userAgent.match(/Edge\/(\d+)/);
        if (!match || match[1] >= 74) {
          match = userAgent.match(/Chrome\/(\d+)/);
          if (match)
            version2 = +match[1];
        }
      }
      module.exports = version2;
    }
  });

  // node_modules/core-js/internals/native-symbol.js
  var require_native_symbol = __commonJS({
    "node_modules/core-js/internals/native-symbol.js"(exports, module) {
      var V8_VERSION2 = require_engine_v8_version();
      var fails4 = require_fails();
      module.exports = !!Object.getOwnPropertySymbols && !fails4(function() {
        var symbol = Symbol();
        return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION2 && V8_VERSION2 < 41;
      });
    }
  });

  // node_modules/core-js/internals/use-symbol-as-uid.js
  var require_use_symbol_as_uid = __commonJS({
    "node_modules/core-js/internals/use-symbol-as-uid.js"(exports, module) {
      var NATIVE_SYMBOL = require_native_symbol();
      module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }
  });

  // node_modules/core-js/internals/is-symbol.js
  var require_is_symbol = __commonJS({
    "node_modules/core-js/internals/is-symbol.js"(exports, module) {
      var global4 = require_global();
      var getBuiltIn2 = require_get_built_in();
      var isCallable3 = require_is_callable();
      var isPrototypeOf2 = require_object_is_prototype_of();
      var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
      var Object2 = global4.Object;
      module.exports = USE_SYMBOL_AS_UID ? function(it2) {
        return typeof it2 == "symbol";
      } : function(it2) {
        var $Symbol = getBuiltIn2("Symbol");
        return isCallable3($Symbol) && isPrototypeOf2($Symbol.prototype, Object2(it2));
      };
    }
  });

  // node_modules/core-js/internals/try-to-string.js
  var require_try_to_string = __commonJS({
    "node_modules/core-js/internals/try-to-string.js"(exports, module) {
      var global4 = require_global();
      var String2 = global4.String;
      module.exports = function(argument) {
        try {
          return String2(argument);
        } catch (error2) {
          return "Object";
        }
      };
    }
  });

  // node_modules/core-js/internals/a-callable.js
  var require_a_callable = __commonJS({
    "node_modules/core-js/internals/a-callable.js"(exports, module) {
      var global4 = require_global();
      var isCallable3 = require_is_callable();
      var tryToString = require_try_to_string();
      var TypeError3 = global4.TypeError;
      module.exports = function(argument) {
        if (isCallable3(argument))
          return argument;
        throw TypeError3(tryToString(argument) + " is not a function");
      };
    }
  });

  // node_modules/core-js/internals/get-method.js
  var require_get_method = __commonJS({
    "node_modules/core-js/internals/get-method.js"(exports, module) {
      var aCallable2 = require_a_callable();
      module.exports = function(V2, P2) {
        var func = V2[P2];
        return func == null ? void 0 : aCallable2(func);
      };
    }
  });

  // node_modules/core-js/internals/ordinary-to-primitive.js
  var require_ordinary_to_primitive = __commonJS({
    "node_modules/core-js/internals/ordinary-to-primitive.js"(exports, module) {
      var global4 = require_global();
      var call5 = require_function_call();
      var isCallable3 = require_is_callable();
      var isObject7 = require_is_object();
      var TypeError3 = global4.TypeError;
      module.exports = function(input, pref) {
        var fn, val;
        if (pref === "string" && isCallable3(fn = input.toString) && !isObject7(val = call5(fn, input)))
          return val;
        if (isCallable3(fn = input.valueOf) && !isObject7(val = call5(fn, input)))
          return val;
        if (pref !== "string" && isCallable3(fn = input.toString) && !isObject7(val = call5(fn, input)))
          return val;
        throw TypeError3("Can't convert object to primitive value");
      };
    }
  });

  // node_modules/core-js/internals/is-pure.js
  var require_is_pure = __commonJS({
    "node_modules/core-js/internals/is-pure.js"(exports, module) {
      module.exports = false;
    }
  });

  // node_modules/core-js/internals/set-global.js
  var require_set_global = __commonJS({
    "node_modules/core-js/internals/set-global.js"(exports, module) {
      var global4 = require_global();
      var defineProperty = Object.defineProperty;
      module.exports = function(key, value) {
        try {
          defineProperty(global4, key, { value, configurable: true, writable: true });
        } catch (error2) {
          global4[key] = value;
        }
        return value;
      };
    }
  });

  // node_modules/core-js/internals/shared-store.js
  var require_shared_store = __commonJS({
    "node_modules/core-js/internals/shared-store.js"(exports, module) {
      var global4 = require_global();
      var setGlobal = require_set_global();
      var SHARED = "__core-js_shared__";
      var store2 = global4[SHARED] || setGlobal(SHARED, {});
      module.exports = store2;
    }
  });

  // node_modules/core-js/internals/shared.js
  var require_shared = __commonJS({
    "node_modules/core-js/internals/shared.js"(exports, module) {
      var IS_PURE4 = require_is_pure();
      var store2 = require_shared_store();
      (module.exports = function(key, value) {
        return store2[key] || (store2[key] = value !== void 0 ? value : {});
      })("versions", []).push({
        version: "3.19.1",
        mode: IS_PURE4 ? "pure" : "global",
        copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)"
      });
    }
  });

  // node_modules/core-js/internals/to-object.js
  var require_to_object = __commonJS({
    "node_modules/core-js/internals/to-object.js"(exports, module) {
      var global4 = require_global();
      var requireObjectCoercible7 = require_require_object_coercible();
      var Object2 = global4.Object;
      module.exports = function(argument) {
        return Object2(requireObjectCoercible7(argument));
      };
    }
  });

  // node_modules/core-js/internals/has-own-property.js
  var require_has_own_property = __commonJS({
    "node_modules/core-js/internals/has-own-property.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var toObject = require_to_object();
      var hasOwnProperty3 = uncurryThis9({}.hasOwnProperty);
      module.exports = Object.hasOwn || function hasOwn3(it2, key) {
        return hasOwnProperty3(toObject(it2), key);
      };
    }
  });

  // node_modules/core-js/internals/uid.js
  var require_uid = __commonJS({
    "node_modules/core-js/internals/uid.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var id = 0;
      var postfix = Math.random();
      var toString7 = uncurryThis9(1 .toString);
      module.exports = function(key) {
        return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString7(++id + postfix, 36);
      };
    }
  });

  // node_modules/core-js/internals/well-known-symbol.js
  var require_well_known_symbol = __commonJS({
    "node_modules/core-js/internals/well-known-symbol.js"(exports, module) {
      var global4 = require_global();
      var shared = require_shared();
      var hasOwn3 = require_has_own_property();
      var uid3 = require_uid();
      var NATIVE_SYMBOL = require_native_symbol();
      var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
      var WellKnownSymbolsStore = shared("wks");
      var Symbol2 = global4.Symbol;
      var symbolFor = Symbol2 && Symbol2["for"];
      var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid3;
      module.exports = function(name) {
        if (!hasOwn3(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
          var description = "Symbol." + name;
          if (NATIVE_SYMBOL && hasOwn3(Symbol2, name)) {
            WellKnownSymbolsStore[name] = Symbol2[name];
          } else if (USE_SYMBOL_AS_UID && symbolFor) {
            WellKnownSymbolsStore[name] = symbolFor(description);
          } else {
            WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
          }
        }
        return WellKnownSymbolsStore[name];
      };
    }
  });

  // node_modules/core-js/internals/to-primitive.js
  var require_to_primitive = __commonJS({
    "node_modules/core-js/internals/to-primitive.js"(exports, module) {
      var global4 = require_global();
      var call5 = require_function_call();
      var isObject7 = require_is_object();
      var isSymbol3 = require_is_symbol();
      var getMethod4 = require_get_method();
      var ordinaryToPrimitive = require_ordinary_to_primitive();
      var wellKnownSymbol4 = require_well_known_symbol();
      var TypeError3 = global4.TypeError;
      var TO_PRIMITIVE = wellKnownSymbol4("toPrimitive");
      module.exports = function(input, pref) {
        if (!isObject7(input) || isSymbol3(input))
          return input;
        var exoticToPrim = getMethod4(input, TO_PRIMITIVE);
        var result;
        if (exoticToPrim) {
          if (pref === void 0)
            pref = "default";
          result = call5(exoticToPrim, input, pref);
          if (!isObject7(result) || isSymbol3(result))
            return result;
          throw TypeError3("Can't convert object to primitive value");
        }
        if (pref === void 0)
          pref = "number";
        return ordinaryToPrimitive(input, pref);
      };
    }
  });

  // node_modules/core-js/internals/to-property-key.js
  var require_to_property_key = __commonJS({
    "node_modules/core-js/internals/to-property-key.js"(exports, module) {
      var toPrimitive = require_to_primitive();
      var isSymbol3 = require_is_symbol();
      module.exports = function(argument) {
        var key = toPrimitive(argument, "string");
        return isSymbol3(key) ? key : key + "";
      };
    }
  });

  // node_modules/core-js/internals/document-create-element.js
  var require_document_create_element = __commonJS({
    "node_modules/core-js/internals/document-create-element.js"(exports, module) {
      var global4 = require_global();
      var isObject7 = require_is_object();
      var document3 = global4.document;
      var EXISTS = isObject7(document3) && isObject7(document3.createElement);
      module.exports = function(it2) {
        return EXISTS ? document3.createElement(it2) : {};
      };
    }
  });

  // node_modules/core-js/internals/ie8-dom-define.js
  var require_ie8_dom_define = __commonJS({
    "node_modules/core-js/internals/ie8-dom-define.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var fails4 = require_fails();
      var createElement = require_document_create_element();
      module.exports = !DESCRIPTORS && !fails4(function() {
        return Object.defineProperty(createElement("div"), "a", {
          get: function() {
            return 7;
          }
        }).a != 7;
      });
    }
  });

  // node_modules/core-js/internals/object-get-own-property-descriptor.js
  var require_object_get_own_property_descriptor = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-descriptor.js"(exports) {
      var DESCRIPTORS = require_descriptors();
      var call5 = require_function_call();
      var propertyIsEnumerableModule = require_object_property_is_enumerable();
      var createPropertyDescriptor = require_create_property_descriptor();
      var toIndexedObject = require_to_indexed_object();
      var toPropertyKey = require_to_property_key();
      var hasOwn3 = require_has_own_property();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor3(O3, P2) {
        O3 = toIndexedObject(O3);
        P2 = toPropertyKey(P2);
        if (IE8_DOM_DEFINE)
          try {
            return $getOwnPropertyDescriptor(O3, P2);
          } catch (error2) {
          }
        if (hasOwn3(O3, P2))
          return createPropertyDescriptor(!call5(propertyIsEnumerableModule.f, O3, P2), O3[P2]);
      };
    }
  });

  // node_modules/core-js/internals/an-object.js
  var require_an_object = __commonJS({
    "node_modules/core-js/internals/an-object.js"(exports, module) {
      var global4 = require_global();
      var isObject7 = require_is_object();
      var String2 = global4.String;
      var TypeError3 = global4.TypeError;
      module.exports = function(argument) {
        if (isObject7(argument))
          return argument;
        throw TypeError3(String2(argument) + " is not an object");
      };
    }
  });

  // node_modules/core-js/internals/object-define-property.js
  var require_object_define_property = __commonJS({
    "node_modules/core-js/internals/object-define-property.js"(exports) {
      var global4 = require_global();
      var DESCRIPTORS = require_descriptors();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var anObject5 = require_an_object();
      var toPropertyKey = require_to_property_key();
      var TypeError3 = global4.TypeError;
      var $defineProperty = Object.defineProperty;
      exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O3, P2, Attributes) {
        anObject5(O3);
        P2 = toPropertyKey(P2);
        anObject5(Attributes);
        if (IE8_DOM_DEFINE)
          try {
            return $defineProperty(O3, P2, Attributes);
          } catch (error2) {
          }
        if ("get" in Attributes || "set" in Attributes)
          throw TypeError3("Accessors not supported");
        if ("value" in Attributes)
          O3[P2] = Attributes.value;
        return O3;
      };
    }
  });

  // node_modules/core-js/internals/create-non-enumerable-property.js
  var require_create_non_enumerable_property = __commonJS({
    "node_modules/core-js/internals/create-non-enumerable-property.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var createPropertyDescriptor = require_create_property_descriptor();
      module.exports = DESCRIPTORS ? function(object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
      } : function(object, key, value) {
        object[key] = value;
        return object;
      };
    }
  });

  // node_modules/core-js/internals/inspect-source.js
  var require_inspect_source = __commonJS({
    "node_modules/core-js/internals/inspect-source.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var isCallable3 = require_is_callable();
      var store2 = require_shared_store();
      var functionToString = uncurryThis9(Function.toString);
      if (!isCallable3(store2.inspectSource)) {
        store2.inspectSource = function(it2) {
          return functionToString(it2);
        };
      }
      module.exports = store2.inspectSource;
    }
  });

  // node_modules/core-js/internals/native-weak-map.js
  var require_native_weak_map = __commonJS({
    "node_modules/core-js/internals/native-weak-map.js"(exports, module) {
      var global4 = require_global();
      var isCallable3 = require_is_callable();
      var inspectSource2 = require_inspect_source();
      var WeakMap2 = global4.WeakMap;
      module.exports = isCallable3(WeakMap2) && /native code/.test(inspectSource2(WeakMap2));
    }
  });

  // node_modules/core-js/internals/shared-key.js
  var require_shared_key = __commonJS({
    "node_modules/core-js/internals/shared-key.js"(exports, module) {
      var shared = require_shared();
      var uid3 = require_uid();
      var keys = shared("keys");
      module.exports = function(key) {
        return keys[key] || (keys[key] = uid3(key));
      };
    }
  });

  // node_modules/core-js/internals/hidden-keys.js
  var require_hidden_keys = __commonJS({
    "node_modules/core-js/internals/hidden-keys.js"(exports, module) {
      module.exports = {};
    }
  });

  // node_modules/core-js/internals/internal-state.js
  var require_internal_state = __commonJS({
    "node_modules/core-js/internals/internal-state.js"(exports, module) {
      var NATIVE_WEAK_MAP = require_native_weak_map();
      var global4 = require_global();
      var uncurryThis9 = require_function_uncurry_this();
      var isObject7 = require_is_object();
      var createNonEnumerableProperty2 = require_create_non_enumerable_property();
      var hasOwn3 = require_has_own_property();
      var shared = require_shared_store();
      var sharedKey = require_shared_key();
      var hiddenKeys = require_hidden_keys();
      var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
      var TypeError3 = global4.TypeError;
      var WeakMap2 = global4.WeakMap;
      var set4;
      var get4;
      var has3;
      var enforce = function(it2) {
        return has3(it2) ? get4(it2) : set4(it2, {});
      };
      var getterFor = function(TYPE) {
        return function(it2) {
          var state;
          if (!isObject7(it2) || (state = get4(it2)).type !== TYPE) {
            throw TypeError3("Incompatible receiver, " + TYPE + " required");
          }
          return state;
        };
      };
      if (NATIVE_WEAK_MAP || shared.state) {
        store2 = shared.state || (shared.state = new WeakMap2());
        wmget = uncurryThis9(store2.get);
        wmhas = uncurryThis9(store2.has);
        wmset = uncurryThis9(store2.set);
        set4 = function(it2, metadata) {
          if (wmhas(store2, it2))
            throw new TypeError3(OBJECT_ALREADY_INITIALIZED);
          metadata.facade = it2;
          wmset(store2, it2, metadata);
          return metadata;
        };
        get4 = function(it2) {
          return wmget(store2, it2) || {};
        };
        has3 = function(it2) {
          return wmhas(store2, it2);
        };
      } else {
        STATE = sharedKey("state");
        hiddenKeys[STATE] = true;
        set4 = function(it2, metadata) {
          if (hasOwn3(it2, STATE))
            throw new TypeError3(OBJECT_ALREADY_INITIALIZED);
          metadata.facade = it2;
          createNonEnumerableProperty2(it2, STATE, metadata);
          return metadata;
        };
        get4 = function(it2) {
          return hasOwn3(it2, STATE) ? it2[STATE] : {};
        };
        has3 = function(it2) {
          return hasOwn3(it2, STATE);
        };
      }
      var store2;
      var wmget;
      var wmhas;
      var wmset;
      var STATE;
      module.exports = {
        set: set4,
        get: get4,
        has: has3,
        enforce,
        getterFor
      };
    }
  });

  // node_modules/core-js/internals/function-name.js
  var require_function_name = __commonJS({
    "node_modules/core-js/internals/function-name.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var hasOwn3 = require_has_own_property();
      var FunctionPrototype = Function.prototype;
      var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
      var EXISTS = hasOwn3(FunctionPrototype, "name");
      var PROPER = EXISTS && function something() {
      }.name === "something";
      var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
      module.exports = {
        EXISTS,
        PROPER,
        CONFIGURABLE
      };
    }
  });

  // node_modules/core-js/internals/redefine.js
  var require_redefine = __commonJS({
    "node_modules/core-js/internals/redefine.js"(exports, module) {
      var global4 = require_global();
      var isCallable3 = require_is_callable();
      var hasOwn3 = require_has_own_property();
      var createNonEnumerableProperty2 = require_create_non_enumerable_property();
      var setGlobal = require_set_global();
      var inspectSource2 = require_inspect_source();
      var InternalStateModule2 = require_internal_state();
      var CONFIGURABLE_FUNCTION_NAME = require_function_name().CONFIGURABLE;
      var getInternalState2 = InternalStateModule2.get;
      var enforceInternalState = InternalStateModule2.enforce;
      var TEMPLATE = String(String).split("String");
      (module.exports = function(O3, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var name = options && options.name !== void 0 ? options.name : key;
        var state;
        if (isCallable3(value)) {
          if (String(name).slice(0, 7) === "Symbol(") {
            name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
          }
          if (!hasOwn3(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
            createNonEnumerableProperty2(value, "name", name);
          }
          state = enforceInternalState(value);
          if (!state.source) {
            state.source = TEMPLATE.join(typeof name == "string" ? name : "");
          }
        }
        if (O3 === global4) {
          if (simple)
            O3[key] = value;
          else
            setGlobal(key, value);
          return;
        } else if (!unsafe) {
          delete O3[key];
        } else if (!noTargetGet && O3[key]) {
          simple = true;
        }
        if (simple)
          O3[key] = value;
        else
          createNonEnumerableProperty2(O3, key, value);
      })(Function.prototype, "toString", function toString7() {
        return isCallable3(this) && getInternalState2(this).source || inspectSource2(this);
      });
    }
  });

  // node_modules/core-js/internals/to-integer-or-infinity.js
  var require_to_integer_or_infinity = __commonJS({
    "node_modules/core-js/internals/to-integer-or-infinity.js"(exports, module) {
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function(argument) {
        var number = +argument;
        return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
      };
    }
  });

  // node_modules/core-js/internals/to-absolute-index.js
  var require_to_absolute_index = __commonJS({
    "node_modules/core-js/internals/to-absolute-index.js"(exports, module) {
      var toIntegerOrInfinity2 = require_to_integer_or_infinity();
      var max3 = Math.max;
      var min5 = Math.min;
      module.exports = function(index3, length) {
        var integer = toIntegerOrInfinity2(index3);
        return integer < 0 ? max3(integer + length, 0) : min5(integer, length);
      };
    }
  });

  // node_modules/core-js/internals/to-length.js
  var require_to_length = __commonJS({
    "node_modules/core-js/internals/to-length.js"(exports, module) {
      var toIntegerOrInfinity2 = require_to_integer_or_infinity();
      var min5 = Math.min;
      module.exports = function(argument) {
        return argument > 0 ? min5(toIntegerOrInfinity2(argument), 9007199254740991) : 0;
      };
    }
  });

  // node_modules/core-js/internals/length-of-array-like.js
  var require_length_of_array_like = __commonJS({
    "node_modules/core-js/internals/length-of-array-like.js"(exports, module) {
      var toLength6 = require_to_length();
      module.exports = function(obj) {
        return toLength6(obj.length);
      };
    }
  });

  // node_modules/core-js/internals/array-includes.js
  var require_array_includes = __commonJS({
    "node_modules/core-js/internals/array-includes.js"(exports, module) {
      var toIndexedObject = require_to_indexed_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var lengthOfArrayLike = require_length_of_array_like();
      var createMethod = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
          var O3 = toIndexedObject($this);
          var length = lengthOfArrayLike(O3);
          var index3 = toAbsoluteIndex(fromIndex, length);
          var value;
          if (IS_INCLUDES && el != el)
            while (length > index3) {
              value = O3[index3++];
              if (value != value)
                return true;
            }
          else
            for (; length > index3; index3++) {
              if ((IS_INCLUDES || index3 in O3) && O3[index3] === el)
                return IS_INCLUDES || index3 || 0;
            }
          return !IS_INCLUDES && -1;
        };
      };
      module.exports = {
        includes: createMethod(true),
        indexOf: createMethod(false)
      };
    }
  });

  // node_modules/core-js/internals/object-keys-internal.js
  var require_object_keys_internal = __commonJS({
    "node_modules/core-js/internals/object-keys-internal.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var hasOwn3 = require_has_own_property();
      var toIndexedObject = require_to_indexed_object();
      var indexOf2 = require_array_includes().indexOf;
      var hiddenKeys = require_hidden_keys();
      var push3 = uncurryThis9([].push);
      module.exports = function(object, names) {
        var O3 = toIndexedObject(object);
        var i3 = 0;
        var result = [];
        var key;
        for (key in O3)
          !hasOwn3(hiddenKeys, key) && hasOwn3(O3, key) && push3(result, key);
        while (names.length > i3)
          if (hasOwn3(O3, key = names[i3++])) {
            ~indexOf2(result, key) || push3(result, key);
          }
        return result;
      };
    }
  });

  // node_modules/core-js/internals/enum-bug-keys.js
  var require_enum_bug_keys = __commonJS({
    "node_modules/core-js/internals/enum-bug-keys.js"(exports, module) {
      module.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
      ];
    }
  });

  // node_modules/core-js/internals/object-get-own-property-names.js
  var require_object_get_own_property_names = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-names.js"(exports) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = enumBugKeys.concat("length", "prototype");
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O3) {
        return internalObjectKeys(O3, hiddenKeys);
      };
    }
  });

  // node_modules/core-js/internals/object-get-own-property-symbols.js
  var require_object_get_own_property_symbols = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-symbols.js"(exports) {
      exports.f = Object.getOwnPropertySymbols;
    }
  });

  // node_modules/core-js/internals/own-keys.js
  var require_own_keys = __commonJS({
    "node_modules/core-js/internals/own-keys.js"(exports, module) {
      var getBuiltIn2 = require_get_built_in();
      var uncurryThis9 = require_function_uncurry_this();
      var getOwnPropertyNamesModule = require_object_get_own_property_names();
      var getOwnPropertySymbolsModule = require_object_get_own_property_symbols();
      var anObject5 = require_an_object();
      var concat2 = uncurryThis9([].concat);
      module.exports = getBuiltIn2("Reflect", "ownKeys") || function ownKeys4(it2) {
        var keys = getOwnPropertyNamesModule.f(anObject5(it2));
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        return getOwnPropertySymbols ? concat2(keys, getOwnPropertySymbols(it2)) : keys;
      };
    }
  });

  // node_modules/core-js/internals/copy-constructor-properties.js
  var require_copy_constructor_properties = __commonJS({
    "node_modules/core-js/internals/copy-constructor-properties.js"(exports, module) {
      var hasOwn3 = require_has_own_property();
      var ownKeys4 = require_own_keys();
      var getOwnPropertyDescriptorModule = require_object_get_own_property_descriptor();
      var definePropertyModule = require_object_define_property();
      module.exports = function(target, source) {
        var keys = ownKeys4(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor3 = getOwnPropertyDescriptorModule.f;
        for (var i3 = 0; i3 < keys.length; i3++) {
          var key = keys[i3];
          if (!hasOwn3(target, key))
            defineProperty(target, key, getOwnPropertyDescriptor3(source, key));
        }
      };
    }
  });

  // node_modules/core-js/internals/is-forced.js
  var require_is_forced = __commonJS({
    "node_modules/core-js/internals/is-forced.js"(exports, module) {
      var fails4 = require_fails();
      var isCallable3 = require_is_callable();
      var replacement = /#|\.prototype\./;
      var isForced2 = function(feature, detection) {
        var value = data2[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : isCallable3(detection) ? fails4(detection) : !!detection;
      };
      var normalize = isForced2.normalize = function(string) {
        return String(string).replace(replacement, ".").toLowerCase();
      };
      var data2 = isForced2.data = {};
      var NATIVE = isForced2.NATIVE = "N";
      var POLYFILL = isForced2.POLYFILL = "P";
      module.exports = isForced2;
    }
  });

  // node_modules/core-js/internals/export.js
  var require_export = __commonJS({
    "node_modules/core-js/internals/export.js"(exports, module) {
      var global4 = require_global();
      var getOwnPropertyDescriptor3 = require_object_get_own_property_descriptor().f;
      var createNonEnumerableProperty2 = require_create_non_enumerable_property();
      var redefine3 = require_redefine();
      var setGlobal = require_set_global();
      var copyConstructorProperties = require_copy_constructor_properties();
      var isForced2 = require_is_forced();
      module.exports = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED2, target, key, targetProperty, sourceProperty, descriptor;
        if (GLOBAL) {
          target = global4;
        } else if (STATIC) {
          target = global4[TARGET] || setGlobal(TARGET, {});
        } else {
          target = (global4[TARGET] || {}).prototype;
        }
        if (target)
          for (key in source) {
            sourceProperty = source[key];
            if (options.noTargetGet) {
              descriptor = getOwnPropertyDescriptor3(target, key);
              targetProperty = descriptor && descriptor.value;
            } else
              targetProperty = target[key];
            FORCED2 = isForced2(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
            if (!FORCED2 && targetProperty !== void 0) {
              if (typeof sourceProperty == typeof targetProperty)
                continue;
              copyConstructorProperties(sourceProperty, targetProperty);
            }
            if (options.sham || targetProperty && targetProperty.sham) {
              createNonEnumerableProperty2(sourceProperty, "sham", true);
            }
            redefine3(target, key, sourceProperty, options);
          }
      };
    }
  });

  // node_modules/core-js/internals/native-promise-constructor.js
  var require_native_promise_constructor = __commonJS({
    "node_modules/core-js/internals/native-promise-constructor.js"(exports, module) {
      var global4 = require_global();
      module.exports = global4.Promise;
    }
  });

  // node_modules/core-js/internals/redefine-all.js
  var require_redefine_all = __commonJS({
    "node_modules/core-js/internals/redefine-all.js"(exports, module) {
      var redefine3 = require_redefine();
      module.exports = function(target, src, options) {
        for (var key in src)
          redefine3(target, key, src[key], options);
        return target;
      };
    }
  });

  // node_modules/core-js/internals/a-possible-prototype.js
  var require_a_possible_prototype = __commonJS({
    "node_modules/core-js/internals/a-possible-prototype.js"(exports, module) {
      var global4 = require_global();
      var isCallable3 = require_is_callable();
      var String2 = global4.String;
      var TypeError3 = global4.TypeError;
      module.exports = function(argument) {
        if (typeof argument == "object" || isCallable3(argument))
          return argument;
        throw TypeError3("Can't set " + String2(argument) + " as a prototype");
      };
    }
  });

  // node_modules/core-js/internals/object-set-prototype-of.js
  var require_object_set_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-set-prototype-of.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var anObject5 = require_an_object();
      var aPossiblePrototype = require_a_possible_prototype();
      module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var CORRECT_SETTER = false;
        var test2 = {};
        var setter;
        try {
          setter = uncurryThis9(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
          setter(test2, []);
          CORRECT_SETTER = test2 instanceof Array;
        } catch (error2) {
        }
        return function setPrototypeOf2(O3, proto) {
          anObject5(O3);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER)
            setter(O3, proto);
          else
            O3.__proto__ = proto;
          return O3;
        };
      }() : void 0);
    }
  });

  // node_modules/core-js/internals/set-to-string-tag.js
  var require_set_to_string_tag = __commonJS({
    "node_modules/core-js/internals/set-to-string-tag.js"(exports, module) {
      var defineProperty = require_object_define_property().f;
      var hasOwn3 = require_has_own_property();
      var wellKnownSymbol4 = require_well_known_symbol();
      var TO_STRING_TAG2 = wellKnownSymbol4("toStringTag");
      module.exports = function(it2, TAG, STATIC) {
        if (it2 && !hasOwn3(it2 = STATIC ? it2 : it2.prototype, TO_STRING_TAG2)) {
          defineProperty(it2, TO_STRING_TAG2, { configurable: true, value: TAG });
        }
      };
    }
  });

  // node_modules/core-js/internals/set-species.js
  var require_set_species = __commonJS({
    "node_modules/core-js/internals/set-species.js"(exports, module) {
      "use strict";
      var getBuiltIn2 = require_get_built_in();
      var definePropertyModule = require_object_define_property();
      var wellKnownSymbol4 = require_well_known_symbol();
      var DESCRIPTORS = require_descriptors();
      var SPECIES2 = wellKnownSymbol4("species");
      module.exports = function(CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn2(CONSTRUCTOR_NAME);
        var defineProperty = definePropertyModule.f;
        if (DESCRIPTORS && Constructor && !Constructor[SPECIES2]) {
          defineProperty(Constructor, SPECIES2, {
            configurable: true,
            get: function() {
              return this;
            }
          });
        }
      };
    }
  });

  // node_modules/core-js/internals/an-instance.js
  var require_an_instance = __commonJS({
    "node_modules/core-js/internals/an-instance.js"(exports, module) {
      var global4 = require_global();
      var isPrototypeOf2 = require_object_is_prototype_of();
      var TypeError3 = global4.TypeError;
      module.exports = function(it2, Prototype) {
        if (isPrototypeOf2(Prototype, it2))
          return it2;
        throw TypeError3("Incorrect invocation");
      };
    }
  });

  // node_modules/core-js/internals/function-bind-context.js
  var require_function_bind_context = __commonJS({
    "node_modules/core-js/internals/function-bind-context.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var aCallable2 = require_a_callable();
      var bind4 = uncurryThis9(uncurryThis9.bind);
      module.exports = function(fn, that) {
        aCallable2(fn);
        return that === void 0 ? fn : bind4 ? bind4(fn, that) : function() {
          return fn.apply(that, arguments);
        };
      };
    }
  });

  // node_modules/core-js/internals/iterators.js
  var require_iterators = __commonJS({
    "node_modules/core-js/internals/iterators.js"(exports, module) {
      module.exports = {};
    }
  });

  // node_modules/core-js/internals/is-array-iterator-method.js
  var require_is_array_iterator_method = __commonJS({
    "node_modules/core-js/internals/is-array-iterator-method.js"(exports, module) {
      var wellKnownSymbol4 = require_well_known_symbol();
      var Iterators = require_iterators();
      var ITERATOR2 = wellKnownSymbol4("iterator");
      var ArrayPrototype = Array.prototype;
      module.exports = function(it2) {
        return it2 !== void 0 && (Iterators.Array === it2 || ArrayPrototype[ITERATOR2] === it2);
      };
    }
  });

  // node_modules/core-js/internals/to-string-tag-support.js
  var require_to_string_tag_support = __commonJS({
    "node_modules/core-js/internals/to-string-tag-support.js"(exports, module) {
      var wellKnownSymbol4 = require_well_known_symbol();
      var TO_STRING_TAG2 = wellKnownSymbol4("toStringTag");
      var test2 = {};
      test2[TO_STRING_TAG2] = "z";
      module.exports = String(test2) === "[object z]";
    }
  });

  // node_modules/core-js/internals/classof.js
  var require_classof = __commonJS({
    "node_modules/core-js/internals/classof.js"(exports, module) {
      var global4 = require_global();
      var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
      var isCallable3 = require_is_callable();
      var classofRaw = require_classof_raw();
      var wellKnownSymbol4 = require_well_known_symbol();
      var TO_STRING_TAG2 = wellKnownSymbol4("toStringTag");
      var Object2 = global4.Object;
      var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
      }()) == "Arguments";
      var tryGet = function(it2, key) {
        try {
          return it2[key];
        } catch (error2) {
        }
      };
      module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it2) {
        var O3, tag, result;
        return it2 === void 0 ? "Undefined" : it2 === null ? "Null" : typeof (tag = tryGet(O3 = Object2(it2), TO_STRING_TAG2)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O3) : (result = classofRaw(O3)) == "Object" && isCallable3(O3.callee) ? "Arguments" : result;
      };
    }
  });

  // node_modules/core-js/internals/get-iterator-method.js
  var require_get_iterator_method = __commonJS({
    "node_modules/core-js/internals/get-iterator-method.js"(exports, module) {
      var classof = require_classof();
      var getMethod4 = require_get_method();
      var Iterators = require_iterators();
      var wellKnownSymbol4 = require_well_known_symbol();
      var ITERATOR2 = wellKnownSymbol4("iterator");
      module.exports = function(it2) {
        if (it2 != void 0)
          return getMethod4(it2, ITERATOR2) || getMethod4(it2, "@@iterator") || Iterators[classof(it2)];
      };
    }
  });

  // node_modules/core-js/internals/get-iterator.js
  var require_get_iterator = __commonJS({
    "node_modules/core-js/internals/get-iterator.js"(exports, module) {
      var global4 = require_global();
      var call5 = require_function_call();
      var aCallable2 = require_a_callable();
      var anObject5 = require_an_object();
      var tryToString = require_try_to_string();
      var getIteratorMethod = require_get_iterator_method();
      var TypeError3 = global4.TypeError;
      module.exports = function(argument, usingIterator) {
        var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
        if (aCallable2(iteratorMethod))
          return anObject5(call5(iteratorMethod, argument));
        throw TypeError3(tryToString(argument) + " is not iterable");
      };
    }
  });

  // node_modules/core-js/internals/iterator-close.js
  var require_iterator_close = __commonJS({
    "node_modules/core-js/internals/iterator-close.js"(exports, module) {
      var call5 = require_function_call();
      var anObject5 = require_an_object();
      var getMethod4 = require_get_method();
      module.exports = function(iterator, kind, value) {
        var innerResult, innerError;
        anObject5(iterator);
        try {
          innerResult = getMethod4(iterator, "return");
          if (!innerResult) {
            if (kind === "throw")
              throw value;
            return value;
          }
          innerResult = call5(innerResult, iterator);
        } catch (error2) {
          innerError = true;
          innerResult = error2;
        }
        if (kind === "throw")
          throw value;
        if (innerError)
          throw innerResult;
        anObject5(innerResult);
        return value;
      };
    }
  });

  // node_modules/core-js/internals/iterate.js
  var require_iterate = __commonJS({
    "node_modules/core-js/internals/iterate.js"(exports, module) {
      var global4 = require_global();
      var bind4 = require_function_bind_context();
      var call5 = require_function_call();
      var anObject5 = require_an_object();
      var tryToString = require_try_to_string();
      var isArrayIteratorMethod = require_is_array_iterator_method();
      var lengthOfArrayLike = require_length_of_array_like();
      var isPrototypeOf2 = require_object_is_prototype_of();
      var getIterator = require_get_iterator();
      var getIteratorMethod = require_get_iterator_method();
      var iteratorClose = require_iterator_close();
      var TypeError3 = global4.TypeError;
      var Result = function(stopped, result) {
        this.stopped = stopped;
        this.result = result;
      };
      var ResultPrototype = Result.prototype;
      module.exports = function(iterable, unboundFunction, options) {
        var that = options && options.that;
        var AS_ENTRIES = !!(options && options.AS_ENTRIES);
        var IS_ITERATOR = !!(options && options.IS_ITERATOR);
        var INTERRUPTED = !!(options && options.INTERRUPTED);
        var fn = bind4(unboundFunction, that);
        var iterator, iterFn, index3, length, result, next2, step;
        var stop3 = function(condition) {
          if (iterator)
            iteratorClose(iterator, "normal", condition);
          return new Result(true, condition);
        };
        var callFn = function(value) {
          if (AS_ENTRIES) {
            anObject5(value);
            return INTERRUPTED ? fn(value[0], value[1], stop3) : fn(value[0], value[1]);
          }
          return INTERRUPTED ? fn(value, stop3) : fn(value);
        };
        if (IS_ITERATOR) {
          iterator = iterable;
        } else {
          iterFn = getIteratorMethod(iterable);
          if (!iterFn)
            throw TypeError3(tryToString(iterable) + " is not iterable");
          if (isArrayIteratorMethod(iterFn)) {
            for (index3 = 0, length = lengthOfArrayLike(iterable); length > index3; index3++) {
              result = callFn(iterable[index3]);
              if (result && isPrototypeOf2(ResultPrototype, result))
                return result;
            }
            return new Result(false);
          }
          iterator = getIterator(iterable, iterFn);
        }
        next2 = iterator.next;
        while (!(step = call5(next2, iterator)).done) {
          try {
            result = callFn(step.value);
          } catch (error2) {
            iteratorClose(iterator, "throw", error2);
          }
          if (typeof result == "object" && result && isPrototypeOf2(ResultPrototype, result))
            return result;
        }
        return new Result(false);
      };
    }
  });

  // node_modules/core-js/internals/check-correctness-of-iteration.js
  var require_check_correctness_of_iteration = __commonJS({
    "node_modules/core-js/internals/check-correctness-of-iteration.js"(exports, module) {
      var wellKnownSymbol4 = require_well_known_symbol();
      var ITERATOR2 = wellKnownSymbol4("iterator");
      var SAFE_CLOSING = false;
      try {
        called = 0;
        iteratorWithReturn = {
          next: function() {
            return { done: !!called++ };
          },
          "return": function() {
            SAFE_CLOSING = true;
          }
        };
        iteratorWithReturn[ITERATOR2] = function() {
          return this;
        };
        Array.from(iteratorWithReturn, function() {
          throw 2;
        });
      } catch (error2) {
      }
      var called;
      var iteratorWithReturn;
      module.exports = function(exec2, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING)
          return false;
        var ITERATION_SUPPORT = false;
        try {
          var object = {};
          object[ITERATOR2] = function() {
            return {
              next: function() {
                return { done: ITERATION_SUPPORT = true };
              }
            };
          };
          exec2(object);
        } catch (error2) {
        }
        return ITERATION_SUPPORT;
      };
    }
  });

  // node_modules/core-js/internals/is-constructor.js
  var require_is_constructor = __commonJS({
    "node_modules/core-js/internals/is-constructor.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var fails4 = require_fails();
      var isCallable3 = require_is_callable();
      var classof = require_classof();
      var getBuiltIn2 = require_get_built_in();
      var inspectSource2 = require_inspect_source();
      var noop2 = function() {
      };
      var empty = [];
      var construct = getBuiltIn2("Reflect", "construct");
      var constructorRegExp = /^\s*(?:class|function)\b/;
      var exec2 = uncurryThis9(constructorRegExp.exec);
      var INCORRECT_TO_STRING = !constructorRegExp.exec(noop2);
      var isConstructorModern = function(argument) {
        if (!isCallable3(argument))
          return false;
        try {
          construct(noop2, empty, argument);
          return true;
        } catch (error2) {
          return false;
        }
      };
      var isConstructorLegacy = function(argument) {
        if (!isCallable3(argument))
          return false;
        switch (classof(argument)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        return INCORRECT_TO_STRING || !!exec2(constructorRegExp, inspectSource2(argument));
      };
      module.exports = !construct || fails4(function() {
        var called;
        return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
          called = true;
        }) || called;
      }) ? isConstructorLegacy : isConstructorModern;
    }
  });

  // node_modules/core-js/internals/a-constructor.js
  var require_a_constructor = __commonJS({
    "node_modules/core-js/internals/a-constructor.js"(exports, module) {
      var global4 = require_global();
      var isConstructor = require_is_constructor();
      var tryToString = require_try_to_string();
      var TypeError3 = global4.TypeError;
      module.exports = function(argument) {
        if (isConstructor(argument))
          return argument;
        throw TypeError3(tryToString(argument) + " is not a constructor");
      };
    }
  });

  // node_modules/core-js/internals/species-constructor.js
  var require_species_constructor = __commonJS({
    "node_modules/core-js/internals/species-constructor.js"(exports, module) {
      var anObject5 = require_an_object();
      var aConstructor = require_a_constructor();
      var wellKnownSymbol4 = require_well_known_symbol();
      var SPECIES2 = wellKnownSymbol4("species");
      module.exports = function(O3, defaultConstructor) {
        var C2 = anObject5(O3).constructor;
        var S2;
        return C2 === void 0 || (S2 = anObject5(C2)[SPECIES2]) == void 0 ? defaultConstructor : aConstructor(S2);
      };
    }
  });

  // node_modules/core-js/internals/function-apply.js
  var require_function_apply = __commonJS({
    "node_modules/core-js/internals/function-apply.js"(exports, module) {
      var FunctionPrototype = Function.prototype;
      var apply3 = FunctionPrototype.apply;
      var bind4 = FunctionPrototype.bind;
      var call5 = FunctionPrototype.call;
      module.exports = typeof Reflect == "object" && Reflect.apply || (bind4 ? call5.bind(apply3) : function() {
        return call5.apply(apply3, arguments);
      });
    }
  });

  // node_modules/core-js/internals/html.js
  var require_html = __commonJS({
    "node_modules/core-js/internals/html.js"(exports, module) {
      var getBuiltIn2 = require_get_built_in();
      module.exports = getBuiltIn2("document", "documentElement");
    }
  });

  // node_modules/core-js/internals/array-slice.js
  var require_array_slice = __commonJS({
    "node_modules/core-js/internals/array-slice.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      module.exports = uncurryThis9([].slice);
    }
  });

  // node_modules/core-js/internals/engine-is-ios.js
  var require_engine_is_ios = __commonJS({
    "node_modules/core-js/internals/engine-is-ios.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
    }
  });

  // node_modules/core-js/internals/engine-is-node.js
  var require_engine_is_node = __commonJS({
    "node_modules/core-js/internals/engine-is-node.js"(exports, module) {
      var classof = require_classof_raw();
      var global4 = require_global();
      module.exports = classof(global4.process) == "process";
    }
  });

  // node_modules/core-js/internals/task.js
  var require_task = __commonJS({
    "node_modules/core-js/internals/task.js"(exports, module) {
      var global4 = require_global();
      var apply3 = require_function_apply();
      var bind4 = require_function_bind_context();
      var isCallable3 = require_is_callable();
      var hasOwn3 = require_has_own_property();
      var fails4 = require_fails();
      var html2 = require_html();
      var arraySlice2 = require_array_slice();
      var createElement = require_document_create_element();
      var IS_IOS = require_engine_is_ios();
      var IS_NODE3 = require_engine_is_node();
      var set4 = global4.setImmediate;
      var clear3 = global4.clearImmediate;
      var process3 = global4.process;
      var Dispatch = global4.Dispatch;
      var Function2 = global4.Function;
      var MessageChannel = global4.MessageChannel;
      var String2 = global4.String;
      var counter = 0;
      var queue3 = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var location2;
      var defer;
      var channel;
      var port;
      try {
        location2 = global4.location;
      } catch (error2) {
      }
      var run = function(id) {
        if (hasOwn3(queue3, id)) {
          var fn = queue3[id];
          delete queue3[id];
          fn();
        }
      };
      var runner = function(id) {
        return function() {
          run(id);
        };
      };
      var listener = function(event2) {
        run(event2.data);
      };
      var post = function(id) {
        global4.postMessage(String2(id), location2.protocol + "//" + location2.host);
      };
      if (!set4 || !clear3) {
        set4 = function setImmediate(fn) {
          var args = arraySlice2(arguments, 1);
          queue3[++counter] = function() {
            apply3(isCallable3(fn) ? fn : Function2(fn), void 0, args);
          };
          defer(counter);
          return counter;
        };
        clear3 = function clearImmediate(id) {
          delete queue3[id];
        };
        if (IS_NODE3) {
          defer = function(id) {
            process3.nextTick(runner(id));
          };
        } else if (Dispatch && Dispatch.now) {
          defer = function(id) {
            Dispatch.now(runner(id));
          };
        } else if (MessageChannel && !IS_IOS) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = bind4(port.postMessage, port);
        } else if (global4.addEventListener && isCallable3(global4.postMessage) && !global4.importScripts && location2 && location2.protocol !== "file:" && !fails4(post)) {
          defer = post;
          global4.addEventListener("message", listener, false);
        } else if (ONREADYSTATECHANGE in createElement("script")) {
          defer = function(id) {
            html2.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
              html2.removeChild(this);
              run(id);
            };
          };
        } else {
          defer = function(id) {
            setTimeout(runner(id), 0);
          };
        }
      }
      module.exports = {
        set: set4,
        clear: clear3
      };
    }
  });

  // node_modules/core-js/internals/engine-is-ios-pebble.js
  var require_engine_is_ios_pebble = __commonJS({
    "node_modules/core-js/internals/engine-is-ios-pebble.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      var global4 = require_global();
      module.exports = /ipad|iphone|ipod/i.test(userAgent) && global4.Pebble !== void 0;
    }
  });

  // node_modules/core-js/internals/engine-is-webos-webkit.js
  var require_engine_is_webos_webkit = __commonJS({
    "node_modules/core-js/internals/engine-is-webos-webkit.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      module.exports = /web0s(?!.*chrome)/i.test(userAgent);
    }
  });

  // node_modules/core-js/internals/microtask.js
  var require_microtask = __commonJS({
    "node_modules/core-js/internals/microtask.js"(exports, module) {
      var global4 = require_global();
      var bind4 = require_function_bind_context();
      var getOwnPropertyDescriptor3 = require_object_get_own_property_descriptor().f;
      var macrotask = require_task().set;
      var IS_IOS = require_engine_is_ios();
      var IS_IOS_PEBBLE = require_engine_is_ios_pebble();
      var IS_WEBOS_WEBKIT = require_engine_is_webos_webkit();
      var IS_NODE3 = require_engine_is_node();
      var MutationObserver2 = global4.MutationObserver || global4.WebKitMutationObserver;
      var document3 = global4.document;
      var process3 = global4.process;
      var Promise2 = global4.Promise;
      var queueMicrotaskDescriptor = getOwnPropertyDescriptor3(global4, "queueMicrotask");
      var queueMicrotask2 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
      var flush;
      var head;
      var last;
      var notify2;
      var toggle;
      var node2;
      var promise;
      var then;
      if (!queueMicrotask2) {
        flush = function() {
          var parent2, fn;
          if (IS_NODE3 && (parent2 = process3.domain))
            parent2.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (error2) {
              if (head)
                notify2();
              else
                last = void 0;
              throw error2;
            }
          }
          last = void 0;
          if (parent2)
            parent2.enter();
        };
        if (!IS_IOS && !IS_NODE3 && !IS_WEBOS_WEBKIT && MutationObserver2 && document3) {
          toggle = true;
          node2 = document3.createTextNode("");
          new MutationObserver2(flush).observe(node2, { characterData: true });
          notify2 = function() {
            node2.data = toggle = !toggle;
          };
        } else if (!IS_IOS_PEBBLE && Promise2 && Promise2.resolve) {
          promise = Promise2.resolve(void 0);
          promise.constructor = Promise2;
          then = bind4(promise.then, promise);
          notify2 = function() {
            then(flush);
          };
        } else if (IS_NODE3) {
          notify2 = function() {
            process3.nextTick(flush);
          };
        } else {
          macrotask = bind4(macrotask, global4);
          notify2 = function() {
            macrotask(flush);
          };
        }
      }
      module.exports = queueMicrotask2 || function(fn) {
        var task2 = { fn, next: void 0 };
        if (last)
          last.next = task2;
        if (!head) {
          head = task2;
          notify2();
        }
        last = task2;
      };
    }
  });

  // node_modules/core-js/internals/new-promise-capability.js
  var require_new_promise_capability = __commonJS({
    "node_modules/core-js/internals/new-promise-capability.js"(exports, module) {
      "use strict";
      var aCallable2 = require_a_callable();
      var PromiseCapability = function(C2) {
        var resolve3, reject2;
        this.promise = new C2(function($$resolve, $$reject) {
          if (resolve3 !== void 0 || reject2 !== void 0)
            throw TypeError("Bad Promise constructor");
          resolve3 = $$resolve;
          reject2 = $$reject;
        });
        this.resolve = aCallable2(resolve3);
        this.reject = aCallable2(reject2);
      };
      module.exports.f = function(C2) {
        return new PromiseCapability(C2);
      };
    }
  });

  // node_modules/core-js/internals/promise-resolve.js
  var require_promise_resolve = __commonJS({
    "node_modules/core-js/internals/promise-resolve.js"(exports, module) {
      var anObject5 = require_an_object();
      var isObject7 = require_is_object();
      var newPromiseCapability2 = require_new_promise_capability();
      module.exports = function(C2, x2) {
        anObject5(C2);
        if (isObject7(x2) && x2.constructor === C2)
          return x2;
        var promiseCapability = newPromiseCapability2.f(C2);
        var resolve3 = promiseCapability.resolve;
        resolve3(x2);
        return promiseCapability.promise;
      };
    }
  });

  // node_modules/core-js/internals/host-report-errors.js
  var require_host_report_errors = __commonJS({
    "node_modules/core-js/internals/host-report-errors.js"(exports, module) {
      var global4 = require_global();
      module.exports = function(a3, b2) {
        var console2 = global4.console;
        if (console2 && console2.error) {
          arguments.length == 1 ? console2.error(a3) : console2.error(a3, b2);
        }
      };
    }
  });

  // node_modules/core-js/internals/perform.js
  var require_perform = __commonJS({
    "node_modules/core-js/internals/perform.js"(exports, module) {
      module.exports = function(exec2) {
        try {
          return { error: false, value: exec2() };
        } catch (error2) {
          return { error: true, value: error2 };
        }
      };
    }
  });

  // node_modules/core-js/internals/engine-is-browser.js
  var require_engine_is_browser = __commonJS({
    "node_modules/core-js/internals/engine-is-browser.js"(exports, module) {
      module.exports = typeof window == "object";
    }
  });

  // node_modules/core-js/modules/es.promise.js
  var $3, IS_PURE, global2, getBuiltIn, call, NativePromise, redefine, redefineAll, setPrototypeOf, setToStringTag, setSpecies, aCallable, isCallable, isObject6, anInstance, inspectSource, iterate, checkCorrectnessOfIteration, speciesConstructor, task, microtask, promiseResolve, hostReportErrors, newPromiseCapabilityModule, perform, InternalStateModule, isForced, wellKnownSymbol, IS_BROWSER, IS_NODE, V8_VERSION, SPECIES, PROMISE, getInternalState, setInternalState, getInternalPromiseState, NativePromisePrototype, PromiseConstructor, PromisePrototype, TypeError2, document2, process2, newPromiseCapability, newGenericPromiseCapability, DISPATCH_EVENT, NATIVE_REJECTION_EVENT, UNHANDLED_REJECTION, REJECTION_HANDLED, PENDING, FULFILLED, REJECTED, HANDLED, UNHANDLED, SUBCLASSING, Internal, OwnPromiseCapability, PromiseWrapper, nativeThen, FORCED, INCORRECT_ITERATION, isThenable, notify, dispatchEvent, onUnhandled, isUnhandled, onHandleUnhandled, bind3, internalReject, internalResolve;
  var init_es_promise = __esm({
    "node_modules/core-js/modules/es.promise.js"() {
      "use strict";
      $3 = require_export();
      IS_PURE = require_is_pure();
      global2 = require_global();
      getBuiltIn = require_get_built_in();
      call = require_function_call();
      NativePromise = require_native_promise_constructor();
      redefine = require_redefine();
      redefineAll = require_redefine_all();
      setPrototypeOf = require_object_set_prototype_of();
      setToStringTag = require_set_to_string_tag();
      setSpecies = require_set_species();
      aCallable = require_a_callable();
      isCallable = require_is_callable();
      isObject6 = require_is_object();
      anInstance = require_an_instance();
      inspectSource = require_inspect_source();
      iterate = require_iterate();
      checkCorrectnessOfIteration = require_check_correctness_of_iteration();
      speciesConstructor = require_species_constructor();
      task = require_task().set;
      microtask = require_microtask();
      promiseResolve = require_promise_resolve();
      hostReportErrors = require_host_report_errors();
      newPromiseCapabilityModule = require_new_promise_capability();
      perform = require_perform();
      InternalStateModule = require_internal_state();
      isForced = require_is_forced();
      wellKnownSymbol = require_well_known_symbol();
      IS_BROWSER = require_engine_is_browser();
      IS_NODE = require_engine_is_node();
      V8_VERSION = require_engine_v8_version();
      SPECIES = wellKnownSymbol("species");
      PROMISE = "Promise";
      getInternalState = InternalStateModule.get;
      setInternalState = InternalStateModule.set;
      getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
      NativePromisePrototype = NativePromise && NativePromise.prototype;
      PromiseConstructor = NativePromise;
      PromisePrototype = NativePromisePrototype;
      TypeError2 = global2.TypeError;
      document2 = global2.document;
      process2 = global2.process;
      newPromiseCapability = newPromiseCapabilityModule.f;
      newGenericPromiseCapability = newPromiseCapability;
      DISPATCH_EVENT = !!(document2 && document2.createEvent && global2.dispatchEvent);
      NATIVE_REJECTION_EVENT = isCallable(global2.PromiseRejectionEvent);
      UNHANDLED_REJECTION = "unhandledrejection";
      REJECTION_HANDLED = "rejectionhandled";
      PENDING = 0;
      FULFILLED = 1;
      REJECTED = 2;
      HANDLED = 1;
      UNHANDLED = 2;
      SUBCLASSING = false;
      FORCED = isForced(PROMISE, function() {
        var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
        var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
        if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66)
          return true;
        if (IS_PURE && !PromisePrototype["finally"])
          return true;
        if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE))
          return false;
        var promise = new PromiseConstructor(function(resolve3) {
          resolve3(1);
        });
        var FakePromise = function(exec2) {
          exec2(function() {
          }, function() {
          });
        };
        var constructor = promise.constructor = {};
        constructor[SPECIES] = FakePromise;
        SUBCLASSING = promise.then(function() {
        }) instanceof FakePromise;
        if (!SUBCLASSING)
          return true;
        return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
      });
      INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
        PromiseConstructor.all(iterable)["catch"](function() {
        });
      });
      isThenable = function(it2) {
        var then;
        return isObject6(it2) && isCallable(then = it2.then) ? then : false;
      };
      notify = function(state, isReject) {
        if (state.notified)
          return;
        state.notified = true;
        var chain = state.reactions;
        microtask(function() {
          var value = state.value;
          var ok = state.state == FULFILLED;
          var index3 = 0;
          while (chain.length > index3) {
            var reaction = chain[index3++];
            var handler4 = ok ? reaction.ok : reaction.fail;
            var resolve3 = reaction.resolve;
            var reject2 = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler4) {
                if (!ok) {
                  if (state.rejection === UNHANDLED)
                    onHandleUnhandled(state);
                  state.rejection = HANDLED;
                }
                if (handler4 === true)
                  result = value;
                else {
                  if (domain)
                    domain.enter();
                  result = handler4(value);
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject2(TypeError2("Promise-chain cycle"));
                } else if (then = isThenable(result)) {
                  call(then, result, resolve3, reject2);
                } else
                  resolve3(result);
              } else
                reject2(value);
            } catch (error2) {
              if (domain && !exited)
                domain.exit();
              reject2(error2);
            }
          }
          state.reactions = [];
          state.notified = false;
          if (isReject && !state.rejection)
            onUnhandled(state);
        });
      };
      dispatchEvent = function(name, promise, reason) {
        var event2, handler4;
        if (DISPATCH_EVENT) {
          event2 = document2.createEvent("Event");
          event2.promise = promise;
          event2.reason = reason;
          event2.initEvent(name, false, true);
          global2.dispatchEvent(event2);
        } else
          event2 = { promise, reason };
        if (!NATIVE_REJECTION_EVENT && (handler4 = global2["on" + name]))
          handler4(event2);
        else if (name === UNHANDLED_REJECTION)
          hostReportErrors("Unhandled promise rejection", reason);
      };
      onUnhandled = function(state) {
        call(task, global2, function() {
          var promise = state.facade;
          var value = state.value;
          var IS_UNHANDLED = isUnhandled(state);
          var result;
          if (IS_UNHANDLED) {
            result = perform(function() {
              if (IS_NODE) {
                process2.emit("unhandledRejection", value, promise);
              } else
                dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error)
              throw result.value;
          }
        });
      };
      isUnhandled = function(state) {
        return state.rejection !== HANDLED && !state.parent;
      };
      onHandleUnhandled = function(state) {
        call(task, global2, function() {
          var promise = state.facade;
          if (IS_NODE) {
            process2.emit("rejectionHandled", promise);
          } else
            dispatchEvent(REJECTION_HANDLED, promise, state.value);
        });
      };
      bind3 = function(fn, state, unwrap) {
        return function(value) {
          fn(state, value, unwrap);
        };
      };
      internalReject = function(state, value, unwrap) {
        if (state.done)
          return;
        state.done = true;
        if (unwrap)
          state = unwrap;
        state.value = value;
        state.state = REJECTED;
        notify(state, true);
      };
      internalResolve = function(state, value, unwrap) {
        if (state.done)
          return;
        state.done = true;
        if (unwrap)
          state = unwrap;
        try {
          if (state.facade === value)
            throw TypeError2("Promise can't be resolved itself");
          var then = isThenable(value);
          if (then) {
            microtask(function() {
              var wrapper = { done: false };
              try {
                call(then, value, bind3(internalResolve, wrapper, state), bind3(internalReject, wrapper, state));
              } catch (error2) {
                internalReject(wrapper, error2, state);
              }
            });
          } else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
          }
        } catch (error2) {
          internalReject({ done: false }, error2, state);
        }
      };
      if (FORCED) {
        PromiseConstructor = function Promise2(executor) {
          anInstance(this, PromisePrototype);
          aCallable(executor);
          call(Internal, this);
          var state = getInternalState(this);
          try {
            executor(bind3(internalResolve, state), bind3(internalReject, state));
          } catch (error2) {
            internalReject(state, error2);
          }
        };
        PromisePrototype = PromiseConstructor.prototype;
        Internal = function Promise2(executor) {
          setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: void 0
          });
        };
        Internal.prototype = redefineAll(PromisePrototype, {
          then: function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reactions = state.reactions;
            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
            reaction.fail = isCallable(onRejected) && onRejected;
            reaction.domain = IS_NODE ? process2.domain : void 0;
            state.parent = true;
            reactions[reactions.length] = reaction;
            if (state.state != PENDING)
              notify(state, false);
            return reaction.promise;
          },
          "catch": function(onRejected) {
            return this.then(void 0, onRejected);
          }
        });
        OwnPromiseCapability = function() {
          var promise = new Internal();
          var state = getInternalState(promise);
          this.promise = promise;
          this.resolve = bind3(internalResolve, state);
          this.reject = bind3(internalReject, state);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function(C2) {
          return C2 === PromiseConstructor || C2 === PromiseWrapper ? new OwnPromiseCapability(C2) : newGenericPromiseCapability(C2);
        };
        if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
          nativeThen = NativePromisePrototype.then;
          if (!SUBCLASSING) {
            redefine(NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
              var that = this;
              return new PromiseConstructor(function(resolve3, reject2) {
                call(nativeThen, that, resolve3, reject2);
              }).then(onFulfilled, onRejected);
            }, { unsafe: true });
            redefine(NativePromisePrototype, "catch", PromisePrototype["catch"], { unsafe: true });
          }
          try {
            delete NativePromisePrototype.constructor;
          } catch (error2) {
          }
          if (setPrototypeOf) {
            setPrototypeOf(NativePromisePrototype, PromisePrototype);
          }
        }
      }
      $3({ global: true, wrap: true, forced: FORCED }, {
        Promise: PromiseConstructor
      });
      setToStringTag(PromiseConstructor, PROMISE, false, true);
      setSpecies(PROMISE);
      PromiseWrapper = getBuiltIn(PROMISE);
      $3({ target: PROMISE, stat: true, forced: FORCED }, {
        reject: function reject(r2) {
          var capability = newPromiseCapability(this);
          call(capability.reject, void 0, r2);
          return capability.promise;
        }
      });
      $3({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
        resolve: function resolve2(x2) {
          return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x2);
        }
      });
      $3({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
        all: function all(iterable) {
          var C2 = this;
          var capability = newPromiseCapability(C2);
          var resolve3 = capability.resolve;
          var reject2 = capability.reject;
          var result = perform(function() {
            var $promiseResolve = aCallable(C2.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function(promise) {
              var index3 = counter++;
              var alreadyCalled = false;
              remaining++;
              call($promiseResolve, C2, promise).then(function(value) {
                if (alreadyCalled)
                  return;
                alreadyCalled = true;
                values[index3] = value;
                --remaining || resolve3(values);
              }, reject2);
            });
            --remaining || resolve3(values);
          });
          if (result.error)
            reject2(result.value);
          return capability.promise;
        },
        race: function race(iterable) {
          var C2 = this;
          var capability = newPromiseCapability(C2);
          var reject2 = capability.reject;
          var result = perform(function() {
            var $promiseResolve = aCallable(C2.resolve);
            iterate(iterable, function(promise) {
              call($promiseResolve, C2, promise).then(capability.resolve, reject2);
            });
          });
          if (result.error)
            reject2(result.value);
          return capability.promise;
        }
      });
    }
  });

  // node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
  function asyncGeneratorStep(gen, resolve3, reject2, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error2) {
      reject2(error2);
      return;
    }
    if (info.done) {
      resolve3(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function() {
      var self2 = this, args = arguments;
      return new Promise(function(resolve3, reject2) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve3, reject2, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve3, reject2, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  var init_asyncToGenerator = __esm({
    "node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"() {
    }
  });

  // node_modules/core-js/internals/to-string.js
  var require_to_string = __commonJS({
    "node_modules/core-js/internals/to-string.js"(exports, module) {
      var global4 = require_global();
      var classof = require_classof();
      var String2 = global4.String;
      module.exports = function(argument) {
        if (classof(argument) === "Symbol")
          throw TypeError("Cannot convert a Symbol value to a string");
        return String2(argument);
      };
    }
  });

  // node_modules/core-js/internals/regexp-flags.js
  var require_regexp_flags = __commonJS({
    "node_modules/core-js/internals/regexp-flags.js"(exports, module) {
      "use strict";
      var anObject5 = require_an_object();
      module.exports = function() {
        var that = anObject5(this);
        var result = "";
        if (that.global)
          result += "g";
        if (that.ignoreCase)
          result += "i";
        if (that.multiline)
          result += "m";
        if (that.dotAll)
          result += "s";
        if (that.unicode)
          result += "u";
        if (that.sticky)
          result += "y";
        return result;
      };
    }
  });

  // node_modules/core-js/internals/regexp-sticky-helpers.js
  var require_regexp_sticky_helpers = __commonJS({
    "node_modules/core-js/internals/regexp-sticky-helpers.js"(exports) {
      var fails4 = require_fails();
      var global4 = require_global();
      var $RegExp = global4.RegExp;
      exports.UNSUPPORTED_Y = fails4(function() {
        var re2 = $RegExp("a", "y");
        re2.lastIndex = 2;
        return re2.exec("abcd") != null;
      });
      exports.BROKEN_CARET = fails4(function() {
        var re2 = $RegExp("^r", "gy");
        re2.lastIndex = 2;
        return re2.exec("str") != null;
      });
    }
  });

  // node_modules/core-js/internals/object-keys.js
  var require_object_keys = __commonJS({
    "node_modules/core-js/internals/object-keys.js"(exports, module) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      module.exports = Object.keys || function keys(O3) {
        return internalObjectKeys(O3, enumBugKeys);
      };
    }
  });

  // node_modules/core-js/internals/object-define-properties.js
  var require_object_define_properties = __commonJS({
    "node_modules/core-js/internals/object-define-properties.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var anObject5 = require_an_object();
      var toIndexedObject = require_to_indexed_object();
      var objectKeys = require_object_keys();
      module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O3, Properties) {
        anObject5(O3);
        var props = toIndexedObject(Properties);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index3 = 0;
        var key;
        while (length > index3)
          definePropertyModule.f(O3, key = keys[index3++], props[key]);
        return O3;
      };
    }
  });

  // node_modules/core-js/internals/object-create.js
  var require_object_create = __commonJS({
    "node_modules/core-js/internals/object-create.js"(exports, module) {
      var anObject5 = require_an_object();
      var defineProperties = require_object_define_properties();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = require_hidden_keys();
      var html2 = require_html();
      var documentCreateElement = require_document_create_element();
      var sharedKey = require_shared_key();
      var GT = ">";
      var LT = "<";
      var PROTOTYPE = "prototype";
      var SCRIPT = "script";
      var IE_PROTO = sharedKey("IE_PROTO");
      var EmptyConstructor = function() {
      };
      var scriptTag = function(content) {
        return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
      };
      var NullProtoObjectViaActiveX = function(activeXDocument2) {
        activeXDocument2.write(scriptTag(""));
        activeXDocument2.close();
        var temp = activeXDocument2.parentWindow.Object;
        activeXDocument2 = null;
        return temp;
      };
      var NullProtoObjectViaIFrame = function() {
        var iframe = documentCreateElement("iframe");
        var JS = "java" + SCRIPT + ":";
        var iframeDocument;
        iframe.style.display = "none";
        html2.appendChild(iframe);
        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag("document.F=Object"));
        iframeDocument.close();
        return iframeDocument.F;
      };
      var activeXDocument;
      var NullProtoObject = function() {
        try {
          activeXDocument = new ActiveXObject("htmlfile");
        } catch (error2) {
        }
        NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
        var length = enumBugKeys.length;
        while (length--)
          delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
        return NullProtoObject();
      };
      hiddenKeys[IE_PROTO] = true;
      module.exports = Object.create || function create(O3, Properties) {
        var result;
        if (O3 !== null) {
          EmptyConstructor[PROTOTYPE] = anObject5(O3);
          result = new EmptyConstructor();
          EmptyConstructor[PROTOTYPE] = null;
          result[IE_PROTO] = O3;
        } else
          result = NullProtoObject();
        return Properties === void 0 ? result : defineProperties(result, Properties);
      };
    }
  });

  // node_modules/core-js/internals/regexp-unsupported-dot-all.js
  var require_regexp_unsupported_dot_all = __commonJS({
    "node_modules/core-js/internals/regexp-unsupported-dot-all.js"(exports, module) {
      var fails4 = require_fails();
      var global4 = require_global();
      var $RegExp = global4.RegExp;
      module.exports = fails4(function() {
        var re2 = $RegExp(".", "s");
        return !(re2.dotAll && re2.exec("\n") && re2.flags === "s");
      });
    }
  });

  // node_modules/core-js/internals/regexp-unsupported-ncg.js
  var require_regexp_unsupported_ncg = __commonJS({
    "node_modules/core-js/internals/regexp-unsupported-ncg.js"(exports, module) {
      var fails4 = require_fails();
      var global4 = require_global();
      var $RegExp = global4.RegExp;
      module.exports = fails4(function() {
        var re2 = $RegExp("(?<a>b)", "g");
        return re2.exec("b").groups.a !== "b" || "b".replace(re2, "$<a>c") !== "bc";
      });
    }
  });

  // node_modules/core-js/internals/regexp-exec.js
  var require_regexp_exec = __commonJS({
    "node_modules/core-js/internals/regexp-exec.js"(exports, module) {
      "use strict";
      var call5 = require_function_call();
      var uncurryThis9 = require_function_uncurry_this();
      var toString7 = require_to_string();
      var regexpFlags = require_regexp_flags();
      var stickyHelpers2 = require_regexp_sticky_helpers();
      var shared = require_shared();
      var create = require_object_create();
      var getInternalState2 = require_internal_state().get;
      var UNSUPPORTED_DOT_ALL = require_regexp_unsupported_dot_all();
      var UNSUPPORTED_NCG = require_regexp_unsupported_ncg();
      var nativeReplace = shared("native-string-replace", String.prototype.replace);
      var nativeExec = RegExp.prototype.exec;
      var patchedExec = nativeExec;
      var charAt = uncurryThis9("".charAt);
      var indexOf2 = uncurryThis9("".indexOf);
      var replace = uncurryThis9("".replace);
      var stringSlice4 = uncurryThis9("".slice);
      var UPDATES_LAST_INDEX_WRONG = function() {
        var re1 = /a/;
        var re2 = /b*/g;
        call5(nativeExec, re1, "a");
        call5(nativeExec, re2, "a");
        return re1.lastIndex !== 0 || re2.lastIndex !== 0;
      }();
      var UNSUPPORTED_Y2 = stickyHelpers2.UNSUPPORTED_Y || stickyHelpers2.BROKEN_CARET;
      var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
      var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y2 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
      if (PATCH) {
        patchedExec = function exec2(string) {
          var re2 = this;
          var state = getInternalState2(re2);
          var str = toString7(string);
          var raw2 = state.raw;
          var result, reCopy, lastIndex, match, i3, object, group;
          if (raw2) {
            raw2.lastIndex = re2.lastIndex;
            result = call5(patchedExec, raw2, str);
            re2.lastIndex = raw2.lastIndex;
            return result;
          }
          var groups = state.groups;
          var sticky = UNSUPPORTED_Y2 && re2.sticky;
          var flags = call5(regexpFlags, re2);
          var source = re2.source;
          var charsAdded = 0;
          var strCopy = str;
          if (sticky) {
            flags = replace(flags, "y", "");
            if (indexOf2(flags, "g") === -1) {
              flags += "g";
            }
            strCopy = stringSlice4(str, re2.lastIndex);
            if (re2.lastIndex > 0 && (!re2.multiline || re2.multiline && charAt(str, re2.lastIndex - 1) !== "\n")) {
              source = "(?: " + source + ")";
              strCopy = " " + strCopy;
              charsAdded++;
            }
            reCopy = new RegExp("^(?:" + source + ")", flags);
          }
          if (NPCG_INCLUDED) {
            reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
          }
          if (UPDATES_LAST_INDEX_WRONG)
            lastIndex = re2.lastIndex;
          match = call5(nativeExec, sticky ? reCopy : re2, strCopy);
          if (sticky) {
            if (match) {
              match.input = stringSlice4(match.input, charsAdded);
              match[0] = stringSlice4(match[0], charsAdded);
              match.index = re2.lastIndex;
              re2.lastIndex += match[0].length;
            } else
              re2.lastIndex = 0;
          } else if (UPDATES_LAST_INDEX_WRONG && match) {
            re2.lastIndex = re2.global ? match.index + match[0].length : lastIndex;
          }
          if (NPCG_INCLUDED && match && match.length > 1) {
            call5(nativeReplace, match[0], reCopy, function() {
              for (i3 = 1; i3 < arguments.length - 2; i3++) {
                if (arguments[i3] === void 0)
                  match[i3] = void 0;
              }
            });
          }
          if (match && groups) {
            match.groups = object = create(null);
            for (i3 = 0; i3 < groups.length; i3++) {
              group = groups[i3];
              object[group[0]] = match[group[1]];
            }
          }
          return match;
        };
      }
      module.exports = patchedExec;
    }
  });

  // node_modules/core-js/modules/es.regexp.exec.js
  var require_es_regexp_exec = __commonJS({
    "node_modules/core-js/modules/es.regexp.exec.js"() {
      "use strict";
      var $12 = require_export();
      var exec2 = require_regexp_exec();
      $12({ target: "RegExp", proto: true, forced: /./.exec !== exec2 }, {
        exec: exec2
      });
    }
  });

  // node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js
  var require_fix_regexp_well_known_symbol_logic = __commonJS({
    "node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js"(exports, module) {
      "use strict";
      require_es_regexp_exec();
      var uncurryThis9 = require_function_uncurry_this();
      var redefine3 = require_redefine();
      var regexpExec2 = require_regexp_exec();
      var fails4 = require_fails();
      var wellKnownSymbol4 = require_well_known_symbol();
      var createNonEnumerableProperty2 = require_create_non_enumerable_property();
      var SPECIES2 = wellKnownSymbol4("species");
      var RegExpPrototype2 = RegExp.prototype;
      module.exports = function(KEY, exec2, FORCED2, SHAM) {
        var SYMBOL = wellKnownSymbol4(KEY);
        var DELEGATES_TO_SYMBOL = !fails4(function() {
          var O3 = {};
          O3[SYMBOL] = function() {
            return 7;
          };
          return ""[KEY](O3) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails4(function() {
          var execCalled = false;
          var re2 = /a/;
          if (KEY === "split") {
            re2 = {};
            re2.constructor = {};
            re2.constructor[SPECIES2] = function() {
              return re2;
            };
            re2.flags = "";
            re2[SYMBOL] = /./[SYMBOL];
          }
          re2.exec = function() {
            execCalled = true;
            return null;
          };
          re2[SYMBOL]("");
          return !execCalled;
        });
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED2) {
          var uncurriedNativeRegExpMethod = uncurryThis9(/./[SYMBOL]);
          var methods = exec2(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = uncurryThis9(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === regexpExec2 || $exec === RegExpPrototype2.exec) {
              if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
              }
              return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
            }
            return { done: false };
          });
          redefine3(String.prototype, KEY, methods[0]);
          redefine3(RegExpPrototype2, SYMBOL, methods[1]);
        }
        if (SHAM)
          createNonEnumerableProperty2(RegExpPrototype2[SYMBOL], "sham", true);
      };
    }
  });

  // node_modules/core-js/internals/string-multibyte.js
  var require_string_multibyte = __commonJS({
    "node_modules/core-js/internals/string-multibyte.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var toIntegerOrInfinity2 = require_to_integer_or_infinity();
      var toString7 = require_to_string();
      var requireObjectCoercible7 = require_require_object_coercible();
      var charAt = uncurryThis9("".charAt);
      var charCodeAt = uncurryThis9("".charCodeAt);
      var stringSlice4 = uncurryThis9("".slice);
      var createMethod = function(CONVERT_TO_STRING) {
        return function($this, pos) {
          var S2 = toString7(requireObjectCoercible7($this));
          var position = toIntegerOrInfinity2(pos);
          var size3 = S2.length;
          var first, second;
          if (position < 0 || position >= size3)
            return CONVERT_TO_STRING ? "" : void 0;
          first = charCodeAt(S2, position);
          return first < 55296 || first > 56319 || position + 1 === size3 || (second = charCodeAt(S2, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt(S2, position) : first : CONVERT_TO_STRING ? stringSlice4(S2, position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
        };
      };
      module.exports = {
        codeAt: createMethod(false),
        charAt: createMethod(true)
      };
    }
  });

  // node_modules/core-js/internals/advance-string-index.js
  var require_advance_string_index = __commonJS({
    "node_modules/core-js/internals/advance-string-index.js"(exports, module) {
      "use strict";
      var charAt = require_string_multibyte().charAt;
      module.exports = function(S2, index3, unicode) {
        return index3 + (unicode ? charAt(S2, index3).length : 1);
      };
    }
  });

  // node_modules/core-js/internals/regexp-exec-abstract.js
  var require_regexp_exec_abstract = __commonJS({
    "node_modules/core-js/internals/regexp-exec-abstract.js"(exports, module) {
      var global4 = require_global();
      var call5 = require_function_call();
      var anObject5 = require_an_object();
      var isCallable3 = require_is_callable();
      var classof = require_classof_raw();
      var regexpExec2 = require_regexp_exec();
      var TypeError3 = global4.TypeError;
      module.exports = function(R2, S2) {
        var exec2 = R2.exec;
        if (isCallable3(exec2)) {
          var result = call5(exec2, R2, S2);
          if (result !== null)
            anObject5(result);
          return result;
        }
        if (classof(R2) === "RegExp")
          return call5(regexpExec2, R2, S2);
        throw TypeError3("RegExp#exec called on incompatible receiver");
      };
    }
  });

  // node_modules/core-js/modules/es.string.match.js
  var call2, fixRegExpWellKnownSymbolLogic, anObject, toLength, toString, requireObjectCoercible, getMethod, advanceStringIndex, regExpExec;
  var init_es_string_match = __esm({
    "node_modules/core-js/modules/es.string.match.js"() {
      "use strict";
      call2 = require_function_call();
      fixRegExpWellKnownSymbolLogic = require_fix_regexp_well_known_symbol_logic();
      anObject = require_an_object();
      toLength = require_to_length();
      toString = require_to_string();
      requireObjectCoercible = require_require_object_coercible();
      getMethod = require_get_method();
      advanceStringIndex = require_advance_string_index();
      regExpExec = require_regexp_exec_abstract();
      fixRegExpWellKnownSymbolLogic("match", function(MATCH, nativeMatch, maybeCallNative) {
        return [
          function match(regexp) {
            var O3 = requireObjectCoercible(this);
            var matcher = regexp == void 0 ? void 0 : getMethod(regexp, MATCH);
            return matcher ? call2(matcher, regexp, O3) : new RegExp(regexp)[MATCH](toString(O3));
          },
          function(string) {
            var rx = anObject(this);
            var S2 = toString(string);
            var res = maybeCallNative(nativeMatch, rx, S2);
            if (res.done)
              return res.value;
            if (!rx.global)
              return regExpExec(rx, S2);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A2 = [];
            var n3 = 0;
            var result;
            while ((result = regExpExec(rx, S2)) !== null) {
              var matchStr = toString(result[0]);
              A2[n3] = matchStr;
              if (matchStr === "")
                rx.lastIndex = advanceStringIndex(S2, toLength(rx.lastIndex), fullUnicode);
              n3++;
            }
            return n3 === 0 ? null : A2;
          }
        ];
      });
    }
  });

  // node_modules/core-js/internals/get-substitution.js
  var require_get_substitution = __commonJS({
    "node_modules/core-js/internals/get-substitution.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var toObject = require_to_object();
      var floor = Math.floor;
      var charAt = uncurryThis9("".charAt);
      var replace = uncurryThis9("".replace);
      var stringSlice4 = uncurryThis9("".slice);
      var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
      var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
      module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m4 = captures.length;
        var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== void 0) {
          namedCaptures = toObject(namedCaptures);
          symbols = SUBSTITUTION_SYMBOLS;
        }
        return replace(replacement, symbols, function(match, ch) {
          var capture;
          switch (charAt(ch, 0)) {
            case "$":
              return "$";
            case "&":
              return matched;
            case "`":
              return stringSlice4(str, 0, position);
            case "'":
              return stringSlice4(str, tailPos);
            case "<":
              capture = namedCaptures[stringSlice4(ch, 1, -1)];
              break;
            default:
              var n3 = +ch;
              if (n3 === 0)
                return match;
              if (n3 > m4) {
                var f3 = floor(n3 / 10);
                if (f3 === 0)
                  return match;
                if (f3 <= m4)
                  return captures[f3 - 1] === void 0 ? charAt(ch, 1) : captures[f3 - 1] + charAt(ch, 1);
                return match;
              }
              capture = captures[n3 - 1];
          }
          return capture === void 0 ? "" : capture;
        });
      };
    }
  });

  // node_modules/core-js/modules/es.string.replace.js
  var apply, call3, uncurryThis, fixRegExpWellKnownSymbolLogic2, fails, anObject2, isCallable2, toIntegerOrInfinity, toLength2, toString2, requireObjectCoercible2, advanceStringIndex2, getMethod2, getSubstitution, regExpExec2, wellKnownSymbol2, REPLACE, max2, min, concat, push, stringIndexOf, stringSlice, maybeToString, REPLACE_KEEPS_$0, REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, REPLACE_SUPPORTS_NAMED_GROUPS;
  var init_es_string_replace = __esm({
    "node_modules/core-js/modules/es.string.replace.js"() {
      "use strict";
      apply = require_function_apply();
      call3 = require_function_call();
      uncurryThis = require_function_uncurry_this();
      fixRegExpWellKnownSymbolLogic2 = require_fix_regexp_well_known_symbol_logic();
      fails = require_fails();
      anObject2 = require_an_object();
      isCallable2 = require_is_callable();
      toIntegerOrInfinity = require_to_integer_or_infinity();
      toLength2 = require_to_length();
      toString2 = require_to_string();
      requireObjectCoercible2 = require_require_object_coercible();
      advanceStringIndex2 = require_advance_string_index();
      getMethod2 = require_get_method();
      getSubstitution = require_get_substitution();
      regExpExec2 = require_regexp_exec_abstract();
      wellKnownSymbol2 = require_well_known_symbol();
      REPLACE = wellKnownSymbol2("replace");
      max2 = Math.max;
      min = Math.min;
      concat = uncurryThis([].concat);
      push = uncurryThis([].push);
      stringIndexOf = uncurryThis("".indexOf);
      stringSlice = uncurryThis("".slice);
      maybeToString = function(it2) {
        return it2 === void 0 ? it2 : String(it2);
      };
      REPLACE_KEEPS_$0 = function() {
        return "a".replace(/./, "$0") === "$0";
      }();
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
        if (/./[REPLACE]) {
          return /./[REPLACE]("a", "$0") === "";
        }
        return false;
      }();
      REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
        var re2 = /./;
        re2.exec = function() {
          var result = [];
          result.groups = { a: "7" };
          return result;
        };
        return "".replace(re2, "$<a>") !== "7";
      });
      fixRegExpWellKnownSymbolLogic2("replace", function(_3, nativeReplace, maybeCallNative) {
        var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
        return [
          function replace(searchValue, replaceValue) {
            var O3 = requireObjectCoercible2(this);
            var replacer2 = searchValue == void 0 ? void 0 : getMethod2(searchValue, REPLACE);
            return replacer2 ? call3(replacer2, searchValue, O3, replaceValue) : call3(nativeReplace, toString2(O3), searchValue, replaceValue);
          },
          function(string, replaceValue) {
            var rx = anObject2(this);
            var S2 = toString2(string);
            if (typeof replaceValue == "string" && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, "$<") === -1) {
              var res = maybeCallNative(nativeReplace, rx, S2, replaceValue);
              if (res.done)
                return res.value;
            }
            var functionalReplace = isCallable2(replaceValue);
            if (!functionalReplace)
              replaceValue = toString2(replaceValue);
            var global4 = rx.global;
            if (global4) {
              var fullUnicode = rx.unicode;
              rx.lastIndex = 0;
            }
            var results = [];
            while (true) {
              var result = regExpExec2(rx, S2);
              if (result === null)
                break;
              push(results, result);
              if (!global4)
                break;
              var matchStr = toString2(result[0]);
              if (matchStr === "")
                rx.lastIndex = advanceStringIndex2(S2, toLength2(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for (var i3 = 0; i3 < results.length; i3++) {
              result = results[i3];
              var matched = toString2(result[0]);
              var position = max2(min(toIntegerOrInfinity(result.index), S2.length), 0);
              var captures = [];
              for (var j2 = 1; j2 < result.length; j2++)
                push(captures, maybeToString(result[j2]));
              var namedCaptures = result.groups;
              if (functionalReplace) {
                var replacerArgs = concat([matched], captures, position, S2);
                if (namedCaptures !== void 0)
                  push(replacerArgs, namedCaptures);
                var replacement = toString2(apply(replaceValue, void 0, replacerArgs));
              } else {
                replacement = getSubstitution(matched, S2, position, captures, namedCaptures, replaceValue);
              }
              if (position >= nextSourcePosition) {
                accumulatedResult += stringSlice(S2, nextSourcePosition, position) + replacement;
                nextSourcePosition = position + matched.length;
              }
            }
            return accumulatedResult + stringSlice(S2, nextSourcePosition);
          }
        ];
      }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
    }
  });

  // node_modules/core-js/internals/is-regexp.js
  var require_is_regexp = __commonJS({
    "node_modules/core-js/internals/is-regexp.js"(exports, module) {
      var isObject7 = require_is_object();
      var classof = require_classof_raw();
      var wellKnownSymbol4 = require_well_known_symbol();
      var MATCH = wellKnownSymbol4("match");
      module.exports = function(it2) {
        var isRegExp2;
        return isObject7(it2) && ((isRegExp2 = it2[MATCH]) !== void 0 ? !!isRegExp2 : classof(it2) == "RegExp");
      };
    }
  });

  // node_modules/core-js/internals/not-a-regexp.js
  var require_not_a_regexp = __commonJS({
    "node_modules/core-js/internals/not-a-regexp.js"(exports, module) {
      var global4 = require_global();
      var isRegExp2 = require_is_regexp();
      var TypeError3 = global4.TypeError;
      module.exports = function(it2) {
        if (isRegExp2(it2)) {
          throw TypeError3("The method doesn't accept regular expressions");
        }
        return it2;
      };
    }
  });

  // node_modules/core-js/internals/correct-is-regexp-logic.js
  var require_correct_is_regexp_logic = __commonJS({
    "node_modules/core-js/internals/correct-is-regexp-logic.js"(exports, module) {
      var wellKnownSymbol4 = require_well_known_symbol();
      var MATCH = wellKnownSymbol4("match");
      module.exports = function(METHOD_NAME) {
        var regexp = /./;
        try {
          "/./"[METHOD_NAME](regexp);
        } catch (error1) {
          try {
            regexp[MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
          } catch (error2) {
          }
        }
        return false;
      };
    }
  });

  // node_modules/core-js/modules/es.string.starts-with.js
  var $4, uncurryThis2, getOwnPropertyDescriptor, toLength3, toString3, notARegExp, requireObjectCoercible3, correctIsRegExpLogic, IS_PURE2, un$StartsWith, stringSlice2, min2, CORRECT_IS_REGEXP_LOGIC, MDN_POLYFILL_BUG;
  var init_es_string_starts_with = __esm({
    "node_modules/core-js/modules/es.string.starts-with.js"() {
      "use strict";
      $4 = require_export();
      uncurryThis2 = require_function_uncurry_this();
      getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
      toLength3 = require_to_length();
      toString3 = require_to_string();
      notARegExp = require_not_a_regexp();
      requireObjectCoercible3 = require_require_object_coercible();
      correctIsRegExpLogic = require_correct_is_regexp_logic();
      IS_PURE2 = require_is_pure();
      un$StartsWith = uncurryThis2("".startsWith);
      stringSlice2 = uncurryThis2("".slice);
      min2 = Math.min;
      CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
      MDN_POLYFILL_BUG = !IS_PURE2 && !CORRECT_IS_REGEXP_LOGIC && !!function() {
        var descriptor = getOwnPropertyDescriptor(String.prototype, "startsWith");
        return descriptor && !descriptor.writable;
      }();
      $4({ target: "String", proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
        startsWith: function startsWith(searchString) {
          var that = toString3(requireObjectCoercible3(this));
          notARegExp(searchString);
          var index3 = toLength3(min2(arguments.length > 1 ? arguments[1] : void 0, that.length));
          var search = toString3(searchString);
          return un$StartsWith ? un$StartsWith(that, search, index3) : stringSlice2(that, index3, index3 + search.length) === search;
        }
      });
    }
  });

  // node_modules/core-js/internals/add-to-unscopables.js
  var require_add_to_unscopables = __commonJS({
    "node_modules/core-js/internals/add-to-unscopables.js"(exports, module) {
      var wellKnownSymbol4 = require_well_known_symbol();
      var create = require_object_create();
      var definePropertyModule = require_object_define_property();
      var UNSCOPABLES = wellKnownSymbol4("unscopables");
      var ArrayPrototype = Array.prototype;
      if (ArrayPrototype[UNSCOPABLES] == void 0) {
        definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
          configurable: true,
          value: create(null)
        });
      }
      module.exports = function(key) {
        ArrayPrototype[UNSCOPABLES][key] = true;
      };
    }
  });

  // node_modules/core-js/internals/correct-prototype-getter.js
  var require_correct_prototype_getter = __commonJS({
    "node_modules/core-js/internals/correct-prototype-getter.js"(exports, module) {
      var fails4 = require_fails();
      module.exports = !fails4(function() {
        function F2() {
        }
        F2.prototype.constructor = null;
        return Object.getPrototypeOf(new F2()) !== F2.prototype;
      });
    }
  });

  // node_modules/core-js/internals/object-get-prototype-of.js
  var require_object_get_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-get-prototype-of.js"(exports, module) {
      var global4 = require_global();
      var hasOwn3 = require_has_own_property();
      var isCallable3 = require_is_callable();
      var toObject = require_to_object();
      var sharedKey = require_shared_key();
      var CORRECT_PROTOTYPE_GETTER = require_correct_prototype_getter();
      var IE_PROTO = sharedKey("IE_PROTO");
      var Object2 = global4.Object;
      var ObjectPrototype = Object2.prototype;
      module.exports = CORRECT_PROTOTYPE_GETTER ? Object2.getPrototypeOf : function(O3) {
        var object = toObject(O3);
        if (hasOwn3(object, IE_PROTO))
          return object[IE_PROTO];
        var constructor = object.constructor;
        if (isCallable3(constructor) && object instanceof constructor) {
          return constructor.prototype;
        }
        return object instanceof Object2 ? ObjectPrototype : null;
      };
    }
  });

  // node_modules/core-js/internals/iterators-core.js
  var require_iterators_core = __commonJS({
    "node_modules/core-js/internals/iterators-core.js"(exports, module) {
      "use strict";
      var fails4 = require_fails();
      var isCallable3 = require_is_callable();
      var create = require_object_create();
      var getPrototypeOf = require_object_get_prototype_of();
      var redefine3 = require_redefine();
      var wellKnownSymbol4 = require_well_known_symbol();
      var IS_PURE4 = require_is_pure();
      var ITERATOR2 = wellKnownSymbol4("iterator");
      var BUGGY_SAFARI_ITERATORS = false;
      var IteratorPrototype;
      var PrototypeOfArrayIteratorPrototype;
      var arrayIterator;
      if ([].keys) {
        arrayIterator = [].keys();
        if (!("next" in arrayIterator))
          BUGGY_SAFARI_ITERATORS = true;
        else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
            IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
      }
      var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == void 0 || fails4(function() {
        var test2 = {};
        return IteratorPrototype[ITERATOR2].call(test2) !== test2;
      });
      if (NEW_ITERATOR_PROTOTYPE)
        IteratorPrototype = {};
      else if (IS_PURE4)
        IteratorPrototype = create(IteratorPrototype);
      if (!isCallable3(IteratorPrototype[ITERATOR2])) {
        redefine3(IteratorPrototype, ITERATOR2, function() {
          return this;
        });
      }
      module.exports = {
        IteratorPrototype,
        BUGGY_SAFARI_ITERATORS
      };
    }
  });

  // node_modules/core-js/internals/create-iterator-constructor.js
  var require_create_iterator_constructor = __commonJS({
    "node_modules/core-js/internals/create-iterator-constructor.js"(exports, module) {
      "use strict";
      var IteratorPrototype = require_iterators_core().IteratorPrototype;
      var create = require_object_create();
      var createPropertyDescriptor = require_create_property_descriptor();
      var setToStringTag2 = require_set_to_string_tag();
      var Iterators = require_iterators();
      var returnThis = function() {
        return this;
      };
      module.exports = function(IteratorConstructor, NAME, next2) {
        var TO_STRING_TAG2 = NAME + " Iterator";
        IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next2) });
        setToStringTag2(IteratorConstructor, TO_STRING_TAG2, false, true);
        Iterators[TO_STRING_TAG2] = returnThis;
        return IteratorConstructor;
      };
    }
  });

  // node_modules/core-js/internals/define-iterator.js
  var require_define_iterator = __commonJS({
    "node_modules/core-js/internals/define-iterator.js"(exports, module) {
      "use strict";
      var $12 = require_export();
      var call5 = require_function_call();
      var IS_PURE4 = require_is_pure();
      var FunctionName = require_function_name();
      var isCallable3 = require_is_callable();
      var createIteratorConstructor = require_create_iterator_constructor();
      var getPrototypeOf = require_object_get_prototype_of();
      var setPrototypeOf2 = require_object_set_prototype_of();
      var setToStringTag2 = require_set_to_string_tag();
      var createNonEnumerableProperty2 = require_create_non_enumerable_property();
      var redefine3 = require_redefine();
      var wellKnownSymbol4 = require_well_known_symbol();
      var Iterators = require_iterators();
      var IteratorsCore = require_iterators_core();
      var PROPER_FUNCTION_NAME2 = FunctionName.PROPER;
      var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
      var IteratorPrototype = IteratorsCore.IteratorPrototype;
      var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
      var ITERATOR2 = wellKnownSymbol4("iterator");
      var KEYS = "keys";
      var VALUES = "values";
      var ENTRIES = "entries";
      var returnThis = function() {
        return this;
      };
      module.exports = function(Iterable, NAME, IteratorConstructor, next2, DEFAULT2, IS_SET, FORCED2) {
        createIteratorConstructor(IteratorConstructor, NAME, next2);
        var getIterationMethod = function(KIND) {
          if (KIND === DEFAULT2 && defaultIterator)
            return defaultIterator;
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
            return IterablePrototype[KIND];
          switch (KIND) {
            case KEYS:
              return function keys() {
                return new IteratorConstructor(this, KIND);
              };
            case VALUES:
              return function values() {
                return new IteratorConstructor(this, KIND);
              };
            case ENTRIES:
              return function entries() {
                return new IteratorConstructor(this, KIND);
              };
          }
          return function() {
            return new IteratorConstructor(this);
          };
        };
        var TO_STRING_TAG2 = NAME + " Iterator";
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR2] || IterablePrototype["@@iterator"] || DEFAULT2 && IterablePrototype[DEFAULT2];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT2);
        var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
          if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE4 && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf2) {
                setPrototypeOf2(CurrentIteratorPrototype, IteratorPrototype);
              } else if (!isCallable3(CurrentIteratorPrototype[ITERATOR2])) {
                redefine3(CurrentIteratorPrototype, ITERATOR2, returnThis);
              }
            }
            setToStringTag2(CurrentIteratorPrototype, TO_STRING_TAG2, true, true);
            if (IS_PURE4)
              Iterators[TO_STRING_TAG2] = returnThis;
          }
        }
        if (PROPER_FUNCTION_NAME2 && DEFAULT2 == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          if (!IS_PURE4 && CONFIGURABLE_FUNCTION_NAME) {
            createNonEnumerableProperty2(IterablePrototype, "name", VALUES);
          } else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
              return call5(nativeIterator, this);
            };
          }
        }
        if (DEFAULT2) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          };
          if (FORCED2)
            for (KEY in methods) {
              if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                redefine3(IterablePrototype, KEY, methods[KEY]);
              }
            }
          else
            $12({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
        }
        if ((!IS_PURE4 || FORCED2) && IterablePrototype[ITERATOR2] !== defaultIterator) {
          redefine3(IterablePrototype, ITERATOR2, defaultIterator, { name: DEFAULT2 });
        }
        Iterators[NAME] = defaultIterator;
        return methods;
      };
    }
  });

  // node_modules/core-js/modules/es.array.iterator.js
  var require_es_array_iterator = __commonJS({
    "node_modules/core-js/modules/es.array.iterator.js"(exports, module) {
      "use strict";
      var toIndexedObject = require_to_indexed_object();
      var addToUnscopables = require_add_to_unscopables();
      var Iterators = require_iterators();
      var InternalStateModule2 = require_internal_state();
      var defineIterator = require_define_iterator();
      var ARRAY_ITERATOR = "Array Iterator";
      var setInternalState2 = InternalStateModule2.set;
      var getInternalState2 = InternalStateModule2.getterFor(ARRAY_ITERATOR);
      module.exports = defineIterator(Array, "Array", function(iterated, kind) {
        setInternalState2(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(iterated),
          index: 0,
          kind
        });
      }, function() {
        var state = getInternalState2(this);
        var target = state.target;
        var kind = state.kind;
        var index3 = state.index++;
        if (!target || index3 >= target.length) {
          state.target = void 0;
          return { value: void 0, done: true };
        }
        if (kind == "keys")
          return { value: index3, done: false };
        if (kind == "values")
          return { value: target[index3], done: false };
        return { value: [index3, target[index3]], done: false };
      }, "values");
      Iterators.Arguments = Iterators.Array;
      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");
    }
  });

  // node_modules/core-js/internals/dom-iterables.js
  var require_dom_iterables = __commonJS({
    "node_modules/core-js/internals/dom-iterables.js"(exports, module) {
      module.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
    }
  });

  // node_modules/core-js/internals/dom-token-list-prototype.js
  var require_dom_token_list_prototype = __commonJS({
    "node_modules/core-js/internals/dom-token-list-prototype.js"(exports, module) {
      var documentCreateElement = require_document_create_element();
      var classList = documentCreateElement("span").classList;
      var DOMTokenListPrototype2 = classList && classList.constructor && classList.constructor.prototype;
      module.exports = DOMTokenListPrototype2 === Object.prototype ? void 0 : DOMTokenListPrototype2;
    }
  });

  // node_modules/core-js/modules/web.dom-collections.iterator.js
  var global3, DOMIterables, DOMTokenListPrototype, ArrayIteratorMethods, createNonEnumerableProperty, wellKnownSymbol3, ITERATOR, TO_STRING_TAG, ArrayValues, handlePrototype, COLLECTION_NAME;
  var init_web_dom_collections_iterator = __esm({
    "node_modules/core-js/modules/web.dom-collections.iterator.js"() {
      global3 = require_global();
      DOMIterables = require_dom_iterables();
      DOMTokenListPrototype = require_dom_token_list_prototype();
      ArrayIteratorMethods = require_es_array_iterator();
      createNonEnumerableProperty = require_create_non_enumerable_property();
      wellKnownSymbol3 = require_well_known_symbol();
      ITERATOR = wellKnownSymbol3("iterator");
      TO_STRING_TAG = wellKnownSymbol3("toStringTag");
      ArrayValues = ArrayIteratorMethods.values;
      handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
        if (CollectionPrototype) {
          if (CollectionPrototype[ITERATOR] !== ArrayValues)
            try {
              createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
            } catch (error2) {
              CollectionPrototype[ITERATOR] = ArrayValues;
            }
          if (!CollectionPrototype[TO_STRING_TAG]) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
          }
          if (DOMIterables[COLLECTION_NAME])
            for (var METHOD_NAME in ArrayIteratorMethods) {
              if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
                try {
                  createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                } catch (error2) {
                  CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                }
            }
        }
      };
      for (COLLECTION_NAME in DOMIterables) {
        handlePrototype(global3[COLLECTION_NAME] && global3[COLLECTION_NAME].prototype, COLLECTION_NAME);
      }
      handlePrototype(DOMTokenListPrototype, "DOMTokenList");
    }
  });

  // node_modules/@babel/runtime/helpers/esm/defineProperty.js
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var init_defineProperty = __esm({
    "node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    }
  });

  // node_modules/core-js/internals/array-reduce.js
  var require_array_reduce = __commonJS({
    "node_modules/core-js/internals/array-reduce.js"(exports, module) {
      var global4 = require_global();
      var aCallable2 = require_a_callable();
      var toObject = require_to_object();
      var IndexedObject = require_indexed_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var TypeError3 = global4.TypeError;
      var createMethod = function(IS_RIGHT) {
        return function(that, callbackfn, argumentsLength, memo) {
          aCallable2(callbackfn);
          var O3 = toObject(that);
          var self2 = IndexedObject(O3);
          var length = lengthOfArrayLike(O3);
          var index3 = IS_RIGHT ? length - 1 : 0;
          var i3 = IS_RIGHT ? -1 : 1;
          if (argumentsLength < 2)
            while (true) {
              if (index3 in self2) {
                memo = self2[index3];
                index3 += i3;
                break;
              }
              index3 += i3;
              if (IS_RIGHT ? index3 < 0 : length <= index3) {
                throw TypeError3("Reduce of empty array with no initial value");
              }
            }
          for (; IS_RIGHT ? index3 >= 0 : length > index3; index3 += i3)
            if (index3 in self2) {
              memo = callbackfn(memo, self2[index3], index3, O3);
            }
          return memo;
        };
      };
      module.exports = {
        left: createMethod(false),
        right: createMethod(true)
      };
    }
  });

  // node_modules/core-js/internals/array-method-is-strict.js
  var require_array_method_is_strict = __commonJS({
    "node_modules/core-js/internals/array-method-is-strict.js"(exports, module) {
      "use strict";
      var fails4 = require_fails();
      module.exports = function(METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !!method && fails4(function() {
          method.call(null, argument || function() {
            throw 1;
          }, 1);
        });
      };
    }
  });

  // node_modules/core-js/modules/es.array.reduce.js
  var $5, $reduce, arrayMethodIsStrict, CHROME_VERSION, IS_NODE2, STRICT_METHOD, CHROME_BUG;
  var init_es_array_reduce = __esm({
    "node_modules/core-js/modules/es.array.reduce.js"() {
      "use strict";
      $5 = require_export();
      $reduce = require_array_reduce().left;
      arrayMethodIsStrict = require_array_method_is_strict();
      CHROME_VERSION = require_engine_v8_version();
      IS_NODE2 = require_engine_is_node();
      STRICT_METHOD = arrayMethodIsStrict("reduce");
      CHROME_BUG = !IS_NODE2 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
      $5({ target: "Array", proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
        reduce: function reduce(callbackfn) {
          var length = arguments.length;
          return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.string.ends-with.js
  var $6, uncurryThis3, getOwnPropertyDescriptor2, toLength4, toString4, notARegExp2, requireObjectCoercible4, correctIsRegExpLogic2, IS_PURE3, un$EndsWith, slice, min3, CORRECT_IS_REGEXP_LOGIC2, MDN_POLYFILL_BUG2;
  var init_es_string_ends_with = __esm({
    "node_modules/core-js/modules/es.string.ends-with.js"() {
      "use strict";
      $6 = require_export();
      uncurryThis3 = require_function_uncurry_this();
      getOwnPropertyDescriptor2 = require_object_get_own_property_descriptor().f;
      toLength4 = require_to_length();
      toString4 = require_to_string();
      notARegExp2 = require_not_a_regexp();
      requireObjectCoercible4 = require_require_object_coercible();
      correctIsRegExpLogic2 = require_correct_is_regexp_logic();
      IS_PURE3 = require_is_pure();
      un$EndsWith = uncurryThis3("".endsWith);
      slice = uncurryThis3("".slice);
      min3 = Math.min;
      CORRECT_IS_REGEXP_LOGIC2 = correctIsRegExpLogic2("endsWith");
      MDN_POLYFILL_BUG2 = !IS_PURE3 && !CORRECT_IS_REGEXP_LOGIC2 && !!function() {
        var descriptor = getOwnPropertyDescriptor2(String.prototype, "endsWith");
        return descriptor && !descriptor.writable;
      }();
      $6({ target: "String", proto: true, forced: !MDN_POLYFILL_BUG2 && !CORRECT_IS_REGEXP_LOGIC2 }, {
        endsWith: function endsWith(searchString) {
          var that = toString4(requireObjectCoercible4(this));
          notARegExp2(searchString);
          var endPosition = arguments.length > 1 ? arguments[1] : void 0;
          var len = that.length;
          var end = endPosition === void 0 ? len : min3(toLength4(endPosition), len);
          var search = toString4(searchString);
          return un$EndsWith ? un$EndsWith(that, search, end) : slice(that, end - search.length, end) === search;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.string.split.js
  var apply2, call4, uncurryThis4, fixRegExpWellKnownSymbolLogic3, isRegExp, anObject3, requireObjectCoercible5, speciesConstructor2, advanceStringIndex3, toLength5, toString5, getMethod3, arraySlice, callRegExpExec, regexpExec, stickyHelpers, fails2, UNSUPPORTED_Y, MAX_UINT32, min4, $push, exec, push2, stringSlice3, SPLIT_WORKS_WITH_OVERWRITTEN_EXEC;
  var init_es_string_split = __esm({
    "node_modules/core-js/modules/es.string.split.js"() {
      "use strict";
      apply2 = require_function_apply();
      call4 = require_function_call();
      uncurryThis4 = require_function_uncurry_this();
      fixRegExpWellKnownSymbolLogic3 = require_fix_regexp_well_known_symbol_logic();
      isRegExp = require_is_regexp();
      anObject3 = require_an_object();
      requireObjectCoercible5 = require_require_object_coercible();
      speciesConstructor2 = require_species_constructor();
      advanceStringIndex3 = require_advance_string_index();
      toLength5 = require_to_length();
      toString5 = require_to_string();
      getMethod3 = require_get_method();
      arraySlice = require_array_slice();
      callRegExpExec = require_regexp_exec_abstract();
      regexpExec = require_regexp_exec();
      stickyHelpers = require_regexp_sticky_helpers();
      fails2 = require_fails();
      UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
      MAX_UINT32 = 4294967295;
      min4 = Math.min;
      $push = [].push;
      exec = uncurryThis4(/./.exec);
      push2 = uncurryThis4($push);
      stringSlice3 = uncurryThis4("".slice);
      SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails2(function() {
        var re2 = /(?:)/;
        var originalExec = re2.exec;
        re2.exec = function() {
          return originalExec.apply(this, arguments);
        };
        var result = "ab".split(re2);
        return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
      });
      fixRegExpWellKnownSymbolLogic3("split", function(SPLIT, nativeSplit, maybeCallNative) {
        var internalSplit;
        if ("abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
          internalSplit = function(separator, limit) {
            var string = toString5(requireObjectCoercible5(this));
            var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
            if (lim === 0)
              return [];
            if (separator === void 0)
              return [string];
            if (!isRegExp(separator)) {
              return call4(nativeSplit, string, separator, lim);
            }
            var output = [];
            var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
            var lastLastIndex = 0;
            var separatorCopy = new RegExp(separator.source, flags + "g");
            var match, lastIndex, lastLength;
            while (match = call4(regexpExec, separatorCopy, string)) {
              lastIndex = separatorCopy.lastIndex;
              if (lastIndex > lastLastIndex) {
                push2(output, stringSlice3(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length)
                  apply2($push, output, arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim)
                  break;
              }
              if (separatorCopy.lastIndex === match.index)
                separatorCopy.lastIndex++;
            }
            if (lastLastIndex === string.length) {
              if (lastLength || !exec(separatorCopy, ""))
                push2(output, "");
            } else
              push2(output, stringSlice3(string, lastLastIndex));
            return output.length > lim ? arraySlice(output, 0, lim) : output;
          };
        } else if ("0".split(void 0, 0).length) {
          internalSplit = function(separator, limit) {
            return separator === void 0 && limit === 0 ? [] : call4(nativeSplit, this, separator, limit);
          };
        } else
          internalSplit = nativeSplit;
        return [
          function split(separator, limit) {
            var O3 = requireObjectCoercible5(this);
            var splitter = separator == void 0 ? void 0 : getMethod3(separator, SPLIT);
            return splitter ? call4(splitter, separator, O3, limit) : call4(internalSplit, toString5(O3), separator, limit);
          },
          function(string, limit) {
            var rx = anObject3(this);
            var S2 = toString5(string);
            var res = maybeCallNative(internalSplit, rx, S2, limit, internalSplit !== nativeSplit);
            if (res.done)
              return res.value;
            var C2 = speciesConstructor2(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y ? "g" : "y");
            var splitter = new C2(UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
            if (lim === 0)
              return [];
            if (S2.length === 0)
              return callRegExpExec(splitter, S2) === null ? [S2] : [];
            var p4 = 0;
            var q2 = 0;
            var A2 = [];
            while (q2 < S2.length) {
              splitter.lastIndex = UNSUPPORTED_Y ? 0 : q2;
              var z2 = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice3(S2, q2) : S2);
              var e2;
              if (z2 === null || (e2 = min4(toLength5(splitter.lastIndex + (UNSUPPORTED_Y ? q2 : 0)), S2.length)) === p4) {
                q2 = advanceStringIndex3(S2, q2, unicodeMatching);
              } else {
                push2(A2, stringSlice3(S2, p4, q2));
                if (A2.length === lim)
                  return A2;
                for (var i3 = 1; i3 <= z2.length - 1; i3++) {
                  push2(A2, z2[i3]);
                  if (A2.length === lim)
                    return A2;
                }
                q2 = p4 = e2;
              }
            }
            push2(A2, stringSlice3(S2, p4));
            return A2;
          }
        ];
      }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
    }
  });

  // node_modules/performance-now/lib/performance-now.js
  var require_performance_now = __commonJS({
    "node_modules/performance-now/lib/performance-now.js"(exports, module) {
      (function() {
        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
        if (typeof performance !== "undefined" && performance !== null && performance.now) {
          module.exports = function() {
            return performance.now();
          };
        } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
          module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
          };
          hrtime = process.hrtime;
          getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
          };
          moduleLoadTime = getNanoSeconds();
          upTime = process.uptime() * 1e9;
          nodeLoadTime = moduleLoadTime - upTime;
        } else if (Date.now) {
          module.exports = function() {
            return Date.now() - loadTime;
          };
          loadTime = Date.now();
        } else {
          module.exports = function() {
            return new Date().getTime() - loadTime;
          };
          loadTime = new Date().getTime();
        }
      }).call(exports);
    }
  });

  // node_modules/raf/index.js
  var require_raf = __commonJS({
    "node_modules/raf/index.js"(exports, module) {
      var now2 = require_performance_now();
      var root = typeof window === "undefined" ? global : window;
      var vendors = ["moz", "webkit"];
      var suffix = "AnimationFrame";
      var raf = root["request" + suffix];
      var caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
      for (i3 = 0; !raf && i3 < vendors.length; i3++) {
        raf = root[vendors[i3] + "Request" + suffix];
        caf = root[vendors[i3] + "Cancel" + suffix] || root[vendors[i3] + "CancelRequest" + suffix];
      }
      var i3;
      if (!raf || !caf) {
        last = 0, id = 0, queue3 = [], frameDuration = 1e3 / 60;
        raf = function(callback) {
          if (queue3.length === 0) {
            var _now = now2(), next2 = Math.max(0, frameDuration - (_now - last));
            last = next2 + _now;
            setTimeout(function() {
              var cp = queue3.slice(0);
              queue3.length = 0;
              for (var i4 = 0; i4 < cp.length; i4++) {
                if (!cp[i4].cancelled) {
                  try {
                    cp[i4].callback(last);
                  } catch (e2) {
                    setTimeout(function() {
                      throw e2;
                    }, 0);
                  }
                }
              }
            }, Math.round(next2));
          }
          queue3.push({
            handle: ++id,
            callback,
            cancelled: false
          });
          return id;
        };
        caf = function(handle) {
          for (var i4 = 0; i4 < queue3.length; i4++) {
            if (queue3[i4].handle === handle) {
              queue3[i4].cancelled = true;
            }
          }
        };
      }
      var last;
      var id;
      var queue3;
      var frameDuration;
      module.exports = function(fn) {
        return raf.call(root, fn);
      };
      module.exports.cancel = function() {
        caf.apply(root, arguments);
      };
      module.exports.polyfill = function(object) {
        if (!object) {
          object = root;
        }
        object.requestAnimationFrame = raf;
        object.cancelAnimationFrame = caf;
      };
    }
  });

  // node_modules/core-js/internals/whitespaces.js
  var require_whitespaces = __commonJS({
    "node_modules/core-js/internals/whitespaces.js"(exports, module) {
      module.exports = "	\n\v\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }
  });

  // node_modules/core-js/internals/string-trim.js
  var require_string_trim = __commonJS({
    "node_modules/core-js/internals/string-trim.js"(exports, module) {
      var uncurryThis9 = require_function_uncurry_this();
      var requireObjectCoercible7 = require_require_object_coercible();
      var toString7 = require_to_string();
      var whitespaces = require_whitespaces();
      var replace = uncurryThis9("".replace);
      var whitespace = "[" + whitespaces + "]";
      var ltrim = RegExp("^" + whitespace + whitespace + "*");
      var rtrim = RegExp(whitespace + whitespace + "*$");
      var createMethod = function(TYPE) {
        return function($this) {
          var string = toString7(requireObjectCoercible7($this));
          if (TYPE & 1)
            string = replace(string, ltrim, "");
          if (TYPE & 2)
            string = replace(string, rtrim, "");
          return string;
        };
      };
      module.exports = {
        start: createMethod(1),
        end: createMethod(2),
        trim: createMethod(3)
      };
    }
  });

  // node_modules/core-js/internals/string-trim-forced.js
  var require_string_trim_forced = __commonJS({
    "node_modules/core-js/internals/string-trim-forced.js"(exports, module) {
      var PROPER_FUNCTION_NAME2 = require_function_name().PROPER;
      var fails4 = require_fails();
      var whitespaces = require_whitespaces();
      var non = "\u200B\x85\u180E";
      module.exports = function(METHOD_NAME) {
        return fails4(function() {
          return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME2 && whitespaces[METHOD_NAME].name !== METHOD_NAME;
        });
      };
    }
  });

  // node_modules/core-js/modules/es.string.trim.js
  var $7, $trim, forcedStringTrimMethod;
  var init_es_string_trim = __esm({
    "node_modules/core-js/modules/es.string.trim.js"() {
      "use strict";
      $7 = require_export();
      $trim = require_string_trim().trim;
      forcedStringTrimMethod = require_string_trim_forced();
      $7({ target: "String", proto: true, forced: forcedStringTrimMethod("trim") }, {
        trim: function trim() {
          return $trim(this);
        }
      });
    }
  });

  // node_modules/rgbcolor/index.js
  var require_rgbcolor = __commonJS({
    "node_modules/rgbcolor/index.js"(exports, module) {
      module.exports = function(color_string) {
        this.ok = false;
        this.alpha = 1;
        if (color_string.charAt(0) == "#") {
          color_string = color_string.substr(1, 6);
        }
        color_string = color_string.replace(/ /g, "");
        color_string = color_string.toLowerCase();
        var simple_colors = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "00ffff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000000",
          blanchedalmond: "ffebcd",
          blue: "0000ff",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "00ffff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dodgerblue: "1e90ff",
          feldspar: "d19275",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "ff00ff",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgrey: "d3d3d3",
          lightgreen: "90ee90",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslateblue: "8470ff",
          lightslategray: "778899",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "00ff00",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "ff00ff",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370d8",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "d87093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          rebeccapurple: "663399",
          red: "ff0000",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          violetred: "d02090",
          wheat: "f5deb3",
          white: "ffffff",
          whitesmoke: "f5f5f5",
          yellow: "ffff00",
          yellowgreen: "9acd32"
        };
        color_string = simple_colors[color_string] || color_string;
        var color_defs = [
          {
            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
            example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
            process: function(bits3) {
              return [
                parseInt(bits3[1]),
                parseInt(bits3[2]),
                parseInt(bits3[3]),
                parseFloat(bits3[4])
              ];
            }
          },
          {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
            process: function(bits3) {
              return [
                parseInt(bits3[1]),
                parseInt(bits3[2]),
                parseInt(bits3[3])
              ];
            }
          },
          {
            re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            example: ["#00ff00", "336699"],
            process: function(bits3) {
              return [
                parseInt(bits3[1], 16),
                parseInt(bits3[2], 16),
                parseInt(bits3[3], 16)
              ];
            }
          },
          {
            re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            example: ["#fb0", "f0f"],
            process: function(bits3) {
              return [
                parseInt(bits3[1] + bits3[1], 16),
                parseInt(bits3[2] + bits3[2], 16),
                parseInt(bits3[3] + bits3[3], 16)
              ];
            }
          }
        ];
        for (var i3 = 0; i3 < color_defs.length; i3++) {
          var re2 = color_defs[i3].re;
          var processor = color_defs[i3].process;
          var bits2 = re2.exec(color_string);
          if (bits2) {
            var channels = processor(bits2);
            this.r = channels[0];
            this.g = channels[1];
            this.b = channels[2];
            if (channels.length > 3) {
              this.alpha = channels[3];
            }
            this.ok = true;
          }
        }
        this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r;
        this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g;
        this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
        this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha;
        this.toRGB = function() {
          return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
        };
        this.toRGBA = function() {
          return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
        };
        this.toHex = function() {
          var r2 = this.r.toString(16);
          var g2 = this.g.toString(16);
          var b2 = this.b.toString(16);
          if (r2.length == 1)
            r2 = "0" + r2;
          if (g2.length == 1)
            g2 = "0" + g2;
          if (b2.length == 1)
            b2 = "0" + b2;
          return "#" + r2 + g2 + b2;
        };
        this.getHelpXML = function() {
          var examples = new Array();
          for (var i4 = 0; i4 < color_defs.length; i4++) {
            var example = color_defs[i4].example;
            for (var j2 = 0; j2 < example.length; j2++) {
              examples[examples.length] = example[j2];
            }
          }
          for (var sc in simple_colors) {
            examples[examples.length] = sc;
          }
          var xml = document.createElement("ul");
          xml.setAttribute("id", "rgbcolor-examples");
          for (var i4 = 0; i4 < examples.length; i4++) {
            try {
              var list_item = document.createElement("li");
              var list_color = new RGBColor(examples[i4]);
              var example_div = document.createElement("div");
              example_div.style.cssText = "margin: 3px; border: 1px solid black; background:" + list_color.toHex() + "; color:" + list_color.toHex();
              example_div.appendChild(document.createTextNode("test"));
              var list_item_value = document.createTextNode(" " + examples[i4] + " -> " + list_color.toRGB() + " -> " + list_color.toHex());
              list_item.appendChild(example_div);
              list_item.appendChild(list_item_value);
              xml.appendChild(list_item);
            } catch (e2) {
            }
          }
          return xml;
        };
      };
    }
  });

  // node_modules/core-js/modules/es.string.includes.js
  var $8, uncurryThis5, notARegExp3, requireObjectCoercible6, toString6, correctIsRegExpLogic3, stringIndexOf2;
  var init_es_string_includes = __esm({
    "node_modules/core-js/modules/es.string.includes.js"() {
      "use strict";
      $8 = require_export();
      uncurryThis5 = require_function_uncurry_this();
      notARegExp3 = require_not_a_regexp();
      requireObjectCoercible6 = require_require_object_coercible();
      toString6 = require_to_string();
      correctIsRegExpLogic3 = require_correct_is_regexp_logic();
      stringIndexOf2 = uncurryThis5("".indexOf);
      $8({ target: "String", proto: true, forced: !correctIsRegExpLogic3("includes") }, {
        includes: function includes(searchString) {
          return !!~stringIndexOf2(toString6(requireObjectCoercible6(this)), toString6(notARegExp3(searchString)), arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.index-of.js
  var $9, uncurryThis6, $IndexOf, arrayMethodIsStrict2, un$IndexOf, NEGATIVE_ZERO, STRICT_METHOD2;
  var init_es_array_index_of = __esm({
    "node_modules/core-js/modules/es.array.index-of.js"() {
      "use strict";
      $9 = require_export();
      uncurryThis6 = require_function_uncurry_this();
      $IndexOf = require_array_includes().indexOf;
      arrayMethodIsStrict2 = require_array_method_is_strict();
      un$IndexOf = uncurryThis6([].indexOf);
      NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
      STRICT_METHOD2 = arrayMethodIsStrict2("indexOf");
      $9({ target: "Array", proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD2 }, {
        indexOf: function indexOf(searchElement) {
          var fromIndex = arguments.length > 1 ? arguments[1] : void 0;
          return NEGATIVE_ZERO ? un$IndexOf(this, searchElement, fromIndex) || 0 : $IndexOf(this, searchElement, fromIndex);
        }
      });
    }
  });

  // node_modules/core-js/internals/is-array.js
  var require_is_array = __commonJS({
    "node_modules/core-js/internals/is-array.js"(exports, module) {
      var classof = require_classof_raw();
      module.exports = Array.isArray || function isArray5(argument) {
        return classof(argument) == "Array";
      };
    }
  });

  // node_modules/core-js/modules/es.array.reverse.js
  var $10, uncurryThis7, isArray4, un$Reverse, test;
  var init_es_array_reverse = __esm({
    "node_modules/core-js/modules/es.array.reverse.js"() {
      "use strict";
      $10 = require_export();
      uncurryThis7 = require_function_uncurry_this();
      isArray4 = require_is_array();
      un$Reverse = uncurryThis7([].reverse);
      test = [1, 2];
      $10({ target: "Array", proto: true, forced: String(test) === String(test.reverse()) }, {
        reverse: function reverse() {
          if (isArray4(this))
            this.length = this.length;
          return un$Reverse(this);
        }
      });
    }
  });

  // node_modules/svg-pathdata/lib/SVGPathData.module.js
  function r(r2, e2) {
    if (typeof e2 != "function" && e2 !== null)
      throw new TypeError("Class extends value " + String(e2) + " is not a constructor or null");
    function i3() {
      this.constructor = r2;
    }
    t(r2, e2), r2.prototype = e2 === null ? Object.create(e2) : (i3.prototype = e2.prototype, new i3());
  }
  function e(t3) {
    var r2 = "";
    Array.isArray(t3) || (t3 = [t3]);
    for (var e2 = 0; e2 < t3.length; e2++) {
      var i3 = t3[e2];
      if (i3.type === _.CLOSE_PATH)
        r2 += "z";
      else if (i3.type === _.HORIZ_LINE_TO)
        r2 += (i3.relative ? "h" : "H") + i3.x;
      else if (i3.type === _.VERT_LINE_TO)
        r2 += (i3.relative ? "v" : "V") + i3.y;
      else if (i3.type === _.MOVE_TO)
        r2 += (i3.relative ? "m" : "M") + i3.x + " " + i3.y;
      else if (i3.type === _.LINE_TO)
        r2 += (i3.relative ? "l" : "L") + i3.x + " " + i3.y;
      else if (i3.type === _.CURVE_TO)
        r2 += (i3.relative ? "c" : "C") + i3.x1 + " " + i3.y1 + " " + i3.x2 + " " + i3.y2 + " " + i3.x + " " + i3.y;
      else if (i3.type === _.SMOOTH_CURVE_TO)
        r2 += (i3.relative ? "s" : "S") + i3.x2 + " " + i3.y2 + " " + i3.x + " " + i3.y;
      else if (i3.type === _.QUAD_TO)
        r2 += (i3.relative ? "q" : "Q") + i3.x1 + " " + i3.y1 + " " + i3.x + " " + i3.y;
      else if (i3.type === _.SMOOTH_QUAD_TO)
        r2 += (i3.relative ? "t" : "T") + i3.x + " " + i3.y;
      else {
        if (i3.type !== _.ARC)
          throw new Error('Unexpected command type "' + i3.type + '" at index ' + e2 + ".");
        r2 += (i3.relative ? "a" : "A") + i3.rX + " " + i3.rY + " " + i3.xRot + " " + +i3.lArcFlag + " " + +i3.sweepFlag + " " + i3.x + " " + i3.y;
      }
    }
    return r2;
  }
  function i(t3, r2) {
    var e2 = t3[0], i3 = t3[1];
    return [e2 * Math.cos(r2) - i3 * Math.sin(r2), e2 * Math.sin(r2) + i3 * Math.cos(r2)];
  }
  function a() {
    for (var t3 = [], r2 = 0; r2 < arguments.length; r2++)
      t3[r2] = arguments[r2];
    for (var e2 = 0; e2 < t3.length; e2++)
      if (typeof t3[e2] != "number")
        throw new Error("assertNumbers arguments[" + e2 + "] is not a number. " + typeof t3[e2] + " == typeof " + t3[e2]);
    return true;
  }
  function o(t3, r2, e2) {
    t3.lArcFlag = t3.lArcFlag === 0 ? 0 : 1, t3.sweepFlag = t3.sweepFlag === 0 ? 0 : 1;
    var a3 = t3.rX, o3 = t3.rY, s3 = t3.x, u3 = t3.y;
    a3 = Math.abs(t3.rX), o3 = Math.abs(t3.rY);
    var h4 = i([(r2 - s3) / 2, (e2 - u3) / 2], -t3.xRot / 180 * n), c4 = h4[0], y3 = h4[1], p4 = Math.pow(c4, 2) / Math.pow(a3, 2) + Math.pow(y3, 2) / Math.pow(o3, 2);
    1 < p4 && (a3 *= Math.sqrt(p4), o3 *= Math.sqrt(p4)), t3.rX = a3, t3.rY = o3;
    var m4 = Math.pow(a3, 2) * Math.pow(y3, 2) + Math.pow(o3, 2) * Math.pow(c4, 2), O3 = (t3.lArcFlag !== t3.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(a3, 2) * Math.pow(o3, 2) - m4) / m4)), l3 = a3 * y3 / o3 * O3, T3 = -o3 * c4 / a3 * O3, v3 = i([l3, T3], t3.xRot / 180 * n);
    t3.cX = v3[0] + (r2 + s3) / 2, t3.cY = v3[1] + (e2 + u3) / 2, t3.phi1 = Math.atan2((y3 - T3) / o3, (c4 - l3) / a3), t3.phi2 = Math.atan2((-y3 - T3) / o3, (-c4 - l3) / a3), t3.sweepFlag === 0 && t3.phi2 > t3.phi1 && (t3.phi2 -= 2 * n), t3.sweepFlag === 1 && t3.phi2 < t3.phi1 && (t3.phi2 += 2 * n), t3.phi1 *= 180 / n, t3.phi2 *= 180 / n;
  }
  function s(t3, r2, e2) {
    a(t3, r2, e2);
    var i3 = t3 * t3 + r2 * r2 - e2 * e2;
    if (0 > i3)
      return [];
    if (i3 === 0)
      return [[t3 * e2 / (t3 * t3 + r2 * r2), r2 * e2 / (t3 * t3 + r2 * r2)]];
    var n3 = Math.sqrt(i3);
    return [[(t3 * e2 + r2 * n3) / (t3 * t3 + r2 * r2), (r2 * e2 - t3 * n3) / (t3 * t3 + r2 * r2)], [(t3 * e2 - r2 * n3) / (t3 * t3 + r2 * r2), (r2 * e2 + t3 * n3) / (t3 * t3 + r2 * r2)]];
  }
  function c(t3, r2, e2) {
    return (1 - e2) * t3 + e2 * r2;
  }
  function y(t3, r2, e2, i3) {
    return t3 + Math.cos(i3 / 180 * n) * r2 + Math.sin(i3 / 180 * n) * e2;
  }
  function p2(t3, r2, e2, i3) {
    var a3 = 1e-6, n3 = r2 - t3, o3 = e2 - r2, s3 = 3 * n3 + 3 * (i3 - e2) - 6 * o3, u3 = 6 * (o3 - n3), h4 = 3 * n3;
    return Math.abs(s3) < a3 ? [-h4 / u3] : function(t4, r3, e3) {
      e3 === void 0 && (e3 = 1e-6);
      var i4 = t4 * t4 / 4 - r3;
      if (i4 < -e3)
        return [];
      if (i4 <= e3)
        return [-t4 / 2];
      var a4 = Math.sqrt(i4);
      return [-t4 / 2 - a4, -t4 / 2 + a4];
    }(u3 / s3, h4 / s3, a3);
  }
  function m(t3, r2, e2, i3, a3) {
    var n3 = 1 - a3;
    return t3 * (n3 * n3 * n3) + r2 * (3 * n3 * n3 * a3) + e2 * (3 * n3 * a3 * a3) + i3 * (a3 * a3 * a3);
  }
  var t, n, u, h2, O, l, T, v, f, _, N;
  var init_SVGPathData_module = __esm({
    "node_modules/svg-pathdata/lib/SVGPathData.module.js"() {
      t = function(r2, e2) {
        return (t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, r3) {
          t3.__proto__ = r3;
        } || function(t3, r3) {
          for (var e3 in r3)
            Object.prototype.hasOwnProperty.call(r3, e3) && (t3[e3] = r3[e3]);
        })(r2, e2);
      };
      n = Math.PI;
      h2 = Math.PI / 180;
      !function(t3) {
        function r2() {
          return u3(function(t4, r3, e3) {
            return t4.relative && (t4.x1 !== void 0 && (t4.x1 += r3), t4.y1 !== void 0 && (t4.y1 += e3), t4.x2 !== void 0 && (t4.x2 += r3), t4.y2 !== void 0 && (t4.y2 += e3), t4.x !== void 0 && (t4.x += r3), t4.y !== void 0 && (t4.y += e3), t4.relative = false), t4;
          });
        }
        function e2() {
          var t4 = NaN, r3 = NaN, e3 = NaN, i3 = NaN;
          return u3(function(a3, n4, o3) {
            return a3.type & _.SMOOTH_CURVE_TO && (a3.type = _.CURVE_TO, t4 = isNaN(t4) ? n4 : t4, r3 = isNaN(r3) ? o3 : r3, a3.x1 = a3.relative ? n4 - t4 : 2 * n4 - t4, a3.y1 = a3.relative ? o3 - r3 : 2 * o3 - r3), a3.type & _.CURVE_TO ? (t4 = a3.relative ? n4 + a3.x2 : a3.x2, r3 = a3.relative ? o3 + a3.y2 : a3.y2) : (t4 = NaN, r3 = NaN), a3.type & _.SMOOTH_QUAD_TO && (a3.type = _.QUAD_TO, e3 = isNaN(e3) ? n4 : e3, i3 = isNaN(i3) ? o3 : i3, a3.x1 = a3.relative ? n4 - e3 : 2 * n4 - e3, a3.y1 = a3.relative ? o3 - i3 : 2 * o3 - i3), a3.type & _.QUAD_TO ? (e3 = a3.relative ? n4 + a3.x1 : a3.x1, i3 = a3.relative ? o3 + a3.y1 : a3.y1) : (e3 = NaN, i3 = NaN), a3;
          });
        }
        function n3() {
          var t4 = NaN, r3 = NaN;
          return u3(function(e3, i3, a3) {
            if (e3.type & _.SMOOTH_QUAD_TO && (e3.type = _.QUAD_TO, t4 = isNaN(t4) ? i3 : t4, r3 = isNaN(r3) ? a3 : r3, e3.x1 = e3.relative ? i3 - t4 : 2 * i3 - t4, e3.y1 = e3.relative ? a3 - r3 : 2 * a3 - r3), e3.type & _.QUAD_TO) {
              t4 = e3.relative ? i3 + e3.x1 : e3.x1, r3 = e3.relative ? a3 + e3.y1 : e3.y1;
              var n4 = e3.x1, o3 = e3.y1;
              e3.type = _.CURVE_TO, e3.x1 = ((e3.relative ? 0 : i3) + 2 * n4) / 3, e3.y1 = ((e3.relative ? 0 : a3) + 2 * o3) / 3, e3.x2 = (e3.x + 2 * n4) / 3, e3.y2 = (e3.y + 2 * o3) / 3;
            } else
              t4 = NaN, r3 = NaN;
            return e3;
          });
        }
        function u3(t4) {
          var r3 = 0, e3 = 0, i3 = NaN, a3 = NaN;
          return function(n4) {
            if (isNaN(i3) && !(n4.type & _.MOVE_TO))
              throw new Error("path must start with moveto");
            var o3 = t4(n4, r3, e3, i3, a3);
            return n4.type & _.CLOSE_PATH && (r3 = i3, e3 = a3), n4.x !== void 0 && (r3 = n4.relative ? r3 + n4.x : n4.x), n4.y !== void 0 && (e3 = n4.relative ? e3 + n4.y : n4.y), n4.type & _.MOVE_TO && (i3 = r3, a3 = e3), o3;
          };
        }
        function O3(t4, r3, e3, i3, n4, o3) {
          return a(t4, r3, e3, i3, n4, o3), u3(function(a3, s3, u4, h4) {
            var c4 = a3.x1, y3 = a3.x2, p4 = a3.relative && !isNaN(h4), m4 = a3.x !== void 0 ? a3.x : p4 ? 0 : s3, O4 = a3.y !== void 0 ? a3.y : p4 ? 0 : u4;
            function l4(t5) {
              return t5 * t5;
            }
            a3.type & _.HORIZ_LINE_TO && r3 !== 0 && (a3.type = _.LINE_TO, a3.y = a3.relative ? 0 : u4), a3.type & _.VERT_LINE_TO && e3 !== 0 && (a3.type = _.LINE_TO, a3.x = a3.relative ? 0 : s3), a3.x !== void 0 && (a3.x = a3.x * t4 + O4 * e3 + (p4 ? 0 : n4)), a3.y !== void 0 && (a3.y = m4 * r3 + a3.y * i3 + (p4 ? 0 : o3)), a3.x1 !== void 0 && (a3.x1 = a3.x1 * t4 + a3.y1 * e3 + (p4 ? 0 : n4)), a3.y1 !== void 0 && (a3.y1 = c4 * r3 + a3.y1 * i3 + (p4 ? 0 : o3)), a3.x2 !== void 0 && (a3.x2 = a3.x2 * t4 + a3.y2 * e3 + (p4 ? 0 : n4)), a3.y2 !== void 0 && (a3.y2 = y3 * r3 + a3.y2 * i3 + (p4 ? 0 : o3));
            var T3 = t4 * i3 - r3 * e3;
            if (a3.xRot !== void 0 && (t4 !== 1 || r3 !== 0 || e3 !== 0 || i3 !== 1))
              if (T3 === 0)
                delete a3.rX, delete a3.rY, delete a3.xRot, delete a3.lArcFlag, delete a3.sweepFlag, a3.type = _.LINE_TO;
              else {
                var v3 = a3.xRot * Math.PI / 180, f3 = Math.sin(v3), N3 = Math.cos(v3), x2 = 1 / l4(a3.rX), d2 = 1 / l4(a3.rY), E2 = l4(N3) * x2 + l4(f3) * d2, A2 = 2 * f3 * N3 * (x2 - d2), C2 = l4(f3) * x2 + l4(N3) * d2, M2 = E2 * i3 * i3 - A2 * r3 * i3 + C2 * r3 * r3, R2 = A2 * (t4 * i3 + r3 * e3) - 2 * (E2 * e3 * i3 + C2 * t4 * r3), g2 = E2 * e3 * e3 - A2 * t4 * e3 + C2 * t4 * t4, I2 = (Math.atan2(R2, M2 - g2) + Math.PI) % Math.PI / 2, S2 = Math.sin(I2), L2 = Math.cos(I2);
                a3.rX = Math.abs(T3) / Math.sqrt(M2 * l4(L2) + R2 * S2 * L2 + g2 * l4(S2)), a3.rY = Math.abs(T3) / Math.sqrt(M2 * l4(S2) - R2 * S2 * L2 + g2 * l4(L2)), a3.xRot = 180 * I2 / Math.PI;
              }
            return a3.sweepFlag !== void 0 && 0 > T3 && (a3.sweepFlag = +!a3.sweepFlag), a3;
          });
        }
        function l3() {
          return function(t4) {
            var r3 = {};
            for (var e3 in t4)
              r3[e3] = t4[e3];
            return r3;
          };
        }
        t3.ROUND = function(t4) {
          function r3(r4) {
            return Math.round(r4 * t4) / t4;
          }
          return t4 === void 0 && (t4 = 1e13), a(t4), function(t5) {
            return t5.x1 !== void 0 && (t5.x1 = r3(t5.x1)), t5.y1 !== void 0 && (t5.y1 = r3(t5.y1)), t5.x2 !== void 0 && (t5.x2 = r3(t5.x2)), t5.y2 !== void 0 && (t5.y2 = r3(t5.y2)), t5.x !== void 0 && (t5.x = r3(t5.x)), t5.y !== void 0 && (t5.y = r3(t5.y)), t5.rX !== void 0 && (t5.rX = r3(t5.rX)), t5.rY !== void 0 && (t5.rY = r3(t5.rY)), t5;
          };
        }, t3.TO_ABS = r2, t3.TO_REL = function() {
          return u3(function(t4, r3, e3) {
            return t4.relative || (t4.x1 !== void 0 && (t4.x1 -= r3), t4.y1 !== void 0 && (t4.y1 -= e3), t4.x2 !== void 0 && (t4.x2 -= r3), t4.y2 !== void 0 && (t4.y2 -= e3), t4.x !== void 0 && (t4.x -= r3), t4.y !== void 0 && (t4.y -= e3), t4.relative = true), t4;
          });
        }, t3.NORMALIZE_HVZ = function(t4, r3, e3) {
          return t4 === void 0 && (t4 = true), r3 === void 0 && (r3 = true), e3 === void 0 && (e3 = true), u3(function(i3, a3, n4, o3, s3) {
            if (isNaN(o3) && !(i3.type & _.MOVE_TO))
              throw new Error("path must start with moveto");
            return r3 && i3.type & _.HORIZ_LINE_TO && (i3.type = _.LINE_TO, i3.y = i3.relative ? 0 : n4), e3 && i3.type & _.VERT_LINE_TO && (i3.type = _.LINE_TO, i3.x = i3.relative ? 0 : a3), t4 && i3.type & _.CLOSE_PATH && (i3.type = _.LINE_TO, i3.x = i3.relative ? o3 - a3 : o3, i3.y = i3.relative ? s3 - n4 : s3), i3.type & _.ARC && (i3.rX === 0 || i3.rY === 0) && (i3.type = _.LINE_TO, delete i3.rX, delete i3.rY, delete i3.xRot, delete i3.lArcFlag, delete i3.sweepFlag), i3;
          });
        }, t3.NORMALIZE_ST = e2, t3.QT_TO_C = n3, t3.INFO = u3, t3.SANITIZE = function(t4) {
          t4 === void 0 && (t4 = 0), a(t4);
          var r3 = NaN, e3 = NaN, i3 = NaN, n4 = NaN;
          return u3(function(a3, o3, s3, u4, h4) {
            var c4 = Math.abs, y3 = false, p4 = 0, m4 = 0;
            if (a3.type & _.SMOOTH_CURVE_TO && (p4 = isNaN(r3) ? 0 : o3 - r3, m4 = isNaN(e3) ? 0 : s3 - e3), a3.type & (_.CURVE_TO | _.SMOOTH_CURVE_TO) ? (r3 = a3.relative ? o3 + a3.x2 : a3.x2, e3 = a3.relative ? s3 + a3.y2 : a3.y2) : (r3 = NaN, e3 = NaN), a3.type & _.SMOOTH_QUAD_TO ? (i3 = isNaN(i3) ? o3 : 2 * o3 - i3, n4 = isNaN(n4) ? s3 : 2 * s3 - n4) : a3.type & _.QUAD_TO ? (i3 = a3.relative ? o3 + a3.x1 : a3.x1, n4 = a3.relative ? s3 + a3.y1 : a3.y2) : (i3 = NaN, n4 = NaN), a3.type & _.LINE_COMMANDS || a3.type & _.ARC && (a3.rX === 0 || a3.rY === 0 || !a3.lArcFlag) || a3.type & _.CURVE_TO || a3.type & _.SMOOTH_CURVE_TO || a3.type & _.QUAD_TO || a3.type & _.SMOOTH_QUAD_TO) {
              var O4 = a3.x === void 0 ? 0 : a3.relative ? a3.x : a3.x - o3, l4 = a3.y === void 0 ? 0 : a3.relative ? a3.y : a3.y - s3;
              p4 = isNaN(i3) ? a3.x1 === void 0 ? p4 : a3.relative ? a3.x : a3.x1 - o3 : i3 - o3, m4 = isNaN(n4) ? a3.y1 === void 0 ? m4 : a3.relative ? a3.y : a3.y1 - s3 : n4 - s3;
              var T3 = a3.x2 === void 0 ? 0 : a3.relative ? a3.x : a3.x2 - o3, v3 = a3.y2 === void 0 ? 0 : a3.relative ? a3.y : a3.y2 - s3;
              c4(O4) <= t4 && c4(l4) <= t4 && c4(p4) <= t4 && c4(m4) <= t4 && c4(T3) <= t4 && c4(v3) <= t4 && (y3 = true);
            }
            return a3.type & _.CLOSE_PATH && c4(o3 - u4) <= t4 && c4(s3 - h4) <= t4 && (y3 = true), y3 ? [] : a3;
          });
        }, t3.MATRIX = O3, t3.ROTATE = function(t4, r3, e3) {
          r3 === void 0 && (r3 = 0), e3 === void 0 && (e3 = 0), a(t4, r3, e3);
          var i3 = Math.sin(t4), n4 = Math.cos(t4);
          return O3(n4, i3, -i3, n4, r3 - r3 * n4 + e3 * i3, e3 - r3 * i3 - e3 * n4);
        }, t3.TRANSLATE = function(t4, r3) {
          return r3 === void 0 && (r3 = 0), a(t4, r3), O3(1, 0, 0, 1, t4, r3);
        }, t3.SCALE = function(t4, r3) {
          return r3 === void 0 && (r3 = t4), a(t4, r3), O3(t4, 0, 0, r3, 0, 0);
        }, t3.SKEW_X = function(t4) {
          return a(t4), O3(1, 0, Math.atan(t4), 1, 0, 0);
        }, t3.SKEW_Y = function(t4) {
          return a(t4), O3(1, Math.atan(t4), 0, 1, 0, 0);
        }, t3.X_AXIS_SYMMETRY = function(t4) {
          return t4 === void 0 && (t4 = 0), a(t4), O3(-1, 0, 0, 1, t4, 0);
        }, t3.Y_AXIS_SYMMETRY = function(t4) {
          return t4 === void 0 && (t4 = 0), a(t4), O3(1, 0, 0, -1, 0, t4);
        }, t3.A_TO_C = function() {
          return u3(function(t4, r3, e3) {
            return _.ARC === t4.type ? function(t5, r4, e4) {
              var a3, n4, s3, u4;
              t5.cX || o(t5, r4, e4);
              for (var y3 = Math.min(t5.phi1, t5.phi2), p4 = Math.max(t5.phi1, t5.phi2) - y3, m4 = Math.ceil(p4 / 90), O4 = new Array(m4), l4 = r4, T3 = e4, v3 = 0; v3 < m4; v3++) {
                var f3 = c(t5.phi1, t5.phi2, v3 / m4), N3 = c(t5.phi1, t5.phi2, (v3 + 1) / m4), x2 = N3 - f3, d2 = 4 / 3 * Math.tan(x2 * h2 / 4), E2 = [Math.cos(f3 * h2) - d2 * Math.sin(f3 * h2), Math.sin(f3 * h2) + d2 * Math.cos(f3 * h2)], A2 = E2[0], C2 = E2[1], M2 = [Math.cos(N3 * h2), Math.sin(N3 * h2)], R2 = M2[0], g2 = M2[1], I2 = [R2 + d2 * Math.sin(N3 * h2), g2 - d2 * Math.cos(N3 * h2)], S2 = I2[0], L2 = I2[1];
                O4[v3] = { relative: t5.relative, type: _.CURVE_TO };
                var H2 = function(r5, e5) {
                  var a4 = i([r5 * t5.rX, e5 * t5.rY], t5.xRot), n5 = a4[0], o3 = a4[1];
                  return [t5.cX + n5, t5.cY + o3];
                };
                a3 = H2(A2, C2), O4[v3].x1 = a3[0], O4[v3].y1 = a3[1], n4 = H2(S2, L2), O4[v3].x2 = n4[0], O4[v3].y2 = n4[1], s3 = H2(R2, g2), O4[v3].x = s3[0], O4[v3].y = s3[1], t5.relative && (O4[v3].x1 -= l4, O4[v3].y1 -= T3, O4[v3].x2 -= l4, O4[v3].y2 -= T3, O4[v3].x -= l4, O4[v3].y -= T3), l4 = (u4 = [O4[v3].x, O4[v3].y])[0], T3 = u4[1];
              }
              return O4;
            }(t4, t4.relative ? 0 : r3, t4.relative ? 0 : e3) : t4;
          });
        }, t3.ANNOTATE_ARCS = function() {
          return u3(function(t4, r3, e3) {
            return t4.relative && (r3 = 0, e3 = 0), _.ARC === t4.type && o(t4, r3, e3), t4;
          });
        }, t3.CLONE = l3, t3.CALCULATE_BOUNDS = function() {
          var t4 = function(t5) {
            var r3 = {};
            for (var e3 in t5)
              r3[e3] = t5[e3];
            return r3;
          }, i3 = r2(), a3 = n3(), h4 = e2(), c4 = u3(function(r3, e3, n4) {
            var u4 = h4(a3(i3(t4(r3))));
            function O4(t5) {
              t5 > c4.maxX && (c4.maxX = t5), t5 < c4.minX && (c4.minX = t5);
            }
            function l4(t5) {
              t5 > c4.maxY && (c4.maxY = t5), t5 < c4.minY && (c4.minY = t5);
            }
            if (u4.type & _.DRAWING_COMMANDS && (O4(e3), l4(n4)), u4.type & _.HORIZ_LINE_TO && O4(u4.x), u4.type & _.VERT_LINE_TO && l4(u4.y), u4.type & _.LINE_TO && (O4(u4.x), l4(u4.y)), u4.type & _.CURVE_TO) {
              O4(u4.x), l4(u4.y);
              for (var T3 = 0, v3 = p2(e3, u4.x1, u4.x2, u4.x); T3 < v3.length; T3++) {
                0 < (w2 = v3[T3]) && 1 > w2 && O4(m(e3, u4.x1, u4.x2, u4.x, w2));
              }
              for (var f3 = 0, N3 = p2(n4, u4.y1, u4.y2, u4.y); f3 < N3.length; f3++) {
                0 < (w2 = N3[f3]) && 1 > w2 && l4(m(n4, u4.y1, u4.y2, u4.y, w2));
              }
            }
            if (u4.type & _.ARC) {
              O4(u4.x), l4(u4.y), o(u4, e3, n4);
              for (var x2 = u4.xRot / 180 * Math.PI, d2 = Math.cos(x2) * u4.rX, E2 = Math.sin(x2) * u4.rX, A2 = -Math.sin(x2) * u4.rY, C2 = Math.cos(x2) * u4.rY, M2 = u4.phi1 < u4.phi2 ? [u4.phi1, u4.phi2] : -180 > u4.phi2 ? [u4.phi2 + 360, u4.phi1 + 360] : [u4.phi2, u4.phi1], R2 = M2[0], g2 = M2[1], I2 = function(t5) {
                var r4 = t5[0], e4 = t5[1], i4 = 180 * Math.atan2(e4, r4) / Math.PI;
                return i4 < R2 ? i4 + 360 : i4;
              }, S2 = 0, L2 = s(A2, -d2, 0).map(I2); S2 < L2.length; S2++) {
                (w2 = L2[S2]) > R2 && w2 < g2 && O4(y(u4.cX, d2, A2, w2));
              }
              for (var H2 = 0, U2 = s(C2, -E2, 0).map(I2); H2 < U2.length; H2++) {
                var w2;
                (w2 = U2[H2]) > R2 && w2 < g2 && l4(y(u4.cY, E2, C2, w2));
              }
            }
            return r3;
          });
          return c4.minX = 1 / 0, c4.maxX = -1 / 0, c4.minY = 1 / 0, c4.maxY = -1 / 0, c4;
        };
      }(u || (u = {}));
      l = function() {
        function t3() {
        }
        return t3.prototype.round = function(t4) {
          return this.transform(u.ROUND(t4));
        }, t3.prototype.toAbs = function() {
          return this.transform(u.TO_ABS());
        }, t3.prototype.toRel = function() {
          return this.transform(u.TO_REL());
        }, t3.prototype.normalizeHVZ = function(t4, r2, e2) {
          return this.transform(u.NORMALIZE_HVZ(t4, r2, e2));
        }, t3.prototype.normalizeST = function() {
          return this.transform(u.NORMALIZE_ST());
        }, t3.prototype.qtToC = function() {
          return this.transform(u.QT_TO_C());
        }, t3.prototype.aToC = function() {
          return this.transform(u.A_TO_C());
        }, t3.prototype.sanitize = function(t4) {
          return this.transform(u.SANITIZE(t4));
        }, t3.prototype.translate = function(t4, r2) {
          return this.transform(u.TRANSLATE(t4, r2));
        }, t3.prototype.scale = function(t4, r2) {
          return this.transform(u.SCALE(t4, r2));
        }, t3.prototype.rotate = function(t4, r2, e2) {
          return this.transform(u.ROTATE(t4, r2, e2));
        }, t3.prototype.matrix = function(t4, r2, e2, i3, a3, n3) {
          return this.transform(u.MATRIX(t4, r2, e2, i3, a3, n3));
        }, t3.prototype.skewX = function(t4) {
          return this.transform(u.SKEW_X(t4));
        }, t3.prototype.skewY = function(t4) {
          return this.transform(u.SKEW_Y(t4));
        }, t3.prototype.xSymmetry = function(t4) {
          return this.transform(u.X_AXIS_SYMMETRY(t4));
        }, t3.prototype.ySymmetry = function(t4) {
          return this.transform(u.Y_AXIS_SYMMETRY(t4));
        }, t3.prototype.annotateArcs = function() {
          return this.transform(u.ANNOTATE_ARCS());
        }, t3;
      }();
      T = function(t3) {
        return t3 === " " || t3 === "	" || t3 === "\r" || t3 === "\n";
      };
      v = function(t3) {
        return "0".charCodeAt(0) <= t3.charCodeAt(0) && t3.charCodeAt(0) <= "9".charCodeAt(0);
      };
      f = function(t3) {
        function e2() {
          var r2 = t3.call(this) || this;
          return r2.curNumber = "", r2.curCommandType = -1, r2.curCommandRelative = false, r2.canParseCommandOrComma = true, r2.curNumberHasExp = false, r2.curNumberHasExpDigits = false, r2.curNumberHasDecimal = false, r2.curArgs = [], r2;
        }
        return r(e2, t3), e2.prototype.finish = function(t4) {
          if (t4 === void 0 && (t4 = []), this.parse(" ", t4), this.curArgs.length !== 0 || !this.canParseCommandOrComma)
            throw new SyntaxError("Unterminated command at the path end.");
          return t4;
        }, e2.prototype.parse = function(t4, r2) {
          var e3 = this;
          r2 === void 0 && (r2 = []);
          for (var i3 = function(t5) {
            r2.push(t5), e3.curArgs.length = 0, e3.canParseCommandOrComma = true;
          }, a3 = 0; a3 < t4.length; a3++) {
            var n3 = t4[a3], o3 = !(this.curCommandType !== _.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), s3 = v(n3) && (this.curNumber === "0" && n3 === "0" || o3);
            if (!v(n3) || s3)
              if (n3 !== "e" && n3 !== "E")
                if (n3 !== "-" && n3 !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits)
                  if (n3 !== "." || this.curNumberHasExp || this.curNumberHasDecimal || o3) {
                    if (this.curNumber && this.curCommandType !== -1) {
                      var u3 = Number(this.curNumber);
                      if (isNaN(u3))
                        throw new SyntaxError("Invalid number ending at " + a3);
                      if (this.curCommandType === _.ARC) {
                        if (this.curArgs.length === 0 || this.curArgs.length === 1) {
                          if (0 > u3)
                            throw new SyntaxError('Expected positive number, got "' + u3 + '" at index "' + a3 + '"');
                        } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1")
                          throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + a3 + '"');
                      }
                      this.curArgs.push(u3), this.curArgs.length === N[this.curCommandType] && (_.HORIZ_LINE_TO === this.curCommandType ? i3({ type: _.HORIZ_LINE_TO, relative: this.curCommandRelative, x: u3 }) : _.VERT_LINE_TO === this.curCommandType ? i3({ type: _.VERT_LINE_TO, relative: this.curCommandRelative, y: u3 }) : this.curCommandType === _.MOVE_TO || this.curCommandType === _.LINE_TO || this.curCommandType === _.SMOOTH_QUAD_TO ? (i3({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), _.MOVE_TO === this.curCommandType && (this.curCommandType = _.LINE_TO)) : this.curCommandType === _.CURVE_TO ? i3({ type: _.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === _.SMOOTH_CURVE_TO ? i3({ type: _.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === _.QUAD_TO ? i3({ type: _.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === _.ARC && i3({ type: _.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = false, this.curNumberHasExp = false, this.curNumberHasDecimal = false, this.canParseCommandOrComma = true;
                    }
                    if (!T(n3))
                      if (n3 === "," && this.canParseCommandOrComma)
                        this.canParseCommandOrComma = false;
                      else if (n3 !== "+" && n3 !== "-" && n3 !== ".")
                        if (s3)
                          this.curNumber = n3, this.curNumberHasDecimal = false;
                        else {
                          if (this.curArgs.length !== 0)
                            throw new SyntaxError("Unterminated command at index " + a3 + ".");
                          if (!this.canParseCommandOrComma)
                            throw new SyntaxError('Unexpected character "' + n3 + '" at index ' + a3 + ". Command cannot follow comma");
                          if (this.canParseCommandOrComma = false, n3 !== "z" && n3 !== "Z")
                            if (n3 === "h" || n3 === "H")
                              this.curCommandType = _.HORIZ_LINE_TO, this.curCommandRelative = n3 === "h";
                            else if (n3 === "v" || n3 === "V")
                              this.curCommandType = _.VERT_LINE_TO, this.curCommandRelative = n3 === "v";
                            else if (n3 === "m" || n3 === "M")
                              this.curCommandType = _.MOVE_TO, this.curCommandRelative = n3 === "m";
                            else if (n3 === "l" || n3 === "L")
                              this.curCommandType = _.LINE_TO, this.curCommandRelative = n3 === "l";
                            else if (n3 === "c" || n3 === "C")
                              this.curCommandType = _.CURVE_TO, this.curCommandRelative = n3 === "c";
                            else if (n3 === "s" || n3 === "S")
                              this.curCommandType = _.SMOOTH_CURVE_TO, this.curCommandRelative = n3 === "s";
                            else if (n3 === "q" || n3 === "Q")
                              this.curCommandType = _.QUAD_TO, this.curCommandRelative = n3 === "q";
                            else if (n3 === "t" || n3 === "T")
                              this.curCommandType = _.SMOOTH_QUAD_TO, this.curCommandRelative = n3 === "t";
                            else {
                              if (n3 !== "a" && n3 !== "A")
                                throw new SyntaxError('Unexpected character "' + n3 + '" at index ' + a3 + ".");
                              this.curCommandType = _.ARC, this.curCommandRelative = n3 === "a";
                            }
                          else
                            r2.push({ type: _.CLOSE_PATH }), this.canParseCommandOrComma = true, this.curCommandType = -1;
                        }
                      else
                        this.curNumber = n3, this.curNumberHasDecimal = n3 === ".";
                  } else
                    this.curNumber += n3, this.curNumberHasDecimal = true;
                else
                  this.curNumber += n3;
              else
                this.curNumber += n3, this.curNumberHasExp = true;
            else
              this.curNumber += n3, this.curNumberHasExpDigits = this.curNumberHasExp;
          }
          return r2;
        }, e2.prototype.transform = function(t4) {
          return Object.create(this, { parse: { value: function(r2, e3) {
            e3 === void 0 && (e3 = []);
            for (var i3 = 0, a3 = Object.getPrototypeOf(this).parse.call(this, r2); i3 < a3.length; i3++) {
              var n3 = a3[i3], o3 = t4(n3);
              Array.isArray(o3) ? e3.push.apply(e3, o3) : e3.push(o3);
            }
            return e3;
          } } });
        }, e2;
      }(l);
      _ = function(t3) {
        function i3(r2) {
          var e2 = t3.call(this) || this;
          return e2.commands = typeof r2 == "string" ? i3.parse(r2) : r2, e2;
        }
        return r(i3, t3), i3.prototype.encode = function() {
          return i3.encode(this.commands);
        }, i3.prototype.getBounds = function() {
          var t4 = u.CALCULATE_BOUNDS();
          return this.transform(t4), t4;
        }, i3.prototype.transform = function(t4) {
          for (var r2 = [], e2 = 0, i4 = this.commands; e2 < i4.length; e2++) {
            var a3 = t4(i4[e2]);
            Array.isArray(a3) ? r2.push.apply(r2, a3) : r2.push(a3);
          }
          return this.commands = r2, this;
        }, i3.encode = function(t4) {
          return e(t4);
        }, i3.parse = function(t4) {
          var r2 = new f(), e2 = [];
          return r2.parse(t4, e2), r2.finish(e2), e2;
        }, i3.CLOSE_PATH = 1, i3.MOVE_TO = 2, i3.HORIZ_LINE_TO = 4, i3.VERT_LINE_TO = 8, i3.LINE_TO = 16, i3.CURVE_TO = 32, i3.SMOOTH_CURVE_TO = 64, i3.QUAD_TO = 128, i3.SMOOTH_QUAD_TO = 256, i3.ARC = 512, i3.LINE_COMMANDS = i3.LINE_TO | i3.HORIZ_LINE_TO | i3.VERT_LINE_TO, i3.DRAWING_COMMANDS = i3.HORIZ_LINE_TO | i3.VERT_LINE_TO | i3.LINE_TO | i3.CURVE_TO | i3.SMOOTH_CURVE_TO | i3.QUAD_TO | i3.SMOOTH_QUAD_TO | i3.ARC, i3;
      }(l);
      N = ((O = {})[_.MOVE_TO] = 2, O[_.LINE_TO] = 2, O[_.HORIZ_LINE_TO] = 1, O[_.VERT_LINE_TO] = 1, O[_.CLOSE_PATH] = 0, O[_.QUAD_TO] = 4, O[_.SMOOTH_QUAD_TO] = 2, O[_.CURVE_TO] = 6, O[_.SMOOTH_CURVE_TO] = 4, O[_.ARC] = 7, O);
    }
  });

  // node_modules/core-js/modules/es.regexp.to-string.js
  var uncurryThis8, PROPER_FUNCTION_NAME, redefine2, anObject4, isPrototypeOf, $toString, fails3, regExpFlags, TO_STRING, RegExpPrototype, n$ToString, getFlags, NOT_GENERIC, INCORRECT_NAME;
  var init_es_regexp_to_string = __esm({
    "node_modules/core-js/modules/es.regexp.to-string.js"() {
      "use strict";
      uncurryThis8 = require_function_uncurry_this();
      PROPER_FUNCTION_NAME = require_function_name().PROPER;
      redefine2 = require_redefine();
      anObject4 = require_an_object();
      isPrototypeOf = require_object_is_prototype_of();
      $toString = require_to_string();
      fails3 = require_fails();
      regExpFlags = require_regexp_flags();
      TO_STRING = "toString";
      RegExpPrototype = RegExp.prototype;
      n$ToString = RegExpPrototype[TO_STRING];
      getFlags = uncurryThis8(regExpFlags);
      NOT_GENERIC = fails3(function() {
        return n$ToString.call({ source: "a", flags: "b" }) != "/a/b";
      });
      INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;
      if (NOT_GENERIC || INCORRECT_NAME) {
        redefine2(RegExp.prototype, TO_STRING, function toString7() {
          var R2 = anObject4(this);
          var p4 = $toString(R2.source);
          var rf = R2.flags;
          var f3 = $toString(rf === void 0 && isPrototypeOf(RegExpPrototype, R2) && !("flags" in RegExpPrototype) ? getFlags(R2) : rf);
          return "/" + p4 + "/" + f3;
        }, { unsafe: true });
      }
    }
  });

  // node_modules/stackblur-canvas/dist/stackblur-es.js
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function getImageDataFromCanvas(canvas, topX, topY, width, height) {
    if (typeof canvas === "string") {
      canvas = document.getElementById(canvas);
    }
    if (!canvas || _typeof2(canvas) !== "object" || !("getContext" in canvas)) {
      throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
    }
    var context = canvas.getContext("2d");
    try {
      return context.getImageData(topX, topY, width, height);
    } catch (e2) {
      throw new Error("unable to access image data: " + e2);
    }
  }
  function processCanvasRGBA(canvas, topX, topY, width, height, radius) {
    if (isNaN(radius) || radius < 1) {
      return;
    }
    radius |= 0;
    var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
    imageData = processImageDataRGBA(imageData, topX, topY, width, height, radius);
    canvas.getContext("2d").putImageData(imageData, topX, topY);
  }
  function processImageDataRGBA(imageData, topX, topY, width, height, radius) {
    var pixels = imageData.data;
    var div = 2 * radius + 1;
    var widthMinus1 = width - 1;
    var heightMinus1 = height - 1;
    var radiusPlus1 = radius + 1;
    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
    var stackStart = new BlurStack();
    var stack2 = stackStart;
    var stackEnd;
    for (var i3 = 1; i3 < div; i3++) {
      stack2 = stack2.next = new BlurStack();
      if (i3 === radiusPlus1) {
        stackEnd = stack2;
      }
    }
    stack2.next = stackStart;
    var stackIn = null, stackOut = null, yw = 0, yi = 0;
    var mulSum = mulTable[radius];
    var shgSum = shgTable[radius];
    for (var y3 = 0; y3 < height; y3++) {
      stack2 = stackStart;
      var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], pa = pixels[yi + 3];
      for (var _i = 0; _i < radiusPlus1; _i++) {
        stack2.r = pr;
        stack2.g = pg;
        stack2.b = pb;
        stack2.a = pa;
        stack2 = stack2.next;
      }
      var rInSum = 0, gInSum = 0, bInSum = 0, aInSum = 0, rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, aOutSum = radiusPlus1 * pa, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb, aSum = sumFactor * pa;
      for (var _i2 = 1; _i2 < radiusPlus1; _i2++) {
        var p4 = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
        var r2 = pixels[p4], g2 = pixels[p4 + 1], b2 = pixels[p4 + 2], a3 = pixels[p4 + 3];
        var rbs = radiusPlus1 - _i2;
        rSum += (stack2.r = r2) * rbs;
        gSum += (stack2.g = g2) * rbs;
        bSum += (stack2.b = b2) * rbs;
        aSum += (stack2.a = a3) * rbs;
        rInSum += r2;
        gInSum += g2;
        bInSum += b2;
        aInSum += a3;
        stack2 = stack2.next;
      }
      stackIn = stackStart;
      stackOut = stackEnd;
      for (var x2 = 0; x2 < width; x2++) {
        var paInitial = aSum * mulSum >> shgSum;
        pixels[yi + 3] = paInitial;
        if (paInitial !== 0) {
          var _a22 = 255 / paInitial;
          pixels[yi] = (rSum * mulSum >> shgSum) * _a22;
          pixels[yi + 1] = (gSum * mulSum >> shgSum) * _a22;
          pixels[yi + 2] = (bSum * mulSum >> shgSum) * _a22;
        } else {
          pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
        }
        rSum -= rOutSum;
        gSum -= gOutSum;
        bSum -= bOutSum;
        aSum -= aOutSum;
        rOutSum -= stackIn.r;
        gOutSum -= stackIn.g;
        bOutSum -= stackIn.b;
        aOutSum -= stackIn.a;
        var _p = x2 + radius + 1;
        _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
        rInSum += stackIn.r = pixels[_p];
        gInSum += stackIn.g = pixels[_p + 1];
        bInSum += stackIn.b = pixels[_p + 2];
        aInSum += stackIn.a = pixels[_p + 3];
        rSum += rInSum;
        gSum += gInSum;
        bSum += bInSum;
        aSum += aInSum;
        stackIn = stackIn.next;
        var _stackOut = stackOut, _r = _stackOut.r, _g = _stackOut.g, _b2 = _stackOut.b, _a3 = _stackOut.a;
        rOutSum += _r;
        gOutSum += _g;
        bOutSum += _b2;
        aOutSum += _a3;
        rInSum -= _r;
        gInSum -= _g;
        bInSum -= _b2;
        aInSum -= _a3;
        stackOut = stackOut.next;
        yi += 4;
      }
      yw += width;
    }
    for (var _x = 0; _x < width; _x++) {
      yi = _x << 2;
      var _pr = pixels[yi], _pg = pixels[yi + 1], _pb = pixels[yi + 2], _pa = pixels[yi + 3], _rOutSum = radiusPlus1 * _pr, _gOutSum = radiusPlus1 * _pg, _bOutSum = radiusPlus1 * _pb, _aOutSum = radiusPlus1 * _pa, _rSum = sumFactor * _pr, _gSum = sumFactor * _pg, _bSum = sumFactor * _pb, _aSum = sumFactor * _pa;
      stack2 = stackStart;
      for (var _i3 = 0; _i3 < radiusPlus1; _i3++) {
        stack2.r = _pr;
        stack2.g = _pg;
        stack2.b = _pb;
        stack2.a = _pa;
        stack2 = stack2.next;
      }
      var yp = width;
      var _gInSum = 0, _bInSum = 0, _aInSum = 0, _rInSum = 0;
      for (var _i4 = 1; _i4 <= radius; _i4++) {
        yi = yp + _x << 2;
        var _rbs = radiusPlus1 - _i4;
        _rSum += (stack2.r = _pr = pixels[yi]) * _rbs;
        _gSum += (stack2.g = _pg = pixels[yi + 1]) * _rbs;
        _bSum += (stack2.b = _pb = pixels[yi + 2]) * _rbs;
        _aSum += (stack2.a = _pa = pixels[yi + 3]) * _rbs;
        _rInSum += _pr;
        _gInSum += _pg;
        _bInSum += _pb;
        _aInSum += _pa;
        stack2 = stack2.next;
        if (_i4 < heightMinus1) {
          yp += width;
        }
      }
      yi = _x;
      stackIn = stackStart;
      stackOut = stackEnd;
      for (var _y = 0; _y < height; _y++) {
        var _p2 = yi << 2;
        pixels[_p2 + 3] = _pa = _aSum * mulSum >> shgSum;
        if (_pa > 0) {
          _pa = 255 / _pa;
          pixels[_p2] = (_rSum * mulSum >> shgSum) * _pa;
          pixels[_p2 + 1] = (_gSum * mulSum >> shgSum) * _pa;
          pixels[_p2 + 2] = (_bSum * mulSum >> shgSum) * _pa;
        } else {
          pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
        }
        _rSum -= _rOutSum;
        _gSum -= _gOutSum;
        _bSum -= _bOutSum;
        _aSum -= _aOutSum;
        _rOutSum -= stackIn.r;
        _gOutSum -= stackIn.g;
        _bOutSum -= stackIn.b;
        _aOutSum -= stackIn.a;
        _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
        _rSum += _rInSum += stackIn.r = pixels[_p2];
        _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
        _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
        _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
        stackIn = stackIn.next;
        _rOutSum += _pr = stackOut.r;
        _gOutSum += _pg = stackOut.g;
        _bOutSum += _pb = stackOut.b;
        _aOutSum += _pa = stackOut.a;
        _rInSum -= _pr;
        _gInSum -= _pg;
        _bInSum -= _pb;
        _aInSum -= _pa;
        stackOut = stackOut.next;
        yi += width;
      }
    }
    return imageData;
  }
  var mulTable, shgTable, BlurStack;
  var init_stackblur_es = __esm({
    "node_modules/stackblur-canvas/dist/stackblur-es.js"() {
      mulTable = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];
      shgTable = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
      BlurStack = function BlurStack2() {
        _classCallCheck(this, BlurStack2);
        this.r = 0;
        this.g = 0;
        this.b = 0;
        this.a = 0;
        this.next = null;
      };
    }
  });

  // node_modules/canvg/lib/index.es.js
  var index_es_exports = {};
  __export(index_es_exports, {
    AElement: () => AElement,
    AnimateColorElement: () => AnimateColorElement,
    AnimateElement: () => AnimateElement,
    AnimateTransformElement: () => AnimateTransformElement,
    BoundingBox: () => BoundingBox,
    CB1: () => CB1,
    CB2: () => CB2,
    CB3: () => CB3,
    CB4: () => CB4,
    Canvg: () => Canvg,
    CircleElement: () => CircleElement,
    ClipPathElement: () => ClipPathElement,
    DefsElement: () => DefsElement,
    DescElement: () => DescElement,
    Document: () => Document,
    Element: () => Element2,
    EllipseElement: () => EllipseElement,
    FeColorMatrixElement: () => FeColorMatrixElement,
    FeCompositeElement: () => FeCompositeElement,
    FeDropShadowElement: () => FeDropShadowElement,
    FeGaussianBlurElement: () => FeGaussianBlurElement,
    FeMorphologyElement: () => FeMorphologyElement,
    FilterElement: () => FilterElement,
    Font: () => Font,
    FontElement: () => FontElement,
    FontFaceElement: () => FontFaceElement,
    GElement: () => GElement,
    GlyphElement: () => GlyphElement,
    GradientElement: () => GradientElement,
    ImageElement: () => ImageElement,
    LineElement: () => LineElement,
    LinearGradientElement: () => LinearGradientElement,
    MarkerElement: () => MarkerElement,
    MaskElement: () => MaskElement,
    Matrix: () => Matrix,
    MissingGlyphElement: () => MissingGlyphElement,
    Mouse: () => Mouse,
    PSEUDO_ZERO: () => PSEUDO_ZERO,
    Parser: () => Parser,
    PathElement: () => PathElement,
    PathParser: () => PathParser,
    PatternElement: () => PatternElement,
    Point: () => Point,
    PolygonElement: () => PolygonElement,
    PolylineElement: () => PolylineElement,
    Property: () => Property,
    QB1: () => QB1,
    QB2: () => QB2,
    QB3: () => QB3,
    RadialGradientElement: () => RadialGradientElement,
    RectElement: () => RectElement,
    RenderedElement: () => RenderedElement,
    Rotate: () => Rotate,
    SVGElement: () => SVGElement2,
    SVGFontLoader: () => SVGFontLoader,
    Scale: () => Scale,
    Screen: () => Screen,
    Skew: () => Skew,
    SkewX: () => SkewX,
    SkewY: () => SkewY,
    StopElement: () => StopElement,
    StyleElement: () => StyleElement,
    SymbolElement: () => SymbolElement,
    TRefElement: () => TRefElement,
    TSpanElement: () => TSpanElement,
    TextElement: () => TextElement,
    TextPathElement: () => TextPathElement,
    TitleElement: () => TitleElement,
    Transform: () => Transform,
    Translate: () => Translate,
    UnknownElement: () => UnknownElement,
    UseElement: () => UseElement,
    ViewPort: () => ViewPort,
    compressSpaces: () => compressSpaces,
    default: () => index_es_default,
    getSelectorSpecificity: () => getSelectorSpecificity,
    normalizeAttributeName: () => normalizeAttributeName,
    normalizeColor: () => normalizeColor,
    parseExternalUrl: () => parseExternalUrl,
    presets: () => index2,
    toNumbers: () => toNumbers,
    trimLeft: () => trimLeft,
    trimRight: () => trimRight,
    vectorMagnitude: () => vectorMagnitude,
    vectorsAngle: () => vectorsAngle,
    vectorsRatio: () => vectorsRatio
  });
  function offscreen() {
    var {
      DOMParser: DOMParserFallback
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var preset = {
      window: null,
      ignoreAnimation: true,
      ignoreMouse: true,
      DOMParser: DOMParserFallback,
      createCanvas(width, height) {
        return new OffscreenCanvas(width, height);
      },
      createImage(url) {
        return _asyncToGenerator(function* () {
          var response = yield fetch(url);
          var blob = yield response.blob();
          var img = yield createImageBitmap(blob);
          return img;
        })();
      }
    };
    if (typeof DOMParser !== "undefined" || typeof DOMParserFallback === "undefined") {
      Reflect.deleteProperty(preset, "DOMParser");
    }
    return preset;
  }
  function node(_ref) {
    var {
      DOMParser: DOMParser2,
      canvas,
      fetch: fetch2
    } = _ref;
    return {
      window: null,
      ignoreAnimation: true,
      ignoreMouse: true,
      DOMParser: DOMParser2,
      fetch: fetch2,
      createCanvas: canvas.createCanvas,
      createImage: canvas.loadImage
    };
  }
  function compressSpaces(str) {
    return str.replace(/(?!\u3000)\s+/gm, " ");
  }
  function trimLeft(str) {
    return str.replace(/^[\n \t]+/, "");
  }
  function trimRight(str) {
    return str.replace(/[\n \t]+$/, "");
  }
  function toNumbers(str) {
    var matches = (str || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
    return matches.map(parseFloat);
  }
  function normalizeAttributeName(name) {
    if (allUppercase.test(name)) {
      return name.toLowerCase();
    }
    return name;
  }
  function parseExternalUrl(url) {
    var urlMatch = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(url) || [];
    return urlMatch[2] || urlMatch[3] || urlMatch[4];
  }
  function normalizeColor(color) {
    if (!color.startsWith("rgb")) {
      return color;
    }
    var rgbParts = 3;
    var normalizedColor = color.replace(/\d+(\.\d+)?/g, (num, isFloat) => rgbParts-- && isFloat ? String(Math.round(parseFloat(num))) : num);
    return normalizedColor;
  }
  function findSelectorMatch(selector, regex) {
    var matches = regex.exec(selector);
    if (!matches) {
      return [selector, 0];
    }
    return [selector.replace(regex, " "), matches.length];
  }
  function getSelectorSpecificity(selector) {
    var specificity = [0, 0, 0];
    var currentSelector = selector.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " ");
    var delta = 0;
    [currentSelector, delta] = findSelectorMatch(currentSelector, attributeRegex);
    specificity[1] += delta;
    [currentSelector, delta] = findSelectorMatch(currentSelector, idRegex);
    specificity[0] += delta;
    [currentSelector, delta] = findSelectorMatch(currentSelector, classRegex);
    specificity[1] += delta;
    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoElementRegex);
    specificity[2] += delta;
    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassWithBracketsRegex);
    specificity[1] += delta;
    [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassRegex);
    specificity[1] += delta;
    currentSelector = currentSelector.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " ");
    [currentSelector, delta] = findSelectorMatch(currentSelector, elementRegex);
    specificity[2] += delta;
    return specificity.join("");
  }
  function vectorMagnitude(v3) {
    return Math.sqrt(Math.pow(v3[0], 2) + Math.pow(v3[1], 2));
  }
  function vectorsRatio(u3, v3) {
    return (u3[0] * v3[0] + u3[1] * v3[1]) / (vectorMagnitude(u3) * vectorMagnitude(v3));
  }
  function vectorsAngle(u3, v3) {
    return (u3[0] * v3[1] < u3[1] * v3[0] ? -1 : 1) * Math.acos(vectorsRatio(u3, v3));
  }
  function CB1(t3) {
    return t3 * t3 * t3;
  }
  function CB2(t3) {
    return 3 * t3 * t3 * (1 - t3);
  }
  function CB3(t3) {
    return 3 * t3 * (1 - t3) * (1 - t3);
  }
  function CB4(t3) {
    return (1 - t3) * (1 - t3) * (1 - t3);
  }
  function QB1(t3) {
    return t3 * t3;
  }
  function QB2(t3) {
    return 2 * t3 * (1 - t3);
  }
  function QB3(t3) {
    return (1 - t3) * (1 - t3);
  }
  function parseTransforms(transform2) {
    return compressSpaces(transform2).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
  }
  function parseTransform(transform2) {
    var [type, value] = transform2.split("(");
    return [type.trim(), value.trim().replace(")", "")];
  }
  function wrapFontFamily(fontFamily) {
    var trimmed = fontFamily.trim();
    return /^('|")/.test(trimmed) ? trimmed : '"'.concat(trimmed, '"');
  }
  function prepareFontFamily(fontFamily) {
    return typeof process === "undefined" ? fontFamily : fontFamily.trim().split(",").map(wrapFontFamily).join(",");
  }
  function prepareFontStyle(fontStyle) {
    if (!fontStyle) {
      return "";
    }
    var targetFontStyle = fontStyle.trim().toLowerCase();
    switch (targetFontStyle) {
      case "normal":
      case "italic":
      case "oblique":
      case "inherit":
      case "initial":
      case "unset":
        return targetFontStyle;
      default:
        if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) {
          return targetFontStyle;
        }
        return "";
    }
  }
  function prepareFontWeight(fontWeight) {
    if (!fontWeight) {
      return "";
    }
    var targetFontWeight = fontWeight.trim().toLowerCase();
    switch (targetFontWeight) {
      case "normal":
      case "bold":
      case "lighter":
      case "bolder":
      case "inherit":
      case "initial":
      case "unset":
        return targetFontWeight;
      default:
        if (/^[\d.]+$/.test(targetFontWeight)) {
          return targetFontWeight;
        }
        return "";
    }
  }
  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly)
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3] != null ? arguments[i3] : {};
      if (i3 % 2) {
        ownKeys$2(Object(source), true).forEach(function(key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function imGet(img, x2, y3, width, _height, rgba) {
    return img[y3 * width * 4 + x2 * 4 + rgba];
  }
  function imSet(img, x2, y3, width, _height, rgba, val) {
    img[y3 * width * 4 + x2 * 4 + rgba] = val;
  }
  function m2(matrix, i3, v3) {
    var mi = matrix[i3];
    return mi * v3;
  }
  function c2(a3, m1, m22, m32) {
    return m1 + Math.cos(a3) * m22 + Math.sin(a3) * m32;
  }
  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly)
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$1(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3] != null ? arguments[i3] : {};
      if (i3 % 2) {
        ownKeys$1(Object(source), true).forEach(function(key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function createCanvas(width, height) {
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
  function createImage(_x) {
    return _createImage.apply(this, arguments);
  }
  function _createImage() {
    _createImage = _asyncToGenerator(function* (src) {
      var anonymousCrossOrigin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var image = document.createElement("img");
      if (anonymousCrossOrigin) {
        image.crossOrigin = "Anonymous";
      }
      return new Promise((resolve3, reject2) => {
        image.onload = () => {
          resolve3(image);
        };
        image.onerror = (_event, _source, _lineno, _colno, error2) => {
          reject2(error2);
        };
        image.src = src;
      });
    });
    return _createImage.apply(this, arguments);
  }
  function ownKeys3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly)
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3] != null ? arguments[i3] : {};
      if (i3 % 2) {
        ownKeys3(Object(source), true).forEach(function(key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys3(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var import_es_array_iterator, import_raf, import_rgbcolor, index2, allUppercase, attributeRegex, idRegex, classRegex, pseudoElementRegex, pseudoClassWithBracketsRegex, pseudoClassRegex, elementRegex, PSEUDO_ZERO, Property, ViewPort, Point, Mouse, defaultWindow, defaultFetch$1, Screen, defaultFetch, DefaultDOMParser, Parser, Translate, Rotate, Scale, Matrix, Skew, SkewX, SkewY, Transform, Element2, UnknownElement, Font, BoundingBox, PathParser, RenderedElement, PathElement, GlyphElement, TextElement, TSpanElement, TextNode, SVGElement2, RectElement, CircleElement, EllipseElement, LineElement, PolylineElement, PolygonElement, PatternElement, MarkerElement, DefsElement, GElement, GradientElement, LinearGradientElement, RadialGradientElement, StopElement, AnimateElement, AnimateColorElement, AnimateTransformElement, FontElement, FontFaceElement, MissingGlyphElement, TRefElement, AElement, TextPathElement, dataUriRegex, ImageElement, SymbolElement, SVGFontLoader, StyleElement, UseElement, FeColorMatrixElement, MaskElement, noop, ClipPathElement, FilterElement, FeDropShadowElement, FeMorphologyElement, FeCompositeElement, FeGaussianBlurElement, TitleElement, DescElement, elements, Document, Canvg, index_es_default;
  var init_index_es = __esm({
    "node_modules/canvg/lib/index.es.js"() {
      init_es_promise();
      init_asyncToGenerator();
      init_es_string_match();
      init_es_string_replace();
      init_es_string_starts_with();
      import_es_array_iterator = __toModule(require_es_array_iterator());
      init_web_dom_collections_iterator();
      init_defineProperty();
      init_es_array_reduce();
      init_es_string_ends_with();
      init_es_string_split();
      import_raf = __toModule(require_raf());
      init_es_string_trim();
      import_rgbcolor = __toModule(require_rgbcolor());
      init_es_string_includes();
      init_es_array_index_of();
      init_es_array_reverse();
      init_SVGPathData_module();
      init_es_regexp_to_string();
      init_stackblur_es();
      index2 = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        offscreen,
        node
      });
      allUppercase = /^[A-Z-]+$/;
      attributeRegex = /(\[[^\]]+\])/g;
      idRegex = /(#[^\s+>~.[:]+)/g;
      classRegex = /(\.[^\s+>~.[:]+)/g;
      pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
      pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi;
      pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
      elementRegex = /([^\s+>~.[:]+)/g;
      PSEUDO_ZERO = 1e-8;
      Property = class {
        constructor(document3, name, value) {
          this.document = document3;
          this.name = name;
          this.value = value;
          this.isNormalizedColor = false;
        }
        static empty(document3) {
          return new Property(document3, "EMPTY", "");
        }
        split() {
          var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ";
          var {
            document: document3,
            name
          } = this;
          return compressSpaces(this.getString()).trim().split(separator).map((value) => new Property(document3, name, value));
        }
        hasValue(zeroIsValue) {
          var {
            value
          } = this;
          return value !== null && value !== "" && (zeroIsValue || value !== 0) && typeof value !== "undefined";
        }
        isString(regexp) {
          var {
            value
          } = this;
          var result = typeof value === "string";
          if (!result || !regexp) {
            return result;
          }
          return regexp.test(value);
        }
        isUrlDefinition() {
          return this.isString(/^url\(/);
        }
        isPixels() {
          if (!this.hasValue()) {
            return false;
          }
          var asString = this.getString();
          switch (true) {
            case asString.endsWith("px"):
            case /^[0-9]+$/.test(asString):
              return true;
            default:
              return false;
          }
        }
        setValue(value) {
          this.value = value;
          return this;
        }
        getValue(def2) {
          if (typeof def2 === "undefined" || this.hasValue()) {
            return this.value;
          }
          return def2;
        }
        getNumber(def2) {
          if (!this.hasValue()) {
            if (typeof def2 === "undefined") {
              return 0;
            }
            return parseFloat(def2);
          }
          var {
            value
          } = this;
          var n3 = parseFloat(value);
          if (this.isString(/%$/)) {
            n3 /= 100;
          }
          return n3;
        }
        getString(def2) {
          if (typeof def2 === "undefined" || this.hasValue()) {
            return typeof this.value === "undefined" ? "" : String(this.value);
          }
          return String(def2);
        }
        getColor(def2) {
          var color = this.getString(def2);
          if (this.isNormalizedColor) {
            return color;
          }
          this.isNormalizedColor = true;
          color = normalizeColor(color);
          this.value = color;
          return color;
        }
        getDpi() {
          return 96;
        }
        getRem() {
          return this.document.rootEmSize;
        }
        getEm() {
          return this.document.emSize;
        }
        getUnits() {
          return this.getString().replace(/[0-9.-]/g, "");
        }
        getPixels(axisOrIsFontSize) {
          var processPercent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          if (!this.hasValue()) {
            return 0;
          }
          var [axis, isFontSize] = typeof axisOrIsFontSize === "boolean" ? [void 0, axisOrIsFontSize] : [axisOrIsFontSize];
          var {
            viewPort
          } = this.document.screen;
          switch (true) {
            case this.isString(/vmin$/):
              return this.getNumber() / 100 * Math.min(viewPort.computeSize("x"), viewPort.computeSize("y"));
            case this.isString(/vmax$/):
              return this.getNumber() / 100 * Math.max(viewPort.computeSize("x"), viewPort.computeSize("y"));
            case this.isString(/vw$/):
              return this.getNumber() / 100 * viewPort.computeSize("x");
            case this.isString(/vh$/):
              return this.getNumber() / 100 * viewPort.computeSize("y");
            case this.isString(/rem$/):
              return this.getNumber() * this.getRem();
            case this.isString(/em$/):
              return this.getNumber() * this.getEm();
            case this.isString(/ex$/):
              return this.getNumber() * this.getEm() / 2;
            case this.isString(/px$/):
              return this.getNumber();
            case this.isString(/pt$/):
              return this.getNumber() * this.getDpi() * (1 / 72);
            case this.isString(/pc$/):
              return this.getNumber() * 15;
            case this.isString(/cm$/):
              return this.getNumber() * this.getDpi() / 2.54;
            case this.isString(/mm$/):
              return this.getNumber() * this.getDpi() / 25.4;
            case this.isString(/in$/):
              return this.getNumber() * this.getDpi();
            case (this.isString(/%$/) && isFontSize):
              return this.getNumber() * this.getEm();
            case this.isString(/%$/):
              return this.getNumber() * viewPort.computeSize(axis);
            default: {
              var n3 = this.getNumber();
              if (processPercent && n3 < 1) {
                return n3 * viewPort.computeSize(axis);
              }
              return n3;
            }
          }
        }
        getMilliseconds() {
          if (!this.hasValue()) {
            return 0;
          }
          if (this.isString(/ms$/)) {
            return this.getNumber();
          }
          return this.getNumber() * 1e3;
        }
        getRadians() {
          if (!this.hasValue()) {
            return 0;
          }
          switch (true) {
            case this.isString(/deg$/):
              return this.getNumber() * (Math.PI / 180);
            case this.isString(/grad$/):
              return this.getNumber() * (Math.PI / 200);
            case this.isString(/rad$/):
              return this.getNumber();
            default:
              return this.getNumber() * (Math.PI / 180);
          }
        }
        getDefinition() {
          var asString = this.getString();
          var name = /#([^)'"]+)/.exec(asString);
          if (name) {
            name = name[1];
          }
          if (!name) {
            name = asString;
          }
          return this.document.definitions[name];
        }
        getFillStyleDefinition(element, opacity) {
          var def2 = this.getDefinition();
          if (!def2) {
            return null;
          }
          if (typeof def2.createGradient === "function") {
            return def2.createGradient(this.document.ctx, element, opacity);
          }
          if (typeof def2.createPattern === "function") {
            if (def2.getHrefAttribute().hasValue()) {
              var patternTransform = def2.getAttribute("patternTransform");
              def2 = def2.getHrefAttribute().getDefinition();
              if (patternTransform.hasValue()) {
                def2.getAttribute("patternTransform", true).setValue(patternTransform.value);
              }
            }
            return def2.createPattern(this.document.ctx, element, opacity);
          }
          return null;
        }
        getTextBaseline() {
          if (!this.hasValue()) {
            return null;
          }
          return Property.textBaselineMapping[this.getString()];
        }
        addOpacity(opacity) {
          var value = this.getColor();
          var len = value.length;
          var commas = 0;
          for (var i3 = 0; i3 < len; i3++) {
            if (value[i3] === ",") {
              commas++;
            }
            if (commas === 3) {
              break;
            }
          }
          if (opacity.hasValue() && this.isString() && commas !== 3) {
            var color = new import_rgbcolor.default(value);
            if (color.ok) {
              color.alpha = opacity.getNumber();
              value = color.toRGBA();
            }
          }
          return new Property(this.document, this.name, value);
        }
      };
      Property.textBaselineMapping = {
        "baseline": "alphabetic",
        "before-edge": "top",
        "text-before-edge": "top",
        "middle": "middle",
        "central": "middle",
        "after-edge": "bottom",
        "text-after-edge": "bottom",
        "ideographic": "ideographic",
        "alphabetic": "alphabetic",
        "hanging": "hanging",
        "mathematical": "alphabetic"
      };
      ViewPort = class {
        constructor() {
          this.viewPorts = [];
        }
        clear() {
          this.viewPorts = [];
        }
        setCurrent(width, height) {
          this.viewPorts.push({
            width,
            height
          });
        }
        removeCurrent() {
          this.viewPorts.pop();
        }
        getCurrent() {
          var {
            viewPorts
          } = this;
          return viewPorts[viewPorts.length - 1];
        }
        get width() {
          return this.getCurrent().width;
        }
        get height() {
          return this.getCurrent().height;
        }
        computeSize(d2) {
          if (typeof d2 === "number") {
            return d2;
          }
          if (d2 === "x") {
            return this.width;
          }
          if (d2 === "y") {
            return this.height;
          }
          return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
        }
      };
      Point = class {
        constructor(x2, y3) {
          this.x = x2;
          this.y = y3;
        }
        static parse(point) {
          var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          var [x2 = defaultValue, y3 = defaultValue] = toNumbers(point);
          return new Point(x2, y3);
        }
        static parseScale(scale) {
          var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
          var [x2 = defaultValue, y3 = x2] = toNumbers(scale);
          return new Point(x2, y3);
        }
        static parsePath(path) {
          var points = toNumbers(path);
          var len = points.length;
          var pathPoints = [];
          for (var i3 = 0; i3 < len; i3 += 2) {
            pathPoints.push(new Point(points[i3], points[i3 + 1]));
          }
          return pathPoints;
        }
        angleTo(point) {
          return Math.atan2(point.y - this.y, point.x - this.x);
        }
        applyTransform(transform2) {
          var {
            x: x2,
            y: y3
          } = this;
          var xp = x2 * transform2[0] + y3 * transform2[2] + transform2[4];
          var yp = x2 * transform2[1] + y3 * transform2[3] + transform2[5];
          this.x = xp;
          this.y = yp;
        }
      };
      Mouse = class {
        constructor(screen) {
          this.screen = screen;
          this.working = false;
          this.events = [];
          this.eventElements = [];
          this.onClick = this.onClick.bind(this);
          this.onMouseMove = this.onMouseMove.bind(this);
        }
        isWorking() {
          return this.working;
        }
        start() {
          if (this.working) {
            return;
          }
          var {
            screen,
            onClick: onClick2,
            onMouseMove
          } = this;
          var canvas = screen.ctx.canvas;
          canvas.onclick = onClick2;
          canvas.onmousemove = onMouseMove;
          this.working = true;
        }
        stop() {
          if (!this.working) {
            return;
          }
          var canvas = this.screen.ctx.canvas;
          this.working = false;
          canvas.onclick = null;
          canvas.onmousemove = null;
        }
        hasEvents() {
          return this.working && this.events.length > 0;
        }
        runEvents() {
          if (!this.working) {
            return;
          }
          var {
            screen: document3,
            events: events2,
            eventElements
          } = this;
          var {
            style
          } = document3.ctx.canvas;
          if (style) {
            style.cursor = "";
          }
          events2.forEach((_ref, i3) => {
            var {
              run
            } = _ref;
            var element = eventElements[i3];
            while (element) {
              run(element);
              element = element.parent;
            }
          });
          this.events = [];
          this.eventElements = [];
        }
        checkPath(element, ctx) {
          if (!this.working || !ctx) {
            return;
          }
          var {
            events: events2,
            eventElements
          } = this;
          events2.forEach((_ref2, i3) => {
            var {
              x: x2,
              y: y3
            } = _ref2;
            if (!eventElements[i3] && ctx.isPointInPath && ctx.isPointInPath(x2, y3)) {
              eventElements[i3] = element;
            }
          });
        }
        checkBoundingBox(element, boundingBox) {
          if (!this.working || !boundingBox) {
            return;
          }
          var {
            events: events2,
            eventElements
          } = this;
          events2.forEach((_ref3, i3) => {
            var {
              x: x2,
              y: y3
            } = _ref3;
            if (!eventElements[i3] && boundingBox.isPointInBox(x2, y3)) {
              eventElements[i3] = element;
            }
          });
        }
        mapXY(x2, y3) {
          var {
            window: window2,
            ctx
          } = this.screen;
          var point = new Point(x2, y3);
          var element = ctx.canvas;
          while (element) {
            point.x -= element.offsetLeft;
            point.y -= element.offsetTop;
            element = element.offsetParent;
          }
          if (window2.scrollX) {
            point.x += window2.scrollX;
          }
          if (window2.scrollY) {
            point.y += window2.scrollY;
          }
          return point;
        }
        onClick(event2) {
          var {
            x: x2,
            y: y3
          } = this.mapXY(event2.clientX, event2.clientY);
          this.events.push({
            type: "onclick",
            x: x2,
            y: y3,
            run(eventTarget) {
              if (eventTarget.onClick) {
                eventTarget.onClick();
              }
            }
          });
        }
        onMouseMove(event2) {
          var {
            x: x2,
            y: y3
          } = this.mapXY(event2.clientX, event2.clientY);
          this.events.push({
            type: "onmousemove",
            x: x2,
            y: y3,
            run(eventTarget) {
              if (eventTarget.onMouseMove) {
                eventTarget.onMouseMove();
              }
            }
          });
        }
      };
      defaultWindow = typeof window !== "undefined" ? window : null;
      defaultFetch$1 = typeof fetch !== "undefined" ? fetch.bind(void 0) : null;
      Screen = class {
        constructor(ctx) {
          var {
            fetch: fetch2 = defaultFetch$1,
            window: window2 = defaultWindow
          } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          this.ctx = ctx;
          this.FRAMERATE = 30;
          this.MAX_VIRTUAL_PIXELS = 3e4;
          this.CLIENT_WIDTH = 800;
          this.CLIENT_HEIGHT = 600;
          this.viewPort = new ViewPort();
          this.mouse = new Mouse(this);
          this.animations = [];
          this.waits = [];
          this.frameDuration = 0;
          this.isReadyLock = false;
          this.isFirstRender = true;
          this.intervalId = null;
          this.window = window2;
          this.fetch = fetch2;
        }
        wait(checker) {
          this.waits.push(checker);
        }
        ready() {
          if (!this.readyPromise) {
            return Promise.resolve();
          }
          return this.readyPromise;
        }
        isReady() {
          if (this.isReadyLock) {
            return true;
          }
          var isReadyLock = this.waits.every((_3) => _3());
          if (isReadyLock) {
            this.waits = [];
            if (this.resolveReady) {
              this.resolveReady();
            }
          }
          this.isReadyLock = isReadyLock;
          return isReadyLock;
        }
        setDefaults(ctx) {
          ctx.strokeStyle = "rgba(0,0,0,0)";
          ctx.lineCap = "butt";
          ctx.lineJoin = "miter";
          ctx.miterLimit = 4;
        }
        setViewBox(_ref) {
          var {
            document: document3,
            ctx,
            aspectRatio,
            width,
            desiredWidth,
            height,
            desiredHeight,
            minX = 0,
            minY = 0,
            refX,
            refY,
            clip = false,
            clipX = 0,
            clipY = 0
          } = _ref;
          var cleanAspectRatio = compressSpaces(aspectRatio).replace(/^defer\s/, "");
          var [aspectRatioAlign, aspectRatioMeetOrSlice] = cleanAspectRatio.split(" ");
          var align = aspectRatioAlign || "xMidYMid";
          var meetOrSlice = aspectRatioMeetOrSlice || "meet";
          var scaleX = width / desiredWidth;
          var scaleY = height / desiredHeight;
          var scaleMin = Math.min(scaleX, scaleY);
          var scaleMax = Math.max(scaleX, scaleY);
          var finalDesiredWidth = desiredWidth;
          var finalDesiredHeight = desiredHeight;
          if (meetOrSlice === "meet") {
            finalDesiredWidth *= scaleMin;
            finalDesiredHeight *= scaleMin;
          }
          if (meetOrSlice === "slice") {
            finalDesiredWidth *= scaleMax;
            finalDesiredHeight *= scaleMax;
          }
          var refXProp = new Property(document3, "refX", refX);
          var refYProp = new Property(document3, "refY", refY);
          var hasRefs = refXProp.hasValue() && refYProp.hasValue();
          if (hasRefs) {
            ctx.translate(-scaleMin * refXProp.getPixels("x"), -scaleMin * refYProp.getPixels("y"));
          }
          if (clip) {
            var scaledClipX = scaleMin * clipX;
            var scaledClipY = scaleMin * clipY;
            ctx.beginPath();
            ctx.moveTo(scaledClipX, scaledClipY);
            ctx.lineTo(width, scaledClipY);
            ctx.lineTo(width, height);
            ctx.lineTo(scaledClipX, height);
            ctx.closePath();
            ctx.clip();
          }
          if (!hasRefs) {
            var isMeetMinY = meetOrSlice === "meet" && scaleMin === scaleY;
            var isSliceMaxY = meetOrSlice === "slice" && scaleMax === scaleY;
            var isMeetMinX = meetOrSlice === "meet" && scaleMin === scaleX;
            var isSliceMaxX = meetOrSlice === "slice" && scaleMax === scaleX;
            if (align.startsWith("xMid") && (isMeetMinY || isSliceMaxY)) {
              ctx.translate(width / 2 - finalDesiredWidth / 2, 0);
            }
            if (align.endsWith("YMid") && (isMeetMinX || isSliceMaxX)) {
              ctx.translate(0, height / 2 - finalDesiredHeight / 2);
            }
            if (align.startsWith("xMax") && (isMeetMinY || isSliceMaxY)) {
              ctx.translate(width - finalDesiredWidth, 0);
            }
            if (align.endsWith("YMax") && (isMeetMinX || isSliceMaxX)) {
              ctx.translate(0, height - finalDesiredHeight);
            }
          }
          switch (true) {
            case align === "none":
              ctx.scale(scaleX, scaleY);
              break;
            case meetOrSlice === "meet":
              ctx.scale(scaleMin, scaleMin);
              break;
            case meetOrSlice === "slice":
              ctx.scale(scaleMax, scaleMax);
              break;
          }
          ctx.translate(-minX, -minY);
        }
        start(element) {
          var {
            enableRedraw = false,
            ignoreMouse = false,
            ignoreAnimation = false,
            ignoreDimensions = false,
            ignoreClear = false,
            forceRedraw,
            scaleWidth,
            scaleHeight,
            offsetX,
            offsetY
          } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var {
            FRAMERATE,
            mouse
          } = this;
          var frameDuration = 1e3 / FRAMERATE;
          this.frameDuration = frameDuration;
          this.readyPromise = new Promise((resolve3) => {
            this.resolveReady = resolve3;
          });
          if (this.isReady()) {
            this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
          }
          if (!enableRedraw) {
            return;
          }
          var now2 = Date.now();
          var then = now2;
          var delta = 0;
          var tick2 = () => {
            now2 = Date.now();
            delta = now2 - then;
            if (delta >= frameDuration) {
              then = now2 - delta % frameDuration;
              if (this.shouldUpdate(ignoreAnimation, forceRedraw)) {
                this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
                mouse.runEvents();
              }
            }
            this.intervalId = (0, import_raf.default)(tick2);
          };
          if (!ignoreMouse) {
            mouse.start();
          }
          this.intervalId = (0, import_raf.default)(tick2);
        }
        stop() {
          if (this.intervalId) {
            import_raf.default.cancel(this.intervalId);
            this.intervalId = null;
          }
          this.mouse.stop();
        }
        shouldUpdate(ignoreAnimation, forceRedraw) {
          if (!ignoreAnimation) {
            var {
              frameDuration
            } = this;
            var shouldUpdate = this.animations.reduce((shouldUpdate2, animation) => animation.update(frameDuration) || shouldUpdate2, false);
            if (shouldUpdate) {
              return true;
            }
          }
          if (typeof forceRedraw === "function" && forceRedraw()) {
            return true;
          }
          if (!this.isReadyLock && this.isReady()) {
            return true;
          }
          if (this.mouse.hasEvents()) {
            return true;
          }
          return false;
        }
        render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
          var {
            CLIENT_WIDTH,
            CLIENT_HEIGHT,
            viewPort,
            ctx,
            isFirstRender
          } = this;
          var canvas = ctx.canvas;
          viewPort.clear();
          if (canvas.width && canvas.height) {
            viewPort.setCurrent(canvas.width, canvas.height);
          } else {
            viewPort.setCurrent(CLIENT_WIDTH, CLIENT_HEIGHT);
          }
          var widthStyle = element.getStyle("width");
          var heightStyle = element.getStyle("height");
          if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== "number" && typeof scaleHeight !== "number")) {
            if (widthStyle.hasValue()) {
              canvas.width = widthStyle.getPixels("x");
              if (canvas.style) {
                canvas.style.width = "".concat(canvas.width, "px");
              }
            }
            if (heightStyle.hasValue()) {
              canvas.height = heightStyle.getPixels("y");
              if (canvas.style) {
                canvas.style.height = "".concat(canvas.height, "px");
              }
            }
          }
          var cWidth = canvas.clientWidth || canvas.width;
          var cHeight = canvas.clientHeight || canvas.height;
          if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
            cWidth = widthStyle.getPixels("x");
            cHeight = heightStyle.getPixels("y");
          }
          viewPort.setCurrent(cWidth, cHeight);
          if (typeof offsetX === "number") {
            element.getAttribute("x", true).setValue(offsetX);
          }
          if (typeof offsetY === "number") {
            element.getAttribute("y", true).setValue(offsetY);
          }
          if (typeof scaleWidth === "number" || typeof scaleHeight === "number") {
            var viewBox = toNumbers(element.getAttribute("viewBox").getString());
            var xRatio = 0;
            var yRatio = 0;
            if (typeof scaleWidth === "number") {
              var _widthStyle = element.getStyle("width");
              if (_widthStyle.hasValue()) {
                xRatio = _widthStyle.getPixels("x") / scaleWidth;
              } else if (!isNaN(viewBox[2])) {
                xRatio = viewBox[2] / scaleWidth;
              }
            }
            if (typeof scaleHeight === "number") {
              var _heightStyle = element.getStyle("height");
              if (_heightStyle.hasValue()) {
                yRatio = _heightStyle.getPixels("y") / scaleHeight;
              } else if (!isNaN(viewBox[3])) {
                yRatio = viewBox[3] / scaleHeight;
              }
            }
            if (!xRatio) {
              xRatio = yRatio;
            }
            if (!yRatio) {
              yRatio = xRatio;
            }
            element.getAttribute("width", true).setValue(scaleWidth);
            element.getAttribute("height", true).setValue(scaleHeight);
            var transformStyle = element.getStyle("transform", true, true);
            transformStyle.setValue("".concat(transformStyle.getString(), " scale(").concat(1 / xRatio, ", ").concat(1 / yRatio, ")"));
          }
          if (!ignoreClear) {
            ctx.clearRect(0, 0, cWidth, cHeight);
          }
          element.render(ctx);
          if (isFirstRender) {
            this.isFirstRender = false;
          }
        }
      };
      Screen.defaultWindow = defaultWindow;
      Screen.defaultFetch = defaultFetch$1;
      ({
        defaultFetch
      } = Screen);
      DefaultDOMParser = typeof DOMParser !== "undefined" ? DOMParser : null;
      Parser = class {
        constructor() {
          var {
            fetch: fetch2 = defaultFetch,
            DOMParser: DOMParser2 = DefaultDOMParser
          } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          this.fetch = fetch2;
          this.DOMParser = DOMParser2;
        }
        parse(resource) {
          var _this = this;
          return _asyncToGenerator(function* () {
            if (resource.startsWith("<")) {
              return _this.parseFromString(resource);
            }
            return _this.load(resource);
          })();
        }
        parseFromString(xml) {
          var parser = new this.DOMParser();
          try {
            return this.checkDocument(parser.parseFromString(xml, "image/svg+xml"));
          } catch (err) {
            return this.checkDocument(parser.parseFromString(xml, "text/xml"));
          }
        }
        checkDocument(document3) {
          var parserError = document3.getElementsByTagName("parsererror")[0];
          if (parserError) {
            throw new Error(parserError.textContent);
          }
          return document3;
        }
        load(url) {
          var _this2 = this;
          return _asyncToGenerator(function* () {
            var response = yield _this2.fetch(url);
            var xml = yield response.text();
            return _this2.parseFromString(xml);
          })();
        }
      };
      Translate = class {
        constructor(_3, point) {
          this.type = "translate";
          this.point = null;
          this.point = Point.parse(point);
        }
        apply(ctx) {
          var {
            x: x2,
            y: y3
          } = this.point;
          ctx.translate(x2 || 0, y3 || 0);
        }
        unapply(ctx) {
          var {
            x: x2,
            y: y3
          } = this.point;
          ctx.translate(-1 * x2 || 0, -1 * y3 || 0);
        }
        applyToPoint(point) {
          var {
            x: x2,
            y: y3
          } = this.point;
          point.applyTransform([1, 0, 0, 1, x2 || 0, y3 || 0]);
        }
      };
      Rotate = class {
        constructor(document3, rotate, transformOrigin) {
          this.type = "rotate";
          this.angle = null;
          this.originX = null;
          this.originY = null;
          this.cx = 0;
          this.cy = 0;
          var numbers = toNumbers(rotate);
          this.angle = new Property(document3, "angle", numbers[0]);
          this.originX = transformOrigin[0];
          this.originY = transformOrigin[1];
          this.cx = numbers[1] || 0;
          this.cy = numbers[2] || 0;
        }
        apply(ctx) {
          var {
            cx,
            cy,
            originX,
            originY,
            angle
          } = this;
          var tx = cx + originX.getPixels("x");
          var ty = cy + originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.rotate(angle.getRadians());
          ctx.translate(-tx, -ty);
        }
        unapply(ctx) {
          var {
            cx,
            cy,
            originX,
            originY,
            angle
          } = this;
          var tx = cx + originX.getPixels("x");
          var ty = cy + originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.rotate(-1 * angle.getRadians());
          ctx.translate(-tx, -ty);
        }
        applyToPoint(point) {
          var {
            cx,
            cy,
            angle
          } = this;
          var rad = angle.getRadians();
          point.applyTransform([
            1,
            0,
            0,
            1,
            cx || 0,
            cy || 0
          ]);
          point.applyTransform([Math.cos(rad), Math.sin(rad), -Math.sin(rad), Math.cos(rad), 0, 0]);
          point.applyTransform([
            1,
            0,
            0,
            1,
            -cx || 0,
            -cy || 0
          ]);
        }
      };
      Scale = class {
        constructor(_3, scale, transformOrigin) {
          this.type = "scale";
          this.scale = null;
          this.originX = null;
          this.originY = null;
          var scaleSize = Point.parseScale(scale);
          if (scaleSize.x === 0 || scaleSize.y === 0) {
            scaleSize.x = PSEUDO_ZERO;
            scaleSize.y = PSEUDO_ZERO;
          }
          this.scale = scaleSize;
          this.originX = transformOrigin[0];
          this.originY = transformOrigin[1];
        }
        apply(ctx) {
          var {
            scale: {
              x: x2,
              y: y3
            },
            originX,
            originY
          } = this;
          var tx = originX.getPixels("x");
          var ty = originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.scale(x2, y3 || x2);
          ctx.translate(-tx, -ty);
        }
        unapply(ctx) {
          var {
            scale: {
              x: x2,
              y: y3
            },
            originX,
            originY
          } = this;
          var tx = originX.getPixels("x");
          var ty = originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.scale(1 / x2, 1 / y3 || x2);
          ctx.translate(-tx, -ty);
        }
        applyToPoint(point) {
          var {
            x: x2,
            y: y3
          } = this.scale;
          point.applyTransform([x2 || 0, 0, 0, y3 || 0, 0, 0]);
        }
      };
      Matrix = class {
        constructor(_3, matrix, transformOrigin) {
          this.type = "matrix";
          this.matrix = [];
          this.originX = null;
          this.originY = null;
          this.matrix = toNumbers(matrix);
          this.originX = transformOrigin[0];
          this.originY = transformOrigin[1];
        }
        apply(ctx) {
          var {
            originX,
            originY,
            matrix
          } = this;
          var tx = originX.getPixels("x");
          var ty = originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
          ctx.translate(-tx, -ty);
        }
        unapply(ctx) {
          var {
            originX,
            originY,
            matrix
          } = this;
          var a3 = matrix[0];
          var b2 = matrix[2];
          var c4 = matrix[4];
          var d2 = matrix[1];
          var e2 = matrix[3];
          var f3 = matrix[5];
          var g2 = 0;
          var h4 = 0;
          var i3 = 1;
          var det = 1 / (a3 * (e2 * i3 - f3 * h4) - b2 * (d2 * i3 - f3 * g2) + c4 * (d2 * h4 - e2 * g2));
          var tx = originX.getPixels("x");
          var ty = originY.getPixels("y");
          ctx.translate(tx, ty);
          ctx.transform(det * (e2 * i3 - f3 * h4), det * (f3 * g2 - d2 * i3), det * (c4 * h4 - b2 * i3), det * (a3 * i3 - c4 * g2), det * (b2 * f3 - c4 * e2), det * (c4 * d2 - a3 * f3));
          ctx.translate(-tx, -ty);
        }
        applyToPoint(point) {
          point.applyTransform(this.matrix);
        }
      };
      Skew = class extends Matrix {
        constructor(document3, skew, transformOrigin) {
          super(document3, skew, transformOrigin);
          this.type = "skew";
          this.angle = null;
          this.angle = new Property(document3, "angle", skew);
        }
      };
      SkewX = class extends Skew {
        constructor(document3, skew, transformOrigin) {
          super(document3, skew, transformOrigin);
          this.type = "skewX";
          this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
        }
      };
      SkewY = class extends Skew {
        constructor(document3, skew, transformOrigin) {
          super(document3, skew, transformOrigin);
          this.type = "skewY";
          this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
        }
      };
      Transform = class {
        constructor(document3, transform2, transformOrigin) {
          this.document = document3;
          this.transforms = [];
          var data2 = parseTransforms(transform2);
          data2.forEach((transform3) => {
            if (transform3 === "none") {
              return;
            }
            var [type, value] = parseTransform(transform3);
            var TransformType = Transform.transformTypes[type];
            if (typeof TransformType !== "undefined") {
              this.transforms.push(new TransformType(this.document, value, transformOrigin));
            }
          });
        }
        static fromElement(document3, element) {
          var transformStyle = element.getStyle("transform", false, true);
          var [transformOriginXProperty, transformOriginYProperty = transformOriginXProperty] = element.getStyle("transform-origin", false, true).split();
          var transformOrigin = [transformOriginXProperty, transformOriginYProperty];
          if (transformStyle.hasValue()) {
            return new Transform(document3, transformStyle.getString(), transformOrigin);
          }
          return null;
        }
        apply(ctx) {
          var {
            transforms
          } = this;
          var len = transforms.length;
          for (var i3 = 0; i3 < len; i3++) {
            transforms[i3].apply(ctx);
          }
        }
        unapply(ctx) {
          var {
            transforms
          } = this;
          var len = transforms.length;
          for (var i3 = len - 1; i3 >= 0; i3--) {
            transforms[i3].unapply(ctx);
          }
        }
        applyToPoint(point) {
          var {
            transforms
          } = this;
          var len = transforms.length;
          for (var i3 = 0; i3 < len; i3++) {
            transforms[i3].applyToPoint(point);
          }
        }
      };
      Transform.transformTypes = {
        translate: Translate,
        rotate: Rotate,
        scale: Scale,
        matrix: Matrix,
        skewX: SkewX,
        skewY: SkewY
      };
      Element2 = class {
        constructor(document3, node2) {
          var captureTextNodes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          this.document = document3;
          this.node = node2;
          this.captureTextNodes = captureTextNodes;
          this.attributes = {};
          this.styles = {};
          this.stylesSpecificity = {};
          this.animationFrozen = false;
          this.animationFrozenValue = "";
          this.parent = null;
          this.children = [];
          if (!node2 || node2.nodeType !== 1) {
            return;
          }
          Array.from(node2.attributes).forEach((attribute) => {
            var nodeName = normalizeAttributeName(attribute.nodeName);
            this.attributes[nodeName] = new Property(document3, nodeName, attribute.value);
          });
          this.addStylesFromStyleDefinition();
          if (this.getAttribute("style").hasValue()) {
            var styles2 = this.getAttribute("style").getString().split(";").map((_3) => _3.trim());
            styles2.forEach((style) => {
              if (!style) {
                return;
              }
              var [name, value] = style.split(":").map((_3) => _3.trim());
              this.styles[name] = new Property(document3, name, value);
            });
          }
          var {
            definitions
          } = document3;
          var id = this.getAttribute("id");
          if (id.hasValue()) {
            if (!definitions[id.getString()]) {
              definitions[id.getString()] = this;
            }
          }
          Array.from(node2.childNodes).forEach((childNode) => {
            if (childNode.nodeType === 1) {
              this.addChild(childNode);
            } else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
              var textNode = document3.createTextNode(childNode);
              if (textNode.getText().length > 0) {
                this.addChild(textNode);
              }
            }
          });
        }
        getAttribute(name) {
          var createIfNotExists = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          var attr2 = this.attributes[name];
          if (!attr2 && createIfNotExists) {
            var _attr = new Property(this.document, name, "");
            this.attributes[name] = _attr;
            return _attr;
          }
          return attr2 || Property.empty(this.document);
        }
        getHrefAttribute() {
          for (var key in this.attributes) {
            if (key === "href" || key.endsWith(":href")) {
              return this.attributes[key];
            }
          }
          return Property.empty(this.document);
        }
        getStyle(name) {
          var createIfNotExists = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          var skipAncestors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          var style = this.styles[name];
          if (style) {
            return style;
          }
          var attr2 = this.getAttribute(name);
          if (attr2 !== null && attr2 !== void 0 && attr2.hasValue()) {
            this.styles[name] = attr2;
            return attr2;
          }
          if (!skipAncestors) {
            var {
              parent: parent2
            } = this;
            if (parent2) {
              var parentStyle = parent2.getStyle(name);
              if (parentStyle !== null && parentStyle !== void 0 && parentStyle.hasValue()) {
                return parentStyle;
              }
            }
          }
          if (createIfNotExists) {
            var _style = new Property(this.document, name, "");
            this.styles[name] = _style;
            return _style;
          }
          return style || Property.empty(this.document);
        }
        render(ctx) {
          if (this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden") {
            return;
          }
          ctx.save();
          if (this.getStyle("mask").hasValue()) {
            var mask = this.getStyle("mask").getDefinition();
            if (mask) {
              this.applyEffects(ctx);
              mask.apply(ctx, this);
            }
          } else if (this.getStyle("filter").getValue("none") !== "none") {
            var filter2 = this.getStyle("filter").getDefinition();
            if (filter2) {
              this.applyEffects(ctx);
              filter2.apply(ctx, this);
            }
          } else {
            this.setContext(ctx);
            this.renderChildren(ctx);
            this.clearContext(ctx);
          }
          ctx.restore();
        }
        setContext(_3) {
        }
        applyEffects(ctx) {
          var transform2 = Transform.fromElement(this.document, this);
          if (transform2) {
            transform2.apply(ctx);
          }
          var clipPathStyleProp = this.getStyle("clip-path", false, true);
          if (clipPathStyleProp.hasValue()) {
            var clip = clipPathStyleProp.getDefinition();
            if (clip) {
              clip.apply(ctx);
            }
          }
        }
        clearContext(_3) {
        }
        renderChildren(ctx) {
          this.children.forEach((child) => {
            child.render(ctx);
          });
        }
        addChild(childNode) {
          var child = childNode instanceof Element2 ? childNode : this.document.createElement(childNode);
          child.parent = this;
          if (!Element2.ignoreChildTypes.includes(child.type)) {
            this.children.push(child);
          }
        }
        matchesSelector(selector) {
          var {
            node: node2
          } = this;
          if (typeof node2.matches === "function") {
            return node2.matches(selector);
          }
          var styleClasses = node2.getAttribute("class");
          if (!styleClasses || styleClasses === "") {
            return false;
          }
          return styleClasses.split(" ").some((styleClass) => ".".concat(styleClass) === selector);
        }
        addStylesFromStyleDefinition() {
          var {
            styles: styles2,
            stylesSpecificity
          } = this.document;
          for (var selector in styles2) {
            if (!selector.startsWith("@") && this.matchesSelector(selector)) {
              var style = styles2[selector];
              var specificity = stylesSpecificity[selector];
              if (style) {
                for (var name in style) {
                  var existingSpecificity = this.stylesSpecificity[name];
                  if (typeof existingSpecificity === "undefined") {
                    existingSpecificity = "000";
                  }
                  if (specificity >= existingSpecificity) {
                    this.styles[name] = style[name];
                    this.stylesSpecificity[name] = specificity;
                  }
                }
              }
            }
          }
        }
        removeStyles(element, ignoreStyles) {
          var toRestore = ignoreStyles.reduce((toRestore2, name) => {
            var styleProp = element.getStyle(name);
            if (!styleProp.hasValue()) {
              return toRestore2;
            }
            var value = styleProp.getString();
            styleProp.setValue("");
            return [...toRestore2, [name, value]];
          }, []);
          return toRestore;
        }
        restoreStyles(element, styles2) {
          styles2.forEach((_ref) => {
            var [name, value] = _ref;
            element.getStyle(name, true).setValue(value);
          });
        }
      };
      Element2.ignoreChildTypes = ["title"];
      UnknownElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
        }
      };
      Font = class {
        constructor(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
          var inheritFont = inherit ? typeof inherit === "string" ? Font.parse(inherit) : inherit : {};
          this.fontFamily = fontFamily || inheritFont.fontFamily;
          this.fontSize = fontSize || inheritFont.fontSize;
          this.fontStyle = fontStyle || inheritFont.fontStyle;
          this.fontWeight = fontWeight || inheritFont.fontWeight;
          this.fontVariant = fontVariant || inheritFont.fontVariant;
        }
        static parse() {
          var font = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
          var inherit = arguments.length > 1 ? arguments[1] : void 0;
          var fontStyle = "";
          var fontVariant = "";
          var fontWeight = "";
          var fontSize = "";
          var fontFamily = "";
          var parts = compressSpaces(font).trim().split(" ");
          var set4 = {
            fontSize: false,
            fontStyle: false,
            fontWeight: false,
            fontVariant: false
          };
          parts.forEach((part) => {
            switch (true) {
              case (!set4.fontStyle && Font.styles.includes(part)):
                if (part !== "inherit") {
                  fontStyle = part;
                }
                set4.fontStyle = true;
                break;
              case (!set4.fontVariant && Font.variants.includes(part)):
                if (part !== "inherit") {
                  fontVariant = part;
                }
                set4.fontStyle = true;
                set4.fontVariant = true;
                break;
              case (!set4.fontWeight && Font.weights.includes(part)):
                if (part !== "inherit") {
                  fontWeight = part;
                }
                set4.fontStyle = true;
                set4.fontVariant = true;
                set4.fontWeight = true;
                break;
              case !set4.fontSize:
                if (part !== "inherit") {
                  [fontSize] = part.split("/");
                }
                set4.fontStyle = true;
                set4.fontVariant = true;
                set4.fontWeight = true;
                set4.fontSize = true;
                break;
              default:
                if (part !== "inherit") {
                  fontFamily += part;
                }
            }
          });
          return new Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
        }
        toString() {
          return [
            prepareFontStyle(this.fontStyle),
            this.fontVariant,
            prepareFontWeight(this.fontWeight),
            this.fontSize,
            prepareFontFamily(this.fontFamily)
          ].join(" ").trim();
        }
      };
      Font.styles = "normal|italic|oblique|inherit";
      Font.variants = "normal|small-caps|inherit";
      Font.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
      BoundingBox = class {
        constructor() {
          var x1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN;
          var y1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN;
          var x2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN;
          var y22 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
          this.x1 = x1;
          this.y1 = y1;
          this.x2 = x2;
          this.y2 = y22;
          this.addPoint(x1, y1);
          this.addPoint(x2, y22);
        }
        get x() {
          return this.x1;
        }
        get y() {
          return this.y1;
        }
        get width() {
          return this.x2 - this.x1;
        }
        get height() {
          return this.y2 - this.y1;
        }
        addPoint(x2, y3) {
          if (typeof x2 !== "undefined") {
            if (isNaN(this.x1) || isNaN(this.x2)) {
              this.x1 = x2;
              this.x2 = x2;
            }
            if (x2 < this.x1) {
              this.x1 = x2;
            }
            if (x2 > this.x2) {
              this.x2 = x2;
            }
          }
          if (typeof y3 !== "undefined") {
            if (isNaN(this.y1) || isNaN(this.y2)) {
              this.y1 = y3;
              this.y2 = y3;
            }
            if (y3 < this.y1) {
              this.y1 = y3;
            }
            if (y3 > this.y2) {
              this.y2 = y3;
            }
          }
        }
        addX(x2) {
          this.addPoint(x2, null);
        }
        addY(y3) {
          this.addPoint(null, y3);
        }
        addBoundingBox(boundingBox) {
          if (!boundingBox) {
            return;
          }
          var {
            x1,
            y1,
            x2,
            y2: y22
          } = boundingBox;
          this.addPoint(x1, y1);
          this.addPoint(x2, y22);
        }
        sumCubic(t3, p0, p1, p22, p32) {
          return Math.pow(1 - t3, 3) * p0 + 3 * Math.pow(1 - t3, 2) * t3 * p1 + 3 * (1 - t3) * Math.pow(t3, 2) * p22 + Math.pow(t3, 3) * p32;
        }
        bezierCurveAdd(forX, p0, p1, p22, p32) {
          var b2 = 6 * p0 - 12 * p1 + 6 * p22;
          var a3 = -3 * p0 + 9 * p1 - 9 * p22 + 3 * p32;
          var c4 = 3 * p1 - 3 * p0;
          if (a3 === 0) {
            if (b2 === 0) {
              return;
            }
            var t3 = -c4 / b2;
            if (0 < t3 && t3 < 1) {
              if (forX) {
                this.addX(this.sumCubic(t3, p0, p1, p22, p32));
              } else {
                this.addY(this.sumCubic(t3, p0, p1, p22, p32));
              }
            }
            return;
          }
          var b2ac = Math.pow(b2, 2) - 4 * c4 * a3;
          if (b2ac < 0) {
            return;
          }
          var t1 = (-b2 + Math.sqrt(b2ac)) / (2 * a3);
          if (0 < t1 && t1 < 1) {
            if (forX) {
              this.addX(this.sumCubic(t1, p0, p1, p22, p32));
            } else {
              this.addY(this.sumCubic(t1, p0, p1, p22, p32));
            }
          }
          var t22 = (-b2 - Math.sqrt(b2ac)) / (2 * a3);
          if (0 < t22 && t22 < 1) {
            if (forX) {
              this.addX(this.sumCubic(t22, p0, p1, p22, p32));
            } else {
              this.addY(this.sumCubic(t22, p0, p1, p22, p32));
            }
          }
        }
        addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
          this.addPoint(p0x, p0y);
          this.addPoint(p3x, p3y);
          this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
          this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
        }
        addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
          var cp1x = p0x + 2 / 3 * (p1x - p0x);
          var cp1y = p0y + 2 / 3 * (p1y - p0y);
          var cp2x = cp1x + 1 / 3 * (p2x - p0x);
          var cp2y = cp1y + 1 / 3 * (p2y - p0y);
          this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
        }
        isPointInBox(x2, y3) {
          var {
            x1,
            y1,
            x2: x22,
            y2: y22
          } = this;
          return x1 <= x2 && x2 <= x22 && y1 <= y3 && y3 <= y22;
        }
      };
      PathParser = class extends _ {
        constructor(path) {
          super(path.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ""));
          this.control = null;
          this.start = null;
          this.current = null;
          this.command = null;
          this.commands = this.commands;
          this.i = -1;
          this.previousCommand = null;
          this.points = [];
          this.angles = [];
        }
        reset() {
          this.i = -1;
          this.command = null;
          this.previousCommand = null;
          this.start = new Point(0, 0);
          this.control = new Point(0, 0);
          this.current = new Point(0, 0);
          this.points = [];
          this.angles = [];
        }
        isEnd() {
          var {
            i: i3,
            commands
          } = this;
          return i3 >= commands.length - 1;
        }
        next() {
          var command = this.commands[++this.i];
          this.previousCommand = this.command;
          this.command = command;
          return command;
        }
        getPoint() {
          var xProp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x";
          var yProp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y";
          var point = new Point(this.command[xProp], this.command[yProp]);
          return this.makeAbsolute(point);
        }
        getAsControlPoint(xProp, yProp) {
          var point = this.getPoint(xProp, yProp);
          this.control = point;
          return point;
        }
        getAsCurrentPoint(xProp, yProp) {
          var point = this.getPoint(xProp, yProp);
          this.current = point;
          return point;
        }
        getReflectedControlPoint() {
          var previousCommand = this.previousCommand.type;
          if (previousCommand !== _.CURVE_TO && previousCommand !== _.SMOOTH_CURVE_TO && previousCommand !== _.QUAD_TO && previousCommand !== _.SMOOTH_QUAD_TO) {
            return this.current;
          }
          var {
            current: {
              x: cx,
              y: cy
            },
            control: {
              x: ox,
              y: oy
            }
          } = this;
          var point = new Point(2 * cx - ox, 2 * cy - oy);
          return point;
        }
        makeAbsolute(point) {
          if (this.command.relative) {
            var {
              x: x2,
              y: y3
            } = this.current;
            point.x += x2;
            point.y += y3;
          }
          return point;
        }
        addMarker(point, from, priorTo) {
          var {
            points,
            angles
          } = this;
          if (priorTo && angles.length > 0 && !angles[angles.length - 1]) {
            angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
          }
          this.addMarkerAngle(point, from ? from.angleTo(point) : null);
        }
        addMarkerAngle(point, angle) {
          this.points.push(point);
          this.angles.push(angle);
        }
        getMarkerPoints() {
          return this.points;
        }
        getMarkerAngles() {
          var {
            angles
          } = this;
          var len = angles.length;
          for (var i3 = 0; i3 < len; i3++) {
            if (!angles[i3]) {
              for (var j2 = i3 + 1; j2 < len; j2++) {
                if (angles[j2]) {
                  angles[i3] = angles[j2];
                  break;
                }
              }
            }
          }
          return angles;
        }
      };
      RenderedElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.modifiedEmSizeStack = false;
        }
        calculateOpacity() {
          var opacity = 1;
          var element = this;
          while (element) {
            var opacityStyle = element.getStyle("opacity", false, true);
            if (opacityStyle.hasValue(true)) {
              opacity *= opacityStyle.getNumber();
            }
            element = element.parent;
          }
          return opacity;
        }
        setContext(ctx) {
          var fromMeasure = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          if (!fromMeasure) {
            var fillStyleProp = this.getStyle("fill");
            var fillOpacityStyleProp = this.getStyle("fill-opacity");
            var strokeStyleProp = this.getStyle("stroke");
            var strokeOpacityProp = this.getStyle("stroke-opacity");
            if (fillStyleProp.isUrlDefinition()) {
              var fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);
              if (fillStyle) {
                ctx.fillStyle = fillStyle;
              }
            } else if (fillStyleProp.hasValue()) {
              if (fillStyleProp.getString() === "currentColor") {
                fillStyleProp.setValue(this.getStyle("color").getColor());
              }
              var _fillStyle = fillStyleProp.getColor();
              if (_fillStyle !== "inherit") {
                ctx.fillStyle = _fillStyle === "none" ? "rgba(0,0,0,0)" : _fillStyle;
              }
            }
            if (fillOpacityStyleProp.hasValue()) {
              var _fillStyle2 = new Property(this.document, "fill", ctx.fillStyle).addOpacity(fillOpacityStyleProp).getColor();
              ctx.fillStyle = _fillStyle2;
            }
            if (strokeStyleProp.isUrlDefinition()) {
              var strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);
              if (strokeStyle) {
                ctx.strokeStyle = strokeStyle;
              }
            } else if (strokeStyleProp.hasValue()) {
              if (strokeStyleProp.getString() === "currentColor") {
                strokeStyleProp.setValue(this.getStyle("color").getColor());
              }
              var _strokeStyle = strokeStyleProp.getString();
              if (_strokeStyle !== "inherit") {
                ctx.strokeStyle = _strokeStyle === "none" ? "rgba(0,0,0,0)" : _strokeStyle;
              }
            }
            if (strokeOpacityProp.hasValue()) {
              var _strokeStyle2 = new Property(this.document, "stroke", ctx.strokeStyle).addOpacity(strokeOpacityProp).getString();
              ctx.strokeStyle = _strokeStyle2;
            }
            var strokeWidthStyleProp = this.getStyle("stroke-width");
            if (strokeWidthStyleProp.hasValue()) {
              var newLineWidth = strokeWidthStyleProp.getPixels();
              ctx.lineWidth = !newLineWidth ? PSEUDO_ZERO : newLineWidth;
            }
            var strokeLinecapStyleProp = this.getStyle("stroke-linecap");
            var strokeLinejoinStyleProp = this.getStyle("stroke-linejoin");
            var strokeMiterlimitProp = this.getStyle("stroke-miterlimit");
            var strokeDasharrayStyleProp = this.getStyle("stroke-dasharray");
            var strokeDashoffsetProp = this.getStyle("stroke-dashoffset");
            if (strokeLinecapStyleProp.hasValue()) {
              ctx.lineCap = strokeLinecapStyleProp.getString();
            }
            if (strokeLinejoinStyleProp.hasValue()) {
              ctx.lineJoin = strokeLinejoinStyleProp.getString();
            }
            if (strokeMiterlimitProp.hasValue()) {
              ctx.miterLimit = strokeMiterlimitProp.getNumber();
            }
            if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== "none") {
              var gaps = toNumbers(strokeDasharrayStyleProp.getString());
              if (typeof ctx.setLineDash !== "undefined") {
                ctx.setLineDash(gaps);
              } else if (typeof ctx.webkitLineDash !== "undefined") {
                ctx.webkitLineDash = gaps;
              } else if (typeof ctx.mozDash !== "undefined" && !(gaps.length === 1 && gaps[0] === 0)) {
                ctx.mozDash = gaps;
              }
              var offset2 = strokeDashoffsetProp.getPixels();
              if (typeof ctx.lineDashOffset !== "undefined") {
                ctx.lineDashOffset = offset2;
              } else if (typeof ctx.webkitLineDashOffset !== "undefined") {
                ctx.webkitLineDashOffset = offset2;
              } else if (typeof ctx.mozDashOffset !== "undefined") {
                ctx.mozDashOffset = offset2;
              }
            }
          }
          this.modifiedEmSizeStack = false;
          if (typeof ctx.font !== "undefined") {
            var fontStyleProp = this.getStyle("font");
            var fontStyleStyleProp = this.getStyle("font-style");
            var fontVariantStyleProp = this.getStyle("font-variant");
            var fontWeightStyleProp = this.getStyle("font-weight");
            var fontSizeStyleProp = this.getStyle("font-size");
            var fontFamilyStyleProp = this.getStyle("font-family");
            var font = new Font(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : "", fontFamilyStyleProp.getString(), Font.parse(fontStyleProp.getString(), ctx.font));
            fontStyleStyleProp.setValue(font.fontStyle);
            fontVariantStyleProp.setValue(font.fontVariant);
            fontWeightStyleProp.setValue(font.fontWeight);
            fontSizeStyleProp.setValue(font.fontSize);
            fontFamilyStyleProp.setValue(font.fontFamily);
            ctx.font = font.toString();
            if (fontSizeStyleProp.isPixels()) {
              this.document.emSize = fontSizeStyleProp.getPixels();
              this.modifiedEmSizeStack = true;
            }
          }
          if (!fromMeasure) {
            this.applyEffects(ctx);
            ctx.globalAlpha = this.calculateOpacity();
          }
        }
        clearContext(ctx) {
          super.clearContext(ctx);
          if (this.modifiedEmSizeStack) {
            this.document.popEmSize();
          }
        }
      };
      PathElement = class extends RenderedElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "path";
          this.pathParser = null;
          this.pathParser = new PathParser(this.getAttribute("d").getString());
        }
        path(ctx) {
          var {
            pathParser
          } = this;
          var boundingBox = new BoundingBox();
          pathParser.reset();
          if (ctx) {
            ctx.beginPath();
          }
          while (!pathParser.isEnd()) {
            switch (pathParser.next().type) {
              case PathParser.MOVE_TO:
                this.pathM(ctx, boundingBox);
                break;
              case PathParser.LINE_TO:
                this.pathL(ctx, boundingBox);
                break;
              case PathParser.HORIZ_LINE_TO:
                this.pathH(ctx, boundingBox);
                break;
              case PathParser.VERT_LINE_TO:
                this.pathV(ctx, boundingBox);
                break;
              case PathParser.CURVE_TO:
                this.pathC(ctx, boundingBox);
                break;
              case PathParser.SMOOTH_CURVE_TO:
                this.pathS(ctx, boundingBox);
                break;
              case PathParser.QUAD_TO:
                this.pathQ(ctx, boundingBox);
                break;
              case PathParser.SMOOTH_QUAD_TO:
                this.pathT(ctx, boundingBox);
                break;
              case PathParser.ARC:
                this.pathA(ctx, boundingBox);
                break;
              case PathParser.CLOSE_PATH:
                this.pathZ(ctx, boundingBox);
                break;
            }
          }
          return boundingBox;
        }
        getBoundingBox(_3) {
          return this.path();
        }
        getMarkers() {
          var {
            pathParser
          } = this;
          var points = pathParser.getMarkerPoints();
          var angles = pathParser.getMarkerAngles();
          var markers = points.map((point, i3) => [point, angles[i3]]);
          return markers;
        }
        renderChildren(ctx) {
          this.path(ctx);
          this.document.screen.mouse.checkPath(this, ctx);
          var fillRuleStyleProp = this.getStyle("fill-rule");
          if (ctx.fillStyle !== "") {
            if (fillRuleStyleProp.getString("inherit") !== "inherit") {
              ctx.fill(fillRuleStyleProp.getString());
            } else {
              ctx.fill();
            }
          }
          if (ctx.strokeStyle !== "") {
            if (this.getAttribute("vector-effect").getString() === "non-scaling-stroke") {
              ctx.save();
              ctx.setTransform(1, 0, 0, 1, 0, 0);
              ctx.stroke();
              ctx.restore();
            } else {
              ctx.stroke();
            }
          }
          var markers = this.getMarkers();
          if (markers) {
            var markersLastIndex = markers.length - 1;
            var markerStartStyleProp = this.getStyle("marker-start");
            var markerMidStyleProp = this.getStyle("marker-mid");
            var markerEndStyleProp = this.getStyle("marker-end");
            if (markerStartStyleProp.isUrlDefinition()) {
              var marker = markerStartStyleProp.getDefinition();
              var [point, angle] = markers[0];
              marker.render(ctx, point, angle);
            }
            if (markerMidStyleProp.isUrlDefinition()) {
              var _marker = markerMidStyleProp.getDefinition();
              for (var i3 = 1; i3 < markersLastIndex; i3++) {
                var [_point, _angle] = markers[i3];
                _marker.render(ctx, _point, _angle);
              }
            }
            if (markerEndStyleProp.isUrlDefinition()) {
              var _marker2 = markerEndStyleProp.getDefinition();
              var [_point2, _angle2] = markers[markersLastIndex];
              _marker2.render(ctx, _point2, _angle2);
            }
          }
        }
        static pathM(pathParser) {
          var point = pathParser.getAsCurrentPoint();
          pathParser.start = pathParser.current;
          return {
            point
          };
        }
        pathM(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            point
          } = PathElement.pathM(pathParser);
          var {
            x: x2,
            y: y3
          } = point;
          pathParser.addMarker(point);
          boundingBox.addPoint(x2, y3);
          if (ctx) {
            ctx.moveTo(x2, y3);
          }
        }
        static pathL(pathParser) {
          var {
            current
          } = pathParser;
          var point = pathParser.getAsCurrentPoint();
          return {
            current,
            point
          };
        }
        pathL(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            point
          } = PathElement.pathL(pathParser);
          var {
            x: x2,
            y: y3
          } = point;
          pathParser.addMarker(point, current);
          boundingBox.addPoint(x2, y3);
          if (ctx) {
            ctx.lineTo(x2, y3);
          }
        }
        static pathH(pathParser) {
          var {
            current,
            command
          } = pathParser;
          var point = new Point((command.relative ? current.x : 0) + command.x, current.y);
          pathParser.current = point;
          return {
            current,
            point
          };
        }
        pathH(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            point
          } = PathElement.pathH(pathParser);
          var {
            x: x2,
            y: y3
          } = point;
          pathParser.addMarker(point, current);
          boundingBox.addPoint(x2, y3);
          if (ctx) {
            ctx.lineTo(x2, y3);
          }
        }
        static pathV(pathParser) {
          var {
            current,
            command
          } = pathParser;
          var point = new Point(current.x, (command.relative ? current.y : 0) + command.y);
          pathParser.current = point;
          return {
            current,
            point
          };
        }
        pathV(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            point
          } = PathElement.pathV(pathParser);
          var {
            x: x2,
            y: y3
          } = point;
          pathParser.addMarker(point, current);
          boundingBox.addPoint(x2, y3);
          if (ctx) {
            ctx.lineTo(x2, y3);
          }
        }
        static pathC(pathParser) {
          var {
            current
          } = pathParser;
          var point = pathParser.getPoint("x1", "y1");
          var controlPoint = pathParser.getAsControlPoint("x2", "y2");
          var currentPoint = pathParser.getAsCurrentPoint();
          return {
            current,
            point,
            controlPoint,
            currentPoint
          };
        }
        pathC(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            point,
            controlPoint,
            currentPoint
          } = PathElement.pathC(pathParser);
          pathParser.addMarker(currentPoint, controlPoint, point);
          boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          if (ctx) {
            ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          }
        }
        static pathS(pathParser) {
          var {
            current
          } = pathParser;
          var point = pathParser.getReflectedControlPoint();
          var controlPoint = pathParser.getAsControlPoint("x2", "y2");
          var currentPoint = pathParser.getAsCurrentPoint();
          return {
            current,
            point,
            controlPoint,
            currentPoint
          };
        }
        pathS(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            point,
            controlPoint,
            currentPoint
          } = PathElement.pathS(pathParser);
          pathParser.addMarker(currentPoint, controlPoint, point);
          boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          if (ctx) {
            ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          }
        }
        static pathQ(pathParser) {
          var {
            current
          } = pathParser;
          var controlPoint = pathParser.getAsControlPoint("x1", "y1");
          var currentPoint = pathParser.getAsCurrentPoint();
          return {
            current,
            controlPoint,
            currentPoint
          };
        }
        pathQ(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            controlPoint,
            currentPoint
          } = PathElement.pathQ(pathParser);
          pathParser.addMarker(currentPoint, controlPoint, controlPoint);
          boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          if (ctx) {
            ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          }
        }
        static pathT(pathParser) {
          var {
            current
          } = pathParser;
          var controlPoint = pathParser.getReflectedControlPoint();
          pathParser.control = controlPoint;
          var currentPoint = pathParser.getAsCurrentPoint();
          return {
            current,
            controlPoint,
            currentPoint
          };
        }
        pathT(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            current,
            controlPoint,
            currentPoint
          } = PathElement.pathT(pathParser);
          pathParser.addMarker(currentPoint, controlPoint, controlPoint);
          boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          if (ctx) {
            ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          }
        }
        static pathA(pathParser) {
          var {
            current,
            command
          } = pathParser;
          var {
            rX,
            rY,
            xRot,
            lArcFlag,
            sweepFlag
          } = command;
          var xAxisRotation = xRot * (Math.PI / 180);
          var currentPoint = pathParser.getAsCurrentPoint();
          var currp = new Point(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2);
          var l3 = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);
          if (l3 > 1) {
            rX *= Math.sqrt(l3);
            rY *= Math.sqrt(l3);
          }
          var s3 = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));
          if (isNaN(s3)) {
            s3 = 0;
          }
          var cpp = new Point(s3 * rX * currp.y / rY, s3 * -rY * currp.x / rX);
          var centp = new Point((current.x + currentPoint.x) / 2 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y);
          var a1 = vectorsAngle([1, 0], [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY]);
          var u3 = [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY];
          var v3 = [(-currp.x - cpp.x) / rX, (-currp.y - cpp.y) / rY];
          var ad = vectorsAngle(u3, v3);
          if (vectorsRatio(u3, v3) <= -1) {
            ad = Math.PI;
          }
          if (vectorsRatio(u3, v3) >= 1) {
            ad = 0;
          }
          return {
            currentPoint,
            rX,
            rY,
            sweepFlag,
            xAxisRotation,
            centp,
            a1,
            ad
          };
        }
        pathA(ctx, boundingBox) {
          var {
            pathParser
          } = this;
          var {
            currentPoint,
            rX,
            rY,
            sweepFlag,
            xAxisRotation,
            centp,
            a1,
            ad
          } = PathElement.pathA(pathParser);
          var dir = 1 - sweepFlag ? 1 : -1;
          var ah = a1 + dir * (ad / 2);
          var halfWay = new Point(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
          pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
          pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
          boundingBox.addPoint(currentPoint.x, currentPoint.y);
          if (ctx && !isNaN(a1) && !isNaN(ad)) {
            var r2 = rX > rY ? rX : rY;
            var sx = rX > rY ? 1 : rX / rY;
            var sy = rX > rY ? rY / rX : 1;
            ctx.translate(centp.x, centp.y);
            ctx.rotate(xAxisRotation);
            ctx.scale(sx, sy);
            ctx.arc(0, 0, r2, a1, a1 + ad, Boolean(1 - sweepFlag));
            ctx.scale(1 / sx, 1 / sy);
            ctx.rotate(-xAxisRotation);
            ctx.translate(-centp.x, -centp.y);
          }
        }
        static pathZ(pathParser) {
          pathParser.current = pathParser.start;
        }
        pathZ(ctx, boundingBox) {
          PathElement.pathZ(this.pathParser);
          if (ctx) {
            if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) {
              ctx.closePath();
            }
          }
        }
      };
      GlyphElement = class extends PathElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "glyph";
          this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
          this.unicode = this.getAttribute("unicode").getString();
          this.arabicForm = this.getAttribute("arabic-form").getString();
        }
      };
      TextElement = class extends RenderedElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, new.target === TextElement ? true : captureTextNodes);
          this.type = "text";
          this.x = 0;
          this.y = 0;
          this.measureCache = -1;
        }
        setContext(ctx) {
          var fromMeasure = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          super.setContext(ctx, fromMeasure);
          var textBaseline = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
          if (textBaseline) {
            ctx.textBaseline = textBaseline;
          }
        }
        initializeCoordinates(ctx) {
          this.x = this.getAttribute("x").getPixels("x");
          this.y = this.getAttribute("y").getPixels("y");
          var dxAttr = this.getAttribute("dx");
          var dyAttr = this.getAttribute("dy");
          if (dxAttr.hasValue()) {
            this.x += dxAttr.getPixels("x");
          }
          if (dyAttr.hasValue()) {
            this.y += dyAttr.getPixels("y");
          }
          this.x += this.getAnchorDelta(ctx, this, 0);
        }
        getBoundingBox(ctx) {
          if (this.type !== "text") {
            return this.getTElementBoundingBox(ctx);
          }
          this.initializeCoordinates(ctx);
          var boundingBox = null;
          this.children.forEach((_3, i3) => {
            var childBoundingBox = this.getChildBoundingBox(ctx, this, this, i3);
            if (!boundingBox) {
              boundingBox = childBoundingBox;
            } else {
              boundingBox.addBoundingBox(childBoundingBox);
            }
          });
          return boundingBox;
        }
        getFontSize() {
          var {
            document: document3,
            parent: parent2
          } = this;
          var inheritFontSize = Font.parse(document3.ctx.font).fontSize;
          var fontSize = parent2.getStyle("font-size").getNumber(inheritFontSize);
          return fontSize;
        }
        getTElementBoundingBox(ctx) {
          var fontSize = this.getFontSize();
          return new BoundingBox(this.x, this.y - fontSize, this.x + this.measureText(ctx), this.y);
        }
        getGlyph(font, text2, i3) {
          var char = text2[i3];
          var glyph = null;
          if (font.isArabic) {
            var len = text2.length;
            var prevChar = text2[i3 - 1];
            var nextChar = text2[i3 + 1];
            var arabicForm = "isolated";
            if ((i3 === 0 || prevChar === " ") && i3 < len - 2 && nextChar !== " ") {
              arabicForm = "terminal";
            }
            if (i3 > 0 && prevChar !== " " && i3 < len - 2 && nextChar !== " ") {
              arabicForm = "medial";
            }
            if (i3 > 0 && prevChar !== " " && (i3 === len - 1 || nextChar === " ")) {
              arabicForm = "initial";
            }
            if (typeof font.glyphs[char] !== "undefined") {
              var maybeGlyph = font.glyphs[char];
              glyph = maybeGlyph instanceof GlyphElement ? maybeGlyph : maybeGlyph[arabicForm];
            }
          } else {
            glyph = font.glyphs[char];
          }
          if (!glyph) {
            glyph = font.missingGlyph;
          }
          return glyph;
        }
        getText() {
          return "";
        }
        getTextFromNode(node2) {
          var textNode = node2 || this.node;
          var childNodes = Array.from(textNode.parentNode.childNodes);
          var index3 = childNodes.indexOf(textNode);
          var lastIndex = childNodes.length - 1;
          var text2 = compressSpaces(textNode.textContent || "");
          if (index3 === 0) {
            text2 = trimLeft(text2);
          }
          if (index3 === lastIndex) {
            text2 = trimRight(text2);
          }
          return text2;
        }
        renderChildren(ctx) {
          if (this.type !== "text") {
            this.renderTElementChildren(ctx);
            return;
          }
          this.initializeCoordinates(ctx);
          this.children.forEach((_3, i3) => {
            this.renderChild(ctx, this, this, i3);
          });
          var {
            mouse
          } = this.document.screen;
          if (mouse.isWorking()) {
            mouse.checkBoundingBox(this, this.getBoundingBox(ctx));
          }
        }
        renderTElementChildren(ctx) {
          var {
            document: document3,
            parent: parent2
          } = this;
          var renderText = this.getText();
          var customFont = parent2.getStyle("font-family").getDefinition();
          if (customFont) {
            var {
              unitsPerEm
            } = customFont.fontFace;
            var ctxFont = Font.parse(document3.ctx.font);
            var fontSize = parent2.getStyle("font-size").getNumber(ctxFont.fontSize);
            var fontStyle = parent2.getStyle("font-style").getString(ctxFont.fontStyle);
            var scale = fontSize / unitsPerEm;
            var text2 = customFont.isRTL ? renderText.split("").reverse().join("") : renderText;
            var dx = toNumbers(parent2.getAttribute("dx").getString());
            var len = text2.length;
            for (var i3 = 0; i3 < len; i3++) {
              var glyph = this.getGlyph(customFont, text2, i3);
              ctx.translate(this.x, this.y);
              ctx.scale(scale, -scale);
              var lw = ctx.lineWidth;
              ctx.lineWidth = ctx.lineWidth * unitsPerEm / fontSize;
              if (fontStyle === "italic") {
                ctx.transform(1, 0, 0.4, 1, 0, 0);
              }
              glyph.render(ctx);
              if (fontStyle === "italic") {
                ctx.transform(1, 0, -0.4, 1, 0, 0);
              }
              ctx.lineWidth = lw;
              ctx.scale(1 / scale, -1 / scale);
              ctx.translate(-this.x, -this.y);
              this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;
              if (typeof dx[i3] !== "undefined" && !isNaN(dx[i3])) {
                this.x += dx[i3];
              }
            }
            return;
          }
          var {
            x: x2,
            y: y3
          } = this;
          if (ctx.fillStyle) {
            ctx.fillText(renderText, x2, y3);
          }
          if (ctx.strokeStyle) {
            ctx.strokeText(renderText, x2, y3);
          }
        }
        getAnchorDelta(ctx, parent2, startI) {
          var textAnchor = this.getStyle("text-anchor").getString("start");
          if (textAnchor !== "start") {
            var {
              children: children2
            } = parent2;
            var len = children2.length;
            var child = null;
            var width = 0;
            for (var i3 = startI; i3 < len; i3++) {
              child = children2[i3];
              if (i3 > startI && child.getAttribute("x").hasValue() || child.getAttribute("text-anchor").hasValue()) {
                break;
              }
              width += child.measureTextRecursive(ctx);
            }
            return -1 * (textAnchor === "end" ? width : width / 2);
          }
          return 0;
        }
        adjustChildCoordinates(ctx, textParent, parent2, i3) {
          var child = parent2.children[i3];
          if (typeof child.measureText !== "function") {
            return child;
          }
          ctx.save();
          child.setContext(ctx, true);
          var xAttr = child.getAttribute("x");
          var yAttr = child.getAttribute("y");
          var dxAttr = child.getAttribute("dx");
          var dyAttr = child.getAttribute("dy");
          var textAnchor = child.getAttribute("text-anchor").getString("start");
          if (i3 === 0 && child.type !== "textNode") {
            if (!xAttr.hasValue()) {
              xAttr.setValue(textParent.getAttribute("x").getValue("0"));
            }
            if (!yAttr.hasValue()) {
              yAttr.setValue(textParent.getAttribute("y").getValue("0"));
            }
            if (!dxAttr.hasValue()) {
              dxAttr.setValue(textParent.getAttribute("dx").getValue("0"));
            }
            if (!dyAttr.hasValue()) {
              dyAttr.setValue(textParent.getAttribute("dy").getValue("0"));
            }
          }
          if (xAttr.hasValue()) {
            child.x = xAttr.getPixels("x") + textParent.getAnchorDelta(ctx, parent2, i3);
            if (textAnchor !== "start") {
              var width = child.measureTextRecursive(ctx);
              child.x += -1 * (textAnchor === "end" ? width : width / 2);
            }
            if (dxAttr.hasValue()) {
              child.x += dxAttr.getPixels("x");
            }
          } else {
            if (textAnchor !== "start") {
              var _width = child.measureTextRecursive(ctx);
              textParent.x += -1 * (textAnchor === "end" ? _width : _width / 2);
            }
            if (dxAttr.hasValue()) {
              textParent.x += dxAttr.getPixels("x");
            }
            child.x = textParent.x;
          }
          textParent.x = child.x + child.measureText(ctx);
          if (yAttr.hasValue()) {
            child.y = yAttr.getPixels("y");
            if (dyAttr.hasValue()) {
              child.y += dyAttr.getPixels("y");
            }
          } else {
            if (dyAttr.hasValue()) {
              textParent.y += dyAttr.getPixels("y");
            }
            child.y = textParent.y;
          }
          textParent.y = child.y;
          child.clearContext(ctx);
          ctx.restore();
          return child;
        }
        getChildBoundingBox(ctx, textParent, parent2, i3) {
          var child = this.adjustChildCoordinates(ctx, textParent, parent2, i3);
          if (typeof child.getBoundingBox !== "function") {
            return null;
          }
          var boundingBox = child.getBoundingBox(ctx);
          if (!boundingBox) {
            return null;
          }
          child.children.forEach((_3, i4) => {
            var childBoundingBox = textParent.getChildBoundingBox(ctx, textParent, child, i4);
            boundingBox.addBoundingBox(childBoundingBox);
          });
          return boundingBox;
        }
        renderChild(ctx, textParent, parent2, i3) {
          var child = this.adjustChildCoordinates(ctx, textParent, parent2, i3);
          child.render(ctx);
          child.children.forEach((_3, i4) => {
            textParent.renderChild(ctx, textParent, child, i4);
          });
        }
        measureTextRecursive(ctx) {
          var width = this.children.reduce((width2, child) => width2 + child.measureTextRecursive(ctx), this.measureText(ctx));
          return width;
        }
        measureText(ctx) {
          var {
            measureCache
          } = this;
          if (~measureCache) {
            return measureCache;
          }
          var renderText = this.getText();
          var measure = this.measureTargetText(ctx, renderText);
          this.measureCache = measure;
          return measure;
        }
        measureTargetText(ctx, targetText) {
          if (!targetText.length) {
            return 0;
          }
          var {
            parent: parent2
          } = this;
          var customFont = parent2.getStyle("font-family").getDefinition();
          if (customFont) {
            var fontSize = this.getFontSize();
            var text2 = customFont.isRTL ? targetText.split("").reverse().join("") : targetText;
            var dx = toNumbers(parent2.getAttribute("dx").getString());
            var len = text2.length;
            var _measure = 0;
            for (var i3 = 0; i3 < len; i3++) {
              var glyph = this.getGlyph(customFont, text2, i3);
              _measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
              if (typeof dx[i3] !== "undefined" && !isNaN(dx[i3])) {
                _measure += dx[i3];
              }
            }
            return _measure;
          }
          if (!ctx.measureText) {
            return targetText.length * 10;
          }
          ctx.save();
          this.setContext(ctx, true);
          var {
            width: measure
          } = ctx.measureText(targetText);
          this.clearContext(ctx);
          ctx.restore();
          return measure;
        }
      };
      TSpanElement = class extends TextElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, new.target === TSpanElement ? true : captureTextNodes);
          this.type = "tspan";
          this.text = this.children.length > 0 ? "" : this.getTextFromNode();
        }
        getText() {
          return this.text;
        }
      };
      TextNode = class extends TSpanElement {
        constructor() {
          super(...arguments);
          this.type = "textNode";
        }
      };
      SVGElement2 = class extends RenderedElement {
        constructor() {
          super(...arguments);
          this.type = "svg";
          this.root = false;
        }
        setContext(ctx) {
          var _this$node$parentNode;
          var {
            document: document3
          } = this;
          var {
            screen,
            window: window2
          } = document3;
          var canvas = ctx.canvas;
          screen.setDefaults(ctx);
          if (canvas.style && typeof ctx.font !== "undefined" && window2 && typeof window2.getComputedStyle !== "undefined") {
            ctx.font = window2.getComputedStyle(canvas).getPropertyValue("font");
            var fontSizeProp = new Property(document3, "fontSize", Font.parse(ctx.font).fontSize);
            if (fontSizeProp.hasValue()) {
              document3.rootEmSize = fontSizeProp.getPixels("y");
              document3.emSize = document3.rootEmSize;
            }
          }
          if (!this.getAttribute("x").hasValue()) {
            this.getAttribute("x", true).setValue(0);
          }
          if (!this.getAttribute("y").hasValue()) {
            this.getAttribute("y", true).setValue(0);
          }
          var {
            width,
            height
          } = screen.viewPort;
          if (!this.getStyle("width").hasValue()) {
            this.getStyle("width", true).setValue("100%");
          }
          if (!this.getStyle("height").hasValue()) {
            this.getStyle("height", true).setValue("100%");
          }
          if (!this.getStyle("color").hasValue()) {
            this.getStyle("color", true).setValue("black");
          }
          var refXAttr = this.getAttribute("refX");
          var refYAttr = this.getAttribute("refY");
          var viewBoxAttr = this.getAttribute("viewBox");
          var viewBox = viewBoxAttr.hasValue() ? toNumbers(viewBoxAttr.getString()) : null;
          var clip = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible";
          var minX = 0;
          var minY = 0;
          var clipX = 0;
          var clipY = 0;
          if (viewBox) {
            minX = viewBox[0];
            minY = viewBox[1];
          }
          if (!this.root) {
            width = this.getStyle("width").getPixels("x");
            height = this.getStyle("height").getPixels("y");
            if (this.type === "marker") {
              clipX = minX;
              clipY = minY;
              minX = 0;
              minY = 0;
            }
          }
          screen.viewPort.setCurrent(width, height);
          if (this.node && (!this.parent || ((_this$node$parentNode = this.node.parentNode) === null || _this$node$parentNode === void 0 ? void 0 : _this$node$parentNode.nodeName) === "foreignObject") && this.getStyle("transform", false, true).hasValue() && !this.getStyle("transform-origin", false, true).hasValue()) {
            this.getStyle("transform-origin", true, true).setValue("50% 50%");
          }
          super.setContext(ctx);
          ctx.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y"));
          if (viewBox) {
            width = viewBox[2];
            height = viewBox[3];
          }
          document3.setViewBox({
            ctx,
            aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
            width: screen.viewPort.width,
            desiredWidth: width,
            height: screen.viewPort.height,
            desiredHeight: height,
            minX,
            minY,
            refX: refXAttr.getValue(),
            refY: refYAttr.getValue(),
            clip,
            clipX,
            clipY
          });
          if (viewBox) {
            screen.viewPort.removeCurrent();
            screen.viewPort.setCurrent(width, height);
          }
        }
        clearContext(ctx) {
          super.clearContext(ctx);
          this.document.screen.viewPort.removeCurrent();
        }
        resize(width) {
          var height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : width;
          var preserveAspectRatio = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          var widthAttr = this.getAttribute("width", true);
          var heightAttr = this.getAttribute("height", true);
          var viewBoxAttr = this.getAttribute("viewBox");
          var styleAttr = this.getAttribute("style");
          var originWidth = widthAttr.getNumber(0);
          var originHeight = heightAttr.getNumber(0);
          if (preserveAspectRatio) {
            if (typeof preserveAspectRatio === "string") {
              this.getAttribute("preserveAspectRatio", true).setValue(preserveAspectRatio);
            } else {
              var preserveAspectRatioAttr = this.getAttribute("preserveAspectRatio");
              if (preserveAspectRatioAttr.hasValue()) {
                preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
              }
            }
          }
          widthAttr.setValue(width);
          heightAttr.setValue(height);
          if (!viewBoxAttr.hasValue()) {
            viewBoxAttr.setValue("0 0 ".concat(originWidth || width, " ").concat(originHeight || height));
          }
          if (styleAttr.hasValue()) {
            var widthStyle = this.getStyle("width");
            var heightStyle = this.getStyle("height");
            if (widthStyle.hasValue()) {
              widthStyle.setValue("".concat(width, "px"));
            }
            if (heightStyle.hasValue()) {
              heightStyle.setValue("".concat(height, "px"));
            }
          }
        }
      };
      RectElement = class extends PathElement {
        constructor() {
          super(...arguments);
          this.type = "rect";
        }
        path(ctx) {
          var x2 = this.getAttribute("x").getPixels("x");
          var y3 = this.getAttribute("y").getPixels("y");
          var width = this.getStyle("width", false, true).getPixels("x");
          var height = this.getStyle("height", false, true).getPixels("y");
          var rxAttr = this.getAttribute("rx");
          var ryAttr = this.getAttribute("ry");
          var rx = rxAttr.getPixels("x");
          var ry = ryAttr.getPixels("y");
          if (rxAttr.hasValue() && !ryAttr.hasValue()) {
            ry = rx;
          }
          if (ryAttr.hasValue() && !rxAttr.hasValue()) {
            rx = ry;
          }
          rx = Math.min(rx, width / 2);
          ry = Math.min(ry, height / 2);
          if (ctx) {
            var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
            ctx.beginPath();
            if (height > 0 && width > 0) {
              ctx.moveTo(x2 + rx, y3);
              ctx.lineTo(x2 + width - rx, y3);
              ctx.bezierCurveTo(x2 + width - rx + KAPPA * rx, y3, x2 + width, y3 + ry - KAPPA * ry, x2 + width, y3 + ry);
              ctx.lineTo(x2 + width, y3 + height - ry);
              ctx.bezierCurveTo(x2 + width, y3 + height - ry + KAPPA * ry, x2 + width - rx + KAPPA * rx, y3 + height, x2 + width - rx, y3 + height);
              ctx.lineTo(x2 + rx, y3 + height);
              ctx.bezierCurveTo(x2 + rx - KAPPA * rx, y3 + height, x2, y3 + height - ry + KAPPA * ry, x2, y3 + height - ry);
              ctx.lineTo(x2, y3 + ry);
              ctx.bezierCurveTo(x2, y3 + ry - KAPPA * ry, x2 + rx - KAPPA * rx, y3, x2 + rx, y3);
              ctx.closePath();
            }
          }
          return new BoundingBox(x2, y3, x2 + width, y3 + height);
        }
        getMarkers() {
          return null;
        }
      };
      CircleElement = class extends PathElement {
        constructor() {
          super(...arguments);
          this.type = "circle";
        }
        path(ctx) {
          var cx = this.getAttribute("cx").getPixels("x");
          var cy = this.getAttribute("cy").getPixels("y");
          var r2 = this.getAttribute("r").getPixels();
          if (ctx && r2 > 0) {
            ctx.beginPath();
            ctx.arc(cx, cy, r2, 0, Math.PI * 2, false);
            ctx.closePath();
          }
          return new BoundingBox(cx - r2, cy - r2, cx + r2, cy + r2);
        }
        getMarkers() {
          return null;
        }
      };
      EllipseElement = class extends PathElement {
        constructor() {
          super(...arguments);
          this.type = "ellipse";
        }
        path(ctx) {
          var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
          var rx = this.getAttribute("rx").getPixels("x");
          var ry = this.getAttribute("ry").getPixels("y");
          var cx = this.getAttribute("cx").getPixels("x");
          var cy = this.getAttribute("cy").getPixels("y");
          if (ctx && rx > 0 && ry > 0) {
            ctx.beginPath();
            ctx.moveTo(cx + rx, cy);
            ctx.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
            ctx.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
            ctx.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
            ctx.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
            ctx.closePath();
          }
          return new BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
        }
        getMarkers() {
          return null;
        }
      };
      LineElement = class extends PathElement {
        constructor() {
          super(...arguments);
          this.type = "line";
        }
        getPoints() {
          return [new Point(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new Point(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
        }
        path(ctx) {
          var [{
            x: x0,
            y: y0
          }, {
            x: x1,
            y: y1
          }] = this.getPoints();
          if (ctx) {
            ctx.beginPath();
            ctx.moveTo(x0, y0);
            ctx.lineTo(x1, y1);
          }
          return new BoundingBox(x0, y0, x1, y1);
        }
        getMarkers() {
          var [p0, p1] = this.getPoints();
          var a3 = p0.angleTo(p1);
          return [[p0, a3], [p1, a3]];
        }
      };
      PolylineElement = class extends PathElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "polyline";
          this.points = [];
          this.points = Point.parsePath(this.getAttribute("points").getString());
        }
        path(ctx) {
          var {
            points
          } = this;
          var [{
            x: x0,
            y: y0
          }] = points;
          var boundingBox = new BoundingBox(x0, y0);
          if (ctx) {
            ctx.beginPath();
            ctx.moveTo(x0, y0);
          }
          points.forEach((_ref) => {
            var {
              x: x2,
              y: y3
            } = _ref;
            boundingBox.addPoint(x2, y3);
            if (ctx) {
              ctx.lineTo(x2, y3);
            }
          });
          return boundingBox;
        }
        getMarkers() {
          var {
            points
          } = this;
          var lastIndex = points.length - 1;
          var markers = [];
          points.forEach((point, i3) => {
            if (i3 === lastIndex) {
              return;
            }
            markers.push([point, point.angleTo(points[i3 + 1])]);
          });
          if (markers.length > 0) {
            markers.push([points[points.length - 1], markers[markers.length - 1][1]]);
          }
          return markers;
        }
      };
      PolygonElement = class extends PolylineElement {
        constructor() {
          super(...arguments);
          this.type = "polygon";
        }
        path(ctx) {
          var boundingBox = super.path(ctx);
          var [{
            x: x2,
            y: y3
          }] = this.points;
          if (ctx) {
            ctx.lineTo(x2, y3);
            ctx.closePath();
          }
          return boundingBox;
        }
      };
      PatternElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "pattern";
        }
        createPattern(ctx, _3, parentOpacityProp) {
          var width = this.getStyle("width").getPixels("x", true);
          var height = this.getStyle("height").getPixels("y", true);
          var patternSvg = new SVGElement2(this.document, null);
          patternSvg.attributes.viewBox = new Property(this.document, "viewBox", this.getAttribute("viewBox").getValue());
          patternSvg.attributes.width = new Property(this.document, "width", "".concat(width, "px"));
          patternSvg.attributes.height = new Property(this.document, "height", "".concat(height, "px"));
          patternSvg.attributes.transform = new Property(this.document, "transform", this.getAttribute("patternTransform").getValue());
          patternSvg.children = this.children;
          var patternCanvas = this.document.createCanvas(width, height);
          var patternCtx = patternCanvas.getContext("2d");
          var xAttr = this.getAttribute("x");
          var yAttr = this.getAttribute("y");
          if (xAttr.hasValue() && yAttr.hasValue()) {
            patternCtx.translate(xAttr.getPixels("x", true), yAttr.getPixels("y", true));
          }
          if (parentOpacityProp.hasValue()) {
            this.styles["fill-opacity"] = parentOpacityProp;
          } else {
            Reflect.deleteProperty(this.styles, "fill-opacity");
          }
          for (var x2 = -1; x2 <= 1; x2++) {
            for (var y3 = -1; y3 <= 1; y3++) {
              patternCtx.save();
              patternSvg.attributes.x = new Property(this.document, "x", x2 * patternCanvas.width);
              patternSvg.attributes.y = new Property(this.document, "y", y3 * patternCanvas.height);
              patternSvg.render(patternCtx);
              patternCtx.restore();
            }
          }
          var pattern = ctx.createPattern(patternCanvas, "repeat");
          return pattern;
        }
      };
      MarkerElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "marker";
        }
        render(ctx, point, angle) {
          if (!point) {
            return;
          }
          var {
            x: x2,
            y: y3
          } = point;
          var orient = this.getAttribute("orient").getString("auto");
          var markerUnits = this.getAttribute("markerUnits").getString("strokeWidth");
          ctx.translate(x2, y3);
          if (orient === "auto") {
            ctx.rotate(angle);
          }
          if (markerUnits === "strokeWidth") {
            ctx.scale(ctx.lineWidth, ctx.lineWidth);
          }
          ctx.save();
          var markerSvg = new SVGElement2(this.document, null);
          markerSvg.type = this.type;
          markerSvg.attributes.viewBox = new Property(this.document, "viewBox", this.getAttribute("viewBox").getValue());
          markerSvg.attributes.refX = new Property(this.document, "refX", this.getAttribute("refX").getValue());
          markerSvg.attributes.refY = new Property(this.document, "refY", this.getAttribute("refY").getValue());
          markerSvg.attributes.width = new Property(this.document, "width", this.getAttribute("markerWidth").getValue());
          markerSvg.attributes.height = new Property(this.document, "height", this.getAttribute("markerHeight").getValue());
          markerSvg.attributes.overflow = new Property(this.document, "overflow", this.getAttribute("overflow").getValue());
          markerSvg.attributes.fill = new Property(this.document, "fill", this.getAttribute("fill").getColor("black"));
          markerSvg.attributes.stroke = new Property(this.document, "stroke", this.getAttribute("stroke").getValue("none"));
          markerSvg.children = this.children;
          markerSvg.render(ctx);
          ctx.restore();
          if (markerUnits === "strokeWidth") {
            ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
          }
          if (orient === "auto") {
            ctx.rotate(-angle);
          }
          ctx.translate(-x2, -y3);
        }
      };
      DefsElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "defs";
        }
        render() {
        }
      };
      GElement = class extends RenderedElement {
        constructor() {
          super(...arguments);
          this.type = "g";
        }
        getBoundingBox(ctx) {
          var boundingBox = new BoundingBox();
          this.children.forEach((child) => {
            boundingBox.addBoundingBox(child.getBoundingBox(ctx));
          });
          return boundingBox;
        }
      };
      GradientElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.attributesToInherit = ["gradientUnits"];
          this.stops = [];
          var {
            stops,
            children: children2
          } = this;
          children2.forEach((child) => {
            if (child.type === "stop") {
              stops.push(child);
            }
          });
        }
        getGradientUnits() {
          return this.getAttribute("gradientUnits").getString("objectBoundingBox");
        }
        createGradient(ctx, element, parentOpacityProp) {
          var stopsContainer = this;
          if (this.getHrefAttribute().hasValue()) {
            stopsContainer = this.getHrefAttribute().getDefinition();
            this.inheritStopContainer(stopsContainer);
          }
          var {
            stops
          } = stopsContainer;
          var gradient = this.getGradient(ctx, element);
          if (!gradient) {
            return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
          }
          stops.forEach((stop3) => {
            gradient.addColorStop(stop3.offset, this.addParentOpacity(parentOpacityProp, stop3.color));
          });
          if (this.getAttribute("gradientTransform").hasValue()) {
            var {
              document: document3
            } = this;
            var {
              MAX_VIRTUAL_PIXELS,
              viewPort
            } = document3.screen;
            var [rootView] = viewPort.viewPorts;
            var rect = new RectElement(document3, null);
            rect.attributes.x = new Property(document3, "x", -MAX_VIRTUAL_PIXELS / 3);
            rect.attributes.y = new Property(document3, "y", -MAX_VIRTUAL_PIXELS / 3);
            rect.attributes.width = new Property(document3, "width", MAX_VIRTUAL_PIXELS);
            rect.attributes.height = new Property(document3, "height", MAX_VIRTUAL_PIXELS);
            var group = new GElement(document3, null);
            group.attributes.transform = new Property(document3, "transform", this.getAttribute("gradientTransform").getValue());
            group.children = [rect];
            var patternSvg = new SVGElement2(document3, null);
            patternSvg.attributes.x = new Property(document3, "x", 0);
            patternSvg.attributes.y = new Property(document3, "y", 0);
            patternSvg.attributes.width = new Property(document3, "width", rootView.width);
            patternSvg.attributes.height = new Property(document3, "height", rootView.height);
            patternSvg.children = [group];
            var patternCanvas = document3.createCanvas(rootView.width, rootView.height);
            var patternCtx = patternCanvas.getContext("2d");
            patternCtx.fillStyle = gradient;
            patternSvg.render(patternCtx);
            return patternCtx.createPattern(patternCanvas, "no-repeat");
          }
          return gradient;
        }
        inheritStopContainer(stopsContainer) {
          this.attributesToInherit.forEach((attributeToInherit) => {
            if (!this.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) {
              this.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
            }
          });
        }
        addParentOpacity(parentOpacityProp, color) {
          if (parentOpacityProp.hasValue()) {
            var colorProp = new Property(this.document, "color", color);
            return colorProp.addOpacity(parentOpacityProp).getColor();
          }
          return color;
        }
      };
      LinearGradientElement = class extends GradientElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "linearGradient";
          this.attributesToInherit.push("x1", "y1", "x2", "y2");
        }
        getGradient(ctx, element) {
          var isBoundingBoxUnits = this.getGradientUnits() === "objectBoundingBox";
          var boundingBox = isBoundingBoxUnits ? element.getBoundingBox(ctx) : null;
          if (isBoundingBoxUnits && !boundingBox) {
            return null;
          }
          if (!this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue()) {
            this.getAttribute("x1", true).setValue(0);
            this.getAttribute("y1", true).setValue(0);
            this.getAttribute("x2", true).setValue(1);
            this.getAttribute("y2", true).setValue(0);
          }
          var x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x");
          var y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y");
          var x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x");
          var y22 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
          if (x1 === x2 && y1 === y22) {
            return null;
          }
          return ctx.createLinearGradient(x1, y1, x2, y22);
        }
      };
      RadialGradientElement = class extends GradientElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "radialGradient";
          this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
        }
        getGradient(ctx, element) {
          var isBoundingBoxUnits = this.getGradientUnits() === "objectBoundingBox";
          var boundingBox = element.getBoundingBox(ctx);
          if (isBoundingBoxUnits && !boundingBox) {
            return null;
          }
          if (!this.getAttribute("cx").hasValue()) {
            this.getAttribute("cx", true).setValue("50%");
          }
          if (!this.getAttribute("cy").hasValue()) {
            this.getAttribute("cy", true).setValue("50%");
          }
          if (!this.getAttribute("r").hasValue()) {
            this.getAttribute("r", true).setValue("50%");
          }
          var cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x");
          var cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y");
          var fx = cx;
          var fy = cy;
          if (this.getAttribute("fx").hasValue()) {
            fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x");
          }
          if (this.getAttribute("fy").hasValue()) {
            fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y");
          }
          var r2 = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels();
          var fr = this.getAttribute("fr").getPixels();
          return ctx.createRadialGradient(fx, fy, fr, cx, cy, r2);
        }
      };
      StopElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "stop";
          var offset2 = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber()));
          var stopOpacity = this.getStyle("stop-opacity");
          var stopColor = this.getStyle("stop-color", true);
          if (stopColor.getString() === "") {
            stopColor.setValue("#000");
          }
          if (stopOpacity.hasValue()) {
            stopColor = stopColor.addOpacity(stopOpacity);
          }
          this.offset = offset2;
          this.color = stopColor.getColor();
        }
      };
      AnimateElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "animate";
          this.duration = 0;
          this.initialValue = null;
          this.initialUnits = "";
          this.removed = false;
          this.frozen = false;
          document3.screen.animations.push(this);
          this.begin = this.getAttribute("begin").getMilliseconds();
          this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds();
          this.from = this.getAttribute("from");
          this.to = this.getAttribute("to");
          this.values = new Property(document3, "values", null);
          var valuesAttr = this.getAttribute("values");
          if (valuesAttr.hasValue()) {
            this.values.setValue(valuesAttr.getString().split(";"));
          }
        }
        getProperty() {
          var attributeType = this.getAttribute("attributeType").getString();
          var attributeName = this.getAttribute("attributeName").getString();
          if (attributeType === "CSS") {
            return this.parent.getStyle(attributeName, true);
          }
          return this.parent.getAttribute(attributeName, true);
        }
        calcValue() {
          var {
            initialUnits
          } = this;
          var {
            progress,
            from,
            to
          } = this.getProgress();
          var newValue = from.getNumber() + (to.getNumber() - from.getNumber()) * progress;
          if (initialUnits === "%") {
            newValue *= 100;
          }
          return "".concat(newValue).concat(initialUnits);
        }
        update(delta) {
          var {
            parent: parent2
          } = this;
          var prop = this.getProperty();
          if (!this.initialValue) {
            this.initialValue = prop.getString();
            this.initialUnits = prop.getUnits();
          }
          if (this.duration > this.maxDuration) {
            var fill = this.getAttribute("fill").getString("remove");
            if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite") {
              this.duration = 0;
            } else if (fill === "freeze" && !this.frozen) {
              this.frozen = true;
              parent2.animationFrozen = true;
              parent2.animationFrozenValue = prop.getString();
            } else if (fill === "remove" && !this.removed) {
              this.removed = true;
              prop.setValue(parent2.animationFrozen ? parent2.animationFrozenValue : this.initialValue);
              return true;
            }
            return false;
          }
          this.duration += delta;
          var updated = false;
          if (this.begin < this.duration) {
            var newValue = this.calcValue();
            var typeAttr = this.getAttribute("type");
            if (typeAttr.hasValue()) {
              var type = typeAttr.getString();
              newValue = "".concat(type, "(").concat(newValue, ")");
            }
            prop.setValue(newValue);
            updated = true;
          }
          return updated;
        }
        getProgress() {
          var {
            document: document3,
            values
          } = this;
          var result = {
            progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
          };
          if (values.hasValue()) {
            var p4 = result.progress * (values.getValue().length - 1);
            var lb = Math.floor(p4);
            var ub = Math.ceil(p4);
            result.from = new Property(document3, "from", parseFloat(values.getValue()[lb]));
            result.to = new Property(document3, "to", parseFloat(values.getValue()[ub]));
            result.progress = (p4 - lb) / (ub - lb);
          } else {
            result.from = this.from;
            result.to = this.to;
          }
          return result;
        }
      };
      AnimateColorElement = class extends AnimateElement {
        constructor() {
          super(...arguments);
          this.type = "animateColor";
        }
        calcValue() {
          var {
            progress,
            from,
            to
          } = this.getProgress();
          var colorFrom = new import_rgbcolor.default(from.getColor());
          var colorTo = new import_rgbcolor.default(to.getColor());
          if (colorFrom.ok && colorTo.ok) {
            var r2 = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
            var g2 = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
            var b2 = colorFrom.b + (colorTo.b - colorFrom.b) * progress;
            return "rgb(".concat(Math.floor(r2), ", ").concat(Math.floor(g2), ", ").concat(Math.floor(b2), ")");
          }
          return this.getAttribute("from").getColor();
        }
      };
      AnimateTransformElement = class extends AnimateElement {
        constructor() {
          super(...arguments);
          this.type = "animateTransform";
        }
        calcValue() {
          var {
            progress,
            from,
            to
          } = this.getProgress();
          var transformFrom = toNumbers(from.getString());
          var transformTo = toNumbers(to.getString());
          var newValue = transformFrom.map((from2, i3) => {
            var to2 = transformTo[i3];
            return from2 + (to2 - from2) * progress;
          }).join(" ");
          return newValue;
        }
      };
      FontElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "font";
          this.glyphs = {};
          this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
          var {
            definitions
          } = document3;
          var {
            children: children2
          } = this;
          for (var child of children2) {
            switch (child.type) {
              case "font-face": {
                this.fontFace = child;
                var fontFamilyStyle = child.getStyle("font-family");
                if (fontFamilyStyle.hasValue()) {
                  definitions[fontFamilyStyle.getString()] = this;
                }
                break;
              }
              case "missing-glyph":
                this.missingGlyph = child;
                break;
              case "glyph": {
                var glyph = child;
                if (glyph.arabicForm) {
                  this.isRTL = true;
                  this.isArabic = true;
                  if (typeof this.glyphs[glyph.unicode] === "undefined") {
                    this.glyphs[glyph.unicode] = {};
                  }
                  this.glyphs[glyph.unicode][glyph.arabicForm] = glyph;
                } else {
                  this.glyphs[glyph.unicode] = glyph;
                }
                break;
              }
            }
          }
        }
        render() {
        }
      };
      FontFaceElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "font-face";
          this.ascent = this.getAttribute("ascent").getNumber();
          this.descent = this.getAttribute("descent").getNumber();
          this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
        }
      };
      MissingGlyphElement = class extends PathElement {
        constructor() {
          super(...arguments);
          this.type = "missing-glyph";
          this.horizAdvX = 0;
        }
      };
      TRefElement = class extends TextElement {
        constructor() {
          super(...arguments);
          this.type = "tref";
        }
        getText() {
          var element = this.getHrefAttribute().getDefinition();
          if (element) {
            var firstChild = element.children[0];
            if (firstChild) {
              return firstChild.getText();
            }
          }
          return "";
        }
      };
      AElement = class extends TextElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "a";
          var {
            childNodes
          } = node2;
          var firstChild = childNodes[0];
          var hasText = childNodes.length > 0 && Array.from(childNodes).every((node3) => node3.nodeType === 3);
          this.hasText = hasText;
          this.text = hasText ? this.getTextFromNode(firstChild) : "";
        }
        getText() {
          return this.text;
        }
        renderChildren(ctx) {
          if (this.hasText) {
            super.renderChildren(ctx);
            var {
              document: document3,
              x: x2,
              y: y3
            } = this;
            var {
              mouse
            } = document3.screen;
            var fontSize = new Property(document3, "fontSize", Font.parse(document3.ctx.font).fontSize);
            if (mouse.isWorking()) {
              mouse.checkBoundingBox(this, new BoundingBox(x2, y3 - fontSize.getPixels("y"), x2 + this.measureText(ctx), y3));
            }
          } else if (this.children.length > 0) {
            var g2 = new GElement(this.document, null);
            g2.children = this.children;
            g2.parent = this;
            g2.render(ctx);
          }
        }
        onClick() {
          var {
            window: window2
          } = this.document;
          if (window2) {
            window2.open(this.getHrefAttribute().getString());
          }
        }
        onMouseMove() {
          var ctx = this.document.ctx;
          ctx.canvas.style.cursor = "pointer";
        }
      };
      TextPathElement = class extends TextElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "textPath";
          this.textWidth = 0;
          this.textHeight = 0;
          this.pathLength = -1;
          this.glyphInfo = null;
          this.letterSpacingCache = [];
          this.measuresCache = new Map([["", 0]]);
          var pathElement = this.getHrefAttribute().getDefinition();
          this.text = this.getTextFromNode();
          this.dataArray = this.parsePathData(pathElement);
        }
        getText() {
          return this.text;
        }
        path(ctx) {
          var {
            dataArray
          } = this;
          if (ctx) {
            ctx.beginPath();
          }
          dataArray.forEach((_ref) => {
            var {
              type,
              points
            } = _ref;
            switch (type) {
              case PathParser.LINE_TO:
                if (ctx) {
                  ctx.lineTo(points[0], points[1]);
                }
                break;
              case PathParser.MOVE_TO:
                if (ctx) {
                  ctx.moveTo(points[0], points[1]);
                }
                break;
              case PathParser.CURVE_TO:
                if (ctx) {
                  ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
                }
                break;
              case PathParser.QUAD_TO:
                if (ctx) {
                  ctx.quadraticCurveTo(points[0], points[1], points[2], points[3]);
                }
                break;
              case PathParser.ARC: {
                var [cx, cy, rx, ry, theta, dTheta, psi, fs] = points;
                var r2 = rx > ry ? rx : ry;
                var scaleX = rx > ry ? 1 : rx / ry;
                var scaleY = rx > ry ? ry / rx : 1;
                if (ctx) {
                  ctx.translate(cx, cy);
                  ctx.rotate(psi);
                  ctx.scale(scaleX, scaleY);
                  ctx.arc(0, 0, r2, theta, theta + dTheta, Boolean(1 - fs));
                  ctx.scale(1 / scaleX, 1 / scaleY);
                  ctx.rotate(-psi);
                  ctx.translate(-cx, -cy);
                }
                break;
              }
              case PathParser.CLOSE_PATH:
                if (ctx) {
                  ctx.closePath();
                }
                break;
            }
          });
        }
        renderChildren(ctx) {
          this.setTextData(ctx);
          ctx.save();
          var textDecoration = this.parent.getStyle("text-decoration").getString();
          var fontSize = this.getFontSize();
          var {
            glyphInfo
          } = this;
          var fill = ctx.fillStyle;
          if (textDecoration === "underline") {
            ctx.beginPath();
          }
          glyphInfo.forEach((glyph, i3) => {
            var {
              p0,
              p1,
              rotation,
              text: partialText
            } = glyph;
            ctx.save();
            ctx.translate(p0.x, p0.y);
            ctx.rotate(rotation);
            if (ctx.fillStyle) {
              ctx.fillText(partialText, 0, 0);
            }
            if (ctx.strokeStyle) {
              ctx.strokeText(partialText, 0, 0);
            }
            ctx.restore();
            if (textDecoration === "underline") {
              if (i3 === 0) {
                ctx.moveTo(p0.x, p0.y + fontSize / 8);
              }
              ctx.lineTo(p1.x, p1.y + fontSize / 5);
            }
          });
          if (textDecoration === "underline") {
            ctx.lineWidth = fontSize / 20;
            ctx.strokeStyle = fill;
            ctx.stroke();
            ctx.closePath();
          }
          ctx.restore();
        }
        getLetterSpacingAt() {
          var idx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return this.letterSpacingCache[idx] || 0;
        }
        findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c4, charI) {
          var offset2 = inputOffset;
          var glyphWidth = this.measureText(ctx, c4);
          if (c4 === " " && anchor === "justify" && textFullWidth < fullPathWidth) {
            glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
          }
          if (charI > -1) {
            offset2 += this.getLetterSpacingAt(charI);
          }
          var splineStep = this.textHeight / 20;
          var p0 = this.getEquidistantPointOnPath(offset2, splineStep, 0);
          var p1 = this.getEquidistantPointOnPath(offset2 + glyphWidth, splineStep, 0);
          var segment = {
            p0,
            p1
          };
          var rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;
          if (dy) {
            var dyX = Math.cos(Math.PI / 2 + rotation) * dy;
            var dyY = Math.cos(-rotation) * dy;
            segment.p0 = _objectSpread$2(_objectSpread$2({}, p0), {}, {
              x: p0.x + dyX,
              y: p0.y + dyY
            });
            segment.p1 = _objectSpread$2(_objectSpread$2({}, p1), {}, {
              x: p1.x + dyX,
              y: p1.y + dyY
            });
          }
          offset2 += glyphWidth;
          return {
            offset: offset2,
            segment,
            rotation
          };
        }
        measureText(ctx, text2) {
          var {
            measuresCache
          } = this;
          var targetText = text2 || this.getText();
          if (measuresCache.has(targetText)) {
            return measuresCache.get(targetText);
          }
          var measure = this.measureTargetText(ctx, targetText);
          measuresCache.set(targetText, measure);
          return measure;
        }
        setTextData(ctx) {
          if (this.glyphInfo) {
            return;
          }
          var renderText = this.getText();
          var chars = renderText.split("");
          var spacesNumber = renderText.split(" ").length - 1;
          var dx = this.parent.getAttribute("dx").split().map((_3) => _3.getPixels("x"));
          var dy = this.parent.getAttribute("dy").getPixels("y");
          var anchor = this.parent.getStyle("text-anchor").getString("start");
          var thisSpacing = this.getStyle("letter-spacing");
          var parentSpacing = this.parent.getStyle("letter-spacing");
          var letterSpacing = 0;
          if (!thisSpacing.hasValue() || thisSpacing.getValue() === "inherit") {
            letterSpacing = parentSpacing.getPixels();
          } else if (thisSpacing.hasValue()) {
            if (thisSpacing.getValue() !== "initial" && thisSpacing.getValue() !== "unset") {
              letterSpacing = thisSpacing.getPixels();
            }
          }
          var letterSpacingCache = [];
          var textLen = renderText.length;
          this.letterSpacingCache = letterSpacingCache;
          for (var i3 = 0; i3 < textLen; i3++) {
            letterSpacingCache.push(typeof dx[i3] !== "undefined" ? dx[i3] : letterSpacing);
          }
          var dxSum = letterSpacingCache.reduce((acc, cur, i4) => i4 === 0 ? 0 : acc + cur || 0, 0);
          var textWidth = this.measureText(ctx);
          var textFullWidth = Math.max(textWidth + dxSum, 0);
          this.textWidth = textWidth;
          this.textHeight = this.getFontSize();
          this.glyphInfo = [];
          var fullPathWidth = this.getPathLength();
          var startOffset = this.getStyle("startOffset").getNumber(0) * fullPathWidth;
          var offset2 = 0;
          if (anchor === "middle" || anchor === "center") {
            offset2 = -textFullWidth / 2;
          }
          if (anchor === "end" || anchor === "right") {
            offset2 = -textFullWidth;
          }
          offset2 += startOffset;
          chars.forEach((char, i4) => {
            var {
              offset: nextOffset,
              segment,
              rotation
            } = this.findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, offset2, dy, char, i4);
            offset2 = nextOffset;
            if (!segment.p0 || !segment.p1) {
              return;
            }
            this.glyphInfo.push({
              text: chars[i4],
              p0: segment.p0,
              p1: segment.p1,
              rotation
            });
          });
        }
        parsePathData(path) {
          this.pathLength = -1;
          if (!path) {
            return [];
          }
          var pathCommands = [];
          var {
            pathParser
          } = path;
          pathParser.reset();
          while (!pathParser.isEnd()) {
            var {
              current
            } = pathParser;
            var startX = current ? current.x : 0;
            var startY = current ? current.y : 0;
            var command = pathParser.next();
            var nextCommandType = command.type;
            var points = [];
            switch (command.type) {
              case PathParser.MOVE_TO:
                this.pathM(pathParser, points);
                break;
              case PathParser.LINE_TO:
                nextCommandType = this.pathL(pathParser, points);
                break;
              case PathParser.HORIZ_LINE_TO:
                nextCommandType = this.pathH(pathParser, points);
                break;
              case PathParser.VERT_LINE_TO:
                nextCommandType = this.pathV(pathParser, points);
                break;
              case PathParser.CURVE_TO:
                this.pathC(pathParser, points);
                break;
              case PathParser.SMOOTH_CURVE_TO:
                nextCommandType = this.pathS(pathParser, points);
                break;
              case PathParser.QUAD_TO:
                this.pathQ(pathParser, points);
                break;
              case PathParser.SMOOTH_QUAD_TO:
                nextCommandType = this.pathT(pathParser, points);
                break;
              case PathParser.ARC:
                points = this.pathA(pathParser);
                break;
              case PathParser.CLOSE_PATH:
                PathElement.pathZ(pathParser);
                break;
            }
            if (command.type !== PathParser.CLOSE_PATH) {
              pathCommands.push({
                type: nextCommandType,
                points,
                start: {
                  x: startX,
                  y: startY
                },
                pathLength: this.calcLength(startX, startY, nextCommandType, points)
              });
            } else {
              pathCommands.push({
                type: PathParser.CLOSE_PATH,
                points: [],
                pathLength: 0
              });
            }
          }
          return pathCommands;
        }
        pathM(pathParser, points) {
          var {
            x: x2,
            y: y3
          } = PathElement.pathM(pathParser).point;
          points.push(x2, y3);
        }
        pathL(pathParser, points) {
          var {
            x: x2,
            y: y3
          } = PathElement.pathL(pathParser).point;
          points.push(x2, y3);
          return PathParser.LINE_TO;
        }
        pathH(pathParser, points) {
          var {
            x: x2,
            y: y3
          } = PathElement.pathH(pathParser).point;
          points.push(x2, y3);
          return PathParser.LINE_TO;
        }
        pathV(pathParser, points) {
          var {
            x: x2,
            y: y3
          } = PathElement.pathV(pathParser).point;
          points.push(x2, y3);
          return PathParser.LINE_TO;
        }
        pathC(pathParser, points) {
          var {
            point,
            controlPoint,
            currentPoint
          } = PathElement.pathC(pathParser);
          points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        }
        pathS(pathParser, points) {
          var {
            point,
            controlPoint,
            currentPoint
          } = PathElement.pathS(pathParser);
          points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          return PathParser.CURVE_TO;
        }
        pathQ(pathParser, points) {
          var {
            controlPoint,
            currentPoint
          } = PathElement.pathQ(pathParser);
          points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        }
        pathT(pathParser, points) {
          var {
            controlPoint,
            currentPoint
          } = PathElement.pathT(pathParser);
          points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
          return PathParser.QUAD_TO;
        }
        pathA(pathParser) {
          var {
            rX,
            rY,
            sweepFlag,
            xAxisRotation,
            centp,
            a1,
            ad
          } = PathElement.pathA(pathParser);
          if (sweepFlag === 0 && ad > 0) {
            ad -= 2 * Math.PI;
          }
          if (sweepFlag === 1 && ad < 0) {
            ad += 2 * Math.PI;
          }
          return [centp.x, centp.y, rX, rY, a1, ad, xAxisRotation, sweepFlag];
        }
        calcLength(x2, y3, commandType, points) {
          var len = 0;
          var p1 = null;
          var p22 = null;
          var t3 = 0;
          switch (commandType) {
            case PathParser.LINE_TO:
              return this.getLineLength(x2, y3, points[0], points[1]);
            case PathParser.CURVE_TO:
              len = 0;
              p1 = this.getPointOnCubicBezier(0, x2, y3, points[0], points[1], points[2], points[3], points[4], points[5]);
              for (t3 = 0.01; t3 <= 1; t3 += 0.01) {
                p22 = this.getPointOnCubicBezier(t3, x2, y3, points[0], points[1], points[2], points[3], points[4], points[5]);
                len += this.getLineLength(p1.x, p1.y, p22.x, p22.y);
                p1 = p22;
              }
              return len;
            case PathParser.QUAD_TO:
              len = 0;
              p1 = this.getPointOnQuadraticBezier(0, x2, y3, points[0], points[1], points[2], points[3]);
              for (t3 = 0.01; t3 <= 1; t3 += 0.01) {
                p22 = this.getPointOnQuadraticBezier(t3, x2, y3, points[0], points[1], points[2], points[3]);
                len += this.getLineLength(p1.x, p1.y, p22.x, p22.y);
                p1 = p22;
              }
              return len;
            case PathParser.ARC: {
              len = 0;
              var start2 = points[4];
              var dTheta = points[5];
              var end = points[4] + dTheta;
              var inc = Math.PI / 180;
              if (Math.abs(start2 - end) < inc) {
                inc = Math.abs(start2 - end);
              }
              p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start2, 0);
              if (dTheta < 0) {
                for (t3 = start2 - inc; t3 > end; t3 -= inc) {
                  p22 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t3, 0);
                  len += this.getLineLength(p1.x, p1.y, p22.x, p22.y);
                  p1 = p22;
                }
              } else {
                for (t3 = start2 + inc; t3 < end; t3 += inc) {
                  p22 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t3, 0);
                  len += this.getLineLength(p1.x, p1.y, p22.x, p22.y);
                  p1 = p22;
                }
              }
              p22 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
              len += this.getLineLength(p1.x, p1.y, p22.x, p22.y);
              return len;
            }
          }
          return 0;
        }
        getPointOnLine(dist, p1x, p1y, p2x, p2y) {
          var fromX = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : p1x;
          var fromY = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : p1y;
          var m4 = (p2y - p1y) / (p2x - p1x + PSEUDO_ZERO);
          var run = Math.sqrt(dist * dist / (1 + m4 * m4));
          if (p2x < p1x) {
            run *= -1;
          }
          var rise = m4 * run;
          var pt2 = null;
          if (p2x === p1x) {
            pt2 = {
              x: fromX,
              y: fromY + rise
            };
          } else if ((fromY - p1y) / (fromX - p1x + PSEUDO_ZERO) === m4) {
            pt2 = {
              x: fromX + run,
              y: fromY + rise
            };
          } else {
            var ix = 0;
            var iy = 0;
            var len = this.getLineLength(p1x, p1y, p2x, p2y);
            if (len < PSEUDO_ZERO) {
              return null;
            }
            var u3 = (fromX - p1x) * (p2x - p1x) + (fromY - p1y) * (p2y - p1y);
            u3 /= len * len;
            ix = p1x + u3 * (p2x - p1x);
            iy = p1y + u3 * (p2y - p1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m4 * m4));
            if (p2x < p1x) {
              run *= -1;
            }
            rise = m4 * run;
            pt2 = {
              x: ix + run,
              y: iy + rise
            };
          }
          return pt2;
        }
        getPointOnPath(distance) {
          var fullLen = this.getPathLength();
          var cumulativePathLength = 0;
          var p4 = null;
          if (distance < -5e-5 || distance - 5e-5 > fullLen) {
            return null;
          }
          var {
            dataArray
          } = this;
          for (var command of dataArray) {
            if (command && (command.pathLength < 5e-5 || cumulativePathLength + command.pathLength + 5e-5 < distance)) {
              cumulativePathLength += command.pathLength;
              continue;
            }
            var delta = distance - cumulativePathLength;
            var currentT = 0;
            switch (command.type) {
              case PathParser.LINE_TO:
                p4 = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
                break;
              case PathParser.ARC: {
                var start2 = command.points[4];
                var dTheta = command.points[5];
                var end = command.points[4] + dTheta;
                currentT = start2 + delta / command.pathLength * dTheta;
                if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                  break;
                }
                p4 = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
                break;
              }
              case PathParser.CURVE_TO:
                currentT = delta / command.pathLength;
                if (currentT > 1) {
                  currentT = 1;
                }
                p4 = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
                break;
              case PathParser.QUAD_TO:
                currentT = delta / command.pathLength;
                if (currentT > 1) {
                  currentT = 1;
                }
                p4 = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
                break;
            }
            if (p4) {
              return p4;
            }
            break;
          }
          return null;
        }
        getLineLength(x1, y1, x2, y22) {
          return Math.sqrt((x2 - x1) * (x2 - x1) + (y22 - y1) * (y22 - y1));
        }
        getPathLength() {
          if (this.pathLength === -1) {
            this.pathLength = this.dataArray.reduce((length, command) => command.pathLength > 0 ? length + command.pathLength : length, 0);
          }
          return this.pathLength;
        }
        getPointOnCubicBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
          var x2 = p4x * CB1(pct) + p3x * CB2(pct) + p2x * CB3(pct) + p1x * CB4(pct);
          var y3 = p4y * CB1(pct) + p3y * CB2(pct) + p2y * CB3(pct) + p1y * CB4(pct);
          return {
            x: x2,
            y: y3
          };
        }
        getPointOnQuadraticBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y) {
          var x2 = p3x * QB1(pct) + p2x * QB2(pct) + p1x * QB3(pct);
          var y3 = p3y * QB1(pct) + p2y * QB2(pct) + p1y * QB3(pct);
          return {
            x: x2,
            y: y3
          };
        }
        getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
          var cosPsi = Math.cos(psi);
          var sinPsi = Math.sin(psi);
          var pt2 = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
          };
          return {
            x: cx + (pt2.x * cosPsi - pt2.y * sinPsi),
            y: cy + (pt2.x * sinPsi + pt2.y * cosPsi)
          };
        }
        buildEquidistantCache(inputStep, inputPrecision) {
          var fullLen = this.getPathLength();
          var precision = inputPrecision || 0.25;
          var step = inputStep || fullLen / 100;
          if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
            this.equidistantCache = {
              step,
              precision,
              points: []
            };
            var s3 = 0;
            for (var l3 = 0; l3 <= fullLen; l3 += precision) {
              var p0 = this.getPointOnPath(l3);
              var p1 = this.getPointOnPath(l3 + precision);
              if (!p0 || !p1) {
                continue;
              }
              s3 += this.getLineLength(p0.x, p0.y, p1.x, p1.y);
              if (s3 >= step) {
                this.equidistantCache.points.push({
                  x: p0.x,
                  y: p0.y,
                  distance: l3
                });
                s3 -= step;
              }
            }
          }
        }
        getEquidistantPointOnPath(targetDistance, step, precision) {
          this.buildEquidistantCache(step, precision);
          if (targetDistance < 0 || targetDistance - this.getPathLength() > 5e-5) {
            return null;
          }
          var idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
          return this.equidistantCache.points[idx] || null;
        }
      };
      dataUriRegex = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
      ImageElement = class extends RenderedElement {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "image";
          this.loaded = false;
          var href = this.getHrefAttribute().getString();
          if (!href) {
            return;
          }
          var isSvg = href.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(href);
          document3.images.push(this);
          if (!isSvg) {
            void this.loadImage(href);
          } else {
            void this.loadSvg(href);
          }
          this.isSvg = isSvg;
        }
        loadImage(href) {
          var _this = this;
          return _asyncToGenerator(function* () {
            try {
              var image = yield _this.document.createImage(href);
              _this.image = image;
            } catch (err) {
              console.error('Error while loading image "'.concat(href, '":'), err);
            }
            _this.loaded = true;
          })();
        }
        loadSvg(href) {
          var _this2 = this;
          return _asyncToGenerator(function* () {
            var match = dataUriRegex.exec(href);
            if (match) {
              var data2 = match[5];
              if (match[4] === "base64") {
                _this2.image = atob(data2);
              } else {
                _this2.image = decodeURIComponent(data2);
              }
            } else {
              try {
                var response = yield _this2.document.fetch(href);
                var svg = yield response.text();
                _this2.image = svg;
              } catch (err) {
                console.error('Error while loading image "'.concat(href, '":'), err);
              }
            }
            _this2.loaded = true;
          })();
        }
        renderChildren(ctx) {
          var {
            document: document3,
            image,
            loaded
          } = this;
          var x2 = this.getAttribute("x").getPixels("x");
          var y3 = this.getAttribute("y").getPixels("y");
          var width = this.getStyle("width").getPixels("x");
          var height = this.getStyle("height").getPixels("y");
          if (!loaded || !image || !width || !height) {
            return;
          }
          ctx.save();
          ctx.translate(x2, y3);
          if (this.isSvg) {
            var subDocument = document3.canvg.forkString(ctx, this.image, {
              ignoreMouse: true,
              ignoreAnimation: true,
              ignoreDimensions: true,
              ignoreClear: true,
              offsetX: 0,
              offsetY: 0,
              scaleWidth: width,
              scaleHeight: height
            });
            subDocument.document.documentElement.parent = this;
            void subDocument.render();
          } else {
            var _image = this.image;
            document3.setViewBox({
              ctx,
              aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
              width,
              desiredWidth: _image.width,
              height,
              desiredHeight: _image.height
            });
            if (this.loaded) {
              if (typeof _image.complete === "undefined" || _image.complete) {
                ctx.drawImage(_image, 0, 0);
              }
            }
          }
          ctx.restore();
        }
        getBoundingBox() {
          var x2 = this.getAttribute("x").getPixels("x");
          var y3 = this.getAttribute("y").getPixels("y");
          var width = this.getStyle("width").getPixels("x");
          var height = this.getStyle("height").getPixels("y");
          return new BoundingBox(x2, y3, x2 + width, y3 + height);
        }
      };
      SymbolElement = class extends RenderedElement {
        constructor() {
          super(...arguments);
          this.type = "symbol";
        }
        render(_3) {
        }
      };
      SVGFontLoader = class {
        constructor(document3) {
          this.document = document3;
          this.loaded = false;
          document3.fonts.push(this);
        }
        load(fontFamily, url) {
          var _this = this;
          return _asyncToGenerator(function* () {
            try {
              var {
                document: document3
              } = _this;
              var svgDocument = yield document3.canvg.parser.load(url);
              var fonts = svgDocument.getElementsByTagName("font");
              Array.from(fonts).forEach((fontNode) => {
                var font = document3.createElement(fontNode);
                document3.definitions[fontFamily] = font;
              });
            } catch (err) {
              console.error('Error while loading font "'.concat(url, '":'), err);
            }
            _this.loaded = true;
          })();
        }
      };
      StyleElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "style";
          var css2 = compressSpaces(Array.from(node2.childNodes).map((_3) => _3.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, ""));
          var cssDefs = css2.split("}");
          cssDefs.forEach((_3) => {
            var def2 = _3.trim();
            if (!def2) {
              return;
            }
            var cssParts = def2.split("{");
            var cssClasses = cssParts[0].split(",");
            var cssProps = cssParts[1].split(";");
            cssClasses.forEach((_4) => {
              var cssClass = _4.trim();
              if (!cssClass) {
                return;
              }
              var props = document3.styles[cssClass] || {};
              cssProps.forEach((cssProp) => {
                var prop = cssProp.indexOf(":");
                var name = cssProp.substr(0, prop).trim();
                var value = cssProp.substr(prop + 1, cssProp.length - prop).trim();
                if (name && value) {
                  props[name] = new Property(document3, name, value);
                }
              });
              document3.styles[cssClass] = props;
              document3.stylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);
              if (cssClass === "@font-face") {
                var fontFamily = props["font-family"].getString().replace(/"|'/g, "");
                var srcs = props.src.getString().split(",");
                srcs.forEach((src) => {
                  if (src.indexOf('format("svg")') > 0) {
                    var url = parseExternalUrl(src);
                    if (url) {
                      void new SVGFontLoader(document3).load(fontFamily, url);
                    }
                  }
                });
              }
            });
          });
        }
      };
      StyleElement.parseExternalUrl = parseExternalUrl;
      UseElement = class extends RenderedElement {
        constructor() {
          super(...arguments);
          this.type = "use";
        }
        setContext(ctx) {
          super.setContext(ctx);
          var xAttr = this.getAttribute("x");
          var yAttr = this.getAttribute("y");
          if (xAttr.hasValue()) {
            ctx.translate(xAttr.getPixels("x"), 0);
          }
          if (yAttr.hasValue()) {
            ctx.translate(0, yAttr.getPixels("y"));
          }
        }
        path(ctx) {
          var {
            element
          } = this;
          if (element) {
            element.path(ctx);
          }
        }
        renderChildren(ctx) {
          var {
            document: document3,
            element
          } = this;
          if (element) {
            var tempSvg = element;
            if (element.type === "symbol") {
              tempSvg = new SVGElement2(document3, null);
              tempSvg.attributes.viewBox = new Property(document3, "viewBox", element.getAttribute("viewBox").getString());
              tempSvg.attributes.preserveAspectRatio = new Property(document3, "preserveAspectRatio", element.getAttribute("preserveAspectRatio").getString());
              tempSvg.attributes.overflow = new Property(document3, "overflow", element.getAttribute("overflow").getString());
              tempSvg.children = element.children;
              element.styles.opacity = new Property(document3, "opacity", this.calculateOpacity());
            }
            if (tempSvg.type === "svg") {
              var widthStyle = this.getStyle("width", false, true);
              var heightStyle = this.getStyle("height", false, true);
              if (widthStyle.hasValue()) {
                tempSvg.attributes.width = new Property(document3, "width", widthStyle.getString());
              }
              if (heightStyle.hasValue()) {
                tempSvg.attributes.height = new Property(document3, "height", heightStyle.getString());
              }
            }
            var oldParent = tempSvg.parent;
            tempSvg.parent = this;
            tempSvg.render(ctx);
            tempSvg.parent = oldParent;
          }
        }
        getBoundingBox(ctx) {
          var {
            element
          } = this;
          if (element) {
            return element.getBoundingBox(ctx);
          }
          return null;
        }
        elementTransform() {
          var {
            document: document3,
            element
          } = this;
          return Transform.fromElement(document3, element);
        }
        get element() {
          if (!this.cachedElement) {
            this.cachedElement = this.getHrefAttribute().getDefinition();
          }
          return this.cachedElement;
        }
      };
      FeColorMatrixElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "feColorMatrix";
          var matrix = toNumbers(this.getAttribute("values").getString());
          switch (this.getAttribute("type").getString("matrix")) {
            case "saturate": {
              var s3 = matrix[0];
              matrix = [0.213 + 0.787 * s3, 0.715 - 0.715 * s3, 0.072 - 0.072 * s3, 0, 0, 0.213 - 0.213 * s3, 0.715 + 0.285 * s3, 0.072 - 0.072 * s3, 0, 0, 0.213 - 0.213 * s3, 0.715 - 0.715 * s3, 0.072 + 0.928 * s3, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
              break;
            }
            case "hueRotate": {
              var a3 = matrix[0] * Math.PI / 180;
              matrix = [c2(a3, 0.213, 0.787, -0.213), c2(a3, 0.715, -0.715, -0.715), c2(a3, 0.072, -0.072, 0.928), 0, 0, c2(a3, 0.213, -0.213, 0.143), c2(a3, 0.715, 0.285, 0.14), c2(a3, 0.072, -0.072, -0.283), 0, 0, c2(a3, 0.213, -0.213, -0.787), c2(a3, 0.715, -0.715, 0.715), c2(a3, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
              break;
            }
            case "luminanceToAlpha":
              matrix = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
              break;
          }
          this.matrix = matrix;
          this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
        }
        apply(ctx, _x, _y, width, height) {
          var {
            includeOpacity,
            matrix
          } = this;
          var srcData = ctx.getImageData(0, 0, width, height);
          for (var y3 = 0; y3 < height; y3++) {
            for (var x2 = 0; x2 < width; x2++) {
              var r2 = imGet(srcData.data, x2, y3, width, height, 0);
              var g2 = imGet(srcData.data, x2, y3, width, height, 1);
              var b2 = imGet(srcData.data, x2, y3, width, height, 2);
              var a3 = imGet(srcData.data, x2, y3, width, height, 3);
              var nr = m2(matrix, 0, r2) + m2(matrix, 1, g2) + m2(matrix, 2, b2) + m2(matrix, 3, a3) + m2(matrix, 4, 1);
              var ng = m2(matrix, 5, r2) + m2(matrix, 6, g2) + m2(matrix, 7, b2) + m2(matrix, 8, a3) + m2(matrix, 9, 1);
              var nb = m2(matrix, 10, r2) + m2(matrix, 11, g2) + m2(matrix, 12, b2) + m2(matrix, 13, a3) + m2(matrix, 14, 1);
              var na = m2(matrix, 15, r2) + m2(matrix, 16, g2) + m2(matrix, 17, b2) + m2(matrix, 18, a3) + m2(matrix, 19, 1);
              if (includeOpacity) {
                nr = 0;
                ng = 0;
                nb = 0;
                na *= a3 / 255;
              }
              imSet(srcData.data, x2, y3, width, height, 0, nr);
              imSet(srcData.data, x2, y3, width, height, 1, ng);
              imSet(srcData.data, x2, y3, width, height, 2, nb);
              imSet(srcData.data, x2, y3, width, height, 3, na);
            }
          }
          ctx.clearRect(0, 0, width, height);
          ctx.putImageData(srcData, 0, 0);
        }
      };
      MaskElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "mask";
        }
        apply(ctx, element) {
          var {
            document: document3
          } = this;
          var x2 = this.getAttribute("x").getPixels("x");
          var y3 = this.getAttribute("y").getPixels("y");
          var width = this.getStyle("width").getPixels("x");
          var height = this.getStyle("height").getPixels("y");
          if (!width && !height) {
            var boundingBox = new BoundingBox();
            this.children.forEach((child) => {
              boundingBox.addBoundingBox(child.getBoundingBox(ctx));
            });
            x2 = Math.floor(boundingBox.x1);
            y3 = Math.floor(boundingBox.y1);
            width = Math.floor(boundingBox.width);
            height = Math.floor(boundingBox.height);
          }
          var ignoredStyles = this.removeStyles(element, MaskElement.ignoreStyles);
          var maskCanvas = document3.createCanvas(x2 + width, y3 + height);
          var maskCtx = maskCanvas.getContext("2d");
          document3.screen.setDefaults(maskCtx);
          this.renderChildren(maskCtx);
          new FeColorMatrixElement(document3, {
            nodeType: 1,
            childNodes: [],
            attributes: [{
              nodeName: "type",
              value: "luminanceToAlpha"
            }, {
              nodeName: "includeOpacity",
              value: "true"
            }]
          }).apply(maskCtx, 0, 0, x2 + width, y3 + height);
          var tmpCanvas = document3.createCanvas(x2 + width, y3 + height);
          var tmpCtx = tmpCanvas.getContext("2d");
          document3.screen.setDefaults(tmpCtx);
          element.render(tmpCtx);
          tmpCtx.globalCompositeOperation = "destination-in";
          tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, "no-repeat");
          tmpCtx.fillRect(0, 0, x2 + width, y3 + height);
          ctx.fillStyle = tmpCtx.createPattern(tmpCanvas, "no-repeat");
          ctx.fillRect(0, 0, x2 + width, y3 + height);
          this.restoreStyles(element, ignoredStyles);
        }
        render(_3) {
        }
      };
      MaskElement.ignoreStyles = ["mask", "transform", "clip-path"];
      noop = () => {
      };
      ClipPathElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "clipPath";
        }
        apply(ctx) {
          var {
            document: document3
          } = this;
          var contextProto = Reflect.getPrototypeOf(ctx);
          var {
            beginPath,
            closePath
          } = ctx;
          if (contextProto) {
            contextProto.beginPath = noop;
            contextProto.closePath = noop;
          }
          Reflect.apply(beginPath, ctx, []);
          this.children.forEach((child) => {
            if (typeof child.path === "undefined") {
              return;
            }
            var transform2 = typeof child.elementTransform !== "undefined" ? child.elementTransform() : null;
            if (!transform2) {
              transform2 = Transform.fromElement(document3, child);
            }
            if (transform2) {
              transform2.apply(ctx);
            }
            child.path(ctx);
            if (contextProto) {
              contextProto.closePath = closePath;
            }
            if (transform2) {
              transform2.unapply(ctx);
            }
          });
          Reflect.apply(closePath, ctx, []);
          ctx.clip();
          if (contextProto) {
            contextProto.beginPath = beginPath;
            contextProto.closePath = closePath;
          }
        }
        render(_3) {
        }
      };
      FilterElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "filter";
        }
        apply(ctx, element) {
          var {
            document: document3,
            children: children2
          } = this;
          var boundingBox = element.getBoundingBox(ctx);
          if (!boundingBox) {
            return;
          }
          var px = 0;
          var py = 0;
          children2.forEach((child) => {
            var efd = child.extraFilterDistance || 0;
            px = Math.max(px, efd);
            py = Math.max(py, efd);
          });
          var width = Math.floor(boundingBox.width);
          var height = Math.floor(boundingBox.height);
          var tmpCanvasWidth = width + 2 * px;
          var tmpCanvasHeight = height + 2 * py;
          if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) {
            return;
          }
          var x2 = Math.floor(boundingBox.x);
          var y3 = Math.floor(boundingBox.y);
          var ignoredStyles = this.removeStyles(element, FilterElement.ignoreStyles);
          var tmpCanvas = document3.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
          var tmpCtx = tmpCanvas.getContext("2d");
          document3.screen.setDefaults(tmpCtx);
          tmpCtx.translate(-x2 + px, -y3 + py);
          element.render(tmpCtx);
          children2.forEach((child) => {
            if (typeof child.apply === "function") {
              child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
            }
          });
          ctx.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x2 - px, y3 - py, tmpCanvasWidth, tmpCanvasHeight);
          this.restoreStyles(element, ignoredStyles);
        }
        render(_3) {
        }
      };
      FilterElement.ignoreStyles = ["filter", "transform", "clip-path"];
      FeDropShadowElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "feDropShadow";
          this.addStylesFromStyleDefinition();
        }
        apply(_3, _x, _y, _width, _height) {
        }
      };
      FeMorphologyElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "feMorphology";
        }
        apply(_3, _x, _y, _width, _height) {
        }
      };
      FeCompositeElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "feComposite";
        }
        apply(_3, _x, _y, _width, _height) {
        }
      };
      FeGaussianBlurElement = class extends Element2 {
        constructor(document3, node2, captureTextNodes) {
          super(document3, node2, captureTextNodes);
          this.type = "feGaussianBlur";
          this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber());
          this.extraFilterDistance = this.blurRadius;
        }
        apply(ctx, x2, y3, width, height) {
          var {
            document: document3,
            blurRadius
          } = this;
          var body = document3.window ? document3.window.document.body : null;
          var canvas = ctx.canvas;
          canvas.id = document3.getUniqueId();
          if (body) {
            canvas.style.display = "none";
            body.appendChild(canvas);
          }
          processCanvasRGBA(canvas, x2, y3, width, height, blurRadius);
          if (body) {
            body.removeChild(canvas);
          }
        }
      };
      TitleElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "title";
        }
      };
      DescElement = class extends Element2 {
        constructor() {
          super(...arguments);
          this.type = "desc";
        }
      };
      elements = {
        "svg": SVGElement2,
        "rect": RectElement,
        "circle": CircleElement,
        "ellipse": EllipseElement,
        "line": LineElement,
        "polyline": PolylineElement,
        "polygon": PolygonElement,
        "path": PathElement,
        "pattern": PatternElement,
        "marker": MarkerElement,
        "defs": DefsElement,
        "linearGradient": LinearGradientElement,
        "radialGradient": RadialGradientElement,
        "stop": StopElement,
        "animate": AnimateElement,
        "animateColor": AnimateColorElement,
        "animateTransform": AnimateTransformElement,
        "font": FontElement,
        "font-face": FontFaceElement,
        "missing-glyph": MissingGlyphElement,
        "glyph": GlyphElement,
        "text": TextElement,
        "tspan": TSpanElement,
        "tref": TRefElement,
        "a": AElement,
        "textPath": TextPathElement,
        "image": ImageElement,
        "g": GElement,
        "symbol": SymbolElement,
        "style": StyleElement,
        "use": UseElement,
        "mask": MaskElement,
        "clipPath": ClipPathElement,
        "filter": FilterElement,
        "feDropShadow": FeDropShadowElement,
        "feMorphology": FeMorphologyElement,
        "feComposite": FeCompositeElement,
        "feColorMatrix": FeColorMatrixElement,
        "feGaussianBlur": FeGaussianBlurElement,
        "title": TitleElement,
        "desc": DescElement
      };
      Document = class {
        constructor(canvg) {
          var {
            rootEmSize = 12,
            emSize = 12,
            createCanvas: createCanvas2 = Document.createCanvas,
            createImage: createImage2 = Document.createImage,
            anonymousCrossOrigin
          } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          this.canvg = canvg;
          this.definitions = {};
          this.styles = {};
          this.stylesSpecificity = {};
          this.images = [];
          this.fonts = [];
          this.emSizeStack = [];
          this.uniqueId = 0;
          this.screen = canvg.screen;
          this.rootEmSize = rootEmSize;
          this.emSize = emSize;
          this.createCanvas = createCanvas2;
          this.createImage = this.bindCreateImage(createImage2, anonymousCrossOrigin);
          this.screen.wait(this.isImagesLoaded.bind(this));
          this.screen.wait(this.isFontsLoaded.bind(this));
        }
        bindCreateImage(createImage2, anonymousCrossOrigin) {
          if (typeof anonymousCrossOrigin === "boolean") {
            return (source, forceAnonymousCrossOrigin) => createImage2(source, typeof forceAnonymousCrossOrigin === "boolean" ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
          }
          return createImage2;
        }
        get window() {
          return this.screen.window;
        }
        get fetch() {
          return this.screen.fetch;
        }
        get ctx() {
          return this.screen.ctx;
        }
        get emSize() {
          var {
            emSizeStack
          } = this;
          return emSizeStack[emSizeStack.length - 1];
        }
        set emSize(value) {
          var {
            emSizeStack
          } = this;
          emSizeStack.push(value);
        }
        popEmSize() {
          var {
            emSizeStack
          } = this;
          emSizeStack.pop();
        }
        getUniqueId() {
          return "canvg".concat(++this.uniqueId);
        }
        isImagesLoaded() {
          return this.images.every((_3) => _3.loaded);
        }
        isFontsLoaded() {
          return this.fonts.every((_3) => _3.loaded);
        }
        createDocumentElement(document3) {
          var documentElement = this.createElement(document3.documentElement);
          documentElement.root = true;
          documentElement.addStylesFromStyleDefinition();
          this.documentElement = documentElement;
          return documentElement;
        }
        createElement(node2) {
          var elementType = node2.nodeName.replace(/^[^:]+:/, "");
          var ElementType = Document.elementTypes[elementType];
          if (typeof ElementType !== "undefined") {
            return new ElementType(this, node2);
          }
          return new UnknownElement(this, node2);
        }
        createTextNode(node2) {
          return new TextNode(this, node2);
        }
        setViewBox(config) {
          this.screen.setViewBox(_objectSpread$1({
            document: this
          }, config));
        }
      };
      Document.createCanvas = createCanvas;
      Document.createImage = createImage;
      Document.elementTypes = elements;
      Canvg = class {
        constructor(ctx, svg) {
          var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          this.parser = new Parser(options);
          this.screen = new Screen(ctx, options);
          this.options = options;
          var document3 = new Document(this, options);
          var documentElement = document3.createDocumentElement(svg);
          this.document = document3;
          this.documentElement = documentElement;
        }
        static from(ctx, svg) {
          var _arguments = arguments;
          return _asyncToGenerator(function* () {
            var options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
            var parser = new Parser(options);
            var svgDocument = yield parser.parse(svg);
            return new Canvg(ctx, svgDocument, options);
          })();
        }
        static fromString(ctx, svg) {
          var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          var parser = new Parser(options);
          var svgDocument = parser.parseFromString(svg);
          return new Canvg(ctx, svgDocument, options);
        }
        fork(ctx, svg) {
          var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return Canvg.from(ctx, svg, _objectSpread(_objectSpread({}, this.options), options));
        }
        forkString(ctx, svg) {
          var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return Canvg.fromString(ctx, svg, _objectSpread(_objectSpread({}, this.options), options));
        }
        ready() {
          return this.screen.ready();
        }
        isReady() {
          return this.screen.isReady();
        }
        render() {
          var _arguments2 = arguments, _this = this;
          return _asyncToGenerator(function* () {
            var options = _arguments2.length > 0 && _arguments2[0] !== void 0 ? _arguments2[0] : {};
            _this.start(_objectSpread({
              enableRedraw: true,
              ignoreAnimation: true,
              ignoreMouse: true
            }, options));
            yield _this.ready();
            _this.stop();
          })();
        }
        start() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var {
            documentElement,
            screen,
            options: baseOptions
          } = this;
          screen.start(documentElement, _objectSpread(_objectSpread({
            enableRedraw: true
          }, baseOptions), options));
        }
        stop() {
          this.screen.stop();
        }
        resize(width) {
          var height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : width;
          var preserveAspectRatio = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          this.documentElement.resize(width, height, preserveAspectRatio);
        }
      };
      index_es_default = Canvg;
    }
  });

  // node_modules/alpinejs/dist/module.esm.js
  var flushPending = false;
  var flushing = false;
  var queue = [];
  var lastFlushedIndex = -1;
  function scheduler(callback) {
    queueJob(callback);
  }
  function queueJob(job) {
    if (!queue.includes(job))
      queue.push(job);
    queueFlush();
  }
  function dequeueJob(job) {
    let index3 = queue.indexOf(job);
    if (index3 !== -1 && index3 > lastFlushedIndex)
      queue.splice(index3, 1);
  }
  function queueFlush() {
    if (!flushing && !flushPending) {
      flushPending = true;
      queueMicrotask(flushJobs);
    }
  }
  function flushJobs() {
    flushPending = false;
    flushing = true;
    for (let i3 = 0; i3 < queue.length; i3++) {
      queue[i3]();
      lastFlushedIndex = i3;
    }
    queue.length = 0;
    lastFlushedIndex = -1;
    flushing = false;
  }
  var reactive;
  var effect;
  var release;
  var raw;
  var shouldSchedule = true;
  function disableEffectScheduling(callback) {
    shouldSchedule = false;
    callback();
    shouldSchedule = true;
  }
  function setReactivityEngine(engine) {
    reactive = engine.reactive;
    release = engine.release;
    effect = (callback) => engine.effect(callback, { scheduler: (task2) => {
      if (shouldSchedule) {
        scheduler(task2);
      } else {
        task2();
      }
    } });
    raw = engine.raw;
  }
  function overrideEffect(override) {
    effect = override;
  }
  function elementBoundEffect(el) {
    let cleanup2 = () => {
    };
    let wrappedEffect = (callback) => {
      let effectReference = effect(callback);
      if (!el._x_effects) {
        el._x_effects = new Set();
        el._x_runEffects = () => {
          el._x_effects.forEach((i3) => i3());
        };
      }
      el._x_effects.add(effectReference);
      cleanup2 = () => {
        if (effectReference === void 0)
          return;
        el._x_effects.delete(effectReference);
        release(effectReference);
      };
      return effectReference;
    };
    return [wrappedEffect, () => {
      cleanup2();
    }];
  }
  var onAttributeAddeds = [];
  var onElRemoveds = [];
  var onElAddeds = [];
  function onElAdded(callback) {
    onElAddeds.push(callback);
  }
  function onElRemoved(el, callback) {
    if (typeof callback === "function") {
      if (!el._x_cleanups)
        el._x_cleanups = [];
      el._x_cleanups.push(callback);
    } else {
      callback = el;
      onElRemoveds.push(callback);
    }
  }
  function onAttributesAdded(callback) {
    onAttributeAddeds.push(callback);
  }
  function onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups)
      el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name])
      el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
  }
  function cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups)
      return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
      if (names === void 0 || names.includes(name)) {
        value.forEach((i3) => i3());
        delete el._x_attributeCleanups[name];
      }
    });
  }
  var observer = new MutationObserver(onMutate);
  var currentlyObserving = false;
  function startObservingMutations() {
    observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
    currentlyObserving = true;
  }
  function stopObservingMutations() {
    flushObserver();
    observer.disconnect();
    currentlyObserving = false;
  }
  var recordQueue = [];
  var willProcessRecordQueue = false;
  function flushObserver() {
    recordQueue = recordQueue.concat(observer.takeRecords());
    if (recordQueue.length && !willProcessRecordQueue) {
      willProcessRecordQueue = true;
      queueMicrotask(() => {
        processRecordQueue();
        willProcessRecordQueue = false;
      });
    }
  }
  function processRecordQueue() {
    onMutate(recordQueue);
    recordQueue.length = 0;
  }
  function mutateDom(callback) {
    if (!currentlyObserving)
      return callback();
    stopObservingMutations();
    let result = callback();
    startObservingMutations();
    return result;
  }
  var isCollecting = false;
  var deferredMutations = [];
  function deferMutations() {
    isCollecting = true;
  }
  function flushAndStopDeferringMutations() {
    isCollecting = false;
    onMutate(deferredMutations);
    deferredMutations = [];
  }
  function onMutate(mutations) {
    if (isCollecting) {
      deferredMutations = deferredMutations.concat(mutations);
      return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = new Map();
    let removedAttributes = new Map();
    for (let i3 = 0; i3 < mutations.length; i3++) {
      if (mutations[i3].target._x_ignoreMutationObserver)
        continue;
      if (mutations[i3].type === "childList") {
        mutations[i3].addedNodes.forEach((node2) => node2.nodeType === 1 && addedNodes.push(node2));
        mutations[i3].removedNodes.forEach((node2) => node2.nodeType === 1 && removedNodes.push(node2));
      }
      if (mutations[i3].type === "attributes") {
        let el = mutations[i3].target;
        let name = mutations[i3].attributeName;
        let oldValue = mutations[i3].oldValue;
        let add22 = () => {
          if (!addedAttributes.has(el))
            addedAttributes.set(el, []);
          addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
        };
        let remove3 = () => {
          if (!removedAttributes.has(el))
            removedAttributes.set(el, []);
          removedAttributes.get(el).push(name);
        };
        if (el.hasAttribute(name) && oldValue === null) {
          add22();
        } else if (el.hasAttribute(name)) {
          remove3();
          add22();
        } else {
          remove3();
        }
      }
    }
    removedAttributes.forEach((attrs, el) => {
      cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el) => {
      onAttributeAddeds.forEach((i3) => i3(el, attrs));
    });
    for (let node2 of removedNodes) {
      if (addedNodes.includes(node2))
        continue;
      onElRemoveds.forEach((i3) => i3(node2));
      if (node2._x_cleanups) {
        while (node2._x_cleanups.length)
          node2._x_cleanups.pop()();
      }
    }
    addedNodes.forEach((node2) => {
      node2._x_ignoreSelf = true;
      node2._x_ignore = true;
    });
    for (let node2 of addedNodes) {
      if (removedNodes.includes(node2))
        continue;
      if (!node2.isConnected)
        continue;
      delete node2._x_ignoreSelf;
      delete node2._x_ignore;
      onElAddeds.forEach((i3) => i3(node2));
      node2._x_ignore = true;
      node2._x_ignoreSelf = true;
    }
    addedNodes.forEach((node2) => {
      delete node2._x_ignoreSelf;
      delete node2._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
  }
  function scope(node2) {
    return mergeProxies(closestDataStack(node2));
  }
  function addScopeToNode(node2, data2, referenceNode) {
    node2._x_dataStack = [data2, ...closestDataStack(referenceNode || node2)];
    return () => {
      node2._x_dataStack = node2._x_dataStack.filter((i3) => i3 !== data2);
    };
  }
  function closestDataStack(node2) {
    if (node2._x_dataStack)
      return node2._x_dataStack;
    if (typeof ShadowRoot === "function" && node2 instanceof ShadowRoot) {
      return closestDataStack(node2.host);
    }
    if (!node2.parentNode) {
      return [];
    }
    return closestDataStack(node2.parentNode);
  }
  function mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
      ownKeys: () => {
        return Array.from(new Set(objects.flatMap((i3) => Object.keys(i3))));
      },
      has: (target, name) => {
        return objects.some((obj) => obj.hasOwnProperty(name));
      },
      get: (target, name) => {
        return (objects.find((obj) => {
          if (obj.hasOwnProperty(name)) {
            let descriptor = Object.getOwnPropertyDescriptor(obj, name);
            if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) {
              return true;
            }
            if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
              let getter = descriptor.get;
              let setter = descriptor.set;
              let property = descriptor;
              getter = getter && getter.bind(thisProxy);
              setter = setter && setter.bind(thisProxy);
              if (getter)
                getter._x_alreadyBound = true;
              if (setter)
                setter._x_alreadyBound = true;
              Object.defineProperty(obj, name, {
                ...property,
                get: getter,
                set: setter
              });
            }
            return true;
          }
          return false;
        }) || {})[name];
      },
      set: (target, name, value) => {
        let closestObjectWithKey = objects.find((obj) => obj.hasOwnProperty(name));
        if (closestObjectWithKey) {
          closestObjectWithKey[name] = value;
        } else {
          objects[objects.length - 1][name] = value;
        }
        return true;
      }
    });
    return thisProxy;
  }
  function initInterceptors(data2) {
    let isObject22 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
        if (enumerable === false || value === void 0)
          return;
        let path = basePath === "" ? key : `${basePath}.${key}`;
        if (typeof value === "object" && value !== null && value._x_interceptor) {
          obj[key] = value.initialize(data2, path, key);
        } else {
          if (isObject22(value) && value !== obj && !(value instanceof Element)) {
            recurse(value, path);
          }
        }
      });
    };
    return recurse(data2);
  }
  function interceptor(callback, mutateObj = () => {
  }) {
    let obj = {
      initialValue: void 0,
      _x_interceptor: true,
      initialize(data2, path, key) {
        return callback(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key);
      }
    };
    mutateObj(obj);
    return (initialValue) => {
      if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
        let initialize = obj.initialize.bind(obj);
        obj.initialize = (data2, path, key) => {
          let innerValue = initialValue.initialize(data2, path, key);
          obj.initialValue = innerValue;
          return initialize(data2, path, key);
        };
      } else {
        obj.initialValue = initialValue;
      }
      return obj;
    };
  }
  function get(obj, path) {
    return path.split(".").reduce((carry, segment) => carry[segment], obj);
  }
  function set(obj, path, value) {
    if (typeof path === "string")
      path = path.split(".");
    if (path.length === 1)
      obj[path[0]] = value;
    else if (path.length === 0)
      throw error;
    else {
      if (obj[path[0]])
        return set(obj[path[0]], path.slice(1), value);
      else {
        obj[path[0]] = {};
        return set(obj[path[0]], path.slice(1), value);
      }
    }
  }
  var magics = {};
  function magic(name, callback) {
    magics[name] = callback;
  }
  function injectMagics(obj, el) {
    Object.entries(magics).forEach(([name, callback]) => {
      let memoizedUtilities = null;
      function getUtilities() {
        if (memoizedUtilities) {
          return memoizedUtilities;
        } else {
          let [utilities, cleanup2] = getElementBoundUtilities(el);
          memoizedUtilities = { interceptor, ...utilities };
          onElRemoved(el, cleanup2);
          return memoizedUtilities;
        }
      }
      Object.defineProperty(obj, `$${name}`, {
        get() {
          return callback(el, getUtilities());
        },
        enumerable: false
      });
    });
    return obj;
  }
  function tryCatch(el, expression, callback, ...args) {
    try {
      return callback(...args);
    } catch (e2) {
      handleError(e2, el, expression);
    }
  }
  function handleError(error2, el, expression = void 0) {
    Object.assign(error2, { el, expression });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(() => {
      throw error2;
    }, 0);
  }
  var shouldAutoEvaluateFunctions = true;
  function dontAutoEvaluateFunctions(callback) {
    let cache = shouldAutoEvaluateFunctions;
    shouldAutoEvaluateFunctions = false;
    let result = callback();
    shouldAutoEvaluateFunctions = cache;
    return result;
  }
  function evaluate(el, expression, extras = {}) {
    let result;
    evaluateLater(el, expression)((value) => result = value, extras);
    return result;
  }
  function evaluateLater(...args) {
    return theEvaluatorFunction(...args);
  }
  var theEvaluatorFunction = normalEvaluator;
  function setEvaluator(newEvaluator) {
    theEvaluatorFunction = newEvaluator;
  }
  function normalEvaluator(el, expression) {
    let overriddenMagics = {};
    injectMagics(overriddenMagics, el);
    let dataStack = [overriddenMagics, ...closestDataStack(el)];
    let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
    return tryCatch.bind(null, el, expression, evaluator);
  }
  function generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
      runIfTypeOfFunction(receiver, result);
    };
  }
  var evaluatorMemo = {};
  function generateFunctionFromString(expression, el) {
    if (evaluatorMemo[expression]) {
      return evaluatorMemo[expression];
    }
    let AsyncFunction = Object.getPrototypeOf(async function() {
    }).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = () => {
      try {
        return new AsyncFunction(["__self", "scope"], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
      } catch (error2) {
        handleError(error2, el, expression);
        return Promise.resolve();
      }
    };
    let func = safeAsyncFunction();
    evaluatorMemo[expression] = func;
    return func;
  }
  function generateEvaluatorFromString(dataStack, expression, el) {
    let func = generateFunctionFromString(expression, el);
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      func.result = void 0;
      func.finished = false;
      let completeScope = mergeProxies([scope2, ...dataStack]);
      if (typeof func === "function") {
        let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
        if (func.finished) {
          runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
          func.result = void 0;
        } else {
          promise.then((result) => {
            runIfTypeOfFunction(receiver, result, completeScope, params, el);
          }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
        }
      }
    };
  }
  function runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if (shouldAutoEvaluateFunctions && typeof value === "function") {
      let result = value.apply(scope2, params);
      if (result instanceof Promise) {
        result.then((i3) => runIfTypeOfFunction(receiver, i3, scope2, params)).catch((error2) => handleError(error2, el, value));
      } else {
        receiver(result);
      }
    } else if (typeof value === "object" && value instanceof Promise) {
      value.then((i3) => receiver(i3));
    } else {
      receiver(value);
    }
  }
  var prefixAsString = "x-";
  function prefix(subject = "") {
    return prefixAsString + subject;
  }
  function setPrefix(newPrefix) {
    prefixAsString = newPrefix;
  }
  var directiveHandlers = {};
  function directive(name, callback) {
    directiveHandlers[name] = callback;
    return {
      before(directive2) {
        if (!directiveHandlers[directive2]) {
          console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
          return;
        }
        const pos = directiveOrder.indexOf(directive2);
        directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
      }
    };
  }
  function directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
      let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
      let staticAttributes = attributesOnly(vAttributes);
      vAttributes = vAttributes.map((attribute) => {
        if (staticAttributes.find((attr2) => attr2.name === attribute.name)) {
          return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
          };
        }
        return attribute;
      });
      attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
    return directives2.map((directive2) => {
      return getDirectiveHandler(el, directive2);
    });
  }
  function attributesOnly(attributes) {
    return Array.from(attributes).map(toTransformedAttributes()).filter((attr2) => !outNonAlpineAttributes(attr2));
  }
  var isDeferringHandlers = false;
  var directiveHandlerStacks = new Map();
  var currentHandlerStackKey = Symbol();
  function deferHandlingDirectives(callback) {
    isDeferringHandlers = true;
    let key = Symbol();
    currentHandlerStackKey = key;
    directiveHandlerStacks.set(key, []);
    let flushHandlers = () => {
      while (directiveHandlerStacks.get(key).length)
        directiveHandlerStacks.get(key).shift()();
      directiveHandlerStacks.delete(key);
    };
    let stopDeferring = () => {
      isDeferringHandlers = false;
      flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
  }
  function getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback) => cleanups.push(callback);
    let [effect32, cleanupEffect2] = elementBoundEffect(el);
    cleanups.push(cleanupEffect2);
    let utilities = {
      Alpine: alpine_default,
      effect: effect32,
      cleanup: cleanup2,
      evaluateLater: evaluateLater.bind(evaluateLater, el),
      evaluate: evaluate.bind(evaluate, el)
    };
    let doCleanup = () => cleanups.forEach((i3) => i3());
    return [utilities, doCleanup];
  }
  function getDirectiveHandler(el, directive2) {
    let noop2 = () => {
    };
    let handler4 = directiveHandlers[directive2.type] || noop2;
    let [utilities, cleanup2] = getElementBoundUtilities(el);
    onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = () => {
      if (el._x_ignore || el._x_ignoreSelf)
        return;
      handler4.inline && handler4.inline(el, directive2, utilities);
      handler4 = handler4.bind(handler4, el, directive2, utilities);
      isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
  }
  var startingWith = (subject, replacement) => ({ name, value }) => {
    if (name.startsWith(subject))
      name = name.replace(subject, replacement);
    return { name, value };
  };
  var into = (i3) => i3;
  function toTransformedAttributes(callback = () => {
  }) {
    return ({ name, value }) => {
      let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform2) => {
        return transform2(carry);
      }, { name, value });
      if (newName !== name)
        callback(newName, name);
      return { name: newName, value: newValue };
    };
  }
  var attributeTransformers = [];
  function mapAttributes(callback) {
    attributeTransformers.push(callback);
  }
  function outNonAlpineAttributes({ name }) {
    return alpineAttributeRegex().test(name);
  }
  var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
  function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name, value }) => {
      let typeMatch = name.match(alpineAttributeRegex());
      let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
      let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
      let original = originalAttributeOverride || transformedAttributeMap[name] || name;
      return {
        type: typeMatch ? typeMatch[1] : null,
        value: valueMatch ? valueMatch[1] : null,
        modifiers: modifiers.map((i3) => i3.replace(".", "")),
        expression: value,
        original
      };
    };
  }
  var DEFAULT = "DEFAULT";
  var directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    DEFAULT,
    "teleport"
  ];
  function byPriority(a3, b2) {
    let typeA = directiveOrder.indexOf(a3.type) === -1 ? DEFAULT : a3.type;
    let typeB = directiveOrder.indexOf(b2.type) === -1 ? DEFAULT : b2.type;
    return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
  }
  function dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
      detail,
      bubbles: true,
      composed: true,
      cancelable: true
    }));
  }
  function walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
      Array.from(el.children).forEach((el2) => walk(el2, callback));
      return;
    }
    let skip = false;
    callback(el, () => skip = true);
    if (skip)
      return;
    let node2 = el.firstElementChild;
    while (node2) {
      walk(node2, callback, false);
      node2 = node2.nextElementSibling;
    }
  }
  function warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
  }
  var started = false;
  function start() {
    if (started)
      warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    started = true;
    if (!document.body)
      warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    dispatch(document, "alpine:init");
    dispatch(document, "alpine:initializing");
    startObservingMutations();
    onElAdded((el) => initTree(el, walk));
    onElRemoved((el) => destroyTree(el));
    onAttributesAdded((el, attrs) => {
      directives(el, attrs).forEach((handle) => handle());
    });
    let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll(allSelectors())).filter(outNestedComponents).forEach((el) => {
      initTree(el);
    });
    dispatch(document, "alpine:initialized");
  }
  var rootSelectorCallbacks = [];
  var initSelectorCallbacks = [];
  function rootSelectors() {
    return rootSelectorCallbacks.map((fn) => fn());
  }
  function allSelectors() {
    return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
  }
  function addRootSelector(selectorCallback) {
    rootSelectorCallbacks.push(selectorCallback);
  }
  function addInitSelector(selectorCallback) {
    initSelectorCallbacks.push(selectorCallback);
  }
  function closestRoot(el, includeInitSelectors = false) {
    return findClosest(el, (element) => {
      const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
      if (selectors.some((selector) => element.matches(selector)))
        return true;
    });
  }
  function findClosest(el, callback) {
    if (!el)
      return;
    if (callback(el))
      return el;
    if (el._x_teleportBack)
      el = el._x_teleportBack;
    if (!el.parentElement)
      return;
    return findClosest(el.parentElement, callback);
  }
  function isRoot(el) {
    return rootSelectors().some((selector) => el.matches(selector));
  }
  var initInterceptors2 = [];
  function interceptInit(callback) {
    initInterceptors2.push(callback);
  }
  function initTree(el, walker = walk, intercept = () => {
  }) {
    deferHandlingDirectives(() => {
      walker(el, (el2, skip) => {
        intercept(el2, skip);
        initInterceptors2.forEach((i3) => i3(el2, skip));
        directives(el2, el2.attributes).forEach((handle) => handle());
        el2._x_ignore && skip();
      });
    });
  }
  function destroyTree(root) {
    walk(root, (el) => cleanupAttributes(el));
  }
  var tickStack = [];
  var isHolding = false;
  function nextTick(callback = () => {
  }) {
    queueMicrotask(() => {
      isHolding || setTimeout(() => {
        releaseNextTicks();
      });
    });
    return new Promise((res) => {
      tickStack.push(() => {
        callback();
        res();
      });
    });
  }
  function releaseNextTicks() {
    isHolding = false;
    while (tickStack.length)
      tickStack.shift()();
  }
  function holdNextTicks() {
    isHolding = true;
  }
  function setClasses(el, value) {
    if (Array.isArray(value)) {
      return setClassesFromString(el, value.join(" "));
    } else if (typeof value === "object" && value !== null) {
      return setClassesFromObject(el, value);
    } else if (typeof value === "function") {
      return setClasses(el, value());
    }
    return setClassesFromString(el, value);
  }
  function setClassesFromString(el, classString) {
    let split = (classString2) => classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2) => classString2.split(" ").filter((i3) => !el.classList.contains(i3)).filter(Boolean);
    let addClassesAndReturnUndo = (classes) => {
      el.classList.add(...classes);
      return () => {
        el.classList.remove(...classes);
      };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
  }
  function setClassesFromObject(el, classObject) {
    let split = (classString) => classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i3) => {
      if (el.classList.contains(i3)) {
        el.classList.remove(i3);
        removed.push(i3);
      }
    });
    forAdd.forEach((i3) => {
      if (!el.classList.contains(i3)) {
        el.classList.add(i3);
        added.push(i3);
      }
    });
    return () => {
      removed.forEach((i3) => el.classList.add(i3));
      added.forEach((i3) => el.classList.remove(i3));
    };
  }
  function setStyles(el, value) {
    if (typeof value === "object" && value !== null) {
      return setStylesFromObject(el, value);
    }
    return setStylesFromString(el, value);
  }
  function setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2]) => {
      previousStyles[key] = el.style[key];
      if (!key.startsWith("--")) {
        key = kebabCase(key);
      }
      el.style.setProperty(key, value2);
    });
    setTimeout(() => {
      if (el.style.length === 0) {
        el.removeAttribute("style");
      }
    });
    return () => {
      setStyles(el, previousStyles);
    };
  }
  function setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return () => {
      el.setAttribute("style", cache || "");
    };
  }
  function kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }
  function once(callback, fallback = () => {
  }) {
    let called = false;
    return function() {
      if (!called) {
        called = true;
        callback.apply(this, arguments);
      } else {
        fallback.apply(this, arguments);
      }
    };
  }
  directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "function")
      expression = evaluate2(expression);
    if (expression === false)
      return;
    if (!expression || typeof expression === "boolean") {
      registerTransitionsFromHelper(el, modifiers, value);
    } else {
      registerTransitionsFromClassString(el, expression, value);
    }
  });
  function registerTransitionsFromClassString(el, classString, stage) {
    registerTransitionObject(el, setClasses, "");
    let directiveStorageMap = {
      enter: (classes) => {
        el._x_transition.enter.during = classes;
      },
      "enter-start": (classes) => {
        el._x_transition.enter.start = classes;
      },
      "enter-end": (classes) => {
        el._x_transition.enter.end = classes;
      },
      leave: (classes) => {
        el._x_transition.leave.during = classes;
      },
      "leave-start": (classes) => {
        el._x_transition.leave.start = classes;
      },
      "leave-end": (classes) => {
        el._x_transition.leave.end = classes;
      }
    };
    directiveStorageMap[stage](classString);
  }
  function registerTransitionsFromHelper(el, modifiers, stage) {
    registerTransitionObject(el, setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) {
      modifiers = modifiers.filter((i3, index3) => index3 < modifiers.indexOf("out"));
    }
    if (modifiers.includes("out") && !doesntSpecify) {
      modifiers = modifiers.filter((i3, index3) => index3 > modifiers.indexOf("out"));
    }
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
      el._x_transition.enter.during = {
        transformOrigin: origin,
        transitionDelay: `${delay}s`,
        transitionProperty: property,
        transitionDuration: `${durationIn}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.enter.start = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
      el._x_transition.enter.end = {
        opacity: 1,
        transform: `scale(1)`
      };
    }
    if (transitioningOut) {
      el._x_transition.leave.during = {
        transformOrigin: origin,
        transitionDelay: `${delay}s`,
        transitionProperty: property,
        transitionDuration: `${durationOut}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.leave.start = {
        opacity: 1,
        transform: `scale(1)`
      };
      el._x_transition.leave.end = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
    }
  }
  function registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition)
      el._x_transition = {
        enter: { during: defaultValue, start: defaultValue, end: defaultValue },
        leave: { during: defaultValue, start: defaultValue, end: defaultValue },
        in(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.enter.during,
            start: this.enter.start,
            end: this.enter.end
          }, before, after);
        },
        out(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.leave.during,
            start: this.leave.start,
            end: this.leave.end
          }, before, after);
        }
      };
  }
  window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick22 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = () => nextTick22(show);
    if (value) {
      if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
        el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
      } else {
        el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
      }
      return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve3, reject2) => {
      el._x_transition.out(() => {
      }, () => resolve3(hide));
      el._x_transitioning.beforeCancel(() => reject2({ isFromCancelledTransition: true }));
    }) : Promise.resolve(hide);
    queueMicrotask(() => {
      let closest2 = closestHide(el);
      if (closest2) {
        if (!closest2._x_hideChildren)
          closest2._x_hideChildren = [];
        closest2._x_hideChildren.push(el);
      } else {
        nextTick22(() => {
          let hideAfterChildren = (el2) => {
            let carry = Promise.all([
              el2._x_hidePromise,
              ...(el2._x_hideChildren || []).map(hideAfterChildren)
            ]).then(([i3]) => i3());
            delete el2._x_hidePromise;
            delete el2._x_hideChildren;
            return carry;
          };
          hideAfterChildren(el).catch((e2) => {
            if (!e2.isFromCancelledTransition)
              throw e2;
          });
        });
      }
    });
  };
  function closestHide(el) {
    let parent2 = el.parentNode;
    if (!parent2)
      return;
    return parent2._x_hidePromise ? parent2 : closestHide(parent2);
  }
  function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
  }, after = () => {
  }) {
    if (el._x_transitioning)
      el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
      before();
      after();
      return;
    }
    let undoStart, undoDuring, undoEnd;
    performTransition(el, {
      start() {
        undoStart = setFunction(el, start2);
      },
      during() {
        undoDuring = setFunction(el, during);
      },
      before,
      end() {
        undoStart();
        undoEnd = setFunction(el, end);
      },
      after,
      cleanup() {
        undoDuring();
        undoEnd();
      }
    });
  }
  function performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = once(() => {
      mutateDom(() => {
        interrupted = true;
        if (!reachedBefore)
          stages.before();
        if (!reachedEnd) {
          stages.end();
          releaseNextTicks();
        }
        stages.after();
        if (el.isConnected)
          stages.cleanup();
        delete el._x_transitioning;
      });
    });
    el._x_transitioning = {
      beforeCancels: [],
      beforeCancel(callback) {
        this.beforeCancels.push(callback);
      },
      cancel: once(function() {
        while (this.beforeCancels.length) {
          this.beforeCancels.shift()();
        }
        ;
        finish();
      }),
      finish
    };
    mutateDom(() => {
      stages.start();
      stages.during();
    });
    holdNextTicks();
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
      let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
      if (duration === 0)
        duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
      mutateDom(() => {
        stages.before();
      });
      reachedBefore = true;
      requestAnimationFrame(() => {
        if (interrupted)
          return;
        mutateDom(() => {
          stages.end();
        });
        releaseNextTicks();
        setTimeout(el._x_transitioning.finish, duration + delay);
        reachedEnd = true;
      });
    });
  }
  function modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1)
      return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue)
      return fallback;
    if (key === "scale") {
      if (isNaN(rawValue))
        return fallback;
    }
    if (key === "duration" || key === "delay") {
      let match = rawValue.match(/([0-9]+)ms/);
      if (match)
        return match[1];
    }
    if (key === "origin") {
      if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
        return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
      }
    }
    return rawValue;
  }
  var isCloning = false;
  function skipDuringClone(callback, fallback = () => {
  }) {
    return (...args) => isCloning ? fallback(...args) : callback(...args);
  }
  function onlyDuringClone(callback) {
    return (...args) => isCloning && callback(...args);
  }
  function clone(oldEl, newEl) {
    if (!newEl._x_dataStack)
      newEl._x_dataStack = oldEl._x_dataStack;
    isCloning = true;
    dontRegisterReactiveSideEffects(() => {
      cloneTree(newEl);
    });
    isCloning = false;
  }
  function cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback) => {
      walk(el2, (el3, skip) => {
        if (hasRunThroughFirstEl && isRoot(el3))
          return skip();
        hasRunThroughFirstEl = true;
        callback(el3, skip);
      });
    };
    initTree(el, shallowWalker);
  }
  function dontRegisterReactiveSideEffects(callback) {
    let cache = effect;
    overrideEffect((callback2, el) => {
      let storedEffect = cache(callback2);
      release(storedEffect);
      return () => {
      };
    });
    callback();
    overrideEffect(cache);
  }
  function bind(el, name, value, modifiers = []) {
    if (!el._x_bindings)
      el._x_bindings = reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? camelCase(name) : name;
    switch (name) {
      case "value":
        bindInputValue(el, value);
        break;
      case "style":
        bindStyles(el, value);
        break;
      case "class":
        bindClasses(el, value);
        break;
      case "selected":
      case "checked":
        bindAttributeAndProperty(el, name, value);
        break;
      default:
        bindAttribute(el, name, value);
        break;
    }
  }
  function bindInputValue(el, value) {
    if (el.type === "radio") {
      if (el.attributes.value === void 0) {
        el.value = value;
      }
      if (window.fromModel) {
        el.checked = checkedAttrLooseCompare(el.value, value);
      }
    } else if (el.type === "checkbox") {
      if (Number.isInteger(value)) {
        el.value = value;
      } else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
        el.value = String(value);
      } else {
        if (Array.isArray(value)) {
          el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
        } else {
          el.checked = !!value;
        }
      }
    } else if (el.tagName === "SELECT") {
      updateSelect(el, value);
    } else {
      if (el.value === value)
        return;
      el.value = value;
    }
  }
  function bindClasses(el, value) {
    if (el._x_undoAddedClasses)
      el._x_undoAddedClasses();
    el._x_undoAddedClasses = setClasses(el, value);
  }
  function bindStyles(el, value) {
    if (el._x_undoAddedStyles)
      el._x_undoAddedStyles();
    el._x_undoAddedStyles = setStyles(el, value);
  }
  function bindAttributeAndProperty(el, name, value) {
    bindAttribute(el, name, value);
    setPropertyIfChanged(el, name, value);
  }
  function bindAttribute(el, name, value) {
    if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
      el.removeAttribute(name);
    } else {
      if (isBooleanAttr(name))
        value = name;
      setIfChanged(el, name, value);
    }
  }
  function setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) {
      el.setAttribute(attrName, value);
    }
  }
  function setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) {
      el[propName] = value;
    }
  }
  function updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2) => {
      return value2 + "";
    });
    Array.from(el.options).forEach((option) => {
      option.selected = arrayWrappedValue.includes(option.value);
    });
  }
  function camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
  }
  function checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
  }
  function isBooleanAttr(attrName) {
    const booleanAttributes = [
      "disabled",
      "checked",
      "required",
      "readonly",
      "hidden",
      "open",
      "selected",
      "autofocus",
      "itemscope",
      "multiple",
      "novalidate",
      "allowfullscreen",
      "allowpaymentrequest",
      "formnovalidate",
      "autoplay",
      "controls",
      "loop",
      "muted",
      "playsinline",
      "default",
      "ismap",
      "reversed",
      "async",
      "defer",
      "nomodule"
    ];
    return booleanAttributes.includes(attrName);
  }
  function attributeShouldntBePreservedIfFalsy(name) {
    return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
  }
  function getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0)
      return el._x_bindings[name];
    return getAttributeBinding(el, name, fallback);
  }
  function extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0)
      return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
      let binding = el._x_inlineBindings[name];
      binding.extract = extract;
      return dontAutoEvaluateFunctions(() => {
        return evaluate(el, binding.expression);
      });
    }
    return getAttributeBinding(el, name, fallback);
  }
  function getAttributeBinding(el, name, fallback) {
    let attr2 = el.getAttribute(name);
    if (attr2 === null)
      return typeof fallback === "function" ? fallback() : fallback;
    if (attr2 === "")
      return true;
    if (isBooleanAttr(name)) {
      return !![name, "true"].includes(attr2);
    }
    return attr2;
  }
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      let context = this, args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  function plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [callback];
    callbacks.forEach((i3) => i3(alpine_default));
  }
  var stores = {};
  var isReactive = false;
  function store(name, value) {
    if (!isReactive) {
      stores = reactive(stores);
      isReactive = true;
    }
    if (value === void 0) {
      return stores[name];
    }
    stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
      stores[name].init();
    }
    initInterceptors(stores[name]);
  }
  function getStores() {
    return stores;
  }
  var binds = {};
  function bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
    if (name instanceof Element) {
      applyBindingsObject(name, getBindings());
    } else {
      binds[name] = getBindings;
    }
  }
  function injectBindingProviders(obj) {
    Object.entries(binds).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback(...args);
          };
        }
      });
    });
    return obj;
  }
  function applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while (cleanupRunners.length)
      cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(attributes);
    attributes = attributes.map((attribute) => {
      if (staticAttributes.find((attr2) => attr2.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    directives(el, attributes, original).map((handle) => {
      cleanupRunners.push(handle.runCleanups);
      handle();
    });
  }
  var datas = {};
  function data(name, callback) {
    datas[name] = callback;
  }
  function injectDataProviders(obj, context) {
    Object.entries(datas).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback.bind(context)(...args);
          };
        },
        enumerable: false
      });
    });
    return obj;
  }
  var Alpine = {
    get reactive() {
      return reactive;
    },
    get release() {
      return release;
    },
    get effect() {
      return effect;
    },
    get raw() {
      return raw;
    },
    version: "3.12.3",
    flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions,
    disableEffectScheduling,
    startObservingMutations,
    stopObservingMutations,
    setReactivityEngine,
    closestDataStack,
    skipDuringClone,
    onlyDuringClone,
    addRootSelector,
    addInitSelector,
    addScopeToNode,
    deferMutations,
    mapAttributes,
    evaluateLater,
    interceptInit,
    setEvaluator,
    mergeProxies,
    extractProp,
    findClosest,
    closestRoot,
    destroyTree,
    interceptor,
    transition,
    setStyles,
    mutateDom,
    directive,
    throttle,
    debounce,
    evaluate,
    initTree,
    nextTick,
    prefixed: prefix,
    prefix: setPrefix,
    plugin,
    magic,
    store,
    start,
    clone,
    bound: getBinding,
    $data: scope,
    walk,
    data,
    bind: bind2
  };
  var alpine_default = Alpine;
  function makeMap(str, expectsLowerCase) {
    const map2 = Object.create(null);
    const list = str.split(",");
    for (let i3 = 0; i3 < list.length; i3++) {
      map2[list[i3]] = true;
    }
    return expectsLowerCase ? (val) => !!map2[val.toLowerCase()] : (val) => !!map2[val];
  }
  var PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
  };
  var slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
  };
  var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isBooleanAttr2 = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
  var EMPTY_OBJ = true ? Object.freeze({}) : {};
  var EMPTY_ARR = true ? Object.freeze([]) : [];
  var extend = Object.assign;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasOwn = (val, key) => hasOwnProperty.call(val, key);
  var isArray = Array.isArray;
  var isMap = (val) => toTypeString(val) === "[object Map]";
  var isString = (val) => typeof val === "string";
  var isSymbol = (val) => typeof val === "symbol";
  var isObject = (val) => val !== null && typeof val === "object";
  var objectToString = Object.prototype.toString;
  var toTypeString = (value) => objectToString.call(value);
  var toRawType = (value) => {
    return toTypeString(value).slice(8, -1);
  };
  var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
  var cacheStringFunction = (fn) => {
    const cache = Object.create(null);
    return (str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  };
  var camelizeRE = /-(\w)/g;
  var camelize = cacheStringFunction((str) => {
    return str.replace(camelizeRE, (_3, c4) => c4 ? c4.toUpperCase() : "");
  });
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
  var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
  var toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
  var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
  var targetMap = new WeakMap();
  var effectStack = [];
  var activeEffect;
  var ITERATE_KEY = Symbol(true ? "iterate" : "");
  var MAP_KEY_ITERATE_KEY = Symbol(true ? "Map key iterate" : "");
  function isEffect(fn) {
    return fn && fn._isEffect === true;
  }
  function effect2(fn, options = EMPTY_OBJ) {
    if (isEffect(fn)) {
      fn = fn.raw;
    }
    const effect32 = createReactiveEffect(fn, options);
    if (!options.lazy) {
      effect32();
    }
    return effect32;
  }
  function stop(effect32) {
    if (effect32.active) {
      cleanup(effect32);
      if (effect32.options.onStop) {
        effect32.options.onStop();
      }
      effect32.active = false;
    }
  }
  var uid = 0;
  function createReactiveEffect(fn, options) {
    const effect32 = function reactiveEffect() {
      if (!effect32.active) {
        return fn();
      }
      if (!effectStack.includes(effect32)) {
        cleanup(effect32);
        try {
          enableTracking();
          effectStack.push(effect32);
          activeEffect = effect32;
          return fn();
        } finally {
          effectStack.pop();
          resetTracking();
          activeEffect = effectStack[effectStack.length - 1];
        }
      }
    };
    effect32.id = uid++;
    effect32.allowRecurse = !!options.allowRecurse;
    effect32._isEffect = true;
    effect32.active = true;
    effect32.raw = fn;
    effect32.deps = [];
    effect32.options = options;
    return effect32;
  }
  function cleanup(effect32) {
    const { deps } = effect32;
    if (deps.length) {
      for (let i3 = 0; i3 < deps.length; i3++) {
        deps[i3].delete(effect32);
      }
      deps.length = 0;
    }
  }
  var shouldTrack = true;
  var trackStack = [];
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function track(target, type, key) {
    if (!shouldTrack || activeEffect === void 0) {
      return;
    }
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = new Set());
    }
    if (!dep.has(activeEffect)) {
      dep.add(activeEffect);
      activeEffect.deps.push(dep);
      if (activeEffect.options.onTrack) {
        activeEffect.options.onTrack({
          effect: activeEffect,
          target,
          type,
          key
        });
      }
    }
  }
  function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
      return;
    }
    const effects = new Set();
    const add22 = (effectsToAdd) => {
      if (effectsToAdd) {
        effectsToAdd.forEach((effect32) => {
          if (effect32 !== activeEffect || effect32.allowRecurse) {
            effects.add(effect32);
          }
        });
      }
    };
    if (type === "clear") {
      depsMap.forEach(add22);
    } else if (key === "length" && isArray(target)) {
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 >= newValue) {
          add22(dep);
        }
      });
    } else {
      if (key !== void 0) {
        add22(depsMap.get(key));
      }
      switch (type) {
        case "add":
          if (!isArray(target)) {
            add22(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add22(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isIntegerKey(key)) {
            add22(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!isArray(target)) {
            add22(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add22(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            add22(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
    const run = (effect32) => {
      if (effect32.options.onTrigger) {
        effect32.options.onTrigger({
          effect: effect32,
          target,
          key,
          type,
          newValue,
          oldValue,
          oldTarget
        });
      }
      if (effect32.options.scheduler) {
        effect32.options.scheduler(effect32);
      } else {
        effect32();
      }
    };
    effects.forEach(run);
  }
  var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
  var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
  var get2 = /* @__PURE__ */ createGetter();
  var shallowGet = /* @__PURE__ */ createGetter(false, true);
  var readonlyGet = /* @__PURE__ */ createGetter(true);
  var shallowReadonlyGet = /* @__PURE__ */ createGetter(true, true);
  var arrayInstrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    const method = Array.prototype[key];
    arrayInstrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i3 = 0, l3 = this.length; i3 < l3; i3++) {
        track(arr, "get", i3 + "");
      }
      const res = method.apply(arr, args);
      if (res === -1 || res === false) {
        return method.apply(arr, args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    const method = Array.prototype[key];
    arrayInstrumentations[key] = function(...args) {
      pauseTracking();
      const res = method.apply(this, args);
      resetTracking();
      return res;
    };
  });
  function createGetter(isReadonly2 = false, shallow = false) {
    return function get32(target, key, receiver) {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
        return target;
      }
      const targetIsArray = isArray(target);
      if (!isReadonly2 && targetIsArray && hasOwn(arrayInstrumentations, key)) {
        return Reflect.get(arrayInstrumentations, key, receiver);
      }
      const res = Reflect.get(target, key, receiver);
      if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
        return res;
      }
      if (!isReadonly2) {
        track(target, "get", key);
      }
      if (shallow) {
        return res;
      }
      if (isRef(res)) {
        const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
        return shouldUnwrap ? res.value : res;
      }
      if (isObject(res)) {
        return isReadonly2 ? readonly(res) : reactive2(res);
      }
      return res;
    };
  }
  var set2 = /* @__PURE__ */ createSetter();
  var shallowSet = /* @__PURE__ */ createSetter(true);
  function createSetter(shallow = false) {
    return function set32(target, key, value, receiver) {
      let oldValue = target[key];
      if (!shallow) {
        value = toRaw(value);
        oldValue = toRaw(oldValue);
        if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
          oldValue.value = value;
          return true;
        }
      }
      const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
      const result = Reflect.set(target, key, value, receiver);
      if (target === toRaw(receiver)) {
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value, oldValue);
        }
      }
      return result;
    };
  }
  function deleteProperty(target, key) {
    const hadKey = hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function has(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol(key) || !builtInSymbols.has(key)) {
      track(target, "has", key);
    }
    return result;
  }
  function ownKeys(target) {
    track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
    return Reflect.ownKeys(target);
  }
  var mutableHandlers = {
    get: get2,
    set: set2,
    deleteProperty,
    has,
    ownKeys
  };
  var readonlyHandlers = {
    get: readonlyGet,
    set(target, key) {
      if (true) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    },
    deleteProperty(target, key) {
      if (true) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    }
  };
  var shallowReactiveHandlers = extend({}, mutableHandlers, {
    get: shallowGet,
    set: shallowSet
  });
  var shallowReadonlyHandlers = extend({}, readonlyHandlers, {
    get: shallowReadonlyGet
  });
  var toReactive = (value) => isObject(value) ? reactive2(value) : value;
  var toReadonly = (value) => isObject(value) ? readonly(value) : value;
  var toShallow = (value) => value;
  var getProto = (v3) => Reflect.getPrototypeOf(v3);
  function get$1(target, key, isReadonly2 = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (key !== rawKey) {
      !isReadonly2 && track(rawTarget, "get", key);
    }
    !isReadonly2 && track(rawTarget, "get", rawKey);
    const { has: has22 } = getProto(rawTarget);
    const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
    if (has22.call(rawTarget, key)) {
      return wrap(target.get(key));
    } else if (has22.call(rawTarget, rawKey)) {
      return wrap(target.get(rawKey));
    } else if (target !== rawTarget) {
      target.get(key);
    }
  }
  function has$1(key, isReadonly2 = false) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (key !== rawKey) {
      !isReadonly2 && track(rawTarget, "has", key);
    }
    !isReadonly2 && track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
  }
  function size(target, isReadonly2 = false) {
    target = target["__v_raw"];
    !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
  }
  function add(value) {
    value = toRaw(value);
    const target = toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
      target.add(value);
      trigger(target, "add", value, value);
    }
    return this;
  }
  function set$1(key, value) {
    value = toRaw(value);
    const target = toRaw(this);
    const { has: has22, get: get32 } = getProto(target);
    let hadKey = has22.call(target, key);
    if (!hadKey) {
      key = toRaw(key);
      hadKey = has22.call(target, key);
    } else if (true) {
      checkIdentityKeys(target, has22, key);
    }
    const oldValue = get32.call(target, key);
    target.set(key, value);
    if (!hadKey) {
      trigger(target, "add", key, value);
    } else if (hasChanged(value, oldValue)) {
      trigger(target, "set", key, value, oldValue);
    }
    return this;
  }
  function deleteEntry(key) {
    const target = toRaw(this);
    const { has: has22, get: get32 } = getProto(target);
    let hadKey = has22.call(target, key);
    if (!hadKey) {
      key = toRaw(key);
      hadKey = has22.call(target, key);
    } else if (true) {
      checkIdentityKeys(target, has22, key);
    }
    const oldValue = get32 ? get32.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) {
      trigger(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function clear() {
    const target = toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = true ? isMap(target) ? new Map(target) : new Set(target) : void 0;
    const result = target.clear();
    if (hadItems) {
      trigger(target, "clear", void 0, void 0, oldTarget);
    }
    return result;
  }
  function createForEach(isReadonly2, isShallow) {
    return function forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = toRaw(target);
      const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
      !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap(value), wrap(key), observed);
      });
    };
  }
  function createIterableMethod(method, isReadonly2, isShallow) {
    return function(...args) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
      !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
      return {
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
            done
          };
        },
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      if (true) {
        const key = args[0] ? `on key "${args[0]}" ` : ``;
        console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
      }
      return type === "delete" ? false : this;
    };
  }
  var mutableInstrumentations = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  var shallowInstrumentations = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  var readonlyInstrumentations = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, false)
  };
  var shallowReadonlyInstrumentations = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, true)
  };
  var iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations[method] = createIterableMethod(method, true, false);
    shallowInstrumentations[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations[method] = createIterableMethod(method, true, true);
  });
  function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
    return (target, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw") {
        return target;
      }
      return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
  }
  var mutableCollectionHandlers = {
    get: createInstrumentationGetter(false, false)
  };
  var shallowCollectionHandlers = {
    get: createInstrumentationGetter(false, true)
  };
  var readonlyCollectionHandlers = {
    get: createInstrumentationGetter(true, false)
  };
  var shallowReadonlyCollectionHandlers = {
    get: createInstrumentationGetter(true, true)
  };
  function checkIdentityKeys(target, has22, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has22.call(target, rawKey)) {
      const type = toRawType(target);
      console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
  }
  var reactiveMap = new WeakMap();
  var shallowReactiveMap = new WeakMap();
  var readonlyMap = new WeakMap();
  var shallowReadonlyMap = new WeakMap();
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
  }
  function reactive2(target) {
    if (target && target["__v_isReadonly"]) {
      return target;
    }
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
  }
  function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
  }
  function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject(target)) {
      if (true) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
      }
      return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = getTargetType(target);
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
  }
  function toRaw(observed) {
    return observed && toRaw(observed["__v_raw"]) || observed;
  }
  function isRef(r2) {
    return Boolean(r2 && r2.__v_isRef === true);
  }
  magic("nextTick", () => nextTick);
  magic("dispatch", (el) => dispatch.bind(dispatch, el));
  magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect32 }) => (key, callback) => {
    let evaluate2 = evaluateLater2(key);
    let firstTime = true;
    let oldValue;
    let effectReference = effect32(() => evaluate2((value) => {
      JSON.stringify(value);
      if (!firstTime) {
        queueMicrotask(() => {
          callback(value, oldValue);
          oldValue = value;
        });
      } else {
        oldValue = value;
      }
      firstTime = false;
    }));
    el._x_effects.delete(effectReference);
  });
  magic("store", getStores);
  magic("data", (el) => scope(el));
  magic("root", (el) => closestRoot(el));
  magic("refs", (el) => {
    if (el._x_refs_proxy)
      return el._x_refs_proxy;
    el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
    return el._x_refs_proxy;
  });
  function getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while (currentEl) {
      if (currentEl._x_refs)
        refObjects.push(currentEl._x_refs);
      currentEl = currentEl.parentNode;
    }
    return refObjects;
  }
  var globalIdMemo = {};
  function findAndIncrementId(name) {
    if (!globalIdMemo[name])
      globalIdMemo[name] = 0;
    return ++globalIdMemo[name];
  }
  function closestIdRoot(el, name) {
    return findClosest(el, (element) => {
      if (element._x_ids && element._x_ids[name])
        return true;
    });
  }
  function setIdRoot(el, name) {
    if (!el._x_ids)
      el._x_ids = {};
    if (!el._x_ids[name])
      el._x_ids[name] = findAndIncrementId(name);
  }
  magic("id", (el) => (name, key = null) => {
    let root = closestIdRoot(el, name);
    let id = root ? root._x_ids[name] : findAndIncrementId(name);
    return key ? `${name}-${id}-${key}` : `${name}-${id}`;
  });
  magic("el", (el) => el);
  warnMissingPluginMagic("Focus", "focus", "focus");
  warnMissingPluginMagic("Persist", "persist", "persist");
  function warnMissingPluginMagic(name, magicName, slug) {
    magic(magicName, (el) => warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash, innerHash, outerHashLatest, innerHashLatest;
    let reference = effect(() => {
      let outer, inner;
      if (firstRun) {
        outer = outerGet();
        innerSet(outer);
        inner = innerGet();
        firstRun = false;
      } else {
        outer = outerGet();
        inner = innerGet();
        outerHashLatest = JSON.stringify(outer);
        innerHashLatest = JSON.stringify(inner);
        if (outerHashLatest !== outerHash) {
          inner = innerGet();
          innerSet(outer);
          inner = outer;
        } else {
          outerSet(inner);
          outer = inner;
        }
      }
      outerHash = JSON.stringify(outer);
      innerHash = JSON.stringify(inner);
    });
    return () => {
      release(reference);
    };
  }
  directive("modelable", (el, { expression }, { effect: effect32, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
    let func = evaluateLater2(expression);
    let innerGet = () => {
      let result;
      func((i3) => result = i3);
      return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val) => evaluateInnerSet(() => {
    }, { scope: { __placeholder: val } });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(() => {
      if (!el._x_model)
        return;
      el._x_removeModelListeners["default"]();
      let outerGet = el._x_model.get;
      let outerSet = el._x_model.set;
      let releaseEntanglement = entangle({
        get() {
          return outerGet();
        },
        set(value) {
          outerSet(value);
        }
      }, {
        get() {
          return innerGet();
        },
        set(value) {
          innerSet(value);
        }
      });
      cleanup2(releaseEntanglement);
    });
  });
  var teleportContainerDuringClone = document.createElement("div");
  directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
    if (el.tagName.toLowerCase() !== "template")
      warn("x-teleport can only be used on a <template> tag", el);
    let target = skipDuringClone(() => {
      return document.querySelector(expression);
    }, () => {
      return teleportContainerDuringClone;
    })();
    if (!target)
      warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) {
      el._x_forwardEvents.forEach((eventName) => {
        clone2.addEventListener(eventName, (e2) => {
          e2.stopPropagation();
          el.dispatchEvent(new e2.constructor(e2.type, e2));
        });
      });
    }
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      if (modifiers.includes("prepend")) {
        target.parentNode.insertBefore(clone2, target);
      } else if (modifiers.includes("append")) {
        target.parentNode.insertBefore(clone2, target.nextSibling);
      } else {
        target.appendChild(clone2);
      }
      initTree(clone2);
      clone2._x_ignore = true;
    });
    cleanup2(() => clone2.remove());
  });
  var handler = () => {
  };
  handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(() => {
      modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
  };
  directive("ignore", handler);
  directive("effect", (el, { expression }, { effect: effect32 }) => effect32(evaluateLater(el, expression)));
  function on(el, event2, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e2) => callback(e2);
    let options = {};
    let wrapHandler = (callback2, wrapper) => (e2) => wrapper(callback2, e2);
    if (modifiers.includes("dot"))
      event2 = dotSyntax(event2);
    if (modifiers.includes("camel"))
      event2 = camelCase2(event2);
    if (modifiers.includes("passive"))
      options.passive = true;
    if (modifiers.includes("capture"))
      options.capture = true;
    if (modifiers.includes("window"))
      listenerTarget = window;
    if (modifiers.includes("document"))
      listenerTarget = document;
    if (modifiers.includes("debounce")) {
      let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler4 = debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
      let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler4 = throttle(handler4, wait);
    }
    if (modifiers.includes("prevent"))
      handler4 = wrapHandler(handler4, (next2, e2) => {
        e2.preventDefault();
        next2(e2);
      });
    if (modifiers.includes("stop"))
      handler4 = wrapHandler(handler4, (next2, e2) => {
        e2.stopPropagation();
        next2(e2);
      });
    if (modifiers.includes("self"))
      handler4 = wrapHandler(handler4, (next2, e2) => {
        e2.target === el && next2(e2);
      });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
      listenerTarget = document;
      handler4 = wrapHandler(handler4, (next2, e2) => {
        if (el.contains(e2.target))
          return;
        if (e2.target.isConnected === false)
          return;
        if (el.offsetWidth < 1 && el.offsetHeight < 1)
          return;
        if (el._x_isShown === false)
          return;
        next2(e2);
      });
    }
    if (modifiers.includes("once")) {
      handler4 = wrapHandler(handler4, (next2, e2) => {
        next2(e2);
        listenerTarget.removeEventListener(event2, handler4, options);
      });
    }
    handler4 = wrapHandler(handler4, (next2, e2) => {
      if (isKeyEvent(event2)) {
        if (isListeningForASpecificKeyThatHasntBeenPressed(e2, modifiers)) {
          return;
        }
      }
      next2(e2);
    });
    listenerTarget.addEventListener(event2, handler4, options);
    return () => {
      listenerTarget.removeEventListener(event2, handler4, options);
    };
  }
  function dotSyntax(subject) {
    return subject.replace(/-/g, ".");
  }
  function camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
  }
  function isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function kebabCase2(subject) {
    if ([" ", "_"].includes(subject))
      return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
  }
  function isKeyEvent(event2) {
    return ["keydown", "keyup"].includes(event2);
  }
  function isListeningForASpecificKeyThatHasntBeenPressed(e2, modifiers) {
    let keyModifiers = modifiers.filter((i3) => {
      return !["window", "document", "prevent", "stop", "once", "capture"].includes(i3);
    });
    if (keyModifiers.includes("debounce")) {
      let debounceIndex = keyModifiers.indexOf("debounce");
      keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
      let debounceIndex = keyModifiers.indexOf("throttle");
      keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0)
      return false;
    if (keyModifiers.length === 1 && keyToModifiers(e2.key).includes(keyModifiers[0]))
      return false;
    const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i3) => !selectedSystemKeyModifiers.includes(i3));
    if (selectedSystemKeyModifiers.length > 0) {
      const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
        if (modifier === "cmd" || modifier === "super")
          modifier = "meta";
        return e2[`${modifier}Key`];
      });
      if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
        if (keyToModifiers(e2.key).includes(keyModifiers[0]))
          return false;
      }
    }
    return true;
  }
  function keyToModifiers(key) {
    if (!key)
      return [];
    key = kebabCase2(key);
    let modifierToKeyMap = {
      ctrl: "control",
      slash: "/",
      space: " ",
      spacebar: " ",
      cmd: "meta",
      esc: "escape",
      up: "arrow-up",
      down: "arrow-down",
      left: "arrow-left",
      right: "arrow-right",
      period: ".",
      equal: "=",
      minus: "-",
      underscore: "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier) => {
      if (modifierToKeyMap[modifier] === key)
        return modifier;
    }).filter((modifier) => modifier);
  }
  directive("model", (el, { modifiers, expression }, { effect: effect32, cleanup: cleanup2 }) => {
    let scopeTarget = el;
    if (modifiers.includes("parent")) {
      scopeTarget = el.parentNode;
    }
    let evaluateGet = evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") {
      evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
    } else if (typeof expression === "function" && typeof expression() === "string") {
      evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    } else {
      evaluateSet = () => {
      };
    }
    let getValue2 = () => {
      let result;
      evaluateGet((value) => result = value);
      return isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value) => {
      let result;
      evaluateGet((value2) => result = value2);
      if (isGetterSetter(result)) {
        result.set(value);
      } else {
        evaluateSet(() => {
        }, {
          scope: { __placeholder: value }
        });
      }
    };
    if (typeof expression === "string" && el.type === "radio") {
      mutateDom(() => {
        if (!el.hasAttribute("name"))
          el.setAttribute("name", expression);
      });
    }
    var event2 = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = isCloning ? () => {
    } : on(el, event2, modifiers, (e2) => {
      setValue(getInputValue(el, modifiers, e2, getValue2()));
    });
    if (modifiers.includes("fill") && [null, ""].includes(getValue2())) {
      el.dispatchEvent(new Event(event2, {}));
    }
    if (!el._x_removeModelListeners)
      el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(() => el._x_removeModelListeners["default"]());
    if (el.form) {
      let removeResetListener = on(el.form, "reset", [], (e2) => {
        nextTick(() => el._x_model && el._x_model.set(el.value));
      });
      cleanup2(() => removeResetListener());
    }
    el._x_model = {
      get() {
        return getValue2();
      },
      set(value) {
        setValue(value);
      }
    };
    el._x_forceModelUpdate = (value) => {
      value = value === void 0 ? getValue2() : value;
      if (value === void 0 && typeof expression === "string" && expression.match(/\./))
        value = "";
      window.fromModel = true;
      mutateDom(() => bind(el, "value", value));
      delete window.fromModel;
    };
    effect32(() => {
      let value = getValue2();
      if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
        return;
      el._x_forceModelUpdate(value);
    });
  });
  function getInputValue(el, modifiers, event2, currentValue) {
    return mutateDom(() => {
      if (event2 instanceof CustomEvent && event2.detail !== void 0)
        return event2.detail ?? event2.target.value;
      else if (el.type === "checkbox") {
        if (Array.isArray(currentValue)) {
          let newValue = modifiers.includes("number") ? safeParseNumber(event2.target.value) : event2.target.value;
          return event2.target.checked ? currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
        } else {
          return event2.target.checked;
        }
      } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
        return modifiers.includes("number") ? Array.from(event2.target.selectedOptions).map((option) => {
          let rawValue = option.value || option.text;
          return safeParseNumber(rawValue);
        }) : Array.from(event2.target.selectedOptions).map((option) => {
          return option.value || option.text;
        });
      } else {
        let rawValue = event2.target.value;
        return modifiers.includes("number") ? safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
      }
    });
  }
  function safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return isNumeric2(number) ? number : rawValue;
  }
  function checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
  }
  function isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
  }
  directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
  addInitSelector(() => `[${prefix("init")}]`);
  directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "string") {
      return !!expression.trim() && evaluate2(expression, {}, false);
    }
    return evaluate2(expression, {}, false);
  }));
  directive("text", (el, { expression }, { effect: effect32, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect32(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.textContent = value;
        });
      });
    });
  });
  directive("html", (el, { expression }, { effect: effect32, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect32(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.innerHTML = value;
          el._x_ignoreSelf = true;
          initTree(el);
          delete el._x_ignoreSelf;
        });
      });
    });
  });
  mapAttributes(startingWith(":", into(prefix("bind:"))));
  var handler2 = (el, { value, modifiers, expression, original }, { effect: effect32 }) => {
    if (!value) {
      let bindingProviders = {};
      injectBindingProviders(bindingProviders);
      let getBindings = evaluateLater(el, expression);
      getBindings((bindings) => {
        applyBindingsObject(el, bindings, original);
      }, { scope: bindingProviders });
      return;
    }
    if (value === "key")
      return storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) {
      return;
    }
    let evaluate2 = evaluateLater(el, expression);
    effect32(() => evaluate2((result) => {
      if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
        result = "";
      }
      mutateDom(() => bind(el, value, result, modifiers));
    }));
  };
  handler2.inline = (el, { value, modifiers, expression }) => {
    if (!value)
      return;
    if (!el._x_inlineBindings)
      el._x_inlineBindings = {};
    el._x_inlineBindings[value] = { expression, extract: false };
  };
  directive("bind", handler2);
  function storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
  }
  addRootSelector(() => `[${prefix("data")}]`);
  directive("data", skipDuringClone((el, { expression }, { cleanup: cleanup2 }) => {
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    injectMagics(magicContext, el);
    let dataProviderContext = {};
    injectDataProviders(dataProviderContext, magicContext);
    let data2 = evaluate(el, expression, { scope: dataProviderContext });
    if (data2 === void 0 || data2 === true)
      data2 = {};
    injectMagics(data2, el);
    let reactiveData = reactive(data2);
    initInterceptors(reactiveData);
    let undo = addScopeToNode(el, reactiveData);
    reactiveData["init"] && evaluate(el, reactiveData["init"]);
    cleanup2(() => {
      reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
      undo();
    });
  }));
  directive("show", (el, { modifiers, expression }, { effect: effect32 }) => {
    let evaluate2 = evaluateLater(el, expression);
    if (!el._x_doHide)
      el._x_doHide = () => {
        mutateDom(() => {
          el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
      };
    if (!el._x_doShow)
      el._x_doShow = () => {
        mutateDom(() => {
          if (el.style.length === 1 && el.style.display === "none") {
            el.removeAttribute("style");
          } else {
            el.style.removeProperty("display");
          }
        });
      };
    let hide = () => {
      el._x_doHide();
      el._x_isShown = false;
    };
    let show = () => {
      el._x_doShow();
      el._x_isShown = true;
    };
    let clickAwayCompatibleShow = () => setTimeout(show);
    let toggle = once((value) => value ? show() : hide(), (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    });
    let oldValue;
    let firstTime = true;
    effect32(() => evaluate2((value) => {
      if (!firstTime && value === oldValue)
        return;
      if (modifiers.includes("immediate"))
        value ? clickAwayCompatibleShow() : hide();
      toggle(value);
      oldValue = value;
      firstTime = false;
    }));
  });
  directive("for", (el, { expression }, { effect: effect32, cleanup: cleanup2 }) => {
    let iteratorNames = parseForExpression(expression);
    let evaluateItems = evaluateLater(el, iteratorNames.items);
    let evaluateKey = evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect32(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(() => {
      Object.values(el._x_lookup).forEach((el2) => el2.remove());
      delete el._x_prevKeys;
      delete el._x_lookup;
    });
  });
  function loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject22 = (i3) => typeof i3 === "object" && !Array.isArray(i3);
    let templateEl = el;
    evaluateItems((items) => {
      if (isNumeric3(items) && items >= 0) {
        items = Array.from(Array(items).keys(), (i3) => i3 + 1);
      }
      if (items === void 0)
        items = [];
      let lookup = el._x_lookup;
      let prevKeys = el._x_prevKeys;
      let scopes = [];
      let keys = [];
      if (isObject22(items)) {
        items = Object.entries(items).map(([key, value]) => {
          let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
          evaluateKey((value2) => keys.push(value2), { scope: { index: key, ...scope2 } });
          scopes.push(scope2);
        });
      } else {
        for (let i3 = 0; i3 < items.length; i3++) {
          let scope2 = getIterationScopeVariables(iteratorNames, items[i3], i3, items);
          evaluateKey((value) => keys.push(value), { scope: { index: i3, ...scope2 } });
          scopes.push(scope2);
        }
      }
      let adds = [];
      let moves = [];
      let removes = [];
      let sames = [];
      for (let i3 = 0; i3 < prevKeys.length; i3++) {
        let key = prevKeys[i3];
        if (keys.indexOf(key) === -1)
          removes.push(key);
      }
      prevKeys = prevKeys.filter((key) => !removes.includes(key));
      let lastKey = "template";
      for (let i3 = 0; i3 < keys.length; i3++) {
        let key = keys[i3];
        let prevIndex = prevKeys.indexOf(key);
        if (prevIndex === -1) {
          prevKeys.splice(i3, 0, key);
          adds.push([lastKey, i3]);
        } else if (prevIndex !== i3) {
          let keyInSpot = prevKeys.splice(i3, 1)[0];
          let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
          prevKeys.splice(i3, 0, keyForSpot);
          prevKeys.splice(prevIndex, 0, keyInSpot);
          moves.push([keyInSpot, keyForSpot]);
        } else {
          sames.push(key);
        }
        lastKey = key;
      }
      for (let i3 = 0; i3 < removes.length; i3++) {
        let key = removes[i3];
        if (!!lookup[key]._x_effects) {
          lookup[key]._x_effects.forEach(dequeueJob);
        }
        lookup[key].remove();
        lookup[key] = null;
        delete lookup[key];
      }
      for (let i3 = 0; i3 < moves.length; i3++) {
        let [keyInSpot, keyForSpot] = moves[i3];
        let elInSpot = lookup[keyInSpot];
        let elForSpot = lookup[keyForSpot];
        let marker = document.createElement("div");
        mutateDom(() => {
          if (!elForSpot)
            warn(`x-for ":key" is undefined or invalid`, templateEl);
          elForSpot.after(marker);
          elInSpot.after(elForSpot);
          elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
          marker.before(elInSpot);
          elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
          marker.remove();
        });
        elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
      }
      for (let i3 = 0; i3 < adds.length; i3++) {
        let [lastKey2, index3] = adds[i3];
        let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
        if (lastEl._x_currentIfEl)
          lastEl = lastEl._x_currentIfEl;
        let scope2 = scopes[index3];
        let key = keys[index3];
        let clone2 = document.importNode(templateEl.content, true).firstElementChild;
        let reactiveScope = reactive(scope2);
        addScopeToNode(clone2, reactiveScope, templateEl);
        clone2._x_refreshXForScope = (newScope) => {
          Object.entries(newScope).forEach(([key2, value]) => {
            reactiveScope[key2] = value;
          });
        };
        mutateDom(() => {
          lastEl.after(clone2);
          initTree(clone2);
        });
        if (typeof key === "object") {
          warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
        }
        lookup[key] = clone2;
      }
      for (let i3 = 0; i3 < sames.length; i3++) {
        lookup[sames[i3]]._x_refreshXForScope(scopes[keys.indexOf(sames[i3])]);
      }
      templateEl._x_prevKeys = keys;
    });
  }
  function parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch)
      return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
      res.item = item.replace(forIteratorRE, "").trim();
      res.index = iteratorMatch[1].trim();
      if (iteratorMatch[2]) {
        res.collection = iteratorMatch[2].trim();
      }
    } else {
      res.item = item;
    }
    return res;
  }
  function getIterationScopeVariables(iteratorNames, item, index3, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
      let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i3) => i3.trim());
      names.forEach((name, i3) => {
        scopeVariables[name] = item[i3];
      });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
      let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i3) => i3.trim());
      names.forEach((name) => {
        scopeVariables[name] = item[name];
      });
    } else {
      scopeVariables[iteratorNames.item] = item;
    }
    if (iteratorNames.index)
      scopeVariables[iteratorNames.index] = index3;
    if (iteratorNames.collection)
      scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
  }
  function isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function handler3() {
  }
  handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
    let root = closestRoot(el);
    if (!root._x_refs)
      root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(() => delete root._x_refs[expression]);
  };
  directive("ref", handler3);
  directive("if", (el, { expression }, { effect: effect32, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater(el, expression);
    let show = () => {
      if (el._x_currentIfEl)
        return el._x_currentIfEl;
      let clone2 = el.content.cloneNode(true).firstElementChild;
      addScopeToNode(clone2, {}, el);
      mutateDom(() => {
        el.after(clone2);
        initTree(clone2);
      });
      el._x_currentIfEl = clone2;
      el._x_undoIf = () => {
        walk(clone2, (node2) => {
          if (!!node2._x_effects) {
            node2._x_effects.forEach(dequeueJob);
          }
        });
        clone2.remove();
        delete el._x_currentIfEl;
      };
      return clone2;
    };
    let hide = () => {
      if (!el._x_undoIf)
        return;
      el._x_undoIf();
      delete el._x_undoIf;
    };
    effect32(() => evaluate2((value) => {
      value ? show() : hide();
    }));
    cleanup2(() => el._x_undoIf && el._x_undoIf());
  });
  directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
    let names = evaluate2(expression);
    names.forEach((name) => setIdRoot(el, name));
  });
  mapAttributes(startingWith("@", into(prefix("on:"))));
  directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
    let evaluate2 = expression ? evaluateLater(el, expression) : () => {
    };
    if (el.tagName.toLowerCase() === "template") {
      if (!el._x_forwardEvents)
        el._x_forwardEvents = [];
      if (!el._x_forwardEvents.includes(value))
        el._x_forwardEvents.push(value);
    }
    let removeListener = on(el, value, modifiers, (e2) => {
      evaluate2(() => {
      }, { scope: { $event: e2 }, params: [e2] });
    });
    cleanup2(() => removeListener());
  }));
  warnMissingPluginDirective("Collapse", "collapse", "collapse");
  warnMissingPluginDirective("Intersect", "intersect", "intersect");
  warnMissingPluginDirective("Focus", "trap", "focus");
  warnMissingPluginDirective("Mask", "mask", "mask");
  function warnMissingPluginDirective(name, directiveName2, slug) {
    directive(directiveName2, (el) => warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  alpine_default.setEvaluator(normalEvaluator);
  alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
  var src_default = alpine_default;
  var module_default = src_default;

  // node_modules/@alpinejs/collapse/dist/module.esm.js
  function src_default2(Alpine2) {
    Alpine2.directive("collapse", collapse);
    collapse.inline = (el, { modifiers }) => {
      if (!modifiers.includes("min"))
        return;
      el._x_doShow = () => {
      };
      el._x_doHide = () => {
      };
    };
    function collapse(el, { modifiers }) {
      let duration = modifierValue2(modifiers, "duration", 250) / 1e3;
      let floor = modifierValue2(modifiers, "min", 0);
      let fullyHide = !modifiers.includes("min");
      if (!el._x_isShown)
        el.style.height = `${floor}px`;
      if (!el._x_isShown && fullyHide)
        el.hidden = true;
      if (!el._x_isShown)
        el.style.overflow = "hidden";
      let setFunction = (el2, styles2) => {
        let revertFunction = Alpine2.setStyles(el2, styles2);
        return styles2.height ? () => {
        } : revertFunction;
      };
      let transitionStyles = {
        transitionProperty: "height",
        transitionDuration: `${duration}s`,
        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
      };
      el._x_transition = {
        in(before = () => {
        }, after = () => {
        }) {
          if (fullyHide)
            el.hidden = false;
          if (fullyHide)
            el.style.display = null;
          let current = el.getBoundingClientRect().height;
          el.style.height = "auto";
          let full = el.getBoundingClientRect().height;
          if (current === full) {
            current = floor;
          }
          Alpine2.transition(el, Alpine2.setStyles, {
            during: transitionStyles,
            start: { height: current + "px" },
            end: { height: full + "px" }
          }, () => el._x_isShown = true, () => {
            if (el.getBoundingClientRect().height == full) {
              el.style.overflow = null;
            }
          });
        },
        out(before = () => {
        }, after = () => {
        }) {
          let full = el.getBoundingClientRect().height;
          Alpine2.transition(el, setFunction, {
            during: transitionStyles,
            start: { height: full + "px" },
            end: { height: floor + "px" }
          }, () => el.style.overflow = "hidden", () => {
            el._x_isShown = false;
            if (el.style.height == `${floor}px` && fullyHide) {
              el.style.display = "none";
              el.hidden = true;
            }
          });
        }
      };
    }
  }
  function modifierValue2(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1)
      return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue)
      return fallback;
    if (key === "duration") {
      let match = rawValue.match(/([0-9]+)ms/);
      if (match)
        return match[1];
    }
    if (key === "min") {
      let match = rawValue.match(/([0-9]+)px/);
      if (match)
        return match[1];
    }
    return rawValue;
  }
  var module_default2 = src_default2;

  // source/import/alpine.js
  (function(window2, document3) {
    "use strict";
    window2.Alpine = module_default;
    module_default.plugin(module_default2);
    window2.addEventListener("DOMContentLoaded", () => {
      module_default.start();
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      module_default.start();
    });
    window2.addEventListener("alpine:initializing", () => {
      document3.addEventListener("scroll", function() {
        const submenus = document3.querySelectorAll(".header__submenu");
        if (document3.querySelector("#shopify-section-header").classList.contains("shopify-section-header-hidden")) {
          for (var submenu of submenus) {
            submenu.classList.add("hidden");
          }
        } else {
          for (var submenu of submenus) {
            submenu.classList.remove("hidden");
          }
        }
      });
    });
  })(window, document);

  // source/import/animation.js
  (function(window2, document3) {
    "use strict";
    function animationDriver() {
      let items = document3.querySelectorAll(".on-scroll");
      if ("IntersectionObserver" in window2) {
        let callback = function(entries, observer2) {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.target.classList.contains("pre-animated")) {
              observer2.unobserve(entry.target);
              let delay = entry.target.dataset.delay || 0;
              setTimeout(function() {
                entry.target.classList.remove("pre-animated");
              }, delay * 1e3);
            }
          });
        };
        let animationObserver = new IntersectionObserver(callback, {
          threshold: 0.1
        });
        items.forEach((item) => {
          item.classList.add("pre-animated");
          animationObserver.observe(item);
        });
      } else {
        items.forEach((item) => {
        });
      }
      let templateIndex = document3.querySelector(".template-index");
      if (templateIndex) {
        templateIndex.addEventListener("click", () => {
          templateIndex.classList.add("remove-animation");
        });
      }
    }
    window2.addEventListener("DOMContentLoaded", () => {
      animationDriver();
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      animationDriver();
    });
  })(window, document);

  // node_modules/ssr-window/ssr-window.esm.js
  function isObject2(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
  }
  function extend2(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
      if (typeof target[key] === "undefined")
        target[key] = src[key];
      else if (isObject2(src[key]) && isObject2(target[key]) && Object.keys(src[key]).length > 0) {
        extend2(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener() {
    },
    removeEventListener() {
    },
    activeElement: {
      blur() {
      },
      nodeName: ""
    },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return {
        initEvent() {
        }
      };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {
        },
        getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS() {
      return {};
    },
    importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    }
  };
  function getDocument() {
    const doc2 = typeof document !== "undefined" ? document : {};
    extend2(doc2, ssrDocument);
    return doc2;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState() {
      },
      pushState() {
      },
      go() {
      },
      back() {
      }
    },
    CustomEvent: function CustomEvent2() {
      return this;
    },
    addEventListener() {
    },
    removeEventListener() {
    },
    getComputedStyle() {
      return {
        getPropertyValue() {
          return "";
        }
      };
    },
    Image() {
    },
    Date() {
    },
    screen: {},
    setTimeout() {
    },
    clearTimeout() {
    },
    matchMedia() {
      return {};
    },
    requestAnimationFrame(callback) {
      if (typeof setTimeout === "undefined") {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
      if (typeof setTimeout === "undefined") {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend2(win, ssrWindow);
    return win;
  }

  // node_modules/dom7/dom7.esm.js
  function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
      get() {
        return proto;
      },
      set(value) {
        proto.__proto__ = value;
      }
    });
  }
  var Dom7 = class extends Array {
    constructor(items) {
      super(...items || []);
      makeReactive(this);
    }
  };
  function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el) => {
      if (Array.isArray(el)) {
        res.push(...arrayFlat(el));
      } else {
        res.push(el);
      }
    });
    return res;
  }
  function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
  }
  function arrayUnique(arr) {
    const uniqueArray = [];
    for (let i3 = 0; i3 < arr.length; i3 += 1) {
      if (uniqueArray.indexOf(arr[i3]) === -1)
        uniqueArray.push(arr[i3]);
    }
    return uniqueArray;
  }
  function qsa(selector, context) {
    if (typeof selector !== "string") {
      return [selector];
    }
    const a3 = [];
    const res = context.querySelectorAll(selector);
    for (let i3 = 0; i3 < res.length; i3 += 1) {
      a3.push(res[i3]);
    }
    return a3;
  }
  function $2(selector, context) {
    const window2 = getWindow();
    const document3 = getDocument();
    let arr = [];
    if (!context && selector instanceof Dom7) {
      return selector;
    }
    if (!selector) {
      return new Dom7(arr);
    }
    if (typeof selector === "string") {
      const html2 = selector.trim();
      if (html2.indexOf("<") >= 0 && html2.indexOf(">") >= 0) {
        let toCreate = "div";
        if (html2.indexOf("<li") === 0)
          toCreate = "ul";
        if (html2.indexOf("<tr") === 0)
          toCreate = "tbody";
        if (html2.indexOf("<td") === 0 || html2.indexOf("<th") === 0)
          toCreate = "tr";
        if (html2.indexOf("<tbody") === 0)
          toCreate = "table";
        if (html2.indexOf("<option") === 0)
          toCreate = "select";
        const tempParent = document3.createElement(toCreate);
        tempParent.innerHTML = html2;
        for (let i3 = 0; i3 < tempParent.childNodes.length; i3 += 1) {
          arr.push(tempParent.childNodes[i3]);
        }
      } else {
        arr = qsa(selector.trim(), context || document3);
      }
    } else if (selector.nodeType || selector === window2 || selector === document3) {
      arr.push(selector);
    } else if (Array.isArray(selector)) {
      if (selector instanceof Dom7)
        return selector;
      arr = selector;
    }
    return new Dom7(arrayUnique(arr));
  }
  $2.fn = Dom7.prototype;
  function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c4) => c4.split(" ")));
    this.forEach((el) => {
      el.classList.add(...classNames);
    });
    return this;
  }
  function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c4) => c4.split(" ")));
    this.forEach((el) => {
      el.classList.remove(...classNames);
    });
    return this;
  }
  function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c4) => c4.split(" ")));
    this.forEach((el) => {
      classNames.forEach((className) => {
        el.classList.toggle(className);
      });
    });
  }
  function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c4) => c4.split(" ")));
    return arrayFilter(this, (el) => {
      return classNames.filter((className) => el.classList.contains(className)).length > 0;
    }).length > 0;
  }
  function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
      if (this[0])
        return this[0].getAttribute(attrs);
      return void 0;
    }
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      if (arguments.length === 2) {
        this[i3].setAttribute(attrs, value);
      } else {
        for (const attrName in attrs) {
          this[i3][attrName] = attrs[attrName];
          this[i3].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  function removeAttr(attr2) {
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      this[i3].removeAttribute(attr2);
    }
    return this;
  }
  function transform(transform2) {
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      this[i3].style.transform = transform2;
    }
    return this;
  }
  function transition2(duration) {
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      this[i3].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    }
    return this;
  }
  function on2(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
      [eventType, listener, capture] = args;
      targetSelector = void 0;
    }
    if (!capture)
      capture = false;
    function handleLiveEvent(e2) {
      const target = e2.target;
      if (!target)
        return;
      const eventData = e2.target.dom7EventData || [];
      if (eventData.indexOf(e2) < 0) {
        eventData.unshift(e2);
      }
      if ($2(target).is(targetSelector))
        listener.apply(target, eventData);
      else {
        const parents2 = $2(target).parents();
        for (let k2 = 0; k2 < parents2.length; k2 += 1) {
          if ($2(parents2[k2]).is(targetSelector))
            listener.apply(parents2[k2], eventData);
        }
      }
    }
    function handleEvent(e2) {
      const eventData = e2 && e2.target ? e2.target.dom7EventData || [] : [];
      if (eventData.indexOf(e2) < 0) {
        eventData.unshift(e2);
      }
      listener.apply(this, eventData);
    }
    const events2 = eventType.split(" ");
    let j2;
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      const el = this[i3];
      if (!targetSelector) {
        for (j2 = 0; j2 < events2.length; j2 += 1) {
          const event2 = events2[j2];
          if (!el.dom7Listeners)
            el.dom7Listeners = {};
          if (!el.dom7Listeners[event2])
            el.dom7Listeners[event2] = [];
          el.dom7Listeners[event2].push({
            listener,
            proxyListener: handleEvent
          });
          el.addEventListener(event2, handleEvent, capture);
        }
      } else {
        for (j2 = 0; j2 < events2.length; j2 += 1) {
          const event2 = events2[j2];
          if (!el.dom7LiveListeners)
            el.dom7LiveListeners = {};
          if (!el.dom7LiveListeners[event2])
            el.dom7LiveListeners[event2] = [];
          el.dom7LiveListeners[event2].push({
            listener,
            proxyListener: handleLiveEvent
          });
          el.addEventListener(event2, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
      [eventType, listener, capture] = args;
      targetSelector = void 0;
    }
    if (!capture)
      capture = false;
    const events2 = eventType.split(" ");
    for (let i3 = 0; i3 < events2.length; i3 += 1) {
      const event2 = events2[i3];
      for (let j2 = 0; j2 < this.length; j2 += 1) {
        const el = this[j2];
        let handlers;
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event2];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event2];
        }
        if (handlers && handlers.length) {
          for (let k2 = handlers.length - 1; k2 >= 0; k2 -= 1) {
            const handler4 = handlers[k2];
            if (listener && handler4.listener === listener) {
              el.removeEventListener(event2, handler4.proxyListener, capture);
              handlers.splice(k2, 1);
            } else if (listener && handler4.listener && handler4.listener.dom7proxy && handler4.listener.dom7proxy === listener) {
              el.removeEventListener(event2, handler4.proxyListener, capture);
              handlers.splice(k2, 1);
            } else if (!listener) {
              el.removeEventListener(event2, handler4.proxyListener, capture);
              handlers.splice(k2, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger2(...args) {
    const window2 = getWindow();
    const events2 = args[0].split(" ");
    const eventData = args[1];
    for (let i3 = 0; i3 < events2.length; i3 += 1) {
      const event2 = events2[i3];
      for (let j2 = 0; j2 < this.length; j2 += 1) {
        const el = this[j2];
        if (window2.CustomEvent) {
          const evt = new window2.CustomEvent(event2, {
            detail: eventData,
            bubbles: true,
            cancelable: true
          });
          el.dom7EventData = args.filter((data2, dataIndex) => dataIndex > 0);
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e2) {
      if (e2.target !== this)
        return;
      callback.call(this, e2);
      dom.off("transitionend", fireCallBack);
    }
    if (callback) {
      dom.on("transitionend", fireCallBack);
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        const styles2 = this.styles();
        return this[0].offsetWidth + parseFloat(styles2.getPropertyValue("margin-right")) + parseFloat(styles2.getPropertyValue("margin-left"));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        const styles2 = this.styles();
        return this[0].offsetHeight + parseFloat(styles2.getPropertyValue("margin-top")) + parseFloat(styles2.getPropertyValue("margin-bottom"));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      const window2 = getWindow();
      const document3 = getDocument();
      const el = this[0];
      const box = el.getBoundingClientRect();
      const body = document3.body;
      const clientTop = el.clientTop || body.clientTop || 0;
      const clientLeft = el.clientLeft || body.clientLeft || 0;
      const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
      const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
      return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
      };
    }
    return null;
  }
  function styles() {
    const window2 = getWindow();
    if (this[0])
      return window2.getComputedStyle(this[0], null);
    return {};
  }
  function css(props, value) {
    const window2 = getWindow();
    let i3;
    if (arguments.length === 1) {
      if (typeof props === "string") {
        if (this[0])
          return window2.getComputedStyle(this[0], null).getPropertyValue(props);
      } else {
        for (i3 = 0; i3 < this.length; i3 += 1) {
          for (const prop in props) {
            this[i3].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === "string") {
      for (i3 = 0; i3 < this.length; i3 += 1) {
        this[i3].style[props] = value;
      }
      return this;
    }
    return this;
  }
  function each(callback) {
    if (!callback)
      return this;
    this.forEach((el, index3) => {
      callback.apply(el, [el, index3]);
    });
    return this;
  }
  function filter(callback) {
    const result = arrayFilter(this, callback);
    return $2(result);
  }
  function html(html2) {
    if (typeof html2 === "undefined") {
      return this[0] ? this[0].innerHTML : null;
    }
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      this[i3].innerHTML = html2;
    }
    return this;
  }
  function text(text2) {
    if (typeof text2 === "undefined") {
      return this[0] ? this[0].textContent.trim() : null;
    }
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      this[i3].textContent = text2;
    }
    return this;
  }
  function is(selector) {
    const window2 = getWindow();
    const document3 = getDocument();
    const el = this[0];
    let compareWith;
    let i3;
    if (!el || typeof selector === "undefined")
      return false;
    if (typeof selector === "string") {
      if (el.matches)
        return el.matches(selector);
      if (el.webkitMatchesSelector)
        return el.webkitMatchesSelector(selector);
      if (el.msMatchesSelector)
        return el.msMatchesSelector(selector);
      compareWith = $2(selector);
      for (i3 = 0; i3 < compareWith.length; i3 += 1) {
        if (compareWith[i3] === el)
          return true;
      }
      return false;
    }
    if (selector === document3) {
      return el === document3;
    }
    if (selector === window2) {
      return el === window2;
    }
    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i3 = 0; i3 < compareWith.length; i3 += 1) {
        if (compareWith[i3] === el)
          return true;
      }
      return false;
    }
    return false;
  }
  function index() {
    let child = this[0];
    let i3;
    if (child) {
      i3 = 0;
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1)
          i3 += 1;
      }
      return i3;
    }
    return void 0;
  }
  function eq(index3) {
    if (typeof index3 === "undefined")
      return this;
    const length = this.length;
    if (index3 > length - 1) {
      return $2([]);
    }
    if (index3 < 0) {
      const returnIndex = length + index3;
      if (returnIndex < 0)
        return $2([]);
      return $2([this[returnIndex]]);
    }
    return $2([this[index3]]);
  }
  function append(...els) {
    let newChild;
    const document3 = getDocument();
    for (let k2 = 0; k2 < els.length; k2 += 1) {
      newChild = els[k2];
      for (let i3 = 0; i3 < this.length; i3 += 1) {
        if (typeof newChild === "string") {
          const tempDiv = document3.createElement("div");
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i3].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (let j2 = 0; j2 < newChild.length; j2 += 1) {
            this[i3].appendChild(newChild[j2]);
          }
        } else {
          this[i3].appendChild(newChild);
        }
      }
    }
    return this;
  }
  function prepend(newChild) {
    const document3 = getDocument();
    let i3;
    let j2;
    for (i3 = 0; i3 < this.length; i3 += 1) {
      if (typeof newChild === "string") {
        const tempDiv = document3.createElement("div");
        tempDiv.innerHTML = newChild;
        for (j2 = tempDiv.childNodes.length - 1; j2 >= 0; j2 -= 1) {
          this[i3].insertBefore(tempDiv.childNodes[j2], this[i3].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j2 = 0; j2 < newChild.length; j2 += 1) {
          this[i3].insertBefore(newChild[j2], this[i3].childNodes[0]);
        }
      } else {
        this[i3].insertBefore(newChild, this[i3].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $2(this[0].nextElementSibling).is(selector)) {
          return $2([this[0].nextElementSibling]);
        }
        return $2([]);
      }
      if (this[0].nextElementSibling)
        return $2([this[0].nextElementSibling]);
      return $2([]);
    }
    return $2([]);
  }
  function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el)
      return $2([]);
    while (el.nextElementSibling) {
      const next2 = el.nextElementSibling;
      if (selector) {
        if ($2(next2).is(selector))
          nextEls.push(next2);
      } else
        nextEls.push(next2);
      el = next2;
    }
    return $2(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      const el = this[0];
      if (selector) {
        if (el.previousElementSibling && $2(el.previousElementSibling).is(selector)) {
          return $2([el.previousElementSibling]);
        }
        return $2([]);
      }
      if (el.previousElementSibling)
        return $2([el.previousElementSibling]);
      return $2([]);
    }
    return $2([]);
  }
  function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el)
      return $2([]);
    while (el.previousElementSibling) {
      const prev2 = el.previousElementSibling;
      if (selector) {
        if ($2(prev2).is(selector))
          prevEls.push(prev2);
      } else
        prevEls.push(prev2);
      el = prev2;
    }
    return $2(prevEls);
  }
  function parent(selector) {
    const parents2 = [];
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      if (this[i3].parentNode !== null) {
        if (selector) {
          if ($2(this[i3].parentNode).is(selector))
            parents2.push(this[i3].parentNode);
        } else {
          parents2.push(this[i3].parentNode);
        }
      }
    }
    return $2(parents2);
  }
  function parents(selector) {
    const parents2 = [];
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      let parent2 = this[i3].parentNode;
      while (parent2) {
        if (selector) {
          if ($2(parent2).is(selector))
            parents2.push(parent2);
        } else {
          parents2.push(parent2);
        }
        parent2 = parent2.parentNode;
      }
    }
    return $2(parents2);
  }
  function closest(selector) {
    let closest2 = this;
    if (typeof selector === "undefined") {
      return $2([]);
    }
    if (!closest2.is(selector)) {
      closest2 = closest2.parents(selector).eq(0);
    }
    return closest2;
  }
  function find(selector) {
    const foundElements = [];
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      const found = this[i3].querySelectorAll(selector);
      for (let j2 = 0; j2 < found.length; j2 += 1) {
        foundElements.push(found[j2]);
      }
    }
    return $2(foundElements);
  }
  function children(selector) {
    const children2 = [];
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      const childNodes = this[i3].children;
      for (let j2 = 0; j2 < childNodes.length; j2 += 1) {
        if (!selector || $2(childNodes[j2]).is(selector)) {
          children2.push(childNodes[j2]);
        }
      }
    }
    return $2(children2);
  }
  function remove() {
    for (let i3 = 0; i3 < this.length; i3 += 1) {
      if (this[i3].parentNode)
        this[i3].parentNode.removeChild(this[i3]);
    }
    return this;
  }
  var noTrigger = "resize scroll".split(" ");
  function shortcut(name) {
    function eventHandler(...args) {
      if (typeof args[0] === "undefined") {
        for (let i3 = 0; i3 < this.length; i3 += 1) {
          if (noTrigger.indexOf(name) < 0) {
            if (name in this[i3])
              this[i3][name]();
            else {
              $2(this[i3]).trigger(name);
            }
          }
        }
        return this;
      }
      return this.on(name, ...args);
    }
    return eventHandler;
  }
  var click = shortcut("click");
  var blur = shortcut("blur");
  var focus = shortcut("focus");
  var focusin = shortcut("focusin");
  var focusout = shortcut("focusout");
  var keyup = shortcut("keyup");
  var keydown = shortcut("keydown");
  var keypress = shortcut("keypress");
  var submit = shortcut("submit");
  var change = shortcut("change");
  var mousedown = shortcut("mousedown");
  var mousemove = shortcut("mousemove");
  var mouseup = shortcut("mouseup");
  var mouseenter = shortcut("mouseenter");
  var mouseleave = shortcut("mouseleave");
  var mouseout = shortcut("mouseout");
  var mouseover = shortcut("mouseover");
  var touchstart = shortcut("touchstart");
  var touchend = shortcut("touchend");
  var touchmove = shortcut("touchmove");
  var resize = shortcut("resize");
  var scroll = shortcut("scroll");

  // node_modules/swiper/shared/dom.js
  var Methods = {
    addClass,
    removeClass,
    hasClass,
    toggleClass,
    attr,
    removeAttr,
    transform,
    transition: transition2,
    on: on2,
    off,
    trigger: trigger2,
    transitionEnd,
    outerWidth,
    outerHeight,
    styles,
    offset,
    css,
    each,
    html,
    text,
    is,
    index,
    eq,
    append,
    prepend,
    next,
    nextAll,
    prev,
    prevAll,
    parent,
    parents,
    closest,
    find,
    children,
    filter,
    remove
  };
  Object.keys(Methods).forEach((methodName) => {
    Object.defineProperty($2.fn, methodName, {
      value: Methods[methodName],
      writable: true
    });
  });
  var dom_default = $2;

  // node_modules/swiper/shared/utils.js
  function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key) => {
      try {
        object[key] = null;
      } catch (e2) {
      }
      try {
        delete object[key];
      } catch (e2) {
      }
    });
  }
  function nextTick2(callback, delay = 0) {
    return setTimeout(callback, delay);
  }
  function now() {
    return Date.now();
  }
  function getComputedStyle2(el) {
    const window2 = getWindow();
    let style;
    if (window2.getComputedStyle) {
      style = window2.getComputedStyle(el, null);
    }
    if (!style && el.currentStyle) {
      style = el.currentStyle;
    }
    if (!style) {
      style = el.style;
    }
    return style;
  }
  function getTranslate(el, axis = "x") {
    const window2 = getWindow();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle2(el, null);
    if (window2.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(",").length > 6) {
        curTransform = curTransform.split(", ").map((a3) => a3.replace(",", ".")).join(", ");
      }
      transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
      matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
      if (window2.WebKitCSSMatrix)
        curTransform = transformMatrix.m41;
      else if (matrix.length === 16)
        curTransform = parseFloat(matrix[12]);
      else
        curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
      if (window2.WebKitCSSMatrix)
        curTransform = transformMatrix.m42;
      else if (matrix.length === 16)
        curTransform = parseFloat(matrix[13]);
      else
        curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  }
  function isObject3(o3) {
    return typeof o3 === "object" && o3 !== null && o3.constructor && Object.prototype.toString.call(o3).slice(8, -1) === "Object";
  }
  function isNode(node2) {
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
      return node2 instanceof HTMLElement;
    }
    return node2 && (node2.nodeType === 1 || node2.nodeType === 11);
  }
  function extend3(...args) {
    const to = Object(args[0]);
    const noExtend = ["__proto__", "constructor", "prototype"];
    for (let i3 = 1; i3 < args.length; i3 += 1) {
      const nextSource = args[i3];
      if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
        const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          const nextKey = keysArray[nextIndex];
          const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== void 0 && desc.enumerable) {
            if (isObject3(to[nextKey]) && isObject3(nextSource[nextKey])) {
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend3(to[nextKey], nextSource[nextKey]);
              }
            } else if (!isObject3(to[nextKey]) && isObject3(nextSource[nextKey])) {
              to[nextKey] = {};
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend3(to[nextKey], nextSource[nextKey]);
              }
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
  function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
  }
  function animateCSSModeScroll({
    swiper,
    targetPosition,
    side
  }) {
    const window2 = getWindow();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window2.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target) => {
      return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = () => {
      time = new Date().getTime();
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
      let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
      if (isOutOfBound(currentPosition, targetPosition)) {
        currentPosition = targetPosition;
      }
      swiper.wrapperEl.scrollTo({
        [side]: currentPosition
      });
      if (isOutOfBound(currentPosition, targetPosition)) {
        swiper.wrapperEl.style.overflow = "hidden";
        swiper.wrapperEl.style.scrollSnapType = "";
        setTimeout(() => {
          swiper.wrapperEl.style.overflow = "";
          swiper.wrapperEl.scrollTo({
            [side]: currentPosition
          });
        });
        window2.cancelAnimationFrame(swiper.cssModeFrameID);
        return;
      }
      swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
    };
    animate();
  }

  // node_modules/swiper/shared/get-support.js
  var support;
  function calcSupport() {
    const window2 = getWindow();
    const document3 = getDocument();
    return {
      smoothScroll: document3.documentElement && "scrollBehavior" in document3.documentElement.style,
      touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document3 instanceof window2.DocumentTouch),
      passiveListener: function checkPassiveListener() {
        let supportsPassive = false;
        try {
          const opts = Object.defineProperty({}, "passive", {
            get() {
              supportsPassive = true;
            }
          });
          window2.addEventListener("testPassiveListener", null, opts);
        } catch (e2) {
        }
        return supportsPassive;
      }(),
      gestures: function checkGestures() {
        return "ongesturestart" in window2;
      }()
    };
  }
  function getSupport() {
    if (!support) {
      support = calcSupport();
    }
    return support;
  }

  // node_modules/swiper/shared/get-device.js
  var deviceCached;
  function calcDevice({
    userAgent
  } = {}) {
    const support2 = getSupport();
    const window2 = getWindow();
    const platform = window2.navigator.platform;
    const ua = userAgent || window2.navigator.userAgent;
    const device = {
      ios: false,
      android: false
    };
    const screenWidth = window2.screen.width;
    const screenHeight = window2.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad)
        ipad = [0, 1, "13_0_0"];
      macos = false;
    }
    if (android && !windows) {
      device.os = "android";
      device.android = true;
    }
    if (ipad || iphone || ipod) {
      device.os = "ios";
      device.ios = true;
    }
    return device;
  }
  function getDevice(overrides = {}) {
    if (!deviceCached) {
      deviceCached = calcDevice(overrides);
    }
    return deviceCached;
  }

  // node_modules/swiper/shared/get-browser.js
  var browser;
  function calcBrowser() {
    const window2 = getWindow();
    function isSafari() {
      const ua = window2.navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
      isSafari: isSafari(),
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
    };
  }
  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }
    return browser;
  }

  // node_modules/swiper/core/modules/resize/resize.js
  function Resize({
    swiper,
    on: on3,
    emit: emit2
  }) {
    const window2 = getWindow();
    let observer2 = null;
    const resizeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized)
        return;
      emit2("beforeResize");
      emit2("resize");
    };
    const createObserver = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized)
        return;
      observer2 = new ResizeObserver((entries) => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
      observer2.observe(swiper.el);
    };
    const removeObserver = () => {
      if (observer2 && observer2.unobserve && swiper.el) {
        observer2.unobserve(swiper.el);
        observer2 = null;
      }
    };
    const orientationChangeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized)
        return;
      emit2("orientationchange");
    };
    on3("init", () => {
      if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
        createObserver();
        return;
      }
      window2.addEventListener("resize", resizeHandler);
      window2.addEventListener("orientationchange", orientationChangeHandler);
    });
    on3("destroy", () => {
      removeObserver();
      window2.removeEventListener("resize", resizeHandler);
      window2.removeEventListener("orientationchange", orientationChangeHandler);
    });
  }

  // node_modules/swiper/core/modules/observer/observer.js
  function Observer({
    swiper,
    extendParams,
    on: on3,
    emit: emit2
  }) {
    const observers = [];
    const window2 = getWindow();
    const attach = (target, options = {}) => {
      const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
      const observer2 = new ObserverFunc((mutations) => {
        if (mutations.length === 1) {
          emit2("observerUpdate", mutations[0]);
          return;
        }
        const observerUpdate = function observerUpdate2() {
          emit2("observerUpdate", mutations[0]);
        };
        if (window2.requestAnimationFrame) {
          window2.requestAnimationFrame(observerUpdate);
        } else {
          window2.setTimeout(observerUpdate, 0);
        }
      });
      observer2.observe(target, {
        attributes: typeof options.attributes === "undefined" ? true : options.attributes,
        childList: typeof options.childList === "undefined" ? true : options.childList,
        characterData: typeof options.characterData === "undefined" ? true : options.characterData
      });
      observers.push(observer2);
    };
    const init = () => {
      if (!swiper.params.observer)
        return;
      if (swiper.params.observeParents) {
        const containerParents = swiper.$el.parents();
        for (let i3 = 0; i3 < containerParents.length; i3 += 1) {
          attach(containerParents[i3]);
        }
      }
      attach(swiper.$el[0], {
        childList: swiper.params.observeSlideChildren
      });
      attach(swiper.$wrapperEl[0], {
        attributes: false
      });
    };
    const destroy = () => {
      observers.forEach((observer2) => {
        observer2.disconnect();
      });
      observers.splice(0, observers.length);
    };
    extendParams({
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    });
    on3("init", init);
    on3("destroy", destroy);
  }

  // node_modules/swiper/core/events-emitter.js
  var events_emitter_default = {
    on(events2, handler4, priority) {
      const self2 = this;
      if (typeof handler4 !== "function")
        return self2;
      const method = priority ? "unshift" : "push";
      events2.split(" ").forEach((event2) => {
        if (!self2.eventsListeners[event2])
          self2.eventsListeners[event2] = [];
        self2.eventsListeners[event2][method](handler4);
      });
      return self2;
    },
    once(events2, handler4, priority) {
      const self2 = this;
      if (typeof handler4 !== "function")
        return self2;
      function onceHandler(...args) {
        self2.off(events2, onceHandler);
        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }
        handler4.apply(self2, args);
      }
      onceHandler.__emitterProxy = handler4;
      return self2.on(events2, onceHandler, priority);
    },
    onAny(handler4, priority) {
      const self2 = this;
      if (typeof handler4 !== "function")
        return self2;
      const method = priority ? "unshift" : "push";
      if (self2.eventsAnyListeners.indexOf(handler4) < 0) {
        self2.eventsAnyListeners[method](handler4);
      }
      return self2;
    },
    offAny(handler4) {
      const self2 = this;
      if (!self2.eventsAnyListeners)
        return self2;
      const index3 = self2.eventsAnyListeners.indexOf(handler4);
      if (index3 >= 0) {
        self2.eventsAnyListeners.splice(index3, 1);
      }
      return self2;
    },
    off(events2, handler4) {
      const self2 = this;
      if (!self2.eventsListeners)
        return self2;
      events2.split(" ").forEach((event2) => {
        if (typeof handler4 === "undefined") {
          self2.eventsListeners[event2] = [];
        } else if (self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler, index3) => {
            if (eventHandler === handler4 || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler4) {
              self2.eventsListeners[event2].splice(index3, 1);
            }
          });
        }
      });
      return self2;
    },
    emit(...args) {
      const self2 = this;
      if (!self2.eventsListeners)
        return self2;
      let events2;
      let data2;
      let context;
      if (typeof args[0] === "string" || Array.isArray(args[0])) {
        events2 = args[0];
        data2 = args.slice(1, args.length);
        context = self2;
      } else {
        events2 = args[0].events;
        data2 = args[0].data;
        context = args[0].context || self2;
      }
      data2.unshift(context);
      const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
      eventsArray.forEach((event2) => {
        if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
          self2.eventsAnyListeners.forEach((eventHandler) => {
            eventHandler.apply(context, [event2, ...data2]);
          });
        }
        if (self2.eventsListeners && self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler) => {
            eventHandler.apply(context, data2);
          });
        }
      });
      return self2;
    }
  };

  // node_modules/swiper/core/update/updateSize.js
  function updateSize() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    }
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width))
      width = 0;
    if (Number.isNaN(height))
      height = 0;
    Object.assign(swiper, {
      width,
      height,
      size: swiper.isHorizontal() ? width : height
    });
  }

  // node_modules/swiper/core/update/updateSlides.js
  function updateSlides() {
    const swiper = this;
    function getDirectionLabel(property) {
      if (swiper.isHorizontal()) {
        return property;
      }
      return {
        "width": "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        "marginRight": "marginBottom"
      }[property];
    }
    function getDirectionPropertyValue(node2, label) {
      return parseFloat(node2.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const {
      $wrapperEl,
      size: swiperSize,
      rtlTranslate: rtl,
      wrongRTL
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index3 = 0;
    if (typeof swiperSize === "undefined") {
      return;
    }
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    }
    swiper.virtualSize = -spaceBetween;
    if (rtl)
      slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
      });
    else
      slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
      });
    if (params.centeredSlides && params.cssMode) {
      setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", "");
      setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) {
      swiper.grid.initSlides(slidesLength);
    }
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
      return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for (let i3 = 0; i3 < slidesLength; i3 += 1) {
      slideSize = 0;
      const slide = slides.eq(i3);
      if (gridEnabled) {
        swiper.grid.updateSlide(i3, slide, slidesLength, getDirectionLabel);
      }
      if (slide.css("display") === "none")
        continue;
      if (params.slidesPerView === "auto") {
        if (shouldResetSlideSize) {
          slides[i3].style[getDirectionLabel("width")] = ``;
        }
        const slideStyles = getComputedStyle(slide[0]);
        const currentTransform = slide[0].style.transform;
        const currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = "none";
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = "none";
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
        } else {
          const width = getDirectionPropertyValue(slideStyles, "width");
          const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
          const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
          const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
          const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
          const boxSizing = slideStyles.getPropertyValue("box-sizing");
          if (boxSizing && boxSizing === "border-box") {
            slideSize = width + marginLeft + marginRight;
          } else {
            const {
              clientWidth,
              offsetWidth
            } = slide[0];
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths)
          slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths)
          slideSize = Math.floor(slideSize);
        if (slides[i3]) {
          slides[i3].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
      }
      if (slides[i3]) {
        slides[i3].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);
      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i3 !== 0)
          slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i3 === 0)
          slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1e3)
          slidePosition = 0;
        if (params.roundLengths)
          slidePosition = Math.floor(slidePosition);
        if (index3 % params.slidesPerGroup === 0)
          snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths)
          slidePosition = Math.floor(slidePosition);
        if ((index3 - Math.min(swiper.params.slidesPerGroupSkip, index3)) % swiper.params.slidesPerGroup === 0)
          snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }
      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index3 += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
      $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
      });
    }
    if (params.setWrapperSize) {
      $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
      });
    }
    if (gridEnabled) {
      swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    }
    if (!params.centeredSlides) {
      const newSlidesGrid = [];
      for (let i3 = 0; i3 < snapGrid.length; i3 += 1) {
        let slidesGridItem = snapGrid[i3];
        if (params.roundLengths)
          slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i3] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0)
      snapGrid = [0];
    if (params.spaceBetween !== 0) {
      const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
      slides.filter((_3, slideIndex) => {
        if (!params.cssMode)
          return true;
        if (slideIndex === slides.length - 1) {
          return false;
        }
        return true;
      }).css({
        [key]: `${spaceBetween}px`
      });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      const maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map((snap) => {
        if (snap < 0)
          return -offsetBefore;
        if (snap > maxSnap)
          return maxSnap + offsetAfter;
        return snap;
      });
    }
    if (params.centerInsufficientSlides) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach((snap, snapIndex) => {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach((snap, snapIndex) => {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }
    Object.assign(swiper, {
      slides,
      snapGrid,
      slidesGrid,
      slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
      setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
      setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
      const addToSnapGrid = -swiper.snapGrid[0];
      const addToSlidesGrid = -swiper.slidesGrid[0];
      swiper.snapGrid = swiper.snapGrid.map((v3) => v3 + addToSnapGrid);
      swiper.slidesGrid = swiper.slidesGrid.map((v3) => v3 + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) {
      swiper.emit("slidesLengthChange");
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow)
        swiper.checkOverflow();
      swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit("slidesGridLengthChange");
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
  }

  // node_modules/swiper/core/update/updateAutoHeight.js
  function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i3;
    if (typeof speed === "number") {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    const getSlideByIndex = (index3) => {
      if (isVirtual) {
        return swiper.slides.filter((el) => parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index3)[0];
      }
      return swiper.slides.eq(index3)[0];
    };
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        swiper.visibleSlides.each((slide) => {
          activeSlides.push(slide);
        });
      } else {
        for (i3 = 0; i3 < Math.ceil(swiper.params.slidesPerView); i3 += 1) {
          const index3 = swiper.activeIndex + i3;
          if (index3 > swiper.slides.length && !isVirtual)
            break;
          activeSlides.push(getSlideByIndex(index3));
        }
      }
    } else {
      activeSlides.push(getSlideByIndex(swiper.activeIndex));
    }
    for (i3 = 0; i3 < activeSlides.length; i3 += 1) {
      if (typeof activeSlides[i3] !== "undefined") {
        const height = activeSlides[i3].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }
    if (newHeight)
      swiper.$wrapperEl.css("height", `${newHeight}px`);
  }

  // node_modules/swiper/core/update/updateSlidesOffset.js
  function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    for (let i3 = 0; i3 < slides.length; i3 += 1) {
      slides[i3].swiperSlideOffset = swiper.isHorizontal() ? slides[i3].offsetLeft : slides[i3].offsetTop;
    }
  }

  // node_modules/swiper/core/update/updateSlidesProgress.js
  function updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const {
      slides,
      rtlTranslate: rtl,
      snapGrid
    } = swiper;
    if (slides.length === 0)
      return;
    if (typeof slides[0].swiperSlideOffset === "undefined")
      swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl)
      offsetCenter = translate;
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for (let i3 = 0; i3 < slides.length; i3 += 1) {
      const slide = slides[i3];
      let slideOffset = slide.swiperSlideOffset;
      if (params.cssMode && params.centeredSlides) {
        slideOffset -= slides[0].swiperSlideOffset;
      }
      const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
      const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
      const slideBefore = -(offsetCenter - slideOffset);
      const slideAfter = slideBefore + swiper.slidesSizesGrid[i3];
      const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i3);
        slides.eq(i3).addClass(params.slideVisibleClass);
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
      slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = dom_default(swiper.visibleSlides);
  }

  // node_modules/swiper/core/update/updateProgress.js
  function updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
      const multiplier = swiper.rtlTranslate ? -1 : 1;
      translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let {
      progress,
      isBeginning,
      isEnd
    } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / translatesDiff;
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Object.assign(swiper, {
      progress,
      isBeginning,
      isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
      swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) {
      swiper.emit("reachBeginning toEdge");
    }
    if (isEnd && !wasEnd) {
      swiper.emit("reachEnd toEdge");
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit("fromEdge");
    }
    swiper.emit("progress", progress);
  }

  // node_modules/swiper/core/update/updateSlidesClasses.js
  function updateSlidesClasses() {
    const swiper = this;
    const {
      slides,
      params,
      $wrapperEl,
      activeIndex,
      realIndex
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    } else {
      activeSlide = slides.eq(activeIndex);
    }
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
      }
    }
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
      }
    }
    swiper.emitSlidesClasses();
  }

  // node_modules/swiper/core/update/updateActiveIndex.js
  function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const {
      slidesGrid,
      snapGrid,
      params,
      activeIndex: previousIndex,
      realIndex: previousRealIndex,
      snapIndex: previousSnapIndex
    } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
      for (let i3 = 0; i3 < slidesGrid.length; i3 += 1) {
        if (typeof slidesGrid[i3 + 1] !== "undefined") {
          if (translate >= slidesGrid[i3] && translate < slidesGrid[i3 + 1] - (slidesGrid[i3 + 1] - slidesGrid[i3]) / 2) {
            activeIndex = i3;
          } else if (translate >= slidesGrid[i3] && translate < slidesGrid[i3 + 1]) {
            activeIndex = i3 + 1;
          }
        } else if (translate >= slidesGrid[i3]) {
          activeIndex = i3;
        }
      }
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined")
          activeIndex = 0;
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length)
      snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit("snapIndexChange");
      }
      return;
    }
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
      snapIndex,
      realIndex,
      previousIndex,
      activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) {
      swiper.emit("realIndexChange");
    }
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      swiper.emit("slideChange");
    }
  }

  // node_modules/swiper/core/update/updateClickedSlide.js
  function updateClickedSlide(e2) {
    const swiper = this;
    const params = swiper.params;
    const slide = dom_default(e2.target).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
      for (let i3 = 0; i3 < swiper.slides.length; i3 += 1) {
        if (swiper.slides[i3] === slide) {
          slideFound = true;
          slideIndex = i3;
          break;
        }
      }
    }
    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt(dom_default(slide).attr("data-swiper-slide-index"), 10);
      } else {
        swiper.clickedIndex = slideIndex;
      }
    } else {
      swiper.clickedSlide = void 0;
      swiper.clickedIndex = void 0;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  // node_modules/swiper/core/update/index.js
  var update_default = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
  };

  // node_modules/swiper/core/translate/getTranslate.js
  function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const {
      params,
      rtlTranslate: rtl,
      translate,
      $wrapperEl
    } = swiper;
    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }
    if (params.cssMode) {
      return translate;
    }
    let currentTranslate = getTranslate($wrapperEl[0], axis);
    if (rtl)
      currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }

  // node_modules/swiper/core/translate/setTranslate.js
  function setTranslate(translate, byController) {
    const swiper = this;
    const {
      rtlTranslate: rtl,
      params,
      $wrapperEl,
      wrapperEl,
      progress
    } = swiper;
    let x2 = 0;
    let y3 = 0;
    const z2 = 0;
    if (swiper.isHorizontal()) {
      x2 = rtl ? -translate : translate;
    } else {
      y3 = translate;
    }
    if (params.roundLengths) {
      x2 = Math.floor(x2);
      y3 = Math.floor(y3);
    }
    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x2 : -y3;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform(`translate3d(${x2}px, ${y3}px, ${z2}px)`);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x2 : y3;
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }
    swiper.emit("setTranslate", swiper.translate, byController);
  }

  // node_modules/swiper/core/translate/minTranslate.js
  function minTranslate() {
    return -this.snapGrid[0];
  }

  // node_modules/swiper/core/translate/maxTranslate.js
  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }

  // node_modules/swiper/core/translate/translateTo.js
  function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const {
      params,
      wrapperEl
    } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    const minTranslate2 = swiper.minTranslate();
    const maxTranslate2 = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate2)
      newTranslate = minTranslate2;
    else if (translateBounds && translate < maxTranslate2)
      newTranslate = maxTranslate2;
    else
      newTranslate = translate;
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: -newTranslate,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: -newTranslate,
          behavior: "smooth"
        });
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionEnd");
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionStart");
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd3(e2) {
            if (!swiper || swiper.destroyed)
              return;
            if (e2.target !== this)
              return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            if (runCallbacks) {
              swiper.emit("transitionEnd");
            }
          };
        }
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
      }
    }
    return true;
  }

  // node_modules/swiper/core/translate/index.js
  var translate_default = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
  };

  // node_modules/swiper/core/transition/setTransition.js
  function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }
    swiper.emit("setTransition", duration, byController);
  }

  // node_modules/swiper/core/transition/transitionEmit.js
  function transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step
  }) {
    const {
      activeIndex,
      previousIndex
    } = swiper;
    let dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex)
        dir = "next";
      else if (activeIndex < previousIndex)
        dir = "prev";
      else
        dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === "reset") {
        swiper.emit(`slideResetTransition${step}`);
        return;
      }
      swiper.emit(`slideChangeTransition${step}`);
      if (dir === "next") {
        swiper.emit(`slideNextTransition${step}`);
      } else {
        swiper.emit(`slidePrevTransition${step}`);
      }
    }
  }

  // node_modules/swiper/core/transition/transitionStart.js
  function transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    if (params.cssMode)
      return;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "Start"
    });
  }

  // node_modules/swiper/core/transition/transitionEnd.js
  function transitionEnd2(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.animating = false;
    if (params.cssMode)
      return;
    swiper.setTransition(0);
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "End"
    });
  }

  // node_modules/swiper/core/transition/index.js
  var transition_default = {
    setTransition,
    transitionStart,
    transitionEnd: transitionEnd2
  };

  // node_modules/swiper/core/slide/slideTo.js
  function slideTo(index3 = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index3 !== "number" && typeof index3 !== "string") {
      throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index3}] given.`);
    }
    if (typeof index3 === "string") {
      const indexAsNumber = parseInt(index3, 10);
      const isValidNumber = isFinite(indexAsNumber);
      if (!isValidNumber) {
        throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index3}] given.`);
      }
      index3 = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index3;
    if (slideIndex < 0)
      slideIndex = 0;
    const {
      params,
      snapGrid,
      slidesGrid,
      previousIndex,
      activeIndex,
      rtlTranslate: rtl,
      wrapperEl,
      enabled
    } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
      return false;
    }
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length)
      snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit("beforeSlideChangeStart");
    }
    const translate = -snapGrid[snapIndex];
    swiper.updateProgress(translate);
    if (params.normalizeSlideIndex) {
      for (let i3 = 0; i3 < slidesGrid.length; i3 += 1) {
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i3] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i3 + 1] * 100);
        if (typeof slidesGrid[i3 + 1] !== "undefined") {
          if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
            slideIndex = i3;
          } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
            slideIndex = i3 + 1;
          }
        } else if (normalizedTranslate >= normalizedGrid) {
          slideIndex = i3;
        }
      }
    }
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex)
          return false;
      }
    }
    let direction;
    if (slideIndex > activeIndex)
      direction = "next";
    else if (slideIndex < activeIndex)
      direction = "prev";
    else
      direction = "reset";
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
      swiper.updateActiveIndex(slideIndex);
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== "slide") {
        swiper.setTranslate(translate);
      }
      if (direction !== "reset") {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      const t3 = rtl ? translate : -translate;
      if (speed === 0) {
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        if (isVirtual) {
          swiper.wrapperEl.style.scrollSnapType = "none";
          swiper._immediateVirtual = true;
        }
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t3;
        if (isVirtual) {
          requestAnimationFrame(() => {
            swiper.wrapperEl.style.scrollSnapType = "";
            swiper._swiperImmediateVirtual = false;
          });
        }
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: t3,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: t3,
          behavior: "smooth"
        });
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd3(e2) {
            if (!swiper || swiper.destroyed)
              return;
            if (e2.target !== this)
              return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
      }
    }
    return true;
  }

  // node_modules/swiper/core/slide/slideToLoop.js
  function slideToLoop(index3 = 0, speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    let newIndex = index3;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  // node_modules/swiper/core/slide/slideNext.js
  function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      animating,
      enabled,
      params
    } = swiper;
    if (!enabled)
      return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    }
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
      if (animating && params.loopPreventsSlide)
        return false;
      swiper.loopFix();
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }

  // node_modules/swiper/core/slide/slidePrev.js
  function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      params,
      animating,
      snapGrid,
      slidesGrid,
      rtlTranslate,
      enabled
    } = swiper;
    if (!enabled)
      return swiper;
    if (params.loop) {
      if (animating && params.loopPreventsSlide)
        return false;
      swiper.loopFix();
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0)
        return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
      let prevSnapIndex;
      snapGrid.forEach((snap, snapIndex) => {
        if (normalizedTranslate >= snap) {
          prevSnapIndex = snapIndex;
        }
      });
      if (typeof prevSnapIndex !== "undefined") {
        prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
      }
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0)
        prevIndex = swiper.activeIndex - 1;
      if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
        prevIndex = Math.max(prevIndex, 0);
      }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  // node_modules/swiper/core/slide/slideReset.js
  function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  // node_modules/swiper/core/slide/slideToClosest.js
  function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index3 = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index3);
    const snapIndex = skip + Math.floor((index3 - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
      const currentSnap = swiper.snapGrid[snapIndex];
      const nextSnap = swiper.snapGrid[snapIndex + 1];
      if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
        index3 += swiper.params.slidesPerGroup;
      }
    } else {
      const prevSnap = swiper.snapGrid[snapIndex - 1];
      const currentSnap = swiper.snapGrid[snapIndex];
      if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
        index3 -= swiper.params.slidesPerGroup;
      }
    }
    index3 = Math.max(index3, 0);
    index3 = Math.min(index3, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index3, speed, runCallbacks, internal);
  }

  // node_modules/swiper/core/slide/slideToClickedSlide.js
  function slideToClickedSlide() {
    const swiper = this;
    const {
      params,
      $wrapperEl
    } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
      if (swiper.animating)
        return;
      realIndex = parseInt(dom_default(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
      if (params.centeredSlides) {
        if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
          nextTick2(() => {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick2(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  // node_modules/swiper/core/slide/index.js
  var slide_default = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
  };

  // node_modules/swiper/core/loop/loopCreate.js
  function loopCreate() {
    const swiper = this;
    const document3 = getDocument();
    const {
      params,
      $wrapperEl
    } = swiper;
    const $selector = $wrapperEl.children().length > 0 ? dom_default($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
      const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (let i3 = 0; i3 < blankSlidesNum; i3 += 1) {
          const blankNode = dom_default(document3.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
          $selector.append(blankNode);
        }
        slides = $selector.children(`.${params.slideClass}`);
      }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides)
      params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index3) => {
      const slide = dom_default(el);
      if (index3 < swiper.loopedSlides) {
        appendSlides.push(el);
      }
      if (index3 < slides.length && index3 >= slides.length - swiper.loopedSlides) {
        prependSlides.push(el);
      }
      slide.attr("data-swiper-slide-index", index3);
    });
    for (let i3 = 0; i3 < appendSlides.length; i3 += 1) {
      $selector.append(dom_default(appendSlides[i3].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (let i3 = prependSlides.length - 1; i3 >= 0; i3 -= 1) {
      $selector.prepend(dom_default(prependSlides[i3].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  // node_modules/swiper/core/loop/loopFix.js
  function loopFix() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const {
      activeIndex,
      slides,
      loopedSlides,
      allowSlidePrev,
      allowSlideNext,
      snapGrid,
      rtlTranslate: rtl
    } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate();
    if (activeIndex < loopedSlides) {
      newIndex = slides.length - loopedSlides * 3 + activeIndex;
      newIndex += loopedSlides;
      const slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      const slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
  }

  // node_modules/swiper/core/loop/loopDestroy.js
  function loopDestroy() {
    const swiper = this;
    const {
      $wrapperEl,
      params,
      slides
    } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
  }

  // node_modules/swiper/core/loop/index.js
  var loop_default = {
    loopCreate,
    loopFix,
    loopDestroy
  };

  // node_modules/swiper/core/grab-cursor/setGrabCursor.js
  function setGrabCursor(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode)
      return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
  }

  // node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
  function unsetGrabCursor() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  }

  // node_modules/swiper/core/grab-cursor/index.js
  var grab_cursor_default = {
    setGrabCursor,
    unsetGrabCursor
  };

  // node_modules/swiper/core/events/onTouchStart.js
  function closestElement(selector, base = this) {
    function __closestFrom(el) {
      if (!el || el === getDocument() || el === getWindow())
        return null;
      if (el.assignedSlot)
        el = el.assignedSlot;
      const found = el.closest(selector);
      return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
  }
  function onTouchStart(event2) {
    const swiper = this;
    const document3 = getDocument();
    const window2 = getWindow();
    const data2 = swiper.touchEventsData;
    const {
      params,
      touches,
      enabled
    } = swiper;
    if (!enabled)
      return;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    if (!swiper.animating && params.cssMode && params.loop) {
      swiper.loopFix();
    }
    let e2 = event2;
    if (e2.originalEvent)
      e2 = e2.originalEvent;
    let $targetEl = dom_default(e2.target);
    if (params.touchEventsTarget === "wrapper") {
      if (!$targetEl.closest(swiper.wrapperEl).length)
        return;
    }
    data2.isTouchEvent = e2.type === "touchstart";
    if (!data2.isTouchEvent && "which" in e2 && e2.which === 3)
      return;
    if (!data2.isTouchEvent && "button" in e2 && e2.button > 0)
      return;
    if (data2.isTouched && data2.isMoved)
      return;
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    if (swipingClassHasValue && e2.target && e2.target.shadowRoot && event2.path && event2.path[0]) {
      $targetEl = dom_default(event2.path[0]);
    }
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e2.target && e2.target.shadowRoot);
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e2.target) : $targetEl.closest(noSwipingSelector)[0])) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0])
        return;
    }
    touches.currentX = e2.type === "touchstart" ? e2.targetTouches[0].pageX : e2.pageX;
    touches.currentY = e2.type === "touchstart" ? e2.targetTouches[0].pageY : e2.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
      if (edgeSwipeDetection === "prevent") {
        event2.preventDefault();
      } else {
        return;
      }
    }
    Object.assign(data2, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: void 0,
      startMoving: void 0
    });
    touches.startX = startX;
    touches.startY = startY;
    data2.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = void 0;
    if (params.threshold > 0)
      data2.allowThresholdMove = false;
    if (e2.type !== "touchstart") {
      let preventDefault = true;
      if ($targetEl.is(data2.focusableElements))
        preventDefault = false;
      if (document3.activeElement && dom_default(document3.activeElement).is(data2.focusableElements) && document3.activeElement !== $targetEl[0]) {
        document3.activeElement.blur();
      }
      const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
        e2.preventDefault();
      }
    }
    swiper.emit("touchStart", e2);
  }

  // node_modules/swiper/core/events/onTouchMove.js
  function onTouchMove(event2) {
    const document3 = getDocument();
    const swiper = this;
    const data2 = swiper.touchEventsData;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      enabled
    } = swiper;
    if (!enabled)
      return;
    let e2 = event2;
    if (e2.originalEvent)
      e2 = e2.originalEvent;
    if (!data2.isTouched) {
      if (data2.startMoving && data2.isScrolling) {
        swiper.emit("touchMoveOpposite", e2);
      }
      return;
    }
    if (data2.isTouchEvent && e2.type !== "touchmove")
      return;
    const targetTouch = e2.type === "touchmove" && e2.targetTouches && (e2.targetTouches[0] || e2.changedTouches[0]);
    const pageX = e2.type === "touchmove" ? targetTouch.pageX : e2.pageX;
    const pageY = e2.type === "touchmove" ? targetTouch.pageY : e2.pageY;
    if (e2.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      swiper.allowClick = false;
      if (data2.isTouched) {
        Object.assign(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data2.touchStartTime = now();
      }
      return;
    }
    if (data2.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data2.isTouched = false;
          data2.isMoved = false;
          return;
        }
      } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
        return;
      }
    }
    if (data2.isTouchEvent && document3.activeElement) {
      if (e2.target === document3.activeElement && dom_default(e2.target).is(data2.focusableElements)) {
        data2.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data2.allowTouchCallbacks) {
      swiper.emit("touchMove", e2);
    }
    if (e2.targetTouches && e2.targetTouches.length > 1)
      return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
      return;
    if (typeof data2.isScrolling === "undefined") {
      let touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data2.isScrolling = false;
      } else {
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data2.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data2.isScrolling) {
      swiper.emit("touchMoveOpposite", e2);
    }
    if (typeof data2.startMoving === "undefined") {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data2.startMoving = true;
      }
    }
    if (data2.isScrolling) {
      data2.isTouched = false;
      return;
    }
    if (!data2.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e2.cancelable) {
      e2.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e2.stopPropagation();
    }
    if (!data2.isMoved) {
      if (params.loop && !params.cssMode) {
        swiper.loopFix();
      }
      data2.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
      }
      data2.allowMomentumBounce = false;
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit("sliderFirstMove", e2);
    }
    swiper.emit("sliderMove", e2);
    data2.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl)
      diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data2.currentTranslate = diff + data2.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0 && data2.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance)
        data2.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data2.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data2.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance)
        data2.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data2.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) {
      e2.preventedByNestedSwiper = true;
    }
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data2.currentTranslate < data2.startTranslate) {
      data2.currentTranslate = data2.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data2.currentTranslate > data2.startTranslate) {
      data2.currentTranslate = data2.startTranslate;
    }
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
      data2.currentTranslate = data2.startTranslate;
    }
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data2.allowThresholdMove) {
        if (!data2.allowThresholdMove) {
          data2.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data2.currentTranslate = data2.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data2.currentTranslate = data2.startTranslate;
        return;
      }
    }
    if (!params.followFinger || params.cssMode)
      return;
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
      swiper.freeMode.onTouchMove();
    }
    swiper.updateProgress(data2.currentTranslate);
    swiper.setTranslate(data2.currentTranslate);
  }

  // node_modules/swiper/core/events/onTouchEnd.js
  function onTouchEnd(event2) {
    const swiper = this;
    const data2 = swiper.touchEventsData;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      slidesGrid,
      enabled
    } = swiper;
    if (!enabled)
      return;
    let e2 = event2;
    if (e2.originalEvent)
      e2 = e2.originalEvent;
    if (data2.allowTouchCallbacks) {
      swiper.emit("touchEnd", e2);
    }
    data2.allowTouchCallbacks = false;
    if (!data2.isTouched) {
      if (data2.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data2.isMoved = false;
      data2.startMoving = false;
      return;
    }
    if (params.grabCursor && data2.isMoved && data2.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }
    const touchEndTime = now();
    const timeDiff = touchEndTime - data2.touchStartTime;
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e2);
      swiper.emit("tap click", e2);
      if (timeDiff < 300 && touchEndTime - data2.lastClickTime < 300) {
        swiper.emit("doubleTap doubleClick", e2);
      }
    }
    data2.lastClickTime = now();
    nextTick2(() => {
      if (!swiper.destroyed)
        swiper.allowClick = true;
    });
    if (!data2.isTouched || !data2.isMoved || !swiper.swipeDirection || touches.diff === 0 || data2.currentTranslate === data2.startTranslate) {
      data2.isTouched = false;
      data2.isMoved = false;
      data2.startMoving = false;
      return;
    }
    data2.isTouched = false;
    data2.isMoved = false;
    data2.startMoving = false;
    let currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data2.currentTranslate;
    }
    if (params.cssMode) {
      return;
    }
    if (swiper.params.freeMode && params.freeMode.enabled) {
      swiper.freeMode.onTouchEnd({
        currentPos
      });
      return;
    }
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for (let i3 = 0; i3 < slidesGrid.length; i3 += i3 < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      const increment2 = i3 < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (typeof slidesGrid[i3 + increment2] !== "undefined") {
        if (currentPos >= slidesGrid[i3] && currentPos < slidesGrid[i3 + increment2]) {
          stopIndex = i3;
          groupSize = slidesGrid[i3 + increment2] - slidesGrid[i3];
        }
      } else if (currentPos >= slidesGrid[i3]) {
        stopIndex = i3;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === "next") {
        if (ratio >= params.longSwipesRatio)
          swiper.slideTo(stopIndex + increment);
        else
          swiper.slideTo(stopIndex);
      }
      if (swiper.swipeDirection === "prev") {
        if (ratio > 1 - params.longSwipesRatio)
          swiper.slideTo(stopIndex + increment);
        else
          swiper.slideTo(stopIndex);
      }
    } else {
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      const isNavButtonTarget = swiper.navigation && (e2.target === swiper.navigation.nextEl || e2.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === "next") {
          swiper.slideTo(stopIndex + increment);
        }
        if (swiper.swipeDirection === "prev") {
          swiper.slideTo(stopIndex);
        }
      } else if (e2.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }

  // node_modules/swiper/core/events/onResize.js
  function onResize() {
    const swiper = this;
    const {
      params,
      el
    } = swiper;
    if (el && el.offsetWidth === 0)
      return;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    const {
      allowSlideNext,
      allowSlidePrev,
      snapGrid
    } = swiper;
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  // node_modules/swiper/core/events/onClick.js
  function onClick(e2) {
    const swiper = this;
    if (!swiper.enabled)
      return;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks)
        e2.preventDefault();
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e2.stopPropagation();
        e2.stopImmediatePropagation();
      }
    }
  }

  // node_modules/swiper/core/events/onScroll.js
  function onScroll() {
    const swiper = this;
    const {
      wrapperEl,
      rtlTranslate,
      enabled
    } = swiper;
    if (!enabled)
      return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
      swiper.translate = -wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    }
    if (swiper.translate === -0)
      swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit("setTranslate", swiper.translate, false);
  }

  // node_modules/swiper/core/events/index.js
  var dummyEventAttached = false;
  function dummyEventListener() {
  }
  var events = (swiper, method) => {
    const document3 = getDocument();
    const {
      params,
      touchEvents,
      el,
      wrapperEl,
      device,
      support: support2
    } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!support2.touch) {
      el[domMethod](touchEvents.start, swiper.onTouchStart, false);
      document3[domMethod](touchEvents.move, swiper.onTouchMove, capture);
      document3[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
      const passiveListener = touchEvents.start === "touchstart" && support2.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
      el[domMethod](touchEvents.move, swiper.onTouchMove, support2.passiveListener ? {
        passive: false,
        capture
      } : capture);
      el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
      if (touchEvents.cancel) {
        el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }
    if (params.preventClicks || params.preventClicksPropagation) {
      el[domMethod]("click", swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl[domMethod]("scroll", swiper.onScroll);
    }
    if (params.updateOnWindowResize) {
      swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    } else {
      swiper[swiperMethod]("observerUpdate", onResize, true);
    }
  };
  function attachEvents() {
    const swiper = this;
    const document3 = getDocument();
    const {
      params,
      support: support2
    } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    if (support2.touch && !dummyEventAttached) {
      document3.addEventListener("touchstart", dummyEventListener);
      dummyEventAttached = true;
    }
    events(swiper, "on");
  }
  function detachEvents() {
    const swiper = this;
    events(swiper, "off");
  }
  var events_default = {
    attachEvents,
    detachEvents
  };

  // node_modules/swiper/core/breakpoints/setBreakpoint.js
  var isGridEnabled = (swiper, params) => {
    return swiper.grid && params.grid && params.grid.rows > 1;
  };
  function setBreakpoint() {
    const swiper = this;
    const {
      activeIndex,
      initialized,
      loopedSlides = 0,
      params,
      $el
    } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0)
      return;
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint)
      return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : void 0;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
      $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      $el.addClass(`${params.containerModifierClass}grid`);
      if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
        $el.addClass(`${params.containerModifierClass}grid-column`);
      }
      swiper.emitContainerClasses();
    }
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) {
      swiper.changeDirection();
    }
    extend3(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) {
      swiper.disable();
    } else if (!wasEnabled && isEnabled) {
      swiper.enable();
    }
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
  }

  // node_modules/swiper/core/breakpoints/getBreakpoint.js
  function getBreakpoint(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl)
      return void 0;
    let breakpoint = false;
    const window2 = getWindow();
    const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point) => {
      if (typeof point === "string" && point.indexOf("@") === 0) {
        const minRatio = parseFloat(point.substr(1));
        const value = currentHeight * minRatio;
        return {
          value,
          point
        };
      }
      return {
        value: point,
        point
      };
    });
    points.sort((a3, b2) => parseInt(a3.value, 10) - parseInt(b2.value, 10));
    for (let i3 = 0; i3 < points.length; i3 += 1) {
      const {
        point,
        value
      } = points[i3];
      if (base === "window") {
        if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
          breakpoint = point;
        }
      } else if (value <= containerEl.clientWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || "max";
  }

  // node_modules/swiper/core/breakpoints/index.js
  var breakpoints_default = {
    setBreakpoint,
    getBreakpoint
  };

  // node_modules/swiper/core/classes/addClasses.js
  function prepareClasses(entries, prefix2) {
    const resultClasses = [];
    entries.forEach((item) => {
      if (typeof item === "object") {
        Object.keys(item).forEach((classNames) => {
          if (item[classNames]) {
            resultClasses.push(prefix2 + classNames);
          }
        });
      } else if (typeof item === "string") {
        resultClasses.push(prefix2 + item);
      }
    });
    return resultClasses;
  }
  function addClasses() {
    const swiper = this;
    const {
      classNames,
      params,
      rtl,
      $el,
      device,
      support: support2
    } = swiper;
    const suffixes = prepareClasses(["initialized", params.direction, {
      "pointer-events": !support2.touch
    }, {
      "free-mode": swiper.params.freeMode && params.freeMode.enabled
    }, {
      "autoheight": params.autoHeight
    }, {
      "rtl": rtl
    }, {
      "grid": params.grid && params.grid.rows > 1
    }, {
      "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
    }, {
      "android": device.android
    }, {
      "ios": device.ios
    }, {
      "css-mode": params.cssMode
    }, {
      "centered": params.cssMode && params.centeredSlides
    }], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([...classNames].join(" "));
    swiper.emitContainerClasses();
  }

  // node_modules/swiper/core/classes/removeClasses.js
  function removeClasses() {
    const swiper = this;
    const {
      $el,
      classNames
    } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
  }

  // node_modules/swiper/core/classes/index.js
  var classes_default = {
    addClasses,
    removeClasses
  };

  // node_modules/swiper/core/images/loadImage.js
  function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window2 = getWindow();
    let image;
    function onReady() {
      if (callback)
        callback();
    }
    const isPicture = dom_default(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
      if (src) {
        image = new window2.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      onReady();
    }
  }

  // node_modules/swiper/core/images/preloadImages.js
  function preloadImages() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
      if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed)
        return;
      if (swiper.imagesLoaded !== void 0)
        swiper.imagesLoaded += 1;
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady)
          swiper.update();
        swiper.emit("imagesReady");
      }
    }
    for (let i3 = 0; i3 < swiper.imagesToLoad.length; i3 += 1) {
      const imageEl = swiper.imagesToLoad[i3];
      swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
  }

  // node_modules/swiper/core/images/index.js
  var images_default = {
    loadImage,
    preloadImages
  };

  // node_modules/swiper/core/check-overflow/index.js
  function checkOverflow() {
    const swiper = this;
    const {
      isLocked: wasLocked,
      params
    } = swiper;
    const {
      slidesOffsetBefore
    } = params;
    if (slidesOffsetBefore) {
      const lastSlideIndex = swiper.slides.length - 1;
      const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
      swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }
    if (params.allowSlideNext === true) {
      swiper.allowSlideNext = !swiper.isLocked;
    }
    if (params.allowSlidePrev === true) {
      swiper.allowSlidePrev = !swiper.isLocked;
    }
    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
    }
    if (wasLocked !== swiper.isLocked) {
      swiper.emit(swiper.isLocked ? "lock" : "unlock");
    }
  }
  var check_overflow_default = {
    checkOverflow
  };

  // node_modules/swiper/core/defaults.js
  var defaults_default = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: false,
    userAgent: null,
    url: null,
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    autoHeight: false,
    setWrapperSize: false,
    virtualTranslate: false,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    watchOverflow: true,
    roundLengths: false,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    uniqueNavElements: true,
    resistance: true,
    resistanceRatio: 0.85,
    watchSlidesProgress: false,
    grabCursor: false,
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    preloadImages: true,
    updateOnImagesReady: true,
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: true,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    runCallbacksOnInit: true,
    _emitClasses: false
  };

  // node_modules/swiper/core/moduleExtendParams.js
  function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
      const moduleParamName = Object.keys(obj)[0];
      const moduleParams = obj[moduleParamName];
      if (typeof moduleParams !== "object" || moduleParams === null) {
        extend3(allModulesParams, obj);
        return;
      }
      if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
        params[moduleParamName] = {
          auto: true
        };
      }
      if (!(moduleParamName in params && "enabled" in moduleParams)) {
        extend3(allModulesParams, obj);
        return;
      }
      if (params[moduleParamName] === true) {
        params[moduleParamName] = {
          enabled: true
        };
      }
      if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
        params[moduleParamName].enabled = true;
      }
      if (!params[moduleParamName])
        params[moduleParamName] = {
          enabled: false
        };
      extend3(allModulesParams, obj);
    };
  }

  // node_modules/swiper/core/core.js
  var prototypes = {
    eventsEmitter: events_emitter_default,
    update: update_default,
    translate: translate_default,
    transition: transition_default,
    slide: slide_default,
    loop: loop_default,
    grabCursor: grab_cursor_default,
    events: events_default,
    breakpoints: breakpoints_default,
    checkOverflow: check_overflow_default,
    classes: classes_default,
    images: images_default
  };
  var extendedDefaults = {};
  var Swiper = class {
    constructor(...args) {
      let el;
      let params;
      if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
        params = args[0];
      } else {
        [el, params] = args;
      }
      if (!params)
        params = {};
      params = extend3({}, params);
      if (el && !params.el)
        params.el = el;
      if (params.el && dom_default(params.el).length > 1) {
        const swipers = [];
        dom_default(params.el).each((containerEl) => {
          const newParams = extend3({}, params, {
            el: containerEl
          });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }
      const swiper = this;
      swiper.__swiper__ = true;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];
      swiper.modules = [...swiper.__modules__];
      if (params.modules && Array.isArray(params.modules)) {
        swiper.modules.push(...params.modules);
      }
      const allModulesParams = {};
      swiper.modules.forEach((mod) => {
        mod({
          swiper,
          extendParams: moduleExtendParams(params, allModulesParams),
          on: swiper.on.bind(swiper),
          once: swiper.once.bind(swiper),
          off: swiper.off.bind(swiper),
          emit: swiper.emit.bind(swiper)
        });
      });
      const swiperParams = extend3({}, defaults_default, allModulesParams);
      swiper.params = extend3({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend3({}, swiper.params);
      swiper.passedParams = extend3({}, params);
      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach((eventName) => {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }
      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      }
      swiper.$ = dom_default;
      Object.assign(swiper, {
        enabled: swiper.params.enabled,
        el,
        classNames: [],
        slides: dom_default(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal() {
          return swiper.params.direction === "horizontal";
        },
        isVertical() {
          return swiper.params.direction === "vertical";
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: true,
        isEnd: false,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        touchEvents: function touchEvents() {
          const touch = ["touchstart", "touchmove", "touchend", "touchcancel"];
          const desktop = ["pointerdown", "pointermove", "pointerup"];
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3]
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2]
          };
          return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }(),
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: swiper.params.focusableElements,
          lastClickTime: now(),
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          isTouchEvent: void 0,
          startMoving: void 0
        },
        allowClick: true,
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        imagesToLoad: [],
        imagesLoaded: 0
      });
      swiper.emit("_swiper");
      if (swiper.params.init) {
        swiper.init();
      }
      return swiper;
    }
    enable() {
      const swiper = this;
      if (swiper.enabled)
        return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit("enable");
    }
    disable() {
      const swiper = this;
      if (!swiper.enabled)
        return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit("disable");
    }
    setProgress(progress, speed) {
      const swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      const min5 = swiper.minTranslate();
      const max3 = swiper.maxTranslate();
      const current = (max3 - min5) * progress + min5;
      swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el)
        return;
      const cls = swiper.el.className.split(" ").filter((className) => {
        return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
      const swiper = this;
      return slideEl.className.split(" ").filter((className) => {
        return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(" ");
    }
    emitSlidesClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el)
        return;
      const updates = [];
      swiper.slides.each((slideEl) => {
        const classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl,
          classNames
        });
        swiper.emit("_slideClass", slideEl, classNames);
      });
      swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
      const swiper = this;
      const {
        params,
        slides,
        slidesGrid,
        slidesSizesGrid,
        size: swiperSize,
        activeIndex
      } = swiper;
      let spv = 1;
      if (params.centeredSlides) {
        let slideSize = slides[activeIndex].swiperSlideSize;
        let breakLoop;
        for (let i3 = activeIndex + 1; i3 < slides.length; i3 += 1) {
          if (slides[i3] && !breakLoop) {
            slideSize += slides[i3].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize)
              breakLoop = true;
          }
        }
        for (let i3 = activeIndex - 1; i3 >= 0; i3 -= 1) {
          if (slides[i3] && !breakLoop) {
            slideSize += slides[i3].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize)
              breakLoop = true;
          }
        }
      } else {
        if (view === "current") {
          for (let i3 = activeIndex + 1; i3 < slides.length; i3 += 1) {
            const slideInView = exact ? slidesGrid[i3] + slidesSizesGrid[i3] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i3] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          for (let i3 = activeIndex - 1; i3 >= 0; i3 -= 1) {
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
    update() {
      const swiper = this;
      if (!swiper || swiper.destroyed)
        return;
      const {
        snapGrid,
        params
      } = swiper;
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate2() {
        const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      let translated;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
        setTranslate2();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate2();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
      const swiper = this;
      const currentDirection = swiper.params.direction;
      if (!newDirection) {
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
      }
      if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
        return swiper;
      }
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.each((slideEl) => {
        if (newDirection === "vertical") {
          slideEl.style.width = "";
        } else {
          slideEl.style.height = "";
        }
      });
      swiper.emit("changeDirection");
      if (needUpdate)
        swiper.update();
      return swiper;
    }
    mount(el) {
      const swiper = this;
      if (swiper.mounted)
        return true;
      const $el = dom_default(el || swiper.params.el);
      el = $el[0];
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      const getWrapperSelector = () => {
        return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
      };
      const getWrapper = () => {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          const res = dom_default(el.shadowRoot.querySelector(getWrapperSelector()));
          res.children = (options) => $el.children(options);
          return res;
        }
        return $el.children(getWrapperSelector());
      };
      let $wrapperEl = getWrapper();
      if ($wrapperEl.length === 0 && swiper.params.createElements) {
        const document3 = getDocument();
        const wrapper = document3.createElement("div");
        $wrapperEl = dom_default(wrapper);
        wrapper.className = swiper.params.wrapperClass;
        $el.append(wrapper);
        $el.children(`.${swiper.params.slideClass}`).each((slideEl) => {
          $wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        $el,
        el,
        $wrapperEl,
        wrapperEl: $wrapperEl[0],
        mounted: true,
        rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
        rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
        wrongRTL: $wrapperEl.css("display") === "-webkit-box"
      });
      return true;
    }
    init(el) {
      const swiper = this;
      if (swiper.initialized)
        return swiper;
      const mounted = swiper.mount(el);
      if (mounted === false)
        return swiper;
      swiper.emit("beforeInit");
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.addClasses();
      if (swiper.params.loop) {
        swiper.loopCreate();
      }
      swiper.updateSize();
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }
      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }
      swiper.attachEvents();
      swiper.initialized = true;
      swiper.emit("init");
      swiper.emit("afterInit");
      return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
      const swiper = this;
      const {
        params,
        $el,
        $wrapperEl,
        slides
      } = swiper;
      if (typeof swiper.params === "undefined" || swiper.destroyed) {
        return null;
      }
      swiper.emit("beforeDestroy");
      swiper.initialized = false;
      swiper.detachEvents();
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr("style");
        $wrapperEl.removeAttr("style");
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
      }
      swiper.emit("destroy");
      Object.keys(swiper.eventsListeners).forEach((eventName) => {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
    static extendDefaults(newDefaults) {
      extend3(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
      return extendedDefaults;
    }
    static get defaults() {
      return defaults_default;
    }
    static installModule(mod) {
      if (!Swiper.prototype.__modules__)
        Swiper.prototype.__modules__ = [];
      const modules = Swiper.prototype.__modules__;
      if (typeof mod === "function" && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
    static use(module) {
      if (Array.isArray(module)) {
        module.forEach((m4) => Swiper.installModule(m4));
        return Swiper;
      }
      Swiper.installModule(module);
      return Swiper;
    }
  };
  Object.keys(prototypes).forEach((prototypeGroup) => {
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
      Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper.use([Resize, Observer]);
  var core_default = Swiper;

  // node_modules/swiper/shared/create-element-if-not-defined.js
  function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    const document3 = getDocument();
    if (swiper.params.createElements) {
      Object.keys(checkProps).forEach((key) => {
        if (!params[key] && params.auto === true) {
          let element = swiper.$el.children(`.${checkProps[key]}`)[0];
          if (!element) {
            element = document3.createElement("div");
            element.className = checkProps[key];
            swiper.$el.append(element);
          }
          params[key] = element;
          originalParams[key] = element;
        }
      });
    }
    return params;
  }

  // node_modules/swiper/modules/navigation/navigation.js
  function Navigation({
    swiper,
    extendParams,
    on: on3,
    emit: emit2
  }) {
    extendParams({
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: false,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock"
      }
    });
    swiper.navigation = {
      nextEl: null,
      $nextEl: null,
      prevEl: null,
      $prevEl: null
    };
    function getEl(el) {
      let $el;
      if (el) {
        $el = dom_default(el);
        if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) {
          $el = swiper.$el.find(el);
        }
      }
      return $el;
    }
    function toggleEl($el, disabled) {
      const params = swiper.params.navigation;
      if ($el && $el.length > 0) {
        $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
        if ($el[0] && $el[0].tagName === "BUTTON")
          $el[0].disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
      }
    }
    function update() {
      if (swiper.params.loop)
        return;
      const {
        $nextEl,
        $prevEl
      } = swiper.navigation;
      toggleEl($prevEl, swiper.isBeginning);
      toggleEl($nextEl, swiper.isEnd);
    }
    function onPrevClick(e2) {
      e2.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop)
        return;
      swiper.slidePrev();
    }
    function onNextClick(e2) {
      e2.preventDefault();
      if (swiper.isEnd && !swiper.params.loop)
        return;
      swiper.slideNext();
    }
    function init() {
      const params = swiper.params.navigation;
      swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      });
      if (!(params.nextEl || params.prevEl))
        return;
      const $nextEl = getEl(params.nextEl);
      const $prevEl = getEl(params.prevEl);
      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on("click", onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on("click", onPrevClick);
      }
      Object.assign(swiper.navigation, {
        $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl,
        prevEl: $prevEl && $prevEl[0]
      });
      if (!swiper.enabled) {
        if ($nextEl)
          $nextEl.addClass(params.lockClass);
        if ($prevEl)
          $prevEl.addClass(params.lockClass);
      }
    }
    function destroy() {
      const {
        $nextEl,
        $prevEl
      } = swiper.navigation;
      if ($nextEl && $nextEl.length) {
        $nextEl.off("click", onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off("click", onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    }
    on3("init", () => {
      init();
      update();
    });
    on3("toEdge fromEdge lock unlock", () => {
      update();
    });
    on3("destroy", () => {
      destroy();
    });
    on3("enable disable", () => {
      const {
        $nextEl,
        $prevEl
      } = swiper.navigation;
      if ($nextEl) {
        $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
      }
      if ($prevEl) {
        $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
      }
    });
    on3("click", (_s, e2) => {
      const {
        $nextEl,
        $prevEl
      } = swiper.navigation;
      const targetEl = e2.target;
      if (swiper.params.navigation.hideOnClick && !dom_default(targetEl).is($prevEl) && !dom_default(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl)))
          return;
        let isHidden;
        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          emit2("navigationShow");
        } else {
          emit2("navigationHide");
        }
        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    });
    Object.assign(swiper.navigation, {
      update,
      init,
      destroy
    });
  }

  // node_modules/swiper/modules/scrollbar/scrollbar.js
  function Scrollbar({
    swiper,
    extendParams,
    on: on3,
    emit: emit2
  }) {
    const document3 = getDocument();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
      scrollbar: {
        el: null,
        dragSize: "auto",
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: "swiper-scrollbar-lock",
        dragClass: "swiper-scrollbar-drag"
      }
    });
    swiper.scrollbar = {
      el: null,
      dragEl: null,
      $el: null,
      $dragEl: null
    };
    function setTranslate2() {
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
        return;
      const {
        scrollbar,
        rtlTranslate: rtl,
        progress
      } = swiper;
      const {
        $dragEl,
        $el
      } = scrollbar;
      const params = swiper.params.scrollbar;
      let newSize = dragSize;
      let newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
        $dragEl[0].style.width = `${newSize}px`;
      } else {
        $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
        $dragEl[0].style.height = `${newSize}px`;
      }
      if (params.hide) {
        clearTimeout(timeout);
        $el[0].style.opacity = 1;
        timeout = setTimeout(() => {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1e3);
      }
    }
    function setTransition2(duration) {
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
        return;
      swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize2() {
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
        return;
      const {
        scrollbar
      } = swiper;
      const {
        $dragEl,
        $el
      } = scrollbar;
      $dragEl[0].style.width = "";
      $dragEl[0].style.height = "";
      trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
      divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
      if (swiper.params.scrollbar.dragSize === "auto") {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }
      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = `${dragSize}px`;
      } else {
        $dragEl[0].style.height = `${dragSize}px`;
      }
      if (divider >= 1) {
        $el[0].style.display = "none";
      } else {
        $el[0].style.display = "";
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
      }
    }
    function getPointerPosition(e2) {
      if (swiper.isHorizontal()) {
        return e2.type === "touchstart" || e2.type === "touchmove" ? e2.targetTouches[0].clientX : e2.clientX;
      }
      return e2.type === "touchstart" || e2.type === "touchmove" ? e2.targetTouches[0].clientY : e2.clientY;
    }
    function setDragPosition(e2) {
      const {
        scrollbar,
        rtlTranslate: rtl
      } = swiper;
      const {
        $el
      } = scrollbar;
      let positionRatio;
      positionRatio = (getPointerPosition(e2) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }
      const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    function onDragStart(e2) {
      const params = swiper.params.scrollbar;
      const {
        scrollbar,
        $wrapperEl
      } = swiper;
      const {
        $el,
        $dragEl
      } = scrollbar;
      isTouched = true;
      dragStartPos = e2.target === $dragEl[0] || e2.target === $dragEl ? getPointerPosition(e2) - e2.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
      e2.preventDefault();
      e2.stopPropagation();
      $wrapperEl.transition(100);
      $dragEl.transition(100);
      setDragPosition(e2);
      clearTimeout(dragTimeout);
      $el.transition(0);
      if (params.hide) {
        $el.css("opacity", 1);
      }
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css("scroll-snap-type", "none");
      }
      emit2("scrollbarDragStart", e2);
    }
    function onDragMove(e2) {
      const {
        scrollbar,
        $wrapperEl
      } = swiper;
      const {
        $el,
        $dragEl
      } = scrollbar;
      if (!isTouched)
        return;
      if (e2.preventDefault)
        e2.preventDefault();
      else
        e2.returnValue = false;
      setDragPosition(e2);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      emit2("scrollbarDragMove", e2);
    }
    function onDragEnd(e2) {
      const params = swiper.params.scrollbar;
      const {
        scrollbar,
        $wrapperEl
      } = swiper;
      const {
        $el
      } = scrollbar;
      if (!isTouched)
        return;
      isTouched = false;
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css("scroll-snap-type", "");
        $wrapperEl.transition("");
      }
      if (params.hide) {
        clearTimeout(dragTimeout);
        dragTimeout = nextTick2(() => {
          $el.css("opacity", 0);
          $el.transition(400);
        }, 1e3);
      }
      emit2("scrollbarDragEnd", e2);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    }
    function events2(method) {
      const {
        scrollbar,
        touchEventsTouch,
        touchEventsDesktop,
        params,
        support: support2
      } = swiper;
      const $el = scrollbar.$el;
      const target = $el[0];
      const activeListener = support2.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
      } : false;
      const passiveListener = support2.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      if (!target)
        return;
      const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
      if (!support2.touch) {
        target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
        document3[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
        document3[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
      } else {
        target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
        target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
        target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
      }
    }
    function enableDraggable() {
      if (!swiper.params.scrollbar.el)
        return;
      events2("on");
    }
    function disableDraggable() {
      if (!swiper.params.scrollbar.el)
        return;
      events2("off");
    }
    function init() {
      const {
        scrollbar,
        $el: $swiperEl
      } = swiper;
      swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
        el: "swiper-scrollbar"
      });
      const params = swiper.params.scrollbar;
      if (!params.el)
        return;
      let $el = dom_default(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }
      let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
      if ($dragEl.length === 0) {
        $dragEl = dom_default(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
        $el.append($dragEl);
      }
      Object.assign(scrollbar, {
        $el,
        el: $el[0],
        $dragEl,
        dragEl: $dragEl[0]
      });
      if (params.draggable) {
        enableDraggable();
      }
      if ($el) {
        $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
      }
    }
    function destroy() {
      disableDraggable();
    }
    on3("init", () => {
      init();
      updateSize2();
      setTranslate2();
    });
    on3("update resize observerUpdate lock unlock", () => {
      updateSize2();
    });
    on3("setTranslate", () => {
      setTranslate2();
    });
    on3("setTransition", (_s, duration) => {
      setTransition2(duration);
    });
    on3("enable disable", () => {
      const {
        $el
      } = swiper.scrollbar;
      if ($el) {
        $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
      }
    });
    on3("destroy", () => {
      destroy();
    });
    Object.assign(swiper.scrollbar, {
      updateSize: updateSize2,
      setTranslate: setTranslate2,
      init,
      destroy
    });
  }

  // node_modules/swiper/modules/lazy/lazy.js
  function Lazy({
    swiper,
    extendParams,
    on: on3,
    emit: emit2
  }) {
    extendParams({
      lazy: {
        checkInView: false,
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,
        scrollingElement: "",
        elementClass: "swiper-lazy",
        loadingClass: "swiper-lazy-loading",
        loadedClass: "swiper-lazy-loaded",
        preloaderClass: "swiper-lazy-preloader"
      }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index3, loadInDuplicate = true) {
      const params = swiper.params.lazy;
      if (typeof index3 === "undefined")
        return;
      if (swiper.slides.length === 0)
        return;
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index3}"]`) : swiper.slides.eq(index3);
      const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images.push($slideEl[0]);
      }
      if ($images.length === 0)
        return;
      $images.each((imageEl) => {
        const $imageEl = dom_default(imageEl);
        $imageEl.addClass(params.loadingClass);
        const background = $imageEl.attr("data-background");
        const src = $imageEl.attr("data-src");
        const srcset = $imageEl.attr("data-srcset");
        const sizes = $imageEl.attr("data-sizes");
        const $pictureEl = $imageEl.parent("picture");
        swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
          if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed)
            return;
          if (background) {
            $imageEl.css("background-image", `url("${background}")`);
            $imageEl.removeAttr("data-background");
          } else {
            if (srcset) {
              $imageEl.attr("srcset", srcset);
              $imageEl.removeAttr("data-srcset");
            }
            if (sizes) {
              $imageEl.attr("sizes", sizes);
              $imageEl.removeAttr("data-sizes");
            }
            if ($pictureEl.length) {
              $pictureEl.children("source").each((sourceEl) => {
                const $source = dom_default(sourceEl);
                if ($source.attr("data-srcset")) {
                  $source.attr("srcset", $source.attr("data-srcset"));
                  $source.removeAttr("data-srcset");
                }
              });
            }
            if (src) {
              $imageEl.attr("src", src);
              $imageEl.removeAttr("data-src");
            }
          }
          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(`.${params.preloaderClass}`).remove();
          if (swiper.params.loop && loadInDuplicate) {
            const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
              loadInSlide(originalSlide.index(), false);
            } else {
              const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
              loadInSlide(duplicatedSlide.index(), false);
            }
          }
          emit2("lazyImageReady", $slideEl[0], $imageEl[0]);
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        });
        emit2("lazyImageLoad", $slideEl[0], $imageEl[0]);
      });
    }
    function load() {
      const {
        $wrapperEl,
        params: swiperParams,
        slides,
        activeIndex
      } = swiper;
      const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      const params = swiperParams.lazy;
      let slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === "auto") {
        slidesPerView = 0;
      }
      function slideExist(index3) {
        if (isVirtual) {
          if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index3}"]`).length) {
            return true;
          }
        } else if (slides[index3])
          return true;
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return dom_default(slideEl).attr("data-swiper-slide-index");
        }
        return dom_default(slideEl).index();
      }
      if (!initialImageLoaded)
        initialImageLoaded = true;
      if (swiper.params.watchSlidesProgress) {
        $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl) => {
          const index3 = isVirtual ? dom_default(slideEl).attr("data-swiper-slide-index") : dom_default(slideEl).index();
          loadInSlide(index3);
        });
      } else if (slidesPerView > 1) {
        for (let i3 = activeIndex; i3 < activeIndex + slidesPerView; i3 += 1) {
          if (slideExist(i3))
            loadInSlide(i3);
        }
      } else {
        loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
          const amount = params.loadPrevNextAmount;
          const spv = slidesPerView;
          const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          for (let i3 = activeIndex + slidesPerView; i3 < maxIndex; i3 += 1) {
            if (slideExist(i3))
              loadInSlide(i3);
          }
          for (let i3 = minIndex; i3 < activeIndex; i3 += 1) {
            if (slideExist(i3))
              loadInSlide(i3);
          }
        } else {
          const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
          if (nextSlide.length > 0)
            loadInSlide(slideIndex(nextSlide));
          const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
          if (prevSlide.length > 0)
            loadInSlide(slideIndex(prevSlide));
        }
      }
    }
    function checkInViewOnLoad() {
      const window2 = getWindow();
      if (!swiper || swiper.destroyed)
        return;
      const $scrollElement = swiper.params.lazy.scrollingElement ? dom_default(swiper.params.lazy.scrollingElement) : dom_default(window2);
      const isWindow = $scrollElement[0] === window2;
      const scrollElementWidth = isWindow ? window2.innerWidth : $scrollElement[0].offsetWidth;
      const scrollElementHeight = isWindow ? window2.innerHeight : $scrollElement[0].offsetHeight;
      const swiperOffset = swiper.$el.offset();
      const {
        rtlTranslate: rtl
      } = swiper;
      let inView = false;
      if (rtl)
        swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
      for (let i3 = 0; i3 < swiperCoord.length; i3 += 1) {
        const point = swiperCoord[i3];
        if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
          if (point[0] === 0 && point[1] === 0)
            continue;
          inView = true;
        }
      }
      const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      if (inView) {
        load();
        $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
      } else if (!scrollHandlerAttached) {
        scrollHandlerAttached = true;
        $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
      }
    }
    on3("beforeInit", () => {
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    });
    on3("init", () => {
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    });
    on3("scroll", () => {
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
        load();
      }
    });
    on3("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    });
    on3("transitionStart", () => {
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
          if (swiper.params.lazy.checkInView) {
            checkInViewOnLoad();
          } else {
            load();
          }
        }
      }
    });
    on3("transitionEnd", () => {
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    });
    on3("slideChange", () => {
      const {
        lazy,
        cssMode,
        watchSlidesProgress,
        touchReleaseOnEdges,
        resistanceRatio
      } = swiper.params;
      if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
        load();
      }
    });
    Object.assign(swiper.lazy, {
      load,
      loadInSlide
    });
  }

  // node_modules/swiper/modules/thumbs/thumbs.js
  function Thumb({
    swiper,
    extendParams,
    on: on3
  }) {
    extendParams({
      thumbs: {
        swiper: null,
        multipleActiveThumbs: true,
        autoScrollOffset: 0,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        thumbsContainerClass: "swiper-thumbs"
      }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
      swiper: null
    };
    function onThumbClick() {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper)
        return;
      const clickedIndex = thumbsSwiper.clickedIndex;
      const clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && dom_default(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass))
        return;
      if (typeof clickedIndex === "undefined" || clickedIndex === null)
        return;
      let slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt(dom_default(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        let currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
        const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
        if (typeof prevIndex === "undefined")
          slideToIndex = nextIndex;
        else if (typeof nextIndex === "undefined")
          slideToIndex = prevIndex;
        else if (nextIndex - currentIndex < currentIndex - prevIndex)
          slideToIndex = nextIndex;
        else
          slideToIndex = prevIndex;
      }
      swiper.slideTo(slideToIndex);
    }
    function init() {
      const {
        thumbs: thumbsParams
      } = swiper.params;
      if (initialized)
        return false;
      initialized = true;
      const SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Object.assign(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        Object.assign(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
      } else if (isObject3(thumbsParams.swiper)) {
        const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
        Object.assign(thumbsSwiperParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
        swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on("tap", onThumbClick);
      return true;
    }
    function update(initial) {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper)
        return;
      const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
      const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
      const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
      if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
        let currentThumbsIndex = thumbsSwiper.activeIndex;
        let newThumbsIndex;
        let direction;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
          const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
          if (typeof prevThumbsIndex === "undefined") {
            newThumbsIndex = nextThumbsIndex;
          } else if (typeof nextThumbsIndex === "undefined") {
            newThumbsIndex = prevThumbsIndex;
          } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
            newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
          } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
            newThumbsIndex = nextThumbsIndex;
          } else {
            newThumbsIndex = prevThumbsIndex;
          }
          direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
        } else {
          newThumbsIndex = swiper.realIndex;
          direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
        }
        if (useOffset) {
          newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
        }
      }
      let thumbsToActivate = 1;
      const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }
      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }
      thumbsToActivate = Math.floor(thumbsToActivate);
      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
        for (let i3 = 0; i3 < thumbsToActivate; i3 += 1) {
          thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i3}"]`).addClass(thumbActiveClass);
        }
      } else {
        for (let i3 = 0; i3 < thumbsToActivate; i3 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i3).addClass(thumbActiveClass);
        }
      }
    }
    on3("beforeInit", () => {
      const {
        thumbs
      } = swiper.params;
      if (!thumbs || !thumbs.swiper)
        return;
      init();
      update(true);
    });
    on3("slideChange update resize observerUpdate", () => {
      if (!swiper.thumbs.swiper)
        return;
      update();
    });
    on3("setTransition", (_s, duration) => {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper)
        return;
      thumbsSwiper.setTransition(duration);
    });
    on3("beforeDestroy", () => {
      const thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper)
        return;
      if (swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    });
    Object.assign(swiper.thumbs, {
      init,
      update
    });
  }

  // node_modules/swiper/shared/effect-init.js
  function effectInit(params) {
    const {
      effect: effect4,
      swiper,
      on: on3,
      setTranslate: setTranslate2,
      setTransition: setTransition2,
      overwriteParams,
      perspective
    } = params;
    on3("beforeInit", () => {
      if (swiper.params.effect !== effect4)
        return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}${effect4}`);
      if (perspective && perspective()) {
        swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      }
      const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
      Object.assign(swiper.params, overwriteParamsResult);
      Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on3("setTranslate", () => {
      if (swiper.params.effect !== effect4)
        return;
      setTranslate2();
    });
    on3("setTransition", (_s, duration) => {
      if (swiper.params.effect !== effect4)
        return;
      setTransition2(duration);
    });
  }

  // node_modules/swiper/shared/effect-target.js
  function effectTarget(effectParams, $slideEl) {
    if (effectParams.transformEl) {
      return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
      });
    }
    return $slideEl;
  }

  // node_modules/swiper/shared/effect-virtual-transition-end.js
  function effectVirtualTransitionEnd({
    swiper,
    duration,
    transformEl,
    allSlides
  }) {
    const {
      slides,
      activeIndex,
      $wrapperEl
    } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
      let eventTriggered = false;
      let $transitionEndTarget;
      if (allSlides) {
        $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
      } else {
        $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
      }
      $transitionEndTarget.transitionEnd(() => {
        if (eventTriggered)
          return;
        if (!swiper || swiper.destroyed)
          return;
        eventTriggered = true;
        swiper.animating = false;
        const triggerEvents = ["webkitTransitionEnd", "transitionend"];
        for (let i3 = 0; i3 < triggerEvents.length; i3 += 1) {
          $wrapperEl.trigger(triggerEvents[i3]);
        }
      });
    }
  }

  // node_modules/swiper/modules/effect-fade/effect-fade.js
  function EffectFade({
    swiper,
    extendParams,
    on: on3
  }) {
    extendParams({
      fadeEffect: {
        crossFade: false,
        transformEl: null
      }
    });
    const setTranslate2 = () => {
      const {
        slides
      } = swiper;
      const params = swiper.params.fadeEffect;
      for (let i3 = 0; i3 < slides.length; i3 += 1) {
        const $slideEl = swiper.slides.eq(i3);
        const offset2 = $slideEl[0].swiperSlideOffset;
        let tx = -offset2;
        if (!swiper.params.virtualTranslate)
          tx -= swiper.translate;
        let ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        const $targetEl = effectTarget(params, $slideEl);
        $targetEl.css({
          opacity: slideOpacity
        }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
      }
    };
    const setTransition2 = (duration) => {
      const {
        transformEl
      } = swiper.params.fadeEffect;
      const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
      $transitionElements.transition(duration);
      effectVirtualTransitionEnd({
        swiper,
        duration,
        transformEl,
        allSlides: true
      });
    };
    effectInit({
      effect: "fade",
      swiper,
      on: on3,
      setTranslate: setTranslate2,
      setTransition: setTransition2,
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: !swiper.params.cssMode
      })
    });
  }

  // source/import/carousel-scrollbar.js
  (function(window2, document3) {
    "use strict";
    function activateVisibleScrollbar() {
      core_default.use([Scrollbar, Lazy]);
      $("[data-package-sheet-carousel]").map((i3, element) => {
        new core_default(element, {
          lazy: true,
          freeMode: false,
          slidesPerView: 1,
          scrollbar: {
            el: $(element).find(".swiper-scrollbar")[0],
            draggable: true,
            hide: false,
            dragSize: 17
          }
        });
      });
      var packageTitles = document3.querySelectorAll("[data-package]");
      var packageSummeries = document3.querySelectorAll("[data-package-summary]");
      packageSummeries[0].classList.add("open", "relative", "z-10");
      packageSummeries[0].classList.remove("absolute");
      for (var packageTitle of packageTitles) {
        packageTitle.addEventListener("click", function() {
          var packageSlugify = this.getAttribute("data-package");
          for (var packageSummery of packageSummeries) {
            packageSummery.classList.remove("open", "z-10");
            if (packageSummery.getAttribute("data-package-summary") === packageSlugify) {
              packageSummery.classList.add("open", "z-10");
            }
          }
        });
      }
    }
    function slideshowInit() {
      core_default.use([Navigation, Scrollbar]);
      new core_default(".swiper-container--with-scrollbar.package-page__image-carousel", {
        slidesPerView: 1.15,
        spaceBetween: 12,
        scrollbar: {
          slidesPerView: 1,
          el: ".swiper-scrollbar",
          draggable: true,
          hide: false,
          dragSize: 17
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          768: {
            spaceBetween: 30,
            slidesPerView: "auto"
          }
        }
      });
    }
    function pressScrollbar() {
      core_default.use([Scrollbar]);
      new core_default(".swiper-container--with-scrollbar.press-carousel", {
        slidesPerView: "auto",
        spaceBetween: 12,
        scrollbar: {
          el: ".press-swiper-scrollbar",
          draggable: true,
          hide: false,
          dragSize: 17
        },
        breakpoints: {
          768: {
            spaceBetween: 30
          }
        }
      });
    }
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelector(".package-page__image-carousel")) {
        slideshowInit();
      }
      if (document3.querySelector("[data-package-sheet-carousel]")) {
        activateVisibleScrollbar();
      }
      if (document3.querySelector(".swiper-container--with-scrollbar.press-carousel")) {
        console.log("press");
        pressScrollbar();
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelector(".package-page__image-carousel")) {
        slideshowInit();
      }
      if (document3.querySelector("[data-package-sheet-carousel]")) {
        activateVisibleScrollbar();
      }
      if (document3.querySelector(".swiper-container--with-scrollbar.press-carousel")) {
        console.log("p0ress");
        pressScrollbar();
      }
    });
  })(window, document);

  // source/import/product-carousel.js
  (function(window2, document3) {
    "use strict";
    function productCarouselInit() {
      core_default.use([Navigation, Thumb]);
      var thumbs = new core_default(".product__media-list", {
        loop: true,
        spaceBetween: 32,
        slidesPerView: 4,
        freeMode: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
      var featuredMedia = new core_default(".featured-product-media", {
        loop: true,
        autoHeight: true,
        thumbs: {
          swiper: thumbs
        }
      });
    }
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelector(".product__media-list")) {
        productCarouselInit();
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelector(".product__media-list")) {
        productCarouselInit();
      }
    });
  })(window, document);

  // source/import/collections-carousel.js
  (function(window2, document3) {
    "use strict";
    function collectionsCarouselInit() {
      core_default.use([Navigation]);
      new core_default(".collections-container", {
        spaceBetween: 20,
        slidesPerView: 1.25,
        freeMode: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next.collections-button",
          prevEl: ".swiper-button-prev.collections-button"
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25
          },
          1024: {
            slidesPerView: 5
          }
        }
      });
    }
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelector(".collections-container")) {
        collectionsCarouselInit();
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelector(".collections-container")) {
        collectionsCarouselInit();
      }
    });
  })(window, document);

  // source/import/feature-collection-carousel.js
  (function(window2, document3) {
    "use strict";
    const featureCollectionCarouselInit = (sliderElm) => {
      core_default.use([Navigation]);
      const sliderIdentifier = sliderElm.dataset.id;
      return new core_default(`#` + sliderIdentifier, {
        spaceBetween: 20,
        slidesPerView: 1,
        freeMode: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: `.` + sliderIdentifier + `.swiper-button-next.fc-button`,
          prevEl: `.` + sliderIdentifier + `.swiper-button-prev.fc-button`
        },
        breakpoints: {
          768: {
            slidesPerView: 1.25
          },
          820: {
            slidesPerView: 2.25
          },
          1024: {
            slidesPerView: 3
          },
          1280: {
            slidesPerView: 4
          }
        }
      });
    };
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelectorAll(".feature-collection-container")) {
        const allSliders = document3.querySelectorAll(".feature-collection-container");
        allSliders.forEach((slider) => featureCollectionCarouselInit(slider));
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelectorAll(".feature-collection-container")) {
        const allSliders = document3.querySelectorAll(".feature-collection-container");
        allSliders.forEach((slider) => featureCollectionCarouselInit(slider));
      }
    });
  })(window, document);

  // source/import/breadcrumbs.js
  (function(window2, document3) {
    "use strict";
    var overlayHero = document3.querySelector(".overlay-hero");
    if (overlayHero) {
      document3.querySelector(".breadcrumbs").classList.add("overlay");
    }
  })(window, document);

  // source/import/video.js
  var import_plyr = __toModule(require_plyr_min());
  (function(window2, document3) {
    function videoInit() {
      if (document3.querySelector(".video-thumbnail")) {
        var thumbnails = document3.querySelectorAll(".video-thumbnail");
        thumbnails.forEach((thumbnail) => {
          var thumbnailContainer = thumbnail.closest(".video-thumbnail-container");
          var embedID = thumbnail.getAttribute("data-embed-id");
          var startTime = thumbnail.getAttribute("data-start-time");
          thumbnail.addEventListener("click", (e2) => {
            e2.preventDefault();
            var playerContainer = thumbnailContainer.nextElementSibling;
            var player = playerContainer.querySelector(".player");
            player.setAttribute("data-plyr-embed-id", embedID);
            const plyr = new import_plyr.default(player, {
              captions: { active: true },
              tooltips: { controls: true, seek: true },
              ratio: "16:9"
            });
            plyr.on("ready", () => {
              plyr.embed.seekTo(startTime);
            });
            const close = playerContainer.querySelector(".close-btn");
            close.addEventListener("click", () => {
              plyr.pause();
            });
            playerContainer.addEventListener("click", (e3) => {
              if (e3.target == playerContainer) {
                plyr.pause();
              }
            });
          });
        });
      } else {
        document3.querySelectorAll(".player").forEach((video) => {
          const player = new import_plyr.default(video, {
            captions: { active: true },
            tooltips: { controls: true, seek: true },
            ratio: "16:9"
          });
          const playerContainer = video.closest(".player-container");
          const close = playerContainer.querySelector(".close-btn");
          close.addEventListener("click", () => {
            player.pause();
          });
          playerContainer.addEventListener("click", (e2) => {
            if (e2.target == playerContainer) {
              player.pause();
            }
          });
        });
      }
      if (document3.querySelector(".player-fullscreen")) {
        document3.querySelectorAll(".player-fullscreen").forEach((video) => {
          const player = new import_plyr.default(video, {
            captions: { active: true },
            tooltips: { controls: true, seek: true },
            ratio: "16:9"
          });
        });
      }
    }
    function videoSeekToInit() {
      var player = document3.querySelector(".player");
      var videoHero = document3.querySelector(".video-hero");
      var embedID = videoHero.getAttribute("data-embed-id");
      player.setAttribute("data-plyr-provider", "youtube");
      player.setAttribute("data-plyr-embed-id", embedID);
      const heroPlyr = new import_plyr.default(player, {
        captions: { active: true },
        tooltips: { controls: true, seek: true },
        ratio: "16:9",
        ready: true
      });
      heroPlyr.on("ready", () => {
        var startTime = document3.querySelector(".video-hero").getAttribute("data-start-time");
        console.log("start time is: " + startTime);
        heroPlyr.embed.seekTo(startTime);
      });
      const close = document3.querySelector(".close-btn");
      close.addEventListener("click", () => {
        heroPlyr.pause();
      });
      const playerContainer = document3.querySelector(".player-container");
      playerContainer.addEventListener("click", (e2) => {
        if (e2.target == playerContainer) {
          heroPlyr.pause();
        }
      });
    }
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelector(".video-hero")) {
        videoSeekToInit();
      }
      if (document3.querySelectorAll(".video-thumbnail-container")) {
        videoInit();
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelectorAll(".video-thumbnail-container")) {
        videoSeekToInit();
      }
      if (document3.querySelector(".video-hero")) {
        videoInit();
      }
    });
  })(window, document);

  // source/import/product-detail-tabs.js
  (function(window2, document3) {
    "use strict";
    function productCarouselInit() {
      core_default.use([EffectFade, Thumb]);
      var thumbs = new core_default(".tabs-list__thumbs-container", {
        slidesPerView: 2.5,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            freeMode: false
          }
        }
      });
      var tab = new core_default(".tabs-list-container", {
        loop: false,
        freeMode: false,
        autoHeight: true,
        effect: "fade",
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: thumbs
        },
        breakpoints: {
          768: {
            freeMode: false
          }
        }
      });
      var defaultTabTitle = document3.querySelector(".swiper-slide-thumb-active h3");
      var border = document3.querySelector(".title-border-b");
      var titleWidth = defaultTabTitle.clientWidth;
      border.style.width = titleWidth + "px";
      var tabTitles = document3.querySelectorAll(".tabs-list__title");
      var initDistance = tabTitles[0].offsetLeft;
      border.style.left = initDistance + "px";
      for (var tabTitle of tabTitles) {
        tabTitle.addEventListener("click", function() {
          var title = this.querySelector("h3");
          var distance = this.offsetLeft;
          var titleWidth2 = title.clientWidth;
          border.style.width = titleWidth2 + "px";
          border.style.left = distance + "px";
        });
      }
    }
    window2.addEventListener("DOMContentLoaded", () => {
      if (document3.querySelector(".tabs-list__thumbs")) {
        productCarouselInit();
      }
    });
    document3.body.addEventListener("htmx:afterSwap", () => {
      if (document3.querySelector(".tabs-list__thumbs")) {
        productCarouselInit();
      }
    });
  })(window, document);

  // node_modules/@vue/runtime-core/node_modules/@vue/shared/dist/shared.esm-bundler.js
  function makeMap2(str, expectsLowerCase) {
    const map2 = Object.create(null);
    const list = str.split(",");
    for (let i3 = 0; i3 < list.length; i3++) {
      map2[list[i3]] = true;
    }
    return expectsLowerCase ? (val) => !!map2[val.toLowerCase()] : (val) => !!map2[val];
  }
  var PatchFlagNames2 = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
  };
  var slotFlagsText2 = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
  };
  var specialBooleanAttrs2 = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isBooleanAttr3 = /* @__PURE__ */ makeMap2(specialBooleanAttrs2 + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
  function normalizeStyle(value) {
    if (isArray2(value)) {
      const res = {};
      for (let i3 = 0; i3 < value.length; i3++) {
        const item = value[i3];
        const normalized = isString2(item) ? parseStringStyle(item) : normalizeStyle(item);
        if (normalized) {
          for (const key in normalized) {
            res[key] = normalized[key];
          }
        }
      }
      return res;
    } else if (isString2(value)) {
      return value;
    } else if (isObject4(value)) {
      return value;
    }
  }
  var listDelimiterRE = /;(?![^(]*\))/g;
  var propertyDelimiterRE = /:(.+)/;
  function parseStringStyle(cssText) {
    const ret = {};
    cssText.split(listDelimiterRE).forEach((item) => {
      if (item) {
        const tmp = item.split(propertyDelimiterRE);
        tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return ret;
  }
  function normalizeClass(value) {
    let res = "";
    if (isString2(value)) {
      res = value;
    } else if (isArray2(value)) {
      for (let i3 = 0; i3 < value.length; i3++) {
        const normalized = normalizeClass(value[i3]);
        if (normalized) {
          res += normalized + " ";
        }
      }
    } else if (isObject4(value)) {
      for (const name in value) {
        if (value[name]) {
          res += name + " ";
        }
      }
    }
    return res.trim();
  }
  var toDisplayString = (val) => {
    return val == null ? "" : isArray2(val) || isObject4(val) && (val.toString === objectToString2 || !isFunction(val.toString)) ? JSON.stringify(val, replacer, 2) : String(val);
  };
  var replacer = (_key, val) => {
    if (val && val.__v_isRef) {
      return replacer(_key, val.value);
    } else if (isMap2(val)) {
      return {
        [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val2]) => {
          entries[`${key} =>`] = val2;
          return entries;
        }, {})
      };
    } else if (isSet(val)) {
      return {
        [`Set(${val.size})`]: [...val.values()]
      };
    } else if (isObject4(val) && !isArray2(val) && !isPlainObject(val)) {
      return String(val);
    }
    return val;
  };
  var EMPTY_OBJ2 = true ? Object.freeze({}) : {};
  var EMPTY_ARR2 = true ? Object.freeze([]) : [];
  var NOOP = () => {
  };
  var NO = () => false;
  var onRE = /^on[^a-z]/;
  var isOn = (key) => onRE.test(key);
  var isModelListener = (key) => key.startsWith("onUpdate:");
  var extend4 = Object.assign;
  var remove2 = (arr, el) => {
    const i3 = arr.indexOf(el);
    if (i3 > -1) {
      arr.splice(i3, 1);
    }
  };
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var hasOwn2 = (val, key) => hasOwnProperty2.call(val, key);
  var isArray2 = Array.isArray;
  var isMap2 = (val) => toTypeString2(val) === "[object Map]";
  var isSet = (val) => toTypeString2(val) === "[object Set]";
  var isFunction = (val) => typeof val === "function";
  var isString2 = (val) => typeof val === "string";
  var isSymbol2 = (val) => typeof val === "symbol";
  var isObject4 = (val) => val !== null && typeof val === "object";
  var isPromise = (val) => {
    return isObject4(val) && isFunction(val.then) && isFunction(val.catch);
  };
  var objectToString2 = Object.prototype.toString;
  var toTypeString2 = (value) => objectToString2.call(value);
  var toRawType2 = (value) => {
    return toTypeString2(value).slice(8, -1);
  };
  var isPlainObject = (val) => toTypeString2(val) === "[object Object]";
  var isIntegerKey2 = (key) => isString2(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
  var isReservedProp = /* @__PURE__ */ makeMap2(",key,ref,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
  var cacheStringFunction2 = (fn) => {
    const cache = Object.create(null);
    return (str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  };
  var camelizeRE2 = /-(\w)/g;
  var camelize2 = cacheStringFunction2((str) => {
    return str.replace(camelizeRE2, (_3, c4) => c4 ? c4.toUpperCase() : "");
  });
  var hyphenateRE2 = /\B([A-Z])/g;
  var hyphenate2 = cacheStringFunction2((str) => str.replace(hyphenateRE2, "-$1").toLowerCase());
  var capitalize2 = cacheStringFunction2((str) => str.charAt(0).toUpperCase() + str.slice(1));
  var toHandlerKey2 = cacheStringFunction2((str) => str ? `on${capitalize2(str)}` : ``);
  var hasChanged2 = (value, oldValue) => !Object.is(value, oldValue);
  var invokeArrayFns = (fns, arg) => {
    for (let i3 = 0; i3 < fns.length; i3++) {
      fns[i3](arg);
    }
  };
  var def = (obj, key, value) => {
    Object.defineProperty(obj, key, {
      configurable: true,
      enumerable: false,
      value
    });
  };
  var toNumber = (val) => {
    const n3 = parseFloat(val);
    return isNaN(n3) ? val : n3;
  };
  var _globalThis;
  var getGlobalThis = () => {
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
  };

  // node_modules/@vue/runtime-core/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
  function warn2(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
  }
  var activeEffectScope;
  var effectScopeStack = [];
  var EffectScope = class {
    constructor(detached = false) {
      this.active = true;
      this.effects = [];
      this.cleanups = [];
      if (!detached && activeEffectScope) {
        this.parent = activeEffectScope;
        this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
      }
    }
    run(fn) {
      if (this.active) {
        try {
          this.on();
          return fn();
        } finally {
          this.off();
        }
      } else if (true) {
        warn2(`cannot run an inactive effect scope.`);
      }
    }
    on() {
      if (this.active) {
        effectScopeStack.push(this);
        activeEffectScope = this;
      }
    }
    off() {
      if (this.active) {
        effectScopeStack.pop();
        activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
      }
    }
    stop(fromParent) {
      if (this.active) {
        this.effects.forEach((e2) => e2.stop());
        this.cleanups.forEach((cleanup2) => cleanup2());
        if (this.scopes) {
          this.scopes.forEach((e2) => e2.stop(true));
        }
        if (this.parent && !fromParent) {
          const last = this.parent.scopes.pop();
          if (last && last !== this) {
            this.parent.scopes[this.index] = last;
            last.index = this.index;
          }
        }
        this.active = false;
      }
    }
  };
  function recordEffectScope(effect4, scope2) {
    scope2 = scope2 || activeEffectScope;
    if (scope2 && scope2.active) {
      scope2.effects.push(effect4);
    }
  }
  var createDep = (effects) => {
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
  };
  var wasTracked = (dep) => (dep.w & trackOpBit) > 0;
  var newTracked = (dep) => (dep.n & trackOpBit) > 0;
  var initDepMarkers = ({ deps }) => {
    if (deps.length) {
      for (let i3 = 0; i3 < deps.length; i3++) {
        deps[i3].w |= trackOpBit;
      }
    }
  };
  var finalizeDepMarkers = (effect4) => {
    const { deps } = effect4;
    if (deps.length) {
      let ptr = 0;
      for (let i3 = 0; i3 < deps.length; i3++) {
        const dep = deps[i3];
        if (wasTracked(dep) && !newTracked(dep)) {
          dep.delete(effect4);
        } else {
          deps[ptr++] = dep;
        }
        dep.w &= ~trackOpBit;
        dep.n &= ~trackOpBit;
      }
      deps.length = ptr;
    }
  };
  var targetMap2 = new WeakMap();
  var effectTrackDepth = 0;
  var trackOpBit = 1;
  var maxMarkerBits = 30;
  var effectStack2 = [];
  var activeEffect2;
  var ITERATE_KEY2 = Symbol(true ? "iterate" : "");
  var MAP_KEY_ITERATE_KEY2 = Symbol(true ? "Map key iterate" : "");
  var ReactiveEffect = class {
    constructor(fn, scheduler2 = null, scope2) {
      this.fn = fn;
      this.scheduler = scheduler2;
      this.active = true;
      this.deps = [];
      recordEffectScope(this, scope2);
    }
    run() {
      if (!this.active) {
        return this.fn();
      }
      if (!effectStack2.includes(this)) {
        try {
          effectStack2.push(activeEffect2 = this);
          enableTracking2();
          trackOpBit = 1 << ++effectTrackDepth;
          if (effectTrackDepth <= maxMarkerBits) {
            initDepMarkers(this);
          } else {
            cleanupEffect(this);
          }
          return this.fn();
        } finally {
          if (effectTrackDepth <= maxMarkerBits) {
            finalizeDepMarkers(this);
          }
          trackOpBit = 1 << --effectTrackDepth;
          resetTracking2();
          effectStack2.pop();
          const n3 = effectStack2.length;
          activeEffect2 = n3 > 0 ? effectStack2[n3 - 1] : void 0;
        }
      }
    }
    stop() {
      if (this.active) {
        cleanupEffect(this);
        if (this.onStop) {
          this.onStop();
        }
        this.active = false;
      }
    }
  };
  function cleanupEffect(effect4) {
    const { deps } = effect4;
    if (deps.length) {
      for (let i3 = 0; i3 < deps.length; i3++) {
        deps[i3].delete(effect4);
      }
      deps.length = 0;
    }
  }
  var shouldTrack2 = true;
  var trackStack2 = [];
  function pauseTracking2() {
    trackStack2.push(shouldTrack2);
    shouldTrack2 = false;
  }
  function enableTracking2() {
    trackStack2.push(shouldTrack2);
    shouldTrack2 = true;
  }
  function resetTracking2() {
    const last = trackStack2.pop();
    shouldTrack2 = last === void 0 ? true : last;
  }
  function track2(target, type, key) {
    if (!isTracking()) {
      return;
    }
    let depsMap = targetMap2.get(target);
    if (!depsMap) {
      targetMap2.set(target, depsMap = new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = createDep());
    }
    const eventInfo = true ? { effect: activeEffect2, target, type, key } : void 0;
    trackEffects(dep, eventInfo);
  }
  function isTracking() {
    return shouldTrack2 && activeEffect2 !== void 0;
  }
  function trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack3 = false;
    if (effectTrackDepth <= maxMarkerBits) {
      if (!newTracked(dep)) {
        dep.n |= trackOpBit;
        shouldTrack3 = !wasTracked(dep);
      }
    } else {
      shouldTrack3 = !dep.has(activeEffect2);
    }
    if (shouldTrack3) {
      dep.add(activeEffect2);
      activeEffect2.deps.push(dep);
      if (activeEffect2.onTrack) {
        activeEffect2.onTrack(Object.assign({
          effect: activeEffect2
        }, debuggerEventExtraInfo));
      }
    }
  }
  function trigger3(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap2.get(target);
    if (!depsMap) {
      return;
    }
    let deps = [];
    if (type === "clear") {
      deps = [...depsMap.values()];
    } else if (key === "length" && isArray2(target)) {
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 >= newValue) {
          deps.push(dep);
        }
      });
    } else {
      if (key !== void 0) {
        deps.push(depsMap.get(key));
      }
      switch (type) {
        case "add":
          if (!isArray2(target)) {
            deps.push(depsMap.get(ITERATE_KEY2));
            if (isMap2(target)) {
              deps.push(depsMap.get(MAP_KEY_ITERATE_KEY2));
            }
          } else if (isIntegerKey2(key)) {
            deps.push(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!isArray2(target)) {
            deps.push(depsMap.get(ITERATE_KEY2));
            if (isMap2(target)) {
              deps.push(depsMap.get(MAP_KEY_ITERATE_KEY2));
            }
          }
          break;
        case "set":
          if (isMap2(target)) {
            deps.push(depsMap.get(ITERATE_KEY2));
          }
          break;
      }
    }
    const eventInfo = true ? { target, type, key, newValue, oldValue, oldTarget } : void 0;
    if (deps.length === 1) {
      if (deps[0]) {
        if (true) {
          triggerEffects(deps[0], eventInfo);
        } else {
          triggerEffects(deps[0]);
        }
      }
    } else {
      const effects = [];
      for (const dep of deps) {
        if (dep) {
          effects.push(...dep);
        }
      }
      if (true) {
        triggerEffects(createDep(effects), eventInfo);
      } else {
        triggerEffects(createDep(effects));
      }
    }
  }
  function triggerEffects(dep, debuggerEventExtraInfo) {
    for (const effect4 of isArray2(dep) ? dep : [...dep]) {
      if (effect4 !== activeEffect2 || effect4.allowRecurse) {
        if (effect4.onTrigger) {
          effect4.onTrigger(extend4({ effect: effect4 }, debuggerEventExtraInfo));
        }
        if (effect4.scheduler) {
          effect4.scheduler();
        } else {
          effect4.run();
        }
      }
    }
  }
  var isNonTrackableKeys2 = /* @__PURE__ */ makeMap2(`__proto__,__v_isRef,__isVue`);
  var builtInSymbols2 = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol2));
  var get3 = /* @__PURE__ */ createGetter2();
  var shallowGet2 = /* @__PURE__ */ createGetter2(false, true);
  var readonlyGet2 = /* @__PURE__ */ createGetter2(true);
  var shallowReadonlyGet2 = /* @__PURE__ */ createGetter2(true, true);
  var arrayInstrumentations2 = /* @__PURE__ */ createArrayInstrumentations();
  function createArrayInstrumentations() {
    const instrumentations = {};
    ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
      instrumentations[key] = function(...args) {
        const arr = toRaw2(this);
        for (let i3 = 0, l3 = this.length; i3 < l3; i3++) {
          track2(arr, "get", i3 + "");
        }
        const res = arr[key](...args);
        if (res === -1 || res === false) {
          return arr[key](...args.map(toRaw2));
        } else {
          return res;
        }
      };
    });
    ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
      instrumentations[key] = function(...args) {
        pauseTracking2();
        const res = toRaw2(this)[key].apply(this, args);
        resetTracking2();
        return res;
      };
    });
    return instrumentations;
  }
  function createGetter2(isReadonly2 = false, shallow = false) {
    return function get4(target, key, receiver) {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? shallowReadonlyMap2 : readonlyMap2 : shallow ? shallowReactiveMap2 : reactiveMap2).get(target)) {
        return target;
      }
      const targetIsArray = isArray2(target);
      if (!isReadonly2 && targetIsArray && hasOwn2(arrayInstrumentations2, key)) {
        return Reflect.get(arrayInstrumentations2, key, receiver);
      }
      const res = Reflect.get(target, key, receiver);
      if (isSymbol2(key) ? builtInSymbols2.has(key) : isNonTrackableKeys2(key)) {
        return res;
      }
      if (!isReadonly2) {
        track2(target, "get", key);
      }
      if (shallow) {
        return res;
      }
      if (isRef2(res)) {
        const shouldUnwrap = !targetIsArray || !isIntegerKey2(key);
        return shouldUnwrap ? res.value : res;
      }
      if (isObject4(res)) {
        return isReadonly2 ? readonly2(res) : reactive3(res);
      }
      return res;
    };
  }
  var set3 = /* @__PURE__ */ createSetter2();
  var shallowSet2 = /* @__PURE__ */ createSetter2(true);
  function createSetter2(shallow = false) {
    return function set4(target, key, value, receiver) {
      let oldValue = target[key];
      if (!shallow) {
        value = toRaw2(value);
        oldValue = toRaw2(oldValue);
        if (!isArray2(target) && isRef2(oldValue) && !isRef2(value)) {
          oldValue.value = value;
          return true;
        }
      }
      const hadKey = isArray2(target) && isIntegerKey2(key) ? Number(key) < target.length : hasOwn2(target, key);
      const result = Reflect.set(target, key, value, receiver);
      if (target === toRaw2(receiver)) {
        if (!hadKey) {
          trigger3(target, "add", key, value);
        } else if (hasChanged2(value, oldValue)) {
          trigger3(target, "set", key, value, oldValue);
        }
      }
      return result;
    };
  }
  function deleteProperty2(target, key) {
    const hadKey = hasOwn2(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger3(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function has2(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol2(key) || !builtInSymbols2.has(key)) {
      track2(target, "has", key);
    }
    return result;
  }
  function ownKeys2(target) {
    track2(target, "iterate", isArray2(target) ? "length" : ITERATE_KEY2);
    return Reflect.ownKeys(target);
  }
  var mutableHandlers2 = {
    get: get3,
    set: set3,
    deleteProperty: deleteProperty2,
    has: has2,
    ownKeys: ownKeys2
  };
  var readonlyHandlers2 = {
    get: readonlyGet2,
    set(target, key) {
      if (true) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    },
    deleteProperty(target, key) {
      if (true) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    }
  };
  var shallowReactiveHandlers2 = /* @__PURE__ */ extend4({}, mutableHandlers2, {
    get: shallowGet2,
    set: shallowSet2
  });
  var shallowReadonlyHandlers2 = /* @__PURE__ */ extend4({}, readonlyHandlers2, {
    get: shallowReadonlyGet2
  });
  var toShallow2 = (value) => value;
  var getProto2 = (v3) => Reflect.getPrototypeOf(v3);
  function get$12(target, key, isReadonly2 = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = toRaw2(target);
    const rawKey = toRaw2(key);
    if (key !== rawKey) {
      !isReadonly2 && track2(rawTarget, "get", key);
    }
    !isReadonly2 && track2(rawTarget, "get", rawKey);
    const { has: has3 } = getProto2(rawTarget);
    const wrap = isShallow ? toShallow2 : isReadonly2 ? toReadonly2 : toReactive2;
    if (has3.call(rawTarget, key)) {
      return wrap(target.get(key));
    } else if (has3.call(rawTarget, rawKey)) {
      return wrap(target.get(rawKey));
    } else if (target !== rawTarget) {
      target.get(key);
    }
  }
  function has$12(key, isReadonly2 = false) {
    const target = this["__v_raw"];
    const rawTarget = toRaw2(target);
    const rawKey = toRaw2(key);
    if (key !== rawKey) {
      !isReadonly2 && track2(rawTarget, "has", key);
    }
    !isReadonly2 && track2(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
  }
  function size2(target, isReadonly2 = false) {
    target = target["__v_raw"];
    !isReadonly2 && track2(toRaw2(target), "iterate", ITERATE_KEY2);
    return Reflect.get(target, "size", target);
  }
  function add2(value) {
    value = toRaw2(value);
    const target = toRaw2(this);
    const proto = getProto2(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
      target.add(value);
      trigger3(target, "add", value, value);
    }
    return this;
  }
  function set$12(key, value) {
    value = toRaw2(value);
    const target = toRaw2(this);
    const { has: has3, get: get4 } = getProto2(target);
    let hadKey = has3.call(target, key);
    if (!hadKey) {
      key = toRaw2(key);
      hadKey = has3.call(target, key);
    } else if (true) {
      checkIdentityKeys2(target, has3, key);
    }
    const oldValue = get4.call(target, key);
    target.set(key, value);
    if (!hadKey) {
      trigger3(target, "add", key, value);
    } else if (hasChanged2(value, oldValue)) {
      trigger3(target, "set", key, value, oldValue);
    }
    return this;
  }
  function deleteEntry2(key) {
    const target = toRaw2(this);
    const { has: has3, get: get4 } = getProto2(target);
    let hadKey = has3.call(target, key);
    if (!hadKey) {
      key = toRaw2(key);
      hadKey = has3.call(target, key);
    } else if (true) {
      checkIdentityKeys2(target, has3, key);
    }
    const oldValue = get4 ? get4.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) {
      trigger3(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function clear2() {
    const target = toRaw2(this);
    const hadItems = target.size !== 0;
    const oldTarget = true ? isMap2(target) ? new Map(target) : new Set(target) : void 0;
    const result = target.clear();
    if (hadItems) {
      trigger3(target, "clear", void 0, void 0, oldTarget);
    }
    return result;
  }
  function createForEach2(isReadonly2, isShallow) {
    return function forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = toRaw2(target);
      const wrap = isShallow ? toShallow2 : isReadonly2 ? toReadonly2 : toReactive2;
      !isReadonly2 && track2(rawTarget, "iterate", ITERATE_KEY2);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap(value), wrap(key), observed);
      });
    };
  }
  function createIterableMethod2(method, isReadonly2, isShallow) {
    return function(...args) {
      const target = this["__v_raw"];
      const rawTarget = toRaw2(target);
      const targetIsMap = isMap2(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap = isShallow ? toShallow2 : isReadonly2 ? toReadonly2 : toReactive2;
      !isReadonly2 && track2(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY2 : ITERATE_KEY2);
      return {
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
            done
          };
        },
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function createReadonlyMethod2(type) {
    return function(...args) {
      if (true) {
        const key = args[0] ? `on key "${args[0]}" ` : ``;
        console.warn(`${capitalize2(type)} operation ${key}failed: target is readonly.`, toRaw2(this));
      }
      return type === "delete" ? false : this;
    };
  }
  function createInstrumentations() {
    const mutableInstrumentations3 = {
      get(key) {
        return get$12(this, key);
      },
      get size() {
        return size2(this);
      },
      has: has$12,
      add: add2,
      set: set$12,
      delete: deleteEntry2,
      clear: clear2,
      forEach: createForEach2(false, false)
    };
    const shallowInstrumentations3 = {
      get(key) {
        return get$12(this, key, false, true);
      },
      get size() {
        return size2(this);
      },
      has: has$12,
      add: add2,
      set: set$12,
      delete: deleteEntry2,
      clear: clear2,
      forEach: createForEach2(false, true)
    };
    const readonlyInstrumentations3 = {
      get(key) {
        return get$12(this, key, true);
      },
      get size() {
        return size2(this, true);
      },
      has(key) {
        return has$12.call(this, key, true);
      },
      add: createReadonlyMethod2("add"),
      set: createReadonlyMethod2("set"),
      delete: createReadonlyMethod2("delete"),
      clear: createReadonlyMethod2("clear"),
      forEach: createForEach2(true, false)
    };
    const shallowReadonlyInstrumentations3 = {
      get(key) {
        return get$12(this, key, true, true);
      },
      get size() {
        return size2(this, true);
      },
      has(key) {
        return has$12.call(this, key, true);
      },
      add: createReadonlyMethod2("add"),
      set: createReadonlyMethod2("set"),
      delete: createReadonlyMethod2("delete"),
      clear: createReadonlyMethod2("clear"),
      forEach: createForEach2(true, true)
    };
    const iteratorMethods2 = ["keys", "values", "entries", Symbol.iterator];
    iteratorMethods2.forEach((method) => {
      mutableInstrumentations3[method] = createIterableMethod2(method, false, false);
      readonlyInstrumentations3[method] = createIterableMethod2(method, true, false);
      shallowInstrumentations3[method] = createIterableMethod2(method, false, true);
      shallowReadonlyInstrumentations3[method] = createIterableMethod2(method, true, true);
    });
    return [
      mutableInstrumentations3,
      readonlyInstrumentations3,
      shallowInstrumentations3,
      shallowReadonlyInstrumentations3
    ];
  }
  var [mutableInstrumentations2, readonlyInstrumentations2, shallowInstrumentations2, shallowReadonlyInstrumentations2] = /* @__PURE__ */ createInstrumentations();
  function createInstrumentationGetter2(isReadonly2, shallow) {
    const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations2 : shallowInstrumentations2 : isReadonly2 ? readonlyInstrumentations2 : mutableInstrumentations2;
    return (target, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw") {
        return target;
      }
      return Reflect.get(hasOwn2(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
  }
  var mutableCollectionHandlers2 = {
    get: /* @__PURE__ */ createInstrumentationGetter2(false, false)
  };
  var shallowCollectionHandlers2 = {
    get: /* @__PURE__ */ createInstrumentationGetter2(false, true)
  };
  var readonlyCollectionHandlers2 = {
    get: /* @__PURE__ */ createInstrumentationGetter2(true, false)
  };
  var shallowReadonlyCollectionHandlers2 = {
    get: /* @__PURE__ */ createInstrumentationGetter2(true, true)
  };
  function checkIdentityKeys2(target, has3, key) {
    const rawKey = toRaw2(key);
    if (rawKey !== key && has3.call(target, rawKey)) {
      const type = toRawType2(target);
      console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
  }
  var reactiveMap2 = new WeakMap();
  var shallowReactiveMap2 = new WeakMap();
  var readonlyMap2 = new WeakMap();
  var shallowReadonlyMap2 = new WeakMap();
  function targetTypeMap2(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  function getTargetType2(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap2(toRawType2(value));
  }
  function reactive3(target) {
    if (target && target["__v_isReadonly"]) {
      return target;
    }
    return createReactiveObject2(target, false, mutableHandlers2, mutableCollectionHandlers2, reactiveMap2);
  }
  function shallowReactive(target) {
    return createReactiveObject2(target, false, shallowReactiveHandlers2, shallowCollectionHandlers2, shallowReactiveMap2);
  }
  function readonly2(target) {
    return createReactiveObject2(target, true, readonlyHandlers2, readonlyCollectionHandlers2, readonlyMap2);
  }
  function shallowReadonly(target) {
    return createReactiveObject2(target, true, shallowReadonlyHandlers2, shallowReadonlyCollectionHandlers2, shallowReadonlyMap2);
  }
  function createReactiveObject2(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject4(target)) {
      if (true) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
      }
      return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = getTargetType2(target);
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
  }
  function isReactive2(value) {
    if (isReadonly(value)) {
      return isReactive2(value["__v_raw"]);
    }
    return !!(value && value["__v_isReactive"]);
  }
  function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
  }
  function isProxy(value) {
    return isReactive2(value) || isReadonly(value);
  }
  function toRaw2(observed) {
    const raw2 = observed && observed["__v_raw"];
    return raw2 ? toRaw2(raw2) : observed;
  }
  function markRaw(value) {
    def(value, "__v_skip", true);
    return value;
  }
  var toReactive2 = (value) => isObject4(value) ? reactive3(value) : value;
  var toReadonly2 = (value) => isObject4(value) ? readonly2(value) : value;
  function trackRefValue(ref2) {
    if (isTracking()) {
      ref2 = toRaw2(ref2);
      if (!ref2.dep) {
        ref2.dep = createDep();
      }
      if (true) {
        trackEffects(ref2.dep, {
          target: ref2,
          type: "get",
          key: "value"
        });
      } else {
        trackEffects(ref2.dep);
      }
    }
  }
  function triggerRefValue(ref2, newVal) {
    ref2 = toRaw2(ref2);
    if (ref2.dep) {
      if (true) {
        triggerEffects(ref2.dep, {
          target: ref2,
          type: "set",
          key: "value",
          newValue: newVal
        });
      } else {
        triggerEffects(ref2.dep);
      }
    }
  }
  function isRef2(r2) {
    return Boolean(r2 && r2.__v_isRef === true);
  }
  function unref(ref2) {
    return isRef2(ref2) ? ref2.value : ref2;
  }
  var shallowUnwrapHandlers = {
    get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver) => {
      const oldValue = target[key];
      if (isRef2(oldValue) && !isRef2(value)) {
        oldValue.value = value;
        return true;
      } else {
        return Reflect.set(target, key, value, receiver);
      }
    }
  };
  function proxyRefs(objectWithRefs) {
    return isReactive2(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
  }
  var ComputedRefImpl = class {
    constructor(getter, _setter, isReadonly2) {
      this._setter = _setter;
      this.dep = void 0;
      this._dirty = true;
      this.__v_isRef = true;
      this.effect = new ReactiveEffect(getter, () => {
        if (!this._dirty) {
          this._dirty = true;
          triggerRefValue(this);
        }
      });
      this["__v_isReadonly"] = isReadonly2;
    }
    get value() {
      const self2 = toRaw2(this);
      trackRefValue(self2);
      if (self2._dirty) {
        self2._dirty = false;
        self2._value = self2.effect.run();
      }
      return self2._value;
    }
    set value(newValue) {
      this._setter(newValue);
    }
  };
  function computed(getterOrOptions, debugOptions) {
    let getter;
    let setter;
    const onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
      getter = getterOrOptions;
      setter = true ? () => {
        console.warn("Write operation failed: computed value is readonly");
      } : NOOP;
    } else {
      getter = getterOrOptions.get;
      setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter);
    if (debugOptions) {
      cRef.effect.onTrack = debugOptions.onTrack;
      cRef.effect.onTrigger = debugOptions.onTrigger;
    }
    return cRef;
  }
  var _a;
  var tick = Promise.resolve();
  _a = "__v_isReadonly";

  // node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
  var isHmrUpdating = false;
  var hmrDirtyComponents = new Set();
  if (true) {
    getGlobalThis().__VUE_HMR_RUNTIME__ = {
      createRecord: tryWrap(createRecord),
      rerender: tryWrap(rerender),
      reload: tryWrap(reload)
    };
  }
  var map = new Map();
  function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
      createRecord(id, instance.type);
      record = map.get(id);
    }
    record.instances.add(instance);
  }
  function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
  }
  function createRecord(id, initialDef) {
    if (map.has(id)) {
      return false;
    }
    map.set(id, {
      initialDef: normalizeClassComponent(initialDef),
      instances: new Set()
    });
    return true;
  }
  function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
  }
  function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) {
      return;
    }
    record.initialDef.render = newRender;
    [...record.instances].forEach((instance) => {
      if (newRender) {
        instance.render = newRender;
        normalizeClassComponent(instance.type).render = newRender;
      }
      instance.renderCache = [];
      isHmrUpdating = true;
      instance.update();
      isHmrUpdating = false;
    });
  }
  function reload(id, newComp) {
    const record = map.get(id);
    if (!record)
      return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [...record.instances];
    for (const instance of instances) {
      const oldComp = normalizeClassComponent(instance.type);
      if (!hmrDirtyComponents.has(oldComp)) {
        if (oldComp !== record.initialDef) {
          updateComponentDef(oldComp, newComp);
        }
        hmrDirtyComponents.add(oldComp);
      }
      instance.appContext.optionsCache.delete(instance.type);
      if (instance.ceReload) {
        hmrDirtyComponents.add(oldComp);
        instance.ceReload(newComp.styles);
        hmrDirtyComponents.delete(oldComp);
      } else if (instance.parent) {
        queueJob2(instance.parent.update);
        if (instance.parent.type.__asyncLoader && instance.parent.ceReload) {
          instance.parent.ceReload(newComp.styles);
        }
      } else if (instance.appContext.reload) {
        instance.appContext.reload();
      } else if (typeof window !== "undefined") {
        window.location.reload();
      } else {
        console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
      }
    }
    queuePostFlushCb(() => {
      for (const instance of instances) {
        hmrDirtyComponents.delete(normalizeClassComponent(instance.type));
      }
    });
  }
  function updateComponentDef(oldComp, newComp) {
    extend4(oldComp, newComp);
    for (const key in oldComp) {
      if (key !== "__file" && !(key in newComp)) {
        delete oldComp[key];
      }
    }
  }
  function tryWrap(fn) {
    return (id, arg) => {
      try {
        return fn(id, arg);
      } catch (e2) {
        console.error(e2);
        console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
      }
    };
  }
  var devtools;
  var buffer = [];
  var devtoolsNotInstalled = false;
  function emit(event2, ...args) {
    if (devtools) {
      devtools.emit(event2, ...args);
    } else if (!devtoolsNotInstalled) {
      buffer.push({ event: event2, args });
    }
  }
  function setDevtoolsHook(hook, target) {
    var _a3, _b2;
    devtools = hook;
    if (devtools) {
      devtools.enabled = true;
      buffer.forEach(({ event: event2, args }) => devtools.emit(event2, ...args));
      buffer = [];
    } else if (typeof window !== "undefined" && window.HTMLElement && !((_b2 = (_a3 = window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) === null || _b2 === void 0 ? void 0 : _b2.includes("jsdom"))) {
      const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
      replay.push((newHook) => {
        setDevtoolsHook(newHook, target);
      });
      setTimeout(() => {
        if (!devtools) {
          target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
          devtoolsNotInstalled = true;
          buffer = [];
        }
      }, 3e3);
    } else {
      devtoolsNotInstalled = true;
      buffer = [];
    }
  }
  function devtoolsInitApp(app, version2) {
    emit("app:init", app, version2, {
      Fragment,
      Text,
      Comment,
      Static
    });
  }
  function devtoolsUnmountApp(app) {
    emit("app:unmount", app);
  }
  var devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added");
  var devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated");
  var devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed");
  function createDevtoolsComponentHook(hook) {
    return (component) => {
      emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
  }
  var devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start");
  var devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end");
  function createDevtoolsPerformanceHook(hook) {
    return (component, type, time) => {
      emit(hook, component.appContext.app, component.uid, component, type, time);
    };
  }
  function devtoolsComponentEmit(component, event2, params) {
    emit("component:emit", component.appContext.app, component, event2, params);
  }
  function emit$1(instance, event2, ...rawArgs) {
    const props = instance.vnode.props || EMPTY_OBJ2;
    if (true) {
      const { emitsOptions, propsOptions: [propsOptions] } = instance;
      if (emitsOptions) {
        if (!(event2 in emitsOptions) && true) {
          if (!propsOptions || !(toHandlerKey2(event2) in propsOptions)) {
            warn3(`Component emitted event "${event2}" but it is neither declared in the emits option nor as an "${toHandlerKey2(event2)}" prop.`);
          }
        } else {
          const validator = emitsOptions[event2];
          if (isFunction(validator)) {
            const isValid = validator(...rawArgs);
            if (!isValid) {
              warn3(`Invalid event arguments: event validation failed for event "${event2}".`);
            }
          }
        }
      }
    }
    let args = rawArgs;
    const isModelListener3 = event2.startsWith("update:");
    const modelArg = isModelListener3 && event2.slice(7);
    if (modelArg && modelArg in props) {
      const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
      const { number, trim: trim2 } = props[modifiersKey] || EMPTY_OBJ2;
      if (trim2) {
        args = rawArgs.map((a3) => a3.trim());
      } else if (number) {
        args = rawArgs.map(toNumber);
      }
    }
    if (true) {
      devtoolsComponentEmit(instance, event2, args);
    }
    if (true) {
      const lowerCaseEvent = event2.toLowerCase();
      if (lowerCaseEvent !== event2 && props[toHandlerKey2(lowerCaseEvent)]) {
        warn3(`Event "${lowerCaseEvent}" is emitted in component ${formatComponentName(instance, instance.type)} but the handler is registered for "${event2}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${hyphenate2(event2)}" instead of "${event2}".`);
      }
    }
    let handlerName;
    let handler4 = props[handlerName = toHandlerKey2(event2)] || props[handlerName = toHandlerKey2(camelize2(event2))];
    if (!handler4 && isModelListener3) {
      handler4 = props[handlerName = toHandlerKey2(hyphenate2(event2))];
    }
    if (handler4) {
      callWithAsyncErrorHandling(handler4, instance, 6, args);
    }
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
      if (!instance.emitted) {
        instance.emitted = {};
      } else if (instance.emitted[handlerName]) {
        return;
      }
      instance.emitted[handlerName] = true;
      callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
  }
  function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) {
      return cached;
    }
    const raw2 = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (!isFunction(comp)) {
      const extendEmits = (raw3) => {
        const normalizedFromExtend = normalizeEmitsOptions(raw3, appContext, true);
        if (normalizedFromExtend) {
          hasExtends = true;
          extend4(normalized, normalizedFromExtend);
        }
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendEmits);
      }
      if (comp.extends) {
        extendEmits(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendEmits);
      }
    }
    if (!raw2 && !hasExtends) {
      cache.set(comp, null);
      return null;
    }
    if (isArray2(raw2)) {
      raw2.forEach((key) => normalized[key] = null);
    } else {
      extend4(normalized, raw2);
    }
    cache.set(comp, normalized);
    return normalized;
  }
  function isEmitListener(options, key) {
    if (!options || !isOn(key)) {
      return false;
    }
    key = key.slice(2).replace(/Once$/, "");
    return hasOwn2(options, key[0].toLowerCase() + key.slice(1)) || hasOwn2(options, hyphenate2(key)) || hasOwn2(options, key);
  }
  var currentRenderingInstance = null;
  var currentScopeId = null;
  function setCurrentRenderingInstance(instance) {
    const prev2 = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev2;
  }
  function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx)
      return fn;
    if (fn._n) {
      return fn;
    }
    const renderFnWithContext = (...args) => {
      if (renderFnWithContext._d) {
        setBlockTracking(-1);
      }
      const prevInstance = setCurrentRenderingInstance(ctx);
      const res = fn(...args);
      setCurrentRenderingInstance(prevInstance);
      if (renderFnWithContext._d) {
        setBlockTracking(1);
      }
      if (true) {
        devtoolsComponentUpdated(ctx);
      }
      return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
  }
  var accessedAttrs = false;
  function markAttrsAccessed() {
    accessedAttrs = true;
  }
  function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, props, propsOptions: [propsOptions], slots, attrs, emit: emit2, render: render15, renderCache, data: data2, setupState, ctx, inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev2 = setCurrentRenderingInstance(instance);
    if (true) {
      accessedAttrs = false;
    }
    try {
      if (vnode.shapeFlag & 4) {
        const proxyToUse = withProxy || proxy;
        result = normalizeVNode(render15.call(proxyToUse, proxyToUse, renderCache, props, setupState, data2, ctx));
        fallthroughAttrs = attrs;
      } else {
        const render16 = Component;
        if (attrs === props) {
          markAttrsAccessed();
        }
        result = normalizeVNode(render16.length > 1 ? render16(props, true ? {
          get attrs() {
            markAttrsAccessed();
            return attrs;
          },
          slots,
          emit: emit2
        } : { attrs, slots, emit: emit2 }) : render16(props, null));
        fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
      }
    } catch (err) {
      blockStack.length = 0;
      handleError2(err, instance, 1);
      result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (result.patchFlag > 0 && result.patchFlag & 2048) {
      [root, setRoot] = getChildRoot(result);
    }
    if (fallthroughAttrs && inheritAttrs !== false) {
      const keys = Object.keys(fallthroughAttrs);
      const { shapeFlag } = root;
      if (keys.length) {
        if (shapeFlag & (1 | 6)) {
          if (propsOptions && keys.some(isModelListener)) {
            fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
          }
          root = cloneVNode(root, fallthroughAttrs);
        } else if (!accessedAttrs && root.type !== Comment) {
          const allAttrs = Object.keys(attrs);
          const eventAttrs = [];
          const extraAttrs = [];
          for (let i3 = 0, l3 = allAttrs.length; i3 < l3; i3++) {
            const key = allAttrs[i3];
            if (isOn(key)) {
              if (!isModelListener(key)) {
                eventAttrs.push(key[2].toLowerCase() + key.slice(3));
              }
            } else {
              extraAttrs.push(key);
            }
          }
          if (extraAttrs.length) {
            warn3(`Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`);
          }
          if (eventAttrs.length) {
            warn3(`Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
          }
        }
      }
    }
    if (vnode.dirs) {
      if (!isElementRoot(root)) {
        warn3(`Runtime directive used on component with non-element root node. The directives will not function as intended.`);
      }
      root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
      if (!isElementRoot(root)) {
        warn3(`Component inside <Transition> renders non-element root node that cannot be animated.`);
      }
      root.transition = vnode.transition;
    }
    if (setRoot) {
      setRoot(root);
    } else {
      result = root;
    }
    setCurrentRenderingInstance(prev2);
    return result;
  }
  var getChildRoot = (vnode) => {
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren);
    if (!childRoot) {
      return [vnode, void 0];
    }
    const index3 = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot) => {
      rawChildren[index3] = updatedRoot;
      if (dynamicChildren) {
        if (dynamicIndex > -1) {
          dynamicChildren[dynamicIndex] = updatedRoot;
        } else if (updatedRoot.patchFlag > 0) {
          vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
        }
      }
    };
    return [normalizeVNode(childRoot), setRoot];
  };
  function filterSingleRoot(children2) {
    let singleRoot;
    for (let i3 = 0; i3 < children2.length; i3++) {
      const child = children2[i3];
      if (isVNode(child)) {
        if (child.type !== Comment || child.children === "v-if") {
          if (singleRoot) {
            return;
          } else {
            singleRoot = child;
          }
        }
      } else {
        return;
      }
    }
    return singleRoot;
  }
  var getFunctionalFallthrough = (attrs) => {
    let res;
    for (const key in attrs) {
      if (key === "class" || key === "style" || isOn(key)) {
        (res || (res = {}))[key] = attrs[key];
      }
    }
    return res;
  };
  var filterModelListeners = (attrs, props) => {
    const res = {};
    for (const key in attrs) {
      if (!isModelListener(key) || !(key.slice(9) in props)) {
        res[key] = attrs[key];
      }
    }
    return res;
  };
  var isElementRoot = (vnode) => {
    return vnode.shapeFlag & (6 | 1) || vnode.type === Comment;
  };
  function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if ((prevChildren || nextChildren) && isHmrUpdating) {
      return true;
    }
    if (nextVNode.dirs || nextVNode.transition) {
      return true;
    }
    if (optimized && patchFlag >= 0) {
      if (patchFlag & 1024) {
        return true;
      }
      if (patchFlag & 16) {
        if (!prevProps) {
          return !!nextProps;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
      } else if (patchFlag & 8) {
        const dynamicProps = nextVNode.dynamicProps;
        for (let i3 = 0; i3 < dynamicProps.length; i3++) {
          const key = dynamicProps[i3];
          if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
            return true;
          }
        }
      }
    } else {
      if (prevChildren || nextChildren) {
        if (!nextChildren || !nextChildren.$stable) {
          return true;
        }
      }
      if (prevProps === nextProps) {
        return false;
      }
      if (!prevProps) {
        return !!nextProps;
      }
      if (!nextProps) {
        return true;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
  }
  function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
      return true;
    }
    for (let i3 = 0; i3 < nextKeys.length; i3++) {
      const key = nextKeys[i3];
      if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
        return true;
      }
    }
    return false;
  }
  function updateHOCHostEl({ vnode, parent: parent2 }, el) {
    while (parent2 && parent2.subTree === vnode) {
      (vnode = parent2.vnode).el = el;
      parent2 = parent2.parent;
    }
  }
  var isSuspense = (type) => type.__isSuspense;
  function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
      if (isArray2(fn)) {
        suspense.effects.push(...fn);
      } else {
        suspense.effects.push(fn);
      }
    } else {
      queuePostFlushCb(fn);
    }
  }
  function provide(key, value) {
    if (!currentInstance) {
      if (true) {
        warn3(`provide() can only be used inside setup().`);
      }
    } else {
      let provides = currentInstance.provides;
      const parentProvides = currentInstance.parent && currentInstance.parent.provides;
      if (parentProvides === provides) {
        provides = currentInstance.provides = Object.create(parentProvides);
      }
      provides[key] = value;
    }
  }
  function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance) {
      const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
      if (provides && key in provides) {
        return provides[key];
      } else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
      } else if (true) {
        warn3(`injection "${String(key)}" not found.`);
      }
    } else if (true) {
      warn3(`inject() can only be used inside setup() or functional components.`);
    }
  }
  function useTransitionState() {
    const state = {
      isMounted: false,
      isLeaving: false,
      isUnmounting: false,
      leavingVNodes: new Map()
    };
    onMounted(() => {
      state.isMounted = true;
    });
    onBeforeUnmount(() => {
      state.isUnmounting = true;
    });
    return state;
  }
  var TransitionHookValidator = [Function, Array];
  var BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
      mode: String,
      appear: Boolean,
      persisted: Boolean,
      onBeforeEnter: TransitionHookValidator,
      onEnter: TransitionHookValidator,
      onAfterEnter: TransitionHookValidator,
      onEnterCancelled: TransitionHookValidator,
      onBeforeLeave: TransitionHookValidator,
      onLeave: TransitionHookValidator,
      onAfterLeave: TransitionHookValidator,
      onLeaveCancelled: TransitionHookValidator,
      onBeforeAppear: TransitionHookValidator,
      onAppear: TransitionHookValidator,
      onAfterAppear: TransitionHookValidator,
      onAppearCancelled: TransitionHookValidator
    },
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const state = useTransitionState();
      let prevTransitionKey;
      return () => {
        const children2 = slots.default && getTransitionRawChildren(slots.default(), true);
        if (!children2 || !children2.length) {
          return;
        }
        if (children2.length > 1) {
          warn3("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
        }
        const rawProps = toRaw2(props);
        const { mode } = rawProps;
        if (mode && !["in-out", "out-in", "default"].includes(mode)) {
          warn3(`invalid <transition> mode: ${mode}`);
        }
        const child = children2[0];
        if (state.isLeaving) {
          return emptyPlaceholder(child);
        }
        const innerChild = getKeepAliveChild(child);
        if (!innerChild) {
          return emptyPlaceholder(child);
        }
        const enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
        setTransitionHooks(innerChild, enterHooks);
        const oldChild = instance.subTree;
        const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
        let transitionKeyChanged = false;
        const { getTransitionKey } = innerChild.type;
        if (getTransitionKey) {
          const key = getTransitionKey();
          if (prevTransitionKey === void 0) {
            prevTransitionKey = key;
          } else if (key !== prevTransitionKey) {
            prevTransitionKey = key;
            transitionKeyChanged = true;
          }
        }
        if (oldInnerChild && oldInnerChild.type !== Comment && (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
          const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
          setTransitionHooks(oldInnerChild, leavingHooks);
          if (mode === "out-in") {
            state.isLeaving = true;
            leavingHooks.afterLeave = () => {
              state.isLeaving = false;
              instance.update();
            };
            return emptyPlaceholder(child);
          } else if (mode === "in-out" && innerChild.type !== Comment) {
            leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
              const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
              leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
              el._leaveCb = () => {
                earlyRemove();
                el._leaveCb = void 0;
                delete enterHooks.delayedLeave;
              };
              enterHooks.delayedLeave = delayedLeave;
            };
          }
        }
        return child;
      };
    }
  };
  var BaseTransition = BaseTransitionImpl;
  function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
      leavingVNodesCache = Object.create(null);
      leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
  }
  function resolveTransitionHooks(vnode, props, state, instance) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook3 = (hook, args) => {
      hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const hooks = {
      mode,
      persisted,
      beforeEnter(el) {
        let hook = onBeforeEnter;
        if (!state.isMounted) {
          if (appear) {
            hook = onBeforeAppear || onBeforeEnter;
          } else {
            return;
          }
        }
        if (el._leaveCb) {
          el._leaveCb(true);
        }
        const leavingVNode = leavingVNodesCache[key];
        if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) {
          leavingVNode.el._leaveCb();
        }
        callHook3(hook, [el]);
      },
      enter(el) {
        let hook = onEnter;
        let afterHook = onAfterEnter;
        let cancelHook = onEnterCancelled;
        if (!state.isMounted) {
          if (appear) {
            hook = onAppear || onEnter;
            afterHook = onAfterAppear || onAfterEnter;
            cancelHook = onAppearCancelled || onEnterCancelled;
          } else {
            return;
          }
        }
        let called = false;
        const done = el._enterCb = (cancelled) => {
          if (called)
            return;
          called = true;
          if (cancelled) {
            callHook3(cancelHook, [el]);
          } else {
            callHook3(afterHook, [el]);
          }
          if (hooks.delayedLeave) {
            hooks.delayedLeave();
          }
          el._enterCb = void 0;
        };
        if (hook) {
          hook(el, done);
          if (hook.length <= 1) {
            done();
          }
        } else {
          done();
        }
      },
      leave(el, remove3) {
        const key2 = String(vnode.key);
        if (el._enterCb) {
          el._enterCb(true);
        }
        if (state.isUnmounting) {
          return remove3();
        }
        callHook3(onBeforeLeave, [el]);
        let called = false;
        const done = el._leaveCb = (cancelled) => {
          if (called)
            return;
          called = true;
          remove3();
          if (cancelled) {
            callHook3(onLeaveCancelled, [el]);
          } else {
            callHook3(onAfterLeave, [el]);
          }
          el._leaveCb = void 0;
          if (leavingVNodesCache[key2] === vnode) {
            delete leavingVNodesCache[key2];
          }
        };
        leavingVNodesCache[key2] = vnode;
        if (onLeave) {
          onLeave(el, done);
          if (onLeave.length <= 1) {
            done();
          }
        } else {
          done();
        }
      },
      clone(vnode2) {
        return resolveTransitionHooks(vnode2, props, state, instance);
      }
    };
    return hooks;
  }
  function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
      vnode = cloneVNode(vnode);
      vnode.children = null;
      return vnode;
    }
  }
  function getKeepAliveChild(vnode) {
    return isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
  }
  function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
      setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
      vnode.ssContent.transition = hooks.clone(vnode.ssContent);
      vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
      vnode.transition = hooks;
    }
  }
  function getTransitionRawChildren(children2, keepComment = false) {
    let ret = [];
    let keyedFragmentCount = 0;
    for (let i3 = 0; i3 < children2.length; i3++) {
      const child = children2[i3];
      if (child.type === Fragment) {
        if (child.patchFlag & 128)
          keyedFragmentCount++;
        ret = ret.concat(getTransitionRawChildren(child.children, keepComment));
      } else if (keepComment || child.type !== Comment) {
        ret.push(child);
      }
    }
    if (keyedFragmentCount > 1) {
      for (let i3 = 0; i3 < ret.length; i3++) {
        ret[i3].patchFlag = -2;
      }
    }
    return ret;
  }
  var isAsyncWrapper = (i3) => !!i3.type.__asyncLoader;
  var isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
  function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
  }
  function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
  }
  function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = () => {
      let current = target;
      while (current) {
        if (current.isDeactivated) {
          return;
        }
        current = current.parent;
      }
      hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
      let current = target.parent;
      while (current && current.parent) {
        if (isKeepAlive(current.parent.vnode)) {
          injectToKeepAliveRoot(wrappedHook, type, target, current);
        }
        current = current.parent;
      }
    }
  }
  function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(() => {
      remove2(keepAliveRoot[type], injected);
    }, target);
  }
  function injectHook(type, hook, target = currentInstance, prepend2 = false) {
    if (target) {
      const hooks = target[type] || (target[type] = []);
      const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
        if (target.isUnmounted) {
          return;
        }
        pauseTracking2();
        setCurrentInstance(target);
        const res = callWithAsyncErrorHandling(hook, target, type, args);
        unsetCurrentInstance();
        resetTracking2();
        return res;
      });
      if (prepend2) {
        hooks.unshift(wrappedHook);
      } else {
        hooks.push(wrappedHook);
      }
      return wrappedHook;
    } else if (true) {
      const apiName = toHandlerKey2(ErrorTypeStrings[type].replace(/ hook$/, ""));
      warn3(`${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
    }
  }
  var createHook = (lifecycle) => (hook, target = currentInstance) => (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, hook, target);
  var onBeforeMount = createHook("bm");
  var onMounted = createHook("m");
  var onBeforeUpdate = createHook("bu");
  var onUpdated = createHook("u");
  var onBeforeUnmount = createHook("bum");
  var onUnmounted = createHook("um");
  var onServerPrefetch = createHook("sp");
  var onRenderTriggered = createHook("rtg");
  var onRenderTracked = createHook("rtc");
  function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
  }
  function createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key) => {
      if (cache[key]) {
        warn3(`${type} property "${key}" is already defined in ${cache[key]}.`);
      } else {
        cache[key] = type;
      }
    };
  }
  var shouldCacheAccess = true;
  function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) {
      callHook(options.beforeCreate, instance, "bc");
    }
    const {
      data: dataOptions,
      computed: computedOptions,
      methods,
      watch: watchOptions,
      provide: provideOptions,
      inject: injectOptions,
      created,
      beforeMount,
      mounted,
      beforeUpdate,
      updated,
      activated,
      deactivated,
      beforeDestroy,
      beforeUnmount,
      destroyed,
      unmounted,
      render: render15,
      renderTracked,
      renderTriggered,
      errorCaptured,
      serverPrefetch,
      expose,
      inheritAttrs,
      components,
      directives: directives2,
      filters
    } = options;
    const checkDuplicateProperties = true ? createDuplicateChecker() : null;
    if (true) {
      const [propsOptions] = instance.propsOptions;
      if (propsOptions) {
        for (const key in propsOptions) {
          checkDuplicateProperties("Props", key);
        }
      }
    }
    if (injectOptions) {
      resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    }
    if (methods) {
      for (const key in methods) {
        const methodHandler = methods[key];
        if (isFunction(methodHandler)) {
          if (true) {
            Object.defineProperty(ctx, key, {
              value: methodHandler.bind(publicThis),
              configurable: true,
              enumerable: true,
              writable: true
            });
          } else {
            ctx[key] = methodHandler.bind(publicThis);
          }
          if (true) {
            checkDuplicateProperties("Methods", key);
          }
        } else if (true) {
          warn3(`Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`);
        }
      }
    }
    if (dataOptions) {
      if (!isFunction(dataOptions)) {
        warn3(`The data option must be a function. Plain object usage is no longer supported.`);
      }
      const data2 = dataOptions.call(publicThis, publicThis);
      if (isPromise(data2)) {
        warn3(`data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`);
      }
      if (!isObject4(data2)) {
        warn3(`data() should return an object.`);
      } else {
        instance.data = reactive3(data2);
        if (true) {
          for (const key in data2) {
            checkDuplicateProperties("Data", key);
            if (key[0] !== "$" && key[0] !== "_") {
              Object.defineProperty(ctx, key, {
                configurable: true,
                enumerable: true,
                get: () => data2[key],
                set: NOOP
              });
            }
          }
        }
      }
    }
    shouldCacheAccess = true;
    if (computedOptions) {
      for (const key in computedOptions) {
        const opt = computedOptions[key];
        const get4 = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
        if (get4 === NOOP) {
          warn3(`Computed property "${key}" has no getter.`);
        }
        const set4 = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : true ? () => {
          warn3(`Write operation failed: computed property "${key}" is readonly.`);
        } : NOOP;
        const c4 = computed({
          get: get4,
          set: set4
        });
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => c4.value,
          set: (v3) => c4.value = v3
        });
        if (true) {
          checkDuplicateProperties("Computed", key);
        }
      }
    }
    if (watchOptions) {
      for (const key in watchOptions) {
        createWatcher(watchOptions[key], ctx, publicThis, key);
      }
    }
    if (provideOptions) {
      const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
      Reflect.ownKeys(provides).forEach((key) => {
        provide(key, provides[key]);
      });
    }
    if (created) {
      callHook(created, instance, "c");
    }
    function registerLifecycleHook(register, hook) {
      if (isArray2(hook)) {
        hook.forEach((_hook) => register(_hook.bind(publicThis)));
      } else if (hook) {
        register(hook.bind(publicThis));
      }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if (isArray2(expose)) {
      if (expose.length) {
        const exposed = instance.exposed || (instance.exposed = {});
        expose.forEach((key) => {
          Object.defineProperty(exposed, key, {
            get: () => publicThis[key],
            set: (val) => publicThis[key] = val
          });
        });
      } else if (!instance.exposed) {
        instance.exposed = {};
      }
    }
    if (render15 && instance.render === NOOP) {
      instance.render = render15;
    }
    if (inheritAttrs != null) {
      instance.inheritAttrs = inheritAttrs;
    }
    if (components)
      instance.components = components;
    if (directives2)
      instance.directives = directives2;
  }
  function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP, unwrapRef = false) {
    if (isArray2(injectOptions)) {
      injectOptions = normalizeInject(injectOptions);
    }
    for (const key in injectOptions) {
      const opt = injectOptions[key];
      let injected;
      if (isObject4(opt)) {
        if ("default" in opt) {
          injected = inject(opt.from || key, opt.default, true);
        } else {
          injected = inject(opt.from || key);
        }
      } else {
        injected = inject(opt);
      }
      if (isRef2(injected)) {
        if (unwrapRef) {
          Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: () => injected.value,
            set: (v3) => injected.value = v3
          });
        } else {
          if (true) {
            warn3(`injected property "${key}" is a ref and will be auto-unwrapped and no longer needs \`.value\` in the next minor release. To opt-in to the new behavior now, set \`app.config.unwrapInjectedRef = true\` (this config is temporary and will not be needed in the future.)`);
          }
          ctx[key] = injected;
        }
      } else {
        ctx[key] = injected;
      }
      if (true) {
        checkDuplicateProperties("Inject", key);
      }
    }
  }
  function callHook(hook, instance, type) {
    callWithAsyncErrorHandling(isArray2(hook) ? hook.map((h4) => h4.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
  }
  function createWatcher(raw2, ctx, publicThis, key) {
    const getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
    if (isString2(raw2)) {
      const handler4 = ctx[raw2];
      if (isFunction(handler4)) {
        watch(getter, handler4);
      } else if (true) {
        warn3(`Invalid watch handler specified by key "${raw2}"`, handler4);
      }
    } else if (isFunction(raw2)) {
      watch(getter, raw2.bind(publicThis));
    } else if (isObject4(raw2)) {
      if (isArray2(raw2)) {
        raw2.forEach((r2) => createWatcher(r2, ctx, publicThis, key));
      } else {
        const handler4 = isFunction(raw2.handler) ? raw2.handler.bind(publicThis) : ctx[raw2.handler];
        if (isFunction(handler4)) {
          watch(getter, handler4, raw2);
        } else if (true) {
          warn3(`Invalid watch handler specified by key "${raw2.handler}"`, handler4);
        }
      }
    } else if (true) {
      warn3(`Invalid watch option: "${key}"`, raw2);
    }
  }
  function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) {
      resolved = cached;
    } else if (!globalMixins.length && !mixins && !extendsOptions) {
      {
        resolved = base;
      }
    } else {
      resolved = {};
      if (globalMixins.length) {
        globalMixins.forEach((m4) => mergeOptions(resolved, m4, optionMergeStrategies, true));
      }
      mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
  }
  function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) {
      mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
      mixins.forEach((m4) => mergeOptions(to, m4, strats, true));
    }
    for (const key in from) {
      if (asMixin && key === "expose") {
        warn3(`"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`);
      } else {
        const strat = internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
      }
    }
    return to;
  }
  var internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeObjectOptions,
    emits: mergeObjectOptions,
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    watch: mergeWatchOptions,
    provide: mergeDataFn,
    inject: mergeInject
  };
  function mergeDataFn(to, from) {
    if (!from) {
      return to;
    }
    if (!to) {
      return from;
    }
    return function mergedDataFn() {
      return extend4(isFunction(to) ? to.call(this, this) : to, isFunction(from) ? from.call(this, this) : from);
    };
  }
  function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
  }
  function normalizeInject(raw2) {
    if (isArray2(raw2)) {
      const res = {};
      for (let i3 = 0; i3 < raw2.length; i3++) {
        res[raw2[i3]] = raw2[i3];
      }
      return res;
    }
    return raw2;
  }
  function mergeAsArray(to, from) {
    return to ? [...new Set([].concat(to, from))] : from;
  }
  function mergeObjectOptions(to, from) {
    return to ? extend4(extend4(Object.create(null), to), from) : from;
  }
  function mergeWatchOptions(to, from) {
    if (!to)
      return from;
    if (!from)
      return to;
    const merged = extend4(Object.create(null), to);
    for (const key in from) {
      merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
  }
  function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    def(attrs, InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for (const key in instance.propsOptions[0]) {
      if (!(key in props)) {
        props[key] = void 0;
      }
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
    if (isStateful) {
      instance.props = isSSR ? props : shallowReactive(props);
    } else {
      if (!instance.type.props) {
        instance.props = attrs;
      } else {
        instance.props = props;
      }
    }
    instance.attrs = attrs;
  }
  function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = toRaw2(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (!(instance.type.__hmrId || instance.parent && instance.parent.type.__hmrId) && (optimized || patchFlag > 0) && !(patchFlag & 16)) {
      if (patchFlag & 8) {
        const propsToUpdate = instance.vnode.dynamicProps;
        for (let i3 = 0; i3 < propsToUpdate.length; i3++) {
          let key = propsToUpdate[i3];
          const value = rawProps[key];
          if (options) {
            if (hasOwn2(attrs, key)) {
              if (value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
              }
            } else {
              const camelizedKey = camelize2(key);
              props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
            }
          } else {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          }
        }
      }
    } else {
      if (setFullProps(instance, rawProps, props, attrs)) {
        hasAttrsChanged = true;
      }
      let kebabKey;
      for (const key in rawCurrentProps) {
        if (!rawProps || !hasOwn2(rawProps, key) && ((kebabKey = hyphenate2(key)) === key || !hasOwn2(rawProps, kebabKey))) {
          if (options) {
            if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) {
              props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            }
          } else {
            delete props[key];
          }
        }
      }
      if (attrs !== rawCurrentProps) {
        for (const key in attrs) {
          if (!rawProps || !hasOwn2(rawProps, key)) {
            delete attrs[key];
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (hasAttrsChanged) {
      trigger3(instance, "set", "$attrs");
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
  }
  function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) {
      for (let key in rawProps) {
        if (isReservedProp(key)) {
          continue;
        }
        const value = rawProps[key];
        let camelKey;
        if (options && hasOwn2(options, camelKey = camelize2(key))) {
          if (!needCastKeys || !needCastKeys.includes(camelKey)) {
            props[camelKey] = value;
          } else {
            (rawCastValues || (rawCastValues = {}))[camelKey] = value;
          }
        } else if (!isEmitListener(instance.emitsOptions, key)) {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (needCastKeys) {
      const rawCurrentProps = toRaw2(props);
      const castValues = rawCastValues || EMPTY_OBJ2;
      for (let i3 = 0; i3 < needCastKeys.length; i3++) {
        const key = needCastKeys[i3];
        props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !hasOwn2(castValues, key));
      }
    }
    return hasAttrsChanged;
  }
  function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
      const hasDefault = hasOwn2(opt, "default");
      if (hasDefault && value === void 0) {
        const defaultValue = opt.default;
        if (opt.type !== Function && isFunction(defaultValue)) {
          const { propsDefaults } = instance;
          if (key in propsDefaults) {
            value = propsDefaults[key];
          } else {
            setCurrentInstance(instance);
            value = propsDefaults[key] = defaultValue.call(null, props);
            unsetCurrentInstance();
          }
        } else {
          value = defaultValue;
        }
      }
      if (opt[0]) {
        if (isAbsent && !hasDefault) {
          value = false;
        } else if (opt[1] && (value === "" || value === hyphenate2(key))) {
          value = true;
        }
      }
    }
    return value;
  }
  function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) {
      return cached;
    }
    const raw2 = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (!isFunction(comp)) {
      const extendProps = (raw3) => {
        hasExtends = true;
        const [props, keys] = normalizePropsOptions(raw3, appContext, true);
        extend4(normalized, props);
        if (keys)
          needCastKeys.push(...keys);
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendProps);
      }
      if (comp.extends) {
        extendProps(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendProps);
      }
    }
    if (!raw2 && !hasExtends) {
      cache.set(comp, EMPTY_ARR2);
      return EMPTY_ARR2;
    }
    if (isArray2(raw2)) {
      for (let i3 = 0; i3 < raw2.length; i3++) {
        if (!isString2(raw2[i3])) {
          warn3(`props must be strings when using array syntax.`, raw2[i3]);
        }
        const normalizedKey = camelize2(raw2[i3]);
        if (validatePropName(normalizedKey)) {
          normalized[normalizedKey] = EMPTY_OBJ2;
        }
      }
    } else if (raw2) {
      if (!isObject4(raw2)) {
        warn3(`invalid props options`, raw2);
      }
      for (const key in raw2) {
        const normalizedKey = camelize2(key);
        if (validatePropName(normalizedKey)) {
          const opt = raw2[key];
          const prop = normalized[normalizedKey] = isArray2(opt) || isFunction(opt) ? { type: opt } : opt;
          if (prop) {
            const booleanIndex = getTypeIndex(Boolean, prop.type);
            const stringIndex = getTypeIndex(String, prop.type);
            prop[0] = booleanIndex > -1;
            prop[1] = stringIndex < 0 || booleanIndex < stringIndex;
            if (booleanIndex > -1 || hasOwn2(prop, "default")) {
              needCastKeys.push(normalizedKey);
            }
          }
        }
      }
    }
    const res = [normalized, needCastKeys];
    cache.set(comp, res);
    return res;
  }
  function validatePropName(key) {
    if (key[0] !== "$") {
      return true;
    } else if (true) {
      warn3(`Invalid prop name: "${key}" is a reserved property.`);
    }
    return false;
  }
  function getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
  }
  function isSameType(a3, b2) {
    return getType(a3) === getType(b2);
  }
  function getTypeIndex(type, expectedTypes) {
    if (isArray2(expectedTypes)) {
      return expectedTypes.findIndex((t3) => isSameType(t3, type));
    } else if (isFunction(expectedTypes)) {
      return isSameType(expectedTypes, type) ? 0 : -1;
    }
    return -1;
  }
  function validateProps(rawProps, props, instance) {
    const resolvedValues = toRaw2(props);
    const options = instance.propsOptions[0];
    for (const key in options) {
      let opt = options[key];
      if (opt == null)
        continue;
      validateProp(key, resolvedValues[key], opt, !hasOwn2(rawProps, key) && !hasOwn2(rawProps, hyphenate2(key)));
    }
  }
  function validateProp(name, value, prop, isAbsent) {
    const { type, required, validator } = prop;
    if (required && isAbsent) {
      warn3('Missing required prop: "' + name + '"');
      return;
    }
    if (value == null && !prop.required) {
      return;
    }
    if (type != null && type !== true) {
      let isValid = false;
      const types = isArray2(type) ? type : [type];
      const expectedTypes = [];
      for (let i3 = 0; i3 < types.length && !isValid; i3++) {
        const { valid, expectedType } = assertType(value, types[i3]);
        expectedTypes.push(expectedType || "");
        isValid = valid;
      }
      if (!isValid) {
        warn3(getInvalidTypeMessage(name, value, expectedTypes));
        return;
      }
    }
    if (validator && !validator(value)) {
      warn3('Invalid prop: custom validator check failed for prop "' + name + '".');
    }
  }
  var isSimpleType = /* @__PURE__ */ makeMap2("String,Number,Boolean,Function,Symbol,BigInt");
  function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (isSimpleType(expectedType)) {
      const t3 = typeof value;
      valid = t3 === expectedType.toLowerCase();
      if (!valid && t3 === "object") {
        valid = value instanceof type;
      }
    } else if (expectedType === "Object") {
      valid = isObject4(value);
    } else if (expectedType === "Array") {
      valid = isArray2(value);
    } else if (expectedType === "null") {
      valid = value === null;
    } else {
      valid = value instanceof type;
    }
    return {
      valid,
      expectedType
    };
  }
  function getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map(capitalize2).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = toRawType2(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) {
      message += ` with value ${expectedValue}`;
    }
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) {
      message += `with value ${receivedValue}.`;
    }
    return message;
  }
  function styleValue(value, type) {
    if (type === "String") {
      return `"${value}"`;
    } else if (type === "Number") {
      return `${Number(value)}`;
    } else {
      return `${value}`;
    }
  }
  function isExplicable(type) {
    const explicitTypes = ["string", "number", "boolean"];
    return explicitTypes.some((elem) => type.toLowerCase() === elem);
  }
  function isBoolean(...args) {
    return args.some((elem) => elem.toLowerCase() === "boolean");
  }
  var isInternalKey = (key) => key[0] === "_" || key === "$stable";
  var normalizeSlotValue = (value) => isArray2(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
  var normalizeSlot = (key, rawSlot, ctx) => {
    const normalized = withCtx((...args) => {
      if (currentInstance) {
        warn3(`Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`);
      }
      return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
  };
  var normalizeObjectSlots = (rawSlots, slots, instance) => {
    const ctx = rawSlots._ctx;
    for (const key in rawSlots) {
      if (isInternalKey(key))
        continue;
      const value = rawSlots[key];
      if (isFunction(value)) {
        slots[key] = normalizeSlot(key, value, ctx);
      } else if (value != null) {
        if (true) {
          warn3(`Non-function value encountered for slot "${key}". Prefer function slots for better performance.`);
        }
        const normalized = normalizeSlotValue(value);
        slots[key] = () => normalized;
      }
    }
  };
  var normalizeVNodeSlots = (instance, children2) => {
    if (!isKeepAlive(instance.vnode) && true) {
      warn3(`Non-function value encountered for default slot. Prefer function slots for better performance.`);
    }
    const normalized = normalizeSlotValue(children2);
    instance.slots.default = () => normalized;
  };
  var initSlots = (instance, children2) => {
    if (instance.vnode.shapeFlag & 32) {
      const type = children2._;
      if (type) {
        instance.slots = toRaw2(children2);
        def(children2, "_", type);
      } else {
        normalizeObjectSlots(children2, instance.slots = {});
      }
    } else {
      instance.slots = {};
      if (children2) {
        normalizeVNodeSlots(instance, children2);
      }
    }
    def(instance.slots, InternalObjectKey, 1);
  };
  var updateSlots = (instance, children2, optimized) => {
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = EMPTY_OBJ2;
    if (vnode.shapeFlag & 32) {
      const type = children2._;
      if (type) {
        if (isHmrUpdating) {
          extend4(slots, children2);
        } else if (optimized && type === 1) {
          needDeletionCheck = false;
        } else {
          extend4(slots, children2);
          if (!optimized && type === 1) {
            delete slots._;
          }
        }
      } else {
        needDeletionCheck = !children2.$stable;
        normalizeObjectSlots(children2, slots);
      }
      deletionComparisonTarget = children2;
    } else if (children2) {
      normalizeVNodeSlots(instance, children2);
      deletionComparisonTarget = { default: 1 };
    }
    if (needDeletionCheck) {
      for (const key in slots) {
        if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
          delete slots[key];
        }
      }
    }
  };
  var isBuiltInDirective = /* @__PURE__ */ makeMap2("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
  function validateDirectiveName(name) {
    if (isBuiltInDirective(name)) {
      warn3("Do not use built-in directive ids as custom directive id: " + name);
    }
  }
  function withDirectives(vnode, directives2) {
    const internalInstance = currentRenderingInstance;
    if (internalInstance === null) {
      warn3(`withDirectives can only be used inside render functions.`);
      return vnode;
    }
    const instance = internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for (let i3 = 0; i3 < directives2.length; i3++) {
      let [dir, value, arg, modifiers = EMPTY_OBJ2] = directives2[i3];
      if (isFunction(dir)) {
        dir = {
          mounted: dir,
          updated: dir
        };
      }
      if (dir.deep) {
        traverse(value);
      }
      bindings.push({
        dir,
        instance,
        value,
        oldValue: void 0,
        arg,
        modifiers
      });
    }
    return vnode;
  }
  function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for (let i3 = 0; i3 < bindings.length; i3++) {
      const binding = bindings[i3];
      if (oldBindings) {
        binding.oldValue = oldBindings[i3].value;
      }
      let hook = binding.dir[name];
      if (hook) {
        pauseTracking2();
        callWithAsyncErrorHandling(hook, instance, 8, [
          vnode.el,
          binding,
          vnode,
          prevVNode
        ]);
        resetTracking2();
      }
    }
  }
  function createAppContext() {
    return {
      app: null,
      config: {
        isNativeTag: NO,
        performance: false,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: Object.create(null),
      optionsCache: new WeakMap(),
      propsCache: new WeakMap(),
      emitsCache: new WeakMap()
    };
  }
  var uid2 = 0;
  function createAppAPI(render15, hydrate) {
    return function createApp2(rootComponent, rootProps = null) {
      if (rootProps != null && !isObject4(rootProps)) {
        warn3(`root props passed to app.mount() must be an object.`);
        rootProps = null;
      }
      const context = createAppContext();
      const installedPlugins = new Set();
      let isMounted = false;
      const app = context.app = {
        _uid: uid2++,
        _component: rootComponent,
        _props: rootProps,
        _container: null,
        _context: context,
        _instance: null,
        version,
        get config() {
          return context.config;
        },
        set config(v3) {
          if (true) {
            warn3(`app.config cannot be replaced. Modify individual options instead.`);
          }
        },
        use(plugin2, ...options) {
          if (installedPlugins.has(plugin2)) {
            warn3(`Plugin has already been applied to target app.`);
          } else if (plugin2 && isFunction(plugin2.install)) {
            installedPlugins.add(plugin2);
            plugin2.install(app, ...options);
          } else if (isFunction(plugin2)) {
            installedPlugins.add(plugin2);
            plugin2(app, ...options);
          } else if (true) {
            warn3(`A plugin must either be a function or an object with an "install" function.`);
          }
          return app;
        },
        mixin(mixin) {
          if (true) {
            if (!context.mixins.includes(mixin)) {
              context.mixins.push(mixin);
            } else if (true) {
              warn3("Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : ""));
            }
          } else if (true) {
            warn3("Mixins are only available in builds supporting Options API");
          }
          return app;
        },
        component(name, component) {
          if (true) {
            validateComponentName(name, context.config);
          }
          if (!component) {
            return context.components[name];
          }
          if (context.components[name]) {
            warn3(`Component "${name}" has already been registered in target app.`);
          }
          context.components[name] = component;
          return app;
        },
        directive(name, directive2) {
          if (true) {
            validateDirectiveName(name);
          }
          if (!directive2) {
            return context.directives[name];
          }
          if (context.directives[name]) {
            warn3(`Directive "${name}" has already been registered in target app.`);
          }
          context.directives[name] = directive2;
          return app;
        },
        mount(rootContainer, isHydrate, isSVG) {
          if (!isMounted) {
            const vnode = createVNode(rootComponent, rootProps);
            vnode.appContext = context;
            if (true) {
              context.reload = () => {
                render15(cloneVNode(vnode), rootContainer, isSVG);
              };
            }
            if (isHydrate && hydrate) {
              hydrate(vnode, rootContainer);
            } else {
              render15(vnode, rootContainer, isSVG);
            }
            isMounted = true;
            app._container = rootContainer;
            rootContainer.__vue_app__ = app;
            if (true) {
              app._instance = vnode.component;
              devtoolsInitApp(app, version);
            }
            return getExposeProxy(vnode.component) || vnode.component.proxy;
          } else if (true) {
            warn3(`App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``);
          }
        },
        unmount() {
          if (isMounted) {
            render15(null, app._container);
            if (true) {
              app._instance = null;
              devtoolsUnmountApp(app);
            }
            delete app._container.__vue_app__;
          } else if (true) {
            warn3(`Cannot unmount an app that is not mounted.`);
          }
        },
        provide(key, value) {
          if (key in context.provides) {
            warn3(`App already provides property with key "${String(key)}". It will be overwritten with the new value.`);
          }
          context.provides[key] = value;
          return app;
        }
      };
      return app;
    };
  }
  var supported;
  var perf;
  function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      perf.mark(`vue-${type}-${instance.uid}`);
    }
    if (true) {
      devtoolsPerfStart(instance, type, supported ? perf.now() : Date.now());
    }
  }
  function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      const startTag = `vue-${type}-${instance.uid}`;
      const endTag = startTag + `:end`;
      perf.mark(endTag);
      perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
    }
    if (true) {
      devtoolsPerfEnd(instance, type, supported ? perf.now() : Date.now());
    }
  }
  function isSupported() {
    if (supported !== void 0) {
      return supported;
    }
    if (typeof window !== "undefined" && window.performance) {
      supported = true;
      perf = window.performance;
    } else {
      supported = false;
    }
    return supported;
  }
  function initFeatureFlags() {
    const needWarn = [];
    if (false) {
      needWarn.push(`__VUE_OPTIONS_API__`);
      getGlobalThis().__VUE_OPTIONS_API__ = true;
    }
    if (false) {
      needWarn.push(`__VUE_PROD_DEVTOOLS__`);
      getGlobalThis().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (needWarn.length) {
      const multi = needWarn.length > 1;
      console.warn(`Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see http://link.vuejs.org/feature-flags.`);
    }
  }
  var queuePostRenderEffect = queueEffectWithSuspense;
  function createRenderer(options) {
    return baseCreateRenderer(options);
  }
  function baseCreateRenderer(options, createHydrationFns) {
    {
      initFeatureFlags();
    }
    const target = getGlobalThis();
    target.__VUE__ = true;
    if (true) {
      setDevtoolsHook(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    }
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n22, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = isHmrUpdating ? false : !!n22.dynamicChildren) => {
      if (n1 === n22) {
        return;
      }
      if (n1 && !isSameVNodeType(n1, n22)) {
        anchor = getNextHostNode(n1);
        unmount(n1, parentComponent, parentSuspense, true);
        n1 = null;
      }
      if (n22.patchFlag === -2) {
        optimized = false;
        n22.dynamicChildren = null;
      }
      const { type, ref: ref2, shapeFlag } = n22;
      switch (type) {
        case Text:
          processText(n1, n22, container, anchor);
          break;
        case Comment:
          processCommentNode(n1, n22, container, anchor);
          break;
        case Static:
          if (n1 == null) {
            mountStaticNode(n22, container, anchor, isSVG);
          } else if (true) {
            patchStaticNode(n1, n22, container, isSVG);
          }
          break;
        case Fragment:
          processFragment(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          break;
        default:
          if (shapeFlag & 1) {
            processElement(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          } else if (shapeFlag & 6) {
            processComponent(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          } else if (shapeFlag & 64) {
            type.process(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
          } else if (shapeFlag & 128) {
            type.process(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
          } else if (true) {
            warn3("Invalid VNode type:", type, `(${typeof type})`);
          }
      }
      if (ref2 != null && parentComponent) {
        setRef(ref2, n1 && n1.ref, parentSuspense, n22 || n1, !n22);
      }
    };
    const processText = (n1, n22, container, anchor) => {
      if (n1 == null) {
        hostInsert(n22.el = hostCreateText(n22.children), container, anchor);
      } else {
        const el = n22.el = n1.el;
        if (n22.children !== n1.children) {
          hostSetText(el, n22.children);
        }
      }
    };
    const processCommentNode = (n1, n22, container, anchor) => {
      if (n1 == null) {
        hostInsert(n22.el = hostCreateComment(n22.children || ""), container, anchor);
      } else {
        n22.el = n1.el;
      }
    };
    const mountStaticNode = (n22, container, anchor, isSVG) => {
      [n22.el, n22.anchor] = hostInsertStaticContent(n22.children, container, anchor, isSVG);
    };
    const patchStaticNode = (n1, n22, container, isSVG) => {
      if (n22.children !== n1.children) {
        const anchor = hostNextSibling(n1.anchor);
        removeStaticNode(n1);
        [n22.el, n22.anchor] = hostInsertStaticContent(n22.children, container, anchor, isSVG);
      } else {
        n22.el = n1.el;
        n22.anchor = n1.anchor;
      }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
      let next2;
      while (el && el !== anchor) {
        next2 = hostNextSibling(el);
        hostInsert(el, container, nextSibling);
        el = next2;
      }
      hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor }) => {
      let next2;
      while (el && el !== anchor) {
        next2 = hostNextSibling(el);
        hostRemove(el);
        el = next2;
      }
      hostRemove(anchor);
    };
    const processElement = (n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      isSVG = isSVG || n22.type === "svg";
      if (n1 == null) {
        mountElement(n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        patchElement(n1, n22, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      let el;
      let vnodeHook;
      const { type, props, shapeFlag, transition: transition3, patchFlag, dirs } = vnode;
      if (false) {
        el = vnode.el = hostCloneNode(vnode.el);
      } else {
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) {
          hostSetElementText(el, vnode.children);
        } else if (shapeFlag & 16) {
          mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        }
        if (dirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "created");
        }
        if (props) {
          for (const key in props) {
            if (key !== "value" && !isReservedProp(key)) {
              hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
          }
          if ("value" in props) {
            hostPatchProp(el, "value", null, props.value);
          }
          if (vnodeHook = props.onVnodeBeforeMount) {
            invokeVNodeHook(vnodeHook, parentComponent, vnode);
          }
        }
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
      }
      if (true) {
        Object.defineProperty(el, "__vnode", {
          value: vnode,
          enumerable: false
        });
        Object.defineProperty(el, "__vueParentComponent", {
          value: parentComponent,
          enumerable: false
        });
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
      }
      const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition3 && !transition3.persisted;
      if (needCallTransitionHooks) {
        transition3.beforeEnter(el);
      }
      hostInsert(el, container, anchor);
      if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          needCallTransitionHooks && transition3.enter(el);
          dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
      }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
      if (scopeId) {
        hostSetScopeId(el, scopeId);
      }
      if (slotScopeIds) {
        for (let i3 = 0; i3 < slotScopeIds.length; i3++) {
          hostSetScopeId(el, slotScopeIds[i3]);
        }
      }
      if (parentComponent) {
        let subTree = parentComponent.subTree;
        if (subTree.patchFlag > 0 && subTree.patchFlag & 2048) {
          subTree = filterSingleRoot(subTree.children) || subTree;
        }
        if (vnode === subTree) {
          const parentVNode = parentComponent.vnode;
          setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
        }
      }
    };
    const mountChildren = (children2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start2 = 0) => {
      for (let i3 = start2; i3 < children2.length; i3++) {
        const child = children2[i3] = optimized ? cloneIfMounted(children2[i3]) : normalizeVNode(children2[i3]);
        patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
    };
    const patchElement = (n1, n22, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      const el = n22.el = n1.el;
      let { patchFlag, dynamicChildren, dirs } = n22;
      patchFlag |= n1.patchFlag & 16;
      const oldProps = n1.props || EMPTY_OBJ2;
      const newProps = n22.props || EMPTY_OBJ2;
      let vnodeHook;
      if (vnodeHook = newProps.onVnodeBeforeUpdate) {
        invokeVNodeHook(vnodeHook, parentComponent, n22, n1);
      }
      if (dirs) {
        invokeDirectiveHook(n22, n1, parentComponent, "beforeUpdate");
      }
      if (isHmrUpdating) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      const areChildrenSVG = isSVG && n22.type !== "foreignObject";
      if (dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        if (parentComponent && parentComponent.type.__hmrId) {
          traverseStaticChildren(n1, n22);
        }
      } else if (!optimized) {
        patchChildren(n1, n22, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
      }
      if (patchFlag > 0) {
        if (patchFlag & 16) {
          patchProps(el, n22, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        } else {
          if (patchFlag & 2) {
            if (oldProps.class !== newProps.class) {
              hostPatchProp(el, "class", null, newProps.class, isSVG);
            }
          }
          if (patchFlag & 4) {
            hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
          }
          if (patchFlag & 8) {
            const propsToUpdate = n22.dynamicProps;
            for (let i3 = 0; i3 < propsToUpdate.length; i3++) {
              const key = propsToUpdate[i3];
              const prev2 = oldProps[key];
              const next2 = newProps[key];
              if (next2 !== prev2 || key === "value") {
                hostPatchProp(el, key, prev2, next2, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
              }
            }
          }
        }
        if (patchFlag & 1) {
          if (n1.children !== n22.children) {
            hostSetElementText(el, n22.children);
          }
        }
      } else if (!optimized && dynamicChildren == null) {
        patchProps(el, n22, oldProps, newProps, parentComponent, parentSuspense, isSVG);
      }
      if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n22, n1);
          dirs && invokeDirectiveHook(n22, n1, parentComponent, "updated");
        }, parentSuspense);
      }
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) => {
      for (let i3 = 0; i3 < newChildren.length; i3++) {
        const oldVNode = oldChildren[i3];
        const newVNode = newChildren[i3];
        const container = oldVNode.el && (oldVNode.type === Fragment || !isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : fallbackContainer;
        patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
      }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
      if (oldProps !== newProps) {
        for (const key in newProps) {
          if (isReservedProp(key))
            continue;
          const next2 = newProps[key];
          const prev2 = oldProps[key];
          if (next2 !== prev2 && key !== "value") {
            hostPatchProp(el, key, prev2, next2, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
        if (oldProps !== EMPTY_OBJ2) {
          for (const key in oldProps) {
            if (!isReservedProp(key) && !(key in newProps)) {
              hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
          }
        }
        if ("value" in newProps) {
          hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
      }
    };
    const processFragment = (n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      const fragmentStartAnchor = n22.el = n1 ? n1.el : hostCreateText("");
      const fragmentEndAnchor = n22.anchor = n1 ? n1.anchor : hostCreateText("");
      let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n22;
      if (isHmrUpdating) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      if (n1 == null) {
        hostInsert(fragmentStartAnchor, container, anchor);
        hostInsert(fragmentEndAnchor, container, anchor);
        mountChildren(n22.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren) {
          patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
          if (parentComponent && parentComponent.type.__hmrId) {
            traverseStaticChildren(n1, n22);
          } else if (n22.key != null || parentComponent && n22 === parentComponent.subTree) {
            traverseStaticChildren(n1, n22, true);
          }
        } else {
          patchChildren(n1, n22, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      }
    };
    const processComponent = (n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      n22.slotScopeIds = slotScopeIds;
      if (n1 == null) {
        if (n22.shapeFlag & 512) {
          parentComponent.ctx.activate(n22, container, anchor, isSVG, optimized);
        } else {
          mountComponent(n22, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        }
      } else {
        updateComponent(n1, n22, optimized);
      }
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
      const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
      if (instance.type.__hmrId) {
        registerHMR(instance);
      }
      if (true) {
        pushWarningContext(initialVNode);
        startMeasure(instance, `mount`);
      }
      if (isKeepAlive(initialVNode)) {
        instance.ctx.renderer = internals;
      }
      {
        if (true) {
          startMeasure(instance, `init`);
        }
        setupComponent(instance);
        if (true) {
          endMeasure(instance, `init`);
        }
      }
      if (instance.asyncDep) {
        parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
        if (!initialVNode.el) {
          const placeholder = instance.subTree = createVNode(Comment);
          processCommentNode(null, placeholder, container, anchor);
        }
        return;
      }
      setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
      if (true) {
        popWarningContext();
        endMeasure(instance, `mount`);
      }
    };
    const updateComponent = (n1, n22, optimized) => {
      const instance = n22.component = n1.component;
      if (shouldUpdateComponent(n1, n22, optimized)) {
        if (instance.asyncDep && !instance.asyncResolved) {
          if (true) {
            pushWarningContext(n22);
          }
          updateComponentPreRender(instance, n22, optimized);
          if (true) {
            popWarningContext();
          }
          return;
        } else {
          instance.next = n22;
          invalidateJob(instance.update);
          instance.update();
        }
      } else {
        n22.component = n1.component;
        n22.el = n1.el;
        instance.vnode = n22;
      }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
      const componentUpdateFn = () => {
        if (!instance.isMounted) {
          let vnodeHook;
          const { el, props } = initialVNode;
          const { bm, m: m4, parent: parent2 } = instance;
          const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
          effect4.allowRecurse = false;
          if (bm) {
            invokeArrayFns(bm);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
            invokeVNodeHook(vnodeHook, parent2, initialVNode);
          }
          effect4.allowRecurse = true;
          if (el && hydrateNode) {
            const hydrateSubTree = () => {
              if (true) {
                startMeasure(instance, `render`);
              }
              instance.subTree = renderComponentRoot(instance);
              if (true) {
                endMeasure(instance, `render`);
              }
              if (true) {
                startMeasure(instance, `hydrate`);
              }
              hydrateNode(el, instance.subTree, instance, parentSuspense, null);
              if (true) {
                endMeasure(instance, `hydrate`);
              }
            };
            if (isAsyncWrapperVNode) {
              initialVNode.type.__asyncLoader().then(() => !instance.isUnmounted && hydrateSubTree());
            } else {
              hydrateSubTree();
            }
          } else {
            if (true) {
              startMeasure(instance, `render`);
            }
            const subTree = instance.subTree = renderComponentRoot(instance);
            if (true) {
              endMeasure(instance, `render`);
            }
            if (true) {
              startMeasure(instance, `patch`);
            }
            patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
            if (true) {
              endMeasure(instance, `patch`);
            }
            initialVNode.el = subTree.el;
          }
          if (m4) {
            queuePostRenderEffect(m4, parentSuspense);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
            const scopedInitialVNode = initialVNode;
            queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent2, scopedInitialVNode), parentSuspense);
          }
          if (initialVNode.shapeFlag & 256) {
            instance.a && queuePostRenderEffect(instance.a, parentSuspense);
          }
          instance.isMounted = true;
          if (true) {
            devtoolsComponentAdded(instance);
          }
          initialVNode = container = anchor = null;
        } else {
          let { next: next2, bu, u: u3, parent: parent2, vnode } = instance;
          let originNext = next2;
          let vnodeHook;
          if (true) {
            pushWarningContext(next2 || instance.vnode);
          }
          effect4.allowRecurse = false;
          if (next2) {
            next2.el = vnode.el;
            updateComponentPreRender(instance, next2, optimized);
          } else {
            next2 = vnode;
          }
          if (bu) {
            invokeArrayFns(bu);
          }
          if (vnodeHook = next2.props && next2.props.onVnodeBeforeUpdate) {
            invokeVNodeHook(vnodeHook, parent2, next2, vnode);
          }
          effect4.allowRecurse = true;
          if (true) {
            startMeasure(instance, `render`);
          }
          const nextTree = renderComponentRoot(instance);
          if (true) {
            endMeasure(instance, `render`);
          }
          const prevTree = instance.subTree;
          instance.subTree = nextTree;
          if (true) {
            startMeasure(instance, `patch`);
          }
          patch(prevTree, nextTree, hostParentNode(prevTree.el), getNextHostNode(prevTree), instance, parentSuspense, isSVG);
          if (true) {
            endMeasure(instance, `patch`);
          }
          next2.el = nextTree.el;
          if (originNext === null) {
            updateHOCHostEl(instance, nextTree.el);
          }
          if (u3) {
            queuePostRenderEffect(u3, parentSuspense);
          }
          if (vnodeHook = next2.props && next2.props.onVnodeUpdated) {
            queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent2, next2, vnode), parentSuspense);
          }
          if (true) {
            devtoolsComponentUpdated(instance);
          }
          if (true) {
            popWarningContext();
          }
        }
      };
      const effect4 = new ReactiveEffect(componentUpdateFn, () => queueJob2(instance.update), instance.scope);
      const update = instance.update = effect4.run.bind(effect4);
      update.id = instance.uid;
      effect4.allowRecurse = update.allowRecurse = true;
      if (true) {
        effect4.onTrack = instance.rtc ? (e2) => invokeArrayFns(instance.rtc, e2) : void 0;
        effect4.onTrigger = instance.rtg ? (e2) => invokeArrayFns(instance.rtg, e2) : void 0;
        update.ownerInstance = instance;
      }
      update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized) => {
      nextVNode.component = instance;
      const prevProps = instance.vnode.props;
      instance.vnode = nextVNode;
      instance.next = null;
      updateProps(instance, nextVNode.props, prevProps, optimized);
      updateSlots(instance, nextVNode.children, optimized);
      pauseTracking2();
      flushPreFlushCbs(void 0, instance.update);
      resetTracking2();
    };
    const patchChildren = (n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false) => {
      const c1 = n1 && n1.children;
      const prevShapeFlag = n1 ? n1.shapeFlag : 0;
      const c22 = n22.children;
      const { patchFlag, shapeFlag } = n22;
      if (patchFlag > 0) {
        if (patchFlag & 128) {
          patchKeyedChildren(c1, c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          return;
        } else if (patchFlag & 256) {
          patchUnkeyedChildren(c1, c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          return;
        }
      }
      if (shapeFlag & 8) {
        if (prevShapeFlag & 16) {
          unmountChildren(c1, parentComponent, parentSuspense);
        }
        if (c22 !== c1) {
          hostSetElementText(container, c22);
        }
      } else {
        if (prevShapeFlag & 16) {
          if (shapeFlag & 16) {
            patchKeyedChildren(c1, c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          } else {
            unmountChildren(c1, parentComponent, parentSuspense, true);
          }
        } else {
          if (prevShapeFlag & 8) {
            hostSetElementText(container, "");
          }
          if (shapeFlag & 16) {
            mountChildren(c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          }
        }
      }
    };
    const patchUnkeyedChildren = (c1, c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      c1 = c1 || EMPTY_ARR2;
      c22 = c22 || EMPTY_ARR2;
      const oldLength = c1.length;
      const newLength = c22.length;
      const commonLength = Math.min(oldLength, newLength);
      let i3;
      for (i3 = 0; i3 < commonLength; i3++) {
        const nextChild = c22[i3] = optimized ? cloneIfMounted(c22[i3]) : normalizeVNode(c22[i3]);
        patch(c1[i3], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
      if (oldLength > newLength) {
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
      } else {
        mountChildren(c22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
      }
    };
    const patchKeyedChildren = (c1, c22, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
      let i3 = 0;
      const l22 = c22.length;
      let e1 = c1.length - 1;
      let e2 = l22 - 1;
      while (i3 <= e1 && i3 <= e2) {
        const n1 = c1[i3];
        const n22 = c22[i3] = optimized ? cloneIfMounted(c22[i3]) : normalizeVNode(c22[i3]);
        if (isSameVNodeType(n1, n22)) {
          patch(n1, n22, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else {
          break;
        }
        i3++;
      }
      while (i3 <= e1 && i3 <= e2) {
        const n1 = c1[e1];
        const n22 = c22[e2] = optimized ? cloneIfMounted(c22[e2]) : normalizeVNode(c22[e2]);
        if (isSameVNodeType(n1, n22)) {
          patch(n1, n22, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else {
          break;
        }
        e1--;
        e2--;
      }
      if (i3 > e1) {
        if (i3 <= e2) {
          const nextPos = e2 + 1;
          const anchor = nextPos < l22 ? c22[nextPos].el : parentAnchor;
          while (i3 <= e2) {
            patch(null, c22[i3] = optimized ? cloneIfMounted(c22[i3]) : normalizeVNode(c22[i3]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            i3++;
          }
        }
      } else if (i3 > e2) {
        while (i3 <= e1) {
          unmount(c1[i3], parentComponent, parentSuspense, true);
          i3++;
        }
      } else {
        const s1 = i3;
        const s22 = i3;
        const keyToNewIndexMap = new Map();
        for (i3 = s22; i3 <= e2; i3++) {
          const nextChild = c22[i3] = optimized ? cloneIfMounted(c22[i3]) : normalizeVNode(c22[i3]);
          if (nextChild.key != null) {
            if (keyToNewIndexMap.has(nextChild.key)) {
              warn3(`Duplicate keys found during update:`, JSON.stringify(nextChild.key), `Make sure keys are unique.`);
            }
            keyToNewIndexMap.set(nextChild.key, i3);
          }
        }
        let j2;
        let patched = 0;
        const toBePatched = e2 - s22 + 1;
        let moved = false;
        let maxNewIndexSoFar = 0;
        const newIndexToOldIndexMap = new Array(toBePatched);
        for (i3 = 0; i3 < toBePatched; i3++)
          newIndexToOldIndexMap[i3] = 0;
        for (i3 = s1; i3 <= e1; i3++) {
          const prevChild = c1[i3];
          if (patched >= toBePatched) {
            unmount(prevChild, parentComponent, parentSuspense, true);
            continue;
          }
          let newIndex;
          if (prevChild.key != null) {
            newIndex = keyToNewIndexMap.get(prevChild.key);
          } else {
            for (j2 = s22; j2 <= e2; j2++) {
              if (newIndexToOldIndexMap[j2 - s22] === 0 && isSameVNodeType(prevChild, c22[j2])) {
                newIndex = j2;
                break;
              }
            }
          }
          if (newIndex === void 0) {
            unmount(prevChild, parentComponent, parentSuspense, true);
          } else {
            newIndexToOldIndexMap[newIndex - s22] = i3 + 1;
            if (newIndex >= maxNewIndexSoFar) {
              maxNewIndexSoFar = newIndex;
            } else {
              moved = true;
            }
            patch(prevChild, c22[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            patched++;
          }
        }
        const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR2;
        j2 = increasingNewIndexSequence.length - 1;
        for (i3 = toBePatched - 1; i3 >= 0; i3--) {
          const nextIndex = s22 + i3;
          const nextChild = c22[nextIndex];
          const anchor = nextIndex + 1 < l22 ? c22[nextIndex + 1].el : parentAnchor;
          if (newIndexToOldIndexMap[i3] === 0) {
            patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          } else if (moved) {
            if (j2 < 0 || i3 !== increasingNewIndexSequence[j2]) {
              move(nextChild, container, anchor, 2);
            } else {
              j2--;
            }
          }
        }
      }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
      const { el, type, transition: transition3, children: children2, shapeFlag } = vnode;
      if (shapeFlag & 6) {
        move(vnode.component.subTree, container, anchor, moveType);
        return;
      }
      if (shapeFlag & 128) {
        vnode.suspense.move(container, anchor, moveType);
        return;
      }
      if (shapeFlag & 64) {
        type.move(vnode, container, anchor, internals);
        return;
      }
      if (type === Fragment) {
        hostInsert(el, container, anchor);
        for (let i3 = 0; i3 < children2.length; i3++) {
          move(children2[i3], container, anchor, moveType);
        }
        hostInsert(vnode.anchor, container, anchor);
        return;
      }
      if (type === Static) {
        moveStaticNode(vnode, container, anchor);
        return;
      }
      const needTransition = moveType !== 2 && shapeFlag & 1 && transition3;
      if (needTransition) {
        if (moveType === 0) {
          transition3.beforeEnter(el);
          hostInsert(el, container, anchor);
          queuePostRenderEffect(() => transition3.enter(el), parentSuspense);
        } else {
          const { leave, delayLeave, afterLeave } = transition3;
          const remove4 = () => hostInsert(el, container, anchor);
          const performLeave = () => {
            leave(el, () => {
              remove4();
              afterLeave && afterLeave();
            });
          };
          if (delayLeave) {
            delayLeave(el, remove4, performLeave);
          } else {
            performLeave();
          }
        }
      } else {
        hostInsert(el, container, anchor);
      }
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
      const { type, props, ref: ref2, children: children2, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
      if (ref2 != null) {
        setRef(ref2, null, parentSuspense, vnode, true);
      }
      if (shapeFlag & 256) {
        parentComponent.ctx.deactivate(vnode);
        return;
      }
      const shouldInvokeDirs = shapeFlag & 1 && dirs;
      const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
      let vnodeHook;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
      if (shapeFlag & 6) {
        unmountComponent(vnode.component, parentSuspense, doRemove);
      } else {
        if (shapeFlag & 128) {
          vnode.suspense.unmount(parentSuspense, doRemove);
          return;
        }
        if (shouldInvokeDirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
        }
        if (shapeFlag & 64) {
          vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
        } else if (dynamicChildren && (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
          unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
        } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
          unmountChildren(children2, parentComponent, parentSuspense);
        }
        if (doRemove) {
          remove3(vnode);
        }
      }
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
      }
    };
    const remove3 = (vnode) => {
      const { type, el, anchor, transition: transition3 } = vnode;
      if (type === Fragment) {
        removeFragment(el, anchor);
        return;
      }
      if (type === Static) {
        removeStaticNode(vnode);
        return;
      }
      const performRemove = () => {
        hostRemove(el);
        if (transition3 && !transition3.persisted && transition3.afterLeave) {
          transition3.afterLeave();
        }
      };
      if (vnode.shapeFlag & 1 && transition3 && !transition3.persisted) {
        const { leave, delayLeave } = transition3;
        const performLeave = () => leave(el, performRemove);
        if (delayLeave) {
          delayLeave(vnode.el, performRemove, performLeave);
        } else {
          performLeave();
        }
      } else {
        performRemove();
      }
    };
    const removeFragment = (cur, end) => {
      let next2;
      while (cur !== end) {
        next2 = hostNextSibling(cur);
        hostRemove(cur);
        cur = next2;
      }
      hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove) => {
      if (instance.type.__hmrId) {
        unregisterHMR(instance);
      }
      const { bum, scope: scope2, update, subTree, um } = instance;
      if (bum) {
        invokeArrayFns(bum);
      }
      scope2.stop();
      if (update) {
        update.active = false;
        unmount(subTree, instance, parentSuspense, doRemove);
      }
      if (um) {
        queuePostRenderEffect(um, parentSuspense);
      }
      queuePostRenderEffect(() => {
        instance.isUnmounted = true;
      }, parentSuspense);
      if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
        parentSuspense.deps--;
        if (parentSuspense.deps === 0) {
          parentSuspense.resolve();
        }
      }
      if (true) {
        devtoolsComponentRemoved(instance);
      }
    };
    const unmountChildren = (children2, parentComponent, parentSuspense, doRemove = false, optimized = false, start2 = 0) => {
      for (let i3 = start2; i3 < children2.length; i3++) {
        unmount(children2[i3], parentComponent, parentSuspense, doRemove, optimized);
      }
    };
    const getNextHostNode = (vnode) => {
      if (vnode.shapeFlag & 6) {
        return getNextHostNode(vnode.component.subTree);
      }
      if (vnode.shapeFlag & 128) {
        return vnode.suspense.next();
      }
      return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render15 = (vnode, container, isSVG) => {
      if (vnode == null) {
        if (container._vnode) {
          unmount(container._vnode, null, null, true);
        }
      } else {
        patch(container._vnode || null, vnode, container, null, null, null, isSVG);
      }
      flushPostFlushCbs();
      container._vnode = vnode;
    };
    const internals = {
      p: patch,
      um: unmount,
      m: move,
      r: remove3,
      mt: mountComponent,
      mc: mountChildren,
      pc: patchChildren,
      pbc: patchBlockChildren,
      n: getNextHostNode,
      o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) {
      [hydrate, hydrateNode] = createHydrationFns(internals);
    }
    return {
      render: render15,
      hydrate,
      createApp: createAppAPI(render15, hydrate)
    };
  }
  function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if (isArray2(rawRef)) {
      rawRef.forEach((r2, i3) => setRef(r2, oldRawRef && (isArray2(oldRawRef) ? oldRawRef[i3] : oldRawRef), parentSuspense, vnode, isUnmount));
      return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
      return;
    }
    const refValue = vnode.shapeFlag & 4 ? getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref2 } = rawRef;
    if (!owner) {
      warn3(`Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`);
      return;
    }
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === EMPTY_OBJ2 ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref2) {
      if (isString2(oldRef)) {
        refs[oldRef] = null;
        if (hasOwn2(setupState, oldRef)) {
          setupState[oldRef] = null;
        }
      } else if (isRef2(oldRef)) {
        oldRef.value = null;
      }
    }
    if (isString2(ref2)) {
      const doSet = () => {
        {
          refs[ref2] = value;
        }
        if (hasOwn2(setupState, ref2)) {
          setupState[ref2] = value;
        }
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    } else if (isRef2(ref2)) {
      const doSet = () => {
        ref2.value = value;
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    } else if (isFunction(ref2)) {
      callWithErrorHandling(ref2, owner, 12, [value, refs]);
    } else if (true) {
      warn3("Invalid template ref type:", value, `(${typeof value})`);
    }
  }
  function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
      vnode,
      prevVNode
    ]);
  }
  function traverseStaticChildren(n1, n22, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n22.children;
    if (isArray2(ch1) && isArray2(ch2)) {
      for (let i3 = 0; i3 < ch1.length; i3++) {
        const c1 = ch1[i3];
        let c22 = ch2[i3];
        if (c22.shapeFlag & 1 && !c22.dynamicChildren) {
          if (c22.patchFlag <= 0 || c22.patchFlag === 32) {
            c22 = ch2[i3] = cloneIfMounted(ch2[i3]);
            c22.el = c1.el;
          }
          if (!shallow)
            traverseStaticChildren(c1, c22);
        }
        if (c22.type === Comment && !c22.el) {
          c22.el = c1.el;
        }
      }
    }
  }
  function getSequence(arr) {
    const p4 = arr.slice();
    const result = [0];
    let i3, j2, u3, v3, c4;
    const len = arr.length;
    for (i3 = 0; i3 < len; i3++) {
      const arrI = arr[i3];
      if (arrI !== 0) {
        j2 = result[result.length - 1];
        if (arr[j2] < arrI) {
          p4[i3] = j2;
          result.push(i3);
          continue;
        }
        u3 = 0;
        v3 = result.length - 1;
        while (u3 < v3) {
          c4 = u3 + v3 >> 1;
          if (arr[result[c4]] < arrI) {
            u3 = c4 + 1;
          } else {
            v3 = c4;
          }
        }
        if (arrI < arr[result[u3]]) {
          if (u3 > 0) {
            p4[i3] = result[u3 - 1];
          }
          result[u3] = i3;
        }
      }
    }
    u3 = result.length;
    v3 = result[u3 - 1];
    while (u3-- > 0) {
      result[u3] = v3;
      v3 = p4[v3];
    }
    return result;
  }
  var isTeleport = (type) => type.__isTeleport;
  var isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
  var isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
  var resolveTarget = (props, select) => {
    const targetSelector = props && props.to;
    if (isString2(targetSelector)) {
      if (!select) {
        warn3(`Current renderer does not support string target for Teleports. (missing querySelector renderer option)`);
        return null;
      } else {
        const target = select(targetSelector);
        if (!target) {
          warn3(`Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`);
        }
        return target;
      }
    } else {
      if (!targetSelector && !isTeleportDisabled(props)) {
        warn3(`Invalid Teleport target: ${targetSelector}`);
      }
      return targetSelector;
    }
  };
  var TeleportImpl = {
    __isTeleport: true,
    process(n1, n22, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
      const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
      const disabled = isTeleportDisabled(n22.props);
      let { shapeFlag, children: children2, dynamicChildren } = n22;
      if (isHmrUpdating) {
        optimized = false;
        dynamicChildren = null;
      }
      if (n1 == null) {
        const placeholder = n22.el = true ? createComment("teleport start") : createText("");
        const mainAnchor = n22.anchor = true ? createComment("teleport end") : createText("");
        insert(placeholder, container, anchor);
        insert(mainAnchor, container, anchor);
        const target = n22.target = resolveTarget(n22.props, querySelector);
        const targetAnchor = n22.targetAnchor = createText("");
        if (target) {
          insert(targetAnchor, target);
          isSVG = isSVG || isTargetSVG(target);
        } else if (!disabled) {
          warn3("Invalid Teleport target on mount:", target, `(${typeof target})`);
        }
        const mount = (container2, anchor2) => {
          if (shapeFlag & 16) {
            mountChildren(children2, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          }
        };
        if (disabled) {
          mount(container, mainAnchor);
        } else if (target) {
          mount(target, targetAnchor);
        }
      } else {
        n22.el = n1.el;
        const mainAnchor = n22.anchor = n1.anchor;
        const target = n22.target = n1.target;
        const targetAnchor = n22.targetAnchor = n1.targetAnchor;
        const wasDisabled = isTeleportDisabled(n1.props);
        const currentContainer = wasDisabled ? container : target;
        const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
        isSVG = isSVG || isTargetSVG(target);
        if (dynamicChildren) {
          patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
          traverseStaticChildren(n1, n22, true);
        } else if (!optimized) {
          patchChildren(n1, n22, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
        }
        if (disabled) {
          if (!wasDisabled) {
            moveTeleport(n22, container, mainAnchor, internals, 1);
          }
        } else {
          if ((n22.props && n22.props.to) !== (n1.props && n1.props.to)) {
            const nextTarget = n22.target = resolveTarget(n22.props, querySelector);
            if (nextTarget) {
              moveTeleport(n22, nextTarget, null, internals, 0);
            } else if (true) {
              warn3("Invalid Teleport target on update:", target, `(${typeof target})`);
            }
          } else if (wasDisabled) {
            moveTeleport(n22, target, targetAnchor, internals, 1);
          }
        }
      }
    },
    remove(vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
      const { shapeFlag, children: children2, anchor, targetAnchor, target, props } = vnode;
      if (target) {
        hostRemove(targetAnchor);
      }
      if (doRemove || !isTeleportDisabled(props)) {
        hostRemove(anchor);
        if (shapeFlag & 16) {
          for (let i3 = 0; i3 < children2.length; i3++) {
            const child = children2[i3];
            unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
          }
        }
      }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
  };
  function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
      insert(vnode.targetAnchor, container, parentAnchor);
    }
    const { el, anchor, shapeFlag, children: children2, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) {
      insert(el, container, parentAnchor);
    }
    if (!isReorder || isTeleportDisabled(props)) {
      if (shapeFlag & 16) {
        for (let i3 = 0; i3 < children2.length; i3++) {
          move(children2[i3], container, parentAnchor, 2);
        }
      }
    }
    if (isReorder) {
      insert(anchor, container, parentAnchor);
    }
  }
  function hydrateTeleport(node2, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector } }, hydrateChildren) {
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
      const targetNode = target._lpa || target.firstChild;
      if (vnode.shapeFlag & 16) {
        if (isTeleportDisabled(vnode.props)) {
          vnode.anchor = hydrateChildren(nextSibling(node2), vnode, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
          vnode.targetAnchor = targetNode;
        } else {
          vnode.anchor = nextSibling(node2);
          vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
        }
        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
      }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
  }
  var Teleport = TeleportImpl;
  var COMPONENTS = "components";
  function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
  }
  var NULL_DYNAMIC_COMPONENT = Symbol();
  function resolveDynamicComponent(component) {
    if (isString2(component)) {
      return resolveAsset(COMPONENTS, component, false) || component;
    } else {
      return component || NULL_DYNAMIC_COMPONENT;
    }
  }
  function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
      const Component = instance.type;
      if (type === COMPONENTS) {
        const selfName = getComponentName(Component);
        if (selfName && (selfName === name || selfName === camelize2(name) || selfName === capitalize2(camelize2(name)))) {
          return Component;
        }
      }
      const res = resolve(instance[type] || Component[type], name) || resolve(instance.appContext[type], name);
      if (!res && maybeSelfReference) {
        return Component;
      }
      if (warnMissing && !res) {
        const extra = type === COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
        warn3(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
      }
      return res;
    } else if (true) {
      warn3(`resolve${capitalize2(type.slice(0, -1))} can only be used in render() or setup().`);
    }
  }
  function resolve(registry, name) {
    return registry && (registry[name] || registry[camelize2(name)] || registry[capitalize2(camelize2(name))]);
  }
  var Fragment = Symbol(true ? "Fragment" : void 0);
  var Text = Symbol(true ? "Text" : void 0);
  var Comment = Symbol(true ? "Comment" : void 0);
  var Static = Symbol(true ? "Static" : void 0);
  var blockStack = [];
  var currentBlock = null;
  function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
  }
  function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
  }
  var isBlockTreeEnabled = 1;
  function setBlockTracking(value) {
    isBlockTreeEnabled += value;
  }
  function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR2 : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  function createElementBlock(type, props, children2, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children2, patchFlag, dynamicProps, shapeFlag, true));
  }
  function createBlock(type, props, children2, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children2, patchFlag, dynamicProps, true));
  }
  function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
  }
  function isSameVNodeType(n1, n22) {
    if (n22.shapeFlag & 6 && hmrDirtyComponents.has(n22.type)) {
      return false;
    }
    return n1.type === n22.type && n1.key === n22.key;
  }
  var vnodeArgsTransformer;
  var createVNodeWithArgsTransform = (...args) => {
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
  };
  var InternalObjectKey = `__vInternal`;
  var normalizeKey = ({ key }) => key != null ? key : null;
  var normalizeRef = ({ ref: ref2 }) => {
    return ref2 != null ? isString2(ref2) || isRef2(ref2) || isFunction(ref2) ? { i: currentRenderingInstance, r: ref2 } : ref2 : null;
  };
  function createBaseVNode(type, props = null, children2 = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
      __v_isVNode: true,
      __v_skip: true,
      type,
      props,
      key: props && normalizeKey(props),
      ref: props && normalizeRef(props),
      scopeId: currentScopeId,
      slotScopeIds: null,
      children: children2,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag,
      patchFlag,
      dynamicProps,
      dynamicChildren: null,
      appContext: null
    };
    if (needFullChildrenNormalization) {
      normalizeChildren(vnode, children2);
      if (shapeFlag & 128) {
        type.normalize(vnode);
      }
    } else if (children2) {
      vnode.shapeFlag |= isString2(children2) ? 8 : 16;
    }
    if (vnode.key !== vnode.key) {
      warn3(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
    }
    if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  var createVNode = true ? createVNodeWithArgsTransform : _createVNode;
  function _createVNode(type, props = null, children2 = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
      if (!type) {
        warn3(`Invalid vnode type when creating vnode: ${type}.`);
      }
      type = Comment;
    }
    if (isVNode(type)) {
      const cloned = cloneVNode(type, props, true);
      if (children2) {
        normalizeChildren(cloned, children2);
      }
      return cloned;
    }
    if (isClassComponent(type)) {
      type = type.__vccOpts;
    }
    if (props) {
      props = guardReactiveProps(props);
      let { class: klass, style } = props;
      if (klass && !isString2(klass)) {
        props.class = normalizeClass(klass);
      }
      if (isObject4(style)) {
        if (isProxy(style) && !isArray2(style)) {
          style = extend4({}, style);
        }
        props.style = normalizeStyle(style);
      }
    }
    const shapeFlag = isString2(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject4(type) ? 4 : isFunction(type) ? 2 : 0;
    if (shapeFlag & 4 && isProxy(type)) {
      type = toRaw2(type);
      warn3(`Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`, `
Component that was made reactive: `, type);
    }
    return createBaseVNode(type, props, children2, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
  }
  function guardReactiveProps(props) {
    if (!props)
      return null;
    return isProxy(props) || InternalObjectKey in props ? extend4({}, props) : props;
  }
  function cloneVNode(vnode, extraProps, mergeRef = false) {
    const { props, ref: ref2, patchFlag, children: children2 } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
      __v_isVNode: true,
      __v_skip: true,
      type: vnode.type,
      props: mergedProps,
      key: mergedProps && normalizeKey(mergedProps),
      ref: extraProps && extraProps.ref ? mergeRef && ref2 ? isArray2(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps) : ref2,
      scopeId: vnode.scopeId,
      slotScopeIds: vnode.slotScopeIds,
      children: patchFlag === -1 && isArray2(children2) ? children2.map(deepCloneVNode) : children2,
      target: vnode.target,
      targetAnchor: vnode.targetAnchor,
      staticCount: vnode.staticCount,
      shapeFlag: vnode.shapeFlag,
      patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
      dynamicProps: vnode.dynamicProps,
      dynamicChildren: vnode.dynamicChildren,
      appContext: vnode.appContext,
      dirs: vnode.dirs,
      transition: vnode.transition,
      component: vnode.component,
      suspense: vnode.suspense,
      ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
      ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
      el: vnode.el,
      anchor: vnode.anchor
    };
    return cloned;
  }
  function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if (isArray2(vnode.children)) {
      cloned.children = vnode.children.map(deepCloneVNode);
    }
    return cloned;
  }
  function createTextVNode(text2 = " ", flag = 0) {
    return createVNode(Text, null, text2, flag);
  }
  function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
  }
  function createCommentVNode(text2 = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text2)) : createVNode(Comment, null, text2);
  }
  function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") {
      return createVNode(Comment);
    } else if (isArray2(child)) {
      return createVNode(Fragment, null, child.slice());
    } else if (typeof child === "object") {
      return cloneIfMounted(child);
    } else {
      return createVNode(Text, null, String(child));
    }
  }
  function cloneIfMounted(child) {
    return child.el === null || child.memo ? child : cloneVNode(child);
  }
  function normalizeChildren(vnode, children2) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children2 == null) {
      children2 = null;
    } else if (isArray2(children2)) {
      type = 16;
    } else if (typeof children2 === "object") {
      if (shapeFlag & (1 | 64)) {
        const slot = children2.default;
        if (slot) {
          slot._c && (slot._d = false);
          normalizeChildren(vnode, slot());
          slot._c && (slot._d = true);
        }
        return;
      } else {
        type = 32;
        const slotFlag = children2._;
        if (!slotFlag && !(InternalObjectKey in children2)) {
          children2._ctx = currentRenderingInstance;
        } else if (slotFlag === 3 && currentRenderingInstance) {
          if (currentRenderingInstance.slots._ === 1) {
            children2._ = 1;
          } else {
            children2._ = 2;
            vnode.patchFlag |= 1024;
          }
        }
      }
    } else if (isFunction(children2)) {
      children2 = { default: children2, _ctx: currentRenderingInstance };
      type = 32;
    } else {
      children2 = String(children2);
      if (shapeFlag & 64) {
        type = 16;
        children2 = [createTextVNode(children2)];
      } else {
        type = 8;
      }
    }
    vnode.children = children2;
    vnode.shapeFlag |= type;
  }
  function mergeProps(...args) {
    const ret = {};
    for (let i3 = 0; i3 < args.length; i3++) {
      const toMerge = args[i3];
      for (const key in toMerge) {
        if (key === "class") {
          if (ret.class !== toMerge.class) {
            ret.class = normalizeClass([ret.class, toMerge.class]);
          }
        } else if (key === "style") {
          ret.style = normalizeStyle([ret.style, toMerge.style]);
        } else if (isOn(key)) {
          const existing = ret[key];
          const incoming = toMerge[key];
          if (existing !== incoming && !(isArray2(existing) && existing.includes(incoming))) {
            ret[key] = existing ? [].concat(existing, incoming) : incoming;
          }
        } else if (key !== "") {
          ret[key] = toMerge[key];
        }
      }
    }
    return ret;
  }
  function renderList(source, renderItem, cache, index3) {
    let ret;
    const cached = cache && cache[index3];
    if (isArray2(source) || isString2(source)) {
      ret = new Array(source.length);
      for (let i3 = 0, l3 = source.length; i3 < l3; i3++) {
        ret[i3] = renderItem(source[i3], i3, void 0, cached && cached[i3]);
      }
    } else if (typeof source === "number") {
      if (!Number.isInteger(source)) {
        warn3(`The v-for range expect an integer value but got ${source}.`);
        return [];
      }
      ret = new Array(source);
      for (let i3 = 0; i3 < source; i3++) {
        ret[i3] = renderItem(i3 + 1, i3, void 0, cached && cached[i3]);
      }
    } else if (isObject4(source)) {
      if (source[Symbol.iterator]) {
        ret = Array.from(source, (item, i3) => renderItem(item, i3, void 0, cached && cached[i3]));
      } else {
        const keys = Object.keys(source);
        ret = new Array(keys.length);
        for (let i3 = 0, l3 = keys.length; i3 < l3; i3++) {
          const key = keys[i3];
          ret[i3] = renderItem(source[key], key, i3, cached && cached[i3]);
        }
      }
    } else {
      ret = [];
    }
    if (cache) {
      cache[index3] = ret;
    }
    return ret;
  }
  var getPublicInstance = (i3) => {
    if (!i3)
      return null;
    if (isStatefulComponent(i3))
      return getExposeProxy(i3) || i3.proxy;
    return getPublicInstance(i3.parent);
  };
  var publicPropertiesMap = extend4(Object.create(null), {
    $: (i3) => i3,
    $el: (i3) => i3.vnode.el,
    $data: (i3) => i3.data,
    $props: (i3) => true ? shallowReadonly(i3.props) : i3.props,
    $attrs: (i3) => true ? shallowReadonly(i3.attrs) : i3.attrs,
    $slots: (i3) => true ? shallowReadonly(i3.slots) : i3.slots,
    $refs: (i3) => true ? shallowReadonly(i3.refs) : i3.refs,
    $parent: (i3) => getPublicInstance(i3.parent),
    $root: (i3) => getPublicInstance(i3.root),
    $emit: (i3) => i3.emit,
    $options: (i3) => true ? resolveMergedOptions(i3) : i3.type,
    $forceUpdate: (i3) => () => queueJob2(i3.update),
    $nextTick: (i3) => nextTick3.bind(i3.proxy),
    $watch: (i3) => true ? instanceWatch.bind(i3) : NOOP
  });
  var PublicInstanceProxyHandlers = {
    get({ _: instance }, key) {
      const { ctx, setupState, data: data2, props, accessCache, type, appContext } = instance;
      if (key === "__isVue") {
        return true;
      }
      if (setupState !== EMPTY_OBJ2 && setupState.__isScriptSetup && hasOwn2(setupState, key)) {
        return setupState[key];
      }
      let normalizedProps;
      if (key[0] !== "$") {
        const n3 = accessCache[key];
        if (n3 !== void 0) {
          switch (n3) {
            case 0:
              return setupState[key];
            case 1:
              return data2[key];
            case 3:
              return ctx[key];
            case 2:
              return props[key];
          }
        } else if (setupState !== EMPTY_OBJ2 && hasOwn2(setupState, key)) {
          accessCache[key] = 0;
          return setupState[key];
        } else if (data2 !== EMPTY_OBJ2 && hasOwn2(data2, key)) {
          accessCache[key] = 1;
          return data2[key];
        } else if ((normalizedProps = instance.propsOptions[0]) && hasOwn2(normalizedProps, key)) {
          accessCache[key] = 2;
          return props[key];
        } else if (ctx !== EMPTY_OBJ2 && hasOwn2(ctx, key)) {
          accessCache[key] = 3;
          return ctx[key];
        } else if (shouldCacheAccess) {
          accessCache[key] = 4;
        }
      }
      const publicGetter = publicPropertiesMap[key];
      let cssModule, globalProperties;
      if (publicGetter) {
        if (key === "$attrs") {
          track2(instance, "get", key);
          markAttrsAccessed();
        }
        return publicGetter(instance);
      } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) {
        return cssModule;
      } else if (ctx !== EMPTY_OBJ2 && hasOwn2(ctx, key)) {
        accessCache[key] = 3;
        return ctx[key];
      } else if (globalProperties = appContext.config.globalProperties, hasOwn2(globalProperties, key)) {
        {
          return globalProperties[key];
        }
      } else if (currentRenderingInstance && (!isString2(key) || key.indexOf("__v") !== 0)) {
        if (data2 !== EMPTY_OBJ2 && (key[0] === "$" || key[0] === "_") && hasOwn2(data2, key)) {
          warn3(`Property ${JSON.stringify(key)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`);
        } else if (instance === currentRenderingInstance) {
          warn3(`Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`);
        }
      }
    },
    set({ _: instance }, key, value) {
      const { data: data2, setupState, ctx } = instance;
      if (setupState !== EMPTY_OBJ2 && hasOwn2(setupState, key)) {
        setupState[key] = value;
      } else if (data2 !== EMPTY_OBJ2 && hasOwn2(data2, key)) {
        data2[key] = value;
      } else if (hasOwn2(instance.props, key)) {
        warn3(`Attempting to mutate prop "${key}". Props are readonly.`, instance);
        return false;
      }
      if (key[0] === "$" && key.slice(1) in instance) {
        warn3(`Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`, instance);
        return false;
      } else {
        if (key in instance.appContext.config.globalProperties) {
          Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            value
          });
        } else {
          ctx[key] = value;
        }
      }
      return true;
    },
    has({ _: { data: data2, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
      let normalizedProps;
      return accessCache[key] !== void 0 || data2 !== EMPTY_OBJ2 && hasOwn2(data2, key) || setupState !== EMPTY_OBJ2 && hasOwn2(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn2(normalizedProps, key) || hasOwn2(ctx, key) || hasOwn2(publicPropertiesMap, key) || hasOwn2(appContext.config.globalProperties, key);
    }
  };
  if (true) {
    PublicInstanceProxyHandlers.ownKeys = (target) => {
      warn3(`Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`);
      return Reflect.ownKeys(target);
    };
  }
  function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
      configurable: true,
      enumerable: false,
      get: () => instance
    });
    Object.keys(publicPropertiesMap).forEach((key) => {
      Object.defineProperty(target, key, {
        configurable: true,
        enumerable: false,
        get: () => publicPropertiesMap[key](instance),
        set: NOOP
      });
    });
    return target;
  }
  function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) {
      Object.keys(propsOptions).forEach((key) => {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => instance.props[key],
          set: NOOP
        });
      });
    }
  }
  function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys(toRaw2(setupState)).forEach((key) => {
      if (!setupState.__isScriptSetup) {
        if (key[0] === "$" || key[0] === "_") {
          warn3(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
          return;
        }
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => setupState[key],
          set: NOOP
        });
      }
    });
  }
  var emptyAppContext = createAppContext();
  var uid$1 = 0;
  function createComponentInstance(vnode, parent2, suspense) {
    const type = vnode.type;
    const appContext = (parent2 ? parent2.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
      uid: uid$1++,
      vnode,
      type,
      parent: parent2,
      appContext,
      root: null,
      next: null,
      subTree: null,
      update: null,
      scope: new EffectScope(true),
      render: null,
      proxy: null,
      exposed: null,
      exposeProxy: null,
      withProxy: null,
      provides: parent2 ? parent2.provides : Object.create(appContext.provides),
      accessCache: null,
      renderCache: [],
      components: null,
      directives: null,
      propsOptions: normalizePropsOptions(type, appContext),
      emitsOptions: normalizeEmitsOptions(type, appContext),
      emit: null,
      emitted: null,
      propsDefaults: EMPTY_OBJ2,
      inheritAttrs: type.inheritAttrs,
      ctx: EMPTY_OBJ2,
      data: EMPTY_OBJ2,
      props: EMPTY_OBJ2,
      attrs: EMPTY_OBJ2,
      slots: EMPTY_OBJ2,
      refs: EMPTY_OBJ2,
      setupState: EMPTY_OBJ2,
      setupContext: null,
      suspense,
      suspenseId: suspense ? suspense.pendingId : 0,
      asyncDep: null,
      asyncResolved: false,
      isMounted: false,
      isUnmounted: false,
      isDeactivated: false,
      bc: null,
      c: null,
      bm: null,
      m: null,
      bu: null,
      u: null,
      um: null,
      bum: null,
      da: null,
      a: null,
      rtg: null,
      rtc: null,
      ec: null,
      sp: null
    };
    if (true) {
      instance.ctx = createDevRenderContext(instance);
    } else {
      instance.ctx = { _: instance };
    }
    instance.root = parent2 ? parent2.root : instance;
    instance.emit = emit$1.bind(null, instance);
    if (vnode.ce) {
      vnode.ce(instance);
    }
    return instance;
  }
  var currentInstance = null;
  var getCurrentInstance = () => currentInstance || currentRenderingInstance;
  var setCurrentInstance = (instance) => {
    currentInstance = instance;
    instance.scope.on();
  };
  var unsetCurrentInstance = () => {
    currentInstance && currentInstance.scope.off();
    currentInstance = null;
  };
  var isBuiltInTag = /* @__PURE__ */ makeMap2("slot,component");
  function validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || NO;
    if (isBuiltInTag(name) || appIsNativeTag(name)) {
      warn3("Do not use built-in or reserved HTML elements as component id: " + name);
    }
  }
  function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
  }
  var isInSSRComponentSetup = false;
  function setupComponent(instance, isSSR = false) {
    isInSSRComponentSetup = isSSR;
    const { props, children: children2 } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children2);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isInSSRComponentSetup = false;
    return setupResult;
  }
  function setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    if (true) {
      if (Component.name) {
        validateComponentName(Component.name, instance.appContext.config);
      }
      if (Component.components) {
        const names = Object.keys(Component.components);
        for (let i3 = 0; i3 < names.length; i3++) {
          validateComponentName(names[i3], instance.appContext.config);
        }
      }
      if (Component.directives) {
        const names = Object.keys(Component.directives);
        for (let i3 = 0; i3 < names.length; i3++) {
          validateDirectiveName(names[i3]);
        }
      }
      if (Component.compilerOptions && isRuntimeOnly()) {
        warn3(`"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`);
      }
    }
    instance.accessCache = Object.create(null);
    instance.proxy = markRaw(new Proxy(instance.ctx, PublicInstanceProxyHandlers));
    if (true) {
      exposePropsOnRenderContext(instance);
    }
    const { setup } = Component;
    if (setup) {
      const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
      setCurrentInstance(instance);
      pauseTracking2();
      const setupResult = callWithErrorHandling(setup, instance, 0, [true ? shallowReadonly(instance.props) : instance.props, setupContext]);
      resetTracking2();
      unsetCurrentInstance();
      if (isPromise(setupResult)) {
        setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
        if (isSSR) {
          return setupResult.then((resolvedResult) => {
            handleSetupResult(instance, resolvedResult, isSSR);
          }).catch((e2) => {
            handleError2(e2, instance, 0);
          });
        } else {
          instance.asyncDep = setupResult;
        }
      } else {
        handleSetupResult(instance, setupResult, isSSR);
      }
    } else {
      finishComponentSetup(instance, isSSR);
    }
  }
  function handleSetupResult(instance, setupResult, isSSR) {
    if (isFunction(setupResult)) {
      if (instance.type.__ssrInlineRender) {
        instance.ssrRender = setupResult;
      } else {
        instance.render = setupResult;
      }
    } else if (isObject4(setupResult)) {
      if (isVNode(setupResult)) {
        warn3(`setup() should not return VNodes directly - return a render function instead.`);
      }
      if (true) {
        instance.devtoolsRawSetupState = setupResult;
      }
      instance.setupState = proxyRefs(setupResult);
      if (true) {
        exposeSetupStateOnRenderContext(instance);
      }
    } else if (setupResult !== void 0) {
      warn3(`setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`);
    }
    finishComponentSetup(instance, isSSR);
  }
  var compile;
  var installWithProxy;
  var isRuntimeOnly = () => !compile;
  function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
      if (!isSSR && compile && !Component.render) {
        const template = Component.template;
        if (template) {
          if (true) {
            startMeasure(instance, `compile`);
          }
          const { isCustomElement, compilerOptions } = instance.appContext.config;
          const { delimiters, compilerOptions: componentCompilerOptions } = Component;
          const finalCompilerOptions = extend4(extend4({
            isCustomElement,
            delimiters
          }, compilerOptions), componentCompilerOptions);
          Component.render = compile(template, finalCompilerOptions);
          if (true) {
            endMeasure(instance, `compile`);
          }
        }
      }
      instance.render = Component.render || NOOP;
      if (installWithProxy) {
        installWithProxy(instance);
      }
    }
    if (true) {
      setCurrentInstance(instance);
      pauseTracking2();
      applyOptions(instance);
      resetTracking2();
      unsetCurrentInstance();
    }
    if (!Component.render && instance.render === NOOP && !isSSR) {
      if (!compile && Component.template) {
        warn3(`Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
      } else {
        warn3(`Component is missing template or render function.`);
      }
    }
  }
  function createAttrsProxy(instance) {
    return new Proxy(instance.attrs, true ? {
      get(target, key) {
        markAttrsAccessed();
        track2(instance, "get", "$attrs");
        return target[key];
      },
      set() {
        warn3(`setupContext.attrs is readonly.`);
        return false;
      },
      deleteProperty() {
        warn3(`setupContext.attrs is readonly.`);
        return false;
      }
    } : {
      get(target, key) {
        track2(instance, "get", "$attrs");
        return target[key];
      }
    });
  }
  function createSetupContext(instance) {
    const expose = (exposed) => {
      if (instance.exposed) {
        warn3(`expose() should be called only once per setup().`);
      }
      instance.exposed = exposed || {};
    };
    let attrs;
    if (true) {
      return Object.freeze({
        get attrs() {
          return attrs || (attrs = createAttrsProxy(instance));
        },
        get slots() {
          return shallowReadonly(instance.slots);
        },
        get emit() {
          return (event2, ...args) => instance.emit(event2, ...args);
        },
        expose
      });
    } else {
      return {
        get attrs() {
          return attrs || (attrs = createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose
      };
    }
  }
  function getExposeProxy(instance) {
    if (instance.exposed) {
      return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
        get(target, key) {
          if (key in target) {
            return target[key];
          } else if (key in publicPropertiesMap) {
            return publicPropertiesMap[key](instance);
          }
        }
      }));
    }
  }
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = (str) => str.replace(classifyRE, (c4) => c4.toUpperCase()).replace(/[-_]/g, "");
  function getComponentName(Component) {
    return isFunction(Component) ? Component.displayName || Component.name : Component.name;
  }
  function formatComponentName(instance, Component, isRoot2 = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
      const match = Component.__file.match(/([^/\\]+)\.\w+$/);
      if (match) {
        name = match[1];
      }
    }
    if (!name && instance && instance.parent) {
      const inferFromRegistry = (registry) => {
        for (const key in registry) {
          if (registry[key] === Component) {
            return key;
          }
        }
      };
      name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot2 ? `App` : `Anonymous`;
  }
  function isClassComponent(value) {
    return isFunction(value) && "__vccOpts" in value;
  }
  var stack = [];
  function pushWarningContext(vnode) {
    stack.push(vnode);
  }
  function popWarningContext() {
    stack.pop();
  }
  function warn3(msg, ...args) {
    pauseTracking2();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) {
      callWithErrorHandling(appWarnHandler, instance, 11, [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
      ]);
    } else {
      const warnArgs = [`[Vue warn]: ${msg}`, ...args];
      if (trace.length && true) {
        warnArgs.push(`
`, ...formatTrace(trace));
      }
      console.warn(...warnArgs);
    }
    resetTracking2();
  }
  function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
      return [];
    }
    const normalizedStack = [];
    while (currentVNode) {
      const last = normalizedStack[0];
      if (last && last.vnode === currentVNode) {
        last.recurseCount++;
      } else {
        normalizedStack.push({
          vnode: currentVNode,
          recurseCount: 0
        });
      }
      const parentInstance = currentVNode.component && currentVNode.component.parent;
      currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
  }
  function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i3) => {
      logs.push(...i3 === 0 ? [] : [`
`], ...formatTraceEntry(entry));
    });
    return logs;
  }
  function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot2 = vnode.component ? vnode.component.parent == null : false;
    const open2 = ` at <${formatComponentName(vnode.component, vnode.type, isRoot2)}`;
    const close = `>` + postfix;
    return vnode.props ? [open2, ...formatProps(vnode.props), close] : [open2 + close];
  }
  function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key) => {
      res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) {
      res.push(` ...`);
    }
    return res;
  }
  function formatProp(key, value, raw2) {
    if (isString2(value)) {
      value = JSON.stringify(value);
      return raw2 ? value : [`${key}=${value}`];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
      return raw2 ? value : [`${key}=${value}`];
    } else if (isRef2(value)) {
      value = formatProp(key, toRaw2(value.value), true);
      return raw2 ? value : [`${key}=Ref<`, value, `>`];
    } else if (isFunction(value)) {
      return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
    } else {
      value = toRaw2(value);
      return raw2 ? value : [`${key}=`, value];
    }
  }
  var ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/vue-next"
  };
  function callWithErrorHandling(fn, instance, type, args) {
    let res;
    try {
      res = args ? fn(...args) : fn();
    } catch (err) {
      handleError2(err, instance, type);
    }
    return res;
  }
  function callWithAsyncErrorHandling(fn, instance, type, args) {
    if (isFunction(fn)) {
      const res = callWithErrorHandling(fn, instance, type, args);
      if (res && isPromise(res)) {
        res.catch((err) => {
          handleError2(err, instance, type);
        });
      }
      return res;
    }
    const values = [];
    for (let i3 = 0; i3 < fn.length; i3++) {
      values.push(callWithAsyncErrorHandling(fn[i3], instance, type, args));
    }
    return values;
  }
  function handleError2(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
      let cur = instance.parent;
      const exposedInstance = instance.proxy;
      const errorInfo = true ? ErrorTypeStrings[type] : type;
      while (cur) {
        const errorCapturedHooks = cur.ec;
        if (errorCapturedHooks) {
          for (let i3 = 0; i3 < errorCapturedHooks.length; i3++) {
            if (errorCapturedHooks[i3](err, exposedInstance, errorInfo) === false) {
              return;
            }
          }
        }
        cur = cur.parent;
      }
      const appErrorHandler = instance.appContext.config.errorHandler;
      if (appErrorHandler) {
        callWithErrorHandling(appErrorHandler, null, 10, [err, exposedInstance, errorInfo]);
        return;
      }
    }
    logError(err, type, contextVNode, throwInDev);
  }
  function logError(err, type, contextVNode, throwInDev = true) {
    if (true) {
      const info = ErrorTypeStrings[type];
      if (contextVNode) {
        pushWarningContext(contextVNode);
      }
      warn3(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
      if (contextVNode) {
        popWarningContext();
      }
      if (throwInDev) {
        throw err;
      } else {
        console.error(err);
      }
    } else {
      console.error(err);
    }
  }
  var isFlushing = false;
  var isFlushPending = false;
  var queue2 = [];
  var flushIndex = 0;
  var pendingPreFlushCbs = [];
  var activePreFlushCbs = null;
  var preFlushIndex = 0;
  var pendingPostFlushCbs = [];
  var activePostFlushCbs = null;
  var postFlushIndex = 0;
  var resolvedPromise = Promise.resolve();
  var currentFlushPromise = null;
  var currentPreFlushParentJob = null;
  var RECURSION_LIMIT = 100;
  function nextTick3(fn) {
    const p4 = currentFlushPromise || resolvedPromise;
    return fn ? p4.then(this ? fn.bind(this) : fn) : p4;
  }
  function findInsertionIndex(id) {
    let start2 = flushIndex + 1;
    let end = queue2.length;
    while (start2 < end) {
      const middle = start2 + end >>> 1;
      const middleJobId = getId(queue2[middle]);
      middleJobId < id ? start2 = middle + 1 : end = middle;
    }
    return start2;
  }
  function queueJob2(job) {
    if ((!queue2.length || !queue2.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) && job !== currentPreFlushParentJob) {
      if (job.id == null) {
        queue2.push(job);
      } else {
        queue2.splice(findInsertionIndex(job.id), 0, job);
      }
      queueFlush2();
    }
  }
  function queueFlush2() {
    if (!isFlushing && !isFlushPending) {
      isFlushPending = true;
      currentFlushPromise = resolvedPromise.then(flushJobs2);
    }
  }
  function invalidateJob(job) {
    const i3 = queue2.indexOf(job);
    if (i3 > flushIndex) {
      queue2.splice(i3, 1);
    }
  }
  function queueCb(cb, activeQueue, pendingQueue, index3) {
    if (!isArray2(cb)) {
      if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index3 + 1 : index3)) {
        pendingQueue.push(cb);
      }
    } else {
      pendingQueue.push(...cb);
    }
    queueFlush2();
  }
  function queuePreFlushCb(cb) {
    queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
  }
  function queuePostFlushCb(cb) {
    queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
  }
  function flushPreFlushCbs(seen, parentJob = null) {
    if (pendingPreFlushCbs.length) {
      currentPreFlushParentJob = parentJob;
      activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
      pendingPreFlushCbs.length = 0;
      if (true) {
        seen = seen || new Map();
      }
      for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
        if (checkRecursiveUpdates(seen, activePreFlushCbs[preFlushIndex])) {
          continue;
        }
        activePreFlushCbs[preFlushIndex]();
      }
      activePreFlushCbs = null;
      preFlushIndex = 0;
      currentPreFlushParentJob = null;
      flushPreFlushCbs(seen, parentJob);
    }
  }
  function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
      const deduped = [...new Set(pendingPostFlushCbs)];
      pendingPostFlushCbs.length = 0;
      if (activePostFlushCbs) {
        activePostFlushCbs.push(...deduped);
        return;
      }
      activePostFlushCbs = deduped;
      if (true) {
        seen = seen || new Map();
      }
      activePostFlushCbs.sort((a3, b2) => getId(a3) - getId(b2));
      for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
        if (checkRecursiveUpdates(seen, activePostFlushCbs[postFlushIndex])) {
          continue;
        }
        activePostFlushCbs[postFlushIndex]();
      }
      activePostFlushCbs = null;
      postFlushIndex = 0;
    }
  }
  var getId = (job) => job.id == null ? Infinity : job.id;
  function flushJobs2(seen) {
    isFlushPending = false;
    isFlushing = true;
    if (true) {
      seen = seen || new Map();
    }
    flushPreFlushCbs(seen);
    queue2.sort((a3, b2) => getId(a3) - getId(b2));
    const check = true ? (job) => checkRecursiveUpdates(seen, job) : NOOP;
    try {
      for (flushIndex = 0; flushIndex < queue2.length; flushIndex++) {
        const job = queue2[flushIndex];
        if (job && job.active !== false) {
          if (check(job)) {
            continue;
          }
          callWithErrorHandling(job, null, 14);
        }
      }
    } finally {
      flushIndex = 0;
      queue2.length = 0;
      flushPostFlushCbs(seen);
      isFlushing = false;
      currentFlushPromise = null;
      if (queue2.length || pendingPreFlushCbs.length || pendingPostFlushCbs.length) {
        flushJobs2(seen);
      }
    }
  }
  function checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) {
      seen.set(fn, 1);
    } else {
      const count = seen.get(fn);
      if (count > RECURSION_LIMIT) {
        const instance = fn.ownerInstance;
        const componentName = instance && getComponentName(instance.type);
        warn3(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
        return true;
      } else {
        seen.set(fn, count + 1);
      }
    }
  }
  var INITIAL_WATCHER_VALUE = {};
  function watch(source, cb, options) {
    if (!isFunction(cb)) {
      warn3(`\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`);
    }
    return doWatch(source, cb, options);
  }
  function doWatch(source, cb, { immediate, deep, flush, onTrack, onTrigger } = EMPTY_OBJ2) {
    if (!cb) {
      if (immediate !== void 0) {
        warn3(`watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`);
      }
      if (deep !== void 0) {
        warn3(`watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`);
      }
    }
    const warnInvalidSource = (s3) => {
      warn3(`Invalid watch source: `, s3, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef2(source)) {
      getter = () => source.value;
      forceTrigger = !!source._shallow;
    } else if (isReactive2(source)) {
      getter = () => source;
      deep = true;
    } else if (isArray2(source)) {
      isMultiSource = true;
      forceTrigger = source.some(isReactive2);
      getter = () => source.map((s3) => {
        if (isRef2(s3)) {
          return s3.value;
        } else if (isReactive2(s3)) {
          return traverse(s3);
        } else if (isFunction(s3)) {
          return callWithErrorHandling(s3, instance, 2);
        } else {
          warnInvalidSource(s3);
        }
      });
    } else if (isFunction(source)) {
      if (cb) {
        getter = () => callWithErrorHandling(source, instance, 2);
      } else {
        getter = () => {
          if (instance && instance.isUnmounted) {
            return;
          }
          if (cleanup2) {
            cleanup2();
          }
          return callWithAsyncErrorHandling(source, instance, 3, [onInvalidate]);
        };
      }
    } else {
      getter = NOOP;
      warnInvalidSource(source);
    }
    if (cb && deep) {
      const baseGetter = getter;
      getter = () => traverse(baseGetter());
    }
    let cleanup2;
    let onInvalidate = (fn) => {
      cleanup2 = effect4.onStop = () => {
        callWithErrorHandling(fn, instance, 4);
      };
    };
    if (isInSSRComponentSetup) {
      onInvalidate = NOOP;
      if (!cb) {
        getter();
      } else if (immediate) {
        callWithAsyncErrorHandling(cb, instance, 3, [
          getter(),
          isMultiSource ? [] : void 0,
          onInvalidate
        ]);
      }
      return NOOP;
    }
    let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    const job = () => {
      if (!effect4.active) {
        return;
      }
      if (cb) {
        const newValue = effect4.run();
        if (deep || forceTrigger || (isMultiSource ? newValue.some((v3, i3) => hasChanged2(v3, oldValue[i3])) : hasChanged2(newValue, oldValue)) || false) {
          if (cleanup2) {
            cleanup2();
          }
          callWithAsyncErrorHandling(cb, instance, 3, [
            newValue,
            oldValue === INITIAL_WATCHER_VALUE ? void 0 : oldValue,
            onInvalidate
          ]);
          oldValue = newValue;
        }
      } else {
        effect4.run();
      }
    };
    job.allowRecurse = !!cb;
    let scheduler2;
    if (flush === "sync") {
      scheduler2 = job;
    } else if (flush === "post") {
      scheduler2 = () => queuePostRenderEffect(job, instance && instance.suspense);
    } else {
      scheduler2 = () => {
        if (!instance || instance.isMounted) {
          queuePreFlushCb(job);
        } else {
          job();
        }
      };
    }
    const effect4 = new ReactiveEffect(getter, scheduler2);
    if (true) {
      effect4.onTrack = onTrack;
      effect4.onTrigger = onTrigger;
    }
    if (cb) {
      if (immediate) {
        job();
      } else {
        oldValue = effect4.run();
      }
    } else if (flush === "post") {
      queuePostRenderEffect(effect4.run.bind(effect4), instance && instance.suspense);
    } else {
      effect4.run();
    }
    return () => {
      effect4.stop();
      if (instance && instance.scope) {
        remove2(instance.scope.effects, effect4);
      }
    };
  }
  function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = isString2(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if (isFunction(value)) {
      cb = value;
    } else {
      cb = value.handler;
      options = value;
    }
    const cur = currentInstance;
    setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    if (cur) {
      setCurrentInstance(cur);
    } else {
      unsetCurrentInstance();
    }
    return res;
  }
  function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return () => {
      let cur = ctx;
      for (let i3 = 0; i3 < segments.length && cur; i3++) {
        cur = cur[segments[i3]];
      }
      return cur;
    };
  }
  function traverse(value, seen) {
    if (!isObject4(value) || value["__v_skip"]) {
      return value;
    }
    seen = seen || new Set();
    if (seen.has(value)) {
      return value;
    }
    seen.add(value);
    if (isRef2(value)) {
      traverse(value.value, seen);
    } else if (isArray2(value)) {
      for (let i3 = 0; i3 < value.length; i3++) {
        traverse(value[i3], seen);
      }
    } else if (isSet(value) || isMap2(value)) {
      value.forEach((v3) => {
        traverse(v3, seen);
      });
    } else if (isPlainObject(value)) {
      for (const key in value) {
        traverse(value[key], seen);
      }
    }
    return value;
  }
  function h(type, propsOrChildren, children2) {
    const l3 = arguments.length;
    if (l3 === 2) {
      if (isObject4(propsOrChildren) && !isArray2(propsOrChildren)) {
        if (isVNode(propsOrChildren)) {
          return createVNode(type, null, [propsOrChildren]);
        }
        return createVNode(type, propsOrChildren);
      } else {
        return createVNode(type, null, propsOrChildren);
      }
    } else {
      if (l3 > 3) {
        children2 = Array.prototype.slice.call(arguments, 2);
      } else if (l3 === 3 && isVNode(children2)) {
        children2 = [children2];
      }
      return createVNode(type, propsOrChildren, children2);
    }
  }
  var ssrContextKey = Symbol(true ? `ssrContext` : ``);
  function initCustomFormatter() {
    if (typeof window === "undefined") {
      return;
    }
    const vueStyle = { style: "color:#3ba776" };
    const numberStyle = { style: "color:#0b1bc9" };
    const stringStyle = { style: "color:#b62e24" };
    const keywordStyle = { style: "color:#9d288c" };
    const formatter = {
      header(obj) {
        if (!isObject4(obj)) {
          return null;
        }
        if (obj.__isVue) {
          return ["div", vueStyle, `VueInstance`];
        } else if (isRef2(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, genRefFlag(obj)],
            "<",
            formatValue(obj.value),
            `>`
          ];
        } else if (isReactive2(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, "Reactive"],
            "<",
            formatValue(obj),
            `>${isReadonly(obj) ? ` (readonly)` : ``}`
          ];
        } else if (isReadonly(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, "Readonly"],
            "<",
            formatValue(obj),
            ">"
          ];
        }
        return null;
      },
      hasBody(obj) {
        return obj && obj.__isVue;
      },
      body(obj) {
        if (obj && obj.__isVue) {
          return [
            "div",
            {},
            ...formatInstance(obj.$)
          ];
        }
      }
    };
    function formatInstance(instance) {
      const blocks = [];
      if (instance.type.props && instance.props) {
        blocks.push(createInstanceBlock("props", toRaw2(instance.props)));
      }
      if (instance.setupState !== EMPTY_OBJ2) {
        blocks.push(createInstanceBlock("setup", instance.setupState));
      }
      if (instance.data !== EMPTY_OBJ2) {
        blocks.push(createInstanceBlock("data", toRaw2(instance.data)));
      }
      const computed2 = extractKeys(instance, "computed");
      if (computed2) {
        blocks.push(createInstanceBlock("computed", computed2));
      }
      const injected = extractKeys(instance, "inject");
      if (injected) {
        blocks.push(createInstanceBlock("injected", injected));
      }
      blocks.push([
        "div",
        {},
        [
          "span",
          {
            style: keywordStyle.style + ";opacity:0.66"
          },
          "$ (internal): "
        ],
        ["object", { object: instance }]
      ]);
      return blocks;
    }
    function createInstanceBlock(type, target) {
      target = extend4({}, target);
      if (!Object.keys(target).length) {
        return ["span", {}];
      }
      return [
        "div",
        { style: "line-height:1.25em;margin-bottom:0.6em" },
        [
          "div",
          {
            style: "color:#476582"
          },
          type
        ],
        [
          "div",
          {
            style: "padding-left:1.25em"
          },
          ...Object.keys(target).map((key) => {
            return [
              "div",
              {},
              ["span", keywordStyle, key + ": "],
              formatValue(target[key], false)
            ];
          })
        ]
      ];
    }
    function formatValue(v3, asRaw = true) {
      if (typeof v3 === "number") {
        return ["span", numberStyle, v3];
      } else if (typeof v3 === "string") {
        return ["span", stringStyle, JSON.stringify(v3)];
      } else if (typeof v3 === "boolean") {
        return ["span", keywordStyle, v3];
      } else if (isObject4(v3)) {
        return ["object", { object: asRaw ? toRaw2(v3) : v3 }];
      } else {
        return ["span", stringStyle, String(v3)];
      }
    }
    function extractKeys(instance, type) {
      const Comp = instance.type;
      if (isFunction(Comp)) {
        return;
      }
      const extracted = {};
      for (const key in instance.ctx) {
        if (isKeyOfType(Comp, key, type)) {
          extracted[key] = instance.ctx[key];
        }
      }
      return extracted;
    }
    function isKeyOfType(Comp, key, type) {
      const opts = Comp[type];
      if (isArray2(opts) && opts.includes(key) || isObject4(opts) && key in opts) {
        return true;
      }
      if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
        return true;
      }
      if (Comp.mixins && Comp.mixins.some((m4) => isKeyOfType(m4, key, type))) {
        return true;
      }
    }
    function genRefFlag(v3) {
      if (v3._shallow) {
        return `ShallowRef`;
      }
      if (v3.effect) {
        return `ComputedRef`;
      }
      return `Ref`;
    }
    if (window.devtoolsFormatters) {
      window.devtoolsFormatters.push(formatter);
    } else {
      window.devtoolsFormatters = [formatter];
    }
  }
  var version = "3.2.22";

  // node_modules/@vue/runtime-dom/node_modules/@vue/shared/dist/shared.esm-bundler.js
  function makeMap3(str, expectsLowerCase) {
    const map2 = Object.create(null);
    const list = str.split(",");
    for (let i3 = 0; i3 < list.length; i3++) {
      map2[list[i3]] = true;
    }
    return expectsLowerCase ? (val) => !!map2[val.toLowerCase()] : (val) => !!map2[val];
  }
  var PatchFlagNames3 = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
  };
  var slotFlagsText3 = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
  };
  var specialBooleanAttrs3 = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isSpecialBooleanAttr = /* @__PURE__ */ makeMap3(specialBooleanAttrs3);
  var isBooleanAttr4 = /* @__PURE__ */ makeMap3(specialBooleanAttrs3 + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
  function includeBooleanAttr(value) {
    return !!value || value === "";
  }
  var HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
  var SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
  var isHTMLTag = /* @__PURE__ */ makeMap3(HTML_TAGS);
  var isSVGTag = /* @__PURE__ */ makeMap3(SVG_TAGS);
  function looseCompareArrays(a3, b2) {
    if (a3.length !== b2.length)
      return false;
    let equal = true;
    for (let i3 = 0; equal && i3 < a3.length; i3++) {
      equal = looseEqual(a3[i3], b2[i3]);
    }
    return equal;
  }
  function looseEqual(a3, b2) {
    if (a3 === b2)
      return true;
    let aValidType = isDate(a3);
    let bValidType = isDate(b2);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? a3.getTime() === b2.getTime() : false;
    }
    aValidType = isArray3(a3);
    bValidType = isArray3(b2);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? looseCompareArrays(a3, b2) : false;
    }
    aValidType = isObject5(a3);
    bValidType = isObject5(b2);
    if (aValidType || bValidType) {
      if (!aValidType || !bValidType) {
        return false;
      }
      const aKeysCount = Object.keys(a3).length;
      const bKeysCount = Object.keys(b2).length;
      if (aKeysCount !== bKeysCount) {
        return false;
      }
      for (const key in a3) {
        const aHasKey = a3.hasOwnProperty(key);
        const bHasKey = b2.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a3[key], b2[key])) {
          return false;
        }
      }
    }
    return String(a3) === String(b2);
  }
  function looseIndexOf(arr, val) {
    return arr.findIndex((item) => looseEqual(item, val));
  }
  var EMPTY_OBJ3 = true ? Object.freeze({}) : {};
  var EMPTY_ARR3 = true ? Object.freeze([]) : [];
  var onRE2 = /^on[^a-z]/;
  var isOn2 = (key) => onRE2.test(key);
  var isModelListener2 = (key) => key.startsWith("onUpdate:");
  var extend5 = Object.assign;
  var isArray3 = Array.isArray;
  var isSet2 = (val) => toTypeString3(val) === "[object Set]";
  var isDate = (val) => val instanceof Date;
  var isFunction2 = (val) => typeof val === "function";
  var isString3 = (val) => typeof val === "string";
  var isObject5 = (val) => val !== null && typeof val === "object";
  var objectToString3 = Object.prototype.toString;
  var toTypeString3 = (value) => objectToString3.call(value);
  var cacheStringFunction3 = (fn) => {
    const cache = Object.create(null);
    return (str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  };
  var camelizeRE3 = /-(\w)/g;
  var camelize3 = cacheStringFunction3((str) => {
    return str.replace(camelizeRE3, (_3, c4) => c4 ? c4.toUpperCase() : "");
  });
  var hyphenateRE3 = /\B([A-Z])/g;
  var hyphenate3 = cacheStringFunction3((str) => str.replace(hyphenateRE3, "-$1").toLowerCase());
  var capitalize3 = cacheStringFunction3((str) => str.charAt(0).toUpperCase() + str.slice(1));
  var toHandlerKey3 = cacheStringFunction3((str) => str ? `on${capitalize3(str)}` : ``);
  var invokeArrayFns2 = (fns, arg) => {
    for (let i3 = 0; i3 < fns.length; i3++) {
      fns[i3](arg);
    }
  };
  var toNumber2 = (val) => {
    const n3 = parseFloat(val);
    return isNaN(n3) ? val : n3;
  };

  // node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
  var svgNS = "http://www.w3.org/2000/svg";
  var doc = typeof document !== "undefined" ? document : null;
  var staticTemplateCache = new Map();
  var nodeOps = {
    insert: (child, parent2, anchor) => {
      parent2.insertBefore(child, anchor || null);
    },
    remove: (child) => {
      const parent2 = child.parentNode;
      if (parent2) {
        parent2.removeChild(child);
      }
    },
    createElement: (tag, isSVG, is2, props) => {
      const el = isSVG ? doc.createElementNS(svgNS, tag) : doc.createElement(tag, is2 ? { is: is2 } : void 0);
      if (tag === "select" && props && props.multiple != null) {
        el.setAttribute("multiple", props.multiple);
      }
      return el;
    },
    createText: (text2) => doc.createTextNode(text2),
    createComment: (text2) => doc.createComment(text2),
    setText: (node2, text2) => {
      node2.nodeValue = text2;
    },
    setElementText: (el, text2) => {
      el.textContent = text2;
    },
    parentNode: (node2) => node2.parentNode,
    nextSibling: (node2) => node2.nextSibling,
    querySelector: (selector) => doc.querySelector(selector),
    setScopeId(el, id) {
      el.setAttribute(id, "");
    },
    cloneNode(el) {
      const cloned = el.cloneNode(true);
      if (`_value` in el) {
        cloned._value = el._value;
      }
      return cloned;
    },
    insertStaticContent(content, parent2, anchor, isSVG) {
      const before = anchor ? anchor.previousSibling : parent2.lastChild;
      let template = staticTemplateCache.get(content);
      if (!template) {
        const t3 = doc.createElement("template");
        t3.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
        template = t3.content;
        if (isSVG) {
          const wrapper = template.firstChild;
          while (wrapper.firstChild) {
            template.appendChild(wrapper.firstChild);
          }
          template.removeChild(wrapper);
        }
        staticTemplateCache.set(content, template);
      }
      parent2.insertBefore(template.cloneNode(true), anchor);
      return [
        before ? before.nextSibling : parent2.firstChild,
        anchor ? anchor.previousSibling : parent2.lastChild
      ];
    }
  };
  function patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) {
      value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
    }
    if (value == null) {
      el.removeAttribute("class");
    } else if (isSVG) {
      el.setAttribute("class", value);
    } else {
      el.className = value;
    }
  }
  function patchStyle(el, prev2, next2) {
    const style = el.style;
    const isCssString = isString3(next2);
    if (next2 && !isCssString) {
      for (const key in next2) {
        setStyle(style, key, next2[key]);
      }
      if (prev2 && !isString3(prev2)) {
        for (const key in prev2) {
          if (next2[key] == null) {
            setStyle(style, key, "");
          }
        }
      }
    } else {
      const currentDisplay = style.display;
      if (isCssString) {
        if (prev2 !== next2) {
          style.cssText = next2;
        }
      } else if (prev2) {
        el.removeAttribute("style");
      }
      if ("_vod" in el) {
        style.display = currentDisplay;
      }
    }
  }
  var importantRE = /\s*!important$/;
  function setStyle(style, name, val) {
    if (isArray3(val)) {
      val.forEach((v3) => setStyle(style, name, v3));
    } else {
      if (name.startsWith("--")) {
        style.setProperty(name, val);
      } else {
        const prefixed = autoPrefix(style, name);
        if (importantRE.test(val)) {
          style.setProperty(hyphenate3(prefixed), val.replace(importantRE, ""), "important");
        } else {
          style[prefixed] = val;
        }
      }
    }
  }
  var prefixes = ["Webkit", "Moz", "ms"];
  var prefixCache = {};
  function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) {
      return cached;
    }
    let name = camelize2(rawName);
    if (name !== "filter" && name in style) {
      return prefixCache[rawName] = name;
    }
    name = capitalize3(name);
    for (let i3 = 0; i3 < prefixes.length; i3++) {
      const prefixed = prefixes[i3] + name;
      if (prefixed in style) {
        return prefixCache[rawName] = prefixed;
      }
    }
    return rawName;
  }
  var xlinkNS = "http://www.w3.org/1999/xlink";
  function patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
      if (value == null) {
        el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      const isBoolean2 = isSpecialBooleanAttr(key);
      if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
        el.removeAttribute(key);
      } else {
        el.setAttribute(key, isBoolean2 ? "" : value);
      }
    }
  }
  function patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
      if (prevChildren) {
        unmountChildren(prevChildren, parentComponent, parentSuspense);
      }
      el[key] = value == null ? "" : value;
      return;
    }
    if (key === "value" && el.tagName !== "PROGRESS") {
      el._value = value;
      const newValue = value == null ? "" : value;
      if (el.value !== newValue) {
        el.value = newValue;
      }
      if (value == null) {
        el.removeAttribute(key);
      }
      return;
    }
    if (value === "" || value == null) {
      const type = typeof el[key];
      if (type === "boolean") {
        el[key] = includeBooleanAttr(value);
        return;
      } else if (value == null && type === "string") {
        el[key] = "";
        el.removeAttribute(key);
        return;
      } else if (type === "number") {
        try {
          el[key] = 0;
        } catch (_a3) {
        }
        el.removeAttribute(key);
        return;
      }
    }
    try {
      el[key] = value;
    } catch (e2) {
      if (true) {
        warn3(`Failed setting prop "${key}" on <${el.tagName.toLowerCase()}>: value ${value} is invalid.`, e2);
      }
    }
  }
  var _getNow = Date.now;
  var skipTimestampCheck = false;
  if (typeof window !== "undefined") {
    if (_getNow() > document.createEvent("Event").timeStamp) {
      _getNow = () => performance.now();
    }
    const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
    skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
  }
  var cachedNow = 0;
  var p = Promise.resolve();
  var reset = () => {
    cachedNow = 0;
  };
  var getNow = () => cachedNow || (p.then(reset), cachedNow = _getNow());
  function addEventListener(el, event2, handler4, options) {
    el.addEventListener(event2, handler4, options);
  }
  function removeEventListener(el, event2, handler4, options) {
    el.removeEventListener(event2, handler4, options);
  }
  function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
      existingInvoker.value = nextValue;
    } else {
      const [name, options] = parseName(rawName);
      if (nextValue) {
        const invoker = invokers[rawName] = createInvoker(nextValue, instance);
        addEventListener(el, name, invoker, options);
      } else if (existingInvoker) {
        removeEventListener(el, name, existingInvoker, options);
        invokers[rawName] = void 0;
      }
    }
  }
  var optionsModifierRE = /(?:Once|Passive|Capture)$/;
  function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
      options = {};
      let m4;
      while (m4 = name.match(optionsModifierRE)) {
        name = name.slice(0, name.length - m4[0].length);
        options[m4[0].toLowerCase()] = true;
      }
    }
    return [hyphenate3(name.slice(2)), options];
  }
  function createInvoker(initialValue, instance) {
    const invoker = (e2) => {
      const timeStamp = e2.timeStamp || _getNow();
      if (skipTimestampCheck || timeStamp >= invoker.attached - 1) {
        callWithAsyncErrorHandling(patchStopImmediatePropagation(e2, invoker.value), instance, 5, [e2]);
      }
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
  }
  function patchStopImmediatePropagation(e2, value) {
    if (isArray3(value)) {
      const originalStop = e2.stopImmediatePropagation;
      e2.stopImmediatePropagation = () => {
        originalStop.call(e2);
        e2._stopped = true;
      };
      return value.map((fn) => (e3) => !e3._stopped && fn(e3));
    } else {
      return value;
    }
  }
  var nativeOnRE = /^on[a-z]/;
  var patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
    if (key === "class") {
      patchClass(el, nextValue, isSVG);
    } else if (key === "style") {
      patchStyle(el, prevValue, nextValue);
    } else if (isOn2(key)) {
      if (!isModelListener2(key)) {
        patchEvent(el, key, prevValue, nextValue, parentComponent);
      }
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
      patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    } else {
      if (key === "true-value") {
        el._trueValue = nextValue;
      } else if (key === "false-value") {
        el._falseValue = nextValue;
      }
      patchAttr(el, key, nextValue, isSVG);
    }
  };
  function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
      if (key === "innerHTML" || key === "textContent") {
        return true;
      }
      if (key in el && nativeOnRE.test(key) && isFunction2(value)) {
        return true;
      }
      return false;
    }
    if (key === "spellcheck" || key === "draggable") {
      return false;
    }
    if (key === "form") {
      return false;
    }
    if (key === "list" && el.tagName === "INPUT") {
      return false;
    }
    if (key === "type" && el.tagName === "TEXTAREA") {
      return false;
    }
    if (nativeOnRE.test(key) && isString3(value)) {
      return false;
    }
    return key in el;
  }
  var TRANSITION = "transition";
  var ANIMATION = "animation";
  var Transition = (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots);
  Transition.displayName = "Transition";
  var DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
      type: Boolean,
      default: true
    },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
  };
  var TransitionPropsValidators = Transition.props = /* @__PURE__ */ extend5({}, BaseTransition.props, DOMTransitionPropsValidators);
  var callHook2 = (hook, args = []) => {
    if (isArray3(hook)) {
      hook.forEach((h4) => h4(...args));
    } else if (hook) {
      hook(...args);
    }
  };
  var hasExplicitCallback = (hook) => {
    return hook ? isArray3(hook) ? hook.some((h4) => h4.length > 1) : hook.length > 1 : false;
  };
  function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for (const key in rawProps) {
      if (!(key in DOMTransitionPropsValidators)) {
        baseProps[key] = rawProps[key];
      }
    }
    if (rawProps.css === false) {
      return baseProps;
    }
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done) => {
      removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
      removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
      done && done();
    };
    const finishLeave = (el, done) => {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
      done && done();
    };
    const makeEnterHook = (isAppear) => {
      return (el, done) => {
        const hook = isAppear ? onAppear : onEnter;
        const resolve3 = () => finishEnter(el, isAppear, done);
        callHook2(hook, [el, resolve3]);
        nextFrame(() => {
          removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
          addTransitionClass(el, isAppear ? appearToClass : enterToClass);
          if (!hasExplicitCallback(hook)) {
            whenTransitionEnds(el, type, enterDuration, resolve3);
          }
        });
      };
    };
    return extend5(baseProps, {
      onBeforeEnter(el) {
        callHook2(onBeforeEnter, [el]);
        addTransitionClass(el, enterFromClass);
        addTransitionClass(el, enterActiveClass);
      },
      onBeforeAppear(el) {
        callHook2(onBeforeAppear, [el]);
        addTransitionClass(el, appearFromClass);
        addTransitionClass(el, appearActiveClass);
      },
      onEnter: makeEnterHook(false),
      onAppear: makeEnterHook(true),
      onLeave(el, done) {
        const resolve3 = () => finishLeave(el, done);
        addTransitionClass(el, leaveFromClass);
        forceReflow();
        addTransitionClass(el, leaveActiveClass);
        nextFrame(() => {
          removeTransitionClass(el, leaveFromClass);
          addTransitionClass(el, leaveToClass);
          if (!hasExplicitCallback(onLeave)) {
            whenTransitionEnds(el, type, leaveDuration, resolve3);
          }
        });
        callHook2(onLeave, [el, resolve3]);
      },
      onEnterCancelled(el) {
        finishEnter(el, false);
        callHook2(onEnterCancelled, [el]);
      },
      onAppearCancelled(el) {
        finishEnter(el, true);
        callHook2(onAppearCancelled, [el]);
      },
      onLeaveCancelled(el) {
        finishLeave(el);
        callHook2(onLeaveCancelled, [el]);
      }
    });
  }
  function normalizeDuration(duration) {
    if (duration == null) {
      return null;
    } else if (isObject5(duration)) {
      return [NumberOf(duration.enter), NumberOf(duration.leave)];
    } else {
      const n3 = NumberOf(duration);
      return [n3, n3];
    }
  }
  function NumberOf(val) {
    const res = toNumber2(val);
    if (true)
      validateDuration(res);
    return res;
  }
  function validateDuration(val) {
    if (typeof val !== "number") {
      warn3(`<transition> explicit duration is not a valid number - got ${JSON.stringify(val)}.`);
    } else if (isNaN(val)) {
      warn3(`<transition> explicit duration is NaN - the duration expression might be incorrect.`);
    }
  }
  function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c4) => c4 && el.classList.add(c4));
    (el._vtc || (el._vtc = new Set())).add(cls);
  }
  function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c4) => c4 && el.classList.remove(c4));
    const { _vtc } = el;
    if (_vtc) {
      _vtc.delete(cls);
      if (!_vtc.size) {
        el._vtc = void 0;
      }
    }
  }
  function nextFrame(cb) {
    requestAnimationFrame(() => {
      requestAnimationFrame(cb);
    });
  }
  var endId = 0;
  function whenTransitionEnds(el, expectedType, explicitTimeout, resolve3) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = () => {
      if (id === el._endId) {
        resolve3();
      }
    };
    if (explicitTimeout) {
      return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) {
      return resolve3();
    }
    const endEvent = type + "end";
    let ended = 0;
    const end = () => {
      el.removeEventListener(endEvent, onEnd);
      resolveIfNotStale();
    };
    const onEnd = (e2) => {
      if (e2.target === el && ++ended >= propCount) {
        end();
      }
    };
    setTimeout(() => {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
  }
  function getTransitionInfo(el, expectedType) {
    const styles2 = window.getComputedStyle(el);
    const getStyleProperties = (key) => (styles2[key] || "").split(", ");
    const transitionDelays = getStyleProperties(TRANSITION + "Delay");
    const transitionDurations = getStyleProperties(TRANSITION + "Duration");
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(ANIMATION + "Delay");
    const animationDurations = getStyleProperties(ANIMATION + "Duration");
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(styles2[TRANSITION + "Property"]);
    return {
      type,
      timeout,
      propCount,
      hasTransform
    };
  }
  function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }
    return Math.max(...durations.map((d2, i3) => toMs(d2) + toMs(delays[i3])));
  }
  function toMs(s3) {
    return Number(s3.slice(0, -1).replace(",", ".")) * 1e3;
  }
  function forceReflow() {
    return document.body.offsetHeight;
  }
  var positionMap = new WeakMap();
  var newPositionMap = new WeakMap();
  var TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ extend5({}, TransitionPropsValidators, {
      tag: String,
      moveClass: String
    }),
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const state = useTransitionState();
      let prevChildren;
      let children2;
      onUpdated(() => {
        if (!prevChildren.length) {
          return;
        }
        const moveClass = props.moveClass || `${props.name || "v"}-move`;
        if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
          return;
        }
        prevChildren.forEach(callPendingCbs);
        prevChildren.forEach(recordPosition);
        const movedChildren = prevChildren.filter(applyTranslation);
        forceReflow();
        movedChildren.forEach((c4) => {
          const el = c4.el;
          const style = el.style;
          addTransitionClass(el, moveClass);
          style.transform = style.webkitTransform = style.transitionDuration = "";
          const cb = el._moveCb = (e2) => {
            if (e2 && e2.target !== el) {
              return;
            }
            if (!e2 || /transform$/.test(e2.propertyName)) {
              el.removeEventListener("transitionend", cb);
              el._moveCb = null;
              removeTransitionClass(el, moveClass);
            }
          };
          el.addEventListener("transitionend", cb);
        });
      });
      return () => {
        const rawProps = toRaw2(props);
        const cssTransitionProps = resolveTransitionProps(rawProps);
        let tag = rawProps.tag || Fragment;
        prevChildren = children2;
        children2 = slots.default ? getTransitionRawChildren(slots.default()) : [];
        for (let i3 = 0; i3 < children2.length; i3++) {
          const child = children2[i3];
          if (child.key != null) {
            setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
          } else if (true) {
            warn3(`<TransitionGroup> children must be keyed.`);
          }
        }
        if (prevChildren) {
          for (let i3 = 0; i3 < prevChildren.length; i3++) {
            const child = prevChildren[i3];
            setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
            positionMap.set(child, child.el.getBoundingClientRect());
          }
        }
        return createVNode(tag, null, children2);
      };
    }
  };
  var TransitionGroup = TransitionGroupImpl;
  function callPendingCbs(c4) {
    const el = c4.el;
    if (el._moveCb) {
      el._moveCb();
    }
    if (el._enterCb) {
      el._enterCb();
    }
  }
  function recordPosition(c4) {
    newPositionMap.set(c4, c4.el.getBoundingClientRect());
  }
  function applyTranslation(c4) {
    const oldPos = positionMap.get(c4);
    const newPos = newPositionMap.get(c4);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
      const s3 = c4.el.style;
      s3.transform = s3.webkitTransform = `translate(${dx}px,${dy}px)`;
      s3.transitionDuration = "0s";
      return c4;
    }
  }
  function hasCSSTransform(el, root, moveClass) {
    const clone2 = el.cloneNode();
    if (el._vtc) {
      el._vtc.forEach((cls) => {
        cls.split(/\s+/).forEach((c4) => c4 && clone2.classList.remove(c4));
      });
    }
    moveClass.split(/\s+/).forEach((c4) => c4 && clone2.classList.add(c4));
    clone2.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone2);
    const { hasTransform } = getTransitionInfo(clone2);
    container.removeChild(clone2);
    return hasTransform;
  }
  var getModelAssigner = (vnode) => {
    const fn = vnode.props["onUpdate:modelValue"];
    return isArray3(fn) ? (value) => invokeArrayFns2(fn, value) : fn;
  };
  function onCompositionStart(e2) {
    e2.target.composing = true;
  }
  function onCompositionEnd(e2) {
    const target = e2.target;
    if (target.composing) {
      target.composing = false;
      trigger4(target, "input");
    }
  }
  function trigger4(el, type) {
    const e2 = document.createEvent("HTMLEvents");
    e2.initEvent(type, true, true);
    el.dispatchEvent(e2);
  }
  var vModelText = {
    created(el, { modifiers: { lazy, trim: trim2, number } }, vnode) {
      el._assign = getModelAssigner(vnode);
      const castToNumber = number || vnode.props && vnode.props.type === "number";
      addEventListener(el, lazy ? "change" : "input", (e2) => {
        if (e2.target.composing)
          return;
        let domValue = el.value;
        if (trim2) {
          domValue = domValue.trim();
        } else if (castToNumber) {
          domValue = toNumber2(domValue);
        }
        el._assign(domValue);
      });
      if (trim2) {
        addEventListener(el, "change", () => {
          el.value = el.value.trim();
        });
      }
      if (!lazy) {
        addEventListener(el, "compositionstart", onCompositionStart);
        addEventListener(el, "compositionend", onCompositionEnd);
        addEventListener(el, "change", onCompositionEnd);
      }
    },
    mounted(el, { value }) {
      el.value = value == null ? "" : value;
    },
    beforeUpdate(el, { value, modifiers: { lazy, trim: trim2, number } }, vnode) {
      el._assign = getModelAssigner(vnode);
      if (el.composing)
        return;
      if (document.activeElement === el) {
        if (lazy) {
          return;
        }
        if (trim2 && el.value.trim() === value) {
          return;
        }
        if ((number || el.type === "number") && toNumber2(el.value) === value) {
          return;
        }
      }
      const newValue = value == null ? "" : value;
      if (el.value !== newValue) {
        el.value = newValue;
      }
    }
  };
  var vModelCheckbox = {
    deep: true,
    created(el, _3, vnode) {
      el._assign = getModelAssigner(vnode);
      addEventListener(el, "change", () => {
        const modelValue = el._modelValue;
        const elementValue = getValue(el);
        const checked = el.checked;
        const assign = el._assign;
        if (isArray3(modelValue)) {
          const index3 = looseIndexOf(modelValue, elementValue);
          const found = index3 !== -1;
          if (checked && !found) {
            assign(modelValue.concat(elementValue));
          } else if (!checked && found) {
            const filtered = [...modelValue];
            filtered.splice(index3, 1);
            assign(filtered);
          }
        } else if (isSet2(modelValue)) {
          const cloned = new Set(modelValue);
          if (checked) {
            cloned.add(elementValue);
          } else {
            cloned.delete(elementValue);
          }
          assign(cloned);
        } else {
          assign(getCheckboxValue(el, checked));
        }
      });
    },
    mounted: setChecked,
    beforeUpdate(el, binding, vnode) {
      el._assign = getModelAssigner(vnode);
      setChecked(el, binding, vnode);
    }
  };
  function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    if (isArray3(value)) {
      el.checked = looseIndexOf(value, vnode.props.value) > -1;
    } else if (isSet2(value)) {
      el.checked = value.has(vnode.props.value);
    } else if (value !== oldValue) {
      el.checked = looseEqual(value, getCheckboxValue(el, true));
    }
  }
  var vModelRadio = {
    created(el, { value }, vnode) {
      el.checked = looseEqual(value, vnode.props.value);
      el._assign = getModelAssigner(vnode);
      addEventListener(el, "change", () => {
        el._assign(getValue(el));
      });
    },
    beforeUpdate(el, { value, oldValue }, vnode) {
      el._assign = getModelAssigner(vnode);
      if (value !== oldValue) {
        el.checked = looseEqual(value, vnode.props.value);
      }
    }
  };
  function getValue(el) {
    return "_value" in el ? el._value : el.value;
  }
  function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
  }
  var systemModifiers = ["ctrl", "shift", "alt", "meta"];
  var modifierGuards = {
    stop: (e2) => e2.stopPropagation(),
    prevent: (e2) => e2.preventDefault(),
    self: (e2) => e2.target !== e2.currentTarget,
    ctrl: (e2) => !e2.ctrlKey,
    shift: (e2) => !e2.shiftKey,
    alt: (e2) => !e2.altKey,
    meta: (e2) => !e2.metaKey,
    left: (e2) => "button" in e2 && e2.button !== 0,
    middle: (e2) => "button" in e2 && e2.button !== 1,
    right: (e2) => "button" in e2 && e2.button !== 2,
    exact: (e2, modifiers) => systemModifiers.some((m4) => e2[`${m4}Key`] && !modifiers.includes(m4))
  };
  var withModifiers = (fn, modifiers) => {
    return (event2, ...args) => {
      for (let i3 = 0; i3 < modifiers.length; i3++) {
        const guard = modifierGuards[modifiers[i3]];
        if (guard && guard(event2, modifiers))
          return;
      }
      return fn(event2, ...args);
    };
  };
  var rendererOptions = extend5({ patchProp }, nodeOps);
  var renderer;
  function ensureRenderer() {
    return renderer || (renderer = createRenderer(rendererOptions));
  }
  var createApp = (...args) => {
    const app = ensureRenderer().createApp(...args);
    if (true) {
      injectNativeTagCheck(app);
      injectCompilerOptionsCheck(app);
    }
    const { mount } = app;
    app.mount = (containerOrSelector) => {
      const container = normalizeContainer(containerOrSelector);
      if (!container)
        return;
      const component = app._component;
      if (!isFunction2(component) && !component.render && !component.template) {
        component.template = container.innerHTML;
      }
      container.innerHTML = "";
      const proxy = mount(container, false, container instanceof SVGElement);
      if (container instanceof Element) {
        container.removeAttribute("v-cloak");
        container.setAttribute("data-v-app", "");
      }
      return proxy;
    };
    return app;
  };
  function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
      value: (tag) => isHTMLTag(tag) || isSVGTag(tag),
      writable: false
    });
  }
  function injectCompilerOptionsCheck(app) {
    if (isRuntimeOnly()) {
      const isCustomElement = app.config.isCustomElement;
      Object.defineProperty(app.config, "isCustomElement", {
        get() {
          return isCustomElement;
        },
        set() {
          warn3(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
        }
      });
      const compilerOptions = app.config.compilerOptions;
      const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
      Object.defineProperty(app.config, "compilerOptions", {
        get() {
          warn3(msg);
          return compilerOptions;
        },
        set() {
          warn3(msg);
        }
      });
    }
  }
  function normalizeContainer(container) {
    if (isString3(container)) {
      const res = document.querySelector(container);
      if (!res) {
        warn3(`Failed to mount app: mount target selector "${container}" returned null.`);
      }
      return res;
    }
    if (window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") {
      warn3(`mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`);
    }
    return container;
  }

  // node_modules/vue/dist/vue.runtime.esm-bundler.js
  function initDev() {
    {
      initCustomFormatter();
    }
  }
  if (true) {
    initDev();
  }

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/Background.vue?type=script
  var Background_default = {
    name: "Background",
    props: {
      backgroundImage: Object,
      imageStack: Array,
      imageBase: String
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/Background.vue?type=template
  var _hoisted_1 = { class: "z-0 order-0 lg:absolute relative w-full lg:h-full lg:pb-0 md:pb-2/3 pb-4/5 inset-0" };
  var _hoisted_2 = { class: "absolute w-full h-full inset-0 z-0" };
  var _hoisted_3 = ["src"];
  var _hoisted_4 = ["src"];
  var _hoisted_5 = ["src", "alt"];
  function render(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1, [
      createBaseVNode("div", _hoisted_2, [
        createVNode(TransitionGroup, {
          name: "fade",
          mode: "out-in"
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.imageStack, (image) => {
              return openBlock(), createElementBlock("img", {
                key: image.url,
                loading: "lazy",
                src: image.url,
                style: normalizeStyle({ zIndex: image.order }),
                class: "absolute w-full h-full inset-0 object-cover object-center"
              }, null, 12, _hoisted_3);
            }), 128))
          ]),
          _: 1
        })
      ]),
      createVNode(TransitionGroup, {
        name: "fade",
        mode: "out-in"
      }, {
        default: withCtx(() => [
          $props.imageBase ? (openBlock(), createElementBlock("img", {
            key: 0,
            loading: "lazy",
            class: "absolute w-full h-full inset-0 object-cover object-center",
            style: { "z-index": "-1" },
            src: $props.imageBase
          }, null, 8, _hoisted_4)) : (openBlock(), createElementBlock("img", {
            key: 1,
            loading: "lazy",
            class: "absolute w-full h-full inset-0 object-cover object-center",
            style: { "z-index": "-1" },
            src: $props.backgroundImage.src,
            alt: $props.backgroundImage.alt
          }, null, 8, _hoisted_5))
        ]),
        _: 1
      })
    ]);
  }

  // source/configurator/components/Background.vue
  Background_default.render = render;
  Background_default.__file = "source/configurator/components/Background.vue";
  var Background_default2 = Background_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/Button.vue?type=script
  var Button_default = {
    name: "Button",
    props: {
      title: String
    },
    methods: {
      onClick() {
        console.log("click default");
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/Button.vue?type=template
  function render2(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("button", {
      onClick: _cache[0] || (_cache[0] = ($event) => $options.onClick())
    }, toDisplayString($props.title), 1);
  }

  // source/configurator/components/Button.vue
  Button_default.render = render2;
  Button_default.__file = "source/configurator/components/Button.vue";
  var Button_default2 = Button_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/ButtonNew.vue?type=script
  var ButtonNew_default = {
    name: "ButtonNew",
    props: {
      title: String,
      onClick: Function
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/ButtonNew.vue?type=template
  function render3(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => $props.onClick && $props.onClick(...args))
    }, toDisplayString($props.title), 1);
  }

  // source/configurator/components/ButtonNew.vue
  ButtonNew_default.render = render3;
  ButtonNew_default.__file = "source/configurator/components/ButtonNew.vue";
  var ButtonNew_default2 = ButtonNew_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/Modal.vue?type=script
  var Modal_default = {
    props: {
      show: Boolean
    },
    data() {
      return {
        introTitle: "",
        introCopy: ""
      };
    },
    beforeMount() {
      const configurator = document.getElementById("configurator");
      this.introTitle = configurator.dataset.introtitle ?? "Build your Van";
      this.introCopy = configurator.dataset.introcopy ?? "";
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/Modal.vue?type=template
  var _hoisted_12 = {
    key: 0,
    class: "conf-modal-mask fixed w-full h-full top-0 left-0"
  };
  var _hoisted_22 = { class: "conf-modal-container cursor-auto px-8 pt-8 pb-2" };
  var _hoisted_32 = { class: "h3 mb-2" };
  var _hoisted_42 = ["innerHTML"];
  var _hoisted_52 = { class: "flex items-baseline justify-end" };
  function render4(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createBlock(Transition, { name: "modal" }, {
      default: withCtx(() => [
        $props.show ? (openBlock(), createElementBlock("div", _hoisted_12, [
          createBaseVNode("div", {
            onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("close"), ["self"])),
            class: "conf-modal-wrapper cursor-pointer"
          }, [
            createBaseVNode("div", _hoisted_22, [
              createBaseVNode("h2", _hoisted_32, toDisplayString($data.introTitle), 1),
              createBaseVNode("div", {
                innerHTML: $data.introCopy,
                class: "prose"
              }, null, 8, _hoisted_42),
              createBaseVNode("div", _hoisted_52, [
                createBaseVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close")),
                  class: "p-3"
                }, "OK")
              ])
            ])
          ])
        ])) : createCommentVNode("v-if", true)
      ]),
      _: 1
    });
  }

  // source/configurator/components/Modal.vue
  Modal_default.render = render4;
  Modal_default.__file = "source/configurator/components/Modal.vue";
  var Modal_default2 = Modal_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/PackageTotal.vue?type=script
  var PackageTotal_default = {
    name: "PackageTotal",
    emits: ["selectNavigationGroup"],
    props: {
      userSelections: Object,
      checkedAnswersObject: Object,
      activePackageTitle: String,
      activeVanTitle: String,
      activeVanYear: [Number, String],
      activeVanKitBasePrice: Number,
      currentPrice: Number,
      factoryInstall: Boolean,
      totalFactoryInstall: Number,
      saveBuild: Function,
      vanGroup: String,
      newBuild: Function
    },
    data() {
      return {
        viewOrderIsActive: false
      };
    },
    methods: {
      toggleOrderView() {
        this.viewOrderIsActive = !this.viewOrderIsActive;
      }
    },
    computed: {
      orderViewButtonText() {
        return this.viewOrderIsActive ? "Close Order" : "View Order";
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/PackageTotal.vue?type=template
  var _hoisted_13 = /* @__PURE__ */ createBaseVNode("path", {
    d: "M8 7.5L4 0L0 7.5H8Z",
    fill: "currentColor"
  }, null, -1);
  var _hoisted_23 = [
    _hoisted_13
  ];
  var _hoisted_33 = {
    key: 0,
    class: "text-blue ml-4"
  };
  var _hoisted_43 = {
    key: 1,
    class: "text-blue ml-4"
  };
  var _hoisted_53 = { class: "h-full" };
  var _hoisted_6 = { class: "md:pb-8 flex flex-wrap items-center" };
  var _hoisted_7 = { class: "flex flex-col space-y-2 pr-8 mb-4" };
  var _hoisted_8 = { class: "h3" };
  var _hoisted_9 = {
    key: 0,
    class: "text-blue link lg:hidden"
  };
  var _hoisted_10 = { class: "text-right ml-auto" };
  var _hoisted_11 = /* @__PURE__ */ createBaseVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    class: "mr-0"
  }, [
    /* @__PURE__ */ createBaseVNode("path", { d: "M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z" })
  ], -1);
  var _hoisted_122 = /* @__PURE__ */ createTextVNode(" Copy URL for Sharing ");
  var _hoisted_132 = [
    _hoisted_11,
    _hoisted_122
  ];
  var _hoisted_14 = /* @__PURE__ */ createBaseVNode("small", null, "Clear Configurator", -1);
  var _hoisted_15 = [
    _hoisted_14
  ];
  var _hoisted_16 = { class: "specs pb-18" };
  var _hoisted_17 = { class: "pb-4 border-b border-grey-light" };
  var _hoisted_18 = { class: "intro-sm" };
  var _hoisted_19 = { key: 0 };
  var _hoisted_20 = {
    key: 0,
    class: "ml-2 pl-4 micro-alt spec-li relative flex justify-between mt-3"
  };
  var _hoisted_21 = { key: 0 };
  var _hoisted_222 = {
    key: 1,
    class: "ml-2"
  };
  var _hoisted_232 = {
    key: 0,
    class: "ml-2 pl-4 micro-alt spec-li relative flex justify-between mt-3"
  };
  var _hoisted_24 = /* @__PURE__ */ createBaseVNode("span", null, " Conversion Kit Base Price ", -1);
  var _hoisted_25 = {
    key: 0,
    class: "min-w-20 w-20 ml-5"
  };
  var _hoisted_26 = { class: "flex justify-between" };
  var _hoisted_27 = {
    key: 0,
    class: "mr-2 font-semibold"
  };
  var _hoisted_28 = {
    key: 0,
    class: "min-w-20 w-20 ml-5 text-right"
  };
  var _hoisted_29 = {
    key: 1,
    class: "min-w-20 w-20 ml-5 text-right"
  };
  var _hoisted_30 = {
    key: 2,
    class: "min-w-20 w-20 ml-5 text-right"
  };
  var _hoisted_31 = {
    key: 0,
    class: "block mt-1"
  };
  function render5(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.vanGroup ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([[$data.viewOrderIsActive ? "translate-y-0 lg:h-package-total" : "lg:translate-y-full translate-y-0 lg:h-2px"], "lg:absolute w-full left-0 bottom-0 h-full lg:z-1000 bg-white py-8 lg:px-15 px-5 transform transition-transform duration-500 order-4 lg:shadow-conf-spec -lg:border-t border-brand"])
    }, [
      createBaseVNode("h1", {
        onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleOrderView && $options.toggleOrderView(...args)),
        class: "cursor-pointer lg:absolute left-0 bottom-full link link-no-effect py-8 px-10 bg-white inline-flex shadow-conf-spec -lg:hidden"
      }, [
        (openBlock(), createElementBlock("svg", {
          class: normalizeClass([[$data.viewOrderIsActive ? "open text-blue" : "text-brand"], "mr-2 icon-caret"]),
          width: "8",
          height: "8",
          viewBox: "0 0 8 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_23, 2)),
        createBaseVNode("span", null, toDisplayString($options.orderViewButtonText), 1),
        $props.currentPrice && $props.currentPrice.toString().includes("-") ? (openBlock(), createElementBlock("span", _hoisted_33, toDisplayString($props.currentPrice.toFixed(2).toString().replace("-", "- $")), 1)) : $props.currentPrice ? (openBlock(), createElementBlock("span", _hoisted_43, " $" + toDisplayString($props.currentPrice.toFixed(2)), 1)) : createCommentVNode("v-if", true)
      ]),
      createBaseVNode("div", _hoisted_53, [
        createBaseVNode("div", _hoisted_6, [
          createBaseVNode("div", _hoisted_7, [
            createBaseVNode("h2", _hoisted_8, toDisplayString($props.activePackageTitle) + " Configuration", 1),
            $props.currentPrice ? (openBlock(), createElementBlock("h3", _hoisted_9, "$" + toDisplayString($props.currentPrice.toFixed(2)), 1)) : createCommentVNode("v-if", true)
          ]),
          createBaseVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("selectNavigationGroup", 999)),
            class: "btn btn-brand link-no-effect transition duration-300 mb-4",
            "aria-label": "add configuration to cart"
          }, " View Purchase Options "),
          createBaseVNode("div", _hoisted_10, [
            $props.vanGroup ? (openBlock(), createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = (...args) => $props.saveBuild && $props.saveBuild(...args)),
              "aria-label": "get a unique url to share your build",
              class: "hidden ml-8 mb-2 link transition duration-300 hover:opacity-50 focus:opacity-50 flex items-baseline"
            }, _hoisted_132)) : createCommentVNode("v-if", true),
            $props.vanGroup ? (openBlock(), createElementBlock("button", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = (...args) => $props.newBuild && $props.newBuild(...args)),
              "aria-label": "restart the configurator",
              class: "ml-8 transition duration-300 hover:opacity-50 focus:opacity-50"
            }, _hoisted_15)) : createCommentVNode("v-if", true)
          ])
        ]),
        createBaseVNode("div", {
          class: normalizeClass([[$data.viewOrderIsActive ? "lg:h-full" : "lg:translate-y-full translate-y-0 lg:h-2px"], "h-full relative overflow-auto"])
        }, [
          createBaseVNode("ul", _hoisted_16, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.checkedAnswersObject, (answers, category) => {
              return openBlock(), createElementBlock("li", {
                key: category,
                class: "mt-4 w-full lg:max-w-132"
              }, [
                createBaseVNode("div", _hoisted_17, [
                  createBaseVNode("h3", _hoisted_18, toDisplayString(category), 1),
                  category === "Model Type" ? (openBlock(), createElementBlock("ul", _hoisted_19, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($props.userSelections.vans, (van, i3) => {
                      return openBlock(), createElementBlock(Fragment, { key: i3 }, [
                        van.checked ? (openBlock(), createElementBlock("li", _hoisted_20, [
                          createBaseVNode("span", null, [
                            $props.activeVanTitle ? (openBlock(), createElementBlock("span", _hoisted_21, toDisplayString($props.activeVanTitle), 1)) : createCommentVNode("v-if", true),
                            $props.activeVanYear ? (openBlock(), createElementBlock("span", _hoisted_222, toDisplayString($props.activeVanYear), 1)) : createCommentVNode("v-if", true)
                          ])
                        ])) : createCommentVNode("v-if", true)
                      ], 64);
                    }), 128)),
                    $props.activeVanKitBasePrice ? (openBlock(), createElementBlock("li", _hoisted_232, [
                      _hoisted_24,
                      $props.activeVanKitBasePrice ? (openBlock(), createElementBlock("span", _hoisted_25, " $" + toDisplayString($props.activeVanKitBasePrice.toFixed(2)), 1)) : createCommentVNode("v-if", true)
                    ])) : createCommentVNode("v-if", true)
                  ])) : createCommentVNode("v-if", true),
                  createBaseVNode("ul", null, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(answers, (answer, i3) => {
                      return openBlock(), createElementBlock("li", {
                        key: i3,
                        class: "ml-2 pl-4 micro-alt spec-li relative mt-3"
                      }, [
                        createBaseVNode("div", _hoisted_26, [
                          createBaseVNode("span", null, [
                            category != "Model Type" ? (openBlock(), createElementBlock("span", _hoisted_27, toDisplayString(answer.question) + ":", 1)) : createCommentVNode("v-if", true),
                            createBaseVNode("span", null, toDisplayString(answer.title), 1)
                          ]),
                          createCommentVNode(` <span class="min-w-20 w-20 ml-5 text-right" v-if="'factory_install' == answer.unique_id">
										\${{ currentInstallCost.toFixed(2) }}
									</span> `),
                          answer.question === "Installation options" && answer.title === "Factory Install" ? (openBlock(), createElementBlock("span", _hoisted_28, " $" + toDisplayString($props.totalFactoryInstall.toFixed(2)), 1)) : answer.price && answer.price.toString().includes("-") ? (openBlock(), createElementBlock("span", _hoisted_29, toDisplayString(answer.price.toFixed(2).toString().replace("-", "- $")), 1)) : answer.price ? (openBlock(), createElementBlock("span", _hoisted_30, " $" + toDisplayString(answer.price.toFixed(2)), 1)) : createCommentVNode("v-if", true)
                        ]),
                        answer.installCost && $props.factoryInstall == true ? (openBlock(), createElementBlock("small", _hoisted_31, " (Adds $" + toDisplayString(answer.installCost.toFixed(2)) + " to factory install) ", 1)) : createCommentVNode("v-if", true)
                      ]);
                    }), 128))
                  ])
                ])
              ]);
            }), 128))
          ])
        ], 2)
      ])
    ], 2)) : createCommentVNode("v-if", true);
  }

  // source/configurator/components/PackageTotal.vue
  PackageTotal_default.render = render5;
  PackageTotal_default.__file = "source/configurator/components/PackageTotal.vue";
  var PackageTotal_default2 = PackageTotal_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsRadios.vue?type=script
  var QuestionsRadios_default = {
    name: "QuestionsRadios",
    props: {
      modelValue: {
        type: Object,
        required: true
      },
      questionKey: String
    },
    emits: [
      "createQuestionGroupToC",
      "checkRequirementsRestrictions"
    ],
    data() {
      return {
        aHovered: {},
        forceTickHack: 0
      };
    },
    methods: {
      uniqueCheck(i3) {
        let hasDisabled = false;
        let disabledChecked = {};
        let disabledIndex = [];
        for (const [key, value] of Object.entries(this.modelValue[this.questionKey])) {
          if (value.disabled) {
            disabledIndex.push(key);
            disabledChecked[key] = value.checked;
            hasDisabled = true;
          }
        }
        if (!hasDisabled) {
          for (const [key, value] of Object.entries(this.modelValue[this.questionKey])) {
            value.checked = key == i3;
          }
        } else {
          for (const [key, value] of Object.entries(this.modelValue[this.questionKey])) {
            if (disabledIndex.includes(key)) {
              value.checked = disabledChecked[key];
            } else {
              if (Object.values(disabledChecked).includes(true)) {
                value.checked = false;
              } else {
                value.checked = key == i3;
              }
            }
          }
        }
        this.forceTickHack += 1;
        this.$emit("checkRequirementsRestrictions", this.modelValue[this.questionKey]);
        this.$emit("createQuestionGroupToC");
      }
    },
    mounted() {
    },
    beforeUnmount() {
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsRadios.vue?type=template
  var _hoisted_110 = ["onUpdate:modelValue", "disabled", "id", "name", "onChange"];
  var _hoisted_210 = {
    class: "conf-radio-btn absolute left-0 top-3",
    width: "17",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  };
  var _hoisted_34 = ["fill"];
  var _hoisted_44 = ["fill"];
  var _hoisted_54 = { class: "flex justify-between items-start w-full" };
  var _hoisted_62 = ["onMouseover", "onMouseleave"];
  var _hoisted_72 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "6",
    height: "9",
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      d: "M2.1898 6.34624C2.1898 6.52264 2.2528 6.58564 2.4166 6.58564H3.1978C3.3616 6.58564 3.4246 6.52264 3.4246 6.34624V5.71624C3.4246 5.25004 3.6892 5.06104 4.0042 4.90984L4.6972 4.58224C5.1382 4.36804 5.7934 3.88924 5.7934 2.80564V2.01184C5.7934 0.978641 5.1382 0.0714417 3.034 0.0714417C0.929805 0.0714417 0.299805 0.978641 0.299805 2.01184V2.74264C0.299805 2.91904 0.362805 2.99464 0.539205 2.99464H1.27C1.4338 2.99464 1.4968 2.91904 1.4968 2.74264V2.20084C1.4968 1.50784 1.9126 1.10464 3.034 1.10464C4.1428 1.10464 4.5712 1.50784 4.5712 2.20084V2.84344C4.5712 3.37264 4.2058 3.62464 4.0042 3.72544L2.9962 4.24204C2.6686 4.40584 2.1898 4.68304 2.1898 5.41384V6.34624ZM3.4246 7.49284C3.4246 7.32904 3.3616 7.25344 3.1978 7.25344H2.4166C2.2528 7.25344 2.1898 7.32904 2.1898 7.49284V8.50084C2.1898 8.67724 2.2528 8.74024 2.4166 8.74024H3.1978C3.3616 8.74024 3.4246 8.67724 3.4246 8.50084V7.49284Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_82 = [
    _hoisted_72
  ];
  var _hoisted_92 = {
    key: 0,
    class: "md:w-105 w-full p-10 bg-brand-ada text-white micro-alt absolute z-50 top-10 right-0"
  };
  var _hoisted_102 = {
    key: 0,
    class: "flex items-center",
    price: ""
  };
  var _hoisted_112 = {
    key: 1,
    class: "flex items-center",
    price: ""
  };
  function render6(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(true), createElementBlock(Fragment, null, renderList($props.modelValue[$props.questionKey], (answer, i3) => {
      return openBlock(), createElementBlock("label", {
        class: "cursor-pointer conf-q relative flex items-start conf-radio py-3",
        key: i3
      }, [
        withDirectives(createBaseVNode("input", {
          type: "radio",
          "onUpdate:modelValue": ($event) => answer.checked = $event,
          disabled: answer.disabled,
          id: answer.id,
          name: $props.questionKey,
          value: "true",
          class: "opacity-0",
          onChange: ($event) => $options.uniqueCheck(i3)
        }, null, 40, _hoisted_110), [
          [vModelRadio, answer.checked]
        ]),
        (openBlock(), createElementBlock("svg", _hoisted_210, [
          createBaseVNode("path", {
            d: "M1.8218 4.93301L8 1.36603L14.1782 4.93301V12.067L8 15.634L1.8218 12.067V4.93301Z",
            stroke: "#456FB6",
            "stroke-width": "1.5",
            fill: [answer.checked ? "#456FB6" : "transparent"]
          }, null, 8, _hoisted_34),
          createBaseVNode("circle", {
            cx: "8",
            cy: "8.5",
            r: "3.5",
            fill: [answer.checked ? "white" : "transparent"]
          }, null, 8, _hoisted_44)
        ])),
        createBaseVNode("div", _hoisted_54, [
          createBaseVNode("div", {
            class: normalizeClass([[answer.price ? "max-w-question" : ""], "flex items-start"])
          }, [
            createBaseVNode("span", {
              class: normalizeClass(["pl-2", [answer.disabled ? "opacity-30" : ""]])
            }, toDisplayString(answer.title), 3),
            answer.infoBubble ? (openBlock(), createElementBlock("div", {
              key: 0,
              onMouseover: ($event) => $data.aHovered[i3] = true,
              onMouseleave: ($event) => $data.aHovered[i3] = false,
              class: "ml-2 cursor-help min-w-5 w-5 h-5 rounded-full flex justify-center items-center border border-brand-ada"
            }, _hoisted_82, 40, _hoisted_62)) : createCommentVNode("v-if", true),
            createVNode(Transition, { name: "fade" }, {
              default: withCtx(() => [
                $data.aHovered[i3] ? (openBlock(), createElementBlock("div", _hoisted_92, toDisplayString(answer.infoBubble), 1)) : createCommentVNode("v-if", true)
              ]),
              _: 2
            }, 1024)
          ], 2),
          answer.price && answer.price.toString().includes("-") ? (openBlock(), createElementBlock("span", _hoisted_102, toDisplayString(answer.price.toFixed(2).toString().replace("-", "- $")), 1)) : answer.price ? (openBlock(), createElementBlock("span", _hoisted_112, " + $" + toDisplayString(answer.price.toFixed(2)), 1)) : createCommentVNode("v-if", true)
        ])
      ]);
    }), 128);
  }

  // source/configurator/components/QuestionsRadios.vue
  QuestionsRadios_default.render = render6;
  QuestionsRadios_default.__file = "source/configurator/components/QuestionsRadios.vue";
  var QuestionsRadios_default2 = QuestionsRadios_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsCheckboxes.vue?type=script
  var QuestionsCheckboxes_default = {
    name: "QuestionsCheckboxes",
    props: {
      modelValue: {
        type: Object,
        required: true
      },
      questionKey: String
    },
    emits: [
      "createQuestionGroupToC",
      "checkRequirementsRestrictions"
    ],
    data() {
      return {
        aHovered: {},
        forceTickHack: 0
      };
    },
    methods: {
      uniqueCheck(i3) {
        this.forceTickHack += 1;
        this.$emit("checkRequirementsRestrictions", this.modelValue[this.questionKey]);
        this.$emit("createQuestionGroupToC");
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsCheckboxes.vue?type=template
  var _hoisted_111 = ["onUpdate:modelValue", "disabled", "id", "name", "value", "onChange"];
  var _hoisted_211 = { class: "flex justify-between w-full" };
  var _hoisted_35 = ["onMouseover", "onMouseleave"];
  var _hoisted_45 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "6",
    height: "9",
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      d: "M2.1898 6.34624C2.1898 6.52264 2.2528 6.58564 2.4166 6.58564H3.1978C3.3616 6.58564 3.4246 6.52264 3.4246 6.34624V5.71624C3.4246 5.25004 3.6892 5.06104 4.0042 4.90984L4.6972 4.58224C5.1382 4.36804 5.7934 3.88924 5.7934 2.80564V2.01184C5.7934 0.978641 5.1382 0.0714417 3.034 0.0714417C0.929805 0.0714417 0.299805 0.978641 0.299805 2.01184V2.74264C0.299805 2.91904 0.362805 2.99464 0.539205 2.99464H1.27C1.4338 2.99464 1.4968 2.91904 1.4968 2.74264V2.20084C1.4968 1.50784 1.9126 1.10464 3.034 1.10464C4.1428 1.10464 4.5712 1.50784 4.5712 2.20084V2.84344C4.5712 3.37264 4.2058 3.62464 4.0042 3.72544L2.9962 4.24204C2.6686 4.40584 2.1898 4.68304 2.1898 5.41384V6.34624ZM3.4246 7.49284C3.4246 7.32904 3.3616 7.25344 3.1978 7.25344H2.4166C2.2528 7.25344 2.1898 7.32904 2.1898 7.49284V8.50084C2.1898 8.67724 2.2528 8.74024 2.4166 8.74024H3.1978C3.3616 8.74024 3.4246 8.67724 3.4246 8.50084V7.49284Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_55 = [
    _hoisted_45
  ];
  var _hoisted_63 = {
    key: 0,
    class: "md:w-105 w-full p-10 bg-brand-ada text-white micro-alt absolute z-50 top-10 right-0"
  };
  var _hoisted_73 = {
    key: 0,
    class: "flex items-center",
    price: ""
  };
  var _hoisted_83 = {
    key: 1,
    class: "flex items-center",
    price: ""
  };
  function render7(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(true), createElementBlock(Fragment, null, renderList($props.modelValue[$props.questionKey], (answer, i3) => {
      return openBlock(), createElementBlock("label", {
        class: "cursor-pointer conf-q relative flex items-center conf-checkbox py-3",
        key: i3
      }, [
        withDirectives(createBaseVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": ($event) => answer.checked = $event,
          disabled: answer.disabled,
          id: answer.id,
          name: $props.questionKey,
          value: answer.title,
          onChange: ($event) => $options.uniqueCheck(i3)
        }, null, 40, _hoisted_111), [
          [vModelCheckbox, answer.checked]
        ]),
        createBaseVNode("div", _hoisted_211, [
          createBaseVNode("div", {
            class: normalizeClass([[answer.price ? "max-w-question" : ""], "flex items-center"])
          }, [
            createBaseVNode("span", {
              class: normalizeClass(["pl-2", [answer.disabled ? "opacity-30" : ""]])
            }, toDisplayString(answer.title), 3),
            answer.infoBubble ? (openBlock(), createElementBlock("div", {
              key: 0,
              onMouseover: ($event) => $data.aHovered[i3] = true,
              onMouseleave: ($event) => $data.aHovered[i3] = false,
              class: "ml-2 cursor-help w-5 h-5 rounded-full flex justify-center items-center border border-brand-ada"
            }, _hoisted_55, 40, _hoisted_35)) : createCommentVNode("v-if", true),
            createVNode(Transition, { name: "fade" }, {
              default: withCtx(() => [
                $data.aHovered[i3] ? (openBlock(), createElementBlock("div", _hoisted_63, toDisplayString(answer.infoBubble), 1)) : createCommentVNode("v-if", true)
              ]),
              _: 2
            }, 1024)
          ], 2),
          answer.price && answer.price.toString().includes("-") ? (openBlock(), createElementBlock("span", _hoisted_73, toDisplayString(answer.price.toFixed(2).toString().replace("-", "- $")), 1)) : answer.price ? (openBlock(), createElementBlock("span", _hoisted_83, " + $" + toDisplayString(answer.price.toFixed(2)), 1)) : createCommentVNode("v-if", true)
        ])
      ]);
    }), 128);
  }

  // source/configurator/components/QuestionsCheckboxes.vue
  QuestionsCheckboxes_default.render = render7;
  QuestionsCheckboxes_default.__file = "source/configurator/components/QuestionsCheckboxes.vue";
  var QuestionsCheckboxes_default2 = QuestionsCheckboxes_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsGroup.vue?type=script
  var QuestionsGroup_default = {
    name: "QuestionsGroup",
    components: {
      QuestionsRadios: QuestionsRadios_default2,
      QuestionsCheckboxes: QuestionsCheckboxes_default2
    },
    props: {
      modelValue: {
        type: Object,
        required: true
      }
    },
    emits: [
      "createQuestionGroupToC",
      "checkRequirementsRestrictions"
    ],
    methods: {
      createQuestionGroupToC(val) {
        this.$emit("createQuestionGroupToC");
      },
      checkRequirementsRestrictions(answers) {
        this.$emit("checkRequirementsRestrictions", answers);
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsGroup.vue?type=template
  function render8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuestionsCheckboxes = resolveComponent("QuestionsCheckboxes");
    const _component_QuestionsRadios = resolveComponent("QuestionsRadios");
    return $props.modelValue.multipleChoice ? (openBlock(), createBlock(_component_QuestionsCheckboxes, {
      key: 0,
      onCreateQuestionGroupToC: $options.createQuestionGroupToC,
      onCheckRequirementsRestrictions: $options.checkRequirementsRestrictions,
      modelValue: $props.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $props.modelValue = $event),
      questionKey: "answers"
    }, null, 8, ["onCreateQuestionGroupToC", "onCheckRequirementsRestrictions", "modelValue"])) : (openBlock(), createBlock(_component_QuestionsRadios, {
      key: 1,
      onCreateQuestionGroupToC: $options.createQuestionGroupToC,
      onCheckRequirementsRestrictions: $options.checkRequirementsRestrictions,
      modelValue: $props.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $props.modelValue = $event),
      questionKey: "answers"
    }, null, 8, ["onCreateQuestionGroupToC", "onCheckRequirementsRestrictions", "modelValue"]));
  }

  // source/configurator/components/QuestionsGroup.vue
  QuestionsGroup_default.render = render8;
  QuestionsGroup_default.__file = "source/configurator/components/QuestionsGroup.vue";
  var QuestionsGroup_default2 = QuestionsGroup_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsGroupVans.vue?type=script
  var QuestionsGroupVans_default = {
    name: "QuestionsGroupVans",
    components: {
      QuestionsRadios: QuestionsRadios_default2
    },
    props: {
      allQuestionGroupCategories: Array,
      modelValue: {
        type: Object,
        required: true
      },
      navigation: Object,
      activeVanTitle: String,
      activeVanYear: [Number, String]
    },
    emits: [
      "updateQuestionTitle",
      "updateQuestionNumberInGroup",
      "updateActiveQuestionNumber",
      "updateShowPrevButton",
      "updateShowNextButton"
    ],
    data() {
      return {
        qHovered: false,
        title0: "Choose your Van",
        title1: "Choose your Year"
      };
    },
    watch: {
      "navigation": {
        deep: true,
        immediate: true,
        handler(newVal) {
          let currentGroup = newVal.group;
          if (currentGroup === 0) {
            let currentQuestion = newVal.question[0];
            if (currentQuestion === 0) {
              this.$emit("updateQuestionTitle", this.title0);
              this.$emit("updateShowPrevButton", false);
              if (this.activeVanTitle) {
                this.$emit("updateShowNextButton", true);
              } else {
                this.$emit("updateShowNextButton", false);
              }
            }
            if (currentQuestion === 1) {
              this.$emit("updateQuestionTitle", this.title1);
              this.$emit("updateShowPrevButton", true);
              if (this.activeVanYear) {
                this.$emit("updateShowNextButton", true);
              } else {
                this.$emit("updateShowNextButton", false);
              }
            }
          }
        }
      },
      "activeVanTitle": function(newVal) {
        if (this.navigation.question[this.navigation.group] === 0) {
          if (newVal) {
            this.$emit("updateShowNextButton", true);
          } else {
            this.$emit("updateShowNextButton", false);
          }
        }
      },
      "activeVanYear": function(newVal) {
        if (this.navigation.question[this.navigation.group] === 1) {
          if (newVal) {
            this.$emit("updateShowNextButton", true);
          } else {
            this.$emit("updateShowNextButton", false);
          }
        }
      }
    },
    mounted() {
      this.$emit("updateQuestionTitle", this.title0);
      this.$emit("updateQuestionNumberInGroup", 1);
      if (this.activeVanTitle) {
        this.$emit("updateShowNextButton", true);
      } else {
        this.$emit("updateShowNextButton", false);
      }
    },
    beforeUnmount() {
      this.$emit("updateShowPrevButton", true);
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/QuestionsGroupVans.vue?type=template
  function render9(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuestionsRadios = resolveComponent("QuestionsRadios");
    return openBlock(), createElementBlock(Fragment, null, [
      $props.navigation.question[$props.navigation.group] == 0 ? (openBlock(), createBlock(_component_QuestionsRadios, {
        key: 0,
        modelValue: $props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $props.modelValue = $event),
        questionKey: "vans"
      }, null, 8, ["modelValue"])) : createCommentVNode("v-if", true),
      $props.navigation.question[$props.navigation.group] == 1 ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList($props.modelValue.vans, (answer, i3) => {
        return openBlock(), createElementBlock(Fragment, { key: i3 }, [
          answer.checked ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            answer.years ? (openBlock(), createBlock(_component_QuestionsRadios, {
              key: 0,
              modelValue: $props.modelValue.vans[i3],
              "onUpdate:modelValue": ($event) => $props.modelValue.vans[i3] = $event,
              questionKey: "years"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("v-if", true)
          ], 2112)) : createCommentVNode("v-if", true)
        ], 64);
      }), 128)) : createCommentVNode("v-if", true)
    ], 64);
  }

  // source/configurator/components/QuestionsGroupVans.vue
  QuestionsGroupVans_default.render = render9;
  QuestionsGroupVans_default.__file = "source/configurator/components/QuestionsGroupVans.vue";
  var QuestionsGroupVans_default2 = QuestionsGroupVans_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/Questions.vue?type=script
  var Questions_default = {
    name: "Questions",
    components: {
      QuestionsGroup: QuestionsGroup_default2,
      QuestionsGroupVans: QuestionsGroupVans_default2
    },
    props: {
      userSelections: Object,
      navigation: Object,
      packageChoice: Object,
      vanGroup: String,
      allQuestionGroupCategories: Array,
      activeVanTitle: String,
      activeVanYear: [Number, String]
    },
    emits: [
      "updateCurrentView",
      "previousNavigationGroup",
      "nextNavigationGroup",
      "previousNavigationQuestion",
      "nextNavigationQuestion",
      "selectNavigationQuestion"
    ],
    data() {
      return {
        currentTab: 0,
        totalTabs: 123,
        currentGroupToC: false,
        currentGroup: false,
        currentGroupQuestion: "",
        currentGroupQuestionDescription: "",
        currentGroupQuestionLearnMore: "",
        questionNumberInGroup: 0,
        activeQuestionNumber: 0,
        showPrevButton: true,
        showNextButton: true,
        questionBubbleText: "",
        qHovered: false
      };
    },
    methods: {
      selectNavigationQuestion(val) {
        this.$emit("selectNavigationQuestion", val);
      },
      updateQuestionTitle(val) {
        this.currentGroupQuestion = val;
      },
      updateQuestionDescription(val) {
        this.currentGroupQuestionDescription = val;
      },
      updateQuestionLearnMore(val) {
        this.currentGroupQuestionLearnMore = val;
      },
      updateQuestionBubbleText(val) {
        this.questionBubbleText = val;
      },
      updateQuestionNumberInGroup(num) {
        this.questionNumberInGroup = num;
      },
      updateActiveQuestionNumber(num) {
        this.activeQuestionNumber = num;
      },
      updateShowPrevButton(bool) {
        this.showPrevButton = bool;
      },
      updateShowNextButton(bool) {
        this.showNextButton = bool;
      },
      pushQuestionAnswersToToC(question) {
        let thisToCStep = [question];
        if (Array.isArray(question.answers)) {
          question.answers.forEach((answer) => {
            if (answer.questions && answer.checked && answer.questions.length) {
              answer.questions.forEach((question2) => {
                let newToCStep = this.pushQuestionAnswersToToC(question2);
                if (newToCStep) {
                  thisToCStep = thisToCStep.concat(newToCStep);
                }
              });
            }
          });
        }
        return thisToCStep;
      },
      createQuestionGroupToC() {
        let questionGroupToC = [];
        if (this.vanGroup && this.navigation.group > 0 && this.userSelections.questionGroups[this.vanGroup] && this.userSelections.questionGroups[this.vanGroup].length >= this.navigation.group) {
          this.userSelections.questionGroups[this.vanGroup][this.navigation.group - 1].questions.forEach((question) => {
            let newToCStep = this.pushQuestionAnswersToToC(question);
            if (newToCStep) {
              questionGroupToC = questionGroupToC.concat(newToCStep);
            }
          });
        }
        this.updateQuestionNumberInGroup(questionGroupToC.length - 1);
        this.currentGroupToC = questionGroupToC;
      },
      checkRequirementsRestrictions(answers) {
        answers.forEach((answer) => {
          if (answer.unique_id) {
            this.userSelections.questionGroups[this.vanGroup].forEach((group) => {
              this.checkRequirementsRestrictionsOfQuesions(answer, group.questions);
            });
          }
        });
      },
      checkRequirementsRestrictionsOfQuesions(answer, questions) {
        if (Array.isArray(questions) && questions.length) {
          questions.forEach((question) => {
            if (Array.isArray(question.answers) && question.answers.length) {
              question.answers.forEach((groupAnswer) => {
                if (groupAnswer.requirements.length) {
                  groupAnswer.requirements.some((requirement) => {
                    if (requirement.answer_unique_id === answer.unique_id) {
                      if (groupAnswer.disabled = answer.checked) {
                        if (!question.multipleChoice) {
                          question.answers.map(function(thisAnswer) {
                            thisAnswer.checked = false;
                          });
                        }
                        groupAnswer.checked = true;
                      }
                    }
                  });
                }
                if (groupAnswer.restrictions.length) {
                  groupAnswer.restrictions.some((restriction) => {
                    if (restriction.answer_unique_id === answer.unique_id) {
                      if (groupAnswer.disabled = answer.checked) {
                        groupAnswer.checked = false;
                      }
                    }
                  });
                }
                if (Array.isArray(groupAnswer.questions) && groupAnswer.questions.length) {
                  this.checkRequirementsRestrictionsOfQuesions(answer, groupAnswer.questions);
                }
              });
            }
          });
        }
      }
    },
    computed: {
      vanTabVisible() {
        return this.navigation.group === 0;
      },
      currentGroupNumberFormatted() {
        currentQuestionPlusOne = this.navigation.group + 1;
        if (currentQuestionPlusOne < 10) {
          return "0" + currentQuestionPlusOne;
        }
        return currentQuestionPlusOne;
      },
      currentGroupCategory() {
        if (this.navigation.group == 0) {
          return "Van Selection";
        }
        if (this.vanGroup && this.navigation.group > 0 && this.userSelections.questionGroups[this.vanGroup] && this.userSelections.questionGroups[this.vanGroup].length >= this.navigation.group) {
          return this.userSelections.questionGroups[this.vanGroup][this.navigation.group - 1].category;
        }
      },
      currentGroupQuestionObject() {
        let newCurrentGroupQuestionObject = false;
        if (this.vanGroup && this.navigation.group > 0 && this.currentGroupToC) {
          let questionIndex = this.navigation.question[this.navigation.group] ?? 0;
          newCurrentGroupQuestionObject = this.currentGroupToC[questionIndex];
        }
        return newCurrentGroupQuestionObject;
      },
      showNextQuestion() {
        return this.showNextButton && this.navigation.question[this.navigation.group] < this.questionNumberInGroup;
      },
      showNextGroup() {
        return this.showNextButton && this.navigation.question[this.navigation.group] >= this.questionNumberInGroup;
      },
      showPrevQuestion() {
        return this.showPrevButton && this.navigation.question[this.navigation.group] > 0;
      },
      showPrevGroup() {
        return this.showPrevButton && this.navigation.question[this.navigation.group] <= 0;
      },
      progress() {
        if (this.allQuestionGroupCategories) {
          currentQuestionPlusOne = this.navigation.group + 1;
          totalPlusOne = this.allQuestionGroupCategories.length + 1;
          return currentQuestionPlusOne / totalPlusOne * 100 + "%";
        }
      }
    },
    watch: {
      "navigation": {
        deep: true,
        immediate: true,
        handler(newVal) {
          let currentGroup = newVal.group;
          if (this.vanGroup && currentGroup > 0) {
            this.createQuestionGroupToC();
            let questionIndex = this.navigation.question[currentGroup] ?? 0;
            let newQuestion = this.currentGroupToC[questionIndex];
            if (newQuestion) {
              this.updateQuestionTitle(newQuestion.title ?? "");
              this.updateQuestionDescription(newQuestion.description ?? "");
              this.updateQuestionLearnMore(newQuestion.learnMore ?? "");
              this.updateQuestionBubbleText(newQuestion.infoBubble ?? false);
            } else {
              this.updateQuestionTitle("end fo the road (unable to find new question)");
              this.updateQuestionDescription("end of the road");
              this.updateQuestionLearnMore(false);
              this.updateQuestionBubbleText(false);
            }
          }
        }
      }
    },
    beforeUnmount() {
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/Questions.vue?type=template
  var _hoisted_113 = {
    id: "right-sidebar",
    class: "lg:mt-7 lg:mb-24 lg:max-w-90 w-full p-5 pb-2 bg-white lg:z-50 order-3"
  };
  var _hoisted_212 = { class: "flex justify-between pb-2" };
  var _hoisted_36 = { class: "conf-q text-blue" };
  var _hoisted_46 = { class: "conf-q" };
  var _hoisted_56 = { class: "conf-q text-blue mr-1" };
  var _hoisted_64 = { class: "relative w-full h-2px bg-grey-light mb-5" };
  var _hoisted_74 = { class: "pb-8 relative" };
  var _hoisted_84 = { class: "micro-alt" };
  var _hoisted_93 = { class: "intro mb-1" };
  var _hoisted_103 = {
    key: 0,
    class: "micro-alt mb-2"
  };
  var _hoisted_114 = { key: 1 };
  var _hoisted_123 = ["href"];
  var _hoisted_133 = /* @__PURE__ */ createTextVNode(" Learn More ");
  var _hoisted_142 = /* @__PURE__ */ createBaseVNode("span", { class: "arrow" }, [
    /* @__PURE__ */ createBaseVNode("svg", {
      viewBox: "0 0 18 18",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      role: "presentation",
      class: "icon icon-arrow"
    }, [
      /* @__PURE__ */ createBaseVNode("path", {
        d: "M17.3536 9.35355C17.5488 9.15829 17.5488 8.84171 17.3536 8.64645L14.1716 5.46446C13.9763 5.2692 13.6597 5.2692 13.4645 5.46446C13.2692 5.65973 13.2692 5.97631 13.4645 6.17157L16.2929 9L13.4645 11.8284C13.2692 12.0237 13.2692 12.3403 13.4645 12.5355C13.6597 12.7308 13.9763 12.7308 14.1716 12.5355L17.3536 9.35355ZM4.37114e-08 9.5L17 9.5L17 8.5L-4.37114e-08 8.5L4.37114e-08 9.5Z",
        fill: "currentColor"
      })
    ])
  ], -1);
  var _hoisted_152 = [
    _hoisted_133,
    _hoisted_142
  ];
  var _hoisted_162 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "6",
    height: "9",
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      d: "M2.1898 6.34624C2.1898 6.52264 2.2528 6.58564 2.4166 6.58564H3.1978C3.3616 6.58564 3.4246 6.52264 3.4246 6.34624V5.71624C3.4246 5.25004 3.6892 5.06104 4.0042 4.90984L4.6972 4.58224C5.1382 4.36804 5.7934 3.88924 5.7934 2.80564V2.01184C5.7934 0.978641 5.1382 0.0714417 3.034 0.0714417C0.929805 0.0714417 0.299805 0.978641 0.299805 2.01184V2.74264C0.299805 2.91904 0.362805 2.99464 0.539205 2.99464H1.27C1.4338 2.99464 1.4968 2.91904 1.4968 2.74264V2.20084C1.4968 1.50784 1.9126 1.10464 3.034 1.10464C4.1428 1.10464 4.5712 1.50784 4.5712 2.20084V2.84344C4.5712 3.37264 4.2058 3.62464 4.0042 3.72544L2.9962 4.24204C2.6686 4.40584 2.1898 4.68304 2.1898 5.41384V6.34624ZM3.4246 7.49284C3.4246 7.32904 3.3616 7.25344 3.1978 7.25344H2.4166C2.2528 7.25344 2.1898 7.32904 2.1898 7.49284V8.50084C2.1898 8.67724 2.2528 8.74024 2.4166 8.74024H3.1978C3.3616 8.74024 3.4246 8.67724 3.4246 8.50084V7.49284Z",
      fill: "white"
    })
  ], -1);
  var _hoisted_172 = [
    _hoisted_162
  ];
  var _hoisted_182 = {
    key: 0,
    class: "md:w-105 w-full p-10 bg-brand-ada text-white micro-alt absolute z-50 top-6 right-0"
  };
  var _hoisted_192 = { class: "flex justify-end space-x-4 mt-5 mb-3" };
  var _hoisted_202 = { class: "w-12 h-12" };
  var _hoisted_213 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M1.07416 5.61341C0.781269 5.9063 0.781269 6.38117 1.07416 6.67407L5.84713 11.447C6.14003 11.7399 6.6149 11.7399 6.90779 11.447C7.20069 11.1541 7.20069 10.6793 6.90779 10.3864L2.66515 6.14374L6.90779 1.9011C7.20069 1.6082 7.20069 1.13333 6.90779 0.840436C6.6149 0.547542 6.14003 0.547542 5.84713 0.840436L1.07416 5.61341ZM21.6045 5.39374L1.60449 5.39374L1.60449 6.89374L21.6045 6.89374L21.6045 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_223 = [
    _hoisted_213
  ];
  var _hoisted_233 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M1.07416 5.61341C0.781269 5.9063 0.781269 6.38117 1.07416 6.67407L5.84713 11.447C6.14003 11.7399 6.6149 11.7399 6.90779 11.447C7.20069 11.1541 7.20069 10.6793 6.90779 10.3864L2.66515 6.14374L6.90779 1.9011C7.20069 1.6082 7.20069 1.13333 6.90779 0.840436C6.6149 0.547542 6.14003 0.547542 5.84713 0.840436L1.07416 5.61341ZM21.6045 5.39374L1.60449 5.39374L1.60449 6.89374L21.6045 6.89374L21.6045 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_242 = [
    _hoisted_233
  ];
  var _hoisted_252 = {
    key: 2,
    class: "opacity-25 w-12 h-12 flex justify-center items-center border-2 border-grey-light rounded-full"
  };
  var _hoisted_262 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M1.07416 5.61341C0.781269 5.9063 0.781269 6.38117 1.07416 6.67407L5.84713 11.447C6.14003 11.7399 6.6149 11.7399 6.90779 11.447C7.20069 11.1541 7.20069 10.6793 6.90779 10.3864L2.66515 6.14374L6.90779 1.9011C7.20069 1.6082 7.20069 1.13333 6.90779 0.840436C6.6149 0.547542 6.14003 0.547542 5.84713 0.840436L1.07416 5.61341ZM21.6045 5.39374L1.60449 5.39374L1.60449 6.89374L21.6045 6.89374L21.6045 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_272 = [
    _hoisted_262
  ];
  var _hoisted_282 = { class: "w-12 h-12" };
  var _hoisted_292 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M20.9258 5.61341C21.2187 5.9063 21.2187 6.38117 20.9258 6.67407L16.1529 11.447C15.86 11.7399 15.3851 11.7399 15.0922 11.447C14.7993 11.1541 14.7993 10.6793 15.0922 10.3864L19.3348 6.14374L15.0922 1.9011C14.7993 1.6082 14.7993 1.13333 15.0922 0.840436C15.3851 0.547542 15.86 0.547542 16.1529 0.840436L20.9258 5.61341ZM0.395508 5.39374L20.3955 5.39374L20.3955 6.89374L0.395508 6.89374L0.395508 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_302 = [
    _hoisted_292
  ];
  var _hoisted_312 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M20.9258 5.61341C21.2187 5.9063 21.2187 6.38117 20.9258 6.67407L16.1529 11.447C15.86 11.7399 15.3851 11.7399 15.0922 11.447C14.7993 11.1541 14.7993 10.6793 15.0922 10.3864L19.3348 6.14374L15.0922 1.9011C14.7993 1.6082 14.7993 1.13333 15.0922 0.840436C15.3851 0.547542 15.86 0.547542 16.1529 0.840436L20.9258 5.61341ZM0.395508 5.39374L20.3955 5.39374L20.3955 6.89374L0.395508 6.89374L0.395508 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_322 = [
    _hoisted_312
  ];
  var _hoisted_332 = {
    key: 2,
    class: "opacity-25 w-12 h-12 flex justify-center items-center border-2 border-grey-light rounded-full"
  };
  var _hoisted_342 = /* @__PURE__ */ createBaseVNode("svg", {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      class: "transition duration-300",
      d: "M20.9258 5.61341C21.2187 5.9063 21.2187 6.38117 20.9258 6.67407L16.1529 11.447C15.86 11.7399 15.3851 11.7399 15.0922 11.447C14.7993 11.1541 14.7993 10.6793 15.0922 10.3864L19.3348 6.14374L15.0922 1.9011C14.7993 1.6082 14.7993 1.13333 15.0922 0.840436C15.3851 0.547542 15.86 0.547542 16.1529 0.840436L20.9258 5.61341ZM0.395508 5.39374L20.3955 5.39374L20.3955 6.89374L0.395508 6.89374L0.395508 5.39374Z",
      fill: "#456FB6"
    })
  ], -1);
  var _hoisted_352 = [
    _hoisted_342
  ];
  function render10(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuestionsGroupVans = resolveComponent("QuestionsGroupVans");
    const _component_QuestionsGroup = resolveComponent("QuestionsGroup");
    return openBlock(), createElementBlock("div", _hoisted_113, [
      createBaseVNode("div", _hoisted_212, [
        createBaseVNode("div", _hoisted_36, " Step ." + toDisplayString($options.currentGroupNumberFormatted), 1),
        createBaseVNode("div", _hoisted_46, [
          createBaseVNode("span", _hoisted_56, toDisplayString(this.navigation.question[this.navigation.group] + 1), 1),
          createTextVNode("/ " + toDisplayString($data.questionNumberInGroup + 1), 1)
        ])
      ]),
      createBaseVNode("div", _hoisted_64, [
        createBaseVNode("div", {
          class: "absolute left-0 top-0 h-2px bg-blue transition-width duration-300",
          style: normalizeStyle({ width: $options.progress })
        }, null, 4)
      ]),
      createBaseVNode("div", _hoisted_74, [
        createBaseVNode("div", _hoisted_84, toDisplayString($options.currentGroupCategory), 1),
        createBaseVNode("div", _hoisted_93, toDisplayString($data.currentGroupQuestion), 1),
        $data.currentGroupQuestionDescription ? (openBlock(), createElementBlock("div", _hoisted_103, toDisplayString($data.currentGroupQuestionDescription), 1)) : createCommentVNode("v-if", true),
        $data.currentGroupQuestionLearnMore ? (openBlock(), createElementBlock("div", _hoisted_114, [
          createBaseVNode("a", {
            href: $data.currentGroupQuestionLearnMore,
            class: "btn link link-brand",
            target: "_blank",
            "aria-label": "Learn More"
          }, _hoisted_152, 8, _hoisted_123)
        ])) : createCommentVNode("v-if", true),
        $data.questionBubbleText ? (openBlock(), createElementBlock("div", {
          key: 2,
          onMouseover: _cache[0] || (_cache[0] = ($event) => $data.qHovered = true),
          onMouseleave: _cache[1] || (_cache[1] = ($event) => $data.qHovered = false),
          class: "cursor-help absolute top-0 right-0 w-5 h-5 rounded-full flex justify-center items-center bg-brand-ada"
        }, _hoisted_172, 32)) : createCommentVNode("v-if", true),
        createVNode(Transition, { name: "fade" }, {
          default: withCtx(() => [
            $data.qHovered ? (openBlock(), createElementBlock("div", _hoisted_182, toDisplayString($data.questionBubbleText), 1)) : createCommentVNode("v-if", true)
          ]),
          _: 1
        })
      ]),
      createBaseVNode("div", null, [
        $options.vanTabVisible ? (openBlock(), createBlock(_component_QuestionsGroupVans, {
          key: 0,
          onUpdateQuestionTitle: $options.updateQuestionTitle,
          onUpdateQuestionNumberInGroup: $options.updateQuestionNumberInGroup,
          onUpdateActiveQuestionNumber: $options.updateActiveQuestionNumber,
          onUpdateShowPrevButton: $options.updateShowPrevButton,
          onUpdateShowNextButton: $options.updateShowNextButton,
          modelValue: $props.userSelections,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $props.userSelections = $event),
          navigation: $props.navigation,
          activeVanTitle: $props.activeVanTitle,
          activeVanYear: $props.activeVanYear
        }, null, 8, ["onUpdateQuestionTitle", "onUpdateQuestionNumberInGroup", "onUpdateActiveQuestionNumber", "onUpdateShowPrevButton", "onUpdateShowNextButton", "modelValue", "navigation", "activeVanTitle", "activeVanYear"])) : createCommentVNode("v-if", true),
        $options.currentGroupQuestionObject ? (openBlock(), createBlock(_component_QuestionsGroup, {
          key: 1,
          onCreateQuestionGroupToC: $options.createQuestionGroupToC,
          onCheckRequirementsRestrictions: $options.checkRequirementsRestrictions,
          modelValue: $options.currentGroupQuestionObject,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $options.currentGroupQuestionObject = $event)
        }, null, 8, ["onCreateQuestionGroupToC", "onCheckRequirementsRestrictions", "modelValue"])) : createCommentVNode("v-if", true)
      ]),
      createBaseVNode("div", _hoisted_192, [
        createBaseVNode("div", _hoisted_202, [
          $options.showPrevQuestion ? (openBlock(), createElementBlock("button", {
            key: 0,
            onClick: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("previousNavigationQuestion", $props.navigation.group)),
            class: "w-12 h-12 flex justify-center items-center conf-nav-btn border-2 border-grey-light rounded-full transition duration-300"
          }, _hoisted_223)) : createCommentVNode("v-if", true),
          $options.showPrevGroup ? (openBlock(), createElementBlock("button", {
            key: 1,
            onClick: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("previousNavigationGroup")),
            class: "w-12 h-12 flex justify-center items-center conf-nav-btn border-2 border-grey-light rounded-full transition duration-300"
          }, _hoisted_242)) : createCommentVNode("v-if", true),
          !$options.showPrevQuestion && !$options.showPrevGroup ? (openBlock(), createElementBlock("div", _hoisted_252, _hoisted_272)) : createCommentVNode("v-if", true)
        ]),
        createBaseVNode("div", _hoisted_282, [
          $options.showNextQuestion ? (openBlock(), createElementBlock("button", {
            key: 0,
            onClick: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("nextNavigationQuestion", $props.navigation.group)),
            class: "w-12 h-12 flex justify-center items-center conf-nav-btn border-2 border-grey-light rounded-full transition duration-300"
          }, _hoisted_302)) : createCommentVNode("v-if", true),
          $options.showNextGroup ? (openBlock(), createElementBlock("button", {
            key: 1,
            onClick: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("nextNavigationGroup")),
            class: "w-12 h-12 flex justify-center items-center conf-nav-btn border-2 border-grey-light rounded-full transition duration-300"
          }, _hoisted_322)) : createCommentVNode("v-if", true),
          !$options.showNextQuestion && !$options.showNextGroup ? (openBlock(), createElementBlock("div", _hoisted_332, _hoisted_352)) : createCommentVNode("v-if", true)
        ])
      ])
    ]);
  }

  // source/configurator/components/Questions.vue
  Questions_default.render = render10;
  Questions_default.__file = "source/configurator/components/Questions.vue";
  var Questions_default2 = Questions_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/SubwayNavStop.vue?type=script
  var SubwayNavStop_default = {
    name: "SubwayNavStop",
    emits: ["selectNavigationGroup"],
    props: {
      category: String,
      navigation: Object,
      i: Number
    },
    computed: {
      activeStop() {
        return this.i + 1 == this.navigation.group;
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/SubwayNavStop.vue?type=template
  var _hoisted_115 = { class: "link flex items-center" };
  var _hoisted_214 = { key: 0 };
  function render11(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: "pb-2 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("selectNavigationGroup"))
    }, [
      createBaseVNode("h2", _hoisted_115, [
        createBaseVNode("span", {
          class: normalizeClass([[$options.activeStop ? "border-brand" : "border-transparent"], "w-8 h-8 min-w-8 min-h-8 rounded-full border flex justify-center items-center mr-1"])
        }, [
          $props.i < 8 ? (openBlock(), createElementBlock("span", _hoisted_214, " 0 ")) : createCommentVNode("v-if", true),
          createTextVNode(" " + toDisplayString($props.i + 2), 1)
        ], 2),
        createBaseVNode("span", {
          class: normalizeClass([$options.activeStop ? "text-blue" : "text-brand"])
        }, toDisplayString($props.category), 3)
      ])
    ]);
  }

  // source/configurator/components/SubwayNavStop.vue
  SubwayNavStop_default.render = render11;
  SubwayNavStop_default.__file = "source/configurator/components/SubwayNavStop.vue";
  var SubwayNavStop_default2 = SubwayNavStop_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/SubwayNav.vue?type=script
  var SubwayNav_default = {
    name: "SubwayNav",
    emits: ["selectNavigationGroup"],
    components: {
      SubwayNavStop: SubwayNavStop_default2
    },
    props: {
      computedQuestionGroups: Object,
      navigation: Object,
      userSelections: Object,
      vanGroup: String,
      activePackageTitle: String,
      activeVanTitle: String,
      activeVanYear: [Number, String],
      allQuestionGroupCategories: Array
    },
    data() {
      return {
        expandSubwayNav: false
      };
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/SubwayNav.vue?type=template
  var _hoisted_116 = { class: "subway-nav lg:mt-7 lg:mb-28 relative lg:max-w-68 w-full z-50 order-2 -lg:border-b border-brand" };
  var _hoisted_215 = { class: "subway-nav__header lg:bg-brand-ada bg-grey-bg lg:text-white text-brand p-5 relative z-50" };
  var _hoisted_37 = { class: "flex justify-between items-center" };
  var _hoisted_47 = { class: "leading-none intro mb-1" };
  var _hoisted_57 = /* @__PURE__ */ createStaticVNode(' Menu <svg class="ml-2 icon-caret" width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="1.25" cy="9.81519" r="1.25" transform="rotate(90 1.25 9.81519)" fill="white"></circle><circle cx="5.75" cy="9.81519" r="1.25" transform="rotate(90 5.75 9.81519)" fill="white"></circle><circle cx="10.25" cy="9.81519" r="1.25" transform="rotate(90 10.25 9.81519)" fill="white"></circle><line x1="0.585938" y1="13.5962" x2="11" y2="13.5962" stroke="white" stroke-linecap="round"></line></svg>', 2);
  var _hoisted_75 = [
    _hoisted_57
  ];
  var _hoisted_85 = {
    key: 0,
    class: "link"
  };
  var _hoisted_94 = {
    key: 1,
    class: "link"
  };
  var _hoisted_104 = /* @__PURE__ */ createBaseVNode("span", { class: "text-blue-ada mx-1" }, "/", -1);
  var _hoisted_117 = { class: "link flex items-center" };
  var _hoisted_124 = { class: "link flex items-center text-grey-md" };
  var _hoisted_134 = { class: "w-8 h-8 min-w-8 min-h-8 flex justify-center items-center mr-1" };
  var _hoisted_143 = { key: 0 };
  function render12(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SubwayNavStop = resolveComponent("SubwayNavStop");
    return openBlock(), createElementBlock("div", _hoisted_116, [
      createBaseVNode("div", _hoisted_215, [
        createBaseVNode("div", _hoisted_37, [
          createBaseVNode("h1", _hoisted_47, toDisplayString($props.activePackageTitle), 1),
          createBaseVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event) => $data.expandSubwayNav = !$data.expandSubwayNav),
            class: "lg:hidden cursor-pointer bg-blue hover:bg-brand transition duration-300 rounded-md px-6 py-3 link link-no-effect text-white flex item-center"
          }, _hoisted_75),
          createCommentVNode(` <svg
				:class="[ expandSubwayNav ? '' : 'open']"
				class="ml-2 icon-caret text-white lg:hidden" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8 7.5L4 0L0 7.5H8Z" fill="currentColor"/>
			</svg> `)
        ]),
        createBaseVNode("div", null, [
          $props.activeVanTitle ? (openBlock(), createElementBlock("span", _hoisted_85, toDisplayString($props.activeVanTitle), 1)) : createCommentVNode("v-if", true),
          $props.activeVanYear ? (openBlock(), createElementBlock("span", _hoisted_94, [
            _hoisted_104,
            createTextVNode(" " + toDisplayString($props.activeVanYear), 1)
          ])) : createCommentVNode("v-if", true)
        ])
      ]),
      createBaseVNode("div", {
        class: normalizeClass([[$data.expandSubwayNav ? "-lg:left-0 -lg:translate-x-0" : "-lg:translate-x-full -lg:hidden"], "w-full p-5 bg-white text-brand-ada subway-nav__body overflow-hidden transform transition-tranform duration-300"])
      }, [
        createBaseVNode("div", {
          class: "pb-2 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("selectNavigationGroup", 0))
        }, [
          createBaseVNode("h2", _hoisted_117, [
            createBaseVNode("span", {
              class: normalizeClass([[$props.navigation.group === 0 ? "border-brand" : "border-transparent"], "w-8 h-8 min-w-8 min-h-8 rounded-full border flex justify-center items-center mr-1"])
            }, " 01 ", 2),
            createBaseVNode("span", {
              class: normalizeClass([$props.navigation.group === 0 ? "text-blue" : "text-brand"])
            }, "Van Model", 2)
          ])
        ]),
        createVNode(TransitionGroup, {
          appear: "",
          name: "fade"
        }, {
          default: withCtx(() => [
            $props.vanGroup ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList($props.userSelections.questionGroups[$props.vanGroup], (questionGroup, i3) => {
              return openBlock(), createElementBlock("div", { key: i3 }, [
                createVNode(_component_SubwayNavStop, {
                  onSelectNavigationGroup: ($event) => _ctx.$emit("selectNavigationGroup", i3 + 1),
                  category: questionGroup.category,
                  navigation: $props.navigation,
                  i: i3
                }, null, 8, ["onSelectNavigationGroup", "category", "navigation", "i"])
              ]);
            }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList($props.allQuestionGroupCategories, (categoryName, i3) => {
              return openBlock(), createElementBlock("div", {
                class: "cursor-default pb-2",
                key: i3
              }, [
                createBaseVNode("h2", _hoisted_124, [
                  createBaseVNode("span", _hoisted_134, [
                    i3 < 8 ? (openBlock(), createElementBlock("span", _hoisted_143, " 0 ")) : createCommentVNode("v-if", true),
                    createTextVNode(" " + toDisplayString(i3 + 2), 1)
                  ]),
                  createBaseVNode("span", null, toDisplayString(categoryName), 1)
                ])
              ]);
            }), 128))
          ]),
          _: 1
        })
      ], 2)
    ]);
  }

  // source/configurator/components/SubwayNav.vue
  SubwayNav_default.render = render12;
  SubwayNav_default.__file = "source/configurator/components/SubwayNav.vue";
  var SubwayNav_default2 = SubwayNav_default;

  // node_modules/@babel/runtime/helpers/esm/typeof.js
  function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof(obj);
  }

  // node_modules/fflate/esm/browser.js
  var u8 = Uint8Array;
  var u16 = Uint16Array;
  var u32 = Uint32Array;
  var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]);
  var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]);
  var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  var freb = function(eb, start2) {
    var b2 = new u16(31);
    for (var i3 = 0; i3 < 31; ++i3) {
      b2[i3] = start2 += 1 << eb[i3 - 1];
    }
    var r2 = new u32(b2[30]);
    for (var i3 = 1; i3 < 30; ++i3) {
      for (var j2 = b2[i3]; j2 < b2[i3 + 1]; ++j2) {
        r2[j2] = j2 - b2[i3] << 5 | i3;
      }
    }
    return [b2, r2];
  };
  var _a2 = freb(fleb, 2);
  var fl = _a2[0];
  var revfl = _a2[1];
  fl[28] = 258, revfl[258] = 28;
  var _b = freb(fdeb, 0);
  var fd = _b[0];
  var revfd = _b[1];
  var rev = new u16(32768);
  for (i3 = 0; i3 < 32768; ++i3) {
    x2 = (i3 & 43690) >>> 1 | (i3 & 21845) << 1;
    x2 = (x2 & 52428) >>> 2 | (x2 & 13107) << 2;
    x2 = (x2 & 61680) >>> 4 | (x2 & 3855) << 4;
    rev[i3] = ((x2 & 65280) >>> 8 | (x2 & 255) << 8) >>> 1;
  }
  var x2;
  var i3;
  var hMap = function(cd, mb, r2) {
    var s3 = cd.length;
    var i3 = 0;
    var l3 = new u16(mb);
    for (; i3 < s3; ++i3)
      ++l3[cd[i3] - 1];
    var le2 = new u16(mb);
    for (i3 = 0; i3 < mb; ++i3) {
      le2[i3] = le2[i3 - 1] + l3[i3 - 1] << 1;
    }
    var co;
    if (r2) {
      co = new u16(1 << mb);
      var rvb = 15 - mb;
      for (i3 = 0; i3 < s3; ++i3) {
        if (cd[i3]) {
          var sv = i3 << 4 | cd[i3];
          var r_1 = mb - cd[i3];
          var v3 = le2[cd[i3] - 1]++ << r_1;
          for (var m4 = v3 | (1 << r_1) - 1; v3 <= m4; ++v3) {
            co[rev[v3] >>> rvb] = sv;
          }
        }
      }
    } else {
      co = new u16(s3);
      for (i3 = 0; i3 < s3; ++i3)
        co[i3] = rev[le2[cd[i3] - 1]++] >>> 15 - cd[i3];
    }
    return co;
  };
  var flt = new u8(288);
  for (i3 = 0; i3 < 144; ++i3)
    flt[i3] = 8;
  var i3;
  for (i3 = 144; i3 < 256; ++i3)
    flt[i3] = 9;
  var i3;
  for (i3 = 256; i3 < 280; ++i3)
    flt[i3] = 7;
  var i3;
  for (i3 = 280; i3 < 288; ++i3)
    flt[i3] = 8;
  var i3;
  var fdt = new u8(32);
  for (i3 = 0; i3 < 32; ++i3)
    fdt[i3] = 5;
  var i3;
  var flm = /* @__PURE__ */ hMap(flt, 9, 0);
  var flrm = /* @__PURE__ */ hMap(flt, 9, 1);
  var fdm = /* @__PURE__ */ hMap(fdt, 5, 0);
  var fdrm = /* @__PURE__ */ hMap(fdt, 5, 1);
  var max = function(a3) {
    var m4 = a3[0];
    for (var i3 = 1; i3 < a3.length; ++i3) {
      if (a3[i3] > m4)
        m4 = a3[i3];
    }
    return m4;
  };
  var bits = function(d2, p4, m4) {
    var o3 = p4 / 8 >> 0;
    return (d2[o3] | d2[o3 + 1] << 8) >>> (p4 & 7) & m4;
  };
  var bits16 = function(d2, p4) {
    var o3 = p4 / 8 >> 0;
    return (d2[o3] | d2[o3 + 1] << 8 | d2[o3 + 2] << 16) >>> (p4 & 7);
  };
  var shft = function(p4) {
    return (p4 / 8 >> 0) + (p4 & 7 && 1);
  };
  var slc = function(v3, s3, e2) {
    if (s3 == null || s3 < 0)
      s3 = 0;
    if (e2 == null || e2 > v3.length)
      e2 = v3.length;
    var n3 = new (v3 instanceof u16 ? u16 : v3 instanceof u32 ? u32 : u8)(e2 - s3);
    n3.set(v3.subarray(s3, e2));
    return n3;
  };
  var inflt = function(dat, buf, st2) {
    var sl = dat.length;
    var noBuf = !buf || st2;
    var noSt = !st2 || st2.i;
    if (!st2)
      st2 = {};
    if (!buf)
      buf = new u8(sl * 3);
    var cbuf = function(l4) {
      var bl = buf.length;
      if (l4 > bl) {
        var nbuf = new u8(Math.max(bl * 2, l4));
        nbuf.set(buf);
        buf = nbuf;
      }
    };
    var final = st2.f || 0, pos = st2.p || 0, bt2 = st2.b || 0, lm = st2.l, dm = st2.d, lbt = st2.m, dbt = st2.n;
    var tbts = sl * 8;
    do {
      if (!lm) {
        st2.f = final = bits(dat, pos, 1);
        var type = bits(dat, pos + 1, 3);
        pos += 3;
        if (!type) {
          var s3 = shft(pos) + 4, l3 = dat[s3 - 4] | dat[s3 - 3] << 8, t3 = s3 + l3;
          if (t3 > sl) {
            if (noSt)
              throw "unexpected EOF";
            break;
          }
          if (noBuf)
            cbuf(bt2 + l3);
          buf.set(dat.subarray(s3, t3), bt2);
          st2.b = bt2 += l3, st2.p = pos = t3 * 8;
          continue;
        } else if (type == 1)
          lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
        else if (type == 2) {
          var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
          var tl = hLit + bits(dat, pos + 5, 31) + 1;
          pos += 14;
          var ldt = new u8(tl);
          var clt = new u8(19);
          for (var i3 = 0; i3 < hcLen; ++i3) {
            clt[clim[i3]] = bits(dat, pos + i3 * 3, 7);
          }
          pos += hcLen * 3;
          var clb = max(clt), clbmsk = (1 << clb) - 1;
          if (!noSt && pos + tl * (clb + 7) > tbts)
            break;
          var clm = hMap(clt, clb, 1);
          for (var i3 = 0; i3 < tl; ) {
            var r2 = clm[bits(dat, pos, clbmsk)];
            pos += r2 & 15;
            var s3 = r2 >>> 4;
            if (s3 < 16) {
              ldt[i3++] = s3;
            } else {
              var c4 = 0, n3 = 0;
              if (s3 == 16)
                n3 = 3 + bits(dat, pos, 3), pos += 2, c4 = ldt[i3 - 1];
              else if (s3 == 17)
                n3 = 3 + bits(dat, pos, 7), pos += 3;
              else if (s3 == 18)
                n3 = 11 + bits(dat, pos, 127), pos += 7;
              while (n3--)
                ldt[i3++] = c4;
            }
          }
          var lt2 = ldt.subarray(0, hLit), dt2 = ldt.subarray(hLit);
          lbt = max(lt2);
          dbt = max(dt2);
          lm = hMap(lt2, lbt, 1);
          dm = hMap(dt2, dbt, 1);
        } else
          throw "invalid block type";
        if (pos > tbts)
          throw "unexpected EOF";
      }
      if (noBuf)
        cbuf(bt2 + 131072);
      var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
      var mxa = lbt + dbt + 18;
      while (noSt || pos + mxa < tbts) {
        var c4 = lm[bits16(dat, pos) & lms], sym = c4 >>> 4;
        pos += c4 & 15;
        if (pos > tbts)
          throw "unexpected EOF";
        if (!c4)
          throw "invalid length/literal";
        if (sym < 256)
          buf[bt2++] = sym;
        else if (sym == 256) {
          lm = null;
          break;
        } else {
          var add3 = sym - 254;
          if (sym > 264) {
            var i3 = sym - 257, b2 = fleb[i3];
            add3 = bits(dat, pos, (1 << b2) - 1) + fl[i3];
            pos += b2;
          }
          var d2 = dm[bits16(dat, pos) & dms], dsym = d2 >>> 4;
          if (!d2)
            throw "invalid distance";
          pos += d2 & 15;
          var dt2 = fd[dsym];
          if (dsym > 3) {
            var b2 = fdeb[dsym];
            dt2 += bits16(dat, pos) & (1 << b2) - 1, pos += b2;
          }
          if (pos > tbts)
            throw "unexpected EOF";
          if (noBuf)
            cbuf(bt2 + 131072);
          var end = bt2 + add3;
          for (; bt2 < end; bt2 += 4) {
            buf[bt2] = buf[bt2 - dt2];
            buf[bt2 + 1] = buf[bt2 + 1 - dt2];
            buf[bt2 + 2] = buf[bt2 + 2 - dt2];
            buf[bt2 + 3] = buf[bt2 + 3 - dt2];
          }
          bt2 = end;
        }
      }
      st2.l = lm, st2.p = pos, st2.b = bt2;
      if (lm)
        final = 1, st2.m = lbt, st2.d = dm, st2.n = dbt;
    } while (!final);
    return bt2 == buf.length ? buf : slc(buf, 0, bt2);
  };
  var wbits = function(d2, p4, v3) {
    v3 <<= p4 & 7;
    var o3 = p4 / 8 >> 0;
    d2[o3] |= v3;
    d2[o3 + 1] |= v3 >>> 8;
  };
  var wbits16 = function(d2, p4, v3) {
    v3 <<= p4 & 7;
    var o3 = p4 / 8 >> 0;
    d2[o3] |= v3;
    d2[o3 + 1] |= v3 >>> 8;
    d2[o3 + 2] |= v3 >>> 16;
  };
  var hTree = function(d2, mb) {
    var t3 = [];
    for (var i3 = 0; i3 < d2.length; ++i3) {
      if (d2[i3])
        t3.push({ s: i3, f: d2[i3] });
    }
    var s3 = t3.length;
    var t22 = t3.slice();
    if (!s3)
      return [new u8(0), 0];
    if (s3 == 1) {
      var v3 = new u8(t3[0].s + 1);
      v3[t3[0].s] = 1;
      return [v3, 1];
    }
    t3.sort(function(a3, b2) {
      return a3.f - b2.f;
    });
    t3.push({ s: -1, f: 25001 });
    var l3 = t3[0], r2 = t3[1], i0 = 0, i1 = 1, i22 = 2;
    t3[0] = { s: -1, f: l3.f + r2.f, l: l3, r: r2 };
    while (i1 != s3 - 1) {
      l3 = t3[t3[i0].f < t3[i22].f ? i0++ : i22++];
      r2 = t3[i0 != i1 && t3[i0].f < t3[i22].f ? i0++ : i22++];
      t3[i1++] = { s: -1, f: l3.f + r2.f, l: l3, r: r2 };
    }
    var maxSym = t22[0].s;
    for (var i3 = 1; i3 < s3; ++i3) {
      if (t22[i3].s > maxSym)
        maxSym = t22[i3].s;
    }
    var tr = new u16(maxSym + 1);
    var mbt = ln(t3[i1 - 1], tr, 0);
    if (mbt > mb) {
      var i3 = 0, dt2 = 0;
      var lft = mbt - mb, cst = 1 << lft;
      t22.sort(function(a3, b2) {
        return tr[b2.s] - tr[a3.s] || a3.f - b2.f;
      });
      for (; i3 < s3; ++i3) {
        var i2_1 = t22[i3].s;
        if (tr[i2_1] > mb) {
          dt2 += cst - (1 << mbt - tr[i2_1]);
          tr[i2_1] = mb;
        } else
          break;
      }
      dt2 >>>= lft;
      while (dt2 > 0) {
        var i2_2 = t22[i3].s;
        if (tr[i2_2] < mb)
          dt2 -= 1 << mb - tr[i2_2]++ - 1;
        else
          ++i3;
      }
      for (; i3 >= 0 && dt2; --i3) {
        var i2_3 = t22[i3].s;
        if (tr[i2_3] == mb) {
          --tr[i2_3];
          ++dt2;
        }
      }
      mbt = mb;
    }
    return [new u8(tr), mbt];
  };
  var ln = function(n3, l3, d2) {
    return n3.s == -1 ? Math.max(ln(n3.l, l3, d2 + 1), ln(n3.r, l3, d2 + 1)) : l3[n3.s] = d2;
  };
  var lc = function(c4) {
    var s3 = c4.length;
    while (s3 && !c4[--s3])
      ;
    var cl = new u16(++s3);
    var cli = 0, cln = c4[0], cls = 1;
    var w2 = function(v3) {
      cl[cli++] = v3;
    };
    for (var i3 = 1; i3 <= s3; ++i3) {
      if (c4[i3] == cln && i3 != s3)
        ++cls;
      else {
        if (!cln && cls > 2) {
          for (; cls > 138; cls -= 138)
            w2(32754);
          if (cls > 2) {
            w2(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
            cls = 0;
          }
        } else if (cls > 3) {
          w2(cln), --cls;
          for (; cls > 6; cls -= 6)
            w2(8304);
          if (cls > 2)
            w2(cls - 3 << 5 | 8208), cls = 0;
        }
        while (cls--)
          w2(cln);
        cls = 1;
        cln = c4[i3];
      }
    }
    return [cl.subarray(0, cli), s3];
  };
  var clen = function(cf, cl) {
    var l3 = 0;
    for (var i3 = 0; i3 < cl.length; ++i3)
      l3 += cf[i3] * cl[i3];
    return l3;
  };
  var wfblk = function(out, pos, dat) {
    var s3 = dat.length;
    var o3 = shft(pos + 2);
    out[o3] = s3 & 255;
    out[o3 + 1] = s3 >>> 8;
    out[o3 + 2] = out[o3] ^ 255;
    out[o3 + 3] = out[o3 + 1] ^ 255;
    for (var i3 = 0; i3 < s3; ++i3)
      out[o3 + i3 + 4] = dat[i3];
    return (o3 + 4 + s3) * 8;
  };
  var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p4) {
    wbits(out, p4++, final);
    ++lf[256];
    var _a3 = hTree(lf, 15), dlt = _a3[0], mlb = _a3[1];
    var _b2 = hTree(df, 15), ddt = _b2[0], mdb = _b2[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i3 = 0; i3 < lclt.length; ++i3)
      lcfreq[lclt[i3] & 31]++;
    for (var i3 = 0; i3 < lcdt.length; ++i3)
      lcfreq[lcdt[i3] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
      ;
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
      return wfblk(out, p4, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p4, 1 + (dtlen < ftlen)), p4 += 2;
    if (dtlen < ftlen) {
      lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
      var llm = hMap(lct, mlcb, 0);
      wbits(out, p4, nlc - 257);
      wbits(out, p4 + 5, ndc - 1);
      wbits(out, p4 + 10, nlcc - 4);
      p4 += 14;
      for (var i3 = 0; i3 < nlcc; ++i3)
        wbits(out, p4 + 3 * i3, lct[clim[i3]]);
      p4 += 3 * nlcc;
      var lcts = [lclt, lcdt];
      for (var it2 = 0; it2 < 2; ++it2) {
        var clct = lcts[it2];
        for (var i3 = 0; i3 < clct.length; ++i3) {
          var len = clct[i3] & 31;
          wbits(out, p4, llm[len]), p4 += lct[len];
          if (len > 15)
            wbits(out, p4, clct[i3] >>> 5 & 127), p4 += clct[i3] >>> 12;
        }
      }
    } else {
      lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i3 = 0; i3 < li; ++i3) {
      if (syms[i3] > 255) {
        var len = syms[i3] >>> 18 & 31;
        wbits16(out, p4, lm[len + 257]), p4 += ll[len + 257];
        if (len > 7)
          wbits(out, p4, syms[i3] >>> 23 & 31), p4 += fleb[len];
        var dst = syms[i3] & 31;
        wbits16(out, p4, dm[dst]), p4 += dl[dst];
        if (dst > 3)
          wbits16(out, p4, syms[i3] >>> 5 & 8191), p4 += fdeb[dst];
      } else {
        wbits16(out, p4, lm[syms[i3]]), p4 += ll[syms[i3]];
      }
    }
    wbits16(out, p4, lm[256]);
    return p4 + ll[256];
  };
  var deo = /* @__PURE__ */ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
  var et = /* @__PURE__ */ new u8(0);
  var dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s3 = dat.length;
    var o3 = new u8(pre + s3 + 5 * (1 + Math.floor(s3 / 7e3)) + post);
    var w2 = o3.subarray(pre, o3.length - post);
    var pos = 0;
    if (!lvl || s3 < 8) {
      for (var i3 = 0; i3 <= s3; i3 += 65535) {
        var e2 = i3 + 65535;
        if (e2 < s3) {
          pos = wfblk(w2, pos, dat.subarray(i3, e2));
        } else {
          w2[i3] = lst;
          pos = wfblk(w2, pos, dat.subarray(i3, s3));
        }
      }
    } else {
      var opt = deo[lvl - 1];
      var n3 = opt >>> 13, c4 = opt & 8191;
      var msk_1 = (1 << plvl) - 1;
      var prev2 = new u16(32768), head = new u16(msk_1 + 1);
      var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
      var hsh = function(i4) {
        return (dat[i4] ^ dat[i4 + 1] << bs1_1 ^ dat[i4 + 2] << bs2_1) & msk_1;
      };
      var syms = new u32(25e3);
      var lf = new u16(288), df = new u16(32);
      var lc_1 = 0, eb = 0, i3 = 0, li = 0, wi = 0, bs = 0;
      for (; i3 < s3; ++i3) {
        var hv = hsh(i3);
        var imod = i3 & 32767;
        var pimod = head[hv];
        prev2[imod] = pimod;
        head[hv] = imod;
        if (wi <= i3) {
          var rem = s3 - i3;
          if ((lc_1 > 7e3 || li > 24576) && rem > 423) {
            pos = wblk(dat, w2, 0, syms, lf, df, eb, li, bs, i3 - bs, pos);
            li = lc_1 = eb = 0, bs = i3;
            for (var j2 = 0; j2 < 286; ++j2)
              lf[j2] = 0;
            for (var j2 = 0; j2 < 30; ++j2)
              df[j2] = 0;
          }
          var l3 = 2, d2 = 0, ch_1 = c4, dif = imod - pimod & 32767;
          if (rem > 2 && hv == hsh(i3 - dif)) {
            var maxn = Math.min(n3, rem) - 1;
            var maxd = Math.min(32767, i3);
            var ml = Math.min(258, rem);
            while (dif <= maxd && --ch_1 && imod != pimod) {
              if (dat[i3 + l3] == dat[i3 + l3 - dif]) {
                var nl = 0;
                for (; nl < ml && dat[i3 + nl] == dat[i3 + nl - dif]; ++nl)
                  ;
                if (nl > l3) {
                  l3 = nl, d2 = dif;
                  if (nl > maxn)
                    break;
                  var mmd = Math.min(dif, nl - 2);
                  var md = 0;
                  for (var j2 = 0; j2 < mmd; ++j2) {
                    var ti = i3 - dif + j2 + 32768 & 32767;
                    var pti = prev2[ti];
                    var cd = ti - pti + 32768 & 32767;
                    if (cd > md)
                      md = cd, pimod = ti;
                  }
                }
              }
              imod = pimod, pimod = prev2[imod];
              dif += imod - pimod + 32768 & 32767;
            }
          }
          if (d2) {
            syms[li++] = 268435456 | revfl[l3] << 18 | revfd[d2];
            var lin = revfl[l3] & 31, din = revfd[d2] & 31;
            eb += fleb[lin] + fdeb[din];
            ++lf[257 + lin];
            ++df[din];
            wi = i3 + l3;
            ++lc_1;
          } else {
            syms[li++] = dat[i3];
            ++lf[dat[i3]];
          }
        }
      }
      pos = wblk(dat, w2, lst, syms, lf, df, eb, li, bs, i3 - bs, pos);
      if (!lst)
        pos = wfblk(w2, pos, et);
    }
    return slc(o3, 0, pre + shft(pos) + post);
  };
  var adler = function() {
    var a3 = 1, b2 = 0;
    return {
      p: function(d2) {
        var n3 = a3, m4 = b2;
        var l3 = d2.length;
        for (var i3 = 0; i3 != l3; ) {
          var e2 = Math.min(i3 + 5552, l3);
          for (; i3 < e2; ++i3)
            n3 += d2[i3], m4 += n3;
          n3 %= 65521, m4 %= 65521;
        }
        a3 = n3, b2 = m4;
      },
      d: function() {
        return (a3 >>> 8 << 16 | (b2 & 255) << 8 | b2 >>> 8) + ((a3 & 255) << 23) * 2;
      }
    };
  };
  var dopt = function(dat, opt, pre, post, st2) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st2);
  };
  var wbytes = function(d2, b2, v3) {
    for (; v3; ++b2)
      d2[b2] = v3, v3 >>>= 8;
  };
  var zlh = function(c4, o3) {
    var lv = o3.level, fl2 = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c4[0] = 120, c4[1] = fl2 << 6 | (fl2 ? 32 - 2 * fl2 : 1);
  };
  var zlv = function(d2) {
    if ((d2[0] & 15) != 8 || d2[0] >>> 4 > 7 || (d2[0] << 8 | d2[1]) % 31)
      throw "invalid zlib data";
    if (d2[1] & 32)
      throw "invalid zlib data: preset dictionaries not supported";
  };
  function zlibSync(data2, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var a3 = adler();
    a3.p(data2);
    var d2 = dopt(data2, opts, 2, 4);
    return zlh(d2, opts), wbytes(d2, d2.length - 4, a3.d()), d2;
  }
  function unzlibSync(data2, out) {
    return inflt((zlv(data2), data2.subarray(2, -4)), out);
  }

  // node_modules/jspdf/dist/jspdf.es.min.js
  var n2 = function() {
    return typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this;
  }();
  function i2() {
    n2.console && typeof n2.console.log == "function" && n2.console.log.apply(n2.console, arguments);
  }
  var a2 = { log: i2, warn: function(t3) {
    n2.console && (typeof n2.console.warn == "function" ? n2.console.warn.apply(n2.console, arguments) : i2.call(null, arguments));
  }, error: function(t3) {
    n2.console && (typeof n2.console.error == "function" ? n2.console.error.apply(n2.console, arguments) : i2(t3));
  } };
  function o2(t3, e2, r2) {
    var n3 = new XMLHttpRequest();
    n3.open("GET", t3), n3.responseType = "blob", n3.onload = function() {
      l2(n3.response, e2, r2);
    }, n3.onerror = function() {
      a2.error("could not download file");
    }, n3.send();
  }
  function s2(t3) {
    var e2 = new XMLHttpRequest();
    e2.open("HEAD", t3, false);
    try {
      e2.send();
    } catch (t4) {
    }
    return e2.status >= 200 && e2.status <= 299;
  }
  function c3(t3) {
    try {
      t3.dispatchEvent(new MouseEvent("click"));
    } catch (r2) {
      var e2 = document.createEvent("MouseEvents");
      e2.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null), t3.dispatchEvent(e2);
    }
  }
  var u2;
  var h3;
  var l2 = n2.saveAs || ((typeof window == "undefined" ? "undefined" : _typeof(window)) !== "object" || window !== n2 ? function() {
  } : typeof HTMLAnchorElement != "undefined" && "download" in HTMLAnchorElement.prototype ? function(t3, e2, r2) {
    var i3 = n2.URL || n2.webkitURL, a3 = document.createElement("a");
    e2 = e2 || t3.name || "download", a3.download = e2, a3.rel = "noopener", typeof t3 == "string" ? (a3.href = t3, a3.origin !== location.origin ? s2(a3.href) ? o2(t3, e2, r2) : c3(a3, a3.target = "_blank") : c3(a3)) : (a3.href = i3.createObjectURL(t3), setTimeout(function() {
      i3.revokeObjectURL(a3.href);
    }, 4e4), setTimeout(function() {
      c3(a3);
    }, 0));
  } : "msSaveOrOpenBlob" in navigator ? function(e2, r2, n3) {
    if (r2 = r2 || e2.name || "download", typeof e2 == "string")
      if (s2(e2))
        o2(e2, r2, n3);
      else {
        var i3 = document.createElement("a");
        i3.href = e2, i3.target = "_blank", setTimeout(function() {
          c3(i3);
        });
      }
    else
      navigator.msSaveOrOpenBlob(function(e3, r3) {
        return r3 === void 0 ? r3 = { autoBom: false } : _typeof(r3) !== "object" && (a2.warn("Deprecated: Expected third argument to be a object"), r3 = { autoBom: !r3 }), r3.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e3.type) ? new Blob([String.fromCharCode(65279), e3], { type: e3.type }) : e3;
      }(e2, n3), r2);
  } : function(e2, r2, i3, a3) {
    if ((a3 = a3 || open("", "_blank")) && (a3.document.title = a3.document.body.innerText = "downloading..."), typeof e2 == "string")
      return o2(e2, r2, i3);
    var s3 = e2.type === "application/octet-stream", c4 = /constructor/i.test(n2.HTMLElement) || n2.safari, u3 = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u3 || s3 && c4) && (typeof FileReader == "undefined" ? "undefined" : _typeof(FileReader)) === "object") {
      var h4 = new FileReader();
      h4.onloadend = function() {
        var t3 = h4.result;
        t3 = u3 ? t3 : t3.replace(/^data:[^;]*;/, "data:attachment/file;"), a3 ? a3.location.href = t3 : location = t3, a3 = null;
      }, h4.readAsDataURL(e2);
    } else {
      var l3 = n2.URL || n2.webkitURL, f3 = l3.createObjectURL(e2);
      a3 ? a3.location = f3 : location.href = f3, a3 = null, setTimeout(function() {
        l3.revokeObjectURL(f3);
      }, 4e4);
    }
  });
  function f2(t3) {
    var e2;
    t3 = t3 || "", this.ok = false, t3.charAt(0) == "#" && (t3 = t3.substr(1, 6));
    t3 = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[t3 = (t3 = t3.replace(/ /g, "")).toLowerCase()] || t3;
    for (var r2 = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(t4) {
      return [parseInt(t4[1]), parseInt(t4[2]), parseInt(t4[3])];
    } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(t4) {
      return [parseInt(t4[1], 16), parseInt(t4[2], 16), parseInt(t4[3], 16)];
    } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(t4) {
      return [parseInt(t4[1] + t4[1], 16), parseInt(t4[2] + t4[2], 16), parseInt(t4[3] + t4[3], 16)];
    } }], n3 = 0; n3 < r2.length; n3++) {
      var i3 = r2[n3].re, a3 = r2[n3].process, o3 = i3.exec(t3);
      o3 && (e2 = a3(o3), this.r = e2[0], this.g = e2[1], this.b = e2[2], this.ok = true);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
      var t4 = this.r.toString(16), e3 = this.g.toString(16), r3 = this.b.toString(16);
      return t4.length == 1 && (t4 = "0" + t4), e3.length == 1 && (e3 = "0" + e3), r3.length == 1 && (r3 = "0" + r3), "#" + t4 + e3 + r3;
    };
  }
  function d(t3, e2) {
    var r2 = t3[0], n3 = t3[1], i3 = t3[2], a3 = t3[3];
    r2 = g(r2, n3, i3, a3, e2[0], 7, -680876936), a3 = g(a3, r2, n3, i3, e2[1], 12, -389564586), i3 = g(i3, a3, r2, n3, e2[2], 17, 606105819), n3 = g(n3, i3, a3, r2, e2[3], 22, -1044525330), r2 = g(r2, n3, i3, a3, e2[4], 7, -176418897), a3 = g(a3, r2, n3, i3, e2[5], 12, 1200080426), i3 = g(i3, a3, r2, n3, e2[6], 17, -1473231341), n3 = g(n3, i3, a3, r2, e2[7], 22, -45705983), r2 = g(r2, n3, i3, a3, e2[8], 7, 1770035416), a3 = g(a3, r2, n3, i3, e2[9], 12, -1958414417), i3 = g(i3, a3, r2, n3, e2[10], 17, -42063), n3 = g(n3, i3, a3, r2, e2[11], 22, -1990404162), r2 = g(r2, n3, i3, a3, e2[12], 7, 1804603682), a3 = g(a3, r2, n3, i3, e2[13], 12, -40341101), i3 = g(i3, a3, r2, n3, e2[14], 17, -1502002290), r2 = m3(r2, n3 = g(n3, i3, a3, r2, e2[15], 22, 1236535329), i3, a3, e2[1], 5, -165796510), a3 = m3(a3, r2, n3, i3, e2[6], 9, -1069501632), i3 = m3(i3, a3, r2, n3, e2[11], 14, 643717713), n3 = m3(n3, i3, a3, r2, e2[0], 20, -373897302), r2 = m3(r2, n3, i3, a3, e2[5], 5, -701558691), a3 = m3(a3, r2, n3, i3, e2[10], 9, 38016083), i3 = m3(i3, a3, r2, n3, e2[15], 14, -660478335), n3 = m3(n3, i3, a3, r2, e2[4], 20, -405537848), r2 = m3(r2, n3, i3, a3, e2[9], 5, 568446438), a3 = m3(a3, r2, n3, i3, e2[14], 9, -1019803690), i3 = m3(i3, a3, r2, n3, e2[3], 14, -187363961), n3 = m3(n3, i3, a3, r2, e2[8], 20, 1163531501), r2 = m3(r2, n3, i3, a3, e2[13], 5, -1444681467), a3 = m3(a3, r2, n3, i3, e2[2], 9, -51403784), i3 = m3(i3, a3, r2, n3, e2[7], 14, 1735328473), r2 = v2(r2, n3 = m3(n3, i3, a3, r2, e2[12], 20, -1926607734), i3, a3, e2[5], 4, -378558), a3 = v2(a3, r2, n3, i3, e2[8], 11, -2022574463), i3 = v2(i3, a3, r2, n3, e2[11], 16, 1839030562), n3 = v2(n3, i3, a3, r2, e2[14], 23, -35309556), r2 = v2(r2, n3, i3, a3, e2[1], 4, -1530992060), a3 = v2(a3, r2, n3, i3, e2[4], 11, 1272893353), i3 = v2(i3, a3, r2, n3, e2[7], 16, -155497632), n3 = v2(n3, i3, a3, r2, e2[10], 23, -1094730640), r2 = v2(r2, n3, i3, a3, e2[13], 4, 681279174), a3 = v2(a3, r2, n3, i3, e2[0], 11, -358537222), i3 = v2(i3, a3, r2, n3, e2[3], 16, -722521979), n3 = v2(n3, i3, a3, r2, e2[6], 23, 76029189), r2 = v2(r2, n3, i3, a3, e2[9], 4, -640364487), a3 = v2(a3, r2, n3, i3, e2[12], 11, -421815835), i3 = v2(i3, a3, r2, n3, e2[15], 16, 530742520), r2 = b(r2, n3 = v2(n3, i3, a3, r2, e2[2], 23, -995338651), i3, a3, e2[0], 6, -198630844), a3 = b(a3, r2, n3, i3, e2[7], 10, 1126891415), i3 = b(i3, a3, r2, n3, e2[14], 15, -1416354905), n3 = b(n3, i3, a3, r2, e2[5], 21, -57434055), r2 = b(r2, n3, i3, a3, e2[12], 6, 1700485571), a3 = b(a3, r2, n3, i3, e2[3], 10, -1894986606), i3 = b(i3, a3, r2, n3, e2[10], 15, -1051523), n3 = b(n3, i3, a3, r2, e2[1], 21, -2054922799), r2 = b(r2, n3, i3, a3, e2[8], 6, 1873313359), a3 = b(a3, r2, n3, i3, e2[15], 10, -30611744), i3 = b(i3, a3, r2, n3, e2[6], 15, -1560198380), n3 = b(n3, i3, a3, r2, e2[13], 21, 1309151649), r2 = b(r2, n3, i3, a3, e2[4], 6, -145523070), a3 = b(a3, r2, n3, i3, e2[11], 10, -1120210379), i3 = b(i3, a3, r2, n3, e2[2], 15, 718787259), n3 = b(n3, i3, a3, r2, e2[9], 21, -343485551), t3[0] = _2(r2, t3[0]), t3[1] = _2(n3, t3[1]), t3[2] = _2(i3, t3[2]), t3[3] = _2(a3, t3[3]);
  }
  function p3(t3, e2, r2, n3, i3, a3) {
    return e2 = _2(_2(e2, t3), _2(n3, a3)), _2(e2 << i3 | e2 >>> 32 - i3, r2);
  }
  function g(t3, e2, r2, n3, i3, a3, o3) {
    return p3(e2 & r2 | ~e2 & n3, t3, e2, i3, a3, o3);
  }
  function m3(t3, e2, r2, n3, i3, a3, o3) {
    return p3(e2 & n3 | r2 & ~n3, t3, e2, i3, a3, o3);
  }
  function v2(t3, e2, r2, n3, i3, a3, o3) {
    return p3(e2 ^ r2 ^ n3, t3, e2, i3, a3, o3);
  }
  function b(t3, e2, r2, n3, i3, a3, o3) {
    return p3(r2 ^ (e2 | ~n3), t3, e2, i3, a3, o3);
  }
  function y2(t3) {
    var e2, r2 = t3.length, n3 = [1732584193, -271733879, -1732584194, 271733878];
    for (e2 = 64; e2 <= t3.length; e2 += 64)
      d(n3, w(t3.substring(e2 - 64, e2)));
    t3 = t3.substring(e2 - 64);
    var i3 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (e2 = 0; e2 < t3.length; e2++)
      i3[e2 >> 2] |= t3.charCodeAt(e2) << (e2 % 4 << 3);
    if (i3[e2 >> 2] |= 128 << (e2 % 4 << 3), e2 > 55)
      for (d(n3, i3), e2 = 0; e2 < 16; e2++)
        i3[e2] = 0;
    return i3[14] = 8 * r2, d(n3, i3), n3;
  }
  function w(t3) {
    var e2, r2 = [];
    for (e2 = 0; e2 < 64; e2 += 4)
      r2[e2 >> 2] = t3.charCodeAt(e2) + (t3.charCodeAt(e2 + 1) << 8) + (t3.charCodeAt(e2 + 2) << 16) + (t3.charCodeAt(e2 + 3) << 24);
    return r2;
  }
  u2 = n2.atob.bind(n2), h3 = n2.btoa.bind(n2);
  var N2 = "0123456789abcdef".split("");
  function L(t3) {
    for (var e2 = "", r2 = 0; r2 < 4; r2++)
      e2 += N2[t3 >> 8 * r2 + 4 & 15] + N2[t3 >> 8 * r2 & 15];
    return e2;
  }
  function A(t3) {
    return String.fromCharCode((255 & t3) >> 0, (65280 & t3) >> 8, (16711680 & t3) >> 16, (4278190080 & t3) >> 24);
  }
  function x(t3) {
    return y2(t3).map(A).join("");
  }
  var S = function(t3) {
    for (var e2 = 0; e2 < t3.length; e2++)
      t3[e2] = L(t3[e2]);
    return t3.join("");
  }(y2("hello")) != "5d41402abc4b2a76b9719d911017c592";
  function _2(t3, e2) {
    if (S) {
      var r2 = (65535 & t3) + (65535 & e2);
      return (t3 >> 16) + (e2 >> 16) + (r2 >> 16) << 16 | 65535 & r2;
    }
    return t3 + e2 & 4294967295;
  }
  function P(t3, e2) {
    var r2, n3, i3, a3;
    if (t3 !== r2) {
      for (var o3 = (i3 = t3, a3 = 1 + (256 / t3.length >> 0), new Array(a3 + 1).join(i3)), s3 = [], c4 = 0; c4 < 256; c4++)
        s3[c4] = c4;
      var u3 = 0;
      for (c4 = 0; c4 < 256; c4++) {
        var h4 = s3[c4];
        u3 = (u3 + h4 + o3.charCodeAt(c4)) % 256, s3[c4] = s3[u3], s3[u3] = h4;
      }
      r2 = t3, n3 = s3;
    } else
      s3 = n3;
    var l3 = e2.length, f3 = 0, d2 = 0, p4 = "";
    for (c4 = 0; c4 < l3; c4++)
      d2 = (d2 + (h4 = s3[f3 = (f3 + 1) % 256])) % 256, s3[f3] = s3[d2], s3[d2] = h4, o3 = s3[(s3[f3] + s3[d2]) % 256], p4 += String.fromCharCode(e2.charCodeAt(c4) ^ o3);
    return p4;
  }
  var k = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
  function I(t3, e2, r2, n3) {
    this.v = 1, this.r = 2;
    var i3 = 192;
    t3.forEach(function(t4) {
      if (k.perm !== void 0)
        throw new Error("Invalid permission: " + t4);
      i3 += k[t4];
    }), this.padding = "(\xBFN^Nu\x8AAd\0NV\xFF\xFA\b..\0\xB6\xD0h>\x80/\f\xA9\xFEdSiz";
    var a3 = (e2 + this.padding).substr(0, 32), o3 = (r2 + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a3, o3), this.P = -(1 + (255 ^ i3)), this.encryptionKey = x(a3 + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n3)).substr(0, 5), this.U = P(this.encryptionKey, this.padding);
  }
  function F(t3) {
    if (/[^\u0000-\u00ff]/.test(t3))
      throw new Error("Invalid PDF Name Object: " + t3 + ", Only accept ASCII characters.");
    for (var e2 = "", r2 = t3.length, n3 = 0; n3 < r2; n3++) {
      var i3 = t3.charCodeAt(n3);
      if (i3 < 33 || i3 === 35 || i3 === 37 || i3 === 40 || i3 === 41 || i3 === 47 || i3 === 60 || i3 === 62 || i3 === 91 || i3 === 93 || i3 === 123 || i3 === 125 || i3 > 126)
        e2 += "#" + ("0" + i3.toString(16)).slice(-2);
      else
        e2 += t3[n3];
    }
    return e2;
  }
  function C(e2) {
    if (_typeof(e2) !== "object")
      throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r2 = {};
    this.subscribe = function(t3, e3, n3) {
      if (n3 = n3 || false, typeof t3 != "string" || typeof e3 != "function" || typeof n3 != "boolean")
        throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
      r2.hasOwnProperty(t3) || (r2[t3] = {});
      var i3 = Math.random().toString(35);
      return r2[t3][i3] = [e3, !!n3], i3;
    }, this.unsubscribe = function(t3) {
      for (var e3 in r2)
        if (r2[e3][t3])
          return delete r2[e3][t3], Object.keys(r2[e3]).length === 0 && delete r2[e3], true;
      return false;
    }, this.publish = function(t3) {
      if (r2.hasOwnProperty(t3)) {
        var i3 = Array.prototype.slice.call(arguments, 1), o3 = [];
        for (var s3 in r2[t3]) {
          var c4 = r2[t3][s3];
          try {
            c4[0].apply(e2, i3);
          } catch (t4) {
            n2.console && a2.error("jsPDF PubSub Error", t4.message, t4);
          }
          c4[1] && o3.push(s3);
        }
        o3.length && o3.forEach(this.unsubscribe);
      }
    }, this.getTopics = function() {
      return r2;
    };
  }
  function j(t3) {
    if (!(this instanceof j))
      return new j(t3);
    var e2 = "opacity,stroke-opacity".split(",");
    for (var r2 in t3)
      t3.hasOwnProperty(r2) && e2.indexOf(r2) >= 0 && (this[r2] = t3[r2]);
    this.id = "", this.objectNumber = -1;
  }
  function O2(t3, e2) {
    this.gState = t3, this.matrix = e2, this.id = "", this.objectNumber = -1;
  }
  function B(t3, e2, r2, n3, i3) {
    if (!(this instanceof B))
      return new B(t3, e2, r2, n3, i3);
    this.type = t3 === "axial" ? 2 : 3, this.coords = e2, this.colors = r2, O2.call(this, n3, i3);
  }
  function E(t3, e2, r2, n3, i3) {
    if (!(this instanceof E))
      return new E(t3, e2, r2, n3, i3);
    this.boundingBox = t3, this.xStep = e2, this.yStep = r2, this.stream = "", this.cloneIndex = 0, O2.call(this, n3, i3);
  }
  function M(e2) {
    var r2, i3 = typeof arguments[0] == "string" ? arguments[0] : "p", o3 = arguments[1], s3 = arguments[2], c4 = arguments[3], u3 = [], d2 = 1, p4 = 16, g2 = "S", m4 = null;
    _typeof(e2 = e2 || {}) === "object" && (i3 = e2.orientation, o3 = e2.unit || o3, s3 = e2.format || s3, c4 = e2.compress || e2.compressPdf || c4, (m4 = e2.encryption || null) !== null && (m4.userPassword = m4.userPassword || "", m4.ownerPassword = m4.ownerPassword || "", m4.userPermissions = m4.userPermissions || []), d2 = typeof e2.userUnit == "number" ? Math.abs(e2.userUnit) : 1, e2.precision !== void 0 && (r2 = e2.precision), e2.floatPrecision !== void 0 && (p4 = e2.floatPrecision), g2 = e2.defaultPathOperation || "S"), u3 = e2.filters || (c4 === true ? ["FlateEncode"] : u3), o3 = o3 || "mm", i3 = ("" + (i3 || "P")).toLowerCase();
    var v3 = e2.putOnlyUsedFonts || false, b2 = {}, y3 = { internal: {}, __private__: {} };
    y3.__private__.PubSub = C;
    var w2 = "1.3", N3 = y3.__private__.getPdfVersion = function() {
      return w2;
    };
    y3.__private__.setPdfVersion = function(t3) {
      w2 = t3;
    };
    var L2 = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    y3.__private__.getPageFormats = function() {
      return L2;
    };
    var A2 = y3.__private__.getPageFormat = function(t3) {
      return L2[t3];
    };
    s3 = s3 || "a4";
    var x2 = { COMPAT: "compat", ADVANCED: "advanced" }, S2 = x2.COMPAT;
    function _3() {
      this.saveGraphicsState(), lt2(new Vt2(_t2, 0, 0, -_t2, 0, Dr() * _t2).toString() + " cm"), this.setFontSize(this.getFontSize() / _t2), g2 = "n", S2 = x2.ADVANCED;
    }
    function P2() {
      this.restoreGraphicsState(), g2 = "S", S2 = x2.COMPAT;
    }
    var k2 = y3.__private__.combineFontStyleAndFontWeight = function(t3, e3) {
      if (t3 == "bold" && e3 == "normal" || t3 == "bold" && e3 == 400 || t3 == "normal" && e3 == "italic" || t3 == "bold" && e3 == "italic")
        throw new Error("Invalid Combination of fontweight and fontstyle");
      return e3 && (t3 = e3 == 400 || e3 === "normal" ? t3 === "italic" ? "italic" : "normal" : e3 != 700 && e3 !== "bold" || t3 !== "normal" ? (e3 == 700 ? "bold" : e3) + "" + t3 : "bold"), t3;
    };
    y3.advancedAPI = function(t3) {
      var e3 = S2 === x2.COMPAT;
      return e3 && _3.call(this), typeof t3 != "function" || (t3(this), e3 && P2.call(this)), this;
    }, y3.compatAPI = function(t3) {
      var e3 = S2 === x2.ADVANCED;
      return e3 && P2.call(this), typeof t3 != "function" || (t3(this), e3 && _3.call(this)), this;
    }, y3.isAdvancedAPI = function() {
      return S2 === x2.ADVANCED;
    };
    var O3, q2 = function(t3) {
      if (S2 !== x2.ADVANCED)
        throw new Error(t3 + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D2 = y3.roundToPrecision = y3.__private__.roundToPrecision = function(t3, e3) {
      var n3 = r2 || e3;
      if (isNaN(t3) || isNaN(n3))
        throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
      return t3.toFixed(n3).replace(/0+$/, "");
    };
    O3 = y3.hpf = y3.__private__.hpf = typeof p4 == "number" ? function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.hpf");
      return D2(t3, p4);
    } : p4 === "smart" ? function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.hpf");
      return D2(t3, t3 > -1 && t3 < 1 ? 16 : 5);
    } : function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.hpf");
      return D2(t3, 16);
    };
    var R2 = y3.f2 = y3.__private__.f2 = function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.f2");
      return D2(t3, 2);
    }, T3 = y3.__private__.f3 = function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.f3");
      return D2(t3, 3);
    }, U2 = y3.scale = y3.__private__.scale = function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.scale");
      return S2 === x2.COMPAT ? t3 * _t2 : S2 === x2.ADVANCED ? t3 : void 0;
    }, z2 = function(t3) {
      return S2 === x2.COMPAT ? Dr() - t3 : S2 === x2.ADVANCED ? t3 : void 0;
    }, H2 = function(t3) {
      return U2(z2(t3));
    };
    y3.__private__.setPrecision = y3.setPrecision = function(t3) {
      typeof parseInt(t3, 10) == "number" && (r2 = parseInt(t3, 10));
    };
    var W2, V2 = "00000000000000000000000000000000", G2 = y3.__private__.getFileId = function() {
      return V2;
    }, Y2 = y3.__private__.setFileId = function(t3) {
      return V2 = t3 !== void 0 && /^[a-fA-F0-9]{32}$/.test(t3) ? t3.toUpperCase() : V2.split("").map(function() {
        return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
      }).join(""), m4 !== null && (Ye = new I(m4.userPermissions, m4.userPassword, m4.ownerPassword, V2)), V2;
    };
    y3.setFileId = function(t3) {
      return Y2(t3), this;
    }, y3.getFileId = function() {
      return G2();
    };
    var J2 = y3.__private__.convertDateToPDFDate = function(t3) {
      var e3 = t3.getTimezoneOffset(), r3 = e3 < 0 ? "+" : "-", n3 = Math.floor(Math.abs(e3 / 60)), i4 = Math.abs(e3 % 60), a3 = [r3, Q2(n3), "'", Q2(i4), "'"].join("");
      return ["D:", t3.getFullYear(), Q2(t3.getMonth() + 1), Q2(t3.getDate()), Q2(t3.getHours()), Q2(t3.getMinutes()), Q2(t3.getSeconds()), a3].join("");
    }, X2 = y3.__private__.convertPDFDateToDate = function(t3) {
      var e3 = parseInt(t3.substr(2, 4), 10), r3 = parseInt(t3.substr(6, 2), 10) - 1, n3 = parseInt(t3.substr(8, 2), 10), i4 = parseInt(t3.substr(10, 2), 10), a3 = parseInt(t3.substr(12, 2), 10), o4 = parseInt(t3.substr(14, 2), 10);
      return new Date(e3, r3, n3, i4, a3, o4, 0);
    }, K2 = y3.__private__.setCreationDate = function(t3) {
      var e3;
      if (t3 === void 0 && (t3 = new Date()), t3 instanceof Date)
        e3 = J2(t3);
      else {
        if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t3))
          throw new Error("Invalid argument passed to jsPDF.setCreationDate");
        e3 = t3;
      }
      return W2 = e3;
    }, Z2 = y3.__private__.getCreationDate = function(t3) {
      var e3 = W2;
      return t3 === "jsDate" && (e3 = X2(W2)), e3;
    };
    y3.setCreationDate = function(t3) {
      return K2(t3), this;
    }, y3.getCreationDate = function(t3) {
      return Z2(t3);
    };
    var $12, Q2 = y3.__private__.padd2 = function(t3) {
      return ("0" + parseInt(t3)).slice(-2);
    }, tt2 = y3.__private__.padd2Hex = function(t3) {
      return ("00" + (t3 = t3.toString())).substr(t3.length);
    }, et3 = 0, rt2 = [], nt2 = [], it2 = 0, at2 = [], ot2 = [], st2 = false, ct2 = nt2, ut2 = function() {
      et3 = 0, it2 = 0, nt2 = [], rt2 = [], at2 = [], Qt2 = Kt2(), te2 = Kt2();
    };
    y3.__private__.setCustomOutputDestination = function(t3) {
      st2 = true, ct2 = t3;
    };
    var ht2 = function(t3) {
      st2 || (ct2 = t3);
    };
    y3.__private__.resetCustomOutputDestination = function() {
      st2 = false, ct2 = nt2;
    };
    var lt2 = y3.__private__.out = function(t3) {
      return t3 = t3.toString(), it2 += t3.length + 1, ct2.push(t3), ct2;
    }, ft2 = y3.__private__.write = function(t3) {
      return lt2(arguments.length === 1 ? t3.toString() : Array.prototype.join.call(arguments, " "));
    }, dt2 = y3.__private__.getArrayBuffer = function(t3) {
      for (var e3 = t3.length, r3 = new ArrayBuffer(e3), n3 = new Uint8Array(r3); e3--; )
        n3[e3] = t3.charCodeAt(e3);
      return r3;
    }, pt2 = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
    y3.__private__.getStandardFonts = function() {
      return pt2;
    };
    var gt2 = e2.fontSize || 16;
    y3.__private__.setFontSize = y3.setFontSize = function(t3) {
      return gt2 = S2 === x2.ADVANCED ? t3 / _t2 : t3, this;
    };
    var mt2, vt2 = y3.__private__.getFontSize = y3.getFontSize = function() {
      return S2 === x2.COMPAT ? gt2 : gt2 * _t2;
    }, bt2 = e2.R2L || false;
    y3.__private__.setR2L = y3.setR2L = function(t3) {
      return bt2 = t3, this;
    }, y3.__private__.getR2L = y3.getR2L = function() {
      return bt2;
    };
    var yt2, wt2 = y3.__private__.setZoomMode = function(t3) {
      var e3 = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
      if (/^\d*\.?\d*%$/.test(t3))
        mt2 = t3;
      else if (isNaN(t3)) {
        if (e3.indexOf(t3) === -1)
          throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t3 + '" is not recognized.');
        mt2 = t3;
      } else
        mt2 = parseInt(t3, 10);
    };
    y3.__private__.getZoomMode = function() {
      return mt2;
    };
    var Nt2, Lt2 = y3.__private__.setPageMode = function(t3) {
      if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(t3) == -1)
        throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t3 + '" is not recognized.');
      yt2 = t3;
    };
    y3.__private__.getPageMode = function() {
      return yt2;
    };
    var At2 = y3.__private__.setLayoutMode = function(t3) {
      if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(t3) == -1)
        throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t3 + '" is not recognized.');
      Nt2 = t3;
    };
    y3.__private__.getLayoutMode = function() {
      return Nt2;
    }, y3.__private__.setDisplayMode = y3.setDisplayMode = function(t3, e3, r3) {
      return wt2(t3), At2(e3), Lt2(r3), this;
    };
    var xt2 = { title: "", subject: "", author: "", keywords: "", creator: "" };
    y3.__private__.getDocumentProperty = function(t3) {
      if (Object.keys(xt2).indexOf(t3) === -1)
        throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
      return xt2[t3];
    }, y3.__private__.getDocumentProperties = function() {
      return xt2;
    }, y3.__private__.setDocumentProperties = y3.setProperties = y3.setDocumentProperties = function(t3) {
      for (var e3 in xt2)
        xt2.hasOwnProperty(e3) && t3[e3] && (xt2[e3] = t3[e3]);
      return this;
    }, y3.__private__.setDocumentProperty = function(t3, e3) {
      if (Object.keys(xt2).indexOf(t3) === -1)
        throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
      return xt2[t3] = e3;
    };
    var St2, _t2, Pt2, kt2, It2, Ft2 = {}, Ct2 = {}, jt2 = [], Ot2 = {}, Bt2 = {}, Et2 = {}, Mt2 = {}, qt2 = null, Dt2 = 0, Rt2 = [], Tt2 = new C(y3), Ut2 = e2.hotfixes || [], zt2 = {}, Ht2 = {}, Wt2 = [], Vt2 = function t3(e3, r3, n3, i4, a3, o4) {
      if (!(this instanceof t3))
        return new t3(e3, r3, n3, i4, a3, o4);
      isNaN(e3) && (e3 = 1), isNaN(r3) && (r3 = 0), isNaN(n3) && (n3 = 0), isNaN(i4) && (i4 = 1), isNaN(a3) && (a3 = 0), isNaN(o4) && (o4 = 0), this._matrix = [e3, r3, n3, i4, a3, o4];
    };
    Object.defineProperty(Vt2.prototype, "sx", { get: function() {
      return this._matrix[0];
    }, set: function(t3) {
      this._matrix[0] = t3;
    } }), Object.defineProperty(Vt2.prototype, "shy", { get: function() {
      return this._matrix[1];
    }, set: function(t3) {
      this._matrix[1] = t3;
    } }), Object.defineProperty(Vt2.prototype, "shx", { get: function() {
      return this._matrix[2];
    }, set: function(t3) {
      this._matrix[2] = t3;
    } }), Object.defineProperty(Vt2.prototype, "sy", { get: function() {
      return this._matrix[3];
    }, set: function(t3) {
      this._matrix[3] = t3;
    } }), Object.defineProperty(Vt2.prototype, "tx", { get: function() {
      return this._matrix[4];
    }, set: function(t3) {
      this._matrix[4] = t3;
    } }), Object.defineProperty(Vt2.prototype, "ty", { get: function() {
      return this._matrix[5];
    }, set: function(t3) {
      this._matrix[5] = t3;
    } }), Object.defineProperty(Vt2.prototype, "a", { get: function() {
      return this._matrix[0];
    }, set: function(t3) {
      this._matrix[0] = t3;
    } }), Object.defineProperty(Vt2.prototype, "b", { get: function() {
      return this._matrix[1];
    }, set: function(t3) {
      this._matrix[1] = t3;
    } }), Object.defineProperty(Vt2.prototype, "c", { get: function() {
      return this._matrix[2];
    }, set: function(t3) {
      this._matrix[2] = t3;
    } }), Object.defineProperty(Vt2.prototype, "d", { get: function() {
      return this._matrix[3];
    }, set: function(t3) {
      this._matrix[3] = t3;
    } }), Object.defineProperty(Vt2.prototype, "e", { get: function() {
      return this._matrix[4];
    }, set: function(t3) {
      this._matrix[4] = t3;
    } }), Object.defineProperty(Vt2.prototype, "f", { get: function() {
      return this._matrix[5];
    }, set: function(t3) {
      this._matrix[5] = t3;
    } }), Object.defineProperty(Vt2.prototype, "rotation", { get: function() {
      return Math.atan2(this.shx, this.sx);
    } }), Object.defineProperty(Vt2.prototype, "scaleX", { get: function() {
      return this.decompose().scale.sx;
    } }), Object.defineProperty(Vt2.prototype, "scaleY", { get: function() {
      return this.decompose().scale.sy;
    } }), Object.defineProperty(Vt2.prototype, "isIdentity", { get: function() {
      return this.sx === 1 && (this.shy === 0 && (this.shx === 0 && (this.sy === 1 && (this.tx === 0 && this.ty === 0))));
    } }), Vt2.prototype.join = function(t3) {
      return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(O3).join(t3);
    }, Vt2.prototype.multiply = function(t3) {
      var e3 = t3.sx * this.sx + t3.shy * this.shx, r3 = t3.sx * this.shy + t3.shy * this.sy, n3 = t3.shx * this.sx + t3.sy * this.shx, i4 = t3.shx * this.shy + t3.sy * this.sy, a3 = t3.tx * this.sx + t3.ty * this.shx + this.tx, o4 = t3.tx * this.shy + t3.ty * this.sy + this.ty;
      return new Vt2(e3, r3, n3, i4, a3, o4);
    }, Vt2.prototype.decompose = function() {
      var t3 = this.sx, e3 = this.shy, r3 = this.shx, n3 = this.sy, i4 = this.tx, a3 = this.ty, o4 = Math.sqrt(t3 * t3 + e3 * e3), s4 = (t3 /= o4) * r3 + (e3 /= o4) * n3;
      r3 -= t3 * s4, n3 -= e3 * s4;
      var c5 = Math.sqrt(r3 * r3 + n3 * n3);
      return s4 /= c5, t3 * (n3 /= c5) < e3 * (r3 /= c5) && (t3 = -t3, e3 = -e3, s4 = -s4, o4 = -o4), { scale: new Vt2(o4, 0, 0, c5, 0, 0), translate: new Vt2(1, 0, 0, 1, i4, a3), rotate: new Vt2(t3, e3, -e3, t3, 0, 0), skew: new Vt2(1, 0, s4, 1, 0, 0) };
    }, Vt2.prototype.toString = function(t3) {
      return this.join(" ");
    }, Vt2.prototype.inversed = function() {
      var t3 = this.sx, e3 = this.shy, r3 = this.shx, n3 = this.sy, i4 = this.tx, a3 = this.ty, o4 = 1 / (t3 * n3 - e3 * r3), s4 = n3 * o4, c5 = -e3 * o4, u4 = -r3 * o4, h4 = t3 * o4;
      return new Vt2(s4, c5, u4, h4, -s4 * i4 - u4 * a3, -c5 * i4 - h4 * a3);
    }, Vt2.prototype.applyToPoint = function(t3) {
      var e3 = t3.x * this.sx + t3.y * this.shx + this.tx, r3 = t3.x * this.shy + t3.y * this.sy + this.ty;
      return new Fr(e3, r3);
    }, Vt2.prototype.applyToRectangle = function(t3) {
      var e3 = this.applyToPoint(t3), r3 = this.applyToPoint(new Fr(t3.x + t3.w, t3.y + t3.h));
      return new Cr(e3.x, e3.y, r3.x - e3.x, r3.y - e3.y);
    }, Vt2.prototype.clone = function() {
      var t3 = this.sx, e3 = this.shy, r3 = this.shx, n3 = this.sy, i4 = this.tx, a3 = this.ty;
      return new Vt2(t3, e3, r3, n3, i4, a3);
    }, y3.Matrix = Vt2;
    var Gt2 = y3.matrixMult = function(t3, e3) {
      return e3.multiply(t3);
    }, Yt2 = new Vt2(1, 0, 0, 1, 0, 0);
    y3.unitMatrix = y3.identityMatrix = Yt2;
    var Jt2 = function(t3, e3) {
      if (!Bt2[t3]) {
        var r3 = (e3 instanceof B ? "Sh" : "P") + (Object.keys(Ot2).length + 1).toString(10);
        e3.id = r3, Bt2[t3] = r3, Ot2[r3] = e3, Tt2.publish("addPattern", e3);
      }
    };
    y3.ShadingPattern = B, y3.TilingPattern = E, y3.addShadingPattern = function(t3, e3) {
      return q2("addShadingPattern()"), Jt2(t3, e3), this;
    }, y3.beginTilingPattern = function(t3) {
      q2("beginTilingPattern()"), Or(t3.boundingBox[0], t3.boundingBox[1], t3.boundingBox[2] - t3.boundingBox[0], t3.boundingBox[3] - t3.boundingBox[1], t3.matrix);
    }, y3.endTilingPattern = function(t3, e3) {
      q2("endTilingPattern()"), e3.stream = ot2[$12].join("\n"), Jt2(t3, e3), Tt2.publish("endTilingPattern", e3), Wt2.pop().restore();
    };
    var Xt2 = y3.__private__.newObject = function() {
      var t3 = Kt2();
      return Zt2(t3, true), t3;
    }, Kt2 = y3.__private__.newObjectDeferred = function() {
      return et3++, rt2[et3] = function() {
        return it2;
      }, et3;
    }, Zt2 = function(t3, e3) {
      return e3 = typeof e3 == "boolean" && e3, rt2[t3] = it2, e3 && lt2(t3 + " 0 obj"), t3;
    }, $t2 = y3.__private__.newAdditionalObject = function() {
      var t3 = { objId: Kt2(), content: "" };
      return at2.push(t3), t3;
    }, Qt2 = Kt2(), te2 = Kt2(), ee2 = y3.__private__.decodeColorString = function(t3) {
      var e3 = t3.split(" ");
      if (e3.length !== 2 || e3[1] !== "g" && e3[1] !== "G") {
        if (e3.length === 5 && (e3[4] === "k" || e3[4] === "K")) {
          e3 = [(1 - e3[0]) * (1 - e3[3]), (1 - e3[1]) * (1 - e3[3]), (1 - e3[2]) * (1 - e3[3]), "r"];
        }
      } else {
        var r3 = parseFloat(e3[0]);
        e3 = [r3, r3, r3, "r"];
      }
      for (var n3 = "#", i4 = 0; i4 < 3; i4++)
        n3 += ("0" + Math.floor(255 * parseFloat(e3[i4])).toString(16)).slice(-2);
      return n3;
    }, re2 = y3.__private__.encodeColorString = function(e3) {
      var r3;
      typeof e3 == "string" && (e3 = { ch1: e3 });
      var n3 = e3.ch1, i4 = e3.ch2, a3 = e3.ch3, o4 = e3.ch4, s4 = e3.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
      if (typeof n3 == "string" && n3.charAt(0) !== "#") {
        var c5 = new f2(n3);
        if (c5.ok)
          n3 = c5.toHex();
        else if (!/^\d*\.?\d*$/.test(n3))
          throw new Error('Invalid color "' + n3 + '" passed to jsPDF.encodeColorString.');
      }
      if (typeof n3 == "string" && /^#[0-9A-Fa-f]{3}$/.test(n3) && (n3 = "#" + n3[1] + n3[1] + n3[2] + n3[2] + n3[3] + n3[3]), typeof n3 == "string" && /^#[0-9A-Fa-f]{6}$/.test(n3)) {
        var u4 = parseInt(n3.substr(1), 16);
        n3 = u4 >> 16 & 255, i4 = u4 >> 8 & 255, a3 = 255 & u4;
      }
      if (i4 === void 0 || o4 === void 0 && n3 === i4 && i4 === a3)
        if (typeof n3 == "string")
          r3 = n3 + " " + s4[0];
        else
          switch (e3.precision) {
            case 2:
              r3 = R2(n3 / 255) + " " + s4[0];
              break;
            case 3:
            default:
              r3 = T3(n3 / 255) + " " + s4[0];
          }
      else if (o4 === void 0 || _typeof(o4) === "object") {
        if (o4 && !isNaN(o4.a) && o4.a === 0)
          return r3 = ["1.", "1.", "1.", s4[1]].join(" ");
        if (typeof n3 == "string")
          r3 = [n3, i4, a3, s4[1]].join(" ");
        else
          switch (e3.precision) {
            case 2:
              r3 = [R2(n3 / 255), R2(i4 / 255), R2(a3 / 255), s4[1]].join(" ");
              break;
            default:
            case 3:
              r3 = [T3(n3 / 255), T3(i4 / 255), T3(a3 / 255), s4[1]].join(" ");
          }
      } else if (typeof n3 == "string")
        r3 = [n3, i4, a3, o4, s4[2]].join(" ");
      else
        switch (e3.precision) {
          case 2:
            r3 = [R2(n3), R2(i4), R2(a3), R2(o4), s4[2]].join(" ");
            break;
          case 3:
          default:
            r3 = [T3(n3), T3(i4), T3(a3), T3(o4), s4[2]].join(" ");
        }
      return r3;
    }, ne2 = y3.__private__.getFilters = function() {
      return u3;
    }, ie2 = y3.__private__.putStream = function(t3) {
      var e3 = (t3 = t3 || {}).data || "", r3 = t3.filters || ne2(), n3 = t3.alreadyAppliedFilters || [], i4 = t3.addLength1 || false, a3 = e3.length, o4 = t3.objectId, s4 = function(t4) {
        return t4;
      };
      if (m4 !== null && o4 === void 0)
        throw new Error("ObjectId must be passed to putStream for file encryption");
      m4 !== null && (s4 = Ye.encryptor(o4, 0));
      var c5 = {};
      r3 === true && (r3 = ["FlateEncode"]);
      var u4 = t3.additionalKeyValues || [], h4 = (c5 = M.API.processDataByFilters !== void 0 ? M.API.processDataByFilters(e3, r3) : { data: e3, reverseChain: [] }).reverseChain + (Array.isArray(n3) ? n3.join(" ") : n3.toString());
      if (c5.data.length !== 0 && (u4.push({ key: "Length", value: c5.data.length }), i4 === true && u4.push({ key: "Length1", value: a3 })), h4.length != 0)
        if (h4.split("/").length - 1 == 1)
          u4.push({ key: "Filter", value: h4 });
        else {
          u4.push({ key: "Filter", value: "[" + h4 + "]" });
          for (var l3 = 0; l3 < u4.length; l3 += 1)
            if (u4[l3].key === "DecodeParms") {
              for (var f3 = [], d3 = 0; d3 < c5.reverseChain.split("/").length - 1; d3 += 1)
                f3.push("null");
              f3.push(u4[l3].value), u4[l3].value = "[" + f3.join(" ") + "]";
            }
        }
      lt2("<<");
      for (var p5 = 0; p5 < u4.length; p5++)
        lt2("/" + u4[p5].key + " " + u4[p5].value);
      lt2(">>"), c5.data.length !== 0 && (lt2("stream"), lt2(s4(c5.data)), lt2("endstream"));
    }, ae2 = y3.__private__.putPage = function(t3) {
      var e3 = t3.number, r3 = t3.data, n3 = t3.objId, i4 = t3.contentsObjId;
      Zt2(n3, true), lt2("<</Type /Page"), lt2("/Parent " + t3.rootDictionaryObjId + " 0 R"), lt2("/Resources " + t3.resourceDictionaryObjId + " 0 R"), lt2("/MediaBox [" + parseFloat(O3(t3.mediaBox.bottomLeftX)) + " " + parseFloat(O3(t3.mediaBox.bottomLeftY)) + " " + O3(t3.mediaBox.topRightX) + " " + O3(t3.mediaBox.topRightY) + "]"), t3.cropBox !== null && lt2("/CropBox [" + O3(t3.cropBox.bottomLeftX) + " " + O3(t3.cropBox.bottomLeftY) + " " + O3(t3.cropBox.topRightX) + " " + O3(t3.cropBox.topRightY) + "]"), t3.bleedBox !== null && lt2("/BleedBox [" + O3(t3.bleedBox.bottomLeftX) + " " + O3(t3.bleedBox.bottomLeftY) + " " + O3(t3.bleedBox.topRightX) + " " + O3(t3.bleedBox.topRightY) + "]"), t3.trimBox !== null && lt2("/TrimBox [" + O3(t3.trimBox.bottomLeftX) + " " + O3(t3.trimBox.bottomLeftY) + " " + O3(t3.trimBox.topRightX) + " " + O3(t3.trimBox.topRightY) + "]"), t3.artBox !== null && lt2("/ArtBox [" + O3(t3.artBox.bottomLeftX) + " " + O3(t3.artBox.bottomLeftY) + " " + O3(t3.artBox.topRightX) + " " + O3(t3.artBox.topRightY) + "]"), typeof t3.userUnit == "number" && t3.userUnit !== 1 && lt2("/UserUnit " + t3.userUnit), Tt2.publish("putPage", { objId: n3, pageContext: Rt2[e3], pageNumber: e3, page: r3 }), lt2("/Contents " + i4 + " 0 R"), lt2(">>"), lt2("endobj");
      var a3 = r3.join("\n");
      return S2 === x2.ADVANCED && (a3 += "\nQ"), Zt2(i4, true), ie2({ data: a3, filters: ne2(), objectId: i4 }), lt2("endobj"), n3;
    }, oe2 = y3.__private__.putPages = function() {
      var t3, e3, r3 = [];
      for (t3 = 1; t3 <= Dt2; t3++)
        Rt2[t3].objId = Kt2(), Rt2[t3].contentsObjId = Kt2();
      for (t3 = 1; t3 <= Dt2; t3++)
        r3.push(ae2({ number: t3, data: ot2[t3], objId: Rt2[t3].objId, contentsObjId: Rt2[t3].contentsObjId, mediaBox: Rt2[t3].mediaBox, cropBox: Rt2[t3].cropBox, bleedBox: Rt2[t3].bleedBox, trimBox: Rt2[t3].trimBox, artBox: Rt2[t3].artBox, userUnit: Rt2[t3].userUnit, rootDictionaryObjId: Qt2, resourceDictionaryObjId: te2 }));
      Zt2(Qt2, true), lt2("<</Type /Pages");
      var n3 = "/Kids [";
      for (e3 = 0; e3 < Dt2; e3++)
        n3 += r3[e3] + " 0 R ";
      lt2(n3 + "]"), lt2("/Count " + Dt2), lt2(">>"), lt2("endobj"), Tt2.publish("postPutPages");
    }, se2 = function(t3) {
      Tt2.publish("putFont", { font: t3, out: lt2, newObject: Xt2, putStream: ie2 }), t3.isAlreadyPutted !== true && (t3.objectNumber = Xt2(), lt2("<<"), lt2("/Type /Font"), lt2("/BaseFont /" + F(t3.postScriptName)), lt2("/Subtype /Type1"), typeof t3.encoding == "string" && lt2("/Encoding /" + t3.encoding), lt2("/FirstChar 32"), lt2("/LastChar 255"), lt2(">>"), lt2("endobj"));
    }, ce2 = function() {
      for (var t3 in Ft2)
        Ft2.hasOwnProperty(t3) && (v3 === false || v3 === true && b2.hasOwnProperty(t3)) && se2(Ft2[t3]);
    }, ue2 = function(t3) {
      t3.objectNumber = Xt2();
      var e3 = [];
      e3.push({ key: "Type", value: "/XObject" }), e3.push({ key: "Subtype", value: "/Form" }), e3.push({ key: "BBox", value: "[" + [O3(t3.x), O3(t3.y), O3(t3.x + t3.width), O3(t3.y + t3.height)].join(" ") + "]" }), e3.push({ key: "Matrix", value: "[" + t3.matrix.toString() + "]" });
      var r3 = t3.pages[1].join("\n");
      ie2({ data: r3, additionalKeyValues: e3, objectId: t3.objectNumber }), lt2("endobj");
    }, he2 = function() {
      for (var t3 in zt2)
        zt2.hasOwnProperty(t3) && ue2(zt2[t3]);
    }, le2 = function(t3, e3) {
      var r3, n3 = [], i4 = 1 / (e3 - 1);
      for (r3 = 0; r3 < 1; r3 += i4)
        n3.push(r3);
      if (n3.push(1), t3[0].offset != 0) {
        var a3 = { offset: 0, color: t3[0].color };
        t3.unshift(a3);
      }
      if (t3[t3.length - 1].offset != 1) {
        var o4 = { offset: 1, color: t3[t3.length - 1].color };
        t3.push(o4);
      }
      for (var s4 = "", c5 = 0, u4 = 0; u4 < n3.length; u4++) {
        for (r3 = n3[u4]; r3 > t3[c5 + 1].offset; )
          c5++;
        var h4 = t3[c5].offset, l3 = (r3 - h4) / (t3[c5 + 1].offset - h4), f3 = t3[c5].color, d3 = t3[c5 + 1].color;
        s4 += tt2(Math.round((1 - l3) * f3[0] + l3 * d3[0]).toString(16)) + tt2(Math.round((1 - l3) * f3[1] + l3 * d3[1]).toString(16)) + tt2(Math.round((1 - l3) * f3[2] + l3 * d3[2]).toString(16));
      }
      return s4.trim();
    }, fe2 = function(t3, e3) {
      e3 || (e3 = 21);
      var r3 = Xt2(), n3 = le2(t3.colors, e3), i4 = [];
      i4.push({ key: "FunctionType", value: "0" }), i4.push({ key: "Domain", value: "[0.0 1.0]" }), i4.push({ key: "Size", value: "[" + e3 + "]" }), i4.push({ key: "BitsPerSample", value: "8" }), i4.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), i4.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), ie2({ data: n3, additionalKeyValues: i4, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: r3 }), lt2("endobj"), t3.objectNumber = Xt2(), lt2("<< /ShadingType " + t3.type), lt2("/ColorSpace /DeviceRGB");
      var a3 = "/Coords [" + O3(parseFloat(t3.coords[0])) + " " + O3(parseFloat(t3.coords[1])) + " ";
      t3.type === 2 ? a3 += O3(parseFloat(t3.coords[2])) + " " + O3(parseFloat(t3.coords[3])) : a3 += O3(parseFloat(t3.coords[2])) + " " + O3(parseFloat(t3.coords[3])) + " " + O3(parseFloat(t3.coords[4])) + " " + O3(parseFloat(t3.coords[5])), lt2(a3 += "]"), t3.matrix && lt2("/Matrix [" + t3.matrix.toString() + "]"), lt2("/Function " + r3 + " 0 R"), lt2("/Extend [true true]"), lt2(">>"), lt2("endobj");
    }, de2 = function(t3, e3) {
      var r3 = Kt2(), n3 = Xt2();
      e3.push({ resourcesOid: r3, objectOid: n3 }), t3.objectNumber = n3;
      var i4 = [];
      i4.push({ key: "Type", value: "/Pattern" }), i4.push({ key: "PatternType", value: "1" }), i4.push({ key: "PaintType", value: "1" }), i4.push({ key: "TilingType", value: "1" }), i4.push({ key: "BBox", value: "[" + t3.boundingBox.map(O3).join(" ") + "]" }), i4.push({ key: "XStep", value: O3(t3.xStep) }), i4.push({ key: "YStep", value: O3(t3.yStep) }), i4.push({ key: "Resources", value: r3 + " 0 R" }), t3.matrix && i4.push({ key: "Matrix", value: "[" + t3.matrix.toString() + "]" }), ie2({ data: t3.stream, additionalKeyValues: i4, objectId: t3.objectNumber }), lt2("endobj");
    }, pe2 = function(t3) {
      var e3;
      for (e3 in Ot2)
        Ot2.hasOwnProperty(e3) && (Ot2[e3] instanceof B ? fe2(Ot2[e3]) : Ot2[e3] instanceof E && de2(Ot2[e3], t3));
    }, ge2 = function(t3) {
      for (var e3 in t3.objectNumber = Xt2(), lt2("<<"), t3)
        switch (e3) {
          case "opacity":
            lt2("/ca " + R2(t3[e3]));
            break;
          case "stroke-opacity":
            lt2("/CA " + R2(t3[e3]));
        }
      lt2(">>"), lt2("endobj");
    }, me2 = function() {
      var t3;
      for (t3 in Et2)
        Et2.hasOwnProperty(t3) && ge2(Et2[t3]);
    }, ve2 = function() {
      for (var t3 in lt2("/XObject <<"), zt2)
        zt2.hasOwnProperty(t3) && zt2[t3].objectNumber >= 0 && lt2("/" + t3 + " " + zt2[t3].objectNumber + " 0 R");
      Tt2.publish("putXobjectDict"), lt2(">>");
    }, be2 = function() {
      Ye.oid = Xt2(), lt2("<<"), lt2("/Filter /Standard"), lt2("/V " + Ye.v), lt2("/R " + Ye.r), lt2("/U <" + Ye.toHexString(Ye.U) + ">"), lt2("/O <" + Ye.toHexString(Ye.O) + ">"), lt2("/P " + Ye.P), lt2(">>"), lt2("endobj");
    }, ye2 = function() {
      for (var t3 in lt2("/Font <<"), Ft2)
        Ft2.hasOwnProperty(t3) && (v3 === false || v3 === true && b2.hasOwnProperty(t3)) && lt2("/" + t3 + " " + Ft2[t3].objectNumber + " 0 R");
      lt2(">>");
    }, we2 = function() {
      if (Object.keys(Ot2).length > 0) {
        for (var t3 in lt2("/Shading <<"), Ot2)
          Ot2.hasOwnProperty(t3) && Ot2[t3] instanceof B && Ot2[t3].objectNumber >= 0 && lt2("/" + t3 + " " + Ot2[t3].objectNumber + " 0 R");
        Tt2.publish("putShadingPatternDict"), lt2(">>");
      }
    }, Ne2 = function(t3) {
      if (Object.keys(Ot2).length > 0) {
        for (var e3 in lt2("/Pattern <<"), Ot2)
          Ot2.hasOwnProperty(e3) && Ot2[e3] instanceof y3.TilingPattern && Ot2[e3].objectNumber >= 0 && Ot2[e3].objectNumber < t3 && lt2("/" + e3 + " " + Ot2[e3].objectNumber + " 0 R");
        Tt2.publish("putTilingPatternDict"), lt2(">>");
      }
    }, Le2 = function() {
      if (Object.keys(Et2).length > 0) {
        var t3;
        for (t3 in lt2("/ExtGState <<"), Et2)
          Et2.hasOwnProperty(t3) && Et2[t3].objectNumber >= 0 && lt2("/" + t3 + " " + Et2[t3].objectNumber + " 0 R");
        Tt2.publish("putGStateDict"), lt2(">>");
      }
    }, Ae = function(t3) {
      Zt2(t3.resourcesOid, true), lt2("<<"), lt2("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye2(), we2(), Ne2(t3.objectOid), Le2(), ve2(), lt2(">>"), lt2("endobj");
    }, xe = function() {
      var t3 = [];
      ce2(), me2(), he2(), pe2(t3), Tt2.publish("putResources"), t3.forEach(Ae), Ae({ resourcesOid: te2, objectOid: Number.MAX_SAFE_INTEGER }), Tt2.publish("postPutResources");
    }, Se = function() {
      Tt2.publish("putAdditionalObjects");
      for (var t3 = 0; t3 < at2.length; t3++) {
        var e3 = at2[t3];
        Zt2(e3.objId, true), lt2(e3.content), lt2("endobj");
      }
      Tt2.publish("postPutAdditionalObjects");
    }, _e = function(t3) {
      Ct2[t3.fontName] = Ct2[t3.fontName] || {}, Ct2[t3.fontName][t3.fontStyle] = t3.id;
    }, Pe = function(t3, e3, r3, n3, i4) {
      var a3 = { id: "F" + (Object.keys(Ft2).length + 1).toString(10), postScriptName: t3, fontName: e3, fontStyle: r3, encoding: n3, isStandardFont: i4 || false, metadata: {} };
      return Tt2.publish("addFont", { font: a3, instance: this }), Ft2[a3.id] = a3, _e(a3), a3.id;
    }, ke = function(t3) {
      for (var e3 = 0, r3 = pt2.length; e3 < r3; e3++) {
        var n3 = Pe.call(this, t3[e3][0], t3[e3][1], t3[e3][2], pt2[e3][3], true);
        v3 === false && (b2[n3] = true);
        var i4 = t3[e3][0].split("-");
        _e({ id: n3, fontName: i4[0], fontStyle: i4[1] || "" });
      }
      Tt2.publish("addFonts", { fonts: Ft2, dictionary: Ct2 });
    }, Ie = function(t3) {
      return t3.foo = function() {
        try {
          return t3.apply(this, arguments);
        } catch (t4) {
          var e3 = t4.stack || "";
          ~e3.indexOf(" at ") && (e3 = e3.split(" at ")[1]);
          var r3 = "Error in function " + e3.split("\n")[0].split("<")[0] + ": " + t4.message;
          if (!n2.console)
            throw new Error(r3);
          n2.console.error(r3, t4), n2.alert && alert(r3);
        }
      }, t3.foo.bar = t3, t3.foo;
    }, Fe = function(t3, e3) {
      var r3, n3, i4, a3, o4, s4, c5, u4, h4;
      if (i4 = (e3 = e3 || {}).sourceEncoding || "Unicode", o4 = e3.outputEncoding, (e3.autoencode || o4) && Ft2[St2].metadata && Ft2[St2].metadata[i4] && Ft2[St2].metadata[i4].encoding && (a3 = Ft2[St2].metadata[i4].encoding, !o4 && Ft2[St2].encoding && (o4 = Ft2[St2].encoding), !o4 && a3.codePages && (o4 = a3.codePages[0]), typeof o4 == "string" && (o4 = a3[o4]), o4)) {
        for (c5 = false, s4 = [], r3 = 0, n3 = t3.length; r3 < n3; r3++)
          (u4 = o4[t3.charCodeAt(r3)]) ? s4.push(String.fromCharCode(u4)) : s4.push(t3[r3]), s4[r3].charCodeAt(0) >> 8 && (c5 = true);
        t3 = s4.join("");
      }
      for (r3 = t3.length; c5 === void 0 && r3 !== 0; )
        t3.charCodeAt(r3 - 1) >> 8 && (c5 = true), r3--;
      if (!c5)
        return t3;
      for (s4 = e3.noBOM ? [] : [254, 255], r3 = 0, n3 = t3.length; r3 < n3; r3++) {
        if ((h4 = (u4 = t3.charCodeAt(r3)) >> 8) >> 8)
          throw new Error("Character at position " + r3 + " of string '" + t3 + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        s4.push(h4), s4.push(u4 - (h4 << 8));
      }
      return String.fromCharCode.apply(void 0, s4);
    }, Ce = y3.__private__.pdfEscape = y3.pdfEscape = function(t3, e3) {
      return Fe(t3, e3).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = y3.__private__.beginPage = function(t3) {
      ot2[++Dt2] = [], Rt2[Dt2] = { objId: 0, contentsObjId: 0, userUnit: Number(d2), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(t3[0]), topRightY: Number(t3[1]) } }, Ee(Dt2), ht2(ot2[$12]);
    }, Oe = function(t3, e3) {
      var r3, n3, o4;
      switch (i3 = e3 || i3, typeof t3 == "string" && (r3 = A2(t3.toLowerCase()), Array.isArray(r3) && (n3 = r3[0], o4 = r3[1])), Array.isArray(t3) && (n3 = t3[0] * _t2, o4 = t3[1] * _t2), isNaN(n3) && (n3 = s3[0], o4 = s3[1]), (n3 > 14400 || o4 > 14400) && (a2.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n3 = Math.min(14400, n3), o4 = Math.min(14400, o4)), s3 = [n3, o4], i3.substr(0, 1)) {
        case "l":
          o4 > n3 && (s3 = [o4, n3]);
          break;
        case "p":
          n3 > o4 && (s3 = [o4, n3]);
      }
      je(s3), dr(fr), lt2(Nr), Pr !== 0 && lt2(Pr + " J"), kr !== 0 && lt2(kr + " j"), Tt2.publish("addPage", { pageNumber: Dt2 });
    }, Be = function(t3) {
      t3 > 0 && t3 <= Dt2 && (ot2.splice(t3, 1), Rt2.splice(t3, 1), Dt2--, $12 > Dt2 && ($12 = Dt2), this.setPage($12));
    }, Ee = function(t3) {
      t3 > 0 && t3 <= Dt2 && ($12 = t3);
    }, Me = y3.__private__.getNumberOfPages = y3.getNumberOfPages = function() {
      return ot2.length - 1;
    }, qe = function(t3, e3, r3) {
      var n3, i4 = void 0;
      return r3 = r3 || {}, t3 = t3 !== void 0 ? t3 : Ft2[St2].fontName, e3 = e3 !== void 0 ? e3 : Ft2[St2].fontStyle, n3 = t3.toLowerCase(), Ct2[n3] !== void 0 && Ct2[n3][e3] !== void 0 ? i4 = Ct2[n3][e3] : Ct2[t3] !== void 0 && Ct2[t3][e3] !== void 0 ? i4 = Ct2[t3][e3] : r3.disableWarning === false && a2.warn("Unable to look up font label for font '" + t3 + "', '" + e3 + "'. Refer to getFontList() for available fonts."), i4 || r3.noFallback || (i4 = Ct2.times[e3]) == null && (i4 = Ct2.times.normal), i4;
    }, De = y3.__private__.putInfo = function() {
      var t3 = Xt2(), e3 = function(t4) {
        return t4;
      };
      for (var r3 in m4 !== null && (e3 = Ye.encryptor(t3, 0)), lt2("<<"), lt2("/Producer (" + Ce(e3("jsPDF " + M.version)) + ")"), xt2)
        xt2.hasOwnProperty(r3) && xt2[r3] && lt2("/" + r3.substr(0, 1).toUpperCase() + r3.substr(1) + " (" + Ce(e3(xt2[r3])) + ")");
      lt2("/CreationDate (" + Ce(e3(W2)) + ")"), lt2(">>"), lt2("endobj");
    }, Re = y3.__private__.putCatalog = function(t3) {
      var e3 = (t3 = t3 || {}).rootDictionaryObjId || Qt2;
      switch (Xt2(), lt2("<<"), lt2("/Type /Catalog"), lt2("/Pages " + e3 + " 0 R"), mt2 || (mt2 = "fullwidth"), mt2) {
        case "fullwidth":
          lt2("/OpenAction [3 0 R /FitH null]");
          break;
        case "fullheight":
          lt2("/OpenAction [3 0 R /FitV null]");
          break;
        case "fullpage":
          lt2("/OpenAction [3 0 R /Fit]");
          break;
        case "original":
          lt2("/OpenAction [3 0 R /XYZ null null 1]");
          break;
        default:
          var r3 = "" + mt2;
          r3.substr(r3.length - 1) === "%" && (mt2 = parseInt(mt2) / 100), typeof mt2 == "number" && lt2("/OpenAction [3 0 R /XYZ null null " + R2(mt2) + "]");
      }
      switch (Nt2 || (Nt2 = "continuous"), Nt2) {
        case "continuous":
          lt2("/PageLayout /OneColumn");
          break;
        case "single":
          lt2("/PageLayout /SinglePage");
          break;
        case "two":
        case "twoleft":
          lt2("/PageLayout /TwoColumnLeft");
          break;
        case "tworight":
          lt2("/PageLayout /TwoColumnRight");
      }
      yt2 && lt2("/PageMode /" + yt2), Tt2.publish("putCatalog"), lt2(">>"), lt2("endobj");
    }, Te = y3.__private__.putTrailer = function() {
      lt2("trailer"), lt2("<<"), lt2("/Size " + (et3 + 1)), lt2("/Root " + et3 + " 0 R"), lt2("/Info " + (et3 - 1) + " 0 R"), m4 !== null && lt2("/Encrypt " + Ye.oid + " 0 R"), lt2("/ID [ <" + V2 + "> <" + V2 + "> ]"), lt2(">>");
    }, Ue = y3.__private__.putHeader = function() {
      lt2("%PDF-" + w2), lt2("%\xBA\xDF\xAC\xE0");
    }, ze = y3.__private__.putXRef = function() {
      var t3 = "0000000000";
      lt2("xref"), lt2("0 " + (et3 + 1)), lt2("0000000000 65535 f ");
      for (var e3 = 1; e3 <= et3; e3++) {
        typeof rt2[e3] == "function" ? lt2((t3 + rt2[e3]()).slice(-10) + " 00000 n ") : rt2[e3] !== void 0 ? lt2((t3 + rt2[e3]).slice(-10) + " 00000 n ") : lt2("0000000000 00000 n ");
      }
    }, He = y3.__private__.buildDocument = function() {
      ut2(), ht2(nt2), Tt2.publish("buildDocument"), Ue(), oe2(), Se(), xe(), m4 !== null && be2(), De(), Re();
      var t3 = it2;
      return ze(), Te(), lt2("startxref"), lt2("" + t3), lt2("%%EOF"), ht2(ot2[$12]), nt2.join("\n");
    }, We = y3.__private__.getBlob = function(t3) {
      return new Blob([dt2(t3)], { type: "application/pdf" });
    }, Ve = y3.output = y3.__private__.output = Ie(function(t3, e3) {
      switch (typeof (e3 = e3 || {}) == "string" ? e3 = { filename: e3 } : e3.filename = e3.filename || "generated.pdf", t3) {
        case void 0:
          return He();
        case "save":
          y3.save(e3.filename);
          break;
        case "arraybuffer":
          return dt2(He());
        case "blob":
          return We(He());
        case "bloburi":
        case "bloburl":
          if (n2.URL !== void 0 && typeof n2.URL.createObjectURL == "function")
            return n2.URL && n2.URL.createObjectURL(We(He())) || void 0;
          a2.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
          break;
        case "datauristring":
        case "dataurlstring":
          var r3 = "", i4 = He();
          try {
            r3 = h3(i4);
          } catch (t4) {
            r3 = h3(unescape(encodeURIComponent(i4)));
          }
          return "data:application/pdf;filename=" + e3.filename + ";base64," + r3;
        case "pdfobjectnewwindow":
          if (Object.prototype.toString.call(n2) === "[object Window]") {
            var o4 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + (e3.pdfObjectUrl || "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js") + '"><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e3) + ");<\/script></body></html>", s4 = n2.open();
            return s4 !== null && s4.document.write(o4), s4;
          }
          throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
        case "pdfjsnewwindow":
          if (Object.prototype.toString.call(n2) === "[object Window]") {
            var c5 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e3.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e3.filename + '" width="500px" height="400px" /></body></html>', u4 = n2.open();
            if (u4 !== null) {
              u4.document.write(c5);
              var l3 = this;
              u4.document.documentElement.querySelector("#pdfViewer").onload = function() {
                u4.document.title = e3.filename, u4.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(l3.output("bloburl"));
              };
            }
            return u4;
          }
          throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
        case "dataurlnewwindow":
          if (Object.prototype.toString.call(n2) !== "[object Window]")
            throw new Error("The option dataurlnewwindow just works in a browser-environment.");
          var f3 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e3) + '"></iframe></body></html>', d3 = n2.open();
          if (d3 !== null && (d3.document.write(f3), d3.document.title = e3.filename), d3 || typeof safari == "undefined")
            return d3;
          break;
        case "datauri":
        case "dataurl":
          return n2.document.location.href = this.output("datauristring", e3);
        default:
          return null;
      }
    }), Ge = function(t3) {
      return Array.isArray(Ut2) === true && Ut2.indexOf(t3) > -1;
    };
    switch (o3) {
      case "pt":
        _t2 = 1;
        break;
      case "mm":
        _t2 = 72 / 25.4;
        break;
      case "cm":
        _t2 = 72 / 2.54;
        break;
      case "in":
        _t2 = 72;
        break;
      case "px":
        _t2 = Ge("px_scaling") == 1 ? 0.75 : 96 / 72;
        break;
      case "pc":
      case "em":
        _t2 = 12;
        break;
      case "ex":
        _t2 = 6;
        break;
      default:
        throw new Error("Invalid unit: " + o3);
    }
    var Ye = null;
    K2(), Y2();
    var Je = function(t3) {
      return m4 !== null ? Ye.encryptor(t3, 0) : function(t4) {
        return t4;
      };
    }, Xe = y3.__private__.getPageInfo = y3.getPageInfo = function(t3) {
      if (isNaN(t3) || t3 % 1 != 0)
        throw new Error("Invalid argument passed to jsPDF.getPageInfo");
      return { objId: Rt2[t3].objId, pageNumber: t3, pageContext: Rt2[t3] };
    }, Ke = y3.__private__.getPageInfoByObjId = function(t3) {
      if (isNaN(t3) || t3 % 1 != 0)
        throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
      for (var e3 in Rt2)
        if (Rt2[e3].objId === t3)
          break;
      return Xe(e3);
    }, Ze = y3.__private__.getCurrentPageInfo = y3.getCurrentPageInfo = function() {
      return { objId: Rt2[$12].objId, pageNumber: $12, pageContext: Rt2[$12] };
    };
    y3.addPage = function() {
      return Oe.apply(this, arguments), this;
    }, y3.setPage = function() {
      return Ee.apply(this, arguments), ht2.call(this, ot2[$12]), this;
    }, y3.insertPage = function(t3) {
      return this.addPage(), this.movePage($12, t3), this;
    }, y3.movePage = function(t3, e3) {
      var r3, n3;
      if (t3 > e3) {
        r3 = ot2[t3], n3 = Rt2[t3];
        for (var i4 = t3; i4 > e3; i4--)
          ot2[i4] = ot2[i4 - 1], Rt2[i4] = Rt2[i4 - 1];
        ot2[e3] = r3, Rt2[e3] = n3, this.setPage(e3);
      } else if (t3 < e3) {
        r3 = ot2[t3], n3 = Rt2[t3];
        for (var a3 = t3; a3 < e3; a3++)
          ot2[a3] = ot2[a3 + 1], Rt2[a3] = Rt2[a3 + 1];
        ot2[e3] = r3, Rt2[e3] = n3, this.setPage(e3);
      }
      return this;
    }, y3.deletePage = function() {
      return Be.apply(this, arguments), this;
    }, y3.__private__.text = y3.text = function(e3, r3, n3, i4, a3) {
      var o4, s4, c5, u4, h4, l3, f3, d3, p5 = (i4 = i4 || {}).scope || this;
      if (typeof e3 == "number" && typeof r3 == "number" && (typeof n3 == "string" || Array.isArray(n3))) {
        var g3 = n3;
        n3 = r3, r3 = e3, e3 = g3;
      }
      if (arguments[3] instanceof Vt2 == false ? (c5 = arguments[4], u4 = arguments[5], _typeof(f3 = arguments[3]) === "object" && f3 !== null || (typeof c5 == "string" && (u4 = c5, c5 = null), typeof f3 == "string" && (u4 = f3, f3 = null), typeof f3 == "number" && (c5 = f3, f3 = null), i4 = { flags: f3, angle: c5, align: u4 })) : (q2("The transform parameter of text() with a Matrix value"), d3 = a3), isNaN(r3) || isNaN(n3) || e3 == null)
        throw new Error("Invalid arguments passed to jsPDF.text");
      if (e3.length === 0)
        return p5;
      var m5 = "", v4 = false, y4 = typeof i4.lineHeightFactor == "number" ? i4.lineHeightFactor : lr, w3 = p5.internal.scaleFactor;
      function N4(t3) {
        return t3 = t3.split("	").join(Array(i4.TabLen || 9).join(" ")), Ce(t3, f3);
      }
      function L3(t3) {
        for (var e4, r4 = t3.concat(), n4 = [], i5 = r4.length; i5--; )
          typeof (e4 = r4.shift()) == "string" ? n4.push(e4) : Array.isArray(t3) && (e4.length === 1 || e4[1] === void 0 && e4[2] === void 0) ? n4.push(e4[0]) : n4.push([e4[0], e4[1], e4[2]]);
        return n4;
      }
      function A3(t3, e4) {
        var r4;
        if (typeof t3 == "string")
          r4 = e4(t3)[0];
        else if (Array.isArray(t3)) {
          for (var n4, i5, a4 = t3.concat(), o5 = [], s5 = a4.length; s5--; )
            typeof (n4 = a4.shift()) == "string" ? o5.push(e4(n4)[0]) : Array.isArray(n4) && typeof n4[0] == "string" && (i5 = e4(n4[0], n4[1], n4[2]), o5.push([i5[0], i5[1], i5[2]]));
          r4 = o5;
        }
        return r4;
      }
      var _4 = false, P3 = true;
      if (typeof e3 == "string")
        _4 = true;
      else if (Array.isArray(e3)) {
        var k3 = e3.concat();
        s4 = [];
        for (var I2, F2 = k3.length; F2--; )
          (typeof (I2 = k3.shift()) != "string" || Array.isArray(I2) && typeof I2[0] != "string") && (P3 = false);
        _4 = P3;
      }
      if (_4 === false)
        throw new Error('Type of text must be string or Array. "' + e3 + '" is not recognized.');
      typeof e3 == "string" && (e3 = e3.match(/[\r?\n]/) ? e3.split(/\r\n|\r|\n/g) : [e3]);
      var C2 = gt2 / p5.internal.scaleFactor, j2 = C2 * (lr - 1);
      switch (i4.baseline) {
        case "bottom":
          n3 -= j2;
          break;
        case "top":
          n3 += C2 - j2;
          break;
        case "hanging":
          n3 += C2 - 2 * j2;
          break;
        case "middle":
          n3 += C2 / 2 - j2;
      }
      if ((l3 = i4.maxWidth || 0) > 0 && (typeof e3 == "string" ? e3 = p5.splitTextToSize(e3, l3) : Object.prototype.toString.call(e3) === "[object Array]" && (e3 = e3.reduce(function(t3, e4) {
        return t3.concat(p5.splitTextToSize(e4, l3));
      }, []))), o4 = { text: e3, x: r3, y: n3, options: i4, mutex: { pdfEscape: Ce, activeFontKey: St2, fonts: Ft2, activeFontSize: gt2 } }, Tt2.publish("preProcessText", o4), e3 = o4.text, c5 = (i4 = o4.options).angle, d3 instanceof Vt2 == false && c5 && typeof c5 == "number") {
        c5 *= Math.PI / 180, i4.rotationDirection === 0 && (c5 = -c5), S2 === x2.ADVANCED && (c5 = -c5);
        var B2 = Math.cos(c5), E2 = Math.sin(c5);
        d3 = new Vt2(B2, E2, -E2, B2, 0, 0);
      } else
        c5 && c5 instanceof Vt2 && (d3 = c5);
      S2 !== x2.ADVANCED || d3 || (d3 = Yt2), (h4 = i4.charSpace || Sr) !== void 0 && (m5 += O3(U2(h4)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0));
      i4.lang;
      var M2 = -1, D3 = i4.renderingMode !== void 0 ? i4.renderingMode : i4.stroke, R3 = p5.internal.getCurrentPageInfo().pageContext;
      switch (D3) {
        case 0:
        case false:
        case "fill":
          M2 = 0;
          break;
        case 1:
        case true:
        case "stroke":
          M2 = 1;
          break;
        case 2:
        case "fillThenStroke":
          M2 = 2;
          break;
        case 3:
        case "invisible":
          M2 = 3;
          break;
        case 4:
        case "fillAndAddForClipping":
          M2 = 4;
          break;
        case 5:
        case "strokeAndAddPathForClipping":
          M2 = 5;
          break;
        case 6:
        case "fillThenStrokeAndAddToPathForClipping":
          M2 = 6;
          break;
        case 7:
        case "addToPathForClipping":
          M2 = 7;
      }
      var T4 = R3.usedRenderingMode !== void 0 ? R3.usedRenderingMode : -1;
      M2 !== -1 ? m5 += M2 + " Tr\n" : T4 !== -1 && (m5 += "0 Tr\n"), M2 !== -1 && (R3.usedRenderingMode = M2), u4 = i4.align || "left";
      var z3, H3 = gt2 * y4, W3 = p5.internal.pageSize.getWidth(), V3 = Ft2[St2];
      h4 = i4.charSpace || Sr, l3 = i4.maxWidth || 0, f3 = Object.assign({ autoencode: true, noBOM: true }, i4.flags);
      var G3 = [];
      if (Object.prototype.toString.call(e3) === "[object Array]") {
        var Y3;
        s4 = L3(e3), u4 !== "left" && (z3 = s4.map(function(t3) {
          return p5.getStringUnitWidth(t3, { font: V3, charSpace: h4, fontSize: gt2, doKerning: false }) * gt2 / w3;
        }));
        var J3, X3 = 0;
        if (u4 === "right") {
          r3 -= z3[0], e3 = [], F2 = s4.length;
          for (var K3 = 0; K3 < F2; K3++)
            K3 === 0 ? (J3 = vr(r3), Y3 = br(n3)) : (J3 = U2(X3 - z3[K3]), Y3 = -H3), e3.push([s4[K3], J3, Y3]), X3 = z3[K3];
        } else if (u4 === "center") {
          r3 -= z3[0] / 2, e3 = [], F2 = s4.length;
          for (var Z3 = 0; Z3 < F2; Z3++)
            Z3 === 0 ? (J3 = vr(r3), Y3 = br(n3)) : (J3 = U2((X3 - z3[Z3]) / 2), Y3 = -H3), e3.push([s4[Z3], J3, Y3]), X3 = z3[Z3];
        } else if (u4 === "left") {
          e3 = [], F2 = s4.length;
          for (var $13 = 0; $13 < F2; $13++)
            e3.push(s4[$13]);
        } else {
          if (u4 !== "justify")
            throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
          e3 = [], F2 = s4.length, l3 = l3 !== 0 ? l3 : W3;
          for (var Q3 = 0; Q3 < F2; Q3++)
            Y3 = Q3 === 0 ? br(n3) : -H3, J3 = Q3 === 0 ? vr(r3) : 0, Q3 < F2 - 1 ? G3.push(O3(U2((l3 - z3[Q3]) / (s4[Q3].split(" ").length - 1)))) : G3.push(0), e3.push([s4[Q3], J3, Y3]);
        }
      }
      var tt3 = typeof i4.R2L == "boolean" ? i4.R2L : bt2;
      tt3 === true && (e3 = A3(e3, function(t3, e4, r4) {
        return [t3.split("").reverse().join(""), e4, r4];
      })), o4 = { text: e3, x: r3, y: n3, options: i4, mutex: { pdfEscape: Ce, activeFontKey: St2, fonts: Ft2, activeFontSize: gt2 } }, Tt2.publish("postProcessText", o4), e3 = o4.text, v4 = o4.mutex.isHex || false;
      var et4 = Ft2[St2].encoding;
      et4 !== "WinAnsiEncoding" && et4 !== "StandardEncoding" || (e3 = A3(e3, function(t3, e4, r4) {
        return [N4(t3), e4, r4];
      })), s4 = L3(e3), e3 = [];
      for (var rt3, nt3, it3, at3 = 0, ot3 = 1, st3 = Array.isArray(s4[0]) ? ot3 : at3, ct3 = "", ut3 = function(t3, e4, r4) {
        var n4 = "";
        return r4 instanceof Vt2 ? (r4 = typeof i4.angle == "number" ? Gt2(r4, new Vt2(1, 0, 0, 1, t3, e4)) : Gt2(new Vt2(1, 0, 0, 1, t3, e4), r4), S2 === x2.ADVANCED && (r4 = Gt2(new Vt2(1, 0, 0, -1, 0, 0), r4)), n4 = r4.join(" ") + " Tm\n") : n4 = O3(t3) + " " + O3(e4) + " Td\n", n4;
      }, ht3 = 0; ht3 < s4.length; ht3++) {
        switch (ct3 = "", st3) {
          case ot3:
            it3 = (v4 ? "<" : "(") + s4[ht3][0] + (v4 ? ">" : ")"), rt3 = parseFloat(s4[ht3][1]), nt3 = parseFloat(s4[ht3][2]);
            break;
          case at3:
            it3 = (v4 ? "<" : "(") + s4[ht3] + (v4 ? ">" : ")"), rt3 = vr(r3), nt3 = br(n3);
        }
        G3 !== void 0 && G3[ht3] !== void 0 && (ct3 = G3[ht3] + " Tw\n"), ht3 === 0 ? e3.push(ct3 + ut3(rt3, nt3, d3) + it3) : st3 === at3 ? e3.push(ct3 + it3) : st3 === ot3 && e3.push(ct3 + ut3(rt3, nt3, d3) + it3);
      }
      e3 = st3 === at3 ? e3.join(" Tj\nT* ") : e3.join(" Tj\n"), e3 += " Tj\n";
      var ft3 = "BT\n/";
      return ft3 += St2 + " " + gt2 + " Tf\n", ft3 += O3(gt2 * y4) + " TL\n", ft3 += Ar + "\n", ft3 += m5, ft3 += e3, lt2(ft3 += "ET"), b2[St2] = true, p5;
    };
    var $e = y3.__private__.clip = y3.clip = function(t3) {
      return lt2(t3 === "evenodd" ? "W*" : "W"), this;
    };
    y3.clipEvenOdd = function() {
      return $e("evenodd");
    }, y3.__private__.discardPath = y3.discardPath = function() {
      return lt2("n"), this;
    };
    var Qe = y3.__private__.isValidStyle = function(t3) {
      var e3 = false;
      return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(t3) !== -1 && (e3 = true), e3;
    };
    y3.__private__.setDefaultPathOperation = y3.setDefaultPathOperation = function(t3) {
      return Qe(t3) && (g2 = t3), this;
    };
    var tr = y3.__private__.getStyle = y3.getStyle = function(t3) {
      var e3 = g2;
      switch (t3) {
        case "D":
        case "S":
          e3 = "S";
          break;
        case "F":
          e3 = "f";
          break;
        case "FD":
        case "DF":
          e3 = "B";
          break;
        case "f":
        case "f*":
        case "B":
        case "B*":
          e3 = t3;
      }
      return e3;
    }, er = y3.close = function() {
      return lt2("h"), this;
    };
    y3.stroke = function() {
      return lt2("S"), this;
    }, y3.fill = function(t3) {
      return rr("f", t3), this;
    }, y3.fillEvenOdd = function(t3) {
      return rr("f*", t3), this;
    }, y3.fillStroke = function(t3) {
      return rr("B", t3), this;
    }, y3.fillStrokeEvenOdd = function(t3) {
      return rr("B*", t3), this;
    };
    var rr = function(e3, r3) {
      _typeof(r3) === "object" ? ar(r3, e3) : lt2(e3);
    }, nr = function(t3) {
      t3 === null || S2 === x2.ADVANCED && t3 === void 0 || (t3 = tr(t3), lt2(t3));
    };
    function ir(t3, e3, r3, n3, i4) {
      var a3 = new E(e3 || this.boundingBox, r3 || this.xStep, n3 || this.yStep, this.gState, i4 || this.matrix);
      a3.stream = this.stream;
      var o4 = t3 + "$$" + this.cloneIndex++ + "$$";
      return Jt2(o4, a3), a3;
    }
    var ar = function(t3, e3) {
      var r3 = Bt2[t3.key], n3 = Ot2[r3];
      if (n3 instanceof B)
        lt2("q"), lt2(or(e3)), n3.gState && y3.setGState(n3.gState), lt2(t3.matrix.toString() + " cm"), lt2("/" + r3 + " sh"), lt2("Q");
      else if (n3 instanceof E) {
        var i4 = new Vt2(1, 0, 0, -1, 0, Dr());
        t3.matrix && (i4 = i4.multiply(t3.matrix || Yt2), r3 = ir.call(n3, t3.key, t3.boundingBox, t3.xStep, t3.yStep, i4).id), lt2("q"), lt2("/Pattern cs"), lt2("/" + r3 + " scn"), n3.gState && y3.setGState(n3.gState), lt2(e3), lt2("Q");
      }
    }, or = function(t3) {
      switch (t3) {
        case "f":
        case "F":
          return "W n";
        case "f*":
          return "W* n";
        case "B":
          return "W S";
        case "B*":
          return "W* S";
        case "S":
          return "W S";
        case "n":
          return "W n";
      }
    }, sr = y3.moveTo = function(t3, e3) {
      return lt2(O3(U2(t3)) + " " + O3(H2(e3)) + " m"), this;
    }, cr = y3.lineTo = function(t3, e3) {
      return lt2(O3(U2(t3)) + " " + O3(H2(e3)) + " l"), this;
    }, ur = y3.curveTo = function(t3, e3, r3, n3, i4, a3) {
      return lt2([O3(U2(t3)), O3(H2(e3)), O3(U2(r3)), O3(H2(n3)), O3(U2(i4)), O3(H2(a3)), "c"].join(" ")), this;
    };
    y3.__private__.line = y3.line = function(t3, e3, r3, n3, i4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n3) || !Qe(i4))
        throw new Error("Invalid arguments passed to jsPDF.line");
      return S2 === x2.COMPAT ? this.lines([[r3 - t3, n3 - e3]], t3, e3, [1, 1], i4 || "S") : this.lines([[r3 - t3, n3 - e3]], t3, e3, [1, 1]).stroke();
    }, y3.__private__.lines = y3.lines = function(t3, e3, r3, n3, i4, a3) {
      var o4, s4, c5, u4, h4, l3, f3, d3, p5, g3, m5, v4;
      if (typeof t3 == "number" && (v4 = r3, r3 = e3, e3 = t3, t3 = v4), n3 = n3 || [1, 1], a3 = a3 || false, isNaN(e3) || isNaN(r3) || !Array.isArray(t3) || !Array.isArray(n3) || !Qe(i4) || typeof a3 != "boolean")
        throw new Error("Invalid arguments passed to jsPDF.lines");
      for (sr(e3, r3), o4 = n3[0], s4 = n3[1], u4 = t3.length, g3 = e3, m5 = r3, c5 = 0; c5 < u4; c5++)
        (h4 = t3[c5]).length === 2 ? (g3 = h4[0] * o4 + g3, m5 = h4[1] * s4 + m5, cr(g3, m5)) : (l3 = h4[0] * o4 + g3, f3 = h4[1] * s4 + m5, d3 = h4[2] * o4 + g3, p5 = h4[3] * s4 + m5, g3 = h4[4] * o4 + g3, m5 = h4[5] * s4 + m5, ur(l3, f3, d3, p5, g3, m5));
      return a3 && er(), nr(i4), this;
    }, y3.path = function(t3) {
      for (var e3 = 0; e3 < t3.length; e3++) {
        var r3 = t3[e3], n3 = r3.c;
        switch (r3.op) {
          case "m":
            sr(n3[0], n3[1]);
            break;
          case "l":
            cr(n3[0], n3[1]);
            break;
          case "c":
            ur.apply(this, n3);
            break;
          case "h":
            er();
        }
      }
      return this;
    }, y3.__private__.rect = y3.rect = function(t3, e3, r3, n3, i4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n3) || !Qe(i4))
        throw new Error("Invalid arguments passed to jsPDF.rect");
      return S2 === x2.COMPAT && (n3 = -n3), lt2([O3(U2(t3)), O3(H2(e3)), O3(U2(r3)), O3(U2(n3)), "re"].join(" ")), nr(i4), this;
    }, y3.__private__.triangle = y3.triangle = function(t3, e3, r3, n3, i4, a3, o4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n3) || isNaN(i4) || isNaN(a3) || !Qe(o4))
        throw new Error("Invalid arguments passed to jsPDF.triangle");
      return this.lines([[r3 - t3, n3 - e3], [i4 - r3, a3 - n3], [t3 - i4, e3 - a3]], t3, e3, [1, 1], o4, true), this;
    }, y3.__private__.roundedRect = y3.roundedRect = function(t3, e3, r3, n3, i4, a3, o4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n3) || isNaN(i4) || isNaN(a3) || !Qe(o4))
        throw new Error("Invalid arguments passed to jsPDF.roundedRect");
      var s4 = 4 / 3 * (Math.SQRT2 - 1);
      return i4 = Math.min(i4, 0.5 * r3), a3 = Math.min(a3, 0.5 * n3), this.lines([[r3 - 2 * i4, 0], [i4 * s4, 0, i4, a3 - a3 * s4, i4, a3], [0, n3 - 2 * a3], [0, a3 * s4, -i4 * s4, a3, -i4, a3], [2 * i4 - r3, 0], [-i4 * s4, 0, -i4, -a3 * s4, -i4, -a3], [0, 2 * a3 - n3], [0, -a3 * s4, i4 * s4, -a3, i4, -a3]], t3 + i4, e3, [1, 1], o4, true), this;
    }, y3.__private__.ellipse = y3.ellipse = function(t3, e3, r3, n3, i4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n3) || !Qe(i4))
        throw new Error("Invalid arguments passed to jsPDF.ellipse");
      var a3 = 4 / 3 * (Math.SQRT2 - 1) * r3, o4 = 4 / 3 * (Math.SQRT2 - 1) * n3;
      return sr(t3 + r3, e3), ur(t3 + r3, e3 - o4, t3 + a3, e3 - n3, t3, e3 - n3), ur(t3 - a3, e3 - n3, t3 - r3, e3 - o4, t3 - r3, e3), ur(t3 - r3, e3 + o4, t3 - a3, e3 + n3, t3, e3 + n3), ur(t3 + a3, e3 + n3, t3 + r3, e3 + o4, t3 + r3, e3), nr(i4), this;
    }, y3.__private__.circle = y3.circle = function(t3, e3, r3, n3) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || !Qe(n3))
        throw new Error("Invalid arguments passed to jsPDF.circle");
      return this.ellipse(t3, e3, r3, r3, n3);
    }, y3.setFont = function(t3, e3, r3) {
      return r3 && (e3 = k2(e3, r3)), St2 = qe(t3, e3, { disableWarning: false }), this;
    };
    var hr = y3.__private__.getFont = y3.getFont = function() {
      return Ft2[qe.apply(y3, arguments)];
    };
    y3.__private__.getFontList = y3.getFontList = function() {
      var t3, e3, r3 = {};
      for (t3 in Ct2)
        if (Ct2.hasOwnProperty(t3))
          for (e3 in r3[t3] = [], Ct2[t3])
            Ct2[t3].hasOwnProperty(e3) && r3[t3].push(e3);
      return r3;
    }, y3.addFont = function(t3, e3, r3, n3, i4) {
      var a3 = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
      return arguments[3] && a3.indexOf(arguments[3]) !== -1 ? i4 = arguments[3] : arguments[3] && a3.indexOf(arguments[3]) == -1 && (r3 = k2(r3, n3)), i4 = i4 || "Identity-H", Pe.call(this, t3, e3, r3, i4);
    };
    var lr, fr = e2.lineWidth || 0.200025, dr = y3.__private__.setLineWidth = y3.setLineWidth = function(t3) {
      return lt2(O3(U2(t3)) + " w"), this;
    };
    y3.__private__.setLineDash = M.API.setLineDash = M.API.setLineDashPattern = function(t3, e3) {
      if (t3 = t3 || [], e3 = e3 || 0, isNaN(e3) || !Array.isArray(t3))
        throw new Error("Invalid arguments passed to jsPDF.setLineDash");
      return t3 = t3.map(function(t4) {
        return O3(U2(t4));
      }).join(" "), e3 = O3(U2(e3)), lt2("[" + t3 + "] " + e3 + " d"), this;
    };
    var pr = y3.__private__.getLineHeight = y3.getLineHeight = function() {
      return gt2 * lr;
    };
    y3.__private__.getLineHeight = y3.getLineHeight = function() {
      return gt2 * lr;
    };
    var gr = y3.__private__.setLineHeightFactor = y3.setLineHeightFactor = function(t3) {
      return typeof (t3 = t3 || 1.15) == "number" && (lr = t3), this;
    }, mr = y3.__private__.getLineHeightFactor = y3.getLineHeightFactor = function() {
      return lr;
    };
    gr(e2.lineHeight);
    var vr = y3.__private__.getHorizontalCoordinate = function(t3) {
      return U2(t3);
    }, br = y3.__private__.getVerticalCoordinate = function(t3) {
      return S2 === x2.ADVANCED ? t3 : Rt2[$12].mediaBox.topRightY - Rt2[$12].mediaBox.bottomLeftY - U2(t3);
    }, yr = y3.__private__.getHorizontalCoordinateString = y3.getHorizontalCoordinateString = function(t3) {
      return O3(vr(t3));
    }, wr = y3.__private__.getVerticalCoordinateString = y3.getVerticalCoordinateString = function(t3) {
      return O3(br(t3));
    }, Nr = e2.strokeColor || "0 G";
    y3.__private__.getStrokeColor = y3.getDrawColor = function() {
      return ee2(Nr);
    }, y3.__private__.setStrokeColor = y3.setDrawColor = function(t3, e3, r3, n3) {
      return Nr = re2({ ch1: t3, ch2: e3, ch3: r3, ch4: n3, pdfColorType: "draw", precision: 2 }), lt2(Nr), this;
    };
    var Lr = e2.fillColor || "0 g";
    y3.__private__.getFillColor = y3.getFillColor = function() {
      return ee2(Lr);
    }, y3.__private__.setFillColor = y3.setFillColor = function(t3, e3, r3, n3) {
      return Lr = re2({ ch1: t3, ch2: e3, ch3: r3, ch4: n3, pdfColorType: "fill", precision: 2 }), lt2(Lr), this;
    };
    var Ar = e2.textColor || "0 g", xr = y3.__private__.getTextColor = y3.getTextColor = function() {
      return ee2(Ar);
    };
    y3.__private__.setTextColor = y3.setTextColor = function(t3, e3, r3, n3) {
      return Ar = re2({ ch1: t3, ch2: e3, ch3: r3, ch4: n3, pdfColorType: "text", precision: 3 }), this;
    };
    var Sr = e2.charSpace, _r = y3.__private__.getCharSpace = y3.getCharSpace = function() {
      return parseFloat(Sr || 0);
    };
    y3.__private__.setCharSpace = y3.setCharSpace = function(t3) {
      if (isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.setCharSpace");
      return Sr = t3, this;
    };
    var Pr = 0;
    y3.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, y3.__private__.setLineCap = y3.setLineCap = function(t3) {
      var e3 = y3.CapJoinStyles[t3];
      if (e3 === void 0)
        throw new Error("Line cap style of '" + t3 + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
      return Pr = e3, lt2(e3 + " J"), this;
    };
    var kr = 0;
    y3.__private__.setLineJoin = y3.setLineJoin = function(t3) {
      var e3 = y3.CapJoinStyles[t3];
      if (e3 === void 0)
        throw new Error("Line join style of '" + t3 + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
      return kr = e3, lt2(e3 + " j"), this;
    }, y3.__private__.setLineMiterLimit = y3.__private__.setMiterLimit = y3.setLineMiterLimit = y3.setMiterLimit = function(t3) {
      if (t3 = t3 || 0, isNaN(t3))
        throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
      return lt2(O3(U2(t3)) + " M"), this;
    }, y3.GState = j, y3.setGState = function(t3) {
      (t3 = typeof t3 == "string" ? Et2[Mt2[t3]] : Ir(null, t3)).equals(qt2) || (lt2("/" + t3.id + " gs"), qt2 = t3);
    };
    var Ir = function(t3, e3) {
      if (!t3 || !Mt2[t3]) {
        var r3 = false;
        for (var n3 in Et2)
          if (Et2.hasOwnProperty(n3) && Et2[n3].equals(e3)) {
            r3 = true;
            break;
          }
        if (r3)
          e3 = Et2[n3];
        else {
          var i4 = "GS" + (Object.keys(Et2).length + 1).toString(10);
          Et2[i4] = e3, e3.id = i4;
        }
        return t3 && (Mt2[t3] = e3.id), Tt2.publish("addGState", e3), e3;
      }
    };
    y3.addGState = function(t3, e3) {
      return Ir(t3, e3), this;
    }, y3.saveGraphicsState = function() {
      return lt2("q"), jt2.push({ key: St2, size: gt2, color: Ar }), this;
    }, y3.restoreGraphicsState = function() {
      lt2("Q");
      var t3 = jt2.pop();
      return St2 = t3.key, gt2 = t3.size, Ar = t3.color, qt2 = null, this;
    }, y3.setCurrentTransformationMatrix = function(t3) {
      return lt2(t3.toString() + " cm"), this;
    }, y3.comment = function(t3) {
      return lt2("#" + t3), this;
    };
    var Fr = function(t3, e3) {
      var r3 = t3 || 0;
      Object.defineProperty(this, "x", { enumerable: true, get: function() {
        return r3;
      }, set: function(t4) {
        isNaN(t4) || (r3 = parseFloat(t4));
      } });
      var n3 = e3 || 0;
      Object.defineProperty(this, "y", { enumerable: true, get: function() {
        return n3;
      }, set: function(t4) {
        isNaN(t4) || (n3 = parseFloat(t4));
      } });
      var i4 = "pt";
      return Object.defineProperty(this, "type", { enumerable: true, get: function() {
        return i4;
      }, set: function(t4) {
        i4 = t4.toString();
      } }), this;
    }, Cr = function(t3, e3, r3, n3) {
      Fr.call(this, t3, e3), this.type = "rect";
      var i4 = r3 || 0;
      Object.defineProperty(this, "w", { enumerable: true, get: function() {
        return i4;
      }, set: function(t4) {
        isNaN(t4) || (i4 = parseFloat(t4));
      } });
      var a3 = n3 || 0;
      return Object.defineProperty(this, "h", { enumerable: true, get: function() {
        return a3;
      }, set: function(t4) {
        isNaN(t4) || (a3 = parseFloat(t4));
      } }), this;
    }, jr = function() {
      this.page = Dt2, this.currentPage = $12, this.pages = ot2.slice(0), this.pagesContext = Rt2.slice(0), this.x = Pt2, this.y = kt2, this.matrix = It2, this.width = Mr($12), this.height = Dr($12), this.outputDestination = ct2, this.id = "", this.objectNumber = -1;
    };
    jr.prototype.restore = function() {
      Dt2 = this.page, $12 = this.currentPage, Rt2 = this.pagesContext, ot2 = this.pages, Pt2 = this.x, kt2 = this.y, It2 = this.matrix, qr($12, this.width), Rr($12, this.height), ct2 = this.outputDestination;
    };
    var Or = function(t3, e3, r3, n3, i4) {
      Wt2.push(new jr()), Dt2 = $12 = 0, ot2 = [], Pt2 = t3, kt2 = e3, It2 = i4, je([r3, n3]);
    }, Br = function(t3) {
      if (Ht2[t3])
        Wt2.pop().restore();
      else {
        var e3 = new jr(), r3 = "Xo" + (Object.keys(zt2).length + 1).toString(10);
        e3.id = r3, Ht2[t3] = r3, zt2[r3] = e3, Tt2.publish("addFormObject", e3), Wt2.pop().restore();
      }
    };
    for (var Er in y3.beginFormObject = function(t3, e3, r3, n3, i4) {
      return Or(t3, e3, r3, n3, i4), this;
    }, y3.endFormObject = function(t3) {
      return Br(t3), this;
    }, y3.doFormObject = function(t3, e3) {
      var r3 = zt2[Ht2[t3]];
      return lt2("q"), lt2(e3.toString() + " cm"), lt2("/" + r3.id + " Do"), lt2("Q"), this;
    }, y3.getFormObject = function(t3) {
      var e3 = zt2[Ht2[t3]];
      return { x: e3.x, y: e3.y, width: e3.width, height: e3.height, matrix: e3.matrix };
    }, y3.save = function(t3, e3) {
      return t3 = t3 || "generated.pdf", (e3 = e3 || {}).returnPromise = e3.returnPromise || false, e3.returnPromise === false ? (l2(We(He()), t3), typeof l2.unload == "function" && n2.setTimeout && setTimeout(l2.unload, 911), this) : new Promise(function(e4, r3) {
        try {
          var i4 = l2(We(He()), t3);
          typeof l2.unload == "function" && n2.setTimeout && setTimeout(l2.unload, 911), e4(i4);
        } catch (t4) {
          r3(t4.message);
        }
      });
    }, M.API)
      M.API.hasOwnProperty(Er) && (Er === "events" && M.API.events.length ? function(t3, e3) {
        var r3, n3, i4;
        for (i4 = e3.length - 1; i4 !== -1; i4--)
          r3 = e3[i4][0], n3 = e3[i4][1], t3.subscribe.apply(t3, [r3].concat(typeof n3 == "function" ? [n3] : n3));
      }(Tt2, M.API.events) : y3[Er] = M.API[Er]);
    var Mr = y3.getPageWidth = function(t3) {
      return (Rt2[t3 = t3 || $12].mediaBox.topRightX - Rt2[t3].mediaBox.bottomLeftX) / _t2;
    }, qr = y3.setPageWidth = function(t3, e3) {
      Rt2[t3].mediaBox.topRightX = e3 * _t2 + Rt2[t3].mediaBox.bottomLeftX;
    }, Dr = y3.getPageHeight = function(t3) {
      return (Rt2[t3 = t3 || $12].mediaBox.topRightY - Rt2[t3].mediaBox.bottomLeftY) / _t2;
    }, Rr = y3.setPageHeight = function(t3, e3) {
      Rt2[t3].mediaBox.topRightY = e3 * _t2 + Rt2[t3].mediaBox.bottomLeftY;
    };
    return y3.internal = { pdfEscape: Ce, getStyle: tr, getFont: hr, getFontSize: vt2, getCharSpace: _r, getTextColor: xr, getLineHeight: pr, getLineHeightFactor: mr, write: ft2, getHorizontalCoordinate: vr, getVerticalCoordinate: br, getCoordinateString: yr, getVerticalCoordinateString: wr, collections: {}, newObject: Xt2, newAdditionalObject: $t2, newObjectDeferred: Kt2, newObjectDeferredBegin: Zt2, getFilters: ne2, putStream: ie2, events: Tt2, scaleFactor: _t2, pageSize: { getWidth: function() {
      return Mr($12);
    }, setWidth: function(t3) {
      qr($12, t3);
    }, getHeight: function() {
      return Dr($12);
    }, setHeight: function(t3) {
      Rr($12, t3);
    } }, encryptionOptions: m4, encryption: Ye, getEncryptor: Je, output: Ve, getNumberOfPages: Me, pages: ot2, out: lt2, f2: R2, f3: T3, getPageInfo: Xe, getPageInfoByObjId: Ke, getCurrentPageInfo: Ze, getPDFVersion: N3, Point: Fr, Rectangle: Cr, Matrix: Vt2, hasHotfix: Ge }, Object.defineProperty(y3.internal.pageSize, "width", { get: function() {
      return Mr($12);
    }, set: function(t3) {
      qr($12, t3);
    }, enumerable: true, configurable: true }), Object.defineProperty(y3.internal.pageSize, "height", { get: function() {
      return Dr($12);
    }, set: function(t3) {
      Rr($12, t3);
    }, enumerable: true, configurable: true }), ke.call(y3, pt2), St2 = "F1", Oe(s3, i3), Tt2.publish("initialized"), y3;
  }
  I.prototype.lsbFirstWord = function(t3) {
    return String.fromCharCode(t3 >> 0 & 255, t3 >> 8 & 255, t3 >> 16 & 255, t3 >> 24 & 255);
  }, I.prototype.toHexString = function(t3) {
    return t3.split("").map(function(t4) {
      return ("0" + (255 & t4.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
  }, I.prototype.hexToBytes = function(t3) {
    for (var e2 = [], r2 = 0; r2 < t3.length; r2 += 2)
      e2.push(String.fromCharCode(parseInt(t3.substr(r2, 2), 16)));
    return e2.join("");
  }, I.prototype.processOwnerPassword = function(t3, e2) {
    return P(x(e2).substr(0, 5), t3);
  }, I.prototype.encryptor = function(t3, e2) {
    var r2 = x(this.encryptionKey + String.fromCharCode(255 & t3, t3 >> 8 & 255, t3 >> 16 & 255, 255 & e2, e2 >> 8 & 255)).substr(0, 10);
    return function(t4) {
      return P(r2, t4);
    };
  }, j.prototype.equals = function(e2) {
    var r2, n3 = "id,objectNumber,equals";
    if (!e2 || _typeof(e2) !== _typeof(this))
      return false;
    var i3 = 0;
    for (r2 in this)
      if (!(n3.indexOf(r2) >= 0)) {
        if (this.hasOwnProperty(r2) && !e2.hasOwnProperty(r2))
          return false;
        if (this[r2] !== e2[r2])
          return false;
        i3++;
      }
    for (r2 in e2)
      e2.hasOwnProperty(r2) && n3.indexOf(r2) < 0 && i3--;
    return i3 === 0;
  }, M.API = { events: [] }, M.version = "2.4.0";
  var q = M.API;
  var D = 1;
  var R = function(t3) {
    return t3.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  };
  var T2 = function(t3) {
    return t3.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
  };
  var U = function(t3) {
    return t3.toFixed(2);
  };
  var z = function(t3) {
    return t3.toFixed(5);
  };
  q.__acroform__ = {};
  var H = function(t3, e2) {
    t3.prototype = Object.create(e2.prototype), t3.prototype.constructor = t3;
  };
  var W = function(t3) {
    return t3 * D;
  };
  var V = function(t3) {
    var e2 = new ut(), r2 = At.internal.getHeight(t3) || 0, n3 = At.internal.getWidth(t3) || 0;
    return e2.BBox = [0, 0, Number(U(n3)), Number(U(r2))], e2;
  };
  var G = q.__acroform__.setBit = function(t3, e2) {
    if (t3 = t3 || 0, e2 = e2 || 0, isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t3 |= 1 << e2;
  };
  var Y = q.__acroform__.clearBit = function(t3, e2) {
    if (t3 = t3 || 0, e2 = e2 || 0, isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t3 &= ~(1 << e2);
  };
  var J = q.__acroform__.getBit = function(t3, e2) {
    if (isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return (t3 & 1 << e2) == 0 ? 0 : 1;
  };
  var X = q.__acroform__.getBitForPdf = function(t3, e2) {
    if (isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return J(t3, e2 - 1);
  };
  var K = q.__acroform__.setBitForPdf = function(t3, e2) {
    if (isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return G(t3, e2 - 1);
  };
  var Z = q.__acroform__.clearBitForPdf = function(t3, e2) {
    if (isNaN(t3) || isNaN(e2))
      throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return Y(t3, e2 - 1);
  };
  var $11 = q.__acroform__.calculateCoordinates = function(t3, e2) {
    var r2 = e2.internal.getHorizontalCoordinate, n3 = e2.internal.getVerticalCoordinate, i3 = t3[0], a3 = t3[1], o3 = t3[2], s3 = t3[3], c4 = {};
    return c4.lowerLeft_X = r2(i3) || 0, c4.lowerLeft_Y = n3(a3 + s3) || 0, c4.upperRight_X = r2(i3 + o3) || 0, c4.upperRight_Y = n3(a3) || 0, [Number(U(c4.lowerLeft_X)), Number(U(c4.lowerLeft_Y)), Number(U(c4.upperRight_X)), Number(U(c4.upperRight_Y))];
  };
  var Q = function(t3) {
    if (t3.appearanceStreamContent)
      return t3.appearanceStreamContent;
    if (t3.V || t3.DV) {
      var e2 = [], r2 = t3._V || t3.DV, n3 = tt(t3, r2), i3 = t3.scope.internal.getFont(t3.fontName, t3.fontStyle).id;
      e2.push("/Tx BMC"), e2.push("q"), e2.push("BT"), e2.push(t3.scope.__private__.encodeColorString(t3.color)), e2.push("/" + i3 + " " + U(n3.fontSize) + " Tf"), e2.push("1 0 0 1 0 0 Tm"), e2.push(n3.text), e2.push("ET"), e2.push("Q"), e2.push("EMC");
      var a3 = V(t3);
      return a3.scope = t3.scope, a3.stream = e2.join("\n"), a3;
    }
  };
  var tt = function(t3, e2) {
    var r2 = t3.fontSize === 0 ? t3.maxFontSize : t3.fontSize, n3 = { text: "", fontSize: "" }, i3 = (e2 = (e2 = e2.substr(0, 1) == "(" ? e2.substr(1) : e2).substr(e2.length - 1) == ")" ? e2.substr(0, e2.length - 1) : e2).split(" "), a3 = r2, o3 = At.internal.getHeight(t3) || 0;
    o3 = o3 < 0 ? -o3 : o3;
    var s3 = At.internal.getWidth(t3) || 0;
    s3 = s3 < 0 ? -s3 : s3;
    var c4 = function(e3, r3, n4) {
      if (e3 + 1 < i3.length) {
        var a4 = r3 + " " + i3[e3 + 1];
        return et2(a4, t3, n4).width <= s3 - 4;
      }
      return false;
    };
    a3++;
    t:
      for (; a3 > 0; ) {
        e2 = "", a3--;
        var u3, h4, l3 = et2("3", t3, a3).height, f3 = t3.multiline ? o3 - a3 : (o3 - l3) / 2, d2 = f3 += 2, p4 = 0, g2 = 0;
        if (a3 <= 0) {
          e2 = "(...) Tj\n", e2 += "% Width of Text: " + et2(e2, t3, a3 = 12).width + ", FieldWidth:" + s3 + "\n";
          break;
        }
        var m4 = "", v3 = 0;
        for (var b2 in i3)
          if (i3.hasOwnProperty(b2)) {
            m4 = (m4 += i3[b2] + " ").substr(m4.length - 1) == " " ? m4.substr(0, m4.length - 1) : m4;
            var y3 = parseInt(b2), w2 = c4(y3, m4, a3), N3 = b2 >= i3.length - 1;
            if (w2 && !N3) {
              m4 += " ";
              continue;
            }
            if (w2 || N3) {
              if (N3)
                g2 = y3;
              else if (t3.multiline && (l3 + 2) * (v3 + 2) + 2 > o3)
                continue t;
            } else {
              if (!t3.multiline)
                continue t;
              if ((l3 + 2) * (v3 + 2) + 2 > o3)
                continue t;
              g2 = y3;
            }
            for (var L2 = "", A2 = p4; A2 <= g2; A2++)
              L2 += i3[A2] + " ";
            switch (L2 = L2.substr(L2.length - 1) == " " ? L2.substr(0, L2.length - 1) : L2, h4 = et2(L2, t3, a3).width, t3.textAlign) {
              case "right":
                u3 = s3 - h4 - 2;
                break;
              case "center":
                u3 = (s3 - h4) / 2;
                break;
              case "left":
              default:
                u3 = 2;
            }
            e2 += U(u3) + " " + U(d2) + " Td\n", e2 += "(" + R(L2) + ") Tj\n", e2 += -U(u3) + " 0 Td\n", d2 = -(a3 + 2), h4 = 0, p4 = g2 + 1, v3++, m4 = "";
          } else
            ;
        break;
      }
    return n3.text = e2, n3.fontSize = a3, n3;
  };
  var et2 = function(t3, e2, r2) {
    var n3 = e2.scope.internal.getFont(e2.fontName, e2.fontStyle), i3 = e2.scope.getStringUnitWidth(t3, { font: n3, fontSize: parseFloat(r2), charSpace: 0 }) * parseFloat(r2);
    return { height: e2.scope.getStringUnitWidth("3", { font: n3, fontSize: parseFloat(r2), charSpace: 0 }) * parseFloat(r2) * 1.5, width: i3 };
  };
  var rt = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: false, internal: null, isInitialized: false };
  var nt = function(t3, e2) {
    var r2 = { type: "reference", object: t3 };
    e2.internal.getPageInfo(t3.page).pageContext.annotations.find(function(t4) {
      return t4.type === r2.type && t4.object === r2.object;
    }) === void 0 && e2.internal.getPageInfo(t3.page).pageContext.annotations.push(r2);
  };
  var it = function(e2, r2) {
    for (var n3 in e2)
      if (e2.hasOwnProperty(n3)) {
        var i3 = n3, a3 = e2[n3];
        r2.internal.newObjectDeferredBegin(a3.objId, true), _typeof(a3) === "object" && typeof a3.putStream == "function" && a3.putStream(), delete e2[i3];
      }
  };
  var at = function(e2, r2) {
    if (r2.scope = e2, e2.internal !== void 0 && (e2.internal.acroformPlugin === void 0 || e2.internal.acroformPlugin.isInitialized === false)) {
      if (lt.FieldNum = 0, e2.internal.acroformPlugin = JSON.parse(JSON.stringify(rt)), e2.internal.acroformPlugin.acroFormDictionaryRoot)
        throw new Error("Exception while creating AcroformDictionary");
      D = e2.internal.scaleFactor, e2.internal.acroformPlugin.acroFormDictionaryRoot = new ht(), e2.internal.acroformPlugin.acroFormDictionaryRoot.scope = e2, e2.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e2.internal.events.subscribe("postPutResources", function() {
        !function(t3) {
          t3.internal.events.unsubscribe(t3.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t3.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t3.internal.acroformPlugin.printedOut = true;
        }(e2);
      }), e2.internal.events.subscribe("buildDocument", function() {
        !function(t3) {
          t3.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
          var e3 = t3.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
          for (var r3 in e3)
            if (e3.hasOwnProperty(r3)) {
              var n3 = e3[r3];
              n3.objId = void 0, n3.hasAnnotation && nt(n3, t3);
            }
        }(e2);
      }), e2.internal.events.subscribe("putCatalog", function() {
        !function(t3) {
          if (t3.internal.acroformPlugin.acroFormDictionaryRoot === void 0)
            throw new Error("putCatalogCallback: Root missing.");
          t3.internal.write("/AcroForm " + t3.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
        }(e2);
      }), e2.internal.events.subscribe("postPutPages", function(r3) {
        !function(e3, r4) {
          var n3 = !e3;
          for (var i3 in e3 || (r4.internal.newObjectDeferredBegin(r4.internal.acroformPlugin.acroFormDictionaryRoot.objId, true), r4.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e3 = e3 || r4.internal.acroformPlugin.acroFormDictionaryRoot.Kids)
            if (e3.hasOwnProperty(i3)) {
              var a3 = e3[i3], o3 = [], s3 = a3.Rect;
              if (a3.Rect && (a3.Rect = $11(a3.Rect, r4)), r4.internal.newObjectDeferredBegin(a3.objId, true), a3.DA = At.createDefaultAppearanceStream(a3), _typeof(a3) === "object" && typeof a3.getKeyValueListForStream == "function" && (o3 = a3.getKeyValueListForStream()), a3.Rect = s3, a3.hasAppearanceStream && !a3.appearanceStreamContent) {
                var c4 = Q(a3);
                o3.push({ key: "AP", value: "<</N " + c4 + ">>" }), r4.internal.acroformPlugin.xForms.push(c4);
              }
              if (a3.appearanceStreamContent) {
                var u3 = "";
                for (var h4 in a3.appearanceStreamContent)
                  if (a3.appearanceStreamContent.hasOwnProperty(h4)) {
                    var l3 = a3.appearanceStreamContent[h4];
                    if (u3 += "/" + h4 + " ", u3 += "<<", Object.keys(l3).length >= 1 || Array.isArray(l3)) {
                      for (var i3 in l3)
                        if (l3.hasOwnProperty(i3)) {
                          var f3 = l3[i3];
                          typeof f3 == "function" && (f3 = f3.call(r4, a3)), u3 += "/" + i3 + " " + f3 + " ", r4.internal.acroformPlugin.xForms.indexOf(f3) >= 0 || r4.internal.acroformPlugin.xForms.push(f3);
                        }
                    } else
                      typeof (f3 = l3) == "function" && (f3 = f3.call(r4, a3)), u3 += "/" + i3 + " " + f3, r4.internal.acroformPlugin.xForms.indexOf(f3) >= 0 || r4.internal.acroformPlugin.xForms.push(f3);
                    u3 += ">>";
                  }
                o3.push({ key: "AP", value: "<<\n" + u3 + ">>" });
              }
              r4.internal.putStream({ additionalKeyValues: o3, objectId: a3.objId }), r4.internal.out("endobj");
            }
          n3 && it(r4.internal.acroformPlugin.xForms, r4);
        }(r3, e2);
      }), e2.internal.acroformPlugin.isInitialized = true;
    }
  };
  var ot = q.__acroform__.arrayToPdfArray = function(e2, r2, n3) {
    var i3 = function(t3) {
      return t3;
    };
    if (Array.isArray(e2)) {
      for (var a3 = "[", o3 = 0; o3 < e2.length; o3++)
        switch (o3 !== 0 && (a3 += " "), _typeof(e2[o3])) {
          case "boolean":
          case "number":
          case "object":
            a3 += e2[o3].toString();
            break;
          case "string":
            e2[o3].substr(0, 1) !== "/" ? (r2 !== void 0 && n3 && (i3 = n3.internal.getEncryptor(r2)), a3 += "(" + R(i3(e2[o3].toString())) + ")") : a3 += e2[o3].toString();
        }
      return a3 += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
  };
  var st = function(t3, e2, r2) {
    var n3 = function(t4) {
      return t4;
    };
    return e2 !== void 0 && r2 && (n3 = r2.internal.getEncryptor(e2)), (t3 = t3 || "").toString(), t3 = "(" + R(n3(t3)) + ")";
  };
  var ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
      if (this._objId === void 0) {
        if (this.scope === void 0)
          return;
        this._objId = this.scope.internal.newObjectDeferred();
      }
      return this._objId;
    }, set: function(t3) {
      this._objId = t3;
    } }), Object.defineProperty(this, "scope", { value: this._scope, writable: true });
  };
  ct.prototype.toString = function() {
    return this.objId + " 0 R";
  }, ct.prototype.putStream = function() {
    var t3 = this.getKeyValueListForStream();
    this.scope.internal.putStream({ data: this.stream, additionalKeyValues: t3, objectId: this.objId }), this.scope.internal.out("endobj");
  }, ct.prototype.getKeyValueListForStream = function() {
    var t3 = [], e2 = Object.getOwnPropertyNames(this).filter(function(t4) {
      return t4 != "content" && t4 != "appearanceStreamContent" && t4 != "scope" && t4 != "objId" && t4.substring(0, 1) != "_";
    });
    for (var r2 in e2)
      if (Object.getOwnPropertyDescriptor(this, e2[r2]).configurable === false) {
        var n3 = e2[r2], i3 = this[n3];
        i3 && (Array.isArray(i3) ? t3.push({ key: n3, value: ot(i3, this.objId, this.scope) }) : i3 instanceof ct ? (i3.scope = this.scope, t3.push({ key: n3, value: i3.objId + " 0 R" })) : typeof i3 != "function" && t3.push({ key: n3, value: i3 }));
      }
    return t3;
  };
  var ut = function() {
    ct.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: false, writable: true }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: false, writable: true }), Object.defineProperty(this, "FormType", { value: 1, configurable: false, writable: true });
    var t3, e2 = [];
    Object.defineProperty(this, "BBox", { configurable: false, get: function() {
      return e2;
    }, set: function(t4) {
      e2 = t4;
    } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: false, writable: true }), Object.defineProperty(this, "stream", { enumerable: false, configurable: true, set: function(e3) {
      t3 = e3.trim();
    }, get: function() {
      return t3 || null;
    } });
  };
  H(ut, ct);
  var ht = function() {
    ct.call(this);
    var t3, e2 = [];
    Object.defineProperty(this, "Kids", { enumerable: false, configurable: true, get: function() {
      return e2.length > 0 ? e2 : void 0;
    } }), Object.defineProperty(this, "Fields", { enumerable: false, configurable: false, get: function() {
      return e2;
    } }), Object.defineProperty(this, "DA", { enumerable: false, configurable: false, get: function() {
      if (t3) {
        var e3 = function(t4) {
          return t4;
        };
        return this.scope && (e3 = this.scope.internal.getEncryptor(this.objId)), "(" + R(e3(t3)) + ")";
      }
    }, set: function(e3) {
      t3 = e3;
    } });
  };
  H(ht, ct);
  var lt = function t2() {
    ct.call(this);
    var e2 = 4;
    Object.defineProperty(this, "F", { enumerable: false, configurable: false, get: function() {
      return e2;
    }, set: function(t3) {
      if (isNaN(t3))
        throw new Error('Invalid value "' + t3 + '" for attribute F supplied.');
      e2 = t3;
    } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(e2, 3));
    }, set: function(t3) {
      Boolean(t3) === true ? this.F = K(e2, 3) : this.F = Z(e2, 3);
    } });
    var r2 = 0;
    Object.defineProperty(this, "Ff", { enumerable: false, configurable: false, get: function() {
      return r2;
    }, set: function(t3) {
      if (isNaN(t3))
        throw new Error('Invalid value "' + t3 + '" for attribute Ff supplied.');
      r2 = t3;
    } });
    var n3 = [];
    Object.defineProperty(this, "Rect", { enumerable: false, configurable: false, get: function() {
      if (n3.length !== 0)
        return n3;
    }, set: function(t3) {
      n3 = t3 !== void 0 ? t3 : [];
    } }), Object.defineProperty(this, "x", { enumerable: true, configurable: true, get: function() {
      return !n3 || isNaN(n3[0]) ? 0 : n3[0];
    }, set: function(t3) {
      n3[0] = t3;
    } }), Object.defineProperty(this, "y", { enumerable: true, configurable: true, get: function() {
      return !n3 || isNaN(n3[1]) ? 0 : n3[1];
    }, set: function(t3) {
      n3[1] = t3;
    } }), Object.defineProperty(this, "width", { enumerable: true, configurable: true, get: function() {
      return !n3 || isNaN(n3[2]) ? 0 : n3[2];
    }, set: function(t3) {
      n3[2] = t3;
    } }), Object.defineProperty(this, "height", { enumerable: true, configurable: true, get: function() {
      return !n3 || isNaN(n3[3]) ? 0 : n3[3];
    }, set: function(t3) {
      n3[3] = t3;
    } });
    var i3 = "";
    Object.defineProperty(this, "FT", { enumerable: true, configurable: false, get: function() {
      return i3;
    }, set: function(t3) {
      switch (t3) {
        case "/Btn":
        case "/Tx":
        case "/Ch":
        case "/Sig":
          i3 = t3;
          break;
        default:
          throw new Error('Invalid value "' + t3 + '" for attribute FT supplied.');
      }
    } });
    var a3 = null;
    Object.defineProperty(this, "T", { enumerable: true, configurable: false, get: function() {
      if (!a3 || a3.length < 1) {
        if (this instanceof yt)
          return;
        a3 = "FieldObject" + t2.FieldNum++;
      }
      var e3 = function(t3) {
        return t3;
      };
      return this.scope && (e3 = this.scope.internal.getEncryptor(this.objId)), "(" + R(e3(a3)) + ")";
    }, set: function(t3) {
      a3 = t3.toString();
    } }), Object.defineProperty(this, "fieldName", { configurable: true, enumerable: true, get: function() {
      return a3;
    }, set: function(t3) {
      a3 = t3;
    } });
    var o3 = "helvetica";
    Object.defineProperty(this, "fontName", { enumerable: true, configurable: true, get: function() {
      return o3;
    }, set: function(t3) {
      o3 = t3;
    } });
    var s3 = "normal";
    Object.defineProperty(this, "fontStyle", { enumerable: true, configurable: true, get: function() {
      return s3;
    }, set: function(t3) {
      s3 = t3;
    } });
    var c4 = 0;
    Object.defineProperty(this, "fontSize", { enumerable: true, configurable: true, get: function() {
      return c4;
    }, set: function(t3) {
      c4 = t3;
    } });
    var u3 = void 0;
    Object.defineProperty(this, "maxFontSize", { enumerable: true, configurable: true, get: function() {
      return u3 === void 0 ? 50 / D : u3;
    }, set: function(t3) {
      u3 = t3;
    } });
    var h4 = "black";
    Object.defineProperty(this, "color", { enumerable: true, configurable: true, get: function() {
      return h4;
    }, set: function(t3) {
      h4 = t3;
    } });
    var l3 = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", { enumerable: true, configurable: false, get: function() {
      if (!(!l3 || this instanceof yt || this instanceof Nt))
        return st(l3, this.objId, this.scope);
    }, set: function(t3) {
      t3 = t3.toString(), l3 = t3;
    } });
    var f3 = null;
    Object.defineProperty(this, "DV", { enumerable: false, configurable: false, get: function() {
      if (f3)
        return this instanceof mt == false ? st(f3, this.objId, this.scope) : f3;
    }, set: function(t3) {
      t3 = t3.toString(), f3 = this instanceof mt == false ? t3.substr(0, 1) === "(" ? T2(t3.substr(1, t3.length - 2)) : T2(t3) : t3;
    } }), Object.defineProperty(this, "defaultValue", { enumerable: true, configurable: true, get: function() {
      return this instanceof mt == true ? T2(f3.substr(1, f3.length - 1)) : f3;
    }, set: function(t3) {
      t3 = t3.toString(), f3 = this instanceof mt == true ? "/" + t3 : t3;
    } });
    var d2 = null;
    Object.defineProperty(this, "_V", { enumerable: false, configurable: false, get: function() {
      if (d2)
        return d2;
    }, set: function(t3) {
      this.V = t3;
    } }), Object.defineProperty(this, "V", { enumerable: false, configurable: false, get: function() {
      if (d2)
        return this instanceof mt == false ? st(d2, this.objId, this.scope) : d2;
    }, set: function(t3) {
      t3 = t3.toString(), d2 = this instanceof mt == false ? t3.substr(0, 1) === "(" ? T2(t3.substr(1, t3.length - 2)) : T2(t3) : t3;
    } }), Object.defineProperty(this, "value", { enumerable: true, configurable: true, get: function() {
      return this instanceof mt == true ? T2(d2.substr(1, d2.length - 1)) : d2;
    }, set: function(t3) {
      t3 = t3.toString(), d2 = this instanceof mt == true ? "/" + t3 : t3;
    } }), Object.defineProperty(this, "hasAnnotation", { enumerable: true, configurable: true, get: function() {
      return this.Rect;
    } }), Object.defineProperty(this, "Type", { enumerable: true, configurable: false, get: function() {
      return this.hasAnnotation ? "/Annot" : null;
    } }), Object.defineProperty(this, "Subtype", { enumerable: true, configurable: false, get: function() {
      return this.hasAnnotation ? "/Widget" : null;
    } });
    var p4, g2 = false;
    Object.defineProperty(this, "hasAppearanceStream", { enumerable: true, configurable: true, get: function() {
      return g2;
    }, set: function(t3) {
      t3 = Boolean(t3), g2 = t3;
    } }), Object.defineProperty(this, "page", { enumerable: true, configurable: true, get: function() {
      if (p4)
        return p4;
    }, set: function(t3) {
      p4 = t3;
    } }), Object.defineProperty(this, "readOnly", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 1));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 1) : this.Ff = Z(this.Ff, 1);
    } }), Object.defineProperty(this, "required", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 2));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 2) : this.Ff = Z(this.Ff, 2);
    } }), Object.defineProperty(this, "noExport", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 3));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 3) : this.Ff = Z(this.Ff, 3);
    } });
    var m4 = null;
    Object.defineProperty(this, "Q", { enumerable: true, configurable: false, get: function() {
      if (m4 !== null)
        return m4;
    }, set: function(t3) {
      if ([0, 1, 2].indexOf(t3) === -1)
        throw new Error('Invalid value "' + t3 + '" for attribute Q supplied.');
      m4 = t3;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      var t3;
      switch (m4) {
        case 0:
        default:
          t3 = "left";
          break;
        case 1:
          t3 = "center";
          break;
        case 2:
          t3 = "right";
      }
      return t3;
    }, configurable: true, enumerable: true, set: function(t3) {
      switch (t3) {
        case "right":
        case 2:
          m4 = 2;
          break;
        case "center":
        case 1:
          m4 = 1;
          break;
        case "left":
        case 0:
        default:
          m4 = 0;
      }
    } });
  };
  H(lt, ct);
  var ft = function() {
    lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t3 = 0;
    Object.defineProperty(this, "TI", { enumerable: true, configurable: false, get: function() {
      return t3;
    }, set: function(e3) {
      t3 = e3;
    } }), Object.defineProperty(this, "topIndex", { enumerable: true, configurable: true, get: function() {
      return t3;
    }, set: function(e3) {
      t3 = e3;
    } });
    var e2 = [];
    Object.defineProperty(this, "Opt", { enumerable: true, configurable: false, get: function() {
      return ot(e2, this.objId, this.scope);
    }, set: function(t4) {
      var r2, n3;
      n3 = [], typeof (r2 = t4) == "string" && (n3 = function(t5, e3, r3) {
        r3 || (r3 = 1);
        for (var n4, i3 = []; n4 = e3.exec(t5); )
          i3.push(n4[r3]);
        return i3;
      }(r2, /\((.*?)\)/g)), e2 = n3;
    } }), this.getOptions = function() {
      return e2;
    }, this.setOptions = function(t4) {
      e2 = t4, this.sort && e2.sort();
    }, this.addOption = function(t4) {
      t4 = (t4 = t4 || "").toString(), e2.push(t4), this.sort && e2.sort();
    }, this.removeOption = function(t4, r2) {
      for (r2 = r2 || false, t4 = (t4 = t4 || "").toString(); e2.indexOf(t4) !== -1 && (e2.splice(e2.indexOf(t4), 1), r2 !== false); )
        ;
    }, Object.defineProperty(this, "combo", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 18));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 18) : this.Ff = Z(this.Ff, 18);
    } }), Object.defineProperty(this, "edit", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 19));
    }, set: function(t4) {
      this.combo === true && (Boolean(t4) === true ? this.Ff = K(this.Ff, 19) : this.Ff = Z(this.Ff, 19));
    } }), Object.defineProperty(this, "sort", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 20));
    }, set: function(t4) {
      Boolean(t4) === true ? (this.Ff = K(this.Ff, 20), e2.sort()) : this.Ff = Z(this.Ff, 20);
    } }), Object.defineProperty(this, "multiSelect", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 22));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 22) : this.Ff = Z(this.Ff, 22);
    } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 23));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 23) : this.Ff = Z(this.Ff, 23);
    } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 27));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 27) : this.Ff = Z(this.Ff, 27);
    } }), this.hasAppearanceStream = false;
  };
  H(ft, lt);
  var dt = function() {
    ft.call(this), this.fontName = "helvetica", this.combo = false;
  };
  H(dt, ft);
  var pt = function() {
    dt.call(this), this.combo = true;
  };
  H(pt, dt);
  var gt = function() {
    pt.call(this), this.edit = true;
  };
  H(gt, pt);
  var mt = function() {
    lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 15));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 15) : this.Ff = Z(this.Ff, 15);
    } }), Object.defineProperty(this, "radio", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 16));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 16) : this.Ff = Z(this.Ff, 16);
    } }), Object.defineProperty(this, "pushButton", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 17));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 17) : this.Ff = Z(this.Ff, 17);
    } }), Object.defineProperty(this, "radioIsUnison", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 26));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 26) : this.Ff = Z(this.Ff, 26);
    } });
    var e2, r2 = {};
    Object.defineProperty(this, "MK", { enumerable: false, configurable: false, get: function() {
      var t3 = function(t4) {
        return t4;
      };
      if (this.scope && (t3 = this.scope.internal.getEncryptor(this.objId)), Object.keys(r2).length !== 0) {
        var e3, n3 = [];
        for (e3 in n3.push("<<"), r2)
          n3.push("/" + e3 + " (" + R(t3(r2[e3])) + ")");
        return n3.push(">>"), n3.join("\n");
      }
    }, set: function(e3) {
      _typeof(e3) === "object" && (r2 = e3);
    } }), Object.defineProperty(this, "caption", { enumerable: true, configurable: true, get: function() {
      return r2.CA || "";
    }, set: function(t3) {
      typeof t3 == "string" && (r2.CA = t3);
    } }), Object.defineProperty(this, "AS", { enumerable: false, configurable: false, get: function() {
      return e2;
    }, set: function(t3) {
      e2 = t3;
    } }), Object.defineProperty(this, "appearanceState", { enumerable: true, configurable: true, get: function() {
      return e2.substr(1, e2.length - 1);
    }, set: function(t3) {
      e2 = "/" + t3;
    } });
  };
  H(mt, lt);
  var vt = function() {
    mt.call(this), this.pushButton = true;
  };
  H(vt, mt);
  var bt = function() {
    mt.call(this), this.radio = true, this.pushButton = false;
    var t3 = [];
    Object.defineProperty(this, "Kids", { enumerable: true, configurable: false, get: function() {
      return t3;
    }, set: function(e2) {
      t3 = e2 !== void 0 ? e2 : [];
    } });
  };
  H(bt, mt);
  var yt = function() {
    var e2, r2;
    lt.call(this), Object.defineProperty(this, "Parent", { enumerable: false, configurable: false, get: function() {
      return e2;
    }, set: function(t3) {
      e2 = t3;
    } }), Object.defineProperty(this, "optionName", { enumerable: false, configurable: true, get: function() {
      return r2;
    }, set: function(t3) {
      r2 = t3;
    } });
    var n3, i3 = {};
    Object.defineProperty(this, "MK", { enumerable: false, configurable: false, get: function() {
      var t3 = function(t4) {
        return t4;
      };
      this.scope && (t3 = this.scope.internal.getEncryptor(this.objId));
      var e3, r3 = [];
      for (e3 in r3.push("<<"), i3)
        r3.push("/" + e3 + " (" + R(t3(i3[e3])) + ")");
      return r3.push(">>"), r3.join("\n");
    }, set: function(e3) {
      _typeof(e3) === "object" && (i3 = e3);
    } }), Object.defineProperty(this, "caption", { enumerable: true, configurable: true, get: function() {
      return i3.CA || "";
    }, set: function(t3) {
      typeof t3 == "string" && (i3.CA = t3);
    } }), Object.defineProperty(this, "AS", { enumerable: false, configurable: false, get: function() {
      return n3;
    }, set: function(t3) {
      n3 = t3;
    } }), Object.defineProperty(this, "appearanceState", { enumerable: true, configurable: true, get: function() {
      return n3.substr(1, n3.length - 1);
    }, set: function(t3) {
      n3 = "/" + t3;
    } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = At.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
  };
  H(yt, lt), bt.prototype.setAppearance = function(t3) {
    if (!("createAppearanceStream" in t3) || !("getCA" in t3))
      throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for (var e2 in this.Kids)
      if (this.Kids.hasOwnProperty(e2)) {
        var r2 = this.Kids[e2];
        r2.appearanceStreamContent = t3.createAppearanceStream(r2.optionName), r2.caption = t3.getCA();
      }
  }, bt.prototype.createOption = function(t3) {
    var e2 = new yt();
    return e2.Parent = this, e2.optionName = t3, this.Kids.push(e2), xt.call(this.scope, e2), e2;
  };
  var wt = function() {
    mt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = At.CheckBox.createAppearanceStream();
  };
  H(wt, mt);
  var Nt = function() {
    lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 13));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 13) : this.Ff = Z(this.Ff, 13);
    } }), Object.defineProperty(this, "fileSelect", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 21));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 21) : this.Ff = Z(this.Ff, 21);
    } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 23));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 23) : this.Ff = Z(this.Ff, 23);
    } }), Object.defineProperty(this, "doNotScroll", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 24));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 24) : this.Ff = Z(this.Ff, 24);
    } }), Object.defineProperty(this, "comb", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 25));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 25) : this.Ff = Z(this.Ff, 25);
    } }), Object.defineProperty(this, "richText", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 26));
    }, set: function(t4) {
      Boolean(t4) === true ? this.Ff = K(this.Ff, 26) : this.Ff = Z(this.Ff, 26);
    } });
    var t3 = null;
    Object.defineProperty(this, "MaxLen", { enumerable: true, configurable: false, get: function() {
      return t3;
    }, set: function(e2) {
      t3 = e2;
    } }), Object.defineProperty(this, "maxLength", { enumerable: true, configurable: true, get: function() {
      return t3;
    }, set: function(e2) {
      Number.isInteger(e2) && (t3 = e2);
    } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: true, configurable: true, get: function() {
      return this.V || this.DV;
    } });
  };
  H(Nt, lt);
  var Lt = function() {
    Nt.call(this), Object.defineProperty(this, "password", { enumerable: true, configurable: true, get: function() {
      return Boolean(X(this.Ff, 14));
    }, set: function(t3) {
      Boolean(t3) === true ? this.Ff = K(this.Ff, 14) : this.Ff = Z(this.Ff, 14);
    } }), this.password = true;
  };
  H(Lt, Nt);
  var At = { CheckBox: { createAppearanceStream: function() {
    return { N: { On: At.CheckBox.YesNormal }, D: { On: At.CheckBox.YesPushDown, Off: At.CheckBox.OffPushDown } };
  }, YesPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [], n3 = t3.scope.internal.getFont(t3.fontName, t3.fontStyle).id, i3 = t3.scope.__private__.encodeColorString(t3.color), a3 = tt(t3, t3.caption);
    return r2.push("0.749023 g"), r2.push("0 0 " + U(At.internal.getWidth(t3)) + " " + U(At.internal.getHeight(t3)) + " re"), r2.push("f"), r2.push("BMC"), r2.push("q"), r2.push("0 0 1 rg"), r2.push("/" + n3 + " " + U(a3.fontSize) + " Tf " + i3), r2.push("BT"), r2.push(a3.text), r2.push("ET"), r2.push("Q"), r2.push("EMC"), e2.stream = r2.join("\n"), e2;
  }, YesNormal: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = t3.scope.internal.getFont(t3.fontName, t3.fontStyle).id, n3 = t3.scope.__private__.encodeColorString(t3.color), i3 = [], a3 = At.internal.getHeight(t3), o3 = At.internal.getWidth(t3), s3 = tt(t3, t3.caption);
    return i3.push("1 g"), i3.push("0 0 " + U(o3) + " " + U(a3) + " re"), i3.push("f"), i3.push("q"), i3.push("0 0 1 rg"), i3.push("0 0 " + U(o3 - 1) + " " + U(a3 - 1) + " re"), i3.push("W"), i3.push("n"), i3.push("0 g"), i3.push("BT"), i3.push("/" + r2 + " " + U(s3.fontSize) + " Tf " + n3), i3.push(s3.text), i3.push("ET"), i3.push("Q"), e2.stream = i3.join("\n"), e2;
  }, OffPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [];
    return r2.push("0.749023 g"), r2.push("0 0 " + U(At.internal.getWidth(t3)) + " " + U(At.internal.getHeight(t3)) + " re"), r2.push("f"), e2.stream = r2.join("\n"), e2;
  } }, RadioButton: { Circle: { createAppearanceStream: function(t3) {
    var e2 = { D: { Off: At.RadioButton.Circle.OffPushDown }, N: {} };
    return e2.N[t3] = At.RadioButton.Circle.YesNormal, e2.D[t3] = At.RadioButton.Circle.YesPushDown, e2;
  }, getCA: function() {
    return "l";
  }, YesNormal: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [], n3 = At.internal.getWidth(t3) <= At.internal.getHeight(t3) ? At.internal.getWidth(t3) / 4 : At.internal.getHeight(t3) / 4;
    n3 = Number((0.9 * n3).toFixed(5));
    var i3 = At.internal.Bezier_C, a3 = Number((n3 * i3).toFixed(5));
    return r2.push("q"), r2.push("1 0 0 1 " + z(At.internal.getWidth(t3) / 2) + " " + z(At.internal.getHeight(t3) / 2) + " cm"), r2.push(n3 + " 0 m"), r2.push(n3 + " " + a3 + " " + a3 + " " + n3 + " 0 " + n3 + " c"), r2.push("-" + a3 + " " + n3 + " -" + n3 + " " + a3 + " -" + n3 + " 0 c"), r2.push("-" + n3 + " -" + a3 + " -" + a3 + " -" + n3 + " 0 -" + n3 + " c"), r2.push(a3 + " -" + n3 + " " + n3 + " -" + a3 + " " + n3 + " 0 c"), r2.push("f"), r2.push("Q"), e2.stream = r2.join("\n"), e2;
  }, YesPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [], n3 = At.internal.getWidth(t3) <= At.internal.getHeight(t3) ? At.internal.getWidth(t3) / 4 : At.internal.getHeight(t3) / 4;
    n3 = Number((0.9 * n3).toFixed(5));
    var i3 = Number((2 * n3).toFixed(5)), a3 = Number((i3 * At.internal.Bezier_C).toFixed(5)), o3 = Number((n3 * At.internal.Bezier_C).toFixed(5));
    return r2.push("0.749023 g"), r2.push("q"), r2.push("1 0 0 1 " + z(At.internal.getWidth(t3) / 2) + " " + z(At.internal.getHeight(t3) / 2) + " cm"), r2.push(i3 + " 0 m"), r2.push(i3 + " " + a3 + " " + a3 + " " + i3 + " 0 " + i3 + " c"), r2.push("-" + a3 + " " + i3 + " -" + i3 + " " + a3 + " -" + i3 + " 0 c"), r2.push("-" + i3 + " -" + a3 + " -" + a3 + " -" + i3 + " 0 -" + i3 + " c"), r2.push(a3 + " -" + i3 + " " + i3 + " -" + a3 + " " + i3 + " 0 c"), r2.push("f"), r2.push("Q"), r2.push("0 g"), r2.push("q"), r2.push("1 0 0 1 " + z(At.internal.getWidth(t3) / 2) + " " + z(At.internal.getHeight(t3) / 2) + " cm"), r2.push(n3 + " 0 m"), r2.push(n3 + " " + o3 + " " + o3 + " " + n3 + " 0 " + n3 + " c"), r2.push("-" + o3 + " " + n3 + " -" + n3 + " " + o3 + " -" + n3 + " 0 c"), r2.push("-" + n3 + " -" + o3 + " -" + o3 + " -" + n3 + " 0 -" + n3 + " c"), r2.push(o3 + " -" + n3 + " " + n3 + " -" + o3 + " " + n3 + " 0 c"), r2.push("f"), r2.push("Q"), e2.stream = r2.join("\n"), e2;
  }, OffPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [], n3 = At.internal.getWidth(t3) <= At.internal.getHeight(t3) ? At.internal.getWidth(t3) / 4 : At.internal.getHeight(t3) / 4;
    n3 = Number((0.9 * n3).toFixed(5));
    var i3 = Number((2 * n3).toFixed(5)), a3 = Number((i3 * At.internal.Bezier_C).toFixed(5));
    return r2.push("0.749023 g"), r2.push("q"), r2.push("1 0 0 1 " + z(At.internal.getWidth(t3) / 2) + " " + z(At.internal.getHeight(t3) / 2) + " cm"), r2.push(i3 + " 0 m"), r2.push(i3 + " " + a3 + " " + a3 + " " + i3 + " 0 " + i3 + " c"), r2.push("-" + a3 + " " + i3 + " -" + i3 + " " + a3 + " -" + i3 + " 0 c"), r2.push("-" + i3 + " -" + a3 + " -" + a3 + " -" + i3 + " 0 -" + i3 + " c"), r2.push(a3 + " -" + i3 + " " + i3 + " -" + a3 + " " + i3 + " 0 c"), r2.push("f"), r2.push("Q"), e2.stream = r2.join("\n"), e2;
  } }, Cross: { createAppearanceStream: function(t3) {
    var e2 = { D: { Off: At.RadioButton.Cross.OffPushDown }, N: {} };
    return e2.N[t3] = At.RadioButton.Cross.YesNormal, e2.D[t3] = At.RadioButton.Cross.YesPushDown, e2;
  }, getCA: function() {
    return "8";
  }, YesNormal: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [], n3 = At.internal.calculateCross(t3);
    return r2.push("q"), r2.push("1 1 " + U(At.internal.getWidth(t3) - 2) + " " + U(At.internal.getHeight(t3) - 2) + " re"), r2.push("W"), r2.push("n"), r2.push(U(n3.x1.x) + " " + U(n3.x1.y) + " m"), r2.push(U(n3.x2.x) + " " + U(n3.x2.y) + " l"), r2.push(U(n3.x4.x) + " " + U(n3.x4.y) + " m"), r2.push(U(n3.x3.x) + " " + U(n3.x3.y) + " l"), r2.push("s"), r2.push("Q"), e2.stream = r2.join("\n"), e2;
  }, YesPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = At.internal.calculateCross(t3), n3 = [];
    return n3.push("0.749023 g"), n3.push("0 0 " + U(At.internal.getWidth(t3)) + " " + U(At.internal.getHeight(t3)) + " re"), n3.push("f"), n3.push("q"), n3.push("1 1 " + U(At.internal.getWidth(t3) - 2) + " " + U(At.internal.getHeight(t3) - 2) + " re"), n3.push("W"), n3.push("n"), n3.push(U(r2.x1.x) + " " + U(r2.x1.y) + " m"), n3.push(U(r2.x2.x) + " " + U(r2.x2.y) + " l"), n3.push(U(r2.x4.x) + " " + U(r2.x4.y) + " m"), n3.push(U(r2.x3.x) + " " + U(r2.x3.y) + " l"), n3.push("s"), n3.push("Q"), e2.stream = n3.join("\n"), e2;
  }, OffPushDown: function(t3) {
    var e2 = V(t3);
    e2.scope = t3.scope;
    var r2 = [];
    return r2.push("0.749023 g"), r2.push("0 0 " + U(At.internal.getWidth(t3)) + " " + U(At.internal.getHeight(t3)) + " re"), r2.push("f"), e2.stream = r2.join("\n"), e2;
  } } }, createDefaultAppearanceStream: function(t3) {
    var e2 = t3.scope.internal.getFont(t3.fontName, t3.fontStyle).id, r2 = t3.scope.__private__.encodeColorString(t3.color);
    return "/" + e2 + " " + t3.fontSize + " Tf " + r2;
  } };
  At.internal = { Bezier_C: 0.551915024494, calculateCross: function(t3) {
    var e2 = At.internal.getWidth(t3), r2 = At.internal.getHeight(t3), n3 = Math.min(e2, r2);
    return { x1: { x: (e2 - n3) / 2, y: (r2 - n3) / 2 + n3 }, x2: { x: (e2 - n3) / 2 + n3, y: (r2 - n3) / 2 }, x3: { x: (e2 - n3) / 2, y: (r2 - n3) / 2 }, x4: { x: (e2 - n3) / 2 + n3, y: (r2 - n3) / 2 + n3 } };
  } }, At.internal.getWidth = function(e2) {
    var r2 = 0;
    return _typeof(e2) === "object" && (r2 = W(e2.Rect[2])), r2;
  }, At.internal.getHeight = function(e2) {
    var r2 = 0;
    return _typeof(e2) === "object" && (r2 = W(e2.Rect[3])), r2;
  };
  var xt = q.addField = function(t3) {
    if (at(this, t3), !(t3 instanceof lt))
      throw new Error("Invalid argument passed to jsPDF.addField.");
    var e2;
    return (e2 = t3).scope.internal.acroformPlugin.printedOut && (e2.scope.internal.acroformPlugin.printedOut = false, e2.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e2.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e2), t3.page = t3.scope.internal.getCurrentPageInfo().pageNumber, this;
  };
  q.AcroFormChoiceField = ft, q.AcroFormListBox = dt, q.AcroFormComboBox = pt, q.AcroFormEditBox = gt, q.AcroFormButton = mt, q.AcroFormPushButton = vt, q.AcroFormRadioButton = bt, q.AcroFormCheckBox = wt, q.AcroFormTextField = Nt, q.AcroFormPasswordField = Lt, q.AcroFormAppearance = At, q.AcroForm = { ChoiceField: ft, ListBox: dt, ComboBox: pt, EditBox: gt, Button: mt, PushButton: vt, RadioButton: bt, CheckBox: wt, TextField: Nt, PasswordField: Lt, Appearance: At }, M.AcroForm = { ChoiceField: ft, ListBox: dt, ComboBox: pt, EditBox: gt, Button: mt, PushButton: vt, RadioButton: bt, CheckBox: wt, TextField: Nt, PasswordField: Lt, Appearance: At };
  var St = M.AcroForm;
  function _t(t3) {
    return t3.reduce(function(t4, e2, r2) {
      return t4[e2] = r2, t4;
    }, {});
  }
  !function(e2) {
    e2.__addimage__ = {};
    var r2 = "UNKNOWN", n3 = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, i3 = e2.__addimage__.getImageFileTypeByImageData = function(t3, e3) {
      var i4, a4, o4, s4, c5, u3 = r2;
      if ((e3 = e3 || r2) === "RGBA" || t3.data !== void 0 && t3.data instanceof Uint8ClampedArray && "height" in t3 && "width" in t3)
        return "RGBA";
      if (x2(t3))
        for (c5 in n3)
          for (o4 = n3[c5], i4 = 0; i4 < o4.length; i4 += 1) {
            for (s4 = true, a4 = 0; a4 < o4[i4].length; a4 += 1)
              if (o4[i4][a4] !== void 0 && o4[i4][a4] !== t3[a4]) {
                s4 = false;
                break;
              }
            if (s4 === true) {
              u3 = c5;
              break;
            }
          }
      else
        for (c5 in n3)
          for (o4 = n3[c5], i4 = 0; i4 < o4.length; i4 += 1) {
            for (s4 = true, a4 = 0; a4 < o4[i4].length; a4 += 1)
              if (o4[i4][a4] !== void 0 && o4[i4][a4] !== t3.charCodeAt(a4)) {
                s4 = false;
                break;
              }
            if (s4 === true) {
              u3 = c5;
              break;
            }
          }
      return u3 === r2 && e3 !== r2 && (u3 = e3), u3;
    }, a3 = function t3(e3) {
      for (var r3 = this.internal.write, n4 = this.internal.putStream, i4 = (0, this.internal.getFilters)(); i4.indexOf("FlateEncode") !== -1; )
        i4.splice(i4.indexOf("FlateEncode"), 1);
      e3.objectId = this.internal.newObject();
      var a4 = [];
      if (a4.push({ key: "Type", value: "/XObject" }), a4.push({ key: "Subtype", value: "/Image" }), a4.push({ key: "Width", value: e3.width }), a4.push({ key: "Height", value: e3.height }), e3.colorSpace === b2.INDEXED ? a4.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (e3.palette.length / 3 - 1) + " " + ("sMask" in e3 && e3.sMask !== void 0 ? e3.objectId + 2 : e3.objectId + 1) + " 0 R]" }) : (a4.push({ key: "ColorSpace", value: "/" + e3.colorSpace }), e3.colorSpace === b2.DEVICE_CMYK && a4.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), a4.push({ key: "BitsPerComponent", value: e3.bitsPerComponent }), "decodeParameters" in e3 && e3.decodeParameters !== void 0 && a4.push({ key: "DecodeParms", value: "<<" + e3.decodeParameters + ">>" }), "transparency" in e3 && Array.isArray(e3.transparency)) {
        for (var o4 = "", s4 = 0, c5 = e3.transparency.length; s4 < c5; s4++)
          o4 += e3.transparency[s4] + " " + e3.transparency[s4] + " ";
        a4.push({ key: "Mask", value: "[" + o4 + "]" });
      }
      e3.sMask !== void 0 && a4.push({ key: "SMask", value: e3.objectId + 1 + " 0 R" });
      var u3 = e3.filter !== void 0 ? ["/" + e3.filter] : void 0;
      if (n4({ data: e3.data, additionalKeyValues: a4, alreadyAppliedFilters: u3, objectId: e3.objectId }), r3("endobj"), "sMask" in e3 && e3.sMask !== void 0) {
        var h5 = "/Predictor " + e3.predictor + " /Colors 1 /BitsPerComponent " + e3.bitsPerComponent + " /Columns " + e3.width, l4 = { width: e3.width, height: e3.height, colorSpace: "DeviceGray", bitsPerComponent: e3.bitsPerComponent, decodeParameters: h5, data: e3.sMask };
        "filter" in e3 && (l4.filter = e3.filter), t3.call(this, l4);
      }
      if (e3.colorSpace === b2.INDEXED) {
        var f4 = this.internal.newObject();
        n4({ data: _3(new Uint8Array(e3.palette)), objectId: f4 }), r3("endobj");
      }
    }, o3 = function() {
      var t3 = this.internal.collections.addImage_images;
      for (var e3 in t3)
        a3.call(this, t3[e3]);
    }, s3 = function() {
      var t3, e3 = this.internal.collections.addImage_images, r3 = this.internal.write;
      for (var n4 in e3)
        r3("/I" + (t3 = e3[n4]).index, t3.objectId, "0", "R");
    }, c4 = function() {
      this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o3), this.internal.events.subscribe("putXobjectDict", s3));
    }, h4 = function() {
      var t3 = this.internal.collections.addImage_images;
      return c4.call(this), t3;
    }, l3 = function() {
      return Object.keys(this.internal.collections.addImage_images).length;
    }, f3 = function(t3) {
      return typeof e2["process" + t3.toUpperCase()] == "function";
    }, d2 = function(e3) {
      return _typeof(e3) === "object" && e3.nodeType === 1;
    }, p4 = function(t3, r3) {
      if (t3.nodeName === "IMG" && t3.hasAttribute("src")) {
        var n4 = "" + t3.getAttribute("src");
        if (n4.indexOf("data:image/") === 0)
          return u2(unescape(n4).split("base64,").pop());
        var i4 = e2.loadFile(n4, true);
        if (i4 !== void 0)
          return i4;
      }
      if (t3.nodeName === "CANVAS") {
        if (t3.width === 0 || t3.height === 0)
          throw new Error("Given canvas must have data. Canvas width: " + t3.width + ", height: " + t3.height);
        var a4;
        switch (r3) {
          case "PNG":
            a4 = "image/png";
            break;
          case "WEBP":
            a4 = "image/webp";
            break;
          case "JPEG":
          case "JPG":
          default:
            a4 = "image/jpeg";
        }
        return u2(t3.toDataURL(a4, 1).split("base64,").pop());
      }
    }, g2 = function(t3) {
      var e3 = this.internal.collections.addImage_images;
      if (e3) {
        for (var r3 in e3)
          if (t3 === e3[r3].alias)
            return e3[r3];
      }
    }, m4 = function(t3, e3, r3) {
      return t3 || e3 || (t3 = -96, e3 = -96), t3 < 0 && (t3 = -1 * r3.width * 72 / t3 / this.internal.scaleFactor), e3 < 0 && (e3 = -1 * r3.height * 72 / e3 / this.internal.scaleFactor), t3 === 0 && (t3 = e3 * r3.width / r3.height), e3 === 0 && (e3 = t3 * r3.height / r3.width), [t3, e3];
    }, v3 = function(t3, e3, r3, n4, i4, a4) {
      var o4 = m4.call(this, r3, n4, i4), s4 = this.internal.getCoordinateString, c5 = this.internal.getVerticalCoordinateString, u3 = h4.call(this);
      if (r3 = o4[0], n4 = o4[1], u3[i4.index] = i4, a4) {
        a4 *= Math.PI / 180;
        var l4 = Math.cos(a4), f4 = Math.sin(a4), d3 = function(t4) {
          return t4.toFixed(4);
        }, p5 = [d3(l4), d3(f4), d3(-1 * f4), d3(l4), 0, 0, "cm"];
      }
      this.internal.write("q"), a4 ? (this.internal.write([1, "0", "0", 1, s4(t3), c5(e3 + n4), "cm"].join(" ")), this.internal.write(p5.join(" ")), this.internal.write([s4(r3), "0", "0", s4(n4), "0", "0", "cm"].join(" "))) : this.internal.write([s4(r3), "0", "0", s4(n4), s4(t3), c5(e3 + n4), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + i4.index + " Do"), this.internal.write("Q");
    }, b2 = e2.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
    e2.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
    var y3 = e2.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, w2 = e2.__addimage__.sHashCode = function(t3) {
      var e3, r3, n4 = 0;
      if (typeof t3 == "string")
        for (r3 = t3.length, e3 = 0; e3 < r3; e3++)
          n4 = (n4 << 5) - n4 + t3.charCodeAt(e3), n4 |= 0;
      else if (x2(t3))
        for (r3 = t3.byteLength / 2, e3 = 0; e3 < r3; e3++)
          n4 = (n4 << 5) - n4 + t3[e3], n4 |= 0;
      return n4;
    }, N3 = e2.__addimage__.validateStringAsBase64 = function(t3) {
      (t3 = t3 || "").toString().trim();
      var e3 = true;
      return t3.length === 0 && (e3 = false), t3.length % 4 != 0 && (e3 = false), /^[A-Za-z0-9+/]+$/.test(t3.substr(0, t3.length - 2)) === false && (e3 = false), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t3.substr(-2)) === false && (e3 = false), e3;
    }, L2 = e2.__addimage__.extractImageFromDataUrl = function(t3) {
      var e3 = (t3 = t3 || "").split("base64,"), r3 = null;
      if (e3.length === 2) {
        var n4 = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e3[0]);
        Array.isArray(n4) && (r3 = { mimeType: n4[1], charset: n4[2], data: e3[1] });
      }
      return r3;
    }, A2 = e2.__addimage__.supportsArrayBuffer = function() {
      return typeof ArrayBuffer != "undefined" && typeof Uint8Array != "undefined";
    };
    e2.__addimage__.isArrayBuffer = function(t3) {
      return A2() && t3 instanceof ArrayBuffer;
    };
    var x2 = e2.__addimage__.isArrayBufferView = function(t3) {
      return A2() && typeof Uint32Array != "undefined" && (t3 instanceof Int8Array || t3 instanceof Uint8Array || typeof Uint8ClampedArray != "undefined" && t3 instanceof Uint8ClampedArray || t3 instanceof Int16Array || t3 instanceof Uint16Array || t3 instanceof Int32Array || t3 instanceof Uint32Array || t3 instanceof Float32Array || t3 instanceof Float64Array);
    }, S2 = e2.__addimage__.binaryStringToUint8Array = function(t3) {
      for (var e3 = t3.length, r3 = new Uint8Array(e3), n4 = 0; n4 < e3; n4++)
        r3[n4] = t3.charCodeAt(n4);
      return r3;
    }, _3 = e2.__addimage__.arrayBufferToBinaryString = function(t3) {
      for (var e3 = "", r3 = x2(t3) ? t3 : new Uint8Array(t3), n4 = 0; n4 < r3.length; n4 += 8192)
        e3 += String.fromCharCode.apply(null, r3.subarray(n4, n4 + 8192));
      return e3;
    };
    e2.addImage = function() {
      var e3, n4, i4, a4, o4, s4, u3, h5, l4;
      if (typeof arguments[1] == "number" ? (n4 = r2, i4 = arguments[1], a4 = arguments[2], o4 = arguments[3], s4 = arguments[4], u3 = arguments[5], h5 = arguments[6], l4 = arguments[7]) : (n4 = arguments[1], i4 = arguments[2], a4 = arguments[3], o4 = arguments[4], s4 = arguments[5], u3 = arguments[6], h5 = arguments[7], l4 = arguments[8]), _typeof(e3 = arguments[0]) === "object" && !d2(e3) && "imageData" in e3) {
        var f4 = e3;
        e3 = f4.imageData, n4 = f4.format || n4 || r2, i4 = f4.x || i4 || 0, a4 = f4.y || a4 || 0, o4 = f4.w || f4.width || o4, s4 = f4.h || f4.height || s4, u3 = f4.alias || u3, h5 = f4.compression || h5, l4 = f4.rotation || f4.angle || l4;
      }
      var p5 = this.internal.getFilters();
      if (h5 === void 0 && p5.indexOf("FlateEncode") !== -1 && (h5 = "SLOW"), isNaN(i4) || isNaN(a4))
        throw new Error("Invalid coordinates passed to jsPDF.addImage");
      c4.call(this);
      var g3 = P2.call(this, e3, n4, u3, h5);
      return v3.call(this, i4, a4, o4, s4, g3, l4), this;
    };
    var P2 = function(t3, n4, a4, o4) {
      var s4, c5, u3;
      if (typeof t3 == "string" && i3(t3) === r2) {
        t3 = unescape(t3);
        var h5 = k2(t3, false);
        (h5 !== "" || (h5 = e2.loadFile(t3, true)) !== void 0) && (t3 = h5);
      }
      if (d2(t3) && (t3 = p4(t3, n4)), n4 = i3(t3, n4), !f3(n4))
        throw new Error("addImage does not support files of type '" + n4 + "', please ensure that a plugin for '" + n4 + "' support is added.");
      if (((u3 = a4) == null || u3.length === 0) && (a4 = function(t4) {
        return typeof t4 == "string" || x2(t4) ? w2(t4) : x2(t4.data) ? w2(t4.data) : null;
      }(t3)), (s4 = g2.call(this, a4)) || (A2() && (t3 instanceof Uint8Array || n4 === "RGBA" || (c5 = t3, t3 = S2(t3))), s4 = this["process" + n4.toUpperCase()](t3, l3.call(this), a4, function(t4) {
        return t4 && typeof t4 == "string" && (t4 = t4.toUpperCase()), t4 in e2.image_compression ? t4 : y3.NONE;
      }(o4), c5)), !s4)
        throw new Error("An unknown error occurred whilst processing the image.");
      return s4;
    }, k2 = e2.__addimage__.convertBase64ToBinaryString = function(t3, e3) {
      var r3;
      e3 = typeof e3 != "boolean" || e3;
      var n4, i4 = "";
      if (typeof t3 == "string") {
        n4 = (r3 = L2(t3)) !== null ? r3.data : t3;
        try {
          i4 = u2(n4);
        } catch (t4) {
          if (e3)
            throw N3(n4) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t4.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
        }
      }
      return i4;
    };
    e2.getImageProperties = function(t3) {
      var n4, a4, o4 = "";
      if (d2(t3) && (t3 = p4(t3)), typeof t3 == "string" && i3(t3) === r2 && ((o4 = k2(t3, false)) === "" && (o4 = e2.loadFile(t3) || ""), t3 = o4), a4 = i3(t3), !f3(a4))
        throw new Error("addImage does not support files of type '" + a4 + "', please ensure that a plugin for '" + a4 + "' support is added.");
      if (!A2() || t3 instanceof Uint8Array || (t3 = S2(t3)), !(n4 = this["process" + a4.toUpperCase()](t3)))
        throw new Error("An unknown error occurred whilst processing the image");
      return n4.fileType = a4, n4;
    };
  }(M.API), function(t3) {
    var e2 = function(t4) {
      if (t4 !== void 0 && t4 != "")
        return true;
    };
    M.API.events.push(["addPage", function(t4) {
      this.internal.getPageInfo(t4.pageNumber).pageContext.annotations = [];
    }]), t3.events.push(["putPage", function(t4) {
      for (var r2, n3, i3, a3 = this.internal.getCoordinateString, o3 = this.internal.getVerticalCoordinateString, s3 = this.internal.getPageInfoByObjId(t4.objId), c4 = t4.pageContext.annotations, u3 = false, h4 = 0; h4 < c4.length && !u3; h4++)
        switch ((r2 = c4[h4]).type) {
          case "link":
            (e2(r2.options.url) || e2(r2.options.pageNumber)) && (u3 = true);
            break;
          case "reference":
          case "text":
          case "freetext":
            u3 = true;
        }
      if (u3 != 0) {
        this.internal.write("/Annots [");
        for (var l3 = 0; l3 < c4.length; l3++) {
          r2 = c4[l3];
          var f3 = this.internal.pdfEscape, d2 = this.internal.getEncryptor(t4.objId);
          switch (r2.type) {
            case "reference":
              this.internal.write(" " + r2.object.objId + " 0 R ");
              break;
            case "text":
              var p4 = this.internal.newAdditionalObject(), g2 = this.internal.newAdditionalObject(), m4 = this.internal.getEncryptor(p4.objId), v3 = r2.title || "Note";
              i3 = "<</Type /Annot /Subtype /Text " + (n3 = "/Rect [" + a3(r2.bounds.x) + " " + o3(r2.bounds.y + r2.bounds.h) + " " + a3(r2.bounds.x + r2.bounds.w) + " " + o3(r2.bounds.y) + "] ") + "/Contents (" + f3(m4(r2.contents)) + ")", i3 += " /Popup " + g2.objId + " 0 R", i3 += " /P " + s3.objId + " 0 R", i3 += " /T (" + f3(m4(v3)) + ") >>", p4.content = i3;
              var b2 = p4.objId + " 0 R";
              i3 = "<</Type /Annot /Subtype /Popup " + (n3 = "/Rect [" + a3(r2.bounds.x + 30) + " " + o3(r2.bounds.y + r2.bounds.h) + " " + a3(r2.bounds.x + r2.bounds.w + 30) + " " + o3(r2.bounds.y) + "] ") + " /Parent " + b2, r2.open && (i3 += " /Open true"), i3 += " >>", g2.content = i3, this.internal.write(p4.objId, "0 R", g2.objId, "0 R");
              break;
            case "freetext":
              n3 = "/Rect [" + a3(r2.bounds.x) + " " + o3(r2.bounds.y) + " " + a3(r2.bounds.x + r2.bounds.w) + " " + o3(r2.bounds.y + r2.bounds.h) + "] ";
              var y3 = r2.color || "#000000";
              i3 = "<</Type /Annot /Subtype /FreeText " + n3 + "/Contents (" + f3(d2(r2.contents)) + ")", i3 += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y3 + ")", i3 += " /Border [0 0 0]", i3 += " >>", this.internal.write(i3);
              break;
            case "link":
              if (r2.options.name) {
                var w2 = this.annotations._nameMap[r2.options.name];
                r2.options.pageNumber = w2.page, r2.options.top = w2.y;
              } else
                r2.options.top || (r2.options.top = 0);
              if (n3 = "/Rect [" + r2.finalBounds.x + " " + r2.finalBounds.y + " " + r2.finalBounds.w + " " + r2.finalBounds.h + "] ", i3 = "", r2.options.url)
                i3 = "<</Type /Annot /Subtype /Link " + n3 + "/Border [0 0 0] /A <</S /URI /URI (" + f3(d2(r2.options.url)) + ") >>";
              else if (r2.options.pageNumber) {
                switch (i3 = "<</Type /Annot /Subtype /Link " + n3 + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r2.options.pageNumber).objId + " 0 R", r2.options.magFactor = r2.options.magFactor || "XYZ", r2.options.magFactor) {
                  case "Fit":
                    i3 += " /Fit]";
                    break;
                  case "FitH":
                    i3 += " /FitH " + r2.options.top + "]";
                    break;
                  case "FitV":
                    r2.options.left = r2.options.left || 0, i3 += " /FitV " + r2.options.left + "]";
                    break;
                  case "XYZ":
                  default:
                    var N3 = o3(r2.options.top);
                    r2.options.left = r2.options.left || 0, r2.options.zoom === void 0 && (r2.options.zoom = 0), i3 += " /XYZ " + r2.options.left + " " + N3 + " " + r2.options.zoom + "]";
                }
              }
              i3 != "" && (i3 += " >>", this.internal.write(i3));
          }
        }
        this.internal.write("]");
      }
    }]), t3.createAnnotation = function(t4) {
      var e3 = this.internal.getCurrentPageInfo();
      switch (t4.type) {
        case "link":
          this.link(t4.bounds.x, t4.bounds.y, t4.bounds.w, t4.bounds.h, t4);
          break;
        case "text":
        case "freetext":
          e3.pageContext.annotations.push(t4);
      }
    }, t3.link = function(t4, e3, r2, n3, i3) {
      var a3 = this.internal.getCurrentPageInfo(), o3 = this.internal.getCoordinateString, s3 = this.internal.getVerticalCoordinateString;
      a3.pageContext.annotations.push({ finalBounds: { x: o3(t4), y: s3(e3), w: o3(t4 + r2), h: s3(e3 + n3) }, options: i3, type: "link" });
    }, t3.textWithLink = function(t4, e3, r2, n3) {
      var i3 = this.getTextWidth(t4), a3 = this.internal.getLineHeight() / this.internal.scaleFactor;
      return this.text(t4, e3, r2, n3), r2 += 0.2 * a3, n3.align === "center" && (e3 -= i3 / 2), n3.align === "right" && (e3 -= i3), this.link(e3, r2 - a3, i3, a3, n3), i3;
    }, t3.getTextWidth = function(t4) {
      var e3 = this.internal.getFontSize();
      return this.getStringUnitWidth(t4) * e3 / this.internal.scaleFactor;
    };
  }(M.API), function(t3) {
    var e2 = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, r2 = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, n3 = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, i3 = [1570, 1571, 1573, 1575];
    t3.__arabicParser__ = {};
    var a3 = t3.__arabicParser__.isInArabicSubstitutionA = function(t4) {
      return e2[t4.charCodeAt(0)] !== void 0;
    }, o3 = t3.__arabicParser__.isArabicLetter = function(t4) {
      return typeof t4 == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t4);
    }, s3 = t3.__arabicParser__.isArabicEndLetter = function(t4) {
      return o3(t4) && a3(t4) && e2[t4.charCodeAt(0)].length <= 2;
    }, c4 = t3.__arabicParser__.isArabicAlfLetter = function(t4) {
      return o3(t4) && i3.indexOf(t4.charCodeAt(0)) >= 0;
    };
    t3.__arabicParser__.arabicLetterHasIsolatedForm = function(t4) {
      return o3(t4) && a3(t4) && e2[t4.charCodeAt(0)].length >= 1;
    };
    var u3 = t3.__arabicParser__.arabicLetterHasFinalForm = function(t4) {
      return o3(t4) && a3(t4) && e2[t4.charCodeAt(0)].length >= 2;
    };
    t3.__arabicParser__.arabicLetterHasInitialForm = function(t4) {
      return o3(t4) && a3(t4) && e2[t4.charCodeAt(0)].length >= 3;
    };
    var h4 = t3.__arabicParser__.arabicLetterHasMedialForm = function(t4) {
      return o3(t4) && a3(t4) && e2[t4.charCodeAt(0)].length == 4;
    }, l3 = t3.__arabicParser__.resolveLigatures = function(t4) {
      var e3 = 0, n4 = r2, i4 = "", a4 = 0;
      for (e3 = 0; e3 < t4.length; e3 += 1)
        n4[t4.charCodeAt(e3)] !== void 0 ? (a4++, typeof (n4 = n4[t4.charCodeAt(e3)]) == "number" && (i4 += String.fromCharCode(n4), n4 = r2, a4 = 0), e3 === t4.length - 1 && (n4 = r2, i4 += t4.charAt(e3 - (a4 - 1)), e3 -= a4 - 1, a4 = 0)) : (n4 = r2, i4 += t4.charAt(e3 - a4), e3 -= a4, a4 = 0);
      return i4;
    };
    t3.__arabicParser__.isArabicDiacritic = function(t4) {
      return t4 !== void 0 && n3[t4.charCodeAt(0)] !== void 0;
    };
    var f3 = t3.__arabicParser__.getCorrectForm = function(t4, e3, r3) {
      return o3(t4) ? a3(t4) === false ? -1 : !u3(t4) || !o3(e3) && !o3(r3) || !o3(r3) && s3(e3) || s3(t4) && !o3(e3) || s3(t4) && c4(e3) || s3(t4) && s3(e3) ? 0 : h4(t4) && o3(e3) && !s3(e3) && o3(r3) && u3(r3) ? 3 : s3(t4) || !o3(r3) ? 1 : 2 : -1;
    }, d2 = function(t4) {
      var r3 = 0, n4 = 0, i4 = 0, a4 = "", s4 = "", c5 = "", u4 = (t4 = t4 || "").split("\\s+"), h5 = [];
      for (r3 = 0; r3 < u4.length; r3 += 1) {
        for (h5.push(""), n4 = 0; n4 < u4[r3].length; n4 += 1)
          a4 = u4[r3][n4], s4 = u4[r3][n4 - 1], c5 = u4[r3][n4 + 1], o3(a4) ? (i4 = f3(a4, s4, c5), h5[r3] += i4 !== -1 ? String.fromCharCode(e2[a4.charCodeAt(0)][i4]) : a4) : h5[r3] += a4;
        h5[r3] = l3(h5[r3]);
      }
      return h5.join(" ");
    }, p4 = t3.__arabicParser__.processArabic = t3.processArabic = function() {
      var t4, e3 = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, r3 = [];
      if (Array.isArray(e3)) {
        var n4 = 0;
        for (r3 = [], n4 = 0; n4 < e3.length; n4 += 1)
          Array.isArray(e3[n4]) ? r3.push([d2(e3[n4][0]), e3[n4][1], e3[n4][2]]) : r3.push([d2(e3[n4])]);
        t4 = r3;
      } else
        t4 = d2(e3);
      return typeof arguments[0] == "string" ? t4 : (arguments[0].text = t4, arguments[0]);
    };
    t3.events.push(["preProcessText", p4]);
  }(M.API), M.API.autoPrint = function(t3) {
    var e2;
    switch ((t3 = t3 || {}).variant = t3.variant || "non-conform", t3.variant) {
      case "javascript":
        this.addJS("print({});");
        break;
      case "non-conform":
      default:
        this.internal.events.subscribe("postPutResources", function() {
          e2 = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
          this.internal.out("/OpenAction " + e2 + " 0 R");
        });
    }
    return this;
  }, function(t3) {
    var e2 = function() {
      var t4 = void 0;
      Object.defineProperty(this, "pdf", { get: function() {
        return t4;
      }, set: function(e4) {
        t4 = e4;
      } });
      var e3 = 150;
      Object.defineProperty(this, "width", { get: function() {
        return e3;
      }, set: function(t5) {
        e3 = isNaN(t5) || Number.isInteger(t5) === false || t5 < 0 ? 150 : t5, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e3 + 1);
      } });
      var r2 = 300;
      Object.defineProperty(this, "height", { get: function() {
        return r2;
      }, set: function(t5) {
        r2 = isNaN(t5) || Number.isInteger(t5) === false || t5 < 0 ? 300 : t5, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r2 + 1);
      } });
      var n3 = [];
      Object.defineProperty(this, "childNodes", { get: function() {
        return n3;
      }, set: function(t5) {
        n3 = t5;
      } });
      var i3 = {};
      Object.defineProperty(this, "style", { get: function() {
        return i3;
      }, set: function(t5) {
        i3 = t5;
      } }), Object.defineProperty(this, "parentNode", {});
    };
    e2.prototype.getContext = function(t4, e3) {
      var r2;
      if ((t4 = t4 || "2d") !== "2d")
        return null;
      for (r2 in e3)
        this.pdf.context2d.hasOwnProperty(r2) && (this.pdf.context2d[r2] = e3[r2]);
      return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e2.prototype.toDataURL = function() {
      throw new Error("toDataURL is not implemented.");
    }, t3.events.push(["initialized", function() {
      this.canvas = new e2(), this.canvas.pdf = this;
    }]);
  }(M.API), function(e2) {
    var r2 = { left: 0, top: 0, bottom: 0, right: 0 }, n3 = false, i3 = function() {
      this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r2), this.internal.__cell__.margins.width = this.getPageWidth(), a3.call(this));
    }, a3 = function() {
      this.internal.__cell__.lastCell = new o3(), this.internal.__cell__.pages = 1;
    }, o3 = function() {
      var t3 = arguments[0];
      Object.defineProperty(this, "x", { enumerable: true, get: function() {
        return t3;
      }, set: function(e4) {
        t3 = e4;
      } });
      var e3 = arguments[1];
      Object.defineProperty(this, "y", { enumerable: true, get: function() {
        return e3;
      }, set: function(t4) {
        e3 = t4;
      } });
      var r3 = arguments[2];
      Object.defineProperty(this, "width", { enumerable: true, get: function() {
        return r3;
      }, set: function(t4) {
        r3 = t4;
      } });
      var n4 = arguments[3];
      Object.defineProperty(this, "height", { enumerable: true, get: function() {
        return n4;
      }, set: function(t4) {
        n4 = t4;
      } });
      var i4 = arguments[4];
      Object.defineProperty(this, "text", { enumerable: true, get: function() {
        return i4;
      }, set: function(t4) {
        i4 = t4;
      } });
      var a4 = arguments[5];
      Object.defineProperty(this, "lineNumber", { enumerable: true, get: function() {
        return a4;
      }, set: function(t4) {
        a4 = t4;
      } });
      var o4 = arguments[6];
      return Object.defineProperty(this, "align", { enumerable: true, get: function() {
        return o4;
      }, set: function(t4) {
        o4 = t4;
      } }), this;
    };
    o3.prototype.clone = function() {
      return new o3(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o3.prototype.toArray = function() {
      return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
    }, e2.setHeaderFunction = function(t3) {
      return i3.call(this), this.internal.__cell__.headerFunction = typeof t3 == "function" ? t3 : void 0, this;
    }, e2.getTextDimensions = function(t3, e3) {
      i3.call(this);
      var r3 = (e3 = e3 || {}).fontSize || this.getFontSize(), n4 = e3.font || this.getFont(), a4 = e3.scaleFactor || this.internal.scaleFactor, o4 = 0, s4 = 0, c5 = 0, u3 = this;
      if (!Array.isArray(t3) && typeof t3 != "string") {
        if (typeof t3 != "number")
          throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
        t3 = String(t3);
      }
      var h4 = e3.maxWidth;
      h4 > 0 ? typeof t3 == "string" ? t3 = this.splitTextToSize(t3, h4) : Object.prototype.toString.call(t3) === "[object Array]" && (t3 = t3.reduce(function(t4, e4) {
        return t4.concat(u3.splitTextToSize(e4, h4));
      }, [])) : t3 = Array.isArray(t3) ? t3 : [t3];
      for (var l3 = 0; l3 < t3.length; l3++)
        o4 < (c5 = this.getStringUnitWidth(t3[l3], { font: n4 }) * r3) && (o4 = c5);
      return o4 !== 0 && (s4 = t3.length), { w: o4 /= a4, h: Math.max((s4 * r3 * this.getLineHeightFactor() - r3 * (this.getLineHeightFactor() - 1)) / a4, 0) };
    }, e2.cellAddPage = function() {
      i3.call(this), this.addPage();
      var t3 = this.internal.__cell__.margins || r2;
      return this.internal.__cell__.lastCell = new o3(t3.left, t3.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s3 = e2.cell = function() {
      var t3;
      t3 = arguments[0] instanceof o3 ? arguments[0] : new o3(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i3.call(this);
      var e3 = this.internal.__cell__.lastCell, a4 = this.internal.__cell__.padding, s4 = this.internal.__cell__.margins || r2, c5 = this.internal.__cell__.tableHeaderRow, u3 = this.internal.__cell__.printHeaders;
      return e3.lineNumber !== void 0 && (e3.lineNumber === t3.lineNumber ? (t3.x = (e3.x || 0) + (e3.width || 0), t3.y = e3.y || 0) : e3.y + e3.height + t3.height + s4.bottom > this.getPageHeight() ? (this.cellAddPage(), t3.y = s4.top, u3 && c5 && (this.printHeaderRow(t3.lineNumber, true), t3.y += c5[0].height)) : t3.y = e3.y + e3.height || t3.y), t3.text[0] !== void 0 && (this.rect(t3.x, t3.y, t3.width, t3.height, n3 === true ? "FD" : void 0), t3.align === "right" ? this.text(t3.text, t3.x + t3.width - a4, t3.y + a4, { align: "right", baseline: "top" }) : t3.align === "center" ? this.text(t3.text, t3.x + t3.width / 2, t3.y + a4, { align: "center", baseline: "top", maxWidth: t3.width - a4 - a4 }) : this.text(t3.text, t3.x + a4, t3.y + a4, { align: "left", baseline: "top", maxWidth: t3.width - a4 - a4 })), this.internal.__cell__.lastCell = t3, this;
    };
    e2.table = function(e3, n4, u3, h4, l3) {
      if (i3.call(this), !u3)
        throw new Error("No data for PDF table.");
      var f3, d2, p4, g2, m4 = [], v3 = [], b2 = [], y3 = {}, w2 = {}, N3 = [], L2 = [], A2 = (l3 = l3 || {}).autoSize || false, x2 = l3.printHeaders !== false, S2 = l3.css && l3.css["font-size"] !== void 0 ? 16 * l3.css["font-size"] : l3.fontSize || 12, _3 = l3.margins || Object.assign({ width: this.getPageWidth() }, r2), P2 = typeof l3.padding == "number" ? l3.padding : 3, k2 = l3.headerBackgroundColor || "#c8c8c8", I2 = l3.headerTextColor || "#000";
      if (a3.call(this), this.internal.__cell__.printHeaders = x2, this.internal.__cell__.margins = _3, this.internal.__cell__.table_font_size = S2, this.internal.__cell__.padding = P2, this.internal.__cell__.headerBackgroundColor = k2, this.internal.__cell__.headerTextColor = I2, this.setFontSize(S2), h4 == null)
        v3 = m4 = Object.keys(u3[0]), b2 = m4.map(function() {
          return "left";
        });
      else if (Array.isArray(h4) && _typeof(h4[0]) === "object")
        for (m4 = h4.map(function(t3) {
          return t3.name;
        }), v3 = h4.map(function(t3) {
          return t3.prompt || t3.name || "";
        }), b2 = h4.map(function(t3) {
          return t3.align || "left";
        }), f3 = 0; f3 < h4.length; f3 += 1)
          w2[h4[f3].name] = h4[f3].width * (19.049976 / 25.4);
      else
        Array.isArray(h4) && typeof h4[0] == "string" && (v3 = m4 = h4, b2 = m4.map(function() {
          return "left";
        }));
      if (A2 || Array.isArray(h4) && typeof h4[0] == "string")
        for (f3 = 0; f3 < m4.length; f3 += 1) {
          for (y3[g2 = m4[f3]] = u3.map(function(t3) {
            return t3[g2];
          }), this.setFont(void 0, "bold"), N3.push(this.getTextDimensions(v3[f3], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), d2 = y3[g2], this.setFont(void 0, "normal"), p4 = 0; p4 < d2.length; p4 += 1)
            N3.push(this.getTextDimensions(d2[p4], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
          w2[g2] = Math.max.apply(null, N3) + P2 + P2, N3 = [];
        }
      if (x2) {
        var F2 = {};
        for (f3 = 0; f3 < m4.length; f3 += 1)
          F2[m4[f3]] = {}, F2[m4[f3]].text = v3[f3], F2[m4[f3]].align = b2[f3];
        var C2 = c4.call(this, F2, w2);
        L2 = m4.map(function(t3) {
          return new o3(e3, n4, w2[t3], C2, F2[t3].text, void 0, F2[t3].align);
        }), this.setTableHeaderRow(L2), this.printHeaderRow(1, false);
      }
      var j2 = h4.reduce(function(t3, e4) {
        return t3[e4.name] = e4.align, t3;
      }, {});
      for (f3 = 0; f3 < u3.length; f3 += 1) {
        "rowStart" in l3 && l3.rowStart instanceof Function && l3.rowStart({ row: f3, data: u3[f3] }, this);
        var O3 = c4.call(this, u3[f3], w2);
        for (p4 = 0; p4 < m4.length; p4 += 1) {
          var B2 = u3[f3][m4[p4]];
          "cellStart" in l3 && l3.cellStart instanceof Function && l3.cellStart({ row: f3, col: p4, data: B2 }, this), s3.call(this, new o3(e3, n4, w2[m4[p4]], O3, B2, f3 + 2, j2[m4[p4]]));
        }
      }
      return this.internal.__cell__.table_x = e3, this.internal.__cell__.table_y = n4, this;
    };
    var c4 = function(t3, e3) {
      var r3 = this.internal.__cell__.padding, n4 = this.internal.__cell__.table_font_size, i4 = this.internal.scaleFactor;
      return Object.keys(t3).map(function(n5) {
        var i5 = t3[n5];
        return this.splitTextToSize(i5.hasOwnProperty("text") ? i5.text : i5, e3[n5] - r3 - r3);
      }, this).map(function(t4) {
        return this.getLineHeightFactor() * t4.length * n4 / i4 + r3 + r3;
      }, this).reduce(function(t4, e4) {
        return Math.max(t4, e4);
      }, 0);
    };
    e2.setTableHeaderRow = function(t3) {
      i3.call(this), this.internal.__cell__.tableHeaderRow = t3;
    }, e2.printHeaderRow = function(t3, e3) {
      if (i3.call(this), !this.internal.__cell__.tableHeaderRow)
        throw new Error("Property tableHeaderRow does not exist.");
      var r3;
      if (n3 = true, typeof this.internal.__cell__.headerFunction == "function") {
        var a4 = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
        this.internal.__cell__.lastCell = new o3(a4[0], a4[1], a4[2], a4[3], void 0, -1);
      }
      this.setFont(void 0, "bold");
      for (var c5 = [], u3 = 0; u3 < this.internal.__cell__.tableHeaderRow.length; u3 += 1) {
        r3 = this.internal.__cell__.tableHeaderRow[u3].clone(), e3 && (r3.y = this.internal.__cell__.margins.top || 0, c5.push(r3)), r3.lineNumber = t3;
        var h4 = this.getTextColor();
        this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s3.call(this, r3), this.setTextColor(h4);
      }
      c5.length > 0 && this.setTableHeaderRow(c5), this.setFont(void 0, "normal"), n3 = false;
    };
  }(M.API);
  var Pt = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] };
  var kt = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"];
  var It = _t(kt);
  var Ft = [100, 200, 300, 400, 500, 600, 700, 800, 900];
  var Ct = _t(Ft);
  function jt(t3) {
    var e2 = t3.family.replace(/"|'/g, "").toLowerCase(), r2 = function(t4) {
      return Pt[t4 = t4 || "normal"] ? t4 : "normal";
    }(t3.style), n3 = function(t4) {
      if (!t4)
        return 400;
      if (typeof t4 == "number")
        return t4 >= 100 && t4 <= 900 && t4 % 100 == 0 ? t4 : 400;
      if (/^\d00$/.test(t4))
        return parseInt(t4);
      switch (t4) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    }(t3.weight), i3 = function(t4) {
      return typeof It[t4 = t4 || "normal"] == "number" ? t4 : "normal";
    }(t3.stretch);
    return { family: e2, style: r2, weight: n3, stretch: i3, src: t3.src || [], ref: t3.ref || { name: e2, style: [i3, r2, n3].join(" ") } };
  }
  function Ot(t3, e2, r2, n3) {
    var i3;
    for (i3 = r2; i3 >= 0 && i3 < e2.length; i3 += n3)
      if (t3[e2[i3]])
        return t3[e2[i3]];
    for (i3 = r2; i3 >= 0 && i3 < e2.length; i3 -= n3)
      if (t3[e2[i3]])
        return t3[e2[i3]];
  }
  var Bt = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" };
  var Et = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
  function Mt(t3) {
    return [t3.stretch, t3.style, t3.weight, t3.family].join(" ");
  }
  function qt(t3, e2, r2) {
    for (var n3 = (r2 = r2 || {}).defaultFontFamily || "times", i3 = Object.assign({}, Bt, r2.genericFontFamilies || {}), a3 = null, o3 = null, s3 = 0; s3 < e2.length; ++s3)
      if (i3[(a3 = jt(e2[s3])).family] && (a3.family = i3[a3.family]), t3.hasOwnProperty(a3.family)) {
        o3 = t3[a3.family];
        break;
      }
    if (!(o3 = o3 || t3[n3]))
      throw new Error("Could not find a font-family for the rule '" + Mt(a3) + "' and default family '" + n3 + "'.");
    if (o3 = function(t4, e3) {
      if (e3[t4])
        return e3[t4];
      var r3 = It[t4], n4 = r3 <= It.normal ? -1 : 1, i4 = Ot(e3, kt, r3, n4);
      if (!i4)
        throw new Error("Could not find a matching font-stretch value for " + t4);
      return i4;
    }(a3.stretch, o3), o3 = function(t4, e3) {
      if (e3[t4])
        return e3[t4];
      for (var r3 = Pt[t4], n4 = 0; n4 < r3.length; ++n4)
        if (e3[r3[n4]])
          return e3[r3[n4]];
      throw new Error("Could not find a matching font-style for " + t4);
    }(a3.style, o3), !(o3 = function(t4, e3) {
      if (e3[t4])
        return e3[t4];
      if (t4 === 400 && e3[500])
        return e3[500];
      if (t4 === 500 && e3[400])
        return e3[400];
      var r3 = Ct[t4], n4 = Ot(e3, Ft, r3, t4 < 400 ? -1 : 1);
      if (!n4)
        throw new Error("Could not find a matching font-weight for value " + t4);
      return n4;
    }(a3.weight, o3)))
      throw new Error("Failed to resolve a font for the rule '" + Mt(a3) + "'.");
    return o3;
  }
  function Dt(t3) {
    return t3.trimLeft();
  }
  function Rt(t3, e2) {
    for (var r2 = 0; r2 < t3.length; ) {
      if (t3.charAt(r2) === e2)
        return [t3.substring(0, r2), t3.substring(r2 + 1)];
      r2 += 1;
    }
    return null;
  }
  function Tt(t3) {
    var e2 = t3.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return e2 === null ? null : [e2[0], t3.substring(e2[0].length)];
  }
  var Ut;
  var zt;
  var Ht;
  var Wt = ["times"];
  !function(e2) {
    var r2, n3, i3, o3, s3, c4, u3, h4, l3, d2 = function(t3) {
      return t3 = t3 || {}, this.isStrokeTransparent = t3.isStrokeTransparent || false, this.strokeOpacity = t3.strokeOpacity || 1, this.strokeStyle = t3.strokeStyle || "#000000", this.fillStyle = t3.fillStyle || "#000000", this.isFillTransparent = t3.isFillTransparent || false, this.fillOpacity = t3.fillOpacity || 1, this.font = t3.font || "10px sans-serif", this.textBaseline = t3.textBaseline || "alphabetic", this.textAlign = t3.textAlign || "left", this.lineWidth = t3.lineWidth || 1, this.lineJoin = t3.lineJoin || "miter", this.lineCap = t3.lineCap || "butt", this.path = t3.path || [], this.transform = t3.transform !== void 0 ? t3.transform.clone() : new h4(), this.globalCompositeOperation = t3.globalCompositeOperation || "normal", this.globalAlpha = t3.globalAlpha || 1, this.clip_path = t3.clip_path || [], this.currentPoint = t3.currentPoint || new c4(), this.miterLimit = t3.miterLimit || 10, this.lastPoint = t3.lastPoint || new c4(), this.lineDashOffset = t3.lineDashOffset || 0, this.lineDash = t3.lineDash || [], this.margin = t3.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = t3.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof t3.ignoreClearRect != "boolean" || t3.ignoreClearRect, this;
    };
    e2.events.push(["initialized", function() {
      this.context2d = new p4(this), r2 = this.internal.f2, n3 = this.internal.getCoordinateString, i3 = this.internal.getVerticalCoordinateString, o3 = this.internal.getHorizontalCoordinate, s3 = this.internal.getVerticalCoordinate, c4 = this.internal.Point, u3 = this.internal.Rectangle, h4 = this.internal.Matrix, l3 = new d2();
    }]);
    var p4 = function(t3) {
      Object.defineProperty(this, "canvas", { get: function() {
        return { parentNode: false, style: false };
      } });
      var e3 = t3;
      Object.defineProperty(this, "pdf", { get: function() {
        return e3;
      } });
      var r3 = false;
      Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
        return r3;
      }, set: function(t4) {
        r3 = Boolean(t4);
      } });
      var n4 = false;
      Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
        return n4;
      }, set: function(t4) {
        n4 = Boolean(t4);
      } });
      var i4 = 0;
      Object.defineProperty(this, "posX", { get: function() {
        return i4;
      }, set: function(t4) {
        isNaN(t4) || (i4 = t4);
      } });
      var a3 = 0;
      Object.defineProperty(this, "posY", { get: function() {
        return a3;
      }, set: function(t4) {
        isNaN(t4) || (a3 = t4);
      } }), Object.defineProperty(this, "margin", { get: function() {
        return l3.margin;
      }, set: function(t4) {
        var e4;
        typeof t4 == "number" ? e4 = [t4, t4, t4, t4] : ((e4 = new Array(4))[0] = t4[0], e4[1] = t4.length >= 2 ? t4[1] : e4[0], e4[2] = t4.length >= 3 ? t4[2] : e4[0], e4[3] = t4.length >= 4 ? t4[3] : e4[1]), l3.margin = e4;
      } });
      var o4 = false;
      Object.defineProperty(this, "autoPaging", { get: function() {
        return o4;
      }, set: function(t4) {
        o4 = t4;
      } });
      var s4 = 0;
      Object.defineProperty(this, "lastBreak", { get: function() {
        return s4;
      }, set: function(t4) {
        s4 = t4;
      } });
      var c5 = [];
      Object.defineProperty(this, "pageBreaks", { get: function() {
        return c5;
      }, set: function(t4) {
        c5 = t4;
      } }), Object.defineProperty(this, "ctx", { get: function() {
        return l3;
      }, set: function(t4) {
        t4 instanceof d2 && (l3 = t4);
      } }), Object.defineProperty(this, "path", { get: function() {
        return l3.path;
      }, set: function(t4) {
        l3.path = t4;
      } });
      var u4 = [];
      Object.defineProperty(this, "ctxStack", { get: function() {
        return u4;
      }, set: function(t4) {
        u4 = t4;
      } }), Object.defineProperty(this, "fillStyle", { get: function() {
        return this.ctx.fillStyle;
      }, set: function(t4) {
        var e4;
        e4 = g2(t4), this.ctx.fillStyle = e4.style, this.ctx.isFillTransparent = e4.a === 0, this.ctx.fillOpacity = e4.a, this.pdf.setFillColor(e4.r, e4.g, e4.b, { a: e4.a }), this.pdf.setTextColor(e4.r, e4.g, e4.b, { a: e4.a });
      } }), Object.defineProperty(this, "strokeStyle", { get: function() {
        return this.ctx.strokeStyle;
      }, set: function(t4) {
        var e4 = g2(t4);
        this.ctx.strokeStyle = e4.style, this.ctx.isStrokeTransparent = e4.a === 0, this.ctx.strokeOpacity = e4.a, e4.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (e4.a, this.pdf.setDrawColor(e4.r, e4.g, e4.b));
      } }), Object.defineProperty(this, "lineCap", { get: function() {
        return this.ctx.lineCap;
      }, set: function(t4) {
        ["butt", "round", "square"].indexOf(t4) !== -1 && (this.ctx.lineCap = t4, this.pdf.setLineCap(t4));
      } }), Object.defineProperty(this, "lineWidth", { get: function() {
        return this.ctx.lineWidth;
      }, set: function(t4) {
        isNaN(t4) || (this.ctx.lineWidth = t4, this.pdf.setLineWidth(t4));
      } }), Object.defineProperty(this, "lineJoin", { get: function() {
        return this.ctx.lineJoin;
      }, set: function(t4) {
        ["bevel", "round", "miter"].indexOf(t4) !== -1 && (this.ctx.lineJoin = t4, this.pdf.setLineJoin(t4));
      } }), Object.defineProperty(this, "miterLimit", { get: function() {
        return this.ctx.miterLimit;
      }, set: function(t4) {
        isNaN(t4) || (this.ctx.miterLimit = t4, this.pdf.setMiterLimit(t4));
      } }), Object.defineProperty(this, "textBaseline", { get: function() {
        return this.ctx.textBaseline;
      }, set: function(t4) {
        this.ctx.textBaseline = t4;
      } }), Object.defineProperty(this, "textAlign", { get: function() {
        return this.ctx.textAlign;
      }, set: function(t4) {
        ["right", "end", "center", "left", "start"].indexOf(t4) !== -1 && (this.ctx.textAlign = t4);
      } });
      var h5 = null;
      function f3(t4, e4) {
        if (h5 === null) {
          var r4 = function(t5) {
            var e5 = [];
            return Object.keys(t5).forEach(function(r5) {
              t5[r5].forEach(function(t6) {
                var n5 = null;
                switch (t6) {
                  case "bold":
                    n5 = { family: r5, weight: "bold" };
                    break;
                  case "italic":
                    n5 = { family: r5, style: "italic" };
                    break;
                  case "bolditalic":
                    n5 = { family: r5, weight: "bold", style: "italic" };
                    break;
                  case "":
                  case "normal":
                    n5 = { family: r5 };
                }
                n5 !== null && (n5.ref = { name: r5, style: t6 }, e5.push(n5));
              });
            }), e5;
          }(t4.getFontList());
          h5 = function(t5) {
            for (var e5 = {}, r5 = 0; r5 < t5.length; ++r5) {
              var n5 = jt(t5[r5]), i5 = n5.family, a4 = n5.stretch, o5 = n5.style, s5 = n5.weight;
              e5[i5] = e5[i5] || {}, e5[i5][a4] = e5[i5][a4] || {}, e5[i5][a4][o5] = e5[i5][a4][o5] || {}, e5[i5][a4][o5][s5] = n5;
            }
            return e5;
          }(r4.concat(e4));
        }
        return h5;
      }
      var p5 = null;
      Object.defineProperty(this, "fontFaces", { get: function() {
        return p5;
      }, set: function(t4) {
        h5 = null, p5 = t4;
      } }), Object.defineProperty(this, "font", { get: function() {
        return this.ctx.font;
      }, set: function(t4) {
        var e4;
        if (this.ctx.font = t4, (e4 = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t4)) !== null) {
          var r4 = e4[1], n5 = (e4[2], e4[3]), i5 = e4[4], a4 = (e4[5], e4[6]), o5 = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i5)[2];
          i5 = o5 === "px" ? Math.floor(parseFloat(i5) * this.pdf.internal.scaleFactor) : o5 === "em" ? Math.floor(parseFloat(i5) * this.pdf.getFontSize()) : Math.floor(parseFloat(i5) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i5);
          var s5 = function(t5) {
            var e5, r5, n6 = [], i6 = t5.trim();
            if (i6 === "")
              return Wt;
            if (i6 in Et)
              return [Et[i6]];
            for (; i6 !== ""; ) {
              switch (r5 = null, e5 = (i6 = Dt(i6)).charAt(0)) {
                case '"':
                case "'":
                  r5 = Rt(i6.substring(1), e5);
                  break;
                default:
                  r5 = Tt(i6);
              }
              if (r5 === null)
                return Wt;
              if (n6.push(r5[0]), (i6 = Dt(r5[1])) !== "" && i6.charAt(0) !== ",")
                return Wt;
              i6 = i6.replace(/^,/, "");
            }
            return n6;
          }(a4);
          if (this.fontFaces) {
            var c6 = qt(f3(this.pdf, this.fontFaces), s5.map(function(t5) {
              return { family: t5, stretch: "normal", weight: n5, style: r4 };
            }));
            this.pdf.setFont(c6.ref.name, c6.ref.style);
          } else {
            var u5 = "";
            (n5 === "bold" || parseInt(n5, 10) >= 700 || r4 === "bold") && (u5 = "bold"), r4 === "italic" && (u5 += "italic"), u5.length === 0 && (u5 = "normal");
            for (var h6 = "", l4 = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, d3 = 0; d3 < s5.length; d3++) {
              if (this.pdf.internal.getFont(s5[d3], u5, { noFallback: true, disableWarning: true }) !== void 0) {
                h6 = s5[d3];
                break;
              }
              if (u5 === "bolditalic" && this.pdf.internal.getFont(s5[d3], "bold", { noFallback: true, disableWarning: true }) !== void 0)
                h6 = s5[d3], u5 = "bold";
              else if (this.pdf.internal.getFont(s5[d3], "normal", { noFallback: true, disableWarning: true }) !== void 0) {
                h6 = s5[d3], u5 = "normal";
                break;
              }
            }
            if (h6 === "") {
              for (var p6 = 0; p6 < s5.length; p6++)
                if (l4[s5[p6]]) {
                  h6 = l4[s5[p6]];
                  break;
                }
            }
            h6 = h6 === "" ? "Times" : h6, this.pdf.setFont(h6, u5);
          }
        }
      } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
        return this.ctx.globalCompositeOperation;
      }, set: function(t4) {
        this.ctx.globalCompositeOperation = t4;
      } }), Object.defineProperty(this, "globalAlpha", { get: function() {
        return this.ctx.globalAlpha;
      }, set: function(t4) {
        this.ctx.globalAlpha = t4;
      } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
        return this.ctx.lineDashOffset;
      }, set: function(t4) {
        this.ctx.lineDashOffset = t4, T3.call(this);
      } }), Object.defineProperty(this, "lineDash", { get: function() {
        return this.ctx.lineDash;
      }, set: function(t4) {
        this.ctx.lineDash = t4, T3.call(this);
      } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
        return this.ctx.ignoreClearRect;
      }, set: function(t4) {
        this.ctx.ignoreClearRect = Boolean(t4);
      } });
    };
    p4.prototype.setLineDash = function(t3) {
      this.lineDash = t3;
    }, p4.prototype.getLineDash = function() {
      return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p4.prototype.fill = function() {
      A2.call(this, "fill", false);
    }, p4.prototype.stroke = function() {
      A2.call(this, "stroke", false);
    }, p4.prototype.beginPath = function() {
      this.path = [{ type: "begin" }];
    }, p4.prototype.moveTo = function(t3, e3) {
      if (isNaN(t3) || isNaN(e3))
        throw a2.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
      var r3 = this.ctx.transform.applyToPoint(new c4(t3, e3));
      this.path.push({ type: "mt", x: r3.x, y: r3.y }), this.ctx.lastPoint = new c4(t3, e3);
    }, p4.prototype.closePath = function() {
      var e3 = new c4(0, 0), r3 = 0;
      for (r3 = this.path.length - 1; r3 !== -1; r3--)
        if (this.path[r3].type === "begin" && _typeof(this.path[r3 + 1]) === "object" && typeof this.path[r3 + 1].x == "number") {
          e3 = new c4(this.path[r3 + 1].x, this.path[r3 + 1].y), this.path.push({ type: "lt", x: e3.x, y: e3.y });
          break;
        }
      _typeof(this.path[r3 + 2]) === "object" && typeof this.path[r3 + 2].x == "number" && this.path.push(JSON.parse(JSON.stringify(this.path[r3 + 2]))), this.path.push({ type: "close" }), this.ctx.lastPoint = new c4(e3.x, e3.y);
    }, p4.prototype.lineTo = function(t3, e3) {
      if (isNaN(t3) || isNaN(e3))
        throw a2.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
      var r3 = this.ctx.transform.applyToPoint(new c4(t3, e3));
      this.path.push({ type: "lt", x: r3.x, y: r3.y }), this.ctx.lastPoint = new c4(r3.x, r3.y);
    }, p4.prototype.clip = function() {
      this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A2.call(this, null, true);
    }, p4.prototype.quadraticCurveTo = function(t3, e3, r3, n4) {
      if (isNaN(r3) || isNaN(n4) || isNaN(t3) || isNaN(e3))
        throw a2.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
      var i4 = this.ctx.transform.applyToPoint(new c4(r3, n4)), o4 = this.ctx.transform.applyToPoint(new c4(t3, e3));
      this.path.push({ type: "qct", x1: o4.x, y1: o4.y, x: i4.x, y: i4.y }), this.ctx.lastPoint = new c4(i4.x, i4.y);
    }, p4.prototype.bezierCurveTo = function(t3, e3, r3, n4, i4, o4) {
      if (isNaN(i4) || isNaN(o4) || isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4))
        throw a2.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
      var s4 = this.ctx.transform.applyToPoint(new c4(i4, o4)), u4 = this.ctx.transform.applyToPoint(new c4(t3, e3)), h5 = this.ctx.transform.applyToPoint(new c4(r3, n4));
      this.path.push({ type: "bct", x1: u4.x, y1: u4.y, x2: h5.x, y2: h5.y, x: s4.x, y: s4.y }), this.ctx.lastPoint = new c4(s4.x, s4.y);
    }, p4.prototype.arc = function(t3, e3, r3, n4, i4, o4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4) || isNaN(i4))
        throw a2.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
      if (o4 = Boolean(o4), !this.ctx.transform.isIdentity) {
        var s4 = this.ctx.transform.applyToPoint(new c4(t3, e3));
        t3 = s4.x, e3 = s4.y;
        var u4 = this.ctx.transform.applyToPoint(new c4(0, r3)), h5 = this.ctx.transform.applyToPoint(new c4(0, 0));
        r3 = Math.sqrt(Math.pow(u4.x - h5.x, 2) + Math.pow(u4.y - h5.y, 2));
      }
      Math.abs(i4 - n4) >= 2 * Math.PI && (n4 = 0, i4 = 2 * Math.PI), this.path.push({ type: "arc", x: t3, y: e3, radius: r3, startAngle: n4, endAngle: i4, counterclockwise: o4 });
    }, p4.prototype.arcTo = function(t3, e3, r3, n4, i4) {
      throw new Error("arcTo not implemented.");
    }, p4.prototype.rect = function(t3, e3, r3, n4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4))
        throw a2.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
      this.moveTo(t3, e3), this.lineTo(t3 + r3, e3), this.lineTo(t3 + r3, e3 + n4), this.lineTo(t3, e3 + n4), this.lineTo(t3, e3), this.lineTo(t3 + r3, e3), this.lineTo(t3, e3);
    }, p4.prototype.fillRect = function(t3, e3, r3, n4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4))
        throw a2.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
      if (!m4.call(this)) {
        var i4 = {};
        this.lineCap !== "butt" && (i4.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (i4.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t3, e3, r3, n4), this.fill(), i4.hasOwnProperty("lineCap") && (this.lineCap = i4.lineCap), i4.hasOwnProperty("lineJoin") && (this.lineJoin = i4.lineJoin);
      }
    }, p4.prototype.strokeRect = function(t3, e3, r3, n4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4))
        throw a2.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
      v3.call(this) || (this.beginPath(), this.rect(t3, e3, r3, n4), this.stroke());
    }, p4.prototype.clearRect = function(t3, e3, r3, n4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4))
        throw a2.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
      this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t3, e3, r3, n4));
    }, p4.prototype.save = function(t3) {
      t3 = typeof t3 != "boolean" || t3;
      for (var e3 = this.pdf.internal.getCurrentPageInfo().pageNumber, r3 = 0; r3 < this.pdf.internal.getNumberOfPages(); r3++)
        this.pdf.setPage(r3 + 1), this.pdf.internal.out("q");
      if (this.pdf.setPage(e3), t3) {
        this.ctx.fontSize = this.pdf.internal.getFontSize();
        var n4 = new d2(this.ctx);
        this.ctxStack.push(this.ctx), this.ctx = n4;
      }
    }, p4.prototype.restore = function(t3) {
      t3 = typeof t3 != "boolean" || t3;
      for (var e3 = this.pdf.internal.getCurrentPageInfo().pageNumber, r3 = 0; r3 < this.pdf.internal.getNumberOfPages(); r3++)
        this.pdf.setPage(r3 + 1), this.pdf.internal.out("Q");
      this.pdf.setPage(e3), t3 && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p4.prototype.toDataURL = function() {
      throw new Error("toDataUrl not implemented.");
    };
    var g2 = function(t3) {
      var e3, r3, n4, i4;
      if (t3.isCanvasGradient === true && (t3 = t3.getColor()), !t3)
        return { r: 0, g: 0, b: 0, a: 0, style: t3 };
      if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t3))
        e3 = 0, r3 = 0, n4 = 0, i4 = 0;
      else {
        var a3 = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t3);
        if (a3 !== null)
          e3 = parseInt(a3[1]), r3 = parseInt(a3[2]), n4 = parseInt(a3[3]), i4 = 1;
        else if ((a3 = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t3)) !== null)
          e3 = parseInt(a3[1]), r3 = parseInt(a3[2]), n4 = parseInt(a3[3]), i4 = parseFloat(a3[4]);
        else {
          if (i4 = 1, typeof t3 == "string" && t3.charAt(0) !== "#") {
            var o4 = new f2(t3);
            t3 = o4.ok ? o4.toHex() : "#000000";
          }
          t3.length === 4 ? (e3 = t3.substring(1, 2), e3 += e3, r3 = t3.substring(2, 3), r3 += r3, n4 = t3.substring(3, 4), n4 += n4) : (e3 = t3.substring(1, 3), r3 = t3.substring(3, 5), n4 = t3.substring(5, 7)), e3 = parseInt(e3, 16), r3 = parseInt(r3, 16), n4 = parseInt(n4, 16);
        }
      }
      return { r: e3, g: r3, b: n4, a: i4, style: t3 };
    }, m4 = function() {
      return this.ctx.isFillTransparent || this.globalAlpha == 0;
    }, v3 = function() {
      return Boolean(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
    };
    p4.prototype.fillText = function(t3, e3, r3, n4) {
      if (isNaN(e3) || isNaN(r3) || typeof t3 != "string")
        throw a2.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
      if (n4 = isNaN(n4) ? void 0 : n4, !m4.call(this)) {
        var i4 = q2(this.ctx.transform.rotation), o4 = this.ctx.transform.scaleX;
        C2.call(this, { text: t3, x: e3, y: r3, scale: o4, angle: i4, align: this.textAlign, maxWidth: n4 });
      }
    }, p4.prototype.strokeText = function(t3, e3, r3, n4) {
      if (isNaN(e3) || isNaN(r3) || typeof t3 != "string")
        throw a2.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
      if (!v3.call(this)) {
        n4 = isNaN(n4) ? void 0 : n4;
        var i4 = q2(this.ctx.transform.rotation), o4 = this.ctx.transform.scaleX;
        C2.call(this, { text: t3, x: e3, y: r3, scale: o4, renderingMode: "stroke", angle: i4, align: this.textAlign, maxWidth: n4 });
      }
    }, p4.prototype.measureText = function(t3) {
      if (typeof t3 != "string")
        throw a2.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
      var e3 = this.pdf, r3 = this.pdf.internal.scaleFactor, n4 = e3.internal.getFontSize(), i4 = e3.getStringUnitWidth(t3) * n4 / e3.internal.scaleFactor, o4 = function(t4) {
        var e4 = (t4 = t4 || {}).width || 0;
        return Object.defineProperty(this, "width", { get: function() {
          return e4;
        } }), this;
      };
      return new o4({ width: i4 *= Math.round(96 * r3 / 72 * 1e4) / 1e4 });
    }, p4.prototype.scale = function(t3, e3) {
      if (isNaN(t3) || isNaN(e3))
        throw a2.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
      var r3 = new h4(t3, 0, 0, e3, 0, 0);
      this.ctx.transform = this.ctx.transform.multiply(r3);
    }, p4.prototype.rotate = function(t3) {
      if (isNaN(t3))
        throw a2.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
      var e3 = new h4(Math.cos(t3), Math.sin(t3), -Math.sin(t3), Math.cos(t3), 0, 0);
      this.ctx.transform = this.ctx.transform.multiply(e3);
    }, p4.prototype.translate = function(t3, e3) {
      if (isNaN(t3) || isNaN(e3))
        throw a2.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
      var r3 = new h4(1, 0, 0, 1, t3, e3);
      this.ctx.transform = this.ctx.transform.multiply(r3);
    }, p4.prototype.transform = function(t3, e3, r3, n4, i4, o4) {
      if (isNaN(t3) || isNaN(e3) || isNaN(r3) || isNaN(n4) || isNaN(i4) || isNaN(o4))
        throw a2.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
      var s4 = new h4(t3, e3, r3, n4, i4, o4);
      this.ctx.transform = this.ctx.transform.multiply(s4);
    }, p4.prototype.setTransform = function(t3, e3, r3, n4, i4, a3) {
      t3 = isNaN(t3) ? 1 : t3, e3 = isNaN(e3) ? 0 : e3, r3 = isNaN(r3) ? 0 : r3, n4 = isNaN(n4) ? 1 : n4, i4 = isNaN(i4) ? 0 : i4, a3 = isNaN(a3) ? 0 : a3, this.ctx.transform = new h4(t3, e3, r3, n4, i4, a3);
    };
    var b2 = function() {
      return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p4.prototype.drawImage = function(t3, e3, r3, n4, i4, a3, o4, s4, c5) {
      var l4 = this.pdf.getImageProperties(t3), f3 = 1, d3 = 1, p5 = 1, g3 = 1;
      n4 !== void 0 && s4 !== void 0 && (p5 = s4 / n4, g3 = c5 / i4, f3 = l4.width / n4 * s4 / n4, d3 = l4.height / i4 * c5 / i4), a3 === void 0 && (a3 = e3, o4 = r3, e3 = 0, r3 = 0), n4 !== void 0 && s4 === void 0 && (s4 = n4, c5 = i4), n4 === void 0 && s4 === void 0 && (s4 = l4.width, c5 = l4.height);
      for (var m5, v4 = this.ctx.transform.decompose(), w3 = q2(v4.rotate.shx), A3 = new h4(), S3 = (A3 = (A3 = (A3 = A3.multiply(v4.translate)).multiply(v4.skew)).multiply(v4.scale)).applyToRectangle(new u3(a3 - e3 * p5, o4 - r3 * g3, n4 * f3, i4 * d3)), _4 = y3.call(this, S3), P3 = [], k3 = 0; k3 < _4.length; k3 += 1)
        P3.indexOf(_4[k3]) === -1 && P3.push(_4[k3]);
      if (L2(P3), this.autoPaging)
        for (var I3 = P3[0], F3 = P3[P3.length - 1], C3 = I3; C3 < F3 + 1; C3++) {
          this.pdf.setPage(C3);
          var j3 = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O4 = C3 === 1 ? this.posY + this.margin[0] : this.margin[0], B3 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], E3 = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], M3 = C3 === 1 ? 0 : B3 + (C3 - 2) * E3;
          if (this.ctx.clip_path.length !== 0) {
            var D3 = this.path;
            m5 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N3(m5, this.posX + this.margin[3], -M3 + O4 + this.ctx.prevPageLastElemOffset), x2.call(this, "fill", true), this.path = D3;
          }
          var R3 = JSON.parse(JSON.stringify(S3));
          R3 = N3([R3], this.posX + this.margin[3], -M3 + O4 + this.ctx.prevPageLastElemOffset)[0];
          var T4 = (C3 > I3 || C3 < F3) && b2.call(this);
          T4 && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j3, E3, null).clip().discardPath()), this.pdf.addImage(t3, "JPEG", R3.x, R3.y, R3.w, R3.h, null, null, w3), T4 && this.pdf.restoreGraphicsState();
        }
      else
        this.pdf.addImage(t3, "JPEG", S3.x, S3.y, S3.w, S3.h, null, null, w3);
    };
    var y3 = function(t3, e3, r3) {
      var n4 = [];
      e3 = e3 || this.pdf.internal.pageSize.width, r3 = r3 || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
      var i4 = this.posY + this.ctx.prevPageLastElemOffset;
      switch (t3.type) {
        default:
        case "mt":
        case "lt":
          n4.push(Math.floor((t3.y + i4) / r3) + 1);
          break;
        case "arc":
          n4.push(Math.floor((t3.y + i4 - t3.radius) / r3) + 1), n4.push(Math.floor((t3.y + i4 + t3.radius) / r3) + 1);
          break;
        case "qct":
          var a3 = D2(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t3.x1, t3.y1, t3.x, t3.y);
          n4.push(Math.floor((a3.y + i4) / r3) + 1), n4.push(Math.floor((a3.y + a3.h + i4) / r3) + 1);
          break;
        case "bct":
          var o4 = R2(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t3.x1, t3.y1, t3.x2, t3.y2, t3.x, t3.y);
          n4.push(Math.floor((o4.y + i4) / r3) + 1), n4.push(Math.floor((o4.y + o4.h + i4) / r3) + 1);
          break;
        case "rect":
          n4.push(Math.floor((t3.y + i4) / r3) + 1), n4.push(Math.floor((t3.y + t3.h + i4) / r3) + 1);
      }
      for (var s4 = 0; s4 < n4.length; s4 += 1)
        for (; this.pdf.internal.getNumberOfPages() < n4[s4]; )
          w2.call(this);
      return n4;
    }, w2 = function() {
      var t3 = this.fillStyle, e3 = this.strokeStyle, r3 = this.font, n4 = this.lineCap, i4 = this.lineWidth, a3 = this.lineJoin;
      this.pdf.addPage(), this.fillStyle = t3, this.strokeStyle = e3, this.font = r3, this.lineCap = n4, this.lineWidth = i4, this.lineJoin = a3;
    }, N3 = function(t3, e3, r3) {
      for (var n4 = 0; n4 < t3.length; n4++)
        switch (t3[n4].type) {
          case "bct":
            t3[n4].x2 += e3, t3[n4].y2 += r3;
          case "qct":
            t3[n4].x1 += e3, t3[n4].y1 += r3;
          case "mt":
          case "lt":
          case "arc":
          default:
            t3[n4].x += e3, t3[n4].y += r3;
        }
      return t3;
    }, L2 = function(t3) {
      return t3.sort(function(t4, e3) {
        return t4 - e3;
      });
    }, A2 = function(t3, e3) {
      for (var r3, n4, i4 = this.fillStyle, a3 = this.strokeStyle, o4 = this.lineCap, s4 = this.lineWidth, c5 = Math.abs(s4 * this.ctx.transform.scaleX), u4 = this.lineJoin, h5 = JSON.parse(JSON.stringify(this.path)), l4 = JSON.parse(JSON.stringify(this.path)), f3 = [], d3 = 0; d3 < l4.length; d3++)
        if (l4[d3].x !== void 0)
          for (var p5 = y3.call(this, l4[d3]), g3 = 0; g3 < p5.length; g3 += 1)
            f3.indexOf(p5[g3]) === -1 && f3.push(p5[g3]);
      for (var m5 = 0; m5 < f3.length; m5++)
        for (; this.pdf.internal.getNumberOfPages() < f3[m5]; )
          w2.call(this);
      if (L2(f3), this.autoPaging)
        for (var v4 = f3[0], A3 = f3[f3.length - 1], S3 = v4; S3 < A3 + 1; S3++) {
          this.pdf.setPage(S3), this.fillStyle = i4, this.strokeStyle = a3, this.lineCap = o4, this.lineWidth = c5, this.lineJoin = u4;
          var _4 = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P3 = S3 === 1 ? this.posY + this.margin[0] : this.margin[0], k3 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I3 = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F3 = S3 === 1 ? 0 : k3 + (S3 - 2) * I3;
          if (this.ctx.clip_path.length !== 0) {
            var C3 = this.path;
            r3 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N3(r3, this.posX + this.margin[3], -F3 + P3 + this.ctx.prevPageLastElemOffset), x2.call(this, t3, true), this.path = C3;
          }
          if (n4 = JSON.parse(JSON.stringify(h5)), this.path = N3(n4, this.posX + this.margin[3], -F3 + P3 + this.ctx.prevPageLastElemOffset), e3 === false || S3 === 0) {
            var j3 = (S3 > v4 || S3 < A3) && b2.call(this);
            j3 && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _4, I3, null).clip().discardPath()), x2.call(this, t3, e3), j3 && this.pdf.restoreGraphicsState();
          }
          this.lineWidth = s4;
        }
      else
        this.lineWidth = c5, x2.call(this, t3, e3), this.lineWidth = s4;
      this.path = h5;
    }, x2 = function(t3, e3) {
      if ((t3 !== "stroke" || e3 || !v3.call(this)) && (t3 === "stroke" || e3 || !m4.call(this))) {
        for (var r3, n4, i4 = [], a3 = this.path, o4 = 0; o4 < a3.length; o4++) {
          var s4 = a3[o4];
          switch (s4.type) {
            case "begin":
              i4.push({ begin: true });
              break;
            case "close":
              i4.push({ close: true });
              break;
            case "mt":
              i4.push({ start: s4, deltas: [], abs: [] });
              break;
            case "lt":
              var c5 = i4.length;
              if (!isNaN(a3[o4 - 1].x) && (r3 = [s4.x - a3[o4 - 1].x, s4.y - a3[o4 - 1].y], c5 > 0)) {
                for (; c5 >= 0; c5--)
                  if (i4[c5 - 1].close !== true && i4[c5 - 1].begin !== true) {
                    i4[c5 - 1].deltas.push(r3), i4[c5 - 1].abs.push(s4);
                    break;
                  }
              }
              break;
            case "bct":
              r3 = [s4.x1 - a3[o4 - 1].x, s4.y1 - a3[o4 - 1].y, s4.x2 - a3[o4 - 1].x, s4.y2 - a3[o4 - 1].y, s4.x - a3[o4 - 1].x, s4.y - a3[o4 - 1].y], i4[i4.length - 1].deltas.push(r3);
              break;
            case "qct":
              var u4 = a3[o4 - 1].x + 2 / 3 * (s4.x1 - a3[o4 - 1].x), h5 = a3[o4 - 1].y + 2 / 3 * (s4.y1 - a3[o4 - 1].y), l4 = s4.x + 2 / 3 * (s4.x1 - s4.x), f3 = s4.y + 2 / 3 * (s4.y1 - s4.y), d3 = s4.x, p5 = s4.y;
              r3 = [u4 - a3[o4 - 1].x, h5 - a3[o4 - 1].y, l4 - a3[o4 - 1].x, f3 - a3[o4 - 1].y, d3 - a3[o4 - 1].x, p5 - a3[o4 - 1].y], i4[i4.length - 1].deltas.push(r3);
              break;
            case "arc":
              i4.push({ deltas: [], abs: [], arc: true }), Array.isArray(i4[i4.length - 1].abs) && i4[i4.length - 1].abs.push(s4);
          }
        }
        n4 = e3 ? null : t3 === "stroke" ? "stroke" : "fill";
        for (var g3 = 0; g3 < i4.length; g3++) {
          if (i4[g3].arc) {
            for (var b3 = i4[g3].abs, y4 = 0; y4 < b3.length; y4++) {
              var w3 = b3[y4];
              w3.type === "arc" ? P2.call(this, w3.x, w3.y, w3.radius, w3.startAngle, w3.endAngle, w3.counterclockwise, void 0, e3) : j2.call(this, w3.x, w3.y);
            }
            k2.call(this, n4), this.pdf.internal.out("h");
          }
          if (!i4[g3].arc && i4[g3].close !== true && i4[g3].begin !== true) {
            var N4 = i4[g3].start.x, L3 = i4[g3].start.y;
            O3.call(this, i4[g3].deltas, N4, L3);
          }
        }
        n4 && k2.call(this, n4), e3 && I2.call(this);
      }
    }, S2 = function(t3) {
      var e3 = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r3 = e3 * (this.pdf.internal.getLineHeightFactor() - 1);
      switch (this.ctx.textBaseline) {
        case "bottom":
          return t3 - r3;
        case "top":
          return t3 + e3 - r3;
        case "hanging":
          return t3 + e3 - 2 * r3;
        case "middle":
          return t3 + e3 / 2 - r3;
        case "ideographic":
          return t3;
        case "alphabetic":
        default:
          return t3;
      }
    }, _3 = function(t3) {
      return t3 + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p4.prototype.createLinearGradient = function() {
      var t3 = function() {
      };
      return t3.colorStops = [], t3.addColorStop = function(t4, e3) {
        this.colorStops.push([t4, e3]);
      }, t3.getColor = function() {
        return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
      }, t3.isCanvasGradient = true, t3;
    }, p4.prototype.createPattern = function() {
      return this.createLinearGradient();
    }, p4.prototype.createRadialGradient = function() {
      return this.createLinearGradient();
    };
    var P2 = function(t3, e3, r3, n4, i4, a3, o4, s4) {
      for (var c5 = E2.call(this, r3, n4, i4, a3), u4 = 0; u4 < c5.length; u4++) {
        var h5 = c5[u4];
        u4 === 0 && F2.call(this, h5.x1 + t3, h5.y1 + e3), B2.call(this, t3, e3, h5.x2, h5.y2, h5.x3, h5.y3, h5.x4, h5.y4);
      }
      s4 ? I2.call(this) : k2.call(this, o4);
    }, k2 = function(t3) {
      switch (t3) {
        case "stroke":
          this.pdf.internal.out("S");
          break;
        case "fill":
          this.pdf.internal.out("f");
      }
    }, I2 = function() {
      this.pdf.clip(), this.pdf.discardPath();
    }, F2 = function(t3, e3) {
      this.pdf.internal.out(n3(t3) + " " + i3(e3) + " m");
    }, C2 = function(t3) {
      var e3;
      switch (t3.align) {
        case "right":
        case "end":
          e3 = "right";
          break;
        case "center":
          e3 = "center";
          break;
        case "left":
        case "start":
        default:
          e3 = "left";
      }
      var r3 = this.pdf.getTextDimensions(t3.text), n4 = S2.call(this, t3.y), i4 = _3.call(this, n4) - r3.h, a3 = this.ctx.transform.applyToPoint(new c4(t3.x, n4)), o4 = this.ctx.transform.decompose(), s4 = new h4();
      s4 = (s4 = (s4 = s4.multiply(o4.translate)).multiply(o4.skew)).multiply(o4.scale);
      for (var l4, f3, d3, p5 = this.ctx.transform.applyToRectangle(new u3(t3.x, n4, r3.w, r3.h)), g3 = s4.applyToRectangle(new u3(t3.x, i4, r3.w, r3.h)), m5 = y3.call(this, g3), v4 = [], w3 = 0; w3 < m5.length; w3 += 1)
        v4.indexOf(m5[w3]) === -1 && v4.push(m5[w3]);
      if (L2(v4), this.autoPaging)
        for (var A3 = v4[0], P3 = v4[v4.length - 1], k3 = A3; k3 < P3 + 1; k3++) {
          this.pdf.setPage(k3);
          var I3 = k3 === 1 ? this.posY + this.margin[0] : this.margin[0], F3 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C3 = this.pdf.internal.pageSize.height - this.margin[2], j3 = C3 - this.margin[0], O4 = this.pdf.internal.pageSize.width - this.margin[1], B3 = O4 - this.margin[3], E3 = k3 === 1 ? 0 : F3 + (k3 - 2) * j3;
          if (this.ctx.clip_path.length !== 0) {
            var M3 = this.path;
            l4 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N3(l4, this.posX + this.margin[3], -1 * E3 + I3), x2.call(this, "fill", true), this.path = M3;
          }
          var q3 = N3([JSON.parse(JSON.stringify(g3))], this.posX + this.margin[3], -E3 + I3 + this.ctx.prevPageLastElemOffset)[0];
          t3.scale >= 0.01 && (f3 = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f3 * t3.scale), d3 = this.lineWidth, this.lineWidth = d3 * t3.scale);
          var D3 = this.autoPaging !== "text";
          if (D3 || q3.y + q3.h <= C3) {
            if (D3 || q3.y >= I3 && q3.x <= O4) {
              var R3 = D3 ? t3.text : this.pdf.splitTextToSize(t3.text, t3.maxWidth || O4 - q3.x)[0], T4 = N3([JSON.parse(JSON.stringify(p5))], this.posX + this.margin[3], -E3 + I3 + this.ctx.prevPageLastElemOffset)[0], U2 = D3 && (k3 > A3 || k3 < P3) && b2.call(this);
              U2 && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B3, j3, null).clip().discardPath()), this.pdf.text(R3, T4.x, T4.y, { angle: t3.angle, align: e3, renderingMode: t3.renderingMode }), U2 && this.pdf.restoreGraphicsState();
            }
          } else
            q3.y < C3 && (this.ctx.prevPageLastElemOffset += C3 - q3.y);
          t3.scale >= 0.01 && (this.pdf.setFontSize(f3), this.lineWidth = d3);
        }
      else
        t3.scale >= 0.01 && (f3 = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f3 * t3.scale), d3 = this.lineWidth, this.lineWidth = d3 * t3.scale), this.pdf.text(t3.text, a3.x + this.posX, a3.y + this.posY, { angle: t3.angle, align: e3, renderingMode: t3.renderingMode, maxWidth: t3.maxWidth }), t3.scale >= 0.01 && (this.pdf.setFontSize(f3), this.lineWidth = d3);
    }, j2 = function(t3, e3, r3, a3) {
      r3 = r3 || 0, a3 = a3 || 0, this.pdf.internal.out(n3(t3 + r3) + " " + i3(e3 + a3) + " l");
    }, O3 = function(t3, e3, r3) {
      return this.pdf.lines(t3, e3, r3, null, null);
    }, B2 = function(t3, e3, n4, i4, a3, c5, u4, h5) {
      this.pdf.internal.out([r2(o3(n4 + t3)), r2(s3(i4 + e3)), r2(o3(a3 + t3)), r2(s3(c5 + e3)), r2(o3(u4 + t3)), r2(s3(h5 + e3)), "c"].join(" "));
    }, E2 = function(t3, e3, r3, n4) {
      for (var i4 = 2 * Math.PI, a3 = Math.PI / 2; e3 > r3; )
        e3 -= i4;
      var o4 = Math.abs(r3 - e3);
      o4 < i4 && n4 && (o4 = i4 - o4);
      for (var s4 = [], c5 = n4 ? -1 : 1, u4 = e3; o4 > 1e-5; ) {
        var h5 = u4 + c5 * Math.min(o4, a3);
        s4.push(M2.call(this, t3, u4, h5)), o4 -= Math.abs(h5 - u4), u4 = h5;
      }
      return s4;
    }, M2 = function(t3, e3, r3) {
      var n4 = (r3 - e3) / 2, i4 = t3 * Math.cos(n4), a3 = t3 * Math.sin(n4), o4 = i4, s4 = -a3, c5 = o4 * o4 + s4 * s4, u4 = c5 + o4 * i4 + s4 * a3, h5 = 4 / 3 * (Math.sqrt(2 * c5 * u4) - u4) / (o4 * a3 - s4 * i4), l4 = o4 - h5 * s4, f3 = s4 + h5 * o4, d3 = l4, p5 = -f3, g3 = n4 + e3, m5 = Math.cos(g3), v4 = Math.sin(g3);
      return { x1: t3 * Math.cos(e3), y1: t3 * Math.sin(e3), x2: l4 * m5 - f3 * v4, y2: l4 * v4 + f3 * m5, x3: d3 * m5 - p5 * v4, y3: d3 * v4 + p5 * m5, x4: t3 * Math.cos(r3), y4: t3 * Math.sin(r3) };
    }, q2 = function(t3) {
      return 180 * t3 / Math.PI;
    }, D2 = function(t3, e3, r3, n4, i4, a3) {
      var o4 = t3 + 0.5 * (r3 - t3), s4 = e3 + 0.5 * (n4 - e3), c5 = i4 + 0.5 * (r3 - i4), h5 = a3 + 0.5 * (n4 - a3), l4 = Math.min(t3, i4, o4, c5), f3 = Math.max(t3, i4, o4, c5), d3 = Math.min(e3, a3, s4, h5), p5 = Math.max(e3, a3, s4, h5);
      return new u3(l4, d3, f3 - l4, p5 - d3);
    }, R2 = function(t3, e3, r3, n4, i4, a3, o4, s4) {
      var c5, h5, l4, f3, d3, p5, g3, m5, v4, b3, y4, w3, N4, L3, A3 = r3 - t3, x3 = n4 - e3, S3 = i4 - r3, _4 = a3 - n4, P3 = o4 - i4, k3 = s4 - a3;
      for (h5 = 0; h5 < 41; h5++)
        v4 = (g3 = (l4 = t3 + (c5 = h5 / 40) * A3) + c5 * ((d3 = r3 + c5 * S3) - l4)) + c5 * (d3 + c5 * (i4 + c5 * P3 - d3) - g3), b3 = (m5 = (f3 = e3 + c5 * x3) + c5 * ((p5 = n4 + c5 * _4) - f3)) + c5 * (p5 + c5 * (a3 + c5 * k3 - p5) - m5), h5 == 0 ? (y4 = v4, w3 = b3, N4 = v4, L3 = b3) : (y4 = Math.min(y4, v4), w3 = Math.min(w3, b3), N4 = Math.max(N4, v4), L3 = Math.max(L3, b3));
      return new u3(Math.round(y4), Math.round(w3), Math.round(N4 - y4), Math.round(L3 - w3));
    }, T3 = function() {
      if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
        var t3, e3, r3 = (t3 = this.ctx.lineDash, e3 = this.ctx.lineDashOffset, JSON.stringify({ lineDash: t3, lineDashOffset: e3 }));
        this.prevLineDash !== r3 && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r3);
      }
    };
  }(M.API), function(t3) {
    var r2 = function(t4) {
      var e2, r3, n4, i4, a4, o3, s3, c4, u3, h4;
      for (/[^\x00-\xFF]/.test(t4), r3 = [], n4 = 0, i4 = (t4 += e2 = "\0\0\0\0".slice(t4.length % 4 || 4)).length; i4 > n4; n4 += 4)
        (a4 = (t4.charCodeAt(n4) << 24) + (t4.charCodeAt(n4 + 1) << 16) + (t4.charCodeAt(n4 + 2) << 8) + t4.charCodeAt(n4 + 3)) !== 0 ? (o3 = (a4 = ((a4 = ((a4 = ((a4 = (a4 - (h4 = a4 % 85)) / 85) - (u3 = a4 % 85)) / 85) - (c4 = a4 % 85)) / 85) - (s3 = a4 % 85)) / 85) % 85, r3.push(o3 + 33, s3 + 33, c4 + 33, u3 + 33, h4 + 33)) : r3.push(122);
      return function(t5, e3) {
        for (var r4 = e3; r4 > 0; r4--)
          t5.pop();
      }(r3, e2.length), String.fromCharCode.apply(String, r3) + "~>";
    }, n3 = function(t4) {
      var e2, r3, n4, i4, a4, o3 = String, s3 = "length", c4 = 255, u3 = "charCodeAt", h4 = "slice", l3 = "replace";
      for (t4[h4](-2), t4 = t4[h4](0, -2)[l3](/\s/g, "")[l3]("z", "!!!!!"), n4 = [], i4 = 0, a4 = (t4 += e2 = "uuuuu"[h4](t4[s3] % 5 || 5))[s3]; a4 > i4; i4 += 5)
        r3 = 52200625 * (t4[u3](i4) - 33) + 614125 * (t4[u3](i4 + 1) - 33) + 7225 * (t4[u3](i4 + 2) - 33) + 85 * (t4[u3](i4 + 3) - 33) + (t4[u3](i4 + 4) - 33), n4.push(c4 & r3 >> 24, c4 & r3 >> 16, c4 & r3 >> 8, c4 & r3);
      return function(t5, e3) {
        for (var r4 = e3; r4 > 0; r4--)
          t5.pop();
      }(n4, e2[s3]), o3.fromCharCode.apply(o3, n4);
    }, i3 = function(t4) {
      var e2 = new RegExp(/^([0-9A-Fa-f]{2})+$/);
      if ((t4 = t4.replace(/\s/g, "")).indexOf(">") !== -1 && (t4 = t4.substr(0, t4.indexOf(">"))), t4.length % 2 && (t4 += "0"), e2.test(t4) === false)
        return "";
      for (var r3 = "", n4 = 0; n4 < t4.length; n4 += 2)
        r3 += String.fromCharCode("0x" + (t4[n4] + t4[n4 + 1]));
      return r3;
    }, a3 = function(t4) {
      for (var r3 = new Uint8Array(t4.length), n4 = t4.length; n4--; )
        r3[n4] = t4.charCodeAt(n4);
      return t4 = (r3 = zlibSync(r3)).reduce(function(t5, e2) {
        return t5 + String.fromCharCode(e2);
      }, "");
    };
    t3.processDataByFilters = function(t4, e2) {
      var o3 = 0, s3 = t4 || "", c4 = [];
      for (typeof (e2 = e2 || []) == "string" && (e2 = [e2]), o3 = 0; o3 < e2.length; o3 += 1)
        switch (e2[o3]) {
          case "ASCII85Decode":
          case "/ASCII85Decode":
            s3 = n3(s3), c4.push("/ASCII85Encode");
            break;
          case "ASCII85Encode":
          case "/ASCII85Encode":
            s3 = r2(s3), c4.push("/ASCII85Decode");
            break;
          case "ASCIIHexDecode":
          case "/ASCIIHexDecode":
            s3 = i3(s3), c4.push("/ASCIIHexEncode");
            break;
          case "ASCIIHexEncode":
          case "/ASCIIHexEncode":
            s3 = s3.split("").map(function(t5) {
              return ("0" + t5.charCodeAt().toString(16)).slice(-2);
            }).join("") + ">", c4.push("/ASCIIHexDecode");
            break;
          case "FlateEncode":
          case "/FlateEncode":
            s3 = a3(s3), c4.push("/FlateDecode");
            break;
          default:
            throw new Error('The filter: "' + e2[o3] + '" is not implemented');
        }
      return { data: s3, reverseChain: c4.reverse().join(" ") };
    };
  }(M.API), function(t3) {
    t3.loadFile = function(t4, e2, r2) {
      return function(t5, e3, r3) {
        e3 = e3 !== false, r3 = typeof r3 == "function" ? r3 : function() {
        };
        var n3 = void 0;
        try {
          n3 = function(t6, e4, r4) {
            var n4 = new XMLHttpRequest(), i3 = 0, a3 = function(t7) {
              var e5 = t7.length, r5 = [], n5 = String.fromCharCode;
              for (i3 = 0; i3 < e5; i3 += 1)
                r5.push(n5(255 & t7.charCodeAt(i3)));
              return r5.join("");
            };
            if (n4.open("GET", t6, !e4), n4.overrideMimeType("text/plain; charset=x-user-defined"), e4 === false && (n4.onload = function() {
              n4.status === 200 ? r4(a3(this.responseText)) : r4(void 0);
            }), n4.send(null), e4 && n4.status === 200)
              return a3(n4.responseText);
          }(t5, e3, r3);
        } catch (t6) {
        }
        return n3;
      }(t4, e2, r2);
    }, t3.loadImageFile = t3.loadFile;
  }(M.API), function(e2) {
    function r2() {
      return (n2.html2canvas ? Promise.resolve(n2.html2canvas) : Promise.resolve().then(() => __toModule(require_html2canvas()))).catch(function(t3) {
        return Promise.reject(new Error("Could not load html2canvas: " + t3));
      }).then(function(t3) {
        return t3.default ? t3.default : t3;
      });
    }
    function i3() {
      return (n2.DOMPurify ? Promise.resolve(n2.DOMPurify) : Promise.resolve().then(() => __toModule(require_purify()))).catch(function(t3) {
        return Promise.reject(new Error("Could not load dompurify: " + t3));
      }).then(function(t3) {
        return t3.default ? t3.default : t3;
      });
    }
    var a3 = function(e3) {
      var r3 = _typeof(e3);
      return r3 === "undefined" ? "undefined" : r3 === "string" || e3 instanceof String ? "string" : r3 === "number" || e3 instanceof Number ? "number" : r3 === "function" || e3 instanceof Function ? "function" : e3 && e3.constructor === Array ? "array" : e3 && e3.nodeType === 1 ? "element" : r3 === "object" ? "object" : "unknown";
    }, o3 = function(t3, e3) {
      var r3 = document.createElement(t3);
      for (var n3 in e3.className && (r3.className = e3.className), e3.innerHTML && e3.dompurify && (r3.innerHTML = e3.dompurify.sanitize(e3.innerHTML)), e3.style)
        r3.style[n3] = e3.style[n3];
      return r3;
    }, s3 = function t3(e3) {
      var r3 = Object.assign(t3.convert(Promise.resolve()), JSON.parse(JSON.stringify(t3.template))), n3 = t3.convert(Promise.resolve(), r3);
      return n3 = (n3 = n3.setProgress(1, t3, 1, [t3])).set(e3);
    };
    (s3.prototype = Object.create(Promise.prototype)).constructor = s3, s3.convert = function(t3, e3) {
      return t3.__proto__ = e3 || s3.prototype, t3;
    }, s3.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
    } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: true, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, s3.prototype.from = function(t3, e3) {
      return this.then(function() {
        switch (e3 = e3 || function(t4) {
          switch (a3(t4)) {
            case "string":
              return "string";
            case "element":
              return t4.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
            default:
              return "unknown";
          }
        }(t3)) {
          case "string":
            return this.then(i3).then(function(e4) {
              return this.set({ src: o3("div", { innerHTML: t3, dompurify: e4 }) });
            });
          case "element":
            return this.set({ src: t3 });
          case "canvas":
            return this.set({ canvas: t3 });
          case "img":
            return this.set({ img: t3 });
          default:
            return this.error("Unknown source type.");
        }
      });
    }, s3.prototype.to = function(t3) {
      switch (t3) {
        case "container":
          return this.toContainer();
        case "canvas":
          return this.toCanvas();
        case "img":
          return this.toImg();
        case "pdf":
          return this.toPdf();
        default:
          return this.error("Invalid target.");
      }
    }, s3.prototype.toContainer = function() {
      return this.thenList([function() {
        return this.prop.src || this.error("Cannot duplicate - no source HTML.");
      }, function() {
        return this.prop.pageSize || this.setPageSize();
      }]).then(function() {
        var t3 = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, e3 = function t4(e4, r3) {
          for (var n3 = e4.nodeType === 3 ? document.createTextNode(e4.nodeValue) : e4.cloneNode(false), i4 = e4.firstChild; i4; i4 = i4.nextSibling)
            r3 !== true && i4.nodeType === 1 && i4.nodeName === "SCRIPT" || n3.appendChild(t4(i4, r3));
          return e4.nodeType === 1 && (e4.nodeName === "CANVAS" ? (n3.width = e4.width, n3.height = e4.height, n3.getContext("2d").drawImage(e4, 0, 0)) : e4.nodeName !== "TEXTAREA" && e4.nodeName !== "SELECT" || (n3.value = e4.value), n3.addEventListener("load", function() {
            n3.scrollTop = e4.scrollTop, n3.scrollLeft = e4.scrollLeft;
          }, true)), n3;
        }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
        e3.tagName === "BODY" && (t3.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o3("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = o3("div", { className: "html2pdf__container", style: t3 }), this.prop.container.appendChild(e3), this.prop.container.firstChild.appendChild(o3("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
      });
    }, s3.prototype.toCanvas = function() {
      var t3 = [function() {
        return document.body.contains(this.prop.container) || this.toContainer();
      }];
      return this.thenList(t3).then(r2).then(function(t4) {
        var e3 = Object.assign({}, this.opt.html2canvas);
        return delete e3.onrendered, t4(this.prop.container, e3);
      }).then(function(t4) {
        (this.opt.html2canvas.onrendered || function() {
        })(t4), this.prop.canvas = t4, document.body.removeChild(this.prop.overlay);
      });
    }, s3.prototype.toContext2d = function() {
      var t3 = [function() {
        return document.body.contains(this.prop.container) || this.toContainer();
      }];
      return this.thenList(t3).then(r2).then(function(t4) {
        var e3 = this.opt.jsPDF, r3 = this.opt.fontFaces, n3 = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i4 = Object.assign({ async: true, allowTaint: true, scale: n3, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: true, proxy: null, removeContainer: true, foreignObjectRendering: false, useCORS: false }, this.opt.html2canvas);
        if (delete i4.onrendered, e3.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, e3.context2d.posX = this.opt.x, e3.context2d.posY = this.opt.y, e3.context2d.margin = this.opt.margin, e3.context2d.fontFaces = r3, r3)
          for (var a4 = 0; a4 < r3.length; ++a4) {
            var o4 = r3[a4], s4 = o4.src.find(function(t5) {
              return t5.format === "truetype";
            });
            s4 && e3.addFont(s4.url, o4.ref.name, o4.ref.style);
          }
        return i4.windowHeight = i4.windowHeight || 0, i4.windowHeight = i4.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i4.windowHeight, t4(this.prop.container, i4);
      }).then(function(t4) {
        (this.opt.html2canvas.onrendered || function() {
        })(t4), this.prop.canvas = t4, document.body.removeChild(this.prop.overlay);
      });
    }, s3.prototype.toImg = function() {
      return this.thenList([function() {
        return this.prop.canvas || this.toCanvas();
      }]).then(function() {
        var t3 = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
        this.prop.img = document.createElement("img"), this.prop.img.src = t3;
      });
    }, s3.prototype.toPdf = function() {
      return this.thenList([function() {
        return this.toContext2d();
      }]).then(function() {
        this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
      });
    }, s3.prototype.output = function(t3, e3, r3) {
      return (r3 = r3 || "pdf").toLowerCase() === "img" || r3.toLowerCase() === "image" ? this.outputImg(t3, e3) : this.outputPdf(t3, e3);
    }, s3.prototype.outputPdf = function(t3, e3) {
      return this.thenList([function() {
        return this.prop.pdf || this.toPdf();
      }]).then(function() {
        return this.prop.pdf.output(t3, e3);
      });
    }, s3.prototype.outputImg = function(t3) {
      return this.thenList([function() {
        return this.prop.img || this.toImg();
      }]).then(function() {
        switch (t3) {
          case void 0:
          case "img":
            return this.prop.img;
          case "datauristring":
          case "dataurlstring":
            return this.prop.img.src;
          case "datauri":
          case "dataurl":
            return document.location.href = this.prop.img.src;
          default:
            throw 'Image output type "' + t3 + '" is not supported.';
        }
      });
    }, s3.prototype.save = function(t3) {
      return this.thenList([function() {
        return this.prop.pdf || this.toPdf();
      }]).set(t3 ? { filename: t3 } : null).then(function() {
        this.prop.pdf.save(this.opt.filename);
      });
    }, s3.prototype.doCallback = function() {
      return this.thenList([function() {
        return this.prop.pdf || this.toPdf();
      }]).then(function() {
        this.prop.callback(this.prop.pdf);
      });
    }, s3.prototype.set = function(t3) {
      if (a3(t3) !== "object")
        return this;
      var e3 = Object.keys(t3 || {}).map(function(e4) {
        if (e4 in s3.template.prop)
          return function() {
            this.prop[e4] = t3[e4];
          };
        switch (e4) {
          case "margin":
            return this.setMargin.bind(this, t3.margin);
          case "jsPDF":
            return function() {
              return this.opt.jsPDF = t3.jsPDF, this.setPageSize();
            };
          case "pageSize":
            return this.setPageSize.bind(this, t3.pageSize);
          default:
            return function() {
              this.opt[e4] = t3[e4];
            };
        }
      }, this);
      return this.then(function() {
        return this.thenList(e3);
      });
    }, s3.prototype.get = function(t3, e3) {
      return this.then(function() {
        var r3 = t3 in s3.template.prop ? this.prop[t3] : this.opt[t3];
        return e3 ? e3(r3) : r3;
      });
    }, s3.prototype.setMargin = function(t3) {
      return this.then(function() {
        switch (a3(t3)) {
          case "number":
            t3 = [t3, t3, t3, t3];
          case "array":
            if (t3.length === 2 && (t3 = [t3[0], t3[1], t3[0], t3[1]]), t3.length === 4)
              break;
          default:
            return this.error("Invalid margin array.");
        }
        this.opt.margin = t3;
      }).then(this.setPageSize);
    }, s3.prototype.setPageSize = function(t3) {
      function e3(t4, e4) {
        return Math.floor(t4 * e4 / 72 * 96);
      }
      return this.then(function() {
        (t3 = t3 || M.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t3.inner = { width: t3.width - this.opt.margin[1] - this.opt.margin[3], height: t3.height - this.opt.margin[0] - this.opt.margin[2] }, t3.inner.px = { width: e3(t3.inner.width, t3.k), height: e3(t3.inner.height, t3.k) }, t3.inner.ratio = t3.inner.height / t3.inner.width), this.prop.pageSize = t3;
      });
    }, s3.prototype.setProgress = function(t3, e3, r3, n3) {
      return t3 != null && (this.progress.val = t3), e3 != null && (this.progress.state = e3), r3 != null && (this.progress.n = r3), n3 != null && (this.progress.stack = n3), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s3.prototype.updateProgress = function(t3, e3, r3, n3) {
      return this.setProgress(t3 ? this.progress.val + t3 : null, e3 || null, r3 ? this.progress.n + r3 : null, n3 ? this.progress.stack.concat(n3) : null);
    }, s3.prototype.then = function(t3, e3) {
      var r3 = this;
      return this.thenCore(t3, e3, function(t4, e4) {
        return r3.updateProgress(null, null, 1, [t4]), Promise.prototype.then.call(this, function(e5) {
          return r3.updateProgress(null, t4), e5;
        }).then(t4, e4).then(function(t5) {
          return r3.updateProgress(1), t5;
        });
      });
    }, s3.prototype.thenCore = function(t3, e3, r3) {
      r3 = r3 || Promise.prototype.then;
      t3 && (t3 = t3.bind(this)), e3 && (e3 = e3.bind(this));
      var n3 = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? this : s3.convert(Object.assign({}, this), Promise.prototype), i4 = r3.call(n3, t3, e3);
      return s3.convert(i4, this.__proto__);
    }, s3.prototype.thenExternal = function(t3, e3) {
      return Promise.prototype.then.call(this, t3, e3);
    }, s3.prototype.thenList = function(t3) {
      var e3 = this;
      return t3.forEach(function(t4) {
        e3 = e3.thenCore(t4);
      }), e3;
    }, s3.prototype.catch = function(t3) {
      t3 && (t3 = t3.bind(this));
      var e3 = Promise.prototype.catch.call(this, t3);
      return s3.convert(e3, this);
    }, s3.prototype.catchExternal = function(t3) {
      return Promise.prototype.catch.call(this, t3);
    }, s3.prototype.error = function(t3) {
      return this.then(function() {
        throw new Error(t3);
      });
    }, s3.prototype.using = s3.prototype.set, s3.prototype.saveAs = s3.prototype.save, s3.prototype.export = s3.prototype.output, s3.prototype.run = s3.prototype.then, M.getPageSize = function(e3, r3, n3) {
      if (_typeof(e3) === "object") {
        var i4 = e3;
        e3 = i4.orientation, r3 = i4.unit || r3, n3 = i4.format || n3;
      }
      r3 = r3 || "mm", n3 = n3 || "a4", e3 = ("" + (e3 || "P")).toLowerCase();
      var a4, o4 = ("" + n3).toLowerCase(), s4 = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
      switch (r3) {
        case "pt":
          a4 = 1;
          break;
        case "mm":
          a4 = 72 / 25.4;
          break;
        case "cm":
          a4 = 72 / 2.54;
          break;
        case "in":
          a4 = 72;
          break;
        case "px":
          a4 = 0.75;
          break;
        case "pc":
        case "em":
          a4 = 12;
          break;
        case "ex":
          a4 = 6;
          break;
        default:
          throw "Invalid unit: " + r3;
      }
      var c4, u3 = 0, h4 = 0;
      if (s4.hasOwnProperty(o4))
        u3 = s4[o4][1] / a4, h4 = s4[o4][0] / a4;
      else
        try {
          u3 = n3[1], h4 = n3[0];
        } catch (t3) {
          throw new Error("Invalid format: " + n3);
        }
      if (e3 === "p" || e3 === "portrait")
        e3 = "p", h4 > u3 && (c4 = h4, h4 = u3, u3 = c4);
      else {
        if (e3 !== "l" && e3 !== "landscape")
          throw "Invalid orientation: " + e3;
        e3 = "l", u3 > h4 && (c4 = h4, h4 = u3, u3 = c4);
      }
      return { width: h4, height: u3, unit: r3, k: a4, orientation: e3 };
    }, e2.html = function(t3, e3) {
      (e3 = e3 || {}).callback = e3.callback || function() {
      }, e3.html2canvas = e3.html2canvas || {}, e3.html2canvas.canvas = e3.html2canvas.canvas || this.canvas, e3.jsPDF = e3.jsPDF || this, e3.fontFaces = e3.fontFaces ? e3.fontFaces.map(jt) : null;
      var r3 = new s3(e3);
      return e3.worker ? r3 : r3.from(t3).doCallback();
    };
  }(M.API), M.API.addJS = function(t3) {
    return Ht = t3, this.internal.events.subscribe("postPutResources", function() {
      Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
      Ut !== void 0 && zt !== void 0 && this.internal.out("/Names <</JavaScript " + Ut + " 0 R>>");
    }), this;
  }, function(t3) {
    var e2;
    t3.events.push(["postPutResources", function() {
      var t4 = this, r2 = /^(\d+) 0 obj$/;
      if (this.outline.root.children.length > 0)
        for (var n3 = t4.outline.render().split(/\r\n/), i3 = 0; i3 < n3.length; i3++) {
          var a3 = n3[i3], o3 = r2.exec(a3);
          if (o3 != null) {
            var s3 = o3[1];
            t4.internal.newObjectDeferredBegin(s3, false);
          }
          t4.internal.write(a3);
        }
      if (this.outline.createNamedDestinations) {
        var c4 = this.internal.pages.length, u3 = [];
        for (i3 = 0; i3 < c4; i3++) {
          var h4 = t4.internal.newObject();
          u3.push(h4);
          var l3 = t4.internal.getPageInfo(i3 + 1);
          t4.internal.write("<< /D[" + l3.objId + " 0 R /XYZ null null null]>> endobj");
        }
        var f3 = t4.internal.newObject();
        t4.internal.write("<< /Names [ ");
        for (i3 = 0; i3 < u3.length; i3++)
          t4.internal.write("(page_" + (i3 + 1) + ")" + u3[i3] + " 0 R");
        t4.internal.write(" ] >>", "endobj"), e2 = t4.internal.newObject(), t4.internal.write("<< /Dests " + f3 + " 0 R"), t4.internal.write(">>", "endobj");
      }
    }]), t3.events.push(["putCatalog", function() {
      this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e2 + " 0 R"));
    }]), t3.events.push(["initialized", function() {
      var t4 = this;
      t4.outline = { createNamedDestinations: false, root: { children: [] } }, t4.outline.add = function(t5, e3, r2) {
        var n3 = { title: e3, options: r2, children: [] };
        return t5 == null && (t5 = this.root), t5.children.push(n3), n3;
      }, t4.outline.render = function() {
        return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t4, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
      }, t4.outline.genIds_r = function(e3) {
        e3.id = t4.internal.newObjectDeferred();
        for (var r2 = 0; r2 < e3.children.length; r2++)
          this.genIds_r(e3.children[r2]);
      }, t4.outline.renderRoot = function(t5) {
        this.objStart(t5), this.line("/Type /Outlines"), t5.children.length > 0 && (this.line("/First " + this.makeRef(t5.children[0])), this.line("/Last " + this.makeRef(t5.children[t5.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, t5)), this.objEnd();
      }, t4.outline.renderItems = function(e3) {
        for (var r2 = this.ctx.pdf.internal.getVerticalCoordinateString, n3 = 0; n3 < e3.children.length; n3++) {
          var i3 = e3.children[n3];
          this.objStart(i3), this.line("/Title " + this.makeString(i3.title)), this.line("/Parent " + this.makeRef(e3)), n3 > 0 && this.line("/Prev " + this.makeRef(e3.children[n3 - 1])), n3 < e3.children.length - 1 && this.line("/Next " + this.makeRef(e3.children[n3 + 1])), i3.children.length > 0 && (this.line("/First " + this.makeRef(i3.children[0])), this.line("/Last " + this.makeRef(i3.children[i3.children.length - 1])));
          var a3 = this.count = this.count_r({ count: 0 }, i3);
          if (a3 > 0 && this.line("/Count " + a3), i3.options && i3.options.pageNumber) {
            var o3 = t4.internal.getPageInfo(i3.options.pageNumber);
            this.line("/Dest [" + o3.objId + " 0 R /XYZ 0 " + r2(0) + " 0]");
          }
          this.objEnd();
        }
        for (var s3 = 0; s3 < e3.children.length; s3++)
          this.renderItems(e3.children[s3]);
      }, t4.outline.line = function(t5) {
        this.ctx.val += t5 + "\r\n";
      }, t4.outline.makeRef = function(t5) {
        return t5.id + " 0 R";
      }, t4.outline.makeString = function(e3) {
        return "(" + t4.internal.pdfEscape(e3) + ")";
      }, t4.outline.objStart = function(t5) {
        this.ctx.val += "\r\n" + t5.id + " 0 obj\r\n<<\r\n";
      }, t4.outline.objEnd = function() {
        this.ctx.val += ">> \r\nendobj\r\n";
      }, t4.outline.count_r = function(t5, e3) {
        for (var r2 = 0; r2 < e3.children.length; r2++)
          t5.count++, this.count_r(t5, e3.children[r2]);
        return t5.count;
      };
    }]);
  }(M.API), function(t3) {
    var e2 = [192, 193, 194, 195, 196, 197, 198, 199];
    t3.processJPEG = function(t4, r2, n3, i3, a3, o3) {
      var s3, c4 = this.decode.DCT_DECODE, u3 = null;
      if (typeof t4 == "string" || this.__addimage__.isArrayBuffer(t4) || this.__addimage__.isArrayBufferView(t4)) {
        switch (t4 = a3 || t4, t4 = this.__addimage__.isArrayBuffer(t4) ? new Uint8Array(t4) : t4, (s3 = function(t5) {
          for (var r3, n4 = 256 * t5.charCodeAt(4) + t5.charCodeAt(5), i4 = t5.length, a4 = { width: 0, height: 0, numcomponents: 1 }, o4 = 4; o4 < i4; o4 += 2) {
            if (o4 += n4, e2.indexOf(t5.charCodeAt(o4 + 1)) !== -1) {
              r3 = 256 * t5.charCodeAt(o4 + 5) + t5.charCodeAt(o4 + 6), a4 = { width: 256 * t5.charCodeAt(o4 + 7) + t5.charCodeAt(o4 + 8), height: r3, numcomponents: t5.charCodeAt(o4 + 9) };
              break;
            }
            n4 = 256 * t5.charCodeAt(o4 + 2) + t5.charCodeAt(o4 + 3);
          }
          return a4;
        }(t4 = this.__addimage__.isArrayBufferView(t4) ? this.__addimage__.arrayBufferToBinaryString(t4) : t4)).numcomponents) {
          case 1:
            o3 = this.color_spaces.DEVICE_GRAY;
            break;
          case 4:
            o3 = this.color_spaces.DEVICE_CMYK;
            break;
          case 3:
            o3 = this.color_spaces.DEVICE_RGB;
        }
        u3 = { data: t4, width: s3.width, height: s3.height, colorSpace: o3, bitsPerComponent: 8, filter: c4, index: r2, alias: n3 };
      }
      return u3;
    };
  }(M.API);
  var Vt;
  var Gt;
  var Yt;
  var Jt;
  var Xt;
  var Kt = function() {
    var t3, e2, i3;
    function a3(t4) {
      var e3, r2, n3, i4, a4, o4, s3, c4, u3, h4, l3, f3, d2, p4;
      for (this.data = t4, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o4 = null; ; ) {
        switch (e3 = this.readUInt32(), u3 = function() {
          var t5, e4;
          for (e4 = [], t5 = 0; t5 < 4; ++t5)
            e4.push(String.fromCharCode(this.data[this.pos++]));
          return e4;
        }.call(this).join("")) {
          case "IHDR":
            this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
            break;
          case "acTL":
            this.animation = { numFrames: this.readUInt32(), numPlays: this.readUInt32() || 1 / 0, frames: [] };
            break;
          case "PLTE":
            this.palette = this.read(e3);
            break;
          case "fcTL":
            o4 && this.animation.frames.push(o4), this.pos += 4, o4 = { width: this.readUInt32(), height: this.readUInt32(), xOffset: this.readUInt32(), yOffset: this.readUInt32() }, a4 = this.readUInt16(), i4 = this.readUInt16() || 100, o4.delay = 1e3 * a4 / i4, o4.disposeOp = this.data[this.pos++], o4.blendOp = this.data[this.pos++], o4.data = [];
            break;
          case "IDAT":
          case "fdAT":
            for (u3 === "fdAT" && (this.pos += 4, e3 -= 4), t4 = (o4 != null ? o4.data : void 0) || this.imgData, f3 = 0; 0 <= e3 ? f3 < e3 : f3 > e3; 0 <= e3 ? ++f3 : --f3)
              t4.push(this.data[this.pos++]);
            break;
          case "tRNS":
            switch (this.transparency = {}, this.colorType) {
              case 3:
                if (n3 = this.palette.length / 3, this.transparency.indexed = this.read(e3), this.transparency.indexed.length > n3)
                  throw new Error("More transparent colors than palette size");
                if ((h4 = n3 - this.transparency.indexed.length) > 0)
                  for (d2 = 0; 0 <= h4 ? d2 < h4 : d2 > h4; 0 <= h4 ? ++d2 : --d2)
                    this.transparency.indexed.push(255);
                break;
              case 0:
                this.transparency.grayscale = this.read(e3)[0];
                break;
              case 2:
                this.transparency.rgb = this.read(e3);
            }
            break;
          case "tEXt":
            s3 = (l3 = this.read(e3)).indexOf(0), c4 = String.fromCharCode.apply(String, l3.slice(0, s3)), this.text[c4] = String.fromCharCode.apply(String, l3.slice(s3 + 1));
            break;
          case "IEND":
            return o4 && this.animation.frames.push(o4), this.colors = function() {
              switch (this.colorType) {
                case 0:
                case 3:
                case 4:
                  return 1;
                case 2:
                case 6:
                  return 3;
              }
            }.call(this), this.hasAlphaChannel = (p4 = this.colorType) === 4 || p4 === 6, r2 = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r2, this.colorSpace = function() {
              switch (this.colors) {
                case 1:
                  return "DeviceGray";
                case 3:
                  return "DeviceRGB";
              }
            }.call(this), void (this.imgData = new Uint8Array(this.imgData));
          default:
            this.pos += e3;
        }
        if (this.pos += 4, this.pos > this.data.length)
          throw new Error("Incomplete or corrupt PNG file");
      }
    }
    a3.prototype.read = function(t4) {
      var e3, r2;
      for (r2 = [], e3 = 0; 0 <= t4 ? e3 < t4 : e3 > t4; 0 <= t4 ? ++e3 : --e3)
        r2.push(this.data[this.pos++]);
      return r2;
    }, a3.prototype.readUInt32 = function() {
      return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a3.prototype.readUInt16 = function() {
      return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a3.prototype.decodePixels = function(t4) {
      var e3 = this.pixelBitlength / 8, n3 = new Uint8Array(this.width * this.height * e3), i4 = 0, a4 = this;
      if (t4 == null && (t4 = this.imgData), t4.length === 0)
        return new Uint8Array(0);
      function o4(r2, o5, s3, c4) {
        var u3, h4, l3, f3, d2, p4, g2, m4, v3, b2, y3, w2, N3, L2, A2, x2, S2, _3, P2, k2, I2, F2 = Math.ceil((a4.width - r2) / s3), C2 = Math.ceil((a4.height - o5) / c4), j2 = a4.width == F2 && a4.height == C2;
        for (L2 = e3 * F2, w2 = j2 ? n3 : new Uint8Array(L2 * C2), p4 = t4.length, N3 = 0, h4 = 0; N3 < C2 && i4 < p4; ) {
          switch (t4[i4++]) {
            case 0:
              for (f3 = S2 = 0; S2 < L2; f3 = S2 += 1)
                w2[h4++] = t4[i4++];
              break;
            case 1:
              for (f3 = _3 = 0; _3 < L2; f3 = _3 += 1)
                u3 = t4[i4++], d2 = f3 < e3 ? 0 : w2[h4 - e3], w2[h4++] = (u3 + d2) % 256;
              break;
            case 2:
              for (f3 = P2 = 0; P2 < L2; f3 = P2 += 1)
                u3 = t4[i4++], l3 = (f3 - f3 % e3) / e3, A2 = N3 && w2[(N3 - 1) * L2 + l3 * e3 + f3 % e3], w2[h4++] = (A2 + u3) % 256;
              break;
            case 3:
              for (f3 = k2 = 0; k2 < L2; f3 = k2 += 1)
                u3 = t4[i4++], l3 = (f3 - f3 % e3) / e3, d2 = f3 < e3 ? 0 : w2[h4 - e3], A2 = N3 && w2[(N3 - 1) * L2 + l3 * e3 + f3 % e3], w2[h4++] = (u3 + Math.floor((d2 + A2) / 2)) % 256;
              break;
            case 4:
              for (f3 = I2 = 0; I2 < L2; f3 = I2 += 1)
                u3 = t4[i4++], l3 = (f3 - f3 % e3) / e3, d2 = f3 < e3 ? 0 : w2[h4 - e3], N3 === 0 ? A2 = x2 = 0 : (A2 = w2[(N3 - 1) * L2 + l3 * e3 + f3 % e3], x2 = l3 && w2[(N3 - 1) * L2 + (l3 - 1) * e3 + f3 % e3]), g2 = d2 + A2 - x2, m4 = Math.abs(g2 - d2), b2 = Math.abs(g2 - A2), y3 = Math.abs(g2 - x2), v3 = m4 <= b2 && m4 <= y3 ? d2 : b2 <= y3 ? A2 : x2, w2[h4++] = (u3 + v3) % 256;
              break;
            default:
              throw new Error("Invalid filter algorithm: " + t4[i4 - 1]);
          }
          if (!j2) {
            var O3 = ((o5 + N3 * c4) * a4.width + r2) * e3, B2 = N3 * L2;
            for (f3 = 0; f3 < F2; f3 += 1) {
              for (var E2 = 0; E2 < e3; E2 += 1)
                n3[O3++] = w2[B2++];
              O3 += (s3 - 1) * e3;
            }
          }
          N3++;
        }
      }
      return t4 = unzlibSync(t4), a4.interlaceMethod == 1 ? (o4(0, 0, 8, 8), o4(4, 0, 8, 8), o4(0, 4, 4, 8), o4(2, 0, 4, 4), o4(0, 2, 2, 4), o4(1, 0, 2, 2), o4(0, 1, 1, 2)) : o4(0, 0, 1, 1), n3;
    }, a3.prototype.decodePalette = function() {
      var t4, e3, r2, n3, i4, a4, o4, s3, c4;
      for (r2 = this.palette, a4 = this.transparency.indexed || [], i4 = new Uint8Array((a4.length || 0) + r2.length), n3 = 0, t4 = 0, e3 = o4 = 0, s3 = r2.length; o4 < s3; e3 = o4 += 3)
        i4[n3++] = r2[e3], i4[n3++] = r2[e3 + 1], i4[n3++] = r2[e3 + 2], i4[n3++] = (c4 = a4[t4++]) != null ? c4 : 255;
      return i4;
    }, a3.prototype.copyToImageData = function(t4, e3) {
      var r2, n3, i4, a4, o4, s3, c4, u3, h4, l3, f3;
      if (n3 = this.colors, h4 = null, r2 = this.hasAlphaChannel, this.palette.length && (h4 = (f3 = this._decodedPalette) != null ? f3 : this._decodedPalette = this.decodePalette(), n3 = 4, r2 = true), u3 = (i4 = t4.data || t4).length, o4 = h4 || e3, a4 = s3 = 0, n3 === 1)
        for (; a4 < u3; )
          c4 = h4 ? 4 * e3[a4 / 4] : s3, l3 = o4[c4++], i4[a4++] = l3, i4[a4++] = l3, i4[a4++] = l3, i4[a4++] = r2 ? o4[c4++] : 255, s3 = c4;
      else
        for (; a4 < u3; )
          c4 = h4 ? 4 * e3[a4 / 4] : s3, i4[a4++] = o4[c4++], i4[a4++] = o4[c4++], i4[a4++] = o4[c4++], i4[a4++] = r2 ? o4[c4++] : 255, s3 = c4;
    }, a3.prototype.decode = function() {
      var t4;
      return t4 = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t4, this.decodePixels()), t4;
    };
    var o3 = function() {
      if (Object.prototype.toString.call(n2) === "[object Window]") {
        try {
          e2 = n2.document.createElement("canvas"), i3 = e2.getContext("2d");
        } catch (t4) {
          return false;
        }
        return true;
      }
      return false;
    };
    return o3(), t3 = function(t4) {
      var r2;
      if (o3() === true)
        return i3.width = t4.width, i3.height = t4.height, i3.clearRect(0, 0, t4.width, t4.height), i3.putImageData(t4, 0, 0), (r2 = new Image()).src = e2.toDataURL(), r2;
      throw new Error("This method requires a Browser with Canvas-capability.");
    }, a3.prototype.decodeFrames = function(e3) {
      var r2, n3, i4, a4, o4, s3, c4, u3;
      if (this.animation) {
        for (u3 = [], n3 = o4 = 0, s3 = (c4 = this.animation.frames).length; o4 < s3; n3 = ++o4)
          r2 = c4[n3], i4 = e3.createImageData(r2.width, r2.height), a4 = this.decodePixels(new Uint8Array(r2.data)), this.copyToImageData(i4, a4), r2.imageData = i4, u3.push(r2.image = t3(i4));
        return u3;
      }
    }, a3.prototype.renderFrame = function(t4, e3) {
      var r2, n3, i4;
      return r2 = (n3 = this.animation.frames)[e3], i4 = n3[e3 - 1], e3 === 0 && t4.clearRect(0, 0, this.width, this.height), (i4 != null ? i4.disposeOp : void 0) === 1 ? t4.clearRect(i4.xOffset, i4.yOffset, i4.width, i4.height) : (i4 != null ? i4.disposeOp : void 0) === 2 && t4.putImageData(i4.imageData, i4.xOffset, i4.yOffset), r2.blendOp === 0 && t4.clearRect(r2.xOffset, r2.yOffset, r2.width, r2.height), t4.drawImage(r2.image, r2.xOffset, r2.yOffset);
    }, a3.prototype.animate = function(t4) {
      var e3, r2, n3, i4, a4, o4, s3 = this;
      return r2 = 0, o4 = this.animation, i4 = o4.numFrames, n3 = o4.frames, a4 = o4.numPlays, (e3 = function() {
        var o5, c4;
        if (o5 = r2++ % i4, c4 = n3[o5], s3.renderFrame(t4, o5), i4 > 1 && r2 / i4 < a4)
          return s3.animation._timeout = setTimeout(e3, c4.delay);
      })();
    }, a3.prototype.stopAnimation = function() {
      var t4;
      return clearTimeout((t4 = this.animation) != null ? t4._timeout : void 0);
    }, a3.prototype.render = function(t4) {
      var e3, r2;
      return t4._png && t4._png.stopAnimation(), t4._png = this, t4.width = this.width, t4.height = this.height, e3 = t4.getContext("2d"), this.animation ? (this.decodeFrames(e3), this.animate(e3)) : (r2 = e3.createImageData(this.width, this.height), this.copyToImageData(r2, this.decodePixels()), e3.putImageData(r2, 0, 0));
    }, a3;
  }();
  function Zt(t3) {
    var e2 = 0;
    if (t3[e2++] !== 71 || t3[e2++] !== 73 || t3[e2++] !== 70 || t3[e2++] !== 56 || (t3[e2++] + 1 & 253) != 56 || t3[e2++] !== 97)
      throw new Error("Invalid GIF 87a/89a header.");
    var r2 = t3[e2++] | t3[e2++] << 8, n3 = t3[e2++] | t3[e2++] << 8, i3 = t3[e2++], a3 = i3 >> 7, o3 = 1 << (7 & i3) + 1;
    t3[e2++];
    t3[e2++];
    var s3 = null, c4 = null;
    a3 && (s3 = e2, c4 = o3, e2 += 3 * o3);
    var u3 = true, h4 = [], l3 = 0, f3 = null, d2 = 0, p4 = null;
    for (this.width = r2, this.height = n3; u3 && e2 < t3.length; )
      switch (t3[e2++]) {
        case 33:
          switch (t3[e2++]) {
            case 255:
              if (t3[e2] !== 11 || t3[e2 + 1] == 78 && t3[e2 + 2] == 69 && t3[e2 + 3] == 84 && t3[e2 + 4] == 83 && t3[e2 + 5] == 67 && t3[e2 + 6] == 65 && t3[e2 + 7] == 80 && t3[e2 + 8] == 69 && t3[e2 + 9] == 50 && t3[e2 + 10] == 46 && t3[e2 + 11] == 48 && t3[e2 + 12] == 3 && t3[e2 + 13] == 1 && t3[e2 + 16] == 0)
                e2 += 14, p4 = t3[e2++] | t3[e2++] << 8, e2++;
              else
                for (e2 += 12; ; ) {
                  if (!((P2 = t3[e2++]) >= 0))
                    throw Error("Invalid block size");
                  if (P2 === 0)
                    break;
                  e2 += P2;
                }
              break;
            case 249:
              if (t3[e2++] !== 4 || t3[e2 + 4] !== 0)
                throw new Error("Invalid graphics extension block.");
              var g2 = t3[e2++];
              l3 = t3[e2++] | t3[e2++] << 8, f3 = t3[e2++], (1 & g2) == 0 && (f3 = null), d2 = g2 >> 2 & 7, e2++;
              break;
            case 254:
              for (; ; ) {
                if (!((P2 = t3[e2++]) >= 0))
                  throw Error("Invalid block size");
                if (P2 === 0)
                  break;
                e2 += P2;
              }
              break;
            default:
              throw new Error("Unknown graphic control label: 0x" + t3[e2 - 1].toString(16));
          }
          break;
        case 44:
          var m4 = t3[e2++] | t3[e2++] << 8, v3 = t3[e2++] | t3[e2++] << 8, b2 = t3[e2++] | t3[e2++] << 8, y3 = t3[e2++] | t3[e2++] << 8, w2 = t3[e2++], N3 = w2 >> 6 & 1, L2 = 1 << (7 & w2) + 1, A2 = s3, x2 = c4, S2 = false;
          if (w2 >> 7) {
            S2 = true;
            A2 = e2, x2 = L2, e2 += 3 * L2;
          }
          var _3 = e2;
          for (e2++; ; ) {
            var P2;
            if (!((P2 = t3[e2++]) >= 0))
              throw Error("Invalid block size");
            if (P2 === 0)
              break;
            e2 += P2;
          }
          h4.push({ x: m4, y: v3, width: b2, height: y3, has_local_palette: S2, palette_offset: A2, palette_size: x2, data_offset: _3, data_length: e2 - _3, transparent_index: f3, interlaced: !!N3, delay: l3, disposal: d2 });
          break;
        case 59:
          u3 = false;
          break;
        default:
          throw new Error("Unknown gif block: 0x" + t3[e2 - 1].toString(16));
      }
    this.numFrames = function() {
      return h4.length;
    }, this.loopCount = function() {
      return p4;
    }, this.frameInfo = function(t4) {
      if (t4 < 0 || t4 >= h4.length)
        throw new Error("Frame index out of range.");
      return h4[t4];
    }, this.decodeAndBlitFrameBGRA = function(e3, n4) {
      var i4 = this.frameInfo(e3), a4 = i4.width * i4.height, o4 = new Uint8Array(a4);
      $t(t3, i4.data_offset, o4, a4);
      var s4 = i4.palette_offset, c5 = i4.transparent_index;
      c5 === null && (c5 = 256);
      var u4 = i4.width, h5 = r2 - u4, l4 = u4, f4 = 4 * (i4.y * r2 + i4.x), d3 = 4 * ((i4.y + i4.height) * r2 + i4.x), p5 = f4, g3 = 4 * h5;
      i4.interlaced === true && (g3 += 4 * r2 * 7);
      for (var m5 = 8, v4 = 0, b3 = o4.length; v4 < b3; ++v4) {
        var y4 = o4[v4];
        if (l4 === 0 && (l4 = u4, (p5 += g3) >= d3 && (g3 = 4 * h5 + 4 * r2 * (m5 - 1), p5 = f4 + (u4 + h5) * (m5 << 1), m5 >>= 1)), y4 === c5)
          p5 += 4;
        else {
          var w3 = t3[s4 + 3 * y4], N4 = t3[s4 + 3 * y4 + 1], L3 = t3[s4 + 3 * y4 + 2];
          n4[p5++] = L3, n4[p5++] = N4, n4[p5++] = w3, n4[p5++] = 255;
        }
        --l4;
      }
    }, this.decodeAndBlitFrameRGBA = function(e3, n4) {
      var i4 = this.frameInfo(e3), a4 = i4.width * i4.height, o4 = new Uint8Array(a4);
      $t(t3, i4.data_offset, o4, a4);
      var s4 = i4.palette_offset, c5 = i4.transparent_index;
      c5 === null && (c5 = 256);
      var u4 = i4.width, h5 = r2 - u4, l4 = u4, f4 = 4 * (i4.y * r2 + i4.x), d3 = 4 * ((i4.y + i4.height) * r2 + i4.x), p5 = f4, g3 = 4 * h5;
      i4.interlaced === true && (g3 += 4 * r2 * 7);
      for (var m5 = 8, v4 = 0, b3 = o4.length; v4 < b3; ++v4) {
        var y4 = o4[v4];
        if (l4 === 0 && (l4 = u4, (p5 += g3) >= d3 && (g3 = 4 * h5 + 4 * r2 * (m5 - 1), p5 = f4 + (u4 + h5) * (m5 << 1), m5 >>= 1)), y4 === c5)
          p5 += 4;
        else {
          var w3 = t3[s4 + 3 * y4], N4 = t3[s4 + 3 * y4 + 1], L3 = t3[s4 + 3 * y4 + 2];
          n4[p5++] = w3, n4[p5++] = N4, n4[p5++] = L3, n4[p5++] = 255;
        }
        --l4;
      }
    };
  }
  function $t(t3, e2, r2, n3) {
    for (var i3 = t3[e2++], o3 = 1 << i3, s3 = o3 + 1, c4 = s3 + 1, u3 = i3 + 1, h4 = (1 << u3) - 1, l3 = 0, f3 = 0, d2 = 0, p4 = t3[e2++], g2 = new Int32Array(4096), m4 = null; ; ) {
      for (; l3 < 16 && p4 !== 0; )
        f3 |= t3[e2++] << l3, l3 += 8, p4 === 1 ? p4 = t3[e2++] : --p4;
      if (l3 < u3)
        break;
      var v3 = f3 & h4;
      if (f3 >>= u3, l3 -= u3, v3 !== o3) {
        if (v3 === s3)
          break;
        for (var b2 = v3 < c4 ? v3 : m4, y3 = 0, w2 = b2; w2 > o3; )
          w2 = g2[w2] >> 8, ++y3;
        var N3 = w2;
        if (d2 + y3 + (b2 !== v3 ? 1 : 0) > n3)
          return void a2.log("Warning, gif stream longer than expected.");
        r2[d2++] = N3;
        var L2 = d2 += y3;
        for (b2 !== v3 && (r2[d2++] = N3), w2 = b2; y3--; )
          w2 = g2[w2], r2[--L2] = 255 & w2, w2 >>= 8;
        m4 !== null && c4 < 4096 && (g2[c4++] = m4 << 8 | N3, c4 >= h4 + 1 && u3 < 12 && (++u3, h4 = h4 << 1 | 1)), m4 = v3;
      } else
        c4 = s3 + 1, h4 = (1 << (u3 = i3 + 1)) - 1, m4 = null;
    }
    return d2 !== n3 && a2.log("Warning, gif stream shorter than expected."), r2;
  }
  function Qt(t3) {
    var e2, r2, n3, i3, a3, o3 = Math.floor, s3 = new Array(64), c4 = new Array(64), u3 = new Array(64), h4 = new Array(64), l3 = new Array(65535), f3 = new Array(65535), d2 = new Array(64), p4 = new Array(64), g2 = [], m4 = 0, v3 = 7, b2 = new Array(64), y3 = new Array(64), w2 = new Array(64), N3 = new Array(256), L2 = new Array(2048), A2 = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], x2 = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], S2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], _3 = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], P2 = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], k2 = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], I2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], F2 = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], C2 = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
    function j2(t4, e3) {
      for (var r3 = 0, n4 = 0, i4 = new Array(), a4 = 1; a4 <= 16; a4++) {
        for (var o4 = 1; o4 <= t4[a4]; o4++)
          i4[e3[n4]] = [], i4[e3[n4]][0] = r3, i4[e3[n4]][1] = a4, n4++, r3++;
        r3 *= 2;
      }
      return i4;
    }
    function O3(t4) {
      for (var e3 = t4[0], r3 = t4[1] - 1; r3 >= 0; )
        e3 & 1 << r3 && (m4 |= 1 << v3), r3--, --v3 < 0 && (m4 == 255 ? (B2(255), B2(0)) : B2(m4), v3 = 7, m4 = 0);
    }
    function B2(t4) {
      g2.push(t4);
    }
    function E2(t4) {
      B2(t4 >> 8 & 255), B2(255 & t4);
    }
    function M2(t4, e3, r3, n4, i4) {
      for (var a4, o4 = i4[0], s4 = i4[240], c5 = function(t5, e4) {
        var r4, n5, i5, a5, o5, s5, c6, u5, h6, l4, f4 = 0;
        for (h6 = 0; h6 < 8; ++h6) {
          r4 = t5[f4], n5 = t5[f4 + 1], i5 = t5[f4 + 2], a5 = t5[f4 + 3], o5 = t5[f4 + 4], s5 = t5[f4 + 5], c6 = t5[f4 + 6];
          var p5 = r4 + (u5 = t5[f4 + 7]), g4 = r4 - u5, m6 = n5 + c6, v5 = n5 - c6, b4 = i5 + s5, y5 = i5 - s5, w4 = a5 + o5, N4 = a5 - o5, L3 = p5 + w4, A3 = p5 - w4, x3 = m6 + b4, S3 = m6 - b4;
          t5[f4] = L3 + x3, t5[f4 + 4] = L3 - x3;
          var _4 = 0.707106781 * (S3 + A3);
          t5[f4 + 2] = A3 + _4, t5[f4 + 6] = A3 - _4;
          var P3 = 0.382683433 * ((L3 = N4 + y5) - (S3 = v5 + g4)), k3 = 0.5411961 * L3 + P3, I3 = 1.306562965 * S3 + P3, F3 = 0.707106781 * (x3 = y5 + v5), C3 = g4 + F3, j3 = g4 - F3;
          t5[f4 + 5] = j3 + k3, t5[f4 + 3] = j3 - k3, t5[f4 + 1] = C3 + I3, t5[f4 + 7] = C3 - I3, f4 += 8;
        }
        for (f4 = 0, h6 = 0; h6 < 8; ++h6) {
          r4 = t5[f4], n5 = t5[f4 + 8], i5 = t5[f4 + 16], a5 = t5[f4 + 24], o5 = t5[f4 + 32], s5 = t5[f4 + 40], c6 = t5[f4 + 48];
          var O4 = r4 + (u5 = t5[f4 + 56]), B3 = r4 - u5, E3 = n5 + c6, M3 = n5 - c6, q3 = i5 + s5, D2 = i5 - s5, R2 = a5 + o5, T3 = a5 - o5, U2 = O4 + R2, z2 = O4 - R2, H2 = E3 + q3, W2 = E3 - q3;
          t5[f4] = U2 + H2, t5[f4 + 32] = U2 - H2;
          var V2 = 0.707106781 * (W2 + z2);
          t5[f4 + 16] = z2 + V2, t5[f4 + 48] = z2 - V2;
          var G2 = 0.382683433 * ((U2 = T3 + D2) - (W2 = M3 + B3)), Y2 = 0.5411961 * U2 + G2, J2 = 1.306562965 * W2 + G2, X2 = 0.707106781 * (H2 = D2 + M3), K2 = B3 + X2, Z2 = B3 - X2;
          t5[f4 + 40] = Z2 + Y2, t5[f4 + 24] = Z2 - Y2, t5[f4 + 8] = K2 + J2, t5[f4 + 56] = K2 - J2, f4++;
        }
        for (h6 = 0; h6 < 64; ++h6)
          l4 = t5[h6] * e4[h6], d2[h6] = l4 > 0 ? l4 + 0.5 | 0 : l4 - 0.5 | 0;
        return d2;
      }(t4, e3), u4 = 0; u4 < 64; ++u4)
        p4[A2[u4]] = c5[u4];
      var h5 = p4[0] - r3;
      r3 = p4[0], h5 == 0 ? O3(n4[0]) : (O3(n4[f3[a4 = 32767 + h5]]), O3(l3[a4]));
      for (var g3 = 63; g3 > 0 && p4[g3] == 0; )
        g3--;
      if (g3 == 0)
        return O3(o4), r3;
      for (var m5, v4 = 1; v4 <= g3; ) {
        for (var b3 = v4; p4[v4] == 0 && v4 <= g3; )
          ++v4;
        var y4 = v4 - b3;
        if (y4 >= 16) {
          m5 = y4 >> 4;
          for (var w3 = 1; w3 <= m5; ++w3)
            O3(s4);
          y4 &= 15;
        }
        a4 = 32767 + p4[v4], O3(i4[(y4 << 4) + f3[a4]]), O3(l3[a4]), v4++;
      }
      return g3 != 63 && O3(o4), r3;
    }
    function q2(t4) {
      (t4 = Math.min(Math.max(t4, 1), 100), a3 != t4) && (!function(t5) {
        for (var e3 = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], r3 = 0; r3 < 64; r3++) {
          var n4 = o3((e3[r3] * t5 + 50) / 100);
          n4 = Math.min(Math.max(n4, 1), 255), s3[A2[r3]] = n4;
        }
        for (var i4 = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], a4 = 0; a4 < 64; a4++) {
          var l4 = o3((i4[a4] * t5 + 50) / 100);
          l4 = Math.min(Math.max(l4, 1), 255), c4[A2[a4]] = l4;
        }
        for (var f4 = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], d3 = 0, p5 = 0; p5 < 8; p5++)
          for (var g3 = 0; g3 < 8; g3++)
            u3[d3] = 1 / (s3[A2[d3]] * f4[p5] * f4[g3] * 8), h4[d3] = 1 / (c4[A2[d3]] * f4[p5] * f4[g3] * 8), d3++;
      }(t4 < 50 ? Math.floor(5e3 / t4) : Math.floor(200 - 2 * t4)), a3 = t4);
    }
    this.encode = function(t4, a4) {
      a4 && q2(a4), g2 = new Array(), m4 = 0, v3 = 7, E2(65496), E2(65504), E2(16), B2(74), B2(70), B2(73), B2(70), B2(0), B2(1), B2(1), B2(0), E2(1), E2(1), B2(0), B2(0), function() {
        E2(65499), E2(132), B2(0);
        for (var t5 = 0; t5 < 64; t5++)
          B2(s3[t5]);
        B2(1);
        for (var e3 = 0; e3 < 64; e3++)
          B2(c4[e3]);
      }(), function(t5, e3) {
        E2(65472), E2(17), B2(8), E2(e3), E2(t5), B2(3), B2(1), B2(17), B2(0), B2(2), B2(17), B2(1), B2(3), B2(17), B2(1);
      }(t4.width, t4.height), function() {
        E2(65476), E2(418), B2(0);
        for (var t5 = 0; t5 < 16; t5++)
          B2(x2[t5 + 1]);
        for (var e3 = 0; e3 <= 11; e3++)
          B2(S2[e3]);
        B2(16);
        for (var r3 = 0; r3 < 16; r3++)
          B2(_3[r3 + 1]);
        for (var n4 = 0; n4 <= 161; n4++)
          B2(P2[n4]);
        B2(1);
        for (var i4 = 0; i4 < 16; i4++)
          B2(k2[i4 + 1]);
        for (var a5 = 0; a5 <= 11; a5++)
          B2(I2[a5]);
        B2(17);
        for (var o5 = 0; o5 < 16; o5++)
          B2(F2[o5 + 1]);
        for (var s4 = 0; s4 <= 161; s4++)
          B2(C2[s4]);
      }(), E2(65498), E2(12), B2(3), B2(1), B2(0), B2(2), B2(17), B2(3), B2(17), B2(0), B2(63), B2(0);
      var o4 = 0, l4 = 0, f4 = 0;
      m4 = 0, v3 = 7, this.encode.displayName = "_encode_";
      for (var d3, p5, N4, A3, j3, D2, R2, T3, U2, z2 = t4.data, H2 = t4.width, W2 = t4.height, V2 = 4 * H2, G2 = 0; G2 < W2; ) {
        for (d3 = 0; d3 < V2; ) {
          for (j3 = V2 * G2 + d3, R2 = -1, T3 = 0, U2 = 0; U2 < 64; U2++)
            D2 = j3 + (T3 = U2 >> 3) * V2 + (R2 = 4 * (7 & U2)), G2 + T3 >= W2 && (D2 -= V2 * (G2 + 1 + T3 - W2)), d3 + R2 >= V2 && (D2 -= d3 + R2 - V2 + 4), p5 = z2[D2++], N4 = z2[D2++], A3 = z2[D2++], b2[U2] = (L2[p5] + L2[N4 + 256 >> 0] + L2[A3 + 512 >> 0] >> 16) - 128, y3[U2] = (L2[p5 + 768 >> 0] + L2[N4 + 1024 >> 0] + L2[A3 + 1280 >> 0] >> 16) - 128, w2[U2] = (L2[p5 + 1280 >> 0] + L2[N4 + 1536 >> 0] + L2[A3 + 1792 >> 0] >> 16) - 128;
          o4 = M2(b2, u3, o4, e2, n3), l4 = M2(y3, h4, l4, r2, i3), f4 = M2(w2, h4, f4, r2, i3), d3 += 32;
        }
        G2 += 8;
      }
      if (v3 >= 0) {
        var Y2 = [];
        Y2[1] = v3 + 1, Y2[0] = (1 << v3 + 1) - 1, O3(Y2);
      }
      return E2(65497), new Uint8Array(g2);
    }, t3 = t3 || 50, function() {
      for (var t4 = String.fromCharCode, e3 = 0; e3 < 256; e3++)
        N3[e3] = t4(e3);
    }(), e2 = j2(x2, S2), r2 = j2(k2, I2), n3 = j2(_3, P2), i3 = j2(F2, C2), function() {
      for (var t4 = 1, e3 = 2, r3 = 1; r3 <= 15; r3++) {
        for (var n4 = t4; n4 < e3; n4++)
          f3[32767 + n4] = r3, l3[32767 + n4] = [], l3[32767 + n4][1] = r3, l3[32767 + n4][0] = n4;
        for (var i4 = -(e3 - 1); i4 <= -t4; i4++)
          f3[32767 + i4] = r3, l3[32767 + i4] = [], l3[32767 + i4][1] = r3, l3[32767 + i4][0] = e3 - 1 + i4;
        t4 <<= 1, e3 <<= 1;
      }
    }(), function() {
      for (var t4 = 0; t4 < 256; t4++)
        L2[t4] = 19595 * t4, L2[t4 + 256 >> 0] = 38470 * t4, L2[t4 + 512 >> 0] = 7471 * t4 + 32768, L2[t4 + 768 >> 0] = -11059 * t4, L2[t4 + 1024 >> 0] = -21709 * t4, L2[t4 + 1280 >> 0] = 32768 * t4 + 8421375, L2[t4 + 1536 >> 0] = -27439 * t4, L2[t4 + 1792 >> 0] = -5329 * t4;
    }(), q2(t3);
  }
  function te(t3, e2) {
    if (this.pos = 0, this.buffer = t3, this.datav = new DataView(t3.buffer), this.is_with_alpha = !!e2, this.bottom_up = true, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1)
      throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
  }
  function ee(t3) {
    function e2(t4) {
      if (!t4)
        throw Error("assert :P");
    }
    function r2(t4, e3, r3) {
      for (var n4 = 0; 4 > n4; n4++)
        if (t4[e3 + n4] != r3.charCodeAt(n4))
          return true;
      return false;
    }
    function n3(t4, e3, r3, n4, i4) {
      for (var a4 = 0; a4 < i4; a4++)
        t4[e3 + a4] = r3[n4 + a4];
    }
    function i3(t4, e3, r3, n4) {
      for (var i4 = 0; i4 < n4; i4++)
        t4[e3 + i4] = r3;
    }
    function a3(t4) {
      return new Int32Array(t4);
    }
    function o3(t4, e3) {
      for (var r3 = [], n4 = 0; n4 < t4; n4++)
        r3.push(new e3());
      return r3;
    }
    function s3(t4, e3) {
      var r3 = [];
      return function t5(r4, n4, i4) {
        for (var a4 = i4[n4], o4 = 0; o4 < a4 && (r4.push(i4.length > n4 + 1 ? [] : new e3()), !(i4.length < n4 + 1)); o4++)
          t5(r4[o4], n4 + 1, i4);
      }(r3, 0, t4), r3;
    }
    var c4 = function() {
      var t4 = this;
      function c5(t5, e3) {
        for (var r3 = 1 << e3 - 1 >>> 0; t5 & r3; )
          r3 >>>= 1;
        return r3 ? (t5 & r3 - 1) + r3 : t5;
      }
      function u4(t5, r3, n4, i4, a4) {
        e2(!(i4 % n4));
        do {
          t5[r3 + (i4 -= n4)] = a4;
        } while (0 < i4);
      }
      function h5(t5, r3, n4, i4, o4) {
        if (e2(2328 >= o4), 512 >= o4)
          var s4 = a3(512);
        else if ((s4 = a3(o4)) == null)
          return 0;
        return function(t6, r4, n5, i5, o5, s5) {
          var h6, f5, d4 = r4, p6 = 1 << n5, g4 = a3(16), m6 = a3(16);
          for (e2(o5 != 0), e2(i5 != null), e2(t6 != null), e2(0 < n5), f5 = 0; f5 < o5; ++f5) {
            if (15 < i5[f5])
              return 0;
            ++g4[i5[f5]];
          }
          if (g4[0] == o5)
            return 0;
          for (m6[1] = 0, h6 = 1; 15 > h6; ++h6) {
            if (g4[h6] > 1 << h6)
              return 0;
            m6[h6 + 1] = m6[h6] + g4[h6];
          }
          for (f5 = 0; f5 < o5; ++f5)
            h6 = i5[f5], 0 < i5[f5] && (s5[m6[h6]++] = f5);
          if (m6[15] == 1)
            return (i5 = new l4()).g = 0, i5.value = s5[0], u4(t6, d4, 1, p6, i5), p6;
          var v5, b4 = -1, y5 = p6 - 1, w4 = 0, N5 = 1, L4 = 1, A4 = 1 << n5;
          for (f5 = 0, h6 = 1, o5 = 2; h6 <= n5; ++h6, o5 <<= 1) {
            if (N5 += L4 <<= 1, 0 > (L4 -= g4[h6]))
              return 0;
            for (; 0 < g4[h6]; --g4[h6])
              (i5 = new l4()).g = h6, i5.value = s5[f5++], u4(t6, d4 + w4, o5, A4, i5), w4 = c5(w4, h6);
          }
          for (h6 = n5 + 1, o5 = 2; 15 >= h6; ++h6, o5 <<= 1) {
            if (N5 += L4 <<= 1, 0 > (L4 -= g4[h6]))
              return 0;
            for (; 0 < g4[h6]; --g4[h6]) {
              if (i5 = new l4(), (w4 & y5) != b4) {
                for (d4 += A4, v5 = 1 << (b4 = h6) - n5; 15 > b4 && !(0 >= (v5 -= g4[b4])); )
                  ++b4, v5 <<= 1;
                p6 += A4 = 1 << (v5 = b4 - n5), t6[r4 + (b4 = w4 & y5)].g = v5 + n5, t6[r4 + b4].value = d4 - r4 - b4;
              }
              i5.g = h6 - n5, i5.value = s5[f5++], u4(t6, d4 + (w4 >> n5), o5, A4, i5), w4 = c5(w4, h6);
            }
          }
          return N5 != 2 * m6[15] - 1 ? 0 : p6;
        }(t5, r3, n4, i4, o4, s4);
      }
      function l4() {
        this.value = this.g = 0;
      }
      function f4() {
        this.value = this.g = 0;
      }
      function d3() {
        this.G = o3(5, l4), this.H = a3(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o3(Dr, f4);
      }
      function p5(t5, r3, n4, i4) {
        e2(t5 != null), e2(r3 != null), e2(2147483648 > i4), t5.Ca = 254, t5.I = 0, t5.b = -8, t5.Ka = 0, t5.oa = r3, t5.pa = n4, t5.Jd = r3, t5.Yc = n4 + i4, t5.Zc = 4 <= i4 ? n4 + i4 - 4 + 1 : n4, _3(t5);
      }
      function g3(t5, e3) {
        for (var r3 = 0; 0 < e3--; )
          r3 |= k2(t5, 128) << e3;
        return r3;
      }
      function m5(t5, e3) {
        var r3 = g3(t5, e3);
        return P2(t5) ? -r3 : r3;
      }
      function v4(t5, r3, n4, i4) {
        var a4, o4 = 0;
        for (e2(t5 != null), e2(r3 != null), e2(4294967288 > i4), t5.Sb = i4, t5.Ra = 0, t5.u = 0, t5.h = 0, 4 < i4 && (i4 = 4), a4 = 0; a4 < i4; ++a4)
          o4 += r3[n4 + a4] << 8 * a4;
        t5.Ra = o4, t5.bb = i4, t5.oa = r3, t5.pa = n4;
      }
      function b3(t5) {
        for (; 8 <= t5.u && t5.bb < t5.Sb; )
          t5.Ra >>>= 8, t5.Ra += t5.oa[t5.pa + t5.bb] << Ur - 8 >>> 0, ++t5.bb, t5.u -= 8;
        A3(t5) && (t5.h = 1, t5.u = 0);
      }
      function y4(t5, r3) {
        if (e2(0 <= r3), !t5.h && r3 <= Tr) {
          var n4 = L3(t5) & Rr[r3];
          return t5.u += r3, b3(t5), n4;
        }
        return t5.h = 1, t5.u = 0;
      }
      function w3() {
        this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
      }
      function N4() {
        this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
      }
      function L3(t5) {
        return t5.Ra >>> (t5.u & Ur - 1) >>> 0;
      }
      function A3(t5) {
        return e2(t5.bb <= t5.Sb), t5.h || t5.bb == t5.Sb && t5.u > Ur;
      }
      function x2(t5, e3) {
        t5.u = e3, t5.h = A3(t5);
      }
      function S2(t5) {
        t5.u >= zr && (e2(t5.u >= zr), b3(t5));
      }
      function _3(t5) {
        e2(t5 != null && t5.oa != null), t5.pa < t5.Zc ? (t5.I = (t5.oa[t5.pa++] | t5.I << 8) >>> 0, t5.b += 8) : (e2(t5 != null && t5.oa != null), t5.pa < t5.Yc ? (t5.b += 8, t5.I = t5.oa[t5.pa++] | t5.I << 8) : t5.Ka ? t5.b = 0 : (t5.I <<= 8, t5.b += 8, t5.Ka = 1));
      }
      function P2(t5) {
        return g3(t5, 1);
      }
      function k2(t5, e3) {
        var r3 = t5.Ca;
        0 > t5.b && _3(t5);
        var n4 = t5.b, i4 = r3 * e3 >>> 8, a4 = (t5.I >>> n4 > i4) + 0;
        for (a4 ? (r3 -= i4, t5.I -= i4 + 1 << n4 >>> 0) : r3 = i4 + 1, n4 = r3, i4 = 0; 256 <= n4; )
          i4 += 8, n4 >>= 8;
        return n4 = 7 ^ i4 + Hr[n4], t5.b -= n4, t5.Ca = (r3 << n4) - 1, a4;
      }
      function I2(t5, e3, r3) {
        t5[e3 + 0] = r3 >> 24 & 255, t5[e3 + 1] = r3 >> 16 & 255, t5[e3 + 2] = r3 >> 8 & 255, t5[e3 + 3] = r3 >> 0 & 255;
      }
      function F2(t5, e3) {
        return t5[e3 + 0] << 0 | t5[e3 + 1] << 8;
      }
      function C2(t5, e3) {
        return F2(t5, e3) | t5[e3 + 2] << 16;
      }
      function j2(t5, e3) {
        return F2(t5, e3) | F2(t5, e3 + 2) << 16;
      }
      function O3(t5, r3) {
        var n4 = 1 << r3;
        return e2(t5 != null), e2(0 < r3), t5.X = a3(n4), t5.X == null ? 0 : (t5.Mb = 32 - r3, t5.Xa = r3, 1);
      }
      function B2(t5, r3) {
        e2(t5 != null), e2(r3 != null), e2(t5.Xa == r3.Xa), n3(r3.X, 0, t5.X, 0, 1 << r3.Xa);
      }
      function E2() {
        this.X = [], this.Xa = this.Mb = 0;
      }
      function M2(t5, r3, n4, i4) {
        e2(n4 != null), e2(i4 != null);
        var a4 = n4[0], o4 = i4[0];
        return a4 == 0 && (a4 = (t5 * o4 + r3 / 2) / r3), o4 == 0 && (o4 = (r3 * a4 + t5 / 2) / t5), 0 >= a4 || 0 >= o4 ? 0 : (n4[0] = a4, i4[0] = o4, 1);
      }
      function q2(t5, e3) {
        return t5 + (1 << e3) - 1 >>> e3;
      }
      function D2(t5, e3) {
        return ((4278255360 & t5) + (4278255360 & e3) >>> 0 & 4278255360) + ((16711935 & t5) + (16711935 & e3) >>> 0 & 16711935) >>> 0;
      }
      function R2(e3, r3) {
        t4[r3] = function(r4, n4, i4, a4, o4, s4, c6) {
          var u5;
          for (u5 = 0; u5 < o4; ++u5) {
            var h6 = t4[e3](s4[c6 + u5 - 1], i4, a4 + u5);
            s4[c6 + u5] = D2(r4[n4 + u5], h6);
          }
        };
      }
      function T3() {
        this.ud = this.hd = this.jd = 0;
      }
      function U2(t5, e3) {
        return ((4278124286 & (t5 ^ e3)) >>> 1) + (t5 & e3) >>> 0;
      }
      function z2(t5) {
        return 0 <= t5 && 256 > t5 ? t5 : 0 > t5 ? 0 : 255 < t5 ? 255 : void 0;
      }
      function H2(t5, e3) {
        return z2(t5 + (t5 - e3 + 0.5 >> 1));
      }
      function W2(t5, e3, r3) {
        return Math.abs(e3 - r3) - Math.abs(t5 - r3);
      }
      function V2(t5, e3, r3, n4, i4, a4, o4) {
        for (n4 = a4[o4 - 1], r3 = 0; r3 < i4; ++r3)
          a4[o4 + r3] = n4 = D2(t5[e3 + r3], n4);
      }
      function G2(t5, e3, r3, n4, i4) {
        var a4;
        for (a4 = 0; a4 < r3; ++a4) {
          var o4 = t5[e3 + a4], s4 = o4 >> 8 & 255, c6 = 16711935 & (c6 = (c6 = 16711935 & o4) + ((s4 << 16) + s4));
          n4[i4 + a4] = (4278255360 & o4) + c6 >>> 0;
        }
      }
      function Y2(t5, e3) {
        e3.jd = t5 >> 0 & 255, e3.hd = t5 >> 8 & 255, e3.ud = t5 >> 16 & 255;
      }
      function J2(t5, e3, r3, n4, i4, a4) {
        var o4;
        for (o4 = 0; o4 < n4; ++o4) {
          var s4 = e3[r3 + o4], c6 = s4 >>> 8, u5 = s4, h6 = 255 & (h6 = (h6 = s4 >>> 16) + ((t5.jd << 24 >> 24) * (c6 << 24 >> 24) >>> 5));
          u5 = 255 & (u5 = (u5 = u5 + ((t5.hd << 24 >> 24) * (c6 << 24 >> 24) >>> 5)) + ((t5.ud << 24 >> 24) * (h6 << 24 >> 24) >>> 5));
          i4[a4 + o4] = (4278255360 & s4) + (h6 << 16) + u5;
        }
      }
      function X2(e3, r3, n4, i4, a4) {
        t4[r3] = function(t5, e4, r4, n5, o4, s4, c6, u5, h6) {
          for (n5 = c6; n5 < u5; ++n5)
            for (c6 = 0; c6 < h6; ++c6)
              o4[s4++] = a4(r4[i4(t5[e4++])]);
        }, t4[e3] = function(e4, r4, o4, s4, c6, u5, h6) {
          var l5 = 8 >> e4.b, f5 = e4.Ea, d4 = e4.K[0], p6 = e4.w;
          if (8 > l5)
            for (e4 = (1 << e4.b) - 1, p6 = (1 << l5) - 1; r4 < o4; ++r4) {
              var g4, m6 = 0;
              for (g4 = 0; g4 < f5; ++g4)
                g4 & e4 || (m6 = i4(s4[c6++])), u5[h6++] = a4(d4[m6 & p6]), m6 >>= l5;
            }
          else
            t4["VP8LMapColor" + n4](s4, c6, d4, p6, u5, h6, r4, o4, f5);
        };
      }
      function K2(t5, e3, r3, n4, i4) {
        for (r3 = e3 + r3; e3 < r3; ) {
          var a4 = t5[e3++];
          n4[i4++] = a4 >> 16 & 255, n4[i4++] = a4 >> 8 & 255, n4[i4++] = a4 >> 0 & 255;
        }
      }
      function Z2(t5, e3, r3, n4, i4) {
        for (r3 = e3 + r3; e3 < r3; ) {
          var a4 = t5[e3++];
          n4[i4++] = a4 >> 16 & 255, n4[i4++] = a4 >> 8 & 255, n4[i4++] = a4 >> 0 & 255, n4[i4++] = a4 >> 24 & 255;
        }
      }
      function $12(t5, e3, r3, n4, i4) {
        for (r3 = e3 + r3; e3 < r3; ) {
          var a4 = (o4 = t5[e3++]) >> 16 & 240 | o4 >> 12 & 15, o4 = o4 >> 0 & 240 | o4 >> 28 & 15;
          n4[i4++] = a4, n4[i4++] = o4;
        }
      }
      function Q2(t5, e3, r3, n4, i4) {
        for (r3 = e3 + r3; e3 < r3; ) {
          var a4 = (o4 = t5[e3++]) >> 16 & 248 | o4 >> 13 & 7, o4 = o4 >> 5 & 224 | o4 >> 3 & 31;
          n4[i4++] = a4, n4[i4++] = o4;
        }
      }
      function tt2(t5, e3, r3, n4, i4) {
        for (r3 = e3 + r3; e3 < r3; ) {
          var a4 = t5[e3++];
          n4[i4++] = a4 >> 0 & 255, n4[i4++] = a4 >> 8 & 255, n4[i4++] = a4 >> 16 & 255;
        }
      }
      function et3(t5, e3, r3, i4, a4, o4) {
        if (o4 == 0)
          for (r3 = e3 + r3; e3 < r3; )
            I2(i4, ((o4 = t5[e3++])[0] >> 24 | o4[1] >> 8 & 65280 | o4[2] << 8 & 16711680 | o4[3] << 24) >>> 0), a4 += 32;
        else
          n3(i4, a4, t5, e3, r3);
      }
      function rt2(e3, r3) {
        t4[r3][0] = t4[e3 + "0"], t4[r3][1] = t4[e3 + "1"], t4[r3][2] = t4[e3 + "2"], t4[r3][3] = t4[e3 + "3"], t4[r3][4] = t4[e3 + "4"], t4[r3][5] = t4[e3 + "5"], t4[r3][6] = t4[e3 + "6"], t4[r3][7] = t4[e3 + "7"], t4[r3][8] = t4[e3 + "8"], t4[r3][9] = t4[e3 + "9"], t4[r3][10] = t4[e3 + "10"], t4[r3][11] = t4[e3 + "11"], t4[r3][12] = t4[e3 + "12"], t4[r3][13] = t4[e3 + "13"], t4[r3][14] = t4[e3 + "0"], t4[r3][15] = t4[e3 + "0"];
      }
      function nt2(t5) {
        return t5 == Hn || t5 == Wn || t5 == Vn || t5 == Gn;
      }
      function it2() {
        this.eb = [], this.size = this.A = this.fb = 0;
      }
      function at2() {
        this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
      }
      function ot2() {
        this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it2(), this.f.kb = new at2(), this.sd = null;
      }
      function st2() {
        this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
      }
      function ct2() {
        this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
      }
      function ut2(t5) {
        return alert("todo:WebPSamplerProcessPlane"), t5.T;
      }
      function ht2(t5, e3) {
        var r3 = t5.T, i4 = e3.ba.f.RGBA, a4 = i4.eb, o4 = i4.fb + t5.ka * i4.A, s4 = vi[e3.ba.S], c6 = t5.y, u5 = t5.O, h6 = t5.f, l5 = t5.N, f5 = t5.ea, d4 = t5.W, p6 = e3.cc, g4 = e3.dc, m6 = e3.Mc, v5 = e3.Nc, b4 = t5.ka, y5 = t5.ka + t5.T, w4 = t5.U, N5 = w4 + 1 >> 1;
        for (b4 == 0 ? s4(c6, u5, null, null, h6, l5, f5, d4, h6, l5, f5, d4, a4, o4, null, null, w4) : (s4(e3.ec, e3.fc, c6, u5, p6, g4, m6, v5, h6, l5, f5, d4, a4, o4 - i4.A, a4, o4, w4), ++r3); b4 + 2 < y5; b4 += 2)
          p6 = h6, g4 = l5, m6 = f5, v5 = d4, l5 += t5.Rc, d4 += t5.Rc, o4 += 2 * i4.A, s4(c6, (u5 += 2 * t5.fa) - t5.fa, c6, u5, p6, g4, m6, v5, h6, l5, f5, d4, a4, o4 - i4.A, a4, o4, w4);
        return u5 += t5.fa, t5.j + y5 < t5.o ? (n3(e3.ec, e3.fc, c6, u5, w4), n3(e3.cc, e3.dc, h6, l5, N5), n3(e3.Mc, e3.Nc, f5, d4, N5), r3--) : 1 & y5 || s4(c6, u5, null, null, h6, l5, f5, d4, h6, l5, f5, d4, a4, o4 + i4.A, null, null, w4), r3;
      }
      function lt2(t5, r3, n4) {
        var i4 = t5.F, a4 = [t5.J];
        if (i4 != null) {
          var o4 = t5.U, s4 = r3.ba.S, c6 = s4 == Tn || s4 == Vn;
          r3 = r3.ba.f.RGBA;
          var u5 = [0], h6 = t5.ka;
          u5[0] = t5.T, t5.Kb && (h6 == 0 ? --u5[0] : (--h6, a4[0] -= t5.width), t5.j + t5.ka + t5.T == t5.o && (u5[0] = t5.o - t5.j - h6));
          var l5 = r3.eb;
          h6 = r3.fb + h6 * r3.A;
          t5 = Sn(i4, a4[0], t5.width, o4, u5, l5, h6 + (c6 ? 0 : 3), r3.A), e2(n4 == u5), t5 && nt2(s4) && An(l5, h6, c6, o4, u5, r3.A);
        }
        return 0;
      }
      function ft2(t5) {
        var e3 = t5.ma, r3 = e3.ba.S, n4 = 11 > r3, i4 = r3 == qn || r3 == Rn || r3 == Tn || r3 == Un || r3 == 12 || nt2(r3);
        if (e3.memory = null, e3.Ib = null, e3.Jb = null, e3.Nd = null, !Er(e3.Oa, t5, i4 ? 11 : 12))
          return 0;
        if (i4 && nt2(r3) && br(), t5.da)
          alert("todo:use_scaling");
        else {
          if (n4) {
            if (e3.Ib = ut2, t5.Kb) {
              if (r3 = t5.U + 1 >> 1, e3.memory = a3(t5.U + 2 * r3), e3.memory == null)
                return 0;
              e3.ec = e3.memory, e3.fc = 0, e3.cc = e3.ec, e3.dc = e3.fc + t5.U, e3.Mc = e3.cc, e3.Nc = e3.dc + r3, e3.Ib = ht2, br();
            }
          } else
            alert("todo:EmitYUV");
          i4 && (e3.Jb = lt2, n4 && mr());
        }
        if (n4 && !Ci) {
          for (t5 = 0; 256 > t5; ++t5)
            ji[t5] = 89858 * (t5 - 128) + _i >> Si, Ei[t5] = -22014 * (t5 - 128) + _i, Bi[t5] = -45773 * (t5 - 128), Oi[t5] = 113618 * (t5 - 128) + _i >> Si;
          for (t5 = Pi; t5 < ki; ++t5)
            e3 = 76283 * (t5 - 16) + _i >> Si, Mi[t5 - Pi] = Vt2(e3, 255), qi[t5 - Pi] = Vt2(e3 + 8 >> 4, 15);
          Ci = 1;
        }
        return 1;
      }
      function dt2(t5) {
        var r3 = t5.ma, n4 = t5.U, i4 = t5.T;
        return e2(!(1 & t5.ka)), 0 >= n4 || 0 >= i4 ? 0 : (n4 = r3.Ib(t5, r3), r3.Jb != null && r3.Jb(t5, r3, n4), r3.Dc += n4, 1);
      }
      function pt2(t5) {
        t5.ma.memory = null;
      }
      function gt2(t5, e3, r3, n4) {
        return y4(t5, 8) != 47 ? 0 : (e3[0] = y4(t5, 14) + 1, r3[0] = y4(t5, 14) + 1, n4[0] = y4(t5, 1), y4(t5, 3) != 0 ? 0 : !t5.h);
      }
      function mt2(t5, e3) {
        if (4 > t5)
          return t5 + 1;
        var r3 = t5 - 2 >> 1;
        return (2 + (1 & t5) << r3) + y4(e3, r3) + 1;
      }
      function vt2(t5, e3) {
        return 120 < e3 ? e3 - 120 : 1 <= (r3 = ((r3 = $n[e3 - 1]) >> 4) * t5 + (8 - (15 & r3))) ? r3 : 1;
        var r3;
      }
      function bt2(t5, e3, r3) {
        var n4 = L3(r3), i4 = t5[e3 += 255 & n4].g - 8;
        return 0 < i4 && (x2(r3, r3.u + 8), n4 = L3(r3), e3 += t5[e3].value, e3 += n4 & (1 << i4) - 1), x2(r3, r3.u + t5[e3].g), t5[e3].value;
      }
      function yt2(t5, r3, n4) {
        return n4.g += t5.g, n4.value += t5.value << r3 >>> 0, e2(8 >= n4.g), t5.g;
      }
      function wt2(t5, r3, n4) {
        var i4 = t5.xc;
        return e2((r3 = i4 == 0 ? 0 : t5.vc[t5.md * (n4 >> i4) + (r3 >> i4)]) < t5.Wb), t5.Ya[r3];
      }
      function Nt2(t5, r3, i4, a4) {
        var o4 = t5.ab, s4 = t5.c * r3, c6 = t5.C;
        r3 = c6 + r3;
        var u5 = i4, h6 = a4;
        for (a4 = t5.Ta, i4 = t5.Ua; 0 < o4--; ) {
          var l5 = t5.gc[o4], f5 = c6, d4 = r3, p6 = u5, g4 = h6, m6 = (h6 = a4, u5 = i4, l5.Ea);
          switch (e2(f5 < d4), e2(d4 <= l5.nc), l5.hc) {
            case 2:
              Gr(p6, g4, (d4 - f5) * m6, h6, u5);
              break;
            case 0:
              var v5 = f5, b4 = d4, y5 = h6, w4 = u5, N5 = (_4 = l5).Ea;
              v5 == 0 && (Wr(p6, g4, null, null, 1, y5, w4), V2(p6, g4 + 1, 0, 0, N5 - 1, y5, w4 + 1), g4 += N5, w4 += N5, ++v5);
              for (var L4 = 1 << _4.b, A4 = L4 - 1, x3 = q2(N5, _4.b), S3 = _4.K, _4 = _4.w + (v5 >> _4.b) * x3; v5 < b4; ) {
                var P3 = S3, k3 = _4, I3 = 1;
                for (Vr(p6, g4, y5, w4 - N5, 1, y5, w4); I3 < N5; ) {
                  var F3 = (I3 & ~A4) + L4;
                  F3 > N5 && (F3 = N5), (0, Zr[P3[k3++] >> 8 & 15])(p6, g4 + +I3, y5, w4 + I3 - N5, F3 - I3, y5, w4 + I3), I3 = F3;
                }
                g4 += N5, w4 += N5, ++v5 & A4 || (_4 += x3);
              }
              d4 != l5.nc && n3(h6, u5 - m6, h6, u5 + (d4 - f5 - 1) * m6, m6);
              break;
            case 1:
              for (m6 = p6, b4 = g4, N5 = (p6 = l5.Ea) - (w4 = p6 & ~(y5 = (g4 = 1 << l5.b) - 1)), v5 = q2(p6, l5.b), L4 = l5.K, l5 = l5.w + (f5 >> l5.b) * v5; f5 < d4; ) {
                for (A4 = L4, x3 = l5, S3 = new T3(), _4 = b4 + w4, P3 = b4 + p6; b4 < _4; )
                  Y2(A4[x3++], S3), $r(S3, m6, b4, g4, h6, u5), b4 += g4, u5 += g4;
                b4 < P3 && (Y2(A4[x3++], S3), $r(S3, m6, b4, N5, h6, u5), b4 += N5, u5 += N5), ++f5 & y5 || (l5 += v5);
              }
              break;
            case 3:
              if (p6 == h6 && g4 == u5 && 0 < l5.b) {
                for (b4 = h6, p6 = m6 = u5 + (d4 - f5) * m6 - (w4 = (d4 - f5) * q2(l5.Ea, l5.b)), g4 = h6, y5 = u5, v5 = [], w4 = (N5 = w4) - 1; 0 <= w4; --w4)
                  v5[w4] = g4[y5 + w4];
                for (w4 = N5 - 1; 0 <= w4; --w4)
                  b4[p6 + w4] = v5[w4];
                Yr(l5, f5, d4, h6, m6, h6, u5);
              } else
                Yr(l5, f5, d4, p6, g4, h6, u5);
          }
          u5 = a4, h6 = i4;
        }
        h6 != i4 && n3(a4, i4, u5, h6, s4);
      }
      function Lt2(t5, r3) {
        var n4 = t5.V, i4 = t5.Ba + t5.c * t5.C, a4 = r3 - t5.C;
        if (e2(r3 <= t5.l.o), e2(16 >= a4), 0 < a4) {
          var o4 = t5.l, s4 = t5.Ta, c6 = t5.Ua, u5 = o4.width;
          if (Nt2(t5, a4, n4, i4), a4 = c6 = [c6], e2((n4 = t5.C) < (i4 = r3)), e2(o4.v < o4.va), i4 > o4.o && (i4 = o4.o), n4 < o4.j) {
            var h6 = o4.j - n4;
            n4 = o4.j;
            a4[0] += h6 * u5;
          }
          if (n4 >= i4 ? n4 = 0 : (a4[0] += 4 * o4.v, o4.ka = n4 - o4.j, o4.U = o4.va - o4.v, o4.T = i4 - n4, n4 = 1), n4) {
            if (c6 = c6[0], 11 > (n4 = t5.ca).S) {
              var l5 = n4.f.RGBA, f5 = (i4 = n4.S, a4 = o4.U, o4 = o4.T, h6 = l5.eb, l5.A), d4 = o4;
              for (l5 = l5.fb + t5.Ma * l5.A; 0 < d4--; ) {
                var p6 = s4, g4 = c6, m6 = a4, v5 = h6, b4 = l5;
                switch (i4) {
                  case Mn:
                    Qr(p6, g4, m6, v5, b4);
                    break;
                  case qn:
                    tn(p6, g4, m6, v5, b4);
                    break;
                  case Hn:
                    tn(p6, g4, m6, v5, b4), An(v5, b4, 0, m6, 1, 0);
                    break;
                  case Dn:
                    nn(p6, g4, m6, v5, b4);
                    break;
                  case Rn:
                    et3(p6, g4, m6, v5, b4, 1);
                    break;
                  case Wn:
                    et3(p6, g4, m6, v5, b4, 1), An(v5, b4, 0, m6, 1, 0);
                    break;
                  case Tn:
                    et3(p6, g4, m6, v5, b4, 0);
                    break;
                  case Vn:
                    et3(p6, g4, m6, v5, b4, 0), An(v5, b4, 1, m6, 1, 0);
                    break;
                  case Un:
                    en(p6, g4, m6, v5, b4);
                    break;
                  case Gn:
                    en(p6, g4, m6, v5, b4), xn(v5, b4, m6, 1, 0);
                    break;
                  case zn:
                    rn(p6, g4, m6, v5, b4);
                    break;
                  default:
                    e2(0);
                }
                c6 += u5, l5 += f5;
              }
              t5.Ma += o4;
            } else
              alert("todo:EmitRescaledRowsYUVA");
            e2(t5.Ma <= n4.height);
          }
        }
        t5.C = r3, e2(t5.C <= t5.i);
      }
      function At2(t5) {
        var e3;
        if (0 < t5.ua)
          return 0;
        for (e3 = 0; e3 < t5.Wb; ++e3) {
          var r3 = t5.Ya[e3].G, n4 = t5.Ya[e3].H;
          if (0 < r3[1][n4[1] + 0].g || 0 < r3[2][n4[2] + 0].g || 0 < r3[3][n4[3] + 0].g)
            return 0;
        }
        return 1;
      }
      function xt2(t5, r3, n4, i4, a4, o4) {
        if (t5.Z != 0) {
          var s4 = t5.qd, c6 = t5.rd;
          for (e2(mi[t5.Z] != null); r3 < n4; ++r3)
            mi[t5.Z](s4, c6, i4, a4, i4, a4, o4), s4 = i4, c6 = a4, a4 += o4;
          t5.qd = s4, t5.rd = c6;
        }
      }
      function St2(t5, r3) {
        var n4 = t5.l.ma, i4 = n4.Z == 0 || n4.Z == 1 ? t5.l.j : t5.C;
        i4 = t5.C < i4 ? i4 : t5.C;
        if (e2(r3 <= t5.l.o), r3 > i4) {
          var a4 = t5.l.width, o4 = n4.ca, s4 = n4.tb + a4 * i4, c6 = t5.V, u5 = t5.Ba + t5.c * i4, h6 = t5.gc;
          e2(t5.ab == 1), e2(h6[0].hc == 3), Xr(h6[0], i4, r3, c6, u5, o4, s4), xt2(n4, i4, r3, o4, s4, a4);
        }
        t5.C = t5.Ma = r3;
      }
      function _t2(t5, r3, n4, i4, a4, o4, s4) {
        var c6 = t5.$ / i4, u5 = t5.$ % i4, h6 = t5.m, l5 = t5.s, f5 = n4 + t5.$, d4 = f5;
        a4 = n4 + i4 * a4;
        var p6 = n4 + i4 * o4, g4 = 280 + l5.ua, m6 = t5.Pb ? c6 : 16777216, v5 = 0 < l5.ua ? l5.Wa : null, b4 = l5.wc, y5 = f5 < p6 ? wt2(l5, u5, c6) : null;
        e2(t5.C < o4), e2(p6 <= a4);
        var w4 = false;
        t:
          for (; ; ) {
            for (; w4 || f5 < p6; ) {
              var N5 = 0;
              if (c6 >= m6) {
                var _4 = f5 - n4;
                e2((m6 = t5).Pb), m6.wd = m6.m, m6.xd = _4, 0 < m6.s.ua && B2(m6.s.Wa, m6.s.vb), m6 = c6 + ti;
              }
              if (u5 & b4 || (y5 = wt2(l5, u5, c6)), e2(y5 != null), y5.Qb && (r3[f5] = y5.qb, w4 = true), !w4)
                if (S2(h6), y5.jc) {
                  N5 = h6, _4 = r3;
                  var P3 = f5, k3 = y5.pd[L3(N5) & Dr - 1];
                  e2(y5.jc), 256 > k3.g ? (x2(N5, N5.u + k3.g), _4[P3] = k3.value, N5 = 0) : (x2(N5, N5.u + k3.g - 256), e2(256 <= k3.value), N5 = k3.value), N5 == 0 && (w4 = true);
                } else
                  N5 = bt2(y5.G[0], y5.H[0], h6);
              if (h6.h)
                break;
              if (w4 || 256 > N5) {
                if (!w4)
                  if (y5.nd)
                    r3[f5] = (y5.qb | N5 << 8) >>> 0;
                  else {
                    if (S2(h6), w4 = bt2(y5.G[1], y5.H[1], h6), S2(h6), _4 = bt2(y5.G[2], y5.H[2], h6), P3 = bt2(y5.G[3], y5.H[3], h6), h6.h)
                      break;
                    r3[f5] = (P3 << 24 | w4 << 16 | N5 << 8 | _4) >>> 0;
                  }
                if (w4 = false, ++f5, ++u5 >= i4 && (u5 = 0, ++c6, s4 != null && c6 <= o4 && !(c6 % 16) && s4(t5, c6), v5 != null))
                  for (; d4 < f5; )
                    N5 = r3[d4++], v5.X[(506832829 * N5 & 4294967295) >>> v5.Mb] = N5;
              } else if (280 > N5) {
                if (N5 = mt2(N5 - 256, h6), _4 = bt2(y5.G[4], y5.H[4], h6), S2(h6), _4 = vt2(i4, _4 = mt2(_4, h6)), h6.h)
                  break;
                if (f5 - n4 < _4 || a4 - f5 < N5)
                  break t;
                for (P3 = 0; P3 < N5; ++P3)
                  r3[f5 + P3] = r3[f5 + P3 - _4];
                for (f5 += N5, u5 += N5; u5 >= i4; )
                  u5 -= i4, ++c6, s4 != null && c6 <= o4 && !(c6 % 16) && s4(t5, c6);
                if (e2(f5 <= a4), u5 & b4 && (y5 = wt2(l5, u5, c6)), v5 != null)
                  for (; d4 < f5; )
                    N5 = r3[d4++], v5.X[(506832829 * N5 & 4294967295) >>> v5.Mb] = N5;
              } else {
                if (!(N5 < g4))
                  break t;
                for (w4 = N5 - 280, e2(v5 != null); d4 < f5; )
                  N5 = r3[d4++], v5.X[(506832829 * N5 & 4294967295) >>> v5.Mb] = N5;
                N5 = f5, e2(!(w4 >>> (_4 = v5).Xa)), r3[N5] = _4.X[w4], w4 = true;
              }
              w4 || e2(h6.h == A3(h6));
            }
            if (t5.Pb && h6.h && f5 < a4)
              e2(t5.m.h), t5.a = 5, t5.m = t5.wd, t5.$ = t5.xd, 0 < t5.s.ua && B2(t5.s.vb, t5.s.Wa);
            else {
              if (h6.h)
                break t;
              s4 != null && s4(t5, c6 > o4 ? o4 : c6), t5.a = 0, t5.$ = f5 - n4;
            }
            return 1;
          }
        return t5.a = 3, 0;
      }
      function Pt2(t5) {
        e2(t5 != null), t5.vc = null, t5.yc = null, t5.Ya = null;
        var r3 = t5.Wa;
        r3 != null && (r3.X = null), t5.vb = null, e2(t5 != null);
      }
      function kt2() {
        var e3 = new or();
        return e3 == null ? null : (e3.a = 0, e3.xb = gi, rt2("Predictor", "VP8LPredictors"), rt2("Predictor", "VP8LPredictors_C"), rt2("PredictorAdd", "VP8LPredictorsAdd"), rt2("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G2, $r = J2, Qr = K2, tn = Z2, en = $12, rn = Q2, nn = tt2, t4.VP8LMapColor32b = Jr, t4.VP8LMapColor8b = Kr, e3);
      }
      function It2(t5, r3, n4, s4, c6) {
        var u5 = 1, f5 = [t5], p6 = [r3], g4 = s4.m, m6 = s4.s, v5 = null, b4 = 0;
        t:
          for (; ; ) {
            if (n4)
              for (; u5 && y4(g4, 1); ) {
                var w4 = f5, N5 = p6, A4 = s4, _4 = 1, P3 = A4.m, k3 = A4.gc[A4.ab], I3 = y4(P3, 2);
                if (A4.Oc & 1 << I3)
                  u5 = 0;
                else {
                  switch (A4.Oc |= 1 << I3, k3.hc = I3, k3.Ea = w4[0], k3.nc = N5[0], k3.K = [null], ++A4.ab, e2(4 >= A4.ab), I3) {
                    case 0:
                    case 1:
                      k3.b = y4(P3, 3) + 2, _4 = It2(q2(k3.Ea, k3.b), q2(k3.nc, k3.b), 0, A4, k3.K), k3.K = k3.K[0];
                      break;
                    case 3:
                      var F3, C3 = y4(P3, 8) + 1, j3 = 16 < C3 ? 0 : 4 < C3 ? 1 : 2 < C3 ? 2 : 3;
                      if (w4[0] = q2(k3.Ea, j3), k3.b = j3, F3 = _4 = It2(C3, 1, 0, A4, k3.K)) {
                        var B3, E3 = C3, M3 = k3, R3 = 1 << (8 >> M3.b), T4 = a3(R3);
                        if (T4 == null)
                          F3 = 0;
                        else {
                          var U3 = M3.K[0], z3 = M3.w;
                          for (T4[0] = M3.K[0][0], B3 = 1; B3 < 1 * E3; ++B3)
                            T4[B3] = D2(U3[z3 + B3], T4[B3 - 1]);
                          for (; B3 < 4 * R3; ++B3)
                            T4[B3] = 0;
                          M3.K[0] = null, M3.K[0] = T4, F3 = 1;
                        }
                      }
                      _4 = F3;
                      break;
                    case 2:
                      break;
                    default:
                      e2(0);
                  }
                  u5 = _4;
                }
              }
            if (f5 = f5[0], p6 = p6[0], u5 && y4(g4, 1) && !(u5 = 1 <= (b4 = y4(g4, 4)) && 11 >= b4)) {
              s4.a = 3;
              break t;
            }
            var H3;
            if (H3 = u5)
              e: {
                var W3, V3, G3, Y3 = s4, J3 = f5, X3 = p6, K3 = b4, Z3 = n4, $13 = Y3.m, Q3 = Y3.s, tt3 = [null], et4 = 1, rt3 = 0, nt3 = Qn[K3];
                r:
                  for (; ; ) {
                    if (Z3 && y4($13, 1)) {
                      var it3 = y4($13, 3) + 2, at3 = q2(J3, it3), ot3 = q2(X3, it3), st3 = at3 * ot3;
                      if (!It2(at3, ot3, 0, Y3, tt3))
                        break r;
                      for (tt3 = tt3[0], Q3.xc = it3, W3 = 0; W3 < st3; ++W3) {
                        var ct3 = tt3[W3] >> 8 & 65535;
                        tt3[W3] = ct3, ct3 >= et4 && (et4 = ct3 + 1);
                      }
                    }
                    if ($13.h)
                      break r;
                    for (V3 = 0; 5 > V3; ++V3) {
                      var ut3 = Xn[V3];
                      !V3 && 0 < K3 && (ut3 += 1 << K3), rt3 < ut3 && (rt3 = ut3);
                    }
                    var ht3 = o3(et4 * nt3, l4), lt3 = et4, ft3 = o3(lt3, d3);
                    if (ft3 == null)
                      var dt3 = null;
                    else
                      e2(65536 >= lt3), dt3 = ft3;
                    var pt3 = a3(rt3);
                    if (dt3 == null || pt3 == null || ht3 == null) {
                      Y3.a = 1;
                      break r;
                    }
                    var gt3 = ht3;
                    for (W3 = G3 = 0; W3 < et4; ++W3) {
                      var mt3 = dt3[W3], vt3 = mt3.G, bt3 = mt3.H, wt3 = 0, Nt3 = 1, Lt3 = 0;
                      for (V3 = 0; 5 > V3; ++V3) {
                        ut3 = Xn[V3], vt3[V3] = gt3, bt3[V3] = G3, !V3 && 0 < K3 && (ut3 += 1 << K3);
                        n: {
                          var At3, xt3 = ut3, St3 = Y3, kt3 = pt3, Ft3 = gt3, Ct3 = G3, jt3 = 0, Ot3 = St3.m, Bt3 = y4(Ot3, 1);
                          if (i3(kt3, 0, 0, xt3), Bt3) {
                            var Et3 = y4(Ot3, 1) + 1, Mt3 = y4(Ot3, 1), qt3 = y4(Ot3, Mt3 == 0 ? 1 : 8);
                            kt3[qt3] = 1, Et3 == 2 && (kt3[qt3 = y4(Ot3, 8)] = 1);
                            var Dt3 = 1;
                          } else {
                            var Rt3 = a3(19), Tt3 = y4(Ot3, 4) + 4;
                            if (19 < Tt3) {
                              St3.a = 3;
                              var Ut3 = 0;
                              break n;
                            }
                            for (At3 = 0; At3 < Tt3; ++At3)
                              Rt3[Zn[At3]] = y4(Ot3, 3);
                            var zt3 = void 0, Ht3 = void 0, Wt3 = St3, Vt3 = Rt3, Gt3 = xt3, Yt3 = kt3, Jt3 = 0, Xt3 = Wt3.m, Kt3 = 8, Zt3 = o3(128, l4);
                            i:
                              for (; h5(Zt3, 0, 7, Vt3, 19); ) {
                                if (y4(Xt3, 1)) {
                                  var $t3 = 2 + 2 * y4(Xt3, 3);
                                  if ((zt3 = 2 + y4(Xt3, $t3)) > Gt3)
                                    break i;
                                } else
                                  zt3 = Gt3;
                                for (Ht3 = 0; Ht3 < Gt3 && zt3--; ) {
                                  S2(Xt3);
                                  var Qt3 = Zt3[0 + (127 & L3(Xt3))];
                                  x2(Xt3, Xt3.u + Qt3.g);
                                  var te3 = Qt3.value;
                                  if (16 > te3)
                                    Yt3[Ht3++] = te3, te3 != 0 && (Kt3 = te3);
                                  else {
                                    var ee3 = te3 == 16, re3 = te3 - 16, ne3 = Jn[re3], ie3 = y4(Xt3, Yn[re3]) + ne3;
                                    if (Ht3 + ie3 > Gt3)
                                      break i;
                                    for (var ae3 = ee3 ? Kt3 : 0; 0 < ie3--; )
                                      Yt3[Ht3++] = ae3;
                                  }
                                }
                                Jt3 = 1;
                                break i;
                              }
                            Jt3 || (Wt3.a = 3), Dt3 = Jt3;
                          }
                          (Dt3 = Dt3 && !Ot3.h) && (jt3 = h5(Ft3, Ct3, 8, kt3, xt3)), Dt3 && jt3 != 0 ? Ut3 = jt3 : (St3.a = 3, Ut3 = 0);
                        }
                        if (Ut3 == 0)
                          break r;
                        if (Nt3 && Kn[V3] == 1 && (Nt3 = gt3[G3].g == 0), wt3 += gt3[G3].g, G3 += Ut3, 3 >= V3) {
                          var oe3, se3 = pt3[0];
                          for (oe3 = 1; oe3 < ut3; ++oe3)
                            pt3[oe3] > se3 && (se3 = pt3[oe3]);
                          Lt3 += se3;
                        }
                      }
                      if (mt3.nd = Nt3, mt3.Qb = 0, Nt3 && (mt3.qb = (vt3[3][bt3[3] + 0].value << 24 | vt3[1][bt3[1] + 0].value << 16 | vt3[2][bt3[2] + 0].value) >>> 0, wt3 == 0 && 256 > vt3[0][bt3[0] + 0].value && (mt3.Qb = 1, mt3.qb += vt3[0][bt3[0] + 0].value << 8)), mt3.jc = !mt3.Qb && 6 > Lt3, mt3.jc) {
                        var ce3, ue3 = mt3;
                        for (ce3 = 0; ce3 < Dr; ++ce3) {
                          var he3 = ce3, le3 = ue3.pd[he3], fe3 = ue3.G[0][ue3.H[0] + he3];
                          256 <= fe3.value ? (le3.g = fe3.g + 256, le3.value = fe3.value) : (le3.g = 0, le3.value = 0, he3 >>= yt2(fe3, 8, le3), he3 >>= yt2(ue3.G[1][ue3.H[1] + he3], 16, le3), he3 >>= yt2(ue3.G[2][ue3.H[2] + he3], 0, le3), yt2(ue3.G[3][ue3.H[3] + he3], 24, le3));
                        }
                      }
                    }
                    Q3.vc = tt3, Q3.Wb = et4, Q3.Ya = dt3, Q3.yc = ht3, H3 = 1;
                    break e;
                  }
                H3 = 0;
              }
            if (!(u5 = H3)) {
              s4.a = 3;
              break t;
            }
            if (0 < b4) {
              if (m6.ua = 1 << b4, !O3(m6.Wa, b4)) {
                s4.a = 1, u5 = 0;
                break t;
              }
            } else
              m6.ua = 0;
            var de3 = s4, pe3 = f5, ge3 = p6, me3 = de3.s, ve3 = me3.xc;
            if (de3.c = pe3, de3.i = ge3, me3.md = q2(pe3, ve3), me3.wc = ve3 == 0 ? -1 : (1 << ve3) - 1, n4) {
              s4.xb = pi;
              break t;
            }
            if ((v5 = a3(f5 * p6)) == null) {
              s4.a = 1, u5 = 0;
              break t;
            }
            u5 = (u5 = _t2(s4, v5, 0, f5, p6, p6, null)) && !g4.h;
            break t;
          }
        return u5 ? (c6 != null ? c6[0] = v5 : (e2(v5 == null), e2(n4)), s4.$ = 0, n4 || Pt2(m6)) : Pt2(m6), u5;
      }
      function Ft2(t5, r3) {
        var n4 = t5.c * t5.i, i4 = n4 + r3 + 16 * r3;
        return e2(t5.c <= r3), t5.V = a3(i4), t5.V == null ? (t5.Ta = null, t5.Ua = 0, t5.a = 1, 0) : (t5.Ta = t5.V, t5.Ua = t5.Ba + n4 + r3, 1);
      }
      function Ct2(t5, r3) {
        var n4 = t5.C, i4 = r3 - n4, a4 = t5.V, o4 = t5.Ba + t5.c * n4;
        for (e2(r3 <= t5.l.o); 0 < i4; ) {
          var s4 = 16 < i4 ? 16 : i4, c6 = t5.l.ma, u5 = t5.l.width, h6 = u5 * s4, l5 = c6.ca, f5 = c6.tb + u5 * n4, d4 = t5.Ta, p6 = t5.Ua;
          Nt2(t5, s4, a4, o4), _n(d4, p6, l5, f5, h6), xt2(c6, n4, n4 + s4, l5, f5, u5), i4 -= s4, a4 += s4 * t5.c, n4 += s4;
        }
        e2(n4 == r3), t5.C = t5.Ma = r3;
      }
      function jt2() {
        this.ub = this.yd = this.td = this.Rb = 0;
      }
      function Ot2() {
        this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
      }
      function Bt2() {
        this.Fb = this.Bb = this.Cb = 0, this.Zb = a3(4), this.Lb = a3(4);
      }
      function Et2() {
        this.Yb = function() {
          var t5 = [];
          return function t6(e3, r3, n4) {
            for (var i4 = n4[r3], a4 = 0; a4 < i4 && (e3.push(n4.length > r3 + 1 ? [] : 0), !(n4.length < r3 + 1)); a4++)
              t6(e3[a4], r3 + 1, n4);
          }(t5, 0, [3, 11]), t5;
        }();
      }
      function Mt2() {
        this.jb = a3(3), this.Wc = s3([4, 8], Et2), this.Xc = s3([4, 17], Et2);
      }
      function qt2() {
        this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a3(4), this.od = new a3(4);
      }
      function Dt2() {
        this.ld = this.La = this.dd = this.tc = 0;
      }
      function Rt2() {
        this.Na = this.la = 0;
      }
      function Tt2() {
        this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
      }
      function Ut2() {
        this.ad = a3(384), this.Za = 0, this.Ob = a3(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
      }
      function zt2() {
        this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt2()), this.Y = 0, this.ya = Array(new Ut2()), this.aa = 0, this.l = new Gt2();
      }
      function Ht2() {
        this.y = a3(16), this.f = a3(8), this.ea = a3(8);
      }
      function Wt2() {
        this.cb = this.a = 0, this.sc = "", this.m = new w3(), this.Od = new jt2(), this.Kc = new Ot2(), this.ed = new qt2(), this.Qa = new Bt2(), this.Ic = this.$c = this.Aa = 0, this.D = new zt2(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o3(8, w3), this.ia = 0, this.pb = o3(4, Tt2), this.Pa = new Mt2(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Ht2()), this.Hd = 0, this.rb = Array(new Rt2()), this.sb = 0, this.wa = Array(new Dt2()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut2()), this.L = this.aa = 0, this.gd = s3([4, 2], Dt2), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
      }
      function Vt2(t5, e3) {
        return 0 > t5 ? 0 : t5 > e3 ? e3 : t5;
      }
      function Gt2() {
        this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
      }
      function Yt2() {
        var t5 = new Wt2();
        return t5 != null && (t5.a = 0, t5.sc = "OK", t5.cb = 0, t5.Xb = 0, ni || (ni = Zt2)), t5;
      }
      function Jt2(t5, e3, r3) {
        return t5.a == 0 && (t5.a = e3, t5.sc = r3, t5.cb = 0), 0;
      }
      function Xt2(t5, e3, r3) {
        return 3 <= r3 && t5[e3 + 0] == 157 && t5[e3 + 1] == 1 && t5[e3 + 2] == 42;
      }
      function Kt2(t5, r3) {
        if (t5 == null)
          return 0;
        if (t5.a = 0, t5.sc = "OK", r3 == null)
          return Jt2(t5, 2, "null VP8Io passed to VP8GetHeaders()");
        var n4 = r3.data, a4 = r3.w, o4 = r3.ha;
        if (4 > o4)
          return Jt2(t5, 7, "Truncated header.");
        var s4 = n4[a4 + 0] | n4[a4 + 1] << 8 | n4[a4 + 2] << 16, c6 = t5.Od;
        if (c6.Rb = !(1 & s4), c6.td = s4 >> 1 & 7, c6.yd = s4 >> 4 & 1, c6.ub = s4 >> 5, 3 < c6.td)
          return Jt2(t5, 3, "Incorrect keyframe parameters.");
        if (!c6.yd)
          return Jt2(t5, 4, "Frame not displayable.");
        a4 += 3, o4 -= 3;
        var u5 = t5.Kc;
        if (c6.Rb) {
          if (7 > o4)
            return Jt2(t5, 7, "cannot parse picture header");
          if (!Xt2(n4, a4, o4))
            return Jt2(t5, 3, "Bad code word");
          u5.c = 16383 & (n4[a4 + 4] << 8 | n4[a4 + 3]), u5.Td = n4[a4 + 4] >> 6, u5.i = 16383 & (n4[a4 + 6] << 8 | n4[a4 + 5]), u5.Ud = n4[a4 + 6] >> 6, a4 += 7, o4 -= 7, t5.za = u5.c + 15 >> 4, t5.Ub = u5.i + 15 >> 4, r3.width = u5.c, r3.height = u5.i, r3.Da = 0, r3.j = 0, r3.v = 0, r3.va = r3.width, r3.o = r3.height, r3.da = 0, r3.ib = r3.width, r3.hb = r3.height, r3.U = r3.width, r3.T = r3.height, i3((s4 = t5.Pa).jb, 0, 255, s4.jb.length), e2((s4 = t5.Qa) != null), s4.Cb = 0, s4.Bb = 0, s4.Fb = 1, i3(s4.Zb, 0, 0, s4.Zb.length), i3(s4.Lb, 0, 0, s4.Lb);
        }
        if (c6.ub > o4)
          return Jt2(t5, 7, "bad partition length");
        p5(s4 = t5.m, n4, a4, c6.ub), a4 += c6.ub, o4 -= c6.ub, c6.Rb && (u5.Ld = P2(s4), u5.Kd = P2(s4)), u5 = t5.Qa;
        var h6, l5 = t5.Pa;
        if (e2(s4 != null), e2(u5 != null), u5.Cb = P2(s4), u5.Cb) {
          if (u5.Bb = P2(s4), P2(s4)) {
            for (u5.Fb = P2(s4), h6 = 0; 4 > h6; ++h6)
              u5.Zb[h6] = P2(s4) ? m5(s4, 7) : 0;
            for (h6 = 0; 4 > h6; ++h6)
              u5.Lb[h6] = P2(s4) ? m5(s4, 6) : 0;
          }
          if (u5.Bb)
            for (h6 = 0; 3 > h6; ++h6)
              l5.jb[h6] = P2(s4) ? g3(s4, 8) : 255;
        } else
          u5.Bb = 0;
        if (s4.Ka)
          return Jt2(t5, 3, "cannot parse segment header");
        if ((u5 = t5.ed).zd = P2(s4), u5.Tb = g3(s4, 6), u5.wb = g3(s4, 3), u5.Pc = P2(s4), u5.Pc && P2(s4)) {
          for (l5 = 0; 4 > l5; ++l5)
            P2(s4) && (u5.vd[l5] = m5(s4, 6));
          for (l5 = 0; 4 > l5; ++l5)
            P2(s4) && (u5.od[l5] = m5(s4, 6));
        }
        if (t5.L = u5.Tb == 0 ? 0 : u5.zd ? 1 : 2, s4.Ka)
          return Jt2(t5, 3, "cannot parse filter header");
        var f5 = o4;
        if (o4 = h6 = a4, a4 = h6 + f5, u5 = f5, t5.Xb = (1 << g3(t5.m, 2)) - 1, f5 < 3 * (l5 = t5.Xb))
          n4 = 7;
        else {
          for (h6 += 3 * l5, u5 -= 3 * l5, f5 = 0; f5 < l5; ++f5) {
            var d4 = n4[o4 + 0] | n4[o4 + 1] << 8 | n4[o4 + 2] << 16;
            d4 > u5 && (d4 = u5), p5(t5.Jc[+f5], n4, h6, d4), h6 += d4, u5 -= d4, o4 += 3;
          }
          p5(t5.Jc[+l5], n4, h6, u5), n4 = h6 < a4 ? 0 : 5;
        }
        if (n4 != 0)
          return Jt2(t5, n4, "cannot parse partitions");
        for (n4 = g3(h6 = t5.m, 7), o4 = P2(h6) ? m5(h6, 4) : 0, a4 = P2(h6) ? m5(h6, 4) : 0, u5 = P2(h6) ? m5(h6, 4) : 0, l5 = P2(h6) ? m5(h6, 4) : 0, h6 = P2(h6) ? m5(h6, 4) : 0, f5 = t5.Qa, d4 = 0; 4 > d4; ++d4) {
          if (f5.Cb) {
            var v5 = f5.Zb[d4];
            f5.Fb || (v5 += n4);
          } else {
            if (0 < d4) {
              t5.pb[d4] = t5.pb[0];
              continue;
            }
            v5 = n4;
          }
          var b4 = t5.pb[d4];
          b4.Sc[0] = ei[Vt2(v5 + o4, 127)], b4.Sc[1] = ri[Vt2(v5 + 0, 127)], b4.Eb[0] = 2 * ei[Vt2(v5 + a4, 127)], b4.Eb[1] = 101581 * ri[Vt2(v5 + u5, 127)] >> 16, 8 > b4.Eb[1] && (b4.Eb[1] = 8), b4.Qc[0] = ei[Vt2(v5 + l5, 117)], b4.Qc[1] = ri[Vt2(v5 + h6, 127)], b4.lc = v5 + h6;
        }
        if (!c6.Rb)
          return Jt2(t5, 4, "Not a key frame.");
        for (P2(s4), c6 = t5.Pa, n4 = 0; 4 > n4; ++n4) {
          for (o4 = 0; 8 > o4; ++o4)
            for (a4 = 0; 3 > a4; ++a4)
              for (u5 = 0; 11 > u5; ++u5)
                l5 = k2(s4, ui[n4][o4][a4][u5]) ? g3(s4, 8) : si[n4][o4][a4][u5], c6.Wc[n4][o4].Yb[a4][u5] = l5;
          for (o4 = 0; 17 > o4; ++o4)
            c6.Xc[n4][o4] = c6.Wc[n4][hi[o4]];
        }
        return t5.kc = P2(s4), t5.kc && (t5.Bd = g3(s4, 8)), t5.cb = 1;
      }
      function Zt2(t5, e3, r3, n4, i4, a4, o4) {
        var s4 = e3[i4].Yb[r3];
        for (r3 = 0; 16 > i4; ++i4) {
          if (!k2(t5, s4[r3 + 0]))
            return i4;
          for (; !k2(t5, s4[r3 + 1]); )
            if (s4 = e3[++i4].Yb[0], r3 = 0, i4 == 16)
              return 16;
          var c6 = e3[i4 + 1].Yb;
          if (k2(t5, s4[r3 + 2])) {
            var u5 = t5, h6 = 0;
            if (k2(u5, (f5 = s4)[(l5 = r3) + 3]))
              if (k2(u5, f5[l5 + 6])) {
                for (s4 = 0, l5 = 2 * (h6 = k2(u5, f5[l5 + 8])) + (f5 = k2(u5, f5[l5 + 9 + h6])), h6 = 0, f5 = ii[l5]; f5[s4]; ++s4)
                  h6 += h6 + k2(u5, f5[s4]);
                h6 += 3 + (8 << l5);
              } else
                k2(u5, f5[l5 + 7]) ? (h6 = 7 + 2 * k2(u5, 165), h6 += k2(u5, 145)) : h6 = 5 + k2(u5, 159);
            else
              h6 = k2(u5, f5[l5 + 4]) ? 3 + k2(u5, f5[l5 + 5]) : 2;
            s4 = c6[2];
          } else
            h6 = 1, s4 = c6[1];
          c6 = o4 + ai[i4], 0 > (u5 = t5).b && _3(u5);
          var l5, f5 = u5.b, d4 = (l5 = u5.Ca >> 1) - (u5.I >> f5) >> 31;
          --u5.b, u5.Ca += d4, u5.Ca |= 1, u5.I -= (l5 + 1 & d4) << f5, a4[c6] = ((h6 ^ d4) - d4) * n4[(0 < i4) + 0];
        }
        return 16;
      }
      function $t2(t5) {
        var e3 = t5.rb[t5.sb - 1];
        e3.la = 0, e3.Na = 0, i3(t5.zc, 0, 0, t5.zc.length), t5.ja = 0;
      }
      function Qt2(t5, r3) {
        if (t5 == null)
          return 0;
        if (r3 == null)
          return Jt2(t5, 2, "NULL VP8Io parameter in VP8Decode().");
        if (!t5.cb && !Kt2(t5, r3))
          return 0;
        if (e2(t5.cb), r3.ac == null || r3.ac(r3)) {
          r3.ob && (t5.L = 0);
          var s4 = Ri[t5.L];
          if (t5.L == 2 ? (t5.yb = 0, t5.zb = 0) : (t5.yb = r3.v - s4 >> 4, t5.zb = r3.j - s4 >> 4, 0 > t5.yb && (t5.yb = 0), 0 > t5.zb && (t5.zb = 0)), t5.Va = r3.o + 15 + s4 >> 4, t5.Hb = r3.va + 15 + s4 >> 4, t5.Hb > t5.za && (t5.Hb = t5.za), t5.Va > t5.Ub && (t5.Va = t5.Ub), 0 < t5.L) {
            var c6 = t5.ed;
            for (s4 = 0; 4 > s4; ++s4) {
              var u5;
              if (t5.Qa.Cb) {
                var h6 = t5.Qa.Lb[s4];
                t5.Qa.Fb || (h6 += c6.Tb);
              } else
                h6 = c6.Tb;
              for (u5 = 0; 1 >= u5; ++u5) {
                var l5 = t5.gd[s4][u5], f5 = h6;
                if (c6.Pc && (f5 += c6.vd[0], u5 && (f5 += c6.od[0])), 0 < (f5 = 0 > f5 ? 0 : 63 < f5 ? 63 : f5)) {
                  var d4 = f5;
                  0 < c6.wb && ((d4 = 4 < c6.wb ? d4 >> 2 : d4 >> 1) > 9 - c6.wb && (d4 = 9 - c6.wb)), 1 > d4 && (d4 = 1), l5.dd = d4, l5.tc = 2 * f5 + d4, l5.ld = 40 <= f5 ? 2 : 15 <= f5 ? 1 : 0;
                } else
                  l5.tc = 0;
                l5.La = u5;
              }
            }
          }
          s4 = 0;
        } else
          Jt2(t5, 6, "Frame setup failed"), s4 = t5.a;
        if (s4 = s4 == 0) {
          if (s4) {
            t5.$c = 0, 0 < t5.Aa || (t5.Ic = Ui);
            t: {
              s4 = t5.Ic;
              c6 = 4 * (d4 = t5.za);
              var p6 = 32 * d4, g4 = d4 + 1, m6 = 0 < t5.L ? d4 * (0 < t5.Aa ? 2 : 1) : 0, v5 = (t5.Aa == 2 ? 2 : 1) * d4;
              if ((l5 = c6 + 832 + (u5 = 3 * (16 * s4 + Ri[t5.L]) / 2 * p6) + (h6 = t5.Fa != null && 0 < t5.Fa.length ? t5.Kc.c * t5.Kc.i : 0)) != l5)
                s4 = 0;
              else {
                if (l5 > t5.Vb) {
                  if (t5.Vb = 0, t5.Ec = a3(l5), t5.Fc = 0, t5.Ec == null) {
                    s4 = Jt2(t5, 1, "no memory during frame initialization.");
                    break t;
                  }
                  t5.Vb = l5;
                }
                l5 = t5.Ec, f5 = t5.Fc, t5.Ac = l5, t5.Bc = f5, f5 += c6, t5.Gd = o3(p6, Ht2), t5.Hd = 0, t5.rb = o3(g4 + 1, Rt2), t5.sb = 1, t5.wa = m6 ? o3(m6, Dt2) : null, t5.Y = 0, t5.D.Nb = 0, t5.D.wa = t5.wa, t5.D.Y = t5.Y, 0 < t5.Aa && (t5.D.Y += d4), e2(true), t5.oc = l5, t5.pc = f5, f5 += 832, t5.ya = o3(v5, Ut2), t5.aa = 0, t5.D.ya = t5.ya, t5.D.aa = t5.aa, t5.Aa == 2 && (t5.D.aa += d4), t5.R = 16 * d4, t5.B = 8 * d4, d4 = (p6 = Ri[t5.L]) * t5.R, p6 = p6 / 2 * t5.B, t5.sa = l5, t5.ta = f5 + d4, t5.qa = t5.sa, t5.ra = t5.ta + 16 * s4 * t5.R + p6, t5.Ha = t5.qa, t5.Ia = t5.ra + 8 * s4 * t5.B + p6, t5.$c = 0, f5 += u5, t5.mb = h6 ? l5 : null, t5.nb = h6 ? f5 : null, e2(f5 + h6 <= t5.Fc + t5.Vb), $t2(t5), i3(t5.Ac, t5.Bc, 0, c6), s4 = 1;
              }
            }
            if (s4) {
              if (r3.ka = 0, r3.y = t5.sa, r3.O = t5.ta, r3.f = t5.qa, r3.N = t5.ra, r3.ea = t5.Ha, r3.Vd = t5.Ia, r3.fa = t5.R, r3.Rc = t5.B, r3.F = null, r3.J = 0, !Cn) {
                for (s4 = -255; 255 >= s4; ++s4)
                  Pn[255 + s4] = 0 > s4 ? -s4 : s4;
                for (s4 = -1020; 1020 >= s4; ++s4)
                  kn[1020 + s4] = -128 > s4 ? -128 : 127 < s4 ? 127 : s4;
                for (s4 = -112; 112 >= s4; ++s4)
                  In[112 + s4] = -16 > s4 ? -16 : 15 < s4 ? 15 : s4;
                for (s4 = -255; 510 >= s4; ++s4)
                  Fn[255 + s4] = 0 > s4 ? 0 : 255 < s4 ? 255 : s4;
                Cn = 1;
              }
              an = ue2, on3 = ae2, cn = oe2, un = se2, hn = ce2, sn = ie2, ln2 = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le2, fi[2] = Le2, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve2, li[1] = de2, li[2] = pe2, li[3] = ge2, li[4] = be2, li[5] = ye2, li[6] = we2, di[0] = Be, di[1] = fe2, di[2] = Ce, di[3] = je, di[4] = Me, di[5] = Ee, di[6] = qe, s4 = 1;
            } else
              s4 = 0;
          }
          s4 && (s4 = function(t6, r4) {
            for (t6.M = 0; t6.M < t6.Va; ++t6.M) {
              var o4, s5 = t6.Jc[t6.M & t6.Xb], c7 = t6.m, u6 = t6;
              for (o4 = 0; o4 < u6.za; ++o4) {
                var h7 = c7, l6 = u6, f6 = l6.Ac, d5 = l6.Bc + 4 * o4, p7 = l6.zc, g5 = l6.ya[l6.aa + o4];
                if (l6.Qa.Bb ? g5.$b = k2(h7, l6.Pa.jb[0]) ? 2 + k2(h7, l6.Pa.jb[2]) : k2(h7, l6.Pa.jb[1]) : g5.$b = 0, l6.kc && (g5.Ad = k2(h7, l6.Bd)), g5.Za = !k2(h7, 145) + 0, g5.Za) {
                  var m7 = g5.Ob, v6 = 0;
                  for (l6 = 0; 4 > l6; ++l6) {
                    var b4, y5 = p7[0 + l6];
                    for (b4 = 0; 4 > b4; ++b4) {
                      y5 = ci[f6[d5 + b4]][y5];
                      for (var w4 = oi[k2(h7, y5[0])]; 0 < w4; )
                        w4 = oi[2 * w4 + k2(h7, y5[w4])];
                      y5 = -w4, f6[d5 + b4] = y5;
                    }
                    n3(m7, v6, f6, d5, 4), v6 += 4, p7[0 + l6] = y5;
                  }
                } else
                  y5 = k2(h7, 156) ? k2(h7, 128) ? 1 : 3 : k2(h7, 163) ? 2 : 0, g5.Ob[0] = y5, i3(f6, d5, y5, 4), i3(p7, 0, y5, 4);
                g5.Dd = k2(h7, 142) ? k2(h7, 114) ? k2(h7, 183) ? 1 : 3 : 2 : 0;
              }
              if (u6.m.Ka)
                return Jt2(t6, 7, "Premature end-of-partition0 encountered.");
              for (; t6.ja < t6.za; ++t6.ja) {
                if (u6 = s5, h7 = (c7 = t6).rb[c7.sb - 1], f6 = c7.rb[c7.sb + c7.ja], o4 = c7.ya[c7.aa + c7.ja], d5 = c7.kc ? o4.Ad : 0)
                  h7.la = f6.la = 0, o4.Za || (h7.Na = f6.Na = 0), o4.Hc = 0, o4.Gc = 0, o4.ia = 0;
                else {
                  var N5, L4;
                  h7 = f6, f6 = u6, d5 = c7.Pa.Xc, p7 = c7.ya[c7.aa + c7.ja], g5 = c7.pb[p7.$b];
                  if (l6 = p7.ad, m7 = 0, v6 = c7.rb[c7.sb - 1], y5 = b4 = 0, i3(l6, m7, 0, 384), p7.Za)
                    var A4 = 0, x3 = d5[3];
                  else {
                    w4 = a3(16);
                    var S3 = h7.Na + v6.Na;
                    if (S3 = ni(f6, d5[1], S3, g5.Eb, 0, w4, 0), h7.Na = v6.Na = (0 < S3) + 0, 1 < S3)
                      an(w4, 0, l6, m7);
                    else {
                      var _4 = w4[0] + 3 >> 3;
                      for (w4 = 0; 256 > w4; w4 += 16)
                        l6[m7 + w4] = _4;
                    }
                    A4 = 1, x3 = d5[0];
                  }
                  var P3 = 15 & h7.la, I3 = 15 & v6.la;
                  for (w4 = 0; 4 > w4; ++w4) {
                    var F3 = 1 & I3;
                    for (_4 = L4 = 0; 4 > _4; ++_4)
                      P3 = P3 >> 1 | (F3 = (S3 = ni(f6, x3, S3 = F3 + (1 & P3), g5.Sc, A4, l6, m7)) > A4) << 7, L4 = L4 << 2 | (3 < S3 ? 3 : 1 < S3 ? 2 : l6[m7 + 0] != 0), m7 += 16;
                    P3 >>= 4, I3 = I3 >> 1 | F3 << 7, b4 = (b4 << 8 | L4) >>> 0;
                  }
                  for (x3 = P3, A4 = I3 >> 4, N5 = 0; 4 > N5; N5 += 2) {
                    for (L4 = 0, P3 = h7.la >> 4 + N5, I3 = v6.la >> 4 + N5, w4 = 0; 2 > w4; ++w4) {
                      for (F3 = 1 & I3, _4 = 0; 2 > _4; ++_4)
                        S3 = F3 + (1 & P3), P3 = P3 >> 1 | (F3 = 0 < (S3 = ni(f6, d5[2], S3, g5.Qc, 0, l6, m7))) << 3, L4 = L4 << 2 | (3 < S3 ? 3 : 1 < S3 ? 2 : l6[m7 + 0] != 0), m7 += 16;
                      P3 >>= 2, I3 = I3 >> 1 | F3 << 5;
                    }
                    y5 |= L4 << 4 * N5, x3 |= P3 << 4 << N5, A4 |= (240 & I3) << N5;
                  }
                  h7.la = x3, v6.la = A4, p7.Hc = b4, p7.Gc = y5, p7.ia = 43690 & y5 ? 0 : g5.ia, d5 = !(b4 | y5);
                }
                if (0 < c7.L && (c7.wa[c7.Y + c7.ja] = c7.gd[o4.$b][o4.Za], c7.wa[c7.Y + c7.ja].La |= !d5), u6.Ka)
                  return Jt2(t6, 7, "Premature end-of-file encountered.");
              }
              if ($t2(t6), c7 = r4, u6 = 1, o4 = (s5 = t6).D, h7 = 0 < s5.L && s5.M >= s5.zb && s5.M <= s5.Va, s5.Aa == 0)
                t: {
                  if (o4.M = s5.M, o4.uc = h7, Or(s5, o4), u6 = 1, o4 = (L4 = s5.D).Nb, h7 = (y5 = Ri[s5.L]) * s5.R, f6 = y5 / 2 * s5.B, w4 = 16 * o4 * s5.R, _4 = 8 * o4 * s5.B, d5 = s5.sa, p7 = s5.ta - h7 + w4, g5 = s5.qa, l6 = s5.ra - f6 + _4, m7 = s5.Ha, v6 = s5.Ia - f6 + _4, I3 = (P3 = L4.M) == 0, b4 = P3 >= s5.Va - 1, s5.Aa == 2 && Or(s5, L4), L4.uc)
                    for (F3 = (S3 = s5).D.M, e2(S3.D.uc), L4 = S3.yb; L4 < S3.Hb; ++L4) {
                      A4 = L4, x3 = F3;
                      var C3 = (j3 = (U3 = S3).D).Nb;
                      N5 = U3.R;
                      var j3 = j3.wa[j3.Y + A4], O4 = U3.sa, B3 = U3.ta + 16 * C3 * N5 + 16 * A4, E3 = j3.dd, M3 = j3.tc;
                      if (M3 != 0)
                        if (e2(3 <= M3), U3.L == 1)
                          0 < A4 && wn(O4, B3, N5, M3 + 4), j3.La && Ln(O4, B3, N5, M3), 0 < x3 && yn(O4, B3, N5, M3 + 4), j3.La && Nn(O4, B3, N5, M3);
                        else {
                          var q3 = U3.B, D3 = U3.qa, R3 = U3.ra + 8 * C3 * q3 + 8 * A4, T4 = U3.Ha, U3 = U3.Ia + 8 * C3 * q3 + 8 * A4;
                          C3 = j3.ld;
                          0 < A4 && (fn(O4, B3, N5, M3 + 4, E3, C3), pn(D3, R3, T4, U3, q3, M3 + 4, E3, C3)), j3.La && (mn(O4, B3, N5, M3, E3, C3), bn(D3, R3, T4, U3, q3, M3, E3, C3)), 0 < x3 && (ln2(O4, B3, N5, M3 + 4, E3, C3), dn(D3, R3, T4, U3, q3, M3 + 4, E3, C3)), j3.La && (gn(O4, B3, N5, M3, E3, C3), vn(D3, R3, T4, U3, q3, M3, E3, C3));
                        }
                    }
                  if (s5.ia && alert("todo:DitherRow"), c7.put != null) {
                    if (L4 = 16 * P3, P3 = 16 * (P3 + 1), I3 ? (c7.y = s5.sa, c7.O = s5.ta + w4, c7.f = s5.qa, c7.N = s5.ra + _4, c7.ea = s5.Ha, c7.W = s5.Ia + _4) : (L4 -= y5, c7.y = d5, c7.O = p7, c7.f = g5, c7.N = l6, c7.ea = m7, c7.W = v6), b4 || (P3 -= y5), P3 > c7.o && (P3 = c7.o), c7.F = null, c7.J = null, s5.Fa != null && 0 < s5.Fa.length && L4 < P3 && (c7.J = lr(s5, c7, L4, P3 - L4), c7.F = s5.mb, c7.F == null && c7.F.length == 0)) {
                      u6 = Jt2(s5, 3, "Could not decode alpha data.");
                      break t;
                    }
                    L4 < c7.j && (y5 = c7.j - L4, L4 = c7.j, e2(!(1 & y5)), c7.O += s5.R * y5, c7.N += s5.B * (y5 >> 1), c7.W += s5.B * (y5 >> 1), c7.F != null && (c7.J += c7.width * y5)), L4 < P3 && (c7.O += c7.v, c7.N += c7.v >> 1, c7.W += c7.v >> 1, c7.F != null && (c7.J += c7.v), c7.ka = L4 - c7.j, c7.U = c7.va - c7.v, c7.T = P3 - L4, u6 = c7.put(c7));
                  }
                  o4 + 1 != s5.Ic || b4 || (n3(s5.sa, s5.ta - h7, d5, p7 + 16 * s5.R, h7), n3(s5.qa, s5.ra - f6, g5, l6 + 8 * s5.B, f6), n3(s5.Ha, s5.Ia - f6, m7, v6 + 8 * s5.B, f6));
                }
              if (!u6)
                return Jt2(t6, 6, "Output aborted.");
            }
            return 1;
          }(t5, r3)), r3.bc != null && r3.bc(r3), s4 &= 1;
        }
        return s4 ? (t5.cb = 0, s4) : 0;
      }
      function te2(t5, e3, r3, n4, i4) {
        i4 = t5[e3 + r3 + 32 * n4] + (i4 >> 3), t5[e3 + r3 + 32 * n4] = -256 & i4 ? 0 > i4 ? 0 : 255 : i4;
      }
      function ee2(t5, e3, r3, n4, i4, a4) {
        te2(t5, e3, 0, r3, n4 + i4), te2(t5, e3, 1, r3, n4 + a4), te2(t5, e3, 2, r3, n4 - a4), te2(t5, e3, 3, r3, n4 - i4);
      }
      function re2(t5) {
        return (20091 * t5 >> 16) + t5;
      }
      function ne2(t5, e3, r3, n4) {
        var i4, o4 = 0, s4 = a3(16);
        for (i4 = 0; 4 > i4; ++i4) {
          var c6 = t5[e3 + 0] + t5[e3 + 8], u5 = t5[e3 + 0] - t5[e3 + 8], h6 = (35468 * t5[e3 + 4] >> 16) - re2(t5[e3 + 12]), l5 = re2(t5[e3 + 4]) + (35468 * t5[e3 + 12] >> 16);
          s4[o4 + 0] = c6 + l5, s4[o4 + 1] = u5 + h6, s4[o4 + 2] = u5 - h6, s4[o4 + 3] = c6 - l5, o4 += 4, e3++;
        }
        for (i4 = o4 = 0; 4 > i4; ++i4)
          c6 = (t5 = s4[o4 + 0] + 4) + s4[o4 + 8], u5 = t5 - s4[o4 + 8], h6 = (35468 * s4[o4 + 4] >> 16) - re2(s4[o4 + 12]), te2(r3, n4, 0, 0, c6 + (l5 = re2(s4[o4 + 4]) + (35468 * s4[o4 + 12] >> 16))), te2(r3, n4, 1, 0, u5 + h6), te2(r3, n4, 2, 0, u5 - h6), te2(r3, n4, 3, 0, c6 - l5), o4++, n4 += 32;
      }
      function ie2(t5, e3, r3, n4) {
        var i4 = t5[e3 + 0] + 4, a4 = 35468 * t5[e3 + 4] >> 16, o4 = re2(t5[e3 + 4]), s4 = 35468 * t5[e3 + 1] >> 16;
        ee2(r3, n4, 0, i4 + o4, t5 = re2(t5[e3 + 1]), s4), ee2(r3, n4, 1, i4 + a4, t5, s4), ee2(r3, n4, 2, i4 - a4, t5, s4), ee2(r3, n4, 3, i4 - o4, t5, s4);
      }
      function ae2(t5, e3, r3, n4, i4) {
        ne2(t5, e3, r3, n4), i4 && ne2(t5, e3 + 16, r3, n4 + 4);
      }
      function oe2(t5, e3, r3, n4) {
        on3(t5, e3 + 0, r3, n4, 1), on3(t5, e3 + 32, r3, n4 + 128, 1);
      }
      function se2(t5, e3, r3, n4) {
        var i4;
        for (t5 = t5[e3 + 0] + 4, i4 = 0; 4 > i4; ++i4)
          for (e3 = 0; 4 > e3; ++e3)
            te2(r3, n4, e3, i4, t5);
      }
      function ce2(t5, e3, r3, n4) {
        t5[e3 + 0] && un(t5, e3 + 0, r3, n4), t5[e3 + 16] && un(t5, e3 + 16, r3, n4 + 4), t5[e3 + 32] && un(t5, e3 + 32, r3, n4 + 128), t5[e3 + 48] && un(t5, e3 + 48, r3, n4 + 128 + 4);
      }
      function ue2(t5, e3, r3, n4) {
        var i4, o4 = a3(16);
        for (i4 = 0; 4 > i4; ++i4) {
          var s4 = t5[e3 + 0 + i4] + t5[e3 + 12 + i4], c6 = t5[e3 + 4 + i4] + t5[e3 + 8 + i4], u5 = t5[e3 + 4 + i4] - t5[e3 + 8 + i4], h6 = t5[e3 + 0 + i4] - t5[e3 + 12 + i4];
          o4[0 + i4] = s4 + c6, o4[8 + i4] = s4 - c6, o4[4 + i4] = h6 + u5, o4[12 + i4] = h6 - u5;
        }
        for (i4 = 0; 4 > i4; ++i4)
          s4 = (t5 = o4[0 + 4 * i4] + 3) + o4[3 + 4 * i4], c6 = o4[1 + 4 * i4] + o4[2 + 4 * i4], u5 = o4[1 + 4 * i4] - o4[2 + 4 * i4], h6 = t5 - o4[3 + 4 * i4], r3[n4 + 0] = s4 + c6 >> 3, r3[n4 + 16] = h6 + u5 >> 3, r3[n4 + 32] = s4 - c6 >> 3, r3[n4 + 48] = h6 - u5 >> 3, n4 += 64;
      }
      function he2(t5, e3, r3) {
        var n4, i4 = e3 - 32, a4 = Bn, o4 = 255 - t5[i4 - 1];
        for (n4 = 0; n4 < r3; ++n4) {
          var s4, c6 = a4, u5 = o4 + t5[e3 - 1];
          for (s4 = 0; s4 < r3; ++s4)
            t5[e3 + s4] = c6[u5 + t5[i4 + s4]];
          e3 += 32;
        }
      }
      function le2(t5, e3) {
        he2(t5, e3, 4);
      }
      function fe2(t5, e3) {
        he2(t5, e3, 8);
      }
      function de2(t5, e3) {
        he2(t5, e3, 16);
      }
      function pe2(t5, e3) {
        var r3;
        for (r3 = 0; 16 > r3; ++r3)
          n3(t5, e3 + 32 * r3, t5, e3 - 32, 16);
      }
      function ge2(t5, e3) {
        var r3;
        for (r3 = 16; 0 < r3; --r3)
          i3(t5, e3, t5[e3 - 1], 16), e3 += 32;
      }
      function me2(t5, e3, r3) {
        var n4;
        for (n4 = 0; 16 > n4; ++n4)
          i3(e3, r3 + 32 * n4, t5, 16);
      }
      function ve2(t5, e3) {
        var r3, n4 = 16;
        for (r3 = 0; 16 > r3; ++r3)
          n4 += t5[e3 - 1 + 32 * r3] + t5[e3 + r3 - 32];
        me2(n4 >> 5, t5, e3);
      }
      function be2(t5, e3) {
        var r3, n4 = 8;
        for (r3 = 0; 16 > r3; ++r3)
          n4 += t5[e3 - 1 + 32 * r3];
        me2(n4 >> 4, t5, e3);
      }
      function ye2(t5, e3) {
        var r3, n4 = 8;
        for (r3 = 0; 16 > r3; ++r3)
          n4 += t5[e3 + r3 - 32];
        me2(n4 >> 4, t5, e3);
      }
      function we2(t5, e3) {
        me2(128, t5, e3);
      }
      function Ne2(t5, e3, r3) {
        return t5 + 2 * e3 + r3 + 2 >> 2;
      }
      function Le2(t5, e3) {
        var r3, i4 = e3 - 32;
        i4 = new Uint8Array([Ne2(t5[i4 - 1], t5[i4 + 0], t5[i4 + 1]), Ne2(t5[i4 + 0], t5[i4 + 1], t5[i4 + 2]), Ne2(t5[i4 + 1], t5[i4 + 2], t5[i4 + 3]), Ne2(t5[i4 + 2], t5[i4 + 3], t5[i4 + 4])]);
        for (r3 = 0; 4 > r3; ++r3)
          n3(t5, e3 + 32 * r3, i4, 0, i4.length);
      }
      function Ae(t5, e3) {
        var r3 = t5[e3 - 1], n4 = t5[e3 - 1 + 32], i4 = t5[e3 - 1 + 64], a4 = t5[e3 - 1 + 96];
        I2(t5, e3 + 0, 16843009 * Ne2(t5[e3 - 1 - 32], r3, n4)), I2(t5, e3 + 32, 16843009 * Ne2(r3, n4, i4)), I2(t5, e3 + 64, 16843009 * Ne2(n4, i4, a4)), I2(t5, e3 + 96, 16843009 * Ne2(i4, a4, a4));
      }
      function xe(t5, e3) {
        var r3, n4 = 4;
        for (r3 = 0; 4 > r3; ++r3)
          n4 += t5[e3 + r3 - 32] + t5[e3 - 1 + 32 * r3];
        for (n4 >>= 3, r3 = 0; 4 > r3; ++r3)
          i3(t5, e3 + 32 * r3, n4, 4);
      }
      function Se(t5, e3) {
        var r3 = t5[e3 - 1 + 0], n4 = t5[e3 - 1 + 32], i4 = t5[e3 - 1 + 64], a4 = t5[e3 - 1 - 32], o4 = t5[e3 + 0 - 32], s4 = t5[e3 + 1 - 32], c6 = t5[e3 + 2 - 32], u5 = t5[e3 + 3 - 32];
        t5[e3 + 0 + 96] = Ne2(n4, i4, t5[e3 - 1 + 96]), t5[e3 + 1 + 96] = t5[e3 + 0 + 64] = Ne2(r3, n4, i4), t5[e3 + 2 + 96] = t5[e3 + 1 + 64] = t5[e3 + 0 + 32] = Ne2(a4, r3, n4), t5[e3 + 3 + 96] = t5[e3 + 2 + 64] = t5[e3 + 1 + 32] = t5[e3 + 0 + 0] = Ne2(o4, a4, r3), t5[e3 + 3 + 64] = t5[e3 + 2 + 32] = t5[e3 + 1 + 0] = Ne2(s4, o4, a4), t5[e3 + 3 + 32] = t5[e3 + 2 + 0] = Ne2(c6, s4, o4), t5[e3 + 3 + 0] = Ne2(u5, c6, s4);
      }
      function _e(t5, e3) {
        var r3 = t5[e3 + 1 - 32], n4 = t5[e3 + 2 - 32], i4 = t5[e3 + 3 - 32], a4 = t5[e3 + 4 - 32], o4 = t5[e3 + 5 - 32], s4 = t5[e3 + 6 - 32], c6 = t5[e3 + 7 - 32];
        t5[e3 + 0 + 0] = Ne2(t5[e3 + 0 - 32], r3, n4), t5[e3 + 1 + 0] = t5[e3 + 0 + 32] = Ne2(r3, n4, i4), t5[e3 + 2 + 0] = t5[e3 + 1 + 32] = t5[e3 + 0 + 64] = Ne2(n4, i4, a4), t5[e3 + 3 + 0] = t5[e3 + 2 + 32] = t5[e3 + 1 + 64] = t5[e3 + 0 + 96] = Ne2(i4, a4, o4), t5[e3 + 3 + 32] = t5[e3 + 2 + 64] = t5[e3 + 1 + 96] = Ne2(a4, o4, s4), t5[e3 + 3 + 64] = t5[e3 + 2 + 96] = Ne2(o4, s4, c6), t5[e3 + 3 + 96] = Ne2(s4, c6, c6);
      }
      function Pe(t5, e3) {
        var r3 = t5[e3 - 1 + 0], n4 = t5[e3 - 1 + 32], i4 = t5[e3 - 1 + 64], a4 = t5[e3 - 1 - 32], o4 = t5[e3 + 0 - 32], s4 = t5[e3 + 1 - 32], c6 = t5[e3 + 2 - 32], u5 = t5[e3 + 3 - 32];
        t5[e3 + 0 + 0] = t5[e3 + 1 + 64] = a4 + o4 + 1 >> 1, t5[e3 + 1 + 0] = t5[e3 + 2 + 64] = o4 + s4 + 1 >> 1, t5[e3 + 2 + 0] = t5[e3 + 3 + 64] = s4 + c6 + 1 >> 1, t5[e3 + 3 + 0] = c6 + u5 + 1 >> 1, t5[e3 + 0 + 96] = Ne2(i4, n4, r3), t5[e3 + 0 + 64] = Ne2(n4, r3, a4), t5[e3 + 0 + 32] = t5[e3 + 1 + 96] = Ne2(r3, a4, o4), t5[e3 + 1 + 32] = t5[e3 + 2 + 96] = Ne2(a4, o4, s4), t5[e3 + 2 + 32] = t5[e3 + 3 + 96] = Ne2(o4, s4, c6), t5[e3 + 3 + 32] = Ne2(s4, c6, u5);
      }
      function ke(t5, e3) {
        var r3 = t5[e3 + 0 - 32], n4 = t5[e3 + 1 - 32], i4 = t5[e3 + 2 - 32], a4 = t5[e3 + 3 - 32], o4 = t5[e3 + 4 - 32], s4 = t5[e3 + 5 - 32], c6 = t5[e3 + 6 - 32], u5 = t5[e3 + 7 - 32];
        t5[e3 + 0 + 0] = r3 + n4 + 1 >> 1, t5[e3 + 1 + 0] = t5[e3 + 0 + 64] = n4 + i4 + 1 >> 1, t5[e3 + 2 + 0] = t5[e3 + 1 + 64] = i4 + a4 + 1 >> 1, t5[e3 + 3 + 0] = t5[e3 + 2 + 64] = a4 + o4 + 1 >> 1, t5[e3 + 0 + 32] = Ne2(r3, n4, i4), t5[e3 + 1 + 32] = t5[e3 + 0 + 96] = Ne2(n4, i4, a4), t5[e3 + 2 + 32] = t5[e3 + 1 + 96] = Ne2(i4, a4, o4), t5[e3 + 3 + 32] = t5[e3 + 2 + 96] = Ne2(a4, o4, s4), t5[e3 + 3 + 64] = Ne2(o4, s4, c6), t5[e3 + 3 + 96] = Ne2(s4, c6, u5);
      }
      function Ie(t5, e3) {
        var r3 = t5[e3 - 1 + 0], n4 = t5[e3 - 1 + 32], i4 = t5[e3 - 1 + 64], a4 = t5[e3 - 1 + 96];
        t5[e3 + 0 + 0] = r3 + n4 + 1 >> 1, t5[e3 + 2 + 0] = t5[e3 + 0 + 32] = n4 + i4 + 1 >> 1, t5[e3 + 2 + 32] = t5[e3 + 0 + 64] = i4 + a4 + 1 >> 1, t5[e3 + 1 + 0] = Ne2(r3, n4, i4), t5[e3 + 3 + 0] = t5[e3 + 1 + 32] = Ne2(n4, i4, a4), t5[e3 + 3 + 32] = t5[e3 + 1 + 64] = Ne2(i4, a4, a4), t5[e3 + 3 + 64] = t5[e3 + 2 + 64] = t5[e3 + 0 + 96] = t5[e3 + 1 + 96] = t5[e3 + 2 + 96] = t5[e3 + 3 + 96] = a4;
      }
      function Fe(t5, e3) {
        var r3 = t5[e3 - 1 + 0], n4 = t5[e3 - 1 + 32], i4 = t5[e3 - 1 + 64], a4 = t5[e3 - 1 + 96], o4 = t5[e3 - 1 - 32], s4 = t5[e3 + 0 - 32], c6 = t5[e3 + 1 - 32], u5 = t5[e3 + 2 - 32];
        t5[e3 + 0 + 0] = t5[e3 + 2 + 32] = r3 + o4 + 1 >> 1, t5[e3 + 0 + 32] = t5[e3 + 2 + 64] = n4 + r3 + 1 >> 1, t5[e3 + 0 + 64] = t5[e3 + 2 + 96] = i4 + n4 + 1 >> 1, t5[e3 + 0 + 96] = a4 + i4 + 1 >> 1, t5[e3 + 3 + 0] = Ne2(s4, c6, u5), t5[e3 + 2 + 0] = Ne2(o4, s4, c6), t5[e3 + 1 + 0] = t5[e3 + 3 + 32] = Ne2(r3, o4, s4), t5[e3 + 1 + 32] = t5[e3 + 3 + 64] = Ne2(n4, r3, o4), t5[e3 + 1 + 64] = t5[e3 + 3 + 96] = Ne2(i4, n4, r3), t5[e3 + 1 + 96] = Ne2(a4, i4, n4);
      }
      function Ce(t5, e3) {
        var r3;
        for (r3 = 0; 8 > r3; ++r3)
          n3(t5, e3 + 32 * r3, t5, e3 - 32, 8);
      }
      function je(t5, e3) {
        var r3;
        for (r3 = 0; 8 > r3; ++r3)
          i3(t5, e3, t5[e3 - 1], 8), e3 += 32;
      }
      function Oe(t5, e3, r3) {
        var n4;
        for (n4 = 0; 8 > n4; ++n4)
          i3(e3, r3 + 32 * n4, t5, 8);
      }
      function Be(t5, e3) {
        var r3, n4 = 8;
        for (r3 = 0; 8 > r3; ++r3)
          n4 += t5[e3 + r3 - 32] + t5[e3 - 1 + 32 * r3];
        Oe(n4 >> 4, t5, e3);
      }
      function Ee(t5, e3) {
        var r3, n4 = 4;
        for (r3 = 0; 8 > r3; ++r3)
          n4 += t5[e3 + r3 - 32];
        Oe(n4 >> 3, t5, e3);
      }
      function Me(t5, e3) {
        var r3, n4 = 4;
        for (r3 = 0; 8 > r3; ++r3)
          n4 += t5[e3 - 1 + 32 * r3];
        Oe(n4 >> 3, t5, e3);
      }
      function qe(t5, e3) {
        Oe(128, t5, e3);
      }
      function De(t5, e3, r3) {
        var n4 = t5[e3 - r3], i4 = t5[e3 + 0], a4 = 3 * (i4 - n4) + jn[1020 + t5[e3 - 2 * r3] - t5[e3 + r3]], o4 = On[112 + (a4 + 4 >> 3)];
        t5[e3 - r3] = Bn[255 + n4 + On[112 + (a4 + 3 >> 3)]], t5[e3 + 0] = Bn[255 + i4 - o4];
      }
      function Re(t5, e3, r3, n4) {
        var i4 = t5[e3 + 0], a4 = t5[e3 + r3];
        return En[255 + t5[e3 - 2 * r3] - t5[e3 - r3]] > n4 || En[255 + a4 - i4] > n4;
      }
      function Te(t5, e3, r3, n4) {
        return 4 * En[255 + t5[e3 - r3] - t5[e3 + 0]] + En[255 + t5[e3 - 2 * r3] - t5[e3 + r3]] <= n4;
      }
      function Ue(t5, e3, r3, n4, i4) {
        var a4 = t5[e3 - 3 * r3], o4 = t5[e3 - 2 * r3], s4 = t5[e3 - r3], c6 = t5[e3 + 0], u5 = t5[e3 + r3], h6 = t5[e3 + 2 * r3], l5 = t5[e3 + 3 * r3];
        return 4 * En[255 + s4 - c6] + En[255 + o4 - u5] > n4 ? 0 : En[255 + t5[e3 - 4 * r3] - a4] <= i4 && En[255 + a4 - o4] <= i4 && En[255 + o4 - s4] <= i4 && En[255 + l5 - h6] <= i4 && En[255 + h6 - u5] <= i4 && En[255 + u5 - c6] <= i4;
      }
      function ze(t5, e3, r3, n4) {
        var i4 = 2 * n4 + 1;
        for (n4 = 0; 16 > n4; ++n4)
          Te(t5, e3 + n4, r3, i4) && De(t5, e3 + n4, r3);
      }
      function He(t5, e3, r3, n4) {
        var i4 = 2 * n4 + 1;
        for (n4 = 0; 16 > n4; ++n4)
          Te(t5, e3 + n4 * r3, 1, i4) && De(t5, e3 + n4 * r3, 1);
      }
      function We(t5, e3, r3, n4) {
        var i4;
        for (i4 = 3; 0 < i4; --i4)
          ze(t5, e3 += 4 * r3, r3, n4);
      }
      function Ve(t5, e3, r3, n4) {
        var i4;
        for (i4 = 3; 0 < i4; --i4)
          He(t5, e3 += 4, r3, n4);
      }
      function Ge(t5, e3, r3, n4, i4, a4, o4, s4) {
        for (a4 = 2 * a4 + 1; 0 < i4--; ) {
          if (Ue(t5, e3, r3, a4, o4))
            if (Re(t5, e3, r3, s4))
              De(t5, e3, r3);
            else {
              var c6 = t5, u5 = e3, h6 = r3, l5 = c6[u5 - 2 * h6], f5 = c6[u5 - h6], d4 = c6[u5 + 0], p6 = c6[u5 + h6], g4 = c6[u5 + 2 * h6], m6 = 27 * (b4 = jn[1020 + 3 * (d4 - f5) + jn[1020 + l5 - p6]]) + 63 >> 7, v5 = 18 * b4 + 63 >> 7, b4 = 9 * b4 + 63 >> 7;
              c6[u5 - 3 * h6] = Bn[255 + c6[u5 - 3 * h6] + b4], c6[u5 - 2 * h6] = Bn[255 + l5 + v5], c6[u5 - h6] = Bn[255 + f5 + m6], c6[u5 + 0] = Bn[255 + d4 - m6], c6[u5 + h6] = Bn[255 + p6 - v5], c6[u5 + 2 * h6] = Bn[255 + g4 - b4];
            }
          e3 += n4;
        }
      }
      function Ye(t5, e3, r3, n4, i4, a4, o4, s4) {
        for (a4 = 2 * a4 + 1; 0 < i4--; ) {
          if (Ue(t5, e3, r3, a4, o4))
            if (Re(t5, e3, r3, s4))
              De(t5, e3, r3);
            else {
              var c6 = t5, u5 = e3, h6 = r3, l5 = c6[u5 - h6], f5 = c6[u5 + 0], d4 = c6[u5 + h6], p6 = On[112 + ((g4 = 3 * (f5 - l5)) + 4 >> 3)], g4 = On[112 + (g4 + 3 >> 3)], m6 = p6 + 1 >> 1;
              c6[u5 - 2 * h6] = Bn[255 + c6[u5 - 2 * h6] + m6], c6[u5 - h6] = Bn[255 + l5 + g4], c6[u5 + 0] = Bn[255 + f5 - p6], c6[u5 + h6] = Bn[255 + d4 - m6];
            }
          e3 += n4;
        }
      }
      function Je(t5, e3, r3, n4, i4, a4) {
        Ge(t5, e3, r3, 1, 16, n4, i4, a4);
      }
      function Xe(t5, e3, r3, n4, i4, a4) {
        Ge(t5, e3, 1, r3, 16, n4, i4, a4);
      }
      function Ke(t5, e3, r3, n4, i4, a4) {
        var o4;
        for (o4 = 3; 0 < o4; --o4)
          Ye(t5, e3 += 4 * r3, r3, 1, 16, n4, i4, a4);
      }
      function Ze(t5, e3, r3, n4, i4, a4) {
        var o4;
        for (o4 = 3; 0 < o4; --o4)
          Ye(t5, e3 += 4, 1, r3, 16, n4, i4, a4);
      }
      function $e(t5, e3, r3, n4, i4, a4, o4, s4) {
        Ge(t5, e3, i4, 1, 8, a4, o4, s4), Ge(r3, n4, i4, 1, 8, a4, o4, s4);
      }
      function Qe(t5, e3, r3, n4, i4, a4, o4, s4) {
        Ge(t5, e3, 1, i4, 8, a4, o4, s4), Ge(r3, n4, 1, i4, 8, a4, o4, s4);
      }
      function tr(t5, e3, r3, n4, i4, a4, o4, s4) {
        Ye(t5, e3 + 4 * i4, i4, 1, 8, a4, o4, s4), Ye(r3, n4 + 4 * i4, i4, 1, 8, a4, o4, s4);
      }
      function er(t5, e3, r3, n4, i4, a4, o4, s4) {
        Ye(t5, e3 + 4, 1, i4, 8, a4, o4, s4), Ye(r3, n4 + 4, 1, i4, 8, a4, o4, s4);
      }
      function rr() {
        this.ba = new ot2(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct2(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
      }
      function nr() {
        this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
      }
      function ir() {
        this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
      }
      function ar() {
        this.ua = 0, this.Wa = new E2(), this.vb = new E2(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d3(), this.yc = new l4();
      }
      function or() {
        this.xb = this.a = 0, this.l = new Gt2(), this.ca = new ot2(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N4(), this.Pb = 0, this.wd = new N4(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar(), this.ab = 0, this.gc = o3(4, ir), this.Oc = 0;
      }
      function sr() {
        this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt2(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
      }
      function cr(t5, e3, r3, n4, i4, a4, o4) {
        for (t5 = t5 == null ? 0 : t5[e3 + 0], e3 = 0; e3 < o4; ++e3)
          i4[a4 + e3] = t5 + r3[n4 + e3] & 255, t5 = i4[a4 + e3];
      }
      function ur(t5, e3, r3, n4, i4, a4, o4) {
        var s4;
        if (t5 == null)
          cr(null, null, r3, n4, i4, a4, o4);
        else
          for (s4 = 0; s4 < o4; ++s4)
            i4[a4 + s4] = t5[e3 + s4] + r3[n4 + s4] & 255;
      }
      function hr(t5, e3, r3, n4, i4, a4, o4) {
        if (t5 == null)
          cr(null, null, r3, n4, i4, a4, o4);
        else {
          var s4, c6 = t5[e3 + 0], u5 = c6, h6 = c6;
          for (s4 = 0; s4 < o4; ++s4)
            u5 = h6 + (c6 = t5[e3 + s4]) - u5, h6 = r3[n4 + s4] + (-256 & u5 ? 0 > u5 ? 0 : 255 : u5) & 255, u5 = c6, i4[a4 + s4] = h6;
        }
      }
      function lr(t5, r3, i4, o4) {
        var s4 = r3.width, c6 = r3.o;
        if (e2(t5 != null && r3 != null), 0 > i4 || 0 >= o4 || i4 + o4 > c6)
          return null;
        if (!t5.Cc) {
          if (t5.ga == null) {
            var u5;
            if (t5.ga = new sr(), (u5 = t5.ga == null) || (u5 = r3.width * r3.o, e2(t5.Gb.length == 0), t5.Gb = a3(u5), t5.Uc = 0, t5.Gb == null ? u5 = 0 : (t5.mb = t5.Gb, t5.nb = t5.Uc, t5.rc = null, u5 = 1), u5 = !u5), !u5) {
              u5 = t5.ga;
              var h6 = t5.Fa, l5 = t5.P, f5 = t5.qc, d4 = t5.mb, p6 = t5.nb, g4 = l5 + 1, m6 = f5 - 1, b4 = u5.l;
              if (e2(h6 != null && d4 != null && r3 != null), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u5.ca = d4, u5.tb = p6, u5.c = r3.width, u5.i = r3.height, e2(0 < u5.c && 0 < u5.i), 1 >= f5)
                r3 = 0;
              else if (u5.$a = h6[l5 + 0] >> 0 & 3, u5.Z = h6[l5 + 0] >> 2 & 3, u5.Lc = h6[l5 + 0] >> 4 & 3, l5 = h6[l5 + 0] >> 6 & 3, 0 > u5.$a || 1 < u5.$a || 4 <= u5.Z || 1 < u5.Lc || l5)
                r3 = 0;
              else if (b4.put = dt2, b4.ac = ft2, b4.bc = pt2, b4.ma = u5, b4.width = r3.width, b4.height = r3.height, b4.Da = r3.Da, b4.v = r3.v, b4.va = r3.va, b4.j = r3.j, b4.o = r3.o, u5.$a)
                t: {
                  e2(u5.$a == 1), r3 = kt2();
                  e:
                    for (; ; ) {
                      if (r3 == null) {
                        r3 = 0;
                        break t;
                      }
                      if (e2(u5 != null), u5.mc = r3, r3.c = u5.c, r3.i = u5.i, r3.l = u5.l, r3.l.ma = u5, r3.l.width = u5.c, r3.l.height = u5.i, r3.a = 0, v4(r3.m, h6, g4, m6), !It2(u5.c, u5.i, 1, r3, null))
                        break e;
                      if (r3.ab == 1 && r3.gc[0].hc == 3 && At2(r3.s) ? (u5.ic = 1, h6 = r3.c * r3.i, r3.Ta = null, r3.Ua = 0, r3.V = a3(h6), r3.Ba = 0, r3.V == null ? (r3.a = 1, r3 = 0) : r3 = 1) : (u5.ic = 0, r3 = Ft2(r3, u5.c)), !r3)
                        break e;
                      r3 = 1;
                      break t;
                    }
                  u5.mc = null, r3 = 0;
                }
              else
                r3 = m6 >= u5.c * u5.i;
              u5 = !r3;
            }
            if (u5)
              return null;
            t5.ga.Lc != 1 ? t5.Ga = 0 : o4 = c6 - i4;
          }
          e2(t5.ga != null), e2(i4 + o4 <= c6);
          t: {
            if (r3 = (h6 = t5.ga).c, c6 = h6.l.o, h6.$a == 0) {
              if (g4 = t5.rc, m6 = t5.Vc, b4 = t5.Fa, l5 = t5.P + 1 + i4 * r3, f5 = t5.mb, d4 = t5.nb + i4 * r3, e2(l5 <= t5.P + t5.qc), h6.Z != 0)
                for (e2(mi[h6.Z] != null), u5 = 0; u5 < o4; ++u5)
                  mi[h6.Z](g4, m6, b4, l5, f5, d4, r3), g4 = f5, m6 = d4, d4 += r3, l5 += r3;
              else
                for (u5 = 0; u5 < o4; ++u5)
                  n3(f5, d4, b4, l5, r3), g4 = f5, m6 = d4, d4 += r3, l5 += r3;
              t5.rc = g4, t5.Vc = m6;
            } else {
              if (e2(h6.mc != null), r3 = i4 + o4, e2((u5 = h6.mc) != null), e2(r3 <= u5.i), u5.C >= r3)
                r3 = 1;
              else if (h6.ic || mr(), h6.ic) {
                h6 = u5.V, g4 = u5.Ba, m6 = u5.c;
                var y5 = u5.i, w4 = (b4 = 1, l5 = u5.$ / m6, f5 = u5.$ % m6, d4 = u5.m, p6 = u5.s, u5.$), N5 = m6 * y5, L4 = m6 * r3, x3 = p6.wc, _4 = w4 < L4 ? wt2(p6, f5, l5) : null;
                e2(w4 <= N5), e2(r3 <= y5), e2(At2(p6));
                e:
                  for (; ; ) {
                    for (; !d4.h && w4 < L4; ) {
                      if (f5 & x3 || (_4 = wt2(p6, f5, l5)), e2(_4 != null), S2(d4), 256 > (y5 = bt2(_4.G[0], _4.H[0], d4)))
                        h6[g4 + w4] = y5, ++w4, ++f5 >= m6 && (f5 = 0, ++l5 <= r3 && !(l5 % 16) && St2(u5, l5));
                      else {
                        if (!(280 > y5)) {
                          b4 = 0;
                          break e;
                        }
                        y5 = mt2(y5 - 256, d4);
                        var P3, k3 = bt2(_4.G[4], _4.H[4], d4);
                        if (S2(d4), !(w4 >= (k3 = vt2(m6, k3 = mt2(k3, d4))) && N5 - w4 >= y5)) {
                          b4 = 0;
                          break e;
                        }
                        for (P3 = 0; P3 < y5; ++P3)
                          h6[g4 + w4 + P3] = h6[g4 + w4 + P3 - k3];
                        for (w4 += y5, f5 += y5; f5 >= m6; )
                          f5 -= m6, ++l5 <= r3 && !(l5 % 16) && St2(u5, l5);
                        w4 < L4 && f5 & x3 && (_4 = wt2(p6, f5, l5));
                      }
                      e2(d4.h == A3(d4));
                    }
                    St2(u5, l5 > r3 ? r3 : l5);
                    break e;
                  }
                !b4 || d4.h && w4 < N5 ? (b4 = 0, u5.a = d4.h ? 5 : 3) : u5.$ = w4, r3 = b4;
              } else
                r3 = _t2(u5, u5.V, u5.Ba, u5.c, u5.i, r3, Ct2);
              if (!r3) {
                o4 = 0;
                break t;
              }
            }
            i4 + o4 >= c6 && (t5.Cc = 1), o4 = 1;
          }
          if (!o4)
            return null;
          if (t5.Cc && ((o4 = t5.ga) != null && (o4.mc = null), t5.ga = null, 0 < t5.Ga))
            return alert("todo:WebPDequantizeLevels"), null;
        }
        return t5.nb + i4 * s4;
      }
      function fr(t5, e3, r3, n4, i4, a4) {
        for (; 0 < i4--; ) {
          var o4, s4 = t5, c6 = e3 + (r3 ? 1 : 0), u5 = t5, h6 = e3 + (r3 ? 0 : 3);
          for (o4 = 0; o4 < n4; ++o4) {
            var l5 = u5[h6 + 4 * o4];
            l5 != 255 && (l5 *= 32897, s4[c6 + 4 * o4 + 0] = s4[c6 + 4 * o4 + 0] * l5 >> 23, s4[c6 + 4 * o4 + 1] = s4[c6 + 4 * o4 + 1] * l5 >> 23, s4[c6 + 4 * o4 + 2] = s4[c6 + 4 * o4 + 2] * l5 >> 23);
          }
          e3 += a4;
        }
      }
      function dr(t5, e3, r3, n4, i4) {
        for (; 0 < n4--; ) {
          var a4;
          for (a4 = 0; a4 < r3; ++a4) {
            var o4 = t5[e3 + 2 * a4 + 0], s4 = 15 & (u5 = t5[e3 + 2 * a4 + 1]), c6 = 4369 * s4, u5 = (240 & u5 | u5 >> 4) * c6 >> 16;
            t5[e3 + 2 * a4 + 0] = (240 & o4 | o4 >> 4) * c6 >> 16 & 240 | (15 & o4 | o4 << 4) * c6 >> 16 >> 4 & 15, t5[e3 + 2 * a4 + 1] = 240 & u5 | s4;
          }
          e3 += i4;
        }
      }
      function pr(t5, e3, r3, n4, i4, a4, o4, s4) {
        var c6, u5, h6 = 255;
        for (u5 = 0; u5 < i4; ++u5) {
          for (c6 = 0; c6 < n4; ++c6) {
            var l5 = t5[e3 + c6];
            a4[o4 + 4 * c6] = l5, h6 &= l5;
          }
          e3 += r3, o4 += s4;
        }
        return h6 != 255;
      }
      function gr(t5, e3, r3, n4, i4) {
        var a4;
        for (a4 = 0; a4 < i4; ++a4)
          r3[n4 + a4] = t5[e3 + a4] >> 8;
      }
      function mr() {
        An = fr, xn = dr, Sn = pr, _n = gr;
      }
      function vr(r3, n4, i4) {
        t4[r3] = function(t5, r4, a4, o4, s4, c6, u5, h6, l5, f5, d4, p6, g4, m6, v5, b4, y5) {
          var w4, N5 = y5 - 1 >> 1, L4 = s4[c6 + 0] | u5[h6 + 0] << 16, A4 = l5[f5 + 0] | d4[p6 + 0] << 16;
          e2(t5 != null);
          var x3 = 3 * L4 + A4 + 131074 >> 2;
          for (n4(t5[r4 + 0], 255 & x3, x3 >> 16, g4, m6), a4 != null && (x3 = 3 * A4 + L4 + 131074 >> 2, n4(a4[o4 + 0], 255 & x3, x3 >> 16, v5, b4)), w4 = 1; w4 <= N5; ++w4) {
            var S3 = s4[c6 + w4] | u5[h6 + w4] << 16, _4 = l5[f5 + w4] | d4[p6 + w4] << 16, P3 = L4 + S3 + A4 + _4 + 524296, k3 = P3 + 2 * (S3 + A4) >> 3;
            x3 = k3 + L4 >> 1, L4 = (P3 = P3 + 2 * (L4 + _4) >> 3) + S3 >> 1, n4(t5[r4 + 2 * w4 - 1], 255 & x3, x3 >> 16, g4, m6 + (2 * w4 - 1) * i4), n4(t5[r4 + 2 * w4 - 0], 255 & L4, L4 >> 16, g4, m6 + (2 * w4 - 0) * i4), a4 != null && (x3 = P3 + A4 >> 1, L4 = k3 + _4 >> 1, n4(a4[o4 + 2 * w4 - 1], 255 & x3, x3 >> 16, v5, b4 + (2 * w4 - 1) * i4), n4(a4[o4 + 2 * w4 + 0], 255 & L4, L4 >> 16, v5, b4 + (2 * w4 + 0) * i4)), L4 = S3, A4 = _4;
          }
          1 & y5 || (x3 = 3 * L4 + A4 + 131074 >> 2, n4(t5[r4 + y5 - 1], 255 & x3, x3 >> 16, g4, m6 + (y5 - 1) * i4), a4 != null && (x3 = 3 * A4 + L4 + 131074 >> 2, n4(a4[o4 + y5 - 1], 255 & x3, x3 >> 16, v5, b4 + (y5 - 1) * i4)));
        };
      }
      function br() {
        vi[Mn] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
      }
      function yr(t5) {
        return t5 & ~Fi ? 0 > t5 ? 0 : 255 : t5 >> Ii;
      }
      function wr(t5, e3) {
        return yr((19077 * t5 >> 8) + (26149 * e3 >> 8) - 14234);
      }
      function Nr(t5, e3, r3) {
        return yr((19077 * t5 >> 8) - (6419 * e3 >> 8) - (13320 * r3 >> 8) + 8708);
      }
      function Lr(t5, e3) {
        return yr((19077 * t5 >> 8) + (33050 * e3 >> 8) - 17685);
      }
      function Ar(t5, e3, r3, n4, i4) {
        n4[i4 + 0] = wr(t5, r3), n4[i4 + 1] = Nr(t5, e3, r3), n4[i4 + 2] = Lr(t5, e3);
      }
      function xr(t5, e3, r3, n4, i4) {
        n4[i4 + 0] = Lr(t5, e3), n4[i4 + 1] = Nr(t5, e3, r3), n4[i4 + 2] = wr(t5, r3);
      }
      function Sr(t5, e3, r3, n4, i4) {
        var a4 = Nr(t5, e3, r3);
        e3 = a4 << 3 & 224 | Lr(t5, e3) >> 3, n4[i4 + 0] = 248 & wr(t5, r3) | a4 >> 5, n4[i4 + 1] = e3;
      }
      function _r(t5, e3, r3, n4, i4) {
        var a4 = 240 & Lr(t5, e3) | 15;
        n4[i4 + 0] = 240 & wr(t5, r3) | Nr(t5, e3, r3) >> 4, n4[i4 + 1] = a4;
      }
      function Pr(t5, e3, r3, n4, i4) {
        n4[i4 + 0] = 255, Ar(t5, e3, r3, n4, i4 + 1);
      }
      function kr(t5, e3, r3, n4, i4) {
        xr(t5, e3, r3, n4, i4), n4[i4 + 3] = 255;
      }
      function Ir(t5, e3, r3, n4, i4) {
        Ar(t5, e3, r3, n4, i4), n4[i4 + 3] = 255;
      }
      function Vt2(t5, e3) {
        return 0 > t5 ? 0 : t5 > e3 ? e3 : t5;
      }
      function Fr(e3, r3, n4) {
        t4[e3] = function(t5, e4, i4, a4, o4, s4, c6, u5, h6) {
          for (var l5 = u5 + (-2 & h6) * n4; u5 != l5; )
            r3(t5[e4 + 0], i4[a4 + 0], o4[s4 + 0], c6, u5), r3(t5[e4 + 1], i4[a4 + 0], o4[s4 + 0], c6, u5 + n4), e4 += 2, ++a4, ++s4, u5 += 2 * n4;
          1 & h6 && r3(t5[e4 + 0], i4[a4 + 0], o4[s4 + 0], c6, u5);
        };
      }
      function Cr(t5, e3, r3) {
        return r3 == 0 ? t5 == 0 ? e3 == 0 ? 6 : 5 : e3 == 0 ? 4 : 0 : r3;
      }
      function jr(t5, e3, r3, n4, i4) {
        switch (t5 >>> 30) {
          case 3:
            on3(e3, r3, n4, i4, 0);
            break;
          case 2:
            sn(e3, r3, n4, i4);
            break;
          case 1:
            un(e3, r3, n4, i4);
        }
      }
      function Or(t5, e3) {
        var r3, a4, o4 = e3.M, s4 = e3.Nb, c6 = t5.oc, u5 = t5.pc + 40, h6 = t5.oc, l5 = t5.pc + 584, f5 = t5.oc, d4 = t5.pc + 600;
        for (r3 = 0; 16 > r3; ++r3)
          c6[u5 + 32 * r3 - 1] = 129;
        for (r3 = 0; 8 > r3; ++r3)
          h6[l5 + 32 * r3 - 1] = 129, f5[d4 + 32 * r3 - 1] = 129;
        for (0 < o4 ? c6[u5 - 1 - 32] = h6[l5 - 1 - 32] = f5[d4 - 1 - 32] = 129 : (i3(c6, u5 - 32 - 1, 127, 21), i3(h6, l5 - 32 - 1, 127, 9), i3(f5, d4 - 32 - 1, 127, 9)), a4 = 0; a4 < t5.za; ++a4) {
          var p6 = e3.ya[e3.aa + a4];
          if (0 < a4) {
            for (r3 = -1; 16 > r3; ++r3)
              n3(c6, u5 + 32 * r3 - 4, c6, u5 + 32 * r3 + 12, 4);
            for (r3 = -1; 8 > r3; ++r3)
              n3(h6, l5 + 32 * r3 - 4, h6, l5 + 32 * r3 + 4, 4), n3(f5, d4 + 32 * r3 - 4, f5, d4 + 32 * r3 + 4, 4);
          }
          var g4 = t5.Gd, m6 = t5.Hd + a4, v5 = p6.ad, b4 = p6.Hc;
          if (0 < o4 && (n3(c6, u5 - 32, g4[m6].y, 0, 16), n3(h6, l5 - 32, g4[m6].f, 0, 8), n3(f5, d4 - 32, g4[m6].ea, 0, 8)), p6.Za) {
            var y5 = c6, w4 = u5 - 32 + 16;
            for (0 < o4 && (a4 >= t5.za - 1 ? i3(y5, w4, g4[m6].y[15], 4) : n3(y5, w4, g4[m6 + 1].y, 0, 4)), r3 = 0; 4 > r3; r3++)
              y5[w4 + 128 + r3] = y5[w4 + 256 + r3] = y5[w4 + 384 + r3] = y5[w4 + 0 + r3];
            for (r3 = 0; 16 > r3; ++r3, b4 <<= 2)
              y5 = c6, w4 = u5 + Di[r3], fi[p6.Ob[r3]](y5, w4), jr(b4, v5, 16 * +r3, y5, w4);
          } else if (y5 = Cr(a4, o4, p6.Ob[0]), li[y5](c6, u5), b4 != 0)
            for (r3 = 0; 16 > r3; ++r3, b4 <<= 2)
              jr(b4, v5, 16 * +r3, c6, u5 + Di[r3]);
          for (r3 = p6.Gc, y5 = Cr(a4, o4, p6.Dd), di[y5](h6, l5), di[y5](f5, d4), b4 = v5, y5 = h6, w4 = l5, 255 & (p6 = r3 >> 0) && (170 & p6 ? cn(b4, 256, y5, w4) : hn(b4, 256, y5, w4)), p6 = f5, b4 = d4, 255 & (r3 >>= 8) && (170 & r3 ? cn(v5, 320, p6, b4) : hn(v5, 320, p6, b4)), o4 < t5.Ub - 1 && (n3(g4[m6].y, 0, c6, u5 + 480, 16), n3(g4[m6].f, 0, h6, l5 + 224, 8), n3(g4[m6].ea, 0, f5, d4 + 224, 8)), r3 = 8 * s4 * t5.B, g4 = t5.sa, m6 = t5.ta + 16 * a4 + 16 * s4 * t5.R, v5 = t5.qa, p6 = t5.ra + 8 * a4 + r3, b4 = t5.Ha, y5 = t5.Ia + 8 * a4 + r3, r3 = 0; 16 > r3; ++r3)
            n3(g4, m6 + r3 * t5.R, c6, u5 + 32 * r3, 16);
          for (r3 = 0; 8 > r3; ++r3)
            n3(v5, p6 + r3 * t5.B, h6, l5 + 32 * r3, 8), n3(b4, y5 + r3 * t5.B, f5, d4 + 32 * r3, 8);
        }
      }
      function Br(t5, n4, i4, a4, o4, s4, c6, u5, h6) {
        var l5 = [0], f5 = [0], d4 = 0, p6 = h6 != null ? h6.kd : 0, g4 = h6 != null ? h6 : new nr();
        if (t5 == null || 12 > i4)
          return 7;
        g4.data = t5, g4.w = n4, g4.ha = i4, n4 = [n4], i4 = [i4], g4.gb = [g4.gb];
        t: {
          var m6 = n4, b4 = i4, y5 = g4.gb;
          if (e2(t5 != null), e2(b4 != null), e2(y5 != null), y5[0] = 0, 12 <= b4[0] && !r2(t5, m6[0], "RIFF")) {
            if (r2(t5, m6[0] + 8, "WEBP")) {
              y5 = 3;
              break t;
            }
            var w4 = j2(t5, m6[0] + 4);
            if (12 > w4 || 4294967286 < w4) {
              y5 = 3;
              break t;
            }
            if (p6 && w4 > b4[0] - 8) {
              y5 = 7;
              break t;
            }
            y5[0] = w4, m6[0] += 12, b4[0] -= 12;
          }
          y5 = 0;
        }
        if (y5 != 0)
          return y5;
        for (w4 = 0 < g4.gb[0], i4 = i4[0]; ; ) {
          t: {
            var L4 = t5;
            b4 = n4, y5 = i4;
            var A4 = l5, x3 = f5, S3 = m6 = [0];
            if ((k3 = d4 = [d4])[0] = 0, 8 > y5[0])
              y5 = 7;
            else {
              if (!r2(L4, b4[0], "VP8X")) {
                if (j2(L4, b4[0] + 4) != 10) {
                  y5 = 3;
                  break t;
                }
                if (18 > y5[0]) {
                  y5 = 7;
                  break t;
                }
                var _4 = j2(L4, b4[0] + 8), P3 = 1 + C2(L4, b4[0] + 12);
                if (2147483648 <= P3 * (L4 = 1 + C2(L4, b4[0] + 15))) {
                  y5 = 3;
                  break t;
                }
                S3 != null && (S3[0] = _4), A4 != null && (A4[0] = P3), x3 != null && (x3[0] = L4), b4[0] += 18, y5[0] -= 18, k3[0] = 1;
              }
              y5 = 0;
            }
          }
          if (d4 = d4[0], m6 = m6[0], y5 != 0)
            return y5;
          if (b4 = !!(2 & m6), !w4 && d4)
            return 3;
          if (s4 != null && (s4[0] = !!(16 & m6)), c6 != null && (c6[0] = b4), u5 != null && (u5[0] = 0), c6 = l5[0], m6 = f5[0], d4 && b4 && h6 == null) {
            y5 = 0;
            break;
          }
          if (4 > i4) {
            y5 = 7;
            break;
          }
          if (w4 && d4 || !w4 && !d4 && !r2(t5, n4[0], "ALPH")) {
            i4 = [i4], g4.na = [g4.na], g4.P = [g4.P], g4.Sa = [g4.Sa];
            t: {
              _4 = t5, y5 = n4, w4 = i4;
              var k3 = g4.gb;
              A4 = g4.na, x3 = g4.P, S3 = g4.Sa;
              P3 = 22, e2(_4 != null), e2(w4 != null), L4 = y5[0];
              var I3 = w4[0];
              for (e2(A4 != null), e2(S3 != null), A4[0] = null, x3[0] = null, S3[0] = 0; ; ) {
                if (y5[0] = L4, w4[0] = I3, 8 > I3) {
                  y5 = 7;
                  break t;
                }
                var F3 = j2(_4, L4 + 4);
                if (4294967286 < F3) {
                  y5 = 3;
                  break t;
                }
                var O4 = 8 + F3 + 1 & -2;
                if (P3 += O4, 0 < k3 && P3 > k3) {
                  y5 = 3;
                  break t;
                }
                if (!r2(_4, L4, "VP8 ") || !r2(_4, L4, "VP8L")) {
                  y5 = 0;
                  break t;
                }
                if (I3[0] < O4) {
                  y5 = 7;
                  break t;
                }
                r2(_4, L4, "ALPH") || (A4[0] = _4, x3[0] = L4 + 8, S3[0] = F3), L4 += O4, I3 -= O4;
              }
            }
            if (i4 = i4[0], g4.na = g4.na[0], g4.P = g4.P[0], g4.Sa = g4.Sa[0], y5 != 0)
              break;
          }
          i4 = [i4], g4.Ja = [g4.Ja], g4.xa = [g4.xa];
          t:
            if (k3 = t5, y5 = n4, w4 = i4, A4 = g4.gb[0], x3 = g4.Ja, S3 = g4.xa, _4 = y5[0], L4 = !r2(k3, _4, "VP8 "), P3 = !r2(k3, _4, "VP8L"), e2(k3 != null), e2(w4 != null), e2(x3 != null), e2(S3 != null), 8 > w4[0])
              y5 = 7;
            else {
              if (L4 || P3) {
                if (k3 = j2(k3, _4 + 4), 12 <= A4 && k3 > A4 - 12) {
                  y5 = 3;
                  break t;
                }
                if (p6 && k3 > w4[0] - 8) {
                  y5 = 7;
                  break t;
                }
                x3[0] = k3, y5[0] += 8, w4[0] -= 8, S3[0] = P3;
              } else
                S3[0] = 5 <= w4[0] && k3[_4 + 0] == 47 && !(k3[_4 + 4] >> 5), x3[0] = w4[0];
              y5 = 0;
            }
          if (i4 = i4[0], g4.Ja = g4.Ja[0], g4.xa = g4.xa[0], n4 = n4[0], y5 != 0)
            break;
          if (4294967286 < g4.Ja)
            return 3;
          if (u5 == null || b4 || (u5[0] = g4.xa ? 2 : 1), c6 = [c6], m6 = [m6], g4.xa) {
            if (5 > i4) {
              y5 = 7;
              break;
            }
            u5 = c6, p6 = m6, b4 = s4, t5 == null || 5 > i4 ? t5 = 0 : 5 <= i4 && t5[n4 + 0] == 47 && !(t5[n4 + 4] >> 5) ? (w4 = [0], k3 = [0], A4 = [0], v4(x3 = new N4(), t5, n4, i4), gt2(x3, w4, k3, A4) ? (u5 != null && (u5[0] = w4[0]), p6 != null && (p6[0] = k3[0]), b4 != null && (b4[0] = A4[0]), t5 = 1) : t5 = 0) : t5 = 0;
          } else {
            if (10 > i4) {
              y5 = 7;
              break;
            }
            u5 = m6, t5 == null || 10 > i4 || !Xt2(t5, n4 + 3, i4 - 3) ? t5 = 0 : (p6 = t5[n4 + 0] | t5[n4 + 1] << 8 | t5[n4 + 2] << 16, b4 = 16383 & (t5[n4 + 7] << 8 | t5[n4 + 6]), t5 = 16383 & (t5[n4 + 9] << 8 | t5[n4 + 8]), 1 & p6 || 3 < (p6 >> 1 & 7) || !(p6 >> 4 & 1) || p6 >> 5 >= g4.Ja || !b4 || !t5 ? t5 = 0 : (c6 && (c6[0] = b4), u5 && (u5[0] = t5), t5 = 1));
          }
          if (!t5)
            return 3;
          if (c6 = c6[0], m6 = m6[0], d4 && (l5[0] != c6 || f5[0] != m6))
            return 3;
          h6 != null && (h6[0] = g4, h6.offset = n4 - h6.w, e2(4294967286 > n4 - h6.w), e2(h6.offset == h6.ha - i4));
          break;
        }
        return y5 == 0 || y5 == 7 && d4 && h6 == null ? (s4 != null && (s4[0] |= g4.na != null && 0 < g4.na.length), a4 != null && (a4[0] = c6), o4 != null && (o4[0] = m6), 0) : y5;
      }
      function Er(t5, e3, r3) {
        var n4 = e3.width, i4 = e3.height, a4 = 0, o4 = 0, s4 = n4, c6 = i4;
        if (e3.Da = t5 != null && 0 < t5.Da, e3.Da && (s4 = t5.cd, c6 = t5.bd, a4 = t5.v, o4 = t5.j, 11 > r3 || (a4 &= -2, o4 &= -2), 0 > a4 || 0 > o4 || 0 >= s4 || 0 >= c6 || a4 + s4 > n4 || o4 + c6 > i4))
          return 0;
        if (e3.v = a4, e3.j = o4, e3.va = a4 + s4, e3.o = o4 + c6, e3.U = s4, e3.T = c6, e3.da = t5 != null && 0 < t5.da, e3.da) {
          if (!M2(s4, c6, r3 = [t5.ib], a4 = [t5.hb]))
            return 0;
          e3.ib = r3[0], e3.hb = a4[0];
        }
        return e3.ob = t5 != null && t5.ob, e3.Kb = t5 == null || !t5.Sd, e3.da && (e3.ob = e3.ib < 3 * n4 / 4 && e3.hb < 3 * i4 / 4, e3.Kb = 0), 1;
      }
      function Mr(t5) {
        if (t5 == null)
          return 2;
        if (11 > t5.S) {
          var e3 = t5.f.RGBA;
          e3.fb += (t5.height - 1) * e3.A, e3.A = -e3.A;
        } else
          e3 = t5.f.kb, t5 = t5.height, e3.O += (t5 - 1) * e3.fa, e3.fa = -e3.fa, e3.N += (t5 - 1 >> 1) * e3.Ab, e3.Ab = -e3.Ab, e3.W += (t5 - 1 >> 1) * e3.Db, e3.Db = -e3.Db, e3.F != null && (e3.J += (t5 - 1) * e3.lb, e3.lb = -e3.lb);
        return 0;
      }
      function qr(t5, e3, r3, n4) {
        if (n4 == null || 0 >= t5 || 0 >= e3)
          return 2;
        if (r3 != null) {
          if (r3.Da) {
            var i4 = r3.cd, o4 = r3.bd, s4 = -2 & r3.v, c6 = -2 & r3.j;
            if (0 > s4 || 0 > c6 || 0 >= i4 || 0 >= o4 || s4 + i4 > t5 || c6 + o4 > e3)
              return 2;
            t5 = i4, e3 = o4;
          }
          if (r3.da) {
            if (!M2(t5, e3, i4 = [r3.ib], o4 = [r3.hb]))
              return 2;
            t5 = i4[0], e3 = o4[0];
          }
        }
        n4.width = t5, n4.height = e3;
        t: {
          var u5 = n4.width, h6 = n4.height;
          if (t5 = n4.S, 0 >= u5 || 0 >= h6 || !(t5 >= Mn && 13 > t5))
            t5 = 2;
          else {
            if (0 >= n4.Rd && n4.sd == null) {
              s4 = o4 = i4 = e3 = 0;
              var l5 = (c6 = u5 * zi[t5]) * h6;
              if (11 > t5 || (o4 = (h6 + 1) / 2 * (e3 = (u5 + 1) / 2), t5 == 12 && (s4 = (i4 = u5) * h6)), (h6 = a3(l5 + 2 * o4 + s4)) == null) {
                t5 = 1;
                break t;
              }
              n4.sd = h6, 11 > t5 ? ((u5 = n4.f.RGBA).eb = h6, u5.fb = 0, u5.A = c6, u5.size = l5) : ((u5 = n4.f.kb).y = h6, u5.O = 0, u5.fa = c6, u5.Fd = l5, u5.f = h6, u5.N = 0 + l5, u5.Ab = e3, u5.Cd = o4, u5.ea = h6, u5.W = 0 + l5 + o4, u5.Db = e3, u5.Ed = o4, t5 == 12 && (u5.F = h6, u5.J = 0 + l5 + 2 * o4), u5.Tc = s4, u5.lb = i4);
            }
            if (e3 = 1, i4 = n4.S, o4 = n4.width, s4 = n4.height, i4 >= Mn && 13 > i4)
              if (11 > i4)
                t5 = n4.f.RGBA, e3 &= (c6 = Math.abs(t5.A)) * (s4 - 1) + o4 <= t5.size, e3 &= c6 >= o4 * zi[i4], e3 &= t5.eb != null;
              else {
                t5 = n4.f.kb, c6 = (o4 + 1) / 2, l5 = (s4 + 1) / 2, u5 = Math.abs(t5.fa);
                h6 = Math.abs(t5.Ab);
                var f5 = Math.abs(t5.Db), d4 = Math.abs(t5.lb), p6 = d4 * (s4 - 1) + o4;
                e3 &= u5 * (s4 - 1) + o4 <= t5.Fd, e3 &= h6 * (l5 - 1) + c6 <= t5.Cd, e3 = (e3 &= f5 * (l5 - 1) + c6 <= t5.Ed) & u5 >= o4 & h6 >= c6 & f5 >= c6, e3 &= t5.y != null, e3 &= t5.f != null, e3 &= t5.ea != null, i4 == 12 && (e3 &= d4 >= o4, e3 &= p6 <= t5.Tc, e3 &= t5.F != null);
              }
            else
              e3 = 0;
            t5 = e3 ? 0 : 2;
          }
        }
        return t5 != 0 || r3 != null && r3.fd && (t5 = Mr(n4)), t5;
      }
      var Dr = 64, Rr = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], Tr = 24, Ur = 32, zr = 8, Hr = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
      R2("Predictor0", "PredictorAdd0"), t4.Predictor0 = function() {
        return 4278190080;
      }, t4.Predictor1 = function(t5) {
        return t5;
      }, t4.Predictor2 = function(t5, e3, r3) {
        return e3[r3 + 0];
      }, t4.Predictor3 = function(t5, e3, r3) {
        return e3[r3 + 1];
      }, t4.Predictor4 = function(t5, e3, r3) {
        return e3[r3 - 1];
      }, t4.Predictor5 = function(t5, e3, r3) {
        return U2(U2(t5, e3[r3 + 1]), e3[r3 + 0]);
      }, t4.Predictor6 = function(t5, e3, r3) {
        return U2(t5, e3[r3 - 1]);
      }, t4.Predictor7 = function(t5, e3, r3) {
        return U2(t5, e3[r3 + 0]);
      }, t4.Predictor8 = function(t5, e3, r3) {
        return U2(e3[r3 - 1], e3[r3 + 0]);
      }, t4.Predictor9 = function(t5, e3, r3) {
        return U2(e3[r3 + 0], e3[r3 + 1]);
      }, t4.Predictor10 = function(t5, e3, r3) {
        return U2(U2(t5, e3[r3 - 1]), U2(e3[r3 + 0], e3[r3 + 1]));
      }, t4.Predictor11 = function(t5, e3, r3) {
        var n4 = e3[r3 + 0];
        return 0 >= W2(n4 >> 24 & 255, t5 >> 24 & 255, (e3 = e3[r3 - 1]) >> 24 & 255) + W2(n4 >> 16 & 255, t5 >> 16 & 255, e3 >> 16 & 255) + W2(n4 >> 8 & 255, t5 >> 8 & 255, e3 >> 8 & 255) + W2(255 & n4, 255 & t5, 255 & e3) ? n4 : t5;
      }, t4.Predictor12 = function(t5, e3, r3) {
        var n4 = e3[r3 + 0];
        return (z2((t5 >> 24 & 255) + (n4 >> 24 & 255) - ((e3 = e3[r3 - 1]) >> 24 & 255)) << 24 | z2((t5 >> 16 & 255) + (n4 >> 16 & 255) - (e3 >> 16 & 255)) << 16 | z2((t5 >> 8 & 255) + (n4 >> 8 & 255) - (e3 >> 8 & 255)) << 8 | z2((255 & t5) + (255 & n4) - (255 & e3))) >>> 0;
      }, t4.Predictor13 = function(t5, e3, r3) {
        var n4 = e3[r3 - 1];
        return (H2((t5 = U2(t5, e3[r3 + 0])) >> 24 & 255, n4 >> 24 & 255) << 24 | H2(t5 >> 16 & 255, n4 >> 16 & 255) << 16 | H2(t5 >> 8 & 255, n4 >> 8 & 255) << 8 | H2(t5 >> 0 & 255, n4 >> 0 & 255)) >>> 0;
      };
      var Wr = t4.PredictorAdd0;
      t4.PredictorAdd1 = V2, R2("Predictor2", "PredictorAdd2"), R2("Predictor3", "PredictorAdd3"), R2("Predictor4", "PredictorAdd4"), R2("Predictor5", "PredictorAdd5"), R2("Predictor6", "PredictorAdd6"), R2("Predictor7", "PredictorAdd7"), R2("Predictor8", "PredictorAdd8"), R2("Predictor9", "PredictorAdd9"), R2("Predictor10", "PredictorAdd10"), R2("Predictor11", "PredictorAdd11"), R2("Predictor12", "PredictorAdd12"), R2("Predictor13", "PredictorAdd13");
      var Vr = t4.PredictorAdd2;
      X2("ColorIndexInverseTransform", "MapARGB", "32b", function(t5) {
        return t5 >> 8 & 255;
      }, function(t5) {
        return t5;
      }), X2("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t5) {
        return t5;
      }, function(t5) {
        return t5 >> 8 & 255;
      });
      var Gr, Yr = t4.ColorIndexInverseTransform, Jr = t4.MapARGB, Xr = t4.VP8LColorIndexInverseTransformAlpha, Kr = t4.MapAlpha, Zr = t4.VP8LPredictorsAdd = [];
      Zr.length = 16, (t4.VP8LPredictors = []).length = 16, (t4.VP8LPredictorsAdd_C = []).length = 16, (t4.VP8LPredictors_C = []).length = 16;
      var $r, Qr, tn, en, rn, nn, an, on3, sn, cn, un, hn, ln2, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a3(511), kn = a3(2041), In = a3(225), Fn = a3(767), Cn = 0, jn = kn, On = In, Bn = Fn, En = Pn, Mn = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [2, 3, 7], Jn = [3, 3, 11], Xn = [280, 256, 256, 256, 40], Kn = [0, 1, 1, 1, 0], Zn = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], $n = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], Qn = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], ti = 8, ei = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], ri = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], ni = null, ii = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], ai = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], oi = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], si = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], ci = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], ui = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], hi = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
      vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
      var bi = t4.UpsampleRgbLinePair, yi = t4.UpsampleBgrLinePair, wi = t4.UpsampleRgbaLinePair, Ni = t4.UpsampleBgraLinePair, Li = t4.UpsampleArgbLinePair, Ai = t4.UpsampleRgba4444LinePair, xi = t4.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a3(256), Oi = a3(256), Bi = a3(256), Ei = a3(256), Mi = a3(ki - Pi), qi = a3(ki - Pi);
      Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
      var Di = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Ri = [0, 2, 8], Ti = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], Ui = 1;
      this.WebPDecodeRGBA = function(t5, r3, n4, i4, a4) {
        var o4 = qn, s4 = new rr(), c6 = new ot2();
        s4.ba = c6, c6.S = o4, c6.width = [c6.width], c6.height = [c6.height];
        var u5 = c6.width, h6 = c6.height, l5 = new st2();
        if (l5 == null || t5 == null)
          var f5 = 2;
        else
          e2(l5 != null), f5 = Br(t5, r3, n4, l5.width, l5.height, l5.Pd, l5.Qd, l5.format, null);
        if (f5 != 0 ? u5 = 0 : (u5 != null && (u5[0] = l5.width[0]), h6 != null && (h6[0] = l5.height[0]), u5 = 1), u5) {
          c6.width = c6.width[0], c6.height = c6.height[0], i4 != null && (i4[0] = c6.width), a4 != null && (a4[0] = c6.height);
          t: {
            if (i4 = new Gt2(), (a4 = new nr()).data = t5, a4.w = r3, a4.ha = n4, a4.kd = 1, r3 = [0], e2(a4 != null), ((t5 = Br(a4.data, a4.w, a4.ha, null, null, null, r3, null, a4)) == 0 || t5 == 7) && r3[0] && (t5 = 4), (r3 = t5) == 0) {
              if (e2(s4 != null), i4.data = a4.data, i4.w = a4.w + a4.offset, i4.ha = a4.ha - a4.offset, i4.put = dt2, i4.ac = ft2, i4.bc = pt2, i4.ma = s4, a4.xa) {
                if ((t5 = kt2()) == null) {
                  s4 = 1;
                  break t;
                }
                if (function(t6, r4) {
                  var n5 = [0], i5 = [0], a5 = [0];
                  e:
                    for (; ; ) {
                      if (t6 == null)
                        return 0;
                      if (r4 == null)
                        return t6.a = 2, 0;
                      if (t6.l = r4, t6.a = 0, v4(t6.m, r4.data, r4.w, r4.ha), !gt2(t6.m, n5, i5, a5)) {
                        t6.a = 3;
                        break e;
                      }
                      if (t6.xb = gi, r4.width = n5[0], r4.height = i5[0], !It2(n5[0], i5[0], 1, t6, null))
                        break e;
                      return 1;
                    }
                  return e2(t6.a != 0), 0;
                }(t5, i4)) {
                  if (i4 = (r3 = qr(i4.width, i4.height, s4.Oa, s4.ba)) == 0) {
                    e: {
                      i4 = t5;
                      r:
                        for (; ; ) {
                          if (i4 == null) {
                            i4 = 0;
                            break e;
                          }
                          if (e2(i4.s.yc != null), e2(i4.s.Ya != null), e2(0 < i4.s.Wb), e2((n4 = i4.l) != null), e2((a4 = n4.ma) != null), i4.xb != 0) {
                            if (i4.ca = a4.ba, i4.tb = a4.tb, e2(i4.ca != null), !Er(a4.Oa, n4, Rn)) {
                              i4.a = 2;
                              break r;
                            }
                            if (!Ft2(i4, n4.width))
                              break r;
                            if (n4.da)
                              break r;
                            if ((n4.da || nt2(i4.ca.S)) && mr(), 11 > i4.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), i4.ca.f.kb.F != null && mr()), i4.Pb && 0 < i4.s.ua && i4.s.vb.X == null && !O3(i4.s.vb, i4.s.Wa.Xa)) {
                              i4.a = 1;
                              break r;
                            }
                            i4.xb = 0;
                          }
                          if (!_t2(i4, i4.V, i4.Ba, i4.c, i4.i, n4.o, Lt2))
                            break r;
                          a4.Dc = i4.Ma, i4 = 1;
                          break e;
                        }
                      e2(i4.a != 0), i4 = 0;
                    }
                    i4 = !i4;
                  }
                  i4 && (r3 = t5.a);
                } else
                  r3 = t5.a;
              } else {
                if ((t5 = new Yt2()) == null) {
                  s4 = 1;
                  break t;
                }
                if (t5.Fa = a4.na, t5.P = a4.P, t5.qc = a4.Sa, Kt2(t5, i4)) {
                  if ((r3 = qr(i4.width, i4.height, s4.Oa, s4.ba)) == 0) {
                    if (t5.Aa = 0, n4 = s4.Oa, e2((a4 = t5) != null), n4 != null) {
                      if (0 < (u5 = 0 > (u5 = n4.Md) ? 0 : 100 < u5 ? 255 : 255 * u5 / 100)) {
                        for (h6 = l5 = 0; 4 > h6; ++h6)
                          12 > (f5 = a4.pb[h6]).lc && (f5.ia = u5 * Ti[0 > f5.lc ? 0 : f5.lc] >> 3), l5 |= f5.ia;
                        l5 && (alert("todo:VP8InitRandom"), a4.ia = 1);
                      }
                      a4.Ga = n4.Id, 100 < a4.Ga ? a4.Ga = 100 : 0 > a4.Ga && (a4.Ga = 0);
                    }
                    Qt2(t5, i4) || (r3 = t5.a);
                  }
                } else
                  r3 = t5.a;
              }
              r3 == 0 && s4.Oa != null && s4.Oa.fd && (r3 = Mr(s4.ba));
            }
            s4 = r3;
          }
          o4 = s4 != 0 ? null : 11 > o4 ? c6.f.RGBA.eb : c6.f.kb.y;
        } else
          o4 = null;
        return o4;
      };
      var zi = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
    };
    function u3(t4, e3) {
      for (var r3 = "", n4 = 0; n4 < 4; n4++)
        r3 += String.fromCharCode(t4[e3++]);
      return r3;
    }
    function h4(t4, e3) {
      return (t4[e3 + 0] << 0 | t4[e3 + 1] << 8 | t4[e3 + 2] << 16) >>> 0;
    }
    function l3(t4, e3) {
      return (t4[e3 + 0] << 0 | t4[e3 + 1] << 8 | t4[e3 + 2] << 16 | t4[e3 + 3] << 24) >>> 0;
    }
    new c4();
    var f3 = [0], d2 = [0], p4 = [], g2 = new c4(), m4 = t3, v3 = function(t4, e3) {
      var r3 = {}, n4 = 0, i4 = false, a4 = 0, o4 = 0;
      if (r3.frames = [], !function(t5, e4, r4, n5) {
        for (var i5 = 0; i5 < n5; i5++)
          if (t5[e4 + i5] != r4.charCodeAt(i5))
            return true;
        return false;
      }(t4, e3, "RIFF", 4)) {
        var s4, c5;
        l3(t4, e3 += 4);
        for (e3 += 8; e3 < t4.length; ) {
          var f4 = u3(t4, e3), d3 = l3(t4, e3 += 4);
          e3 += 4;
          var p5 = d3 + (1 & d3);
          switch (f4) {
            case "VP8 ":
            case "VP8L":
              r3.frames[n4] === void 0 && (r3.frames[n4] = {});
              (v4 = r3.frames[n4]).src_off = i4 ? o4 : e3 - 8, v4.src_size = a4 + d3 + 8, n4++, i4 && (i4 = false, a4 = 0, o4 = 0);
              break;
            case "VP8X":
              (v4 = r3.header = {}).feature_flags = t4[e3];
              var g3 = e3 + 4;
              v4.canvas_width = 1 + h4(t4, g3);
              g3 += 3;
              v4.canvas_height = 1 + h4(t4, g3);
              g3 += 3;
              break;
            case "ALPH":
              i4 = true, a4 = p5 + 8, o4 = e3 - 8;
              break;
            case "ANIM":
              (v4 = r3.header).bgcolor = l3(t4, e3);
              g3 = e3 + 4;
              v4.loop_count = (s4 = t4)[(c5 = g3) + 0] << 0 | s4[c5 + 1] << 8;
              g3 += 2;
              break;
            case "ANMF":
              var m5, v4;
              (v4 = r3.frames[n4] = {}).offset_x = 2 * h4(t4, e3), e3 += 3, v4.offset_y = 2 * h4(t4, e3), e3 += 3, v4.width = 1 + h4(t4, e3), e3 += 3, v4.height = 1 + h4(t4, e3), e3 += 3, v4.duration = h4(t4, e3), e3 += 3, m5 = t4[e3++], v4.dispose = 1 & m5, v4.blend = m5 >> 1 & 1;
          }
          f4 != "ANMF" && (e3 += p5);
        }
        return r3;
      }
    }(m4, 0);
    v3.response = m4, v3.rgbaoutput = true, v3.dataurl = false;
    var b2 = v3.header ? v3.header : null, y3 = v3.frames ? v3.frames : null;
    if (b2) {
      b2.loop_counter = b2.loop_count, f3 = [b2.canvas_height], d2 = [b2.canvas_width];
      for (var w2 = 0; w2 < y3.length && y3[w2].blend != 0; w2++)
        ;
    }
    var N3 = y3[0], L2 = g2.WebPDecodeRGBA(m4, N3.src_off, N3.src_size, d2, f3);
    N3.rgba = L2, N3.imgwidth = d2[0], N3.imgheight = f3[0];
    for (var A2 = 0; A2 < d2[0] * f3[0] * 4; A2++)
      p4[A2] = L2[A2];
    return this.width = d2, this.height = f3, this.data = p4, this;
  }
  !function(t3) {
    var r2 = function() {
      return typeof zlibSync == "function";
    }, n3 = function(r3, n4, a4, h5) {
      var l4 = 4, f4 = s3;
      switch (h5) {
        case t3.image_compression.FAST:
          l4 = 1, f4 = o3;
          break;
        case t3.image_compression.MEDIUM:
          l4 = 6, f4 = c4;
          break;
        case t3.image_compression.SLOW:
          l4 = 9, f4 = u3;
      }
      r3 = i3(r3, n4, a4, f4);
      var d2 = zlibSync(r3, { level: l4 });
      return t3.__addimage__.arrayBufferToBinaryString(d2);
    }, i3 = function(t4, e2, r3, n4) {
      for (var i4, a4, o4, s4 = t4.length / e2, c5 = new Uint8Array(t4.length + s4), u4 = l3(), h5 = 0; h5 < s4; h5 += 1) {
        if (o4 = h5 * e2, i4 = t4.subarray(o4, o4 + e2), n4)
          c5.set(n4(i4, r3, a4), o4 + h5);
        else {
          for (var d2, p4 = u4.length, g2 = []; d2 < p4; d2 += 1)
            g2[d2] = u4[d2](i4, r3, a4);
          var m4 = f3(g2.concat());
          c5.set(g2[m4], o4 + h5);
        }
        a4 = i4;
      }
      return c5;
    }, a3 = function(t4) {
      var e2 = Array.apply([], t4);
      return e2.unshift(0), e2;
    }, o3 = function(t4, e2) {
      var r3, n4 = [], i4 = t4.length;
      n4[0] = 1;
      for (var a4 = 0; a4 < i4; a4 += 1)
        r3 = t4[a4 - e2] || 0, n4[a4 + 1] = t4[a4] - r3 + 256 & 255;
      return n4;
    }, s3 = function(t4, e2, r3) {
      var n4, i4 = [], a4 = t4.length;
      i4[0] = 2;
      for (var o4 = 0; o4 < a4; o4 += 1)
        n4 = r3 && r3[o4] || 0, i4[o4 + 1] = t4[o4] - n4 + 256 & 255;
      return i4;
    }, c4 = function(t4, e2, r3) {
      var n4, i4, a4 = [], o4 = t4.length;
      a4[0] = 3;
      for (var s4 = 0; s4 < o4; s4 += 1)
        n4 = t4[s4 - e2] || 0, i4 = r3 && r3[s4] || 0, a4[s4 + 1] = t4[s4] + 256 - (n4 + i4 >>> 1) & 255;
      return a4;
    }, u3 = function(t4, e2, r3) {
      var n4, i4, a4, o4, s4 = [], c5 = t4.length;
      s4[0] = 4;
      for (var u4 = 0; u4 < c5; u4 += 1)
        n4 = t4[u4 - e2] || 0, i4 = r3 && r3[u4] || 0, a4 = r3 && r3[u4 - e2] || 0, o4 = h4(n4, i4, a4), s4[u4 + 1] = t4[u4] - o4 + 256 & 255;
      return s4;
    }, h4 = function(t4, e2, r3) {
      if (t4 === e2 && e2 === r3)
        return t4;
      var n4 = Math.abs(e2 - r3), i4 = Math.abs(t4 - r3), a4 = Math.abs(t4 + e2 - r3 - r3);
      return n4 <= i4 && n4 <= a4 ? t4 : i4 <= a4 ? e2 : r3;
    }, l3 = function() {
      return [a3, o3, s3, c4, u3];
    }, f3 = function(t4) {
      var e2 = t4.map(function(t5) {
        return t5.reduce(function(t6, e3) {
          return t6 + Math.abs(e3);
        }, 0);
      });
      return e2.indexOf(Math.min.apply(null, e2));
    };
    t3.processPNG = function(e2, i4, a4, o4) {
      var s4, c5, u4, h5, l4, f4, d2, p4, g2, m4, v3, b2, y3, w2, N3, L2 = this.decode.FLATE_DECODE, A2 = "";
      if (this.__addimage__.isArrayBuffer(e2) && (e2 = new Uint8Array(e2)), this.__addimage__.isArrayBufferView(e2)) {
        if (e2 = (u4 = new Kt(e2)).imgData, c5 = u4.bits, s4 = u4.colorSpace, l4 = u4.colors, [4, 6].indexOf(u4.colorType) !== -1) {
          if (u4.bits === 8) {
            g2 = (p4 = u4.pixelBitlength == 32 ? new Uint32Array(u4.decodePixels().buffer) : u4.pixelBitlength == 16 ? new Uint16Array(u4.decodePixels().buffer) : new Uint8Array(u4.decodePixels().buffer)).length, v3 = new Uint8Array(g2 * u4.colors), m4 = new Uint8Array(g2);
            var x2, S2 = u4.pixelBitlength - u4.bits;
            for (w2 = 0, N3 = 0; w2 < g2; w2++) {
              for (y3 = p4[w2], x2 = 0; x2 < S2; )
                v3[N3++] = y3 >>> x2 & 255, x2 += u4.bits;
              m4[w2] = y3 >>> x2 & 255;
            }
          }
          if (u4.bits === 16) {
            g2 = (p4 = new Uint32Array(u4.decodePixels().buffer)).length, v3 = new Uint8Array(g2 * (32 / u4.pixelBitlength) * u4.colors), m4 = new Uint8Array(g2 * (32 / u4.pixelBitlength)), b2 = u4.colors > 1, w2 = 0, N3 = 0;
            for (var _3 = 0; w2 < g2; )
              y3 = p4[w2++], v3[N3++] = y3 >>> 0 & 255, b2 && (v3[N3++] = y3 >>> 16 & 255, y3 = p4[w2++], v3[N3++] = y3 >>> 0 & 255), m4[_3++] = y3 >>> 16 & 255;
            c5 = 8;
          }
          o4 !== t3.image_compression.NONE && r2() ? (e2 = n3(v3, u4.width * u4.colors, u4.colors, o4), d2 = n3(m4, u4.width, 1, o4)) : (e2 = v3, d2 = m4, L2 = void 0);
        }
        if (u4.colorType === 3 && (s4 = this.color_spaces.INDEXED, f4 = u4.palette, u4.transparency.indexed)) {
          var P2 = u4.transparency.indexed, k2 = 0;
          for (w2 = 0, g2 = P2.length; w2 < g2; ++w2)
            k2 += P2[w2];
          if ((k2 /= 255) === g2 - 1 && P2.indexOf(0) !== -1)
            h5 = [P2.indexOf(0)];
          else if (k2 !== g2) {
            for (p4 = u4.decodePixels(), m4 = new Uint8Array(p4.length), w2 = 0, g2 = p4.length; w2 < g2; w2++)
              m4[w2] = P2[p4[w2]];
            d2 = n3(m4, u4.width, 1);
          }
        }
        var I2 = function(e3) {
          var r3;
          switch (e3) {
            case t3.image_compression.FAST:
              r3 = 11;
              break;
            case t3.image_compression.MEDIUM:
              r3 = 13;
              break;
            case t3.image_compression.SLOW:
              r3 = 14;
              break;
            default:
              r3 = 12;
          }
          return r3;
        }(o4);
        return L2 === this.decode.FLATE_DECODE && (A2 = "/Predictor " + I2 + " "), A2 += "/Colors " + l4 + " /BitsPerComponent " + c5 + " /Columns " + u4.width, (this.__addimage__.isArrayBuffer(e2) || this.__addimage__.isArrayBufferView(e2)) && (e2 = this.__addimage__.arrayBufferToBinaryString(e2)), (d2 && this.__addimage__.isArrayBuffer(d2) || this.__addimage__.isArrayBufferView(d2)) && (d2 = this.__addimage__.arrayBufferToBinaryString(d2)), { alias: a4, data: e2, index: i4, filter: L2, decodeParameters: A2, transparency: h5, palette: f4, sMask: d2, predictor: I2, width: u4.width, height: u4.height, bitsPerComponent: c5, colorSpace: s4 };
      }
    };
  }(M.API), function(t3) {
    t3.processGIF89A = function(e2, r2, n3, i3) {
      var a3 = new Zt(e2), o3 = a3.width, s3 = a3.height, c4 = [];
      a3.decodeAndBlitFrameRGBA(0, c4);
      var u3 = { data: c4, width: o3, height: s3 }, h4 = new Qt(100).encode(u3, 100);
      return t3.processJPEG.call(this, h4, r2, n3, i3);
    }, t3.processGIF87A = t3.processGIF89A;
  }(M.API), te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, true), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, true), this.pos += 4, this.offset = this.datav.getUint32(this.pos, true), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, true), this.pos += 4, this.width = this.datav.getUint32(this.pos, true), this.pos += 4, this.height = this.datav.getInt32(this.pos, true), this.pos += 4, this.planes = this.datav.getUint16(this.pos, true), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, true), this.pos += 2, this.compress = this.datav.getUint32(this.pos, true), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, true), this.pos += 4, this.hr = this.datav.getUint32(this.pos, true), this.pos += 4, this.vr = this.datav.getUint32(this.pos, true), this.pos += 4, this.colors = this.datav.getUint32(this.pos, true), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, true), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
      var t3 = this.colors === 0 ? 1 << this.bitPP : this.colors;
      this.palette = new Array(t3);
      for (var e2 = 0; e2 < t3; e2++) {
        var r2 = this.datav.getUint8(this.pos++, true), n3 = this.datav.getUint8(this.pos++, true), i3 = this.datav.getUint8(this.pos++, true), a3 = this.datav.getUint8(this.pos++, true);
        this.palette[e2] = { red: i3, green: n3, blue: r2, quad: a3 };
      }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = false);
  }, te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
      var t3 = "bit" + this.bitPP, e2 = this.width * this.height * 4;
      this.data = new Uint8Array(e2), this[t3]();
    } catch (t4) {
      a2.log("bit decode error:" + t4);
    }
  }, te.prototype.bit1 = function() {
    var t3, e2 = Math.ceil(this.width / 8), r2 = e2 % 4;
    for (t3 = this.height - 1; t3 >= 0; t3--) {
      for (var n3 = this.bottom_up ? t3 : this.height - 1 - t3, i3 = 0; i3 < e2; i3++)
        for (var a3 = this.datav.getUint8(this.pos++, true), o3 = n3 * this.width * 4 + 8 * i3 * 4, s3 = 0; s3 < 8 && 8 * i3 + s3 < this.width; s3++) {
          var c4 = this.palette[a3 >> 7 - s3 & 1];
          this.data[o3 + 4 * s3] = c4.blue, this.data[o3 + 4 * s3 + 1] = c4.green, this.data[o3 + 4 * s3 + 2] = c4.red, this.data[o3 + 4 * s3 + 3] = 255;
        }
      r2 !== 0 && (this.pos += 4 - r2);
    }
  }, te.prototype.bit4 = function() {
    for (var t3 = Math.ceil(this.width / 2), e2 = t3 % 4, r2 = this.height - 1; r2 >= 0; r2--) {
      for (var n3 = this.bottom_up ? r2 : this.height - 1 - r2, i3 = 0; i3 < t3; i3++) {
        var a3 = this.datav.getUint8(this.pos++, true), o3 = n3 * this.width * 4 + 2 * i3 * 4, s3 = a3 >> 4, c4 = 15 & a3, u3 = this.palette[s3];
        if (this.data[o3] = u3.blue, this.data[o3 + 1] = u3.green, this.data[o3 + 2] = u3.red, this.data[o3 + 3] = 255, 2 * i3 + 1 >= this.width)
          break;
        u3 = this.palette[c4], this.data[o3 + 4] = u3.blue, this.data[o3 + 4 + 1] = u3.green, this.data[o3 + 4 + 2] = u3.red, this.data[o3 + 4 + 3] = 255;
      }
      e2 !== 0 && (this.pos += 4 - e2);
    }
  }, te.prototype.bit8 = function() {
    for (var t3 = this.width % 4, e2 = this.height - 1; e2 >= 0; e2--) {
      for (var r2 = this.bottom_up ? e2 : this.height - 1 - e2, n3 = 0; n3 < this.width; n3++) {
        var i3 = this.datav.getUint8(this.pos++, true), a3 = r2 * this.width * 4 + 4 * n3;
        if (i3 < this.palette.length) {
          var o3 = this.palette[i3];
          this.data[a3] = o3.red, this.data[a3 + 1] = o3.green, this.data[a3 + 2] = o3.blue, this.data[a3 + 3] = 255;
        } else
          this.data[a3] = 255, this.data[a3 + 1] = 255, this.data[a3 + 2] = 255, this.data[a3 + 3] = 255;
      }
      t3 !== 0 && (this.pos += 4 - t3);
    }
  }, te.prototype.bit15 = function() {
    for (var t3 = this.width % 3, e2 = parseInt("11111", 2), r2 = this.height - 1; r2 >= 0; r2--) {
      for (var n3 = this.bottom_up ? r2 : this.height - 1 - r2, i3 = 0; i3 < this.width; i3++) {
        var a3 = this.datav.getUint16(this.pos, true);
        this.pos += 2;
        var o3 = (a3 & e2) / e2 * 255 | 0, s3 = (a3 >> 5 & e2) / e2 * 255 | 0, c4 = (a3 >> 10 & e2) / e2 * 255 | 0, u3 = a3 >> 15 ? 255 : 0, h4 = n3 * this.width * 4 + 4 * i3;
        this.data[h4] = c4, this.data[h4 + 1] = s3, this.data[h4 + 2] = o3, this.data[h4 + 3] = u3;
      }
      this.pos += t3;
    }
  }, te.prototype.bit16 = function() {
    for (var t3 = this.width % 3, e2 = parseInt("11111", 2), r2 = parseInt("111111", 2), n3 = this.height - 1; n3 >= 0; n3--) {
      for (var i3 = this.bottom_up ? n3 : this.height - 1 - n3, a3 = 0; a3 < this.width; a3++) {
        var o3 = this.datav.getUint16(this.pos, true);
        this.pos += 2;
        var s3 = (o3 & e2) / e2 * 255 | 0, c4 = (o3 >> 5 & r2) / r2 * 255 | 0, u3 = (o3 >> 11) / e2 * 255 | 0, h4 = i3 * this.width * 4 + 4 * a3;
        this.data[h4] = u3, this.data[h4 + 1] = c4, this.data[h4 + 2] = s3, this.data[h4 + 3] = 255;
      }
      this.pos += t3;
    }
  }, te.prototype.bit24 = function() {
    for (var t3 = this.height - 1; t3 >= 0; t3--) {
      for (var e2 = this.bottom_up ? t3 : this.height - 1 - t3, r2 = 0; r2 < this.width; r2++) {
        var n3 = this.datav.getUint8(this.pos++, true), i3 = this.datav.getUint8(this.pos++, true), a3 = this.datav.getUint8(this.pos++, true), o3 = e2 * this.width * 4 + 4 * r2;
        this.data[o3] = a3, this.data[o3 + 1] = i3, this.data[o3 + 2] = n3, this.data[o3 + 3] = 255;
      }
      this.pos += this.width % 4;
    }
  }, te.prototype.bit32 = function() {
    for (var t3 = this.height - 1; t3 >= 0; t3--)
      for (var e2 = this.bottom_up ? t3 : this.height - 1 - t3, r2 = 0; r2 < this.width; r2++) {
        var n3 = this.datav.getUint8(this.pos++, true), i3 = this.datav.getUint8(this.pos++, true), a3 = this.datav.getUint8(this.pos++, true), o3 = this.datav.getUint8(this.pos++, true), s3 = e2 * this.width * 4 + 4 * r2;
        this.data[s3] = a3, this.data[s3 + 1] = i3, this.data[s3 + 2] = n3, this.data[s3 + 3] = o3;
      }
  }, te.prototype.getData = function() {
    return this.data;
  }, function(t3) {
    t3.processBMP = function(e2, r2, n3, i3) {
      var a3 = new te(e2, false), o3 = a3.width, s3 = a3.height, c4 = { data: a3.getData(), width: o3, height: s3 }, u3 = new Qt(100).encode(c4, 100);
      return t3.processJPEG.call(this, u3, r2, n3, i3);
    };
  }(M.API), ee.prototype.getData = function() {
    return this.data;
  }, function(t3) {
    t3.processWEBP = function(e2, r2, n3, i3) {
      var a3 = new ee(e2, false), o3 = a3.width, s3 = a3.height, c4 = { data: a3.getData(), width: o3, height: s3 }, u3 = new Qt(100).encode(c4, 100);
      return t3.processJPEG.call(this, u3, r2, n3, i3);
    };
  }(M.API), M.API.processRGBA = function(t3, e2, r2) {
    for (var n3 = t3.data, i3 = n3.length, a3 = new Uint8Array(i3 / 4 * 3), o3 = new Uint8Array(i3 / 4), s3 = 0, c4 = 0, u3 = 0; u3 < i3; u3 += 4) {
      var h4 = n3[u3], l3 = n3[u3 + 1], f3 = n3[u3 + 2], d2 = n3[u3 + 3];
      a3[s3++] = h4, a3[s3++] = l3, a3[s3++] = f3, o3[c4++] = d2;
    }
    var p4 = this.__addimage__.arrayBufferToBinaryString(a3);
    return { alpha: this.__addimage__.arrayBufferToBinaryString(o3), data: p4, index: e2, alias: r2, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: t3.width, height: t3.height };
  }, M.API.setLanguage = function(t3) {
    return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = false), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[t3] !== void 0 && (this.internal.languageSettings.languageCode = t3, this.internal.languageSettings.isSubscribed === false && (this.internal.events.subscribe("putCatalog", function() {
      this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = true)), this;
  }, Vt = M.API, Gt = Vt.getCharWidthsArray = function(e2, r2) {
    var n3, i3, a3 = (r2 = r2 || {}).font || this.internal.getFont(), o3 = r2.fontSize || this.internal.getFontSize(), s3 = r2.charSpace || this.internal.getCharSpace(), c4 = r2.widths ? r2.widths : a3.metadata.Unicode.widths, u3 = c4.fof ? c4.fof : 1, h4 = r2.kerning ? r2.kerning : a3.metadata.Unicode.kerning, l3 = h4.fof ? h4.fof : 1, f3 = r2.doKerning !== false, d2 = 0, p4 = e2.length, g2 = 0, m4 = c4[0] || u3, v3 = [];
    for (n3 = 0; n3 < p4; n3++)
      i3 = e2.charCodeAt(n3), typeof a3.metadata.widthOfString == "function" ? v3.push((a3.metadata.widthOfGlyph(a3.metadata.characterToGlyph(i3)) + s3 * (1e3 / o3) || 0) / 1e3) : (d2 = f3 && _typeof(h4[i3]) === "object" && !isNaN(parseInt(h4[i3][g2], 10)) ? h4[i3][g2] / l3 : 0, v3.push((c4[i3] || m4) / u3 + d2)), g2 = i3;
    return v3;
  }, Yt = Vt.getStringUnitWidth = function(t3, e2) {
    var r2 = (e2 = e2 || {}).fontSize || this.internal.getFontSize(), n3 = e2.font || this.internal.getFont(), i3 = e2.charSpace || this.internal.getCharSpace();
    return Vt.processArabic && (t3 = Vt.processArabic(t3)), typeof n3.metadata.widthOfString == "function" ? n3.metadata.widthOfString(t3, r2, i3) / r2 : Gt.apply(this, arguments).reduce(function(t4, e3) {
      return t4 + e3;
    }, 0);
  }, Jt = function(t3, e2, r2, n3) {
    for (var i3 = [], a3 = 0, o3 = t3.length, s3 = 0; a3 !== o3 && s3 + e2[a3] < r2; )
      s3 += e2[a3], a3++;
    i3.push(t3.slice(0, a3));
    var c4 = a3;
    for (s3 = 0; a3 !== o3; )
      s3 + e2[a3] > n3 && (i3.push(t3.slice(c4, a3)), s3 = 0, c4 = a3), s3 += e2[a3], a3++;
    return c4 !== a3 && i3.push(t3.slice(c4, a3)), i3;
  }, Xt = function(t3, e2, r2) {
    r2 || (r2 = {});
    var n3, i3, a3, o3, s3, c4, u3, h4 = [], l3 = [h4], f3 = r2.textIndent || 0, d2 = 0, p4 = 0, g2 = t3.split(" "), m4 = Gt.apply(this, [" ", r2])[0];
    if (c4 = r2.lineIndent === -1 ? g2[0].length + 2 : r2.lineIndent || 0) {
      var v3 = Array(c4).join(" "), b2 = [];
      g2.map(function(t4) {
        (t4 = t4.split(/\s*\n/)).length > 1 ? b2 = b2.concat(t4.map(function(t5, e3) {
          return (e3 && t5.length ? "\n" : "") + t5;
        })) : b2.push(t4[0]);
      }), g2 = b2, c4 = Yt.apply(this, [v3, r2]);
    }
    for (a3 = 0, o3 = g2.length; a3 < o3; a3++) {
      var y3 = 0;
      if (n3 = g2[a3], c4 && n3[0] == "\n" && (n3 = n3.substr(1), y3 = 1), f3 + d2 + (p4 = (i3 = Gt.apply(this, [n3, r2])).reduce(function(t4, e3) {
        return t4 + e3;
      }, 0)) > e2 || y3) {
        if (p4 > e2) {
          for (s3 = Jt.apply(this, [n3, i3, e2 - (f3 + d2), e2]), h4.push(s3.shift()), h4 = [s3.pop()]; s3.length; )
            l3.push([s3.shift()]);
          p4 = i3.slice(n3.length - (h4[0] ? h4[0].length : 0)).reduce(function(t4, e3) {
            return t4 + e3;
          }, 0);
        } else
          h4 = [n3];
        l3.push(h4), f3 = p4 + c4, d2 = m4;
      } else
        h4.push(n3), f3 += d2 + p4, d2 = m4;
    }
    return u3 = c4 ? function(t4, e3) {
      return (e3 ? v3 : "") + t4.join(" ");
    } : function(t4) {
      return t4.join(" ");
    }, l3.map(u3);
  }, Vt.splitTextToSize = function(t3, e2, r2) {
    var n3, i3 = (r2 = r2 || {}).fontSize || this.internal.getFontSize(), a3 = function(t4) {
      if (t4.widths && t4.kerning)
        return { widths: t4.widths, kerning: t4.kerning };
      var e3 = this.internal.getFont(t4.fontName, t4.fontStyle);
      return e3.metadata.Unicode ? { widths: e3.metadata.Unicode.widths || { 0: 1 }, kerning: e3.metadata.Unicode.kerning || {} } : { font: e3.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
    }.call(this, r2);
    n3 = Array.isArray(t3) ? t3 : String(t3).split(/\r?\n/);
    var o3 = 1 * this.internal.scaleFactor * e2 / i3;
    a3.textIndent = r2.textIndent ? 1 * r2.textIndent * this.internal.scaleFactor / i3 : 0, a3.lineIndent = r2.lineIndent;
    var s3, c4, u3 = [];
    for (s3 = 0, c4 = n3.length; s3 < c4; s3++)
      u3 = u3.concat(Xt.apply(this, [n3[s3], o3, a3]));
    return u3;
  }, function(e2) {
    e2.__fontmetrics__ = e2.__fontmetrics__ || {};
    for (var r2 = "klmnopqrstuvwxyz", n3 = {}, i3 = {}, a3 = 0; a3 < r2.length; a3++)
      n3[r2[a3]] = "0123456789abcdef"[a3], i3["0123456789abcdef"[a3]] = r2[a3];
    var o3 = function(t3) {
      return "0x" + parseInt(t3, 10).toString(16);
    }, s3 = e2.__fontmetrics__.compress = function(e3) {
      var r3, n4, a4, c5, u4 = ["{"];
      for (var h5 in e3) {
        if (r3 = e3[h5], isNaN(parseInt(h5, 10)) ? n4 = "'" + h5 + "'" : (h5 = parseInt(h5, 10), n4 = (n4 = o3(h5).slice(2)).slice(0, -1) + i3[n4.slice(-1)]), typeof r3 == "number")
          r3 < 0 ? (a4 = o3(r3).slice(3), c5 = "-") : (a4 = o3(r3).slice(2), c5 = ""), a4 = c5 + a4.slice(0, -1) + i3[a4.slice(-1)];
        else {
          if (_typeof(r3) !== "object")
            throw new Error("Don't know what to do with value type " + _typeof(r3) + ".");
          a4 = s3(r3);
        }
        u4.push(n4 + a4);
      }
      return u4.push("}"), u4.join("");
    }, c4 = e2.__fontmetrics__.uncompress = function(t3) {
      if (typeof t3 != "string")
        throw new Error("Invalid argument passed to uncompress.");
      for (var e3, r3, i4, a4, o4 = {}, s4 = 1, c5 = o4, u4 = [], h5 = "", l4 = "", f3 = t3.length - 1, d2 = 1; d2 < f3; d2 += 1)
        (a4 = t3[d2]) == "'" ? e3 ? (i4 = e3.join(""), e3 = void 0) : e3 = [] : e3 ? e3.push(a4) : a4 == "{" ? (u4.push([c5, i4]), c5 = {}, i4 = void 0) : a4 == "}" ? ((r3 = u4.pop())[0][r3[1]] = c5, i4 = void 0, c5 = r3[0]) : a4 == "-" ? s4 = -1 : i4 === void 0 ? n3.hasOwnProperty(a4) ? (h5 += n3[a4], i4 = parseInt(h5, 16) * s4, s4 = 1, h5 = "") : h5 += a4 : n3.hasOwnProperty(a4) ? (l4 += n3[a4], c5[i4] = parseInt(l4, 16) * s4, s4 = 1, i4 = void 0, l4 = "") : l4 += a4;
      return o4;
    }, u3 = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: c4("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, h4 = { Unicode: { Courier: u3, "Courier-Bold": u3, "Courier-BoldOblique": u3, "Courier-Oblique": u3, Helvetica: u3, "Helvetica-Bold": u3, "Helvetica-BoldOblique": u3, "Helvetica-Oblique": u3, "Times-Roman": u3, "Times-Bold": u3, "Times-BoldItalic": u3, "Times-Italic": u3 } }, l3 = { Unicode: { "Courier-Oblique": c4("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": c4("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": c4("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: c4("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": c4("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": c4("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: c4("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: c4("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": c4("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: c4("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": c4("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": c4("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": c4("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": c4("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
    e2.events.push(["addFont", function(t3) {
      var e3 = t3.font, r3 = l3.Unicode[e3.postScriptName];
      r3 && (e3.metadata.Unicode = {}, e3.metadata.Unicode.widths = r3.widths, e3.metadata.Unicode.kerning = r3.kerning);
      var n4 = h4.Unicode[e3.postScriptName];
      n4 && (e3.metadata.Unicode.encoding = n4, e3.encoding = n4.codePages[0]);
    }]);
  }(M.API), function(t3) {
    var e2 = function(t4) {
      for (var e3 = t4.length, r2 = new Uint8Array(e3), n3 = 0; n3 < e3; n3++)
        r2[n3] = t4.charCodeAt(n3);
      return r2;
    };
    t3.API.events.push(["addFont", function(r2) {
      var n3 = void 0, i3 = r2.font, a3 = r2.instance;
      if (!i3.isStandardFont) {
        if (a3 === void 0)
          throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i3.postScriptName + "').");
        if (typeof (n3 = a3.existsFileInVFS(i3.postScriptName) === false ? a3.loadFile(i3.postScriptName) : a3.getFileFromVFS(i3.postScriptName)) != "string")
          throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i3.postScriptName + "').");
        !function(r3, n4) {
          n4 = /^\x00\x01\x00\x00/.test(n4) ? e2(n4) : e2(u2(n4)), r3.metadata = t3.API.TTFFont.open(n4), r3.metadata.Unicode = r3.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, r3.metadata.glyIdsUsed = [0];
        }(i3, n3);
      }
    }]);
  }(M), function(t3) {
    function e2() {
      return (n2.canvg ? Promise.resolve(n2.canvg) : Promise.resolve().then(() => (init_index_es(), index_es_exports))).catch(function(t4) {
        return Promise.reject(new Error("Could not load canvg: " + t4));
      }).then(function(t4) {
        return t4.default ? t4.default : t4;
      });
    }
    M.API.addSvgAsImage = function(t4, r2, n3, i3, o3, s3, c4, u3) {
      if (isNaN(r2) || isNaN(n3))
        throw a2.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
      if (isNaN(i3) || isNaN(o3))
        throw a2.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
      var h4 = document.createElement("canvas");
      h4.width = i3, h4.height = o3;
      var l3 = h4.getContext("2d");
      l3.fillStyle = "#fff", l3.fillRect(0, 0, h4.width, h4.height);
      var f3 = { ignoreMouse: true, ignoreAnimation: true, ignoreDimensions: true }, d2 = this;
      return e2().then(function(e3) {
        return e3.fromString(l3, t4, f3);
      }, function() {
        return Promise.reject(new Error("Could not load canvg."));
      }).then(function(t5) {
        return t5.render(f3);
      }).then(function() {
        d2.addImage(h4.toDataURL("image/jpeg", 1), r2, n3, i3, o3, c4, u3);
      });
    };
  }(), M.API.putTotalPages = function(t3) {
    var e2, r2 = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e2 = new RegExp(t3, "g"), r2 = this.internal.getNumberOfPages()) : (e2 = new RegExp(this.pdfEscape16(t3, this.internal.getFont()), "g"), r2 = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for (var n3 = 1; n3 <= this.internal.getNumberOfPages(); n3++)
      for (var i3 = 0; i3 < this.internal.pages[n3].length; i3++)
        this.internal.pages[n3][i3] = this.internal.pages[n3][i3].replace(e2, r2);
    return this;
  }, M.API.viewerPreferences = function(e2, r2) {
    var n3;
    e2 = e2 || {}, r2 = r2 || false;
    var i3, a3, o3, s3 = { HideToolbar: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.3 }, HideMenubar: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.3 }, FitWindow: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.3 }, CenterWindow: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: false, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: false, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: false, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: false, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: false, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: false, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: false, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: false, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: false, value: false, type: "boolean", explicitSet: false, valueSet: [true, false], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: false, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: false, valueSet: null, pdfVersion: 1.7 } }, c4 = Object.keys(s3), u3 = [], h4 = 0, l3 = 0, f3 = 0;
    function d2(t3, e3) {
      var r3, n4 = false;
      for (r3 = 0; r3 < t3.length; r3 += 1)
        t3[r3] === e3 && (n4 = true);
      return n4;
    }
    if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s3)), this.internal.viewerpreferences.isSubscribed = false), n3 = this.internal.viewerpreferences.configuration, e2 === "reset" || r2 === true) {
      var p4 = c4.length;
      for (f3 = 0; f3 < p4; f3 += 1)
        n3[c4[f3]].value = n3[c4[f3]].defaultValue, n3[c4[f3]].explicitSet = false;
    }
    if (_typeof(e2) === "object") {
      for (a3 in e2)
        if (o3 = e2[a3], d2(c4, a3) && o3 !== void 0) {
          if (n3[a3].type === "boolean" && typeof o3 == "boolean")
            n3[a3].value = o3;
          else if (n3[a3].type === "name" && d2(n3[a3].valueSet, o3))
            n3[a3].value = o3;
          else if (n3[a3].type === "integer" && Number.isInteger(o3))
            n3[a3].value = o3;
          else if (n3[a3].type === "array") {
            for (h4 = 0; h4 < o3.length; h4 += 1)
              if (i3 = true, o3[h4].length === 1 && typeof o3[h4][0] == "number")
                u3.push(String(o3[h4] - 1));
              else if (o3[h4].length > 1) {
                for (l3 = 0; l3 < o3[h4].length; l3 += 1)
                  typeof o3[h4][l3] != "number" && (i3 = false);
                i3 === true && u3.push([o3[h4][0] - 1, o3[h4][1] - 1].join(" "));
              }
            n3[a3].value = "[" + u3.join(" ") + "]";
          } else
            n3[a3].value = n3[a3].defaultValue;
          n3[a3].explicitSet = true;
        }
    }
    return this.internal.viewerpreferences.isSubscribed === false && (this.internal.events.subscribe("putCatalog", function() {
      var t3, e3 = [];
      for (t3 in n3)
        n3[t3].explicitSet === true && (n3[t3].type === "name" ? e3.push("/" + t3 + " /" + n3[t3].value) : e3.push("/" + t3 + " " + n3[t3].value));
      e3.length !== 0 && this.internal.write("/ViewerPreferences\n<<\n" + e3.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = true), this.internal.viewerpreferences.configuration = n3, this;
  }, function(t3) {
    var e2 = function() {
      var t4 = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e3 = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r3 = unescape(encodeURIComponent(t4)), n3 = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i3 = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a3 = unescape(encodeURIComponent("</x:xmpmeta>")), o3 = r3.length + n3.length + i3.length + e3.length + a3.length;
      this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o3 + " >>"), this.internal.write("stream"), this.internal.write(e3 + r3 + n3 + i3 + a3), this.internal.write("endstream"), this.internal.write("endobj");
    }, r2 = function() {
      this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t3.addMetadata = function(t4, n3) {
      return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: t4, namespaceuri: n3 || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", r2), this.internal.events.subscribe("postPutResources", e2)), this;
    };
  }(M.API), function(t3) {
    var e2 = t3.API, r2 = e2.pdfEscape16 = function(t4, e3) {
      for (var r3, n4 = e3.metadata.Unicode.widths, i4 = ["", "0", "00", "000", "0000"], a3 = [""], o3 = 0, s3 = t4.length; o3 < s3; ++o3) {
        if (r3 = e3.metadata.characterToGlyph(t4.charCodeAt(o3)), e3.metadata.glyIdsUsed.push(r3), e3.metadata.toUnicode[r3] = t4.charCodeAt(o3), n4.indexOf(r3) == -1 && (n4.push(r3), n4.push([parseInt(e3.metadata.widthOfGlyph(r3), 10)])), r3 == "0")
          return a3.join("");
        r3 = r3.toString(16), a3.push(i4[4 - r3.length], r3);
      }
      return a3.join("");
    }, n3 = function(t4) {
      var e3, r3, n4, i4, a3, o3, s3;
      for (a3 = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n4 = [], o3 = 0, s3 = (r3 = Object.keys(t4).sort(function(t5, e4) {
        return t5 - e4;
      })).length; o3 < s3; o3++)
        e3 = r3[o3], n4.length >= 100 && (a3 += "\n" + n4.length + " beginbfchar\n" + n4.join("\n") + "\nendbfchar", n4 = []), t4[e3] !== void 0 && t4[e3] !== null && typeof t4[e3].toString == "function" && (i4 = ("0000" + t4[e3].toString(16)).slice(-4), e3 = ("0000" + (+e3).toString(16)).slice(-4), n4.push("<" + e3 + "><" + i4 + ">"));
      return n4.length && (a3 += "\n" + n4.length + " beginbfchar\n" + n4.join("\n") + "\nendbfchar\n"), a3 += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e2.events.push(["putFont", function(e3) {
      !function(e4) {
        var r3 = e4.font, i4 = e4.out, a3 = e4.newObject, o3 = e4.putStream;
        if (r3.metadata instanceof t3.API.TTFFont && r3.encoding === "Identity-H") {
          for (var s3 = r3.metadata.Unicode.widths, c4 = r3.metadata.subset.encode(r3.metadata.glyIdsUsed, 1), u3 = "", h4 = 0; h4 < c4.length; h4++)
            u3 += String.fromCharCode(c4[h4]);
          var l3 = a3();
          o3({ data: u3, addLength1: true, objectId: l3 }), i4("endobj");
          var f3 = a3();
          o3({ data: n3(r3.metadata.toUnicode), addLength1: true, objectId: f3 }), i4("endobj");
          var d2 = a3();
          i4("<<"), i4("/Type /FontDescriptor"), i4("/FontName /" + F(r3.fontName)), i4("/FontFile2 " + l3 + " 0 R"), i4("/FontBBox " + t3.API.PDFObject.convert(r3.metadata.bbox)), i4("/Flags " + r3.metadata.flags), i4("/StemV " + r3.metadata.stemV), i4("/ItalicAngle " + r3.metadata.italicAngle), i4("/Ascent " + r3.metadata.ascender), i4("/Descent " + r3.metadata.decender), i4("/CapHeight " + r3.metadata.capHeight), i4(">>"), i4("endobj");
          var p4 = a3();
          i4("<<"), i4("/Type /Font"), i4("/BaseFont /" + F(r3.fontName)), i4("/FontDescriptor " + d2 + " 0 R"), i4("/W " + t3.API.PDFObject.convert(s3)), i4("/CIDToGIDMap /Identity"), i4("/DW 1000"), i4("/Subtype /CIDFontType2"), i4("/CIDSystemInfo"), i4("<<"), i4("/Supplement 0"), i4("/Registry (Adobe)"), i4("/Ordering (" + r3.encoding + ")"), i4(">>"), i4(">>"), i4("endobj"), r3.objectNumber = a3(), i4("<<"), i4("/Type /Font"), i4("/Subtype /Type0"), i4("/ToUnicode " + f3 + " 0 R"), i4("/BaseFont /" + F(r3.fontName)), i4("/Encoding /" + r3.encoding), i4("/DescendantFonts [" + p4 + " 0 R]"), i4(">>"), i4("endobj"), r3.isAlreadyPutted = true;
        }
      }(e3);
    }]);
    e2.events.push(["putFont", function(e3) {
      !function(e4) {
        var r3 = e4.font, i4 = e4.out, a3 = e4.newObject, o3 = e4.putStream;
        if (r3.metadata instanceof t3.API.TTFFont && r3.encoding === "WinAnsiEncoding") {
          for (var s3 = r3.metadata.rawData, c4 = "", u3 = 0; u3 < s3.length; u3++)
            c4 += String.fromCharCode(s3[u3]);
          var h4 = a3();
          o3({ data: c4, addLength1: true, objectId: h4 }), i4("endobj");
          var l3 = a3();
          o3({ data: n3(r3.metadata.toUnicode), addLength1: true, objectId: l3 }), i4("endobj");
          var f3 = a3();
          i4("<<"), i4("/Descent " + r3.metadata.decender), i4("/CapHeight " + r3.metadata.capHeight), i4("/StemV " + r3.metadata.stemV), i4("/Type /FontDescriptor"), i4("/FontFile2 " + h4 + " 0 R"), i4("/Flags 96"), i4("/FontBBox " + t3.API.PDFObject.convert(r3.metadata.bbox)), i4("/FontName /" + F(r3.fontName)), i4("/ItalicAngle " + r3.metadata.italicAngle), i4("/Ascent " + r3.metadata.ascender), i4(">>"), i4("endobj"), r3.objectNumber = a3();
          for (var d2 = 0; d2 < r3.metadata.hmtx.widths.length; d2++)
            r3.metadata.hmtx.widths[d2] = parseInt(r3.metadata.hmtx.widths[d2] * (1e3 / r3.metadata.head.unitsPerEm));
          i4("<</Subtype/TrueType/Type/Font/ToUnicode " + l3 + " 0 R/BaseFont/" + F(r3.fontName) + "/FontDescriptor " + f3 + " 0 R/Encoding/" + r3.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t3.API.PDFObject.convert(r3.metadata.hmtx.widths) + ">>"), i4("endobj"), r3.isAlreadyPutted = true;
        }
      }(e3);
    }]);
    var i3 = function(t4) {
      var e3, n4 = t4.text || "", i4 = t4.x, a3 = t4.y, o3 = t4.options || {}, s3 = t4.mutex || {}, c4 = s3.pdfEscape, u3 = s3.activeFontKey, h4 = s3.fonts, l3 = u3, f3 = "", d2 = 0, p4 = "", g2 = h4[l3].encoding;
      if (h4[l3].encoding !== "Identity-H")
        return { text: n4, x: i4, y: a3, options: o3, mutex: s3 };
      for (p4 = n4, l3 = u3, Array.isArray(n4) && (p4 = n4[0]), d2 = 0; d2 < p4.length; d2 += 1)
        h4[l3].metadata.hasOwnProperty("cmap") && (e3 = h4[l3].metadata.cmap.unicode.codeMap[p4[d2].charCodeAt(0)]), e3 || p4[d2].charCodeAt(0) < 256 && h4[l3].metadata.hasOwnProperty("Unicode") ? f3 += p4[d2] : f3 += "";
      var m4 = "";
      return parseInt(l3.slice(1)) < 14 || g2 === "WinAnsiEncoding" ? m4 = c4(f3, l3).split("").map(function(t5) {
        return t5.charCodeAt(0).toString(16);
      }).join("") : g2 === "Identity-H" && (m4 = r2(f3, h4[l3])), s3.isHex = true, { text: m4, x: i4, y: a3, options: o3, mutex: s3 };
    };
    e2.events.push(["postProcessText", function(t4) {
      var e3 = t4.text || "", r3 = [], n4 = { text: e3, x: t4.x, y: t4.y, options: t4.options, mutex: t4.mutex };
      if (Array.isArray(e3)) {
        var a3 = 0;
        for (a3 = 0; a3 < e3.length; a3 += 1)
          Array.isArray(e3[a3]) && e3[a3].length === 3 ? r3.push([i3(Object.assign({}, n4, { text: e3[a3][0] })).text, e3[a3][1], e3[a3][2]]) : r3.push(i3(Object.assign({}, n4, { text: e3[a3] })).text);
        t4.text = r3;
      } else
        t4.text = i3(Object.assign({}, n4, { text: e3 })).text;
    }]);
  }(M), function(t3) {
    var e2 = function() {
      return this.internal.vFS === void 0 && (this.internal.vFS = {}), true;
    };
    t3.existsFileInVFS = function(t4) {
      return e2.call(this), this.internal.vFS[t4] !== void 0;
    }, t3.addFileToVFS = function(t4, r2) {
      return e2.call(this), this.internal.vFS[t4] = r2, this;
    }, t3.getFileFromVFS = function(t4) {
      return e2.call(this), this.internal.vFS[t4] !== void 0 ? this.internal.vFS[t4] : null;
    };
  }(M.API), function(t3) {
    t3.__bidiEngine__ = t3.prototype.__bidiEngine__ = function(t4) {
      var r3, n3, i3, a3, o3, s3, c4, u3 = e2, h4 = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], l3 = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], f3 = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, d2 = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, p4 = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "\xAB", "\xBB", "\xAB", "\u2039", "\u203A", "\u2039", "\u2045", "\u2046", "\u2045", "\u207D", "\u207E", "\u207D", "\u208D", "\u208E", "\u208D", "\u2264", "\u2265", "\u2264", "\u2329", "\u232A", "\u2329", "\uFE59", "\uFE5A", "\uFE59", "\uFE5B", "\uFE5C", "\uFE5B", "\uFE5D", "\uFE5E", "\uFE5D", "\uFE64", "\uFE65", "\uFE64"], g2 = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m4 = false, v3 = 0;
      this.__bidiEngine__ = {};
      var b2 = function(t5) {
        var e3 = t5.charCodeAt(), r4 = e3 >> 8, n4 = d2[r4];
        return n4 !== void 0 ? u3[256 * n4 + (255 & e3)] : r4 === 252 || r4 === 253 ? "AL" : g2.test(r4) ? "L" : r4 === 8 ? "R" : "N";
      }, y3 = function(t5) {
        for (var e3, r4 = 0; r4 < t5.length; r4++) {
          if ((e3 = b2(t5.charAt(r4))) === "L")
            return false;
          if (e3 === "R")
            return true;
        }
        return false;
      }, w2 = function(t5, e3, o4, s4) {
        var c5, u4, h5, l4, f4 = e3[s4];
        switch (f4) {
          case "L":
          case "R":
            m4 = false;
            break;
          case "N":
          case "AN":
            break;
          case "EN":
            m4 && (f4 = "AN");
            break;
          case "AL":
            m4 = true, f4 = "R";
            break;
          case "WS":
            f4 = "N";
            break;
          case "CS":
            s4 < 1 || s4 + 1 >= e3.length || (c5 = o4[s4 - 1]) !== "EN" && c5 !== "AN" || (u4 = e3[s4 + 1]) !== "EN" && u4 !== "AN" ? f4 = "N" : m4 && (u4 = "AN"), f4 = u4 === c5 ? u4 : "N";
            break;
          case "ES":
            f4 = (c5 = s4 > 0 ? o4[s4 - 1] : "B") === "EN" && s4 + 1 < e3.length && e3[s4 + 1] === "EN" ? "EN" : "N";
            break;
          case "ET":
            if (s4 > 0 && o4[s4 - 1] === "EN") {
              f4 = "EN";
              break;
            }
            if (m4) {
              f4 = "N";
              break;
            }
            for (h5 = s4 + 1, l4 = e3.length; h5 < l4 && e3[h5] === "ET"; )
              h5++;
            f4 = h5 < l4 && e3[h5] === "EN" ? "EN" : "N";
            break;
          case "NSM":
            if (i3 && !a3) {
              for (l4 = e3.length, h5 = s4 + 1; h5 < l4 && e3[h5] === "NSM"; )
                h5++;
              if (h5 < l4) {
                var d3 = t5[s4], p5 = d3 >= 1425 && d3 <= 2303 || d3 === 64286;
                if (c5 = e3[h5], p5 && (c5 === "R" || c5 === "AL")) {
                  f4 = "R";
                  break;
                }
              }
            }
            f4 = s4 < 1 || (c5 = e3[s4 - 1]) === "B" ? "N" : o4[s4 - 1];
            break;
          case "B":
            m4 = false, r3 = true, f4 = v3;
            break;
          case "S":
            n3 = true, f4 = "N";
            break;
          case "LRE":
          case "RLE":
          case "LRO":
          case "RLO":
          case "PDF":
            m4 = false;
            break;
          case "BN":
            f4 = "N";
        }
        return f4;
      }, N3 = function(t5, e3, r4) {
        var n4 = t5.split("");
        return r4 && L2(n4, r4, { hiLevel: v3 }), n4.reverse(), e3 && e3.reverse(), n4.join("");
      }, L2 = function(t5, e3, i4) {
        var a4, o4, s4, c5, u4, d3 = -1, p5 = t5.length, g3 = 0, y4 = [], N4 = v3 ? l3 : h4, L3 = [];
        for (m4 = false, r3 = false, n3 = false, o4 = 0; o4 < p5; o4++)
          L3[o4] = b2(t5[o4]);
        for (s4 = 0; s4 < p5; s4++) {
          if (u4 = g3, y4[s4] = w2(t5, L3, y4, s4), a4 = 240 & (g3 = N4[u4][f3[y4[s4]]]), g3 &= 15, e3[s4] = c5 = N4[g3][5], a4 > 0)
            if (a4 === 16) {
              for (o4 = d3; o4 < s4; o4++)
                e3[o4] = 1;
              d3 = -1;
            } else
              d3 = -1;
          if (N4[g3][6])
            d3 === -1 && (d3 = s4);
          else if (d3 > -1) {
            for (o4 = d3; o4 < s4; o4++)
              e3[o4] = c5;
            d3 = -1;
          }
          L3[s4] === "B" && (e3[s4] = 0), i4.hiLevel |= c5;
        }
        n3 && function(t6, e4, r4) {
          for (var n4 = 0; n4 < r4; n4++)
            if (t6[n4] === "S") {
              e4[n4] = v3;
              for (var i5 = n4 - 1; i5 >= 0 && t6[i5] === "WS"; i5--)
                e4[i5] = v3;
            }
        }(L3, e3, p5);
      }, A2 = function(t5, e3, n4, i4, a4) {
        if (!(a4.hiLevel < t5)) {
          if (t5 === 1 && v3 === 1 && !r3)
            return e3.reverse(), void (n4 && n4.reverse());
          for (var o4, s4, c5, u4, h5 = e3.length, l4 = 0; l4 < h5; ) {
            if (i4[l4] >= t5) {
              for (c5 = l4 + 1; c5 < h5 && i4[c5] >= t5; )
                c5++;
              for (u4 = l4, s4 = c5 - 1; u4 < s4; u4++, s4--)
                o4 = e3[u4], e3[u4] = e3[s4], e3[s4] = o4, n4 && (o4 = n4[u4], n4[u4] = n4[s4], n4[s4] = o4);
              l4 = c5;
            }
            l4++;
          }
        }
      }, x2 = function(t5, e3, r4) {
        var n4 = t5.split(""), i4 = { hiLevel: v3 };
        return r4 || (r4 = []), L2(n4, r4, i4), function(t6, e4, r5) {
          if (r5.hiLevel !== 0 && c4)
            for (var n5, i5 = 0; i5 < t6.length; i5++)
              e4[i5] === 1 && (n5 = p4.indexOf(t6[i5])) >= 0 && (t6[i5] = p4[n5 + 1]);
        }(n4, r4, i4), A2(2, n4, e3, r4, i4), A2(1, n4, e3, r4, i4), n4.join("");
      };
      return this.__bidiEngine__.doBidiReorder = function(t5, e3, r4) {
        if (function(t6, e4) {
          if (e4)
            for (var r5 = 0; r5 < t6.length; r5++)
              e4[r5] = r5;
          a3 === void 0 && (a3 = y3(t6)), s3 === void 0 && (s3 = y3(t6));
        }(t5, e3), i3 || !o3 || s3)
          if (i3 && o3 && a3 ^ s3)
            v3 = a3 ? 1 : 0, t5 = N3(t5, e3, r4);
          else if (!i3 && o3 && s3)
            v3 = a3 ? 1 : 0, t5 = x2(t5, e3, r4), t5 = N3(t5, e3);
          else if (!i3 || a3 || o3 || s3) {
            if (i3 && !o3 && a3 ^ s3)
              t5 = N3(t5, e3), a3 ? (v3 = 0, t5 = x2(t5, e3, r4)) : (v3 = 1, t5 = x2(t5, e3, r4), t5 = N3(t5, e3));
            else if (i3 && a3 && !o3 && s3)
              v3 = 1, t5 = x2(t5, e3, r4), t5 = N3(t5, e3);
            else if (!i3 && !o3 && a3 ^ s3) {
              var n4 = c4;
              a3 ? (v3 = 1, t5 = x2(t5, e3, r4), v3 = 0, c4 = false, t5 = x2(t5, e3, r4), c4 = n4) : (v3 = 0, t5 = x2(t5, e3, r4), t5 = N3(t5, e3), v3 = 1, c4 = false, t5 = x2(t5, e3, r4), c4 = n4, t5 = N3(t5, e3));
            }
          } else
            v3 = 0, t5 = x2(t5, e3, r4);
        else
          v3 = a3 ? 1 : 0, t5 = x2(t5, e3, r4);
        return t5;
      }, this.__bidiEngine__.setOptions = function(t5) {
        t5 && (i3 = t5.isInputVisual, o3 = t5.isOutputVisual, a3 = t5.isInputRtl, s3 = t5.isOutputRtl, c4 = t5.isSymmetricSwapping);
      }, this.__bidiEngine__.setOptions(t4), this.__bidiEngine__;
    };
    var e2 = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], r2 = new t3.__bidiEngine__({ isInputVisual: true });
    t3.API.events.push(["postProcessText", function(t4) {
      var e3 = t4.text, n3 = (t4.x, t4.y, t4.options || {}), i3 = (t4.mutex, n3.lang, []);
      if (n3.isInputVisual = typeof n3.isInputVisual != "boolean" || n3.isInputVisual, r2.setOptions(n3), Object.prototype.toString.call(e3) === "[object Array]") {
        var a3 = 0;
        for (i3 = [], a3 = 0; a3 < e3.length; a3 += 1)
          Object.prototype.toString.call(e3[a3]) === "[object Array]" ? i3.push([r2.doBidiReorder(e3[a3][0]), e3[a3][1], e3[a3][2]]) : i3.push([r2.doBidiReorder(e3[a3])]);
        t4.text = i3;
      } else
        t4.text = r2.doBidiReorder(e3);
      r2.setOptions({ isInputVisual: true });
    }]);
  }(M), M.API.TTFFont = function() {
    function t3(t4) {
      var e2;
      if (this.rawData = t4, e2 = this.contents = new ne(t4), this.contents.pos = 4, e2.readString(4) === "ttcf")
        throw new Error("TTCF not supported.");
      e2.pos = 0, this.parse(), this.subset = new Le(this), this.registerTTF();
    }
    return t3.open = function(e2) {
      return new t3(e2);
    }, t3.prototype.parse = function() {
      return this.directory = new ie(this.contents), this.head = new se(this), this.name = new pe(this), this.cmap = new ue(this), this.toUnicode = {}, this.hhea = new he(this), this.maxp = new ge(this), this.hmtx = new me(this), this.post = new fe(this), this.os2 = new le(this), this.loca = new Ne(this), this.glyf = new be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
    }, t3.prototype.registerTTF = function() {
      var t4, e2, r2, n3, i3;
      if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = function() {
        var e3, r3, n4, i4;
        for (i4 = [], e3 = 0, r3 = (n4 = this.bbox).length; e3 < r3; e3++)
          t4 = n4[e3], i4.push(Math.round(t4 * this.scaleFactor));
        return i4;
      }.call(this), this.stemV = 0, this.post.exists ? (r2 = 255 & (n3 = this.post.italic_angle), (32768 & (e2 = n3 >> 16)) != 0 && (e2 = -(1 + (65535 ^ e2))), this.italicAngle = +(e2 + "." + r2)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i3 = this.familyClass) === 1 || i3 === 2 || i3 === 3 || i3 === 4 || i3 === 5 || i3 === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode)
        throw new Error("No unicode cmap for font");
    }, t3.prototype.characterToGlyph = function(t4) {
      var e2;
      return ((e2 = this.cmap.unicode) != null ? e2.codeMap[t4] : void 0) || 0;
    }, t3.prototype.widthOfGlyph = function(t4) {
      var e2;
      return e2 = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t4).advance * e2;
    }, t3.prototype.widthOfString = function(t4, e2, r2) {
      var n3, i3, a3, o3;
      for (a3 = 0, i3 = 0, o3 = (t4 = "" + t4).length; 0 <= o3 ? i3 < o3 : i3 > o3; i3 = 0 <= o3 ? ++i3 : --i3)
        n3 = t4.charCodeAt(i3), a3 += this.widthOfGlyph(this.characterToGlyph(n3)) + r2 * (1e3 / e2) || 0;
      return a3 * (e2 / 1e3);
    }, t3.prototype.lineHeight = function(t4, e2) {
      var r2;
      return e2 == null && (e2 = false), r2 = e2 ? this.lineGap : 0, (this.ascender + r2 - this.decender) / 1e3 * t4;
    }, t3;
  }();
  var re;
  var ne = function() {
    function t3(t4) {
      this.data = t4 != null ? t4 : [], this.pos = 0, this.length = this.data.length;
    }
    return t3.prototype.readByte = function() {
      return this.data[this.pos++];
    }, t3.prototype.writeByte = function(t4) {
      return this.data[this.pos++] = t4;
    }, t3.prototype.readUInt32 = function() {
      return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t3.prototype.writeUInt32 = function(t4) {
      return this.writeByte(t4 >>> 24 & 255), this.writeByte(t4 >> 16 & 255), this.writeByte(t4 >> 8 & 255), this.writeByte(255 & t4);
    }, t3.prototype.readInt32 = function() {
      var t4;
      return (t4 = this.readUInt32()) >= 2147483648 ? t4 - 4294967296 : t4;
    }, t3.prototype.writeInt32 = function(t4) {
      return t4 < 0 && (t4 += 4294967296), this.writeUInt32(t4);
    }, t3.prototype.readUInt16 = function() {
      return this.readByte() << 8 | this.readByte();
    }, t3.prototype.writeUInt16 = function(t4) {
      return this.writeByte(t4 >> 8 & 255), this.writeByte(255 & t4);
    }, t3.prototype.readInt16 = function() {
      var t4;
      return (t4 = this.readUInt16()) >= 32768 ? t4 - 65536 : t4;
    }, t3.prototype.writeInt16 = function(t4) {
      return t4 < 0 && (t4 += 65536), this.writeUInt16(t4);
    }, t3.prototype.readString = function(t4) {
      var e2, r2;
      for (r2 = [], e2 = 0; 0 <= t4 ? e2 < t4 : e2 > t4; e2 = 0 <= t4 ? ++e2 : --e2)
        r2[e2] = String.fromCharCode(this.readByte());
      return r2.join("");
    }, t3.prototype.writeString = function(t4) {
      var e2, r2, n3;
      for (n3 = [], e2 = 0, r2 = t4.length; 0 <= r2 ? e2 < r2 : e2 > r2; e2 = 0 <= r2 ? ++e2 : --e2)
        n3.push(this.writeByte(t4.charCodeAt(e2)));
      return n3;
    }, t3.prototype.readShort = function() {
      return this.readInt16();
    }, t3.prototype.writeShort = function(t4) {
      return this.writeInt16(t4);
    }, t3.prototype.readLongLong = function() {
      var t4, e2, r2, n3, i3, a3, o3, s3;
      return t4 = this.readByte(), e2 = this.readByte(), r2 = this.readByte(), n3 = this.readByte(), i3 = this.readByte(), a3 = this.readByte(), o3 = this.readByte(), s3 = this.readByte(), 128 & t4 ? -1 * (72057594037927940 * (255 ^ t4) + 281474976710656 * (255 ^ e2) + 1099511627776 * (255 ^ r2) + 4294967296 * (255 ^ n3) + 16777216 * (255 ^ i3) + 65536 * (255 ^ a3) + 256 * (255 ^ o3) + (255 ^ s3) + 1) : 72057594037927940 * t4 + 281474976710656 * e2 + 1099511627776 * r2 + 4294967296 * n3 + 16777216 * i3 + 65536 * a3 + 256 * o3 + s3;
    }, t3.prototype.writeLongLong = function(t4) {
      var e2, r2;
      return e2 = Math.floor(t4 / 4294967296), r2 = 4294967295 & t4, this.writeByte(e2 >> 24 & 255), this.writeByte(e2 >> 16 & 255), this.writeByte(e2 >> 8 & 255), this.writeByte(255 & e2), this.writeByte(r2 >> 24 & 255), this.writeByte(r2 >> 16 & 255), this.writeByte(r2 >> 8 & 255), this.writeByte(255 & r2);
    }, t3.prototype.readInt = function() {
      return this.readInt32();
    }, t3.prototype.writeInt = function(t4) {
      return this.writeInt32(t4);
    }, t3.prototype.read = function(t4) {
      var e2, r2;
      for (e2 = [], r2 = 0; 0 <= t4 ? r2 < t4 : r2 > t4; r2 = 0 <= t4 ? ++r2 : --r2)
        e2.push(this.readByte());
      return e2;
    }, t3.prototype.write = function(t4) {
      var e2, r2, n3, i3;
      for (i3 = [], r2 = 0, n3 = t4.length; r2 < n3; r2++)
        e2 = t4[r2], i3.push(this.writeByte(e2));
      return i3;
    }, t3;
  }();
  var ie = function() {
    var t3;
    function e2(t4) {
      var e3, r2, n3;
      for (this.scalarType = t4.readInt(), this.tableCount = t4.readShort(), this.searchRange = t4.readShort(), this.entrySelector = t4.readShort(), this.rangeShift = t4.readShort(), this.tables = {}, r2 = 0, n3 = this.tableCount; 0 <= n3 ? r2 < n3 : r2 > n3; r2 = 0 <= n3 ? ++r2 : --r2)
        e3 = { tag: t4.readString(4), checksum: t4.readInt(), offset: t4.readInt(), length: t4.readInt() }, this.tables[e3.tag] = e3;
    }
    return e2.prototype.encode = function(e3) {
      var r2, n3, i3, a3, o3, s3, c4, u3, h4, l3, f3, d2, p4;
      for (p4 in f3 = Object.keys(e3).length, s3 = Math.log(2), h4 = 16 * Math.floor(Math.log(f3) / s3), a3 = Math.floor(h4 / s3), u3 = 16 * f3 - h4, (n3 = new ne()).writeInt(this.scalarType), n3.writeShort(f3), n3.writeShort(h4), n3.writeShort(a3), n3.writeShort(u3), i3 = 16 * f3, c4 = n3.pos + i3, o3 = null, d2 = [], e3)
        for (l3 = e3[p4], n3.writeString(p4), n3.writeInt(t3(l3)), n3.writeInt(c4), n3.writeInt(l3.length), d2 = d2.concat(l3), p4 === "head" && (o3 = c4), c4 += l3.length; c4 % 4; )
          d2.push(0), c4++;
      return n3.write(d2), r2 = 2981146554 - t3(n3.data), n3.pos = o3 + 8, n3.writeUInt32(r2), n3.data;
    }, t3 = function(t4) {
      var e3, r2, n3, i3;
      for (t4 = ve.call(t4); t4.length % 4; )
        t4.push(0);
      for (n3 = new ne(t4), r2 = 0, e3 = 0, i3 = t4.length; e3 < i3; e3 = e3 += 4)
        r2 += n3.readUInt32();
      return 4294967295 & r2;
    }, e2;
  }();
  var ae = {}.hasOwnProperty;
  var oe = function(t3, e2) {
    for (var r2 in e2)
      ae.call(e2, r2) && (t3[r2] = e2[r2]);
    function n3() {
      this.constructor = t3;
    }
    return n3.prototype = e2.prototype, t3.prototype = new n3(), t3.__super__ = e2.prototype, t3;
  };
  re = function() {
    function t3(t4) {
      var e2;
      this.file = t4, e2 = this.file.directory.tables[this.tag], this.exists = !!e2, e2 && (this.offset = e2.offset, this.length = e2.length, this.parse(this.file.contents));
    }
    return t3.prototype.parse = function() {
    }, t3.prototype.encode = function() {
    }, t3.prototype.raw = function() {
      return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t3;
  }();
  var se = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "head", e2.prototype.parse = function(t4) {
      return t4.pos = this.offset, this.version = t4.readInt(), this.revision = t4.readInt(), this.checkSumAdjustment = t4.readInt(), this.magicNumber = t4.readInt(), this.flags = t4.readShort(), this.unitsPerEm = t4.readShort(), this.created = t4.readLongLong(), this.modified = t4.readLongLong(), this.xMin = t4.readShort(), this.yMin = t4.readShort(), this.xMax = t4.readShort(), this.yMax = t4.readShort(), this.macStyle = t4.readShort(), this.lowestRecPPEM = t4.readShort(), this.fontDirectionHint = t4.readShort(), this.indexToLocFormat = t4.readShort(), this.glyphDataFormat = t4.readShort();
    }, e2.prototype.encode = function(t4) {
      var e3;
      return (e3 = new ne()).writeInt(this.version), e3.writeInt(this.revision), e3.writeInt(this.checkSumAdjustment), e3.writeInt(this.magicNumber), e3.writeShort(this.flags), e3.writeShort(this.unitsPerEm), e3.writeLongLong(this.created), e3.writeLongLong(this.modified), e3.writeShort(this.xMin), e3.writeShort(this.yMin), e3.writeShort(this.xMax), e3.writeShort(this.yMax), e3.writeShort(this.macStyle), e3.writeShort(this.lowestRecPPEM), e3.writeShort(this.fontDirectionHint), e3.writeShort(t4), e3.writeShort(this.glyphDataFormat), e3.data;
    }, e2;
  }();
  var ce = function() {
    function t3(t4, e2) {
      var r2, n3, i3, a3, o3, s3, c4, u3, h4, l3, f3, d2, p4, g2, m4, v3, b2;
      switch (this.platformID = t4.readUInt16(), this.encodingID = t4.readShort(), this.offset = e2 + t4.readInt(), h4 = t4.pos, t4.pos = this.offset, this.format = t4.readUInt16(), this.length = t4.readUInt16(), this.language = t4.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
        case 0:
          for (s3 = 0; s3 < 256; ++s3)
            this.codeMap[s3] = t4.readByte();
          break;
        case 4:
          for (f3 = t4.readUInt16(), l3 = f3 / 2, t4.pos += 6, i3 = function() {
            var e3, r3;
            for (r3 = [], s3 = e3 = 0; 0 <= l3 ? e3 < l3 : e3 > l3; s3 = 0 <= l3 ? ++e3 : --e3)
              r3.push(t4.readUInt16());
            return r3;
          }(), t4.pos += 2, p4 = function() {
            var e3, r3;
            for (r3 = [], s3 = e3 = 0; 0 <= l3 ? e3 < l3 : e3 > l3; s3 = 0 <= l3 ? ++e3 : --e3)
              r3.push(t4.readUInt16());
            return r3;
          }(), c4 = function() {
            var e3, r3;
            for (r3 = [], s3 = e3 = 0; 0 <= l3 ? e3 < l3 : e3 > l3; s3 = 0 <= l3 ? ++e3 : --e3)
              r3.push(t4.readUInt16());
            return r3;
          }(), u3 = function() {
            var e3, r3;
            for (r3 = [], s3 = e3 = 0; 0 <= l3 ? e3 < l3 : e3 > l3; s3 = 0 <= l3 ? ++e3 : --e3)
              r3.push(t4.readUInt16());
            return r3;
          }(), n3 = (this.length - t4.pos + this.offset) / 2, o3 = function() {
            var e3, r3;
            for (r3 = [], s3 = e3 = 0; 0 <= n3 ? e3 < n3 : e3 > n3; s3 = 0 <= n3 ? ++e3 : --e3)
              r3.push(t4.readUInt16());
            return r3;
          }(), s3 = m4 = 0, b2 = i3.length; m4 < b2; s3 = ++m4)
            for (g2 = i3[s3], r2 = v3 = d2 = p4[s3]; d2 <= g2 ? v3 <= g2 : v3 >= g2; r2 = d2 <= g2 ? ++v3 : --v3)
              u3[s3] === 0 ? a3 = r2 + c4[s3] : (a3 = o3[u3[s3] / 2 + (r2 - d2) - (l3 - s3)] || 0) !== 0 && (a3 += c4[s3]), this.codeMap[r2] = 65535 & a3;
      }
      t4.pos = h4;
    }
    return t3.encode = function(t4, e2) {
      var r2, n3, i3, a3, o3, s3, c4, u3, h4, l3, f3, d2, p4, g2, m4, v3, b2, y3, w2, N3, L2, A2, x2, S2, _3, P2, k2, I2, F2, C2, j2, O3, B2, E2, M2, q2, D2, R2, T3, U2, z2, H2, W2, V2, G2, Y2;
      switch (I2 = new ne(), a3 = Object.keys(t4).sort(function(t5, e3) {
        return t5 - e3;
      }), e2) {
        case "macroman":
          for (p4 = 0, g2 = function() {
            var t5 = [];
            for (d2 = 0; d2 < 256; ++d2)
              t5.push(0);
            return t5;
          }(), v3 = { 0: 0 }, i3 = {}, F2 = 0, B2 = a3.length; F2 < B2; F2++)
            v3[W2 = t4[n3 = a3[F2]]] == null && (v3[W2] = ++p4), i3[n3] = { old: t4[n3], new: v3[t4[n3]] }, g2[n3] = v3[t4[n3]];
          return I2.writeUInt16(1), I2.writeUInt16(0), I2.writeUInt32(12), I2.writeUInt16(0), I2.writeUInt16(262), I2.writeUInt16(0), I2.write(g2), { charMap: i3, subtable: I2.data, maxGlyphID: p4 + 1 };
        case "unicode":
          for (P2 = [], h4 = [], b2 = 0, v3 = {}, r2 = {}, m4 = c4 = null, C2 = 0, E2 = a3.length; C2 < E2; C2++)
            v3[w2 = t4[n3 = a3[C2]]] == null && (v3[w2] = ++b2), r2[n3] = { old: w2, new: v3[w2] }, o3 = v3[w2] - n3, m4 != null && o3 === c4 || (m4 && h4.push(m4), P2.push(n3), c4 = o3), m4 = n3;
          for (m4 && h4.push(m4), h4.push(65535), P2.push(65535), S2 = 2 * (x2 = P2.length), A2 = 2 * Math.pow(Math.log(x2) / Math.LN2, 2), l3 = Math.log(A2 / 2) / Math.LN2, L2 = 2 * x2 - A2, s3 = [], N3 = [], f3 = [], d2 = j2 = 0, M2 = P2.length; j2 < M2; d2 = ++j2) {
            if (_3 = P2[d2], u3 = h4[d2], _3 === 65535) {
              s3.push(0), N3.push(0);
              break;
            }
            if (_3 - (k2 = r2[_3].new) >= 32768)
              for (s3.push(0), N3.push(2 * (f3.length + x2 - d2)), n3 = O3 = _3; _3 <= u3 ? O3 <= u3 : O3 >= u3; n3 = _3 <= u3 ? ++O3 : --O3)
                f3.push(r2[n3].new);
            else
              s3.push(k2 - _3), N3.push(0);
          }
          for (I2.writeUInt16(3), I2.writeUInt16(1), I2.writeUInt32(12), I2.writeUInt16(4), I2.writeUInt16(16 + 8 * x2 + 2 * f3.length), I2.writeUInt16(0), I2.writeUInt16(S2), I2.writeUInt16(A2), I2.writeUInt16(l3), I2.writeUInt16(L2), z2 = 0, q2 = h4.length; z2 < q2; z2++)
            n3 = h4[z2], I2.writeUInt16(n3);
          for (I2.writeUInt16(0), H2 = 0, D2 = P2.length; H2 < D2; H2++)
            n3 = P2[H2], I2.writeUInt16(n3);
          for (V2 = 0, R2 = s3.length; V2 < R2; V2++)
            o3 = s3[V2], I2.writeUInt16(o3);
          for (G2 = 0, T3 = N3.length; G2 < T3; G2++)
            y3 = N3[G2], I2.writeUInt16(y3);
          for (Y2 = 0, U2 = f3.length; Y2 < U2; Y2++)
            p4 = f3[Y2], I2.writeUInt16(p4);
          return { charMap: r2, subtable: I2.data, maxGlyphID: b2 + 1 };
      }
    }, t3;
  }();
  var ue = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "cmap", e2.prototype.parse = function(t4) {
      var e3, r2, n3;
      for (t4.pos = this.offset, this.version = t4.readUInt16(), n3 = t4.readUInt16(), this.tables = [], this.unicode = null, r2 = 0; 0 <= n3 ? r2 < n3 : r2 > n3; r2 = 0 <= n3 ? ++r2 : --r2)
        e3 = new ce(t4, this.offset), this.tables.push(e3), e3.isUnicode && this.unicode == null && (this.unicode = e3);
      return true;
    }, e2.encode = function(t4, e3) {
      var r2, n3;
      return e3 == null && (e3 = "macroman"), r2 = ce.encode(t4, e3), (n3 = new ne()).writeUInt16(0), n3.writeUInt16(1), r2.table = n3.data.concat(r2.subtable), r2;
    }, e2;
  }();
  var he = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "hhea", e2.prototype.parse = function(t4) {
      return t4.pos = this.offset, this.version = t4.readInt(), this.ascender = t4.readShort(), this.decender = t4.readShort(), this.lineGap = t4.readShort(), this.advanceWidthMax = t4.readShort(), this.minLeftSideBearing = t4.readShort(), this.minRightSideBearing = t4.readShort(), this.xMaxExtent = t4.readShort(), this.caretSlopeRise = t4.readShort(), this.caretSlopeRun = t4.readShort(), this.caretOffset = t4.readShort(), t4.pos += 8, this.metricDataFormat = t4.readShort(), this.numberOfMetrics = t4.readUInt16();
    }, e2;
  }();
  var le = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "OS/2", e2.prototype.parse = function(t4) {
      if (t4.pos = this.offset, this.version = t4.readUInt16(), this.averageCharWidth = t4.readShort(), this.weightClass = t4.readUInt16(), this.widthClass = t4.readUInt16(), this.type = t4.readShort(), this.ySubscriptXSize = t4.readShort(), this.ySubscriptYSize = t4.readShort(), this.ySubscriptXOffset = t4.readShort(), this.ySubscriptYOffset = t4.readShort(), this.ySuperscriptXSize = t4.readShort(), this.ySuperscriptYSize = t4.readShort(), this.ySuperscriptXOffset = t4.readShort(), this.ySuperscriptYOffset = t4.readShort(), this.yStrikeoutSize = t4.readShort(), this.yStrikeoutPosition = t4.readShort(), this.familyClass = t4.readShort(), this.panose = function() {
        var e3, r2;
        for (r2 = [], e3 = 0; e3 < 10; ++e3)
          r2.push(t4.readByte());
        return r2;
      }(), this.charRange = function() {
        var e3, r2;
        for (r2 = [], e3 = 0; e3 < 4; ++e3)
          r2.push(t4.readInt());
        return r2;
      }(), this.vendorID = t4.readString(4), this.selection = t4.readShort(), this.firstCharIndex = t4.readShort(), this.lastCharIndex = t4.readShort(), this.version > 0 && (this.ascent = t4.readShort(), this.descent = t4.readShort(), this.lineGap = t4.readShort(), this.winAscent = t4.readShort(), this.winDescent = t4.readShort(), this.codePageRange = function() {
        var e3, r2;
        for (r2 = [], e3 = 0; e3 < 2; e3 = ++e3)
          r2.push(t4.readInt());
        return r2;
      }(), this.version > 1))
        return this.xHeight = t4.readShort(), this.capHeight = t4.readShort(), this.defaultChar = t4.readShort(), this.breakChar = t4.readShort(), this.maxContext = t4.readShort();
    }, e2;
  }();
  var fe = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "post", e2.prototype.parse = function(t4) {
      var e3, r2, n3;
      switch (t4.pos = this.offset, this.format = t4.readInt(), this.italicAngle = t4.readInt(), this.underlinePosition = t4.readShort(), this.underlineThickness = t4.readShort(), this.isFixedPitch = t4.readInt(), this.minMemType42 = t4.readInt(), this.maxMemType42 = t4.readInt(), this.minMemType1 = t4.readInt(), this.maxMemType1 = t4.readInt(), this.format) {
        case 65536:
          break;
        case 131072:
          var i3;
          for (r2 = t4.readUInt16(), this.glyphNameIndex = [], i3 = 0; 0 <= r2 ? i3 < r2 : i3 > r2; i3 = 0 <= r2 ? ++i3 : --i3)
            this.glyphNameIndex.push(t4.readUInt16());
          for (this.names = [], n3 = []; t4.pos < this.offset + this.length; )
            e3 = t4.readByte(), n3.push(this.names.push(t4.readString(e3)));
          return n3;
        case 151552:
          return r2 = t4.readUInt16(), this.offsets = t4.read(r2);
        case 196608:
          break;
        case 262144:
          return this.map = function() {
            var e4, r3, n4;
            for (n4 = [], i3 = e4 = 0, r3 = this.file.maxp.numGlyphs; 0 <= r3 ? e4 < r3 : e4 > r3; i3 = 0 <= r3 ? ++e4 : --e4)
              n4.push(t4.readUInt32());
            return n4;
          }.call(this);
      }
    }, e2;
  }();
  var de = function(t3, e2) {
    this.raw = t3, this.length = t3.length, this.platformID = e2.platformID, this.encodingID = e2.encodingID, this.languageID = e2.languageID;
  };
  var pe = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "name", e2.prototype.parse = function(t4) {
      var e3, r2, n3, i3, a3, o3, s3, c4, u3, h4, l3;
      for (t4.pos = this.offset, t4.readShort(), e3 = t4.readShort(), o3 = t4.readShort(), r2 = [], i3 = 0; 0 <= e3 ? i3 < e3 : i3 > e3; i3 = 0 <= e3 ? ++i3 : --i3)
        r2.push({ platformID: t4.readShort(), encodingID: t4.readShort(), languageID: t4.readShort(), nameID: t4.readShort(), length: t4.readShort(), offset: this.offset + o3 + t4.readShort() });
      for (s3 = {}, i3 = u3 = 0, h4 = r2.length; u3 < h4; i3 = ++u3)
        n3 = r2[i3], t4.pos = n3.offset, c4 = t4.readString(n3.length), a3 = new de(c4, n3), s3[l3 = n3.nameID] == null && (s3[l3] = []), s3[n3.nameID].push(a3);
      this.strings = s3, this.copyright = s3[0], this.fontFamily = s3[1], this.fontSubfamily = s3[2], this.uniqueSubfamily = s3[3], this.fontName = s3[4], this.version = s3[5];
      try {
        this.postscriptName = s3[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
      } catch (t5) {
        this.postscriptName = s3[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
      }
      return this.trademark = s3[7], this.manufacturer = s3[8], this.designer = s3[9], this.description = s3[10], this.vendorUrl = s3[11], this.designerUrl = s3[12], this.license = s3[13], this.licenseUrl = s3[14], this.preferredFamily = s3[15], this.preferredSubfamily = s3[17], this.compatibleFull = s3[18], this.sampleText = s3[19];
    }, e2;
  }();
  var ge = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "maxp", e2.prototype.parse = function(t4) {
      return t4.pos = this.offset, this.version = t4.readInt(), this.numGlyphs = t4.readUInt16(), this.maxPoints = t4.readUInt16(), this.maxContours = t4.readUInt16(), this.maxCompositePoints = t4.readUInt16(), this.maxComponentContours = t4.readUInt16(), this.maxZones = t4.readUInt16(), this.maxTwilightPoints = t4.readUInt16(), this.maxStorage = t4.readUInt16(), this.maxFunctionDefs = t4.readUInt16(), this.maxInstructionDefs = t4.readUInt16(), this.maxStackElements = t4.readUInt16(), this.maxSizeOfInstructions = t4.readUInt16(), this.maxComponentElements = t4.readUInt16(), this.maxComponentDepth = t4.readUInt16();
    }, e2;
  }();
  var me = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "hmtx", e2.prototype.parse = function(t4) {
      var e3, r2, n3, i3, a3, o3, s3;
      for (t4.pos = this.offset, this.metrics = [], e3 = 0, o3 = this.file.hhea.numberOfMetrics; 0 <= o3 ? e3 < o3 : e3 > o3; e3 = 0 <= o3 ? ++e3 : --e3)
        this.metrics.push({ advance: t4.readUInt16(), lsb: t4.readInt16() });
      for (n3 = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
        var r3, i4;
        for (i4 = [], e3 = r3 = 0; 0 <= n3 ? r3 < n3 : r3 > n3; e3 = 0 <= n3 ? ++r3 : --r3)
          i4.push(t4.readInt16());
        return i4;
      }(), this.widths = function() {
        var t5, e4, r3, n4;
        for (n4 = [], t5 = 0, e4 = (r3 = this.metrics).length; t5 < e4; t5++)
          i3 = r3[t5], n4.push(i3.advance);
        return n4;
      }.call(this), r2 = this.widths[this.widths.length - 1], s3 = [], e3 = a3 = 0; 0 <= n3 ? a3 < n3 : a3 > n3; e3 = 0 <= n3 ? ++a3 : --a3)
        s3.push(this.widths.push(r2));
      return s3;
    }, e2.prototype.forGlyph = function(t4) {
      return t4 in this.metrics ? this.metrics[t4] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[t4 - this.metrics.length] };
    }, e2;
  }();
  var ve = [].slice;
  var be = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "glyf", e2.prototype.parse = function() {
      return this.cache = {};
    }, e2.prototype.glyphFor = function(t4) {
      var e3, r2, n3, i3, a3, o3, s3, c4, u3, h4;
      return t4 in this.cache ? this.cache[t4] : (i3 = this.file.loca, e3 = this.file.contents, r2 = i3.indexOf(t4), (n3 = i3.lengthOf(t4)) === 0 ? this.cache[t4] = null : (e3.pos = this.offset + r2, a3 = (o3 = new ne(e3.read(n3))).readShort(), c4 = o3.readShort(), h4 = o3.readShort(), s3 = o3.readShort(), u3 = o3.readShort(), this.cache[t4] = a3 === -1 ? new we(o3, c4, h4, s3, u3) : new ye(o3, a3, c4, h4, s3, u3), this.cache[t4]));
    }, e2.prototype.encode = function(t4, e3, r2) {
      var n3, i3, a3, o3, s3;
      for (a3 = [], i3 = [], o3 = 0, s3 = e3.length; o3 < s3; o3++)
        n3 = t4[e3[o3]], i3.push(a3.length), n3 && (a3 = a3.concat(n3.encode(r2)));
      return i3.push(a3.length), { table: a3, offsets: i3 };
    }, e2;
  }();
  var ye = function() {
    function t3(t4, e2, r2, n3, i3, a3) {
      this.raw = t4, this.numberOfContours = e2, this.xMin = r2, this.yMin = n3, this.xMax = i3, this.yMax = a3, this.compound = false;
    }
    return t3.prototype.encode = function() {
      return this.raw.data;
    }, t3;
  }();
  var we = function() {
    function t3(t4, e2, r2, n3, i3) {
      var a3, o3;
      for (this.raw = t4, this.xMin = e2, this.yMin = r2, this.xMax = n3, this.yMax = i3, this.compound = true, this.glyphIDs = [], this.glyphOffsets = [], a3 = this.raw; o3 = a3.readShort(), this.glyphOffsets.push(a3.pos), this.glyphIDs.push(a3.readUInt16()), 32 & o3; )
        a3.pos += 1 & o3 ? 4 : 2, 128 & o3 ? a3.pos += 8 : 64 & o3 ? a3.pos += 4 : 8 & o3 && (a3.pos += 2);
    }
    return 1, 8, 32, 64, 128, t3.prototype.encode = function() {
      var t4, e2, r2;
      for (e2 = new ne(ve.call(this.raw.data)), t4 = 0, r2 = this.glyphIDs.length; t4 < r2; ++t4)
        e2.pos = this.glyphOffsets[t4];
      return e2.data;
    }, t3;
  }();
  var Ne = function(t3) {
    function e2() {
      return e2.__super__.constructor.apply(this, arguments);
    }
    return oe(e2, re), e2.prototype.tag = "loca", e2.prototype.parse = function(t4) {
      var e3, r2;
      return t4.pos = this.offset, e3 = this.file.head.indexToLocFormat, this.offsets = e3 === 0 ? function() {
        var e4, n3;
        for (n3 = [], r2 = 0, e4 = this.length; r2 < e4; r2 += 2)
          n3.push(2 * t4.readUInt16());
        return n3;
      }.call(this) : function() {
        var e4, n3;
        for (n3 = [], r2 = 0, e4 = this.length; r2 < e4; r2 += 4)
          n3.push(t4.readUInt32());
        return n3;
      }.call(this);
    }, e2.prototype.indexOf = function(t4) {
      return this.offsets[t4];
    }, e2.prototype.lengthOf = function(t4) {
      return this.offsets[t4 + 1] - this.offsets[t4];
    }, e2.prototype.encode = function(t4, e3) {
      for (var r2 = new Uint32Array(this.offsets.length), n3 = 0, i3 = 0, a3 = 0; a3 < r2.length; ++a3)
        if (r2[a3] = n3, i3 < e3.length && e3[i3] == a3) {
          ++i3, r2[a3] = n3;
          var o3 = this.offsets[a3], s3 = this.offsets[a3 + 1] - o3;
          s3 > 0 && (n3 += s3);
        }
      for (var c4 = new Array(4 * r2.length), u3 = 0; u3 < r2.length; ++u3)
        c4[4 * u3 + 3] = 255 & r2[u3], c4[4 * u3 + 2] = (65280 & r2[u3]) >> 8, c4[4 * u3 + 1] = (16711680 & r2[u3]) >> 16, c4[4 * u3] = (4278190080 & r2[u3]) >> 24;
      return c4;
    }, e2;
  }();
  var Le = function() {
    function t3(t4) {
      this.font = t4, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t3.prototype.generateCmap = function() {
      var t4, e2, r2, n3, i3;
      for (e2 in n3 = this.font.cmap.tables[0].codeMap, t4 = {}, i3 = this.subset)
        r2 = i3[e2], t4[e2] = n3[r2];
      return t4;
    }, t3.prototype.glyphsFor = function(t4) {
      var e2, r2, n3, i3, a3, o3, s3;
      for (n3 = {}, a3 = 0, o3 = t4.length; a3 < o3; a3++)
        n3[i3 = t4[a3]] = this.font.glyf.glyphFor(i3);
      for (i3 in e2 = [], n3)
        ((r2 = n3[i3]) != null ? r2.compound : void 0) && e2.push.apply(e2, r2.glyphIDs);
      if (e2.length > 0)
        for (i3 in s3 = this.glyphsFor(e2))
          r2 = s3[i3], n3[i3] = r2;
      return n3;
    }, t3.prototype.encode = function(t4, e2) {
      var r2, n3, i3, a3, o3, s3, c4, u3, h4, l3, f3, d2, p4, g2, m4;
      for (n3 in r2 = ue.encode(this.generateCmap(), "unicode"), a3 = this.glyphsFor(t4), f3 = { 0: 0 }, m4 = r2.charMap)
        f3[(s3 = m4[n3]).old] = s3.new;
      for (d2 in l3 = r2.maxGlyphID, a3)
        d2 in f3 || (f3[d2] = l3++);
      return u3 = function(t5) {
        var e3, r3;
        for (e3 in r3 = {}, t5)
          r3[t5[e3]] = e3;
        return r3;
      }(f3), h4 = Object.keys(u3).sort(function(t5, e3) {
        return t5 - e3;
      }), p4 = function() {
        var t5, e3, r3;
        for (r3 = [], t5 = 0, e3 = h4.length; t5 < e3; t5++)
          o3 = h4[t5], r3.push(u3[o3]);
        return r3;
      }(), i3 = this.font.glyf.encode(a3, p4, f3), c4 = this.font.loca.encode(i3.offsets, p4), g2 = { cmap: this.font.cmap.raw(), glyf: i3.table, loca: c4, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(e2) }, this.font.os2.exists && (g2["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g2);
    }, t3;
  }();
  M.API.PDFObject = function() {
    var t3;
    function e2() {
    }
    return t3 = function(t4, e3) {
      return (Array(e3 + 1).join("0") + t4).slice(-e3);
    }, e2.convert = function(r2) {
      var n3, i3, a3, o3;
      if (Array.isArray(r2))
        return "[" + function() {
          var t4, i4, a4;
          for (a4 = [], t4 = 0, i4 = r2.length; t4 < i4; t4++)
            n3 = r2[t4], a4.push(e2.convert(n3));
          return a4;
        }().join(" ") + "]";
      if (typeof r2 == "string")
        return "/" + r2;
      if (r2 != null ? r2.isString : void 0)
        return "(" + r2 + ")";
      if (r2 instanceof Date)
        return "(D:" + t3(r2.getUTCFullYear(), 4) + t3(r2.getUTCMonth(), 2) + t3(r2.getUTCDate(), 2) + t3(r2.getUTCHours(), 2) + t3(r2.getUTCMinutes(), 2) + t3(r2.getUTCSeconds(), 2) + "Z)";
      if ({}.toString.call(r2) === "[object Object]") {
        for (i3 in a3 = ["<<"], r2)
          o3 = r2[i3], a3.push("/" + i3 + " " + e2.convert(o3));
        return a3.push(">>"), a3.join("\n");
      }
      return "" + r2;
    }, e2;
  }();

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/components/TheEnd.vue?type=script
  var TheEnd_default = {
    name: "TheEnd",
    emits: ["selectNavigationGroup"],
    props: {
      userSelections: Object,
      checkedAnswersObject: Object,
      activePackageTitle: String,
      activeVanTitle: String,
      activeVanYear: [Number, String],
      activeVanRelatedProductIds: [Object],
      relatedProdcuts: String,
      activeVanKitBasePrice: Number,
      currentPrice: Number,
      factoryInstall: Boolean,
      totalFactoryInstall: Number,
      backgroundImage: Object,
      imageStack: Array,
      imageBase: String
    },
    data() {
      return {
        viewOrderIsActive: false,
        termsCheck: false,
        imageCheck: false,
        endNotes: "",
        buttonText: "Make a Deposit",
        buttonDisabled: false,
        viewSignUpForm: false,
        first_name: "",
        last_name: "",
        email: "",
        hasFormBeenSubmitted: false,
        formSubmitted: false
      };
    },
    methods: {
      openSignUpForm() {
        this.viewSignUpForm = true;
      },
      handleSubmit(e2) {
        e2.preventDefault();
        const doc2 = new M();
        var logo = new Image();
        logo.src = "https://cdn.shopify.com/s/files/1/0549/8571/9851/files/logo.jpg?v=1641832149";
        doc2.setDrawColor(69, 111, 182);
        doc2.addImage(logo, "jpg", 10, 6, 50, 12);
        doc2.setFont("Helvetica", "normal");
        doc2.setFontSize(11);
        doc2.text("503-427-0140", 200, 10, {
          align: "right"
        });
        doc2.text("info@adventurewagon.com", 200, 16, {
          align: "right"
        });
        doc2.text("https://adventurewagon.com", 200, 22, {
          align: "right"
        });
        doc2.setFont("Helvetica", "bold");
        doc2.setTextColor(51, 51, 51);
        doc2.setFontSize(22);
        doc2.text(this.activePackageTitle + " Package", 10, 30 + 10 * 1);
        doc2.setFontSize(16);
        if (this.factoryInstall) {
          doc2.text("$" + this.currentPrice.toFixed(2), 200, 30 + 10 * 1, {
            align: "right"
          });
        } else {
          doc2.text("$" + this.currentPrice.toFixed(2), 200, 30 + 10 * 1, {
            align: "right"
          });
        }
        doc2.setFont("Helvetica", "bold");
        doc2.setFontSize(14);
        doc2.text(this.activeVanTitle + " " + this.activeVanYear, 10, 30 + 10 * 2.5, {
          align: "left"
        });
        doc2.setFont("Helvetica", "bold");
        doc2.setFontSize(11);
        doc2.text("Conversion Kit Base Price: ", 10, 30 + 10 * 4);
        doc2.setFont("Helvetica", "normal");
        doc2.setFontSize(12);
        doc2.text("$" + this.activeVanKitBasePrice.toFixed(2), 200, 30 + 10 * 4, {
          align: "right"
        });
        doc2.line(10, 73, 200, 73);
        var temp = 5;
        var temp2 = 1;
        var temp3 = 1;
        Object.keys(this.checkedAnswersObject).forEach((key) => {
          if (this.checkedAnswersObject[key]) {
            Object.keys(this.checkedAnswersObject[key]).forEach((innerKey) => {
              if (this.checkedAnswersObject[key][innerKey]) {
                let propQuestion = this.checkedAnswersObject[key][innerKey].question;
                let propTitle = this.checkedAnswersObject[key][innerKey].title;
                let propPrice = this.checkedAnswersObject[key][innerKey].price;
                let propInstallCost = this.checkedAnswersObject[key][innerKey].installCost;
                if (propQuestion === "Installation options" && propTitle === "Factory Install") {
                  var price = "$" + this.totalFactoryInstall.toFixed(2);
                } else {
                  if (propPrice) {
                    if (propPrice.toString().includes("-")) {
                      var price = propPrice.toFixed(2).toString().replace("-", "- $");
                    } else {
                      var price = "$" + propPrice.toFixed(2);
                    }
                  } else {
                    var price = "";
                  }
                }
                if (temp === 25) {
                  doc2.addPage();
                  doc2.addImage(logo, "jpg", 10, 6, 50, 12);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(11);
                  doc2.text("503-427-0140", 200, 10, {
                    align: "right"
                  });
                  doc2.text("info@adventurewagon.com", 200, 16, {
                    align: "right"
                  });
                  doc2.text("https://adventurewagon.com", 200, 22, {
                    align: "right"
                  });
                } else if (temp2 === 25) {
                  doc2.addPage();
                  doc2.addImage(logo, "jpg", 10, 6, 50, 12);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(11);
                  doc2.text("503-427-0140", 200, 10, {
                    align: "right"
                  });
                  doc2.text("info@adventurewagon.com", 200, 16, {
                    align: "right"
                  });
                  doc2.text("https://adventurewagon.com", 200, 22, {
                    align: "right"
                  });
                }
                if (temp < 25) {
                  doc2.setFont("Helvetica", "bold");
                  doc2.setFontSize(11);
                  doc2.text(propQuestion + ": ", 10, 30 + 10 * temp);
                  var questionWidth = doc2.getTextWidth(propQuestion);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(12);
                  doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp, {
                    align: "left"
                  });
                  doc2.text("  " + price, 200, 30 + 10 * temp, {
                    align: "right"
                  });
                  doc2.line(10, 10 * temp + 33, 200, 10 * temp + 33);
                } else if (temp >= 25) {
                  if (temp2 < 25) {
                    doc2.setFont("Helvetica", "bold");
                    doc2.setFontSize(11);
                    doc2.text(propQuestion + ": ", 10, 30 + 10 * temp2);
                    var questionWidth = doc2.getTextWidth(propQuestion);
                    doc2.setFont("Helvetica", "normal");
                    doc2.setFontSize(12);
                    doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp2, {
                      align: "left"
                    });
                    doc2.text("  " + price, 200, 30 + 10 * temp2, {
                      align: "right"
                    });
                    doc2.line(10, 10 * temp2 + 33, 200, 10 * temp2 + 33);
                  } else if (temp2 >= 25) {
                    doc2.setFont("Helvetica", "bold");
                    doc2.setFontSize(11);
                    doc2.text(propQuestion + ": ", 10, 30 + 10 * temp3);
                    var questionWidth = doc2.getTextWidth(propQuestion);
                    doc2.setFont("Helvetica", "normal");
                    doc2.setFontSize(12);
                    doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp3, {
                      align: "left"
                    });
                    doc2.text("  " + price, 200, 30 + 10 * temp3, {
                      align: "right"
                    });
                    doc2.line(10, 10 * temp3 + 33, 200, 10 * temp3 + 33);
                    temp3++;
                  }
                  temp2++;
                }
                temp++;
              }
            });
          }
        });
        doc2.save("Adventure-Wagon_Configuration.pdf");
        this.$nextTick(() => {
          const form = this.$refs.salesforceForm;
          this.hasFormBeenSubmitted = true;
          if (form) {
            form.submit();
          } else {
            console.error("Salesforce form not found");
          }
        });
      },
      handleSalesforceResponse() {
        if (this.hasFormBeenSubmitted) {
          this.formSubmitted = true;
          this.first_name = "";
          this.last_name = "";
          this.email = "";
        }
      },
      orderPrep() {
        this.buttonDisabled = true;
        this.buttonText = "Please Wait...";
        let url = "https://www.configuratoradventurewagon.com/order/prep";
        if (this.imageStack) {
          let data2 = {
            "imageBase": this.imageBase,
            "imageStack": this.imageStack
          };
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data2)
          }).then((response) => response.json()).then((data3) => {
            const response = JSON.parse(data3);
            this.cartPost(response.checksum);
          }).catch((error2) => {
            this.cartPost();
          });
        } else {
          this.cartPost();
        }
      },
      cartPost(orderChecksum = "none") {
        this.buttonDisabled = true;
        this.buttonText = "Adding to Cart...";
        let properties = {
          "_product": "configurator",
          "_notes": this.endNotes,
          "_checksum": orderChecksum,
          "Van Choice": "Van: " + this.activeVanTitle + " / " + this.activeVanYear
        };
        Object.keys(this.checkedAnswersObject).forEach((key) => {
          if (this.checkedAnswersObject[key]) {
            Object.keys(this.checkedAnswersObject[key]).forEach((innerKey) => {
              let propQuestion = this.checkedAnswersObject[key][innerKey].question;
              let propTitle = this.checkedAnswersObject[key][innerKey].title;
              let propPrice = this.checkedAnswersObject[key][innerKey].price;
              let propInstallCost = this.checkedAnswersObject[key][innerKey].installCost;
              if (this.checkedAnswersObject[key][innerKey] && propPrice) {
                if (this.checkedAnswersObject[key][innerKey].price.toString().includes("-")) {
                  properties[key + innerKey] = propQuestion + ": " + propTitle + ": " + propPrice.toFixed(2).toString().replace("-", "- $");
                } else {
                  properties[key + innerKey] = propQuestion + ": " + propTitle + ": $" + propPrice.toFixed(2);
                }
                if (this.factoryInstall && propInstallCost) {
                  properties[key + innerKey] += " (+$" + propInstallCost.toFixed(2) + " install)";
                }
              } else if (this.checkedAnswersObject[key][innerKey]) {
                properties[key + innerKey] = propQuestion + ": " + propTitle;
              }
            });
          }
        });
        properties["package_total"] = "Package Total: $" + this.currentPrice.toFixed(2);
        let formData = {
          "items": [{
            "id": 39614227284086,
            "quantity": 1,
            properties
          }]
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }).then((response) => {
          this.buttonText = "Added to Cart";
          location.href = "/cart";
          return response.json();
        }).catch((error2) => {
          this.buttonDisabled = false;
          this.buttonText = "Error Adding to Cart";
        });
      },
      savePdf() {
        const doc2 = new M();
        var logo = new Image();
        logo.src = "https://cdn.shopify.com/s/files/1/0549/8571/9851/files/logo.jpg?v=1641832149";
        doc2.setDrawColor(69, 111, 182);
        doc2.addImage(logo, "jpg", 10, 6, 50, 12);
        doc2.setFont("Helvetica", "normal");
        doc2.setFontSize(11);
        doc2.text("503-427-0140", 200, 10, {
          align: "right"
        });
        doc2.text("info@adventurewagon.com", 200, 16, {
          align: "right"
        });
        doc2.text("https://adventurewagon.com", 200, 22, {
          align: "right"
        });
        doc2.setFont("Helvetica", "bold");
        doc2.setTextColor(51, 51, 51);
        doc2.setFontSize(22);
        doc2.text(this.activePackageTitle + " Package", 10, 30 + 10 * 1);
        doc2.setFontSize(16);
        doc2.text("$" + this.currentPrice.toFixed(2), 200, 30 + 10 * 1, {
          align: "right"
        });
        doc2.setFont("Helvetica", "bold");
        doc2.setFontSize(14);
        doc2.text(this.activeVanTitle + " " + this.activeVanYear, 10, 30 + 10 * 2.5, {
          align: "left"
        });
        doc2.setFont("Helvetica", "bold");
        doc2.setFontSize(11);
        doc2.text("Conversion Kit Base Price: ", 10, 30 + 10 * 4);
        doc2.setFont("Helvetica", "normal");
        doc2.setFontSize(12);
        doc2.text("$" + this.activeVanKitBasePrice.toFixed(2), 200, 30 + 10 * 4, {
          align: "right"
        });
        doc2.line(10, 73, 200, 73);
        var temp = 5;
        var temp2 = 1;
        var temp3 = 1;
        Object.keys(this.checkedAnswersObject).forEach((key) => {
          if (this.checkedAnswersObject[key]) {
            Object.keys(this.checkedAnswersObject[key]).forEach((innerKey) => {
              if (this.checkedAnswersObject[key][innerKey]) {
                let propQuestion = this.checkedAnswersObject[key][innerKey].question;
                let propTitle = this.checkedAnswersObject[key][innerKey].title;
                let propPrice = this.checkedAnswersObject[key][innerKey].price;
                let propInstallCost = this.checkedAnswersObject[key][innerKey].installCost;
                if (propPrice) {
                  if (propPrice.toString().includes("-")) {
                    var price = propPrice.toFixed(2).toString().replace("-", "- $");
                  } else {
                    var price = "$" + propPrice.toFixed(2);
                  }
                  if (this.factoryInstall && propInstallCost) {
                    price += " (+$" + propInstallCost.toFixed(2) + " install)";
                  }
                } else {
                  var price = "";
                }
                if (temp === 25) {
                  doc2.addPage();
                  doc2.addImage(logo, "jpg", 10, 6, 50, 12);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(11);
                  doc2.text("503-427-0140", 200, 10, {
                    align: "right"
                  });
                  doc2.text("info@adventurewagon.com", 200, 16, {
                    align: "right"
                  });
                  doc2.text("https://adventurewagon.com", 200, 22, {
                    align: "right"
                  });
                } else if (temp2 === 25) {
                  doc2.addPage();
                  doc2.addImage(logo, "jpg", 10, 6, 50, 12);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(11);
                  doc2.text("503-427-0140", 200, 10, {
                    align: "right"
                  });
                  doc2.text("info@adventurewagon.com", 200, 16, {
                    align: "right"
                  });
                  doc2.text("https://adventurewagon.com", 200, 22, {
                    align: "right"
                  });
                }
                if (temp < 25) {
                  doc2.setFont("Helvetica", "bold");
                  doc2.setFontSize(11);
                  doc2.text(propQuestion + ": " + temp, 10, 30 + 10 * temp);
                  var questionWidth = doc2.getTextWidth(propQuestion);
                  doc2.setFont("Helvetica", "normal");
                  doc2.setFontSize(12);
                  doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp, {
                    align: "left"
                  });
                  doc2.text("  " + price, 200, 30 + 10 * temp, {
                    align: "right"
                  });
                  doc2.line(10, 10 * temp + 33, 200, 10 * temp + 33);
                } else if (temp >= 25) {
                  if (temp2 < 25) {
                    doc2.setFont("Helvetica", "bold");
                    doc2.setFontSize(11);
                    doc2.text(propQuestion + ": ", 10, 30 + 10 * temp2);
                    var questionWidth = doc2.getTextWidth(propQuestion);
                    doc2.setFont("Helvetica", "normal");
                    doc2.setFontSize(12);
                    doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp2, {
                      align: "left"
                    });
                    doc2.text("  " + price, 200, 30 + 10 * temp2, {
                      align: "right"
                    });
                    doc2.line(10, 10 * temp2 + 33, 200, 10 * temp2 + 33);
                  } else if (temp2 > 25) {
                    doc2.setFont("Helvetica", "bold");
                    doc2.setFontSize(11);
                    doc2.text(propQuestion + ": ", 10, 30 + 10 * temp3);
                    var questionWidth = doc2.getTextWidth(propQuestion);
                    doc2.setFont("Helvetica", "normal");
                    doc2.setFontSize(12);
                    doc2.text(propTitle, questionWidth + 13, 30 + 10 * temp3, {
                      align: "left"
                    });
                    doc2.text("  " + price, 200, 30 + 10 * temp3, {
                      align: "right"
                    });
                    doc2.line(10, 10 * temp3 + 33, 200, 10 * temp3 + 33);
                    temp3++;
                  }
                  temp2++;
                }
                temp++;
              }
            });
          }
        });
        doc2.save("Adventure-Wagon_Configuration.pdf");
      }
    },
    computed: {
      factoryInstall() {
        let isFactoryInstall = false;
        Object.keys(this.checkedAnswersObject).forEach((key) => {
          if (this.checkedAnswersObject[key].length) {
            this.checkedAnswersObject[key].forEach((answer) => {
              if (answer.unique_id === "factory_install") {
                isFactoryInstall = true;
              }
            });
          }
        });
        return isFactoryInstall;
      }
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/components/TheEnd.vue?type=template
  var _hoisted_118 = { class: "lg:flex bg-grey-bg w-full conf-wrap-up" };
  var _hoisted_216 = { class: "lg:w-1/2 bg-white pt-27 pb-6 md:px-15 px-5" };
  var _hoisted_38 = { class: "mb-1" };
  var _hoisted_48 = { class: "h4" };
  var _hoisted_58 = { class: "mt-6 pt-4 border-t border-grey-light w-full lg:max-w-132" };
  var _hoisted_65 = { class: "pb-4 border-b border-grey-light" };
  var _hoisted_76 = { class: "flex items-center justify-start" };
  var _hoisted_86 = { class: "intro-sm" };
  var _hoisted_95 = /* @__PURE__ */ createTextVNode(" Edit ");
  var _hoisted_105 = /* @__PURE__ */ createBaseVNode("svg", {
    class: "ml-2",
    width: "13",
    height: "16",
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.28571 2C9.77673 2 10.2021 2.19453 10.5434 2.53849L12.463 4.45809C12.8072 4.8023 13 5.22469 13 5.71428C13 6.20072 12.8087 6.70533 12.463 7.05105L5.46948 14.0413C4.98328 14.6021 4.29407 14.9467 3.48809 15.0014H0.928571H0V14.0729L0.00301567 11.4386C0.0621961 10.7061 0.40275 10.025 0.911823 9.57706L7.94944 2.53951C8.29478 2.19238 8.79857 2 9.28571 2ZM2.1836 10.9292C1.99273 11.098 1.87465 11.3342 1.85714 11.5134V13.1452L3.42251 13.1466C3.67128 13.129 3.90285 13.0132 4.11124 12.7764L8.58415 8.30352L6.69752 6.4169L2.1836 10.9292ZM8.05737 5.05754L9.94375 6.94391L11.1331 5.75457L9.24693 3.8684L8.05737 5.05754Z",
      fill: "currentColor"
    })
  ], -1);
  var _hoisted_119 = [
    _hoisted_95,
    _hoisted_105
  ];
  var _hoisted_125 = ["onClick"];
  var _hoisted_135 = /* @__PURE__ */ createTextVNode(" Edit ");
  var _hoisted_144 = /* @__PURE__ */ createBaseVNode("svg", {
    class: "ml-2",
    width: "13",
    height: "16",
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createBaseVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.28571 2C9.77673 2 10.2021 2.19453 10.5434 2.53849L12.463 4.45809C12.8072 4.8023 13 5.22469 13 5.71428C13 6.20072 12.8087 6.70533 12.463 7.05105L5.46948 14.0413C4.98328 14.6021 4.29407 14.9467 3.48809 15.0014H0.928571H0V14.0729L0.00301567 11.4386C0.0621961 10.7061 0.40275 10.025 0.911823 9.57706L7.94944 2.53951C8.29478 2.19238 8.79857 2 9.28571 2ZM2.1836 10.9292C1.99273 11.098 1.87465 11.3342 1.85714 11.5134V13.1452L3.42251 13.1466C3.67128 13.129 3.90285 13.0132 4.11124 12.7764L8.58415 8.30352L6.69752 6.4169L2.1836 10.9292ZM8.05737 5.05754L9.94375 6.94391L11.1331 5.75457L9.24693 3.8684L8.05737 5.05754Z",
      fill: "currentColor"
    })
  ], -1);
  var _hoisted_153 = [
    _hoisted_135,
    _hoisted_144
  ];
  var _hoisted_163 = { key: 0 };
  var _hoisted_173 = {
    key: 0,
    class: "ml-2 pl-4 micro-alt spec-li relative flex justify-between mt-3"
  };
  var _hoisted_183 = { key: 0 };
  var _hoisted_193 = {
    key: 1,
    class: "ml-2"
  };
  var _hoisted_203 = {
    key: 0,
    class: "ml-2 pl-4 micro-alt spec-li relative flex justify-between mt-3"
  };
  var _hoisted_217 = /* @__PURE__ */ createBaseVNode("span", null, " Conversion Kit Base Price ", -1);
  var _hoisted_224 = {
    key: 0,
    class: "min-w-20 w-20 ml-5"
  };
  var _hoisted_234 = { class: "flex justify-between" };
  var _hoisted_243 = {
    key: 0,
    class: "mr-2 font-semibold"
  };
  var _hoisted_253 = {
    key: 0,
    class: "min-w-20 w-20 ml-5 text-right"
  };
  var _hoisted_263 = {
    key: 1,
    class: "min-w-20 w-20 ml-5"
  };
  var _hoisted_273 = {
    key: 2,
    class: "min-w-20 w-20 ml-5"
  };
  var _hoisted_283 = {
    key: 0,
    class: "block mt-1"
  };
  var _hoisted_293 = { class: "lg:w-1/2" };
  var _hoisted_303 = {
    class: "z-0 relative max-w-full",
    style: { "padding-bottom": "56%" }
  };
  var _hoisted_313 = { class: "absolute w-full h-full inset-0 z-0" };
  var _hoisted_323 = ["src"];
  var _hoisted_333 = ["src"];
  var _hoisted_343 = ["src", "alt"];
  var _hoisted_353 = { class: "pb-9 xl:flex lg:block md:flex items-center bg-brand-ada py-8 md:px-13 px-5 md:-mt-20 z-10 relative md:mx-8 md:mb-8 text-white -md:border-b -md:border-white" };
  var _hoisted_362 = { class: "xl:w-2/3 lg:w-full md:w-2/3 xl:pr-6 lg:pr-0 md:pr-6 xl:pb-2 lg:pb-6 md:pb-2 pt-2 pb-6 xl:border-r xl:border-b-0 lg:border-r-0 lg:border-b md:border-r md:border-b-0 border-b border-white" };
  var _hoisted_372 = { class: "md:mr-auto" };
  var _hoisted_382 = /* @__PURE__ */ createBaseVNode("div", { class: "h4" }, "Package Subtotal:", -1);
  var _hoisted_39 = {
    key: 0,
    class: "text-blue h2 mt-2"
  };
  var _hoisted_40 = /* @__PURE__ */ createBaseVNode("p", { class: "text-sm" }, "Price does not include taxes and shipping.", -1);
  var _hoisted_41 = { class: "cursor-pointer leading-none my-2 text-sm flex" };
  var _hoisted_422 = /* @__PURE__ */ createBaseVNode("span", null, [
    /* @__PURE__ */ createTextVNode("I have read the "),
    /* @__PURE__ */ createBaseVNode("a", {
      href: "/pages/terms-and-conditions",
      target: "_blank",
      class: "border-b"
    }, "Terms and Conditions")
  ], -1);
  var _hoisted_432 = { class: "cursor-pointer leading-none text-sm flex" };
  var _hoisted_442 = /* @__PURE__ */ createBaseVNode("span", null, "I understand the images in this configurator are representations. Actual products may vary.", -1);
  var _hoisted_452 = {
    class: "field text-black mt-4 md:col-span-2",
    style: { "overflow": "hidden" }
  };
  var _hoisted_462 = /* @__PURE__ */ createBaseVNode("label", {
    class: "form__label field__label left-2 top-4",
    for: "endNotes"
  }, "Notes", -1);
  var _hoisted_472 = ["disabled"];
  var _hoisted_482 = /* @__PURE__ */ createStaticVNode('<svg class="icon icon-cart ml-2" width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.49 2.339h.613a.613.613 0 0 0-.613-.613v.613Zm.613 3.493V2.34h-1.226v3.493h1.226Zm-.613-4.106c-.71 0-1.608.142-2.35.627-.78.509-1.327 1.36-1.327 2.621h1.226c0-.848.34-1.314.771-1.595.47-.306 1.103-.427 1.68-.427V1.726Z" fill="#4D81D9"></path><path d="M9.624 4.79A5.21 5.21 0 0 0 4.414 10v.184a5.394 5.394 0 0 0 5.394 5.393h6.374a5.394 5.394 0 1 0 0-10.787h-.858" stroke="#4D81D9" stroke-width="1.226"></path><path d="M7.477 15.087s1.278 1.34 1.287 3.714c0 .014.01.025.024.025H9.79c.01 0 .02-.006.023-.015l1.28-3.111M18.574 15.087s-1.278 1.34-1.287 3.714a.025.025 0 0 1-.024.025H16.26a.024.024 0 0 1-.022-.015l-1.28-3.111M21.33 8.345s1.041.674 1.777.613c.735-.061.796.878.796 1.961 0 1.083-.356 1.962-.796 1.962l-2.513.429" stroke="#4D81D9" stroke-width="1.226"></path><path d="M4.413 9.142h.613v-.675l-.672.065.06.61Zm-3.236-2.51a.613.613 0 0 0-1.127.484l1.127-.483Zm3.236 4.165h.613v-.498l-.486-.102-.127.6Zm-.059-2.265c-1.047.101-2.59-.53-3.177-1.9L.05 7.117c.831 1.94 2.936 2.78 4.422 2.636l-.118-1.22ZM.05 7.116a10.36 10.36 0 0 0 1.477 2.393c.688.828 1.627 1.649 2.76 1.887l.253-1.199c-.73-.154-1.447-.722-2.07-1.472a9.142 9.142 0 0 1-1.293-2.092L.05 7.116Zm3.75 3.68V10.84h1.226V9.141H3.8V10.84h1.226V10.796H3.8Z" fill="#4D81D9"></path><path stroke="#4D81D9" stroke-width="1.226" stroke-linecap="round" d="M9.437 6.629h6.129"></path><path d="M14.557 6.752a3.192 3.192 0 0 0 1.134-2.444 3.191 3.191 0 0 0-3.188-3.195 3.191 3.191 0 0 0-3.187 3.195c0 .836.32 1.592.844 2.162m0 0c.06.065.123.128.188.187l-.188-.187Z" stroke="#4D81D9" stroke-width="1.226"></path><circle cx="18.02" cy="7.855" r=".981" fill="#4D81D9"></circle></svg>', 1);
  var _hoisted_49 = { class: "xl:md:w-1/2 lg:w-full md:w-1/2 xl:pl-6 lg:pl-0 md:pl-6 xl:pt-2 lg:pt-6 md:pt-2 pb-2 pt-6" };
  var _hoisted_50 = { class: "xl:max-w-64 lg:max-w-full md:max-w-64 xl:ml-auto lg:ml-0 md:ml-auto" };
  var _hoisted_51 = /* @__PURE__ */ createStaticVNode('<svg class="mr-2 min-w-3 h-6" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0239 16.7426L5.78125 18.7426L1.53861 16.7426" stroke="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.75273 0.5H0.78125V13.5909H10.9631V3.71034L7.75273 0.5Z" stroke="currentColor"></path><path d="M10.8281 4.54541H6.82812V0.54541" stroke="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.32812 10.0454V9.04541H7.32813V10.0454H3.32812Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.32812 8.04541V7.04541H8.32812V8.04541H3.32812Z" fill="currentColor"></path></svg> Download &amp; Print PDF ', 2);
  var _hoisted_532 = [
    _hoisted_51
  ];
  var _hoisted_542 = /* @__PURE__ */ createBaseVNode("h2", { class: "h4 link mb-5" }, "Please provide your email address to access PDF", -1);
  var _hoisted_552 = /* @__PURE__ */ createBaseVNode("input", {
    type: "hidden",
    name: "oid",
    value: "00DHp000009v6Fy"
  }, null, -1);
  var _hoisted_562 = /* @__PURE__ */ createBaseVNode("input", {
    type: "hidden",
    name: "retURL",
    value: "about:blank"
  }, null, -1);
  var _hoisted_572 = { class: "mb-4" };
  var _hoisted_582 = /* @__PURE__ */ createBaseVNode("label", {
    class: "configurator--field__label top-full absolute",
    for: "first_name"
  }, "First Name", -1);
  var _hoisted_59 = { class: "mb-4" };
  var _hoisted_60 = /* @__PURE__ */ createBaseVNode("label", {
    class: "configurator--field__label top-full absolute",
    for: "last_name"
  }, "Last Name", -1);
  var _hoisted_61 = { class: "mb-4" };
  var _hoisted_622 = /* @__PURE__ */ createBaseVNode("label", {
    class: "configurator--field__label top-full absolute",
    for: "email"
  }, "Email", -1);
  var _hoisted_632 = /* @__PURE__ */ createBaseVNode("input", {
    type: "hidden",
    name: "lead_source",
    value: "Configurator Download"
  }, null, -1);
  var _hoisted_642 = /* @__PURE__ */ createBaseVNode("button", {
    type: "submit",
    class: "btn btn-transparent-white mt-5"
  }, "Submit", -1);
  var _hoisted_652 = /* @__PURE__ */ createBaseVNode("a", {
    class: "cursor-pointer link link-no-effect flex mt-6 hover:text-blue transition duration-300",
    href: "/pages/contact"
  }, [
    /* @__PURE__ */ createBaseVNode("svg", {
      class: "mr-2 min-w-4",
      width: "14",
      height: "13",
      viewBox: "0 0 16 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ createBaseVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.2031 10.7969C10.0781 11.5312 8.24488 10.9642 6.53541 9.25306C4.82477 7.54073 4.46998 6.15625 5.07916 4.875L5.46998 4.25L3.09498 1.5625C3.09498 1.5625 2.30897 2.05005 1.68133 2.6875C-0.0621004 4.73438 1.46491 8.04029 4.6056 11.1841C7.74531 14.3269 11.2969 15.25 13.3125 13.7656C14.0153 13.2481 14.5156 12.5781 14.75 12.2344L11.9302 10.2543C11.9302 10.2543 11.6529 10.5032 11.2031 10.7969Z",
        stroke: "currentColor"
      })
    ]),
    /* @__PURE__ */ createTextVNode(" Request a Consultation ")
  ], -1);
  var _hoisted_66 = {
    key: 0,
    class: "md:mx-8 md:mb-8"
  };
  var _hoisted_67 = { class: "m-4 md:mx-0" };
  var _hoisted_68 = /* @__PURE__ */ createBaseVNode("h3", null, "Upgrade your Adventure", -1);
  var _hoisted_69 = { class: "h5 mb-0" };
  var _hoisted_70 = ["innerHTML"];
  function render13(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_118, [
      createBaseVNode("div", _hoisted_216, [
        createBaseVNode("h2", _hoisted_38, toDisplayString($props.activePackageTitle) + " Package", 1),
        createBaseVNode("h3", _hoisted_48, toDisplayString($props.activeVanTitle) + " " + toDisplayString($props.activeVanYear), 1),
        createBaseVNode("ul", _hoisted_58, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.checkedAnswersObject, (answers, category, i3) => {
            return openBlock(), createElementBlock("li", {
              key: i3,
              class: "mt-4 w-full"
            }, [
              createBaseVNode("div", _hoisted_65, [
                createBaseVNode("div", _hoisted_76, [
                  createBaseVNode("h3", _hoisted_86, toDisplayString(category), 1),
                  category === "Model Type" ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "cursor-pointer flex ml-3 link link-no-effect hover:text-brand transition duration-300 text-blue",
                    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("selectNavigationGroup", 0))
                  }, _hoisted_119)) : (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: "cursor-pointer flex ml-3 link link-no-effect text-blue hover:text-brand transition duration-300",
                    onClick: ($event) => _ctx.$emit("selectNavigationGroup", i3 + 1)
                  }, _hoisted_153, 8, _hoisted_125))
                ]),
                category === "Model Type" ? (openBlock(), createElementBlock("ul", _hoisted_163, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($props.userSelections.vans, (van, i4) => {
                    return openBlock(), createElementBlock(Fragment, { key: i4 }, [
                      van.checked ? (openBlock(), createElementBlock("li", _hoisted_173, [
                        createBaseVNode("span", null, [
                          $props.activeVanTitle ? (openBlock(), createElementBlock("span", _hoisted_183, toDisplayString($props.activeVanTitle), 1)) : createCommentVNode("v-if", true),
                          $props.activeVanYear ? (openBlock(), createElementBlock("span", _hoisted_193, toDisplayString($props.activeVanYear), 1)) : createCommentVNode("v-if", true)
                        ])
                      ])) : createCommentVNode("v-if", true)
                    ], 64);
                  }), 128)),
                  $props.activeVanKitBasePrice ? (openBlock(), createElementBlock("li", _hoisted_203, [
                    _hoisted_217,
                    $props.activeVanKitBasePrice ? (openBlock(), createElementBlock("span", _hoisted_224, " $" + toDisplayString($props.activeVanKitBasePrice.toFixed(2)), 1)) : createCommentVNode("v-if", true)
                  ])) : createCommentVNode("v-if", true)
                ])) : createCommentVNode("v-if", true),
                createBaseVNode("ul", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(answers, (answer, i4) => {
                    return openBlock(), createElementBlock("li", {
                      key: i4,
                      class: "ml-2 pl-4 micro-alt spec-li relative mt-3"
                    }, [
                      createBaseVNode("div", _hoisted_234, [
                        createBaseVNode("span", null, [
                          category != "Model Type" ? (openBlock(), createElementBlock("span", _hoisted_243, toDisplayString(answer.question) + ":", 1)) : createCommentVNode("v-if", true),
                          createBaseVNode("span", null, toDisplayString(answer.title), 1)
                        ]),
                        createCommentVNode(` <span class="min-w-20 w-20 ml-5" v-if="'factory_install' == answer.unique_id">
										\${{ currentInstallCost.toFixed(2) }}
									</span> `),
                        answer.question === "Installation options" && answer.title === "Factory Install" ? (openBlock(), createElementBlock("span", _hoisted_253, " $" + toDisplayString($props.totalFactoryInstall.toFixed(2)), 1)) : answer.price && answer.price.toString().includes("-") ? (openBlock(), createElementBlock("span", _hoisted_263, toDisplayString(answer.price.toFixed(2).toString().replace("-", "- $")), 1)) : answer.price ? (openBlock(), createElementBlock("span", _hoisted_273, " $" + toDisplayString(answer.price.toFixed(2)), 1)) : createCommentVNode("v-if", true)
                      ]),
                      answer.installCost && $options.factoryInstall == true ? (openBlock(), createElementBlock("small", _hoisted_283, " (Adds $" + toDisplayString(answer.installCost.toFixed(2)) + " to factory install) ", 1)) : createCommentVNode("v-if", true)
                    ]);
                  }), 128))
                ])
              ])
            ]);
          }), 128))
        ]),
        createCommentVNode(' <h3 v-if="currentInstallCost" class="text-blue link lg:hidden my-8">Estimated Install Cost: ${{\n				currentInstallCost.toFixed(2) }}</h3> ')
      ]),
      createBaseVNode("div", _hoisted_293, [
        createBaseVNode("div", _hoisted_303, [
          createBaseVNode("div", _hoisted_313, [
            createVNode(TransitionGroup, {
              name: "fade",
              mode: "out-in"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.imageStack, (image) => {
                  return openBlock(), createElementBlock("img", {
                    key: image,
                    loading: "lazy",
                    src: image.url,
                    style: normalizeStyle({ zIndex: image.order }),
                    class: "absolute w-full h-full inset-0 object-cover object-center"
                  }, null, 12, _hoisted_323);
                }), 128))
              ]),
              _: 1
            })
          ]),
          createVNode(TransitionGroup, {
            name: "fade",
            mode: "out-in"
          }, {
            default: withCtx(() => [
              $props.imageBase ? (openBlock(), createElementBlock("img", {
                key: 0,
                loading: "lazy",
                class: "absolute w-full h-full inset-0 object-cover object-center",
                style: { "z-index": "-1" },
                src: $props.imageBase
              }, null, 8, _hoisted_333)) : (openBlock(), createElementBlock("img", {
                key: 1,
                loading: "lazy",
                class: "absolute w-full h-full inset-0 object-cover object-center",
                style: { "z-index": "-1" },
                src: $props.backgroundImage.src,
                alt: $props.backgroundImage.alt
              }, null, 8, _hoisted_343))
            ]),
            _: 1
          })
        ]),
        createBaseVNode("div", _hoisted_353, [
          createBaseVNode("div", _hoisted_362, [
            createBaseVNode("div", _hoisted_372, [
              _hoisted_382,
              $props.currentPrice ? (openBlock(), createElementBlock("h3", _hoisted_39, [
                $options.factoryInstall ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(" $" + toDisplayString($props.currentPrice.toFixed(2)), 1)
                ], 2112)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(" $" + toDisplayString($props.currentPrice.toFixed(2)), 1)
                ], 2112))
              ])) : createCommentVNode("v-if", true),
              _hoisted_40,
              createBaseVNode("label", _hoisted_41, [
                withDirectives(createBaseVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.termsCheck = $event),
                  class: "mr-2"
                }, null, 512), [
                  [vModelCheckbox, $data.termsCheck]
                ]),
                _hoisted_422
              ]),
              createBaseVNode("label", _hoisted_432, [
                withDirectives(createBaseVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.imageCheck = $event),
                  class: "mr-2"
                }, null, 512), [
                  [vModelCheckbox, $data.imageCheck]
                ]),
                _hoisted_442
              ]),
              createBaseVNode("div", _hoisted_452, [
                withDirectives(createBaseVNode("textarea", {
                  rows: "3",
                  id: "endNotes",
                  class: "text-area field__input p-2",
                  name: "endNotes",
                  placeholder: "Notes",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $data.endNotes = $event)
                }, "\n							", 512), [
                  [vModelText, $data.endNotes]
                ]),
                _hoisted_462
              ]),
              createBaseVNode("button", {
                onClick: _cache[4] || (_cache[4] = (...args) => $options.orderPrep && $options.orderPrep(...args)),
                class: "btn btn-white link-no-effect transition duration-300 mt-5",
                "aria-label": "add configuration to cart",
                disabled: !($data.termsCheck && $data.imageCheck) && !this.buttonDisabled
              }, [
                createTextVNode(toDisplayString(this.buttonText) + " ", 1),
                _hoisted_482
              ], 8, _hoisted_472)
            ])
          ]),
          createBaseVNode("div", _hoisted_49, [
            createBaseVNode("div", _hoisted_50, [
              createBaseVNode("div", {
                class: normalizeClass(["cursor-pointer link link-no-effect hover:text-blue transition duration-300", [$data.viewSignUpForm ? "hidden" : "flex"]]),
                onClick: _cache[5] || (_cache[5] = (...args) => $options.openSignUpForm && $options.openSignUpForm(...args))
              }, _hoisted_532, 2),
              createBaseVNode("div", {
                class: normalizeClass([$data.viewSignUpForm ? "block" : "hidden"])
              }, [
                _hoisted_542,
                createBaseVNode("form", {
                  onSubmit: _cache[9] || (_cache[9] = withModifiers((...args) => $options.handleSubmit && $options.handleSubmit(...args), ["prevent"])),
                  ref: "salesforceForm",
                  target: "salesforceFrame",
                  id: "salesforceForm",
                  action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DHp000009v6Fy",
                  method: "POST"
                }, [
                  _hoisted_552,
                  _hoisted_562,
                  createBaseVNode("div", _hoisted_572, [
                    _hoisted_582,
                    withDirectives(createBaseVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $data.first_name = $event),
                      placeholder: "Enter First Name",
                      class: "text-brand px-2 block w-full",
                      ref: "inputField",
                      id: "first_name",
                      maxlength: "40",
                      name: "first_name",
                      autocomplete: "given-name",
                      size: "20",
                      type: "text"
                    }, null, 512), [
                      [vModelText, $data.first_name]
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_59, [
                    _hoisted_60,
                    withDirectives(createBaseVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => $data.last_name = $event),
                      placeholder: "Enter Last Name",
                      class: "text-brand px-2 block w-full",
                      id: "last_name",
                      maxlength: "80",
                      name: "last_name",
                      autocomplete: "family-name",
                      size: "20",
                      type: "text"
                    }, null, 512), [
                      [vModelText, $data.last_name]
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_61, [
                    _hoisted_622,
                    withDirectives(createBaseVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => $data.email = $event),
                      placeholder: "Enter Email",
                      class: "text-brand px-2 block w-full",
                      id: "email",
                      maxlength: "80",
                      name: "email",
                      size: "20",
                      type: "email",
                      autocomplete: "email"
                    }, null, 512), [
                      [vModelText, $data.email]
                    ])
                  ]),
                  _hoisted_632,
                  _hoisted_642
                ], 544),
                createBaseVNode("iframe", {
                  name: "salesforceFrame",
                  style: { "display": "none" },
                  onLoad: _cache[10] || (_cache[10] = (...args) => $options.handleSalesforceResponse && $options.handleSalesforceResponse(...args))
                }, null, 32),
                createBaseVNode("div", {
                  class: normalizeClass([[$data.formSubmitted ? "block" : "hidden"], "mt-4 p"])
                }, " Thanks! Your form has been submitted. ", 2)
              ], 2),
              _hoisted_652
            ])
          ])
        ]),
        $props.activeVanRelatedProductIds?.product_id_01 || $props.activeVanRelatedProductIds?.product_id_02 || $props.activeVanRelatedProductIds?.product_id_03 || $props.activeVanRelatedProductIds?.product_id_04 || $props.activeVanRelatedProductIds?.product_id_05 ? (openBlock(), createElementBlock("div", _hoisted_66, [
          (openBlock(), createBlock(resolveDynamicComponent("style"), null, {
            default: withCtx(() => [
              createTextVNode(" li.related-" + toDisplayString($props.activeVanRelatedProductIds?.product_id_01) + ", li.related-" + toDisplayString($props.activeVanRelatedProductIds?.product_id_02) + ", li.related-" + toDisplayString($props.activeVanRelatedProductIds?.product_id_03) + ", li.related-" + toDisplayString($props.activeVanRelatedProductIds?.product_id_04) + ", li.related-" + toDisplayString($props.activeVanRelatedProductIds?.product_id_05) + " { display: block; } ", 1)
            ]),
            _: 1
          })),
          createBaseVNode("div", _hoisted_67, [
            _hoisted_68,
            createBaseVNode("p", _hoisted_69, "Accessories for : " + toDisplayString($props.activeVanTitle), 1)
          ]),
          createBaseVNode("div", { innerHTML: $props.relatedProdcuts }, null, 8, _hoisted_70)
        ])) : createCommentVNode("v-if", true)
      ])
    ]);
  }

  // source/configurator/components/TheEnd.vue
  TheEnd_default.render = render13;
  TheEnd_default.__file = "source/configurator/components/TheEnd.vue";
  var TheEnd_default2 = TheEnd_default;

  // sfc-script:/Users/amy/projects/adventure-wagon/source/configurator/App.vue?type=script
  var App_default = {
    name: "Configurator",
    components: {
      SubwayNav: SubwayNav_default2,
      Button: Button_default2,
      ButtonNew: ButtonNew_default2,
      Questions: Questions_default2,
      PackageTotal: PackageTotal_default2,
      Background: Background_default2,
      TheEnd: TheEnd_default2,
      Modal: Modal_default2
    },
    props: {
      relatedProdcuts: String
    },
    data() {
      return {
        loading: true,
        configuratorData: null,
        version: 3,
        userSelections: {},
        currentView: "Back",
        allQuestionGroupCategories: null,
        backgroundImage: {},
        navigation: {
          group: 0,
          question: []
        },
        showModal: true,
        packageChoice: null,
        vanChoice: null,
        yearChoice: null,
        buildChoise: null
      };
    },
    methods: {
      previousNavigationGroup() {
        this._switchNavigation(this.navigation.group - 1, this.navigation.question[this.navigation.group - 1] ?? 0);
      },
      nextNavigationGroup() {
        this._switchNavigation(this.navigation.group + 1, 0);
      },
      selectNavigationGroup(group) {
        this._switchNavigation(group, 0);
      },
      previousNavigationQuestion() {
        this._switchNavigation(this.navigation.group, this.navigation.question[this.navigation.group] - 1);
      },
      nextNavigationQuestion() {
        this._switchNavigation(this.navigation.group, this.navigation.question[this.navigation.group] + 1);
      },
      selectNavigationQuestion(question) {
        this._switchNavigation(this.navigation.group, question);
      },
      selectNavigation(group, question) {
        this._switchNavigation(group, question);
      },
      _switchNavigation(group, question) {
        this.navigation.group = group;
        this.navigation.question[group] = question;
      },
      updateCurrentView(view) {
        this.currentView = view;
      },
      skipNonApplicableVans(applicableVans) {
        if (Array.isArray(applicableVans) && applicableVans.length && this.activeVanId) {
          let vanCheck = applicableVans.filter((item) => {
            return item.id == this.activeVanId;
          }).length;
          if (vanCheck <= 0) {
            return true;
          }
        }
        return false;
      },
      expandAnswers(rawAnswers) {
        if (!Array.isArray(rawAnswers)) {
          return null;
        }
        if (!rawAnswers.length) {
          return null;
        }
        return rawAnswers.reduce(function(filtered, answer) {
          if (this.skipNonApplicableVans(answer.applicable_vans)) {
            return filtered;
          }
          let isChecked = false;
          answer.default_packages.forEach((element) => {
            if (this.convertToSlug(element.title) === this.packageChoice) {
              isChecked = true;
            }
          });
          let newAnswer = {
            title: answer.answer,
            disabled: false,
            checked: isChecked,
            infoBubble: answer.info_bubble,
            unique_id: answer.unique_id,
            questions: this.expandQuestions(answer.question),
            requirements: [],
            restrictions: [],
            price: false,
            installCost: false,
            images: false
          };
          if (Array.isArray(answer.per_van_info) && answer.per_van_info.length) {
            answer.per_van_info.forEach((element) => {
              if (!element.van || element.van.id == this.activeVanId) {
                if ((element.requirements.length || element.restrictions.length) && this.vanGroup) {
                  if (element.requirements.some((requirement) => this.convertToSlug(requirement.answer_unique_id) === this.activeVanYearID)) {
                    newAnswer.checked = true;
                    newAnswer.disabled = true;
                  } else if (element.restrictions.some((restriction) => this.convertToSlug(restriction.answer_unique_id) === this.activeVanYearID)) {
                    newAnswer.checked = false;
                    newAnswer.disabled = true;
                  } else {
                    this.userSelections.questionGroups[this.vanGroup].forEach((group) => {
                      if (Array.isArray(group.questions) && group.questions.length) {
                        let checkedAnswers = this.getCheckedAnswersFromQuestion(group.questions);
                        if (checkedAnswers.length) {
                          if (checkedAnswers.some((answer2) => element.requirements.some((requirement) => requirement.answer_unique_id === answer2.unique_id))) {
                            newAnswer.checked = true;
                            newAnswer.disabled = true;
                          } else if (checkedAnswers.some((answer2) => element.restrictions.some((restriction) => restriction.answer_unique_id === answer2.unique_id))) {
                            newAnswer.checked = false;
                            newAnswer.disabled = true;
                          }
                        }
                      }
                    });
                  }
                }
                if (element.requirements.length) {
                  newAnswer.requirements = element.requirements;
                }
                if (element.restrictions.length) {
                  newAnswer.restrictions = element.restrictions;
                }
                newAnswer.price = element.price;
                newAnswer.installCost = element.install_cost;
                newAnswer.images = element.images;
                newAnswer.image_order = element.image_order ?? 0;
                filtered.push(newAnswer);
              }
            });
          } else {
            filtered.push(newAnswer);
          }
          return filtered;
        }.bind(this), []);
      },
      expandQuestions(rawQuestions) {
        if (!Array.isArray(rawQuestions)) {
          return null;
        }
        if (!rawQuestions.length) {
          return null;
        }
        return rawQuestions.reduce(function(filtered, question) {
          if (!this.skipNonApplicableVans(question.applicable_vans)) {
            let newQuestion = {
              title: question.question ?? question.title,
              description: question.description,
              learnMore: question.learn_more,
              infoBubble: question.info_bubble,
              multipleChoice: question.multiple_choice,
              answers: this.expandAnswers(question.answers)
            };
            filtered.push(newQuestion);
          }
          return filtered;
        }.bind(this), []);
      },
      expandQuestionGroup(rawQuestionGroup) {
        if (this.skipNonApplicableVans(rawQuestionGroup.applicable_vans)) {
          return false;
        }
        const questionGroupSlug = rawQuestionGroup.slug;
        const associatedQuestions = this.configuratorData[3].data.filter((question) => question.question_group && questionGroupSlug === question.question_group.slug);
        let questionGroup = {
          category: rawQuestionGroup.title,
          baseView: rawQuestionGroup.base_view ? rawQuestionGroup.base_view.title : "Back",
          questions: this.expandQuestions(associatedQuestions)
        };
        return questionGroup;
      },
      getCheckedAnswersFromQuestion(questions) {
        return questions.reduce(function(filtered, question) {
          if (question && question.answers && question.answers.length) {
            question.answers.forEach((answer) => {
              if (answer.checked) {
                answer.question = question.title;
                filtered.push(answer);
                if (Array.isArray(answer.questions) && answer.questions.length) {
                  let nestedAnswer = this.getCheckedAnswersFromQuestion(answer.questions);
                  filtered.push(...nestedAnswer);
                }
              }
            });
          }
          return filtered;
        }.bind(this), []);
      },
      convertToSlug(text2) {
        if (!text2) {
          return false;
        }
        return text2.toLowerCase().replace(/ /g, "-").replace(/[-]+/g, "-").replace(/[^\w-]+/g, "");
      },
      doVisibilityChange(e2) {
        if (e2.target.visibilityState === "hidden" && this.vanGroup) {
          console.log("saving data");
          let data2 = {
            "van": this.activeVan.slug,
            "year": this.activeVanYear,
            "package": this.packageChoice,
            "vanGroup": this.vanGroup,
            "data": this.userSelections.questionGroups[this.vanGroup],
            "version": this.version
          };
          localStorage.build = JSON.stringify(data2);
        }
      },
      saveBuild() {
        let url = "https://www.configuratoradventurewagon.com/build/set";
        if (this.vanGroup) {
          let data2 = {
            "van": this.activeVan.slug,
            "year": this.activeVanYear,
            "package": this.packageChoice,
            "vanGroup": this.vanGroup,
            "data": this.userSelections.questionGroups[this.vanGroup]
          };
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data2)
          }).then((response) => response.json()).then((data3) => {
            const response = JSON.parse(data3);
            window.prompt("Copy to clipboard: Ctrl+C, Enter", window.location.href + "?build=" + response.url);
          }).catch((error2) => {
            console.error("Error:", error2);
          });
        }
      },
      loadBuild(build) {
        this.packageChoice = build.package ?? "custom";
        this.vanChoice = build.van;
        this.yearChoice = build.year;
        this.userSelections.questionGroups[build.vanGroup] = build.data;
      },
      newBuild() {
        document.removeEventListener("visibilitychange", this.doVisibilityChange);
        console.log("removing local storage item");
        localStorage.removeItem("build");
        window.location = window.location.pathname;
      },
      getInitialData() {
        Promise.all([
          fetch("https://www.configuratoradventurewagon.com/api/collections/vans/entries?sort=order&limit=1000"),
          fetch("https://www.configuratoradventurewagon.com/api/collections/packages/entries?sort=order&limit=1000"),
          fetch("https://www.configuratoradventurewagon.com/api/taxonomies/question_groups/terms?sort=group_order&limit=1000"),
          fetch("https://www.configuratoradventurewagon.com/api/collections/questions/entries?sort=order&limit=1000")
        ]).then(function(responses) {
          return Promise.all(responses.map(function(response) {
            return response.json();
          }));
        }).then(function(data2) {
          console.log("data:", data2);
          this.configuratorData = data2;
          this.userSelections.vans = this.configuratorData[0].data.map((van) => {
            let baseImages = {};
            if (van.base_views) {
              for (const element of van.base_views) {
                if (element.base_view[0] && element.image) {
                  baseImages[element.base_view[0].title] = element.image.permalink;
                }
              }
            }
            let yearChoice = "";
            if (van.slug !== this.vanChoice || van.slug === this.vanChoice && !this.yearChoice) {
              yearChoice = van.years[van.years.length - 1].year;
            } else if (van.slug === this.vanChoice && this.yearChoice) {
              yearChoice = this.yearChoice;
            }
            return {
              id: van.id,
              slug: van.slug,
              title: van.title,
              relatedProductIds: van.related_product_ids,
              kitBasePrice: van.kit_base_price,
              installBasePrice: van.install_base_price,
              baseView: van.base_view,
              baseImages,
              years: Array.isArray(van.years) ? van.years.map((item) => {
                return {
                  title: item.year,
                  checked: item.year == yearChoice
                };
              }) : null,
              checked: van.slug === this.vanChoice
            };
          });
          this.userSelections.packs = this.configuratorData[1].data.map((item) => {
            return {
              id: item.id,
              title: item.title,
              slug: item.slug,
              checked: false
            };
          });
          this.allQuestionGroupCategories = this.configuratorData[2].data.map((questionGroup) => {
            return questionGroup.title;
          });
        }.bind(this)).catch(function(error2) {
          console.log(error2);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    computed: {
      vanGroup() {
        if (this.activePackageTitle && this.activeVanTitle && this.activeVanYear) {
          return (this.activePackageTitle + this.activeVanTitle + this.activeVanYear).split(" ").join("");
        }
      },
      activePackage() {
        if (this.userSelections.packs) {
          return this.userSelections.packs.filter((pack) => {
            return this.convertToSlug(pack.title) === this.packageChoice;
          });
        }
      },
      activePackageTitle() {
        if (this.activePackage && this.activePackage.length) {
          return this.activePackage.shift().title ?? "Custom";
        }
        return "Custom";
      },
      activeVan() {
        if (this.userSelections.vans) {
          for (const element of this.userSelections.vans) {
            if (element.checked) {
              return element;
            }
          }
        }
      },
      activeVanId() {
        if (this.activeVan) {
          return this.activeVan.id;
        }
      },
      activeVanTitle() {
        if (this.activeVan) {
          return this.activeVan.title;
        }
      },
      activeVanYear() {
        if (this.activeVan && this.activeVan.years) {
          for (const element of this.activeVan.years) {
            if (element.checked) {
              return element.title;
            }
          }
        }
      },
      activeVanYearID() {
        return this.convertToSlug("year " + this.activeVanYear);
      },
      activeVanRelatedProductIds() {
        if (this.activeVan && this.activeVan.relatedProductIds) {
          return this.activeVan.relatedProductIds;
        }
      },
      activeVanKitBasePrice() {
        if (this.activeVan) {
          return this.activeVan.kitBasePrice;
        }
      },
      imageBase() {
        if (this.activeVan && this.activeVan.baseImages && this.activeVan.baseImages[this.currentView]) {
          return this.activeVan.baseImages[this.currentView];
        }
      },
      imageStack() {
        let images = [];
        if (this.checkedAnswersObject) {
          for (const group of Object.keys(this.checkedAnswersObject)) {
            for (const answer of Object.keys(this.checkedAnswersObject[group])) {
              if (Array.isArray(this.checkedAnswersObject[group][answer].images)) {
                let newImage = this.checkedAnswersObject[group][answer].images.map((image) => {
                  return {
                    url: image.permalink,
                    order: this.checkedAnswersObject[group][answer].image_order
                  };
                });
                images = images.concat(newImage);
              }
            }
          }
        }
        return images;
      },
      computedQuestionGroups() {
        if (this.vanGroup) {
          console.log("this.userSelections:", this.userSelections.questionGroups[this.vanGroup]);
          if (!this.userSelections.questionGroups[this.vanGroup]) {
            this.userSelections.questionGroups[this.vanGroup] = [];
            this.configuratorData[2].data.forEach((questionGroup) => {
              let expandedGroup = this.expandQuestionGroup(questionGroup);
              if (expandedGroup) {
                this.userSelections.questionGroups[this.vanGroup].push(expandedGroup);
              }
            });
          }
          return this.userSelections.questionGroups[this.vanGroup];
        }
      },
      checkedAnswersObject() {
        if (this.userSelections.questionGroups && this.computedQuestionGroups) {
          let checkedAnswers = {};
          this.computedQuestionGroups.forEach((group) => {
            if (Array.isArray(group.questions) && group.questions.length) {
              checkedAnswers[group.category] = this.getCheckedAnswersFromQuestion(group.questions);
            }
          });
          return checkedAnswers;
        }
      },
      factoryInstall() {
        if (this.checkedAnswersObject) {
          for (const group of Object.keys(this.checkedAnswersObject)) {
            for (const answer of Object.keys(this.checkedAnswersObject[group])) {
              if (this.checkedAnswersObject[group][answer].title === "Factory Install") {
                return true;
              }
            }
          }
        }
        return false;
      },
      totalFactoryInstall() {
        let factoryInsatllPrice = 0;
        if (this.checkedAnswersObject) {
          for (const group of Object.keys(this.checkedAnswersObject)) {
            for (const answer of Object.keys(this.checkedAnswersObject[group])) {
              let checkedAnswersObject = 0;
              if (this.checkedAnswersObject[group][answer].title === "Factory Install") {
                factoryInsatllPrice = factoryInsatllPrice + parseFloat(this.checkedAnswersObject[group][answer].price.toFixed(2));
              }
              if (this.checkedAnswersObject[group][answer].installCost && Object.values(this.checkedAnswersObject).some((g2) => g2.some((a3) => a3.title === "Factory Install"))) {
                factoryInsatllPrice = factoryInsatllPrice + parseFloat(this.checkedAnswersObject[group][answer].installCost.toFixed(2));
              }
            }
          }
        }
        return factoryInsatllPrice;
      },
      currentPrice() {
        let price = 0;
        if (this.activeVanKitBasePrice) {
          price = price + parseFloat(this.activeVanKitBasePrice.toFixed(2));
        }
        if (this.checkedAnswersObject) {
          for (const group of Object.keys(this.checkedAnswersObject)) {
            for (const answer of Object.keys(this.checkedAnswersObject[group])) {
              console.log(this.checkedAnswersObject[group][answer]);
              if (this.checkedAnswersObject[group][answer].price) {
                console.log(this.checkedAnswersObject[group][answer]);
                price = price + parseFloat(this.checkedAnswersObject[group][answer].price.toFixed(2));
              }
              if (this.checkedAnswersObject[group][answer].installCost) {
                if (this.checkedAnswersObject[group][answer].title === "Factory Install") {
                  price = price + parseFloat(this.checkedAnswersObject[group][answer].installCost.toFixed(2));
                }
                if (this.checkedAnswersObject[group][answer].installCost && Object.values(this.checkedAnswersObject).some((g2) => g2.some((a3) => a3.title === "Factory Install"))) {
                  price = price + parseFloat(this.checkedAnswersObject[group][answer].installCost.toFixed(2));
                }
              }
            }
          }
        }
        return price;
      },
      showEnd() {
        if (this.navigation.group && this.navigation.group > 0 && this.userSelections.questionGroups[this.vanGroup] && this.navigation.group > this.userSelections.questionGroups[this.vanGroup].length) {
          return true;
        }
        return false;
      }
    },
    beforeMount() {
      const urlParams = new URLSearchParams(window.location.search);
      this.buildChoise = urlParams.get("build");
      this.packageChoice = urlParams.get("package") ?? "custom";
      this.vanChoice = urlParams.get("van");
      const configurator = document.getElementById("configurator");
      this.version = configurator.dataset.version ?? 1;
      this.backgroundImage.src = configurator.dataset.bgsrc ?? false;
      this.backgroundImage.alt = configurator.dataset.bgalt ?? "";
      this.userSelections.questionGroups = {};
      if (this.buildChoise) {
        fetch("https://www.configuratoradventurewagon.com/build/get/" + this.buildChoise).then((response) => response.json()).then((data2) => {
          const build = JSON.parse(data2);
          this.loadBuild(build);
        }).catch((error2) => {
          console.error("Error:", error2);
        }).finally(() => {
          this.getInitialData();
        });
      } else {
        if (!urlParams.get("build") && !urlParams.get("package") && !urlParams.get("van") && localStorage.build) {
          const build = JSON.parse(localStorage.build);
          if (build.version == this.version) {
            this.showModal = false;
            this.loadBuild(build);
          }
        }
        this.getInitialData();
      }
    },
    mounted() {
      this.navigation.question[0] = 0;
      document.addEventListener("visibilitychange", this.doVisibilityChange);
    }
  };

  // sfc-template:/Users/amy/projects/adventure-wagon/source/configurator/App.vue?type=template
  var _hoisted_120 = {
    key: 0,
    class: "absolute pin-0 grid place-items-center h-specs-container w-full -z-10"
  };
  var _hoisted_218 = /* @__PURE__ */ createBaseVNode("div", null, " [loading...] ", -1);
  var _hoisted_310 = [
    _hoisted_218
  ];
  var _hoisted_410 = { class: "w-full flex lg:flex-row flex-col lg:justify-between justify-start items-start bgsize order-1" };
  function render14(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TheEnd = resolveComponent("TheEnd");
    const _component_SubwayNav = resolveComponent("SubwayNav");
    const _component_Questions = resolveComponent("Questions");
    const _component_PackageTotal = resolveComponent("PackageTotal");
    const _component_Background = resolveComponent("Background");
    const _component_modal = resolveComponent("modal");
    return openBlock(), createElementBlock(Fragment, null, [
      $data.loading ? (openBlock(), createElementBlock("div", _hoisted_120, _hoisted_310)) : createCommentVNode("v-if", true),
      createBaseVNode("div", {
        class: normalizeClass(["transition-opacity duration-500 -lg:flex lg:flex-row lg:justify-between justify-start items-start flex-col w-full h-full", [$data.loading ? "opacity-0" : ""]])
      }, [
        $options.showEnd ? (openBlock(), createBlock(_component_TheEnd, {
          key: 0,
          onSelectNavigationGroup: $options.selectNavigationGroup,
          userSelections: $data.userSelections,
          checkedAnswersObject: $options.checkedAnswersObject,
          activePackageTitle: $options.activePackageTitle,
          activeVanTitle: $options.activeVanTitle,
          activeVanYear: $options.activeVanYear,
          activeVanKitBasePrice: $options.activeVanKitBasePrice,
          activeVanRelatedProductIds: $options.activeVanRelatedProductIds,
          relatedProdcuts: $props.relatedProdcuts,
          currentPrice: $options.currentPrice,
          factoryInstall: $options.factoryInstall,
          totalFactoryInstall: $options.totalFactoryInstall,
          backgroundImage: $data.backgroundImage,
          imageStack: $options.imageStack,
          imageBase: $options.imageBase
        }, null, 8, ["onSelectNavigationGroup", "userSelections", "checkedAnswersObject", "activePackageTitle", "activeVanTitle", "activeVanYear", "activeVanKitBasePrice", "activeVanRelatedProductIds", "relatedProdcuts", "currentPrice", "factoryInstall", "totalFactoryInstall", "backgroundImage", "imageStack", "imageBase"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createBaseVNode("div", _hoisted_410, [
            createVNode(_component_SubwayNav, {
              onSelectNavigationGroup: $options.selectNavigationGroup,
              navigation: $data.navigation,
              computedQuestionGroups: $options.computedQuestionGroups,
              userSelections: $data.userSelections,
              vanGroup: $options.vanGroup,
              activePackageTitle: $options.activePackageTitle,
              activeVanTitle: $options.activeVanTitle,
              activeVanYear: $options.activeVanYear,
              allQuestionGroupCategories: $data.allQuestionGroupCategories
            }, null, 8, ["onSelectNavigationGroup", "navigation", "computedQuestionGroups", "userSelections", "vanGroup", "activePackageTitle", "activeVanTitle", "activeVanYear", "allQuestionGroupCategories"]),
            createVNode(_component_Questions, {
              onPreviousNavigationGroup: $options.previousNavigationGroup,
              onNextNavigationGroup: $options.nextNavigationGroup,
              onSelectNavigationGroup: $options.selectNavigationGroup,
              onPreviousNavigationQuestion: $options.previousNavigationQuestion,
              onNextNavigationQuestion: $options.nextNavigationQuestion,
              onSelectNavigationQuestion: $options.selectNavigationQuestion,
              navigation: $data.navigation,
              onUpdateCurrentView: $options.updateCurrentView,
              userSelections: $data.userSelections,
              vanGroup: $options.vanGroup,
              activeVanTitle: $options.activeVanTitle,
              activeVanYear: $options.activeVanYear,
              allQuestionGroupCategories: $data.allQuestionGroupCategories
            }, null, 8, ["onPreviousNavigationGroup", "onNextNavigationGroup", "onSelectNavigationGroup", "onPreviousNavigationQuestion", "onNextNavigationQuestion", "onSelectNavigationQuestion", "navigation", "onUpdateCurrentView", "userSelections", "vanGroup", "activeVanTitle", "activeVanYear", "allQuestionGroupCategories"])
          ]),
          createVNode(_component_PackageTotal, {
            onSelectNavigationGroup: $options.selectNavigationGroup,
            userSelections: $data.userSelections,
            checkedAnswersObject: $options.checkedAnswersObject,
            activePackageTitle: $options.activePackageTitle,
            activeVanTitle: $options.activeVanTitle,
            activeVanYear: $options.activeVanYear,
            activeVanKitBasePrice: $options.activeVanKitBasePrice,
            currentPrice: $options.currentPrice,
            factoryInstall: $options.factoryInstall,
            totalFactoryInstall: $options.totalFactoryInstall,
            saveBuild: $options.saveBuild,
            vanGroup: $options.vanGroup,
            newBuild: $options.newBuild
          }, null, 8, ["onSelectNavigationGroup", "userSelections", "checkedAnswersObject", "activePackageTitle", "activeVanTitle", "activeVanYear", "activeVanKitBasePrice", "currentPrice", "factoryInstall", "totalFactoryInstall", "saveBuild", "vanGroup", "newBuild"]),
          createVNode(_component_Background, {
            backgroundImage: $data.backgroundImage,
            imageStack: $options.imageStack,
            imageBase: $options.imageBase
          }, null, 8, ["backgroundImage", "imageStack", "imageBase"])
        ], 64))
      ], 2),
      (openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(_component_modal, {
          show: $data.showModal,
          onClose: _cache[0] || (_cache[0] = ($event) => $data.showModal = false)
        }, null, 8, ["show"])
      ]))
    ], 64);
  }

  // source/configurator/App.vue
  App_default.render = render14;
  App_default.__file = "source/configurator/App.vue";
  var App_default2 = App_default;

  // source/configurator/configurator.js
  if (document.getElementById("configurator")) {
    const relatedProdcuts = document.getElementById("related-products")?.outerHTML;
    const app = createApp(App_default2, { relatedProdcuts });
    if (true) {
      console.log("current environment:", "development");
      app.config.performance = true;
      app.config.devtools = true;
      app.__VUE_PROD_DEVTOOLS__ = true;
    }
    app.mount("#configurator");
  }
})();
/*!
 * html2canvas 1.3.2 <https://html2canvas.hertzen.com>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/*! @license DOMPurify 2.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.3/LICENSE */
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.4.0 Built on 2021-09-14T10:30:30.230Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
